var ener_lib_cif = `
# ---------------------------------------------------
#             ener_lib.cif              4-APR-95/31-MAY-00
# ---------------------------------------------------
#
data_energy
#
# ---------------------------------------------------
#      _dictionary_name		ciflibdic
#      _dictionary_version	2.0
# ---------------------------------------------------
#   -----------   Description of atom's type --------     
#HEADER        C Carbon PI
#ATOMTYPE CSP  = with triple bond
#ATOMTYPE CSP1 = with triple bond and 1 hydrogen
#HEADER        C Carbon SP2
#ATOMTYPE C    = without hydrogen ( carbonyl C )
#ATOMTYPE C1   = connected to 1 hydrogen  
#ATOMTYPE C2   = connected to 2 hydrogens 
#ATOMTYPE CR1  = between two pyrrole units 
#ATOMTYPE CR1H = CR1 connected to 1 hydrogen ( CHA of HEME )
#ATOMTYPE CR15 = connected to 1 hydrogen in 5 atoms ring ( CE1 of HIS)
#ATOMTYPE CR16 = connected to 1 hydrogen in 6 atoms ring ( CE1 of PHE)
#ATOMTYPE CR6  = without hydrogen in 6 atoms ring 
#ATOMTYPE CR5  = without hydrogen in 5 atoms ring 
#ATOMTYPE CR56 = between two atoms in 5-6 rings ( CD2 CE2 of TRP )
#ATOMTYPE CR55 = between two atoms in 5-5 rings 
#ATOMTYPE CR66 = between two atoms in 6-6 rings 
#HEADER        C Carbon SP3
#ATOMTYPE CH1  = connected to 1 hydrogen  ( CA of most amono acids )
#ATOMTYPE CH2  = connected to 2 hydrogens ( CB of most amono acids)
#ATOMTYPE CH3  = connected to 3 hydrogens ( CD1 CD2 of LEUCINE)
#ATOMTYPE CT   = without hydrogen
#ATOMTYPE SI   = tetragonal silicon
#ATOMTYPE SI1  = other silicons
#HEADER        H Hydrogen
#ATOMTYPE HCH  = hydrogen of aliphatic group
#ATOMTYPE HCR  = hydrogen of aromatic group
#ATOMTYPE HNC1 = hydrogen connected to NC1
#ATOMTYPE HNC2 = hydrogen connected to NC2
#ATOMTYPE HNC3 = hydrogen connected to NC3
#ATOMTYPE HNH1 = hydrogen connected to NH1
#ATOMTYPE HNH2 = hydrogen connected to NH2
#ATOMTYPE HNR5 = hydrogen connected to NR15
#ATOMTYPE HNR6 = hydrogen connected to NR16
#ATOMTYPE HOH1 = hydrogen connected to OH1
#ATOMTYPE HOH2 = hydrogen of water
#ATOMTYPE HSH1 = hydrogen of sulphur
#HEADER        N Nitrogen PI
#ATOMTYPE NS   = without hydrogen ( triple bond )
#ATOMTYPE NS1  = connected to 1 hydrogen
#HEADER        N Nitrogen SP2
#ATOMTYPE N    = without hydrogen ( N  of PRO )
#ATOMTYPE NC1  = connected to 1 hyd. in a charged group ( NE of ARG )
#ATOMTYPE NC2  = connected to 2 hyd. in a charged group ( NH2 of ARG )
#ATOMTYPE NH1  = connected to 1 hydrogen ( N of main chain )
#ATOMTYPE NH2  = connected to 2 hydrogen ( NE2 of GLU )
#ATOMTYPE NPA  = without hydrogen ( NA and NC of HEME )
#ATOMTYPE NPB  = without hydrogen ( NB and ND of HEME )
#ATOMTYPE NRD5 = without hydrogen but with electronic doublet in 5 atoms ring
#ATOMTYPE NRD6 = without hydrogen but with electronic doublet in 6 atoms ring 
#ATOMTYPE NR15 = connected to 1 hyd. in 5 atoms ring ( ND1 of HIS )
#ATOMTYPE NR16 = connected to 1 hyd. in 6  atoms ring 
#ATOMTYPE NR5  = connected to 3 atoms in 5 atoms ring ( N9 of ADE )
#ATOMTYPE NR6  = connected to 3 atoms in 6 atoms ring ( N1 of CYT )
#HEADER        N Nitrogen SP3
#ATOMTYPE NT   = without hydrogen
#ATOMTYPE NT1  = connected to 1 hydrogen
#ATOMTYPE NT2  = connected to 2 hydrogens
#ATOMTYPE NT3  = connected to 3 hydrogens
#ATOMTYPE P    = tetragonal P with four bonds
#ATOMTYPE P1   = with three bonds. Planar? 
#HEADER        O Oxygen SP2
#ATOMTYPE O    = without  NET charge ( O of main chain )
#ATOMTYPE OC   = with a NET charge   ( OE1 OE2 of GLU )
#ATOMTYPE OP   = with a NET charge connected to P (O1P of phosphate group )
#ATOMTYPE OS   = with a NET charge connected to S ( O1 of sulphate group )
#ATOMTYPE OB   = with a NET charge connected to B
#HEADER        O Oxygen SP3
#ATOMTYPE O2   = connected to 2 atoms ( O4' of ribose )
#ATOMTYPE OC2  = with a NET charge connected to 2 ATOMS ( O3' of ribose )
#ATOMTYPE OH1  = oxygen of alcohol groups ( OG1 of THR )
#ATOMTYPE OH2  = oxygen of water
#ATOMTYPE OHA  = oxygen of water in MO6
#ATOMTYPE OHB  = oxygen of water in MO6
#ATOMTYPE OHC  = oxygen of water in MO6
#HEADER        S Sulphur 
#ATOMTYPE S    = sulphur without hydrogen 
#ATOMTYPE SH1  = sulphur with a hydrogen ( SG of CYS )
#ATOMTYPE S3   = sulphur with 3 bonds (sulphoxide) 
#ATOMTYPE S2   = sulphur with 2 bonds (methionine) 
#ATOMTYPE S1   = sulphur with 1 double bond 
#HEADER        Fe
#ATOMTYPE FE   = iron
#HEADER        P
#ATOMTYPE P    = phosphorus
#HEADER        Zn
#ATOMTYPE ZN   = zinc
#END
# ---------------------------------------------------
#
# --- ATOM ---
#
loop_
_lib_atom.type
_lib_atom.weight
_lib_atom.hb_type
_lib_atom.vdw_radius
_lib_atom.vdwh_radius
_lib_atom.ion_radius
_lib_atom.element
_lib_atom.valency
_lib_atom.sp
_lib_atom.surface_potential_charge
#   
#  _type         atomic chemical type
#  _weight       atomic weight
#  _hb_type      donnor/acceptor's type:   
#                     N=neither
#                     D=donnor
#                     A=acceptor
#                     B=both
#                     H=hydrogen candidate to hydrogen bonding
#   _vdw_radius  Van-Der-Waals radius
#   _vdwh_radius  Van-Der-Waals radius for atom+H
#  Ionic radii for most of the atoms without hydrogens are
#  http://www.webelements.com/webelements/elements/text/radii/N.html
#  
#  or 
#  Chemstry of the elements by Greenwood and Earnshaw
#  VDW radii of carbon atoms with hydrogen have been taken from paper
#   Li and Nussinov, Proteins, 32 111-127 (1998)
#
# surface_potential_charge parameters are those appropriate for surface 
# electrostatic potential calculations 
#
CSP     12.01150  N     1.700     1.700     .     C   4  1  0.0
CSP1    12.01150  N     1.700     1.700     .     C   4  1  0.0
C       12.01150  N     1.700     1.750     .     C   4  2  0.0
C1      12.01150  N     1.700     1.820     .     C   4  2  0.0
C2      12.01150  N     1.700     1.800     .     C   4  2  0.0
CR1     12.01150  N     1.700     1.800     .     C   4  2  0.0
CR2     12.01150  N     1.700     1.800     .     C   4  2  0.0
CR1H    12.01150  N     1.700     1.800     .     C   4  2  0.0
CR15    12.01150  N     1.700     1.740     .     C   4  2  0.0
CR5     12.01150  N     1.700     1.740     .     C   4  2  0.0
CR56    12.01150  N     1.700     1.740     .     C   4  2  0.0
CR55    12.01150  N     1.700     1.740     .     C   4  2  0.0
CR16    12.01150  N     1.700     1.820     .     C   4  2  0.0
CR6     12.01150  N     1.700     1.740     .     C   4  2  0.0
CR66    12.01150  N     1.700     1.740     .     C   4  2  0.0
CH1     12.01150  N     1.700     1.950     .     C   4  3  0.0
CH2     12.01150  N     1.700     1.920     .     C   4  3  0.0
CH3     12.01150  N     1.700     1.940     .     C   4  3  0.0
CT      12.01150  N     1.700     1.850     .     C   4  3  0.0
#
NS      14.00670  N     1.550     1.600    1.32   N   3  1  0.0
N       14.00670  N     1.550     1.600    1.32   N   3  2  0.0
NC1     14.00670  D     1.550     1.600    1.32   N   3  2  0.0
NH1     14.00670  D     1.550     1.600    1.32   N   3  2  0.0
NC2     14.00670  D     1.550     1.600    1.32   N   3  2  0.5
NH2     14.00670  D     1.550     1.600    1.32   N   3  2  0.0
NC3     14.00670  D     1.550     1.600    1.32   N   3  2  0.0
NT      14.00670  D     1.550     1.600    1.32   N   3  3  0.0
NT1     14.00670  D     1.550     1.600    1.32   N   3  3  0.0
NT2     14.00670  D     1.550     1.600    1.32   N   3  3  0.0
NT3     14.00670  D     1.550     1.600    1.32   N   3  3  1.0
NPA     14.00670  A     1.550     1.600    1.32   N   3  2  0.0
NPB     14.00670  A     1.550     1.600    1.32   N   3  2  0.0
NR5     14.00670  N     1.550     1.600    1.32   N   3  2  0.0
NR15    14.00670  D     1.550     1.600    1.32   N   3  2  0.0
NRD5    14.00670  A     1.550     1.600    1.32   N   3  2  0.0
NR56    14.00670  A     1.550     1.600    1.32   N   3  2  0.0
NR55    14.00670  A     1.550     1.600    1.32   N   3  2  0.0
NR6     14.00670  N     1.550     1.600    1.32   N   3  2  0.0
NR66    14.00670  N     1.550     1.600    1.32   N   3  2  0.0
NR16    14.00670  D     1.550     1.600    1.32   N   3  2  0.0
NRD6    14.00670  A     1.550     1.600    1.32   N   3  2  0.0
#
OS      15.99940  A     1.520     1.520    1.28   O   2  2  0.0
O       15.99940  A     1.520     1.520    1.28   O   2  2  0.0
O2      15.99940  A     1.520     1.520    1.28   O   2  3  0.0
OH1     15.99940  B     1.520     1.520    1.28   O   2  3  0.0
OH2     15.99940  B     1.520     1.520    1.28   O   2  3  0.0
OHA     15.99940  B     1.520     1.680    1.28   O   2  3  0.0
OHB     15.99940  B     1.520     1.680    1.28   O   2  3  0.0
OHC     15.99940  B     1.520     1.680    1.28   O   2  3  0.0
OC2     15.99940  A     1.520     1.520    1.28   O   2  2 -0.2
OC      15.99940  A     1.520     1.520    1.28   O   2  2 -0.5
OP      15.99940  A     1.520     1.520    1.28   O   2  2 -0.3
OB      15.99940  A     1.520     1.520    1.28   O   2  2  0.0
#
P       30.97380  N     1.800     1.88     0.59   P   5  . 0.6
P1      30.97380  N     1.800     1.88     0.59   P   5  . 0.0
PS      30.97380  N     1.800     1.90     0.59   P   5  . 0.0
S       32.06400  A     1.800     1.88     0.4    S   2  . 0.0
S3      32.06400  A     1.800     1.88     0.4    S   4  . 0.0
S2      32.06400  A     1.800     1.88     0.4    S   2  . 0.0
S1      32.06400  A     1.800     1.88     0.4    S   2  . 0.0
ST      32.06400  A     1.800     1.88     0.4    S   6  . 0.0
SH1     32.06400  B     1.800     1.950    0.4    S   2  . 0.0
#
H        1.00800  N     1.200      .     .     H   1  . 0.3
HCH      1.00800  N     1.200      .     .     H   1  . 0.3
HCH1     1.00800  N     1.200      .     .     H   1  . 0.3
HCH2     1.00800  N     1.200      .     .     H   1  . 0.3
HCH3     1.00800  N     1.200      .     .     H   1  . 0.3
HCR1     1.00800  N     1.200      .     .     H   1  . 0.3
HC2      1.00800  N     1.200      .     .     H   1  . 0.3
HC1      1.00800  N     1.200      .     .     H   1  . 0.3
HC2      1.00800  N     1.200      .     .     H   1  . 0.3
HCR5     1.00800  N     1.200      .     .     H   1  . 0.3
HCR6     1.00800  N     1.200      .     .     H   1  . 0.3
HNC1     1.00800  H     1.200      .     .     H   1  . 0.3
HNC2     1.00800  H     1.200      .     .     H   1  . 0.3
HNH1     1.00800  H     1.200      .     .     H   1  . 0.3
HNH2     1.00800  H     1.200      .     .     H   1  . 0.3
HNR5     1.00800  H     1.200      .     .     H   1  . 0.3
HNR6     1.00800  H     1.200      .     .     H   1  . 0.3
HNT1     1.00800  H     1.200      .     .     H   1  . 0.3
HNT2     1.00800  H     1.200      .     .     H   1  . 0.3
HNT3     1.00800  H     1.200      .     .     H   1  . 0.3
HOH1     1.00800  H     1.200      .     .     H   1  . 0.3
HOH2     1.00800  H     1.200      .     .     H   1  . 0.3
HOHA     1.00800  H     1.200      .     .     H   1  . 0.3
HOHB     1.00800  H     1.200      .     .     H   1  . 0.3
HOHC     1.00800  H     1.200      .     .     H   1  . 0.3
HSH1     1.00800  H     1.200      .     .     H   1  . 0.3
#
SI      28.0855   N     2.10       .    0.40   SI   4  3 0.0
SI1     28.0855   N     2.10       .    0.40   SI   4  . 0.0
GE      72.59     N     2.10       .    0.40   GE   1  . 0.0
GE1     72.59     N     2.10       .    0.40   GE   1  . 0.0
SN     118.69     N     2.17       .    0.69   SN   1  . 0.0
PB     207.2      N     2.02       .    0.79   PB   1  . 0.0
#
LI       6.941    N     1.82       .    0.73   LI   1  . 1.0
NA      22.990    N     2.27       .    1.13   NA   1  . 1.0
K       30.0983   N     2.75       .    1.51   K    1  . 1.0
RB      85.468    N     2.00       .    1.48   RB   1  . 1.0
CS     132.905    N     2.98       .    1.81   CS   1  . 1.0
FR     223.0      N     .          .    1.94   FR   1  . 1.0
#
BE       9.0123   N     1.12       .    0.41   BE   1  . 2.0
MG      24.30500  A     1.73       .    0.71   MG   1  . 2.0
CA      40.08000  N     1.94       .    1.14   CA   1  . 2.0
SR      87.62     N     2.19       .    1.32   SR   1  . 2.0
BA     137.33     N     2.53       .    1.49   BA   1  . 2.0
RA     226.025    N     2.15       .    1.62   RA   1  . 2.0
#
SC      44.9559   N     1.60       .    0.885  SC   1  . 0.0
Y       88.9059   N     1.80       .    1.04   Y    1  . 0.0
LA     138.9055   N     1.95       .    1.172  LA   1  . 0.0
CE     140.12     N     1.85       .    1.01   CE   1  . 0.0
PR     140.9077   N     1.85       .    0.99   PR   1  . 0.0
ND     144.24     N     1.85       .    1.123  ND   1  . 0.0
PM        .       N      .         .    1.11   PM   1  . 0.0
SM     150.36     N     1.85       .    1.098  SM   1  . 0.0
EU     151.96     N     1.85       .    1.087  EU   1  . 0.0
GD     157.25     N     1.80       .    1.078  GD   1  . 0.0
TB     158.9254   N     1.75       .    0.90   TB   1  . 0.0
DY     162.50     N     1.75       .    1.052  DY   1  . 0.0
HO     164.9304   N     1.75       .    1.041  HO   1  . 0.0
ER     167.26     N     1.75       .    1.03   ER   1  . 0.0
TM     168.9342   N     1.75       .    1.02   TM   1  . 0.0
YB     173.04     N     1.75       .    1.008  YB   1  . 0.0
LU     174.967    N     1.75       .    1.001  LU   1  . 0.0
#
AC     227.028    N     1.95       .    1.26   AC   1  . 0.0
TH     232.0      N     1.80       .    1.08   TH   1  . 0.0
PA     231.0      N     1.80       .    0.92   PA   1  . 0.0
U      238.0      N     1.86       .    0.66   U    1  . 0.0
NP     237.0      N     1.75       .    0.85   NP   1  . 0.0
PU     239.0      N     1.75       .    0.85   PU   1  . 0.0
AM     241.0      N     1.75       .    0.99   AM   1  . 0.0
CM     244.0      N      .         .    0.99   CM   1  . 0.0
BK     249.0      N      .         .    0.97   BK   1  . 0.0
CF     252.0      N      .         .    0.961  CF   1  . 0.0
ES     253.0      N      .         .     .     ES   1  . 0.0
FM     257.0      N      .         .     .     FM   1  . 0.0
MD     256.0      N      .         .     .     MD   1  . 0.0
NO     255.0      N      .         .     .     NO   1  . 0.0
LR     256.0      N      .         .     .     LR   1  . 0.0
#
TI     47.88      N     1.40       .    0.56   TI   1  . 0.0
ZR     91.22      N     1.55       .    0.73   ZR   1  . 0.0
HF    178.49      N     1.55       .    0.72   HF   1  . 0.0
RF      .         N      .         .     .     RF   1  . 0.0
#
V      50.9415    N     1.35       .    0.68   V    1  . 0.0
NB     92.9064    N     1.45       .    0.62   NB   1  . 0.0
TA    180.9479    N     1.45       .    0.78   TA   1  . 0.0
DB       .        N      .         .     .     DB   1  . 0.0
#
CR     51.996     N     1.40       .    0.53   CR   1  . 0.0
MO     95.94      N     1.45       .    0.55   MO   1  . 0.0
W     183.85      N     1.35       .    0.56   W    1  . 0.0
SG       .        N      .         .     .     SG   1  . 0.0
#
MN     54.938     N     1.40       .   0.46    MN   1  . 0.0
TC     98.906     N     1.35       .   0.51    TC   1  . 0.0
RE    186.207     N     1.35       .   0.52    RE   1  . 0.0
BH      .         N      .         .    .      BH   1  . 0.0
#
FE     55.847     N     1.40       .   0.68    FE   1  . 0.0
RU    101.07      N     1.30       .   0.52    RU   1  . 0.0
OSE   190.2       N     1.30       .   0.53    OS   1  . 0.0
HS       .        N      .         .    .      HS   1  . 0.0
#
CO     58.9332    N     1.35       .   0.54    CO   1  . 0.0
RH    102.9055    N     1.35       .   0.69    RH   1  . 0.0
IR    192.22      N     1.35       .   0.71    IR   1  . 0.0
MT       .        N      .         .    .      MT   1  . 0.0
#
NI    58.69       N     1.63       .   0.63    NI   1  . 0.0
PD   106.42       N     1.63       .   0.78    PD   1  . 0.0
PT   195.08       N     1.75       .   0.71    PT   1  . 0.0
#
CU    63.546      N     1.40       .   0.71    CU   1  . 2.0
 AG   107.868      N     1.72       .   0.81    AG   1  . 0.0
 AU   196.9665     N     1.66       .   0.71    AU   1  . 0.0
#
 ZN    65.38       N     1.39       .   0.74    ZN   1  . 2.0
 CD   112.41       N     1.58       .   0.92    CD   1  . 0.0
 HG   200.59       N     1.55       .   1.10    HG   1  . 0.0
#
 B       10.81     N     0.85       .   0.25    B    1  . 0.0
 AL      26.98154  N     1.25       .   0.53    AL   1  . 0.0
 GA      69.72     N     1.87       .   0.61    GA   1  . 0.0
 IN     114.82     N     1.93       .   0.76    IN   1  . 0.0
 TL     204.383    N     1.96       .   0.89    TL   1  . 0.0
#
 AS     74.9216    N     1.85       .   0.475   AS   1  . 0.0
 AS1    74.9216    N     1.85       .   0.475   AS   1  . 0.0
 SB    121.75      N     1.8        .   0.90    SB   1  . 0.0
 BI    208.9804    N     1.8        .   0.90    BI   1  . 0.0
#
 SE     78.96      N     1.90       .   0.42    SE   1  . 0.0
 TE    127.60      N     2.06       .   0.57    TE   1  . 0.0
 PO    210.0       N     2.0        .   0.81    PO   1  . 0.0
#
 F      18.998     B     1.47       .   1.19    F    1  . 0.0
 CL     35.453     A     1.75       .   1.67    CL   1  . 0.0
 BR     79.904     N     1.85       .   0.73    BR   1  . 0.0
 I     126.9045    N     1.98       .   0.56    I    1  . 0.0
 AT    210.0       N     1.80       .   0.76    AT   1  . 0.0
#
 HE      4.0026    N     1.40       .    .      HE   1  . 0.0
 NE     20.179     N     1.54       .   1.12    NE   1  . 0.0
 AR     39.948     N     1.88       .   1.54    AR   1  . 0.0
 KR     83.80      N     2.02       .   1.69    KR   1  . 0.0
 XE    131.29      N     2.16       .   1.90    XE   1  . 0.0
 RN    222.0       N     2.20       .   2.0     RN   1  . 0.0
 DUM    16.0       N     0.6       0.6  0.6     O    .  . 0.0
 .        .        .      .         .    .      .    .  . .
#
# ---   LIST OF SYNONYMS ---
#

loop_
_lib_synonym.atom_type
_lib_synonym.atom_alternative_type
#
  NT3      NH3   
#
# ---  BONDS ---
#
loop_
_lib_bond.atom_type_1
_lib_bond.atom_type_2
_lib_bond.type
_lib_bond.const
_lib_bond.length
_lib_bond.value_esd
#  
#  _atom_type  atomic chemical type
#  _const      constant KBOND
#  _value     equilibrium length of this bond BOND0
#              BOND - actual bond length 
#
#              ENERGY = KBOND * ( BOND - BOND0 )**2
#
#    Values for bond distances and sigmas are from (where it is possible):
#   International tables for crystallography
#    Volume C, 1992, 
#    Edited by AJC Wilson
#    Published for IUCr by Kluwer Academic Publishers, Dordrecht/Boston/London
#    For carbon-carbon etc
#    Section: Typical Interatomic distances: Organic compounds
#    Authors: FH Allen, O. Kennard, DG Watson, L Brammer, AG Orpen and R Taylor
#    pages:   685-706
#
#    For metal radii and distances.
#    Section: Typical interatomic distances: Organometallic Compounds and 
#             Coordination complexes of the d- and f-block metals
#    Authors: AG Orpen, L. Brammer, FH Allen, O Kennard, DG Watson and R Taylor
#    pages:   707-791
#
 C    C    single    420.0      1.460  0.025
 C    C    double    420.0      1.330  0.020
 C1   C    single    420.000    1.475  0.020
 C1   C    double    420.000    1.340  0.020
 C1   C1   single    420.000    1.460  0.015
 C1   C1   double    420.000    1.330  0.014
 C2   C    double    420.000    1.320  0.030
 C2   C1   double    420.000    1.320  0.030
 C2   C2   double    420.000    1.320  0.030
 C    CR1  single    450.000    1.480  0.020
 C1   CR1  single    450.000    1.480  0.020
 C2   CR1  single    450.000    1.480  0.020
 CR15 CR15 aromatic  450.000    1.380  0.020
 CR5  C    single    405.000    1.490  0.016
 CR5  C1   single    405.000    1.483  0.015
 CR5  C2   single    405.000    1.483  0.020
 CR5  CR1  aromatic  450.000    1.455  0.020
 CR5  CR1H aromatic  450.000    1.455  0.020
 CR5  CR15 aromatic  450.000    1.387  0.020
 CR55 CR15 aromatic  450.000    1.390  0.020
 CR5  CR5  aromatic  450.000    1.390  0.020
 CR5  CR5  single    450.000    1.490  0.015
 CR55 CR5  aromatic  450.000    1.390  0.020
 CR55 CR5  single      .        1.490  0.020
 CR56 CR5  aromatic  450.000    1.390  0.020
 CR56 CR5  single    450.000    1.490  0.020
 CR56 CR56 aromatic  450.000    1.390  0.020
 CR56 CR56 single    450.000    1.490  0.020
 CR16 CR56 aromatic  450.000    1.390  0.020
 CR16 CR16 aromatic  450.000    1.390  0.020
 CR6  C    single    405.000    1.500  0.020
 CR6  C1   single    405.000    1.480  0.020
 CR6  C2   single    405.000    1.480  0.020
 CR6  CR5  single    450.000    1.490  0.015
 CR6  CR5  aromatic  450.000    1.390  0.015
 CR6  CR56 aromatic  450.000    1.390  0.020
 CR6  CR56 single    450.000    1.490  0.020
 CR6  CR16 aromatic  450.000    1.390  0.020
 CR6  CR6  aromatic  450.000    1.384  0.013
 CR6  CR6  single    450.000    1.487  0.015
 CR66 CR16 aromatic  450.000    1.390  0.015
 CR66 CR6  aromatic  450.000    1.390  0.015
 CR66 CR6  single    450.000    1.490  0.015
 CR66 CR66 aromatic  450.000    1.390  0.015
 CR66 CR66 single    450.000    1.490  0.015
 CR15  .   aromatic     .       1.390  0.020
 CR15  .   single       .       1.490  0.020
 CR5   .   aromatic     .       1.390  0.020
 CR5   .   single       .       1.490  0.020
 CR55  .   single       .       1.490  0.020
 CR55  .   aromatic     .       1.390  0.020
 CR56  .   single       .       1.490  0.020
 CR56  .   aromatic     .       1.390  0.020
 CR16  .   single       .       1.490  0.020
 CR16  .   aromatic     .       1.390  0.020
 CR6   .   single       .       1.490   .
 CR6   .   aromatic     .       1.390   .
 CR66  .   single       .       1.490   .
 CR66  .   aromatic     .       1.390   .
 CR1   .   single       .       1.500   .
 CR1H  .   single       .       1.500   .
 C     .   single       .       1.460   .
 C     .   double       .       1.330   .
 C1    .   single       .       1.480   .
 C1    .   double       .       1.330   .
 C2    .   single       .       1.480   .
 C2    .   double       .       1.330   .
 CH1   .   single       .       1.530   .
 CH1  C    single    405.000    1.500   0.020
 CH1  C1   single    405.000    1.510   0.020
 CH1  C2   single    405.000    1.510   0.020
 CH1  CR1  single    405.000    1.500   .
 CH1  CR5  single    405.000    1.480   0.020
 CH1  CR6  single    405.000    1.480   0.020
 CH1  CH1  single    200.000    1.524   0.020
 CH1  CSP  single    200.000    1.470   0.020
 CH2   .   single      .        1.524   0.020
 CH2  C    single    405.000    1.510   0.020
 CH2  C1   single    405.000    1.510   0.020
 CH2  C2   single    405.000    1.510   0.020
 CH2  CR1  single    405.000    1.500   0.020
 CH2  CR5  single    405.000    1.510   0.020
 CH2  CR6  single    405.000    1.511   0.020
 CH2  CH1  single    200.000    1.524   0.020
 CH2  CH2  single    200.000    1.524   0.020
 CH2  CSP  single    200.00     1.470   0.020
 CH3   .   single      .        1.524   0.020
 CH3  CSP  single    405.000    1.470   0.020
 CH3  C    single    405.000    1.500   0.020
 CH3  C1   single    405.000    1.510   0.020
 CH3  CR1  single    405.000    1.500   0.020
 CH3  CR5  single    405.000    1.506   0.020
 CH3  CR6  single    405.000    1.506   0.020
 CH3  CH1  single    200.000    1.524   0.020
 CH3  CH2  single    200.000    1.513   0.014
 CH3  CH3  single    200.000    1.530   0.014
 CSP  .    single      .        1.377   0.020
 CSP  CSP  single    200.000    1.377   0.012
 CSP  .    triple      .        1.180   0.020
 CSP1 .    triple      .        1.180   0.020
 CSP1 .    single      .        1.377   0.020
 CSP  CSP  triple    200.000    1.180   0.015
 CT   .    single      .        1.524   0.020
 CT   C    single    200.000    1.507   0.020
 CT   C1   single    200.000    1.510   0.020
 CT   C2   single    200.000    1.520   0.020
 CT   CR5  single    200.000    1.500   0.020
 CT   CR56 single    200.000    1.500   0.020
 CT   CR6  single    405.000    1.500   0.020
 CT   CH1  single    200.000    1.524   0.020
 CT   CH2  single    200.000    1.524   0.020
 CT   CH3  single    200.000    1.524   0.020
 CT   CT   single    200.000    1.524   0.020
 CT   CSP  single    200.000    1.470   0.020
 NS1  .    triple       .       1.170    .
 NS1  .    single       .       1.350    .      # ?
 NS   .    triple       .       1.170    .
 NS   .    single       .       1.350    .      # ?
 NS   CSP  triple       .       1.158    .
 NS   CSP1 triple       .       1.158    .
 NS   NS   triple       .       1.158    .      # ?
 N    .    single       .       1.410    .      # ?
 N    N    single       .       1.410    .      # ?
 N    .    deloc        .       1.30    0.020
 N    N    deloc        .       1.30    0.020
 N    .    double       .       1.24    0.020
 N    N    double       .       1.24    0.020
 N    C    double    471.000    1.260    .
 N    C    aromat    471.000    1.330    .
 N    C1   double    471.000    1.260    .
 N    C2   double    471.000    1.260    .
 N    CR6  single    422.000    1.400    .
 N    CR6  aromatic  422.000    1.355    .
 N    CR16 single    422.000    1.400    .
 N    CR16 aromatic  422.000    1.355    .
 N    CH1  single    422.000    1.455    .    
 N    CH2  single    422.000    1.455    .
 N    CH3  single    422.000    1.455    .
 N    CT   single    422.000    1.455    .
 NC1  .    single    422.000    1.400    .
 NC1  C    deloc     471.000    1.339    .
 NC1  C1   deloc     471.000    1.327    .
 NC1  C2   deloc     471.000    1.327    .
 NC1  CH2  single    422.000    1.457    .
 NH1  .    single    422.000    1.400    .
 NH1  C    deloc     471.000    1.330    .
 NH1  C1   deloc     471.000    1.330    .
 NH1  C2   deloc     471.000    1.330    .
 NH1  CR6  deloc     471.000    1.350    .
 NH1  CR5  deloc     422.000    1.350    .
 NH1  CH1  single    422.000    1.450    .
 NH1  CH2  single    422.000    1.450    .
 NH1  CH3  single    422.000    1.450    .
 NH1  CT   single    422.000    1.450    .
 NC2  .    single      .        1.400    .
 NC2  C    deloc     400.000    1.336    0.017 
 NC2  C1   deloc     400.000    1.336    0.017
 NC2  C2   deloc     400.000    1.336    0.017
 NC2  CR6  deloc     422.000    1.355    0.020
 NC2  CH1  single    422.000    1.457    .
 NC2  CH2  single    422.000    1.457    .
 NC3   .   single       .       1.410    .
 NC3  CH1  single    422.000    1.470    .    # ?
 NC3  CH2  single    422.000    1.470    .    # ?
 NH2  .    single       .       1.400    .
 NH2  C    deloc     471.000    1.332    0.020
 NH2  C1   deloc     471.000    1.332    0.020
 NH2  C2   deloc     471.000    1.332    0.020
 NH2  CR5  deloc     422.000    1.355    0.020
 NH2  CR6  deloc     471.000    1.355    0.020
 NH2  CH1  single    422.000    1.450    0.020
 NH2  CH2  single    422.000    1.450    0.020
 NT3   .   single      .        1.420     .
 NT3  CR6  single    422.000    1.488     .
 NT3  CH1  single    422.000    1.488    0.020
 NT3  CH2  single    422.000    1.488    0.020
 NT3  CH3  single    422.000    1.488    0.020
 NT3  CT   single    422.000    1.488    0.020
 NT3  C    single    422.000    1.420    0.020
 NT3  C1   single    422.000    1.420    0.020
 NT3  C2   single    422.000    1.420    0.020
 NT1  .    single      .        1.420    0.020
 NT2  .    single      .        1.420    0.020
 NT   .    single      .        1.420     .
 NT   C    single    422.000    1.416    0.020
 NT   C1   single    422.000    1.416    0.020
 NT   C2   single    422.000    1.416    0.020
 NT   CH1  single    422.000    1.469    0.020
 NT   CH2  single    422.000    1.469    0.020
 NT   CH3  single    422.000    1.469    0.020
 NPA   .   aromatic    .        1.31      .
 NPA   .   single      .        1.40      .
 NPA  CR5  aromatic  471.000    1.336    0.014
 NPA  CH1  single    422.000    1.450     .    # ?
 NPA  CT   single    422.000    1.450     .    # ?
 NPB   .   aromatic    .        1.310     .
 NPB   .   single      .        1.400     .
 NPB  CR5  aromatic  471.000    1.336     0.014 
 NR5  .    aromatic    .        1.304     .
 NR5  .    single      .        1.400     .     # ?
 NR5  CR15 aromatic  440.000    1.337    0.020
 NR5  CR5  aromatic  471.000    1.337    0.020  
 NR5  CR56 aromatic  436.000    1.337    0.020
 NR5  CR16 aromatic  471.000    1.337    0.020
 NR5  CR6  aromatic  471.000    1.337    0.020
 NR5  CH1  single    337.000    1.485    0.020
 NR5  CH3  single    337.000    1.485    0.020
 NR5  CT   single    337.000    1.485    0.020
 NR15  .   aromatic    .        1.304     .
 NR15  .   single      .        1.400     .
 NR15 NR15 aromatic  422.000    1.304     .
 NR15 CR15 aromatic  471.000    1.350     .
 NR15 CR5  aromatic  471.000    1.340     . 
 NR15 CR56 aromatic  471.000    1.340     .
 NRD5  .   aromatic    .        1.304     .
 NRD5  .   single      .        1.404     .
 NRD5 CR15 aromatic  471.000    1.350     . #?
 NRD5 CR5  aromatic  471.000    1.350     .  #?
 NRD5 CR56 aromatic  471.000    1.350     .  #?
 NRD5 CR56 aromatic  414.000    1.390     .  #?
 NRD5 CR56 aromatic  471.000    1.350     .  #?
 NR56  .   aromatic    .        1.304     .  
 NR56  .   single      .        1.400     .  # ?
 NR55 CR15 aromatic  450.000    1.390  0.020
 NR55 CR5  aromatic  450.000    1.390  0.020
 NR55 CR5  single      .        1.490  0.020
 NR55  .   single      .        1.400     .  # ?
 NR55  .   aromatic     .       1.390  0.020
 NR56 CR5  aromatic  448.000    1.337     .
 NR56 CR6  aromatic  448.000    1.337     .
 NR56 CR56 aromatic  448.000    1.337     .
 NR56 CR15 aromatic  448.000    1.337     .
 NR56 CR16 aromatic  448.000    1.337     .
 NR6   .   aromatic    .        1.304     .
 NR6   .   single      .        1.400     .
 NR6  CR16 aromatic  448.000    1.337     .
 NR6  CR6  single    424.000    1.410     .
 NR6  CR6  aromatic  424.000    1.337     .
 NR6  CR66 single    424.000    1.410     .
 NR6  CR66 aromatic  424.000    1.337     .
 NR6  CH1  single    337.000    1.465     .
 NR6  CH2  single    337.000    1.465     .
 NR6  CH3  single    337.000    1.465     .
 NR6  CT   single    337.000    1.465     .
 NR16 CR6  aromatic  422.000    1.337     .
 NR16  .   aromatic    .        1.304     .
 NR16  .   single      .        1.400     .
 NR16 CR16 aromatic  422.000    1.337     .
 NR16 CR66 aromatic  422.000    1.337     .
 NR16 CR56 aromatic  461.000    1.337     .
 NRD6  .   aromatic    .        1.330     .
 NRD6  .   single      .        1.400     .
 NRD6 CR56 aromatic  461.000    1.355     .  #?
 NR6  CR56 aromatic  461.000    1.337     .
 NRD6 CR16 aromatic  471.000    1.337     .  #?
 NRD6 CR6  aromatic  470.000    1.350     .  #?
 NRD6 CR66 aromatic  470.000    1.350     .  #?
 O    H    single      .        1.040     .
 O    .    single      .        1.469     .
 O    .    double      .        1.080     .
 O    C    single    580.000    1.330     .
 O    C    double    580.000    1.220     .
 O    C1   single    580.000    1.330     .
 O    C1   double    580.000    1.220     .
 O    C2   double    580.000    1.220     .
 O    CR15 single    580.000    1.370     .
 O    CR15 aromatic  580.000    1.250     .
 O    CR6  single    580.000    1.330     .
 O    CR6  aromatic  580.000    1.250     .
 O    CH1  single    400.000    1.420     .
 O    CH2  single    400.000    1.420     .
 O    CH3  single    400.000    1.413    0.018
 O    CT   single    400.000    1.430    0.015
 O    N    single    580.000    1.400     .
 O    N    double      .        1.220    0.020
 O2   .    single     .         1.469     .
 O2   C    single    580.000    1.454    0.016
 O2   C2   single    580.000    1.454    0.016
 O2   C1   single    580.000    1.454    0.016
 O2   CR5  aromatic  580.000    1.250     .
 O2   CR5  single      .        1.370     .
 O2   CR6  aromatic  580.000    1.250     .
 O2   CR6  single    580.000    1.370     .
 O2   CR66 aromatic  580.000    1.250     .
 O2   CR66 single      .        1.370     0.020
 O2   CH1  single    320.000    1.426     0.020
 O2   CH2  single    320.000    1.426     0.020
 O2   CH3  single    320.000    1.426     0.020
 O2   CT   single    320.000    1.426     0.020
 O2   NR15 aromatic  580.000    1.400     0.020
 OH1  .    single      .        1.469      .
 OH1  C    single    450.000    1.330     0.015
 OH1  C1   single    450.000    1.330     0.015
 OH1  C2   single    450.000    1.330     0.015
 OH1  CR15 single    450.000    1.362     0.015  # ? impossible
 OH1  CR6  single    450.000    1.362     0.015
 OH1  CH1  single    320.000    1.432     0.020
 OH1  CH2  single    320.000    1.432     0.020
 OH1  CH3  single    320.000    1.413     0.020
 OH1  CT   single    320.000    1.432     0.020
 OH1  N    single    450.000    1.392     0.015
 OH1  NH1  single    450.000    1.392     0.020
 OH1  NT   single    450.000    1.460     0.020
 OH1  NT3  single    450.000    1.460     0.020
 OC2   .   single      .        1.469     0.020
 OC2  CR15 single    580.000    1.354      .  #?
 OC2  CR15 aromatic  580.000    1.254      .  #?
 OC2  CH1  single    320.000    1.410      .
 OC2  CH2  single    320.000    1.410      .
 OC2  CT   single    320.000    1.410      .
 OC   .    single      .        1.150      .   #? for OC single and double
 OC   .    double      .        1.150      .   #? are equavalent
 OC   C    deloc     580.000    1.250      .   # bond should be delocalised
 OC   C1   deloc     580.000    1.250      .
 OC   C2   deloc     580.000    1.250      .
 OC   CH1  deloc     580.000    1.420      .  #impossible ?
 OP    .   single     .         1.150      .  # ?
 OP    .   double     .         1.150      .  # single and double are equavalent
 H     .   single     .         0.667     0.020
 HCH1  .   single     .         0.667      .
 HCH1 CH1  single    300.000    1.099     0.010
 HCH2  .   single     .         0.667      .
 HCH2 CH2  single    300.000    1.092     0.013
 HCH3  .   single     .         0.667      .
 HCH3 CH3  single    300.000    1.059     0.030
 HCR1  .   single     .         0.667      .
 HCR1 CR1  single    350.000    1.077     0.012 # impossible
 HCR1 CR1H single    350.000    1.077     0.012
 HC2   .   single     .         0.667      .
 HC2  C2   single    350.000    1.077     0.012
 HC1   .   single     .         0.667      .
 HC1  C1   single    350.000    1.077     0.012
 HCR5  .   single     .         0.667      .
 HCR5 CR15 single    350.000    1.083     0.011
 HCR6  .   single     .         0.667      .
 HCR6 CR16 single    350.000    1.083     0.011
 HNC1  .   single     .         0.667      .
 HNC1 NC1  single    405.000    1.009     0.020  #?  
 HNC2  .   single     .         0.667      .
 HNC2 NC2  single    405.000    1.009     0.020   #?
 HNT1  .   single     .         0.667      .
 HNT1 NT1  single    405.000    1.033     0.022
 HNT2  .   single     .         0.667      .
 HNT2 NT2  single    405.000    1.033     0.022
 HNT3  .   single     .         0.667      .
 HNT3 NT3  single    405.000    1.033     0.022  
 HNH1  .   single     .         0.667      .
 HNH1 NH1  single    405.000    1.010     0.020   #?
 HNH2  .   single     .         0.667      .
 HNH2 NH2  single    405.000    1.010     0.020
 HNR5  .   single     .         0.667      .
 HNR5 NR15 single    405.000    1.040     0.020  #?
 HNR6  .   single     .         0.667      .
 HNR6 NR16 single    405.000    1.040     0.020  #?
 HOH1  .   single     .         0.667      .
 HOH1 OH1  single    450.000    0.967     0.010  
 HOH2  .   single     .         0.667      .
 HOH2 OH2  single    450.000    0.960     0.020 #?
 HOHA  .   single     .         0.667      .
 HOHA OHA  single    450.000    0.960     0.020 #?
 HOHB  .   single     .         0.667      .
 HOHB OHB  single    450.000    0.960     0.020 #?
 HOHC  .   single     .         0.667      .
 HOHC OHC  single    450.000    0.960     0.020 #?
 P    .    single     .         2.256      .
 P    .    double     .         2.050      .
 P    .    deloc      .         2.100     0.020
 P1   .    single     .         2.200     0.020
 P    O2   single    230.000    1.610      .
 P    OC2  single    230.000    1.610      .
 P    OP   deloc        .       1.510      .      
 P    P    single       .       2.214   0.022
 P    P    double       .       2.030   0.030
 PS   PS   single       .       2.214   0.022
 PS   PS   double       .       2.030   0.030
 PS   .    single       .       2.114   0.040
 PS   .    double       .       1.930   0.040
#
 S    .    single      .        2.050      .
 S    .    double      .        1.890      .  # ?
 S    CH1  single    450.000    1.810      .
 S    CH2  single    450.000    1.810      .
 S    CH3  single    450.000    1.810      .
 S    OS   single    525.000    1.577      .
 S    OS   double    525.000    1.436      .
 S    OS   deloc        .       1.470      .
 S    O    single    525.000    1.577      .  # impossible
 S    O    double    525.000    1.436      .
 ST   .    single      .        2.050      .
 ST   .    double      .        1.80      0.020
 ST   .    deloc       .        1.80      0.020
 S2   .    single      .        2.00      0.020
 S1   .    double      .        1.80      0.020
 ST   OS   single    525.000    1.577      .
 ST   OS   double    525.000    1.436      .
 ST   OS   delocal   525.000    1.480      .
 ST   O    single    525.000    1.575      .
 ST   O    double    525.000    1.436      .
 S    S    single    500.000    2.036      .
 SH1  .    single     .         2.050      .
 SH1  CSP  single    450.000    1.680      .
 SH1  CH2  single    450.000    1.810      .
 SH1  HSH1 single    300.000    1.330      .    # ?
 FE   .    metal       .        2.470     0.040 # ?
 FE   NPA  metal     500.000    2.090     0.040 # ?
 FE   NPB  metal     500.000    2.090     0.040 # ?
 FE   NR5  metal     500.000    2.090     0.040 # ?
 FE   NRD5 metal     500.000    1.980     0.040 # ?
 FE   O    metal     500.000    2.040     0.040 # ?
 FE   S    metal     500.000    2.300     0.040 
 MG   .    metal       .        2.670     0.040
 MG   NPA  metal     500.000    2.090      .
 MG   NPB  metal     500.000    2.090      .
 MG   OHA  metal     500.000    2.150      .  # ?
 MG   OHB  metal     500.000    2.150      .  # ?
 MG   OHC  metal     500.000    2.150      .  # ?
 MG   O    metal     500.000    2.180      .  # ?
 F    .    single       .       1.300      .  # ?
 F    CH1  single       .       1.370      .
 F    CH2  single       .       1.370      .
 F    CH3  single       .       1.370      .
 F    CT   single       .       1.320      .
 B    .    single       .       1.600      .  # ? 
 B    CH1  single       .       1.600      .
 B    CH2  single       .       1.600      .
 B    CH3  single       .       1.600      .
 B    CT   single       .       1.600      .
 B    OB   single       .       1.37       .
 CA   .    metal        .       3.25      0.050
 CA   OS   metal        .       2.32      0.050
 CA   O    metal        .       2.32      0.050
 CA   O2   metal        .       2.32      0.050
 CA   OH1  metal        .       2.32      0.050
 CA   OH2  metal        .       2.32      0.050
 CA   OHA  metal        .       2.32      0.050
 CA   OHB  metal        .       2.32      0.050
 CA   OHC  metal        .       2.32      0.050
 CA   OC2  metal        .       2.32      0.050
 CA   OC   metal        .       2.32      0.050
 CA   OP   metal        .       2.32      0.050
 CL   .    single       .       2.20      0.040
 CL   CH1  single       .       1.790     0.020
 CL   CH2  single       .       1.790     0.020
 CL   CH3  single       .       1.790     0.020
 CL   CT   single       .       1.790     0.020
 CO   .    metal        .       2.380     0.050
 CO   C    metal      65.000    1.980      .
 CO   C1   metal      65.000    1.980      .
 CO   C2   metal      65.000    1.980      .
 CO   CT   metal      65.000    1.980      .
 CO   CH1  metal      65.000    1.980      .
 CO   CH2  metal      65.000    1.980      .
 CO   CH3  metal      65.000    1.980      .
 CO   NPA  metal     500.000    1.980      .
 CO   NPB  metal     500.000    1.980      .
 CO   NT3  metal     500.000    1.980      .
 CO   NRD5 metal      65.000    1.980      .
 ZN    .   metal       .        2.900      .
 ZN   NRD5 metal      65.000    2.150      .
 I     .   single      .        2.80       . 
 I    CR6  single     65.000    2.090      .
 BR    .   metal       .        2.500      .
 BR   CR6  metal      65.000    1.890      .
#
 NA        .       metal  .     3.400      .
 V         .       metal  .     2.740      .
 MN        .       metal  .     2.700      .
 CU        .       metal  .     2.750      .
 CD        .       metal  .     3.250      .
 PB        .       metal  .     3.530      .
 HG        .       metal  .     3.200    0.070
 U         .       metal  .     3.400    0.070  # ?
 W         .       metal  .     3.000    0.070
 Y         .       metal  .     3.550    0.070
 K         .       metal  .     4.130    0.070
 SI        .       single .     2.10     0.020
 SI        SI      single .     2.35     0.020
 SI1       .       single .     2.10     0.030
 AL        .       metal  .     3.80     0.070
 AL        O       double .     1.850    0.030
 GD        .       metal  .     3.570    0.070
 NI        .       metal  .     2.800    0.070
 SM        .       metal  .     2.450    0.070
 SR        .       metal  .     3.800    0.070
 IN        .       metal  .     3.400    0.070
 HO        .       metal  .     3.250    0.070
 YB        .       metal  .     3.350    0.070
 TE        .       metal  .     2.600    0.070
 LI        .       metal  .     2.400    0.070
 RB        .       metal  .     3.800    0.070
 BA        .       metal  .     4.350    0.070  # ?
 CS        .       metal  .     4.500    0.070
 TL        .       metal  .     3.400    0.070
 PT        .       metal  .     2.650    0.040
 BE        .       metal  .     2.230    0.040
 SC        .       metal  .      .       0.04
 TI        .       metal  .      .       0.04
 CR        .       metal  .      .       0.04
 GA        .       metal  .      .       0.04
 GE        .       single .    2.35      0.02
 GE        .       metal  .    2.40      0.04
 GE1       .       metal  .    2.40      0.04
 GE1       .       single  .   2.35      0.02
 SN        .       single  .   2.75      0.03
 SN        .       metal   .   2.75      0.03
 PB        .       metal   .   2.90      0.04
# AS        .       metal  .    2.46      0.04
 AS        .       single .    2.40      0.03
 AS1       .       single .    2.46      0.03
 SB        .       metal  .      .       0.04
 BI        .       metal  .    2.80      0.04
# 
 ZR        .       metal  .      .       0.04
 NB        .       metal  .      .       0.04
 TC        .       metal  .      .       0.04
 RU        .       metal  .      .       0.04
 RH        .       metal  .      .       0.04
 PD        .       metal  .      .       0.04
 AG        .       metal  .      .       0.04
            

 SE       CH1      single .     1.970    0.020
 SE       CH2      single .     1.970    0.020
 SE       CH3      single .     1.970    0.020
 SE       CT       single .     1.970    0.020
 SE        .       single .     2.340    0.040
 SE        .       double .     1.750    0.040
 SE        O      single  .     1.974    0.020
 SE        O      double  .     1.597    0.020
 MO        .       metal  .     2.650    0.040
 OSE       .       metal  .     2.650    0.040
 IR        .       metal  .     2.650    0.040
#
 DUM        .       .      .     0.01    1.000
  .         .       .      .     2.4     0.100
#
# ---  ANGLES ---
#
loop_
_lib_angle.atom_type_1
_lib_angle.atom_type_2
_lib_angle.atom_type_3
_lib_angle.const
_lib_angle.value
#
# _atom_type atomic chemical type
# _const     constant KTHETA
# _value     equilibrium value for the angle THETA0
#           THETA - actual angle    
#
#           ENERGY = KTHETA * ( THETA - THETA0 )**2
#
 NS   CSP  CH3      .     180.000
 NS   CSP  SH1      .     180.000

 C    C    C      45.000  120.000
 CH1  C    C      45.000  120.000
 CH2  C    C      45.000  120.000
 CH3  C    C      45.000  120.000
 CT   C    C      45.000  120.000
 C1   C    C      45.000  120.000
 C2   C    C      45.000  120.000
 C1   C    C1     45.000  120.000
 C2   C    C1     45.000  120.000
 CH1  C    C1     45.000  120.000
 CH2  C    C1     45.000  120.000
 CH3  C    C1     45.000  120.000
 CT   C    C1     45.000  120.000
 C2   C    C2     45.000  120.000
 CH1  C    C2     45.000  120.000
 CH2  C    C2     45.000  120.000
 CH3  C    C2     45.000  120.000
 CT   C    C2     45.000  120.000
 CH2  C    CR5    45.000  116.500
 CH3  C    CR5    45.000  116.500
 CH1  C    CH3    45.000  120.000
 CH1  C    CH2    45.000  120.000
 CH2  C    CH3    45.000  120.000
 CH3  C    CH3    45.000  120.000
 CT   C    CH1    45.000  120.000
 CT   C    CH2    45.000  120.000
 CT   C    CH3    45.000  120.000
 N    C    C      20.000  116.500
 N    C    C1     20.000  116.500
 N    C    C2     20.000  116.500
 N    C    CH1    20.000  116.500
 N    C    CH2    20.000  116.500
 N    C    CH3    20.000  116.500
 N    C    CT     20.000  116.500
 N    C    CO     20.     126.000
 N    C    N      70.000  120.000
 N    C    CR6    20.000  120.000
 NH1  C    CR5    20.000  120.000
 NH1  C    CR6    20.000  120.000
 NH1  C    CH1    20.000  116.500
 NH1  C    CH2    20.000  116.500
 NH1  C    CH3    20.000  116.500
 NH1  C    CT     20.000  116.500
 NC2  C    CR6    20.000  116.500
 NC2  C    NC1    70.000  120.000
 NC2  C    NC2    70.000  120.000
 NH2  C    CR6    20.000  120.000
 NH2  C    CH3    20.000  120.000
 NH2  C    CH2    20.000  116.500
 NH2  C    NH1    20.000  120.000
 NH2  C    NH2    20.000  120.000
 NT3  C    C      20.000  120.000
 O    C    C      85.000  120.500
 O    C    C1     85.000  120.500
 O    C    C2     85.000  120.500
 O    C    CH1    85.000  120.500
 O    C    CH2    85.000  120.500
 O    C    CH3    85.000  123.000
 O    C    CT     85.000  120.500
 O    C    CR5    85.000  120.500
 O    C    CR6    85.000  120.500
 O    C    N      85.000  123.000
 O    C    NH1    65.000  123.000
 O    C    NH2    65.000  123.000
 O    C    NH3    65.000  123.000
 O    C    NC1    65.000  123.000
 O    C    NC2    65.000  123.000
 O    C    NT3    65.000  122.000
 O    C    O      60.000  120.000
 O    C    OH1    85.000  119.000
 O    C    O2     60.000  119.000
 O    C    OC     60.000  119.000
 
 O2   C    CR6    60.000  120.000
 O2   C    CH3    60.000  120.000
 O2   C    CH2    60.000  120.000
 O2   C    CH1    60.000  120.000
 O2   C    CT     60.000  120.000
 O2   C    C1     60.000  120.000
 O2   C    C      60.000  120.000
 O2   C    N      70.000  120.000
 O2   C    NH1    70.000  118.000

 OH1  C    CH1    85.000  120.000
 OH1  C    CH2    85.000  120.500
 OH1  C    CR6    85.000  120.000
 OH1  C    C      85.000  120.000
 OH1  C    NH1    85.000  120.000
 OH1  C    OH1    85.000  120.000
 OH1  C    O2     85.000  120.000
 OC   C    C      85.000  120.000
 OC   C    CH1    85.000  118.500
 OC   C    CH2    85.000  118.500
 OC   C    CT     85.000  118.500
 OC   C    OC     85.000  123.000

 O    C1   CH1     85.000  120.500
 O    C1   CH2     85.000  120.500
 O    C1   CH3     85.000  120.500
 O    C1   CT      85.000  120.500
 O    C1   N       70.000  120.000
 C    C1   CH1     85.000  120.500
 CT   C1   CH1     85.000  120.500
 C    C1   CH2     85.000  120.500
 C    C1   CH3     85.000  120.500
 C    C1   CT      85.000  120.500
 C1   C1   C       70.000  120.000
 C1   C1   C1      70.000  120.000
 C2   C1   C1      70.000  120.000
 CR6  C1   C1      70.000  120.000
 CR5  C1   C2      70.000  120.000

 HC1  C1   O       40.000  123.000
 HC1  C1   N       40.000  120.000
 HC1  C1   C       40.000  120.000
 HC1  C1   C1      40.000  120.000
 HC1  C1   C2      40.000  120.000
 HC1  C1   CR6     40.000  120.000
 HC1  C1   CR5     40.000  120.000
 HC1  C1   CH1     40.000  120.000
 HC1  C1   CH2     40.000  120.000
 HC1  C1   CH3     40.000  120.000
 HC1  C1   CT      40.000  120.000

 O    C2   CH1     85.000  120.500
 O    C2   CH2     85.000  120.500
 O    C2   CH3     85.000  120.500
 O    C2   CT      85.000  120.500
 O    C2   C       85.000  120.500
 O    C2   C1      85.000  120.500
 C1   C2   C       70.000  120.000
 HC2  C2   C       40.000  120.000
 HC2  C2   C1      40.000  120.000
 HCH  C2   CR1     40.000  120.000
 HC2  C2   CR5     40.000  120.000
 HC2  C2   HC2     40.000  120.000
 HC2  C2   CH1     40.000  120.000
 HC2  C2   CH2     40.000  120.000
 HC2  C2   CH3     40.000  120.000
 HC2  C2   CT      40.000  120.000
 HC2  C2   O       40.000  120.000

 CR5  CR1  C2     70.000  122.000
 CR5  CR1  CR5    70.000  126.000
 CH1  CR1  CR5    40.000  117.000
 CH3  CR1  CR5    40.000  117.000
 HCR1 CR1  C2     40.000  121.000
 HCR1 CR1  CR5    40.000  117.000

 CR5  CR1H CR5    70.000  126.000
 CH1  CR1H CR5    40.000  117.000
 CH3  CR1H CR5    40.000  117.000
 HCR1 CR1H CR5    40.000  117.000

 CR15 CR15 CR15   70.000  108.000
 CR5  CR15 CR5    70.000  108.000
 CR15 CR15 CR5    70.000  108.000
 CH2  CR15 CR15   70.000  126.000
 NR5  CR15 CR15   65.000  108.000
 NR5  CR15 CR5    65.000  108.000
 NR15 CR15 CR5    65.000  108.000
 NR56 CR15 CR15   65.000  108.000
 NR56 CR15 CR5    65.000  108.000

 CR56 NR56 FE     65.000  126.000
 NR56 NR56 FE     65.000  126.000
 CR56 NR56 MG     65.000  126.000
 NR56 NR56 MG     65.000  126.000
 CR56 NR56 CO     65.000  126.000
 NR56 NR56 CO     65.000  126.000
 CR5  NR5  FE     65.000  126.000
 NR5  NR5  FE     65.000  126.000
 CR5  NR5  MG     65.000  126.000
 NR5  NR5  MG     65.000  126.000
 CR5  NR5  CO     65.000  126.000
 NR5  NR5  CO     65.000  126.000
 CR15 NR5  FE     65.000  126.000
 NR15 NR5  FE     65.000  126.000
 CR15 NR5  MG     65.000  126.000
 NR15 NR5  MG     65.000  126.000
 CR15 NR5  CO     65.000  126.000
 NR15 NR5  CO     65.000  126.000

 NR5  CR5  S1     65.000  126.000
 NR15 CR5  S1     65.000  126.000
 NR5  NR5  S1     65.000  126.000
 NR15 NR5  S1     65.000  126.000
 CR5  CR5  S1     65.000  126.000
 CR15 CR5  S1     65.000  126.000
 CR5  NR5  S1     65.000  126.000
 CR15 NR5  S1     65.000  126.000

 NR56 CR56 CR5    70.000  108.000
 NR56 CR56 CR15   70.000  108.000
 CR56 NR56 CR56   70.000  108.000
 CR5  NR5  CR5    70.000  108.000
 CR56 CR5  CR5    70.000  108.000

 NR56 CR56 CR6    70.000  120.000
 NR56 CR56 CR16   70.000  120.000
 CR56 CR16 CR56   70.000  120.000
 CR56 CR6  CR56   70.000  120.000

 CT   CR56 CR6    70.000  132.000
 CR6  CR56 NR56   70.000  132.000
 CR5  CR56 CR6    70.000  132.000
 CR15 CR56 CR6    70.000  132.000

# CR5  CR56 CR16   70.000  132.000
# CR15 CR56 CR16   70.000  132.000

 CR16 CR56 NR56   70.000  126.000
 CR15 CR56 CR16   70.000  126.000

 CT   CR56 CR16   70.000  126.000
 CR16 CR56 CR5    70.000  126.000
 CR5  CR1  CR5    70.000  126.000

 CT   CR56 NR56   70.000  108.000
 CT   CR5  NR5    70.000  108.000
 CT   CR5  CR56   70.000  108.000
 CT   CR15 CR56   70.000  108.000
 CT   CR5  NR56   70.000  108.000
 CT   CR15 NR56   70.000  108.000
 CR5  CT   CR56   70.000  108.000

 CR66 NR66 FE     65.000  120.000
 NR66 NR66 FE     65.000  120.000
 CR66 NR66 MG     65.000  120.000
 NR66 NR66 MG     65.000  120.000
 CR66 NR66 CO     65.000  120.000
 NR66 NR66 CO     65.000  120.000

 CR66 NR66 S1     65.000  120.000
 NR66 NR66 S1     65.000  120.000
 CR66 CR66 S1     65.000  120.000

 NRD5 CR15 CR5    65.000  108.000
 NR5  CR15 NR5    70.000  108.000
 NR15 CR15 NR5    70.000  108.000
 NR15 CR15 NR15   70.000  108.000
 NRD5 CR15 NR5    70.000  108.000
 NRD5 CR15 NR15   70.000  108.000
 NRD5 CR15 NRD5   70.000  108.000
 O    CR15 CR15   60.000  126.000
 O    CR15 CH2    60.000  126.000
 O    CR15 NR5    60.000  126.000
 OH1  CR15 CR15   60.000  126.000
 OC2  CR15 CR15   60.000  126.000
 OC2  CR15 CR15   60.000  108.000
 HCR5 CR15 CR15   60.000  126.000
 HCR5 CR15 CR5    40.000  126.000
 HCR5 CR15 CH2    40.000  126.000
 HCR5 CR15 NR5    40.000  126.000
 HCR5 CR15 NR15   40.000  126.000
 HCR5 CR15 NRD5   40.000  126.000
 HCR5 CR15 O      40.000  126.000
 HCR5 CR15 O2     40.000  126.000
 HCR5 CR15 OH1    40.000  108.000
 HCR5 CR15 OC2    40.000  126.000

 CR56 CR5  CR6    70.000  126.000
 CR15 CR5  CR6    70.000  126.000
 CR5  CR5  CR16   70.000  126.000
 CR15 CR5  CR16   70.000  126.000
 CR5  CR5  CR6    70.000  126.000
 CR15 CR5  C      70.000  126.000
 CR15 CR5  CR15   70.000  108.000
 CR5  CR5  C      70.000  117.000
 CR5  CR5  C1     70.000  117.000
 CR5  CR5  C2     70.000  117.000
 CR5  CR5  CR1    70.000  126.000
 CR5  CR5  CR1H   70.000  126.000
 CR5  CR5  CR5    70.000  108.000
 CR56 CR5  CR15   70.000  108.000
 CH1  CR5  CR1    70.000  126.000
 CH1  CR5  CR1H   70.000  126.000
 CH1  CR5  CR5    70.000  126.000
 CH2  CR5  CR15   70.000  126.000
 CH2  CR5  CR5    70.000  126.000
 CH2  CR5  CR56   70.000  126.000
 CH3  CR5  CR15   70.000  108.000
 CH3  CR5  CR15   70.000  126.000
 CH3  CR5  CR5    70.000  126.000
 CT   CR5  CR1    70.000  126.000
 CT   CR5  CR1H   70.000  126.000
 CT   CR5  CR5    70.000  126.000
 CT   CR5  CH3    70.000  126.000
 CH2  CR5  CH3    70.000  126.000
 NH1  CR5  CR15   65.000  126.000
 NPA  CR5  CR1    65.000  126.000
 NPA  CR5  CR1H   65.000  126.000
 NPA  CR5  CR5    65.000  108.000
 NPA  CR5  CH1    65.000  108.000
 NPA  CR5  CH3    65.000  126.000
 NPA  CR5  CT     65.000  126.000
 NPB  CR5  CR1    65.000  126.000
 NPB  CR5  CR1H   65.000  126.000
 NPB  CR5  CR5    65.000  108.000
 NPB  CR5  CH1    65.000  108.000
 NPB  CR5  CH3    65.000  126.000
 NPB  CR5  CT     65.000  126.000

 NR5  CR5  C      70.000  126.000
 NR5  CR5  CH1    70.000  126.000
 NR5  CR5  CH2    70.000  126.000
 NR5  CR5  CH3    70.000  126.000
 NR5  CR5  CR5    70.000  108.000
 NR5  CR5  CR15   70.000  108.000
 NR5  CR5  CR6    70.000  126.000
 NR5  CR5  CR16   70.000  126.000
 NR5  CR5  NR5    70.000  108.000
 NR5  CR5  NR15   70.000  108.000
 NR5  CR5  NR56   70.000  108.000
 NR5  CR5  NRD5   70.000  108.000

 NR15 CR5  C      70.000  126.000
 NR15 CR5  CH1    70.000  126.000
 NR15 CR5  CH2    70.000  126.000
 NR15 CR5  CH3    70.000  126.000
 NR15 CR5  CR5    70.000  108.000
 NR15 CR5  CR15   65.000  108.000
 NR15 CR5  NR15   70.000  108.000
 NR15 CR5  NR56   70.000  108.000
 NR15 CR5  NRD5   70.000  108.000

 NR56 CR5  C      70.000  126.000
 NR56 CR5  CH1    70.000  126.000
 NR56 CR5  CH2    70.000  126.000
 NR56 CR5  CH3    70.000  126.000
 NR56 CR5  CR5    70.000  108.000
 NR56 CR5  CR15   70.000  108.000
 NR56 CR5  NR56   70.000  108.000
 NR56 CR5  NRD5   70.000  108.000
 
 NRD5 CR5  C      70.000  126.000
 NRD5 CR5  CH1    70.000  126.000
 NRD5 CR5  CH2    70.000  126.000
 NRD5 CR5  CH3    70.000  126.000
 NRD5 CR5  CR5    65.000  108.000
 NRD5 CR5  CR15   65.000  108.000
 NRD5 CR5  CR6    70.000  126.000
 NRD5 CR5  CR16   70.000  126.000
 NRD5 CR5  NRD5   70.000  108.000

 O2   CR15 CR5    60.000  108.000
 O2   CR15 CR15   60.000  108.000
 O2   CR5  CR15   60.000  108.000
 O2   CR5  CR6    60.000  126.000
 O2   CR5  CH2    60.000  126.000
 O2   CR5  NR15   60.000  108.000

 CR56 CR56 CR5    70.000  108.000
 CR16 CR56 CR56   70.000  120.000
 CR6  CR56 CR56   70.000  120.000
 CR66 CR56 CR56   70.000  120.000
 NR5  CR56 CR56   65.000  108.000
 NR5  CR56 CR16   65.000  132.000
 NR15 CR56 CR6    65.000  132.000
 NR15 CR56 CR56   65.000  108.000
 NR15 CR56 CR16   65.000  132.000
 NRD5 CR56 CR56   65.000  108.000
 CR5  CR56 NR56   65.000  108.000
 CR15 CR56 NR56   65.000  108.000
 NR5  CR56 NR56   65.000  108.000
 NR15 CR56 NR56   65.000  108.000
 NRD5 CR56 NR56   65.000  108.000
 NRD5 CR56 CR16   65.000  132.000
 NC3  CR56 CR6    65.000  132.000
 NRD5 CR56 CR6    65.000  132.000
 NRD6 CR56 CR56   70.000  120.000
 NR16 CR56 CR56   70.000  120.000
 NR16 CR56 NR56   70.000  120.000
 NR6  CR56 NR56   70.000  120.000
 NR6  CR56 CR56   70.000  120.000
 NR6  CR56 NR5    65.000  132.000
 NRD6 CR56 NR5    65.000  132.000
 NR16 CR56 NR5    65.000  132.000
 NR6  CR56 NR15   65.000  132.000
 NRD6 CR56 NR15   65.000  132.000
 NR16 CR56 NR15   65.000  132.000

 CH1  CR16 CR6    70.000  120.000
 CH1  CR16 CR16   70.000  120.000
 CH1  CR16 NR6    70.000  120.000
 CH1  CR16 NR16   70.000  120.000
 CH1  CR16 NRD6   70.000  120.000
 CH2  CR16 CR6    70.000  120.000
 CH2  CR16 CR16   70.000  120.000
 CH2  CR16 NR6    70.000  120.000
 CH2  CR16 NR16   70.000  120.000
 CH2  CR16 NRD6   70.000  120.000
 CH3  CR16 CR6    70.000  120.000
 CH3  CR16 CR16   70.000  120.000
 CH3  CR16 NR6    70.000  120.000
 CH3  CR16 NR16   70.000  120.000
 CH3  CR16 NRD6   70.000  120.000
 CR16 CR16 CR56   70.000  120.000
 CR16 CR16 CR16   70.000  120.000
 CR6  CR16 CR56   70.000  120.000
 CR6  CR16 CR16   70.000  120.000
 CR6  CR16 CR6    70.000  120.000
 CR66 CR16 CR16   70.000  120.000
 CR66 CR16 CR66   70.000  120.000
 CR66 CR16 CR6    70.000  120.000
 CT   CR16 CR16   70.000  120.000
 CT   CR16 CR6    70.000  120.000
 CT   CR16 NR6    70.000  120.000
 CT   CR16 NR16   70.000  120.000
 CT   CR16 NRD6   70.000  120.000

 N    CR16 CR16   70.000  120.000
 N    CR16 CR6    70.000  120.000
 N    CR16 NR6    70.000  120.000
 N    CR16 NRD6   70.000  120.000
 N    CR16 CR56   70.000  120.000
 N    CR16 CR66   70.000  120.000

 NC2  CR16 CR16   70.000  120.000
 NC2  CR16 CR6    70.000  120.000
 NC2  CR16 NR6    70.000  120.000
 NC2  CR16 NR16   70.000  120.000
 NC2  CR16 NRD6   70.000  120.000
 NC2  CR16 CR56   70.000  120.000
 NC2  CR16 CR66   70.000  120.000

 NH2  CR16 CR16   70.000  120.000
 NH2  CR16 CR6    70.000  120.000
 NH2  CR16 NR6    70.000  120.000
 NH2  CR16 NR16   70.000  120.000
 NH2  CR16 NRD6   70.000  120.000
 NH2  CR16 CR56   70.000  120.000

 NT3  CR16 CR16   70.000  120.000
 NT3  CR16 CR6    70.000  120.000
 NT3  CR16 NR6    70.000  120.000
 NT3  CR16 NR16   70.000  120.000
 NT3  CR16 NRD6   70.000  120.000
 NT3  CR16 CR56   70.000  120.000
 NT3  CR16 CR66   70.000  120.000

 NR56 CR16 O      70.000  120.000
 NR56 CR16 CR56   70.000  120.000

 NR6  CR16 CR16   70.000  120.000
 NR6  CR16 CR6    70.000  120.000
 NR6  CR16 NR6    70.000  120.000
 NR6  CR16 NR16   70.000  120.000
 NR6  CR16 NRD6   70.000  120.000
 NR6  CR16 CR56   70.000  120.000
 NR6  CR16 CR66   70.000  120.000

 NR16 CR16 CR16   70.000  120.000
 NR16 CR16 CR6    70.000  120.000
 NR16 CR16 NR6    70.000  120.000
 NR16 CR16 NR16   70.000  120.000
 NR16 CR16 NRD6   70.000  120.000
 NR16 CR16 CR56   70.000  120.000
 NR16 CR16 CR66   70.000  120.000

 NRD6 CR16 CR16   70.000  120.000
 NRD6 CR16 CR6    70.000  120.000
 NRD6 CR16 NR6    70.000  120.000
 NRD6 CR16 NR16   70.000  120.000
 NRD6 CR16 NRD6   70.000  120.000
 NRD6 CR16 CR56   70.000  120.000
 NRD6 CR16 CR66   70.000  120.000

 HCR6 CR16 CR56   40.000  120.000
 HCR6 CR16 CR16   40.000  120.000
 HCR6 CR16 CR6    40.000  120.000
 HCR6 CR16 CR66   40.000  120.000
 HCR6 CR16 CH1    40.000  120.000
 HCR6 CR16 CH2    40.000  120.000
 HCR6 CR16 CH3    40.000  120.000
 HCR6 CR16 NR6    40.000  120.000
 HCR6 CR16 NR16   40.000  120.000
 HCR6 CR16 NRD6   40.000  120.000
 HCR6 CR16 O2     40.000  120.000
 HCR6 CR16 OH1    40.000  120.000


 OH1  CR16 CR16   65.000  120.000
 OH1  CR16 CR6    65.000  120.000
 OH1  CR16 NR6    65.000  120.000
 OH1  CR16 NR16   65.000  120.000
 OH1  CR16 NRD6   65.000  120.000
 OH1  CR16 NR56   65.000  120.000

 CR16 CR6  C      70.000  120.000
 CR16 CR6  C1     70.000  120.000
 CR16 CR6  CR16   70.000  120.000
 CR16 CR6  CR5    70.000  120.000
 CR6  CR6  CR5    70.000  120.000
 CR16 CR6  NR5    70.000  132.000
 CR6  CR6  NR5    70.000  132.000
 CR16 CR6  NR15   70.000  132.000
 CR6  CR6  NR15   70.000  132.000
 CR16 CR6  NRD5   70.000  132.000
 CR6  CR6  NRD5   70.000  132.000
 CR16 CR6  CR15   70.000  120.000
 CR6  CR6  CR15   70.000  120.000
 CR6  CR6  C      65.000  120.000
 CR6  CR6  C1     70.000  120.000
 CR6  CR6  CR16   70.000  120.000
 CR6  CR6  CR6    70.000  120.000
 CR66 CR6  CR6    70.000  120.000
 CR66 CR6  CR16   70.000  120.000
 CR66 CR6  CR66   70.000  120.000
 CH1  CR6  CR16   70.000  120.000
 CH1  CR6  CR6    70.000  120.000
 CH1  CR6  CR66   70.000  120.000
 CH1  CR6  NR6    70.000  120.000
 CH1  CR6  NR16   70.000  120.000
 CH1  CR6  NRD6   70.000  120.000
 CH2  CR6  CR16   70.000  120.000
 CH2  CR6  CR6    70.000  120.000
 CH2  CR6  CR66   70.000  120.000
 CH2  CR6  NR6    70.000  120.000
 CH2  CR6  NR16   70.000  120.000
 CH2  CR6  NRD6   70.000  120.000
 CH3  CR6  CR16   70.000  120.000
 CH3  CR6  CR6    70.000  120.000
 CH3  CR6  CR66   70.000  120.000
 CH3  CR6  NR6    70.000  120.000
 CH3  CR6  NR16   70.000  120.000
 CH3  CR6  NRD6   70.000  120.000
 CT   CR6  CR16   70.000  120.000
 CT   CR6  CR6    70.000  120.000
 CT   CR6  NR6    70.000  120.000
 CT   CR6  NR16   70.000  120.000
 CT   CR6  NRD6   70.000  120.000

 N    CR6  CR16   70.000  120.000
 N    CR6  CR6    70.000  120.000
 N    CR6  NR6    70.000  120.000
 N    CR6  NR16   70.000  120.000
 N    CR6  NRD6   70.000  120.000
 N    CR6  CR56   70.000  120.000
 N    CR6  CR66   70.000  120.000

 NC2  CR6  CR16   70.000  120.000
 NC2  CR6  CR6    70.000  120.000
 NC2  CR6  NR6    70.000  120.000
 NC2  CR6  NR16   70.000  120.000
 NC2  CR6  NRD6   70.000  120.000
 NC2  CR6  CR56   70.000  120.000
 NC2  CR6  CR66   70.000  120.000

 NH2  CR6  CR16   70.000  120.000
 NH2  CR6  CR6    70.000  120.000
 NH2  CR6  NR6    70.000  120.000
 NH2  CR6  NR16   70.000  120.000
 NH2  CR6  NRD6   70.000  120.000
 NH2  CR6  CR56   70.000  120.000

 NT3  CR6  CR16   70.000  120.000
 NT3  CR6  CR6    70.000  120.000
 NT3  CR6  NR6    70.000  120.000
 NT3  CR6  NR16   70.000  120.000
 NT3  CR6  NRD6   70.000  120.000
 NT3  CR6  CR56   70.000  120.000
 NT3  CR6  CR66   70.000  120.000

 NR56 CR6  O      70.000  120.000
 NR56 CR6  CR56   70.000  120.000

 NR6  CR6  CR16   70.000  120.000
 NR6  CR6  CR6    70.000  120.000
 NR6  CR6  NR6    70.000  120.000
 NR6  CR6  NR16   70.000  120.000
 NR6  CR6  NRD6   70.000  120.000
 NR6  CR6  CR56   70.000  120.000
 NR6  CR6  CR66   70.000  120.000

 NR16 CR6  CR16   70.000  120.000
 NR16 CR6  CR6    70.000  120.000
 NR16 CR6  NR6    70.000  120.000
 NR16 CR6  NR16   70.000  120.000
 NR16 CR6  NRD6   70.000  120.000
 NR16 CR6  CR56   70.000  120.000
 NR16 CR6  CR66   70.000  120.000

 NRD6 CR6  CR16   70.000  120.000
 NRD6 CR6  CR6    70.000  120.000
 NRD6 CR6  NR6    70.000  120.000
 NRD6 CR6  NR16   70.000  120.000
 NRD6 CR6  NRD6   70.000  120.000
 NRD6 CR6  CR56   70.000  120.000
 NRD6 CR6  CR66   70.000  120.000


 O    CR6  CR56   65.000  120.000
 O    CR6  CR16   65.000  120.000
 O    CR6  CR6    65.000  120.000
 O    CR6  CR66   65.000  120.000
 O    CR6  NR6    65.000  120.000
 O    CR6  NR16   65.000  120.000
 O    CR6  NRD6   65.000  120.000
 O2   CR6  CR16   65.000  120.000
 O2   CR66 CR16   65.000  120.000
 O2   CR16 CR16   65.000  120.000
 O2   CR16 CR6    65.000  120.000
 O2   CR16 CR66   65.000  120.000
 O2   CR6  CR6    65.000  120.000
 O2   CR6  CR66   65.000  120.000
 O2   CR66 CR6    65.000  120.000
 O2   CR66 CR66   65.000  120.000
 O2   CR6  CR56   65.000  120.000
 O2   CR6  NR6    65.000  120.000
 O2   CR6  NR16   65.000  120.000
 O2   CR6  NRD6   65.000  120.000
 O2   CR6  NR56   65.000  120.000
 OH1  CR6  NR6    65.000  120.000
 OH1  CR6  NR16   65.000  120.000
 OH1  CR6  NRD6   65.000  120.000
 OH1  CR6  CR16   65.000  120.000
 OH1  CR6  CR66   65.000  120.000
 OH1  CR6  CR56   65.000  120.000
 OH1  CR6  CR6    65.000  120.000

 S1   CR6  CR16   50.000  120.000
 S1   CR6  CR6    50.000  120.000
 S1   NR6  CR16   50.000  120.000
 S1   NR6  CR6    50.000  120.000
 S1   NR6  NR16   50.000  120.000
 S1   NR6  NR6    50.000  120.000
 S1   CR6  NR16   50.000  120.000
 S1   CR6  NR6    50.000  120.000

 S    CR6  CR16   50.000  120.000
 S    CR6  CR6    50.000  120.000
 I    CR6  CR16   50.000  120.000
 I    CR6  CR6    50.000  120.000
 BR   CR6  CR16   50.000  120.000
 BR   CR6  CR6    50.000  120.000

 CR16 CR66 CR16   70.000  120.000
 CR6  CR66 CR16   70.000  120.000
 CH2  CR66 CR16   70.000  120.000
 NH2  CR66 CR16   70.000  120.000

 CR16 CR66 CR6    70.000  120.000
 CR6  CR66 CR6    70.000  120.000
 CH2  CR66 CR6    70.000  120.000
 NH2  CR66 CR6    70.000  120.000

 CR66 CR66 CR66   65.000  120.000
 C    CR66 CR66   65.000  120.000
 CR16 CR66 CR66   70.000  120.000
 CR6  CR66 CR66   70.000  120.000
 NR5  CR66 CR66   70.000  132.000
 NRD5 CR66 CR66   70.000  132.000
 NR6  CR66 CR66   70.000  120.000
 NR16 CR66 CR66   70.000  120.000
 NRD6 CR66 CR66   70.000  120.000

 NR6  CR66 CR16   70.000  120.000
 NR6  CR66 CR6    70.000  120.000
 NR6  CR66 NR6    70.000  120.000
 NR6  CR66 NRD6   70.000  120.000
 NR6  CR66 NR16   70.000  120.000

 NRD6 CR66 CR16   70.000  120.000
 NRD6 CR66 CR6    70.000  120.000
 NRD6 CR66 NR6    70.000  120.000
 NRD6 CR66 NRD6   70.000  120.000
 NRD6 CR66 NR16   70.000  120.000

 NR16 CR66 CR16   70.000  120.000
 NR16 CR66 CR6    70.000  120.000
 NR16 CR66 NR6    70.000  120.000
 NR16 CR66 NRD6   70.000  120.000
 NR16 CR66 NR16   70.000  120.000

 O    CR66 CR16   65.000  120.000
 O    CR66 CR66   65.000  120.000
 OH1  CR66 CR16   65.000  120.000

 CL   CH1  CL     70.000  112.000
 CL   CH1  C      70.000  109.470
 C    CH1  C      70.000  111.000
 CH1  CH1  C      70.000  109.470
 CH1  CH1  C1     70.000  109.470
 CH1  CH1  C2     70.000  109.470
 CH1  CH1  CR5    70.000  109.470
 CH1  CH1  CR6    70.000  109.470
 CH1  CH1  CH1    45.000  111.000
 CH2  CH1  C      70.000  109.470
 CH2  CH1  C1     70.000  109.470
 CH2  CH1  C2     70.000  109.470
 CH2  CH1  CR5    70.000  109.470
 CH2  CH1  CR6    70.000  109.470
 CH2  CH1  CH1    45.000  111.000
 CH2  CH1  CH2    45.000  109.470
 CH3  CH1  C      70.000  109.470
 CH3  CH1  C1     70.000  109.470
 CH3  CH1  C2     70.000  109.470
 CH3  CH1  CR5    70.000  109.470
 CH3  CH1  CR6    70.000  109.470
 CH3  CH1  CH1    45.000  111.000
 CH3  CH1  CH2    45.000  111.000
 CH3  CH1  CH3    45.000  111.000
 CT   CH1  C      70.000  109.470
 C1   CH1  C      70.000  109.470
 CT   CH1  C1     70.000  109.470
 CT   CH1  C2     70.000  109.470
 CT   CH1  CR5    70.000  109.470
 CT   CH1  CR6    70.000  109.470
 CT   CH1  CH1    45.000  111.000
 CT   CH1  CH2    45.000  111.000
 CT   CH1  CH3    45.000  111.000
 N    CH1  C      70.000  111.600
 N    CH1  C1     70.000  111.600
 N    CH1  C2     70.000  111.600
 N    CH1  CH1    65.000  105.000
 N    CH1  CH2    65.000  105.000
 NH1  CH1  C      70.000  111.600
 NC3  CH1  C      70.000  111.600
 NH1  CH1  C1     70.000  111.600
 NH1  CH1  C2     70.000  111.600
 NH1  CH1  CR6    65.000  109.470
 NH1  CH1  CR5    65.000  109.470
 NH1  CH1  CH1    65.000  110.000
 NH1  CH1  CH2    65.000  110.000
 NH1  CH1  CH3    65.000  110.000
 NC3  CH1  CH1    65.000  110.000
 NC3  CH1  CH2    65.000  110.000
 NC3  CH1  CH3    65.000  110.000
 NH1  CH1  CT     65.000  110.000
 NH1  CH1  NH1    65.000  109.470
 NH2  CH1  CR6    65.000  109.470
 NH2  CH1  CR5    65.000  109.470
 NH2  CH1  C      65.000  109.470
 NH2  CH1  C1     65.000  109.470
 NH2  CH1  C2     65.000  109.470
 NH2  CH1  CH1    65.000  109.470
 NH2  CH1  CH2    65.000  109.470
 NH2  CH1  CH3    65.000  109.470
 NH2  CH1  NH2    65.000  109.470
 NT3  CH1  C      70.000  111.600
 NT3  CH1  C1     70.000  111.600
 NT3  CH1  C2     70.000  111.600
 NT3  CH1  CH1    65.000  110.000
 NT3  CH1  CH2    65.000  110.000
 NT3  CH1  CH3    65.000  110.000
 NT3  CH1  CT     65.000  110.000
 NPA  CH1  CH1    65.000  108.000
 NPA  CH1  CH3    65.000  108.000
 NPA  CH1  CT     65.000  108.000
 NPB  CH1  CH1    65.000  108.000
 NPB  CH1  CH3    65.000  108.000
 NPB  CH1  CT     65.000  108.000
 NR5  CH1  CH1    65.000  109.470
 NR5  CH1  CH2    65.000  109.470
 NR6  CH1  CH1    65.000  109.470
 NR6  CH1  CH2    65.000  109.470
 O    CH1  CH1    65.000  109.470
 O    CH1  CH2    65.000  109.470
 O    CH1  CH3    50.000  109.470
 O2   CH1  CH1    50.000  109.470
 O2   CH1  CH2    50.000  109.470
 O2   CH1  CH3    65.000  109.470
 O2   CH1  CT     65.000  109.470
 O2   CH1  CR6    65.000  109.470
 O2   CH1  NR5    65.000  109.470
 O2   CH1  NR6    65.000  109.470
 O    CH1  NR5    65.000  109.470
 O    CH1  NR6    65.000  109.470
 OH1  CH1  C      50.000  109.470
 OH1  CH1  C1     50.000  109.470
 OH1  CH1  C2     50.000  109.470
 OH1  CH1  CR6    50.000  109.470
 OH1  CH1  CH1    50.000  109.470
 OH1  CH1  CH2    50.000  109.470
 OH1  CH1  CH3    50.000  109.470
 OH1  CH1  CT     50.000  109.470
 OH1  CH1  NH1    50.000  109.470
 OH1  CH1  NT3    50.000  109.470
 OH1  CH1  O      50.000  109.470
 OH1  CH1  O2     50.000  109.470
 OC2  CH1  CH1    50.000  109.470
 OC2  CH1  CH2    50.000  109.470
 OC2  CH1  CH3    50.000  109.470
 OC2  CH1  O2     50.000  109.470
 O2   CH1  O2     50.000  109.470
 O2   CH1  C      50.000  109.470
 OC   CH1  CH1    50.000  109.470
 OC   CH1  OC     50.000  109.470
 OP   CH1  CH2    50.000  109.470
 OP   CH1  CH3    50.000  109.470
 HCH1 CH1  C      70.000  108.810
 HCH1 CH1  C1     70.000  108.810
 HCH1 CH1  C2     70.000  108.810
 HCH1 CH1  CL     70.000  109.470
 HCH1 CH1  CR5    70.000  109.470
 HCH1 CH1  CH1    40.000  108.340
 HCH1 CH1  CH2    40.000  108.340
 HCH1 CH1  CH3    40.000  108.340
 HCH1 CH1  CT     40.000  108.340
 HCH1 CH1  N      50.000  109.470
 HCH1 CH1  NH1    50.000  108.550
 HCH1 CH1  NH2    50.000  109.470
 HCH1 CH1  NT3    50.000  108.550
 HCH1 CH1  NPA    65.000  108.000
 HCH1 CH1  NPB    65.000  108.000
 HCH1 CH1  NR5    50.000  109.470
 HCH1 CH1  NR6    50.000  109.470
 HCH1 CH1  CR6    50.000  109.470
 HCH1 CH1  O      50.000  109.470
 HCH1 CH1  O2     50.000  109.470
 HCH1 CH1  OH1    50.000  109.470
 HCH1 CH1  OC2    50.000  109.470
 HCH1 CH1  OC     50.000  109.470
 B    CH1  CH2    50.000  109.470
 B    CH1  HCH1   50.000  109.470

 CH1  CH2  C      70.000  109.470
 CH1  CH2  C1     70.000  109.470
 CH1  CH2  C2     70.000  109.470
 CH1  CH2  CR5    70.000  109.470
 CH1  CH2  CR16   70.000  109.470
 CH1  CH2  CR6    70.000  109.470
 CH1  CH2  CR66   70.000  109.470
 CH1  CH2  CH1    45.000  111.000
 CH2  CH2  C      70.000  109.470
 CH2  CH2  C1     70.000  109.470
 CH2  CH2  C2     70.000  109.470
 CH2  CH2  CR5    70.000  109.470
 CH2  CH2  CR6    70.000  109.470
 CR6  CH2  CR6    70.000  109.470
 CH2  CH2  CH1    45.000  111.000
 CH2  CH2  CH2    45.000  111.000
 CH3  CH2  CR5    70.000  109.470
 CH3  CH2  CH1    45.000  111.000
 CH3  CH2  CH2    45.000  111.000
 C1   CH2  CR6    70.000  109.470
 C2   CH2  CR6    70.000  109.470
 C    CH2  CR6    70.000  109.470
 C    CH2  C      70.000  109.470
 C1   CH2  C      70.000  109.470
 C1   CH2  C1     70.000  109.470
 C2   CH2  C      70.000  109.470
 C2   CH2  C1     70.000  109.470
 C2   CH2  C2     70.000  109.470
 CT   CH2  C      70.000  109.470
 CT   CH2  C1     70.000  109.470
 CT   CH2  C2     70.000  109.470
 CT   CH2  CR5    70.000  109.470
 CT   CH2  CR5    70.000  109.470
 CT   CH2  CR6    70.000  109.470
 CT   CH2  CH1    45.000  111.000
 CT   CH2  CH1    45.000  111.000
 CT   CH2  CH2    45.000  111.000
 CT   CH2  CH3    45.000  111.000
 N    CH2  CH2    65.000  105.000
 N    CH2  CH1    65.000  105.000
 NC1  CH2  CH2    65.000  110.000
 NH1  CH2  C      70.000  111.600
 NC3  CH2  C      70.000  111.600
 NH1  CH2  C1     70.000  111.600
 NH1  CH2  C2     70.000  111.600
 NH1  CH2  CH1    65.000  110.000
 NH1  CH2  CH2    65.000  112.000
 NH1  CH2  CH3    65.000  112.000
 NC3  CH2  CH1    65.000  110.000
 NC3  CH2  CH2    65.000  112.000
 NC3  CH2  CH3    65.000  112.000
 NH1  CH2  NH1    65.000  109.470
 NC2  CH2  CH2    65.000  109.470
 NH2  CH2  C      70.000  111.600
 NH2  CH2  C1     70.000  111.600
 NH2  CH2  C2     70.000  111.600
 NH2  CH2  CH2    65.000  109.470
 NH2  CH2  CH1    65.000  109.470
 NH2  CH2  NH1    65.000  109.470
 NT3  CH2  C      70.000  111.600
 NT3  CH2  C1     70.000  111.600
 NT3  CH2  C2     70.000  111.600
 NT3  CH2  CH1    65.000  109.470
 NT3  CH2  CH2    65.000  110.000
 NT   CH2  CH2    65.000  109.470
 N    CH2  CR6    65.000  109.470
 NR6  CH2  CH1    65.000  109.470
 NR6  CH2  CH2    65.000  109.470
 NR6  CH2  CH3    65.000  109.470
 O    CH2  CH1    50.000  109.470
 O    CH2  CH2    50.000  109.470
 O    CH2  CH3    50.000  109.470
 O2   CH2  CR6    50.000  109.470
 OC2  CH2  CR6    50.000  109.470
 O2   CH2  CH1    50.000  109.470
 O2   CH2  C      50.000  109.470
 O2   CH2  CH2    50.000  109.470
 O2   CH2  CH3    50.000  109.470
 OH1  CH2  CH1    50.000  109.470
 OH1  CH2  CH2    50.000  109.470
 OH1  CH2  CH3    50.000  109.470
 OH1  CH2  CT     50.000  109.470
 OH1  CH2  O      50.000  109.470
 OC2  CH2  CR15   50.000  109.470
 OC2  CH2  CH1    50.000  109.470
 OC2  CH2  CT     50.000  109.470
 OC2  CH2  CH2    50.000  109.470
 SH1  CH2  CH2    50.000  109.470
 S    CH2  CR6    50.000  109.470
 HCH2 CH2  C      40.000  109.470
 HCH2 CH2  C1     40.000  109.470
 HCH2 CH2  C2     40.000  109.470
 HCH2 CH2  CR15   40.000  109.470
 HCH2 CH2  CR5    40.000  109.470
 HCH2 CH2  CR16   40.000  109.470
 HCH2 CH2  CR6    40.000  109.470
 HCH2 CH2  CR66   40.000  109.470
 HCH2 CH2  CH1    40.000  109.470
 HCH2 CH2  CH1    40.000  109.470
 HCH2 CH2  CH2    40.000  109.470
 HCH2 CH2  CH3    40.000  109.470
 HCH2 CH2  CT     40.000  109.470
 HCH2 CH2  N      50.000  109.470
 HCH2 CH2  NC1    50.000  109.470
 HCH2 CH2  NH1    50.000  109.470
 HCH2 CH2  NC2    40.000  109.470
 HCH2 CH2  NH2    40.000  109.470
 HCH2 CH2  NT3    50.000  109.470
 HCH2 CH2  NT     40.000  109.470
 HCH2 CH2  NR6    40.000  109.470
 HCH2 CH2  O      40.000  109.470
 HCH2 CH2  O2     40.000  109.470
 HCH2 CH2  OH1    50.000  109.470
 HCH2 CH2  OC2    50.000  109.470
 HCH2 CH2  HCH2   40.000  107.900
 S    CH2  CH1    50.000  112.500
 S    CH2  CH2    50.000  112.500
 S    CH2  CT     50.000  112.500
 S    CH2  HCH2   40.000  109.470
 SH1  CH2  CH1    50.000  112.500
 SH1  CH2  CT     50.000  112.500
 SH1  CH2  HCH2   40.000  109.470

 HCH3 CH3  CSP    70.000  109.470
 HCH3 CH3  C      70.000  109.470
 HCH3 CH3  C1     70.000  109.470
 HCH3 CH3  C2     70.000  109.470
 HCH3 CH3  CR1    70.000  109.470
 HCH3 CH3  CR5    70.000  109.470
 HCH3 CH3  CR6    70.000  109.470
 HCH3 CH3  CR16   70.000  109.470
 HCH3 CH3  CH1    40.000  109.470
 HCH3 CH3  CH2    40.000  109.470
 HCH3 CH3  CT     40.000  109.470
 HCH3 CH3  N      50.000  109.470
 HCH3 CH3  NH1    50.000  109.470
 HCH3 CH3  NT3    50.000  109.470
 HCH3 CH3  NT     50.000  109.470
 HCH3 CH3  NR5    50.000  109.470
 HCH3 CH3  NR6    50.000  109.470
 HCH3 CH3  O      65.000  109.470
 HCH3 CH3  O2     65.000  109.470
 HCH3 CH3  OH1    65.000  109.470
 CH3  CH3  CH3    40.000  109.470
 CH3  CH3  NH1    40.000  109.470
 HCH3 CH3  HCH3   40.000  109.470
 HCH3 CH3  CH3    40.000  109.470
 S    CH3  HCH3   40.000  109.470
 CO   CH3  HCH3   70.000  109.470
 CH1  CT   C      70.000  109.470
 CH1  CT   C1     70.000  109.470
 CH1  CT   C2     70.000  109.470
 CH1  CT   CR5    70.000  109.470
 CH1  CT   CH1    45.000  111.000
 CH2  CT   C      70.000  109.470
 CH2  CT   C1     70.000  109.470
 CH2  CT   C2     70.000  109.470
 CH2  CT   CR5    70.000  109.470
 CH2  CT   CH1    45.000  111.000
 CH2  CT   CH2    45.000  111.000
 CH3  CT   C      70.000  109.470
 CH3  CT   C1     70.000  109.470
 CH3  CT   C2     70.000  109.470
 CH3  CT   CR5    70.000  109.470
 CH3  CT   CH1    45.000  111.000
 CH3  CT   CH2    45.000  111.000
 CH3  CT   CH3    45.000  111.000
 CT   CT   CR5    70.000  109.470
 CT   CT   C      45.000  111.000
 CT   CT   C1     45.000  111.000
 CT   CT   C2     45.000  111.000
 CT   CT   CH1    45.000  111.000
 CT   CT   CH2    45.000  111.000
 CT   CT   CH3    45.000  111.000
 CT   CT   CT     45.000  111.000
 N    CT   C      70.000  111.600
 N    CT   C1     70.000  111.600
 N    CT   C2     70.000  111.600
 N    CT   CH1    70.000  111.600
 N    CT   CH2    70.000  111.600
 N    CT   CH3    70.000  111.600
 N    CT   CT     70.000  111.600
 NH1  CT   C      70.000  111.600
 NH1  CT   C1     70.000  111.600
 NH1  CT   C2     70.000  111.600
 NH1  CT   CH1    65.000  110.000
 NH1  CT   CH2    65.000  110.000
 NH1  CT   CH3    65.000  110.000
 NH1  CT   CT     65.000  110.000
 NT3  CT   C      70.000  111.600
 NT3  CT   C1     70.000  111.600
 NT3  CT   C2     70.000  111.600
 NT3  CT   CH1    65.000  110.000
 NT3  CT   CH2    65.000  110.000
 NT3  CT   CH3    65.000  110.000
 NT3  CT   CT     65.000  110.000
 NPA  CT   CH1    65.000  108.000
 NPA  CT   CH1    65.000  108.000
 NPA  CT   CH2    65.000  108.000
 NPA  CT   CH3    65.000  108.000
 NPA  CT   CT     65.000  108.000
 NPB  CT   CH1    65.000  108.000
 NPB  CT   CH2    65.000  108.000
 NPB  CT   CH3    65.000  108.000
 NPB  CT   CT     65.000  108.000
 O2   CT   C      65.000  109.470
 O2   CT   C1     65.000  109.470
 O2   CT   C2     65.000  109.470
 O2   CT   CH1    65.000  109.470
 O2   CT   CH2    65.000  109.470
 O2   CT   CH3    65.000  109.470
 O2   CT   CT     65.000  109.470
 O2   CT   NR5    65.000  109.470
 O2   CT   NR6    65.000  109.470
 OH1  CT   C      65.000  109.470
 OH1  CT   C1     65.000  109.470
 OH1  CT   C2     65.000  109.470
 OH1  CT   CT     65.000  109.470
 OH1  CT   CH1    50.000  109.470
 OH1  CT   CH2    65.000  109.470
 OH1  CT   CH3    65.000  109.470
 OH1  CT   OH1    50.000  109.470
 OH1  CT   O2     50.000  109.470
 F    CT   CT     50.000  109.470
 F    CT   C      50.000  109.470
 F    CT   C1     50.000  109.470
 F    CT   C2     50.000  109.470
 F    CT   CH1    50.000  109.470
 F    CT   CH2    50.000  109.470
 F    CT   CH3    50.000  109.470
 F    CT   CR6    50.000  109.470
 F    CT   F      50.000  109.470
 F    CT   F      50.000  109.470
 NS   NS   NS     60.     180.000
 CH1  N    C      80.000  121.000
 CH2  N    C      80.000  127.000
 CH3  N    C      80.000  127.000
 CH1  N    C1     80.000  120.000
 CH2  N    C1     80.000  120.000
 CH3  N    C1     80.000  120.000
 CH1  N    C2     80.000  120.000
 CH2  N    C2     80.000  120.000
 CH3  N    C2     80.000  120.000
 CH1  N    CT     80.000  120.000
 CH2  N    CT     80.000  120.000
 CH3  N    CT     80.000  120.000
 CH1  N    CR6    80.000  120.000
 CH2  N    CR6    80.000  120.000
 CH3  N    CR6    80.000  120.000
 CH2  N    CH1    60.000  112.000
 CH2  N    CH2    60.000  120.000
 CH3  N    CH2    60.000  120.000
 CH3  N    CH3    60.000  120.000
 CT   N    C      80.000  121.000
 CT   N    C1     80.000  121.000
 CT   N    C2     80.000  121.000
 OC   N    CR6    60.000  118.500
 OC   N    OC     60.000  123.000
 O    N    CR6    60.000  120.000
 O    N    O      60.000  120.000
 OH1  N    CH3    60.000  120.000
 CH2  NC1  C      80.000  120.000
 HNC1 NC1  C      30.000  120.000
 HNC1 NC1  CH2    35.000  120.000
 CR5  NH1  C      80.000  120.000
 CH1  NH1  C      80.000  121.500
 CH1  NH1  CH1    80.000  120.000
 CH2  NH1  C      80.000  121.500
 CH2  NH1  CH1    80.000  120.000
 CH2  NH1  CH2    80.000  120.000
 CH3  NH1  C      80.000  121.500
 CT   NH1  C      80.000  121.500
 OH1  NH1  C      60.000  120.000
 HNH1 NH1  C      30.000  120.000
 HNH1 NH1  CR5    30.000  120.000
 HNH1 NH1  CH1    35.000  118.500
 HNH1 NH1  CH2    35.000  118.500
 HNH1 NH1  CH3    35.000  118.500
 HNH1 NH1  CT     35.000  118.500
 HNH1 NH1  OH1    30.000  120.200
 CH2  NC2  CR6    60.000  120.000
 CH2  NC2  CH2    60.000  112.000
 HNC1 NC2  CH2    35.000  120.000
 HNC2 NC2  C      35.000  120.000
 HNC2 NC2  CR6    40.000  120.000
 HNC2 NC2  CH2    40.000  120.000
 HNC2 NC2  HNC2   40.000  120.000
 CH2  NH2  CH1    80.000  120.000
 CR6  NH2  C      80.000  126.000
 HNH2 NH2  C      30.000  120.000
 HNH2 NH2  CR6    30.000  120.000
 HNH2 NH2  CR66   30.000  120.000
 HNH2 NH2  CH1    30.000  120.000
 HNH2 NH2  CH2    30.000  120.000
 HNH2 NH2  HNH2   40.000  120.000
 HNH3 NH3  HNH3   40.000  109.470
 CH2  NT3  CR6    40.000  109.470
 CH3  NT3  CH2    40.000  109.470
 CH3  NT3  CH3    40.000  109.470
 OH1  NT3  CH3    40.000  109.470
 HNT3 NT3  CH1    35.000  109.470
 HNT3 NT3  CH2    35.000  109.470
 HNT3 NT3  CT     35.000  109.470
 HNT3 NT3  C      35.000  109.470
 HNT3 NT3  HNT3   40.000  109.470
 CH2  NT   CH1    40.000  109.470
 CH2  NT   CH2    40.000  109.470
 CH3  NT   CH1    70.000  109.470
 CH3  NT   CH2    40.000  109.470
 CH3  NT   CH3    70.000  109.470
 C    NT   C      70.000  109.470
 C    NT   C1     70.000  109.470
 C    NT   CH1    70.000  109.470
 C    NT   CH2    40.000  109.470
 C    NT   CH3    70.000  109.470
 C1   NT   C      70.000  109.470
 C1   NT   C1     70.000  109.470
 C1   NT   CH1    70.000  109.470
 C1   NT   CH2    40.000  109.470
 C1   NT   CH3    70.000  109.470
 OH1  NT   CH3    70.000  109.470
 CR5  NPA  CR5    70.000  108.000
 CH1  NPA  CR5    70.000  108.000
 CT   NPA  CR5    70.000  108.000
 FE   NPA  CR5    50.000  126.000
 MG   NPA  CR5    50.000  126.000
 CO   NPA  CR5    50.000  126.000
 CO   NPA  CH1    50.000  126.000
 CO   NPA  CT     50.000  126.000
 CR5  NPB  CR5    70.000  108.000
 CH1  NPB  CR5    70.000  108.000
 CT   NPB  CR5    70.000  108.000
 FE   NPB  CR5    50.000  126.000
 MG   NPB  CR5    50.000  126.000
 CO   NPB  CR5    50.000  126.000
 CO   NPB  CH1    50.000  126.000
 CO   NPB  CT     50.000  126.000

 CR15 NR5  CR15   70.000  108.000
 CR5  NR5  CR15   70.000  108.000
 CR56 NR5  CR15   70.000  108.000
 CR56 NR5  CR5    70.000  108.000
 CR6  NR5  CR15   70.000  108.000
 CR6  NR5  CR6    70.000  120.000

 CH1  NR5  CR5    70.000  126.000
 CH1  NR5  CR15   70.000  126.000
 CH1  NR5  CRD5   70.000  126.000
 CH1  NR5  CR56   70.000  126.000
 CH2  NR5  CR5    70.000  126.000
 CH2  NR5  CR15   70.000  126.000
 CH2  NR5  CRD5   70.000  126.000
 CH2  NR5  CR56   70.000  126.000
 CH3  NR5  CR5    70.000  126.000
 CH3  NR5  CR15   70.000  126.000
 CH3  NR5  CRD5   70.000  126.000
 CH3  NR5  CR56   70.000  126.000

 CR15 NR15 CR15   60.000  108.000
 CR5  NR15 CR15   60.000  108.000
 CR5  NR15 CR5    60.000  108.000
 CR56 NR15 CR15   60.000  108.000
 CR56 NR15 CR5    60.000  108.000
 O2   NR15 CR5    60.000  108.000
 HNR5 NR15 CR15   30.000  126.000
 HNR5 NR15 CR5    30.000  126.000
 HNR5 NR15 CR56   30.000  126.000

 CR15 NRD5 CR15   70.000  108.000
 CR5  NRD5 CR15   70.000  108.000
 HNR5 NRD5 CR15   30.000  126.000
 CR56 NRD5 CR15   70.000  108.000
 CR56 NRD5 CR5    70.000  108.000
 CR16 NRD5 CR56   70.000  108.000
 FE   NRD5 CR15   30.000  126.000
 ZN   NRD5 CR15   65.000  126.000
 CO   NRD5 CR15   30.000  126.000
 CO   NRD5 CR56   30.000  126.000

 CR56 NR56  CR6   70.000  120.000
 CR56 NR56  CR16  70.000  120.000
 CR56 NR56  CR5   70.000  108.000
 CR56 NR56  CR15  70.000  108.000
 CR6  NR56  CR5   70.000  132.000
 CR16 NR56  CR5   70.000  132.000
 CR6  NR56  CR15  70.000  132.000
 CR16 NR56  CR15  70.000  132.000

 CR6  NR6  CR6    70.000  120.000
 CR6  NR6  CR16   70.000  120.000
 CR6  NR6  CR66   70.000  120.000
 CR6  NR6  CR56   70.000  120.000
 CR16 NR6  CR16   70.000  120.000
 CR16 NR6  CR66   70.000  120.000
 CR16 NR6  CR56   70.000  120.000
 CR66 NR6  CR66   70.000  120.000
 CR66 NR6  CR56   70.000  120.000
 CR56 NR6  CR56   70.000  120.000

 CH1  NR6  CR6    70.000  120.000
 CH1  NR6  CR16   70.000  120.000
 CH1  NR6  CR56   70.000  120.000
 CH1  NR6  CR66   70.000  120.000

 CH2  NR6  CR6    70.000  120.000
 CH2  NR6  CR16   70.000  120.000
 CH2  NR6  CR66   70.000  120.000
 CH2  NR6  CR56   70.000  120.000

 CH3  NR6  CR6    70.000  120.000
 CH3  NR6  CR16   70.000  120.000
 CH3  NR6  CR66   70.000  120.000
 CH3  NR6  CR56   70.000  120.000

 CR6  NR16 CR6    70.000  120.000
 CR16 NR16 CR6    70.000  120.000
 CR66 NR16 CR6    70.000  120.000
 CR56 NR16 CR6    70.000  120.000
 CR16 NR16 CR16   70.000  120.000
 CR66 NR16 CR16   70.000  120.000
 CR56 NR16 CR16   70.000  120.000
 HNR6 NR16 CR56   30.000  120.000
 HNR6 NR16 CR16   30.000  120.000
 HNR6 NR16 CR6    30.000  120.000
 HNR6 NR16 CR66   30.000  120.000

 CR16 NRD6 CR56   70.000  120.000
 CR6  NRD6 CR56   70.000  120.000
 CR6  NRD6 CR16   70.000  120.000
 CR6  NRD6 CR6    70.000  120.000
 CR16 NRD6 CR16   70.000  120.000
 CR66 NRD6 CR6    70.000  120.000
 CR66 NRD6 CR16   70.000  120.000
 CR66 NRD6 CR66   70.000  120.000

 CR15 O    CR15  100.000  108.000
 CH1  O    CH1   100.000  120.000
 CH2  O    C     100.000  111.800
 CH2  O    CH1   100.000  120.000
 CH3  O    C     100.000  111.800
 FE   O    FE    100.000  120.000

 CR5  O2   CR15  100.000  108.000
 CR15 O2   CR15  100.000  108.000
 CR5  O2   CR55  100.000  108.000
 CR55 O2   CR15  100.000  108.000
 CR5  O2   CR5   100.000  108.000
 CH1  O2   CH1   100.000  111.800
 CH2  O2   CH2   100.000  111.800
 CH1  O2   CH2   100.000  111.800
 CH3  O2   CH2   100.000  111.800
 CH3  O2   CH1   100.000  111.800
 CT   O2   CH2   100.000  111.800
 CT   O2   CH1   100.000  111.800
 C    O2   C     100.000  111.800
 C1   O2   C     100.000  111.800
 CH1  O2   C     100.000  111.800
 CH3  O2   C     100.000  120.000
 CH2  O2   CR6   100.000  120.000
 CH3  O2   CR6   100.000  120.000
 CR6  O2   CR6   100.000  120.000
 CR6  O2   CR16  100.000  120.000
 CR16 O2   CR16  100.000  120.000
 CR66 O2   CR66  100.000  120.000
 CR6  O2   CR66  100.000  120.000
 CR16 O2   CR66  100.000  120.000
 NR15 O2   CR5   100.000  108.000
 NR15 O2   CR15  100.000  108.000
 OH1  O2   CH1   100.000  111.800

 HOH1 OH1  C      50.000  109.470
 HOH1 OH1  CR15   50.000  120.000
 HOH1 OH1  CR6    50.000  109.470
 HOH1 OH1  CR66   50.000  109.470
 HOH1 OH1  CH1    35.000  109.470
 HOH1 OH1  CH2    35.000  109.470
 HOH1 OH1  CH3    35.000  109.470
 HOH1 OH1  CT     35.000  109.470
 HOH1 OH1  NH1    35.000  120.000
 HOH1 OH1  NT3    35.000  109.470
 HOH1 OH1  NT     35.000  109.470
 HOH1 OH1  N      35.000  109.470
 HOH2 OH2  HOH2   55.000  104.500
 HOHA OHA  HOHA   55.000  104.500
 HOHB OHB  HOHB   55.000  104.500
 HOHC OHC  HOHC   55.000  104.500
 P    OC2  CR15  100.000  120.500
 P    OC2  CH1   100.000  120.500
 P    OC2  CH2   100.000  120.500
 P    OC2  P     100.000  120.500
 P    O2   CR15  100.000  120.500
 P    O2   CH1   100.000  120.500
 P    O2   CH2   100.000  120.500
 P    O2   P     100.000  120.500
 P    OP   CH1   100.000  120.500
 O2   P    O2     45.000  102.600
 OP   P    O2    100.000  108.200
 OC2  P    OC2    45.000  102.600
 OP   P    OC2   100.000  108.200
 OP   P    OP    140.000  119.900
 CR6  S    CR6    50.000  120.000
 CH3  S    CH2    50.000   99.500
 CH3  S    CH3    50.000  120.000
 OS   S    CR6   100.000  120.000
 OS   S    OS    140.000  109.470
 OS   S    CH2   140.000  109.470
 O    S    CH3   100.000  120.000
 S    S    CH2    50.000  104.200
 HSH1 SH1  CH2    35.000   96.000
 HSH1 SH1  CSP    35.000   96.000
 NPA  FE   NPA    50.000  180.000
 NPB  FE   NPA    50.000   90.000
 NPB  FE   NPB    50.000  180.000
 NRD5 FE   NPA    50.000  115.000
 NRD5 FE   NPB    50.000  115.000
 NPA  MG   NPA    50.000  180.000
 NPB  MG   NPA    50.000   90.000
 NPB  MG   NPB    50.000  180.000
 OB   B    CH1    50.     120.000
 OB   B    OB     50.     120.000
 NPA  CO   C      50.000   90.000
 NPB  CO   C      50.000   90.000
 NPA  CO   CH3    50.000   90.000
 NPA  CO   NPA    50.000  180.000
 NPB  CO   CH3    50.000   90.000
 NPB  CO   NPA    50.000   90.000
 NPB  CO   NPB    50.000  180.000
 NRD5 CO   NPA    50.000   90.000
 NRD5 CO   NPB    50.000   90.000
 NRD5 ZN   NRD5   50.000  109.470
 OHA  MG   OHA    50.     180.000
 OHB  MG   OHB    50.     180.000
 OHC  MG   OHC    50.     180.000
 OHA  MG   OHB    50.      90.000
 OHA  MG   OHC    50.      90.000
 OHB  MG   OHA    50.      90.000
 OHB  MG   OHC    50.      90.000
 OHC  MG   OHA    50.      90.000
 OHC  MG   OHB    50.      90.000
 MG   OHA  HOHA   50.     109.470
 MG   OHB  HOHB   50.     109.470
 MG   OHC  HOHC   50.     109.470
#
 .     B          .       .   120.0
 .     F          .       .      .
 .     NA         .       .    90.0
 .     MG         .       .    90.0
 .     CL         .       .   120.0
 .     CA         .       .    90.0
 .     V          .       .      .
 .     MN         .       .    90.0
 .     FE         .       .    90.0
 .     CO         .       .    90.0
 .     CU         .       .    90.0
 .     ZN         .       .   109.5
 .     BR         .       .      .
 .     CD         .       .      .
 .     I          .       .      .
 .     PB         .       .      .
 .     HG         .       .      .
 .     U          .       .      .
 .     W          .       .      .
 .     Y          .       .      .
 .     K          .       .    90.0
 .     SI         .       .   109.5
 .     SI1        .       .   109.5
 .     GE         .       .   109.5
 .     GE1        .       .   109.5
 .     AL         .       .      .
 .     GD         .       .      .
 .     NI         .       .    90.0
 .     SR         .       .      .
 .     IN         .       .      .
 .     HO         .       .      .
 .     YB         .       .    90.0
 .     TE         .       .    90.0
 .     LI         .       .    90.0
 .     RB         .       .    90.0
 .     BA         .       .      .
 .     CS         .       .      .
 .     SM         .       .      .
 .     TL         .       .      .
 .     PT         .       .    90.0
 .     BE         .       .   120.0
 .     SE         .       .    98.0
#
 .     CSP      .       .    180.0
 .     C        .       .    120.0
 .     C1       .       .    120.0
 .     C2       .       .    120.0
 .     CR1      .       .    120.0
 .     CR2      .       .    120.0
 .     CR1H     .       .    120.0
 .     CR15     .       .    108.0
 .     CR5      .       .    108.0
 .     CR56     .       .    120.0
 .     CR55     .       .    108.0
 .     CR16     .       .    120.0
 .     CR6      .       .    120.0
 .     CR66     .       .    120.0  
 .     CH1      .       .    109.5
 .     CH2      .       .    109.5 
 .     CH3      .       .    109.5
 .     CT       .       .    109.5
#
 .     NS        .       .    180.0
 .     N         .       .    120.0
 .     NC1       .       .    120.0
 .     NH1       .       .    120.0
 .     NC2       .       .    120.0
 .     NH2       .       .    120.0
 .     NC3       .       .    120.0
 .     NT        .       .    109.5
 .     NT1       .       .    109.5
 .     NT2       .       .    109.5
 .     NT3       .       .    109.5
 .     NPA       .       .    120.0
 .     NPB       .       .    120.0
 .     NR5       .       .    108.0
 .     NR15      .       .    108.0
 .     NRD5      .       .    108.0
 .     NR56      .       .    120.0
 .     NR55      .       .    108.0
 .     NR6       .       .    120.0
 .     NR66      .       .    120.0
 .     NR16      .       .    120.0
 .     NRD6      .       .    120.0
#
 .     OS        .       .    120.0
 .     O         .       .    120.0
 .     O2        .       .    120.0
 .     OH1       .       .    120.0
 .     OH2       .       .    120.0
 .     OHA       .       .    120.0
 .     OHB       .       .    120.0
 .     OHC       .       .    120.0
 .     OC2       .       .    120.0
 .     OC        .       .    120.0
 .     OP        .       .    120.0
 .     OB        .       .    120.0
#
 .     P         .       .    109.5
 .     PS        .       .    109.5
 .     P1        .       .    120.0 # or what
 .     AS        .       .    109.47
 .     AS1       .       .    120.0 # or what?
 .     S         .       .     90.0
 .     SH1       .       .    109.5
 .     ST        .       .    109.5
 .     MO        .       .     90.0
#
 .     H         .       .    109.5
#
# ---  TORSIONS ---
#
loop_
_lib_tors.atom_type_1
_lib_tors.atom_type_2
_lib_tors.atom_type_3
_lib_tors.atom_type_4
_lib_tors.label
_lib_tors.const
_lib_tors.angle
_lib_tors.period
#
# _atom_type atomic chemical type
# _const     Constant KPHI
# _period    NPH number of minima in the function
# _angle     angle DELTA
#            PHI - actual angle 
#
#          ENERGY = KPHI * ( 1 + COS( NPH * PHI -   DELTA) )
#
 .    CH1  NH1  .    .           0.000    0.000     3       # AMBER
 .    C    CH1  .    .           0.000  180.000     3       # AMBER
 .    CH2  NH1  .    .           0.000    0.000     3       # AMBER
 .    C    CH2  .    .           0.000  180.000     3       # AMBER
 .    CH1  N    .    .           0.000    0.000     3       # AMBER
 .    C    NH1  .    .          10.000  180.000     2       # AMBER
 .    C    N    .    .          10.000  180.000     2       # AMBER

 .    CH1  CH1  .    .           2.000  180.000     3       # AMBER
 .    CH1  CH2  .    .           2.000  180.000     3       # AMBER
 .    CH1  CH3  .    .           2.0    180.000     3
 .    CH2  CH1  .    .           2.000  180.000     3       # AMBER
 .    CH2  CH2  .    .           2.000  180.000     3       # AMBER
 .    CH2  CH3  .    .           2.0    180.000     3
 .    CH3  CH1  .    .           2.0    180.000     3
 .    CH3  CH2  .    .           2.0    180.000     3
 .    CH3  CH3  .    .           2.0    180.000     3
 .    CH2  NC1  .    .           0.000    0.000     4       # AMBER
 .    C    NC1  .    .           6.800  180.000     2       # AMBER

 .    C    NH2  .    .          10.000  180.000     2       # AMBER

 .    CH2  CR5  .    .           0.000    0.000     2       # AMBER
 .    CH2  CR6  .    .           0.000    0.000     2       # AMBER

 .    CR16 CR6  .    .           5.300    0.000     2       # AMBER
 .    CR16 CR16 .    .           5.300    0.000     2       # AMBER
 .    CR5  CR15 .    .          17.900    0.000     2       # AMBER (ave.)
 .    CR5  CR56 .    .           2.400  180.000     2       # AMBER
 .    CR56 CR56 .    .           4.400  180.000     2       # AMBER
 .    CR56 CR16 .    .           5.300  180.000     2       # AMBER

 .    CR15 NR15 .    .           7.700    0.000     2       # AMBER (ave.)
 .    CR15 NRD5 .    .           7.400    0.000     2       # AMBER (ave.)
 .    CR5  NRD5 .    .           4.800    0.000     2       # AMBER
 .    CR5  NR15 .    .           5.600    0.000     2       # AMBER
 .    CR56 NR15 .    .           6.100  180.000     2       # AMBER


 .    CR5  NPA  .    .           8.200    0.000     2
 .    CR5  NPB  .    .           8.200    0.000     2
 .    CR5  CR5  .    .          12.500    0.000     2

 .    CR15 NR5  .    .          12.500  180.000     2

 .    CR56 CR6  .    .          12.500  180.000     2
 .    CR56 NRD5 .    .          12.500  180.000     2
 .    CR56 NR5  .    .          12.500  180.000     2
 .    CR56 NRD6 .    .          12.500  180.000     2
 .    CR56 NR16 .    .          12.500  180.000     2
 .    CR56 NR6  .    .          12.500  180.000     2

 .    CR16 NR6  .    .          12.500    0.000     2
 .    CR16 NR16 .    .          12.500    0.000     2
 .    CR16 NRD6 .    .          12.500    0.000     2
 .    CR16 CR66 .    .          12.500  180.000     2

 .    CR6  CR6  .    .          12.500    0.000     2
 .    CR6  NR6  .    .          12.500    0.000     2
 .    CR6  NR16 .    .          12.500    0.000     2
 .    CR6  NRD6 .    .          12.500    0.000     2
 .    CR6  CR66 .    .          12.500  180.000     2

 .    CR66 NRD6 .    .          12.500  180.000     2
 .    CR66 NR16 .    .          12.500  180.000     2
 .    CR66 NR6  .    .          12.500  180.000     2

 .    S    S    .    .           3.500    0.000     2  # AMBER (CHARMM is 4.0)
 .    S    CH2  .    .           1.000    0.000     3  # AMBER (CHARMM is 1.2/2)
#
# ---  VDW contacts ---
#
loop_
_lib_vdw.atom_type_1
_lib_vdw.atom_type_2
_lib_vdw.energy_min
_lib_vdw.radius_min
_lib_vdw.H_flag
#
#  _atom_type      atomic chemical type
#  _energy_min     EPSij  minimum of energy parameter
#  _radius_min     Rmin radius of the minimum of energy parameter
#                  Rij - actual distance
#  _H_flag         "h" - the parameters for atoms with hydrogens 
#
#                      Lennard-Jones potential
#
#             ENERGY =  EPSij * ( (Rmin/Rij)**12 - 2 * (Rmin/Rij)**6 )
#
 C    C       -0.19686     3.600   .
 C    C       -0.19686     3.600   h
 CR16 C       -0.20720     3.700   h
 CR16 CR16    -0.21907     3.800   h
 CH1  C       -0.13206     3.600   .
 CH1  C       -0.16242     3.650   h
 CH1  CR16    -0.17116     3.750   h
 CH1  CH1     -0.09011     3.600   .
 CH1  CH1     -0.13540     3.700   h
 CH2  C       -0.19107     3.700   h
 CH2  CR16    -0.20184     3.800   h
 CH2  CH1     -0.15901     3.750   h
 CH2  CH2     -0.18709     3.800   h
 CH3  C       -0.21258     3.750   h
 CH3  CR16    -0.22508     3.850   h
 CH3  CH1     -0.17680     3.800   h
 CH3  CH2     -0.20835     3.850   h
 CH3  CH3     -0.23233     3.900   h
 N    C       -0.21191     3.400   h
 N    CR16    -0.22057     3.500   h
 N    CH1     -0.17646     3.450   h
 N    CH2     -0.20572     3.500   h
 N    CH3     -0.22725     3.550   h
 N    N       -0.23797     3.200   h
 NH1  C       -0.21191     3.400   .
 NH1  C       -0.24248     3.450   h
 NH1  CR16    -0.25307     3.550   h
 NH1  CH1     -0.14490     3.400   .
 NH1  CH1     -0.20175     3.500   h
 NH1  CH2     -0.23565     3.550   h
 NH1  CH3     -0.26072     3.600   h
 NH1  N       -0.26996     3.250   h
 NH1  NH1     -0.23797     3.200   .
 NH1  NH1     -0.30684     3.300   h
 NH2  C       -0.26649     3.500   h
 NH2  CR16    -0.27886     3.600   h
 NH2  CH1     -0.22168     3.550   h
 NH2  CH2     -0.25935     3.600   h
 NH2  CH3     -0.28735     3.650   h
 NH2  N       -0.29449     3.300   h
 NH2  NH1     -0.33528     3.350   h
 NH2  NH2     -0.36694     3.400   h
 NT3  C       -0.29928     3.550   h
 NT3  CR16    -0.31400     3.650   h
 NT3  CH1     -0.24862     3.600   h
 NT3  CH2     -0.29143     3.650   h
 NT3  CH3     -0.32341     3.700   h
 NT3  N       -0.32774     3.350   h
 NT3  NH1     -0.37386     3.400   h
 NT3  NH2     -0.40986     3.450   h
 NT3  NT3     -0.45871     3.500   h
 O    C       -0.17103     3.400   .
 O    C       -0.17103     3.400   h
 O    CR16    -0.17789     3.500   h
 O    CH1     -0.11796     3.400   .
 O    CH1     -0.14333     3.450   h
 O    CH2     -0.16677     3.500   h
 O    CH3     -0.18401     3.550   h
 O    N       -0.19395     3.200   h
 O    NH1     -0.19395     3.200   .
 O    NH1     -0.21971     3.250   h
 O    NH2     -0.23942     3.300   h
 O    NT3     -0.26598     3.350   h
 O    O       -0.15880     3.200   .
 O    O       -0.15880     3.200   h
 OH1  C       -0.21481     3.450   h
 OH1  CR16    -0.22411     3.550   h
 OH1  CH1     -0.17939     3.500   h
 OH1  CH2     -0.20929     3.550   h
 OH1  CH3     -0.23140     3.600   h
 OH1  N       -0.24051     3.250   h
 OH1  NH1     -0.27314     3.300   h
 OH1  NH2     -0.29828     3.350   h
 OH1  NT3     -0.33226     3.400   h
 OH1  O       -0.19625     3.250   h
 OH1  OH1     -0.24350     3.300   h
 OH2  C       -0.19704     3.500   h
 OH2  CR16    -0.20607     3.600   h
 OH2  CH1     -0.16475     3.550   h
 OH2  CH2     -0.19244     3.600   h
 OH2  CH3     -0.21302     3.650   h
 OH2  N       -0.21946     3.300   h
 OH2  NH1     -0.24957     3.350   h
 OH2  NH2     -0.27291     3.400   h
 OH2  NT3     -0.30439     3.450   h
 OH2  O       -0.17907     3.300   h
 OH2  OH1     -0.22249     3.350   h
 OH2  OH2     -0.20356     3.400   h
 OC   C       -0.35278     3.400   .
 OC   C       -0.35278     3.400   h
 OC   CR16    -0.36787     3.500   h
 OC   CH1     -0.23607     3.400   .
 OC   CH1     -0.28913     3.450   h
 OC   CH2     -0.33872     3.500   h
 OC   CH3     -0.37526     3.550   h
 OC   N       -0.38663     3.200   h
 OC   NH1     -0.38663     3.200   .
 OC   NH1     -0.44019     3.250   h
 OC   NH2     -0.48139     3.300   h
 OC   NT3     -0.53814     3.350   h
 OC   O       -0.31166     3.200   .
 OC   O       -0.31166     3.200   h
 OC   OH1     -0.38969     3.250   h
 OC   OH2     -0.35558     3.300   h
 OC   OC      -0.64573     3.200   .
 OC   OC      -0.64573     3.200   h
 HCH  C       -0.02750     3.268   .
 HCH  CH1     -0.01917     3.268   .
 HCH  NH1     -0.03204     3.068   .
 HCH  O       -0.02638     3.068   .
 HCH  OC      -0.05080     3.068   .
 HCH  HCH     -0.00446     2.936   .
 HNH1 C       -0.05419     2.600   .
 HNH1 CH1     -0.03869     2.600   .
 HNH1 NH1     -0.07179     2.400   .
 HNH1 O       -0.05989     2.400   .
 HNH1 OC      -0.11041     2.400   .
 HNH1 HCH     -0.01111     2.268   .
 HNH1 HNH1    -0.04974     1.600   .
 P    C       -0.19058     3.900   .
 P    C       -0.19058     3.900   h
 P    CR16    -0.20265     4.000   h
 P    CH1     -0.13137     3.900   .
 P    CH1     -0.16143     3.950   h
 P    CH2     -0.18991     4.000   h
 P    CH3     -0.21178     4.050   h
 P    N       -0.20588     3.700   h
 P    NH1     -0.20588     3.700   .
 P    NH1     -0.23617     3.750   h
 P    NH2     -0.26052     3.800   h
 P    NT3     -0.29289     3.850   h
 P    O       -0.16851     3.700   .
 P    O       -0.16851     3.700   h
 P    OH1     -0.21091     3.750   h
 P    OH2     -0.19480     3.800   h
 P    OC      -0.33107     3.700   .
 P    OC      -0.33107     3.700   h
 P    HCH     -0.02703     3.568   .
 P    HNH1    -0.04873     2.900   .
 P    P       -0.19972     4.200   .
 P    P       -0.19972     4.200   h
 S    C       -0.34629     3.700   .
 S    C       -0.34629     3.700   h
 S    CR16    -0.36552     3.800   h
 S    CH1     -0.23662     3.700   .
 S    CH1     -0.29025     3.750   h
 S    CH2     -0.34077     3.800   h
 S    CH3     -0.37899     3.850   h
 S    N       -0.37696     3.500   h
 S    NH1     -0.37696     3.500   .
 S    NH1     -0.43109     3.550   h
 S    NH2     -0.47392     3.600   h
 S    NT3     -0.53147     3.650   h
 S    O       -0.30712     3.500   .
 S    O       -0.30712     3.500   h
 S    OH1     -0.38398     3.550   h
 S    OH2     -0.35307     3.600   h
 S    OC      -0.61302     3.500   .
 S    OC      -0.61302     3.500   h
 S    HCH     -0.04961     3.368   .
 S    HNH1    -0.09586     2.700   .
 S    P       -0.34961     4.000   .
 S    P       -0.34961     4.000   h
 S    S       -0.62416     3.800   .
 S    S       -0.62416     3.800   h
 SH1  C       -0.31950     3.750   h
 SH1  CR16    -0.33795     3.850   h
 SH1  CH1     -0.26808     3.800   h
 SH1  CH2     -0.31507     3.850   h
 SH1  CH3     -0.35076     3.900   h
 SH1  N       -0.34620     3.550   h
 SH1  NH1     -0.39639     3.600   h
 SH1  NH2     -0.43628     3.650   h
 SH1  NT3     -0.48980     3.700   h
 SH1  O       -0.28206     3.550   h
 SH1  OH1     -0.35307     3.600   h
 SH1  OH2     -0.32503     3.650   h
 SH1  OC      -0.56301     3.550   h
 SH1  P       -0.32450     4.050   h
 SH1  S       -0.57707     3.850   h
 SH1  SH1     -0.53408     3.900   h
 FE   C       -0.00130     2.450   .
 FE   C       -0.00130     2.450   h
 FE   CR16    -0.00129     2.550   h
 FE   CH1     -0.00078     2.450   .
 FE   CH1     -0.00095     2.500   h
 FE   CH2     -0.00111     2.550   h
 FE   CH3     -0.00121     2.600   h
 FE   N       -0.00147     2.250   h
 FE   NH1     -0.00147     2.250   .
 FE   NH1     -0.00164     2.300   h
 FE   NH2     -0.00174     2.350   h
 FE   NT3     -0.00192     2.400   h
 FE   O       -0.00113     2.250   .
 FE   O       -0.00113     2.250   h
 FE   OH1     -0.00141     2.300   h
 FE   OH2     -0.00124     2.350   h
 FE   OC      -0.00281     2.250   .
 FE   OC      -0.00281     2.250   h
 FE   HCH     -0.00019     2.118   .
 FE   HNH1    -0.00084     1.450   .
 FE   P       -0.00086     2.750   .
 FE   P       -0.00086     2.750   h
 FE   S       -0.00189     2.550   .
 FE   S       -0.00189     2.550   h
 FE   SH1     -0.00168     2.600   h
 FE   FE      -0.00019     1.300   .
 FE   FE      -0.00019     1.300   h
#
# ---  H-BONDS ---
#
loop_
_lib_hbond.atom_type_1
_lib_hbond.atom_type_2
_lib_hbond.min
_lib_hbond.dist
#
#  _atom_type     atomic chemical type
#  _hbond_min     EPSHij  energy at minimum
#  _hbond_dist    RHmin distance at minimum of energy
#                 RHij - actual distance
#
#             ENERGY =  EPSHij * ( (RHmin/RHij)**12 - 2 * (RHmin/RHij)**10 )
#
 NRD5 NH1    -1.500    2.850
 NRD5 NT3    -1.500    2.850
 O    NH1    -1.500    2.850
 O    NT3    -1.500    2.850
 OH1  NH1    -1.500    2.850
 OH1  NT3    -1.500    2.850
 OH1  NRD5   -1.500    2.850
 OH1  O      -1.500    2.850
 OH1  OH1    -1.500    2.850
 OH2  NH1    -1.500    2.850
 OH2  NT3    -1.500    2.850
 OH2  NRD5   -2.000    2.750
 OH2  O      -2.000    2.750
 OH2  OH1    -2.000    2.750
 OH2  OH2    -2.500    2.800
 OC   NH1    -1.500    2.850
 OC   NT3   -10.000    2.500
 OC   OH1    -1.500    2.850
 OC   OH2    -2.000    2.750
 HNT3 NRD5   -1.500    1.850
 HNT3 O      -1.500    1.850
 HNT3 OH1    -1.500    1.850
 HNT3 OH2    -1.500    1.850
 HNT3 OC    -10.000    1.500
 HNH1 NRD5   -1.500    1.850
 HNH1 O      -1.500    1.850
 HNH1 OH1    -1.500    1.850
 HNH1 OH2    -1.500    1.850
 HNH1 OC     -1.500    1.850
 HNH1 HNH1    0.000    0.000
 HOH1 NRD5   -1.500    1.850
 HOH1 O      -1.500    1.850
 HOH1 OH1    -1.500    1.850
 HOH1 OH2    -1.500    1.850
 HOH1 OC     -1.500    1.850
 HOH1 HNH1    0.000    0.000
 HOH1 HOH1    0.000    0.000
 HOH2 NRD5   -2.000    1.750
 HOH2 O      -2.000    1.750
 HOH2 OH1    -2.000    1.750
 HOH2 OH2    -2.500    1.800
 HOH2 OC     -2.000    1.750
 HOH2 HNH1    0.000    0.000
 HOH2 HOH1    0.000    0.000
# -----------------------------------------------------------------------
`.trim();

var monomers = {};

monomers["GLY"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GLY      GLY 'GLYCINE                             ' L-peptide           7   4 .
#
data_comp_GLY
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 GLY           N      N    NH1      -0.204
 GLY           H      H    HNH1      0.204
 GLY           CA     C    CH2       0.002
 GLY           HA3    H    HCH2      0.051
 GLY           HA2    H    HCH2      0.051
 GLY           C      C    C         0.318
 GLY           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GLY      N      n/a    CA     START
 GLY      H      N      .      .
 GLY      CA     N      C      .
 GLY      HA3    CA     .      .
 GLY      HA2    CA     .      .
 GLY      C      CA     .      END
 GLY      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GLY      N      H         single       0.860    0.020
 GLY      N      CA        single       1.451    0.016
 GLY      CA     HA3       single       0.970    0.020
 GLY      CA     HA2       single       0.970    0.020
 GLY      CA     C         single       1.516    0.018
 GLY      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GLY      H      N      CA      114.000    3.000
 GLY      HA3    CA     HA2     109.000    3.000
 GLY      HA2    CA     C       109.000    3.000
 GLY      HA3    CA     C       109.000    3.000
 GLY      N      CA     HA3     110.000    3.000
 GLY      N      CA     HA2     110.000    3.000
 GLY      N      CA     C       112.500    2.900
 GLY      CA     C      O       120.800    2.100
`.trim();

monomers["ALA"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ALA      ALA 'ALANINE                             ' L-peptide          10   5 .
#
data_comp_ALA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 ALA           N      N    NH1      -0.204
 ALA           H      H    HNH1      0.204
 ALA           CA     C    CH1       0.058
 ALA           HA     H    HCH1      0.046
 ALA           CB     C    CH3      -0.120
 ALA           HB1    H    HCH3      0.040
 ALA           HB2    H    HCH3      0.040
 ALA           HB3    H    HCH3      0.040
 ALA           C      C    C         0.318
 ALA           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ALA      N      n/a    CA     START
 ALA      H      N      .      .
 ALA      CA     N      C      .
 ALA      HA     CA     .      .
 ALA      CB     CA     HB3    .
 ALA      HB1    CB     .      .
 ALA      HB2    CB     .      .
 ALA      HB3    CB     .      .
 ALA      C      CA     .      END
 ALA      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ALA      N      H         single      0.860    0.020
 ALA      N      CA        single      1.458    0.019
 ALA      CA     HA        single      0.980    0.020
 ALA      CA     CB        single      1.521    0.020
 ALA      CB     HB1       single      0.960    0.020
 ALA      CB     HB2       single      0.960    0.020
 ALA      CB     HB3       single      0.960    0.020
 ALA      CA     C         single      1.525    0.021
 ALA      C      O         deloc       1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ALA      H      N      CA      114.000    3.000
 ALA      HA     CA     CB      109.000    3.000
 ALA      CB     CA     C       110.500    1.500
 ALA      HA     CA     C       109.000    3.000
 ALA      N      CA     HA      110.000    3.000
 ALA      N      CA     CB      110.400    1.500
 ALA      HB1    CB     HB2     110.000    3.000
 ALA      HB2    CB     HB3     110.000    3.000
 ALA      HB1    CB     HB3     110.000    3.000
 ALA      CA     CB     HB1     109.000    3.000
 ALA      CA     CB     HB2     109.000    3.000
 ALA      CA     CB     HB3     109.000    3.000
 ALA      N      CA     C       111.200    2.800
 ALA      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ALA      hh1      N      CA     CB     HB3       60.000   15.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 ALA      chir_01  CA     N      CB     C         negativ
`.trim();

monomers["VAL"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
VAL      VAL 'VALINE                              ' L-peptide          16   7 .
#
data_comp_VAL
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 VAL           N      N    NH1      -0.204
 VAL           H      H    HNH1      0.204
 VAL           CA     C    CH1       0.058
 VAL           HA     H    HCH1      0.046
 VAL           CB     C    CH1      -0.038
 VAL           HB     H    HCH1      0.038
 VAL           CG1    C    CH3      -0.114
 VAL           HG11   H    HCH3      0.038
 VAL           HG12   H    HCH3      0.038
 VAL           HG13   H    HCH3      0.038
 VAL           CG2    C    CH3      -0.114
 VAL           HG21   H    HCH3      0.038
 VAL           HG22   H    HCH3      0.038
 VAL           HG23   H    HCH3      0.038
 VAL           C      C    C         0.318
 VAL           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 VAL      N      n/a    CA     START
 VAL      H      N      .      .
 VAL      CA     N      C      .
 VAL      HA     CA     .      .
 VAL      CB     CA     CG2    .
 VAL      HB     CB     .      .
 VAL      CG1    CB     HG13   .
 VAL      HG11   CG1    .      .
 VAL      HG12   CG1    .      .
 VAL      HG13   CG1    .      .
 VAL      CG2    CB     HG23   .
 VAL      HG21   CG2    .      .
 VAL      HG22   CG2    .      .
 VAL      HG23   CG2    .      .
 VAL      C      CA     .      END
 VAL      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 VAL      N      H         single       0.860    0.020
 VAL      N      CA        single       1.458    0.019
 VAL      CA     HA        single       0.980    0.020
 VAL      CA     CB        single       1.540    0.020
 VAL      CB     HB        single       0.980    0.020
 VAL      CB     CG1       single       1.521    0.020
 VAL      CG1    HG11      single       0.960    0.020
 VAL      CG1    HG12      single       0.960    0.020
 VAL      CG1    HG13      single       0.960    0.020
 VAL      CB     CG2       single       1.521    0.020
 VAL      CG2    HG21      single       0.960    0.020
 VAL      CG2    HG22      single       0.960    0.020
 VAL      CG2    HG23      single       0.960    0.020
 VAL      CA     C         single       1.525    0.020
 VAL      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 VAL      H      N      CA      114.000    3.000
 VAL      HA     CA     CB      109.000    3.000
 VAL      CB     CA     C       109.100    2.200
 VAL      HA     CA     C       109.000    3.000
 VAL      N      CA     HA      110.000    3.000
 VAL      N      CA     CB      111.500    1.700
 VAL      HB     CB     CG1     108.000    3.000
 VAL      CG1    CB     CG2     110.800    2.200
 VAL      HB     CB     CG2     108.000    3.000
 VAL      CA     CB     HB      109.000    3.000
 VAL      CA     CB     CG1     110.400    1.700
 VAL      HG11   CG1    HG12    110.000    3.000
 VAL      HG12   CG1    HG13    110.000    3.000
 VAL      HG11   CG1    HG13    110.000    3.000
 VAL      CB     CG1    HG11    109.000    3.000
 VAL      CB     CG1    HG12    109.000    3.000
 VAL      CB     CG1    HG13    109.000    3.000
 VAL      CA     CB     CG2     110.400    1.700
 VAL      HG21   CG2    HG22    110.000    3.000
 VAL      HG22   CG2    HG23    110.000    3.000
 VAL      HG21   CG2    HG23    110.000    3.000
 VAL      CB     CG2    HG21    109.000    3.000
 VAL      CB     CG2    HG22    109.000    3.000
 VAL      CB     CG2    HG23    109.000    3.000
 VAL      N      CA     C       111.200    2.800
 VAL      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 VAL      chi1     N      CA     CB     CG2      180.000   15.000   3
 VAL      hh1      CA     CB     CG1    HG13      60.000   30.000   2
 VAL      hh2      CA     CB     CG2    HG23      60.000   30.000   2
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 VAL      chir_01  CA     N      CB     C         negativ
 VAL      chir_02  CB     CA     CG1    CG2       both
`.trim();

monomers["PRO"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PRO      PRO 'PROLINE                             ' L-peptide          14   7 .
#
data_comp_PRO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 PRO           N      N    N        -0.048
 PRO           CA     C    CH1       0.038
 PRO           HA     H    HCH1      0.048
 PRO           CB     C    CH2      -0.076
 PRO           HB3    H    HCH2      0.038
 PRO           HB2    H    HCH2      0.038
 PRO           CG     C    CH2      -0.076
 PRO           HG3    H    HCH2      0.038
 PRO           HG2    H    HCH2      0.038
 PRO           CD     C    CH2      -0.030
 PRO           HD3    H    HCH2      0.047
 PRO           HD2    H    HCH2      0.047
 PRO           C      C    C         0.323
 PRO           O      O    O        -0.425
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PRO      N      n/a    CA     START
 PRO      CA     N      C      .
 PRO      HA     CA     .      .
 PRO      CB     CA     CG     .
 PRO      HB3    CB     .      .
 PRO      HB2    CB     .      .
 PRO      CG     CB     CD     .
 PRO      HG3    CG     .      .
 PRO      HG2    CG     .      .
 PRO      CD     CG     HD2    .
 PRO      HD3    CD     .      .
 PRO      HD2    CD     .      .
 PRO      C      CA     .      END
 PRO      O      C      .      .
 PRO      CD     N      .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PRO      N      CA        single       1.466    0.015
 PRO      CA     HA        single       0.980    0.020
 PRO      CA     CB        single       1.530    0.020
 PRO      CB     HB3       single       0.970    0.020
 PRO      CB     HB2       single       0.970    0.020
 PRO      CB     CG        single       1.492    0.025
 PRO      CG     HG3       single       0.970    0.020
 PRO      CG     HG2       single       0.970    0.020
 PRO      CG     CD        single       1.503    0.022
 PRO      CD     HD3       single       0.970    0.020
 PRO      CD     HD2       single       0.970    0.020
 PRO      CD     N         single       1.473    0.014
 PRO      CA     C         single       1.525    0.021
 PRO      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PRO      CA     N      CD      112.000    1.400
 PRO      HA     CA     CB      109.000    3.000
 PRO      CB     CA     C       110.100    1.900
 PRO      HA     CA     C       109.000    3.000
 PRO      N      CA     HA      110.000    3.000
 PRO      N      CA     CB      103.000    1.100
 PRO      HB3    CB     HB2     110.000    3.000
 PRO      HB2    CB     CG      110.000    3.000
 PRO      HB3    CB     CG      110.000    3.000
 PRO      CA     CB     HB3     109.000    3.000
 PRO      CA     CB     HB2     109.000    3.000
 PRO      CA     CB     CG      104.500    1.900
 PRO      HG3    CG     HG2     110.000    3.000
 PRO      HG2    CG     CD      110.000    3.000
 PRO      HG3    CG     CD      110.000    3.000
 PRO      CB     CG     HG3     109.000    3.000
 PRO      CB     CG     HG2     109.000    3.000
 PRO      CB     CG     CD      106.100    3.200
 PRO      HD3    CD     HD2     110.000    3.000
 PRO      CG     CD     HD3     109.000    3.000
 PRO      CG     CD     HD2     109.000    3.000
 PRO      N      CD     CG      103.200    1.500
 PRO      N      CD     HD3     109.000    3.000
 PRO      N      CD     HD2     109.000    3.000
 PRO      N      CA     C       111.800    2.500
 PRO      CA     C      O       119.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PRO      chi1     N      CA     CB     CG       -25.000   15.000   3
 PRO      chi2     CA     CB     CG     CD        35.000   15.000   3
 PRO      chi3     CB     CG     CD     N        -30.000   15.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 PRO      chir_01  CA     N      CB     C         negativ
`.trim();

monomers["SER"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SER      SER 'SERINE                              ' L-peptide          11   6 .
#
data_comp_SER
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 SER           N      N    NH1      -0.204
 SER           H      H    HNH1      0.204
 SER           CA     C    CH1       0.058
 SER           HA     H    HCH1      0.046
 SER           CB     C    CH2      -0.040
 SER           HB3    H    HCH2      0.053
 SER           HB2    H    HCH2      0.053
 SER           OG     O    OH1      -0.448
 SER           HG     H    HOH1      0.302
 SER           C      C    C         0.318
 SER           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SER      N      n/a    CA     START
 SER      H      N      .      .
 SER      CA     N      C      .
 SER      HA     CA     .      .
 SER      CB     CA     OG     .
 SER      HB3    CB     .      .
 SER      HB2    CB     .      .
 SER      OG     CB     HG     .
 SER      HG     OG     .      .
 SER      C      CA     .      END
 SER      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SER      N      H         single       0.860    0.020
 SER      N      CA        single       1.458    0.019
 SER      CA     HA        single       0.980    0.020
 SER      CA     CB        single       1.530    0.020
 SER      CB     HB3       single       0.970    0.020
 SER      CB     HB2       single       0.970    0.020
 SER      CB     OG        single       1.417    0.020
 SER      OG     HG        single       0.820    0.020
 SER      CA     C         single       1.525    0.021
 SER      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SER      H      N      CA      114.000    3.000
 SER      HA     CA     CB      109.000    3.000
 SER      CB     CA     C       110.100    1.900
 SER      HA     CA     C       109.000    3.000
 SER      N      CA     HA      110.000    3.000
 SER      N      CA     CB      110.500    1.700
 SER      HB3    CB     HB2     110.000    3.000
 SER      HB2    CB     OG      109.000    3.000
 SER      HB3    CB     OG      109.000    3.000
 SER      CA     CB     HB3     109.000    3.000
 SER      CA     CB     HB2     109.000    3.000
 SER      CA     CB     OG      111.100    2.000
 SER      CB     OG     HG      110.000    3.000
 SER      N      CA     C       111.200    2.800
 SER      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 SER      chi1     N      CA     CB     OG       180.000   15.000   3
 SER      hh1      CA     CB     OG     HG       180.000   30.000   2
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 SER      chir_01  CA     N      CB     C         negativ
`.trim();

monomers["THR"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
THR      THR 'THREONINE                           ' L-peptide          14   7 .
#
data_comp_THR
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 THR           N      N    NH1      -0.204
 THR           H      H    HNH1      0.204
 THR           CA     C    CH1       0.058
 THR           HA     H    HCH1      0.046
 THR           CB     C    CH1       0.089
 THR           HB     H    HCH1      0.050
 THR           OG1    O    OH1      -0.441
 THR           HG1    H    HOH1      0.302
 THR           CG2    C    CH3      -0.120
 THR           HG21   H    HCH3      0.040
 THR           HG22   H    HCH3      0.040
 THR           HG23   H    HCH3      0.040
 THR           C      C    C         0.318
 THR           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 THR      N      n/a    CA     START
 THR      H      N      .      .
 THR      CA     N      C      .
 THR      HA     CA     .      .
 THR      CB     CA     CG2    .
 THR      HB     CB     .      .
 THR      OG1    CB     HG1    .
 THR      HG1    OG1    .      .
 THR      CG2    CB     HG23   .
 THR      HG21   CG2    .      .
 THR      HG22   CG2    .      .
 THR      HG23   CG2    .      .
 THR      C      CA     .      END
 THR      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 THR      N      H         single       0.860    0.020
 THR      N      CA        single       1.458    0.019
 THR      CA     HA        single       0.980    0.020
 THR      CA     CB        single       1.540    0.020
 THR      CB     HB        single       0.970    0.020
 THR      CB     OG1       single       1.433    0.016
 THR      OG1    HG1       single       0.820    0.020
 THR      CB     CG2       single       1.521    0.033
 THR      CG2    HG21      single       0.960    0.020
 THR      CG2    HG22      single       0.960    0.020
 THR      CG2    HG23      single       0.960    0.020
 THR      CA     C         single       1.525    0.021
 THR      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 THR      H      N      CA      114.000    3.000
 THR      HA     CA     CB      109.000    3.000
 THR      CB     CA     C       109.100    2.200
 THR      HA     CA     C       109.000    3.000
 THR      N      CA     HA      110.000    3.000
 THR      N      CA     CB      111.500    1.700
 THR      HB     CB     OG1     109.000    3.000
 THR      OG1    CB     CG2     109.300    2.000
 THR      HB     CB     CG2     108.000    3.000
 THR      CA     CB     HB      109.000    3.000
 THR      CA     CB     OG1     109.600    1.500
 THR      CB     OG1    HG1     110.000    3.000
 THR      CA     CB     CG2     110.500    1.700
 THR      HG21   CG2    HG22    109.000    3.000
 THR      HG22   CG2    HG23    109.000    3.000
 THR      HG21   CG2    HG23    109.000    3.000
 THR      CB     CG2    HG21    110.000    3.000
 THR      CB     CG2    HG22    110.000    3.000
 THR      CB     CG2    HG23    110.000    3.000
 THR      N      CA     C       111.200    2.800
 THR      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 THR      chi1     N      CA     CB     CG2      180.000   15.000   3
 THR      hh1      CA     CB     OG1    HG1      180.000   30.000   3
 THR      hh2      CA     CB     CG2    HG23      60.000   30.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 THR      chir_01  CA     N      CB     C         negativ
 THR      chir_02  CB     CA     OG1    CG2       positiv
`.trim();

monomers["LEU"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
LEU      LEU 'LEUCINE                             ' L-peptide          19   8 .
#
data_comp_LEU
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 LEU           N      N    NH1      -0.204
 LEU           H      H    HNH1      0.204
 LEU           CA     C    CH1       0.058
 LEU           HA     H    HCH1      0.046
 LEU           CB     C    CH2      -0.076
 LEU           HB3    H    HCH2      0.038
 LEU           HB2    H    HCH2      0.038
 LEU           CG     C    CH1      -0.038
 LEU           HG     H    HCH1      0.038
 LEU           CD1    C    CH3      -0.114
 LEU           HD11   H    HCH3      0.038
 LEU           HD12   H    HCH3      0.038
 LEU           HD13   H    HCH3      0.038
 LEU           CD2    C    CH3      -0.114
 LEU           HD21   H    HCH3      0.038
 LEU           HD22   H    HCH3      0.038
 LEU           HD23   H    HCH3      0.038
 LEU           C      C    C         0.318
 LEU           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 LEU      N      n/a    CA     START
 LEU      H      N      .      .
 LEU      CA     N      C      .
 LEU      HA     CA     .      .
 LEU      CB     CA     CG     .
 LEU      HB3    CB     .      .
 LEU      HB2    CB     .      .
 LEU      CG     CB     CD2    .
 LEU      HG     CG     .      .
 LEU      CD1    CG     HD13   .
 LEU      HD11   CD1    .      .
 LEU      HD12   CD1    .      .
 LEU      HD13   CD1    .      .
 LEU      CD2    CG     HD23   .
 LEU      HD21   CD2    .      .
 LEU      HD22   CD2    .      .
 LEU      HD23   CD2    .      .
 LEU      C      CA     .      END
 LEU      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 LEU      N      H         single       0.860    0.020
 LEU      N      CA        single       1.458    0.019
 LEU      CA     HA        single       0.980    0.020
 LEU      CA     CB        single       1.530    0.020
 LEU      CB     HB3       single       0.970    0.020
 LEU      CB     HB2       single       0.970    0.020
 LEU      CB     CG        single       1.530    0.020
 LEU      CG     HG        single       0.970    0.020
 LEU      CG     CD1       single       1.521    0.020
 LEU      CD1    HD11      single       0.960    0.020
 LEU      CD1    HD12      single       0.960    0.020
 LEU      CD1    HD13      single       0.960    0.020
 LEU      CG     CD2       single       1.521    0.020
 LEU      CD2    HD21      single       0.960    0.020
 LEU      CD2    HD22      single       0.960    0.020
 LEU      CD2    HD23      single       0.960    0.020
 LEU      CA     C         single       1.525    0.021
 LEU      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 LEU      H      N      CA      114.000    3.000
 LEU      HA     CA     CB      109.000    3.000
 LEU      CB     CA     C       110.100    1.900
 LEU      HA     CA     C       109.000    3.000
 LEU      N      CA     HA      110.000    3.000
 LEU      N      CA     CB      110.500    1.700
 LEU      HB3    CB     HB2     110.000    3.000
 LEU      HB2    CB     CG      108.000    3.000
 LEU      HB3    CB     CG      108.000    3.000
 LEU      CA     CB     HB3     109.000    3.000
 LEU      CA     CB     HB2     109.000    3.000
 LEU      CA     CB     CG      116.300    3.500
 LEU      HG     CG     CD1     108.000    3.000
 LEU      CD1    CG     CD2     110.800    2.200
 LEU      HG     CG     CD2     108.000    3.000
 LEU      CB     CG     HG      109.000    3.000
 LEU      CB     CG     CD1     110.700    3.000
 LEU      HD11   CD1    HD12    110.000    3.000
 LEU      HD12   CD1    HD13    110.000    3.000
 LEU      HD11   CD1    HD13    110.000    3.000
 LEU      CG     CD1    HD11    109.000    3.000
 LEU      CG     CD1    HD12    109.000    3.000
 LEU      CG     CD1    HD13    109.000    3.000
 LEU      CB     CG     CD2     110.700    3.000
 LEU      HD21   CD2    HD22    110.000    3.000
 LEU      HD22   CD2    HD23    110.000    3.000
 LEU      HD21   CD2    HD23    110.000    3.000
 LEU      CG     CD2    HD21    109.000    3.000
 LEU      CG     CD2    HD22    109.000    3.000
 LEU      CG     CD2    HD23    109.000    3.000
 LEU      N      CA     C       111.200    2.800
 LEU      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 LEU      chi1     N      CA     CB     CG       180.000   15.000   3
 LEU      chi2     CA     CB     CG     CD2      180.000   15.000   3
 LEU      hh1      CB     CG     CD1    HD13      60.000   30.000   3
 LEU      hh2      CB     CG     CD2    HD23      60.000   30.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 LEU      chir_01  CA     N      CB     C         negativ
 LEU      chir_02  CG     CB     CD1    CD2       both
`.trim();

monomers["ILE"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ILE      ILE 'ISOLEUCINE                          ' L-peptide          19   8 .
#
data_comp_ILE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 ILE           N      N    NH1      -0.204
 ILE           H      H    HNH1      0.204
 ILE           CA     C    CH1       0.058
 ILE           HA     H    HCH1      0.046
 ILE           CB     C    CH1      -0.038
 ILE           HB     H    HCH1      0.038
 ILE           CG1    C    CH2      -0.076
 ILE           HG13   H    HCH2      0.038
 ILE           HG12   H    HCH2      0.038
 ILE           CD1    C    CH3      -0.114
 ILE           HD11   H    HCH3      0.038
 ILE           HD12   H    HCH3      0.038
 ILE           HD13   H    HCH3      0.038
 ILE           CG2    C    CH3      -0.114
 ILE           HG21   H    HCH3      0.038
 ILE           HG22   H    HCH3      0.038
 ILE           HG23   H    HCH3      0.038
 ILE           C      C    C         0.318
 ILE           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ILE      N      n/a    CA     START
 ILE      H      N      .      .
 ILE      CA     N      C      .
 ILE      HA     CA     .      .
 ILE      CB     CA     CG2    .
 ILE      HB     CB     .      .
 ILE      CG1    CB     CD1    .
 ILE      HG13   CG1    .      .
 ILE      HG12   CG1    .      .
 ILE      CD1    CG1    HD13   .
 ILE      HD11   CD1    .      .
 ILE      HD12   CD1    .      .
 ILE      HD13   CD1    .      .
 ILE      CG2    CB     HG23   .
 ILE      HG21   CG2    .      .
 ILE      HG22   CG2    .      .
 ILE      HG23   CG2    .      .
 ILE      C      CA     .      END
 ILE      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ILE      N      H         single       0.860    0.020
 ILE      N      CA        single       1.458    0.019
 ILE      CA     HA        single       0.980    0.020
 ILE      CA     CB        single       1.540    0.020
 ILE      CB     HB        single       0.970    0.020
 ILE      CB     CG1       single       1.530    0.020
 ILE      CG1    HG13      single       0.970    0.020
 ILE      CG1    HG12      single       0.970    0.020
 ILE      CG1    CD1       single       1.513    0.020
 ILE      CD1    HD11      single       0.960    0.020
 ILE      CD1    HD12      single       0.960    0.020
 ILE      CD1    HD13      single       0.960    0.020
 ILE      CB     CG2       single       1.521    0.020
 ILE      CG2    HG21      single       0.960    0.020
 ILE      CG2    HG22      single       0.960    0.020
 ILE      CG2    HG23      single       0.960    0.020
 ILE      CA     C         single       1.525    0.020
 ILE      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ILE      H      N      CA      114.000    3.000
 ILE      HA     CA     CB      109.000    3.000
 ILE      CB     CA     C       109.100    2.200
 ILE      HA     CA     C       109.000    3.000
 ILE      N      CA     HA      110.000    3.000
 ILE      N      CA     CB      111.500    1.700
 ILE      HB     CB     CG1     109.000    3.000
 ILE      CG1    CB     CG2     110.700    3.000
 ILE      HB     CB     CG2     109.000    3.000
 ILE      CA     CB     HB      109.000    3.000
 ILE      CA     CB     CG1     110.400    1.700
 ILE      HG13   CG1    HG12    110.000    3.000
 ILE      HG12   CG1    CD1     108.000    3.000
 ILE      HG13   CG1    CD1     108.000    3.000
 ILE      CB     CG1    HG13    109.000    3.000
 ILE      CB     CG1    HG12    109.000    3.000
 ILE      CB     CG1    CD1     113.800    2.100
 ILE      HD11   CD1    HD12    110.000    3.000
 ILE      HD12   CD1    HD13    110.000    3.000
 ILE      HD11   CD1    HD13    110.000    3.000
 ILE      CG1    CD1    HD11    109.000    3.000
 ILE      CG1    CD1    HD12    109.000    3.000
 ILE      CG1    CD1    HD13    109.000    3.000
 ILE      CA     CB     CG2     110.500    1.700
 ILE      HG21   CG2    HG22    110.000    3.000
 ILE      HG22   CG2    HG23    110.000    3.000
 ILE      HG21   CG2    HG23    110.000    3.000
 ILE      CB     CG2    HG21    109.000    3.000
 ILE      CB     CG2    HG22    109.000    3.000
 ILE      CB     CG2    HG23    109.000    3.000
 ILE      N      CA     C       111.200    2.800
 ILE      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ILE      chi1     N      CA     CB     CG2      180.000   15.000   3
 ILE      chi2     CA     CB     CG1    CD1      180.000   15.000   3
 ILE      hh1      CB     CG1    CD1    HD13      60.000   30.000   3
 ILE      hh2      CA     CB     CG2    HG23      60.000   30.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 ILE      chir_01  CA     N      CB     C         negativ
 ILE      chir_02  CB     CA     CG1    CG2       positiv
`.trim();

monomers["CYS"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CYS      CYS 'CYSTINE                             ' L-peptide          10   6 .
#
data_comp_CYS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 CYS           N      N    NH1      -0.204
 CYS           H      H    HNH1      0.204
 CYS           CA     C    CH1       0.058
 CYS           HA     H    HCH1      0.046
 CYS           CB     C    CH2      -0.096
 CYS           HB3    H    HCH2      0.046
 CYS           HB2    H    HCH2      0.058
 CYS           SG     S    S         0.004
 CYS           HG     H    H         0.000
 CYS           C      C    C         0.318
 CYS           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CYS      N      n/a    CA     START
 CYS      H      N      .      .
 CYS      CA     N      C      .
 CYS      HA     CA     .      .
 CYS      CB     CA     SG     .
 CYS      HB3    CB     .      .
 CYS      HB2    CB     .      .
 CYS      SG     CB     .     .
 CYS      HG     SG     .      .
 CYS      C      CA     .      END
 CYS      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CYS      N      H         single       0.860    0.020
 CYS      N      CA        single       1.458    0.019
 CYS      CA     HA        single       0.980    0.020
 CYS      CA     CB        single       1.530    0.020
 CYS      CB     HB3       single       0.970    0.020
 CYS      CB     HB2       single       0.970    0.020
 CYS      CB     SG        single       1.808    0.020
 CYS      HG     SG        single       1.340    0.020
 CYS      CA     C         single       1.525    0.021
 CYS      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CYS      H      N      CA      114.000    3.000
 CYS      HA     CA     CB      109.000    3.000
 CYS      CB     CA     C       110.100    1.900
 CYS      HA     CA     C       109.000    3.000
 CYS      N      CA     HA      110.000    3.000
 CYS      N      CA     CB      110.500    1.700
 CYS      HB3    CB     HB2     110.000    3.000
 CYS      HB2    CB     SG      108.000    3.000
 CYS      HB3    CB     SG      108.000    3.000
 CYS      CA     CB     HB3     109.000    3.000
 CYS      CA     CB     HB2     109.000    3.000
 CYS      CA     CB     SG      114.400    2.300
 CYS      CB     SG     HG      109.000    5.000
 CYS      N      CA     C       111.200    2.800
 CYS      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CYS      chi1     N      CA     CB     SG       180.000   15.000   3
 CYS      chi2     CA     CB     SG     HG       180.000   15.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 CYS      chir_01  CA     N      CB     C         negativ
`.trim();

monomers["ASP"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ASP      ASP 'ASPARTIC-ACID                       ' L-peptide          12   8 .
#
data_comp_ASP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 ASP           N      N    NH1      -0.204
 ASP           H      H    HNH1      0.204
 ASP           CA     C    CH1       0.058
 ASP           HA     H    HCH1      0.046
 ASP           CB     C    CH2      -0.059
 ASP           HB3    H    HCH2      0.042
 ASP           HB2    H    HCH2      0.042
 ASP           CG     C    C         0.207
 ASP           OD1    O    OC       -0.616
 ASP           OD2    O    OC       -0.616
 ASP           C      C    C         0.318
 ASP           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ASP      N      n/a    CA     START
 ASP      H      N      .      .
 ASP      CA     N      C      .
 ASP      HA     CA     .      .
 ASP      CB     CA     CG     .
 ASP      HB3    CB     .      .
 ASP      HB2    CB     .      .
 ASP      CG     CB     OD2    .
 ASP      OD1    CG     .      .
 ASP      OD2    CG     .      .
 ASP      C      CA     .      END
 ASP      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ASP      N      H         single       0.860    0.020
 ASP      N      CA        single       1.458    0.019
 ASP      CA     HA        single       0.980    0.020
 ASP      CA     CB        single       1.530    0.020
 ASP      CB     HB3       single       0.970    0.020
 ASP      CB     HB2       single       0.970    0.020
 ASP      CB     CG        single       1.516    0.025
 ASP      CG     OD1       deloc        1.249    0.019
 ASP      CG     OD2       deloc        1.249    0.019
 ASP      CA     C         single       1.525    0.021
 ASP      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ASP      H      N      CA      114.000    3.000
 ASP      HA     CA     CB      109.000    3.000
 ASP      CB     CA     C       110.100    1.900
 ASP      HA     CA     C       109.000    3.000
 ASP      N      CA     HA      110.000    3.000
 ASP      N      CA     CB      110.500    1.700
 ASP      HB3    CB     HB2     110.000    3.000
 ASP      HB2    CB     CG      108.000    3.000
 ASP      HB3    CB     CG      108.000    3.000
 ASP      CA     CB     HB3     109.000    3.000
 ASP      CA     CB     HB2     109.000    3.000
 ASP      CA     CB     CG      112.600    1.000
 ASP      OD1    CG     OD2     122.900    2.400
 ASP      CB     CG     OD1     118.400    2.300
 ASP      CB     CG     OD2     118.400    2.300
 ASP      N      CA     C       111.200    2.800
 ASP      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ASP      chi1     N      CA     CB     CG       180.000   15.000   3
 ASP      chi2     CA     CB     CG     OD2        0.000   30.000   2
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 ASP      chir_01  CA     N      CB     C         negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ASP      plan      CG        0.020
 ASP      plan      CB        0.020
 ASP      plan      OD1       0.020
 ASP      plan      OD2       0.020
`.trim();

monomers["GLU"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GLU      GLU 'GLUTAMIC-ACID                       ' L-peptide          15   9 .
#
data_comp_GLU
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 GLU           N      N    NH1      -0.204
 GLU           H      H    HNH1      0.204
 GLU           CA     C    CH1       0.058
 GLU           HA     H    HCH1      0.046
 GLU           CB     C    CH2      -0.078
 GLU           HB3    H    HCH2      0.039
 GLU           HB2    H    HCH2      0.039
 GLU           CG     C    CH2      -0.067
 GLU           HG3    H    HCH2      0.041
 GLU           HG2    H    HCH2      0.041
 GLU           CD     C    C         0.203
 GLU           OE1    O    OC       -0.609
 GLU           OE2    O    OC       -0.609
 GLU           C      C    C         0.318
 GLU           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GLU      N      n/a    CA     START
 GLU      H      N      .      .
 GLU      CA     N      C      .
 GLU      HA     CA     .      .
 GLU      CB     CA     CG     .
 GLU      HB3    CB     .      .
 GLU      HB2    CB     .      .
 GLU      CG     CB     CD     .
 GLU      HG3    CG     .      .
 GLU      HG2    CG     .      .
 GLU      CD     CG     OE2    .
 GLU      OE1    CD     .      .
 GLU      OE2    CD     .      .
 GLU      C      CA     .      END
 GLU      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GLU      N      H         single       0.860    0.020
 GLU      N      CA        single       1.458    0.019
 GLU      CA     HA        single       0.980    0.020
 GLU      CA     CB        single       1.530    0.020
 GLU      CB     HB3       single       0.970    0.020
 GLU      CB     HB2       single       0.970    0.020
 GLU      CB     CG        single       1.520    0.020
 GLU      CG     HG3       single       0.970    0.020
 GLU      CG     HG2       single       0.970    0.020
 GLU      CG     CD        single       1.516    0.020
 GLU      CD     OE1       deloc        1.249    0.019
 GLU      CD     OE2       deloc        1.249    0.019
 GLU      CA     C         single       1.525    0.021
 GLU      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GLU      H      N      CA      114.000    3.000
 GLU      HA     CA     CB      109.000    3.000
 GLU      CB     CA     C       110.100    1.900
 GLU      HA     CA     C       109.000    3.000
 GLU      N      CA     HA      110.000    3.000
 GLU      N      CA     CB      110.500    1.700
 GLU      HB3    CB     HB2     110.000    3.000
 GLU      HB2    CB     CG      108.000    3.000
 GLU      HB3    CB     CG      108.000    3.000
 GLU      CA     CB     HB3     109.000    3.000
 GLU      CA     CB     HB2     109.000    3.000
 GLU      CA     CB     CG      114.100    2.000
 GLU      HG3    CG     HG2     110.000    3.000
 GLU      HG2    CG     CD      108.000    3.000
 GLU      HG3    CG     CD      108.000    3.000
 GLU      CB     CG     HG3     109.000    3.000
 GLU      CB     CG     HG2     109.000    3.000
 GLU      CB     CG     CD      112.600    1.700
 GLU      OE1    CD     OE2     122.900    2.400
 GLU      CG     CD     OE1     118.400    2.300
 GLU      CG     CD     OE2     118.400    2.300
 GLU      N      CA     C       111.200    2.800
 GLU      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GLU      chi1     N      CA     CB     CG       180.000   15.000   3
 GLU      chi2     CA     CB     CG     CD       180.000   15.000   3
 GLU      chi3     CB     CG     CD     OE2        0.000   30.000   2
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 GLU      chir_01  CA     N      CB     C         negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 GLU      plan      CD        0.020
 GLU      plan      CG        0.020
 GLU      plan      OE1       0.020
 GLU      plan      OE2       0.020
`.trim();

monomers["ASN"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ASN      ASN 'ASPARAGINE                          ' L-peptide          14   8 .
#
data_comp_ASN
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 ASN           N      N    NH1      -0.204
 ASN           H      H    HNH1      0.204
 ASN           CA     C    CH1       0.058
 ASN           HA     H    HCH1      0.046
 ASN           CB     C    CH2      -0.045
 ASN           HB3    H    HCH2      0.041
 ASN           HB2    H    HCH2      0.041
 ASN           CG     C    C         0.324
 ASN           OD1    O    O        -0.425
 ASN           ND2    N    NH2      -0.350
 ASN           HD21   H    HNH2      0.207
 ASN           HD22   H    HNH2      0.207
 ASN           C      C    C         0.318
 ASN           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ASN      N      n/a    CA     START
 ASN      H      N      .      .
 ASN      CA     N      C      .
 ASN      HA     CA     .      .
 ASN      CB     CA     CG     .
 ASN      HB3    CB     .      .
 ASN      HB2    CB     .      .
 ASN      CG     CB     ND2    .
 ASN      OD1    CG     .      .
 ASN      ND2    CG     HD22   .
 ASN      HD21   ND2    .      .
 ASN      HD22   ND2    .      .
 ASN      C      CA     .      END
 ASN      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ASN      N      H         single       0.860    0.020
 ASN      N      CA        single       1.458    0.019
 ASN      CA     HA        single       0.980    0.020
 ASN      CA     CB        single       1.530    0.020
 ASN      CB     HB3       single       0.970    0.020
 ASN      CB     HB2       single       0.970    0.020
 ASN      CB     CG        single       1.516    0.020
 ASN      CG     OD1       double       1.231    0.019
 ASN      CG     ND2       single       1.328    0.021
 ASN      ND2    HD21      single       0.980    0.020
 ASN      ND2    HD22      single       0.980    0.020
 ASN      CA     C         single       1.525    0.021
 ASN      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ASN      H      N      CA      114.000    3.000
 ASN      HA     CA     CB      109.000    3.000
 ASN      CB     CA     C       110.100    1.900
 ASN      HA     CA     C       109.000    3.000
 ASN      N      CA     HA      110.000    3.000
 ASN      N      CA     CB      110.500    1.700
 ASN      HB3    CB     HB2     110.000    3.000
 ASN      HB2    CB     CG      108.000    3.000
 ASN      HB3    CB     CG      108.000    3.000
 ASN      CA     CB     HB3     109.000    3.000
 ASN      CA     CB     HB2     109.000    3.000
 ASN      CA     CB     CG      112.600    1.000
 ASN      OD1    CG     ND2     122.600    1.000
 ASN      CB     CG     OD1     120.800    2.000
 ASN      CB     CG     ND2     116.400    1.500
 ASN      HD21   ND2    HD22    120.000    3.000
 ASN      CG     ND2    HD21    120.000    3.000
 ASN      CG     ND2    HD22    120.000    3.000
 ASN      N      CA     C       111.200    2.800
 ASN      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ASN      chi1     N      CA     CB     CG       180.000   15.000   3
 ASN      chi2     CA     CB     CG     ND2        0.000   30.000   2
 ASN      hh1      CB     CG     ND2    HD22       0.000   30.000   2
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 ASN      chir_01  CA     N      CB     C         negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ASN      plan1     CG        0.020
 ASN      plan1     CB        0.020
 ASN      plan1     OD1       0.020
 ASN      plan1     ND2       0.020
 ASN      plan2     CG        0.020
 ASN      plan2     ND2       0.020
 ASN      plan2     HD21      0.020
 ASN      plan2     HD22      0.020
`.trim();

monomers["GLN"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GLN      GLN 'GLUTAMINE                           ' L-peptide          17   9 .
#
data_comp_GLN
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 GLN           N      N    NH1      -0.204
 GLN           H      H    HNH1      0.204
 GLN           CA     C    CH1       0.058
 GLN           HA     H    HCH1      0.046
 GLN           CB     C    CH2      -0.078
 GLN           HB3    H    HCH2      0.039
 GLN           HB2    H    HCH2      0.039
 GLN           CG     C    CH2      -0.040
 GLN           HG3    H    HCH2      0.035
 GLN           HG2    H    HCH2      0.035
 GLN           CD     C    C         0.322
 GLN           OE1    O    O        -0.422
 GLN           NE2    N    NH2      -0.346
 GLN           HE21   H    HNH2      0.208
 GLN           HE22   H    HNH2      0.208
 GLN           C      C    C         0.318
 GLN           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GLN      N      n/a    CA     START
 GLN      H      N      .      .
 GLN      CA     N      C      .
 GLN      HA     CA     .      .
 GLN      CB     CA     CG     .
 GLN      HB3    CB     .      .
 GLN      HB2    CB     .      .
 GLN      CG     CB     CD     .
 GLN      HG3    CG     .      .
 GLN      HG2    CG     .      .
 GLN      CD     CG     NE2    .
 GLN      OE1    CD     .      .
 GLN      NE2    CD     HE22   .
 GLN      HE21   NE2    .      .
 GLN      HE22   NE2    .      .
 GLN      C      CA     .      END
 GLN      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GLN      N      H         single       0.860    0.020
 GLN      N      CA        single       1.458    0.019
 GLN      CA     HA        single       0.980    0.020
 GLN      CA     CB        single       1.530    0.020
 GLN      CB     HB3       single       0.970    0.020
 GLN      CB     HB2       single       0.970    0.020
 GLN      CB     CG        single       1.520    0.020
 GLN      CG     HG3       single       0.970    0.020
 GLN      CG     HG2       single       0.970    0.020
 GLN      CG     CD        single       1.516    0.020
 GLN      CD     OE1       double       1.231    0.019
 GLN      CD     NE2       single       1.328    0.021
 GLN      NE2    HE21      single       0.860    0.020
 GLN      NE2    HE22      single       0.860    0.020
 GLN      CA     C         single       1.525    0.021
 GLN      C      O         deloc       1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GLN      H      N      CA      114.000    3.000
 GLN      HA     CA     CB      109.000    3.000
 GLN      CB     CA     C       110.100    1.900
 GLN      HA     CA     C       109.000    3.000
 GLN      N      CA     HA      110.000    3.000
 GLN      N      CA     CB      110.500    1.700
 GLN      HB3    CB     HB2     110.000    3.000
 GLN      HB2    CB     CG      108.000    3.000
 GLN      HB3    CB     CG      108.000    3.000
 GLN      CA     CB     HB3     109.000    3.000
 GLN      CA     CB     HB2     109.000    3.000
 GLN      CA     CB     CG      114.100    2.000
 GLN      HG3    CG     HG2     110.000    3.000
 GLN      HG2    CG     CD      108.000    3.000
 GLN      HG3    CG     CD      108.000    3.000
 GLN      CB     CG     HG3     109.000    3.000
 GLN      CB     CG     HG2     109.000    3.000
 GLN      CB     CG     CD      112.600    1.700
 GLN      OE1    CD     NE2     122.600    1.000
 GLN      CG     CD     OE1     120.800    2.000
 GLN      CG     CD     NE2     116.400    1.500
 GLN      HE21   NE2    HE22    120.000    3.000
 GLN      CD     NE2    HE21    120.000    3.000
 GLN      CD     NE2    HE22    120.000    3.000
 GLN      N      CA     C       111.200    2.800
 GLN      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GLN      chi1     N      CA     CB     CG       180.000   15.000   3
 GLN      chi2     CA     CB     CG     CD       180.000   15.000   3
 GLN      chi3     CB     CG     CD     NE2        0.000   30.000   2
 GLN      hh1      CG     CD     NE2    HE22       0.000   30.000   2
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 GLN      chir_01  CA     N      CB     C         negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 GLN      plan1     CD        0.020
 GLN      plan1     CG        0.020
 GLN      plan1     OE1       0.020
 GLN      plan1     NE2       0.020
 GLN      plan2     CD        0.020
 GLN      plan2     NE2       0.020
 GLN      plan2     HE21      0.020
 GLN      plan2     HE22      0.020
`.trim();

monomers["ARG"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ARG      ARG 'ARGININE                            ' L-peptide          24  11 .
#
data_comp_ARG
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 ARG           N      N    NH1      -0.204
 ARG           H      H    HNH1      0.204
 ARG           CA     C    CH1       0.058
 ARG           HA     H    HCH1      0.046
 ARG           CB     C    CH2      -0.076
 ARG           HB3    H    HCH2      0.038
 ARG           HB2    H    HCH2      0.038
 ARG           CG     C    CH2      -0.076
 ARG           HG3    H    HCH2      0.038
 ARG           HG2    H    HCH2      0.038
 ARG           CD     C    CH2      -0.020
 ARG           HD3    H    HCH2      0.066
 ARG           HD2    H    HCH2      0.066
 ARG           NE     N    NC1      -0.098
 ARG           HE     H    HNC1      0.058
 ARG           CZ     C    C         0.694
 ARG           NH1    N    NC2       0.500
 ARG           HH11   H    HNC2      0.334
 ARG           HH12   H    HNC2      0.334
 ARG           NH2    N    NC2       0.500
 ARG           HH21   H    HNC2      0.334
 ARG           HH22   H    HNC2      0.334
 ARG           C      C    C         0.318
 ARG           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ARG      N      n/a    CA     START
 ARG      H      N      .      .
 ARG      CA     N      C      .
 ARG      HA     CA     .      .
 ARG      CB     CA     CG     .
 ARG      HB3    CB     .      .
 ARG      HB2    CB     .      .
 ARG      CG     CB     CD     .
 ARG      HG3    CG     .      .
 ARG      HG2    CG     .      .
 ARG      CD     CG     NE     .
 ARG      HD3    CD     .      .
 ARG      HD2    CD     .      .
 ARG      NE     CD     CZ     .
 ARG      HE     NE     .      .
 ARG      CZ     NE     NH2    .
 ARG      NH1    CZ     HH12   .
 ARG      HH11   NH1    .      .
 ARG      HH12   NH1    .      .
 ARG      NH2    CZ     HH22   .
 ARG      HH21   NH2    .      .
 ARG      HH22   NH2    .      .
 ARG      C      CA     .      END
 ARG      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ARG      N      H         single       0.860    0.020
 ARG      N      CA        single       1.458    0.019
 ARG      CA     HA        single       0.980    0.020
 ARG      CA     CB        single       1.530    0.020
 ARG      CB     HB3       single       0.970    0.020
 ARG      CB     HB2       single       0.970    0.020
 ARG      CB     CG        single       1.520    0.020
 ARG      CG     HG3       single       0.970    0.020
 ARG      CG     HG2       single       0.970    0.020
 ARG      CG     CD        single       1.520    0.020
 ARG      CD     HD3       single       0.970    0.020
 ARG      CD     HD2       single       0.970    0.020
 ARG      CD     NE        single       1.460    0.018
 ARG      NE     HE        single       0.970    0.020
 ARG      NE     CZ        single       1.329    0.014
 ARG      CZ     NH1       deloc        1.326    0.018
 ARG      NH1    HH11      single       0.860    0.020
 ARG      NH1    HH12      single       0.860    0.020
 ARG      CZ     NH2       deloc        1.326    0.018
 ARG      NH2    HH21      single       0.860    0.020
 ARG      NH2    HH22      single       0.860    0.020
 ARG      CA     C         single       1.525    0.021
 ARG      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ARG      H      N      CA      114.000    3.000
 ARG      HA     CA     CB      109.000    3.000
 ARG      CB     CA     C       110.100    1.900
 ARG      HA     CA     C       109.000    3.000
 ARG      N      CA     HA      110.000    3.000
 ARG      N      CA     CB      110.500    1.700
 ARG      HB3    CB     HB2     110.000    3.000
 ARG      HB2    CB     CG      108.000    3.000
 ARG      HB3    CB     CG      108.000    3.000
 ARG      CA     CB     HB3     109.000    3.000
 ARG      CA     CB     HB2     109.000    3.000
 ARG      CA     CB     CG      114.100    2.000
 ARG      HG3    CG     HG2     110.000    3.000
 ARG      HG2    CG     CD      108.000    3.000
 ARG      HG3    CG     CD      108.000    3.000
 ARG      CB     CG     HG3     109.000    3.000
 ARG      CB     CG     HG2     109.000    3.000
 ARG      CB     CG     CD      111.300    2.300
 ARG      HD3    CD     HD2     110.000    3.000
 ARG      HD2    CD     NE      108.000    3.000
 ARG      HD3    CD     NE      108.000    3.000
 ARG      CG     CD     HD3     109.000    3.000
 ARG      CG     CD     HD2     109.000    3.000
 ARG      CG     CD     NE      112.000    2.200
 ARG      HE     NE     CZ      117.900    3.000
 ARG      CD     NE     HE      117.900    3.000
 ARG      CD     NE     CZ      124.200    1.500
 ARG      NH1    CZ     NH2     119.700    1.800
 ARG      NE     CZ     NH1     120.000    1.900
 ARG      HH11   NH1    HH12    120.000    3.000
 ARG      CZ     NH1    HH11    120.000    3.000
 ARG      CZ     NH1    HH12    120.000    3.000
 ARG      NE     CZ     NH2     120.000    1.900
 ARG      HH21   NH2    HH22    120.000    3.000
 ARG      CZ     NH2    HH21    120.000    3.000
 ARG      CZ     NH2    HH22    120.000    3.000
 ARG      N      CA     C       111.200    2.800
 ARG      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ARG      chi1     N      CA     CB     CG        60.000   15.000   3
 ARG      chi2     CA     CB     CG     CD        60.000   15.000   3
 ARG      chi3     CB     CG     CD     NE       180.000   15.000   3
 ARG      chi4     CG     CD     NE     CZ         0.000   15.000   4
 ARG      chi5     CD     NE     CZ     NH2        0.000   10.000   2
 ARG      hh1      NE     CZ     NH1    HH12       0.000   20.000   2
 ARG      hh2      NE     CZ     NH2    HH22       0.000   20.000   2
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 ARG      chir_01  CA     N      CB     C         negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ARG      plan      CD        0.020
 ARG      plan      NE        0.020
 ARG      plan      CZ        0.020
 ARG      plan      NH1       0.020
 ARG      plan      NH2       0.020
 ARG      plan      HH11      0.020
 ARG      plan      HH12      0.020
 ARG      plan      HH21      0.020
 ARG      plan      HH22      0.020
`.trim();

monomers["LYS"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
LYS      LYS 'LYSINE                              ' L-peptide          22   9 .
#
data_comp_LYS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 LYS           N      N    NH1      -0.204
 LYS           H      H    HNH1      0.204
 LYS           CA     C    CH1       0.058
 LYS           HA     H    HCH1      0.046
 LYS           CB     C    CH2      -0.076
 LYS           HB3    H    HCH2      0.038
 LYS           HB2    H    HCH2      0.038
 LYS           CG     C    CH2      -0.076
 LYS           HG3    H    HCH2      0.038
 LYS           HG2    H    HCH2      0.038
 LYS           CD     C    CH2      -0.076
 LYS           HD3    H    HCH2      0.038
 LYS           HD2    H    HCH2      0.038
 LYS           CE     C    CH2      -0.013
 LYS           HE3    H    HCH2      0.098
 LYS           HE2    H    HCH2      0.098
 LYS           NZ     N    NT3      -0.506
 LYS           HZ1    H    HNT3      0.441
 LYS           HZ2    H    HNT3      0.441
 LYS           HZ3    H    HNT3      0.441
 LYS           C      C    C         0.318
 LYS           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 LYS      N      n/a    CA     START
 LYS      H      N      .      .
 LYS      CA     N      C      .
 LYS      HA     CA     .      .
 LYS      CB     CA     CG     .
 LYS      HB3    CB     .      .
 LYS      HB2    CB     .      .
 LYS      CG     CB     CD     .
 LYS      HG3    CG     .      .
 LYS      HG2    CG     .      .
 LYS      CD     CG     CE     .
 LYS      HD3    CD     .      .
 LYS      HD2    CD     .      .
 LYS      CE     CD     NZ     .
 LYS      HE3    CE     .      .
 LYS      HE2    CE     .      .
 LYS      NZ     CE     HZ3    .
 LYS      HZ1    NZ     .      .
 LYS      HZ2    NZ     .      .
 LYS      HZ3    NZ     .      .
 LYS      C      CA     .      END
 LYS      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 LYS      N      H         single       0.860    0.020
 LYS      N      CA        single       1.458    0.019
 LYS      CA     HA        single       0.980    0.020
 LYS      CA     CB        single       1.530    0.020
 LYS      CB     HB3       single       0.970    0.020
 LYS      CB     HB2       single       0.970    0.020
 LYS      CB     CG        single       1.520    0.020
 LYS      CG     HG3       single       0.970    0.020
 LYS      CG     HG2       single       0.970    0.020
 LYS      CG     CD        single       1.520    0.020
 LYS      CD     HD3       single       0.970    0.020
 LYS      CD     HD2       single       0.970    0.020
 LYS      CD     CE        single       1.520    0.020
 LYS      CE     HE3       single       0.970    0.020
 LYS      CE     HE2       single       0.970    0.020
 LYS      CE     NZ        single       1.489    0.020
 LYS      NZ     HZ1       single       0.960    0.020
 LYS      NZ     HZ2       single       0.960    0.020
 LYS      NZ     HZ3       single       0.960    0.020
 LYS      CA     C         single       1.525    0.021
 LYS      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 LYS      H      N      CA      114.000    3.000
 LYS      HA     CA     CB      109.000    3.000
 LYS      CB     CA     C       110.100    1.900
 LYS      HA     CA     C       109.000    3.000
 LYS      N      CA     HA      110.000    3.000
 LYS      N      CA     CB      110.500    1.700
 LYS      HB3    CB     HB2     110.000    3.000
 LYS      HB2    CB     CG      108.000    3.000
 LYS      HB3    CB     CG      108.000    3.000
 LYS      CA     CB     HB3     109.000    3.000
 LYS      CA     CB     HB2     109.000    3.000
 LYS      CA     CB     CG      114.100    2.000
 LYS      HG3    CG     HG2     110.000    3.000
 LYS      HG2    CG     CD      108.000    3.000
 LYS      HG3    CG     CD      108.000    3.000
 LYS      CB     CG     HG3     109.000    3.000
 LYS      CB     CG     HG2     109.000    3.000
 LYS      CB     CG     CD      111.300    2.300
 LYS      HD3    CD     HD2     110.000    3.000
 LYS      HD2    CD     CE      108.000    3.000
 LYS      HD3    CD     CE      108.000    3.000
 LYS      CG     CD     HD3     109.000    3.000
 LYS      CG     CD     HD2     109.000    3.000
 LYS      CG     CD     CE      111.300    2.300
 LYS      HE3    CE     HE2     110.000    3.000
 LYS      HE2    CE     NZ      108.000    3.000
 LYS      HE3    CE     NZ      108.000    3.000
 LYS      CD     CE     HE3     109.000    3.000
 LYS      CD     CE     HE2     109.000    3.000
 LYS      CD     CE     NZ      111.900    3.200
 LYS      HZ1    NZ     HZ2     109.000    3.000
 LYS      HZ2    NZ     HZ3     109.000    3.000
 LYS      HZ1    NZ     HZ3     109.000    3.000
 LYS      CE     NZ     HZ1     110.000    3.000
 LYS      CE     NZ     HZ2     110.000    3.000
 LYS      CE     NZ     HZ3     110.000    3.000
 LYS      N      CA     C       111.200    2.800
 LYS      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 LYS      chi1     N      CA     CB     CG       180.000   15.000   3
 LYS      chi2     CA     CB     CG     CD       180.000   15.000   3
 LYS      chi3     CB     CG     CD     CE       180.000   15.000   3
 LYS      chi4     CG     CD     CE     NZ       180.000   15.000   3
 LYS      hh       CD     CE     NZ     HZ3       60.000   30.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 LYS      chir_01  CA     N      CB     C         negativ
`.trim();

monomers["MET"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MET      MET 'METHIONINE                          ' L-peptide          17   8 .
#
data_comp_MET
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 MET           N      N    NH1      -0.204
 MET           H      H    HNH1      0.204
 MET           CA     C    CH1       0.058
 MET           HA     H    HCH1      0.046
 MET           CB     C    CH2      -0.076
 MET           HB3    H    HCH2      0.038
 MET           HB2    H    HCH2      0.038
 MET           CG     C    CH2      -0.024
 MET           HG3    H    HCH2      0.041
 MET           HG2    H    HCH2      0.041
 MET           SD     S    S        -0.058
 MET           CE     C    CH3      -0.150
 MET           HE1    H    HCH3      0.050
 MET           HE2    H    HCH3      0.050
 MET           HE3    H    HCH3      0.050
 MET           C      C    C         0.318
 MET           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MET      N      n/a    CA     START
 MET      H      N      .      .
 MET      CA     N      C      .
 MET      HA     CA     .      .
 MET      CB     CA     CG     .
 MET      HB3    CB     .      .
 MET      HB2    CB     .      .
 MET      CG     CB     SD     .
 MET      HG3    CG     .      .
 MET      HG2    CG     .      .
 MET      SD     CG     CE     .
 MET      CE     SD     HE3    .
 MET      HE1    CE     .      .
 MET      HE2    CE     .      .
 MET      HE3    CE     .      .
 MET      C      CA     .      END
 MET      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MET      N      H         single       0.860    0.020
 MET      N      CA        single       1.458    0.019
 MET      CA     HA        single       0.980    0.020
 MET      CA     CB        single       1.530    0.020
 MET      CB     HB3       single       0.970    0.020
 MET      CB     HB2       single       0.970    0.020
 MET      CB     CG        single       1.520    0.020
 MET      CG     HG3       single       0.970    0.020
 MET      CG     HG2       single       0.970    0.020
 MET      CG     SD        single       1.803    0.020
 MET      SD     CE        single       1.791    0.020
 MET      CE     HE1       single       0.960    0.020
 MET      CE     HE2       single       0.960    0.020
 MET      CE     HE3       single       0.960    0.020
 MET      CA     C         single       1.525    0.020
 MET      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MET      H      N      CA      114.000    3.000
 MET      HA     CA     CB      109.000    3.000
 MET      CB     CA     C       110.100    1.900
 MET      HA     CA     C       110.000    3.000
 MET      N      CA     HA      110.000    3.000
 MET      N      CA     CB      110.500    1.700
 MET      HB3    CB     HB2     110.000    3.000
 MET      HB2    CB     CG      108.000    3.000
 MET      HB3    CB     CG      108.000    3.000
 MET      CA     CB     HB3     109.000    3.000
 MET      CA     CB     HB2     109.000    3.000
 MET      CA     CB     CG      114.100    2.000
 MET      HG3    CG     HG2     110.000    3.000
 MET      HG2    CG     SD      108.000    3.000
 MET      HG3    CG     SD      108.000    3.000
 MET      CB     CG     HG3     109.000    3.000
 MET      CB     CG     HG2     109.000    3.000
 MET      CB     CG     SD      112.700    3.000
 MET      CG     SD     CE      100.900    2.200
 MET      HE1    CE     HE2     110.000    3.000
 MET      HE2    CE     HE3     110.000    3.000
 MET      HE1    CE     HE3     110.000    3.000
 MET      SD     CE     HE1     109.000    3.000
 MET      SD     CE     HE2     109.000    3.000
 MET      SD     CE     HE3     109.000    3.000
 MET      N      CA     C       111.200    2.800
 MET      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MET      chi1     N      CA     CB     CG       180.000   15.000   3
 MET      chi2     CA     CB     CG     SD       180.000   15.000   3
 MET      chi3     CB     CG     SD     CE       180.000   15.000   3
 MET      hh       CG     SD     CE     HE3       60.000   30.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MET      chir_01  CA     N      CB     C         negativ
`.trim();

monomers["MSE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MSE      MSE 'SELENOMETHIONINE                    ' peptide            19   9 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MSE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MSE           N      N    NH2       0.000      0.000    0.000    0.000
 MSE           HN1    H    H         0.000      0.737    0.502   -0.482
 MSE           HN2    H    H         0.000      0.058   -0.125    1.004
 MSE           CA     C    CH1       0.000     -1.141   -0.541   -0.749
 MSE           HA     H    H         0.000     -1.130   -1.638   -0.692
 MSE           CB     C    CH2       0.000     -2.443   -0.013   -0.145
 MSE           HB2    H    H         0.000     -3.291   -0.416   -0.703
 MSE           HB3    H    H         0.000     -2.455    1.077   -0.204
 MSE           CG     C    CH2       0.000     -2.541   -0.447    1.318
 MSE           HG2    H    H         0.000     -1.691   -0.045    1.874
 MSE           HG3    H    H         0.000     -2.528   -1.538    1.375
 MSE           SE     SE   SE        0.000     -4.209    0.229    2.092
 MSE           CE     C    CH3       0.000     -3.898   -0.538    3.868
 MSE           HE3    H    H         0.000     -3.815   -1.590    3.787
 MSE           HE2    H    H         0.000     -3.004   -0.142    4.271
 MSE           HE1    H    H         0.000     -4.710   -0.295    4.502
 MSE           C      C    C         0.000     -1.045   -0.113   -2.190
 MSE           O      O    OC       -0.500     -0.498    0.972   -2.486
 MSE           OXT    O    OC       -0.500     -1.515   -0.843   -3.091
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MSE      N      n/a    CA     START
 MSE      HN1    N      .      .
 MSE      HN2    N      .      .
 MSE      CA     N      C      .
 MSE      HA     CA     .      .
 MSE      CB     CA     CG     .
 MSE      HB2    CB     .      .
 MSE      HB3    CB     .      .
 MSE      CG     CB     SE     .
 MSE      HG2    CG     .      .
 MSE      HG3    CG     .      .
 MSE      SE     CG     CE     .
 MSE      CE     SE     HE1    .
 MSE      HE3    CE     .      .
 MSE      HE2    CE     .      .
 MSE      HE1    CE     .      .
 MSE      C      CA     .      END
 MSE      O      C      .      .
 MSE      OXT    C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MSE      CA     N         single      1.450    0.020
 MSE      C      CA        single      1.500    0.020
 MSE      CB     CA        single      1.524    0.020
 MSE      HA     CA        single      1.099    0.020
 MSE      O      C         deloc       1.250    0.020
 MSE      OXT    C         deloc       1.250    0.020
 MSE      CG     CB        single      1.524    0.020
 MSE      HB2    CB        single      1.092    0.020
 MSE      HB3    CB        single      1.092    0.020
 MSE      SE     CG        single      1.970    0.020
 MSE      HG2    CG        single      1.092    0.020
 MSE      HG3    CG        single      1.092    0.020
 MSE      CE     SE        single      1.970    0.020
 MSE      HE1    CE        single      1.059    0.020
 MSE      HE2    CE        single      1.059    0.020
 MSE      HE3    CE        single      1.059    0.020
 MSE      HN1    N         single      1.010    0.020
 MSE      HN2    N         single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MSE      HN1    N      HN2     120.000    3.000
 MSE      HN1    N      CA      120.000    3.000
 MSE      HN2    N      CA      120.000    3.000
 MSE      N      CA     HA      109.470    3.000
 MSE      N      CA     CB      109.470    3.000
 MSE      N      CA     C       109.470    3.000
 MSE      HA     CA     CB      108.340    3.000
 MSE      HA     CA     C       108.810    3.000
 MSE      CB     CA     C       109.470    3.000
 MSE      CA     CB     HB2     109.470    3.000
 MSE      CA     CB     HB3     109.470    3.000
 MSE      CA     CB     CG      111.000    3.000
 MSE      HB2    CB     HB3     107.900    3.000
 MSE      HB2    CB     CG      109.470    3.000
 MSE      HB3    CB     CG      109.470    3.000
 MSE      CB     CG     HG2     109.470    3.000
 MSE      CB     CG     HG3     109.470    3.000
 MSE      CB     CG     SE      109.500    3.000
 MSE      HG2    CG     HG3     107.900    3.000
 MSE      HG2    CG     SE      109.500    3.000
 MSE      HG3    CG     SE      109.500    3.000
 MSE      CG     SE     CE       98.000    3.000
 MSE      SE     CE     HE3     109.500    3.000
 MSE      SE     CE     HE2     109.500    3.000
 MSE      SE     CE     HE1     109.500    3.000
 MSE      HE3    CE     HE2     109.470    3.000
 MSE      HE3    CE     HE1     109.470    3.000
 MSE      HE2    CE     HE1     109.470    3.000
 MSE      CA     C      O       118.500    3.000
 MSE      CA     C      OXT     118.500    3.000
 MSE      O      C      OXT     123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MSE      var_1    HN2    N      CA     C        175.000   20.000   1
 MSE      var_2    N      CA     CB     CG       -59.919   20.000   3
 MSE      var_3    CA     CB     CG     SE       179.993   20.000   3
 MSE      var_4    CB     CG     SE     CE      -179.999   20.000   1
 MSE      var_5    CG     SE     CE     HE1     -179.984   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MSE      chir_01  CA     N      C      CB        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 MSE      plan-1    N         0.020
 MSE      plan-1    CA        0.020
 MSE      plan-1    HN1       0.020
 MSE      plan-1    HN2       0.020
 MSE      plan-2    C         0.020
 MSE      plan-2    CA        0.020
 MSE      plan-2    O         0.020
 MSE      plan-2    OXT       0.020
# ------------------------------------------------------
`.trim();

monomers["HIS"] = `
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
HIS      HIS 'HISTIDINE                           ' L-peptide          18  10 .
#
data_comp_HIS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 HIS           N      N    NH1      -0.204
 HIS           H      H    HNH1      0.204
 HIS           CA     C    CH1       0.058
 HIS           HA     H    HCH1      0.046
 HIS           CB     C    CH2      -0.050
 HIS           HB3    H    HCH2      0.041
 HIS           HB2    H    HCH2      0.041
 HIS           CG     C    CR5       0.048
 HIS           ND1    N    NR15      0.013
 HIS           HD1    H    HNR5      0.192
 HIS           CE1    C    CR15      0.191
 HIS           HE1    H    HCR5      0.068
 HIS           NE2    N    NR15     -0.585
 HIS           HE2    H    HNR5      1.000
 HIS           CD2    C    CR15     -0.021
 HIS           HD2    H    HCR5      0.062
 HIS           C      C    C         0.318
 HIS           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 HIS      N      n/a    CA     START
 HIS      H      N      .      .
 HIS      CA     N      C      .
 HIS      HA     CA     .      .
 HIS      CB     CA     CG     .
 HIS      HB3    CB     .      .
 HIS      HB2    CB     .      .
 HIS      CG     CB     ND1    .
 HIS      ND1    CG     CE1    .
 HIS      HD1    ND1    .      .
 HIS      CE1    ND1    NE2    .
 HIS      HE1    CE1    .      .
 HIS      NE2    CE1    CD2    .
 HIS      HE2    NE2    .      .
 HIS      CD2    NE2    HD2    .
 HIS      HD2    CD2    .      .
 HIS      C      CA     .      END
 HIS      O      C      .      .
 HIS      CD2    CG     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 HIS      N      H         single       0.860    0.020
 HIS      N      CA        single       1.458    0.019
 HIS      CA     HA        single       0.980    0.020
 HIS      CA     CB        single       1.530    0.020
 HIS      CB     HB2       single       0.970    0.020
 HIS      CB     HB3       single       0.970    0.020
 HIS      CB     CG        single       1.497    0.014
 HIS      CG     CD2       double       1.354    0.011
 HIS      CG     ND1       single       1.378    0.011
 HIS      ND1    HD1       single       0.860    0.020
 HIS      ND1    CE1       double       1.321    0.010
 HIS      CE1    HE1       single       0.930    0.020
 HIS      CE1    NE2       single       1.321    0.010
 HIS      NE2    HE2       single       0.860    0.020
 HIS      NE2    CD2       single       1.374    0.011
 HIS      CD2    HD2       single       0.930    0.020
 HIS      CA     C         single       1.525    0.021
 HIS      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 HIS      H      N      CA      114.000    3.000
 HIS      HA     CA     CB      109.000    3.000
 HIS      CB     CA     C       110.100    1.900
 HIS      HA     CA     C       109.000    3.000
 HIS      N      CA     HA      110.000    3.000
 HIS      N      CA     CB      110.500    1.700
 HIS      HB3    CB     HB2     110.000    3.000
 HIS      HB2    CB     CG      108.000    3.000
 HIS      HB3    CB     CG      108.000    3.000
 HIS      CA     CB     HB3     109.000    3.000
 HIS      CA     CB     HB2     109.000    3.000
 HIS      CA     CB     CG      113.800    1.000
 HIS      CB     CG     CD2     131.200    1.300
 HIS      ND1    CG     CD2     106.100    1.000
 HIS      CB     CG     ND1     122.700    1.500
 HIS      HD1    ND1    CE1     125.350    3.000
 HIS      CG     ND1    HD1     125.350    3.000
 HIS      CG     ND1    CE1     109.300    1.700
 HIS      HE1    CE1    NE2     125.800    3.000
 HIS      ND1    CE1    HE1     125.800    3.000
 HIS      ND1    CE1    NE2     108.400    1.000
 HIS      HE2    NE2    CD2     125.500    3.000
 HIS      CE1    NE2    HE2     125.500    3.000
 HIS      CE1    NE2    CD2     109.000    1.000
 HIS      NE2    CD2    HD2     126.400    3.000
 HIS      CG     CD2    HD2     126.400    3.000
 HIS      CG     CD2    NE2     107.200    1.000
 HIS      N      CA     C       111.200    2.800
 HIS      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 HIS      chi1     N      CA     CB     CG       180.000   15.000   3
 HIS      chi2     CA     CB     CG     ND1       90.000   20.000   2
 HIS      CONST_01 CB     CG     ND1    CE1      180.000    0.000   0
 HIS      CONST_02 CG     ND1    CE1    NE2        0.000    0.000   0
 HIS      CONST_03 ND1    CE1    NE2    CD2        0.000    0.000   0
 HIS      CONST_04 CE1    NE2    CD2    CG         0.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 HIS      chir_01  CA     N      CB     C         negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 HIS      plan      CB        0.020
 HIS      plan      CG        0.020
 HIS      plan      ND1       0.020
 HIS      plan      CE1       0.020
 HIS      plan      CD2       0.020
 HIS      plan      NE2       0.020
 HIS      plan      HD1       0.020
 HIS      plan      HD2       0.020
 HIS      plan      HE1       0.020
 HIS      plan      HE2       0.020
`.trim();

monomers["PHE"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PHE      PHE 'PHENYLALANINE                       ' L-peptide          20  11 .
#
data_comp_PHE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 PHE           N      N    NH1      -0.204
 PHE           H      H    HNH1      0.204
 PHE           CA     C    CH1       0.058
 PHE           HA     H    HCH1      0.046
 PHE           CB     C    CH2      -0.134
 PHE           HB3    H    HCH2      0.067
 PHE           HB2    H    HCH2      0.067
 PHE           CG     C    CR6      -0.037
 PHE           CD1    C    CR16     -0.090
 PHE           HD1    H    HCR6      0.053
 PHE           CE1    C    CR16     -0.053
 PHE           HE1    H    HCR6      0.053
 PHE           CZ     C    CR16     -0.053
 PHE           HZ     H    HCR6      0.053
 PHE           CE2    C    CR16     -0.053
 PHE           HE2    H    HCR6      0.053
 PHE           CD2    C    CR16     -0.053
 PHE           HD2    H    HCR6      0.053
 PHE           C      C    C         0.318
 PHE           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PHE      N      n/a    CA     START
 PHE      H      N      .      .
 PHE      CA     N      C      .
 PHE      HA     CA     .      .
 PHE      CB     CA     CG     .
 PHE      HB3    CB     .      .
 PHE      HB2    CB     .      .
 PHE      CG     CB     CD1    .
 PHE      CD1    CG     CE1    .
 PHE      HD1    CD1    .      .
 PHE      CE1    CD1    CZ     .
 PHE      HE1    CE1    .      .
 PHE      CZ     CE1    CE2    .
 PHE      HZ     CZ     .      .
 PHE      CE2    CZ     CD2    .
 PHE      HE2    CE2    .      .
 PHE      CD2    CE2    HD2    .
 PHE      HD2    CD2    .      .
 PHE      C      CA     .      END
 PHE      O      C      .      .
 PHE      CD2    CG     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PHE      N      H         single       0.860    0.020
 PHE      N      CA        single       1.458    0.019
 PHE      CA     HA        single       0.980    0.020
 PHE      CA     CB        single       1.530    0.020
 PHE      CB     HB3       single       0.970    0.020
 PHE      CB     HB2       single       0.970    0.020
 PHE      CB     CG        single       1.502    0.020
 PHE      CG     CD2       aromat       1.384    0.021
 PHE      CG     CD1       aromat       1.384    0.021
 PHE      CD1    HD1       single       0.930    0.020
 PHE      CD1    CE1       aromat       1.382    0.020
 PHE      CE1    HE1       single       0.930    0.020
 PHE      CE1    CZ        aromat       1.382    0.020
 PHE      CZ     HZ        single       0.930    0.020
 PHE      CZ     CE2       aromat       1.382    0.020
 PHE      CE2    HE2       single       0.930    0.020
 PHE      CE2    CD2       aromat       1.382    0.020
 PHE      CD2    HD2       single       0.930    0.020
 PHE      CA     C         single       1.525    0.020
 PHE      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PHE      H      N      CA      114.000    3.000
 PHE      HA     CA     CB      109.000    3.000
 PHE      CB     CA     C       110.100    1.900
 PHE      HA     CA     C       109.000    3.000
 PHE      N      CA     HA      110.000    3.000
 PHE      N      CA     CB      110.500    1.700
 PHE      HB3    CB     HB2     110.000    3.000
 PHE      HB2    CB     CG      108.000    3.000
 PHE      HB3    CB     CG      108.000    3.000
 PHE      CA     CB     HB3     109.000    3.000
 PHE      CA     CB     HB2     109.000    3.000
 PHE      CA     CB     CG      113.800    1.000
 PHE      CB     CG     CD2     120.700    1.700
 PHE      CD1    CG     CD2     118.600    1.500
 PHE      CB     CG     CD1     120.700    1.700
 PHE      HD1    CD1    CE1     119.650    3.000
 PHE      CG     CD1    HD1     119.650    3.000
 PHE      CG     CD1    CE1     120.700    1.700
 PHE      CG     CD2    HD2     119.650    3.000
 PHE      CE2    CD2    HD2     119.650    3.000
 PHE      CG     CD2    CE2     120.700    1.700
 PHE      HE1    CE1    CZ      120.000    3.000
 PHE      CD1    CE1    HE1     120.000    3.000
 PHE      CD1    CE1    CZ      120.000    1.800
 PHE      HZ     CZ     CE2     120.000    3.000
 PHE      CE1    CZ     HZ      120.000    3.000
 PHE      CE1    CZ     CE2     120.000    1.800
 PHE      HE2    CE2    CD2     120.000    3.000
 PHE      CZ     CE2    HE2     120.000    3.000
 PHE      CZ     CE2    CD2     120.000    1.800
 PHE      N      CA     C       111.200    2.800
 PHE      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PHE      chi1     N      CA     CB     CG       180.000   15.000   3
 PHE      chi2     CA     CB     CG     CD1       90.000   20.000   2
 PHE      CONST_01 CB     CG     CD1    CE1      180.000    0.000   0
 PHE      CONST_02 CG     CD1    CE1    CZ         0.000    0.000   0
 PHE      CONST_03 CD1    CE1    CZ     CE2        0.000    0.000   0
 PHE      CONST_04 CE1    CZ     CE2    CD2        0.000    0.000   0
 PHE      CONST_05 CZ     CE2    CD2    CG         0.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 PHE      chir_01  CA     N      CB     C         negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 PHE      plan      CB        0.020
 PHE      plan      CG        0.020
 PHE      plan      CD1       0.020
 PHE      plan      CE1       0.020
 PHE      plan      CZ        0.020
 PHE      plan      CE2       0.020
 PHE      plan      CD2       0.020
 PHE      plan      HD1       0.020
 PHE      plan      HE1       0.020
 PHE      plan      HZ        0.020
 PHE      plan      HE2       0.020
 PHE      plan      HD2       0.020
`.trim();

monomers["TYR"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TYR      TYR 'TYROSINE                            ' L-peptide          21  12 .
#
data_comp_TYR
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 TYR           N      N    NH1      -0.204
 TYR           H      H    HNH1      0.204
 TYR           CA     C    CH1       0.058
 TYR           HA     H    HCH1      0.046
 TYR           CB     C    CH2      -0.054
 TYR           HB3    H    HCH2      0.049
 TYR           HB2    H    HCH2      0.049
 TYR           CG     C    CR6      -0.044
 TYR           CD1    C    CR16     -0.053
 TYR           HD1    H    HCR6      0.053
 TYR           CE1    C    CR16     -0.099
 TYR           HE1    H    HCR6      0.054
 TYR           CZ     C    CR6       0.176
 TYR           OH     O    OH1      -0.391
 TYR           HH     H    HOH1      0.305
 TYR           CE2    C    CR16     -0.099
 TYR           HE2    H    HCR6      0.054
 TYR           CD2    C    CR16     -0.053
 TYR           HD2    H    HCR6      0.053
 TYR           C      C    C         0.318
 TYR           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TYR      N      n/a    CA     START
 TYR      H      N      .      .
 TYR      CA     N      C      .
 TYR      HA     CA     .      .
 TYR      CB     CA     CG     .
 TYR      HB3    CB     .      .
 TYR      HB2    CB     .      .
 TYR      CG     CB     CD1    .
 TYR      CD1    CG     CE1    .
 TYR      HD1    CD1    .      .
 TYR      CE1    CD1    CZ     .
 TYR      HE1    CE1    .      .
 TYR      CZ     CE1    CE2    .
 TYR      OH     CZ     HH     .
 TYR      HH     OH     .      .
 TYR      CE2    CZ     CD2    .
 TYR      HE2    CE2    .      .
 TYR      CD2    CE2    HD2    .
 TYR      HD2    CD2    .      .
 TYR      C      CA     .      END
 TYR      O      C      .      .
 TYR      CD2    CG     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TYR      N      H         single       0.860    0.020
 TYR      N      CA        single       1.458    0.019
 TYR      CA     HA        single       0.980    0.020
 TYR      CA     CB        single       1.530    0.020
 TYR      CB     HB3       single       0.970    0.020
 TYR      CB     HB2       single       0.970    0.020
 TYR      CB     CG        single       1.512    0.022
 TYR      CG     CD2       aromat       1.389    0.021
 TYR      CG     CD1       aromat       1.389    0.021
 TYR      CD1    HD1       single       0.930    0.020
 TYR      CD1    CE1       aromat       1.382    0.020
 TYR      CE1    HE1       single       0.930    0.020
 TYR      CE1    CZ        aromat       1.378    0.024
 TYR      CZ     OH        single       1.376    0.021
 TYR      OH     HH        single       0.820    0.020
 TYR      CZ     CE2       aromat       1.378    0.020
 TYR      CE2    HE2       single       0.930    0.020
 TYR      CE2    CD2       aromat       1.382    0.020
 TYR      CD2    HD2       single       0.930    0.020
 TYR      CA     C         single       1.525    0.021
 TYR      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TYR      H      N      CA      114.000    3.000
 TYR      HA     CA     CB      109.000    3.000
 TYR      CB     CA     C       110.100    1.900
 TYR      HA     CA     C       109.000    3.000
 TYR      N      CA     HA      110.000    3.000
 TYR      N      CA     CB      110.500    1.700
 TYR      HB3    CB     HB2     110.000    3.000
 TYR      HB2    CB     CG      108.000    3.000
 TYR      HB3    CB     CG      108.000    3.000
 TYR      CA     CB     HB3     109.000    3.000
 TYR      CA     CB     HB2     109.000    3.000
 TYR      CA     CB     CG      113.900    1.800
 TYR      CB     CG     CD2     120.800    1.500
 TYR      CD1    CG     CD2     118.100    1.500
 TYR      CB     CG     CD1     120.800    1.500
 TYR      HD1    CD1    CE1     119.400    3.000
 TYR      CG     CD1    HD1     119.400    3.000
 TYR      CG     CD1    CE1     121.200    1.500
 TYR      HD2    CD2    CE2     119.400    3.000
 TYR      CG     CD2    HD2     119.400    3.000
 TYR      CG     CD2    CE2     121.200    1.500
 TYR      HE1    CE1    CZ      120.200    3.000
 TYR      CD1    CE1    HE1     120.200    3.000
 TYR      CD1    CE1    CZ      119.600    1.800
 TYR      OH     CZ     CE2     119.900    3.000
 TYR      CE1    CZ     OH      119.900    3.000
 TYR      CZ     OH     HH      110.000    3.000
 TYR      CE1    CZ     CE2     120.300    2.000
 TYR      HE2    CE2    CD2     120.200    3.000
 TYR      CZ     CE2    HE2     120.200    3.000
 TYR      CZ     CE2    CD2     119.600    1.800
 TYR      N      CA     C       111.200    2.800
 TYR      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TYR      chi1     N      CA     CB     CG       180.000   15.000   3
 TYR      chi2     CA     CB     CG     CD1       90.000   20.000   2
 TYR      CONST_01 CB     CG     CD1    CE1      180.000    0.000   0
 TYR      CONST_02 CG     CD1    CE1    CZ         0.000    0.000   0
 TYR      CONST_03 CD1    CE1    CZ     CE2        0.000    0.000   0
 TYR      hh1      CE1    CZ     OH     HH        60.000   30.000   2
 TYR      CONST_04 CE1    CZ     CE2    CD2        0.000    0.000   0
 TYR      CONST_05 CZ     CE2    CD2    CG         0.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TYR      chir_01  CA     N      CB     C         negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TYR      plan      CB        0.020
 TYR      plan      CG        0.020
 TYR      plan      CD1       0.020
 TYR      plan      CE1       0.020
 TYR      plan      CZ        0.020
 TYR      plan      CE2       0.020
 TYR      plan      CD2       0.020
 TYR      plan      OH        0.020
 TYR      plan      HD1       0.020
 TYR      plan      HE1       0.020
 TYR      plan      HE2       0.020
 TYR      plan      HD2       0.020
`.trim();

monomers["TRP"] = `
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TRP      TRP 'TRYPTOPHAN                          ' L-peptide          24  14 .
#
data_comp_TRP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
 TRP           N      N    NH1      -0.204
 TRP           H      H    HNH1      0.204
 TRP           CA     C    CH1       0.058
 TRP           HA     H    HCH1      0.046
 TRP           CB     C    CH2      -0.068
 TRP           HB3    H    HCH2      0.034
 TRP           HB2    H    HCH2      0.034
 TRP           CG     C    CR5      -0.214
 TRP           CD1    C    CR15      0.059
 TRP           HD1    H    HCR5      0.056
 TRP           NE1    N    NR15     -0.080
 TRP           HE1    H    HNR5      0.179
 TRP           CE2    C    CR56      0.109
 TRP           CD2    C    CR56     -0.038
 TRP           CE3    C    CR16     -0.081
 TRP           HE3    H    HCR6      0.058
 TRP           CZ3    C    CR16     -0.094
 TRP           HZ3    H    HCR6      0.052
 TRP           CH2    C    CR16     -0.053
 TRP           HH2    H    HCR6      0.053
 TRP           CZ2    C    CR16     -0.053
 TRP           HZ2    H    HCR6      0.053
 TRP           C      C    C         0.318
 TRP           O      O    O        -0.422
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TRP      N      n/a    CA     START
 TRP      H      N      .      .
 TRP      CA     N      C      .
 TRP      HA     CA     .      .
 TRP      CB     CA     CG     .
 TRP      HB3    CB     .      .
 TRP      HB2    CB     .      .
 TRP      CG     CB     CD1    .
 TRP      CD1    CG     NE1    .
 TRP      HD1    CD1    .      .
 TRP      NE1    CD1    CE2    .
 TRP      HE1    NE1    .      .
 TRP      CE2    NE1    CD2    .
 TRP      CD2    CE2    CE3    .
 TRP      CE3    CD2    CZ3    .
 TRP      HE3    CE3    .      .
 TRP      CZ3    CE3    CH2    .
 TRP      HZ3    CZ3    .      .
 TRP      CH2    CZ3    CZ2    .
 TRP      HH2    CH2    .      .
 TRP      CZ2    CH2    HZ2    .
 TRP      HZ2    CZ2    .      .
 TRP      C      CA     .      END
 TRP      O      C      .      .
 TRP      CD2    CG     .    ADD
 TRP      CZ2    CE2    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TRP      N      H         single       0.860    0.020
 TRP      N      CA        single       1.458    0.019
 TRP      CA     HA        single       0.980    0.020
 TRP      CA     CB        single       1.530    0.020
 TRP      CB     HB2       single       0.970    0.020
 TRP      CB     HB3       single       0.970    0.020
 TRP      CB     CG        single       1.498    0.031
 TRP      CG     CD2       single       1.433    0.018
 TRP      CG     CD1       double       1.365    0.025
 TRP      CD1    HD1       single       0.930    0.020
 TRP      CD1    NE1       sinlge       1.374    0.021
 TRP      NE1    HE1       single       0.860    0.020
 TRP      NE1    CE2       single       1.370    0.011
 TRP      CE2    CZ2       single       1.394    0.021
 TRP      CE2    CD2       double       1.409    0.017
 TRP      CD2    CE3       single       1.398    0.016
 TRP      CE3    HE3       single       0.930    0.020
 TRP      CE3    CZ3       double       1.382    0.030
 TRP      CZ3    HZ3       single       0.930    0.020
 TRP      CZ3    CH2       single       1.400    0.025
 TRP      CH2    HH2       single       0.930    0.020
 TRP      CH2    CZ2       double       1.368    0.019
 TRP      CZ2    HZ2       single       0.930    0.020
 TRP      CA     C         single       1.525    0.021
 TRP      C      O         deloc        1.231    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TRP      H      N      CA      114.000    3.000
 TRP      HA     CA     CB      109.000    3.000
 TRP      CB     CA     C       110.100    1.900
 TRP      HA     CA     C       109.000    3.000
 TRP      N      CA     HA      110.000    3.000
 TRP      N      CA     CB      110.500    1.700
 TRP      HB3    CB     HB2     110.000    3.000
 TRP      HB2    CB     CG      108.000    3.000
 TRP      HB3    CB     CG      108.000    3.000
 TRP      CA     CB     HB3     109.000    3.000
 TRP      CA     CB     HB2     109.000    3.000
 TRP      CA     CB     CG      113.600    1.900
 TRP      CB     CG     CD2     126.800    1.400
 TRP      CD1    CG     CD2     106.300    1.600
 TRP      CB     CG     CD1     126.900    1.500
 TRP      HD1    CD1    NE1     124.900    3.000
 TRP      CG     CD1    HD1     124.900    3.000
 TRP      CG     CD1    NE1     110.200    1.300
 TRP      HE1    NE1    CE2     125.550    3.000
 TRP      CD1    NE1    HE1     125.550    3.000
 TRP      CD1    NE1    CE2     108.900    1.800
 TRP      NE1    CE2    CZ2     130.100    1.500
 TRP      CD2    CE2    CZ2     122.400    1.000
 TRP      NE1    CE2    CD2     107.400    1.300
 TRP      CE2    CD2    CE3     118.800    1.000
 TRP      CE2    CD2    CG      107.200    1.200
 TRP      CG     CD2    CE3     133.900    1.000
 TRP      HE3    CE3    CZ3     120.700    3.000
 TRP      CD2    CE3    HE3     120.700    3.000
 TRP      CD2    CE3    CZ3     118.600    1.300
 TRP      HZ3    CZ3    CH2     119.450    3.000
 TRP      CE3    CZ3    HZ3     119.450    3.000
 TRP      CE3    CZ3    CH2     121.100    1.300
 TRP      HH2    CH2    CZ2     119.250    3.000
 TRP      CZ3    CH2    HH2     119.250    3.000
 TRP      CZ3    CH2    CZ2     121.500    1.300
 TRP      CH2    CZ2    HZ2     121.250    3.000
 TRP      CE2    CZ2    HZ2     121.250    3.000
 TRP      CH2    CZ2    CE2     117.500    1.300
 TRP      N      CA     C       111.200    2.800
 TRP      CA     C      O       120.800    1.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TRP      chi1     N      CA     CB     CG       180.000   15.000   3
 TRP      chi2     CA     CB     CG     CD1       90.000   20.000   2
 TRP      CONST_01 CB     CG     CD1    NE1      180.000    0.000   0
 TRP      CONST_02 CG     CD1    NE1    CE2        0.000    0.000   0
 TRP      CONST_03 CD1    NE1    CE2    CD2        0.000    0.000   0
 TRP      CONST_04 NE1    CE2    CD2    CE3      180.000    0.000   0
 TRP      CONST_05 CE2    CD2    CE3    CZ3        0.000    0.000   0
 TRP      CONST_06 CD2    CE3    CZ3    CH2        0.000    0.000   0
 TRP      CONST_07 CE3    CZ3    CH2    CZ2        0.000    0.000   0
 TRP      CONST_08 CZ3    CH2    CZ2    CE2        0.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TRP      chir_01  CA     N      CB     C         negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TRP      plan      CB        0.020
 TRP      plan      CG        0.020
 TRP      plan      CD1       0.020
 TRP      plan      NE1       0.020
 TRP      plan      CD2       0.020
 TRP      plan      CE2       0.020
 TRP      plan      CZ2       0.020
 TRP      plan      CH2       0.020
 TRP      plan      CE3       0.020
 TRP      plan      CZ3       0.020
 TRP      plan      HD1       0.020
 TRP      plan      HE1       0.020
 TRP      plan      HH2       0.020
 TRP      plan      HE3       0.020
 TRP      plan      HZ3       0.020
 TRP      plan      HZ2       0.020
`.trim();

monomers["HCS"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
HCS      HCS '2-AMINO-4-MERCAPTO-BUTYRIC ACID     ' peptide            16   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_HCS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 HCS           N      N    NH2       0.000      0.000    0.000    0.000
 HCS           HN1    H    H         0.000      0.601   -0.499    0.645
 HCS           HN2    H    H         0.000      0.342    0.221   -0.928
 HCS           CA     C    CH1       0.000     -1.354    0.399    0.405
 HCS           HCA    H    H         0.000     -1.420    1.496    0.432
 HCS           CB     C    CH2       0.000     -2.369   -0.148   -0.598
 HCS           HB2    H    H         0.000     -3.375    0.148   -0.294
 HCS           HB3    H    H         0.000     -2.303   -1.238   -0.623
 HCS           CG     C    CH2       0.000     -2.067    0.415   -1.988
 HCS           HG2    H    H         0.000     -1.060    0.120   -2.288
 HCS           HG3    H    H         0.000     -2.132    1.505   -1.959
 HCS           SD     S    SH1       0.000     -3.271   -0.233   -3.179
 HCS           HD     H    H         0.000     -2.775    0.402   -4.238
 HCS           C      C    C         0.000     -1.651   -0.155    1.775
 HCS           OXT    O    OC       -0.500     -2.427    0.456    2.543
 HCS           O      O    OC       -0.500     -1.125   -1.228    2.144
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 HCS      N      n/a    CA     START
 HCS      HN1    N      .      .
 HCS      HN2    N      .      .
 HCS      CA     N      C      .
 HCS      HCA    CA     .      .
 HCS      CB     CA     CG     .
 HCS      HB2    CB     .      .
 HCS      HB3    CB     .      .
 HCS      CG     CB     SD     .
 HCS      HG2    CG     .      .
 HCS      HG3    CG     .      .
 HCS      SD     CG     HD     .
 HCS      HD     SD     .      .
 HCS      C      CA     .      END
 HCS      OXT    C      .      .
 HCS      O      C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 HCS      CA     N         single      1.450    0.020
 HCS      CB     CA        single      1.524    0.020
 HCS      C      CA        single      1.500    0.020
 HCS      HCA    CA        single      1.099    0.020
 HCS      CG     CB        single      1.524    0.020
 HCS      HB2    CB        single      1.092    0.020
 HCS      HB3    CB        single      1.092    0.020
 HCS      SD     CG        single      1.810    0.020
 HCS      HG2    CG        single      1.092    0.020
 HCS      HG3    CG        single      1.092    0.020
 HCS      HD     SD        single      1.330    0.020
 HCS      OXT    C         deloc       1.250    0.020
 HCS      O      C         deloc       1.250    0.020
 HCS      HN1    N         single      1.010    0.020
 HCS      HN2    N         single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 HCS      HN1    N      HN2     120.000    3.000
 HCS      HN1    N      CA      120.000    3.000
 HCS      HN2    N      CA      120.000    3.000
 HCS      N      CA     HCA     109.470    3.000
 HCS      N      CA     CB      109.470    3.000
 HCS      N      CA     C       109.470    3.000
 HCS      HCA    CA     CB      108.340    3.000
 HCS      HCA    CA     C       108.810    3.000
 HCS      CB     CA     C       109.470    3.000
 HCS      CA     CB     HB2     109.470    3.000
 HCS      CA     CB     HB3     109.470    3.000
 HCS      CA     CB     CG      111.000    3.000
 HCS      HB2    CB     HB3     107.900    3.000
 HCS      HB2    CB     CG      109.470    3.000
 HCS      HB3    CB     CG      109.470    3.000
 HCS      CB     CG     HG2     109.470    3.000
 HCS      CB     CG     HG3     109.470    3.000
 HCS      CB     CG     SD      109.470    3.000
 HCS      HG2    CG     HG3     107.900    3.000
 HCS      HG2    CG     SD      109.470    3.000
 HCS      HG3    CG     SD      109.470    3.000
 HCS      CG     SD     HD       96.000    3.000
 HCS      CA     C      OXT     118.500    3.000
 HCS      CA     C      O       118.500    3.000
 HCS      OXT    C      O       123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 HCS      var_1    HN2    N      CA     C        175.000   20.000   1
 HCS      var_2    N      CA     CB     CG       -60.058   20.000   3
 HCS      var_3    CA     CB     CG     SD      -179.996   20.000   3
 HCS      var_4    CB     CG     SD     HD      -179.983   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 HCS      chir_01  CA     N      CB     C         negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 HCS      plan-1    N         0.020
 HCS      plan-1    CA        0.020
 HCS      plan-1    HN1       0.020
 HCS      plan-1    HN2       0.020
 HCS      plan-2    C         0.020
 HCS      plan-2    CA        0.020
 HCS      plan-2    OXT       0.020
 HCS      plan-2    O         0.020
# ------------------------------------------------------
`.trim();

monomers["ALO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ALO      ALO 'ALLO-THREONINE                      ' peptide            16   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ALO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ALO           N      N    NH2       0.000      0.000    0.000    0.000
 ALO           HN1    H    H         0.000      0.462    0.330   -0.840
 ALO           HN2    H    H         0.000      0.540   -0.119    0.849
 ALO           CA     C    CH1       0.000     -1.438   -0.304   -0.014
 ALO           HA     H    H         0.000     -1.588   -1.378    0.161
 ALO           CB     C    CH1       0.000     -2.137    0.495    1.086
 ALO           HB     H    H         0.000     -1.987    1.569    0.911
 ALO           OG1    O    OH1       0.000     -3.536    0.200    1.072
 ALO           HG1    H    H         0.000     -3.667   -0.746    1.227
 ALO           CG2    C    CH3       0.000     -1.550    0.114    2.446
 ALO           HG23   H    H         0.000     -1.695   -0.921    2.617
 ALO           HG22   H    H         0.000     -0.514    0.332    2.459
 ALO           HG21   H    H         0.000     -2.036    0.667    3.209
 ALO           C      C    C         0.000     -2.017    0.073   -1.353
 ALO           O      O    OC       -0.500     -1.518    1.014   -2.009
 ALO           OXT    O    OC       -0.500     -2.997   -0.557   -1.810
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ALO      N      n/a    CA     START
 ALO      HN1    N      .      .
 ALO      HN2    N      .      .
 ALO      CA     N      C      .
 ALO      HA     CA     .      .
 ALO      CB     CA     CG2    .
 ALO      HB     CB     .      .
 ALO      OG1    CB     HG1    .
 ALO      HG1    OG1    .      .
 ALO      CG2    CB     HG21   .
 ALO      HG23   CG2    .      .
 ALO      HG22   CG2    .      .
 ALO      HG21   CG2    .      .
 ALO      C      CA     .      END
 ALO      O      C      .      .
 ALO      OXT    C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ALO      CA     N         single      1.450    0.020
 ALO      CB     CA        single      1.524    0.020
 ALO      C      CA        single      1.500    0.020
 ALO      HA     CA        single      1.099    0.020
 ALO      CG2    CB        single      1.524    0.020
 ALO      OG1    CB        single      1.432    0.020
 ALO      HB     CB        single      1.099    0.020
 ALO      HG21   CG2       single      1.059    0.020
 ALO      HG22   CG2       single      1.059    0.020
 ALO      HG23   CG2       single      1.059    0.020
 ALO      HG1    OG1       single      0.967    0.020
 ALO      O      C         deloc       1.250    0.020
 ALO      OXT    C         deloc       1.250    0.020
 ALO      HN1    N         single      1.010    0.020
 ALO      HN2    N         single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ALO      HN1    N      HN2     120.000    3.000
 ALO      HN1    N      CA      120.000    3.000
 ALO      HN2    N      CA      120.000    3.000
 ALO      N      CA     HA      109.470    3.000
 ALO      N      CA     CB      109.470    3.000
 ALO      N      CA     C       109.470    3.000
 ALO      HA     CA     CB      108.340    3.000
 ALO      HA     CA     C       108.810    3.000
 ALO      CB     CA     C       109.470    3.000
 ALO      CA     CB     HB      108.340    3.000
 ALO      CA     CB     OG1     109.470    3.000
 ALO      CA     CB     CG2     111.000    3.000
 ALO      HB     CB     OG1     109.470    3.000
 ALO      HB     CB     CG2     108.340    3.000
 ALO      OG1    CB     CG2     109.470    3.000
 ALO      CB     OG1    HG1     109.470    3.000
 ALO      CB     CG2    HG23    109.470    3.000
 ALO      CB     CG2    HG22    109.470    3.000
 ALO      CB     CG2    HG21    109.470    3.000
 ALO      HG23   CG2    HG22    109.470    3.000
 ALO      HG23   CG2    HG21    109.470    3.000
 ALO      HG22   CG2    HG21    109.470    3.000
 ALO      CA     C      O       118.500    3.000
 ALO      CA     C      OXT     118.500    3.000
 ALO      O      C      OXT     123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ALO      var_1    HN2    N      CA     C        175.000   20.000   1
 ALO      var_2    N      CA     CB     CG2      -60.047   20.000   3
 ALO      var_3    CA     CB     OG1    HG1       60.075   20.000   1
 ALO      var_4    CA     CB     CG2    HG21    -179.965   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 ALO      chir_01  CA     N      CB     C         negativ
 ALO      chir_02  CB     CA     CG2    OG1       positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ALO      plan-1    N         0.020
 ALO      plan-1    CA        0.020
 ALO      plan-1    HN1       0.020
 ALO      plan-1    HN2       0.020
 ALO      plan-2    C         0.020
 ALO      plan-2    CA        0.020
 ALO      plan-2    O         0.020
 ALO      plan-2    OXT       0.020
# ------------------------------------------------------
`.trim();

monomers["PDD"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PDD      PDD 'N-(5'-PHOSPHOPYRIDOXYL)-D-ALANINE   ' non-polymer        35  21 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PDD
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PDD           OXT    O    OC       -0.500      0.000    0.000    0.000
 PDD           C      C    C         0.000     -1.180   -0.334    0.245
 PDD           O      O    OC       -0.500     -1.413   -1.362    0.919
 PDD           CA     C    CH1       0.000     -2.324    0.500   -0.272
 PDD           HA     H    H         0.000     -2.247    1.518    0.134
 PDD           CB     C    CH3       0.000     -2.263    0.555   -1.801
 PDD           HB3    H    H         0.000     -3.066    1.143   -2.166
 PDD           HB2    H    H         0.000     -1.345    0.987   -2.104
 PDD           HB1    H    H         0.000     -2.338   -0.426   -2.195
 PDD           N      N    NH1       0.000     -3.597   -0.099    0.146
 PDD           H      H    H         0.000     -3.779   -1.079    0.305
 PDD           C4A    C    CH2       0.000     -4.556    1.004    0.289
 PDD           H4A1   H    H         0.000     -4.664    1.518   -0.668
 PDD           H4A2   H    H         0.000     -4.191    1.708    1.040
 PDD           C4     C    CR6       0.000     -5.892    0.456    0.720
 PDD           C3     C    CR6       0.000     -6.206    0.323    2.068
 PDD           O3A    O    OH1       0.000     -5.311    0.687    3.024
 PDD           HO3    H    H         0.000     -5.445    1.617    3.253
 PDD           C2     C    CR6       0.000     -7.447   -0.185    2.423
 PDD           C2A    C    CH3       0.000     -7.802   -0.335    3.880
 PDD           H2A3   H    H         0.000     -8.470   -1.149    3.999
 PDD           H2A2   H    H         0.000     -6.923   -0.516    4.442
 PDD           H2A1   H    H         0.000     -8.264    0.553    4.225
 PDD           C5     C    CR6       0.000     -6.837    0.076   -0.218
 PDD           C6     C    CR16      0.000     -8.050   -0.426    0.214
 PDD           H6     H    H         0.000     -8.791   -0.732   -0.515
 PDD           N1     N    NRD6      0.000     -8.318   -0.539    1.500
 PDD           C5A    C    CH2       0.000     -6.545    0.201   -1.691
 PDD           H5A1   H    H         0.000     -5.667   -0.399   -1.939
 PDD           H5A2   H    H         0.000     -6.349    1.247   -1.935
 PDD           OP4    O    O2        0.000     -7.669   -0.263   -2.441
 PDD           P      P    P         0.000     -7.288   -0.102   -3.996
 PDD           OP1    O    OP       -0.666     -6.059   -0.929   -4.303
 PDD           OP2    O    OP       -0.666     -8.442   -0.579   -4.850
 PDD           OP3    O    OP       -0.666     -7.005    1.354   -4.299
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PDD      OXT    n/a    C      START
 PDD      C      OXT    CA     .
 PDD      O      C      .      .
 PDD      CA     C      N      .
 PDD      HA     CA     .      .
 PDD      CB     CA     HB1    .
 PDD      HB3    CB     .      .
 PDD      HB2    CB     .      .
 PDD      HB1    CB     .      .
 PDD      N      CA     C4A    .
 PDD      H      N      .      .
 PDD      C4A    N      C4     .
 PDD      H4A1   C4A    .      .
 PDD      H4A2   C4A    .      .
 PDD      C4     C4A    C5     .
 PDD      C3     C4     C2     .
 PDD      O3A    C3     HO3    .
 PDD      HO3    O3A    .      .
 PDD      C2     C3     C2A    .
 PDD      C2A    C2     H2A1   .
 PDD      H2A3   C2A    .      .
 PDD      H2A2   C2A    .      .
 PDD      H2A1   C2A    .      .
 PDD      C5     C4     C5A    .
 PDD      C6     C5     N1     .
 PDD      H6     C6     .      .
 PDD      N1     C6     .      .
 PDD      C5A    C5     OP4    .
 PDD      H5A1   C5A    .      .
 PDD      H5A2   C5A    .      .
 PDD      OP4    C5A    P      .
 PDD      P      OP4    OP3    .
 PDD      OP1    P      .      .
 PDD      OP2    P      .      .
 PDD      OP3    P      .      END
 PDD      N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PDD      C4A    N         single      1.450    0.020
 PDD      N      CA        single      1.450    0.020
 PDD      H      N         single      1.010    0.020
 PDD      N1     C2        double      1.350    0.020
 PDD      N1     C6        single      1.337    0.020
 PDD      C2A    C2        single      1.506    0.020
 PDD      C2     C3        single      1.487    0.020
 PDD      H2A1   C2A       single      1.059    0.020
 PDD      H2A2   C2A       single      1.059    0.020
 PDD      H2A3   C2A       single      1.059    0.020
 PDD      O3A    C3        single      1.362    0.020
 PDD      C3     C4        double      1.487    0.020
 PDD      HO3    O3A       single      0.967    0.020
 PDD      C4     C4A       single      1.511    0.020
 PDD      C5     C4        single      1.487    0.020
 PDD      H4A1   C4A       single      1.092    0.020
 PDD      H4A2   C4A       single      1.092    0.020
 PDD      C5A    C5        single      1.511    0.020
 PDD      C6     C5        double      1.390    0.020
 PDD      OP4    C5A       single      1.426    0.020
 PDD      H5A1   C5A       single      1.092    0.020
 PDD      H5A2   C5A       single      1.092    0.020
 PDD      P      OP4       single      1.610    0.020
 PDD      OP1    P         deloc       1.510    0.020
 PDD      OP2    P         deloc       1.510    0.020
 PDD      OP3    P         deloc       1.510    0.020
 PDD      H6     C6        single      1.083    0.020
 PDD      CB     CA        single      1.524    0.020
 PDD      CA     C         single      1.500    0.020
 PDD      HA     CA        single      1.099    0.020
 PDD      HB1    CB        single      1.059    0.020
 PDD      HB2    CB        single      1.059    0.020
 PDD      HB3    CB        single      1.059    0.020
 PDD      O      C         deloc       1.250    0.020
 PDD      C      OXT       deloc       1.250    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PDD      OXT    C      O       123.000    3.000
 PDD      OXT    C      CA      118.500    3.000
 PDD      O      C      CA      118.500    3.000
 PDD      C      CA     HA      108.810    3.000
 PDD      C      CA     CB      109.470    3.000
 PDD      C      CA     N       111.600    3.000
 PDD      HA     CA     CB      108.340    3.000
 PDD      HA     CA     N       108.550    3.000
 PDD      CB     CA     N       110.000    3.000
 PDD      CA     CB     HB3     109.470    3.000
 PDD      CA     CB     HB2     109.470    3.000
 PDD      CA     CB     HB1     109.470    3.000
 PDD      HB3    CB     HB2     109.470    3.000
 PDD      HB3    CB     HB1     109.470    3.000
 PDD      HB2    CB     HB1     109.470    3.000
 PDD      CA     N      H       118.500    3.000
 PDD      CA     N      C4A     120.000    3.000
 PDD      H      N      C4A     118.500    3.000
 PDD      N      C4A    H4A1    109.470    3.000
 PDD      N      C4A    H4A2    109.470    3.000
 PDD      N      C4A    C4      109.500    3.000
 PDD      H4A1   C4A    H4A2    107.900    3.000
 PDD      H4A1   C4A    C4      109.470    3.000
 PDD      H4A2   C4A    C4      109.470    3.000
 PDD      C4A    C4     C3      120.000    3.000
 PDD      C4A    C4     C5      120.000    3.000
 PDD      C3     C4     C5      120.000    3.000
 PDD      C4     C3     O3A     120.000    3.000
 PDD      C4     C3     C2      120.000    3.000
 PDD      O3A    C3     C2      120.000    3.000
 PDD      C3     O3A    HO3     109.470    3.000
 PDD      C3     C2     C2A     120.000    3.000
 PDD      C3     C2     N1      120.000    3.000
 PDD      C2A    C2     N1      120.000    3.000
 PDD      C2     C2A    H2A3    109.470    3.000
 PDD      C2     C2A    H2A2    109.470    3.000
 PDD      C2     C2A    H2A1    109.470    3.000
 PDD      H2A3   C2A    H2A2    109.470    3.000
 PDD      H2A3   C2A    H2A1    109.470    3.000
 PDD      H2A2   C2A    H2A1    109.470    3.000
 PDD      C4     C5     C6      120.000    3.000
 PDD      C4     C5     C5A     120.000    3.000
 PDD      C6     C5     C5A     120.000    3.000
 PDD      C5     C6     H6      120.000    3.000
 PDD      C5     C6     N1      120.000    3.000
 PDD      H6     C6     N1      120.000    3.000
 PDD      C6     N1     C2      120.000    3.000
 PDD      C5     C5A    H5A1    109.470    3.000
 PDD      C5     C5A    H5A2    109.470    3.000
 PDD      C5     C5A    OP4     109.470    3.000
 PDD      H5A1   C5A    H5A2    107.900    3.000
 PDD      H5A1   C5A    OP4     109.470    3.000
 PDD      H5A2   C5A    OP4     109.470    3.000
 PDD      C5A    OP4    P       120.500    3.000
 PDD      OP4    P      OP1     108.200    3.000
 PDD      OP4    P      OP2     108.200    3.000
 PDD      OP4    P      OP3     108.200    3.000
 PDD      OP1    P      OP2     119.900    3.000
 PDD      OP1    P      OP3     119.900    3.000
 PDD      OP2    P      OP3     119.900    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PDD      var_1    OXT    C      CA     N        179.962   20.000   3
 PDD      var_2    C      CA     CB     HB1       60.095   20.000   3
 PDD      var_3    C      CA     N      C4A      149.969   20.000   3
 PDD      var_4    CA     N      C4A    C4      -179.964   20.000   3
 PDD      var_5    N      C4A    C4     C5       -90.248   20.000   2
 PDD      CONST_1  C4A    C4     C3     C2       180.000    0.000   0
 PDD      var_6    C4     C3     O3A    HO3       89.991   20.000   1
 PDD      CONST_2  C4     C3     C2     C2A      180.000    0.000   0
 PDD      var_7    C3     C2     C2A    H2A1      90.072   20.000   1
 PDD      CONST_3  C4A    C4     C5     C5A        0.000    0.000   0
 PDD      CONST_4  C4     C5     C6     N1         0.000    0.000   0
 PDD      CONST_5  C5     C6     N1     C2         0.000    0.000   0
 PDD      CONST_6  C6     N1     C2     C3         0.000    0.000   0
 PDD      var_8    C4     C5     C5A    OP4      179.543   20.000   2
 PDD      var_9    C5     C5A    OP4    P        179.998   20.000   1
 PDD      var_10   C5A    OP4    P      OP3      -60.026   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 PDD      chir_01  CA     N      CB     C         positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 PDD      plan-1    N         0.020
 PDD      plan-1    C4A       0.020
 PDD      plan-1    CA        0.020
 PDD      plan-1    H         0.020
 PDD      plan-2    N1        0.020
 PDD      plan-2    C2        0.020
 PDD      plan-2    C6        0.020
 PDD      plan-2    C3        0.020
 PDD      plan-2    C4        0.020
 PDD      plan-2    C5        0.020
 PDD      plan-2    C2A       0.020
 PDD      plan-2    O3A       0.020
 PDD      plan-2    C4A       0.020
 PDD      plan-2    C5A       0.020
 PDD      plan-2    H6        0.020
 PDD      plan-3    C         0.020
 PDD      plan-3    CA        0.020
 PDD      plan-3    O         0.020
 PDD      plan-3    OXT       0.020
# ------------------------------------------------------
`.trim();

monomers["UNK"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
UNK      UNK 'UNKNOWN                             ' peptide            15   7 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_UNK
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 UNK           N      N    NH2       0.000      0.000    0.000    0.000
 UNK           HN1    H    H         0.000     -0.564    0.809   -0.210
 UNK           HN2    H    H         0.000     -0.060   -0.441    0.905
 UNK           CA     C    CH1       0.000      0.895   -0.529   -0.998
 UNK           HA     H    H         0.000      1.919   -0.348   -0.640
 UNK           CB     C    CH2       0.000      0.735   -2.045   -1.150
 UNK           HB1    H    H         0.000      0.845   -2.477   -0.153
 UNK           HB2    H    H         0.000      1.553   -2.389   -1.786
 UNK           CG     C    CH3       0.000     -0.596   -2.483   -1.751
 UNK           HG3    H    H         0.000     -0.698   -2.074   -2.723
 UNK           HG2    H    H         0.000     -0.629   -3.541   -1.810
 UNK           HG1    H    H         0.000     -1.392   -2.140   -1.140
 UNK           C      C    C         0.000      0.756    0.191   -2.328
 UNK           O      O    OC       -0.500     -0.105    1.070   -2.555
 UNK           OXT    O    OC       -0.500      1.597   -0.174   -3.178
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 UNK      N      n/a    CA     START
 UNK      HN1    N      .      .
 UNK      HN2    N      .      .
 UNK      CA     N      C      .
 UNK      HA     CA     .      .
 UNK      CB     CA     CG     .
 UNK      HB1    CB     .      .
 UNK      HB2    CB     .      .
 UNK      CG     CB     HG1    .
 UNK      HG3    CG     .      .
 UNK      HG2    CG     .      .
 UNK      HG1    CG     .      .
 UNK      C      CA     .      END
 UNK      O      C      .      .
 UNK      OXT    C      .      .
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 UNK      CA     N         single      1.450    0.020
 UNK      C      CA        single      1.500    0.020
 UNK      CB     CA        single      1.524    0.020
 UNK      HA     CA        single      1.099    0.020
 UNK      O      C         deloc       1.250    0.020
 UNK      OXT    C         deloc       1.250    0.020
 UNK      CG     CB        single      1.513    0.020
 UNK      HB1    CB        single      1.092    0.020
 UNK      HB2    CB        single      1.092    0.020
 UNK      HG1    CG        single      1.059    0.020
 UNK      HG2    CG        single      1.059    0.020
 UNK      HG3    CG        single      1.059    0.020
 UNK      HN1    N         single      1.010    0.020
 UNK      HN2    N         single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 UNK      HN1    N      HN2     120.000    3.000
 UNK      HN1    N      CA      120.000    3.000
 UNK      HN2    N      CA      120.000    3.000
 UNK      N      CA     HA      109.470    3.000
 UNK      N      CA     CB      109.470    3.000
 UNK      N      CA     C       109.470    3.000
 UNK      HA     CA     CB      108.340    3.000
 UNK      HA     CA     C       108.810    3.000
 UNK      CB     CA     C       109.470    3.000
 UNK      CA     CB     HB1     109.470    3.000
 UNK      CA     CB     HB2     109.470    3.000
 UNK      CA     CB     CG      111.000    3.000
 UNK      HB1    CB     HB2     107.900    3.000
 UNK      HB1    CB     CG      109.470    3.000
 UNK      HB2    CB     CG      109.470    3.000
 UNK      CB     CG     HG3     109.470    3.000
 UNK      CB     CG     HG2     109.470    3.000
 UNK      CB     CG     HG1     109.470    3.000
 UNK      HG3    CG     HG2     109.470    3.000
 UNK      HG3    CG     HG1     109.470    3.000
 UNK      HG2    CG     HG1     109.470    3.000
 UNK      CA     C      O       118.500    3.000
 UNK      CA     C      OXT     118.500    3.000
 UNK      O      C      OXT     123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 UNK      var_1    HN2    N      CA     C        175.000   20.000   1
 UNK      var_2    N      CA     CB     CG        68.098   20.000   3
 UNK      var_3    CA     CB     CG     HG1      -59.326   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 UNK      chir_01  CA     N      C      CB        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 UNK      plan-1    N         0.020
 UNK      plan-1    CA        0.020
 UNK      plan-1    HN1       0.020
 UNK      plan-1    HN2       0.020
 UNK      plan-2    C         0.020
 UNK      plan-2    CA        0.020
 UNK      plan-2    O         0.020
 UNK      plan-2    OXT       0.020
# ------------------------------------------------------
`.trim();

monomers["DA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DA       DA  '2'-DEOXYADENOSINE-5'-MONOPHOSPHATE  ' DNA                34  22 .
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DA            P      P    P         0.000      0.025   -0.445    0.115
 DA            OP3    O    OP       -0.660      0.460   -1.806    0.605
 DA            OP1    O    OP       -0.660      0.229    0.645    1.142
 DA            OP2    O    OP       -0.660      0.562   -0.111   -1.258
 DA            "O5'"  O    O2        0.000     -1.574   -0.556   -0.054
 DA            "C5'"  C    CH2       0.000     -2.357    0.563   -0.510
 DA            "H5'" H    H         0.000     -1.882    1.022   -1.379
 DA            "H5''" H    H         0.000     -2.448    1.305    0.287
 DA            "C4'"  C    CH1       0.000     -3.738    0.056   -0.893
 DA            "H4'"  H    H         0.000     -3.588   -0.793   -1.574
 DA            "C3'"  C    CH1       0.000     -4.740    1.000   -1.573
 DA            "H3'"  H    H         0.000     -4.520    2.042   -1.301
 DA            "O3'"  O    OH1       0.000     -4.740    0.852   -3.002
 DA            "HO3'" H    H         0.000     -5.436    1.404   -3.384
 DA            "C2'"  C    CH2       0.000     -6.112    0.574   -0.983
 DA            "H2' " H    H         0.000     -6.698    0.042   -1.735
 DA            "H2''" H    H         0.000     -6.667    1.451   -0.644
 DA            "C1'"  C    CH1       0.000     -5.841   -0.360    0.214
 DA            "H1'"  H    H         0.000     -6.240   -1.354   -0.032
 DA            "O4'"  O    O2        0.000     -4.400   -0.461    0.282
 DA            N9     N    NR5       0.000     -6.425    0.064    1.523
 DA            C4     C    CR56      0.000     -7.532   -0.378    2.125
 DA            C5     C    CR56      0.000     -7.724    0.452    3.366
 DA            N7     N    NRD5      0.000     -6.582    1.102    3.512
 DA            C8     C    CR15      0.000     -5.777    0.724    2.491
 DA            H8     H    H         0.000     -4.715    0.936    2.460
 DA            N3     N    NRD6      0.000     -8.550   -1.119    1.670
 DA            C2     C    CR16      0.000     -9.623   -1.256    2.440
 DA            H2     H    H         0.000    -10.398   -1.937    2.112
 DA            N1     N    NRD6      0.000     -9.807   -0.602    3.601
 DA            C6     C    CR6       0.000     -8.948    0.277    4.162
 DA            N6     N    NH2       0.000     -9.281    0.883    5.319
 DA            H62    H    H         0.000    -10.166    0.676    5.757
 DA            H61    H    H         0.000     -8.645    1.540    5.743
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DA       "O5'"  n/a      "C5'"  START
 DA       P      "O5'"  .      .
 DA       OP3    P      .      .
 DA       OP1    P      .      .
 DA       OP2    P      .      .
 DA       "C5'"  "O5'"  "C4'"  .
 DA       "H5'" "C5'"  .      .
 DA       "H5''" "C5'"  .      .
 DA       "C4'"  "C5'"  "C3'"  .
 DA       "H4'"  "C4'"  .      .
 DA       "C3'"  "C4'"  "C2'"  .
 DA       "H3'"  "C3'"  .      .
 DA       "O3'"  "C3'"  "HO3'" .
 DA       "HO3'" "O3'"  .      .
 DA       "C2'"  "C3'"  "C1'"  .
 DA       "H2' " "C2'"  .      .
 DA       "H2''" "C2'"  .      .
 DA       "C1'"  "C2'"  N9     .
 DA       "H1'"  "C1'"  .      .
 DA       "O4'"  "C1'"  .      .
 DA       N9     "C1'"  C4     .
 DA       C4     N9     N3     .
 DA       C5     C4     N7     .
 DA       N7     C5     C8     .
 DA       C8     N7     H8     .
 DA       H8     C8     .      .
 DA       N3     C4     C2     .
 DA       C2     N3     N1     .
 DA       H2     C2     .      .
 DA       N1     C2     C6     .
 DA       C6     N1     N6     .
 DA       N6     C6     H61    .
 DA       H62    N6     .      .
 DA       H61    N6     .      END
 DA       "C4'"  "O4'"  .    ADD
 DA       N9     C8     .    ADD
 DA       C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DA       OP3    P         deloc       1.485    0.017
 DA       OP1    P         deloc       1.485    0.017
 DA       OP2    P         deloc       1.485    0.017
 DA       "O5'"  P         single      1.593    0.010
 DA       "C5'"  "O5'"     single      1.440    0.016
 DA       "C4'"  "C5'"     single      1.511    0.008
 DA       "C4'"  "O4'"     single      1.446    0.011
 DA       "C3'"  "C4'"     single      1.528    0.010
 DA       "O4'"  "C1'"     single      1.420    0.013
 DA       "O3'"  "C3'"     single      1.431    0.013
 DA       "C2'"  "C3'"     single      1.518    0.010
 DA       "C1'"  "C2'"     single      1.521    0.014
 DA       N9     "C1'"     single      1.462    0.010
 DA       N9     C8        single      1.373    0.008
 DA       C4     N9        single      1.374    0.006
 DA       C8     N7        double      1.311    0.007
 DA       N7     C5        single      1.388    0.006
 DA       C5     C6        single      1.406    0.009
 DA       C5     C4        double      1.383    0.007
 DA       N6     C6        single      1.335    0.008
 DA       C6     N1        double      1.351    0.007
 DA       N1     C2        single      1.339    0.009
 DA       C2     N3        double      1.331    0.009
 DA       N3     C4        single      1.344    0.006
 DA       "H5'" "C5'"     single      1.092    0.020
 DA       "H5''" "C5'"     single      1.092    0.020
 DA       "H4'"  "C4'"     single      1.099    0.020
 DA       "H3'"  "C3'"     single      1.099    0.020
 DA       "HO3'" "O3'"     single      0.967    0.020
 DA       "H2' " "C2'"     single      1.092    0.020
 DA       "H2''" "C2'"     single      1.092    0.020
 DA       "H1'"  "C1'"     single      1.099    0.020
 DA       H8     C8        single      1.083    0.020
 DA       H61    N6        single      1.010    0.020
 DA       H62    N6        single      1.010    0.020
 DA       H2     C2        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DA       OP3    P      OP1     107.400    3.200
 DA       OP3    P      OP2     108.300    3.200
 DA       OP1    P      OP2     119.600    1.500
 DA       OP3    P      "O5'"   104.000    1.900
 DA       OP1    P      "O5'"   108.100    2.900
 DA       OP2    P      "O5'"   108.300    2.700
 DA       P      "O5'"  "C5'"   120.900    1.600
 DA       "O5'"  "C5'"  "H5'"  109.470    3.000
 DA       "O5'"  "C5'"  "H5''"  109.470    3.000
 DA       "O5'"  "C5'"  "C4'"   110.200    1.400
 DA       "H5'" "C5'"  "H5''"  107.900    3.000
 DA       "H5'" "C5'"  "C4'"   109.470    3.000
 DA       "H5''" "C5'"  "C4'"   109.470    3.000
 DA       "C5'"  "C4'"  "H4'"   108.340    3.000
 DA       "C5'"  "C4'"  "C3'"   114.700    1.500
 DA       "C5'"  "C4'"  "O4'"   109.400    1.600
 DA       "H4'"  "C4'"  "C3'"   108.340    3.000
 DA       "H4'"  "C4'"  "O4'"   109.470    3.000
 DA       "C3'"  "C4'"  "O4'"   105.600    1.000
 DA       "C4'"  "C3'"  "H3'"   108.340    3.000
 DA       "C4'"  "C3'"  "O3'"   110.300    2.200
 DA       "C4'"  "C3'"  "C2'"   103.200    1.000
 DA       "H3'"  "C3'"  "O3'"   109.470    3.000
 DA       "H3'"  "C3'"  "C2'"   108.340    3.000
 DA       "O3'"  "C3'"  "C2'"   110.600    2.700
 DA       "C3'"  "O3'"  "HO3'"  109.470    3.000
 DA       "C3'"  "C2'"  "H2' "  109.470    3.000
 DA       "C3'"  "C2'"  "H2''"  109.470    3.000
 DA       "C3'"  "C2'"  "C1'"   102.700    1.400
 DA       "H2' " "C2'"  "H2''"  107.900    3.000
 DA       "H2' " "C2'"  "C1'"   109.470    3.000
 DA       "H2''" "C2'"  "C1'"   109.470    3.000
 DA       "C2'"  "C1'"  "H1'"   108.340    3.000
 DA       "C2'"  "C1'"  "O4'"   106.100    1.100
 DA       "C2'"  "C1'"  N9      114.200    1.600
 DA       "H1'"  "C1'"  "O4'"   109.470    3.000
 DA       "H1'"  "C1'"  N9      109.470    3.000
 DA       "O4'"  "C1'"  N9      107.800    0.800
 DA       "C1'"  "O4'"  "C4'"   109.700    1.400
 DA       "C1'"  N9     C4      126.300    1.800
 DA       "C1'"  N9     C8      127.700    1.800
 DA       C4     N9     C8      105.800    0.400
 DA       N9     C4     C5      105.800    0.400
 DA       N9     C4     N3      127.400    0.800
 DA       C5     C4     N3      126.800    0.700
 DA       C4     C5     N7      110.700    0.500
 DA       C4     C5     C6      117.000    0.500
 DA       N7     C5     C6      132.300    0.700
 DA       C5     N7     C8      103.900    0.500
 DA       N7     C8     H8      126.000    3.000
 DA       N7     C8     N9      113.800    0.500
 DA       H8     C8     N9      126.000    3.000
 DA       C4     N3     C2      110.600    0.500
 DA       N3     C2     H2      120.000    3.000
 DA       N3     C2     N1      129.300    0.500
 DA       H2     C2     N1      120.000    3.000
 DA       C2     N1     C6      118.600    0.600
 DA       N1     C6     N6      118.600    0.600
 DA       N1     C6     C5      117.700    0.500
 DA       N6     C6     C5      123.700    0.800
 DA       C6     N6     H62     120.000    3.000
 DA       C6     N6     H61     120.000    3.000
 DA       H62    N6     H61     120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DA        C2e-nyu0 C4'    O4'    C1'    C2'      340.700    6.300   1
 DA        C2e-nyu1 O4'    C1'    C2'    C3'       32.800    4.900   1
 DA        C2e-nyu2 C1'    C2'    C3'    C4'      326.9      3.600   1
 DA        C2e-nyu3 C2'    C3'    C4'    O4'       22.600    4.500   1
 DA        C2e-nyu4 C3'    C4'    O4'    C1'      357.700    6.100   1
 DA        C2e-delta C5'    C4'   C3'    O3'      145.2000    4.000   1
 DA        C2e-C4N9 C4'    O4'   C1'     N9       217.700    5.500   1


 DA        C3e-nyu0 C4'    O4'    C1'    C2'        2.8      6.100   1
 DA        C3e-nyu1 O4'    C1'    C2'    C3'      335.00     4.900   1
 DA        C3e-nyu2 C1'    C2'    C3'    C4'       35.9      2.800   1
 DA        C3e-nyu3 C2'    C3'    C4'    O4'      324.700    3.100   1
 DA        C3e-nyu4 C3'    C4'    O4'    C1'       20.500    5.100   1
 DA        C3e-delta C5'    C4'   C3'    O3'        84.800    4.500   1
 DA        C2e-C4N9 C4'    O4'   C1'     N9       245.600    2.500   1


 DA       var_1    OP2    P      "O5'"  "C5'"    -60.052   20.000   1
 DA       var_2    P      "O5'"  "C5'"  "C4'"   -179.997   20.000   1
 DA       var_3    "O5'"  "C5'"  "C4'"  "C3'"   -179.980   20.000   3
 DA       var_4    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 DA       var_5    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 DA       var_6    "C4'"  "C3'"  "O3'"  "HO3'"   175.000   20.000   1
 DA       var_8    "C3'"  "C2'"  "C1'"  N9       120.000   20.000   3
 DA       var_10   "C2'"  "C1'"  N9     C4        90.349   20.000   1
 DA       CONST_1  "C1'"  N9     C8     N7       180.000    0.000   0
 DA       CONST_2  "C1'"  N9     C4     N3         0.000    0.000   0
 DA       CONST_3  N9     C4     C5     N7         0.000    0.000   0
 DA       CONST_4  C4     C5     C6     N1         0.000    0.000   0
 DA       CONST_5  C4     C5     N7     C8         0.000    0.000   0
 DA       CONST_6  C5     N7     C8     N9         0.000    0.000   0
 DA       CONST_7  N9     C4     N3     C2       180.000    0.000   0
 DA       CONST_8  C4     N3     C2     N1         0.000    0.000   0
 DA       CONST_9  N3     C2     N1     C6         0.000    0.000   0
 DA       CONST_10 C2     N1     C6     N6       180.000    0.000   0
 DA       CONST_11 N1     C6     N6     H61      180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DA       chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 DA       chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 DA       chir_03  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DA       plan-1    N9        0.020
 DA       plan-1    "C1'"     0.020
 DA       plan-1    C8        0.020
 DA       plan-1    C4        0.020
 DA       plan-1    N7        0.020
 DA       plan-1    H8        0.020
 DA       plan-1    C5        0.020
 DA       plan-1    C6        0.020
 DA       plan-1    N1        0.020
 DA       plan-1    C2        0.020
 DA       plan-1    N3        0.020
 DA       plan-1    N6        0.020
 DA       plan-1    H2        0.020
 DA       plan-1    H62       0.020
 DA       plan-1    H61       0.020
 DA       plan-2    N6        0.020
 DA       plan-2    C6        0.020
 DA       plan-2    H61       0.020
 DA       plan-2    H62       0.020
# ------------------------------------------------------
# ------------------------------------------------------
# ------------------------------------------------------
`.trim();

monomers["DC"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DC       DC  '2'-DEOXYCYTIDINE-5'-MONOPHOSPHATE   ' DNA                32  20 .
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DC
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DC            P      P    P         0.000      0.001   -0.540    0.119
 DC            OP3    O    OP       -0.660      0.227   -1.987    0.516
 DC            OP1    O    OP       -0.660      0.381    0.441    1.194
 DC            "O5'"  O    O2        0.000     -1.613   -0.460    0.002
 DC            "C5'"  C    CH2       0.000     -2.412    0.695   -0.366
 DC            "H5'" H    H         0.000     -2.004    1.206   -1.241
 DC            "H5''" H    H         0.000     -2.500    1.405    0.459
 DC            "C4'"  C    CH1       0.000     -3.783    0.131   -0.701
 DC            "H4'"  H    H         0.000     -3.606   -0.705   -1.391
 DC            "C3'"  C    CH1       0.000     -4.862    0.991   -1.350
 DC            "H3'"  H    H         0.000     -4.664    2.061   -1.199
 DC            "O3'"  O    OH1       0.000     -4.928    0.664   -2.754
 DC            "HO3'" H    H         0.000     -5.661    1.144   -3.165
 DC            "C2'"  C    CH2       0.000     -6.185    0.558   -0.660
 DC            "H2' " H    H         0.000     -6.865    0.104   -1.383
 DC            "H2''" H    H         0.000     -6.673    1.415   -0.192
 DC            "C1'"  C    CH1       0.000     -5.815   -0.478    0.421
 DC            "H1'"  H    H         0.000     -6.089   -1.462    0.015
 DC            "O4'"  O    O2        0.000     -4.377   -0.452    0.488
 DC            N1     N    NR6       0.000     -6.434   -0.388    1.735
 DC            C6     C    CR16      0.000     -7.038   -1.463    2.305
 DC            H6     H    H         0.000     -7.005   -2.406    1.774
 DC            C5     C    CR16      0.000     -7.709   -1.424    3.556
 DC            H5     H    H         0.000     -8.160   -2.314    3.979
 DC            C4     C    CR6       0.000     -7.767   -0.214    4.213
 DC            N4     N    NH2       0.000     -8.312   -0.031    5.446
 DC            H42    H    H         0.000     -8.712   -0.813    5.946
 DC            H41    H    H         0.000     -8.318    0.889    5.866
 DC            N3     N    NRD6      0.000     -6.825    0.681    3.769
 DC            C2     C    CR6       0.000     -6.022    0.556    2.670
 DC            O2     O    O         0.000     -4.961    1.193    2.528
 DC            OP2    O    OP       -0.660      0.506   -0.216   -1.268
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
DC    "O5'"   n/a  "C5'"  START
 DC       P      "O5'"     OP2    .
 DC       OP3    P      .      .
 DC       OP1    P      .      .
 DC       "C5'"  "O5'"  "C4'"  .
 DC       "H5'" "C5'"  .      .
 DC       "H5''" "C5'"  .      .
 DC       "C4'"  "C5'"  "C3'"  .
 DC       "H4'"  "C4'"  .      .
 DC       "C3'"  "C4'"  "C2'"  .
 DC       "H3'"  "C3'"  .      .
 DC       "O3'"  "C3'"  "HO3'" .
 DC       "HO3'" "O3'"  .      .
 DC       "C2'"  "C3'"  "C1'"  .
 DC       "H2' " "C2'"  .      .
 DC       "H2''" "C2'"  .      .
 DC       "C1'"  "C2'"  N1     .
 DC       "H1'"  "C1'"  .      .
 DC       "O4'"  "C1'"  .      .
 DC       N1     "C1'"  C6     .
 DC       C6     N1     C5     .
 DC       H6     C6     .      .
 DC       C5     C6     C4     .
 DC       H5     C5     .      .
 DC       C4     C5     N3     .
 DC       N4     C4     H41    .
 DC       H42    N4     .      .
 DC       H41    N4     .      .
 DC       N3     C4     C2     .
 DC       C2     N3     O2     .
 DC       O2     C2     .      END
 DC       OP2    P      .     .
 DC       "C4'"  "O4'"  .    ADD
 DC       N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DC       OP3    P         deloc       1.485    0.017
 DC       OP1    P         deloc       1.485    0.017
 DC       OP2    P         deloc       1.485    0.017
 DC       "O5'"  P         single      1.593    0.010
 DC       "C5'"  "O5'"     single      1.440    0.016
 DC       "C4'"  "C5'"     single      1.511    0.008
 DC       "C4'"  "O4'"     single      1.446    0.011
 DC       "C3'"  "C4'"     single      1.528    0.010
 DC       "O4'"  "C1'"     single      1.420    0.013
 DC       "O3'"  "C3'"     single      1.431    0.013
 DC       "C2'"  "C3'"     single      1.518    0.010
 DC       "C1'"  "C2'"     single      1.521    0.014
 DC       N1     "C1'"     single      1.470    0.012
 DC       N1     C2        single      1.397    0.010
 DC       C6     N1        single      1.367    0.006
 DC       O2     C2        double      1.240    0.009
 DC       C2     N3        single      1.353    0.008
 DC       N3     C4        double      1.335    0.007
 DC       N4     C4        single      1.335    0.009
 DC       C4     C5        single      1.425    0.008
 DC       C5     C6        double      1.339    0.008
 DC       "H5'" "C5'"     single      1.092    0.020
 DC       "H5''" "C5'"     single      1.092    0.020
 DC       "H4'"  "C4'"     single      1.099    0.020
 DC       "H3'"  "C3'"     single      1.099    0.020
 DC       "HO3'" "O3'"     single      0.967    0.020
 DC       "H2' " "C2'"     single      1.092    0.020
 DC       "H2''" "C2'"     single      1.092    0.020
 DC       "H1'"  "C1'"     single      1.099    0.020
 DC       H41    N4        single      1.010    0.020
 DC       H42    N4        single      1.010    0.020
 DC       H5     C5        single      1.083    0.020
 DC       H6     C6        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DC       OP3    P      OP1     107.400    3.200
 DC       OP3    P      "O5'"   104.000    1.900
 DC       OP1    P      "O5'"   108.100    2.900
 DC       OP3    P      OP2     108.300    3.200
 DC       OP1    P      OP2     119.600    1.500
 DC       "O5'"  P      OP2     108.300    2.700
 DC       P      "O5'"  "C5'"   120.900    1.600
 DC       "O5'"  "C5'"  "H5'"  109.470    3.000
 DC       "O5'"  "C5'"  "H5''"  109.470    3.000
 DC       "O5'"  "C5'"  "C4'"   110.200    1.400
 DC       "H5'" "C5'"  "H5''"  107.900    3.000
 DC       "H5'" "C5'"  "C4'"   109.470    3.000
 DC       "H5''" "C5'"  "C4'"   109.470    3.000
 DC       "C5'"  "C4'"  "H4'"   108.340    3.000
 DC       "C5'"  "C4'"  "C3'"   114.700    1.500
 DC       "C5'"  "C4'"  "O4'"   109.400    1.600
 DC       "H4'"  "C4'"  "C3'"   108.340    3.000
 DC       "H4'"  "C4'"  "O4'"   109.470    3.000
 DC       "C3'"  "C4'"  "O4'"   105.600    1.000
 DC       "C4'"  "C3'"  "H3'"   108.340    3.000
 DC       "C4'"  "C3'"  "O3'"   110.300    2.200
 DC       "C4'"  "C3'"  "C2'"   103.200    1.000
 DC       "H3'"  "C3'"  "O3'"   109.470    3.000
 DC       "H3'"  "C3'"  "C2'"   108.340    3.000
 DC       "O3'"  "C3'"  "C2'"   110.600    2.700
 DC       "C3'"  "O3'"  "HO3'"  109.470    3.000
 DC       "C3'"  "C2'"  "H2' "  109.470    3.000
 DC       "C3'"  "C2'"  "H2''"  109.470    3.000
 DC       "C3'"  "C2'"  "C1'"   102.700    1.400
 DC       "H2' " "C2'"  "H2''"  107.900    3.000
 DC       "H2' " "C2'"  "C1'"   109.470    3.000
 DC       "H2''" "C2'"  "C1'"   109.470    3.000
 DC       "C2'"  "C1'"  "H1'"   108.340    3.000
 DC       "C2'"  "C1'"  "O4'"   106.100    1.100
 DC       "C2'"  "C1'"  N1      114.200    1.600
 DC       "H1'"  "C1'"  "O4'"   109.470    3.000
 DC       "H1'"  "C1'"  N1      109.470    3.000
 DC       "O4'"  "C1'"  N1      107.800    0.800
 DC       "C1'"  "O4'"  "C4'"   109.700    1.400
 DC       "C1'"  N1     C6      120.800    1.200
 DC       "C1'"  N1     C2      118.800    1.100
 DC       C6     N1     C2      120.300    0.400
 DC       N1     C6     H6      120.000    3.000
 DC       N1     C6     C5      121.000    0.500
 DC       H6     C6     C5      120.000    3.000
 DC       C6     C5     H5      120.000    3.000
 DC       C6     C5     C4      117.400    0.500
 DC       H5     C5     C4      120.000    3.000
 DC       C5     C4     N4      120.200    0.700
 DC       C5     C4     N3      121.900    0.400
 DC       N4     C4     N3      118.000    0.700
 DC       C4     N4     H42     120.000    3.000
 DC       C4     N4     H41     120.000    3.000
 DC       H42    N4     H41     120.000    3.000
 DC       C4     N3     C2      119.900    0.500
 DC       N3     C2     O2      121.900    0.700
 DC       N3     C2     N1      119.200    0.700
 DC       O2     C2     N1      118.900    0.600
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DC        C2e-nyu0 C4'    O4'    C1'    C2'      340.700    6.300   1
 DC        C2e-nyu1 O4'    C1'    C2'    C3'       32.800    4.900   1
 DC        C2e-nyu2 C1'    C2'    C3'    C4'      326.9      3.600   1
 DC        C2e-nyu3 C2'    C3'    C4'    O4'       22.600    4.500   1
 DC        C2e-nyu4 C3'    C4'    O4'    C1'      357.700    6.100   1
 DC        C2e-delta C5'    C4'   C3'    O3'      145.2000    4.000   1
 DC        C2e-C4N1 C4'    O4'   C1'     N9       217.700    6.700   1


 DC        C3e-nyu0 C4'    O4'    C1'    C2'        2.8      6.100   1
 DC        C3e-nyu1 O4'    C1'    C2'    C3'      335.00     4.900   1
 DC        C3e-nyu2 C1'    C2'    C3'    C4'       35.9      2.800   1
 DC        C3e-nyu3 C2'    C3'    C4'    O4'      324.700    3.100   1
 DC        C3e-nyu4 C3'    C4'    O4'    C1'       20.500    5.100   1
 DC        C3e-delta C5'    C4'   C3'    O3'        84.800    4.500   1
 DC        C2e-C4N1 C4'    O4'   C1'     N9       245.600    2.500   1


 DC       var_1    OP2    P      "O5'"  "C5'"    -60.014   20.000   1
 DC       var_2    P      "O5'"  "C5'"  "C4'"    179.972   20.000   1
 DC       var_3    "O5'"  "C5'"  "C4'"  "C3'"   -179.996   20.000   3
 DC       var_4    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 DC       var_5    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 DC       var_6    "C4'"  "C3'"  "O3'"  "HO3'"   175.000   20.000   1
 DC       var_8    "C3'"  "C2'"  "C1'"  N1       120.000   20.000   3
 DC       var_10   "C2'"  "C1'"  N1     C6       120.298   20.000   1
 DC       CONST_1  "C1'"  N1     C2     N3       180.000    0.000   0
 DC       CONST_2  "C1'"  N1     C6     C5       180.000    0.000   0
 DC       CONST_3  N1     C6     C5     C4         0.000    0.000   0
 DC       CONST_4  C6     C5     C4     N3         0.000    0.000   0
 DC       CONST_5  C5     C4     N4     H41      180.000    0.000   0
 DC       CONST_6  C5     C4     N3     C2         0.000    0.000   0
 DC       CONST_7  C4     N3     C2     O2       180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DC       chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 DC       chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 DC       chir_03  "C1'"  "O4'"  "C2'"  N1        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DC       plan-1    N1        0.020
 DC       plan-1    "C1'"     0.020
 DC       plan-1    C2        0.020
 DC       plan-1    C6        0.020
 DC       plan-1    N3        0.020
 DC       plan-1    C4        0.020
 DC       plan-1    C5        0.020
 DC       plan-1    O2        0.020
 DC       plan-1    N4        0.020
 DC       plan-1    H5        0.020
 DC       plan-1    H6        0.020
 DC       plan-1    H42       0.020
 DC       plan-1    H41       0.020
 DC       plan-2    N4        0.020
 DC       plan-2    C4        0.020
 DC       plan-2    H41       0.020
 DC       plan-2    H42       0.020
# ------------------------------------------------------
# ------------------------------------------------------
# ------------------------------------------------------
`.trim();

monomers["DG"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DG       DG  '2'-DEOXYGUANOSINE-5'-MONOPHOSPHATE  ' DNA                35  23 .
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DG
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DG            P      P    P         0.000     -0.056   -0.552    0.076
 DG            OP3    O    OP       -0.660      0.020   -2.009    0.478
 DG            OP1    O    OP       -0.660     -0.172    0.378    1.260
 DG            "O5'"  O    O2        0.000     -1.466   -0.414   -0.696
 DG            "C5'"  C    CH2       0.000     -1.980    0.791   -1.294
 DG            "H5'" H    H         0.000     -1.199    1.313   -1.851
 DG            "H5''" H    H         0.000     -2.392    1.458   -0.534
 DG            "C4'"  C    CH1       0.000     -3.092    0.360   -2.253
 DG            "H4'"  H    H         0.000     -2.689   -0.449   -2.879
 DG            "C3'"  C    CH1       0.000     -3.758    1.373   -3.192
 DG            "H3'"  H    H         0.000     -3.624    2.391   -2.801
 DG            "O3'"  O    OH1       0.000     -3.218    1.283   -4.520
 DG            "HO3'" H    H         0.000     -3.707    1.875   -5.109
 DG            "C2'"  C    CH2       0.000     -5.268    0.993   -3.183
 DG            "H2' " H    H         0.000     -5.554    0.561   -4.144
 DG            "H2''" H    H         0.000     -5.879    1.877   -2.987
 DG            "C1'"  C    CH1       0.000     -5.488   -0.042   -2.067
 DG            "H1'"  H    H         0.000     -5.742   -0.995   -2.554
 DG            "O4'"  O    O2        0.000     -4.180   -0.201   -1.473
 DG            N9     N    NR5       0.000     -6.561    0.242   -1.071
 DG            C4     C    CR56      0.000     -7.783   -0.323   -0.980
 DG            C5     C    CR56      0.000     -8.470    0.361    0.156
 DG            N7     N    NRD5      0.000     -7.502    0.995    0.805
 DG            C8     C    CR15      0.000     -6.341    0.713    0.168
 DG            H8     H    H         0.000     -5.358    0.850    0.603
 DG            N3     N    NRD6      0.000     -8.662   -0.949   -1.782
 DG            C2     C    CR6       0.000     -9.985   -1.121   -1.470
 DG            N2     N    NH2       0.000    -10.687   -1.850   -2.375
 DG            H22    H    H         0.000    -10.227   -2.215   -3.197
 DG            H21    H    H         0.000    -11.671   -2.027   -2.227
 DG            N1     N    NR16      0.000    -10.616   -0.564   -0.437
 DG            H1     H    H         0.000    -11.634   -0.721   -0.294
 DG            C6     C    CR6       0.000     -9.926    0.195    0.408
 DG            O6     O    O         0.000    -10.487    0.731    1.387
 DG            OP2    O    OP       -0.660      0.998   -0.164   -0.933
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DG       "O5'"  n/a    "C5'"  START
 DG       P     "O5'"   OP2    .    
 DG       OP3    P      .      .
 DG       OP1    P      .      .
 DG       "C5'"  "O5'"  "C4'"  .
 DG       "H5'" "C5'"  .      .
 DG       "H5''" "C5'"  .      .
 DG       "C4'"  "C5'"  "C3'"  .
 DG       "H4'"  "C4'"  .      .
 DG       "C3'"  "C4'"  "C2'"  .
 DG       "H3'"  "C3'"  .      .
 DG       "O3'"  "C3'"  "HO3'" .
 DG       "HO3'" "O3'"  .      .
 DG       "C2'"  "C3'"  "C1'"  .
 DG       "H2' " "C2'"  .      .
 DG       "H2''" "C2'"  .      .
 DG       "C1'"  "C2'"  N9     .
 DG       "H1'"  "C1'"  .      .
 DG       "O4'"  "C1'"  .      .
 DG       N9     "C1'"  C4     .
 DG       C4     N9     N3     .
 DG       C5     C4     N7     .
 DG       N7     C5     C8     .
 DG       C8     N7     H8     .
 DG       H8     C8     .      .
 DG       N3     C4     C2     .
 DG       C2     N3     N1     .
 DG       N2     C2     H21    .
 DG       H22    N2     .      .
 DG       H21    N2     .      .
 DG       N1     C2     C6     .
 DG       H1     N1     .      .
 DG       C6     N1     O6     .
 DG       OP2    P      .      .  
 DG       O6     C6     .      END
 DG       "C4'"  "O4'"  .    ADD
 DG       N9     C8     .    ADD
 DG       C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DG       OP3    P         deloc       1.485    0.017
 DG       OP1    P         deloc       1.485    0.017
 DG       OP2    P         deloc       1.485    0.017
 DG       "O5'"  P         single      1.593    0.010
 DG       "C5'"  "O5'"     single      1.440    0.016
 DG       "C4'"  "C5'"     single      1.511    0.008
 DG       "C4'"  "O4'"     single      1.446    0.011
 DG       "C3'"  "C4'"     single      1.528    0.010
 DG       "O4'"  "C1'"     single      1.420    0.013
 DG       "O3'"  "C3'"     single      1.431    0.013
 DG       "C2'"  "C3'"     single      1.518    0.010
 DG       "C1'"  "C2'"     single      1.521    0.014
 DG       N9     "C1'"     single      1.459    0.009
 DG       N9     C8        single      1.374    0.007
 DG       C4     N9        single      1.375    0.008
 DG       C8     N7        double      1.305    0.006
 DG       N7     C5        single      1.388    0.006
 DG       C5     C6        single      1.419    0.010
 DG       C5     C4        double      1.379    0.007
 DG       O6     C6        double      1.237    0.009
 DG       C6     N1        single      1.391    0.007
 DG       N1     C2        single      1.373    0.008
 DG       N2     C2        single      1.341    0.010
 DG       C2     N3        double      1.323    0.008
 DG       N3     C4        single      1.350    0.007
 DG       "H5'" "C5'"     single      1.092    0.020
 DG       "H5''" "C5'"     single      1.092    0.020
 DG       "H4'"  "C4'"     single      1.099    0.020
 DG       "H3'"  "C3'"     single      1.099    0.020
 DG       "HO3'" "O3'"     single      0.967    0.020
 DG       "H2' " "C2'"     single      1.092    0.020
 DG       "H2''" "C2'"     single      1.092    0.020
 DG       "H1'"  "C1'"     single      1.099    0.020
 DG       H8     C8        single      1.083    0.020
 DG       H1     N1        single      1.040    0.020
 DG       H21    N2        single      1.010    0.020
 DG       H22    N2        single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DG       OP3    P      OP1     107.400    3.200
 DG       OP3    P      "O5'"   104.000    1.900
 DG       OP1    P      "O5'"   108.100    2.900
 DG       OP3    P      OP2     108.300    3.200
 DG       OP1    P      OP2     119.600    1.500
 DG       "O5'"  P      OP2     108.300    2.700
 DG       P      "O5'"  "C5'"   120.900    1.600
 DG       "O5'"  "C5'"  "H5'"  109.470    3.000
 DG       "O5'"  "C5'"  "H5''"  109.470    3.000
 DG       "O5'"  "C5'"  "C4'"   110.200    1.400
 DG       "H5'" "C5'"  "H5''"  107.900    3.000
 DG       "H5'" "C5'"  "C4'"   109.470    3.000
 DG       "H5''" "C5'"  "C4'"   109.470    3.000
 DG       "C5'"  "C4'"  "H4'"   108.340    3.000
 DG       "C5'"  "C4'"  "C3'"   114.700    1.500
 DG       "C5'"  "C4'"  "O4'"   109.400    1.600
 DG       "H4'"  "C4'"  "C3'"   108.340    3.000
 DG       "H4'"  "C4'"  "O4'"   109.470    3.000
 DG       "C3'"  "C4'"  "O4'"   105.600    1.000
 DG       "C4'"  "C3'"  "H3'"   108.340    3.000
 DG       "C4'"  "C3'"  "O3'"   110.300    2.200
 DG       "C4'"  "C3'"  "C2'"   103.200    1.000
 DG       "H3'"  "C3'"  "O3'"   109.470    3.000
 DG       "H3'"  "C3'"  "C2'"   108.340    3.000
 DG       "O3'"  "C3'"  "C2'"   110.600    2.700
 DG       "C3'"  "O3'"  "HO3'"  109.470    3.000
 DG       "C3'"  "C2'"  "H2' "  109.470    3.000
 DG       "C3'"  "C2'"  "H2''"  109.470    3.000
 DG       "C3'"  "C2'"  "C1'"   102.700    1.400
 DG       "H2' " "C2'"  "H2''"  107.900    3.000
 DG       "H2' " "C2'"  "C1'"   109.470    3.000
 DG       "H2''" "C2'"  "C1'"   109.470    3.000
 DG       "C2'"  "C1'"  "H1'"   108.340    3.000
 DG       "C2'"  "C1'"  "O4'"   106.100    1.100
 DG       "C2'"  "C1'"  N9      114.200    1.600
 DG       "H1'"  "C1'"  "O4'"   109.470    3.000
 DG       "H1'"  "C1'"  N9      109.470    3.000
 DG       "O4'"  "C1'"  N9      107.800    0.800
 DG       "C1'"  "O4'"  "C4'"   109.700    1.400
 DG       "C1'"  N9     C4      126.500    1.300
 DG       "C1'"  N9     C8      127.000    1.300
 DG       C4     N9     C8      106.400    0.400
 DG       N9     C4     C5      105.400    0.400
 DG       N9     C4     N3      126.000    0.600
 DG       C5     C4     N3      128.600    0.500
 DG       C4     C5     N7      110.800    0.400
 DG       C4     C5     C6      118.800    0.600
 DG       N7     C5     C6      130.400    0.600
 DG       C5     N7     C8      104.300    0.500
 DG       N7     C8     H8      126.000    3.000
 DG       N7     C8     N9      113.100    0.500
 DG       H8     C8     N9      126.000    3.000
 DG       C4     N3     C2      111.900    0.500
 DG       N3     C2     N2      119.900    0.700
 DG       N3     C2     N1      123.900    0.600
 DG       N2     C2     N1      116.200    0.900
 DG       C2     N2     H22     120.000    3.000
 DG       C2     N2     H21     120.000    3.000
 DG       H22    N2     H21     120.000    3.000
 DG       C2     N1     H1      120.000    3.000
 DG       C2     N1     C6      125.100    0.600
 DG       H1     N1     C6      120.000    3.000
 DG       N1     C6     O6      119.900    0.600
 DG       N1     C6     C5      111.500    0.500
 DG       O6     C6     C5      128.600    0.600
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DG        C2e-nyu0 C4'    O4'    C1'    C2'      340.700    6.300   1
 DG        C2e-nyu1 O4'    C1'    C2'    C3'       32.800    4.900   1
 DG        C2e-nyu2 C1'    C2'    C3'    C4'      326.9      3.600   1
 DG        C2e-nyu3 C2'    C3'    C4'    O4'       22.600    4.500   1
 DG        C2e-nyu4 C3'    C4'    O4'    C1'      357.700    6.100   1
 DG        C2e-delta C5'    C4'   C3'    O3'      145.2000    4.000   1
 DG        C2e-C4N9 C4'    O4'   C1'     N9       217.700    5.500   1


 DG        C3e-nyu0 C4'    O4'    C1'    C2'        2.8      6.100   1
 DG        C3e-nyu1 O4'    C1'    C2'    C3'      335.00     4.900   1
 DG        C3e-nyu2 C1'    C2'    C3'    C4'       35.9      2.800   1
 DG        C3e-nyu3 C2'    C3'    C4'    O4'      324.700    3.100   1
 DG        C3e-nyu4 C3'    C4'    O4'    C1'       20.500    5.100   1
 DG        C3e-delta C5'    C4'   C3'    O3'        84.800    4.500   1
 DG        C2e-C4N9 C4'    O4'   C1'     N9       245.600    2.500   1


 DG       var_1    OP2    P      "O5'"  "C5'"    -60.054   20.000   1
 DG       var_2    P      "O5'"  "C5'"  "C4'"   -179.992   20.000   1
 DG       var_3    "O5'"  "C5'"  "C4'"  "C3'"    179.992   20.000   3
 DG       var_4    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 DG       var_5    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 DG       var_6    "C4'"  "C3'"  "O3'"  "HO3'"   175.000   20.000   1
 DG       var_8    "C3'"  "C2'"  "C1'"  N9       120.000   20.000   3
 DG       var_10   "C2'"  "C1'"  N9     C4        90.187   20.000   1
 DG       CONST_1  "C1'"  N9     C8     N7       180.000    0.000   0
 DG       CONST_2  "C1'"  N9     C4     N3         0.000    0.000   0
 DG       CONST_3  N9     C4     C5     N7         0.000    0.000   0
 DG       CONST_4  C4     C5     C6     N1         0.000    0.000   0
 DG       CONST_5  C4     C5     N7     C8         0.000    0.000   0
 DG       CONST_6  C5     N7     C8     N9         0.000    0.000   0
 DG       CONST_7  N9     C4     N3     C2       180.000    0.000   0
 DG       CONST_8  C4     N3     C2     N1         0.000    0.000   0
 DG       CONST_9  N3     C2     N2     H21      180.000    0.000   0
 DG       CONST_10 N3     C2     N1     C6         0.000    0.000   0
 DG       CONST_11 C2     N1     C6     O6       180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DG       chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 DG       chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 DG       chir_03  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DG       plan-1    N9        0.020
 DG       plan-1    "C1'"     0.020
 DG       plan-1    C8        0.020
 DG       plan-1    C4        0.020
 DG       plan-1    N7        0.020
 DG       plan-1    H8        0.020
 DG       plan-1    C5        0.020
 DG       plan-1    C6        0.020
 DG       plan-1    N1        0.020
 DG       plan-1    C2        0.020
 DG       plan-1    N3        0.020
 DG       plan-1    O6        0.020
 DG       plan-1    H1        0.020
 DG       plan-1    N2        0.020
 DG       plan-1    H22       0.020
 DG       plan-1    H21       0.020
 DG       plan-2    N2        0.020
 DG       plan-2    C2        0.020
 DG       plan-2    H21       0.020
 DG       plan-2    H22       0.020
# ------------------------------------------------------
# ------------------------------------------------------
# ------------------------------------------------------
`.trim();

monomers["DT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DT       DT  'THYMIDINE-5'-MONOPHOSPHATE          ' DNA                34  21 .
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DT            P      P    P         0.000      0.013    0.030   -0.075
 DT            OP3    O    OP       -0.660     -0.589   -1.011    0.843
 DT            OP1    O    OP       -0.660      1.224   -0.476   -0.823
 DT            "O5'"  O    O2        0.000     -1.088    0.308   -1.228
 DT            "C5'"  C    CH2       0.000     -2.338    0.881   -0.836
 DT            "H5'" H    H         0.000     -2.128    1.849   -0.377
 DT            "H5''" H    H         0.000     -2.786    0.217   -0.093
 DT            "C4'"  C    CH1       0.000     -3.297    1.066   -1.994
 DT            "H4'"  H    H         0.000     -2.865    1.792   -2.697
 DT            "C3'"  C    CH1       0.000     -4.742    1.504   -1.654
 DT            "H3'"  H    H         0.000     -4.810    2.046   -0.700
 DT            "O3'"  O    OH1       0.000     -5.174    2.295   -2.776
 DT            "HO3'" H    H         0.000     -6.104    2.537   -2.662
 DT            "C2'"  C    CH2       0.000     -5.532    0.173   -1.644
 DT            "H2' " H    H         0.000     -6.535    0.301   -2.056
 DT            "H2''" H    H         0.000     -5.604   -0.240   -0.636
 DT            "C1'"  C    CH1       0.000     -4.722   -0.794   -2.543
 DT            "H1'"  H    H         0.000     -5.182   -0.794   -3.542
 DT            "O4'"  O    O2        0.000     -3.408   -0.212   -2.658
 DT            N1     N    NR6       0.000     -4.674   -2.184   -2.064
 DT            C6     C    CR16      0.000     -3.621   -2.648   -1.371
 DT            H6     H    H         0.000     -2.786   -1.975   -1.217
 DT            C5     C    CR6       0.000     -3.521   -3.938   -0.831
 DT            C7     C    CH3       0.000     -2.368   -4.279    0.074
 DT            H73    H    H         0.000     -1.463   -4.228   -0.473
 DT            H72    H    H         0.000     -2.334   -3.589    0.877
 DT            H71    H    H         0.000     -2.496   -5.258    0.455
 DT            C4     C    CR6       0.000     -4.533   -4.912   -1.261
 DT            N3     N    NR16      0.000     -5.439   -4.431   -2.127
 DT            H3     H    H         0.000     -6.159   -5.099   -2.467
 DT            C2     C    CR6       0.000     -5.511   -3.170   -2.601
 DT            O2     O    O         0.000     -6.474   -2.893   -3.352
 DT            O4     O    O         0.000     -4.557   -6.109   -0.904
 DT            OP2    O    OP       -0.660      0.258    1.360    0.609
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DT       "O5'"  n/a    "C5'"  START
 DT       P     "O5'"   OP2    .    
 DT       OP3    P      .      .
 DT       OP1    P      .      .
 DT       "C5'"  "O5'"  "C4'"  .
 DT       "H5'" "C5'"  .      .
 DT       "H5''" "C5'"  .      .
 DT       "C4'"  "C5'"  "C3'"  .
 DT       "H4'"  "C4'"  .      .
 DT       "C3'"  "C4'"  "C2'"  .
 DT       "H3'"  "C3'"  .      .
 DT       "O3'"  "C3'"  "HO3'" .
 DT       "HO3'" "O3'"  .      .
 DT       "C2'"  "C3'"  "C1'"  .
 DT       "H2' " "C2'"  .      .
 DT       "H2''" "C2'"  .      .
 DT       "C1'"  "C2'"  N1     .
 DT       "H1'"  "C1'"  .      .
 DT       "O4'"  "C1'"  .      .
 DT       N1     "C1'"  C6     .
 DT       C6     N1     C5     .
 DT       H6     C6     .      .
 DT       C5     C6     C4     .
 DT       C7     C5     H71    .
 DT       H73    C7     .      .
 DT       H72    C7     .      .
 DT       H71    C7     .      .
 DT       C4     C5     O4     .
 DT       N3     C4     C2     .
 DT       H3     N3     .      .
 DT       C2     N3     O2     .
 DT       O2     C2     .      .
 DT       OP2    P      .      .   
 DT       O4     C4     .      END
 DT       "C4'"  "O4'"  .    ADD
 DT       N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DT       OP3    P         deloc       1.485    0.017
 DT       OP1    P         deloc       1.485    0.017
 DT       OP2    P         deloc       1.485    0.017
 DT       "O5'"  P         single      1.593    0.010
 DT       "C5'"  "O5'"     single      1.440    0.016
 DT       "C4'"  "C5'"     single      1.511    0.008
 DT       "C4'"  "O4'"     single      1.446    0.011
 DT       "C3'"  "C4'"     single      1.528    0.010
 DT       "O4'"  "C1'"     single      1.420    0.013
 DT       "O3'"  "C3'"     single      1.431    0.013
 DT       "C2'"  "C3'"     single      1.518    0.010
 DT       "C1'"  "C2'"     single      1.521    0.014
 DT       N1     "C1'"     single      1.473    0.014
 DT       N1     C2        single      1.376    0.008
 DT       C6     N1        single      1.378    0.007
 DT       O2     C2        double      1.220    0.008
 DT       C2     N3        single      1.373    0.008
 DT       N3     C4        single      1.382    0.008
 DT       O4     C4        double      1.228    0.009
 DT       C4     C5        single      1.445    0.009 
 DT       C7     C5        single      1.496    0.006
 DT       C5     C6        double      1.339    0.007
 DT       "H5'" "C5'"     single      1.092    0.020
 DT       "H5''" "C5'"     single      1.092    0.020
 DT       "H4'"  "C4'"     single      1.099    0.020
 DT       "H3'"  "C3'"     single      1.099    0.020
 DT       "HO3'" "O3'"     single      0.967    0.020
 DT       "H2' " "C2'"     single      1.092    0.020
 DT       "H2''" "C2'"     single      1.092    0.020
 DT       "H1'"  "C1'"     single      1.099    0.020
 DT       H3     N3        single      1.040    0.020
 DT       H71    C7        single      1.059    0.020
 DT       H72    C7        single      1.059    0.020
 DT       H73    C7        single      1.059    0.020
 DT       H6     C6        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DT       OP3    P      OP1     107.400    3.200
 DT       OP3    P      "O5'"   104.000    1.900
 DT       OP1    P      "O5'"   108.100    2.900
 DT       OP3    P      OP2     108.300    3.200
 DT       OP1    P      OP2     119.600    1.500
 DT       "O5'"  P      OP2     108.300    2.700
 DT       P      "O5'"  "C5'"   120.900    1.600
 DT       "O5'"  "C5'"  "H5'"  109.470    3.000
 DT       "O5'"  "C5'"  "H5''"  109.470    3.000
 DT       "O5'"  "C5'"  "C4'"   110.200    1.400
 DT       "H5'" "C5'"  "H5''"  107.900    3.000
 DT       "H5'" "C5'"  "C4'"   109.470    3.000
 DT       "H5''" "C5'"  "C4'"   109.470    3.000
 DT       "C5'"  "C4'"  "H4'"   108.340    3.000
 DT       "C5'"  "C4'"  "C3'"   114.700    1.500
 DT       "C5'"  "C4'"  "O4'"   109.400    1.600
 DT       "H4'"  "C4'"  "C3'"   108.340    3.000
 DT       "H4'"  "C4'"  "O4'"   109.470    3.000
 DT       "C3'"  "C4'"  "O4'"   105.600    1.000
 DT       "C4'"  "C3'"  "H3'"   108.340    3.000
 DT       "C4'"  "C3'"  "O3'"   110.300    2.200
 DT       "C4'"  "C3'"  "C2'"   103.200    1.000
 DT       "H3'"  "C3'"  "O3'"   109.470    3.000
 DT       "H3'"  "C3'"  "C2'"   108.340    3.000
 DT       "O3'"  "C3'"  "C2'"   110.600    2.700
 DT       "C3'"  "O3'"  "HO3'"  109.470    3.000
 DT       "C3'"  "C2'"  "H2' "  109.470    3.000
 DT       "C3'"  "C2'"  "H2''"  109.470    3.000
 DT       "C3'"  "C2'"  "C1'"   102.700    1.400
 DT       "H2' " "C2'"  "H2''"  107.900    3.000
 DT       "H2' " "C2'"  "C1'"   109.470    3.000
 DT       "H2''" "C2'"  "C1'"   109.470    3.000
 DT       "C2'"  "C1'"  "H1'"   108.340    3.000
 DT       "C2'"  "C1'"  "O4'"   106.100    1.100
 DT       "C2'"  "C1'"  N1      114.200    1.600
 DT       "H1'"  "C1'"  "O4'"   109.470    3.000
 DT       "H1'"  "C1'"  N1      109.470    3.000
 DT       "O4'"  "C1'"  N1      107.800    0.800
 DT       "C1'"  "O4'"  "C4'"   109.700    1.400
 DT       "C1'"  N1     C6      120.400    1.500
 DT       "C1'"  N1     C2      118.200    1.600
 DT       C6     N1     C2      121.300    0.500
 DT       N1     C6     H6      120.000    3.000
 DT       N1     C6     C5      123.700    0.600
 DT       H6     C6     C5      120.000    3.000
 DT       C6     C5     C7      122.900    0.600
 DT       C6     C5     C4      118.000    0.600
 DT       C7     C5     C4      119.000    0.600
 DT       C5     C7     H73     109.470    3.000
 DT       C5     C7     H72     109.470    3.000
 DT       C5     C7     H71     109.470    3.000
 DT       H73    C7     H72     109.470    3.000
 DT       H73    C7     H71     109.470    3.000
 DT       H72    C7     H71     109.470    3.000
 DT       C5     C4     N3      115.200    0.600
 DT       C5     C4     O4      124.900    0.700
 DT       N3     C4     O4      119.900    0.600
 DT       C4     N3     H3      120.000    3.000
 DT       C4     N3     C2      127.200    0.600
 DT       H3     N3     C2      120.000    3.000
 DT       N3     C2     O2      122.300    0.600
 DT       N3     C2     N1      114.600    0.600
 DT       O2     C2     N1      123.100    0.800
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DT        C2e-nyu0 C4'    O4'    C1'    C2'      340.700    6.300   1
 DT        C2e-nyu1 O4'    C1'    C2'    C3'       32.800    4.900   1
 DT        C2e-nyu2 C1'    C2'    C3'    C4'      326.9      3.600   1
 DT        C2e-nyu3 C2'    C3'    C4'    O4'       22.600    4.500   1
 DT        C2e-nyu4 C3'    C4'    O4'    C1'      357.700    6.100   1
 DT        C2e-delta C5'    C4'   C3'    O3'      145.2000    4.000   1
 DT        C2e-C4N1 C4'    O4'   C1'     N9       217.700    6.700   1


 DT        C3e-nyu0 C4'    O4'    C1'    C2'        2.8      6.100   1
 DT        C3e-nyu1 O4'    C1'    C2'    C3'      335.00     4.900   1
 DT        C3e-nyu2 C1'    C2'    C3'    C4'       35.9      2.800   1
 DT        C3e-nyu3 C2'    C3'    C4'    O4'      324.700    3.100   1
 DT        C3e-nyu4 C3'    C4'    O4'    C1'       20.500    5.100   1
 DT        C3e-delta C5'    C4'   C3'    O3'        84.800    4.500   1
 DT        C2e-C4N1 C4'    O4'   C1'     N9       245.600    2.500   1


 DT       var_1    OP2    P      "O5'"  "C5'"    -54.229   20.000   1
 DT       var_2    P      "O5'"  "C5'"  "C4'"    179.971   20.000   1
 DT       var_3    "O5'"  "C5'"  "C4'"  "C3'"    179.531   20.000   3
 DT       var_4    "C5'"  "C4'"  "O4'"  "C1'"    120.000   20.000   1
 DT       var_5    "C5'"  "C4'"  "C3'"  "C2'"    -90.000   20.000   3
 DT       var_6    "C4'"  "C3'"  "O3'"  "HO3'"   175.000   20.000   1
 DT       var_8    "C3'"  "C2'"  "C1'"  N1       150.000   20.000   3
 DT       var_10   "C2'"  "C1'"  N1     C6       -86.506   20.000   1
 DT       CONST_1  "C1'"  N1     C2     N3       180.000    0.000   0
 DT       CONST_2  "C1'"  N1     C6     C5       180.000    0.000   0
 DT       CONST_3  N1     C6     C5     C4         0.000    0.000   0
 DT       var_11   C6     C5     C7     H71      175.000   20.000   1
 DT       CONST_4  C6     C5     C4     O4       180.000    0.000   0
 DT       CONST_5  C5     C4     N3     C2         0.000    0.000   0
 DT       CONST_6  C4     N3     C2     O2       180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DT       chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 DT       chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 DT       chir_03  "C1'"  "O4'"  "C2'"  N1        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DT       plan-1    N1        0.020
 DT       plan-1    "C1'"     0.020
 DT       plan-1    C2        0.020
 DT       plan-1    C6        0.020
 DT       plan-1    N3        0.020
 DT       plan-1    C4        0.020
 DT       plan-1    C5        0.020
 DT       plan-1    O2        0.020
 DT       plan-1    H3        0.020
 DT       plan-1    O4        0.020
 DT       plan-1    C7        0.020
 DT       plan-1    H6        0.020
# ------------------------------------------------------
# ------------------------------------------------------
# ------------------------------------------------------
`.trim();

monomers["A"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
A        A   'ADENOSINE-5'-MONOPHOSPHATE          ' RNA                35  23 .
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_A
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 A             P      P    P         0.000     -0.003   -0.405    0.200
 A             OP3    O    OP       -0.660      0.429   -1.625    0.978
 A             OP1    O    OP       -0.660      0.213    0.886    0.959
 A             OP2    O    OP       -0.660      0.528   -0.386   -1.216
 A             "O5'"  O    O2        0.000     -1.607   -0.542    0.062
 A             "C5'"  C    CH2       0.000     -2.368    0.488   -0.595
 A             "H5' " H    H         0.000     -1.931    0.694   -1.575
 A             "H5''" H    H         0.000     -2.347    1.397    0.009
 A             "C4'"  C    CH1       0.000     -3.806    0.025   -0.767
 A             "H4'"  H    H         0.000     -3.772   -0.934   -1.301
 A             "C3'"  C    CH1       0.000     -4.830    0.914   -1.500
 A             "H3'"  H    H         0.000     -4.486    1.958   -1.511
 A             "O3'"  O    OH1       0.000     -5.049    0.450   -2.841
 A             "HO3'" H    H         0.000     -5.750    0.973   -3.254
 A             "C2'"  C    CH1       0.000     -6.131    0.786   -0.657
 A             "H2'"  H    H         0.000     -6.410    1.774   -0.265
 A             "O2'"  O    OH1       0.000     -7.229    0.243   -1.404
 A             "HO2'" H    H         0.000     -7.986    0.112   -0.816
 A             "C1'"  C    CH1       0.000     -5.796   -0.154    0.517
 A             "H1'"  H    H         0.000     -6.179   -1.151    0.257
 A             "O4'"  O    O2        0.000     -4.359   -0.239    0.540
 A             N9     N    NR5       0.000     -6.368    0.208    1.842
 A             C4     C    CR56      0.000     -7.478   -0.316    2.375
 A             C5     C    CR56      0.000     -7.695    0.416    3.664
 A             N7     N    NRD5      0.000     -6.556    1.058    3.891
 A             C8     C    CR15      0.000     -5.716    0.765    2.869
 A             H8     H    H         0.000     -4.650    0.957    2.883
 A             N3     N    NRD6      0.000     -8.459   -1.089    1.874
 A             C2     C    CR16      0.000     -9.586   -1.221    2.569
 A             H2     H    H         0.000    -10.383   -1.815    2.140
 A             N1     N    NRD6      0.000     -9.794   -0.659    3.773
 A             C6     C    CR6       0.000     -8.924    0.147    4.423
 A             N6     N    NH2       0.000     -9.258    0.673    5.620
 A             H62    H    H         0.000    -10.157    0.465    6.028
 A             H61    H    H         0.000     -8.609    1.275    6.104
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 A        "O5'"  n/a      "C5'"  START
 A        P      "O5'"  .    .    
 A        OP3    P      .      .
 A        OP1    P      .      .
 A        OP2    P      .      .
 A        "C5'"  "O5'"  "C4'"  .
 A        "H5' " "C5'"  .      .
 A        "H5''" "C5'"  .      .
 A        "C4'"  "C5'"  "C3'"  .
 A        "H4'"  "C4'"  .      .
 A        "C3'"  "C4'"  "C2'"  .
 A        "H3'"  "C3'"  .      .
 A        "O3'"  "C3'"  "HO3'" .
 A        "HO3'" "O3'"  .      .
 A        "C2'"  "C3'"  "C1'"  .
 A        "H2'"  "C2'"  .      .
 A        "O2'"  "C2'"  "HO2'" .
 A        "HO2'" "O2'"  .      .
 A        "C1'"  "C2'"  N9     .
 A        "H1'"  "C1'"  .      .
 A        "O4'"  "C1'"  .      .
 A        N9     "C1'"  C4     .
 A        C4     N9     N3     .
 A        C5     C4     N7     .
 A        N7     C5     C8     .
 A        C8     N7     H8     .
 A        H8     C8     .      .
 A        N3     C4     C2     .
 A        C2     N3     N1     .
 A        H2     C2     .      .
 A        N1     C2     C6     .
 A        C6     N1     N6     .
 A        N6     C6     H61    .
 A        H62    N6     .      .
 A        H61    N6     .      END
 A        "C4'"  "O4'"  .    ADD
 A        N9     C8     .    ADD
 A        C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 A        OP3    P         deloc       1.485    0.017
 A        OP1    P         deloc       1.485    0.017
 A        OP2    P         deloc       1.485    0.017
 A        "O5'"  P         single      1.593    0.010
 A        "C5'"  "O5'"     single      1.440    0.016
 A        "C4'"  "C5'"     single      1.510    0.013
 A        "C4'"  "O4'"     single      1.453    0.012
 A        "C3'"  "C4'"     single      1.528    0.010
 A        "O4'"  "C1'"     single      1.414    0.012
 A        "O3'"  "C3'"     single      1.423    0.014
 A        "C2'"  "C3'"     single      1.525    0.011
 A        "O2'"  "C2'"     single      1.413    0.013
 A        "C1'"  "C2'"     single      1.528    0.010
 A        N9     "C1'"     single      1.462    0.010
 A        N9     C8        single      1.373    0.008
 A        C4     N9        single      1.374    0.006
 A        C8     N7        double      1.311    0.007
 A        N7     C5        single      1.388    0.006
 A        C5     C6        single      1.406    0.009
 A        C5     C4        double      1.383    0.007
 A        N6     C6        single      1.335    0.008
 A        C6     N1        double      1.351    0.007
 A        N1     C2        single      1.339    0.009
 A        C2     N3        double      1.331    0.009
 A        N3     C4        single      1.344    0.006
 A        "H5' " "C5'"     single      1.092    0.020
 A        "H5''" "C5'"     single      1.092    0.020
 A        "H4'"  "C4'"     single      1.099    0.020
 A        "H3'"  "C3'"     single      1.099    0.020
 A        "HO3'" "O3'"     single      0.967    0.020
 A        "H2'"  "C2'"     single      1.099    0.020
 A        "HO2'" "O2'"     single      0.967    0.020
 A        "H1'"  "C1'"     single      1.099    0.020
 A        H8     C8        single      1.083    0.020
 A        H61    N6        single      1.010    0.020
 A        H62    N6        single      1.010    0.020
 A        H2     C2        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 A        OP3    P      OP1     107.400    3.200
 A        OP3    P      OP2     108.300    3.200
 A        OP1    P      OP2     119.600    1.500
 A        OP3    P      "O5'"   104.000    1.900
 A        OP1    P      "O5'"   108.100    2.900
 A        OP2    P      "O5'"   108.300    2.700
 A        P      "O5'"  "C5'"   120.900    1.600
 A        "O5'"  "C5'"  "H5' "  109.470    3.000
 A        "O5'"  "C5'"  "H5''"  109.470    3.000
 A        "O5'"  "C5'"  "C4'"   110.200    1.400
 A        "H5' " "C5'"  "H5''"  107.900    3.000
 A        "H5' " "C5'"  "C4'"   109.470    3.000
 A        "H5''" "C5'"  "C4'"   109.470    3.000
 A        "C5'"  "C4'"  "H4'"   108.340    3.000
 A        "C5'"  "C4'"  "C3'"   115.500    1.500
 A        "C5'"  "C4'"  "O4'"   109.200    1.400
 A        "H4'"  "C4'"  "C3'"   108.340    3.000
 A        "H4'"  "C4'"  "O4'"   109.470    3.000
 A        "C3'"  "C4'"  "O4'"   105.500    1.400
 A        "C4'"  "C3'"  "H3'"   108.340    3.000
 A        "C4'"  "C3'"  "O3'"   110.600    2.600
 A        "C4'"  "C3'"  "C2'"   102.700    1.000
 A        "H3'"  "C3'"  "O3'"   109.470    3.000
 A        "H3'"  "C3'"  "C2'"   108.340    3.000
 A        "O3'"  "C3'"  "C2'"   111.000    2.800
 A        "C3'"  "O3'"  "HO3'"  109.470    3.000
 A        "C3'"  "C2'"  "H2'"   108.340    3.000
 A        "C3'"  "C2'"  "O2'"   113.300    2.900
 A        "C3'"  "C2'"  "C1'"   101.500    0.900
 A        "H2'"  "C2'"  "O2'"   109.470    3.000
 A        "H2'"  "C2'"  "C1'"   108.340    3.000
 A        "O2'"  "C2'"  "C1'"   110.600    3.000
 A        "C2'"  "O2'"  "HO2'"  109.470    3.000
 A        "C2'"  "C1'"  "H1'"   108.340    3.000
 A        "C2'"  "C1'"  "O4'"   106.400    1.400
 A        "C2'"  "C1'"  N9      113.400    1.600
 A        "H1'"  "C1'"  "O4'"   109.470    3.000
 A        "H1'"  "C1'"  N9      109.470    3.000
 A        "O4'"  "C1'"  N9      108.200    1.000
 A        "C1'"  "O4'"  "C4'"   109.600    0.900
 A        "C1'"  N9     C4      126.300    1.800
 A        "C1'"  N9     C8      127.700    1.800
 A        C4     N9     C8      105.800    0.400
 A        N9     C4     C5      105.800    0.400
 A        N9     C4     N3      127.400    0.800
 A        C5     C4     N3      126.800    0.700
 A        C4     C5     N7      110.700    0.500
 A        C4     C5     C6      117.000    0.500
 A        N7     C5     C6      132.300    0.700
 A        C5     N7     C8      103.900    0.500
 A        N7     C8     H8      126.000    3.000
 A        N7     C8     N9      113.800    0.500
 A        H8     C8     N9      126.000    3.000
 A        C4     N3     C2      110.600    0.500
 A        N3     C2     H2      120.000    3.000
 A        N3     C2     N1      129.300    0.500
 A        H2     C2     N1      120.000    3.000
 A        C2     N1     C6      118.600    0.600
 A        N1     C6     N6      118.600    0.600
 A        N1     C6     C5      117.700    0.500
 A        N6     C6     C5      123.700    0.800
 A        C6     N6     H62     120.000    3.000
 A        C6     N6     H61     120.000    3.000
 A        H62    N6     H61     120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period

 A        C2e-nyu0 C4'    O4'    C1'    C2'      339.000    5.000   1
 A        C2e-nyu1 O4'    C1'    C2'    C3'       35.000    3.400   1
 A        C2e-nyu2 C1'    C2'    C3'    C4'      324.000    2.800   1
 A        C2e-nyu3 C2'    C3'    C4'    O4'       24.000    4.400   1
 A        C2e-nyu4 C3'    C4'    O4'    C1'      357.700    5.700   1
 A        C2e-delta C5'    C4'   C3'    O3'       147.300    4.900   1
 A        C2e-C4N9 C4'    O4'   C1'     N9       216.600    5.500   1

 A        C3e-nyu0 C4'    O4'    C1'    C2'        2.8      6.100   1
 A        C3e-nyu1 O4'    C1'    C2'    C3'      335.00     4.900   1
 A        C3e-nyu2 C1'    C2'    C3'    C4'       35.9      2.800   1
 A        C3e-nyu3 C2'    C3'    C4'    O4'      324.700    3.100   1
 A        C3e-nyu4 C3'    C4'    O4'    C1'       20.500    5.100   1
 A        C3e-delta C5'    C4'   C3'    O3'        81.0      4.400   1
 A        C3e-C4N9 C4'    O4'   C1'     N9       241.400    6.500   1
 
 A        var_1    OP2    P      "O5'"  "C5'"    -60.045   20.000   1
 A        var_2    P      "O5'"  "C5'"  "C4'"   -179.958   20.000   1
 A        var_3    "O5'"  "C5'"  "C4'"  "C3'"    176.951   20.000   3
 A        var_4    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 A        var_5    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 A        var_6    "C4'"  "C3'"  "O3'"  "HO3'"   175.000   20.000   1
 A        var_8    "C3'"  "C2'"  "O2'"  "HO2'"   175.000   20.000   1
 A        var_9    "C3'"  "C2'"  "C1'"  N9       150.000   20.000   3
 A        var_11   "C2'"  "C1'"  N9     C4        91.469   20.000   1
 A        CONST_1  "C1'"  N9     C8     N7       180.000    0.000   0
 A        CONST_2  "C1'"  N9     C4     N3         0.000    0.000   0
 A        CONST_3  N9     C4     C5     N7         0.000    0.000   0
 A        CONST_4  C4     C5     C6     N1         0.000    0.000   0
 A        CONST_5  C4     C5     N7     C8         0.000    0.000   0
 A        CONST_6  C5     N7     C8     N9         0.000    0.000   0
 A        CONST_7  N9     C4     N3     C2       180.000    0.000   0
 A        CONST_8  C4     N3     C2     N1         0.000    0.000   0
 A        CONST_9  N3     C2     N1     C6         0.000    0.000   0
 A        CONST_10 C2     N1     C6     N6       180.000    0.000   0
 A        CONST_11 N1     C6     N6     H61      180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 A        chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 A        chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 A        chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 A        chir_04  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 A        plan-1    N9        0.020
 A        plan-1    "C1'"     0.020
 A        plan-1    C8        0.020
 A        plan-1    C4        0.020
 A        plan-1    N7        0.020
 A        plan-1    H8        0.020
 A        plan-1    C5        0.020
 A        plan-1    C6        0.020
 A        plan-1    N1        0.020
 A        plan-1    C2        0.020
 A        plan-1    N3        0.020
 A        plan-1    N6        0.020
 A        plan-1    H2        0.020
 A        plan-1    H62       0.020
 A        plan-1    H61       0.020
 A        plan-2    N6        0.020
 A        plan-2    C6        0.020
 A        plan-2    H61       0.020
 A        plan-2    H62       0.020
# ------------------------------------------------------
# ------------------------------------------------------
# ------------------------------------------------------
`.trim();

monomers["G"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
G        G   'GUANOSINE-5'-MONOPHOSPHATE          ' RNA                36  24 .
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_G
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 G             P      P    P         0.000     -0.093   -0.437    0.165
 G             OP3    O    OP       -0.660     -0.031   -1.726    0.950
 G             OP1    O    OP       -0.660     -0.147    0.788    1.049
 G             "O5'"  O    O2        0.000     -1.522   -0.476   -0.589
 G             "C5'"  C    CH2       0.000     -1.965    0.618   -1.416
 G             "H5' " H    H         0.000     -1.196    0.861   -2.153
 G             "H5''" H    H         0.000     -2.162    1.495   -0.796
 G             "C4'"  C    CH1       0.000     -3.243    0.204   -2.132
 G             "H4'"  H    H         0.000     -3.029   -0.736   -2.659
 G             "C3'"  C    CH1       0.000     -3.917    1.151   -3.144
 G             "H3'"  H    H         0.000     -3.585    2.184   -2.970
 G             "O3'"  O    OH1       0.000     -3.625    0.763   -4.496
 G             "HO3'" H    H         0.000     -4.122    1.324   -5.107
 G             "C2'"  C    CH1       0.000     -5.439    1.025   -2.847
 G             "H2'"  H    H         0.000     -5.834    2.004   -2.540
 G             "O2'"  O    OH1       0.000     -6.191    0.538   -3.968
 G             "HO2'" H    H         0.000     -7.112    0.405   -3.706
 G             "C1'"  C    CH1       0.000     -5.561    0.036   -1.679
 G             "H1'"  H    H         0.000     -5.804   -0.940   -2.123
 G             "O4'"  O    O2        0.000     -4.240   -0.087   -1.127
 G             N9     N    NR5       0.000     -6.618    0.314   -0.678
 G             C4     C    CR56      0.000     -7.835   -0.266   -0.673
 G             C5     C    CR56      0.000     -8.550    0.357    0.475
 G             N7     N    NRD5      0.000     -7.616    0.990    1.182
 G             C8     C    CR15      0.000     -6.428    0.769    0.571
 G             H8     H    H         0.000     -5.459    0.935    1.027
 G             N3     N    NRD6      0.000     -8.643   -0.944   -1.522
 G             C2     C    CR6       0.000     -9.980   -1.128   -1.282
 G             N2     N    NH2       0.000    -10.673   -1.810   -2.232
 G             H22    H    H         0.000    -10.201   -2.150   -3.058
 G             H21    H    H         0.000    -11.663   -1.978   -2.114
 G             N1     N    NR16      0.000    -10.639   -0.616   -0.239
 G             H1     H    H         0.000    -11.662   -0.778   -0.145
 G             C6     C    CR6       0.000     -9.994    0.101    0.682
 G             O6     O    O         0.000    -10.609    0.572    1.663
 G             OP2    O    OP       -0.660      0.945   -0.363   -0.932
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 G        "O5'"  n/a    "C5'"  START
 G        P      "O5'"  .      .
 G        OP3    P      .      .
 G        OP1    P      .      .
 G        "C5'"  "O5'"  "C4'"  .
 G        "H5' " "C5'"  .      .
 G        "H5''" "C5'"  .      .
 G        "C4'"  "C5'"  "C3'"  .
 G        "H4'"  "C4'"  .      .
 G        "C3'"  "C4'"  "C2'"  .
 G        "H3'"  "C3'"  .      .
 G        "O3'"  "C3'"  "HO3'" .
 G        "HO3'" "O3'"  .      .
 G        "C2'"  "C3'"  "C1'"  .
 G        "H2'"  "C2'"  .      .
 G        "O2'"  "C2'"  "HO2'" .
 G        "HO2'" "O2'"  .      .
 G        "C1'"  "C2'"  N9     .
 G        "H1'"  "C1'"  .      .
 G        "O4'"  "C1'"  .      .
 G        N9     "C1'"  C4     .
 G        C4     N9     N3     .
 G        C5     C4     N7     .
 G        N7     C5     C8     .
 G        C8     N7     H8     .
 G        H8     C8     .      .
 G        N3     C4     C2     .
 G        C2     N3     N1     .
 G        N2     C2     H21    .
 G        H22    N2     .      .
 G        H21    N2     .      .
 G        N1     C2     C6     .
 G        H1     N1     .      .
 G        C6     N1     O6     .
 G        O6     C6     .      END
 G        OP2    P      .      .  
 G        "C4'"  "O4'"  .    ADD
 G        N9     C8     .    ADD
 G        C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 G        OP3    P         deloc       1.485    0.017
 G        OP1    P         deloc       1.485    0.017
 G        OP2    P         deloc       1.485    0.017
 G        "O5'"  P         single      1.593    0.010
 G        "C5'"  "O5'"     single      1.440    0.016
 G        "C4'"  "C5'"     single      1.510    0.013
 G        "C4'"  "O4'"     single      1.453    0.012
 G        "C3'"  "C4'"     single      1.524    0.011
 G        "O4'"  "C1'"     single      1.414    0.012
 G        "O3'"  "C3'"     single      1.423    0.014
 G        "C2'"  "C3'"     single      1.525    0.011
 G        "O2'"  "C2'"     single      1.413    0.013
 G        "C1'"  "C2'"     single      1.528    0.010
 G        N9     "C1'"     single      1.459    0.009
 G        N9     C8        single      1.374    0.007
 G        C4     N9        single      1.375    0.008
 G        C8     N7        double      1.305    0.006
 G        N7     C5        single      1.388    0.006
 G        C5     C6        single      1.419    0.010
 G        C5     C4        double      1.379    0.007
 G        O6     C6        double      1.237    0.009
 G        C6     N1        single      1.391    0.007
 G        N1     C2        single      1.373    0.008
 G        N2     C2        single      1.341    0.010
 G        C2     N3        double      1.323    0.008
 G        N3     C4        single      1.350    0.007
 G        "H5' " "C5'"     single      1.092    0.020
 G        "H5''" "C5'"     single      1.092    0.020
 G        "H4'"  "C4'"     single      1.099    0.020
 G        "H3'"  "C3'"     single      1.099    0.020
 G        "HO3'" "O3'"     single      0.967    0.020
 G        "H2'"  "C2'"     single      1.099    0.020
 G        "HO2'" "O2'"     single      0.967    0.020
 G        "H1'"  "C1'"     single      1.099    0.020
 G        H8     C8        single      1.083    0.020
 G        H1     N1        single      1.040    0.020
 G        H21    N2        single      1.010    0.020
 G        H22    N2        single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 G        OP3    P      OP1     107.400    3.200
 G        OP3    P      "O5'"   104.000    1.900
 G        OP1    P      "O5'"   108.100    2.900
 G        OP3    P      OP2     108.300    3.200
 G        OP1    P      OP2     119.600    1.500
 G        "O5'"  P      OP2     108.300    2.700
 G        P      "O5'"  "C5'"   120.900    1.600
 G        "O5'"  "C5'"  "H5' "  109.470    3.000
 G        "O5'"  "C5'"  "H5''"  109.470    3.000
 G        "O5'"  "C5'"  "C4'"   110.200    1.400
 G        "H5' " "C5'"  "H5''"  107.900    3.000
 G        "H5' " "C5'"  "C4'"   109.470    3.000
 G        "H5''" "C5'"  "C4'"   109.470    3.000
 G        "C5'"  "C4'"  "H4'"   108.340    3.000
 G        "C5'"  "C4'"  "C3'"   115.500    1.500
 G        "C5'"  "C4'"  "O4'"   109.200    1.400
 G        "H4'"  "C4'"  "C3'"   108.340    3.000
 G        "H4'"  "C4'"  "O4'"   109.470    3.000
 G        "C3'"  "C4'"  "O4'"   105.500    1.400
 G        "C4'"  "C3'"  "H3'"   108.340    3.000
 G        "C4'"  "C3'"  "O3'"   110.600    2.600
 G        "C4'"  "C3'"  "C2'"   102.700    1.000
 G        "H3'"  "C3'"  "O3'"   109.470    3.000
 G        "H3'"  "C3'"  "C2'"   108.340    3.000
 G        "O3'"  "C3'"  "C2'"   111.000    2.800
 G        "C3'"  "O3'"  "HO3'"  109.470    3.000
 G        "C3'"  "C2'"  "H2'"   108.340    3.000
 G        "C3'"  "C2'"  "O2'"   113.300    2.900
 G        "C3'"  "C2'"  "C1'"   101.500    0.900
 G        "H2'"  "C2'"  "O2'"   109.470    3.000
 G        "H2'"  "C2'"  "C1'"   108.340    3.000
 G        "O2'"  "C2'"  "C1'"   110.600    3.000
 G        "C2'"  "O2'"  "HO2'"  109.470    3.000
 G        "C2'"  "C1'"  "H1'"   108.340    3.000
 G        "C2'"  "C1'"  "O4'"   106.400    1.400
 G        "C2'"  "C1'"  N9      113.400    1.600
 G        "H1'"  "C1'"  "O4'"   109.470    3.000
 G        "H1'"  "C1'"  N9      109.470    3.000
 G        "O4'"  "C1'"  N9      108.200    1.000
 G        "C1'"  "O4'"  "C4'"   109.600    0.900
 G        "C1'"  N9     C4      126.500    1.300
 G        "C1'"  N9     C8      127.000    1.300
 G        C4     N9     C8      106.400    0.400
 G        N9     C4     C5      105.400    0.400
 G        N9     C4     N3      126.000    0.600
 G        C5     C4     N3      128.600    0.500
 G        C4     C5     N7      110.800    0.400
 G        C4     C5     C6      118.800    0.600
 G        N7     C5     C6      130.400    0.600
 G        C5     N7     C8      104.300    0.500
 G        N7     C8     H8      126.000    3.000
 G        N7     C8     N9      113.100    0.500
 G        H8     C8     N9      126.000    3.000
 G        C4     N3     C2      111.900    0.500
 G        N3     C2     N2      119.900    0.700
 G        N3     C2     N1      123.900    0.600
 G        N2     C2     N1      116.200    0.900
 G        C2     N2     H22     120.000    3.000
 G        C2     N2     H21     120.000    3.000
 G        H22    N2     H21     120.000    3.000
 G        C2     N1     H1      120.000    3.000
 G        C2     N1     C6      125.100    0.600
 G        H1     N1     C6      120.000    3.000
 G        N1     C6     O6      119.900    0.600
 G        N1     C6     C5      111.500    0.500
 G        O6     C6     C5      128.600    0.600
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 G        C2e-nyu0 C4'    O4'    C1'    C2'      339.000    5.000   1
 G        C2e-nyu1 O4'    C1'    C2'    C3'       35.000    3.400   1
 G        C2e-nyu2 C1'    C2'    C3'    C4'      324.000    2.800   1
 G        C2e-nyu3 C2'    C3'    C4'    O4'       24.000    4.400   1
 G        C2e-nyu4 C3'    C4'    O4'    C1'      357.700    5.700   1
 G        C2e-delta C5'    C4'   C3'    O3'        81.0      4.400   1
 G        C2e-C4N9 C4'    O4'   C1'     N9       216.600    5.500   1


 G        C3e-nyu0 C4'    O4'    C1'    C2'        2.8      6.100   1
 G        C3e-nyu1 O4'    C1'    C2'    C3'      335.00     4.900   1
 G        C3e-nyu2 C1'    C2'    C3'    C4'       35.9      2.800   1
 G        C3e-nyu3 C2'    C3'    C4'    O4'      324.700    3.100   1
 G        C3e-nyu4 C3'    C4'    O4'    C1'       20.500    5.100   1
 G        C3e-delta C5'    C4'   C3'    O3'       147.300    4.900   1
 G        C3e-C4N9 C4'    O4'   C1'     N9       241.4      6.500   1

 G        var_1    OP2    P      "O5'"  "C5'"    -60.037   20.000   1
 G        var_2    P      "O5'"  "C5'"  "C4'"   -179.958   20.000   1
 G        var_3    "O5'"  "C5'"  "C4'"  "C3'"    176.934   20.000   3
 G        var_4    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 G        var_5    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 G        var_6    "C4'"  "C3'"  "O3'"  "HO3'"   175.000   20.000   1
 G        var_8    "C3'"  "C2'"  "O2'"  "HO2'"   175.000   20.000   1
 G        var_9    "C3'"  "C2'"  "C1'"  N9       150.000   20.000   3
 G        var_11   "C2'"  "C1'"  N9     C4        91.446   20.000   1
 G        CONST_1  "C1'"  N9     C8     N7       180.000    0.000   0
 G        CONST_2  "C1'"  N9     C4     N3         0.000    0.000   0
 G        CONST_3  N9     C4     C5     N7         0.000    0.000   0
 G        CONST_4  C4     C5     C6     N1         0.000    0.000   0
 G        CONST_5  C4     C5     N7     C8         0.000    0.000   0
 G        CONST_6  C5     N7     C8     N9         0.000    0.000   0
 G        CONST_7  N9     C4     N3     C2       180.000    0.000   0
 G        CONST_8  C4     N3     C2     N1         0.000    0.000   0
 G        CONST_9  N3     C2     N2     H21      180.000    0.000   0
 G        CONST_10 N3     C2     N1     C6         0.000    0.000   0
 G        CONST_11 C2     N1     C6     O6       180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 G        chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 G        chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 G        chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 G        chir_04  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 G        plan-1    N9        0.020
 G        plan-1    "C1'"     0.020
 G        plan-1    C8        0.020
 G        plan-1    C4        0.020
 G        plan-1    N7        0.020
 G        plan-1    H8        0.020
 G        plan-1    C5        0.020
 G        plan-1    C6        0.020
 G        plan-1    N1        0.020
 G        plan-1    C2        0.020
 G        plan-1    N3        0.020
 G        plan-1    O6        0.020
 G        plan-1    H1        0.020
 G        plan-1    N2        0.020
 G        plan-1    H22       0.020
 G        plan-1    H21       0.020
 G        plan-2    N2        0.020
 G        plan-2    C2        0.020
 G        plan-2    H21       0.020
 G        plan-2    H22       0.020
# ------------------------------------------------------
# ------------------------------------------------------
# ------------------------------------------------------
`.trim();

monomers["I"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
I        I   'INOSINIC ACID                       ' RNA                34  23 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_I
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 I             OP3    O    OP       -0.666      0.000    0.000    0.000
 I             P      P    P         0.000     -1.113    0.996    0.244
 I             OP1    O    OP       -0.666     -0.907    1.663    1.586
 I             OP2    O    OP       -0.666     -1.101    2.043   -0.847
 I             "O5'"  O    O2        0.000     -2.529    0.229    0.238
 I             "C5'"  C    CH2       0.000     -3.523    1.195    0.590
 I             "H5'"  H    H         0.000     -3.516    2.006   -0.141
 I             "H5''" H    H         0.000     -3.303    1.597    1.581
 I             "C4'"  C    CH1       0.000     -4.900    0.529    0.602
 I             "H4'"  H    H         0.000     -4.909   -0.330    1.288
 I             "C3'"  C    CH1       0.000     -5.997    1.551    0.993
 I             "H3'"  H    H         0.000     -6.102    1.615    2.085
 I             "C2'"  C    CH1       0.000     -7.262    0.930    0.352
 I             "H2'"  H    H         0.000     -7.833    0.361    1.099
 I             "O2'"  O    OH1       0.000     -8.077    1.948   -0.233
 I             "HO2'" H    H         0.000     -8.365    2.563    0.455
 I             "C1'"  C    CH1       0.000     -6.711   -0.011   -0.736
 I             "H1'"  H    H         0.000     -7.108    0.280   -1.719
 I             "O4'"  O    O2        0.000     -5.279    0.120   -0.729
 I             N9     N    NR5       0.000     -7.086   -1.394   -0.435
 I             C4     C    CR56      0.000     -8.267   -2.002   -0.763
 I             C5     C    CR56      0.000     -8.175   -3.312   -0.281
 I             N7     N    NRD5      0.000     -6.968   -3.438    0.316
 I             C8     C    CR15      0.000     -6.323   -2.311    0.227
 I             H8     H    H         0.000     -5.331   -2.128    0.619
 I             N3     N    NRD6      0.000     -9.372   -1.611   -1.412
 I             C2     C    CR16      0.000    -10.374   -2.425   -1.592
 I             H2     H    H         0.000    -11.252   -2.067   -2.115
 I             N1     N    NR16      0.000    -10.354   -3.706   -1.145
 I             H1     H    H         0.000    -11.174   -4.324   -1.309
 I             C6     C    CR6       0.000     -9.274   -4.183   -0.486
 I             O6     O    O         0.000     -9.246   -5.332   -0.081
 I             "O3'"  O    OH1       0.000     -5.720    2.836    0.433
 I             "HO3'" H    H         0.000     -6.480    3.399    0.633
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 I        OP3    n/a    P      START
 I        P      OP3    "O5'"  .
 I        OP1    P      .      .
 I        OP2    P      .      .
 I        "O5'"  P      "C5'"  .
 I        "C5'"  "O5'"  "C4'"  .
 I        "H5'"  "C5'"  .      .
 I        "H5''" "C5'"  .      .
 I        "C4'"  "C5'"  "C3'"  .
 I        "H4'"  "C4'"  .      .
 I        "C3'"  "C4'"  "O3'"  .
 I        "H3'"  "C3'"  .      .
 I        "C2'"  "C3'"  "C1'"  .
 I        "H2'"  "C2'"  .      .
 I        "O2'"  "C2'"  "HO2'" .
 I        "HO2'" "O2'"  .      .
 I        "C1'"  "C2'"  N9     .
 I        "H1'"  "C1'"  .      .
 I        "O4'"  "C1'"  .      .
 I        N9     "C1'"  C4     .
 I        C4     N9     N3     .
 I        C5     C4     N7     .
 I        N7     C5     C8     .
 I        C8     N7     H8     .
 I        H8     C8     .      .
 I        N3     C4     C2     .
 I        C2     N3     N1     .
 I        H2     C2     .      .
 I        N1     C2     C6     .
 I        H1     N1     .      .
 I        C6     N1     O6     .
 I        O6     C6     .      .
 I        "O3'"  "C3'"  .      END
 I        "HO3'" "O3'"  .      .
 I        "C4'"  "O4'"  .    ADD
 I        N9     C8     .    ADD
 I        C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 I        P      OP3       deloc       1.510    0.020
 I        OP1    P         deloc       1.510    0.020
 I        OP2    P         deloc       1.510    0.020
 I        "O5'"  P         single      1.610    0.020
 I        "C5'"  "O5'"     single      1.426    0.020
 I        "C4'"  "C5'"     single      1.524    0.020
 I        "H5'"  "C5'"     single      1.092    0.020
 I        "H5''" "C5'"     single      1.092    0.020
 I        "C4'"  "O4'"     single      1.426    0.020
 I        "C3'"  "C4'"     single      1.524    0.020
 I        "H4'"  "C4'"     single      1.099    0.020
 I        "O4'"  "C1'"     single      1.426    0.020
 I        "O3'"  "C3'"     single      1.432    0.020
 I        "C2'"  "C3'"     single      1.524    0.020
 I        "H3'"  "C3'"     single      1.099    0.020
 I        "HO3'" "O3'"     single      0.967    0.020
 I        "O2'"  "C2'"     single      1.432    0.020
 I        "C1'"  "C2'"     single      1.524    0.020
 I        "H2'"  "C2'"     single      1.099    0.020
 I        "HO2'" "O2'"     single      0.967    0.020
 I        N9     "C1'"     single      1.485    0.020
 I        "H1'"  "C1'"     single      1.099    0.020
 I        N9     C8        single      1.337    0.020
 I        C4     N9        single      1.337    0.020
 I        C8     N7        double      1.350    0.020
 I        H8     C8        single      1.083    0.020
 I        N7     C5        single      1.350    0.020
 I        C5     C6        single      1.490    0.020
 I        C5     C4        double      1.490    0.020
 I        O6     C6        double      1.250    0.020
 I        C6     N1        single      1.337    0.020
 I        N1     C2        single      1.337    0.020
 I        H1     N1        single      1.040    0.020
 I        C2     N3        double      1.337    0.020
 I        H2     C2        single      1.083    0.020
 I        N3     C4        single      1.355    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 I        OP3    P      OP1     119.900    3.000
 I        OP3    P      OP2     119.900    3.000
 I        OP3    P      "O5'"   108.200    3.000
 I        OP1    P      OP2     119.900    3.000
 I        OP1    P      "O5'"   108.200    3.000
 I        OP2    P      "O5'"   108.200    3.000
 I        P      "O5'"  "C5'"   120.500    3.000
 I        "O5'"  "C5'"  "H5'"   109.470    3.000
 I        "O5'"  "C5'"  "H5''"  109.470    3.000
 I        "O5'"  "C5'"  "C4'"   109.470    3.000
 I        "H5'"  "C5'"  "H5''"  107.900    3.000
 I        "H5'"  "C5'"  "C4'"   109.470    3.000
 I        "H5''" "C5'"  "C4'"   109.470    3.000
 I        "C5'"  "C4'"  "H4'"   108.340    3.000
 I        "C5'"  "C4'"  "C3'"   111.000    3.000
 I        "C5'"  "C4'"  "O4'"   109.470    3.000
 I        "H4'"  "C4'"  "C3'"   108.340    3.000
 I        "H4'"  "C4'"  "O4'"   109.470    3.000
 I        "C3'"  "C4'"  "O4'"   109.470    3.000
 I        "C4'"  "C3'"  "H3'"   108.340    3.000
 I        "C4'"  "C3'"  "C2'"   111.000    3.000
 I        "C4'"  "C3'"  "O3'"   109.470    3.000
 I        "H3'"  "C3'"  "C2'"   108.340    3.000
 I        "H3'"  "C3'"  "O3'"   109.470    3.000
 I        "C2'"  "C3'"  "O3'"   109.470    3.000
 I        "C3'"  "C2'"  "H2'"   108.340    3.000
 I        "C3'"  "C2'"  "O2'"   109.470    3.000
 I        "C3'"  "C2'"  "C1'"   111.000    3.000
 I        "H2'"  "C2'"  "O2'"   109.470    3.000
 I        "H2'"  "C2'"  "C1'"   108.340    3.000
 I        "O2'"  "C2'"  "C1'"   109.470    3.000
 I        "C2'"  "O2'"  "HO2'"  109.470    3.000
 I        "C2'"  "C1'"  "H1'"   108.340    3.000
 I        "C2'"  "C1'"  "O4'"   109.470    3.000
 I        "C2'"  "C1'"  N9      109.470    3.000
 I        "H1'"  "C1'"  "O4'"   109.470    3.000
 I        "H1'"  "C1'"  N9      109.470    3.000
 I        "O4'"  "C1'"  N9      109.470    3.000
 I        "C1'"  "O4'"  "C4'"   111.800    3.000
 I        "C1'"  N9     C4      126.000    3.000
 I        "C1'"  N9     C8      126.000    3.000
 I        C4     N9     C8      108.000    3.000
 I        N9     C4     C5      108.000    3.000
 I        N9     C4     N3      132.000    3.000
 I        C5     C4     N3      120.000    3.000
 I        C4     C5     N7      108.000    3.000
 I        C4     C5     C6      120.000    3.000
 I        N7     C5     C6      132.000    3.000
 I        C5     N7     C8      108.000    3.000
 I        N7     C8     H8      126.000    3.000
 I        N7     C8     N9      108.000    3.000
 I        H8     C8     N9      126.000    3.000
 I        C4     N3     C2      120.000    3.000
 I        N3     C2     H2      120.000    3.000
 I        N3     C2     N1      120.000    3.000
 I        H2     C2     N1      120.000    3.000
 I        C2     N1     H1      120.000    3.000
 I        C2     N1     C6      120.000    3.000
 I        H1     N1     C6      120.000    3.000
 I        N1     C6     O6      120.000    3.000
 I        N1     C6     C5      120.000    3.000
 I        O6     C6     C5      120.000    3.000
 I        "C3'"  "O3'"  "HO3'"  109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 I        var_1    OP3    P      "O5'"  "C5'"    174.977   20.000   1
 I        var_2    P      "O5'"  "C5'"  "C4'"    179.975   20.000   1
 I        var_3    "O5'"  "C5'"  "C4'"  "C3'"    179.501   20.000   3
 I        var_4    "C5'"  "C4'"  "O4'"  "C1'"   -150.000   20.000   1
 I        var_5    "C5'"  "C4'"  "C3'"  "O3'"     30.000   20.000   3
 I        var_6    "C4'"  "C3'"  "C2'"  "C1'"    -30.000   20.000   3
 I        var_7    "C3'"  "C2'"  "O2'"  "HO2'"   -61.433   20.000   1
 I        var_8    "C3'"  "C2'"  "C1'"  N9       120.000   20.000   3
 I        var_9    "C2'"  "C1'"  "O4'"  "C4'"     30.000   20.000   1
 I        var_10   "C2'"  "C1'"  N9     C4        84.740   20.000   1
 I        CONST_1  "C1'"  N9     C8     N7       180.000    0.000   0
 I        CONST_2  "C1'"  N9     C4     N3         0.000    0.000   0
 I        CONST_3  N9     C4     C5     N7         0.000    0.000   0
 I        CONST_4  C4     C5     C6     N1         0.000    0.000   0
 I        CONST_5  C4     C5     N7     C8         0.000    0.000   0
 I        CONST_6  C5     N7     C8     N9         0.000    0.000   0
 I        CONST_7  N9     C4     N3     C2       180.000    0.000   0
 I        CONST_8  C4     N3     C2     N1         0.000    0.000   0
 I        CONST_9  N3     C2     N1     C6         0.000    0.000   0
 I        CONST_10 C2     N1     C6     O6       180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 I        chir_01  "C4'"  "C5'"  "O4'"  "C3'"     positiv
 I        chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 I        chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 I        chir_04  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 I        plan-1    N9        0.020
 I        plan-1    "C1'"     0.020
 I        plan-1    C8        0.020
 I        plan-1    C4        0.020
 I        plan-1    N7        0.020
 I        plan-1    H8        0.020
 I        plan-1    C5        0.020
 I        plan-1    C6        0.020
 I        plan-1    N1        0.020
 I        plan-1    C2        0.020
 I        plan-1    N3        0.020
 I        plan-1    O6        0.020
 I        plan-1    H1        0.020
 I        plan-1    H2        0.020
# ------------------------------------------------------
`.trim();

monomers["U"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
U        U   'URIDINE-5'-MONOPHOSPHATE            ' RNA                32  21 .
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_U
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 U             P      P    P         0.000     -0.065    0.451   -0.171
 U             OP3    O    OP       -0.660      0.051    1.731   -0.965
 U             OP1    O    OP       -0.660     -0.244   -0.771   -1.043
 U             "O5'"  O    O2        0.000     -1.458    0.595    0.636
 U             "C5'"  C    CH2       0.000     -1.952   -0.453    1.498
 U             "H5' " H    H         0.000     -1.183   -0.737    2.220
 U             "H5''" H    H         0.000     -2.232   -1.325    0.904
 U             "C4'"  C    CH1       0.000     -3.173    0.074    2.236
 U             "H4'"  H    H         0.000     -2.890    1.030    2.698
 U             "C3'"  C    CH1       0.000     -3.861   -0.780    3.325
 U             "H3'"  H    H         0.000     -3.615   -1.841    3.180
 U             "O3'"  O    OH1       0.000     -3.451   -0.355    4.635
 U             "HO3'" H    H         0.000     -3.948   -0.845    5.305
 U             "C2'"  C    CH1       0.000     -5.389   -0.553    3.116
 U             "H2'"  H    H         0.000     -5.900   -1.497    2.882
 U             "O2'"  O    OH1       0.000     -5.985    0.087    4.256
 U             "HO2'" H    H         0.000     -6.912    0.285    4.067
 U             "C1'"  C    CH1       0.000     -5.467    0.425    1.930
 U             "H1'"  H    H         0.000     -5.517    1.430    2.372
 U             "O4'"  O    O2        0.000     -4.200    0.356    1.255
 U             N1     N    NR6       0.000     -6.595    0.332    1.036
 U             C6     C    CR16      0.000     -7.416    1.398    0.926
 U             H6     H    H         0.000     -7.237    2.314    1.476
 U             C5     C    CR16      0.000     -8.507    1.259    0.069
 U             H5     H    H         0.000     -9.204    2.076   -0.073
 U             C4     C    CR6       0.000     -8.686    0.049   -0.604
 U             N3     N    NR16      0.000     -7.700   -0.856   -0.647
 U             H3     H    H         0.000     -7.828   -1.748   -1.166
 U             C2     C    CR6       0.000     -6.553   -0.602   -0.018
 U             O2     O    O         0.000     -5.515   -1.234   -0.311
 U             O4     O    O         0.000     -9.642   -0.064   -1.400
 U             OP2    O    OP       -0.660      1.004    0.310    0.888
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 U        "O5'"  n/a    "C5'"  START
 U        P     "O5'"   .     .
 U        OP3    P      .      .
 U        OP1    P      .      .
 U        "C5'"  "O5'"  "C4'"  .
 U        "H5' " "C5'"  .      .
 U        "H5''" "C5'"  .      .
 U        "C4'"  "C5'"  "C3'"  .
 U        "H4'"  "C4'"  .      .
 U        "C3'"  "C4'"  "C2'"  .
 U        "H3'"  "C3'"  .      .
 U        "O3'"  "C3'"  "HO3'" .
 U        "HO3'" "O3'"  .      .
 U        "C2'"  "C3'"  "C1'"  .
 U        "H2'"  "C2'"  .      .
 U        "O2'"  "C2'"  "HO2'" .
 U        "HO2'" "O2'"  .      .
 U        "C1'"  "C2'"  N1     .
 U        "H1'"  "C1'"  .      .
 U        "O4'"  "C1'"  .      .
 U        N1     "C1'"  C6     .
 U        C6     N1     C5     .
 U        H6     C6     .      .
 U        C5     C6     C4     .
 U        H5     C5     .      .
 U        C4     C5     O4     .
 U        N3     C4     C2     .
 U        H3     N3     .      .
 U        C2     N3     O2     .
 U        O2     C2     .      .
 U        O4     C4     .      END
 U        OP2    P      .      .  
 U        "C4'"  "O4'"  .    ADD
 U        N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 U        OP3    P         deloc       1.485    0.017
 U        OP1    P         deloc       1.485    0.017
 U        OP2    P         deloc       1.485    0.017
 U        "O5'"  P         single      1.593    0.010
 U        "C5'"  "O5'"     single      1.440    0.016
 U        "C4'"  "C5'"     single      1.510    0.013
 U        "C4'"  "O4'"     single      1.453    0.012
 U        "C3'"  "C4'"     single      1.524    0.011
 U        "O4'"  "C1'"     single      1.414    0.012
 U        "O3'"  "C3'"     single      1.423    0.014
 U        "C2'"  "C3'"     single      1.525    0.011
 U        "O2'"  "C2'"     single      1.413    0.013
 U        "C1'"  "C2'"     single      1.528    0.010
 U        N1     "C1'"     single      1.469    0.009
 U        N1     C2        single      1.381    0.009
 U        C6     N1        single      1.375    0.009
 U        O2     C2        double      1.219    0.009
 U        C2     N3        single      1.373    0.007
 U        N3     C4        single      1.380    0.009
 U        O4     C4        double      1.232    0.009
 U        C4     C5        single      1.431    0.009
 U        C5     C6        double      1.337    0.009
 U        "H5' " "C5'"     single      1.092    0.020
 U        "H5''" "C5'"     single      1.092    0.020
 U        "H4'"  "C4'"     single      1.099    0.020
 U        "H3'"  "C3'"     single      1.099    0.020
 U        "HO3'" "O3'"     single      0.967    0.020
 U        "H2'"  "C2'"     single      1.099    0.020
 U        "HO2'" "O2'"     single      0.967    0.020
 U        "H1'"  "C1'"     single      1.099    0.020
 U        H3     N3        single      1.040    0.020
 U        H5     C5        single      1.083    0.020
 U        H6     C6        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 U        OP3    P      OP1     107.400    3.200
 U        OP3    P      "O5'"   104.000    1.900
 U        OP1    P      "O5'"   108.100    2.900
 U        OP3    P      OP2     108.300    3.200
 U        OP1    P      OP2     119.600    1.500
 U        "O5'"  P      OP2     108.300    2.700
 U        P      "O5'"  "C5'"   120.900    1.600
 U        "O5'"  "C5'"  "H5' "  109.470    3.000
 U        "O5'"  "C5'"  "H5''"  109.470    3.000
 U        "O5'"  "C5'"  "C4'"   110.200    1.400
 U        "H5' " "C5'"  "H5''"  107.900    3.000
 U        "H5' " "C5'"  "C4'"   109.470    3.000
 U        "H5''" "C5'"  "C4'"   109.470    3.000
 U        "C5'"  "C4'"  "H4'"   108.340    3.000
 U        "C5'"  "C4'"  "C3'"   115.500    1.500
 U        "C5'"  "C4'"  "O4'"   109.200    1.400
 U        "H4'"  "C4'"  "C3'"   108.340    3.000
 U        "H4'"  "C4'"  "O4'"   109.470    3.000
 U        "C3'"  "C4'"  "O4'"   105.500    1.400
 U        "C4'"  "C3'"  "H3'"   108.340    3.000
 U        "C4'"  "C3'"  "O3'"   110.600    2.600
 U        "C4'"  "C3'"  "C2'"   102.700    1.000
 U        "H3'"  "C3'"  "O3'"   109.470    3.000
 U        "H3'"  "C3'"  "C2'"   108.340    3.000
 U        "O3'"  "C3'"  "C2'"   111.000    2.800
 U        "C3'"  "O3'"  "HO3'"  109.470    3.000
 U        "C3'"  "C2'"  "H2'"   108.340    3.000
 U        "C3'"  "C2'"  "O2'"   113.300    2.900
 U        "C3'"  "C2'"  "C1'"   101.500    0.900
 U        "H2'"  "C2'"  "O2'"   109.470    3.000
 U        "H2'"  "C2'"  "C1'"   108.340    3.000
 U        "O2'"  "C2'"  "C1'"   110.600    3.000
 U        "C2'"  "O2'"  "HO2'"  109.470    3.000
 U        "C2'"  "C1'"  "H1'"   108.340    3.000
 U        "C2'"  "C1'"  "O4'"   106.400    1.400
 U        "C2'"  "C1'"  N1      113.400    1.600
 U        "H1'"  "C1'"  "O4'"   109.470    3.000
 U        "H1'"  "C1'"  N1      109.470    3.000
 U        "O4'"  "C1'"  N1      108.200    1.000
 U        "C1'"  "O4'"  "C4'"   109.600    0.900
 U        "C1'"  N1     C6      121.200    1.400
 U        "C1'"  N1     C2      117.700    1.200
 U        C6     N1     C2      121.000    0.600
 U        N1     C6     H6      120.000    3.000
 U        N1     C6     C5      122.700    0.500
 U        H6     C6     C5      120.000    3.000
 U        C6     C5     H5      120.000    3.000
 U        C6     C5     C4      119.700    0.600
 U        H5     C5     C4      120.000    3.000
 U        C5     C4     N3      114.600    0.600
 U        C5     C4     O4      125.900    0.600
 U        N3     C4     O4      119.400    0.700
 U        C4     N3     H3      120.000    3.000
 U        C4     N3     C2      127.600    0.600
 U        H3     N3     C2      120.000    3.000
 U        N3     C2     O2      122.200    0.700
 U        N3     C2     N1      114.900    0.600
 U        O2     C2     N1      122.800    0.700
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 U        C2e-nyu0 C4'    O4'    C1'    C2'      339.000    5.000   1
 U        C2e-nyu1 O4'    C1'    C2'    C3'       35.000    3.400   1
 U        C2e-nyu2 C1'    C2'    C3'    C4'      324.000    2.800   1
 U        C2e-nyu3 C2'    C3'    C4'    O4'       24.000    4.400   1
 U        C2e-nyu4 C3'    C4'    O4'    C1'      357.700    5.700   1
 U        C2e-delta C5'    C4'   C3'    O3'       147.300    4.900   1
 U        C2e-C4N1 C4'    O4'   C1'     N9       216.600    5.500   1


 U        C3e-nyu0 C4'    O4'    C1'    C2'        2.8      6.100   1
 U        C3e-nyu1 O4'    C1'    C2'    C3'      335.00     4.900   1
 U        C3e-nyu2 C1'    C2'    C3'    C4'       35.9      2.800   1
 U        C3e-nyu3 C2'    C3'    C4'    O4'      324.700    3.100   1
 U        C3e-nyu4 C3'    C4'    O4'    C1'       20.500    5.100   1
 U        C3e-delta C5'    C4'   C3'    O3'        81.0      4.400   1
 U        C2e-C4N1 C4'    O4'   C1'     N9       241.400    6.500   1


 U        var_1    OP2    P      "O5'"  "C5'"    -60.034   20.000   1
 U        var_2    P      "O5'"  "C5'"  "C4'"    179.997   20.000   1
 U        var_3    "O5'"  "C5'"  "C4'"  "C3'"    176.904   20.000   3
 U        var_4    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 U        var_5    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 U        var_6    "C4'"  "C3'"  "O3'"  "HO3'"   175.000   20.000   1
 U        var_8    "C3'"  "C2'"  "O2'"  "HO2'"   175.000   20.000   1
 U        var_9    "C3'"  "C2'"  "C1'"  N1       150.000   20.000   3
 U        var_11   "C2'"  "C1'"  N1     C6       120.010   20.000   1
 U        CONST_1  "C1'"  N1     C2     N3       180.000    0.000   0
 U        CONST_2  "C1'"  N1     C6     C5       180.000    0.000   0
 U        CONST_3  N1     C6     C5     C4         0.000    0.000   0
 U        CONST_4  C6     C5     C4     O4       180.000    0.000   0
 U        CONST_5  C5     C4     N3     C2         0.000    0.000   0
 U        CONST_6  C4     N3     C2     O2       180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 U        chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 U        chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 U        chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 U        chir_04  "C1'"  "O4'"  "C2'"  N1        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 U        plan-1    N1        0.020
 U        plan-1    "C1'"     0.020
 U        plan-1    C2        0.020
 U        plan-1    C6        0.020
 U        plan-1    N3        0.020
 U        plan-1    C4        0.020
 U        plan-1    C5        0.020
 U        plan-1    O2        0.020
 U        plan-1    H3        0.020
 U        plan-1    O4        0.020
 U        plan-1    H5        0.020
 U        plan-1    H6        0.020
# ------------------------------------------------------
# ------------------------------------------------------
# ------------------------------------------------------
`.trim();

monomers["T"] = `
# Created using JLigand 1.0.26
# and
# dictionary  5.34    ( 27/02/2012 )
# libcheck    5.2.0   ( 12/12/2011 )
# refmac      5.7.21  ( 20/02/2012 )
#
# Authors: Andrey Lebedev, Paul Young, Alexei Vagin, Garib Murshudov
# E-mail: andrey.lebedev@stfc.ac.uk
#

global_
_lib_name         mon_lib
_lib_version      5.34
_lib_update       27/02/2012

data_comp_list

loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
T        T   "THYMIDINE-5'-MONOPHOSPHATE          " RNA            35  22 .

data_comp_T

loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 T             OP3    O    OP       -0.660      2.622    0.955   -3.902
 T             P      P    P         0.000      3.910    0.490   -3.263
 T             OP1    O    OP       -0.660      4.601   -0.636   -3.996
 T             "O5'"  O    O2        0.000      3.445   -0.178   -1.873
 T             "C5'"  C    CH2       0.000      2.545   -1.286   -1.845
 T             "H5' " H    H         0.000      3.110   -2.220   -1.862
 T             "H5''" H    H         0.000      1.893   -1.267   -2.720
 T             "C4'"  C    CH1       0.000      1.703   -1.194   -0.575
 T             "H4'"  H    H         0.000      1.702   -0.143   -0.257
 T             "C3'"  C    CH1       0.000      2.210   -2.031    0.610
 T             "H3'"  H    H         0.000      2.878   -2.829    0.257
 T             "O3'"  O    OH1       0.000      2.893   -1.175    1.530
 T             "HO3'" H    H         0.000      3.660   -0.779    1.093
 T             "C2'"  C    CH1       0.000      0.974   -2.640    1.264
 T             "H2'"  H    H         0.000      0.919   -2.323    2.316
 T             "C1'"  C    CH1       0.000     -0.125   -1.950    0.469
 T             "H1'"  H    H         0.000     -0.437   -2.922    0.063
 T             "O4'"  O    O2        0.000      0.348   -1.583   -0.820
 T             N1     N    NR6       0.000     -1.528   -1.774    0.877
 T             C6     C    CR16      0.000     -2.178   -0.731    0.338
 T             H6     H    H         0.000     -1.683   -0.101   -0.390
 T             C5     C    CR6       0.000     -3.475   -0.432    0.729
 T             C7     C    CH3       0.000     -4.219    0.718    0.100
 T             H73    H    H         0.000     -5.080    0.352   -0.395
 T             H72    H    H         0.000     -4.509    1.403    0.853
 T             H71    H    H         0.000     -3.594    1.209   -0.600
 T             C4     C    CR6       0.000     -4.121   -1.311    1.737
 T             N3     N    NR16      0.000     -3.417   -2.320    2.268
 T             H3     H    H         0.000     -3.868   -2.942    2.970
 T             C2     C    CR6       0.000     -2.159   -2.578    1.866
 T             O2     O    O         0.000     -1.551   -3.535    2.394
 T             O4     O    O         0.000     -5.298   -1.099    2.103
 T             OP2    O    OP       -0.660      4.827    1.612   -2.835
 T             "O2'"  O    OH1       0.000      0.961   -4.072    1.164
 T             "HO2'" H    H         0.000      1.181   -4.349    0.263

loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 T        OP3    P         deloc       1.510    0.020
 T        P      OP1       deloc       1.510    0.020
 T        P      "O5'"     single      1.610    0.020
 T        P      OP2       deloc       1.510    0.020
 T        "O5'"  "C5'"     single      1.426    0.020
 T        "C5'"  "H5' "    single      1.092    0.020
 T        "C5'"  "H5''"    single      1.092    0.020
 T        "C5'"  "C4'"     single      1.524    0.020
 T        "C4'"  "H4'"     single      1.099    0.020
 T        "C4'"  "C3'"     single      1.524    0.020
 T        "C4'"  "O4'"     single      1.426    0.020
 T        "C3'"  "H3'"     single      1.099    0.020
 T        "C3'"  "O3'"     single      1.432    0.020
 T        "C3'"  "C2'"     single      1.524    0.020
 T        "O3'"  "HO3'"    single      0.967    0.020
 T        "C2'"  "H2'"     single      1.099    0.020
 T        "C2'"  "C1'"     single      1.524    0.020
 T        "C2'"  "O2'"     single      1.432    0.020
 T        "C1'"  "H1'"     single      1.099    0.020
 T        "C1'"  "O4'"     single      1.426    0.020
 T        "C1'"  N1        single      1.465    0.020
 T        N1     C6        single      1.337    0.020
 T        N1     C2        single      1.410    0.020
 T        C6     H6        single      1.083    0.020
 T        C6     C5        double      1.390    0.020
 T        C5     C7        single      1.506    0.020
 T        C5     C4        single      1.487    0.020
 T        C7     H73       single      1.059    0.020
 T        C7     H72       single      1.059    0.020
 T        C7     H71       single      1.059    0.020
 T        C4     N3        single      1.337    0.020
 T        C4     O4        double      1.250    0.020
 T        N3     H3        single      1.040    0.020
 T        N3     C2        single      1.337    0.020
 T        C2     O2        double      1.250    0.020
 T        "O2'"  "HO2'"    single      0.967    0.020

loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 T        OP3    P      OP1     119.900    3.000
 T        OP3    P      "O5'"   108.200    3.000
 T        OP3    P      OP2     119.900    3.000
 T        P      "O5'"  "C5'"   120.500    3.000
 T        OP1    P      "O5'"   108.200    3.000
 T        OP1    P      OP2     119.900    3.000
 T        "O5'"  P      OP2     108.200    3.000
 T        "O5'"  "C5'"  "H5' "  109.470    3.000
 T        "O5'"  "C5'"  "H5''"  109.470    3.000
 T        "O5'"  "C5'"  "C4'"   109.470    3.000
 T        "C5'"  "C4'"  "H4'"   108.340    3.000
 T        "C5'"  "C4'"  "C3'"   111.000    3.000
 T        "C5'"  "C4'"  "O4'"   109.470    3.000
 T        "H5' " "C5'"  "H5''"  107.900    3.000
 T        "H5' " "C5'"  "C4'"   109.470    3.000
 T        "H5''" "C5'"  "C4'"   109.470    3.000
 T        "C4'"  "C3'"  "H3'"   108.340    3.000
 T        "C4'"  "C3'"  "O3'"   109.470    3.000
 T        "C4'"  "C3'"  "C2'"   111.000    3.000
 T        "C4'"  "O4'"  "C1'"   111.800    3.000
 T        "H4'"  "C4'"  "C3'"   108.340    3.000
 T        "H4'"  "C4'"  "O4'"   109.470    3.000
 T        "C3'"  "C4'"  "O4'"   109.470    3.000
 T        "C3'"  "O3'"  "HO3'"  109.470    3.000
 T        "C3'"  "C2'"  "H2'"   108.340    3.000
 T        "C3'"  "C2'"  "C1'"   111.000    3.000
 T        "C3'"  "C2'"  "O2'"   109.470    3.000
 T        "H3'"  "C3'"  "O3'"   109.470    3.000
 T        "H3'"  "C3'"  "C2'"   108.340    3.000
 T        "O3'"  "C3'"  "C2'"   109.470    3.000
 T        "C2'"  "C1'"  "H1'"   108.340    3.000
 T        "C2'"  "C1'"  "O4'"   109.470    3.000
 T        "C2'"  "C1'"  N1      109.470    3.000
 T        "C2'"  "O2'"  "HO2'"  109.470    3.000
 T        "H2'"  "C2'"  "C1'"   108.340    3.000
 T        "H2'"  "C2'"  "O2'"   109.470    3.000
 T        "C1'"  "C2'"  "O2'"   109.470    3.000
 T        "C1'"  N1     C6      120.000    3.000
 T        "C1'"  N1     C2      120.000    3.000
 T        "H1'"  "C1'"  "O4'"   109.470    3.000
 T        "H1'"  "C1'"  N1      109.470    3.000
 T        "O4'"  "C1'"  N1      109.470    3.000
 T        N1     C6     H6      120.000    3.000
 T        N1     C6     C5      120.000    3.000
 T        N1     C2     N3      120.000    3.000
 T        N1     C2     O2      120.000    3.000
 T        C6     N1     C2      120.000    3.000
 T        C6     C5     C7      120.000    3.000
 T        C6     C5     C4      120.000    3.000
 T        H6     C6     C5      120.000    3.000
 T        C5     C7     H73     109.470    3.000
 T        C5     C7     H72     109.470    3.000
 T        C5     C7     H71     109.470    3.000
 T        C5     C4     N3      120.000    3.000
 T        C5     C4     O4      120.000    3.000
 T        C7     C5     C4      120.000    3.000
 T        H73    C7     H72     109.470    3.000
 T        H73    C7     H71     109.470    3.000
 T        H72    C7     H71     109.470    3.000
 T        C4     N3     H3      120.000    3.000
 T        C4     N3     C2      120.000    3.000
 T        N3     C4     O4      120.000    3.000
 T        N3     C2     O2      120.000    3.000
 T        H3     N3     C2      120.000    3.000

loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 T        C2e-nyu0 C4'    O4'    C1'    C2'      339.000    5.000   1
 T        C2e-nyu1 O4'    C1'    C2'    C3'       35.000    3.400   1
 T        C2e-nyu2 C1'    C2'    C3'    C4'      324.000    2.800   1
 T        C2e-nyu3 C2'    C3'    C4'    O4'       24.000    4.400   1
 T        C2e-nyu4 C3'    C4'    O4'    C1'      357.700    5.700   1
 T        C3e-delta C5'    C4'   C3'    O3'       147.300    4.900   1
 T        C2e-C4N1 C4'    O4'   C1'     N9       216.600    5.500   1


 T        C3e-nyu0 C4'    O4'    C1'    C2'        2.8      6.100   1
 T        C3e-nyu1 O4'    C1'    C2'    C3'      335.00     4.900   1
 T        C3e-nyu2 C1'    C2'    C3'    C4'       35.9      2.800   1
 T        C3e-nyu3 C2'    C3'    C4'    O4'      324.700    3.100   1
 T        C3e-nyu4 C3'    C4'    O4'    C1'       20.500    5.100   1
 T        C3e-delta C5'    C4'   C3'    O3'        81.0      4.400   1
 T        C2e-C4N1 C4'    O4'   C1'     N9       241.400    6.500   1

 T        var_1    "C5'"  "O5'"  P      OP2      180.000   20.000   3
 T        var_2    P      "O5'"  "C5'"  "C4'"    180.000   20.000   3
 T        var_3    "O5'"  "C5'"  "C4'"  "O4'"    180.000   20.000   3
 T        var_4    "C5'"  "C4'"  "C3'"  "C2'"    180.000   20.000   3
 T        var_5    "C5'"  "C4'"  "O4'"  "C1'"    180.000   20.000   3
 T        var_6    "C4'"  "O4'"  "C1'"  N1       180.000   20.000   3
 T        var_7    "C3'"  "C2'"  "C1'"  "O4'"    180.000   20.000   3
 T        var_8    "C1'"  "C2'"  "O2'"  "HO2'"   180.000   20.000   3
 T        var_9    "O3'"  "C3'"  "C2'"  "C1'"    180.000   20.000   3
 T        var_10   "HO3'" "O3'"  "C3'"  "C2'"    180.000   20.000   3
 T        var_11   "O4'"  "C1'"  N1     C2       180.000   20.000   3
 T        var_12   H71    C7     C5     C4       180.000   20.000   3
 T        CONST_1  "C1'"  N1     C6     C5         0.000    0.000   0
 T        CONST_2  "C1'"  N1     C2     N3         0.000    0.000   0
 T        CONST_6  N1     C6     C5     C4         0.000    0.000   0
 T        CONST_3  N1     C2     N3     C4         0.000    0.000   0
 T        CONST_5  C6     C5     C4     N3         0.000    0.000   0
 T        CONST_4  C5     C4     N3     C2         0.000    0.000   0

loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 T        chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 T        chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 T        chir_04  "C2'"  "C3'"  "C1'"  "O2'"     both
 T        chir_03  "C1'"  "C2'"  N1     "O4'"     positiv

loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 T        plan-1    "C1'"     0.020
 T        plan-1    N1        0.020
 T        plan-1    C6        0.020
 T        plan-1    H6        0.020
 T        plan-1    C5        0.020
 T        plan-1    C7        0.020
 T        plan-1    C4        0.020
 T        plan-1    N3        0.020
 T        plan-1    H3        0.020
 T        plan-1    C2        0.020
 T        plan-1    O2        0.020
 T        plan-1    O4        0.020
`.trim();

monomers["C"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
C        C   'CYTIDINE-5'-MONOPHOSPHATE           ' RNA                33  21 .
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_C
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 C             P      P    P         0.000      0.038   -0.419    0.173
 C             OP3    O    OP       -0.660      0.567   -1.664    0.847
 C             OP1    O    OP       -0.660      0.215    0.825    1.015
 C             "O5'"  O    O2        0.000     -1.562   -0.639    0.083
 C             "C5'"  C    CH2       0.000     -2.404    0.384   -0.477
 C             "H5' " H    H         0.000     -2.029    0.663   -1.464
 C             "H5''" H    H         0.000     -2.395    1.259    0.175
 C             "C4'"  C    CH1       0.000     -3.824   -0.142   -0.603
 C             "H4'"  H    H         0.000     -3.777   -1.097   -1.144
 C             "C3'"  C    CH1       0.000     -4.916    0.723   -1.278
 C             "H3'"  H    H         0.000     -4.626    1.783   -1.246
 C             "O3'"  O    OH1       0.000     -5.134    0.315   -2.638
 C             "HO3'" H    H         0.000     -5.873    0.815   -3.012
 C             "C2'"  C    CH1       0.000     -6.193    0.496   -0.415
 C             "H2'"  H    H         0.000     -6.557    1.447    0.000
 C             "O2'"  O    OH1       0.000     -7.230   -0.163   -1.162
 C             "HO2'" H    H         0.000     -7.976   -0.359   -0.577
 C             "C1'"  C    CH1       0.000     -5.738   -0.448    0.708
 C             "H1'"  H    H         0.000     -6.006   -1.458    0.369
 C             "O4'"  O    O2        0.000     -4.304   -0.420    0.730
 C             N1     N    NR6       0.000     -6.329   -0.312    2.028
 C             C6     C    CR16      0.000     -7.026   -1.371    2.527
 C             H6     H    H         0.000     -7.062   -2.280    1.939
 C             C5     C    CR16      0.000     -7.699   -1.355    3.754
 C             H5     H    H         0.000     -8.260   -2.207    4.118
 C             C4     C    CR6       0.000     -7.600   -0.190    4.462
 C             N4     N    NH2       0.000     -8.122    0.008    5.696
 C             H42    H    H         0.000     -8.627   -0.736    6.156
 C             H41    H    H         0.000     -8.007    0.900    6.155
 C             N3     N    NRD6      0.000     -6.698    0.750    4.027
 C             C2     C    CR6       0.000     -5.910    0.668    2.928
 C             O2     O    O         0.000     -4.880    1.357    2.766
 C             OP2    O    OP       -0.660      0.516   -0.270   -1.254
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 C        "O5'"  n/a    "C5'"  START
 C        P      "O5'"  .      .    
 C        OP3    P      .      .
 C        OP1    P      .      .
 C        "C5'"  "O5'"  "C4'"  .
 C        "H5' " "C5'"  .      .
 C        "H5''" "C5'"  .      .
 C        "C4'"  "C5'"  "C3'"  .
 C        "H4'"  "C4'"  .      .
 C        "C3'"  "C4'"  "C2'"  .
 C        "H3'"  "C3'"  .      .
 C        "O3'"  "C3'"  "HO3'" .
 C        "HO3'" "O3'"  .      .
 C        "C2'"  "C3'"  "C1'"  .
 C        "H2'"  "C2'"  .      .
 C        "O2'"  "C2'"  "HO2'" .
 C        "HO2'" "O2'"  .      .
 C        "C1'"  "C2'"  N1     .
 C        "H1'"  "C1'"  .      .
 C        "O4'"  "C1'"  .      .
 C        N1     "C1'"  C6     .
 C        C6     N1     C5     .
 C        H6     C6     .      .
 C        C5     C6     C4     .
 C        H5     C5     .      .
 C        C4     C5     N3     .
 C        N4     C4     H41    .
 C        H42    N4     .      .
 C        H41    N4     .      .
 C        N3     C4     C2     .
 C        C2     N3     O2     .
 C        O2     C2     .      END
 C        OP2    P      .      .   
 C        "C4'"  "O4'"  .    ADD
 C        N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 C        OP3    P         deloc       1.485    0.017
 C        OP1    P         deloc       1.485    0.017
 C        OP2    P         deloc       1.485    0.017
 C        "O5'"  P         single      1.593    0.010
 C        "C5'"  "O5'"     single      1.440    0.016
 C        "C4'"  "C5'"     single      1.510    0.013
 C        "C4'"  "O4'"     single      1.453    0.012
 C        "C3'"  "C4'"     single      1.524    0.011
 C        "O4'"  "C1'"     single      1.414    0.012
 C        "O3'"  "C3'"     single      1.423    0.014
 C        "C2'"  "C3'"     single      1.525    0.011
 C        "O2'"  "C2'"     single      1.413    0.013
 C        "C1'"  "C2'"     single      1.528    0.010
 C        N1     "C1'"     single      1.470    0.012
 C        N1     C2        single      1.397    0.010
 C        C6     N1        single      1.367    0.006
 C        O2     C2        double      1.240    0.009
 C        C2     N3        single      1.353    0.008
 C        N3     C4        double      1.335    0.007
 C        N4     C4        single      1.335    0.009
 C        C4     C5        single      1.425    0.008
 C        C5     C6        double      1.339    0.008
 C        "H5' " "C5'"     single      1.092    0.020
 C        "H5''" "C5'"     single      1.092    0.020
 C        "H4'"  "C4'"     single      1.099    0.020
 C        "H3'"  "C3'"     single      1.099    0.020
 C        "HO3'" "O3'"     single      0.967    0.020
 C        "H2'"  "C2'"     single      1.099    0.020
 C        "HO2'" "O2'"     single      0.967    0.020
 C        "H1'"  "C1'"     single      1.099    0.020
 C        H41    N4        single      1.010    0.020
 C        H42    N4        single      1.010    0.020
 C        H5     C5        single      1.083    0.020
 C        H6     C6        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 C        OP3    P      OP1     107.400    3.200
 C        OP3    P      "O5'"   104.000    1.900
 C        OP1    P      "O5'"   108.100    2.900
 C        OP3    P      OP2     108.300    3.200
 C        OP1    P      OP2     119.600    1.500
 C        "O5'"  P      OP2     108.300    2.700
 C        P      "O5'"  "C5'"   120.900    1.600
 C        "O5'"  "C5'"  "H5' "  109.470    3.000
 C        "O5'"  "C5'"  "H5''"  109.470    3.000
 C        "O5'"  "C5'"  "C4'"   110.200    1.400
 C        "H5' " "C5'"  "H5''"  107.900    3.000
 C        "H5' " "C5'"  "C4'"   109.470    3.000
 C        "H5''" "C5'"  "C4'"   109.470    3.000
 C        "C5'"  "C4'"  "H4'"   108.340    3.000
 C        "C5'"  "C4'"  "C3'"   115.500    1.500
 C        "C5'"  "C4'"  "O4'"   109.200    1.400
 C        "H4'"  "C4'"  "C3'"   108.340    3.000
 C        "H4'"  "C4'"  "O4'"   109.470    3.000
 C        "C3'"  "C4'"  "O4'"   105.500    1.400
 C        "C4'"  "C3'"  "H3'"   108.340    3.000
 C        "C4'"  "C3'"  "O3'"   110.600    2.600
 C        "C4'"  "C3'"  "C2'"   102.700    1.000
 C        "H3'"  "C3'"  "O3'"   109.470    3.000
 C        "H3'"  "C3'"  "C2'"   108.340    3.000
 C        "O3'"  "C3'"  "C2'"   111.000    2.800
 C        "C3'"  "O3'"  "HO3'"  109.470    3.000
 C        "C3'"  "C2'"  "H2'"   108.340    3.000
 C        "C3'"  "C2'"  "O2'"   113.300    2.900
 C        "C3'"  "C2'"  "C1'"   101.500    0.900
 C        "H2'"  "C2'"  "O2'"   109.470    3.000
 C        "H2'"  "C2'"  "C1'"   108.340    3.000
 C        "O2'"  "C2'"  "C1'"   110.600    3.000
 C        "C2'"  "O2'"  "HO2'"  109.470    3.000
 C        "C2'"  "C1'"  "H1'"   108.340    3.000
 C        "C2'"  "C1'"  "O4'"   106.400    1.400
 C        "C2'"  "C1'"  N1      113.400    1.600
 C        "H1'"  "C1'"  "O4'"   109.470    3.000
 C        "H1'"  "C1'"  N1      109.470    3.000
 C        "O4'"  "C1'"  N1      108.200    1.000
 C        "C1'"  "O4'"  "C4'"   109.600    0.900
 C        "C1'"  N1     C6      120.800    1.200
 C        "C1'"  N1     C2      118.800    1.100
 C        C6     N1     C2      120.300    0.400
 C        N1     C6     H6      120.000    3.000
 C        N1     C6     C5      121.000    0.500
 C        H6     C6     C5      120.000    3.000
 C        C6     C5     H5      120.000    3.000
 C        C6     C5     C4      117.400    0.500
 C        H5     C5     C4      120.000    3.000
 C        C5     C4     N4      120.200    0.700
 C        C5     C4     N3      121.900    0.400
 C        N4     C4     N3      118.000    0.700
 C        C4     N4     H42     120.000    3.000
 C        C4     N4     H41     120.000    3.000
 C        H42    N4     H41     120.000    3.000
 C        C4     N3     C2      119.900    0.500
 C        N3     C2     O2      121.900    0.700
 C        N3     C2     N1      119.200    0.700
 C        O2     C2     N1      118.900    0.600
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 C        C2e-nyu0 C4'    O4'    C1'    C2'      339.000    5.000   1
 C        C2e-nyu1 O4'    C1'    C2'    C3'       35.000    3.400   1
 C        C2e-nyu2 C1'    C2'    C3'    C4'      324.000    2.800   1
 C        C2e-nyu3 C2'    C3'    C4'    O4'       24.000    4.400   1
 C        C2e-nyu4 C3'    C4'    O4'    C1'      357.700    5.700   1
 C        C2e-delta C5'    C4'   C3'    O3'       147.300    4.900   1
 C        C2e-C4N1 C4'    O4'   C1'     N9       216.60    5.500   1


 C        C3e-nyu0 C4'    O4'    C1'    C2'        2.8      6.100   1
 C        C3e-nyu1 O4'    C1'    C2'    C3'      335.00     4.900   1
 C        C3e-nyu2 C1'    C2'    C3'    C4'       35.9      2.800   1
 C        C3e-nyu3 C2'    C3'    C4'    O4'      324.700    3.100   1
 C        C3e-nyu4 C3'    C4'    O4'    C1'       20.500    5.100   1
 C        C3e-delta C5'    C4'   C3'    O3'        81.0      4.400   1
 C        C2e-C4N1 C4'    O4'   C1'     N9       241.400    6.500   1

 C        var_1    OP2    P      "O5'"  "C5'"    -60.088   20.000   1
 C        var_2    P      "O5'"  "C5'"  "C4'"   -179.950   20.000   1
 C        var_3    "O5'"  "C5'"  "C4'"  "C3'"    176.925   20.000   3
 C        var_4    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 C        var_5    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 C        var_6    "C4'"  "C3'"  "O3'"  "HO3'"   175.000   20.000   1
 C        var_8    "C3'"  "C2'"  "O2'"  "HO2'"   175.000   20.000   1
 C        var_9    "C3'"  "C2'"  "C1'"  N1       150.000   20.000   3
 C        var_11   "C2'"  "C1'"  N1     C6       121.461   20.000   1
 C        CONST_1  "C1'"  N1     C2     N3       180.000    0.000   0
 C        CONST_2  "C1'"  N1     C6     C5       180.000    0.000   0
 C        CONST_3  N1     C6     C5     C4         0.000    0.000   0
 C        CONST_4  C6     C5     C4     N3         0.000    0.000   0
 C        CONST_5  C5     C4     N4     H41      180.000    0.000   0
 C        CONST_6  C5     C4     N3     C2         0.000    0.000   0
 C        CONST_7  C4     N3     C2     O2       180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 C        chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 C        chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 C        chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 C        chir_04  "C1'"  "O4'"  "C2'"  N1        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 C        plan-1    N1        0.020
 C        plan-1    "C1'"     0.020
 C        plan-1    C2        0.020
 C        plan-1    C6        0.020
 C        plan-1    N3        0.020
 C        plan-1    C4        0.020
 C        plan-1    C5        0.020
 C        plan-1    O2        0.020
 C        plan-1    N4        0.020
 C        plan-1    H5        0.020
 C        plan-1    H6        0.020
 C        plan-1    H42       0.020
 C        plan-1    H41       0.020
 C        plan-2    N4        0.020
 C        plan-2    C4        0.020
 C        plan-2    H41       0.020
 C        plan-2    H42       0.020
# ------------------------------------------------------
# ------------------------------------------------------
# ------------------------------------------------------
`.trim();

monomers["YG"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
YG       YG  'WYBUTOSINE                          ' RNA                67  40 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_YG
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 YG            OP3    O    OP       -0.666      0.000    0.000    0.000
 YG            P      P    P         0.000     -0.971   -0.474    1.059
 YG            OP1    O    OP       -0.666     -1.202    0.632    2.066
 YG            OP2    O    OP       -0.666     -0.398   -1.684    1.764
 YG            "O5'"  O    O2        0.000     -2.370   -0.868    0.367
 YG            "C5'"  C    CH2       0.000     -2.859    0.309   -0.277
 YG            "H5'"  H    H         0.000     -2.135    0.641   -1.025
 YG            "H5''" H    H         0.000     -3.001    1.097    0.465
 YG            "C4'"  C    CH1       0.000     -4.193    0.001   -0.959
 YG            "H4'"  H    H         0.000     -4.063   -0.781   -1.720
 YG            "O4'"  O    O2        0.000     -5.175   -0.406    0.019
 YG            "C1'"  C    CH1       0.000     -6.455   -0.191   -0.614
 YG            "H1'"  H    H         0.000     -6.674   -1.004   -1.320
 YG            N9     N    NR5       0.000     -7.512   -0.093    0.394
 YG            C4     C    CR56      0.000     -8.826   -0.402    0.215
 YG            N3     N    NR6       0.000     -9.558   -0.863   -0.851
 YG            C3     C    CH3       0.000     -8.901   -1.121   -2.134
 YG            H33    H    H         0.000     -8.463   -0.226   -2.493
 YG            H32    H    H         0.000     -8.148   -1.855   -2.004
 YG            H31    H    H         0.000     -9.616   -1.469   -2.833
 YG            C8     C    CR15      0.000     -7.361    0.323    1.684
 YG            H8     H    H         0.000     -6.427    0.638    2.132
 YG            N7     N    NRD5      0.000     -8.508    0.283    2.293
 YG            C5     C    CR56      0.000     -9.456   -0.160    1.428
 YG            C6     C    CR6       0.000    -10.849   -0.396    1.543
 YG            O6     O    O         0.000    -11.420   -0.191    2.598
 YG            N1     N    NR56      0.000    -11.538   -0.849    0.478
 YG            C2     C    CR56      0.000    -10.913   -1.085   -0.713
 YG            C12    C    CR5       0.000    -12.869   -1.160    0.307
 YG            C11    C    CR5       0.000    -13.012   -1.574   -0.964
 YG            C10    C    CH3       0.000    -14.301   -2.019   -1.605
 YG            H103   H    H         0.000    -15.114   -1.515   -1.150
 YG            H102   H    H         0.000    -14.279   -1.791   -2.639
 YG            H101   H    H         0.000    -14.417   -3.064   -1.476
 YG            N2     N    NRD5      0.000    -11.815   -1.516   -1.568
 YG            C13    C    CH2       0.000    -13.955   -1.059    1.345
 YG            H131   H    H         0.000    -13.526   -1.227    2.335
 YG            H132   H    H         0.000    -14.718   -1.815    1.147
 YG            C14    C    CH2       0.000    -14.587    0.333    1.291
 YG            H141   H    H         0.000    -15.013    0.500    0.299
 YG            H142   H    H         0.000    -13.822    1.087    1.488
 YG            C15    C    CH1       0.000    -15.690    0.434    2.345
 YG            H15    H    H         0.000    -16.459   -0.325    2.146
 YG            C16    C    C         0.000    -16.312    1.806    2.292
 YG            O18    O    O2       -0.500    -15.846    2.733    2.991
 YG            C19    C    CH3       0.000    -16.412    4.121    2.990
 YG            H193   H    H         0.000    -16.361    4.541    2.012
 YG            H192   H    H         0.000    -17.430    4.107    3.300
 YG            H191   H    H         0.000    -15.863    4.746    3.656
 YG            O17    O    O        -0.500    -17.294    2.018    1.547
 YG            N20    N    NH1       0.000    -15.116    0.210    3.674
 YG            HN2    H    H         0.000    -14.157    0.467    3.860
 YG            C21    C    C         0.000    -15.868   -0.338    4.648
 YG            O22    O    O         0.000    -17.021   -0.647    4.425
 YG            O23    O    O2        0.000    -15.340   -0.543    5.870
 YG            C24    C    CH3       0.000    -16.150   -1.135    6.920
 YG            H243   H    H         0.000    -16.996   -0.523    7.110
 YG            H242   H    H         0.000    -16.479   -2.099    6.621
 YG            H241   H    H         0.000    -15.578   -1.223    7.810
 YG            "C3'"  C    CH1       0.000     -4.781    1.279   -1.597
 YG            "H3'"  H    H         0.000     -4.390    2.175   -1.095
 YG            "C2'"  C    CH1       0.000     -6.304    1.149   -1.368
 YG            "H2'"  H    H         0.000     -6.672    1.980   -0.751
 YG            "O2'"  O    OH1       0.000     -6.997    1.108   -2.617
 YG            "HO2'" H    H         0.000     -6.841    1.932   -3.099
 YG            "O3'"  O    OH1       0.000     -4.486    1.321   -2.995
 YG            "HO3'" H    H         0.000     -4.875    2.136   -3.339
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 YG       OP3    n/a    P      START
 YG       P      OP3    "O5'"  .
 YG       OP1    P      .      .
 YG       OP2    P      .      .
 YG       "O5'"  P      "C5'"  .
 YG       "C5'"  "O5'"  "C4'"  .
 YG       "H5'"  "C5'"  .      .
 YG       "H5''" "C5'"  .      .
 YG       "C4'"  "C5'"  "C3'"  .
 YG       "H4'"  "C4'"  .      .
 YG       "O4'"  "C4'"  "C1'"  .
 YG       "C1'"  "O4'"  N9     .
 YG       "H1'"  "C1'"  .      .
 YG       N9     "C1'"  C8     .
 YG       C4     N9     N3     .
 YG       N3     C4     C3     .
 YG       C3     N3     H31    .
 YG       H33    C3     .      .
 YG       H32    C3     .      .
 YG       H31    C3     .      .
 YG       C8     N9     N7     .
 YG       H8     C8     .      .
 YG       N7     C8     C5     .
 YG       C5     N7     C6     .
 YG       C6     C5     N1     .
 YG       O6     C6     .      .
 YG       N1     C6     C12    .
 YG       C2     N1     .      .
 YG       C12    N1     C13    .
 YG       C11    C12    N2     .
 YG       C10    C11    H101   .
 YG       H103   C10    .      .
 YG       H102   C10    .      .
 YG       H101   C10    .      .
 YG       N2     C11    .      .
 YG       C13    C12    C14    .
 YG       H131   C13    .      .
 YG       H132   C13    .      .
 YG       C14    C13    C15    .
 YG       H141   C14    .      .
 YG       H142   C14    .      .
 YG       C15    C14    N20    .
 YG       H15    C15    .      .
 YG       C16    C15    O17    .
 YG       O18    C16    C19    .
 YG       C19    O18    H191   .
 YG       H193   C19    .      .
 YG       H192   C19    .      .
 YG       H191   C19    .      .
 YG       O17    C16    .      .
 YG       N20    C15    C21    .
 YG       HN2    N20    .      .
 YG       C21    N20    O23    .
 YG       O22    C21    .      .
 YG       O23    C21    C24    .
 YG       C24    O23    H241   .
 YG       H243   C24    .      .
 YG       H242   C24    .      .
 YG       H241   C24    .      .
 YG       "C3'"  "C4'"  "O3'"  .
 YG       "H3'"  "C3'"  .      .
 YG       "C2'"  "C3'"  "O2'"  .
 YG       "H2'"  "C2'"  .      .
 YG       "O2'"  "C2'"  "HO2'" .
 YG       "HO2'" "O2'"  .      .
 YG       "O3'"  "C3'"  .      END
 YG       "HO3'" "O3'"  .      .
 YG       N2     C2     .    ADD
 YG       C2     N3     .    ADD
 YG       C4     C5     .    ADD
 YG       "C1'"  "C2'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 YG       C2     N1        single      1.337    0.020
 YG       N1     C6        single      1.337    0.020
 YG       C12    N1        single      1.337    0.020
 YG       N2     C2        double      1.350    0.020
 YG       N2     C11       single      1.350    0.020
 YG       C2     N3        single      1.337    0.020
 YG       C3     N3        single      1.465    0.020
 YG       N3     C4        single      1.337    0.020
 YG       H31    C3        single      1.059    0.020
 YG       H32    C3        single      1.059    0.020
 YG       H33    C3        single      1.059    0.020
 YG       C4     C5        double      1.490    0.020
 YG       C4     N9        single      1.337    0.020
 YG       C6     C5        single      1.490    0.020
 YG       C5     N7        single      1.350    0.020
 YG       O6     C6        double      1.250    0.020
 YG       N7     C8        double      1.350    0.020
 YG       C8     N9        single      1.337    0.020
 YG       H8     C8        single      1.083    0.020
 YG       N9     "C1'"     single      1.485    0.020
 YG       C10    C11       single      1.506    0.020
 YG       H101   C10       single      1.059    0.020
 YG       H102   C10       single      1.059    0.020
 YG       H103   C10       single      1.059    0.020
 YG       C11    C12       double      1.490    0.020
 YG       C13    C12       single      1.510    0.020
 YG       C14    C13       single      1.524    0.020
 YG       H131   C13       single      1.092    0.020
 YG       H132   C13       single      1.092    0.020
 YG       C15    C14       single      1.524    0.020
 YG       H141   C14       single      1.092    0.020
 YG       H142   C14       single      1.092    0.020
 YG       C16    C15       single      1.500    0.020
 YG       N20    C15       single      1.450    0.020
 YG       H15    C15       single      1.099    0.020
 YG       O17    C16       deloc       1.220    0.020
 YG       O18    C16       deloc       1.454    0.020
 YG       C19    O18       single      1.426    0.020
 YG       H191   C19       single      1.059    0.020
 YG       H192   C19       single      1.059    0.020
 YG       H193   C19       single      1.059    0.020
 YG       C21    N20       single      1.330    0.020
 YG       HN2    N20       single      1.010    0.020
 YG       O22    C21       double      1.220    0.020
 YG       O23    C21       single      1.454    0.020
 YG       C24    O23       single      1.426    0.020
 YG       H241   C24       single      1.059    0.020
 YG       H242   C24       single      1.059    0.020
 YG       H243   C24       single      1.059    0.020
 YG       "C1'"  "C2'"     single      1.524    0.020
 YG       "C1'"  "O4'"     single      1.426    0.020
 YG       "H1'"  "C1'"     single      1.099    0.020
 YG       "O2'"  "C2'"     single      1.432    0.020
 YG       "C2'"  "C3'"     single      1.524    0.020
 YG       "H2'"  "C2'"     single      1.099    0.020
 YG       "HO2'" "O2'"     single      0.967    0.020
 YG       "O3'"  "C3'"     single      1.432    0.020
 YG       "C3'"  "C4'"     single      1.524    0.020
 YG       "H3'"  "C3'"     single      1.099    0.020
 YG       "HO3'" "O3'"     single      0.967    0.020
 YG       "O4'"  "C4'"     single      1.426    0.020
 YG       "C4'"  "C5'"     single      1.524    0.020
 YG       "H4'"  "C4'"     single      1.099    0.020
 YG       "C5'"  "O5'"     single      1.426    0.020
 YG       "H5'"  "C5'"     single      1.092    0.020
 YG       "H5''" "C5'"     single      1.092    0.020
 YG       "O5'"  P         single      1.610    0.020
 YG       OP1    P         deloc       1.510    0.020
 YG       OP2    P         deloc       1.510    0.020
 YG       P      OP3       deloc       1.510    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 YG       OP3    P      OP1     119.900    3.000
 YG       OP3    P      OP2     119.900    3.000
 YG       OP3    P      "O5'"   108.200    3.000
 YG       OP1    P      OP2     119.900    3.000
 YG       OP1    P      "O5'"   108.200    3.000
 YG       OP2    P      "O5'"   108.200    3.000
 YG       P      "O5'"  "C5'"   120.500    3.000
 YG       "O5'"  "C5'"  "H5'"   109.470    3.000
 YG       "O5'"  "C5'"  "H5''"  109.470    3.000
 YG       "O5'"  "C5'"  "C4'"   109.470    3.000
 YG       "H5'"  "C5'"  "H5''"  107.900    3.000
 YG       "H5'"  "C5'"  "C4'"   109.470    3.000
 YG       "H5''" "C5'"  "C4'"   109.470    3.000
 YG       "C5'"  "C4'"  "H4'"   108.340    3.000
 YG       "C5'"  "C4'"  "O4'"   109.470    3.000
 YG       "C5'"  "C4'"  "C3'"   111.000    3.000
 YG       "H4'"  "C4'"  "O4'"   109.470    3.000
 YG       "H4'"  "C4'"  "C3'"   108.340    3.000
 YG       "O4'"  "C4'"  "C3'"   109.470    3.000
 YG       "C4'"  "O4'"  "C1'"   111.800    3.000
 YG       "O4'"  "C1'"  "H1'"   109.470    3.000
 YG       "O4'"  "C1'"  N9      109.470    3.000
 YG       "O4'"  "C1'"  "C2'"   109.470    3.000
 YG       "H1'"  "C1'"  N9      109.470    3.000
 YG       "H1'"  "C1'"  "C2'"   108.340    3.000
 YG       N9     "C1'"  "C2'"   109.470    3.000
 YG       "C1'"  N9     C4      126.000    3.000
 YG       "C1'"  N9     C8      126.000    3.000
 YG       C4     N9     C8      108.000    3.000
 YG       N9     C4     N3      132.000    3.000
 YG       N9     C4     C5      108.000    3.000
 YG       N3     C4     C5      120.000    3.000
 YG       C4     N3     C3      120.000    3.000
 YG       C4     N3     C2      120.000    3.000
 YG       C3     N3     C2      120.000    3.000
 YG       N3     C3     H33     109.470    3.000
 YG       N3     C3     H32     109.470    3.000
 YG       N3     C3     H31     109.470    3.000
 YG       H33    C3     H32     109.470    3.000
 YG       H33    C3     H31     109.470    3.000
 YG       H32    C3     H31     109.470    3.000
 YG       N9     C8     H8      126.000    3.000
 YG       N9     C8     N7      108.000    3.000
 YG       H8     C8     N7      126.000    3.000
 YG       C8     N7     C5      108.000    3.000
 YG       N7     C5     C6      132.000    3.000
 YG       N7     C5     C4      108.000    3.000
 YG       C6     C5     C4      120.000    3.000
 YG       C5     C6     O6      120.000    3.000
 YG       C5     C6     N1      120.000    3.000
 YG       O6     C6     N1      120.000    3.000
 YG       C6     N1     C2      120.000    3.000
 YG       C6     N1     C12     132.000    3.000
 YG       C2     N1     C12     108.000    3.000
 YG       N1     C2     N2      108.000    3.000
 YG       N1     C2     N3      120.000    3.000
 YG       N2     C2     N3      120.000    3.000
 YG       N1     C12    C11     108.000    3.000
 YG       N1     C12    C13     126.000    3.000
 YG       C11    C12    C13     126.000    3.000
 YG       C12    C11    C10     126.000    3.000
 YG       C12    C11    N2      108.000    3.000
 YG       C10    C11    N2      126.000    3.000
 YG       C11    C10    H103    109.470    3.000
 YG       C11    C10    H102    109.470    3.000
 YG       C11    C10    H101    109.470    3.000
 YG       H103   C10    H102    109.470    3.000
 YG       H103   C10    H101    109.470    3.000
 YG       H102   C10    H101    109.470    3.000
 YG       C11    N2     C2      108.000    3.000
 YG       C12    C13    H131    109.470    3.000
 YG       C12    C13    H132    109.470    3.000
 YG       C12    C13    C14     109.470    3.000
 YG       H131   C13    H132    107.900    3.000
 YG       H131   C13    C14     109.470    3.000
 YG       H132   C13    C14     109.470    3.000
 YG       C13    C14    H141    109.470    3.000
 YG       C13    C14    H142    109.470    3.000
 YG       C13    C14    C15     111.000    3.000
 YG       H141   C14    H142    107.900    3.000
 YG       H141   C14    C15     109.470    3.000
 YG       H142   C14    C15     109.470    3.000
 YG       C14    C15    H15     108.340    3.000
 YG       C14    C15    C16     109.470    3.000
 YG       C14    C15    N20     110.000    3.000
 YG       H15    C15    C16     108.810    3.000
 YG       H15    C15    N20     108.550    3.000
 YG       C16    C15    N20     111.600    3.000
 YG       C15    C16    O18     120.000    3.000
 YG       C15    C16    O17     120.500    3.000
 YG       O18    C16    O17     119.000    3.000
 YG       C16    O18    C19     120.000    3.000
 YG       O18    C19    H193    109.470    3.000
 YG       O18    C19    H192    109.470    3.000
 YG       O18    C19    H191    109.470    3.000
 YG       H193   C19    H192    109.470    3.000
 YG       H193   C19    H191    109.470    3.000
 YG       H192   C19    H191    109.470    3.000
 YG       C15    N20    HN2     118.500    3.000
 YG       C15    N20    C21     121.500    3.000
 YG       HN2    N20    C21     120.000    3.000
 YG       N20    C21    O22     123.000    3.000
 YG       N20    C21    O23     118.000    3.000
 YG       O22    C21    O23     119.000    3.000
 YG       C21    O23    C24     120.000    3.000
 YG       O23    C24    H243    109.470    3.000
 YG       O23    C24    H242    109.470    3.000
 YG       O23    C24    H241    109.470    3.000
 YG       H243   C24    H242    109.470    3.000
 YG       H243   C24    H241    109.470    3.000
 YG       H242   C24    H241    109.470    3.000
 YG       "C4'"  "C3'"  "H3'"   108.340    3.000
 YG       "C4'"  "C3'"  "C2'"   111.000    3.000
 YG       "C4'"  "C3'"  "O3'"   109.470    3.000
 YG       "H3'"  "C3'"  "C2'"   108.340    3.000
 YG       "H3'"  "C3'"  "O3'"   109.470    3.000
 YG       "C2'"  "C3'"  "O3'"   109.470    3.000
 YG       "C3'"  "C2'"  "H2'"   108.340    3.000
 YG       "C3'"  "C2'"  "O2'"   109.470    3.000
 YG       "C3'"  "C2'"  "C1'"   111.000    3.000
 YG       "H2'"  "C2'"  "O2'"   109.470    3.000
 YG       "H2'"  "C2'"  "C1'"   108.340    3.000
 YG       "O2'"  "C2'"  "C1'"   109.470    3.000
 YG       "C2'"  "O2'"  "HO2'"  109.470    3.000
 YG       "C3'"  "O3'"  "HO3'"  109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 YG       var_1    OP3    P      "O5'"  "C5'"    -60.024   20.000   1
 YG       var_2    P      "O5'"  "C5'"  "C4'"    179.983   20.000   1
 YG       var_3    "O5'"  "C5'"  "C4'"  "C3'"    176.863   20.000   3
 YG       var_4    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 YG       var_5    "C4'"  "O4'"  "C1'"  N9      -150.000   20.000   1
 YG       var_6    "O4'"  "C1'"  "C2'"  "C3'"     30.000   20.000   3
 YG       var_7    "O4'"  "C1'"  N9     C8        27.025   20.000   1
 YG       CONST_1  "C1'"  N9     C4     N3         0.000    0.000   0
 YG       CONST_2  N9     C4     C5     N7         0.000    0.000   0
 YG       CONST_3  N9     C4     N3     C3         0.000    0.000   0
 YG       var_8    C4     N3     C3     H31      179.960   20.000   1
 YG       CONST_4  "C1'"  N9     C8     N7       180.000    0.000   0
 YG       CONST_5  N9     C8     N7     C5         0.000    0.000   0
 YG       CONST_6  C8     N7     C5     C6       180.000    0.000   0
 YG       CONST_7  N7     C5     C6     N1       180.000    0.000   0
 YG       CONST_8  C5     C6     N1     C12      180.000    0.000   0
 YG       CONST_9  C6     N1     C2     N2       180.000    0.000   0
 YG       CONST_10 N1     C2     N3     C4         0.000    0.000   0
 YG       CONST_11 C6     N1     C12    C13        0.000    0.000   0
 YG       CONST_12 N1     C12    C11    N2         0.000    0.000   0
 YG       var_9    C12    C11    C10    H101     -90.442   20.000   1
 YG       CONST_13 C12    C11    N2     C2         0.000    0.000   0
 YG       CONST_14 C11    N2     C2     N1         0.000    0.000   0
 YG       var_10   N1     C12    C13    C14       89.951   20.000   2
 YG       var_11   C12    C13    C14    C15      179.966   20.000   3
 YG       var_12   C13    C14    C15    N20       60.007   20.000   3
 YG       var_13   C14    C15    C16    O17       90.055   20.000   3
 YG       var_14   C15    C16    O18    C19     -179.992   20.000   1
 YG       var_15   C16    O18    C19    H191    -179.984   20.000   1
 YG       var_16   C14    C15    N20    C21     -150.076   20.000   3
 YG       CONST_15 C15    N20    C21    O23      180.000    0.000   0
 YG       var_17   N20    C21    O23    C24     -179.952   20.000   1
 YG       var_18   C21    O23    C24    H241     179.968   20.000   1
 YG       var_19   "C5'"  "C4'"  "C3'"  "O3'"     90.000   20.000   3
 YG       var_20   "C4'"  "C3'"  "C2'"  "O2'"   -120.000   20.000   3
 YG       var_21   "C3'"  "C2'"  "O2'"  "HO2'"   -61.480   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 YG       chir_01  C15    C14    C16    N20       positiv
 YG       chir_02  "C1'"  N9     "C2'"  "O4'"     negativ
 YG       chir_03  "C2'"  "C1'"  "O2'"  "C3'"     positiv
 YG       chir_04  "C3'"  "C2'"  "O3'"  "C4'"     positiv
 YG       chir_05  "C4'"  "C3'"  "O4'"  "C5'"     positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 YG       plan-1    N2        0.020
 YG       plan-1    C2        0.020
 YG       plan-1    C11       0.020
 YG       plan-1    C12       0.020
 YG       plan-1    N3        0.020
 YG       plan-1    N1        0.020
 YG       plan-1    C6        0.020
 YG       plan-1    C3        0.020
 YG       plan-1    C4        0.020
 YG       plan-1    C5        0.020
 YG       plan-1    N9        0.020
 YG       plan-1    N7        0.020
 YG       plan-1    C8        0.020
 YG       plan-1    O6        0.020
 YG       plan-1    H8        0.020
 YG       plan-1    "C1'"     0.020
 YG       plan-1    C10       0.020
 YG       plan-1    C13       0.020
 YG       plan-2    C16       0.020
 YG       plan-2    C15       0.020
 YG       plan-2    O17       0.020
 YG       plan-2    O18       0.020
 YG       plan-3    N20       0.020
 YG       plan-3    C15       0.020
 YG       plan-3    C21       0.020
 YG       plan-3    HN2       0.020
 YG       plan-4    C21       0.020
 YG       plan-4    N20       0.020
 YG       plan-4    O22       0.020
 YG       plan-4    O23       0.020
 YG       plan-4    HN2       0.020
# ------------------------------------------------------
`.trim();

monomers["PSU"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PSU      PSU 'PSEUDOURIDINE-5'-MONOPHOSPHATE      ' RNA                32  21 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PSU
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PSU           OP3    O    OP       -0.666      0.000    0.000    0.000
 PSU           P      P    P         0.000     -1.224    0.219   -0.862
 PSU           OP1    O    OP       -0.666     -1.686   -1.105   -1.430
 PSU           OP2    O    OP       -0.666     -0.881    1.162   -1.994
 PSU           "O5'"  O    O2        0.000     -2.402    0.859    0.032
 PSU           "C5'"  C    CH2       0.000     -2.679   -0.072    1.078
 PSU           "H5'"  H    H         0.000     -1.778   -0.227    1.675
 PSU           "H5''" H    H         0.000     -2.993   -1.024    0.643
 PSU           "C4'"  C    CH1       0.000     -3.795    0.477    1.968
 PSU           "H4'"  H    H         0.000     -3.486    1.429    2.422
 PSU           "O4'"  O    O2        0.000     -5.008    0.657    1.201
 PSU           "C1'"  C    CH1       0.000     -6.074    0.689    2.174
 PSU           "H1'"  H    H         0.000     -6.118    1.673    2.661
 PSU           C5     C    CR6       0.000     -7.393    0.368    1.520
 PSU           C4     C    CR6       0.000     -7.556   -0.829    0.785
 PSU           O4     O    O         0.000     -6.631   -1.615    0.676
 PSU           N3     N    NR16      0.000     -8.748   -1.098    0.212
 PSU           HN3    H    H         0.000     -8.879   -1.979   -0.324
 PSU           C6     C    CR16      0.000     -8.434    1.221    1.626
 PSU           H6     H    H         0.000     -8.327    2.143    2.183
 PSU           N1     N    NR16      0.000     -9.625    0.914    1.026
 PSU           HN1    H    H         0.000    -10.426    1.572    1.107
 PSU           C2     C    CR6       0.000     -9.768   -0.229    0.333
 PSU           O2     O    O         0.000    -10.835   -0.482   -0.192
 PSU           "C3'"  C    CH1       0.000     -4.171   -0.543    3.064
 PSU           "H3'"  H    H         0.000     -3.905   -1.562    2.749
 PSU           "C2'"  C    CH1       0.000     -5.703   -0.402    3.202
 PSU           "H2'"  H    H         0.000     -6.201   -1.350    2.953
 PSU           "O2'"  O    OH1       0.000     -6.051    0.011    4.524
 PSU           "HO2'" H    H         0.000     -5.757   -0.657    5.158
 PSU           "O3'"  O    OH1       0.000     -3.525   -0.216    4.295
 PSU           "HO3'" H    H         0.000     -3.821   -0.867    4.947
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PSU      OP3    n/a    P      START
 PSU      P      OP3    "O5'"  .
 PSU      OP1    P      .      .
 PSU      OP2    P      .      .
 PSU      "O5'"  P      "C5'"  .
 PSU      "C5'"  "O5'"  "C4'"  .
 PSU      "H5'"  "C5'"  .      .
 PSU      "H5''" "C5'"  .      .
 PSU      "C4'"  "C5'"  "C3'"  .
 PSU      "H4'"  "C4'"  .      .
 PSU      "O4'"  "C4'"  "C1'"  .
 PSU      "C1'"  "O4'"  C5     .
 PSU      "H1'"  "C1'"  .      .
 PSU      C5     "C1'"  C6     .
 PSU      C4     C5     N3     .
 PSU      O4     C4     .      .
 PSU      N3     C4     HN3    .
 PSU      HN3    N3     .      .
 PSU      C6     C5     N1     .
 PSU      H6     C6     .      .
 PSU      N1     C6     C2     .
 PSU      HN1    N1     .      .
 PSU      C2     N1     O2     .
 PSU      O2     C2     .      .
 PSU      "C3'"  "C4'"  "O3'"  .
 PSU      "H3'"  "C3'"  .      .
 PSU      "C2'"  "C3'"  "O2'"  .
 PSU      "H2'"  "C2'"  .      .
 PSU      "O2'"  "C2'"  "HO2'" .
 PSU      "HO2'" "O2'"  .      .
 PSU      "O3'"  "C3'"  .      END
 PSU      "HO3'" "O3'"  .      .
 PSU      C2     N3     .    ADD
 PSU      "C1'"  "C2'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PSU      C2     N1        single      1.337    0.020
 PSU      N1     C6        single      1.337    0.020
 PSU      HN1    N1        single      1.040    0.020
 PSU      C2     N3        single      1.337    0.020
 PSU      O2     C2        double      1.250    0.020
 PSU      N3     C4        single      1.337    0.020
 PSU      HN3    N3        single      1.040    0.020
 PSU      C4     C5        single      1.487    0.020
 PSU      O4     C4        double      1.250    0.020
 PSU      C6     C5        double      1.390    0.020
 PSU      C5     "C1'"     single      1.480    0.020
 PSU      H6     C6        single      1.083    0.020
 PSU      "C1'"  "C2'"     single      1.524    0.020
 PSU      "C1'"  "O4'"     single      1.426    0.020
 PSU      "H1'"  "C1'"     single      1.099    0.020
 PSU      "O2'"  "C2'"     single      1.432    0.020
 PSU      "C2'"  "C3'"     single      1.524    0.020
 PSU      "H2'"  "C2'"     single      1.099    0.020
 PSU      "HO2'" "O2'"     single      0.967    0.020
 PSU      "C3'"  "C4'"     single      1.524    0.020
 PSU      "O3'"  "C3'"     single      1.432    0.020
 PSU      "H3'"  "C3'"     single      1.099    0.020
 PSU      "O4'"  "C4'"     single      1.426    0.020
 PSU      "C4'"  "C5'"     single      1.524    0.020
 PSU      "H4'"  "C4'"     single      1.099    0.020
 PSU      "HO3'" "O3'"     single      0.967    0.020
 PSU      "C5'"  "O5'"     single      1.426    0.020
 PSU      "H5'"  "C5'"     single      1.092    0.020
 PSU      "H5''" "C5'"     single      1.092    0.020
 PSU      "O5'"  P         single      1.610    0.020
 PSU      OP1    P         deloc       1.510    0.020
 PSU      OP2    P         deloc       1.510    0.020
 PSU      P      OP3       deloc       1.510    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PSU      OP3    P      OP1     119.900    3.000
 PSU      OP3    P      OP2     119.900    3.000
 PSU      OP3    P      "O5'"   108.200    3.000
 PSU      OP1    P      OP2     119.900    3.000
 PSU      OP1    P      "O5'"   108.200    3.000
 PSU      OP2    P      "O5'"   108.200    3.000
 PSU      P      "O5'"  "C5'"   120.500    3.000
 PSU      "O5'"  "C5'"  "H5'"   109.470    3.000
 PSU      "O5'"  "C5'"  "H5''"  109.470    3.000
 PSU      "O5'"  "C5'"  "C4'"   109.470    3.000
 PSU      "H5'"  "C5'"  "H5''"  107.900    3.000
 PSU      "H5'"  "C5'"  "C4'"   109.470    3.000
 PSU      "H5''" "C5'"  "C4'"   109.470    3.000
 PSU      "C5'"  "C4'"  "H4'"   108.340    3.000
 PSU      "C5'"  "C4'"  "O4'"   109.470    3.000
 PSU      "C5'"  "C4'"  "C3'"   111.000    3.000
 PSU      "H4'"  "C4'"  "O4'"   109.470    3.000
 PSU      "H4'"  "C4'"  "C3'"   108.340    3.000
 PSU      "O4'"  "C4'"  "C3'"   109.470    3.000
 PSU      "C4'"  "O4'"  "C1'"   111.800    3.000
 PSU      "O4'"  "C1'"  "H1'"   109.470    3.000
 PSU      "O4'"  "C1'"  C5      109.470    3.000
 PSU      "O4'"  "C1'"  "C2'"   109.470    3.000
 PSU      "H1'"  "C1'"  C5      109.470    3.000
 PSU      "H1'"  "C1'"  "C2'"   108.340    3.000
 PSU      C5     "C1'"  "C2'"   109.470    3.000
 PSU      "C1'"  C5     C4      120.000    3.000
 PSU      "C1'"  C5     C6      120.000    3.000
 PSU      C4     C5     C6      120.000    3.000
 PSU      C5     C4     O4      120.000    3.000
 PSU      C5     C4     N3      120.000    3.000
 PSU      O4     C4     N3      120.000    3.000
 PSU      C4     N3     HN3     120.000    3.000
 PSU      C4     N3     C2      120.000    3.000
 PSU      HN3    N3     C2      120.000    3.000
 PSU      C5     C6     H6      120.000    3.000
 PSU      C5     C6     N1      120.000    3.000
 PSU      H6     C6     N1      120.000    3.000
 PSU      C6     N1     HN1     120.000    3.000
 PSU      C6     N1     C2      120.000    3.000
 PSU      HN1    N1     C2      120.000    3.000
 PSU      N1     C2     O2      120.000    3.000
 PSU      N1     C2     N3      120.000    3.000
 PSU      O2     C2     N3      120.000    3.000
 PSU      "C4'"  "C3'"  "H3'"   108.340    3.000
 PSU      "C4'"  "C3'"  "C2'"   111.000    3.000
 PSU      "C4'"  "C3'"  "O3'"   109.470    3.000
 PSU      "H3'"  "C3'"  "C2'"   108.340    3.000
 PSU      "H3'"  "C3'"  "O3'"   109.470    3.000
 PSU      "C2'"  "C3'"  "O3'"   109.470    3.000
 PSU      "C3'"  "C2'"  "H2'"   108.340    3.000
 PSU      "C3'"  "C2'"  "O2'"   109.470    3.000
 PSU      "C3'"  "C2'"  "C1'"   111.000    3.000
 PSU      "H2'"  "C2'"  "O2'"   109.470    3.000
 PSU      "H2'"  "C2'"  "C1'"   108.340    3.000
 PSU      "O2'"  "C2'"  "C1'"   109.470    3.000
 PSU      "C2'"  "O2'"  "HO2'"  109.470    3.000
 PSU      "C3'"  "O3'"  "HO3'"  109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PSU      var_1    OP3    P      "O5'"  "C5'"    -60.027   20.000   1
 PSU      var_2    P      "O5'"  "C5'"  "C4'"   -179.975   20.000   1
 PSU      var_3    "O5'"  "C5'"  "C4'"  "C3'"    176.904   20.000   3
 PSU      var_4    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 PSU      var_5    "C4'"  "O4'"  "C1'"  C5      -150.000   20.000   1
 PSU      var_6    "O4'"  "C1'"  "C2'"  "C3'"     30.000   20.000   3
 PSU      var_7    "O4'"  "C1'"  C5     C6      -124.656   20.000   1
 PSU      CONST_1  "C1'"  C5     C4     N3       180.000    0.000   0
 PSU      CONST_2  C5     C4     N3     C2         0.000    0.000   0
 PSU      CONST_3  "C1'"  C5     C6     N1       180.000    0.000   0
 PSU      CONST_4  C5     C6     N1     C2         0.000    0.000   0
 PSU      CONST_5  C6     N1     C2     O2       180.000    0.000   0
 PSU      CONST_6  N1     C2     N3     C4         0.000    0.000   0
 PSU      var_8    "C5'"  "C4'"  "C3'"  "O3'"     90.000   20.000   3
 PSU      var_9    "C4'"  "C3'"  "C2'"  "O2'"   -120.000   20.000   3
 PSU      var_10   "C3'"  "C2'"  "O2'"  "HO2'"   -61.439   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 PSU      chir_01  "C1'"  C5     "C2'"  "O4'"     negativ
 PSU      chir_02  "C2'"  "C1'"  "O2'"  "C3'"     positiv
 PSU      chir_03  "C3'"  "C2'"  "C4'"  "O3'"     negativ
 PSU      chir_04  "C4'"  "C3'"  "O4'"  "C5'"     positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 PSU      plan-1    C2        0.020
 PSU      plan-1    N3        0.020
 PSU      plan-1    O2        0.020
 PSU      plan-1    N1        0.020
 PSU      plan-1    C4        0.020
 PSU      plan-1    C5        0.020
 PSU      plan-1    C6        0.020
 PSU      plan-1    HN3       0.020
 PSU      plan-1    O4        0.020
 PSU      plan-1    "C1'"     0.020
 PSU      plan-1    H6        0.020
 PSU      plan-1    HN1       0.020
# ------------------------------------------------------
`.trim();

monomers["Cd"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CD       CD  'CADMIUM ION                         ' non-polymer         1   1 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CD
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CD            CD     CD   CD        2.000      0.000    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CD       CD     n/a    .      END
# ------------------------------------------------------
`.trim();

monomers["Gd"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GD       GD  'GADOLINIUM ATOM                     ' non-polymer         1   1 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GD
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GD            GD     GD   GD        0.000      0.000    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GD       GD     n/a    .      END
# ------------------------------------------------------
`.trim();

monomers["ADE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ADE      ADE 'ADENINE                             ' non-polymer        15  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ADE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ADE           N6     N    NH2       0.000      0.000    0.000    0.000
 ADE           HN61   H    H         0.000      0.616    0.004    0.807
 ADE           HN62   H    H         0.000      0.408   -0.004   -0.930
 ADE           C6     C    CR6       0.000     -1.374    0.000    0.165
 ADE           N1     N    NRD6      0.000     -1.912    0.000    1.379
 ADE           C2     C    CR16      0.000     -3.222    0.000    1.547
 ADE           H2     H    H         0.000     -3.618    0.000    2.554
 ADE           N3     N    NRD6      0.000     -4.064    0.000    0.535
 ADE           C4     C    CR56      0.000     -3.617    0.000   -0.717
 ADE           N9     N    NR15      0.000     -4.207    0.000   -1.955
 ADE           HN9    H    H         0.000     -5.228    0.000   -2.149
 ADE           C5     C    CR56      0.000     -2.231    0.005   -0.947
 ADE           N7     N    NRD5      0.000     -2.051    0.000   -2.289
 ADE           C8     C    CR15      0.000     -3.209    0.000   -2.883
 ADE           H8     H    H         0.000     -3.358    0.000   -3.955
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ADE      N6     n/a    C6     START
 ADE      HN61   N6     .      .
 ADE      HN62   N6     .      .
 ADE      C6     N6     N1     .
 ADE      N1     C6     C2     .
 ADE      C2     N1     N3     .
 ADE      H2     C2     .      .
 ADE      N3     C2     C4     .
 ADE      C4     N3     C5     .
 ADE      N9     C4     HN9    .
 ADE      HN9    N9     .      .
 ADE      C5     C4     N7     .
 ADE      N7     C5     C8     .
 ADE      C8     N7     H8     .
 ADE      H8     C8     .      END
 ADE      N9     C8     .    ADD
 ADE      C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ADE      N9     C8        single      1.350    0.020
 ADE      N9     C4        single      1.340    0.020
 ADE      HN9    N9        single      1.040    0.020
 ADE      C8     N7        double      1.350    0.020
 ADE      H8     C8        single      1.083    0.020
 ADE      N7     C5        single      1.350    0.020
 ADE      C5     C6        single      1.490    0.020
 ADE      C5     C4        double      1.490    0.020
 ADE      C6     N6        single      1.355    0.020
 ADE      N1     C6        double      1.350    0.020
 ADE      HN61   N6        single      1.010    0.020
 ADE      HN62   N6        single      1.010    0.020
 ADE      C2     N1        single      1.337    0.020
 ADE      N3     C2        double      1.337    0.020
 ADE      H2     C2        single      1.083    0.020
 ADE      C4     N3        single      1.355    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ADE      HN61   N6     HN62    120.000    3.000
 ADE      HN61   N6     C6      120.000    3.000
 ADE      HN62   N6     C6      120.000    3.000
 ADE      N6     C6     N1      120.000    3.000
 ADE      N6     C6     C5      120.000    3.000
 ADE      N1     C6     C5      120.000    3.000
 ADE      C6     N1     C2      120.000    3.000
 ADE      N1     C2     H2      120.000    3.000
 ADE      N1     C2     N3      120.000    3.000
 ADE      H2     C2     N3      120.000    3.000
 ADE      C2     N3     C4      120.000    3.000
 ADE      N3     C4     N9      132.000    3.000
 ADE      N3     C4     C5      120.000    3.000
 ADE      N9     C4     C5      108.000    3.000
 ADE      C4     N9     HN9     126.000    3.000
 ADE      C4     N9     C8      108.000    3.000
 ADE      HN9    N9     C8      126.000    3.000
 ADE      C4     C5     N7      108.000    3.000
 ADE      C4     C5     C6      120.000    3.000
 ADE      N7     C5     C6      132.000    3.000
 ADE      C5     N7     C8      108.000    3.000
 ADE      N7     C8     H8      126.000    3.000
 ADE      N7     C8     N9      108.000    3.000
 ADE      H8     C8     N9      126.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ADE      CONST_1  HN62   N6     C6     N1       179.727    0.000   0
 ADE      CONST_2  N6     C6     N1     C2       180.000    0.000   0
 ADE      CONST_3  C6     N1     C2     N3         0.000    0.000   0
 ADE      CONST_4  N1     C2     N3     C4         0.000    0.000   0
 ADE      CONST_5  C2     N3     C4     C5         0.000    0.000   0
 ADE      CONST_6  N3     C4     N9     C8       180.000    0.000   0
 ADE      CONST_7  C4     N9     C8     N7         0.000    0.000   0
 ADE      CONST_8  N3     C4     C5     N7       180.000    0.000   0
 ADE      CONST_9  C4     C5     C6     N6       180.000    0.000   0
 ADE      CONST_10 C4     C5     N7     C8         0.000    0.000   0
 ADE      CONST_11 C5     N7     C8     N9         0.000    0.000   0
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ADE      plan-1    N9        0.020
 ADE      plan-1    C8        0.020
 ADE      plan-1    C4        0.020
 ADE      plan-1    HN9       0.020
 ADE      plan-1    N7        0.020
 ADE      plan-1    H8        0.020
 ADE      plan-1    C5        0.020
 ADE      plan-1    C6        0.020
 ADE      plan-1    N1        0.020
 ADE      plan-1    C2        0.020
 ADE      plan-1    N3        0.020
 ADE      plan-1    N6        0.020
 ADE      plan-1    H2        0.020
 ADE      plan-1    HN61      0.020
 ADE      plan-1    HN62      0.020
 ADE      plan-2    N6        0.020
 ADE      plan-2    C6        0.020
 ADE      plan-2    HN61      0.020
 ADE      plan-2    HN62      0.020
# ------------------------------------------------------
`.trim();

monomers["CYT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CYT      CYT '6-AMINOPYRIMIDIN-2(1H)-ONE          ' non-polymer        13   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CYT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CYT           O2     O    O         0.000      0.000    0.000    0.000
 CYT           C2     C    CR6       0.000     -1.007    0.385    0.597
 CYT           N3     N    NR16      0.000     -0.933    1.465    1.475
 CYT           HN3    H    H         0.000     -0.013    1.931    1.610
 CYT           N1     N    NRD6      0.000     -2.237   -0.226    0.426
 CYT           C6     C    CR16      0.000     -3.248    0.237    1.088
 CYT           H6     H    H         0.000     -4.201   -0.255    0.942
 CYT           C5     C    CR16      0.000     -3.215    1.373    2.024
 CYT           H5     H    H         0.000     -4.094    1.720    2.553
 CYT           C4     C    CR6       0.000     -2.015    1.943    2.170
 CYT           N4     N    NH2       0.000     -1.849    3.012    3.012
 CYT           HN42   H    H         0.000     -1.238    3.777    2.752
 CYT           HN41   H    H         0.000     -2.338    3.045    3.899
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CYT      O2     n/a    C2     START
 CYT      C2     O2     N1     .
 CYT      N3     C2     HN3    .
 CYT      HN3    N3     .      .
 CYT      N1     C2     C6     .
 CYT      C6     N1     C5     .
 CYT      H6     C6     .      .
 CYT      C5     C6     C4     .
 CYT      H5     C5     .      .
 CYT      C4     C5     N4     .
 CYT      N4     C4     HN41   .
 CYT      HN42   N4     .      .
 CYT      HN41   N4     .      END
 CYT      N3     C4     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CYT      N3     C4        single      1.337    0.020
 CYT      N3     C2        single      1.337    0.020
 CYT      HN3    N3        single      1.040    0.020
 CYT      N4     C4        single      1.355    0.020
 CYT      C4     C5        double      1.390    0.020
 CYT      N1     C2        single      1.350    0.020
 CYT      C6     N1        double      1.337    0.020
 CYT      C2     O2        double      1.250    0.020
 CYT      HN41   N4        single      1.010    0.020
 CYT      HN42   N4        single      1.010    0.020
 CYT      C5     C6        single      1.390    0.020
 CYT      H5     C5        single      1.083    0.020
 CYT      H6     C6        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CYT      O2     C2     N3      120.000    3.000
 CYT      O2     C2     N1      120.000    3.000
 CYT      N3     C2     N1      120.000    3.000
 CYT      C2     N3     HN3     120.000    3.000
 CYT      C2     N3     C4      120.000    3.000
 CYT      HN3    N3     C4      120.000    3.000
 CYT      C2     N1     C6      120.000    3.000
 CYT      N1     C6     H6      120.000    3.000
 CYT      N1     C6     C5      120.000    3.000
 CYT      H6     C6     C5      120.000    3.000
 CYT      C6     C5     H5      120.000    3.000
 CYT      C6     C5     C4      120.000    3.000
 CYT      H5     C5     C4      120.000    3.000
 CYT      C5     C4     N4      120.000    3.000
 CYT      C5     C4     N3      120.000    3.000
 CYT      N4     C4     N3      120.000    3.000
 CYT      C4     N4     HN42    120.000    3.000
 CYT      C4     N4     HN41    120.000    3.000
 CYT      HN42   N4     HN41    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CYT      CONST_1  O2     C2     N3     C4       180.000    0.000   0
 CYT      CONST_2  C2     N3     C4     C5         0.000    0.000   0
 CYT      CONST_3  O2     C2     N1     C6       180.000    0.000   0
 CYT      CONST_4  C2     N1     C6     C5         0.000    0.000   0
 CYT      CONST_5  N1     C6     C5     C4         0.000    0.000   0
 CYT      CONST_6  C6     C5     C4     N4       180.000    0.000   0
 CYT      CONST_7  C5     C4     N4     HN41      38.774    0.000   0
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 CYT      plan-1    N3        0.020
 CYT      plan-1    C4        0.020
 CYT      plan-1    C2        0.020
 CYT      plan-1    HN3       0.020
 CYT      plan-1    N1        0.020
 CYT      plan-1    C5        0.020
 CYT      plan-1    C6        0.020
 CYT      plan-1    N4        0.020
 CYT      plan-1    O2        0.020
 CYT      plan-1    H5        0.020
 CYT      plan-1    H6        0.020
 CYT      plan-1    HN42      0.020
 CYT      plan-1    HN41      0.020
 CYT      plan-2    N4        0.020
 CYT      plan-2    C4        0.020
 CYT      plan-2    HN41      0.020
 CYT      plan-2    HN42      0.020
# ------------------------------------------------------
`.trim();

monomers["GUA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GUA      GUA 'GLUTARIC ACID                       ' non-polymer        15   9 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GUA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GUA           O4     O    OC       -0.500      0.000    0.000    0.000
 GUA           C5     C    C         0.000     -1.052    0.000    0.677
 GUA           O3     O    OC       -0.500     -0.990    0.000    1.927
 GUA           C4     C    CH2       0.000     -2.392    0.000   -0.010
 GUA           H41    H    H         0.000     -2.479   -0.891   -0.635
 GUA           H42    H    H         0.000     -2.479    0.891   -0.635
 GUA           C3     C    CH2       0.000     -3.504    0.000    1.040
 GUA           H31    H    H         0.000     -3.414    0.891    1.664
 GUA           H32    H    H         0.000     -3.414   -0.891    1.664
 GUA           C2     C    CH2       0.000     -4.865    0.000    0.342
 GUA           H21    H    H         0.000     -4.953   -0.891   -0.283
 GUA           H22    H    H         0.000     -4.953    0.891   -0.283
 GUA           C1     C    C         0.000     -5.960    0.000    1.376
 GUA           O1     O    OC       -0.500     -5.671    0.000    2.593
 GUA           O2     O    OC       -0.500     -7.159    0.000    1.018
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GUA      O4     n/a    C5     START
 GUA      C5     O4     C4     .
 GUA      O3     C5     .      .
 GUA      C4     C5     C3     .
 GUA      H41    C4     .      .
 GUA      H42    C4     .      .
 GUA      C3     C4     C2     .
 GUA      H31    C3     .      .
 GUA      H32    C3     .      .
 GUA      C2     C3     C1     .
 GUA      H21    C2     .      .
 GUA      H22    C2     .      .
 GUA      C1     C2     O2     .
 GUA      O1     C1     .      .
 GUA      O2     C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GUA      C1     C2        single      1.510    0.020
 GUA      O1     C1        deloc       1.250    0.020
 GUA      O2     C1        deloc       1.250    0.020
 GUA      C2     C3        single      1.524    0.020
 GUA      H21    C2        single      1.092    0.020
 GUA      H22    C2        single      1.092    0.020
 GUA      C3     C4        single      1.524    0.020
 GUA      H31    C3        single      1.092    0.020
 GUA      H32    C3        single      1.092    0.020
 GUA      C4     C5        single      1.510    0.020
 GUA      H41    C4        single      1.092    0.020
 GUA      H42    C4        single      1.092    0.020
 GUA      O3     C5        deloc       1.250    0.020
 GUA      C5     O4        deloc       1.250    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GUA      O4     C5     O3      123.000    3.000
 GUA      O4     C5     C4      118.500    3.000
 GUA      O3     C5     C4      118.500    3.000
 GUA      C5     C4     H41     109.470    3.000
 GUA      C5     C4     H42     109.470    3.000
 GUA      C5     C4     C3      109.470    3.000
 GUA      H41    C4     H42     107.900    3.000
 GUA      H41    C4     C3      109.470    3.000
 GUA      H42    C4     C3      109.470    3.000
 GUA      C4     C3     H31     109.470    3.000
 GUA      C4     C3     H32     109.470    3.000
 GUA      C4     C3     C2      111.000    3.000
 GUA      H31    C3     H32     107.900    3.000
 GUA      H31    C3     C2      109.470    3.000
 GUA      H32    C3     C2      109.470    3.000
 GUA      C3     C2     H21     109.470    3.000
 GUA      C3     C2     H22     109.470    3.000
 GUA      C3     C2     C1      109.470    3.000
 GUA      H21    C2     H22     107.900    3.000
 GUA      H21    C2     C1      109.470    3.000
 GUA      H22    C2     C1      109.470    3.000
 GUA      C2     C1     O1      118.500    3.000
 GUA      C2     C1     O2      118.500    3.000
 GUA      O1     C1     O2      123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GUA      var_1    O4     C5     C4     C3       180.000   20.000   3
 GUA      var_2    C5     C4     C3     C2       180.000   20.000   3
 GUA      var_3    C4     C3     C2     C1       180.000   20.000   3
 GUA      var_4    C3     C2     C1     O2       180.000   20.000   3
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 GUA      plan-1    C1        0.020
 GUA      plan-1    C2        0.020
 GUA      plan-1    O1        0.020
 GUA      plan-1    O2        0.020
 GUA      plan-2    C5        0.020
 GUA      plan-2    C4        0.020
 GUA      plan-2    O3        0.020
 GUA      plan-2    O4        0.020
# ------------------------------------------------------
`.trim();

monomers["INO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
INO      INO '2-HYDROXYISONICOTINIC ACID N-OXIDE  ' non-polymer        15  11 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_INO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 INO           O4     O    O        -1.000      0.000    0.000    0.000
 INO           N1     N    NR6       1.000     -1.397    0.233   -0.004
 INO           C6     C    CR16      0.000     -1.838    1.478    0.006
 INO           H6     H    H         0.000     -1.128    2.296    0.017
 INO           C5     C    CR16      0.000     -3.190    1.752    0.002
 INO           H5     H    H         0.000     -3.542    2.776    0.010
 INO           C4     C    CR6       0.000     -4.100    0.688   -0.011
 INO           C7     C    C         0.000     -5.559    0.937   -0.015
 INO           O2     O    OC       -0.500     -5.993    2.110   -0.005
 INO           O1     O    OC       -0.500     -6.357   -0.026   -0.026
 INO           C3     C    CR16      0.000     -3.595   -0.615   -0.015
 INO           H3     H    H         0.000     -4.265   -1.466   -0.017
 INO           C2     C    CR6       0.000     -2.221   -0.802   -0.016
 INO           O3     O    OH1       0.000     -1.715   -2.062   -0.026
 INO           HO3    H    H         0.000     -1.598   -2.369    0.884
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 INO      O4     n/a    N1     START
 INO      N1     O4     C6     .
 INO      C6     N1     C5     .
 INO      H6     C6     .      .
 INO      C5     C6     C4     .
 INO      H5     C5     .      .
 INO      C4     C5     C3     .
 INO      C7     C4     O1     .
 INO      O2     C7     .      .
 INO      O1     C7     .      .
 INO      C3     C4     C2     .
 INO      H3     C3     .      .
 INO      C2     C3     O3     .
 INO      O3     C2     HO3    .
 INO      HO3    O3     .      END
 INO      N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 INO      N1     C2        single      1.410    0.020
 INO      C6     N1        double      1.337    0.020
 INO      N1     O4        single      1.240    0.020
 INO      C2     C3        double      1.390    0.020
 INO      O3     C2        single      1.362    0.020
 INO      C3     C4        single      1.390    0.020
 INO      H3     C3        single      1.083    0.020
 INO      C4     C5        double      1.390    0.020
 INO      C7     C4        single      1.500    0.020
 INO      C5     C6        single      1.390    0.020
 INO      H5     C5        single      1.083    0.020
 INO      H6     C6        single      1.083    0.020
 INO      O1     C7        deloc       1.250    0.020
 INO      O2     C7        deloc       1.250    0.020
 INO      HO3    O3        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 INO      O4     N1     C6      120.000    3.000
 INO      O4     N1     C2      120.000    3.000
 INO      C6     N1     C2      120.000    3.000
 INO      N1     C6     H6      120.000    3.000
 INO      N1     C6     C5      120.000    3.000
 INO      H6     C6     C5      120.000    3.000
 INO      C6     C5     H5      120.000    3.000
 INO      C6     C5     C4      120.000    3.000
 INO      H5     C5     C4      120.000    3.000
 INO      C5     C4     C7      120.000    3.000
 INO      C5     C4     C3      120.000    3.000
 INO      C7     C4     C3      120.000    3.000
 INO      C4     C7     O2      120.000    3.000
 INO      C4     C7     O1      120.000    3.000
 INO      O2     C7     O1      123.000    3.000
 INO      C4     C3     H3      120.000    3.000
 INO      C4     C3     C2      120.000    3.000
 INO      H3     C3     C2      120.000    3.000
 INO      C3     C2     O3      120.000    3.000
 INO      C3     C2     N1      120.000    3.000
 INO      O3     C2     N1      120.000    3.000
 INO      C2     O3     HO3     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 INO      CONST_1  O4     N1     C2     C3       180.000    0.000   0
 INO      CONST_2  O4     N1     C6     C5       180.000    0.000   0
 INO      CONST_3  N1     C6     C5     C4         0.000    0.000   0
 INO      CONST_4  C6     C5     C4     C3         0.000    0.000   0
 INO      var_1    C5     C4     C7     O1      -179.966   20.000   1
 INO      CONST_5  C5     C4     C3     C2         0.000    0.000   0
 INO      CONST_6  C4     C3     C2     O3       180.000    0.000   0
 INO      var_2    C3     C2     O3     HO3      -89.781   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 INO      plan-1    N1        0.020
 INO      plan-1    C2        0.020
 INO      plan-1    C6        0.020
 INO      plan-1    O4        0.020
 INO      plan-1    C3        0.020
 INO      plan-1    C4        0.020
 INO      plan-1    C5        0.020
 INO      plan-1    O3        0.020
 INO      plan-1    H3        0.020
 INO      plan-1    C7        0.020
 INO      plan-1    H5        0.020
 INO      plan-1    H6        0.020
 INO      plan-2    C7        0.020
 INO      plan-2    C4        0.020
 INO      plan-2    O1        0.020
 INO      plan-2    O2        0.020
# ------------------------------------------------------
`.trim();

monomers["THY"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
THY      THY 'C2-1-HYDROXY-2-METHYL-BUTYL-THIAMIN ' non-polymer        57  32 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_THY
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 THY           O2A    O    OP       -0.500      0.000    0.000    0.000
 THY           PA     P    P         0.000      0.000    0.000    0.000
 THY           O1A    O    OP       -0.500      0.000    0.000    0.000
 THY           O3A    O    O2        0.000      0.000    0.000    0.000
 THY           PB     P    P         0.000      0.000    0.000    0.000
 THY           O1B    O    OP       -0.666      0.000    0.000    0.000
 THY           O3B    O    OP       -0.666      0.000    0.000    0.000
 THY           O2B    O    OP       -0.666      0.000    0.000    0.000
 THY           O5G    O    O2        0.000      0.000    0.000    0.000
 THY           C5B    C    CH2       0.000      0.000    0.000    0.000
 THY           H5B1   H    H         0.000      0.000    0.000    0.000
 THY           H5B2   H    H         0.000      0.000    0.000    0.000
 THY           C5A    C    CH2       0.000      0.000    0.000    0.000
 THY           H5A1   H    H         0.000      0.000    0.000    0.000
 THY           H5A2   H    H         0.000      0.000    0.000    0.000
 THY           C5     C    CR5       0.000      0.000    0.000    0.000
 THY           S1     S    S2        0.000      0.000    0.000    0.000
 THY           C2     C    CR5       0.000      0.000    0.000    0.000
 THY           C8     C    C        -1.000      0.000    0.000    0.000
 THY           C9     C    CH1       0.000      0.000    0.000    0.000
 THY           HA     H    H         0.000      0.000    0.000    0.000
 THY           C10    C    CH2       0.000      0.000    0.000    0.000
 THY           H101   H    H         0.000      0.000    0.000    0.000
 THY           H102   H    H         0.000      0.000    0.000    0.000
 THY           C12    C    CH3       0.000      0.000    0.000    0.000
 THY           H123   H    H         0.000      0.000    0.000    0.000
 THY           H122   H    H         0.000      0.000    0.000    0.000
 THY           H121   H    H         0.000      0.000    0.000    0.000
 THY           C11    C    CH3       0.000      0.000    0.000    0.000
 THY           H113   H    H         0.000      0.000    0.000    0.000
 THY           H112   H    H         0.000      0.000    0.000    0.000
 THY           H111   H    H         0.000      0.000    0.000    0.000
 THY           O9     O    OH1       0.000      0.000    0.000    0.000
 THY           H9     H    H         0.000      0.000    0.000    0.000
 THY           N3     N    NR5       1.000      0.000    0.000    0.000
 THY           C4     C    CR5       0.000      0.000    0.000    0.000
 THY           C4A    C    CH3       0.000      0.000    0.000    0.000
 THY           H4A3   H    H         0.000      0.000    0.000    0.000
 THY           H4A2   H    H         0.000      0.000    0.000    0.000
 THY           H4A1   H    H         0.000      0.000    0.000    0.000
 THY           C35    C    CH2       0.000      0.000    0.000    0.000
 THY           H351   H    H         0.000      0.000    0.000    0.000
 THY           H352   H    H         0.000      0.000    0.000    0.000
 THY           "C5'"  C    CR6       0.000      0.000    0.000    0.000
 THY           "C4'"  C    CR6       0.000      0.000    0.000    0.000
 THY           "N4'"  N    NH2       0.000      0.000    0.000    0.000
 THY           "H4'2" H    H         0.000      0.000    0.000    0.000
 THY           "H4'1" H    H         0.000      0.000    0.000    0.000
 THY           "N3'"  N    NRD6      0.000      0.000    0.000    0.000
 THY           "C2'"  C    CR6       0.000      0.000    0.000    0.000
 THY           C2A    C    CH3       0.000      0.000    0.000    0.000
 THY           H2A3   H    H         0.000      0.000    0.000    0.000
 THY           H2A2   H    H         0.000      0.000    0.000    0.000
 THY           H2A1   H    H         0.000      0.000    0.000    0.000
 THY           "N1'"  N    NRD6      0.000      0.000    0.000    0.000
 THY           "C6'"  C    CR16      0.000      0.000    0.000    0.000
 THY           "H6'"  H    H         0.000      0.000    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 THY      O2A    n/a    PA     START
 THY      PA     O2A    O5G    .
 THY      O1A    PA     .      .
 THY      O3A    PA     PB     .
 THY      PB     O3A    O2B    .
 THY      O1B    PB     .      .
 THY      O3B    PB     .      .
 THY      O2B    PB     .      .
 THY      O5G    PA     C5B    .
 THY      C5B    O5G    C5A    .
 THY      H5B1   C5B    .      .
 THY      H5B2   C5B    .      .
 THY      C5A    C5B    C5     .
 THY      H5A1   C5A    .      .
 THY      H5A2   C5A    .      .
 THY      C5     C5A    S1     .
 THY      S1     C5     C2     .
 THY      C2     S1     N3     .
 THY      C8     C2     O9     .
 THY      C9     C8     C11    .
 THY      HA     C9     .      .
 THY      C10    C9     C12    .
 THY      H101   C10    .      .
 THY      H102   C10    .      .
 THY      C12    C10    H121   .
 THY      H123   C12    .      .
 THY      H122   C12    .      .
 THY      H121   C12    .      .
 THY      C11    C9     H111   .
 THY      H113   C11    .      .
 THY      H112   C11    .      .
 THY      H111   C11    .      .
 THY      O9     C8     H9     .
 THY      H9     O9     .      .
 THY      N3     C2     C35    .
 THY      C4     N3     C4A    .
 THY      C4A    C4     H4A1   .
 THY      H4A3   C4A    .      .
 THY      H4A2   C4A    .      .
 THY      H4A1   C4A    .      .
 THY      C35    N3     "C5'"  .
 THY      H351   C35    .      .
 THY      H352   C35    .      .
 THY      "C5'"  C35    "C4'"  .
 THY      "C4'"  "C5'"  "N3'"  .
 THY      "N4'"  "C4'"  "H4'1" .
 THY      "H4'2" "N4'"  .      .
 THY      "H4'1" "N4'"  .      .
 THY      "N3'"  "C4'"  "C2'"  .
 THY      "C2'"  "N3'"  "N1'"  .
 THY      C2A    "C2'"  H2A1   .
 THY      H2A3   C2A    .      .
 THY      H2A2   C2A    .      .
 THY      H2A1   C2A    .      .
 THY      "N1'"  "C2'"  "C6'"  .
 THY      "C6'"  "N1'"  "H6'"  .
 THY      "H6'"  "C6'"  .      END
 THY      C5     C4     .    ADD
 THY      "C5'"  "C6'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 THY      O2B    PB        deloc       1.510    0.020
 THY      O3B    PB        deloc       1.510    0.020
 THY      O1B    PB        deloc       1.510    0.020
 THY      PB     O3A       single      1.610    0.020
 THY      O3A    PA        single      1.610    0.020
 THY      O1A    PA        deloc       1.510    0.020
 THY      PA     O2A       deloc       1.510    0.020
 THY      O5G    PA        single      1.610    0.020
 THY      C5B    O5G       single      1.426    0.020
 THY      C5A    C5B       single      1.524    0.020
 THY      H5B1   C5B       single      1.092    0.020
 THY      H5B2   C5B       single      1.092    0.020
 THY      C5     C5A       single      1.510    0.020
 THY      H5A1   C5A       single      1.092    0.020
 THY      H5A2   C5A       single      1.092    0.020
 THY      C5     C4        double      1.490    0.020
 THY      S1     C5        single      1.745    0.020
 THY      C4A    C4        single      1.506    0.020
 THY      C4     N3        single      1.337    0.020
 THY      H4A1   C4A       single      1.059    0.020
 THY      H4A2   C4A       single      1.059    0.020
 THY      H4A3   C4A       single      1.059    0.020
 THY      C2     S1        single      1.745    0.020
 THY      C8     C2        single      1.490    0.020
 THY      N3     C2        double      1.337    0.020
 THY      O9     C8        single      1.330    0.020
 THY      C9     C8        single      1.500    0.020
 THY      H9     O9        single      0.967    0.020
 THY      C11    C9        single      1.524    0.020
 THY      C10    C9        single      1.524    0.020
 THY      HA     C9        single      1.099    0.020
 THY      H111   C11       single      1.059    0.020
 THY      H112   C11       single      1.059    0.020
 THY      H113   C11       single      1.059    0.020
 THY      C12    C10       single      1.513    0.020
 THY      H101   C10       single      1.092    0.020
 THY      H102   C10       single      1.092    0.020
 THY      H121   C12       single      1.059    0.020
 THY      H122   C12       single      1.059    0.020
 THY      H123   C12       single      1.059    0.020
 THY      C35    N3        single      1.462    0.020
 THY      "C5'"  C35       single      1.511    0.020
 THY      H351   C35       single      1.092    0.020
 THY      H352   C35       single      1.092    0.020
 THY      "C5'"  "C6'"     double      1.390    0.020
 THY      "C4'"  "C5'"     single      1.487    0.020
 THY      "C6'"  "N1'"     single      1.337    0.020
 THY      "H6'"  "C6'"     single      1.083    0.020
 THY      "N1'"  "C2'"     double      1.350    0.020
 THY      C2A    "C2'"     single      1.506    0.020
 THY      "C2'"  "N3'"     single      1.350    0.020
 THY      H2A1   C2A       single      1.059    0.020
 THY      H2A2   C2A       single      1.059    0.020
 THY      H2A3   C2A       single      1.059    0.020
 THY      "N3'"  "C4'"     double      1.350    0.020
 THY      "N4'"  "C4'"     single      1.355    0.020
 THY      "H4'1" "N4'"     single      1.010    0.020
 THY      "H4'2" "N4'"     single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 THY      O2A    PA     O1A     119.900    3.000
 THY      O2A    PA     O3A     108.200    3.000
 THY      O2A    PA     O5G     108.200    3.000
 THY      O1A    PA     O3A     108.200    3.000
 THY      O1A    PA     O5G     108.200    3.000
 THY      O3A    PA     O5G     102.600    3.000
 THY      PA     O3A    PB      120.500    3.000
 THY      O3A    PB     O1B     108.200    3.000
 THY      O3A    PB     O3B     108.200    3.000
 THY      O3A    PB     O2B     108.200    3.000
 THY      O1B    PB     O3B     119.900    3.000
 THY      O1B    PB     O2B     119.900    3.000
 THY      O3B    PB     O2B     119.900    3.000
 THY      PA     O5G    C5B     120.500    3.000
 THY      O5G    C5B    H5B1    109.470    3.000
 THY      O5G    C5B    H5B2    109.470    3.000
 THY      O5G    C5B    C5A     109.470    3.000
 THY      H5B1   C5B    H5B2    107.900    3.000
 THY      H5B1   C5B    C5A     109.470    3.000
 THY      H5B2   C5B    C5A     109.470    3.000
 THY      C5B    C5A    H5A1    109.470    3.000
 THY      C5B    C5A    H5A2    109.470    3.000
 THY      C5B    C5A    C5      109.470    3.000
 THY      H5A1   C5A    H5A2    107.900    3.000
 THY      H5A1   C5A    C5      109.470    3.000
 THY      H5A2   C5A    C5      109.470    3.000
 THY      C5A    C5     S1      108.000    3.000
 THY      C5A    C5     C4      126.000    3.000
 THY      S1     C5     C4      108.000    3.000
 THY      C5     S1     C2       90.000    3.000
 THY      S1     C2     C8      108.000    3.000
 THY      S1     C2     N3      108.000    3.000
 THY      C8     C2     N3      126.000    3.000
 THY      C2     C8     C9      120.000    3.000
 THY      C2     C8     O9      120.000    3.000
 THY      C9     C8     O9      120.000    3.000
 THY      C8     C9     HA      108.810    3.000
 THY      C8     C9     C10     109.470    3.000
 THY      C8     C9     C11     109.470    3.000
 THY      HA     C9     C10     108.340    3.000
 THY      HA     C9     C11     108.340    3.000
 THY      C10    C9     C11     111.000    3.000
 THY      C9     C10    H101    109.470    3.000
 THY      C9     C10    H102    109.470    3.000
 THY      C9     C10    C12     111.000    3.000
 THY      H101   C10    H102    107.900    3.000
 THY      H101   C10    C12     109.470    3.000
 THY      H102   C10    C12     109.470    3.000
 THY      C10    C12    H123    109.470    3.000
 THY      C10    C12    H122    109.470    3.000
 THY      C10    C12    H121    109.470    3.000
 THY      H123   C12    H122    109.470    3.000
 THY      H123   C12    H121    109.470    3.000
 THY      H122   C12    H121    109.470    3.000
 THY      C9     C11    H113    109.470    3.000
 THY      C9     C11    H112    109.470    3.000
 THY      C9     C11    H111    109.470    3.000
 THY      H113   C11    H112    109.470    3.000
 THY      H113   C11    H111    109.470    3.000
 THY      H112   C11    H111    109.470    3.000
 THY      C8     O9     H9      109.470    3.000
 THY      C2     N3     C4      108.000    3.000
 THY      C2     N3     C35     126.000    3.000
 THY      C4     N3     C35     126.000    3.000
 THY      N3     C4     C4A     126.000    3.000
 THY      N3     C4     C5      108.000    3.000
 THY      C4A    C4     C5      126.000    3.000
 THY      C4     C4A    H4A3    109.470    3.000
 THY      C4     C4A    H4A2    109.470    3.000
 THY      C4     C4A    H4A1    109.470    3.000
 THY      H4A3   C4A    H4A2    109.470    3.000
 THY      H4A3   C4A    H4A1    109.470    3.000
 THY      H4A2   C4A    H4A1    109.470    3.000
 THY      N3     C35    H351    109.500    3.000
 THY      N3     C35    H352    109.500    3.000
 THY      N3     C35    "C5'"   109.500    3.000
 THY      H351   C35    H352    107.900    3.000
 THY      H351   C35    "C5'"   109.470    3.000
 THY      H352   C35    "C5'"   109.470    3.000
 THY      C35    "C5'"  "C4'"   120.000    3.000
 THY      C35    "C5'"  "C6'"   120.000    3.000
 THY      "C4'"  "C5'"  "C6'"   120.000    3.000
 THY      "C5'"  "C4'"  "N4'"   120.000    3.000
 THY      "C5'"  "C4'"  "N3'"   120.000    3.000
 THY      "N4'"  "C4'"  "N3'"   120.000    3.000
 THY      "C4'"  "N4'"  "H4'2"  120.000    3.000
 THY      "C4'"  "N4'"  "H4'1"  120.000    3.000
 THY      "H4'2" "N4'"  "H4'1"  120.000    3.000
 THY      "C4'"  "N3'"  "C2'"   120.000    3.000
 THY      "N3'"  "C2'"  C2A     120.000    3.000
 THY      "N3'"  "C2'"  "N1'"   120.000    3.000
 THY      C2A    "C2'"  "N1'"   120.000    3.000
 THY      "C2'"  C2A    H2A3    109.470    3.000
 THY      "C2'"  C2A    H2A2    109.470    3.000
 THY      "C2'"  C2A    H2A1    109.470    3.000
 THY      H2A3   C2A    H2A2    109.470    3.000
 THY      H2A3   C2A    H2A1    109.470    3.000
 THY      H2A2   C2A    H2A1    109.470    3.000
 THY      "C2'"  "N1'"  "C6'"   120.000    3.000
 THY      "N1'"  "C6'"  "H6'"   120.000    3.000
 THY      "N1'"  "C6'"  "C5'"   120.000    3.000
 THY      "H6'"  "C6'"  "C5'"   120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 THY      var_1    O2A    PA     O3A    PB         0.000   20.000   1
 THY      var_2    PA     O3A    PB     O2B        0.000   20.000   1
 THY      var_3    O2A    PA     O5G    C5B        0.000   20.000   1
 THY      var_4    PA     O5G    C5B    C5A        0.000   20.000   1
 THY      var_5    O5G    C5B    C5A    C5         0.000   20.000   3
 THY      var_6    C5B    C5A    C5     S1         0.000   20.000   2
 THY      CONST_1  C5A    C5     C4     N3         0.000    0.000   0
 THY      CONST_2  C5A    C5     S1     C2         0.000    0.000   0
 THY      CONST_3  C5     S1     C2     N3         0.000    0.000   0
 THY      var_7    S1     C2     C8     O9         0.000   20.000   1
 THY      var_8    C2     C8     C9     C11        0.000   20.000   3
 THY      var_9    C8     C9     C10    C12        0.000   20.000   3
 THY      var_10   C9     C10    C12    H121       0.000   20.000   3
 THY      var_11   C8     C9     C11    H111       0.000   20.000   3
 THY      var_12   C2     C8     O9     H9         0.000   20.000   1
 THY      CONST_4  S1     C2     N3     C35        0.000    0.000   0
 THY      CONST_5  C2     N3     C4     C4A        0.000    0.000   0
 THY      var_13   N3     C4     C4A    H4A1       0.000   20.000   1
 THY      var_14   C2     N3     C35    "C5'"      0.000   20.000   1
 THY      var_15   N3     C35    "C5'"  "C4'"      0.000   20.000   2
 THY      CONST_6  C35    "C5'"  "C6'"  "N1'"      0.000    0.000   0
 THY      CONST_7  C35    "C5'"  "C4'"  "N3'"      0.000    0.000   0
 THY      CONST_8  "C5'"  "C4'"  "N4'"  "H4'1"     0.000    0.000   0
 THY      CONST_9  "C5'"  "C4'"  "N3'"  "C2'"      0.000    0.000   0
 THY      CONST_10 "C4'"  "N3'"  "C2'"  "N1'"      0.000    0.000   0
 THY      var_16   "N3'"  "C2'"  C2A    H2A1       0.000   20.000   1
 THY      CONST_11 "N3'"  "C2'"  "N1'"  "C6'"      0.000    0.000   0
 THY      CONST_12 "C2'"  "N1'"  "C6'"  "C5'"      0.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 THY      chir_01  C9     C8     C11    C10       positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 THY      plan-1    C5        0.020
 THY      plan-1    C5A       0.020
 THY      plan-1    C4        0.020
 THY      plan-1    S1        0.020
 THY      plan-1    C2        0.020
 THY      plan-1    N3        0.020
 THY      plan-1    C4A       0.020
 THY      plan-1    C8        0.020
 THY      plan-1    C35       0.020
 THY      plan-2    C8        0.020
 THY      plan-2    C2        0.020
 THY      plan-2    O9        0.020
 THY      plan-2    C9        0.020
 THY      plan-3    "C5'"     0.020
 THY      plan-3    C35       0.020
 THY      plan-3    "C6'"     0.020
 THY      plan-3    "C4'"     0.020
 THY      plan-3    "N1'"     0.020
 THY      plan-3    "C2'"     0.020
 THY      plan-3    "N3'"     0.020
 THY      plan-3    "H6'"     0.020
 THY      plan-3    C2A       0.020
 THY      plan-3    "N4'"     0.020
 THY      plan-3    "H4'2"    0.020
 THY      plan-3    "H4'1"    0.020
 THY      plan-4    "N4'"     0.020
 THY      plan-4    "C4'"     0.020
 THY      plan-4    "H4'1"    0.020
 THY      plan-4    "H4'2"    0.020
# ------------------------------------------------------
`.trim();

monomers["URA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
URA      URA 'URACIL                              ' non-polymer        12   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_URA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 URA           O4     O    O         0.000      0.000    0.000    0.000
 URA           C4     C    CR6       0.000     -1.039    0.000   -0.636
 URA           N3     N    NR16      0.000     -2.226    0.003    0.002
 URA           HN3    H    H         0.000     -2.256    0.009    1.042
 URA           C2     C    CR6       0.000     -3.373   -0.001   -0.702
 URA           O2     O    O         0.000     -4.437   -0.002   -0.113
 URA           C5     C    CR16      0.000     -1.010    0.001   -2.050
 URA           H5     H    H         0.000     -0.065    0.002   -2.580
 URA           C6     C    CR16      0.000     -2.175    0.000   -2.732
 URA           H6     H    H         0.000     -2.173    0.000   -3.815
 URA           N1     N    NR16      0.000     -3.360    0.000   -2.046
 URA           HN1    H    H         0.000     -4.258    0.000   -2.570
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 URA      O4     n/a    C4     START
 URA      C4     O4     C5     .
 URA      N3     C4     C2     .
 URA      HN3    N3     .      .
 URA      C2     N3     O2     .
 URA      O2     C2     .      .
 URA      C5     C4     C6     .
 URA      H5     C5     .      .
 URA      C6     C5     N1     .
 URA      H6     C6     .      .
 URA      N1     C6     HN1    .
 URA      HN1    N1     .      END
 URA      N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 URA      N1     C2        single      1.337    0.020
 URA      N1     C6        single      1.337    0.020
 URA      HN1    N1        single      1.040    0.020
 URA      O2     C2        double      1.250    0.020
 URA      C2     N3        single      1.337    0.020
 URA      N3     C4        single      1.337    0.020
 URA      HN3    N3        single      1.040    0.020
 URA      C4     O4        double      1.250    0.020
 URA      C5     C4        single      1.390    0.020
 URA      C6     C5        double      1.390    0.020
 URA      H5     C5        single      1.083    0.020
 URA      H6     C6        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 URA      O4     C4     N3      120.000    3.000
 URA      O4     C4     C5      120.000    3.000
 URA      N3     C4     C5      120.000    3.000
 URA      C4     N3     HN3     120.000    3.000
 URA      C4     N3     C2      120.000    3.000
 URA      HN3    N3     C2      120.000    3.000
 URA      N3     C2     O2      120.000    3.000
 URA      N3     C2     N1      120.000    3.000
 URA      O2     C2     N1      120.000    3.000
 URA      C4     C5     H5      120.000    3.000
 URA      C4     C5     C6      120.000    3.000
 URA      H5     C5     C6      120.000    3.000
 URA      C5     C6     H6      120.000    3.000
 URA      C5     C6     N1      120.000    3.000
 URA      H6     C6     N1      120.000    3.000
 URA      C6     N1     HN1     120.000    3.000
 URA      C6     N1     C2      120.000    3.000
 URA      HN1    N1     C2      120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 URA      CONST_1  O4     C4     N3     C2       180.000    0.000   0
 URA      CONST_2  C4     N3     C2     O2       180.000    0.000   0
 URA      CONST_3  O4     C4     C5     C6       180.000    0.000   0
 URA      CONST_4  C4     C5     C6     N1         0.000    0.000   0
 URA      CONST_5  C5     C6     N1     C2         0.000    0.000   0
 URA      CONST_6  C6     N1     C2     N3         0.000    0.000   0
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 URA      plan-1    N1        0.020
 URA      plan-1    C2        0.020
 URA      plan-1    C6        0.020
 URA      plan-1    HN1       0.020
 URA      plan-1    N3        0.020
 URA      plan-1    C4        0.020
 URA      plan-1    C5        0.020
 URA      plan-1    O2        0.020
 URA      plan-1    HN3       0.020
 URA      plan-1    O4        0.020
 URA      plan-1    H5        0.020
 URA      plan-1    H6        0.020
# ------------------------------------------------------
`.trim();

monomers["AMP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
AMP      AMP 'ADENOSINE MONOPHOSPHATE             ' non-polymer        35  23 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_AMP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 AMP           O3P    O    OP       -0.666      0.000    0.000    0.000
 AMP           P      P    P         0.000     -1.182   -0.449   -0.831
 AMP           O1P    O    OP       -0.666     -0.884   -1.801   -1.442
 AMP           O2P    O    OP       -0.666     -1.435    0.557   -1.932
 AMP           "O5'"  O    O2        0.000     -2.486   -0.560    0.107
 AMP           "C5'"  C    CH2       0.000     -3.533   -1.098   -0.703
 AMP           "H5'1" H    H         0.000     -3.236   -2.081   -1.074
 AMP           "H5'2" H    H         0.000     -3.716   -0.432   -1.549
 AMP           "C4'"  C    CH1       0.000     -4.808   -1.228    0.131
 AMP           "H4'"  H    H         0.000     -4.618   -1.836    1.027
 AMP           "C3'"  C    CH1       0.000     -5.943   -1.853   -0.710
 AMP           "H3'"  H    H         0.000     -5.770   -1.678   -1.781
 AMP           "O3'"  O    OH1       0.000     -6.053   -3.253   -0.442
 AMP           "HO3'" H    H         0.000     -6.766   -3.627   -0.976
 AMP           "C2'"  C    CH1       0.000     -7.214   -1.109   -0.238
 AMP           "H2'"  H    H         0.000     -7.673   -0.563   -1.075
 AMP           "O2'"  O    OH1       0.000     -8.149   -2.027    0.333
 AMP           "HO2'" H    H         0.000     -8.416   -2.672   -0.337
 AMP           "C1'"  C    CH1       0.000     -6.694   -0.121    0.830
 AMP           "H1'"  H    H         0.000     -6.795   -0.556    1.834
 AMP           "O4'"  O    O2        0.000     -5.301    0.077    0.505
 AMP           N9     N    NR5       0.000     -7.422    1.148    0.749
 AMP           C4     C    CR56      0.000     -8.607    1.445    1.371
 AMP           C5     C    CR56      0.000     -8.921    2.763    0.999
 AMP           N7     N    NRD5      0.000     -7.924    3.198    0.192
 AMP           C8     C    CR15      0.000     -7.044    2.251    0.041
 AMP           H8     H    H         0.000     -6.145    2.327   -0.558
 AMP           N3     N    NRD6      0.000     -9.436    0.786    2.174
 AMP           C2     C    CR16      0.000    -10.534    1.359    2.622
 AMP           H2     H    H         0.000    -11.188    0.794    3.274
 AMP           N1     N    NRD6      0.000    -10.867    2.597    2.306
 AMP           C6     C    CR6       0.000    -10.100    3.334    1.508
 AMP           N6     N    NH2       0.000    -10.457    4.631    1.182
 AMP           HN62   H    H         0.000     -9.869    5.190    0.572
 AMP           HN61   H    H         0.000    -11.312    5.038    1.549
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 AMP      O3P    n/a    P      START
 AMP      P      O3P    "O5'"  .
 AMP      O1P    P      .      .
 AMP      O2P    P      .      .
 AMP      "O5'"  P      "C5'"  .
 AMP      "C5'"  "O5'"  "C4'"  .
 AMP      "H5'1" "C5'"  .      .
 AMP      "H5'2" "C5'"  .      .
 AMP      "C4'"  "C5'"  "C3'"  .
 AMP      "H4'"  "C4'"  .      .
 AMP      "C3'"  "C4'"  "C2'"  .
 AMP      "H3'"  "C3'"  .      .
 AMP      "O3'"  "C3'"  "HO3'" .
 AMP      "HO3'" "O3'"  .      .
 AMP      "C2'"  "C3'"  "C1'"  .
 AMP      "H2'"  "C2'"  .      .
 AMP      "O2'"  "C2'"  "HO2'" .
 AMP      "HO2'" "O2'"  .      .
 AMP      "C1'"  "C2'"  N9     .
 AMP      "H1'"  "C1'"  .      .
 AMP      "O4'"  "C1'"  .      .
 AMP      N9     "C1'"  C4     .
 AMP      C4     N9     N3     .
 AMP      C5     C4     N7     .
 AMP      N7     C5     C8     .
 AMP      C8     N7     H8     .
 AMP      H8     C8     .      .
 AMP      N3     C4     C2     .
 AMP      C2     N3     N1     .
 AMP      H2     C2     .      .
 AMP      N1     C2     C6     .
 AMP      C6     N1     N6     .
 AMP      N6     C6     HN61   .
 AMP      HN62   N6     .      .
 AMP      HN61   N6     .      END
 AMP      "C4'"  "O4'"  .    ADD
 AMP      N9     C8     .    ADD
 AMP      C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 AMP      O1P    P         deloc       1.510    0.020
 AMP      O2P    P         deloc       1.510    0.020
 AMP      P      O3P       deloc       1.510    0.020
 AMP      "O5'"  P         single      1.610    0.020
 AMP      "C5'"  "O5'"     single      1.426    0.020
 AMP      "C4'"  "C5'"     single      1.524    0.020
 AMP      "H5'1" "C5'"     single      1.092    0.020
 AMP      "H5'2" "C5'"     single      1.092    0.020
 AMP      "C4'"  "O4'"     single      1.426    0.020
 AMP      "C3'"  "C4'"     single      1.524    0.020
 AMP      "H4'"  "C4'"     single      1.099    0.020
 AMP      "O4'"  "C1'"     single      1.426    0.020
 AMP      "O3'"  "C3'"     single      1.432    0.020
 AMP      "C2'"  "C3'"     single      1.524    0.020
 AMP      "H3'"  "C3'"     single      1.099    0.020
 AMP      "HO3'" "O3'"     single      0.967    0.020
 AMP      "O2'"  "C2'"     single      1.432    0.020
 AMP      "C1'"  "C2'"     single      1.524    0.020
 AMP      "H2'"  "C2'"     single      1.099    0.020
 AMP      "HO2'" "O2'"     single      0.967    0.020
 AMP      N9     "C1'"     single      1.485    0.020
 AMP      "H1'"  "C1'"     single      1.099    0.020
 AMP      N9     C8        single      1.337    0.020
 AMP      C4     N9        single      1.337    0.020
 AMP      C8     N7        double      1.350    0.020
 AMP      H8     C8        single      1.083    0.020
 AMP      N7     C5        single      1.350    0.020
 AMP      C5     C6        single      1.490    0.020
 AMP      C5     C4        double      1.490    0.020
 AMP      N6     C6        single      1.355    0.020
 AMP      C6     N1        double      1.350    0.020
 AMP      HN61   N6        single      1.010    0.020
 AMP      HN62   N6        single      1.010    0.020
 AMP      N1     C2        single      1.337    0.020
 AMP      C2     N3        double      1.337    0.020
 AMP      H2     C2        single      1.083    0.020
 AMP      N3     C4        single      1.355    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 AMP      O3P    P      O1P     119.900    3.000
 AMP      O3P    P      O2P     119.900    3.000
 AMP      O3P    P      "O5'"   108.200    3.000
 AMP      O1P    P      O2P     119.900    3.000
 AMP      O1P    P      "O5'"   108.200    3.000
 AMP      O2P    P      "O5'"   108.200    3.000
 AMP      P      "O5'"  "C5'"   120.500    3.000
 AMP      "O5'"  "C5'"  "H5'1"  109.470    3.000
 AMP      "O5'"  "C5'"  "H5'2"  109.470    3.000
 AMP      "O5'"  "C5'"  "C4'"   109.470    3.000
 AMP      "H5'1" "C5'"  "H5'2"  107.900    3.000
 AMP      "H5'1" "C5'"  "C4'"   109.470    3.000
 AMP      "H5'2" "C5'"  "C4'"   109.470    3.000
 AMP      "C5'"  "C4'"  "H4'"   108.340    3.000
 AMP      "C5'"  "C4'"  "C3'"   111.000    3.000
 AMP      "C5'"  "C4'"  "O4'"   109.470    3.000
 AMP      "H4'"  "C4'"  "C3'"   108.340    3.000
 AMP      "H4'"  "C4'"  "O4'"   109.470    3.000
 AMP      "C3'"  "C4'"  "O4'"   109.470    3.000
 AMP      "C4'"  "C3'"  "H3'"   108.340    3.000
 AMP      "C4'"  "C3'"  "O3'"   109.470    3.000
 AMP      "C4'"  "C3'"  "C2'"   111.000    3.000
 AMP      "H3'"  "C3'"  "O3'"   109.470    3.000
 AMP      "H3'"  "C3'"  "C2'"   108.340    3.000
 AMP      "O3'"  "C3'"  "C2'"   109.470    3.000
 AMP      "C3'"  "O3'"  "HO3'"  109.470    3.000
 AMP      "C3'"  "C2'"  "H2'"   108.340    3.000
 AMP      "C3'"  "C2'"  "O2'"   109.470    3.000
 AMP      "C3'"  "C2'"  "C1'"   111.000    3.000
 AMP      "H2'"  "C2'"  "O2'"   109.470    3.000
 AMP      "H2'"  "C2'"  "C1'"   108.340    3.000
 AMP      "O2'"  "C2'"  "C1'"   109.470    3.000
 AMP      "C2'"  "O2'"  "HO2'"  109.470    3.000
 AMP      "C2'"  "C1'"  "H1'"   108.340    3.000
 AMP      "C2'"  "C1'"  "O4'"   109.470    3.000
 AMP      "C2'"  "C1'"  N9      109.470    3.000
 AMP      "H1'"  "C1'"  "O4'"   109.470    3.000
 AMP      "H1'"  "C1'"  N9      109.470    3.000
 AMP      "O4'"  "C1'"  N9      109.470    3.000
 AMP      "C1'"  "O4'"  "C4'"   111.800    3.000
 AMP      "C1'"  N9     C4      126.000    3.000
 AMP      "C1'"  N9     C8      126.000    3.000
 AMP      C4     N9     C8      108.000    3.000
 AMP      N9     C4     C5      108.000    3.000
 AMP      N9     C4     N3      132.000    3.000
 AMP      C5     C4     N3      120.000    3.000
 AMP      C4     C5     N7      108.000    3.000
 AMP      C4     C5     C6      120.000    3.000
 AMP      N7     C5     C6      132.000    3.000
 AMP      C5     N7     C8      108.000    3.000
 AMP      N7     C8     H8      126.000    3.000
 AMP      N7     C8     N9      108.000    3.000
 AMP      H8     C8     N9      126.000    3.000
 AMP      C4     N3     C2      120.000    3.000
 AMP      N3     C2     H2      120.000    3.000
 AMP      N3     C2     N1      120.000    3.000
 AMP      H2     C2     N1      120.000    3.000
 AMP      C2     N1     C6      120.000    3.000
 AMP      N1     C6     N6      120.000    3.000
 AMP      N1     C6     C5      120.000    3.000
 AMP      N6     C6     C5      120.000    3.000
 AMP      C6     N6     HN62    120.000    3.000
 AMP      C6     N6     HN61    120.000    3.000
 AMP      HN62   N6     HN61    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 AMP      var_1    O3P    P      "O5'"  "C5'"   -175.001   20.000   1
 AMP      var_2    P      "O5'"  "C5'"  "C4'"   -179.958   20.000   1
 AMP      var_3    "O5'"  "C5'"  "C4'"  "C3'"   -178.105   20.000   3
 AMP      var_4    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 AMP      var_5    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 AMP      var_6    "C4'"  "C3'"  "O3'"  "HO3'"  -179.951   20.000   1
 AMP      var_7    "C4'"  "C3'"  "C2'"  "C1'"      0.000   20.000   3
 AMP      var_8    "C3'"  "C2'"  "O2'"  "HO2'"   -61.481   20.000   1
 AMP      var_9    "C3'"  "C2'"  "C1'"  N9       150.000   20.000   3
 AMP      var_10   "C2'"  "C1'"  "O4'"  "C4'"    -30.000   20.000   1
 AMP      var_11   "C2'"  "C1'"  N9     C4        86.574   20.000   1
 AMP      CONST_1  "C1'"  N9     C8     N7       180.000    0.000   0
 AMP      CONST_2  "C1'"  N9     C4     N3         0.000    0.000   0
 AMP      CONST_3  N9     C4     C5     N7         0.000    0.000   0
 AMP      CONST_4  C4     C5     C6     N1         0.000    0.000   0
 AMP      CONST_5  C4     C5     N7     C8         0.000    0.000   0
 AMP      CONST_6  C5     N7     C8     N9         0.000    0.000   0
 AMP      CONST_7  N9     C4     N3     C2       180.000    0.000   0
 AMP      CONST_8  C4     N3     C2     N1         0.000    0.000   0
 AMP      CONST_9  N3     C2     N1     C6         0.000    0.000   0
 AMP      CONST_10 C2     N1     C6     N6       180.000    0.000   0
 AMP      CONST_11 N1     C6     N6     HN61       0.041    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 AMP      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 AMP      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 AMP      chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 AMP      chir_04  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 AMP      plan-1    N9        0.020
 AMP      plan-1    "C1'"     0.020
 AMP      plan-1    C8        0.020
 AMP      plan-1    C4        0.020
 AMP      plan-1    N7        0.020
 AMP      plan-1    H8        0.020
 AMP      plan-1    C5        0.020
 AMP      plan-1    C6        0.020
 AMP      plan-1    N1        0.020
 AMP      plan-1    C2        0.020
 AMP      plan-1    N3        0.020
 AMP      plan-1    N6        0.020
 AMP      plan-1    H2        0.020
 AMP      plan-1    HN62      0.020
 AMP      plan-1    HN61      0.020
 AMP      plan-2    N6        0.020
 AMP      plan-2    C6        0.020
 AMP      plan-2    HN61      0.020
 AMP      plan-2    HN62      0.020
# ------------------------------------------------------
`.trim();

monomers["ADP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ADP      ADP 'ADENOSINE-5'-DIPHOSPHATE            ' non-polymer        39  27 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ADP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ADP           O2A    O    OP       -0.500      0.000    0.000    0.000
 ADP           PA     P    P         0.000     -0.869   -0.071    1.200
 ADP           O1A    O    OP       -0.500     -1.040    1.289    1.766
 ADP           O3A    O    O2        0.000     -0.187   -1.029    2.298
 ADP           PB     P    P         0.000      1.240   -0.377    2.662
 ADP           O3B    O    OP       -0.666      2.093   -0.300    1.415
 ADP           O2B    O    OP       -0.666      1.935   -1.235    3.697
 ADP           O1B    O    OP       -0.666      1.032    1.014    3.218
 ADP           "O5'"  O    O2        0.000     -2.307   -0.664    0.787
 ADP           "C5'"  C    CH2       0.000     -2.858    0.225   -0.186
 ADP           "H5'1" H    H         0.000     -2.194    0.272   -1.052
 ADP           "H5'2" H    H         0.000     -2.959    1.222    0.248
 ADP           "C4'"  C    CH1       0.000     -4.231   -0.284   -0.623
 ADP           "H4'"  H    H         0.000     -4.143   -1.281   -1.076
 ADP           "C3'"  C    CH1       0.000     -4.883    0.702   -1.618
 ADP           "H3'"  H    H         0.000     -4.473    1.713   -1.483
 ADP           "O3'"  O    OH1       0.000     -4.688    0.259   -2.961
 ADP           "HO3'" H    H         0.000     -5.102    0.886   -3.570
 ADP           "C2'"  C    CH1       0.000     -6.385    0.673   -1.247
 ADP           "H2'"  H    H         0.000     -6.721    1.670   -0.928
 ADP           "O2'"  O    OH1       0.000     -7.164    0.213   -2.354
 ADP           "HO2'" H    H         0.000     -7.055    0.820   -3.098
 ADP           "C1'"  C    CH1       0.000     -6.460   -0.324   -0.071
 ADP           "H1'"  H    H         0.000     -6.715   -1.328   -0.437
 ADP           "O4'"  O    O2        0.000     -5.135   -0.322    0.504
 ADP           N9     N    NR5       0.000     -7.445    0.123    0.916
 ADP           C4     C    CR56      0.000     -8.773   -0.216    0.950
 ADP           C5     C    CR56      0.000     -9.316    0.451    2.060
 ADP           N7     N    NRD5      0.000     -8.307    1.144    2.642
 ADP           C8     C    CR15      0.000     -7.209    0.956    1.969
 ADP           H8     H    H         0.000     -6.249    1.396    2.210
 ADP           N3     N    NRD6      0.000     -9.567   -0.977    0.204
 ADP           C2     C    CR16      0.000    -10.842   -1.111    0.500
 ADP           H2     H    H         0.000    -11.460   -1.738   -0.130
 ADP           N1     N    NRD6      0.000    -11.395   -0.509    1.536
 ADP           C6     C    CR6       0.000    -10.681    0.272    2.340
 ADP           N6     N    NH2       0.000    -11.270    0.899    3.424
 ADP           HN62   H    H         0.000    -10.721    1.495    4.036
 ADP           HN61   H    H         0.000    -12.258    0.771    3.621
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ADP      O2A    n/a    PA     START
 ADP      PA     O2A    "O5'"  .
 ADP      O1A    PA     .      .
 ADP      O3A    PA     PB     .
 ADP      PB     O3A    O1B    .
 ADP      O3B    PB     .      .
 ADP      O2B    PB     .      .
 ADP      O1B    PB     .      .
 ADP      "O5'"  PA     "C5'"  .
 ADP      "C5'"  "O5'"  "C4'"  .
 ADP      "H5'1" "C5'"  .      .
 ADP      "H5'2" "C5'"  .      .
 ADP      "C4'"  "C5'"  "C3'"  .
 ADP      "H4'"  "C4'"  .      .
 ADP      "C3'"  "C4'"  "C2'"  .
 ADP      "H3'"  "C3'"  .      .
 ADP      "O3'"  "C3'"  "HO3'" .
 ADP      "HO3'" "O3'"  .      .
 ADP      "C2'"  "C3'"  "C1'"  .
 ADP      "H2'"  "C2'"  .      .
 ADP      "O2'"  "C2'"  "HO2'" .
 ADP      "HO2'" "O2'"  .      .
 ADP      "C1'"  "C2'"  N9     .
 ADP      "H1'"  "C1'"  .      .
 ADP      "O4'"  "C1'"  .      .
 ADP      N9     "C1'"  C4     .
 ADP      C4     N9     N3     .
 ADP      C5     C4     N7     .
 ADP      N7     C5     C8     .
 ADP      C8     N7     H8     .
 ADP      H8     C8     .      .
 ADP      N3     C4     C2     .
 ADP      C2     N3     N1     .
 ADP      H2     C2     .      .
 ADP      N1     C2     C6     .
 ADP      C6     N1     N6     .
 ADP      N6     C6     HN61   .
 ADP      HN62   N6     .      .
 ADP      HN61   N6     .      END
 ADP      "C4'"  "O4'"  .    ADD
 ADP      N9     C8     .    ADD
 ADP      C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ADP      O1B    PB        deloc       1.510    0.020
 ADP      O2B    PB        deloc       1.510    0.020
 ADP      O3B    PB        deloc       1.510    0.020
 ADP      PB     O3A       single      1.610    0.020
 ADP      O1A    PA        deloc       1.510    0.020
 ADP      PA     O2A       deloc       1.510    0.020
 ADP      O3A    PA        single      1.610    0.020
 ADP      "O5'"  PA        single      1.610    0.020
 ADP      "C5'"  "O5'"     single      1.426    0.020
 ADP      "C4'"  "C5'"     single      1.524    0.020
 ADP      "H5'1" "C5'"     single      1.092    0.020
 ADP      "H5'2" "C5'"     single      1.092    0.020
 ADP      "C4'"  "O4'"     single      1.426    0.020
 ADP      "C3'"  "C4'"     single      1.524    0.020
 ADP      "H4'"  "C4'"     single      1.099    0.020
 ADP      "O4'"  "C1'"     single      1.426    0.020
 ADP      "O3'"  "C3'"     single      1.432    0.020
 ADP      "C2'"  "C3'"     single      1.524    0.020
 ADP      "H3'"  "C3'"     single      1.099    0.020
 ADP      "HO3'" "O3'"     single      0.967    0.020
 ADP      "O2'"  "C2'"     single      1.432    0.020
 ADP      "C1'"  "C2'"     single      1.524    0.020
 ADP      "H2'"  "C2'"     single      1.099    0.020
 ADP      "HO2'" "O2'"     single      0.967    0.020
 ADP      N9     "C1'"     single      1.485    0.020
 ADP      "H1'"  "C1'"     single      1.099    0.020
 ADP      N9     C8        single      1.337    0.020
 ADP      C4     N9        single      1.337    0.020
 ADP      C8     N7        double      1.350    0.020
 ADP      H8     C8        single      1.083    0.020
 ADP      N7     C5        single      1.350    0.020
 ADP      C5     C6        single      1.490    0.020
 ADP      C5     C4        double      1.490    0.020
 ADP      N6     C6        single      1.355    0.020
 ADP      C6     N1        double      1.350    0.020
 ADP      HN61   N6        single      1.010    0.020
 ADP      HN62   N6        single      1.010    0.020
 ADP      N1     C2        single      1.337    0.020
 ADP      C2     N3        double      1.337    0.020
 ADP      H2     C2        single      1.083    0.020
 ADP      N3     C4        single      1.355    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ADP      O2A    PA     O1A     119.900    3.000
 ADP      O2A    PA     O3A     108.200    3.000
 ADP      O2A    PA     "O5'"   108.200    3.000
 ADP      O1A    PA     O3A     108.200    3.000
 ADP      O1A    PA     "O5'"   108.200    3.000
 ADP      O3A    PA     "O5'"   102.600    3.000
 ADP      PA     O3A    PB      120.500    3.000
 ADP      O3A    PB     O3B     108.200    3.000
 ADP      O3A    PB     O2B     108.200    3.000
 ADP      O3A    PB     O1B     108.200    3.000
 ADP      O3B    PB     O2B     119.900    3.000
 ADP      O3B    PB     O1B     119.900    3.000
 ADP      O2B    PB     O1B     119.900    3.000
 ADP      PA     "O5'"  "C5'"   120.500    3.000
 ADP      "O5'"  "C5'"  "H5'1"  109.470    3.000
 ADP      "O5'"  "C5'"  "H5'2"  109.470    3.000
 ADP      "O5'"  "C5'"  "C4'"   109.470    3.000
 ADP      "H5'1" "C5'"  "H5'2"  107.900    3.000
 ADP      "H5'1" "C5'"  "C4'"   109.470    3.000
 ADP      "H5'2" "C5'"  "C4'"   109.470    3.000
 ADP      "C5'"  "C4'"  "H4'"   108.340    3.000
 ADP      "C5'"  "C4'"  "C3'"   111.000    3.000
 ADP      "C5'"  "C4'"  "O4'"   109.470    3.000
 ADP      "H4'"  "C4'"  "C3'"   108.340    3.000
 ADP      "H4'"  "C4'"  "O4'"   109.470    3.000
 ADP      "C3'"  "C4'"  "O4'"   109.470    3.000
 ADP      "C4'"  "C3'"  "H3'"   108.340    3.000
 ADP      "C4'"  "C3'"  "O3'"   109.470    3.000
 ADP      "C4'"  "C3'"  "C2'"   111.000    3.000
 ADP      "H3'"  "C3'"  "O3'"   109.470    3.000
 ADP      "H3'"  "C3'"  "C2'"   108.340    3.000
 ADP      "O3'"  "C3'"  "C2'"   109.470    3.000
 ADP      "C3'"  "O3'"  "HO3'"  109.470    3.000
 ADP      "C3'"  "C2'"  "H2'"   108.340    3.000
 ADP      "C3'"  "C2'"  "O2'"   109.470    3.000
 ADP      "C3'"  "C2'"  "C1'"   111.000    3.000
 ADP      "H2'"  "C2'"  "O2'"   109.470    3.000
 ADP      "H2'"  "C2'"  "C1'"   108.340    3.000
 ADP      "O2'"  "C2'"  "C1'"   109.470    3.000
 ADP      "C2'"  "O2'"  "HO2'"  109.470    3.000
 ADP      "C2'"  "C1'"  "H1'"   108.340    3.000
 ADP      "C2'"  "C1'"  "O4'"   109.470    3.000
 ADP      "C2'"  "C1'"  N9      109.470    3.000
 ADP      "H1'"  "C1'"  "O4'"   109.470    3.000
 ADP      "H1'"  "C1'"  N9      109.470    3.000
 ADP      "O4'"  "C1'"  N9      109.470    3.000
 ADP      "C1'"  "O4'"  "C4'"   111.800    3.000
 ADP      "C1'"  N9     C4      126.000    3.000
 ADP      "C1'"  N9     C8      126.000    3.000
 ADP      C4     N9     C8      108.000    3.000
 ADP      N9     C4     C5      108.000    3.000
 ADP      N9     C4     N3      132.000    3.000
 ADP      C5     C4     N3      120.000    3.000
 ADP      C4     C5     N7      108.000    3.000
 ADP      C4     C5     C6      120.000    3.000
 ADP      N7     C5     C6      132.000    3.000
 ADP      C5     N7     C8      108.000    3.000
 ADP      N7     C8     H8      126.000    3.000
 ADP      N7     C8     N9      108.000    3.000
 ADP      H8     C8     N9      126.000    3.000
 ADP      C4     N3     C2      120.000    3.000
 ADP      N3     C2     H2      120.000    3.000
 ADP      N3     C2     N1      120.000    3.000
 ADP      H2     C2     N1      120.000    3.000
 ADP      C2     N1     C6      120.000    3.000
 ADP      N1     C6     N6      120.000    3.000
 ADP      N1     C6     C5      120.000    3.000
 ADP      N6     C6     C5      120.000    3.000
 ADP      C6     N6     HN62    120.000    3.000
 ADP      C6     N6     HN61    120.000    3.000
 ADP      HN62   N6     HN61    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ADP      var_1    O2A    PA     O3A    PB        60.005   20.000   1
 ADP      var_2    PA     O3A    PB     O1B       59.979   20.000   1
 ADP      var_3    O2A    PA     "O5'"  "C5'"    -59.942   20.000   1
 ADP      var_4    PA     "O5'"  "C5'"  "C4'"    179.996   20.000   1
 ADP      var_5    "O5'"  "C5'"  "C4'"  "C3'"    176.858   20.000   3
 ADP      var_6    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 ADP      var_7    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 ADP      var_8    "C4'"  "C3'"  "O3'"  "HO3'"  -179.997   20.000   1
 ADP      var_9    "C4'"  "C3'"  "C2'"  "C1'"      0.000   20.000   3
 ADP      var_10   "C3'"  "C2'"  "O2'"  "HO2'"   -61.432   20.000   1
 ADP      var_11   "C3'"  "C2'"  "C1'"  N9       150.000   20.000   3
 ADP      var_12   "C2'"  "C1'"  "O4'"  "C4'"    -30.000   20.000   1
 ADP      var_13   "C2'"  "C1'"  N9     C4        91.437   20.000   1
 ADP      CONST_1  "C1'"  N9     C8     N7       180.000    0.000   0
 ADP      CONST_2  "C1'"  N9     C4     N3         0.000    0.000   0
 ADP      CONST_3  N9     C4     C5     N7         0.000    0.000   0
 ADP      CONST_4  C4     C5     C6     N1         0.000    0.000   0
 ADP      CONST_5  C4     C5     N7     C8         0.000    0.000   0
 ADP      CONST_6  C5     N7     C8     N9         0.000    0.000   0
 ADP      CONST_7  N9     C4     N3     C2       180.000    0.000   0
 ADP      CONST_8  C4     N3     C2     N1         0.000    0.000   0
 ADP      CONST_9  N3     C2     N1     C6         0.000    0.000   0
 ADP      CONST_10 C2     N1     C6     N6       180.000    0.000   0
 ADP      CONST_11 N1     C6     N6     HN61       0.014    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 ADP      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 ADP      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 ADP      chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 ADP      chir_04  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ADP      plan-1    N9        0.020
 ADP      plan-1    "C1'"     0.020
 ADP      plan-1    C8        0.020
 ADP      plan-1    C4        0.020
 ADP      plan-1    N7        0.020
 ADP      plan-1    H8        0.020
 ADP      plan-1    C5        0.020
 ADP      plan-1    C6        0.020
 ADP      plan-1    N1        0.020
 ADP      plan-1    C2        0.020
 ADP      plan-1    N3        0.020
 ADP      plan-1    N6        0.020
 ADP      plan-1    H2        0.020
 ADP      plan-1    HN62      0.020
 ADP      plan-1    HN61      0.020
 ADP      plan-2    N6        0.020
 ADP      plan-2    C6        0.020
 ADP      plan-2    HN61      0.020
 ADP      plan-2    HN62      0.020
# ------------------------------------------------------
`.trim();

monomers["ATP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ATP      ATP 'ADENOSINE-5'-TRIPHOSPHATE           ' non-polymer        43  31 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ATP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ATP           O2A    O    OP       -0.500      0.000    0.000    0.000
 ATP           PA     P    P         0.000     -0.864   -1.063   -0.567
 ATP           O1A    O    OP       -0.500     -0.799   -1.016   -2.048
 ATP           O3A    O    O2        0.000     -0.353   -2.500   -0.054
 ATP           PB     P    P         0.000      1.165   -2.665   -0.566
 ATP           O1B    O    OP       -0.500      1.997   -1.577    0.002
 ATP           O2B    O    OP       -0.500      1.199   -2.592   -2.046
 ATP           O3B    O    O2        0.000      1.742   -4.088   -0.084
 ATP           PG     P    P         0.000      3.255   -4.184   -0.626
 ATP           O3G    O    OP       -0.666      3.257   -4.087   -2.136
 ATP           O2G    O    OP       -0.666      3.858   -5.506   -0.205
 ATP           O1G    O    OP       -0.666      4.072   -3.050   -0.046
 ATP           "O5'"  O    O2        0.000     -2.384   -0.831   -0.090
 ATP           "C5'"  C    CH2       0.000     -2.777    0.453   -0.574
 ATP           "H5'1" H    H         0.000     -2.705    0.469   -1.663
 ATP           "H5'2" H    H         0.000     -2.118    1.216   -0.156
 ATP           "C4'"  C    CH1       0.000     -4.221    0.737   -0.152
 ATP           "H4'"  H    H         0.000     -4.899   -0.016   -0.578
 ATP           "C3'"  C    CH1       0.000     -4.645    2.154   -0.597
 ATP           "H3'"  H    H         0.000     -3.764    2.800   -0.716
 ATP           "O3'"  O    OH1       0.000     -5.392    2.095   -1.814
 ATP           "HO3'" H    H         0.000     -5.649    2.989   -2.078
 ATP           "C2'"  C    CH1       0.000     -5.536    2.661    0.562
 ATP           "H2'"  H    H         0.000     -5.097    3.560    1.018
 ATP           "O2'"  O    OH1       0.000     -6.858    2.933    0.095
 ATP           "HO2'" H    H         0.000     -6.826    3.626   -0.579
 ATP           "C1'"  C    CH1       0.000     -5.538    1.491    1.570
 ATP           "H1'"  H    H         0.000     -6.419    0.853    1.411
 ATP           "O4'"  O    O2        0.000     -4.329    0.755    1.288
 ATP           N9     N    NR5       0.000     -5.519    1.999    2.942
 ATP           C4     C    CR56      0.000     -6.612    2.269    3.725
 ATP           C5     C    CR56      0.000     -6.108    2.738    4.949
 ATP           N7     N    NRD5      0.000     -4.756    2.724    4.855
 ATP           C8     C    CR15      0.000     -4.409    2.295    3.677
 ATP           H8     H    H         0.000     -3.388    2.188    3.330
 ATP           N3     N    NRD6      0.000     -7.928    2.181    3.561
 ATP           C2     C    CR16      0.000     -8.750    2.523    4.531
 ATP           H2     H    H         0.000     -9.817    2.440    4.364
 ATP           N1     N    NRD6      0.000     -8.322    2.965    5.699
 ATP           C6     C    CR6       0.000     -7.024    3.086    5.956
 ATP           N6     N    NH2       0.000     -6.586    3.549    7.183
 ATP           HN62   H    H         0.000     -5.593    3.640    7.375
 ATP           HN61   H    H         0.000     -7.252    3.803    7.907
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ATP      O2A    n/a    PA     START
 ATP      PA     O2A    "O5'"  .
 ATP      O1A    PA     .      .
 ATP      O3A    PA     PB     .
 ATP      PB     O3A    O3B    .
 ATP      O1B    PB     .      .
 ATP      O2B    PB     .      .
 ATP      O3B    PB     PG     .
 ATP      PG     O3B    O1G    .
 ATP      O3G    PG     .      .
 ATP      O2G    PG     .      .
 ATP      O1G    PG     .      .
 ATP      "O5'"  PA     "C5'"  .
 ATP      "C5'"  "O5'"  "C4'"  .
 ATP      "H5'1" "C5'"  .      .
 ATP      "H5'2" "C5'"  .      .
 ATP      "C4'"  "C5'"  "C3'"  .
 ATP      "H4'"  "C4'"  .      .
 ATP      "C3'"  "C4'"  "C2'"  .
 ATP      "H3'"  "C3'"  .      .
 ATP      "O3'"  "C3'"  "HO3'" .
 ATP      "HO3'" "O3'"  .      .
 ATP      "C2'"  "C3'"  "C1'"  .
 ATP      "H2'"  "C2'"  .      .
 ATP      "O2'"  "C2'"  "HO2'" .
 ATP      "HO2'" "O2'"  .      .
 ATP      "C1'"  "C2'"  N9     .
 ATP      "H1'"  "C1'"  .      .
 ATP      "O4'"  "C1'"  .      .
 ATP      N9     "C1'"  C4     .
 ATP      C4     N9     N3     .
 ATP      C5     C4     N7     .
 ATP      N7     C5     C8     .
 ATP      C8     N7     H8     .
 ATP      H8     C8     .      .
 ATP      N3     C4     C2     .
 ATP      C2     N3     N1     .
 ATP      H2     C2     .      .
 ATP      N1     C2     C6     .
 ATP      C6     N1     N6     .
 ATP      N6     C6     HN61   .
 ATP      HN62   N6     .      .
 ATP      HN61   N6     .      END
 ATP      "C4'"  "O4'"  .    ADD
 ATP      N9     C8     .    ADD
 ATP      C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ATP      O1G    PG        deloc       1.510    0.020
 ATP      O2G    PG        deloc       1.510    0.020
 ATP      O3G    PG        deloc       1.510    0.020
 ATP      PG     O3B       single      1.610    0.020
 ATP      O1B    PB        deloc       1.510    0.020
 ATP      O2B    PB        deloc       1.510    0.020
 ATP      O3B    PB        single      1.610    0.020
 ATP      PB     O3A       single      1.610    0.020
 ATP      O1A    PA        deloc       1.510    0.020
 ATP      PA     O2A       deloc       1.510    0.020
 ATP      O3A    PA        single      1.610    0.020
 ATP      "O5'"  PA        single      1.610    0.020
 ATP      "C5'"  "O5'"     single      1.426    0.020
 ATP      "C4'"  "C5'"     single      1.524    0.020
 ATP      "H5'1" "C5'"     single      1.092    0.020
 ATP      "H5'2" "C5'"     single      1.092    0.020
 ATP      "C4'"  "O4'"     single      1.426    0.020
 ATP      "C3'"  "C4'"     single      1.524    0.020
 ATP      "H4'"  "C4'"     single      1.099    0.020
 ATP      "O4'"  "C1'"     single      1.426    0.020
 ATP      "O3'"  "C3'"     single      1.432    0.020
 ATP      "C2'"  "C3'"     single      1.524    0.020
 ATP      "H3'"  "C3'"     single      1.099    0.020
 ATP      "HO3'" "O3'"     single      0.967    0.020
 ATP      "O2'"  "C2'"     single      1.432    0.020
 ATP      "C1'"  "C2'"     single      1.524    0.020
 ATP      "H2'"  "C2'"     single      1.099    0.020
 ATP      "HO2'" "O2'"     single      0.967    0.020
 ATP      N9     "C1'"     single      1.485    0.020
 ATP      "H1'"  "C1'"     single      1.099    0.020
 ATP      N9     C8        single      1.337    0.020
 ATP      C4     N9        single      1.337    0.020
 ATP      C8     N7        double      1.350    0.020
 ATP      H8     C8        single      1.083    0.020
 ATP      N7     C5        single      1.350    0.020
 ATP      C5     C6        single      1.490    0.020
 ATP      C5     C4        double      1.490    0.020
 ATP      N6     C6        single      1.355    0.020
 ATP      C6     N1        double      1.350    0.020
 ATP      HN61   N6        single      1.010    0.020
 ATP      HN62   N6        single      1.010    0.020
 ATP      N1     C2        single      1.337    0.020
 ATP      C2     N3        double      1.337    0.020
 ATP      H2     C2        single      1.083    0.020
 ATP      N3     C4        single      1.355    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ATP      O2A    PA     O1A     119.900    3.000
 ATP      O2A    PA     O3A     108.200    3.000
 ATP      O2A    PA     "O5'"   108.200    3.000
 ATP      O1A    PA     O3A     108.200    3.000
 ATP      O1A    PA     "O5'"   108.200    3.000
 ATP      O3A    PA     "O5'"   102.600    3.000
 ATP      PA     O3A    PB      120.500    3.000
 ATP      O3A    PB     O1B     108.200    3.000
 ATP      O3A    PB     O2B     108.200    3.000
 ATP      O3A    PB     O3B     102.600    3.000
 ATP      O1B    PB     O2B     119.900    3.000
 ATP      O1B    PB     O3B     108.200    3.000
 ATP      O2B    PB     O3B     108.200    3.000
 ATP      PB     O3B    PG      120.500    3.000
 ATP      O3B    PG     O3G     108.200    3.000
 ATP      O3B    PG     O2G     108.200    3.000
 ATP      O3B    PG     O1G     108.200    3.000
 ATP      O3G    PG     O2G     119.900    3.000
 ATP      O3G    PG     O1G     119.900    3.000
 ATP      O2G    PG     O1G     119.900    3.000
 ATP      PA     "O5'"  "C5'"   120.500    3.000
 ATP      "O5'"  "C5'"  "H5'1"  109.470    3.000
 ATP      "O5'"  "C5'"  "H5'2"  109.470    3.000
 ATP      "O5'"  "C5'"  "C4'"   109.470    3.000
 ATP      "H5'1" "C5'"  "H5'2"  107.900    3.000
 ATP      "H5'1" "C5'"  "C4'"   109.470    3.000
 ATP      "H5'2" "C5'"  "C4'"   109.470    3.000
 ATP      "C5'"  "C4'"  "H4'"   108.340    3.000
 ATP      "C5'"  "C4'"  "C3'"   111.000    3.000
 ATP      "C5'"  "C4'"  "O4'"   109.470    3.000
 ATP      "H4'"  "C4'"  "C3'"   108.340    3.000
 ATP      "H4'"  "C4'"  "O4'"   109.470    3.000
 ATP      "C3'"  "C4'"  "O4'"   109.470    3.000
 ATP      "C4'"  "C3'"  "H3'"   108.340    3.000
 ATP      "C4'"  "C3'"  "O3'"   109.470    3.000
 ATP      "C4'"  "C3'"  "C2'"   111.000    3.000
 ATP      "H3'"  "C3'"  "O3'"   109.470    3.000
 ATP      "H3'"  "C3'"  "C2'"   108.340    3.000
 ATP      "O3'"  "C3'"  "C2'"   109.470    3.000
 ATP      "C3'"  "O3'"  "HO3'"  109.470    3.000
 ATP      "C3'"  "C2'"  "H2'"   108.340    3.000
 ATP      "C3'"  "C2'"  "O2'"   109.470    3.000
 ATP      "C3'"  "C2'"  "C1'"   111.000    3.000
 ATP      "H2'"  "C2'"  "O2'"   109.470    3.000
 ATP      "H2'"  "C2'"  "C1'"   108.340    3.000
 ATP      "O2'"  "C2'"  "C1'"   109.470    3.000
 ATP      "C2'"  "O2'"  "HO2'"  109.470    3.000
 ATP      "C2'"  "C1'"  "H1'"   108.340    3.000
 ATP      "C2'"  "C1'"  "O4'"   109.470    3.000
 ATP      "C2'"  "C1'"  N9      109.470    3.000
 ATP      "H1'"  "C1'"  "O4'"   109.470    3.000
 ATP      "H1'"  "C1'"  N9      109.470    3.000
 ATP      "O4'"  "C1'"  N9      109.470    3.000
 ATP      "C1'"  "O4'"  "C4'"   111.800    3.000
 ATP      "C1'"  N9     C4      126.000    3.000
 ATP      "C1'"  N9     C8      126.000    3.000
 ATP      C4     N9     C8      108.000    3.000
 ATP      N9     C4     C5      108.000    3.000
 ATP      N9     C4     N3      132.000    3.000
 ATP      C5     C4     N3      120.000    3.000
 ATP      C4     C5     N7      108.000    3.000
 ATP      C4     C5     C6      120.000    3.000
 ATP      N7     C5     C6      132.000    3.000
 ATP      C5     N7     C8      108.000    3.000
 ATP      N7     C8     H8      126.000    3.000
 ATP      N7     C8     N9      108.000    3.000
 ATP      H8     C8     N9      126.000    3.000
 ATP      C4     N3     C2      120.000    3.000
 ATP      N3     C2     H2      120.000    3.000
 ATP      N3     C2     N1      120.000    3.000
 ATP      H2     C2     N1      120.000    3.000
 ATP      C2     N1     C6      120.000    3.000
 ATP      N1     C6     N6      120.000    3.000
 ATP      N1     C6     C5      120.000    3.000
 ATP      N6     C6     C5      120.000    3.000
 ATP      C6     N6     HN62    120.000    3.000
 ATP      C6     N6     HN61    120.000    3.000
 ATP      HN62   N6     HN61    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ATP      var_1    O2A    PA     O3A    PB       -60.019   20.000   1
 ATP      var_2    PA     O3A    PB     O3B      179.979   20.000   1
 ATP      var_3    O3A    PB     O3B    PG      -179.939   20.000   1
 ATP      var_4    PB     O3B    PG     O1G       60.008   20.000   1
 ATP      var_5    O2A    PA     "O5'"  "C5'"     59.988   20.000   1
 ATP      var_6    PA     "O5'"  "C5'"  "C4'"   -179.996   20.000   1
 ATP      var_7    "O5'"  "C5'"  "C4'"  "C3'"    176.888   20.000   3
 ATP      var_8    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 ATP      var_9    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 ATP      var_10   "C4'"  "C3'"  "O3'"  "HO3'"  -179.962   20.000   1
 ATP      var_11   "C4'"  "C3'"  "C2'"  "C1'"      0.000   20.000   3
 ATP      var_12   "C3'"  "C2'"  "O2'"  "HO2'"   -61.452   20.000   1
 ATP      var_13   "C3'"  "C2'"  "C1'"  N9       150.000   20.000   3
 ATP      var_14   "C2'"  "C1'"  "O4'"  "C4'"    -30.000   20.000   1
 ATP      var_15   "C2'"  "C1'"  N9     C4        91.389   20.000   1
 ATP      CONST_1  "C1'"  N9     C8     N7       180.000    0.000   0
 ATP      CONST_2  "C1'"  N9     C4     N3         0.000    0.000   0
 ATP      CONST_3  N9     C4     C5     N7         0.000    0.000   0
 ATP      CONST_4  C4     C5     C6     N1         0.000    0.000   0
 ATP      CONST_5  C4     C5     N7     C8         0.000    0.000   0
 ATP      CONST_6  C5     N7     C8     N9         0.000    0.000   0
 ATP      CONST_7  N9     C4     N3     C2       180.000    0.000   0
 ATP      CONST_8  C4     N3     C2     N1         0.000    0.000   0
 ATP      CONST_9  N3     C2     N1     C6         0.000    0.000   0
 ATP      CONST_10 C2     N1     C6     N6       180.000    0.000   0
 ATP      CONST_11 N1     C6     N6     HN61       0.017    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 ATP      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 ATP      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 ATP      chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 ATP      chir_04  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ATP      plan-1    N9        0.020
 ATP      plan-1    "C1'"     0.020
 ATP      plan-1    C8        0.020
 ATP      plan-1    C4        0.020
 ATP      plan-1    N7        0.020
 ATP      plan-1    H8        0.020
 ATP      plan-1    C5        0.020
 ATP      plan-1    C6        0.020
 ATP      plan-1    N1        0.020
 ATP      plan-1    C2        0.020
 ATP      plan-1    N3        0.020
 ATP      plan-1    N6        0.020
 ATP      plan-1    H2        0.020
 ATP      plan-1    HN62      0.020
 ATP      plan-1    HN61      0.020
 ATP      plan-2    N6        0.020
 ATP      plan-2    C6        0.020
 ATP      plan-2    HN61      0.020
 ATP      plan-2    HN62      0.020
# ------------------------------------------------------
`.trim();

monomers["CMP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CMP      CMP 'ADENOSINE-3',5'-CYCLIC-MONOPHOSPHATE' non-polymer        33  22 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CMP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CMP           O2P    O    OP       -0.500      0.000    0.000    0.000
 CMP           P      P    P         0.000     -1.239   -0.086    0.811
 CMP           O1P    O    OP       -0.500     -1.170    0.907    1.910
 CMP           "O3'"  O    O2        0.000     -2.511    0.248   -0.125
 CMP           "C3'"  C    CH1       0.000     -3.641    0.101    0.713
 CMP           "H3'"  H    H         0.000     -3.559    0.749    1.596
 CMP           "C4'"  C    CH1       0.000     -3.717   -1.391    1.129
 CMP           "H4'"  H    H         0.000     -3.586   -2.032    0.246
 CMP           "C5'"  C    CH2       0.000     -2.610   -1.661    2.131
 CMP           "H5'2" H    H         0.000     -2.715   -2.664    2.551
 CMP           "H5'1" H    H         0.000     -2.641   -0.926    2.938
 CMP           "O5'"  O    O2        0.000     -1.358   -1.560    1.437
 CMP           "C2'"  C    CH1       0.000     -5.005    0.286    0.025
 CMP           "H2'"  H    H         0.000     -5.408    1.287    0.232
 CMP           "O2'"  O    OH1       0.000     -4.891    0.074   -1.384
 CMP           "HO2'" H    H         0.000     -5.756    0.195   -1.798
 CMP           "C1'"  C    CH1       0.000     -5.884   -0.801    0.688
 CMP           "H1'"  H    H         0.000     -6.264   -1.492   -0.077
 CMP           "O4'"  O    O2        0.000     -5.048   -1.516    1.627
 CMP           N9     N    NR5       0.000     -7.004   -0.174    1.393
 CMP           C4     C    CR56      0.000     -8.242    0.104    0.870
 CMP           C5     C    CR56      0.000     -8.976    0.703    1.905
 CMP           N7     N    NRD5      0.000     -8.168    0.751    2.991
 CMP           C8     C    CR15      0.000     -7.009    0.239    2.691
 CMP           H8     H    H         0.000     -6.172    0.154    3.373
 CMP           N3     N    NRD6      0.000     -8.817   -0.066   -0.317
 CMP           C2     C    CR16      0.000    -10.061    0.317   -0.519
 CMP           H2     H    H         0.000    -10.500    0.165   -1.497
 CMP           N1     N    NRD6      0.000    -10.792    0.878    0.426
 CMP           C6     C    CR6       0.000    -10.301    1.088    1.642
 CMP           N6     N    NH2       0.000    -11.076    1.679    2.626
 CMP           HN62   H    H         0.000    -10.697    1.839    3.554
 CMP           HN61   H    H         0.000    -12.032    1.960    2.430
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CMP      O2P    n/a    P      START
 CMP      P      O2P    "O3'"  .
 CMP      O1P    P      .      .
 CMP      "O3'"  P      "C3'"  .
 CMP      "C3'"  "O3'"  "C2'"  .
 CMP      "H3'"  "C3'"  .      .
 CMP      "C4'"  "C3'"  "C5'"  .
 CMP      "H4'"  "C4'"  .      .
 CMP      "C5'"  "C4'"  "O5'"  .
 CMP      "H5'2" "C5'"  .      .
 CMP      "H5'1" "C5'"  .      .
 CMP      "O5'"  "C5'"  .      .
 CMP      "C2'"  "C3'"  "C1'"  .
 CMP      "H2'"  "C2'"  .      .
 CMP      "O2'"  "C2'"  "HO2'" .
 CMP      "HO2'" "O2'"  .      .
 CMP      "C1'"  "C2'"  N9     .
 CMP      "H1'"  "C1'"  .      .
 CMP      "O4'"  "C1'"  .      .
 CMP      N9     "C1'"  C4     .
 CMP      C4     N9     N3     .
 CMP      C5     C4     N7     .
 CMP      N7     C5     C8     .
 CMP      C8     N7     H8     .
 CMP      H8     C8     .      .
 CMP      N3     C4     C2     .
 CMP      C2     N3     N1     .
 CMP      H2     C2     .      .
 CMP      N1     C2     C6     .
 CMP      C6     N1     N6     .
 CMP      N6     C6     HN61   .
 CMP      HN62   N6     .      .
 CMP      HN61   N6     .      END
 CMP      P      "O5'"  .    ADD
 CMP      "C4'"  "O4'"  .    ADD
 CMP      N9     C8     .    ADD
 CMP      C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CMP      O1P    P         deloc       1.510    0.020
 CMP      P      O2P       deloc       1.510    0.020
 CMP      P      "O5'"     single      1.610    0.020
 CMP      "O3'"  P         single      1.610    0.020
 CMP      "O5'"  "C5'"     single      1.426    0.020
 CMP      "C5'"  "C4'"     single      1.524    0.020
 CMP      "H5'1" "C5'"     single      1.092    0.020
 CMP      "H5'2" "C5'"     single      1.092    0.020
 CMP      "C4'"  "O4'"     single      1.426    0.020
 CMP      "C4'"  "C3'"     single      1.524    0.020
 CMP      "H4'"  "C4'"     single      1.099    0.020
 CMP      "O4'"  "C1'"     single      1.426    0.020
 CMP      "C3'"  "O3'"     single      1.426    0.020
 CMP      "C2'"  "C3'"     single      1.524    0.020
 CMP      "H3'"  "C3'"     single      1.099    0.020
 CMP      "O2'"  "C2'"     single      1.432    0.020
 CMP      "C1'"  "C2'"     single      1.524    0.020
 CMP      "H2'"  "C2'"     single      1.099    0.020
 CMP      "HO2'" "O2'"     single      0.967    0.020
 CMP      N9     "C1'"     single      1.485    0.020
 CMP      "H1'"  "C1'"     single      1.099    0.020
 CMP      N9     C8        single      1.337    0.020
 CMP      C4     N9        single      1.337    0.020
 CMP      C8     N7        double      1.350    0.020
 CMP      H8     C8        single      1.083    0.020
 CMP      N7     C5        single      1.350    0.020
 CMP      C5     C6        single      1.490    0.020
 CMP      C5     C4        double      1.490    0.020
 CMP      N6     C6        single      1.355    0.020
 CMP      C6     N1        double      1.350    0.020
 CMP      HN61   N6        single      1.010    0.020
 CMP      HN62   N6        single      1.010    0.020
 CMP      N1     C2        single      1.337    0.020
 CMP      C2     N3        double      1.337    0.020
 CMP      H2     C2        single      1.083    0.020
 CMP      N3     C4        single      1.355    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CMP      O2P    P      O1P     119.900    3.000
 CMP      O2P    P      "O3'"   108.200    3.000
 CMP      O2P    P      "O5'"   108.200    3.000
 CMP      O1P    P      "O3'"   108.200    3.000
 CMP      O1P    P      "O5'"   108.200    3.000
 CMP      "O3'"  P      "O5'"   102.600    3.000
 CMP      P      "O3'"  "C3'"   120.500    3.000
 CMP      "O3'"  "C3'"  "H3'"   109.470    3.000
 CMP      "O3'"  "C3'"  "C4'"   109.470    3.000
 CMP      "O3'"  "C3'"  "C2'"   109.470    3.000
 CMP      "H3'"  "C3'"  "C4'"   108.340    3.000
 CMP      "H3'"  "C3'"  "C2'"   108.340    3.000
 CMP      "C4'"  "C3'"  "C2'"   111.000    3.000
 CMP      "C3'"  "C4'"  "H4'"   108.340    3.000
 CMP      "C3'"  "C4'"  "C5'"   111.000    3.000
 CMP      "C3'"  "C4'"  "O4'"   109.470    3.000
 CMP      "H4'"  "C4'"  "C5'"   108.340    3.000
 CMP      "H4'"  "C4'"  "O4'"   109.470    3.000
 CMP      "C5'"  "C4'"  "O4'"   109.470    3.000
 CMP      "C4'"  "C5'"  "H5'2"  109.470    3.000
 CMP      "C4'"  "C5'"  "H5'1"  109.470    3.000
 CMP      "C4'"  "C5'"  "O5'"   109.470    3.000
 CMP      "H5'2" "C5'"  "H5'1"  107.900    3.000
 CMP      "H5'2" "C5'"  "O5'"   109.470    3.000
 CMP      "H5'1" "C5'"  "O5'"   109.470    3.000
 CMP      "C5'"  "O5'"  P       120.500    3.000
 CMP      "C3'"  "C2'"  "H2'"   108.340    3.000
 CMP      "C3'"  "C2'"  "O2'"   109.470    3.000
 CMP      "C3'"  "C2'"  "C1'"   111.000    3.000
 CMP      "H2'"  "C2'"  "O2'"   109.470    3.000
 CMP      "H2'"  "C2'"  "C1'"   108.340    3.000
 CMP      "O2'"  "C2'"  "C1'"   109.470    3.000
 CMP      "C2'"  "O2'"  "HO2'"  109.470    3.000
 CMP      "C2'"  "C1'"  "H1'"   108.340    3.000
 CMP      "C2'"  "C1'"  "O4'"   109.470    3.000
 CMP      "C2'"  "C1'"  N9      109.470    3.000
 CMP      "H1'"  "C1'"  "O4'"   109.470    3.000
 CMP      "H1'"  "C1'"  N9      109.470    3.000
 CMP      "O4'"  "C1'"  N9      109.470    3.000
 CMP      "C1'"  "O4'"  "C4'"   111.800    3.000
 CMP      "C1'"  N9     C4      126.000    3.000
 CMP      "C1'"  N9     C8      126.000    3.000
 CMP      C4     N9     C8      108.000    3.000
 CMP      N9     C4     C5      108.000    3.000
 CMP      N9     C4     N3      132.000    3.000
 CMP      C5     C4     N3      120.000    3.000
 CMP      C4     C5     N7      108.000    3.000
 CMP      C4     C5     C6      120.000    3.000
 CMP      N7     C5     C6      132.000    3.000
 CMP      C5     N7     C8      108.000    3.000
 CMP      N7     C8     H8      126.000    3.000
 CMP      N7     C8     N9      108.000    3.000
 CMP      H8     C8     N9      126.000    3.000
 CMP      C4     N3     C2      120.000    3.000
 CMP      N3     C2     H2      120.000    3.000
 CMP      N3     C2     N1      120.000    3.000
 CMP      H2     C2     N1      120.000    3.000
 CMP      C2     N1     C6      120.000    3.000
 CMP      N1     C6     N6      120.000    3.000
 CMP      N1     C6     C5      120.000    3.000
 CMP      N6     C6     C5      120.000    3.000
 CMP      C6     N6     HN62    120.000    3.000
 CMP      C6     N6     HN61    120.000    3.000
 CMP      HN62   N6     HN61    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CMP      var_1    O2P    P      "O5'"  "C5'"    180.000   20.000   1
 CMP      var_2    O2P    P      "O3'"  "C3'"    180.000   20.000   1
 CMP      var_3    P      "O3'"  "C3'"  "C2'"    180.000   20.000   1
 CMP      var_4    "O3'"  "C3'"  "C4'"  "C5'"     60.000   20.000   3
 CMP      var_5    "C3'"  "C4'"  "O4'"  "C1'"     30.000   20.000   1
 CMP      var_6    "C3'"  "C4'"  "C5'"  "O5'"    -60.000   20.000   3
 CMP      var_7    "C4'"  "C5'"  "O5'"  P         60.000   20.000   1
 CMP      var_8    "O3'"  "C3'"  "C2'"  "C1'"    150.000   20.000   3
 CMP      var_9    "C3'"  "C2'"  "O2'"  "HO2'"  -179.969   20.000   1
 CMP      var_10   "C3'"  "C2'"  "C1'"  N9       120.000   20.000   3
 CMP      var_11   "C2'"  "C1'"  "O4'"  "C4'"    -30.000   20.000   1
 CMP      var_12   "C2'"  "C1'"  N9     C4        90.351   20.000   1
 CMP      CONST_1  "C1'"  N9     C8     N7       180.000    0.000   0
 CMP      CONST_2  "C1'"  N9     C4     N3         0.000    0.000   0
 CMP      CONST_3  N9     C4     C5     N7         0.000    0.000   0
 CMP      CONST_4  C4     C5     C6     N1         0.000    0.000   0
 CMP      CONST_5  C4     C5     N7     C8         0.000    0.000   0
 CMP      CONST_6  C5     N7     C8     N9         0.000    0.000   0
 CMP      CONST_7  N9     C4     N3     C2       180.000    0.000   0
 CMP      CONST_8  C4     N3     C2     N1         0.000    0.000   0
 CMP      CONST_9  N3     C2     N1     C6         0.000    0.000   0
 CMP      CONST_10 C2     N1     C6     N6       180.000    0.000   0
 CMP      CONST_11 N1     C6     N6     HN61       0.027    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 CMP      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 CMP      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 CMP      chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 CMP      chir_04  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 CMP      plan-1    N9        0.020
 CMP      plan-1    "C1'"     0.020
 CMP      plan-1    C8        0.020
 CMP      plan-1    C4        0.020
 CMP      plan-1    N7        0.020
 CMP      plan-1    H8        0.020
 CMP      plan-1    C5        0.020
 CMP      plan-1    C6        0.020
 CMP      plan-1    N1        0.020
 CMP      plan-1    C2        0.020
 CMP      plan-1    N3        0.020
 CMP      plan-1    N6        0.020
 CMP      plan-1    H2        0.020
 CMP      plan-1    HN62      0.020
 CMP      plan-1    HN61      0.020
 CMP      plan-2    N6        0.020
 CMP      plan-2    C6        0.020
 CMP      plan-2    HN61      0.020
 CMP      plan-2    HN62      0.020
# ------------------------------------------------------
`.trim();

monomers["CDP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CDP      CDP 'CYTIDINE-5'-DIPHOSPHATE             ' non-polymer        37  25 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CDP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CDP           O2     O    O         0.000      0.000    0.000    0.000
 CDP           C2     C    CR6       0.000      0.527    0.304   -1.058
 CDP           N3     N    NRD6      0.000      1.468    1.247   -1.073
 CDP           C4     C    CR6       0.000      2.056    1.597   -2.210
 CDP           N4     N    NH2       0.000      3.027    2.571   -2.214
 CDP           H4N2   H    H         0.000      3.478    2.841   -3.081
 CDP           H4N1   H    H         0.000      3.299    3.027   -1.350
 CDP           C5     C    CR16      0.000      1.681    0.964   -3.413
 CDP           H5     H    H         0.000      2.150    1.242   -4.349
 CDP           C6     C    CR16      0.000      0.726    0.004   -3.379
 CDP           H6     H    H         0.000      0.427   -0.502   -4.289
 CDP           N1     N    NR6       0.000      0.147   -0.318   -2.189
 CDP           "C1'"  C    CH1       0.000     -0.890   -1.351   -2.139
 CDP           "H1'"  H    H         0.000     -1.125   -1.713   -3.150
 CDP           "O4'"  O    O2        0.000     -2.078   -0.848   -1.490
 CDP           "C2'"  C    CH1       0.000     -0.449   -2.525   -1.229
 CDP           "H2'"  H    H         0.000      0.108   -2.155   -0.357
 CDP           "O2'"  O    OH1       0.000      0.325   -3.476   -1.962
 CDP           HB     H    H         0.000      0.510   -4.241   -1.400
 CDP           "C3'"  C    CH1       0.000     -1.808   -3.131   -0.799
 CDP           "H3'"  H    H         0.000     -1.784   -3.417    0.262
 CDP           "O3'"  O    OH1       0.000     -2.133   -4.258   -1.614
 CDP           HA     H    H         0.000     -1.490   -4.963   -1.459
 CDP           "C4'"  C    CH1       0.000     -2.819   -1.990   -1.028
 CDP           "H4'"  H    H         0.000     -3.556   -2.290   -1.786
 CDP           "C5'"  C    CH2       0.000     -3.529   -1.654    0.284
 CDP           "H5'1" H    H         0.000     -2.802   -1.268    1.002
 CDP           "H5'2" H    H         0.000     -3.994   -2.556    0.688
 CDP           "O5'"  O    O2        0.000     -4.533   -0.666    0.043
 CDP           PA     P    P         0.000     -5.479   -0.075    1.205
 CDP           O1A    O    OP       -0.500     -6.168   -1.190    1.896
 CDP           O2A    O    OP       -0.500     -4.652    0.677    2.180
 CDP           O3A    O    O2        0.000     -6.573    0.912    0.555
 CDP           PB     P    P         0.000     -7.949    1.559    1.085
 CDP           O3B    O    OP       -0.666     -7.640    2.757    1.956
 CDP           O1B    O    OP       -0.666     -8.713    0.532    1.891
 CDP           O2B    O    OP       -0.666     -8.786    1.998   -0.096
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CDP      O2     n/a    C2     START
 CDP      C2     O2     N3     .
 CDP      N3     C2     C4     .
 CDP      C4     N3     C5     .
 CDP      N4     C4     H4N1   .
 CDP      H4N2   N4     .      .
 CDP      H4N1   N4     .      .
 CDP      C5     C4     C6     .
 CDP      H5     C5     .      .
 CDP      C6     C5     N1     .
 CDP      H6     C6     .      .
 CDP      N1     C6     "C1'"  .
 CDP      "C1'"  N1     "C2'"  .
 CDP      "H1'"  "C1'"  .      .
 CDP      "O4'"  "C1'"  .      .
 CDP      "C2'"  "C1'"  "C3'"  .
 CDP      "H2'"  "C2'"  .      .
 CDP      "O2'"  "C2'"  HB     .
 CDP      HB     "O2'"  .      .
 CDP      "C3'"  "C2'"  "C4'"  .
 CDP      "H3'"  "C3'"  .      .
 CDP      "O3'"  "C3'"  HA     .
 CDP      HA     "O3'"  .      .
 CDP      "C4'"  "C3'"  "C5'"  .
 CDP      "H4'"  "C4'"  .      .
 CDP      "C5'"  "C4'"  "O5'"  .
 CDP      "H5'1" "C5'"  .      .
 CDP      "H5'2" "C5'"  .      .
 CDP      "O5'"  "C5'"  PA     .
 CDP      PA     "O5'"  O3A    .
 CDP      O1A    PA     .      .
 CDP      O2A    PA     .      .
 CDP      O3A    PA     PB     .
 CDP      PB     O3A    O2B    .
 CDP      O3B    PB     .      .
 CDP      O1B    PB     .      .
 CDP      O2B    PB     .      END
 CDP      "C4'"  "O4'"  .    ADD
 CDP      N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CDP      O3B    PB        deloc       1.510    0.020
 CDP      O1B    PB        deloc       1.510    0.020
 CDP      O2B    PB        deloc       1.510    0.020
 CDP      PB     O3A       single      1.610    0.020
 CDP      O3A    PA        single      1.610    0.020
 CDP      O1A    PA        deloc       1.510    0.020
 CDP      O2A    PA        deloc       1.510    0.020
 CDP      PA     "O5'"     single      1.610    0.020
 CDP      "O5'"  "C5'"     single      1.426    0.020
 CDP      "C5'"  "C4'"     single      1.524    0.020
 CDP      "H5'1" "C5'"     single      1.092    0.020
 CDP      "H5'2" "C5'"     single      1.092    0.020
 CDP      "C4'"  "O4'"     single      1.426    0.020
 CDP      "C4'"  "C3'"     single      1.524    0.020
 CDP      "H4'"  "C4'"     single      1.099    0.020
 CDP      "O4'"  "C1'"     single      1.426    0.020
 CDP      "O3'"  "C3'"     single      1.432    0.020
 CDP      "C3'"  "C2'"     single      1.524    0.020
 CDP      "H3'"  "C3'"     single      1.099    0.020
 CDP      HA     "O3'"     single      0.967    0.020
 CDP      "O2'"  "C2'"     single      1.432    0.020
 CDP      "C2'"  "C1'"     single      1.524    0.020
 CDP      "H2'"  "C2'"     single      1.099    0.020
 CDP      HB     "O2'"     single      0.967    0.020
 CDP      "C1'"  N1        single      1.465    0.020
 CDP      "H1'"  "C1'"     single      1.099    0.020
 CDP      N1     C2        single      1.410    0.020
 CDP      N1     C6        single      1.337    0.020
 CDP      C2     O2        double      1.250    0.020
 CDP      N3     C2        single      1.350    0.020
 CDP      C4     N3        double      1.350    0.020
 CDP      N4     C4        single      1.355    0.020
 CDP      C5     C4        single      1.390    0.020
 CDP      H4N1   N4        single      1.010    0.020
 CDP      H4N2   N4        single      1.010    0.020
 CDP      C6     C5        double      1.390    0.020
 CDP      H5     C5        single      1.083    0.020
 CDP      H6     C6        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CDP      O2     C2     N3      120.000    3.000
 CDP      O2     C2     N1      120.000    3.000
 CDP      N3     C2     N1      120.000    3.000
 CDP      C2     N3     C4      120.000    3.000
 CDP      N3     C4     N4      120.000    3.000
 CDP      N3     C4     C5      120.000    3.000
 CDP      N4     C4     C5      120.000    3.000
 CDP      C4     N4     H4N2    120.000    3.000
 CDP      C4     N4     H4N1    120.000    3.000
 CDP      H4N2   N4     H4N1    120.000    3.000
 CDP      C4     C5     H5      120.000    3.000
 CDP      C4     C5     C6      120.000    3.000
 CDP      H5     C5     C6      120.000    3.000
 CDP      C5     C6     H6      120.000    3.000
 CDP      C5     C6     N1      120.000    3.000
 CDP      H6     C6     N1      120.000    3.000
 CDP      C6     N1     "C1'"   120.000    3.000
 CDP      C6     N1     C2      120.000    3.000
 CDP      "C1'"  N1     C2      120.000    3.000
 CDP      N1     "C1'"  "H1'"   109.470    3.000
 CDP      N1     "C1'"  "O4'"   109.470    3.000
 CDP      N1     "C1'"  "C2'"   109.470    3.000
 CDP      "H1'"  "C1'"  "O4'"   109.470    3.000
 CDP      "H1'"  "C1'"  "C2'"   108.340    3.000
 CDP      "O4'"  "C1'"  "C2'"   109.470    3.000
 CDP      "C1'"  "O4'"  "C4'"   111.800    3.000
 CDP      "C1'"  "C2'"  "H2'"   108.340    3.000
 CDP      "C1'"  "C2'"  "O2'"   109.470    3.000
 CDP      "C1'"  "C2'"  "C3'"   111.000    3.000
 CDP      "H2'"  "C2'"  "O2'"   109.470    3.000
 CDP      "H2'"  "C2'"  "C3'"   108.340    3.000
 CDP      "O2'"  "C2'"  "C3'"   109.470    3.000
 CDP      "C2'"  "O2'"  HB      109.470    3.000
 CDP      "C2'"  "C3'"  "H3'"   108.340    3.000
 CDP      "C2'"  "C3'"  "O3'"   109.470    3.000
 CDP      "C2'"  "C3'"  "C4'"   111.000    3.000
 CDP      "H3'"  "C3'"  "O3'"   109.470    3.000
 CDP      "H3'"  "C3'"  "C4'"   108.340    3.000
 CDP      "O3'"  "C3'"  "C4'"   109.470    3.000
 CDP      "C3'"  "O3'"  HA      109.470    3.000
 CDP      "C3'"  "C4'"  "H4'"   108.340    3.000
 CDP      "C3'"  "C4'"  "C5'"   111.000    3.000
 CDP      "C3'"  "C4'"  "O4'"   109.470    3.000
 CDP      "H4'"  "C4'"  "C5'"   108.340    3.000
 CDP      "H4'"  "C4'"  "O4'"   109.470    3.000
 CDP      "C5'"  "C4'"  "O4'"   109.470    3.000
 CDP      "C4'"  "C5'"  "H5'1"  109.470    3.000
 CDP      "C4'"  "C5'"  "H5'2"  109.470    3.000
 CDP      "C4'"  "C5'"  "O5'"   109.470    3.000
 CDP      "H5'1" "C5'"  "H5'2"  107.900    3.000
 CDP      "H5'1" "C5'"  "O5'"   109.470    3.000
 CDP      "H5'2" "C5'"  "O5'"   109.470    3.000
 CDP      "C5'"  "O5'"  PA      120.500    3.000
 CDP      "O5'"  PA     O1A     108.200    3.000
 CDP      "O5'"  PA     O2A     108.200    3.000
 CDP      "O5'"  PA     O3A     102.600    3.000
 CDP      O1A    PA     O2A     119.900    3.000
 CDP      O1A    PA     O3A     108.200    3.000
 CDP      O2A    PA     O3A     108.200    3.000
 CDP      PA     O3A    PB      120.500    3.000
 CDP      O3A    PB     O3B     108.200    3.000
 CDP      O3A    PB     O1B     108.200    3.000
 CDP      O3A    PB     O2B     108.200    3.000
 CDP      O3B    PB     O1B     119.900    3.000
 CDP      O3B    PB     O2B     119.900    3.000
 CDP      O1B    PB     O2B     119.900    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CDP      CONST_1  O2     C2     N3     C4       180.000    0.000   0
 CDP      CONST_2  C2     N3     C4     C5         0.000    0.000   0
 CDP      CONST_3  N3     C4     N4     H4N1      -0.012    0.000   0
 CDP      CONST_4  N3     C4     C5     C6         0.000    0.000   0
 CDP      CONST_5  C4     C5     C6     N1         0.000    0.000   0
 CDP      CONST_6  C5     C6     N1     "C1'"    180.000    0.000   0
 CDP      CONST_7  C6     N1     C2     O2       180.000    0.000   0
 CDP      var_1    C6     N1     "C1'"  "C2'"    119.214   20.000   1
 CDP      var_2    N1     "C1'"  "O4'"  "C4'"   -150.000   20.000   1
 CDP      var_3    N1     "C1'"  "C2'"  "C3'"    150.000   20.000   3
 CDP      var_4    "C1'"  "C2'"  "O2'"  HB      -174.146   20.000   1
 CDP      var_5    "C1'"  "C2'"  "C3'"  "C4'"    -30.000   20.000   3
 CDP      var_6    "C2'"  "C3'"  "O3'"  HA        65.262   20.000   1
 CDP      var_7    "C2'"  "C3'"  "C4'"  "C5'"   -120.000   20.000   3
 CDP      var_8    "C3'"  "C4'"  "O4'"  "C1'"     30.000   20.000   1
 CDP      var_9    "C3'"  "C4'"  "C5'"  "O5'"   -175.715   20.000   3
 CDP      var_10   "C4'"  "C5'"  "O5'"  PA      -179.959   20.000   1
 CDP      var_11   "C5'"  "O5'"  PA     O3A     -174.972   20.000   1
 CDP      var_12   "O5'"  PA     O3A    PB       164.987   20.000   1
 CDP      var_13   PA     O3A    PB     O2B     -160.031   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 CDP      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 CDP      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 CDP      chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 CDP      chir_04  "C1'"  "O4'"  "C2'"  N1        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 CDP      plan-1    N1        0.020
 CDP      plan-1    "C1'"     0.020
 CDP      plan-1    C2        0.020
 CDP      plan-1    C6        0.020
 CDP      plan-1    N3        0.020
 CDP      plan-1    C4        0.020
 CDP      plan-1    C5        0.020
 CDP      plan-1    O2        0.020
 CDP      plan-1    N4        0.020
 CDP      plan-1    H5        0.020
 CDP      plan-1    H6        0.020
 CDP      plan-1    H4N2      0.020
 CDP      plan-1    H4N1      0.020
 CDP      plan-2    N4        0.020
 CDP      plan-2    C4        0.020
 CDP      plan-2    H4N1      0.020
 CDP      plan-2    H4N2      0.020
# ------------------------------------------------------
`.trim();

monomers["CTP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CTP      CTP 'CYTIDINE-5'-TRIPHOSPHATE            ' non-polymer        41  29 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CTP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CTP           O3G    O    OP       -0.666      0.000    0.000    0.000
 CTP           PG     P    P         0.000     -0.352    0.245   -1.451
 CTP           O1G    O    OP       -0.666     -0.510   -1.080   -2.164
 CTP           O2G    O    OP       -0.666      0.753    1.044   -2.108
 CTP           O3B    O    O2        0.000     -1.732    1.068   -1.536
 CTP           PB     P    P         0.000     -2.858    0.165   -0.822
 CTP           O1B    O    OP       -0.500     -2.974   -1.132   -1.530
 CTP           O2B    O    OP       -0.500     -2.475   -0.074    0.591
 CTP           O3A    O    O2        0.000     -4.272    0.932   -0.871
 CTP           PA     P    P         0.000     -5.345   -0.021   -0.143
 CTP           O1A    O    OP       -0.500     -5.423   -1.316   -0.862
 CTP           O2A    O    OP       -0.500     -4.924   -0.259    1.258
 CTP           "O5'"  O    O2        0.000     -6.791    0.686   -0.156
 CTP           "C5'"  C    CH2       0.000     -7.693   -0.204    0.501
 CTP           "H5'1" H    H         0.000     -7.353   -0.376    1.524
 CTP           "H5'2" H    H         0.000     -7.720   -1.155   -0.036
 CTP           "C4'"  C    CH1       0.000     -9.093    0.412    0.523
 CTP           "H4'"  H    H         0.000     -9.083    1.363    1.073
 CTP           "C3'"  C    CH1       0.000    -10.104   -0.567    1.159
 CTP           "H3'"  H    H         0.000     -9.749   -1.603    1.067
 CTP           "O3'"  O    OH1       0.000    -10.327   -0.234    2.532
 CTP           "HO3'" H    H         0.000    -10.961   -0.855    2.914
 CTP           "C2'"  C    CH1       0.000    -11.397   -0.361    0.334
 CTP           "H2'"  H    H         0.000    -11.684   -1.295   -0.169
 CTP           "O2'"  O    OH1       0.000    -12.457    0.101    1.173
 CTP           "HO2'" H    H         0.000    -12.642   -0.562    1.852
 CTP           "O4'"  O    O2        0.000     -9.573    0.615   -0.824
 CTP           "C1'"  C    CH1       0.000    -11.010    0.715   -0.704
 CTP           "H1'"  H    H         0.000    -11.295    1.713   -0.345
 CTP           N1     N    NR6       0.000    -11.649    0.433   -1.991
 CTP           C6     C    CR16      0.000    -12.476    1.360   -2.553
 CTP           H6     H    H         0.000    -12.666    2.300   -2.050
 CTP           C5     C    CR16      0.000    -13.057    1.091   -3.747
 CTP           H5     H    H         0.000    -13.711    1.817   -4.216
 CTP           C4     C    CR6       0.000    -12.798   -0.146   -4.369
 CTP           N4     N    NH2       0.000    -13.378   -0.447   -5.579
 CTP           HN42   H    H         0.000    -13.999    0.216   -6.030
 CTP           HN41   H    H         0.000    -13.190   -1.335   -6.031
 CTP           N3     N    NRD6      0.000    -11.986   -1.018   -3.784
 CTP           C2     C    CR6       0.000    -11.417   -0.736   -2.612
 CTP           O2     O    O         0.000    -10.674   -1.553   -2.095
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CTP      O3G    n/a    PG     START
 CTP      PG     O3G    O3B    .
 CTP      O1G    PG     .      .
 CTP      O2G    PG     .      .
 CTP      O3B    PG     PB     .
 CTP      PB     O3B    O3A    .
 CTP      O1B    PB     .      .
 CTP      O2B    PB     .      .
 CTP      O3A    PB     PA     .
 CTP      PA     O3A    "O5'"  .
 CTP      O1A    PA     .      .
 CTP      O2A    PA     .      .
 CTP      "O5'"  PA     "C5'"  .
 CTP      "C5'"  "O5'"  "C4'"  .
 CTP      "H5'1" "C5'"  .      .
 CTP      "H5'2" "C5'"  .      .
 CTP      "C4'"  "C5'"  "O4'"  .
 CTP      "H4'"  "C4'"  .      .
 CTP      "C3'"  "C4'"  "C2'"  .
 CTP      "H3'"  "C3'"  .      .
 CTP      "O3'"  "C3'"  "HO3'" .
 CTP      "HO3'" "O3'"  .      .
 CTP      "C2'"  "C3'"  "O2'"  .
 CTP      "H2'"  "C2'"  .      .
 CTP      "O2'"  "C2'"  "HO2'" .
 CTP      "HO2'" "O2'"  .      .
 CTP      "O4'"  "C4'"  "C1'"  .
 CTP      "C1'"  "O4'"  N1     .
 CTP      "H1'"  "C1'"  .      .
 CTP      N1     "C1'"  C6     .
 CTP      C6     N1     C5     .
 CTP      H6     C6     .      .
 CTP      C5     C6     C4     .
 CTP      H5     C5     .      .
 CTP      C4     C5     N3     .
 CTP      N4     C4     HN41   .
 CTP      HN42   N4     .      .
 CTP      HN41   N4     .      .
 CTP      N3     C4     C2     .
 CTP      C2     N3     O2     .
 CTP      O2     C2     .      END
 CTP      N1     C2     .    ADD
 CTP      "C1'"  "C2'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CTP      N1     C2        single      1.410    0.020
 CTP      C6     N1        single      1.337    0.020
 CTP      N1     "C1'"     single      1.465    0.020
 CTP      C2     N3        single      1.350    0.020
 CTP      O2     C2        double      1.250    0.020
 CTP      N3     C4        double      1.350    0.020
 CTP      C4     C5        single      1.390    0.020
 CTP      N4     C4        single      1.355    0.020
 CTP      C5     C6        double      1.390    0.020
 CTP      H5     C5        single      1.083    0.020
 CTP      H6     C6        single      1.083    0.020
 CTP      HN41   N4        single      1.010    0.020
 CTP      HN42   N4        single      1.010    0.020
 CTP      "C1'"  "C2'"     single      1.524    0.020
 CTP      "C1'"  "O4'"     single      1.426    0.020
 CTP      "H1'"  "C1'"     single      1.099    0.020
 CTP      "O2'"  "C2'"     single      1.432    0.020
 CTP      "C2'"  "C3'"     single      1.524    0.020
 CTP      "H2'"  "C2'"     single      1.099    0.020
 CTP      "HO2'" "O2'"     single      0.967    0.020
 CTP      "C3'"  "C4'"     single      1.524    0.020
 CTP      "O3'"  "C3'"     single      1.432    0.020
 CTP      "H3'"  "C3'"     single      1.099    0.020
 CTP      "O4'"  "C4'"     single      1.426    0.020
 CTP      "C4'"  "C5'"     single      1.524    0.020
 CTP      "H4'"  "C4'"     single      1.099    0.020
 CTP      "HO3'" "O3'"     single      0.967    0.020
 CTP      "C5'"  "O5'"     single      1.426    0.020
 CTP      "H5'1" "C5'"     single      1.092    0.020
 CTP      "H5'2" "C5'"     single      1.092    0.020
 CTP      "O5'"  PA        single      1.610    0.020
 CTP      O1A    PA        deloc       1.510    0.020
 CTP      O2A    PA        deloc       1.510    0.020
 CTP      PA     O3A       single      1.610    0.020
 CTP      O3A    PB        single      1.610    0.020
 CTP      O1B    PB        deloc       1.510    0.020
 CTP      O2B    PB        deloc       1.510    0.020
 CTP      PB     O3B       single      1.610    0.020
 CTP      O3B    PG        single      1.610    0.020
 CTP      O1G    PG        deloc       1.510    0.020
 CTP      O2G    PG        deloc       1.510    0.020
 CTP      PG     O3G       deloc       1.510    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CTP      O3G    PG     O1G     119.900    3.000
 CTP      O3G    PG     O2G     119.900    3.000
 CTP      O3G    PG     O3B     108.200    3.000
 CTP      O1G    PG     O2G     119.900    3.000
 CTP      O1G    PG     O3B     108.200    3.000
 CTP      O2G    PG     O3B     108.200    3.000
 CTP      PG     O3B    PB      120.500    3.000
 CTP      O3B    PB     O1B     108.200    3.000
 CTP      O3B    PB     O2B     108.200    3.000
 CTP      O3B    PB     O3A     102.600    3.000
 CTP      O1B    PB     O2B     119.900    3.000
 CTP      O1B    PB     O3A     108.200    3.000
 CTP      O2B    PB     O3A     108.200    3.000
 CTP      PB     O3A    PA      120.500    3.000
 CTP      O3A    PA     O1A     108.200    3.000
 CTP      O3A    PA     O2A     108.200    3.000
 CTP      O3A    PA     "O5'"   102.600    3.000
 CTP      O1A    PA     O2A     119.900    3.000
 CTP      O1A    PA     "O5'"   108.200    3.000
 CTP      O2A    PA     "O5'"   108.200    3.000
 CTP      PA     "O5'"  "C5'"   120.500    3.000
 CTP      "O5'"  "C5'"  "H5'1"  109.470    3.000
 CTP      "O5'"  "C5'"  "H5'2"  109.470    3.000
 CTP      "O5'"  "C5'"  "C4'"   109.470    3.000
 CTP      "H5'1" "C5'"  "H5'2"  107.900    3.000
 CTP      "H5'1" "C5'"  "C4'"   109.470    3.000
 CTP      "H5'2" "C5'"  "C4'"   109.470    3.000
 CTP      "C5'"  "C4'"  "H4'"   108.340    3.000
 CTP      "C5'"  "C4'"  "C3'"   111.000    3.000
 CTP      "C5'"  "C4'"  "O4'"   109.470    3.000
 CTP      "H4'"  "C4'"  "C3'"   108.340    3.000
 CTP      "H4'"  "C4'"  "O4'"   109.470    3.000
 CTP      "C3'"  "C4'"  "O4'"   109.470    3.000
 CTP      "C4'"  "C3'"  "H3'"   108.340    3.000
 CTP      "C4'"  "C3'"  "O3'"   109.470    3.000
 CTP      "C4'"  "C3'"  "C2'"   111.000    3.000
 CTP      "H3'"  "C3'"  "O3'"   109.470    3.000
 CTP      "H3'"  "C3'"  "C2'"   108.340    3.000
 CTP      "O3'"  "C3'"  "C2'"   109.470    3.000
 CTP      "C3'"  "O3'"  "HO3'"  109.470    3.000
 CTP      "C3'"  "C2'"  "H2'"   108.340    3.000
 CTP      "C3'"  "C2'"  "O2'"   109.470    3.000
 CTP      "C3'"  "C2'"  "C1'"   111.000    3.000
 CTP      "H2'"  "C2'"  "O2'"   109.470    3.000
 CTP      "H2'"  "C2'"  "C1'"   108.340    3.000
 CTP      "O2'"  "C2'"  "C1'"   109.470    3.000
 CTP      "C2'"  "O2'"  "HO2'"  109.470    3.000
 CTP      "C4'"  "O4'"  "C1'"   111.800    3.000
 CTP      "O4'"  "C1'"  "H1'"   109.470    3.000
 CTP      "O4'"  "C1'"  N1      109.470    3.000
 CTP      "O4'"  "C1'"  "C2'"   109.470    3.000
 CTP      "H1'"  "C1'"  N1      109.470    3.000
 CTP      "H1'"  "C1'"  "C2'"   108.340    3.000
 CTP      N1     "C1'"  "C2'"   109.470    3.000
 CTP      "C1'"  N1     C6      120.000    3.000
 CTP      "C1'"  N1     C2      120.000    3.000
 CTP      C6     N1     C2      120.000    3.000
 CTP      N1     C6     H6      120.000    3.000
 CTP      N1     C6     C5      120.000    3.000
 CTP      H6     C6     C5      120.000    3.000
 CTP      C6     C5     H5      120.000    3.000
 CTP      C6     C5     C4      120.000    3.000
 CTP      H5     C5     C4      120.000    3.000
 CTP      C5     C4     N4      120.000    3.000
 CTP      C5     C4     N3      120.000    3.000
 CTP      N4     C4     N3      120.000    3.000
 CTP      C4     N4     HN42    120.000    3.000
 CTP      C4     N4     HN41    120.000    3.000
 CTP      HN42   N4     HN41    120.000    3.000
 CTP      C4     N3     C2      120.000    3.000
 CTP      N3     C2     O2      120.000    3.000
 CTP      N3     C2     N1      120.000    3.000
 CTP      O2     C2     N1      120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CTP      var_1    O3G    PG     O3B    PB       -60.092   20.000   1
 CTP      var_2    PG     O3B    PB     O3A      179.996   20.000   1
 CTP      var_3    O3B    PB     O3A    PA      -179.998   20.000   1
 CTP      var_4    PB     O3A    PA     "O5'"   -179.976   20.000   1
 CTP      var_5    O3A    PA     "O5'"  "C5'"   -179.957   20.000   1
 CTP      var_6    PA     "O5'"  "C5'"  "C4'"    179.996   20.000   1
 CTP      var_7    "O5'"  "C5'"  "C4'"  "O4'"     61.435   20.000   3
 CTP      var_8    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 CTP      var_9    "C4'"  "C3'"  "O3'"  "HO3'"  -179.989   20.000   1
 CTP      var_10   "C4'"  "C3'"  "C2'"  "O2'"   -120.000   20.000   3
 CTP      var_11   "C3'"  "C2'"  "O2'"  "HO2'"   -61.415   20.000   1
 CTP      var_12   "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 CTP      var_13   "C4'"  "O4'"  "C1'"  N1      -150.000   20.000   1
 CTP      var_14   "O4'"  "C1'"  "C2'"  "C3'"     30.000   20.000   3
 CTP      var_15   "O4'"  "C1'"  N1     C6      -122.984   20.000   1
 CTP      CONST_1  "C1'"  N1     C2     N3       180.000    0.000   0
 CTP      CONST_2  "C1'"  N1     C6     C5       180.000    0.000   0
 CTP      CONST_3  N1     C6     C5     C4         0.000    0.000   0
 CTP      CONST_4  C6     C5     C4     N3         0.000    0.000   0
 CTP      CONST_5  C5     C4     N4     HN41     179.724    0.000   0
 CTP      CONST_6  C5     C4     N3     C2         0.000    0.000   0
 CTP      CONST_7  C4     N3     C2     O2       180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 CTP      chir_01  "C1'"  N1     "C2'"  "O4'"     negativ
 CTP      chir_02  "C2'"  "C1'"  "O2'"  "C3'"     positiv
 CTP      chir_03  "C3'"  "C2'"  "C4'"  "O3'"     negativ
 CTP      chir_04  "C4'"  "C3'"  "O4'"  "C5'"     positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 CTP      plan-1    N1        0.020
 CTP      plan-1    C2        0.020
 CTP      plan-1    C6        0.020
 CTP      plan-1    "C1'"     0.020
 CTP      plan-1    N3        0.020
 CTP      plan-1    C4        0.020
 CTP      plan-1    C5        0.020
 CTP      plan-1    O2        0.020
 CTP      plan-1    N4        0.020
 CTP      plan-1    H5        0.020
 CTP      plan-1    H6        0.020
 CTP      plan-1    HN42      0.020
 CTP      plan-1    HN41      0.020
 CTP      plan-2    N4        0.020
 CTP      plan-2    C4        0.020
 CTP      plan-2    HN41      0.020
 CTP      plan-2    HN42      0.020
# ------------------------------------------------------
`.trim();

monomers["GMP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GMP      GMP 'GUANOSINE                           ' non-polymer        33  20 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GMP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GMP           O6     O    O         0.000      0.000    0.000    0.000
 GMP           C6     C    CR6       0.000     -1.109    0.455   -0.222
 GMP           N1     N    NR16      0.000     -1.262    1.726   -0.656
 GMP           HN1    H    H         0.000     -0.425    2.324   -0.808
 GMP           C2     C    CR6       0.000     -2.507    2.226   -0.896
 GMP           N2     N    NH2       0.000     -2.633    3.522   -1.330
 GMP           HN22   H    H         0.000     -1.810    4.098   -1.464
 GMP           HN21   H    H         0.000     -3.549    3.911   -1.518
 GMP           N3     N    NRD6      0.000     -3.591    1.501   -0.729
 GMP           C4     C    CR56      0.000     -3.517    0.233   -0.308
 GMP           C5     C    CR56      0.000     -2.267   -0.336   -0.039
 GMP           N7     N    NRD5      0.000     -2.485   -1.611    0.366
 GMP           C8     C    CR15      0.000     -3.763   -1.852    0.361
 GMP           H8     H    H         0.000     -4.220   -2.793    0.641
 GMP           N9     N    NR5       0.000     -4.442   -0.741   -0.048
 GMP           "C1'"  C    CH1       0.000     -5.895   -0.615   -0.184
 GMP           "H1'"  H    H         0.000     -6.145    0.045   -1.026
 GMP           "O4'"  O    O2        0.000     -6.498   -1.914   -0.367
 GMP           "C2'"  C    CH1       0.000     -6.513   -0.075    1.125
 GMP           "H2'"  H    H         0.000     -6.692    1.007    1.048
 GMP           "O2'"  O    OH1       0.000     -5.664   -0.365    2.237
 GMP           "HO2'" H    H         0.000     -6.094   -0.075    3.053
 GMP           "C3'"  C    CH1       0.000     -7.852   -0.837    1.250
 GMP           "H3'"  H    H         0.000     -8.697   -0.135    1.237
 GMP           "O3'"  O    OH1       0.000     -7.870   -1.621    2.445
 GMP           "HO3'" H    H         0.000     -8.686   -2.138    2.477
 GMP           "C4'"  C    CH1       0.000     -7.884   -1.747    0.004
 GMP           "H4'"  H    H         0.000     -8.442   -1.263   -0.810
 GMP           "C5'"  C    CH2       0.000     -8.510   -3.100    0.348
 GMP           "H5'1" H    H         0.000     -9.518   -2.945    0.737
 GMP           "H5'2" H    H         0.000     -7.902   -3.599    1.106
 GMP           "O5'"  O    OH1       0.000     -8.569   -3.910   -0.827
 GMP           "HO5'" H    H         0.000     -8.965   -4.765   -0.609
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GMP      O6     n/a    C6     START
 GMP      C6     O6     N1     .
 GMP      N1     C6     C2     .
 GMP      HN1    N1     .      .
 GMP      C2     N1     N3     .
 GMP      N2     C2     HN21   .
 GMP      HN22   N2     .      .
 GMP      HN21   N2     .      .
 GMP      N3     C2     C4     .
 GMP      C4     N3     N9     .
 GMP      C5     C4     N7     .
 GMP      N7     C5     C8     .
 GMP      C8     N7     H8     .
 GMP      H8     C8     .      .
 GMP      N9     C4     "C1'"  .
 GMP      "C1'"  N9     "C2'"  .
 GMP      "H1'"  "C1'"  .      .
 GMP      "O4'"  "C1'"  .      .
 GMP      "C2'"  "C1'"  "C3'"  .
 GMP      "H2'"  "C2'"  .      .
 GMP      "O2'"  "C2'"  "HO2'" .
 GMP      "HO2'" "O2'"  .      .
 GMP      "C3'"  "C2'"  "C4'"  .
 GMP      "H3'"  "C3'"  .      .
 GMP      "O3'"  "C3'"  "HO3'" .
 GMP      "HO3'" "O3'"  .      .
 GMP      "C4'"  "C3'"  "C5'"  .
 GMP      "H4'"  "C4'"  .      .
 GMP      "C5'"  "C4'"  "O5'"  .
 GMP      "H5'1" "C5'"  .      .
 GMP      "H5'2" "C5'"  .      .
 GMP      "O5'"  "C5'"  "HO5'" .
 GMP      "HO5'" "O5'"  .      END
 GMP      "C4'"  "O4'"  .    ADD
 GMP      N9     C8     .    ADD
 GMP      C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GMP      "O5'"  "C5'"     single      1.432    0.020
 GMP      "HO5'" "O5'"     single      0.967    0.020
 GMP      "C5'"  "C4'"     single      1.524    0.020
 GMP      "H5'1" "C5'"     single      1.092    0.020
 GMP      "H5'2" "C5'"     single      1.092    0.020
 GMP      "C4'"  "O4'"     single      1.426    0.020
 GMP      "C4'"  "C3'"     single      1.524    0.020
 GMP      "H4'"  "C4'"     single      1.099    0.020
 GMP      "O4'"  "C1'"     single      1.426    0.020
 GMP      "O3'"  "C3'"     single      1.432    0.020
 GMP      "C3'"  "C2'"     single      1.524    0.020
 GMP      "H3'"  "C3'"     single      1.099    0.020
 GMP      "HO3'" "O3'"     single      0.967    0.020
 GMP      "O2'"  "C2'"     single      1.432    0.020
 GMP      "C2'"  "C1'"     single      1.524    0.020
 GMP      "H2'"  "C2'"     single      1.099    0.020
 GMP      "HO2'" "O2'"     single      0.967    0.020
 GMP      "C1'"  N9        single      1.485    0.020
 GMP      "H1'"  "C1'"     single      1.099    0.020
 GMP      N9     C8        single      1.337    0.020
 GMP      N9     C4        single      1.337    0.020
 GMP      C8     N7        double      1.350    0.020
 GMP      H8     C8        single      1.083    0.020
 GMP      N7     C5        single      1.350    0.020
 GMP      C5     C6        single      1.490    0.020
 GMP      C5     C4        double      1.490    0.020
 GMP      C6     O6        double      1.250    0.020
 GMP      N1     C6        single      1.337    0.020
 GMP      C2     N1        single      1.337    0.020
 GMP      HN1    N1        single      1.040    0.020
 GMP      N2     C2        single      1.355    0.020
 GMP      N3     C2        double      1.350    0.020
 GMP      HN21   N2        single      1.010    0.020
 GMP      HN22   N2        single      1.010    0.020
 GMP      C4     N3        single      1.355    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GMP      O6     C6     N1      120.000    3.000
 GMP      O6     C6     C5      120.000    3.000
 GMP      N1     C6     C5      120.000    3.000
 GMP      C6     N1     HN1     120.000    3.000
 GMP      C6     N1     C2      120.000    3.000
 GMP      HN1    N1     C2      120.000    3.000
 GMP      N1     C2     N2      120.000    3.000
 GMP      N1     C2     N3      120.000    3.000
 GMP      N2     C2     N3      120.000    3.000
 GMP      C2     N2     HN22    120.000    3.000
 GMP      C2     N2     HN21    120.000    3.000
 GMP      HN22   N2     HN21    120.000    3.000
 GMP      C2     N3     C4      120.000    3.000
 GMP      N3     C4     C5      120.000    3.000
 GMP      N3     C4     N9      132.000    3.000
 GMP      C5     C4     N9      108.000    3.000
 GMP      C4     C5     N7      108.000    3.000
 GMP      C4     C5     C6      120.000    3.000
 GMP      N7     C5     C6      132.000    3.000
 GMP      C5     N7     C8      108.000    3.000
 GMP      N7     C8     H8      126.000    3.000
 GMP      N7     C8     N9      108.000    3.000
 GMP      H8     C8     N9      126.000    3.000
 GMP      C4     N9     "C1'"   126.000    3.000
 GMP      C4     N9     C8      108.000    3.000
 GMP      "C1'"  N9     C8      126.000    3.000
 GMP      N9     "C1'"  "H1'"   109.470    3.000
 GMP      N9     "C1'"  "O4'"   109.470    3.000
 GMP      N9     "C1'"  "C2'"   109.470    3.000
 GMP      "H1'"  "C1'"  "O4'"   109.470    3.000
 GMP      "H1'"  "C1'"  "C2'"   108.340    3.000
 GMP      "O4'"  "C1'"  "C2'"   109.470    3.000
 GMP      "C1'"  "O4'"  "C4'"   111.800    3.000
 GMP      "C1'"  "C2'"  "H2'"   108.340    3.000
 GMP      "C1'"  "C2'"  "O2'"   109.470    3.000
 GMP      "C1'"  "C2'"  "C3'"   111.000    3.000
 GMP      "H2'"  "C2'"  "O2'"   109.470    3.000
 GMP      "H2'"  "C2'"  "C3'"   108.340    3.000
 GMP      "O2'"  "C2'"  "C3'"   109.470    3.000
 GMP      "C2'"  "O2'"  "HO2'"  109.470    3.000
 GMP      "C2'"  "C3'"  "H3'"   108.340    3.000
 GMP      "C2'"  "C3'"  "O3'"   109.470    3.000
 GMP      "C2'"  "C3'"  "C4'"   111.000    3.000
 GMP      "H3'"  "C3'"  "O3'"   109.470    3.000
 GMP      "H3'"  "C3'"  "C4'"   108.340    3.000
 GMP      "O3'"  "C3'"  "C4'"   109.470    3.000
 GMP      "C3'"  "O3'"  "HO3'"  109.470    3.000
 GMP      "C3'"  "C4'"  "H4'"   108.340    3.000
 GMP      "C3'"  "C4'"  "C5'"   111.000    3.000
 GMP      "C3'"  "C4'"  "O4'"   109.470    3.000
 GMP      "H4'"  "C4'"  "C5'"   108.340    3.000
 GMP      "H4'"  "C4'"  "O4'"   109.470    3.000
 GMP      "C5'"  "C4'"  "O4'"   109.470    3.000
 GMP      "C4'"  "C5'"  "H5'1"  109.470    3.000
 GMP      "C4'"  "C5'"  "H5'2"  109.470    3.000
 GMP      "C4'"  "C5'"  "O5'"   109.470    3.000
 GMP      "H5'1" "C5'"  "H5'2"  107.900    3.000
 GMP      "H5'1" "C5'"  "O5'"   109.470    3.000
 GMP      "H5'2" "C5'"  "O5'"   109.470    3.000
 GMP      "C5'"  "O5'"  "HO5'"  109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GMP      CONST_1  O6     C6     N1     C2       180.000    0.000   0
 GMP      CONST_2  C6     N1     C2     N3         0.000    0.000   0
 GMP      CONST_3  N1     C2     N2     HN21     179.701    0.000   0
 GMP      CONST_4  N1     C2     N3     C4         0.000    0.000   0
 GMP      CONST_5  C2     N3     C4     N9       180.000    0.000   0
 GMP      CONST_6  N3     C4     C5     N7       180.000    0.000   0
 GMP      CONST_7  C4     C5     C6     O6       180.000    0.000   0
 GMP      CONST_8  C4     C5     N7     C8         0.000    0.000   0
 GMP      CONST_9  C5     N7     C8     N9         0.000    0.000   0
 GMP      CONST_10 N3     C4     N9     "C1'"      0.000    0.000   0
 GMP      CONST_11 C4     N9     C8     N7         0.000    0.000   0
 GMP      var_1    C4     N9     "C1'"  "C2'"    -88.219   20.000   1
 GMP      var_2    N9     "C1'"  "O4'"  "C4'"    150.000   20.000   1
 GMP      var_3    N9     "C1'"  "C2'"  "C3'"   -150.000   20.000   3
 GMP      var_4    "C1'"  "C2'"  "O2'"  "HO2'"  -176.126   20.000   1
 GMP      var_5    "C1'"  "C2'"  "C3'"  "C4'"      0.000   20.000   3
 GMP      var_6    "C2'"  "C3'"  "O3'"  "HO3'"  -176.082   20.000   1
 GMP      var_7    "C2'"  "C3'"  "C4'"  "C5'"    150.000   20.000   3
 GMP      var_8    "C3'"  "C4'"  "O4'"  "C1'"    -30.000   20.000   1
 GMP      var_9    "C3'"  "C4'"  "C5'"  "O5'"    178.128   20.000   3
 GMP      var_10   "C4'"  "C5'"  "O5'"  "HO5'"   179.996   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 GMP      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     positiv
 GMP      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 GMP      chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 GMP      chir_04  "C1'"  "O4'"  "C2'"  N9        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 GMP      plan-1    N9        0.020
 GMP      plan-1    "C1'"     0.020
 GMP      plan-1    C8        0.020
 GMP      plan-1    C4        0.020
 GMP      plan-1    N7        0.020
 GMP      plan-1    H8        0.020
 GMP      plan-1    C5        0.020
 GMP      plan-1    C6        0.020
 GMP      plan-1    N1        0.020
 GMP      plan-1    C2        0.020
 GMP      plan-1    N3        0.020
 GMP      plan-1    O6        0.020
 GMP      plan-1    HN1       0.020
 GMP      plan-1    N2        0.020
 GMP      plan-1    HN22      0.020
 GMP      plan-1    HN21      0.020
 GMP      plan-2    N2        0.020
 GMP      plan-2    C2        0.020
 GMP      plan-2    HN21      0.020
 GMP      plan-2    HN22      0.020
# ------------------------------------------------------
`.trim();

monomers["GDP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GDP      GDP 'GUANOSINE-5'-DIPHOSPHATE            ' non-polymer        40  28 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GDP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GDP           O6     O    O         0.000      0.000    0.000    0.000
 GDP           C6     C    CR6       0.000     -0.765   -0.444    0.839
 GDP           N1     N    NR16      0.000     -0.325   -1.281    1.803
 GDP           HN1    H    H         0.000      0.680   -1.550    1.836
 GDP           C2     C    CR6       0.000     -1.190   -1.776    2.732
 GDP           N2     N    NH2       0.000     -0.715   -2.630    3.695
 GDP           HN22   H    H         0.000      0.264   -2.890    3.711
 GDP           HN21   H    H         0.000     -1.341   -3.006    4.398
 GDP           N3     N    NRD6      0.000     -2.464   -1.456    2.734
 GDP           C4     C    CR56      0.000     -2.972   -0.628    1.814
 GDP           C5     C    CR56      0.000     -2.135   -0.091    0.830
 GDP           N7     N    NRD5      0.000     -2.900    0.703    0.041
 GDP           C8     C    CR15      0.000     -4.127    0.684    0.472
 GDP           H8     H    H         0.000     -4.951    1.229    0.029
 GDP           N9     N    NR5       0.000     -4.220   -0.126    1.567
 GDP           "C1'"  C    CH1       0.000     -5.433   -0.404    2.337
 GDP           "H1'"  H    H         0.000     -5.391   -1.415    2.765
 GDP           "O4'"  O    O2        0.000     -6.603   -0.261    1.501
 GDP           "C2'"  C    CH1       0.000     -5.615    0.645    3.456
 GDP           "H2'"  H    H         0.000     -5.094    1.577    3.196
 GDP           "O2'"  O    OH1       0.000     -5.143    0.141    4.706
 GDP           "HO2'" H    H         0.000     -5.320    0.788    5.402
 GDP           "C3'"  C    CH1       0.000     -7.143    0.878    3.507
 GDP           "H3'"  H    H         0.000     -7.382    1.924    3.272
 GDP           "O3'"  O    OH1       0.000     -7.661    0.520    4.790
 GDP           "HO3'" H    H         0.000     -7.302    1.117    5.460
 GDP           "C4'"  C    CH1       0.000     -7.702   -0.063    2.417
 GDP           "H4'"  H    H         0.000     -8.010   -1.020    2.859
 GDP           "C5'"  C    CH2       0.000     -8.881    0.595    1.698
 GDP           "H5'"  H    H         0.000     -8.562    1.552    1.278
 GDP           "H5''" H    H         0.000     -9.693    0.763    2.409
 GDP           "O5'"  O    O2        0.000     -9.335   -0.260    0.646
 GDP           PA     P    P         0.000    -10.570    0.489   -0.063
 GDP           O1A    O    OP       -0.500    -10.112    1.791   -0.606
 GDP           O2A    O    OP       -0.500    -11.647    0.720    0.930
 GDP           O3A    O    O2        0.000    -11.134   -0.422   -1.263
 GDP           PB     P    P         0.000    -12.360    0.385   -1.926
 GDP           O1B    O    OP       -0.666    -11.864    1.714   -2.450
 GDP           O2B    O    OP       -0.666    -12.939   -0.423   -3.067
 GDP           O3B    O    OP       -0.666    -13.430    0.622   -0.882
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GDP      O6     n/a    C6     START
 GDP      C6     O6     N1     .
 GDP      N1     C6     C2     .
 GDP      HN1    N1     .      .
 GDP      C2     N1     N3     .
 GDP      N2     C2     HN21   .
 GDP      HN22   N2     .      .
 GDP      HN21   N2     .      .
 GDP      N3     C2     C4     .
 GDP      C4     N3     N9     .
 GDP      C5     C4     N7     .
 GDP      N7     C5     C8     .
 GDP      C8     N7     H8     .
 GDP      H8     C8     .      .
 GDP      N9     C4     "C1'"  .
 GDP      "C1'"  N9     "C2'"  .
 GDP      "H1'"  "C1'"  .      .
 GDP      "O4'"  "C1'"  .      .
 GDP      "C2'"  "C1'"  "C3'"  .
 GDP      "H2'"  "C2'"  .      .
 GDP      "O2'"  "C2'"  "HO2'" .
 GDP      "HO2'" "O2'"  .      .
 GDP      "C3'"  "C2'"  "C4'"  .
 GDP      "H3'"  "C3'"  .      .
 GDP      "O3'"  "C3'"  "HO3'" .
 GDP      "HO3'" "O3'"  .      .
 GDP      "C4'"  "C3'"  "C5'"  .
 GDP      "H4'"  "C4'"  .      .
 GDP      "C5'"  "C4'"  "O5'"  .
 GDP      "H5'"  "C5'"  .      .
 GDP      "H5''" "C5'"  .      .
 GDP      "O5'"  "C5'"  PA     .
 GDP      PA     "O5'"  O3A    .
 GDP      O1A    PA     .      .
 GDP      O2A    PA     .      .
 GDP      O3A    PA     PB     .
 GDP      PB     O3A    O3B    .
 GDP      O1B    PB     .      .
 GDP      O2B    PB     .      .
 GDP      O3B    PB     .      END
 GDP      "C4'"  "O4'"  .    ADD
 GDP      N9     C8     .    ADD
 GDP      C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GDP      O1B    PB        deloc       1.510    0.020
 GDP      O2B    PB        deloc       1.510    0.020
 GDP      O3B    PB        deloc       1.510    0.020
 GDP      PB     O3A       single      1.610    0.020
 GDP      O3A    PA        single      1.610    0.020
 GDP      O1A    PA        deloc       1.510    0.020
 GDP      O2A    PA        deloc       1.510    0.020
 GDP      PA     "O5'"     single      1.610    0.020
 GDP      "O5'"  "C5'"     single      1.426    0.020
 GDP      "C5'"  "C4'"     single      1.524    0.020
 GDP      "H5'"  "C5'"     single      1.092    0.020
 GDP      "H5''" "C5'"     single      1.092    0.020
 GDP      "C4'"  "O4'"     single      1.426    0.020
 GDP      "C4'"  "C3'"     single      1.524    0.020
 GDP      "H4'"  "C4'"     single      1.099    0.020
 GDP      "O4'"  "C1'"     single      1.426    0.020
 GDP      "O3'"  "C3'"     single      1.432    0.020
 GDP      "C3'"  "C2'"     single      1.524    0.020
 GDP      "H3'"  "C3'"     single      1.099    0.020
 GDP      "HO3'" "O3'"     single      0.967    0.020
 GDP      "O2'"  "C2'"     single      1.432    0.020
 GDP      "C2'"  "C1'"     single      1.524    0.020
 GDP      "H2'"  "C2'"     single      1.099    0.020
 GDP      "HO2'" "O2'"     single      0.967    0.020
 GDP      "C1'"  N9        single      1.485    0.020
 GDP      "H1'"  "C1'"     single      1.099    0.020
 GDP      N9     C8        single      1.337    0.020
 GDP      N9     C4        single      1.337    0.020
 GDP      C8     N7        double      1.350    0.020
 GDP      H8     C8        single      1.083    0.020
 GDP      N7     C5        single      1.350    0.020
 GDP      C5     C6        single      1.490    0.020
 GDP      C5     C4        double      1.490    0.020
 GDP      C6     O6        double      1.250    0.020
 GDP      N1     C6        single      1.337    0.020
 GDP      C2     N1        single      1.337    0.020
 GDP      HN1    N1        single      1.040    0.020
 GDP      N2     C2        single      1.355    0.020
 GDP      N3     C2        double      1.350    0.020
 GDP      HN21   N2        single      1.010    0.020
 GDP      HN22   N2        single      1.010    0.020
 GDP      C4     N3        single      1.355    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GDP      O6     C6     N1      120.000    3.000
 GDP      O6     C6     C5      120.000    3.000
 GDP      N1     C6     C5      120.000    3.000
 GDP      C6     N1     HN1     120.000    3.000
 GDP      C6     N1     C2      120.000    3.000
 GDP      HN1    N1     C2      120.000    3.000
 GDP      N1     C2     N2      120.000    3.000
 GDP      N1     C2     N3      120.000    3.000
 GDP      N2     C2     N3      120.000    3.000
 GDP      C2     N2     HN22    120.000    3.000
 GDP      C2     N2     HN21    120.000    3.000
 GDP      HN22   N2     HN21    120.000    3.000
 GDP      C2     N3     C4      120.000    3.000
 GDP      N3     C4     C5      120.000    3.000
 GDP      N3     C4     N9      132.000    3.000
 GDP      C5     C4     N9      108.000    3.000
 GDP      C4     C5     N7      108.000    3.000
 GDP      C4     C5     C6      120.000    3.000
 GDP      N7     C5     C6      132.000    3.000
 GDP      C5     N7     C8      108.000    3.000
 GDP      N7     C8     H8      126.000    3.000
 GDP      N7     C8     N9      108.000    3.000
 GDP      H8     C8     N9      126.000    3.000
 GDP      C4     N9     "C1'"   126.000    3.000
 GDP      C4     N9     C8      108.000    3.000
 GDP      "C1'"  N9     C8      126.000    3.000
 GDP      N9     "C1'"  "H1'"   109.470    3.000
 GDP      N9     "C1'"  "O4'"   109.470    3.000
 GDP      N9     "C1'"  "C2'"   109.470    3.000
 GDP      "H1'"  "C1'"  "O4'"   109.470    3.000
 GDP      "H1'"  "C1'"  "C2'"   108.340    3.000
 GDP      "O4'"  "C1'"  "C2'"   109.470    3.000
 GDP      "C1'"  "O4'"  "C4'"   111.800    3.000
 GDP      "C1'"  "C2'"  "H2'"   108.340    3.000
 GDP      "C1'"  "C2'"  "O2'"   109.470    3.000
 GDP      "C1'"  "C2'"  "C3'"   111.000    3.000
 GDP      "H2'"  "C2'"  "O2'"   109.470    3.000
 GDP      "H2'"  "C2'"  "C3'"   108.340    3.000
 GDP      "O2'"  "C2'"  "C3'"   109.470    3.000
 GDP      "C2'"  "O2'"  "HO2'"  109.470    3.000
 GDP      "C2'"  "C3'"  "H3'"   108.340    3.000
 GDP      "C2'"  "C3'"  "O3'"   109.470    3.000
 GDP      "C2'"  "C3'"  "C4'"   111.000    3.000
 GDP      "H3'"  "C3'"  "O3'"   109.470    3.000
 GDP      "H3'"  "C3'"  "C4'"   108.340    3.000
 GDP      "O3'"  "C3'"  "C4'"   109.470    3.000
 GDP      "C3'"  "O3'"  "HO3'"  109.470    3.000
 GDP      "C3'"  "C4'"  "H4'"   108.340    3.000
 GDP      "C3'"  "C4'"  "C5'"   111.000    3.000
 GDP      "C3'"  "C4'"  "O4'"   109.470    3.000
 GDP      "H4'"  "C4'"  "C5'"   108.340    3.000
 GDP      "H4'"  "C4'"  "O4'"   109.470    3.000
 GDP      "C5'"  "C4'"  "O4'"   109.470    3.000
 GDP      "C4'"  "C5'"  "H5'"   109.470    3.000
 GDP      "C4'"  "C5'"  "H5''"  109.470    3.000
 GDP      "C4'"  "C5'"  "O5'"   109.470    3.000
 GDP      "H5'"  "C5'"  "H5''"  107.900    3.000
 GDP      "H5'"  "C5'"  "O5'"   109.470    3.000
 GDP      "H5''" "C5'"  "O5'"   109.470    3.000
 GDP      "C5'"  "O5'"  PA      120.500    3.000
 GDP      "O5'"  PA     O1A     108.200    3.000
 GDP      "O5'"  PA     O2A     108.200    3.000
 GDP      "O5'"  PA     O3A     102.600    3.000
 GDP      O1A    PA     O2A     119.900    3.000
 GDP      O1A    PA     O3A     108.200    3.000
 GDP      O2A    PA     O3A     108.200    3.000
 GDP      PA     O3A    PB      120.500    3.000
 GDP      O3A    PB     O1B     108.200    3.000
 GDP      O3A    PB     O2B     108.200    3.000
 GDP      O3A    PB     O3B     108.200    3.000
 GDP      O1B    PB     O2B     119.900    3.000
 GDP      O1B    PB     O3B     119.900    3.000
 GDP      O2B    PB     O3B     119.900    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GDP      CONST_1  O6     C6     N1     C2       180.000    0.000   0
 GDP      CONST_2  C6     N1     C2     N3         0.000    0.000   0
 GDP      CONST_3  N1     C2     N2     HN21     179.765    0.000   0
 GDP      CONST_4  N1     C2     N3     C4         0.000    0.000   0
 GDP      CONST_5  C2     N3     C4     N9       180.000    0.000   0
 GDP      CONST_6  N3     C4     C5     N7       180.000    0.000   0
 GDP      CONST_7  C4     C5     C6     O6       180.000    0.000   0
 GDP      CONST_8  C4     C5     N7     C8         0.000    0.000   0
 GDP      CONST_9  C5     N7     C8     N9         0.000    0.000   0
 GDP      CONST_10 N3     C4     N9     "C1'"      0.000    0.000   0
 GDP      CONST_11 C4     N9     C8     N7         0.000    0.000   0
 GDP      var_1    C4     N9     "C1'"  "C2'"     91.462   20.000   1
 GDP      var_2    N9     "C1'"  "O4'"  "C4'"   -150.000   20.000   1
 GDP      var_3    N9     "C1'"  "C2'"  "C3'"    150.000   20.000   3
 GDP      var_4    "C1'"  "C2'"  "O2'"  "HO2'"  -176.232   20.000   1
 GDP      var_5    "C1'"  "C2'"  "C3'"  "C4'"      0.000   20.000   3
 GDP      var_6    "C2'"  "C3'"  "O3'"  "HO3'"    65.353   20.000   1
 GDP      var_7    "C2'"  "C3'"  "C4'"  "C5'"   -150.000   20.000   3
 GDP      var_8    "C3'"  "C4'"  "O4'"  "C1'"     30.000   20.000   1
 GDP      var_9    "C3'"  "C4'"  "C5'"  "O5'"    176.854   20.000   3
 GDP      var_10   "C4'"  "C5'"  "O5'"  PA       179.952   20.000   1
 GDP      var_11   "C5'"  "O5'"  PA     O3A     -179.993   20.000   1
 GDP      var_12   "O5'"  PA     O3A    PB      -179.945   20.000   1
 GDP      var_13   PA     O3A    PB     O3B      -59.968   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 GDP      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 GDP      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 GDP      chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 GDP      chir_04  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 GDP      plan-1    N9        0.020
 GDP      plan-1    "C1'"     0.020
 GDP      plan-1    C8        0.020
 GDP      plan-1    C4        0.020
 GDP      plan-1    N7        0.020
 GDP      plan-1    H8        0.020
 GDP      plan-1    C5        0.020
 GDP      plan-1    C6        0.020
 GDP      plan-1    N1        0.020
 GDP      plan-1    C2        0.020
 GDP      plan-1    N3        0.020
 GDP      plan-1    O6        0.020
 GDP      plan-1    HN1       0.020
 GDP      plan-1    N2        0.020
 GDP      plan-1    HN22      0.020
 GDP      plan-1    HN21      0.020
 GDP      plan-2    N2        0.020
 GDP      plan-2    C2        0.020
 GDP      plan-2    HN21      0.020
 GDP      plan-2    HN22      0.020
# ------------------------------------------------------
`.trim();

monomers["GTP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GTP      GTP 'GUANOSINE-5'-TRIPHOSPHATE           ' non-polymer        44  32 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GTP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GTP           O6     O    O         0.000      0.000    0.000    0.000
 GTP           C6     C    CR6       0.000     -0.686   -0.495    0.878
 GTP           N1     N    NR16      0.000     -0.158   -1.380    1.753
 GTP           HN1    H    H         0.000      0.847   -1.641    1.683
 GTP           C2     C    CR6       0.000     -0.935   -1.932    2.726
 GTP           N2     N    NH2       0.000     -0.374   -2.833    3.597
 GTP           HN22   H    H         0.000      0.603   -3.086    3.511
 GTP           HN21   H    H         0.000     -0.933   -3.251    4.330
 GTP           N3     N    NRD6      0.000     -2.206   -1.622    2.860
 GTP           C4     C    CR56      0.000     -2.795   -0.749    2.036
 GTP           C5     C    CR56      0.000     -2.051   -0.154    1.011
 GTP           N7     N    NRD5      0.000     -2.887    0.676    0.338
 GTP           C8     C    CR15      0.000     -4.070    0.625    0.876
 GTP           H8     H    H         0.000     -4.932    1.187    0.539
 GTP           N9     N    NR5       0.000     -4.062   -0.244    1.930
 GTP           "C1'"  C    CH1       0.000     -5.201   -0.573    2.787
 GTP           "H1'"  H    H         0.000     -5.117   -1.606    3.154
 GTP           "O4'"  O    O2        0.000     -6.441   -0.395    2.068
 GTP           "C2'"  C    CH1       0.000     -5.285    0.412    3.973
 GTP           "H2'"  H    H         0.000     -4.792    1.361    3.720
 GTP           "O2'"  O    OH1       0.000     -4.701   -0.156    5.147
 GTP           "HO2'" H    H         0.000     -4.818    0.451    5.891
 GTP           "C3'"  C    CH1       0.000     -6.804    0.628    4.174
 GTP           "H3'"  H    H         0.000     -7.066    1.684    4.020
 GTP           "O3'"  O    OH1       0.000     -7.204    0.198    5.476
 GTP           "HO3'" H    H         0.000     -6.787    0.761    6.142
 GTP           "C4'"  C    CH1       0.000     -7.456   -0.255    3.087
 GTP           "H4'"  H    H         0.000     -7.720   -1.238    3.501
 GTP           "C5'"  C    CH2       0.000     -8.696    0.431    2.513
 GTP           "H5'"  H    H         0.000     -8.420    1.412    2.120
 GTP           "H5''" H    H         0.000     -9.441    0.552    3.302
 GTP           "O5'"  O    O2        0.000     -9.239   -0.369    1.461
 GTP           PA     P    P         0.000    -10.535    0.408    0.907
 GTP           O1A    O    OP       -0.500    -10.131    1.741    0.397
 GTP           O2A    O    OP       -0.500    -11.519    0.576    2.004
 GTP           O3A    O    O2        0.000    -11.201   -0.442   -0.286
 GTP           PB     P    P         0.000    -12.484    0.390   -0.791
 GTP           O1B    O    OP       -0.500    -12.049    1.723   -1.275
 GTP           O2B    O    OP       -0.500    -13.437    0.558    0.332
 GTP           O3B    O    O2        0.000    -13.203   -0.407   -1.990
 GTP           PG     P    P         0.000    -14.469    0.476   -2.444
 GTP           O1G    O    OP       -0.666    -13.995    1.835   -2.911
 GTP           O2G    O    OP       -0.666    -15.193   -0.222   -3.575
 GTP           O3G    O    OP       -0.666    -15.411    0.647   -1.272
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GTP      O6     n/a    C6     START
 GTP      C6     O6     N1     .
 GTP      N1     C6     C2     .
 GTP      HN1    N1     .      .
 GTP      C2     N1     N3     .
 GTP      N2     C2     HN21   .
 GTP      HN22   N2     .      .
 GTP      HN21   N2     .      .
 GTP      N3     C2     C4     .
 GTP      C4     N3     N9     .
 GTP      C5     C4     N7     .
 GTP      N7     C5     C8     .
 GTP      C8     N7     H8     .
 GTP      H8     C8     .      .
 GTP      N9     C4     "C1'"  .
 GTP      "C1'"  N9     "C2'"  .
 GTP      "H1'"  "C1'"  .      .
 GTP      "O4'"  "C1'"  .      .
 GTP      "C2'"  "C1'"  "C3'"  .
 GTP      "H2'"  "C2'"  .      .
 GTP      "O2'"  "C2'"  "HO2'" .
 GTP      "HO2'" "O2'"  .      .
 GTP      "C3'"  "C2'"  "C4'"  .
 GTP      "H3'"  "C3'"  .      .
 GTP      "O3'"  "C3'"  "HO3'" .
 GTP      "HO3'" "O3'"  .      .
 GTP      "C4'"  "C3'"  "C5'"  .
 GTP      "H4'"  "C4'"  .      .
 GTP      "C5'"  "C4'"  "O5'"  .
 GTP      "H5'"  "C5'"  .      .
 GTP      "H5''" "C5'"  .      .
 GTP      "O5'"  "C5'"  PA     .
 GTP      PA     "O5'"  O3A    .
 GTP      O1A    PA     .      .
 GTP      O2A    PA     .      .
 GTP      O3A    PA     PB     .
 GTP      PB     O3A    O3B    .
 GTP      O1B    PB     .      .
 GTP      O2B    PB     .      .
 GTP      O3B    PB     PG     .
 GTP      PG     O3B    O3G    .
 GTP      O1G    PG     .      .
 GTP      O2G    PG     .      .
 GTP      O3G    PG     .      END
 GTP      "C4'"  "O4'"  .    ADD
 GTP      N9     C8     .    ADD
 GTP      C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GTP      O1G    PG        deloc       1.510    0.020
 GTP      O2G    PG        deloc       1.510    0.020
 GTP      O3G    PG        deloc       1.510    0.020
 GTP      PG     O3B       single      1.610    0.020
 GTP      O3B    PB        single      1.610    0.020
 GTP      O1B    PB        deloc       1.510    0.020
 GTP      O2B    PB        deloc       1.510    0.020
 GTP      PB     O3A       single      1.610    0.020
 GTP      O3A    PA        single      1.610    0.020
 GTP      O1A    PA        deloc       1.510    0.020
 GTP      O2A    PA        deloc       1.510    0.020
 GTP      PA     "O5'"     single      1.610    0.020
 GTP      "O5'"  "C5'"     single      1.426    0.020
 GTP      "C5'"  "C4'"     single      1.524    0.020
 GTP      "H5'"  "C5'"     single      1.092    0.020
 GTP      "H5''" "C5'"     single      1.092    0.020
 GTP      "C4'"  "O4'"     single      1.426    0.020
 GTP      "C4'"  "C3'"     single      1.524    0.020
 GTP      "H4'"  "C4'"     single      1.099    0.020
 GTP      "O4'"  "C1'"     single      1.426    0.020
 GTP      "O3'"  "C3'"     single      1.432    0.020
 GTP      "C3'"  "C2'"     single      1.524    0.020
 GTP      "H3'"  "C3'"     single      1.099    0.020
 GTP      "HO3'" "O3'"     single      0.967    0.020
 GTP      "O2'"  "C2'"     single      1.432    0.020
 GTP      "C2'"  "C1'"     single      1.524    0.020
 GTP      "H2'"  "C2'"     single      1.099    0.020
 GTP      "HO2'" "O2'"     single      0.967    0.020
 GTP      "C1'"  N9        single      1.485    0.020
 GTP      "H1'"  "C1'"     single      1.099    0.020
 GTP      N9     C8        single      1.337    0.020
 GTP      N9     C4        single      1.337    0.020
 GTP      C8     N7        double      1.350    0.020
 GTP      H8     C8        single      1.083    0.020
 GTP      N7     C5        single      1.350    0.020
 GTP      C5     C6        single      1.490    0.020
 GTP      C5     C4        double      1.490    0.020
 GTP      C6     O6        double      1.250    0.020
 GTP      N1     C6        single      1.337    0.020
 GTP      C2     N1        single      1.337    0.020
 GTP      HN1    N1        single      1.040    0.020
 GTP      N2     C2        single      1.355    0.020
 GTP      N3     C2        double      1.350    0.020
 GTP      HN21   N2        single      1.010    0.020
 GTP      HN22   N2        single      1.010    0.020
 GTP      C4     N3        single      1.355    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GTP      O6     C6     N1      120.000    3.000
 GTP      O6     C6     C5      120.000    3.000
 GTP      N1     C6     C5      120.000    3.000
 GTP      C6     N1     HN1     120.000    3.000
 GTP      C6     N1     C2      120.000    3.000
 GTP      HN1    N1     C2      120.000    3.000
 GTP      N1     C2     N2      120.000    3.000
 GTP      N1     C2     N3      120.000    3.000
 GTP      N2     C2     N3      120.000    3.000
 GTP      C2     N2     HN22    120.000    3.000
 GTP      C2     N2     HN21    120.000    3.000
 GTP      HN22   N2     HN21    120.000    3.000
 GTP      C2     N3     C4      120.000    3.000
 GTP      N3     C4     C5      120.000    3.000
 GTP      N3     C4     N9      132.000    3.000
 GTP      C5     C4     N9      108.000    3.000
 GTP      C4     C5     N7      108.000    3.000
 GTP      C4     C5     C6      120.000    3.000
 GTP      N7     C5     C6      132.000    3.000
 GTP      C5     N7     C8      108.000    3.000
 GTP      N7     C8     H8      126.000    3.000
 GTP      N7     C8     N9      108.000    3.000
 GTP      H8     C8     N9      126.000    3.000
 GTP      C4     N9     "C1'"   126.000    3.000
 GTP      C4     N9     C8      108.000    3.000
 GTP      "C1'"  N9     C8      126.000    3.000
 GTP      N9     "C1'"  "H1'"   109.470    3.000
 GTP      N9     "C1'"  "O4'"   109.470    3.000
 GTP      N9     "C1'"  "C2'"   109.470    3.000
 GTP      "H1'"  "C1'"  "O4'"   109.470    3.000
 GTP      "H1'"  "C1'"  "C2'"   108.340    3.000
 GTP      "O4'"  "C1'"  "C2'"   109.470    3.000
 GTP      "C1'"  "O4'"  "C4'"   111.800    3.000
 GTP      "C1'"  "C2'"  "H2'"   108.340    3.000
 GTP      "C1'"  "C2'"  "O2'"   109.470    3.000
 GTP      "C1'"  "C2'"  "C3'"   111.000    3.000
 GTP      "H2'"  "C2'"  "O2'"   109.470    3.000
 GTP      "H2'"  "C2'"  "C3'"   108.340    3.000
 GTP      "O2'"  "C2'"  "C3'"   109.470    3.000
 GTP      "C2'"  "O2'"  "HO2'"  109.470    3.000
 GTP      "C2'"  "C3'"  "H3'"   108.340    3.000
 GTP      "C2'"  "C3'"  "O3'"   109.470    3.000
 GTP      "C2'"  "C3'"  "C4'"   111.000    3.000
 GTP      "H3'"  "C3'"  "O3'"   109.470    3.000
 GTP      "H3'"  "C3'"  "C4'"   108.340    3.000
 GTP      "O3'"  "C3'"  "C4'"   109.470    3.000
 GTP      "C3'"  "O3'"  "HO3'"  109.470    3.000
 GTP      "C3'"  "C4'"  "H4'"   108.340    3.000
 GTP      "C3'"  "C4'"  "C5'"   111.000    3.000
 GTP      "C3'"  "C4'"  "O4'"   109.470    3.000
 GTP      "H4'"  "C4'"  "C5'"   108.340    3.000
 GTP      "H4'"  "C4'"  "O4'"   109.470    3.000
 GTP      "C5'"  "C4'"  "O4'"   109.470    3.000
 GTP      "C4'"  "C5'"  "H5'"   109.470    3.000
 GTP      "C4'"  "C5'"  "H5''"  109.470    3.000
 GTP      "C4'"  "C5'"  "O5'"   109.470    3.000
 GTP      "H5'"  "C5'"  "H5''"  107.900    3.000
 GTP      "H5'"  "C5'"  "O5'"   109.470    3.000
 GTP      "H5''" "C5'"  "O5'"   109.470    3.000
 GTP      "C5'"  "O5'"  PA      120.500    3.000
 GTP      "O5'"  PA     O1A     108.200    3.000
 GTP      "O5'"  PA     O2A     108.200    3.000
 GTP      "O5'"  PA     O3A     102.600    3.000
 GTP      O1A    PA     O2A     119.900    3.000
 GTP      O1A    PA     O3A     108.200    3.000
 GTP      O2A    PA     O3A     108.200    3.000
 GTP      PA     O3A    PB      120.500    3.000
 GTP      O3A    PB     O1B     108.200    3.000
 GTP      O3A    PB     O2B     108.200    3.000
 GTP      O3A    PB     O3B     102.600    3.000
 GTP      O1B    PB     O2B     119.900    3.000
 GTP      O1B    PB     O3B     108.200    3.000
 GTP      O2B    PB     O3B     108.200    3.000
 GTP      PB     O3B    PG      120.500    3.000
 GTP      O3B    PG     O1G     108.200    3.000
 GTP      O3B    PG     O2G     108.200    3.000
 GTP      O3B    PG     O3G     108.200    3.000
 GTP      O1G    PG     O2G     119.900    3.000
 GTP      O1G    PG     O3G     119.900    3.000
 GTP      O2G    PG     O3G     119.900    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GTP      CONST_1  O6     C6     N1     C2       180.000    0.000   0
 GTP      CONST_2  C6     N1     C2     N3         0.000    0.000   0
 GTP      CONST_3  N1     C2     N2     HN21     179.672    0.000   0
 GTP      CONST_4  N1     C2     N3     C4         0.000    0.000   0
 GTP      CONST_5  C2     N3     C4     N9       180.000    0.000   0
 GTP      CONST_6  N3     C4     C5     N7       180.000    0.000   0
 GTP      CONST_7  C4     C5     C6     O6       180.000    0.000   0
 GTP      CONST_8  C4     C5     N7     C8         0.000    0.000   0
 GTP      CONST_9  C5     N7     C8     N9         0.000    0.000   0
 GTP      CONST_10 N3     C4     N9     "C1'"      0.000    0.000   0
 GTP      CONST_11 C4     N9     C8     N7         0.000    0.000   0
 GTP      var_1    C4     N9     "C1'"  "C2'"     91.485   20.000   1
 GTP      var_2    N9     "C1'"  "O4'"  "C4'"   -150.000   20.000   1
 GTP      var_3    N9     "C1'"  "C2'"  "C3'"    150.000   20.000   3
 GTP      var_4    "C1'"  "C2'"  "O2'"  "HO2'"  -176.151   20.000   1
 GTP      var_5    "C1'"  "C2'"  "C3'"  "C4'"      0.000   20.000   3
 GTP      var_6    "C2'"  "C3'"  "O3'"  "HO3'"    65.296   20.000   1
 GTP      var_7    "C2'"  "C3'"  "C4'"  "C5'"   -150.000   20.000   3
 GTP      var_8    "C3'"  "C4'"  "O4'"  "C1'"     30.000   20.000   1
 GTP      var_9    "C3'"  "C4'"  "C5'"  "O5'"    176.894   20.000   3
 GTP      var_10   "C4'"  "C5'"  "O5'"  PA       179.994   20.000   1
 GTP      var_11   "C5'"  "O5'"  PA     O3A     -179.978   20.000   1
 GTP      var_12   "O5'"  PA     O3A    PB      -179.962   20.000   1
 GTP      var_13   PA     O3A    PB     O3B     -179.956   20.000   1
 GTP      var_14   O3A    PB     O3B    PG      -179.994   20.000   1
 GTP      var_15   PB     O3B    PG     O3G      -59.996   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 GTP      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 GTP      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 GTP      chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 GTP      chir_04  "C1'"  "O4'"  "C2'"  N9        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 GTP      plan-1    N9        0.020
 GTP      plan-1    "C1'"     0.020
 GTP      plan-1    C8        0.020
 GTP      plan-1    C4        0.020
 GTP      plan-1    N7        0.020
 GTP      plan-1    H8        0.020
 GTP      plan-1    C5        0.020
 GTP      plan-1    C6        0.020
 GTP      plan-1    N1        0.020
 GTP      plan-1    C2        0.020
 GTP      plan-1    N3        0.020
 GTP      plan-1    O6        0.020
 GTP      plan-1    HN1       0.020
 GTP      plan-1    N2        0.020
 GTP      plan-1    HN22      0.020
 GTP      plan-1    HN21      0.020
 GTP      plan-2    N2        0.020
 GTP      plan-2    C2        0.020
 GTP      plan-2    HN21      0.020
 GTP      plan-2    HN22      0.020
# ------------------------------------------------------
`.trim();

monomers["TMP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TMP      TMP 'THYMIDINE-5'-PHOSPHATE              ' non-polymer        34  21 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TMP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TMP           O4     O    O         0.000      0.000    0.000    0.000
 TMP           C4     C    CR6       0.000     -1.127   -0.370   -0.275
 TMP           N3     N    NR16      0.000     -2.118   -0.263    0.632
 TMP           HN3    H    H         0.000     -1.920    0.136    1.571
 TMP           C2     C    CR6       0.000     -3.364   -0.672    0.327
 TMP           O2     O    O         0.000     -4.248   -0.573    1.157
 TMP           C5     C    CR6       0.000     -1.410   -0.908   -1.554
 TMP           C5M    C    CH3       0.000     -0.320   -1.034   -2.587
 TMP           H53    H    H         0.000      0.611   -1.178   -2.103
 TMP           H52    H    H         0.000     -0.523   -1.862   -3.215
 TMP           H51    H    H         0.000     -0.282   -0.150   -3.170
 TMP           C6     C    CR16      0.000     -2.668   -1.311   -1.833
 TMP           H6     H    H         0.000     -2.902   -1.728   -2.805
 TMP           N1     N    NR6       0.000     -3.645   -1.189   -0.884
 TMP           "C1'"  C    CH1       0.000     -5.010   -1.627   -1.185
 TMP           "H1'"  H    H         0.000     -5.081   -1.925   -2.241
 TMP           "O4'"  O    O2        0.000     -5.936   -0.561   -0.915
 TMP           "C2'"  C    CH2       0.000     -5.393   -2.813   -0.280
 TMP           "H2'1" H    H         0.000     -4.604   -3.053    0.435
 TMP           "H2'2" H    H         0.000     -5.643   -3.705   -0.858
 TMP           "C3'"  C    CH1       0.000     -6.649   -2.320    0.480
 TMP           "H3'"  H    H         0.000     -6.379   -1.936    1.474
 TMP           "O3'"  O    OH1       0.000     -7.624   -3.359    0.583
 TMP           "HO3'" H    H         0.000     -7.254   -4.100    1.082
 TMP           "C4'"  C    CH1       0.000     -7.154   -1.176   -0.436
 TMP           "H4'"  H    H         0.000     -7.737   -1.582   -1.274
 TMP           "C5'"  C    CH2       0.000     -7.989   -0.174    0.364
 TMP           "H5'1" H    H         0.000     -7.354    0.319    1.103
 TMP           "H5'2" H    H         0.000     -8.798   -0.701    0.874
 TMP           "O5'"  O    O2        0.000     -8.538    0.804   -0.522
 TMP           P      P    P         0.000     -9.399    1.821    0.382
 TMP           O1P    O    OP       -0.666     -8.527    2.378    1.486
 TMP           O2P    O    OP       -0.666     -9.909    2.954   -0.481
 TMP           O3P    O    OP       -0.666    -10.572    1.083    0.991
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TMP      O4     n/a    C4     START
 TMP      C4     O4     C5     .
 TMP      N3     C4     C2     .
 TMP      HN3    N3     .      .
 TMP      C2     N3     O2     .
 TMP      O2     C2     .      .
 TMP      C5     C4     C6     .
 TMP      C5M    C5     H51    .
 TMP      H53    C5M    .      .
 TMP      H52    C5M    .      .
 TMP      H51    C5M    .      .
 TMP      C6     C5     N1     .
 TMP      H6     C6     .      .
 TMP      N1     C6     "C1'"  .
 TMP      "C1'"  N1     "C2'"  .
 TMP      "H1'"  "C1'"  .      .
 TMP      "O4'"  "C1'"  .      .
 TMP      "C2'"  "C1'"  "C3'"  .
 TMP      "H2'1" "C2'"  .      .
 TMP      "H2'2" "C2'"  .      .
 TMP      "C3'"  "C2'"  "C4'"  .
 TMP      "H3'"  "C3'"  .      .
 TMP      "O3'"  "C3'"  "HO3'" .
 TMP      "HO3'" "O3'"  .      .
 TMP      "C4'"  "C3'"  "C5'"  .
 TMP      "H4'"  "C4'"  .      .
 TMP      "C5'"  "C4'"  "O5'"  .
 TMP      "H5'1" "C5'"  .      .
 TMP      "H5'2" "C5'"  .      .
 TMP      "O5'"  "C5'"  P      .
 TMP      P      "O5'"  O3P    .
 TMP      O1P    P      .      .
 TMP      O2P    P      .      .
 TMP      O3P    P      .      END
 TMP      "C4'"  "O4'"  .    ADD
 TMP      N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TMP      O1P    P         deloc       1.510    0.020
 TMP      O2P    P         deloc       1.510    0.020
 TMP      O3P    P         deloc       1.510    0.020
 TMP      P      "O5'"     single      1.610    0.020
 TMP      "O5'"  "C5'"     single      1.426    0.020
 TMP      "C5'"  "C4'"     single      1.524    0.020
 TMP      "H5'1" "C5'"     single      1.092    0.020
 TMP      "H5'2" "C5'"     single      1.092    0.020
 TMP      "C4'"  "O4'"     single      1.426    0.020
 TMP      "C4'"  "C3'"     single      1.524    0.020
 TMP      "H4'"  "C4'"     single      1.099    0.020
 TMP      "O4'"  "C1'"     single      1.426    0.020
 TMP      "O3'"  "C3'"     single      1.432    0.020
 TMP      "C3'"  "C2'"     single      1.524    0.020
 TMP      "H3'"  "C3'"     single      1.099    0.020
 TMP      "HO3'" "O3'"     single      0.967    0.020
 TMP      "C2'"  "C1'"     single      1.524    0.020
 TMP      "H2'1" "C2'"     single      1.092    0.020
 TMP      "H2'2" "C2'"     single      1.092    0.020
 TMP      "C1'"  N1        single      1.465    0.020
 TMP      "H1'"  "C1'"     single      1.099    0.020
 TMP      N1     C2        single      1.410    0.020
 TMP      N1     C6        single      1.337    0.020
 TMP      O2     C2        double      1.250    0.020
 TMP      C2     N3        single      1.337    0.020
 TMP      N3     C4        single      1.337    0.020
 TMP      HN3    N3        single      1.040    0.020
 TMP      C4     O4        double      1.250    0.020
 TMP      C5     C4        single      1.487    0.020
 TMP      C5M    C5        single      1.506    0.020
 TMP      C6     C5        double      1.390    0.020
 TMP      H51    C5M       single      1.059    0.020
 TMP      H52    C5M       single      1.059    0.020
 TMP      H53    C5M       single      1.059    0.020
 TMP      H6     C6        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TMP      O4     C4     N3      120.000    3.000
 TMP      O4     C4     C5      120.000    3.000
 TMP      N3     C4     C5      120.000    3.000
 TMP      C4     N3     HN3     120.000    3.000
 TMP      C4     N3     C2      120.000    3.000
 TMP      HN3    N3     C2      120.000    3.000
 TMP      N3     C2     O2      120.000    3.000
 TMP      N3     C2     N1      120.000    3.000
 TMP      O2     C2     N1      120.000    3.000
 TMP      C4     C5     C5M     120.000    3.000
 TMP      C4     C5     C6      120.000    3.000
 TMP      C5M    C5     C6      120.000    3.000
 TMP      C5     C5M    H53     109.470    3.000
 TMP      C5     C5M    H52     109.470    3.000
 TMP      C5     C5M    H51     109.470    3.000
 TMP      H53    C5M    H52     109.470    3.000
 TMP      H53    C5M    H51     109.470    3.000
 TMP      H52    C5M    H51     109.470    3.000
 TMP      C5     C6     H6      120.000    3.000
 TMP      C5     C6     N1      120.000    3.000
 TMP      H6     C6     N1      120.000    3.000
 TMP      C6     N1     "C1'"   120.000    3.000
 TMP      C6     N1     C2      120.000    3.000
 TMP      "C1'"  N1     C2      120.000    3.000
 TMP      N1     "C1'"  "H1'"   109.470    3.000
 TMP      N1     "C1'"  "O4'"   109.470    3.000
 TMP      N1     "C1'"  "C2'"   109.470    3.000
 TMP      "H1'"  "C1'"  "O4'"   109.470    3.000
 TMP      "H1'"  "C1'"  "C2'"   108.340    3.000
 TMP      "O4'"  "C1'"  "C2'"   109.470    3.000
 TMP      "C1'"  "O4'"  "C4'"   111.800    3.000
 TMP      "C1'"  "C2'"  "H2'1"  109.470    3.000
 TMP      "C1'"  "C2'"  "H2'2"  109.470    3.000
 TMP      "C1'"  "C2'"  "C3'"   111.000    3.000
 TMP      "H2'1" "C2'"  "H2'2"  107.900    3.000
 TMP      "H2'1" "C2'"  "C3'"   109.470    3.000
 TMP      "H2'2" "C2'"  "C3'"   109.470    3.000
 TMP      "C2'"  "C3'"  "H3'"   108.340    3.000
 TMP      "C2'"  "C3'"  "O3'"   109.470    3.000
 TMP      "C2'"  "C3'"  "C4'"   111.000    3.000
 TMP      "H3'"  "C3'"  "O3'"   109.470    3.000
 TMP      "H3'"  "C3'"  "C4'"   108.340    3.000
 TMP      "O3'"  "C3'"  "C4'"   109.470    3.000
 TMP      "C3'"  "O3'"  "HO3'"  109.470    3.000
 TMP      "C3'"  "C4'"  "H4'"   108.340    3.000
 TMP      "C3'"  "C4'"  "C5'"   111.000    3.000
 TMP      "C3'"  "C4'"  "O4'"   109.470    3.000
 TMP      "H4'"  "C4'"  "C5'"   108.340    3.000
 TMP      "H4'"  "C4'"  "O4'"   109.470    3.000
 TMP      "C5'"  "C4'"  "O4'"   109.470    3.000
 TMP      "C4'"  "C5'"  "H5'1"  109.470    3.000
 TMP      "C4'"  "C5'"  "H5'2"  109.470    3.000
 TMP      "C4'"  "C5'"  "O5'"   109.470    3.000
 TMP      "H5'1" "C5'"  "H5'2"  107.900    3.000
 TMP      "H5'1" "C5'"  "O5'"   109.470    3.000
 TMP      "H5'2" "C5'"  "O5'"   109.470    3.000
 TMP      "C5'"  "O5'"  P       120.500    3.000
 TMP      "O5'"  P      O1P     108.200    3.000
 TMP      "O5'"  P      O2P     108.200    3.000
 TMP      "O5'"  P      O3P     108.200    3.000
 TMP      O1P    P      O2P     119.900    3.000
 TMP      O1P    P      O3P     119.900    3.000
 TMP      O2P    P      O3P     119.900    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TMP      CONST_1  O4     C4     N3     C2       180.000    0.000   0
 TMP      CONST_2  C4     N3     C2     O2       180.000    0.000   0
 TMP      CONST_3  O4     C4     C5     C6       180.000    0.000   0
 TMP      var_1    C4     C5     C5M    H51      -90.303   20.000   1
 TMP      CONST_4  C4     C5     C6     N1         0.000    0.000   0
 TMP      CONST_5  C5     C6     N1     "C1'"    180.000    0.000   0
 TMP      CONST_6  C6     N1     C2     N3         0.000    0.000   0
 TMP      var_2    C6     N1     "C1'"  "C2'"    115.273   20.000   1
 TMP      var_3    N1     "C1'"  "O4'"  "C4'"   -150.000   20.000   1
 TMP      var_4    N1     "C1'"  "C2'"  "C3'"    120.000   20.000   3
 TMP      var_5    "C1'"  "C2'"  "C3'"  "C4'"     30.000   20.000   3
 TMP      var_6    "C2'"  "C3'"  "O3'"  "HO3'"    61.506   20.000   1
 TMP      var_7    "C2'"  "C3'"  "C4'"  "C5'"   -150.000   20.000   3
 TMP      var_8    "C3'"  "C4'"  "O4'"  "C1'"     30.000   20.000   1
 TMP      var_9    "C3'"  "C4'"  "C5'"  "O5'"   -174.975   20.000   3
 TMP      var_10   "C4'"  "C5'"  "O5'"  P       -179.986   20.000   1
 TMP      var_11   "C5'"  "O5'"  P      O3P      -65.018   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TMP      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 TMP      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 TMP      chir_03  "C1'"  "O4'"  "C2'"  N1        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TMP      plan-1    N1        0.020
 TMP      plan-1    "C1'"     0.020
 TMP      plan-1    C2        0.020
 TMP      plan-1    C6        0.020
 TMP      plan-1    N3        0.020
 TMP      plan-1    C4        0.020
 TMP      plan-1    C5        0.020
 TMP      plan-1    O2        0.020
 TMP      plan-1    HN3       0.020
 TMP      plan-1    O4        0.020
 TMP      plan-1    C5M       0.020
 TMP      plan-1    H6        0.020
# ------------------------------------------------------
`.trim();

monomers["TDP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TDP      TDP 'THIAMIN DIPHOSPHATE                 ' non-polymer        42  26 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TDP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TDP           O23    O    OP       -0.666      0.000    0.000    0.000
 TDP           P2     P    P         0.000      0.000    0.000    0.000
 TDP           O21    O    OP       -0.666      0.000    0.000    0.000
 TDP           O22    O    OP       -0.666      0.000    0.000    0.000
 TDP           O11    O    O2        0.000      0.000    0.000    0.000
 TDP           P1     P    P         0.000      0.000    0.000    0.000
 TDP           O12    O    OP       -0.500      0.000    0.000    0.000
 TDP           O13    O    OP       -0.500      0.000    0.000    0.000
 TDP           O5G    O    O2        0.000      0.000    0.000    0.000
 TDP           C5B    C    CH2       0.000      0.000    0.000    0.000
 TDP           H5B1   H    H         0.000      0.000    0.000    0.000
 TDP           H5B2   H    H         0.000      0.000    0.000    0.000
 TDP           C5A    C    CH2       0.000      0.000    0.000    0.000
 TDP           H5A1   H    H         0.000      0.000    0.000    0.000
 TDP           H5A2   H    H         0.000      0.000    0.000    0.000
 TDP           C5     C    CR5       0.000      0.000    0.000    0.000
 TDP           S1     S    S2        0.000      0.000    0.000    0.000
 TDP           C2     C    CR15      0.000      0.000    0.000    0.000
 TDP           H2     H    H         0.000      0.000    0.000    0.000
 TDP           C4     C    CR5       0.000      0.000    0.000    0.000
 TDP           C4A    C    CH3       0.000      0.000    0.000    0.000
 TDP           H4A3   H    H         0.000      0.000    0.000    0.000
 TDP           H4A2   H    H         0.000      0.000    0.000    0.000
 TDP           H4A1   H    H         0.000      0.000    0.000    0.000
 TDP           N3     N    NR5       1.000      0.000    0.000    0.000
 TDP           C35    C    CH2       0.000      0.000    0.000    0.000
 TDP           H351   H    H         0.000      0.000    0.000    0.000
 TDP           H352   H    H         0.000      0.000    0.000    0.000
 TDP           "C5'"  C    CR6       0.000      0.000    0.000    0.000
 TDP           "C6'"  C    CR16      0.000      0.000    0.000    0.000
 TDP           "H6'"  H    H         0.000      0.000    0.000    0.000
 TDP           "N1'"  N    NRD6      0.000      0.000    0.000    0.000
 TDP           "C4'"  C    CR6       0.000      0.000    0.000    0.000
 TDP           "N4'"  N    NH2       0.000      0.000    0.000    0.000
 TDP           "H4'2" H    H         0.000      0.000    0.000    0.000
 TDP           "H4'1" H    H         0.000      0.000    0.000    0.000
 TDP           "N3'"  N    NRD6      0.000      0.000    0.000    0.000
 TDP           "C2'"  C    CR6       0.000      0.000    0.000    0.000
 TDP           C2A    C    CH3       0.000      0.000    0.000    0.000
 TDP           H2A3   H    H         0.000      0.000    0.000    0.000
 TDP           H2A2   H    H         0.000      0.000    0.000    0.000
 TDP           H2A1   H    H         0.000      0.000    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TDP      O23    n/a    P2     START
 TDP      P2     O23    O11    .
 TDP      O21    P2     .      .
 TDP      O22    P2     .      .
 TDP      O11    P2     P1     .
 TDP      P1     O11    O5G    .
 TDP      O12    P1     .      .
 TDP      O13    P1     .      .
 TDP      O5G    P1     C5B    .
 TDP      C5B    O5G    C5A    .
 TDP      H5B1   C5B    .      .
 TDP      H5B2   C5B    .      .
 TDP      C5A    C5B    C5     .
 TDP      H5A1   C5A    .      .
 TDP      H5A2   C5A    .      .
 TDP      C5     C5A    C4     .
 TDP      S1     C5     C2     .
 TDP      C2     S1     H2     .
 TDP      H2     C2     .      .
 TDP      C4     C5     N3     .
 TDP      C4A    C4     H4A1   .
 TDP      H4A3   C4A    .      .
 TDP      H4A2   C4A    .      .
 TDP      H4A1   C4A    .      .
 TDP      N3     C4     C35    .
 TDP      C35    N3     "C5'"  .
 TDP      H351   C35    .      .
 TDP      H352   C35    .      .
 TDP      "C5'"  C35    "C4'"  .
 TDP      "C6'"  "C5'"  "N1'"  .
 TDP      "H6'"  "C6'"  .      .
 TDP      "N1'"  "C6'"  .      .
 TDP      "C4'"  "C5'"  "N3'"  .
 TDP      "N4'"  "C4'"  "H4'1" .
 TDP      "H4'2" "N4'"  .      .
 TDP      "H4'1" "N4'"  .      .
 TDP      "N3'"  "C4'"  "C2'"  .
 TDP      "C2'"  "N3'"  C2A    .
 TDP      C2A    "C2'"  H2A1   .
 TDP      H2A3   C2A    .      .
 TDP      H2A2   C2A    .      .
 TDP      H2A1   C2A    .      END
 TDP      "N1'"  "C2'"  .    ADD
 TDP      N3     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TDP      "N1'"  "C2'"     double      1.350    0.020
 TDP      "N1'"  "C6'"     single      1.337    0.020
 TDP      C2A    "C2'"     single      1.506    0.020
 TDP      "C2'"  "N3'"     single      1.350    0.020
 TDP      H2A1   C2A       single      1.059    0.020
 TDP      H2A2   C2A       single      1.059    0.020
 TDP      H2A3   C2A       single      1.059    0.020
 TDP      "N3'"  "C4'"     double      1.350    0.020
 TDP      "N4'"  "C4'"     single      1.355    0.020
 TDP      "C4'"  "C5'"     single      1.487    0.020
 TDP      "H4'1" "N4'"     single      1.010    0.020
 TDP      "H4'2" "N4'"     single      1.010    0.020
 TDP      "C6'"  "C5'"     double      1.390    0.020
 TDP      "C5'"  C35       single      1.511    0.020
 TDP      "H6'"  "C6'"     single      1.083    0.020
 TDP      C35    N3        single      1.462    0.020
 TDP      H351   C35       single      1.092    0.020
 TDP      H352   C35       single      1.092    0.020
 TDP      N3     C2        double      1.337    0.020
 TDP      N3     C4        single      1.337    0.020
 TDP      C2     S1        single      1.745    0.020
 TDP      H2     C2        single      1.083    0.020
 TDP      S1     C5        single      1.745    0.020
 TDP      C4     C5        double      1.490    0.020
 TDP      C5     C5A       single      1.510    0.020
 TDP      C4A    C4        single      1.506    0.020
 TDP      H4A1   C4A       single      1.059    0.020
 TDP      H4A2   C4A       single      1.059    0.020
 TDP      H4A3   C4A       single      1.059    0.020
 TDP      C5A    C5B       single      1.524    0.020
 TDP      H5A1   C5A       single      1.092    0.020
 TDP      H5A2   C5A       single      1.092    0.020
 TDP      C5B    O5G       single      1.426    0.020
 TDP      H5B1   C5B       single      1.092    0.020
 TDP      H5B2   C5B       single      1.092    0.020
 TDP      O5G    P1        single      1.610    0.020
 TDP      P1     O11       single      1.610    0.020
 TDP      O12    P1        deloc       1.510    0.020
 TDP      O13    P1        deloc       1.510    0.020
 TDP      O11    P2        single      1.610    0.020
 TDP      O21    P2        deloc       1.510    0.020
 TDP      O22    P2        deloc       1.510    0.020
 TDP      P2     O23       deloc       1.510    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TDP      O23    P2     O21     119.900    3.000
 TDP      O23    P2     O22     119.900    3.000
 TDP      O23    P2     O11     108.200    3.000
 TDP      O21    P2     O22     119.900    3.000
 TDP      O21    P2     O11     108.200    3.000
 TDP      O22    P2     O11     108.200    3.000
 TDP      P2     O11    P1      120.500    3.000
 TDP      O11    P1     O12     108.200    3.000
 TDP      O11    P1     O13     108.200    3.000
 TDP      O11    P1     O5G     102.600    3.000
 TDP      O12    P1     O13     119.900    3.000
 TDP      O12    P1     O5G     108.200    3.000
 TDP      O13    P1     O5G     108.200    3.000
 TDP      P1     O5G    C5B     120.500    3.000
 TDP      O5G    C5B    H5B1    109.470    3.000
 TDP      O5G    C5B    H5B2    109.470    3.000
 TDP      O5G    C5B    C5A     109.470    3.000
 TDP      H5B1   C5B    H5B2    107.900    3.000
 TDP      H5B1   C5B    C5A     109.470    3.000
 TDP      H5B2   C5B    C5A     109.470    3.000
 TDP      C5B    C5A    H5A1    109.470    3.000
 TDP      C5B    C5A    H5A2    109.470    3.000
 TDP      C5B    C5A    C5      109.470    3.000
 TDP      H5A1   C5A    H5A2    107.900    3.000
 TDP      H5A1   C5A    C5      109.470    3.000
 TDP      H5A2   C5A    C5      109.470    3.000
 TDP      C5A    C5     S1      108.000    3.000
 TDP      C5A    C5     C4      126.000    3.000
 TDP      S1     C5     C4      108.000    3.000
 TDP      C5     S1     C2       90.000    3.000
 TDP      S1     C2     H2      108.000    3.000
 TDP      S1     C2     N3      108.000    3.000
 TDP      H2     C2     N3      126.000    3.000
 TDP      C5     C4     C4A     126.000    3.000
 TDP      C5     C4     N3      108.000    3.000
 TDP      C4A    C4     N3      126.000    3.000
 TDP      C4     C4A    H4A3    109.470    3.000
 TDP      C4     C4A    H4A2    109.470    3.000
 TDP      C4     C4A    H4A1    109.470    3.000
 TDP      H4A3   C4A    H4A2    109.470    3.000
 TDP      H4A3   C4A    H4A1    109.470    3.000
 TDP      H4A2   C4A    H4A1    109.470    3.000
 TDP      C4     N3     C35     126.000    3.000
 TDP      C4     N3     C2      108.000    3.000
 TDP      C35    N3     C2      126.000    3.000
 TDP      N3     C35    H351    109.500    3.000
 TDP      N3     C35    H352    109.500    3.000
 TDP      N3     C35    "C5'"   109.500    3.000
 TDP      H351   C35    H352    107.900    3.000
 TDP      H351   C35    "C5'"   109.470    3.000
 TDP      H352   C35    "C5'"   109.470    3.000
 TDP      C35    "C5'"  "C6'"   120.000    3.000
 TDP      C35    "C5'"  "C4'"   120.000    3.000
 TDP      "C6'"  "C5'"  "C4'"   120.000    3.000
 TDP      "C5'"  "C6'"  "H6'"   120.000    3.000
 TDP      "C5'"  "C6'"  "N1'"   120.000    3.000
 TDP      "H6'"  "C6'"  "N1'"   120.000    3.000
 TDP      "C6'"  "N1'"  "C2'"   120.000    3.000
 TDP      "C5'"  "C4'"  "N4'"   120.000    3.000
 TDP      "C5'"  "C4'"  "N3'"   120.000    3.000
 TDP      "N4'"  "C4'"  "N3'"   120.000    3.000
 TDP      "C4'"  "N4'"  "H4'2"  120.000    3.000
 TDP      "C4'"  "N4'"  "H4'1"  120.000    3.000
 TDP      "H4'2" "N4'"  "H4'1"  120.000    3.000
 TDP      "C4'"  "N3'"  "C2'"   120.000    3.000
 TDP      "N3'"  "C2'"  C2A     120.000    3.000
 TDP      "N3'"  "C2'"  "N1'"   120.000    3.000
 TDP      C2A    "C2'"  "N1'"   120.000    3.000
 TDP      "C2'"  C2A    H2A3    109.470    3.000
 TDP      "C2'"  C2A    H2A2    109.470    3.000
 TDP      "C2'"  C2A    H2A1    109.470    3.000
 TDP      H2A3   C2A    H2A2    109.470    3.000
 TDP      H2A3   C2A    H2A1    109.470    3.000
 TDP      H2A2   C2A    H2A1    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TDP      var_1    O23    P2     O11    P1         0.000   20.000   1
 TDP      var_2    P2     O11    P1     O5G        0.000   20.000   1
 TDP      var_3    O11    P1     O5G    C5B        0.000   20.000   1
 TDP      var_4    P1     O5G    C5B    C5A        0.000   20.000   1
 TDP      var_5    O5G    C5B    C5A    C5         0.000   20.000   3
 TDP      var_6    C5B    C5A    C5     C4         0.000   20.000   2
 TDP      CONST_1  C5A    C5     S1     C2         0.000    0.000   0
 TDP      CONST_2  C5     S1     C2     N3         0.000    0.000   0
 TDP      CONST_3  C5A    C5     C4     N3         0.000    0.000   0
 TDP      var_7    C5     C4     C4A    H4A1       0.000   20.000   1
 TDP      CONST_4  C5     C4     N3     C35        0.000    0.000   0
 TDP      CONST_5  C4     N3     C2     S1         0.000    0.000   0
 TDP      var_8    C4     N3     C35    "C5'"      0.000   20.000   1
 TDP      var_9    N3     C35    "C5'"  "C4'"      0.000   20.000   2
 TDP      CONST_6  C35    "C5'"  "C6'"  "N1'"      0.000    0.000   0
 TDP      CONST_7  "C5'"  "C6'"  "N1'"  "C2'"      0.000    0.000   0
 TDP      CONST_8  "C6'"  "N1'"  "C2'"  "N3'"      0.000    0.000   0
 TDP      CONST_9  C35    "C5'"  "C4'"  "N3'"      0.000    0.000   0
 TDP      CONST_10 "C5'"  "C4'"  "N4'"  "H4'1"     0.000    0.000   0
 TDP      CONST_11 "C5'"  "C4'"  "N3'"  "C2'"      0.000    0.000   0
 TDP      CONST_12 "C4'"  "N3'"  "C2'"  C2A        0.000    0.000   0
 TDP      var_10   "N3'"  "C2'"  C2A    H2A1       0.000   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TDP      plan-1    "N1'"     0.020
 TDP      plan-1    "C2'"     0.020
 TDP      plan-1    "C6'"     0.020
 TDP      plan-1    "N3'"     0.020
 TDP      plan-1    "C4'"     0.020
 TDP      plan-1    "C5'"     0.020
 TDP      plan-1    C2A       0.020
 TDP      plan-1    "N4'"     0.020
 TDP      plan-1    C35       0.020
 TDP      plan-1    "H6'"     0.020
 TDP      plan-1    "H4'2"    0.020
 TDP      plan-1    "H4'1"    0.020
 TDP      plan-2    "N4'"     0.020
 TDP      plan-2    "C4'"     0.020
 TDP      plan-2    "H4'1"    0.020
 TDP      plan-2    "H4'2"    0.020
 TDP      plan-3    N3        0.020
 TDP      plan-3    C35       0.020
 TDP      plan-3    C2        0.020
 TDP      plan-3    C4        0.020
 TDP      plan-3    S1        0.020
 TDP      plan-3    C5        0.020
 TDP      plan-3    H2        0.020
 TDP      plan-3    C5A       0.020
 TDP      plan-3    C4A       0.020
# ------------------------------------------------------
`.trim();

monomers["TTP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TTP      TTP 'THYMIDINE-5'-TRIPHOSPHATE           ' non-polymer        42  29 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TTP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TTP           O4     O    O         0.000      0.000    0.000    0.000
 TTP           C4     C    CR6       0.000     -1.078    0.325   -0.465
 TTP           N3     N    NR16      0.000     -2.071   -0.580   -0.577
 TTP           HN3    H    H         0.000     -1.917   -1.560   -0.263
 TTP           C2     C    CR6       0.000     -3.261   -0.221   -1.091
 TTP           O2     O    O         0.000     -4.146   -1.049   -1.189
 TTP           C5     C    CR6       0.000     -1.302    1.657   -0.885
 TTP           C5M    C    CH3       0.000     -0.210    2.689   -0.767
 TTP           HM53   H    H         0.000      0.022    3.069   -1.728
 TTP           HM52   H    H         0.000     -0.538    3.480   -0.144
 TTP           HM51   H    H         0.000      0.653    2.242   -0.346
 TTP           C6     C    CR16      0.000     -2.506    1.991   -1.397
 TTP           H6     H    H         0.000     -2.695    3.005   -1.726
 TTP           N1     N    NR6       0.000     -3.486    1.041   -1.498
 TTP           "C1'"  C    CH1       0.000     -4.792    1.403   -2.053
 TTP           "H1'"  H    H         0.000     -4.802    2.469   -2.320
 TTP           "O4'"  O    O2        0.000     -5.825    1.129   -1.092
 TTP           "C2'"  C    CH2       0.000     -5.085    0.548   -3.301
 TTP           "H2'1" H    H         0.000     -4.299   -0.185   -3.490
 TTP           "H2'2" H    H         0.000     -5.230    1.162   -4.193
 TTP           "C3'"  C    CH1       0.000     -6.405   -0.184   -2.958
 TTP           "H3'"  H    H         0.000     -6.204   -1.198   -2.585
 TTP           "O3'"  O    OH1       0.000     -7.277   -0.221   -4.089
 TTP           "HO3'" H    H         0.000     -6.851   -0.708   -4.807
 TTP           "C4'"  C    CH1       0.000     -6.991    0.711   -1.836
 TTP           "H4'"  H    H         0.000     -7.506    1.581   -2.267
 TTP           "C5'"  C    CH2       0.000     -7.943   -0.091   -0.948
 TTP           "H5'1" H    H         0.000     -7.400   -0.922   -0.492
 TTP           "H5'2" H    H         0.000     -8.762   -0.483   -1.554
 TTP           "O5'"  O    O2        0.000     -8.468    0.756    0.075
 TTP           PA     P    P         0.000     -9.456   -0.150    0.967
 TTP           O1A    O    OP       -0.500     -8.695   -1.278    1.557
 TTP           O2A    O    OP       -0.500    -10.546   -0.681    0.114
 TTP           O3A    O    O2        0.000    -10.087    0.746    2.147
 TTP           PB     P    P         0.000    -11.059   -0.218    2.994
 TTP           O1B    O    OP       -0.500    -12.124   -0.747    2.108
 TTP           O2B    O    OP       -0.500    -10.273   -1.344    3.553
 TTP           O3B    O    O2        0.000    -11.728    0.619    4.196
 TTP           PG     P    P         0.000    -12.682   -0.402    4.997
 TTP           O1G    O    OP       -0.666    -11.854   -1.548    5.536
 TTP           O2G    O    OP       -0.666    -13.344    0.325    6.147
 TTP           O3G    O    OP       -0.666    -13.743   -0.939    4.063
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TTP      O4     n/a    C4     START
 TTP      C4     O4     C5     .
 TTP      N3     C4     C2     .
 TTP      HN3    N3     .      .
 TTP      C2     N3     O2     .
 TTP      O2     C2     .      .
 TTP      C5     C4     C6     .
 TTP      C5M    C5     HM51   .
 TTP      HM53   C5M    .      .
 TTP      HM52   C5M    .      .
 TTP      HM51   C5M    .      .
 TTP      C6     C5     N1     .
 TTP      H6     C6     .      .
 TTP      N1     C6     "C1'"  .
 TTP      "C1'"  N1     "C2'"  .
 TTP      "H1'"  "C1'"  .      .
 TTP      "O4'"  "C1'"  .      .
 TTP      "C2'"  "C1'"  "C3'"  .
 TTP      "H2'1" "C2'"  .      .
 TTP      "H2'2" "C2'"  .      .
 TTP      "C3'"  "C2'"  "C4'"  .
 TTP      "H3'"  "C3'"  .      .
 TTP      "O3'"  "C3'"  "HO3'" .
 TTP      "HO3'" "O3'"  .      .
 TTP      "C4'"  "C3'"  "C5'"  .
 TTP      "H4'"  "C4'"  .      .
 TTP      "C5'"  "C4'"  "O5'"  .
 TTP      "H5'1" "C5'"  .      .
 TTP      "H5'2" "C5'"  .      .
 TTP      "O5'"  "C5'"  PA     .
 TTP      PA     "O5'"  O3A    .
 TTP      O1A    PA     .      .
 TTP      O2A    PA     .      .
 TTP      O3A    PA     PB     .
 TTP      PB     O3A    O3B    .
 TTP      O1B    PB     .      .
 TTP      O2B    PB     .      .
 TTP      O3B    PB     PG     .
 TTP      PG     O3B    O3G    .
 TTP      O1G    PG     .      .
 TTP      O2G    PG     .      .
 TTP      O3G    PG     .      END
 TTP      "C4'"  "O4'"  .    ADD
 TTP      N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TTP      O1A    PA        deloc       1.510    0.020
 TTP      O2A    PA        deloc       1.510    0.020
 TTP      O3A    PA        single      1.610    0.020
 TTP      PA     "O5'"     single      1.610    0.020
 TTP      PB     O3A       single      1.610    0.020
 TTP      O1B    PB        deloc       1.510    0.020
 TTP      O2B    PB        deloc       1.510    0.020
 TTP      O3B    PB        single      1.610    0.020
 TTP      PG     O3B       single      1.610    0.020
 TTP      O1G    PG        deloc       1.510    0.020
 TTP      O2G    PG        deloc       1.510    0.020
 TTP      O3G    PG        deloc       1.510    0.020
 TTP      "O5'"  "C5'"     single      1.426    0.020
 TTP      "C5'"  "C4'"     single      1.524    0.020
 TTP      "H5'1" "C5'"     single      1.092    0.020
 TTP      "H5'2" "C5'"     single      1.092    0.020
 TTP      "C4'"  "O4'"     single      1.426    0.020
 TTP      "C4'"  "C3'"     single      1.524    0.020
 TTP      "H4'"  "C4'"     single      1.099    0.020
 TTP      "O4'"  "C1'"     single      1.426    0.020
 TTP      "O3'"  "C3'"     single      1.432    0.020
 TTP      "C3'"  "C2'"     single      1.524    0.020
 TTP      "H3'"  "C3'"     single      1.099    0.020
 TTP      "HO3'" "O3'"     single      0.967    0.020
 TTP      "C2'"  "C1'"     single      1.524    0.020
 TTP      "H2'1" "C2'"     single      1.092    0.020
 TTP      "H2'2" "C2'"     single      1.092    0.020
 TTP      "C1'"  N1        single      1.465    0.020
 TTP      "H1'"  "C1'"     single      1.099    0.020
 TTP      N1     C2        single      1.410    0.020
 TTP      N1     C6        single      1.337    0.020
 TTP      O2     C2        double      1.250    0.020
 TTP      C2     N3        single      1.337    0.020
 TTP      N3     C4        single      1.337    0.020
 TTP      HN3    N3        single      1.040    0.020
 TTP      C4     O4        double      1.250    0.020
 TTP      C5     C4        single      1.487    0.020
 TTP      C5M    C5        single      1.506    0.020
 TTP      C6     C5        double      1.390    0.020
 TTP      HM51   C5M       single      1.059    0.020
 TTP      HM52   C5M       single      1.059    0.020
 TTP      HM53   C5M       single      1.059    0.020
 TTP      H6     C6        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TTP      O4     C4     N3      120.000    3.000
 TTP      O4     C4     C5      120.000    3.000
 TTP      N3     C4     C5      120.000    3.000
 TTP      C4     N3     HN3     120.000    3.000
 TTP      C4     N3     C2      120.000    3.000
 TTP      HN3    N3     C2      120.000    3.000
 TTP      N3     C2     O2      120.000    3.000
 TTP      N3     C2     N1      120.000    3.000
 TTP      O2     C2     N1      120.000    3.000
 TTP      C4     C5     C5M     120.000    3.000
 TTP      C4     C5     C6      120.000    3.000
 TTP      C5M    C5     C6      120.000    3.000
 TTP      C5     C5M    HM53    109.470    3.000
 TTP      C5     C5M    HM52    109.470    3.000
 TTP      C5     C5M    HM51    109.470    3.000
 TTP      HM53   C5M    HM52    109.470    3.000
 TTP      HM53   C5M    HM51    109.470    3.000
 TTP      HM52   C5M    HM51    109.470    3.000
 TTP      C5     C6     H6      120.000    3.000
 TTP      C5     C6     N1      120.000    3.000
 TTP      H6     C6     N1      120.000    3.000
 TTP      C6     N1     "C1'"   120.000    3.000
 TTP      C6     N1     C2      120.000    3.000
 TTP      "C1'"  N1     C2      120.000    3.000
 TTP      N1     "C1'"  "H1'"   109.470    3.000
 TTP      N1     "C1'"  "O4'"   109.470    3.000
 TTP      N1     "C1'"  "C2'"   109.470    3.000
 TTP      "H1'"  "C1'"  "O4'"   109.470    3.000
 TTP      "H1'"  "C1'"  "C2'"   108.340    3.000
 TTP      "O4'"  "C1'"  "C2'"   109.470    3.000
 TTP      "C1'"  "O4'"  "C4'"   111.800    3.000
 TTP      "C1'"  "C2'"  "H2'1"  109.470    3.000
 TTP      "C1'"  "C2'"  "H2'2"  109.470    3.000
 TTP      "C1'"  "C2'"  "C3'"   111.000    3.000
 TTP      "H2'1" "C2'"  "H2'2"  107.900    3.000
 TTP      "H2'1" "C2'"  "C3'"   109.470    3.000
 TTP      "H2'2" "C2'"  "C3'"   109.470    3.000
 TTP      "C2'"  "C3'"  "H3'"   108.340    3.000
 TTP      "C2'"  "C3'"  "O3'"   109.470    3.000
 TTP      "C2'"  "C3'"  "C4'"   111.000    3.000
 TTP      "H3'"  "C3'"  "O3'"   109.470    3.000
 TTP      "H3'"  "C3'"  "C4'"   108.340    3.000
 TTP      "O3'"  "C3'"  "C4'"   109.470    3.000
 TTP      "C3'"  "O3'"  "HO3'"  109.470    3.000
 TTP      "C3'"  "C4'"  "H4'"   108.340    3.000
 TTP      "C3'"  "C4'"  "C5'"   111.000    3.000
 TTP      "C3'"  "C4'"  "O4'"   109.470    3.000
 TTP      "H4'"  "C4'"  "C5'"   108.340    3.000
 TTP      "H4'"  "C4'"  "O4'"   109.470    3.000
 TTP      "C5'"  "C4'"  "O4'"   109.470    3.000
 TTP      "C4'"  "C5'"  "H5'1"  109.470    3.000
 TTP      "C4'"  "C5'"  "H5'2"  109.470    3.000
 TTP      "C4'"  "C5'"  "O5'"   109.470    3.000
 TTP      "H5'1" "C5'"  "H5'2"  107.900    3.000
 TTP      "H5'1" "C5'"  "O5'"   109.470    3.000
 TTP      "H5'2" "C5'"  "O5'"   109.470    3.000
 TTP      "C5'"  "O5'"  PA      120.500    3.000
 TTP      "O5'"  PA     O1A     108.200    3.000
 TTP      "O5'"  PA     O2A     108.200    3.000
 TTP      "O5'"  PA     O3A     102.600    3.000
 TTP      O1A    PA     O2A     119.900    3.000
 TTP      O1A    PA     O3A     108.200    3.000
 TTP      O2A    PA     O3A     108.200    3.000
 TTP      PA     O3A    PB      120.500    3.000
 TTP      O3A    PB     O1B     108.200    3.000
 TTP      O3A    PB     O2B     108.200    3.000
 TTP      O3A    PB     O3B     102.600    3.000
 TTP      O1B    PB     O2B     119.900    3.000
 TTP      O1B    PB     O3B     108.200    3.000
 TTP      O2B    PB     O3B     108.200    3.000
 TTP      PB     O3B    PG      120.500    3.000
 TTP      O3B    PG     O1G     108.200    3.000
 TTP      O3B    PG     O2G     108.200    3.000
 TTP      O3B    PG     O3G     108.200    3.000
 TTP      O1G    PG     O2G     119.900    3.000
 TTP      O1G    PG     O3G     119.900    3.000
 TTP      O2G    PG     O3G     119.900    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TTP      CONST_1  O4     C4     N3     C2       180.000    0.000   0
 TTP      CONST_2  C4     N3     C2     O2       180.000    0.000   0
 TTP      CONST_3  O4     C4     C5     C6       180.000    0.000   0
 TTP      var_1    C4     C5     C5M    HM51      -0.211   20.000   1
 TTP      CONST_4  C4     C5     C6     N1         0.000    0.000   0
 TTP      CONST_5  C5     C6     N1     "C1'"    180.000    0.000   0
 TTP      CONST_6  C6     N1     C2     N3         0.000    0.000   0
 TTP      var_2    C6     N1     "C1'"  "C2'"    120.302   20.000   1
 TTP      var_3    N1     "C1'"  "O4'"  "C4'"   -150.000   20.000   1
 TTP      var_4    N1     "C1'"  "C2'"  "C3'"    120.000   20.000   3
 TTP      var_5    "C1'"  "C2'"  "C3'"  "C4'"     30.000   20.000   3
 TTP      var_6    "C2'"  "C3'"  "O3'"  "HO3'"    61.461   20.000   1
 TTP      var_7    "C2'"  "C3'"  "C4'"  "C5'"   -150.000   20.000   3
 TTP      var_8    "C3'"  "C4'"  "O4'"  "C1'"     30.000   20.000   1
 TTP      var_9    "C3'"  "C4'"  "C5'"  "O5'"   -179.983   20.000   3
 TTP      var_10   "C4'"  "C5'"  "O5'"  PA      -179.980   20.000   1
 TTP      var_11   "C5'"  "O5'"  PA     O3A      179.998   20.000   1
 TTP      var_12   "O5'"  PA     O3A    PB       179.971   20.000   1
 TTP      var_13   PA     O3A    PB     O3B     -179.979   20.000   1
 TTP      var_14   O3A    PB     O3B    PG      -179.972   20.000   1
 TTP      var_15   PB     O3B    PG     O3G      -60.082   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TTP      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 TTP      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 TTP      chir_03  "C1'"  "O4'"  "C2'"  N1        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TTP      plan-1    N1        0.020
 TTP      plan-1    "C1'"     0.020
 TTP      plan-1    C2        0.020
 TTP      plan-1    C6        0.020
 TTP      plan-1    N3        0.020
 TTP      plan-1    C4        0.020
 TTP      plan-1    C5        0.020
 TTP      plan-1    O2        0.020
 TTP      plan-1    HN3       0.020
 TTP      plan-1    O4        0.020
 TTP      plan-1    C5M       0.020
 TTP      plan-1    H6        0.020
# ------------------------------------------------------
`.trim();

monomers["GLC"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GLC      GLC 'ALPHA-D-GLUCOSE                     ' pyranose           24  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GLC
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GLC           C1     C    CH1       0.000      0.000    0.000    0.000
 GLC           H1     H    H         0.000      0.877    0.215   -0.626
 GLC           O1     O    OH1       0.000      0.069    0.773    1.199
 GLC           HO1    H    H         0.000      0.875    0.545    1.682
 GLC           O5     O    O2        0.000     -0.020   -1.391    0.330
 GLC           C5     C    CH1       0.000     -1.112   -1.776    1.167
 GLC           H5     H    H         0.000     -1.073   -1.204    2.105
 GLC           C6     C    CH2       0.000     -1.016   -3.271    1.476
 GLC           H61    H    H         0.000     -0.965   -3.832    0.541
 GLC           H62    H    H         0.000     -1.898   -3.582    2.039
 GLC           O6     O    OH1       0.000      0.159   -3.523    2.249
 GLC           HO6    H    H         0.000      0.286   -4.453    2.482
 GLC           C4     C    CH1       0.000     -2.432   -1.487    0.448
 GLC           H4     H    H         0.000     -2.489   -2.089   -0.470
 GLC           O4     O    OH1       0.000     -3.526   -1.817    1.306
 GLC           HO4    H    H         0.000     -4.359   -1.630    0.851
 GLC           C3     C    CH1       0.000     -2.494    0.001    0.089
 GLC           H3     H    H         0.000     -2.489    0.602    1.008
 GLC           O3     O    OH1       0.000     -3.690    0.265   -0.649
 GLC           HO3    H    H         0.000     -3.724    1.203   -0.880
 GLC           C2     C    CH1       0.000     -1.275    0.360   -0.767
 GLC           H2     H    H         0.000     -1.308   -0.204   -1.710
 GLC           O2     O    OH1       0.000     -1.284    1.761   -1.047
 GLC           HO2    H    H         0.000     -0.512    1.986   -1.584
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GLC      C1     n/a    O5     START
 GLC      H1     C1     .      .
 GLC      O1     C1     HO1    .
 GLC      HO1    O1     .      .
 GLC      O5     C1     .      END
 GLC      C5     O5     C4     .
 GLC      H5     C5     .      .
 GLC      C6     C5     O6     .
 GLC      H61    C6     .      .
 GLC      H62    C6     .      .
 GLC      O6     C6     .      .
 GLC      HO6    O6     .      .
 GLC      C4     C5     C3     .
 GLC      H4     C4     .      .
 GLC      O4     C4     HO4    .
 GLC      HO4    O4     .      .
 GLC      C3     C4     C2     .
 GLC      H3     C3     .      .
 GLC      O3     C3     HO3    .
 GLC      HO3    O3     .      .
 GLC      C2     C3     O2     .
 GLC      H2     C2     .      .
 GLC      O2     C2     HO2    .
 GLC      HO2    O2     .      .
 GLC      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GLC      C1     C2        single      1.524    0.020
 GLC      O1     C1        single      1.432    0.020
 GLC      O5     C1        single      1.426    0.020
 GLC      H1     C1        single      1.099    0.020
 GLC      C2     C3        single      1.524    0.020
 GLC      O2     C2        single      1.432    0.020
 GLC      H2     C2        single      1.099    0.020
 GLC      C3     C4        single      1.524    0.020
 GLC      O3     C3        single      1.432    0.020
 GLC      H3     C3        single      1.099    0.020
 GLC      C4     C5        single      1.524    0.020
 GLC      O4     C4        single      1.432    0.020
 GLC      H4     C4        single      1.099    0.020
 GLC      C6     C5        single      1.524    0.020
 GLC      C5     O5        single      1.426    0.020
 GLC      H5     C5        single      1.099    0.020
 GLC      O6     C6        single      1.432    0.020
 GLC      H61    C6        single      1.092    0.020
 GLC      H62    C6        single      1.092    0.020
 GLC      HO1    O1        single      0.967    0.020
 GLC      HO2    O2        single      0.967    0.020
 GLC      HO3    O3        single      0.967    0.020
 GLC      HO4    O4        single      0.967    0.020
 GLC      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GLC      H1     C1     O1      109.470    3.000
 GLC      H1     C1     O5      109.470    3.000
 GLC      O1     C1     O5      109.470    3.000
 GLC      H1     C1     C2      108.340    3.000
 GLC      O1     C1     C2      109.470    3.000
 GLC      O5     C1     C2      109.470    3.000
 GLC      C1     O1     HO1     109.470    3.000
 GLC      C1     O5     C5      111.800    3.000
 GLC      O5     C5     H5      109.470    3.000
 GLC      O5     C5     C6      109.470    3.000
 GLC      O5     C5     C4      109.470    3.000
 GLC      H5     C5     C6      108.340    3.000
 GLC      H5     C5     C4      108.340    3.000
 GLC      C6     C5     C4      111.000    3.000
 GLC      C5     C6     H61     109.470    3.000
 GLC      C5     C6     H62     109.470    3.000
 GLC      C5     C6     O6      109.470    3.000
 GLC      H61    C6     H62     107.900    3.000
 GLC      H61    C6     O6      109.470    3.000
 GLC      H62    C6     O6      109.470    3.000
 GLC      C6     O6     HO6     109.470    3.000
 GLC      C5     C4     H4      108.340    3.000
 GLC      C5     C4     O4      109.470    3.000
 GLC      C5     C4     C3      111.000    3.000
 GLC      H4     C4     O4      109.470    3.000
 GLC      H4     C4     C3      108.340    3.000
 GLC      O4     C4     C3      109.470    3.000
 GLC      C4     O4     HO4     109.470    3.000
 GLC      C4     C3     H3      108.340    3.000
 GLC      C4     C3     O3      109.470    3.000
 GLC      C4     C3     C2      111.000    3.000
 GLC      H3     C3     O3      109.470    3.000
 GLC      H3     C3     C2      108.340    3.000
 GLC      O3     C3     C2      109.470    3.000
 GLC      C3     O3     HO3     109.470    3.000
 GLC      C3     C2     H2      108.340    3.000
 GLC      C3     C2     O2      109.470    3.000
 GLC      C3     C2     C1      111.000    3.000
 GLC      H2     C2     O2      109.470    3.000
 GLC      H2     C2     C1      108.340    3.000
 GLC      O2     C2     C1      109.470    3.000
 GLC      C2     O2     HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GLC      var_1    O5     C1     O1     HO1       60.059   20.000   1
 GLC      var_2    C1     O5     C5     C4        60.000   20.000   1
 GLC      var_3    O5     C5     C6     O6        65.039   20.000   3
 GLC      var_4    O5     C5     C4     C3       -60.000   20.000   3
 GLC      var_5    C5     C4     O4     HO4      179.717   20.000   1
 GLC      var_6    C5     C4     C3     C2        60.000   20.000   3
 GLC      var_7    C4     C3     O3     HO3     -179.572   20.000   1
 GLC      var_8    C4     C3     C2     O2       180.000   20.000   3
 GLC      var_9    C3     C2     C1     O5        60.000   20.000   3
 GLC      var_10   C3     C2     O2     HO2      179.756   20.000   1
 GLC      var_1    C5     O5     C1     C2       -60.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 GLC      chir_01  C1     C2     O1     O5        negativ
 GLC      chir_02  C2     C1     C3     O2        negativ
 GLC      chir_03  C3     C2     C4     O3        positiv
 GLC      chir_04  C4     C3     C5     O4        negativ
 GLC      chir_05  C5     C4     C6     O5        negativ
# ------------------------------------------------------
`.trim();

monomers["MAN"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MAN      MAN 'ALPHA-D-MANNOSE                     ' pyranose           24  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MAN
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MAN           C1     C    CH1       0.000      0.000    0.000    0.000
 MAN           H1     H    H         0.000      0.894    0.567   -0.296
 MAN           O1     O    OH1       0.000      0.210   -1.388   -0.263
 MAN           HO1    H    H         0.000      0.378   -1.514   -1.207
 MAN           O5     O    O2        0.000     -1.123    0.460   -0.749
 MAN           C5     C    CH1       0.000     -2.213   -0.414   -0.471
 MAN           H5     H    H         0.000     -1.900   -1.454   -0.642
 MAN           C6     C    CH2       0.000     -3.384   -0.077   -1.398
 MAN           H61    H    H         0.000     -3.696    0.955   -1.228
 MAN           H62    H    H         0.000     -4.219   -0.748   -1.186
 MAN           O6     O    OH1       0.000     -2.976   -0.236   -2.757
 MAN           HO6    H    H         0.000     -3.740   -0.014   -3.307
 MAN           C4     C    CH1       0.000     -2.653   -0.248    0.984
 MAN           H4     H    H         0.000     -2.942    0.797    1.164
 MAN           O4     O    OH1       0.000     -3.764   -1.105    1.251
 MAN           HO4    H    H         0.000     -4.035   -1.002    2.173
 MAN           C3     C    CH1       0.000     -1.485   -0.622    1.903
 MAN           H3     H    H         0.000     -1.262   -1.693    1.800
 MAN           O3     O    OH1       0.000     -1.826   -0.331    3.260
 MAN           HO3    H    H         0.000     -1.082   -0.556    3.835
 MAN           C2     C    CH1       0.000     -0.257    0.199    1.495
 MAN           H2     H    H         0.000      0.618   -0.138    2.068
 MAN           O2     O    OH1       0.000     -0.497    1.582    1.758
 MAN           HO2    H    H         0.000      0.276    2.099    1.493
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MAN      C1     n/a    O5     START
 MAN      H1     C1     .      .
 MAN      O1     C1     HO1    .
 MAN      HO1    O1     .      .
 MAN      O5     C1     .      END
 MAN      C5     O5     C4     .
 MAN      H5     C5     .      .
 MAN      C6     C5     O6     .
 MAN      H61    C6     .      .
 MAN      H62    C6     .      .
 MAN      O6     C6     .      .
 MAN      HO6    O6     .      .
 MAN      C4     C5     C3     .
 MAN      H4     C4     .      .
 MAN      O4     C4     HO4    .
 MAN      HO4    O4     .      .
 MAN      C3     C4     C2     .
 MAN      H3     C3     .      .
 MAN      O3     C3     HO3    .
 MAN      HO3    O3     .      .
 MAN      C2     C3     O2     .
 MAN      H2     C2     .      .
 MAN      O2     C2     HO2    .
 MAN      HO2    O2     .      .
 MAN      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MAN      C1     C2        single      1.524    0.020
 MAN      O1     C1        single      1.432    0.020
 MAN      O5     C1        single      1.426    0.020
 MAN      H1     C1        single      1.099    0.020
 MAN      C2     C3        single      1.524    0.020
 MAN      O2     C2        single      1.432    0.020
 MAN      H2     C2        single      1.099    0.020
 MAN      C3     C4        single      1.524    0.020
 MAN      O3     C3        single      1.432    0.020
 MAN      H3     C3        single      1.099    0.020
 MAN      C4     C5        single      1.524    0.020
 MAN      O4     C4        single      1.432    0.020
 MAN      H4     C4        single      1.099    0.020
 MAN      C6     C5        single      1.524    0.020
 MAN      C5     O5        single      1.426    0.020
 MAN      H5     C5        single      1.099    0.020
 MAN      O6     C6        single      1.432    0.020
 MAN      H61    C6        single      1.092    0.020
 MAN      H62    C6        single      1.092    0.020
 MAN      HO1    O1        single      0.967    0.020
 MAN      HO2    O2        single      0.967    0.020
 MAN      HO3    O3        single      0.967    0.020
 MAN      HO4    O4        single      0.967    0.020
 MAN      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MAN      H1     C1     O1      109.470    3.000
 MAN      H1     C1     O5      109.470    3.000
 MAN      O1     C1     O5      109.470    3.000
 MAN      H1     C1     C2      108.340    3.000
 MAN      O1     C1     C2      109.470    3.000
 MAN      O5     C1     C2      109.470    3.000
 MAN      C1     O1     HO1     109.470    3.000
 MAN      C1     O5     C5      111.800    3.000
 MAN      O5     C5     H5      109.470    3.000
 MAN      O5     C5     C6      109.470    3.000
 MAN      O5     C5     C4      109.470    3.000
 MAN      H5     C5     C6      108.340    3.000
 MAN      H5     C5     C4      108.340    3.000
 MAN      C6     C5     C4      111.000    3.000
 MAN      C5     C6     H61     109.470    3.000
 MAN      C5     C6     H62     109.470    3.000
 MAN      C5     C6     O6      109.470    3.000
 MAN      H61    C6     H62     107.900    3.000
 MAN      H61    C6     O6      109.470    3.000
 MAN      H62    C6     O6      109.470    3.000
 MAN      C6     O6     HO6     109.470    3.000
 MAN      C5     C4     H4      108.340    3.000
 MAN      C5     C4     O4      109.470    3.000
 MAN      C5     C4     C3      111.000    3.000
 MAN      H4     C4     O4      109.470    3.000
 MAN      H4     C4     C3      108.340    3.000
 MAN      O4     C4     C3      109.470    3.000
 MAN      C4     O4     HO4     109.470    3.000
 MAN      C4     C3     H3      108.340    3.000
 MAN      C4     C3     O3      109.470    3.000
 MAN      C4     C3     C2      111.000    3.000
 MAN      H3     C3     O3      109.470    3.000
 MAN      H3     C3     C2      108.340    3.000
 MAN      O3     C3     C2      109.470    3.000
 MAN      C3     O3     HO3     109.470    3.000
 MAN      C3     C2     H2      108.340    3.000
 MAN      C3     C2     O2      109.470    3.000
 MAN      C3     C2     C1      111.000    3.000
 MAN      H2     C2     O2      109.470    3.000
 MAN      H2     C2     C1      108.340    3.000
 MAN      O2     C2     C1      109.470    3.000
 MAN      C2     O2     HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MAN      var_1    O5     C1     O1     HO1       60.045   20.000   1
 MAN      var_2    C1     O5     C5     C4        60.000   20.000   1
 MAN      var_3    O5     C5     C6     O6        59.817   20.000   3
 MAN      var_4    O5     C5     C4     C3       -60.000   20.000   3
 MAN      var_5    C5     C4     O4     HO4      179.577   20.000   1
 MAN      var_6    C5     C4     C3     C2        60.000   20.000   3
 MAN      var_7    C4     C3     O3     HO3     -179.209   20.000   1
 MAN      var_8    C4     C3     C2     O2        60.000   20.000   3
 MAN      var_9    C3     C2     C1     O5        60.000   20.000   3
 MAN      var_10   C3     C2     O2     HO2     -179.538   20.000   1
 MAN      var_1    C5     O5     C1     C2       -60.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MAN      chir_01  C1     C2     O1     O5        negativ
 MAN      chir_02  C2     C1     C3     O2        positiv
 MAN      chir_03  C3     C2     C4     O3        positiv
 MAN      chir_04  C4     C3     C5     O4        negativ
 MAN      chir_05  C5     C4     C6     O5        negativ
# ------------------------------------------------------
`.trim();

monomers["NAG"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
NAG      NAG 'N-ACETYL-D-GLUCOSAMINE              ' pyranose           30  15 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_NAG
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 NAG           C1     C    CH1       0.000      0.000    0.000    0.000
 NAG           H1     H    H         0.000      0.214   -0.239   -1.051
 NAG           O1     O    OH1       0.000      1.203    0.420    0.648
 NAG           HO1    H    H         0.000      1.551    1.204    0.203
 NAG           O5     O    O2        0.000     -0.967    1.051    0.063
 NAG           C5     C    CH1       0.000     -2.206    0.744   -0.581
 NAG           H5     H    H         0.000     -2.022    0.514   -1.640
 NAG           C6     C    CH2       0.000     -3.147    1.945   -0.475
 NAG           H61    H    H         0.000     -3.259    2.227    0.574
 NAG           H62    H    H         0.000     -4.123    1.679   -0.885
 NAG           O6     O    OH1       0.000     -2.603    3.043   -1.210
 NAG           HO6    H    H         0.000     -3.198    3.801   -1.142
 NAG           C4     C    CH1       0.000     -2.846   -0.468    0.101
 NAG           H4     H    H         0.000     -3.068   -0.226    1.149
 NAG           O4     O    OH1       0.000     -4.055   -0.814   -0.578
 NAG           HO4    H    H         0.000     -4.670   -0.068   -0.541
 NAG           C3     C    CH1       0.000     -1.873   -1.650    0.044
 NAG           H3     H    H         0.000     -1.690   -1.926   -1.004
 NAG           O3     O    OH1       0.000     -2.432   -2.765    0.741
 NAG           HO3    H    H         0.000     -3.265   -3.021    0.323
 NAG           C2     C    CH1       0.000     -0.552   -1.242    0.705
 NAG           H2     H    H         0.000     -0.727   -1.016    1.766
 NAG           N2     N    NH1       0.000      0.412   -2.338    0.590
 NAG           HN2    H    H         0.000      0.320   -3.016   -0.153
 NAG           C7     C    C         0.000      1.422   -2.444    1.477
 NAG           C8     C    CH3       0.000      2.413   -3.572    1.359
 NAG           H83    H    H         0.000      3.130   -3.497    2.135
 NAG           H82    H    H         0.000      1.906   -4.499    1.437
 NAG           H81    H    H         0.000      2.903   -3.517    0.421
 NAG           O7     O    O         0.000      1.531   -1.630    2.369
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 NAG      C1     n/a    O5     START
 NAG      H1     C1     .      .
 NAG      O1     C1     HO1    .
 NAG      HO1    O1     .      .
 NAG      O5     C1     .      END
 NAG      C5     O5     C4     .
 NAG      H5     C5     .      .
 NAG      C6     C5     O6     .
 NAG      H61    C6     .      .
 NAG      H62    C6     .      .
 NAG      O6     C6     HO6    .
 NAG      HO6    O6     .      .
 NAG      C4     C5     C3     .
 NAG      H4     C4     .      .
 NAG      O4     C4     HO4    .
 NAG      HO4    O4     .      .
 NAG      C3     C4     C2     .
 NAG      H3     C3     .      .
 NAG      O3     C3     HO3    .
 NAG      HO3    O3     .      .
 NAG      C2     C3     N2     .
 NAG      H2     C2     .      .
 NAG      N2     C2     C7     .
 NAG      HN2    N2     .      .
 NAG      C7     N2     O7     .
 NAG      C8     C7     H81    .
 NAG      H83    C8     .      .
 NAG      H82    C8     .      .
 NAG      H81    C8     .      .
 NAG      O7     C7     .      .
 NAG      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 NAG      C1     C2        single      1.524    0.020
 NAG      O1     C1        single      1.432    0.020
 NAG      O5     C1        single      1.426    0.020
 NAG      H1     C1        single      1.099    0.020
 NAG      C2     C3        single      1.524    0.020
 NAG      N2     C2        single      1.450    0.020
 NAG      H2     C2        single      1.099    0.020
 NAG      C3     C4        single      1.524    0.020
 NAG      O3     C3        single      1.432    0.020
 NAG      H3     C3        single      1.099    0.020
 NAG      C4     C5        single      1.524    0.020
 NAG      O4     C4        single      1.432    0.020
 NAG      H4     C4        single      1.099    0.020
 NAG      C6     C5        single      1.524    0.020
 NAG      C5     O5        single      1.426    0.020
 NAG      H5     C5        single      1.099    0.020
 NAG      O6     C6        single      1.432    0.020
 NAG      H61    C6        single      1.092    0.020
 NAG      H62    C6        single      1.092    0.020
 NAG      C8     C7        single      1.500    0.020
 NAG      C7     N2        single      1.330    0.020
 NAG      O7     C7        double      1.220    0.020
 NAG      H81    C8        single      1.059    0.020
 NAG      H82    C8        single      1.059    0.020
 NAG      H83    C8        single      1.059    0.020
 NAG      HN2    N2        single      1.010    0.020
 NAG      HO1    O1        single      0.967    0.020
 NAG      HO3    O3        single      0.967    0.020
 NAG      HO4    O4        single      0.967    0.020
 NAG      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 NAG      H1     C1     O1      109.470    3.000
 NAG      H1     C1     O5      109.470    3.000
 NAG      O1     C1     O5      109.470    3.000
 NAG      H1     C1     C2      108.340    3.000
 NAG      O1     C1     C2      109.470    3.000
 NAG      O5     C1     C2      109.470    3.000
 NAG      C1     O1     HO1     109.470    3.000
 NAG      C1     O5     C5      111.800    3.000
 NAG      O5     C5     H5      109.470    3.000
 NAG      O5     C5     C6      109.470    3.000
 NAG      O5     C5     C4      109.470    3.000
 NAG      H5     C5     C6      108.340    3.000
 NAG      H5     C5     C4      108.340    3.000
 NAG      C6     C5     C4      111.000    3.000
 NAG      C5     C6     H61     109.470    3.000
 NAG      C5     C6     H62     109.470    3.000
 NAG      C5     C6     O6      109.470    3.000
 NAG      H61    C6     H62     107.900    3.000
 NAG      H61    C6     O6      109.470    3.000
 NAG      H62    C6     O6      109.470    3.000
 NAG      C6     O6     HO6     109.470    3.000
 NAG      C5     C4     H4      108.340    3.000
 NAG      C5     C4     O4      109.470    3.000
 NAG      C5     C4     C3      111.000    3.000
 NAG      H4     C4     O4      109.470    3.000
 NAG      H4     C4     C3      108.340    3.000
 NAG      O4     C4     C3      109.470    3.000
 NAG      C4     O4     HO4     109.470    3.000
 NAG      C4     C3     H3      108.340    3.000
 NAG      C4     C3     O3      109.470    3.000
 NAG      C4     C3     C2      111.000    3.000
 NAG      H3     C3     O3      109.470    3.000
 NAG      H3     C3     C2      108.340    3.000
 NAG      O3     C3     C2      109.470    3.000
 NAG      C3     O3     HO3     109.470    3.000
 NAG      C3     C2     H2      108.340    3.000
 NAG      C3     C2     N2      110.000    3.000
 NAG      C3     C2     C1      111.000    3.000
 NAG      H2     C2     N2      108.550    3.000
 NAG      H2     C2     C1      108.340    3.000
 NAG      N2     C2     C1      110.000    3.000
 NAG      C2     N2     HN2     118.500    3.000
 NAG      C2     N2     C7      121.500    3.000
 NAG      HN2    N2     C7      120.000    3.000
 NAG      N2     C7     C8      116.500    3.000
 NAG      N2     C7     O7      123.000    3.000
 NAG      C8     C7     O7      123.000    3.000
 NAG      C7     C8     H83     109.470    3.000
 NAG      C7     C8     H82     109.470    3.000
 NAG      C7     C8     H81     109.470    3.000
 NAG      H83    C8     H82     109.470    3.000
 NAG      H83    C8     H81     109.470    3.000
 NAG      H82    C8     H81     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 NAG      var_1    O5     C1     O1     HO1      -60.103   20.000   1
 NAG      var_2    C1     O5     C5     C4        60.000   20.000   1
 NAG      var_3    O5     C5     C6     O6        65.068   20.000   3
 NAG      var_4    C5     C6     O6     HO6      179.993   20.000   1
 NAG      var_5    O5     C5     C4     C3       -60.000   20.000   3
 NAG      var_6    C5     C4     O4     HO4      -60.379   20.000   1
 NAG      var_7    C5     C4     C3     C2        60.000   20.000   3
 NAG      var_8    C4     C3     O3     HO3       60.483   20.000   1
 NAG      var_9    C4     C3     C2     N2       180.000   20.000   3
 NAG      var_10   C3     C2     C1     O5        60.000   20.000   3
 NAG      var_11   C3     C2     N2     C7      -155.341   20.000   3
 NAG      CONST_1  C2     N2     C7     O7         0.000    0.000   0
 NAG      var_12   N2     C7     C8     H81       60.085   20.000   1
 NAG      var_1    C5     O5     C1     C2         0.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 NAG      chir_01  C1     C2     O1     O5        positiv
 NAG      chir_02  C2     C1     C3     N2        negativ
 NAG      chir_03  C3     C2     C4     O3        positiv
 NAG      chir_04  C4     C3     C5     O4        negativ
 NAG      chir_05  C5     C4     C6     O5        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 NAG      plan-1    C7        0.020
 NAG      plan-1    C8        0.020
 NAG      plan-1    N2        0.020
 NAG      plan-1    O7        0.020
 NAG      plan-1    HN2       0.020
 NAG      plan-2    N2        0.020
 NAG      plan-2    C2        0.020
 NAG      plan-2    C7        0.020
 NAG      plan-2    HN2       0.020
# ------------------------------------------------------
`.trim();

monomers["RAM"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
RAM      RAM 'ALPHA-L-RHAMNOSE                    ' pyranose           23  11 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_RAM
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 RAM           C1     C    CH1       0.000      0.000    0.000    0.000
 RAM           H1     H    H         0.000      0.972    0.419   -0.295
 RAM           O1     O    OH1       0.000      0.162   -1.376    0.350
 RAM           HO1    H    H         0.000      0.785   -1.450    1.085
 RAM           O5     O    O2        0.000     -0.504    0.718    1.123
 RAM           C5     C    CH1       0.000     -1.668    0.036    1.584
 RAM           H5     H    H         0.000     -1.430   -1.025    1.746
 RAM           C6     C    CH3       0.000     -2.134    0.658    2.902
 RAM           H63    H    H         0.000     -2.365    1.681    2.749
 RAM           H62    H    H         0.000     -2.998    0.151    3.248
 RAM           H61    H    H         0.000     -1.365    0.575    3.625
 RAM           C4     C    CH1       0.000     -2.783    0.153    0.543
 RAM           H4     H    H         0.000     -3.006    1.214    0.361
 RAM           C3     C    CH1       0.000     -2.320   -0.503   -0.761
 RAM           H3     H    H         0.000     -2.197   -1.584   -0.606
 RAM           O3     O    OH1       0.000     -3.288   -0.272   -1.787
 RAM           HO3    H    H         0.000     -2.986   -0.677   -2.611
 RAM           C2     C    CH1       0.000     -0.979    0.113   -1.171
 RAM           H2     H    H         0.000     -0.577   -0.425   -2.040
 RAM           O2     O    OH1       0.000     -1.166    1.489   -1.505
 RAM           HO2    H    H         0.000     -0.317    1.877   -1.756
 RAM           O4     O    OH1       0.000     -3.956   -0.506    1.022
 RAM           HO4    H    H         0.000     -4.212   -0.062    1.842
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 RAM      C1     n/a    O5     START
 RAM      H1     C1     .      .
 RAM      O1     C1     HO1    .
 RAM      HO1    O1     .      .
 RAM      O5     C1     .      END
 RAM      C5     O5     C4     .
 RAM      H5     C5     .      .
 RAM      C6     C5     H61    .
 RAM      H63    C6     .      .
 RAM      H62    C6     .      .
 RAM      H61    C6     .      .
 RAM      C4     C5     O4     .
 RAM      H4     C4     .      .
 RAM      C3     C4     C2     .
 RAM      H3     C3     .      .
 RAM      O3     C3     HO3    .
 RAM      HO3    O3     .      .
 RAM      C2     C3     O2     .
 RAM      H2     C2     .      .
 RAM      O2     C2     HO2    .
 RAM      HO2    O2     .      .
 RAM      O4     C4     .      .
 RAM      HO4    O4     .      .
 RAM      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 RAM      C1     C2        single      1.524    0.020
 RAM      O1     C1        single      1.432    0.020
 RAM      O5     C1        single      1.426    0.020
 RAM      H1     C1        single      1.099    0.020
 RAM      C2     C3        single      1.524    0.020
 RAM      O2     C2        single      1.432    0.020
 RAM      H2     C2        single      1.099    0.020
 RAM      C3     C4        single      1.524    0.020
 RAM      O3     C3        single      1.432    0.020
 RAM      H3     C3        single      1.099    0.020
 RAM      C4     C5        single      1.524    0.020
 RAM      O4     C4        single      1.432    0.020
 RAM      H4     C4        single      1.099    0.020
 RAM      C6     C5        single      1.524    0.020
 RAM      C5     O5        single      1.426    0.020
 RAM      H5     C5        single      1.099    0.020
 RAM      H61    C6        single      1.059    0.020
 RAM      H62    C6        single      1.059    0.020
 RAM      H63    C6        single      1.059    0.020
 RAM      HO1    O1        single      0.967    0.020
 RAM      HO2    O2        single      0.967    0.020
 RAM      HO3    O3        single      0.967    0.020
 RAM      HO4    O4        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 RAM      H1     C1     O1      109.470    3.000
 RAM      H1     C1     O5      109.470    3.000
 RAM      O1     C1     O5      109.470    3.000
 RAM      H1     C1     C2      108.340    3.000
 RAM      O1     C1     C2      109.470    3.000
 RAM      O5     C1     C2      109.470    3.000
 RAM      C1     O1     HO1     109.470    3.000
 RAM      C1     O5     C5      111.800    3.000
 RAM      O5     C5     H5      109.470    3.000
 RAM      O5     C5     C6      109.470    3.000
 RAM      O5     C5     C4      109.470    3.000
 RAM      H5     C5     C6      108.340    3.000
 RAM      H5     C5     C4      108.340    3.000
 RAM      C6     C5     C4      111.000    3.000
 RAM      C5     C6     H63     109.470    3.000
 RAM      C5     C6     H62     109.470    3.000
 RAM      C5     C6     H61     109.470    3.000
 RAM      H63    C6     H62     109.470    3.000
 RAM      H63    C6     H61     109.470    3.000
 RAM      H62    C6     H61     109.470    3.000
 RAM      C5     C4     H4      108.340    3.000
 RAM      C5     C4     C3      111.000    3.000
 RAM      C5     C4     O4      109.470    3.000
 RAM      H4     C4     C3      108.340    3.000
 RAM      H4     C4     O4      109.470    3.000
 RAM      C3     C4     O4      109.470    3.000
 RAM      C4     C3     H3      108.340    3.000
 RAM      C4     C3     O3      109.470    3.000
 RAM      C4     C3     C2      111.000    3.000
 RAM      H3     C3     O3      109.470    3.000
 RAM      H3     C3     C2      108.340    3.000
 RAM      O3     C3     C2      109.470    3.000
 RAM      C3     O3     HO3     109.470    3.000
 RAM      C3     C2     H2      108.340    3.000
 RAM      C3     C2     O2      109.470    3.000
 RAM      C3     C2     C1      111.000    3.000
 RAM      H2     C2     O2      109.470    3.000
 RAM      H2     C2     C1      108.340    3.000
 RAM      O2     C2     C1      109.470    3.000
 RAM      C2     O2     HO2     109.470    3.000
 RAM      C4     O4     HO4     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 RAM      var_1    O5     C1     O1     HO1      -60.042   20.000   1
 RAM      var_2    C1     O5     C5     C4       -60.000   20.000   1
 RAM      var_3    O5     C5     C6     H61      -59.857   20.000   3
 RAM      var_4    O5     C5     C4     O4       180.000   20.000   3
 RAM      var_5    C5     C4     C3     C2       -60.000   20.000   3
 RAM      var_6    C4     C3     O3     HO3      179.219   20.000   1
 RAM      var_7    C4     C3     C2     O2       -60.000   20.000   3
 RAM      var_8    C3     C2     C1     O5       -60.000   20.000   3
 RAM      var_9    C3     C2     O2     HO2      179.584   20.000   1
 RAM      var_1    C5     O5     C1     C2         0.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 RAM      chir_01  C1     C2     O1     O5        positiv
 RAM      chir_02  C2     C1     C3     O2        negativ
 RAM      chir_03  C3     C2     C4     O3        negativ
 RAM      chir_04  C4     C3     C5     O4        positiv
 RAM      chir_05  C5     C4     C6     O5        positiv
# ------------------------------------------------------
`.trim();

monomers["RIB"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
RIB      RIB 'RIBOSE                              ' furanose           20  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_RIB
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 RIB           "O1'"  O    OH1       0.000      0.000    0.000    0.000
 RIB           "HO1'" H    H         0.000      0.105    0.002   -0.961
 RIB           "C1'"  C    CH1       0.000     -1.274    0.550    0.340
 RIB           "H1'"  H    H         0.000     -1.349    1.586   -0.019
 RIB           "O4'"  O    O2        0.000     -2.328   -0.248   -0.218
 RIB           "C2'"  C    CH1       0.000     -1.493    0.495    1.872
 RIB           "H2'"  H    H         0.000     -1.071    1.383    2.363
 RIB           "O2'"  O    OH1       0.000     -0.953   -0.705    2.428
 RIB           "HO2'" H    H         0.000      0.001   -0.731    2.269
 RIB           "C3'"  C    CH1       0.000     -3.045    0.499    1.949
 RIB           "H3'"  H    H         0.000     -3.436    1.525    1.899
 RIB           "O3'"  O    OH1       0.000     -3.497   -0.159    3.135
 RIB           "HO3'" H    H         0.000     -3.164    0.312    3.911
 RIB           "C4'"  C    CH1       0.000     -3.434   -0.298    0.687
 RIB           "H4'"  H    H         0.000     -3.647   -1.342    0.956
 RIB           "C5'"  C    CH2       0.000     -4.668    0.331    0.035
 RIB           "H5'1" H    H         0.000     -4.445    1.364   -0.241
 RIB           "H5'2" H    H         0.000     -5.499    0.315    0.742
 RIB           "O5'"  O    OH1       0.000     -5.020   -0.410   -1.134
 RIB           "HO5'" H    H         0.000     -5.799   -0.011   -1.544
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 RIB      "O1'"  n/a    "C1'"  START
 RIB      "HO1'" "O1'"  .      .
 RIB      "C1'"  "O1'"  "C2'"  .
 RIB      "H1'"  "C1'"  .      .
 RIB      "O4'"  "C1'"  .      .
 RIB      "C2'"  "C1'"  "C3'"  .
 RIB      "H2'"  "C2'"  .      .
 RIB      "O2'"  "C2'"  "HO2'" .
 RIB      "HO2'" "O2'"  .      .
 RIB      "C3'"  "C2'"  "C4'"  .
 RIB      "H3'"  "C3'"  .      .
 RIB      "O3'"  "C3'"  "HO3'" .
 RIB      "HO3'" "O3'"  .      .
 RIB      "C4'"  "C3'"  "C5'"  .
 RIB      "H4'"  "C4'"  .      .
 RIB      "C5'"  "C4'"  "O5'"  .
 RIB      "H5'1" "C5'"  .      .
 RIB      "H5'2" "C5'"  .      .
 RIB      "O5'"  "C5'"  "HO5'" .
 RIB      "HO5'" "O5'"  .      END
 RIB      "C4'"  "O4'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 RIB      "O5'"  "C5'"     single      1.432    0.020
 RIB      "HO5'" "O5'"     single      0.967    0.020
 RIB      "C5'"  "C4'"     single      1.524    0.020
 RIB      "H5'1" "C5'"     single      1.092    0.020
 RIB      "H5'2" "C5'"     single      1.092    0.020
 RIB      "C4'"  "O4'"     single      1.426    0.020
 RIB      "C4'"  "C3'"     single      1.524    0.020
 RIB      "H4'"  "C4'"     single      1.099    0.020
 RIB      "O4'"  "C1'"     single      1.426    0.020
 RIB      "O3'"  "C3'"     single      1.432    0.020
 RIB      "C3'"  "C2'"     single      1.524    0.020
 RIB      "H3'"  "C3'"     single      1.099    0.020
 RIB      "HO3'" "O3'"     single      0.967    0.020
 RIB      "O2'"  "C2'"     single      1.432    0.020
 RIB      "C2'"  "C1'"     single      1.524    0.020
 RIB      "H2'"  "C2'"     single      1.099    0.020
 RIB      "HO2'" "O2'"     single      0.967    0.020
 RIB      "C1'"  "O1'"     single      1.432    0.020
 RIB      "H1'"  "C1'"     single      1.099    0.020
 RIB      "HO1'" "O1'"     single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 RIB      "HO1'" "O1'"  "C1'"   109.470    3.000
 RIB      "O1'"  "C1'"  "H1'"   109.470    3.000
 RIB      "O1'"  "C1'"  "O4'"   109.470    3.000
 RIB      "O1'"  "C1'"  "C2'"   109.470    3.000
 RIB      "H1'"  "C1'"  "O4'"   109.470    3.000
 RIB      "H1'"  "C1'"  "C2'"   108.340    3.000
 RIB      "O4'"  "C1'"  "C2'"   109.470    3.000
 RIB      "C1'"  "O4'"  "C4'"   111.800    3.000
 RIB      "C1'"  "C2'"  "H2'"   108.340    3.000
 RIB      "C1'"  "C2'"  "O2'"   109.470    3.000
 RIB      "C1'"  "C2'"  "C3'"   111.000    3.000
 RIB      "H2'"  "C2'"  "O2'"   109.470    3.000
 RIB      "H2'"  "C2'"  "C3'"   108.340    3.000
 RIB      "O2'"  "C2'"  "C3'"   109.470    3.000
 RIB      "C2'"  "O2'"  "HO2'"  109.470    3.000
 RIB      "C2'"  "C3'"  "H3'"   108.340    3.000
 RIB      "C2'"  "C3'"  "O3'"   109.470    3.000
 RIB      "C2'"  "C3'"  "C4'"   111.000    3.000
 RIB      "H3'"  "C3'"  "O3'"   109.470    3.000
 RIB      "H3'"  "C3'"  "C4'"   108.340    3.000
 RIB      "O3'"  "C3'"  "C4'"   109.470    3.000
 RIB      "C3'"  "O3'"  "HO3'"  109.470    3.000
 RIB      "C3'"  "C4'"  "H4'"   108.340    3.000
 RIB      "C3'"  "C4'"  "C5'"   111.000    3.000
 RIB      "C3'"  "C4'"  "O4'"   109.470    3.000
 RIB      "H4'"  "C4'"  "C5'"   108.340    3.000
 RIB      "H4'"  "C4'"  "O4'"   109.470    3.000
 RIB      "C5'"  "C4'"  "O4'"   109.470    3.000
 RIB      "C4'"  "C5'"  "H5'1"  109.470    3.000
 RIB      "C4'"  "C5'"  "H5'2"  109.470    3.000
 RIB      "C4'"  "C5'"  "O5'"   109.470    3.000
 RIB      "H5'1" "C5'"  "H5'2"  107.900    3.000
 RIB      "H5'1" "C5'"  "O5'"   109.470    3.000
 RIB      "H5'2" "C5'"  "O5'"   109.470    3.000
 RIB      "C5'"  "O5'"  "HO5'"  109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 RIB      var_1    "HO1'" "O1'"  "C1'"  "C2'"    177.268   20.000   1
 RIB      var_2    "O1'"  "C1'"  "O4'"  "C4'"    150.000   20.000   1
 RIB      var_3    "O1'"  "C1'"  "C2'"  "C3'"   -150.000   20.000   3
 RIB      var_4    "C1'"  "C2'"  "O2'"  "HO2'"    61.428   20.000   1
 RIB      var_5    "C1'"  "C2'"  "C3'"  "C4'"     30.000   20.000   3
 RIB      var_6    "C2'"  "C3'"  "O3'"  "HO3'"    61.459   20.000   1
 RIB      var_7    "C2'"  "C3'"  "C4'"  "C5'"   -150.000   20.000   3
 RIB      var_8    "C3'"  "C4'"  "O4'"  "C1'"      0.000   20.000   1
 RIB      var_9    "C3'"  "C4'"  "C5'"  "O5'"    179.891   20.000   3
 RIB      var_10   "C4'"  "C5'"  "O5'"  "HO5'"  -179.946   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 RIB      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 RIB      chir_02  "C3'"  "C4'"  "O3'"  "C2'"     negativ
 RIB      chir_03  "C2'"  "C3'"  "O2'"  "C1'"     negativ
 RIB      chir_04  "C1'"  "O4'"  "C2'"  "O1'"     negativ
# ------------------------------------------------------
`.trim();

monomers["RIP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
RIP      RIP 'RIBOSE(PYRANOSE FORM)               ' pyranose           20  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_RIP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 RIP           C1     C    CH1       0.000      0.000    0.000    0.000
 RIP           H1     H    H         0.000     -0.137    1.090   -0.017
 RIP           O1     O    OH1       0.000      1.034   -0.362   -0.917
 RIP           HO1    H    H         0.000      1.859    0.073   -0.660
 RIP           O5     O    O2        0.000      0.365   -0.411    1.316
 RIP           C5     C    CH2       0.000     -0.599    0.121    2.219
 RIP           H51    H    H         0.000     -0.692    1.197    2.053
 RIP           H52    H    H         0.000     -0.271   -0.060    3.244
 RIP           C4     C    CH1       0.000     -1.954   -0.551    1.988
 RIP           H4     H    H         0.000     -1.855   -1.636    2.133
 RIP           C3     C    CH1       0.000     -2.417   -0.265    0.555
 RIP           H3     H    H         0.000     -3.329   -0.840    0.340
 RIP           O3     O    OH1       0.000     -2.683    1.130    0.407
 RIP           HO3    H    H         0.000     -3.385    1.390    1.019
 RIP           C2     C    CH1       0.000     -1.305   -0.682   -0.413
 RIP           H2     H    H         0.000     -1.176   -1.773   -0.376
 RIP           O2     O    OH1       0.000     -1.652   -0.287   -1.741
 RIP           HO2    H    H         0.000     -0.946   -0.547   -2.349
 RIP           O4     O    OH1       0.000     -2.910   -0.031    2.913
 RIP           HO4    H    H         0.000     -2.578   -0.230    3.800
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 RIP      C1     n/a    O5     START
 RIP      H1     C1     .      .
 RIP      O1     C1     HO1    .
 RIP      HO1    O1     .      .
 RIP      O5     C1     .      END
 RIP      C5     O5     C4     .
 RIP      H51    C5     .      .
 RIP      H52    C5     .      .
 RIP      C4     C5     O4     .
 RIP      H4     C4     .      .
 RIP      C3     C4     C2     .
 RIP      H3     C3     .      .
 RIP      O3     C3     HO3    .
 RIP      HO3    O3     .      .
 RIP      C2     C3     O2     .
 RIP      H2     C2     .      .
 RIP      O2     C2     HO2    .
 RIP      HO2    O2     .      .
 RIP      O4     C4     .      .
 RIP      HO4    O4     .      .
 RIP      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 RIP      C1     C2        single      1.524    0.020
 RIP      O1     C1        single      1.432    0.020
 RIP      O5     C1        single      1.426    0.020
 RIP      H1     C1        single      1.099    0.020
 RIP      C2     C3        single      1.524    0.020
 RIP      O2     C2        single      1.432    0.020
 RIP      H2     C2        single      1.099    0.020
 RIP      C3     C4        single      1.524    0.020
 RIP      O3     C3        single      1.432    0.020
 RIP      H3     C3        single      1.099    0.020
 RIP      C4     C5        single      1.524    0.020
 RIP      O4     C4        single      1.432    0.020
 RIP      H4     C4        single      1.099    0.020
 RIP      C5     O5        single      1.426    0.020
 RIP      H51    C5        single      1.092    0.020
 RIP      H52    C5        single      1.092    0.020
 RIP      HO1    O1        single      0.967    0.020
 RIP      HO2    O2        single      0.967    0.020
 RIP      HO3    O3        single      0.967    0.020
 RIP      HO4    O4        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 RIP      H1     C1     O1      109.470    3.000
 RIP      H1     C1     O5      109.470    3.000
 RIP      O1     C1     O5      109.470    3.000
 RIP      H1     C1     C2      108.340    3.000
 RIP      O1     C1     C2      109.470    3.000
 RIP      O5     C1     C2      109.470    3.000
 RIP      C1     O1     HO1     109.470    3.000
 RIP      C1     O5     C5      111.800    3.000
 RIP      O5     C5     H51     109.470    3.000
 RIP      O5     C5     H52     109.470    3.000
 RIP      O5     C5     C4      109.470    3.000
 RIP      H51    C5     H52     107.900    3.000
 RIP      H51    C5     C4      109.470    3.000
 RIP      H52    C5     C4      109.470    3.000
 RIP      C5     C4     H4      108.340    3.000
 RIP      C5     C4     C3      111.000    3.000
 RIP      C5     C4     O4      109.470    3.000
 RIP      H4     C4     C3      108.340    3.000
 RIP      H4     C4     O4      109.470    3.000
 RIP      C3     C4     O4      109.470    3.000
 RIP      C4     C3     H3      108.340    3.000
 RIP      C4     C3     O3      109.470    3.000
 RIP      C4     C3     C2      111.000    3.000
 RIP      H3     C3     O3      109.470    3.000
 RIP      H3     C3     C2      108.340    3.000
 RIP      O3     C3     C2      109.470    3.000
 RIP      C3     O3     HO3     109.470    3.000
 RIP      C3     C2     H2      108.340    3.000
 RIP      C3     C2     O2      109.470    3.000
 RIP      C3     C2     C1      111.000    3.000
 RIP      H2     C2     O2      109.470    3.000
 RIP      H2     C2     C1      108.340    3.000
 RIP      O2     C2     C1      109.470    3.000
 RIP      C2     O2     HO2     109.470    3.000
 RIP      C4     O4     HO4     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 RIP      var_1    O5     C1     O1     HO1      -59.972   20.000   1
 RIP      var_2    C1     O5     C5     C4        60.000   20.000   1
 RIP      var_3    O5     C5     C4     O4       180.000   20.000   3
 RIP      var_4    C5     C4     C3     C2        60.000   20.000   3
 RIP      var_5    C4     C3     O3     HO3      -60.786   20.000   1
 RIP      var_6    C4     C3     C2     O2       180.000   20.000   3
 RIP      var_7    C3     C2     C1     O5        60.000   20.000   3
 RIP      var_8    C3     C2     O2     HO2      179.696   20.000   1
 RIP      var_1    C5     O5     C1     C2         0.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 RIP      chir_01  C1     C2     O1     O5        positiv
 RIP      chir_02  C2     C1     C3     O2        negativ
 RIP      chir_03  C3     C2     C4     O3        negativ
 RIP      chir_04  C4     C3     C5     O4        negativ
# ------------------------------------------------------
`.trim();

monomers["XYS"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
XYS      XYS 'XYLOPYRANOSE                        ' pyranose           20  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_XYS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 XYS           C1     C    CH1       0.000      0.000    0.000    0.000
 XYS           H1     H    H         0.000      1.015    0.304   -0.293
 XYS           O1     O    OH1       0.000     -0.172   -1.394   -0.261
 XYS           HO1    H    H         0.000     -0.042   -1.563   -1.204
 XYS           O5     O    O2        0.000     -0.955    0.745   -0.754
 XYS           C5     C    CH2       0.000     -2.243    0.198   -0.479
 XYS           H51    H    H         0.000     -2.221   -0.880   -0.649
 XYS           H52    H    H         0.000     -2.978    0.655   -1.145
 XYS           C4     C    CH1       0.000     -2.624    0.480    0.976
 XYS           H4     H    H         0.000     -2.623    1.565    1.152
 XYS           C3     C    CH1       0.000     -1.603   -0.191    1.900
 XYS           H3     H    H         0.000     -1.679   -1.283    1.801
 XYS           O3     O    OH1       0.000     -1.856    0.186    3.255
 XYS           HO3    H    H         0.000     -2.743   -0.103    3.509
 XYS           C2     C    CH1       0.000     -0.199    0.266    1.493
 XYS           H2     H    H         0.000     -0.090    1.341    1.693
 XYS           O2     O    OH1       0.000      0.778   -0.461    2.241
 XYS           HO2    H    H         0.000      1.663   -0.174    1.978
 XYS           O4     O    OH1       0.000     -3.926   -0.045    1.238
 XYS           HO4    H    H         0.000     -4.536    0.401    0.634
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 XYS      C1     n/a    O5     START
 XYS      H1     C1     .      .
 XYS      O1     C1     HO1    .
 XYS      HO1    O1     .      .
 XYS      O5     C1     .      END
 XYS      C5     O5     C4     .
 XYS      H51    C5     .      .
 XYS      H52    C5     .      .
 XYS      C4     C5     O4     .
 XYS      H4     C4     .      .
 XYS      C3     C4     C2     .
 XYS      H3     C3     .      .
 XYS      O3     C3     HO3    .
 XYS      HO3    O3     .      .
 XYS      C2     C3     O2     .
 XYS      H2     C2     .      .
 XYS      O2     C2     HO2    .
 XYS      HO2    O2     .      .
 XYS      O4     C4     .      .
 XYS      HO4    O4     .      .
 XYS      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 XYS      C1     C2        single      1.524    0.020
 XYS      O1     C1        single      1.432    0.020
 XYS      O5     C1        single      1.426    0.020
 XYS      H1     C1        single      1.099    0.020
 XYS      C2     C3        single      1.524    0.020
 XYS      O2     C2        single      1.432    0.020
 XYS      H2     C2        single      1.099    0.020
 XYS      C3     C4        single      1.524    0.020
 XYS      O3     C3        single      1.432    0.020
 XYS      H3     C3        single      1.099    0.020
 XYS      C4     C5        single      1.524    0.020
 XYS      O4     C4        single      1.432    0.020
 XYS      H4     C4        single      1.099    0.020
 XYS      C5     O5        single      1.426    0.020
 XYS      H51    C5        single      1.092    0.020
 XYS      H52    C5        single      1.092    0.020
 XYS      HO1    O1        single      0.967    0.020
 XYS      HO2    O2        single      0.967    0.020
 XYS      HO3    O3        single      0.967    0.020
 XYS      HO4    O4        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 XYS      H1     C1     O1      109.470    3.000
 XYS      H1     C1     O5      109.470    3.000
 XYS      O1     C1     O5      109.470    3.000
 XYS      H1     C1     C2      108.340    3.000
 XYS      O1     C1     C2      109.470    3.000
 XYS      O5     C1     C2      109.470    3.000
 XYS      C1     O1     HO1     109.470    3.000
 XYS      C1     O5     C5      111.800    3.000
 XYS      O5     C5     H51     109.470    3.000
 XYS      O5     C5     H52     109.470    3.000
 XYS      O5     C5     C4      109.470    3.000
 XYS      H51    C5     H52     107.900    3.000
 XYS      H51    C5     C4      109.470    3.000
 XYS      H52    C5     C4      109.470    3.000
 XYS      C5     C4     H4      108.340    3.000
 XYS      C5     C4     C3      111.000    3.000
 XYS      C5     C4     O4      109.470    3.000
 XYS      H4     C4     C3      108.340    3.000
 XYS      H4     C4     O4      109.470    3.000
 XYS      C3     C4     O4      109.470    3.000
 XYS      C4     C3     H3      108.340    3.000
 XYS      C4     C3     O3      109.470    3.000
 XYS      C4     C3     C2      111.000    3.000
 XYS      H3     C3     O3      109.470    3.000
 XYS      H3     C3     C2      108.340    3.000
 XYS      O3     C3     C2      109.470    3.000
 XYS      C3     O3     HO3     109.470    3.000
 XYS      C3     C2     H2      108.340    3.000
 XYS      C3     C2     O2      109.470    3.000
 XYS      C3     C2     C1      111.000    3.000
 XYS      H2     C2     O2      109.470    3.000
 XYS      H2     C2     C1      108.340    3.000
 XYS      O2     C2     C1      109.470    3.000
 XYS      C2     O2     HO2     109.470    3.000
 XYS      C4     O4     HO4     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 XYS      var_1    O5     C1     O1     HO1       59.988   20.000   1
 XYS      var_2    C1     O5     C5     C4        60.000   20.000   1
 XYS      var_3    O5     C5     C4     O4       180.000   20.000   3
 XYS      var_4    C5     C4     C3     C2        60.000   20.000   3
 XYS      var_5    C4     C3     O3     HO3       60.621   20.000   1
 XYS      var_6    C4     C3     C2     O2       180.000   20.000   3
 XYS      var_7    C3     C2     C1     O5        60.000   20.000   3
 XYS      var_8    C3     C2     O2     HO2      179.655   20.000   1
 XYS      var_1    C5     O5     C1     C2       -60.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 XYS      chir_01  C1     C2     O1     O5        negativ
 XYS      chir_02  C2     C1     C3     O2        negativ
 XYS      chir_03  C3     C2     C4     O3        positiv
 XYS      chir_04  C4     C3     C5     O4        negativ
# ------------------------------------------------------
`.trim();

monomers["SUC"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SUC      SUC 'SUCROSE                             ' pyranose           45  23 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SUC
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SUC           C1     C    CH1       0.000      0.000    0.000    0.000
 SUC           H1     H    H         0.000     -0.007    1.051   -0.322
 SUC           O1     O    O2        0.000     -1.334   -0.512   -0.019
 SUC           "C2'"  C    CT        0.000     -2.208    0.609    0.120
 SUC           "C1'"  C    CH2       0.000     -2.283    1.375   -1.201
 SUC           "H1'1" H    H         0.000     -3.039    2.159   -1.125
 SUC           "H1'2" H    H         0.000     -2.554    0.688   -2.006
 SUC           "O1'"  O    OH1       0.000     -1.012    1.963   -1.483
 SUC           "HO1'" H    H         0.000     -1.059    2.448   -2.318
 SUC           "O2'"  O    O2        0.000     -1.729    1.471    1.157
 SUC           "C5'"  C    CH1       0.000     -2.730    1.615    2.177
 SUC           "H5'"  H    H         0.000     -3.336    2.513    1.993
 SUC           "C4'"  C    CH1       0.000     -3.607    0.344    2.065
 SUC           "H4'"  H    H         0.000     -3.138   -0.506    2.581
 SUC           "O4'"  O    OH1       0.000     -4.925    0.581    2.561
 SUC           "HO4'" H    H         0.000     -4.879    0.820    3.496
 SUC           "C3'"  C    CH1       0.000     -3.617    0.126    0.526
 SUC           "H3'"  H    H         0.000     -4.393    0.741    0.049
 SUC           "O3'"  O    OH1       0.000     -3.797   -1.256    0.208
 SUC           "HO3'" H    H         0.000     -4.650   -1.556    0.551
 SUC           "C6'"  C    CH2       0.000     -2.074    1.690    3.557
 SUC           "H6'1" H    H         0.000     -1.494    0.782    3.734
 SUC           "H6'2" H    H         0.000     -2.848    1.782    4.323
 SUC           "O6'"  O    OH1       0.000     -1.211    2.828    3.612
 SUC           "HO6'" H    H         0.000     -0.758    2.794    4.466
 SUC           O5     O    O2        0.000      0.521   -0.087    1.323
 SUC           C5     C    CH1       0.000      0.348   -1.430    1.769
 SUC           H5     H    H         0.000     -0.701   -1.727    1.634
 SUC           C6     C    CH2       0.000      0.717   -1.528    3.250
 SUC           H61    H    H         0.000      1.734   -1.157    3.396
 SUC           H62    H    H         0.000      0.661   -2.570    3.571
 SUC           O6     O    OH1       0.000     -0.193   -0.742    4.021
 SUC           HO6    H    H         0.000     -0.008   -0.865    4.961
 SUC           C4     C    CH1       0.000      1.250   -2.365    0.958
 SUC           H4     H    H         0.000      2.298   -2.055    1.072
 SUC           O4     O    OH1       0.000      1.093   -3.705    1.426
 SUC           HO4    H    H         0.000      1.657   -4.295    0.908
 SUC           C3     C    CH1       0.000      0.849   -2.287   -0.519
 SUC           H3     H    H         0.000     -0.163   -2.695   -0.648
 SUC           O3     O    OH1       0.000      1.773   -3.038   -1.309
 SUC           HO3    H    H         0.000      1.523   -2.976   -2.241
 SUC           C2     C    CH1       0.000      0.872   -0.819   -0.956
 SUC           H2     H    H         0.000      1.904   -0.443   -0.926
 SUC           O2     O    OH1       0.000      0.360   -0.706   -2.285
 SUC           HO2    H    H         0.000      0.370    0.222   -2.556
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SUC      C1     n/a    O5     START
 SUC      H1     C1     .      .
 SUC      O1     C1     "C2'"  .
 SUC      "C2'"  O1     "O2'"  .
 SUC      "C1'"  "C2'"  "O1'"  .
 SUC      "H1'1" "C1'"  .      .
 SUC      "H1'2" "C1'"  .      .
 SUC      "O1'"  "C1'"  "HO1'" .
 SUC      "HO1'" "O1'"  .      .
 SUC      "O2'"  "C2'"  "C5'"  .
 SUC      "C5'"  "O2'"  "C6'"  .
 SUC      "H5'"  "C5'"  .      .
 SUC      "C4'"  "C5'"  "C3'"  .
 SUC      "H4'"  "C4'"  .      .
 SUC      "O4'"  "C4'"  "HO4'" .
 SUC      "HO4'" "O4'"  .      .
 SUC      "C3'"  "C4'"  "O3'"  .
 SUC      "H3'"  "C3'"  .      .
 SUC      "O3'"  "C3'"  "HO3'" .
 SUC      "HO3'" "O3'"  .      .
 SUC      "C6'"  "C5'"  "O6'"  .
 SUC      "H6'1" "C6'"  .      .
 SUC      "H6'2" "C6'"  .      .
 SUC      "O6'"  "C6'"  .      .
 SUC      "HO6'" "O6'"  .      .
 SUC      O5     C1     .      END
 SUC      C5     O5     C4     .
 SUC      H5     C5     .      .
 SUC      C6     C5     O6     .
 SUC      H61    C6     .      .
 SUC      H62    C6     .      .
 SUC      O6     C6     HO6    .
 SUC      HO6    O6     .      .
 SUC      C4     C5     C3     .
 SUC      H4     C4     .      .
 SUC      O4     C4     HO4    .
 SUC      HO4    O4     .      .
 SUC      C3     C4     C2     .
 SUC      H3     C3     .      .
 SUC      O3     C3     HO3    .
 SUC      HO3    O3     .      .
 SUC      C2     C3     O2     .
 SUC      H2     C2     .      .
 SUC      O2     C2     HO2    .
 SUC      HO2    O2     .      .
 SUC      C1     C2     .    ADD
 SUC      "C2'"  "C3'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SUC      C1     C2        single      1.524    0.020
 SUC      O1     C1        single      1.426    0.020
 SUC      O5     C1        single      1.426    0.020
 SUC      H1     C1        single      1.099    0.020
 SUC      C2     C3        single      1.524    0.020
 SUC      O2     C2        single      1.432    0.020
 SUC      H2     C2        single      1.099    0.020
 SUC      C3     C4        single      1.524    0.020
 SUC      O3     C3        single      1.432    0.020
 SUC      H3     C3        single      1.099    0.020
 SUC      C4     C5        single      1.524    0.020
 SUC      O4     C4        single      1.432    0.020
 SUC      H4     C4        single      1.099    0.020
 SUC      C6     C5        single      1.524    0.020
 SUC      C5     O5        single      1.426    0.020
 SUC      H5     C5        single      1.099    0.020
 SUC      O6     C6        single      1.432    0.020
 SUC      H61    C6        single      1.092    0.020
 SUC      H62    C6        single      1.092    0.020
 SUC      "C2'"  O1        single      1.426    0.020
 SUC      HO2    O2        single      0.967    0.020
 SUC      HO3    O3        single      0.967    0.020
 SUC      HO4    O4        single      0.967    0.020
 SUC      HO6    O6        single      0.967    0.020
 SUC      "C1'"  "C2'"     single      1.524    0.020
 SUC      "O1'"  "C1'"     single      1.432    0.020
 SUC      "H1'1" "C1'"     single      1.092    0.020
 SUC      "H1'2" "C1'"     single      1.092    0.020
 SUC      "C2'"  "C3'"     single      1.524    0.020
 SUC      "O2'"  "C2'"     single      1.426    0.020
 SUC      "C3'"  "C4'"     single      1.524    0.020
 SUC      "O3'"  "C3'"     single      1.432    0.020
 SUC      "H3'"  "C3'"     single      1.099    0.020
 SUC      "C4'"  "C5'"     single      1.524    0.020
 SUC      "O4'"  "C4'"     single      1.432    0.020
 SUC      "H4'"  "C4'"     single      1.099    0.020
 SUC      "C6'"  "C5'"     single      1.524    0.020
 SUC      "C5'"  "O2'"     single      1.426    0.020
 SUC      "H5'"  "C5'"     single      1.099    0.020
 SUC      "O6'"  "C6'"     single      1.432    0.020
 SUC      "H6'1" "C6'"     single      1.092    0.020
 SUC      "H6'2" "C6'"     single      1.092    0.020
 SUC      "HO1'" "O1'"     single      0.967    0.020
 SUC      "HO3'" "O3'"     single      0.967    0.020
 SUC      "HO4'" "O4'"     single      0.967    0.020
 SUC      "HO6'" "O6'"     single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SUC      H1     C1     O1      109.470    3.000
 SUC      H1     C1     O5      109.470    3.000
 SUC      O1     C1     O5      109.470    3.000
 SUC      H1     C1     C2      108.340    3.000
 SUC      O1     C1     C2      109.470    3.000
 SUC      O5     C1     C2      109.470    3.000
 SUC      C1     O1     "C2'"   111.800    3.000
 SUC      O1     "C2'"  "C1'"   109.470    3.000
 SUC      O1     "C2'"  "O2'"   109.500    3.000
 SUC      O1     "C2'"  "C3'"   109.470    3.000
 SUC      "C1'"  "C2'"  "O2'"   109.470    3.000
 SUC      "C1'"  "C2'"  "C3'"   111.000    3.000
 SUC      "O2'"  "C2'"  "C3'"   109.470    3.000
 SUC      "C2'"  "C1'"  "H1'1"  109.470    3.000
 SUC      "C2'"  "C1'"  "H1'2"  109.470    3.000
 SUC      "C2'"  "C1'"  "O1'"   109.470    3.000
 SUC      "H1'1" "C1'"  "H1'2"  107.900    3.000
 SUC      "H1'1" "C1'"  "O1'"   109.470    3.000
 SUC      "H1'2" "C1'"  "O1'"   109.470    3.000
 SUC      "C1'"  "O1'"  "HO1'"  109.470    3.000
 SUC      "C2'"  "O2'"  "C5'"   111.800    3.000
 SUC      "O2'"  "C5'"  "H5'"   109.470    3.000
 SUC      "O2'"  "C5'"  "C4'"   109.470    3.000
 SUC      "O2'"  "C5'"  "C6'"   109.470    3.000
 SUC      "H5'"  "C5'"  "C4'"   108.340    3.000
 SUC      "H5'"  "C5'"  "C6'"   108.340    3.000
 SUC      "C4'"  "C5'"  "C6'"   111.000    3.000
 SUC      "C5'"  "C4'"  "H4'"   108.340    3.000
 SUC      "C5'"  "C4'"  "O4'"   109.470    3.000
 SUC      "C5'"  "C4'"  "C3'"   111.000    3.000
 SUC      "H4'"  "C4'"  "O4'"   109.470    3.000
 SUC      "H4'"  "C4'"  "C3'"   108.340    3.000
 SUC      "O4'"  "C4'"  "C3'"   109.470    3.000
 SUC      "C4'"  "O4'"  "HO4'"  109.470    3.000
 SUC      "C4'"  "C3'"  "H3'"   108.340    3.000
 SUC      "C4'"  "C3'"  "O3'"   109.470    3.000
 SUC      "C4'"  "C3'"  "C2'"   111.000    3.000
 SUC      "H3'"  "C3'"  "O3'"   109.470    3.000
 SUC      "H3'"  "C3'"  "C2'"   108.340    3.000
 SUC      "O3'"  "C3'"  "C2'"   109.470    3.000
 SUC      "C3'"  "O3'"  "HO3'"  109.470    3.000
 SUC      "C5'"  "C6'"  "H6'1"  109.470    3.000
 SUC      "C5'"  "C6'"  "H6'2"  109.470    3.000
 SUC      "C5'"  "C6'"  "O6'"   109.470    3.000
 SUC      "H6'1" "C6'"  "H6'2"  107.900    3.000
 SUC      "H6'1" "C6'"  "O6'"   109.470    3.000
 SUC      "H6'2" "C6'"  "O6'"   109.470    3.000
 SUC      "C6'"  "O6'"  "HO6'"  109.470    3.000
 SUC      C1     O5     C5      111.800    3.000
 SUC      O5     C5     H5      109.470    3.000
 SUC      O5     C5     C6      109.470    3.000
 SUC      O5     C5     C4      109.470    3.000
 SUC      H5     C5     C6      108.340    3.000
 SUC      H5     C5     C4      108.340    3.000
 SUC      C6     C5     C4      111.000    3.000
 SUC      C5     C6     H61     109.470    3.000
 SUC      C5     C6     H62     109.470    3.000
 SUC      C5     C6     O6      109.470    3.000
 SUC      H61    C6     H62     107.900    3.000
 SUC      H61    C6     O6      109.470    3.000
 SUC      H62    C6     O6      109.470    3.000
 SUC      C6     O6     HO6     109.470    3.000
 SUC      C5     C4     H4      108.340    3.000
 SUC      C5     C4     O4      109.470    3.000
 SUC      C5     C4     C3      111.000    3.000
 SUC      H4     C4     O4      109.470    3.000
 SUC      H4     C4     C3      108.340    3.000
 SUC      O4     C4     C3      109.470    3.000
 SUC      C4     O4     HO4     109.470    3.000
 SUC      C4     C3     H3      108.340    3.000
 SUC      C4     C3     O3      109.470    3.000
 SUC      C4     C3     C2      111.000    3.000
 SUC      H3     C3     O3      109.470    3.000
 SUC      H3     C3     C2      108.340    3.000
 SUC      O3     C3     C2      109.470    3.000
 SUC      C3     O3     HO3     109.470    3.000
 SUC      C3     C2     H2      108.340    3.000
 SUC      C3     C2     O2      109.470    3.000
 SUC      C3     C2     C1      111.000    3.000
 SUC      H2     C2     O2      109.470    3.000
 SUC      H2     C2     C1      108.340    3.000
 SUC      O2     C2     C1      109.470    3.000
 SUC      C2     O2     HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 SUC      var_1    O5     C1     O1     "C2'"     95.437   20.000   1
 SUC      var_2    C1     O1     "C2'"  "O2'"    -45.135   20.000   1
 SUC      var_3    O1     "C2'"  "C3'"  "C4'"     90.000   20.000   1
 SUC      var_4    O1     "C2'"  "C1'"  "O1'"    -66.519   20.000   1
 SUC      var_5    "C2'"  "C1'"  "O1'"  "HO1'"  -179.994   20.000   1
 SUC      var_6    O1     "C2'"  "O2'"  "C5'"   -120.000   20.000   1
 SUC      var_7    "C2'"  "O2'"  "C5'"  "C6'"    150.000   20.000   1
 SUC      var_8    "O2'"  "C5'"  "C4'"  "C3'"    -30.000   20.000   3
 SUC      var_9    "C5'"  "C4'"  "O4'"  "HO4'"   -61.444   20.000   1
 SUC      var_10   "C5'"  "C4'"  "C3'"  "O3'"    150.000   20.000   3
 SUC      var_11   "C4'"  "C3'"  "O3'"  "HO3'"    61.489   20.000   1
 SUC      var_12   "O2'"  "C5'"  "C6'"  "O6'"     60.943   20.000   3
 SUC      var_13   C1     O5     C5     C4        60.000   20.000   1
 SUC      var_14   O5     C5     C6     O6        64.436   20.000   3
 SUC      var_15   C5     C6     O6     HO6      175.062   20.000   1
 SUC      var_16   O5     C5     C4     C3       -60.000   20.000   3
 SUC      var_17   C5     C4     O4     HO4      179.468   20.000   1
 SUC      var_18   C5     C4     C3     C2        60.000   20.000   3
 SUC      var_19   C4     C3     O3     HO3     -179.232   20.000   1
 SUC      var_20   C4     C3     C2     O2       180.000   20.000   3
 SUC      var_21   C3     C2     C1     O5        60.000   20.000   3
 SUC      var_22   C3     C2     O2     HO2      179.610   20.000   1
 SUC      var_1    C5     O5     C1     C2       -60.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 SUC      chir_01  C1     C2     O1     O5        negativ
 SUC      chir_02  C2     C1     C3     O2        negativ
 SUC      chir_03  C3     C2     C4     O3        positiv
 SUC      chir_04  C4     C3     C5     O4        negativ
 SUC      chir_05  C5     C4     C6     O5        negativ
 SUC      chir_06  "C2'"  O1     "C1'"  "C3'"     negativ
 SUC      chir_07  "C3'"  "C2'"  "C4'"  "O3'"     positiv
 SUC      chir_08  "C4'"  "C3'"  "C5'"  "O4'"     negativ
 SUC      chir_09  "C5'"  "C4'"  "C6'"  "O2'"     negativ
# ------------------------------------------------------
`.trim();

monomers["RER"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
RER      RER '(1R,3S,4S,5S)-3-amino-2,3,6-trideoxy' pyranose           26  11 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_RER
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 RER           C1     C    CH1       0.000      0.000    0.000    0.000
 RER           H1     H    H         0.000      0.896    0.033   -0.636
 RER           O1     O    OH1       0.000     -0.035   -1.240    0.710
 RER           HO1    H    H         0.000      0.729   -1.385    1.285
 RER           O5     O    O2        0.000      0.037    1.082    0.933
 RER           C5     C    CH1       0.000     -1.074    1.119    1.829
 RER           H5     H    H         0.000     -1.115    0.180    2.400
 RER           C5A    C    CH3       0.000     -0.913    2.295    2.794
 RER           H5A3   H    H         0.000     -0.018    2.179    3.348
 RER           H5A2   H    H         0.000     -0.873    3.200    2.245
 RER           H5A1   H    H         0.000     -1.738    2.323    3.459
 RER           C4     C    CH1       0.000     -2.369    1.287    1.030
 RER           H4     H    H         0.000     -3.228    1.271    1.714
 RER           O4     O    OH1       0.000     -2.338    2.532    0.329
 RER           HO4    H    H         0.000     -2.261    3.257    0.964
 RER           C3     C    CT        0.000     -2.492    0.138    0.024
 RER           C3A    C    CH3       0.000     -2.596   -1.192    0.775
 RER           H3A3   H    H         0.000     -3.534   -1.252    1.263
 RER           H3A2   H    H         0.000     -2.505   -1.994    0.088
 RER           H3A1   H    H         0.000     -1.821   -1.255    1.494
 RER           N3     N    NH2       0.000     -3.692    0.332   -0.800
 RER           H32N   H    H         0.000     -4.289    1.134   -0.646
 RER           H31N   H    H         0.000     -3.924   -0.335   -1.523
 RER           C2     C    CH2       0.000     -1.251    0.124   -0.873
 RER           H22C   H    H         0.000     -1.204    1.052   -1.448
 RER           H21C   H    H         0.000     -1.304   -0.724   -1.558
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 RER      C1     n/a    O5     START
 RER      H1     C1     .      .
 RER      O1     C1     .      .
 RER      HO1    O1     .      .
 RER      O5     C1     .      END
 RER      C5     O5     C4     .
 RER      H5     C5     .      .
 RER      C5A    C5     H5A1   .
 RER      H5A3   C5A    .      .
 RER      H5A2   C5A    .      .
 RER      H5A1   C5A    .      .
 RER      C4     C5     C3     .
 RER      H4     C4     .      .
 RER      O4     C4     HO4    .
 RER      HO4    O4     .      .
 RER      C3     C4     C2     .
 RER      C3A    C3     H3A1   .
 RER      H3A3   C3A    .      .
 RER      H3A2   C3A    .      .
 RER      H3A1   C3A    .      .
 RER      N3     C3     H31N   .
 RER      H32N   N3     .      .
 RER      H31N   N3     .      .
 RER      C2     C3     H21C   .
 RER      H22C   C2     .      .
 RER      H21C   C2     .      .
 RER      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 RER      C1     C2        single      1.524    0.020
 RER      O5     C1        single      1.426    0.020
 RER      O1     C1        single      1.432    0.020
 RER      C2     C3        single      1.524    0.020
 RER      N3     C3        single      1.462    0.020
 RER      C3A    C3        single      1.524    0.020
 RER      C3     C4        single      1.524    0.020
 RER      O4     C4        single      1.432    0.020
 RER      C4     C5        single      1.524    0.020
 RER      C5     O5        single      1.426    0.020
 RER      C5A    C5        single      1.524    0.020
 RER      H1     C1        single      1.099    0.020
 RER      H21C   C2        single      1.092    0.020
 RER      H22C   C2        single      1.092    0.020
 RER      HO1    O1        single      0.967    0.020
 RER      H31N   N3        single      1.010    0.020
 RER      H32N   N3        single      1.010    0.020
 RER      H3A1   C3A       single      1.059    0.020
 RER      H3A2   C3A       single      1.059    0.020
 RER      H3A3   C3A       single      1.059    0.020
 RER      H4     C4        single      1.099    0.020
 RER      HO4    O4        single      0.967    0.020
 RER      H5     C5        single      1.099    0.020
 RER      H5A1   C5A       single      1.059    0.020
 RER      H5A2   C5A       single      1.059    0.020
 RER      H5A3   C5A       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 RER      H1     C1     O1      109.470    3.000
 RER      H1     C1     O5      109.470    3.000
 RER      O1     C1     O5      109.470    3.000
 RER      H1     C1     C2      108.340    3.000
 RER      O1     C1     C2      109.470    3.000
 RER      O5     C1     C2      109.470    3.000
 RER      C1     O1     HO1     109.470    3.000
 RER      C1     O5     C5      111.800    3.000
 RER      O5     C5     H5      109.470    3.000
 RER      O5     C5     C5A     109.470    3.000
 RER      O5     C5     C4      109.470    3.000
 RER      H5     C5     C5A     108.340    3.000
 RER      H5     C5     C4      108.340    3.000
 RER      C5A    C5     C4      111.000    3.000
 RER      C5     C5A    H5A3    109.470    3.000
 RER      C5     C5A    H5A2    109.470    3.000
 RER      C5     C5A    H5A1    109.470    3.000
 RER      H5A3   C5A    H5A2    109.470    3.000
 RER      H5A3   C5A    H5A1    109.470    3.000
 RER      H5A2   C5A    H5A1    109.470    3.000
 RER      C5     C4     H4      108.340    3.000
 RER      C5     C4     O4      109.470    3.000
 RER      C5     C4     C3      111.000    3.000
 RER      H4     C4     O4      109.470    3.000
 RER      H4     C4     C3      108.340    3.000
 RER      O4     C4     C3      109.470    3.000
 RER      C4     O4     HO4     109.470    3.000
 RER      C4     C3     C3A     111.000    3.000
 RER      C4     C3     N3      109.500    3.000
 RER      C4     C3     C2      111.000    3.000
 RER      C3A    C3     N3      109.500    3.000
 RER      C3A    C3     C2      111.000    3.000
 RER      N3     C3     C2      109.500    3.000
 RER      C3     C3A    H3A3    109.470    3.000
 RER      C3     C3A    H3A2    109.470    3.000
 RER      C3     C3A    H3A1    109.470    3.000
 RER      H3A3   C3A    H3A2    109.470    3.000
 RER      H3A3   C3A    H3A1    109.470    3.000
 RER      H3A2   C3A    H3A1    109.470    3.000
 RER      C3     N3     H32N    120.000    3.000
 RER      C3     N3     H31N    120.000    3.000
 RER      H32N   N3     H31N    120.000    3.000
 RER      C3     C2     H22C    109.470    3.000
 RER      C3     C2     H21C    109.470    3.000
 RER      C3     C2     C1      111.000    3.000
 RER      H22C   C2     H21C    107.900    3.000
 RER      H22C   C2     C1      109.470    3.000
 RER      H21C   C2     C1      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 RER      var_1    C1     O5     C5     C4       -60.000   20.000   1
 RER      var_2    O5     C5     C5A    H5A1     179.948   20.000   3
 RER      var_3    O5     C5     C4     C3        60.000   20.000   3
 RER      var_4    C5     C4     O4     HO4      -60.400   20.000   1
 RER      var_5    C5     C4     C3     C2       -60.000   20.000   1
 RER      var_6    C4     C3     C3A    H3A1     -49.839   20.000   1
 RER      var_7    C4     C3     N3     H31N     179.609   20.000   1
 RER      var_8    C4     C3     C2     C1        60.000   20.000   1
 RER      var_9    C3     C2     C1     O5       -60.000   20.000   3
 RER      var_1    C5     O5     C1     C2         0.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 RER      chir_01  C1     C2     O5     O1        negativ
 RER      chir_02  C3     C2     N3     C3A       negativ
 RER      chir_03  C4     C3     O4     C5        positiv
 RER      chir_04  C5     C4     O5     C5A       negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 RER      plan-1    N3        0.020
 RER      plan-1    C3        0.000
 RER      plan-1    H31N      0.000
 RER      plan-1    H32N      0.000
# ------------------------------------------------------
`.trim();

monomers["BGC"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BGC      BGC 'BETA-D-GLUCOSE                      ' pyranose           24  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BGC
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BGC           C1     C    CH1       0.000      0.000    0.000    0.000
 BGC           H1     H    H         0.000      0.051    1.095    0.076
 BGC           O1     O    OH1       0.000      1.319   -0.527   -0.155
 BGC           HA     H    H         0.000      1.857   -0.279    0.609
 BGC           C2     C    CH1       0.000     -0.848   -0.387   -1.212
 BGC           H2     H    H         0.000     -0.920   -1.481   -1.276
 BGC           O2     O    OH1       0.000     -0.243    0.121   -2.402
 BGC           HB     H    H         0.000      0.643   -0.252   -2.496
 BGC           O5     O    O2        0.000     -0.585   -0.530    1.187
 BGC           C5     C    CH1       0.000     -1.818    0.151    1.402
 BGC           H5     H    H         0.000     -1.644    1.236    1.381
 BGC           C4     C    CH1       0.000     -2.814   -0.225    0.304
 BGC           H4     H    H         0.000     -2.971   -1.312    0.307
 BGC           O4     O    OH1       0.000     -4.058    0.438    0.539
 BGC           HD     H    H         0.000     -4.684    0.204   -0.161
 BGC           C3     C    CH1       0.000     -2.250    0.209   -1.052
 BGC           H3     H    H         0.000     -2.191    1.306   -1.093
 BGC           O3     O    OH1       0.000     -3.096   -0.264   -2.102
 BGC           HC     H    H         0.000     -2.729    0.002   -2.955
 BGC           C6     C    CH2       0.000     -2.389   -0.246    2.765
 BGC           H6C1   H    H         0.000     -2.564   -1.323    2.785
 BGC           H6C2   H    H         0.000     -3.332    0.278    2.930
 BGC           O6     O    OH1       0.000     -1.461    0.107    3.792
 BGC           H6     H    H         0.000     -1.858   -0.159    4.632
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BGC      C1     n/a    O5     START
 BGC      H1     C1     .      .
 BGC      O1     C1     HA     .
 BGC      HA     O1     .      .
 BGC      C2     C1     O2     .
 BGC      H2     C2     .      .
 BGC      O2     C2     HB     .
 BGC      HB     O2     .      .
 BGC      O5     C1     .      END
 BGC      C5     O5     C6     .
 BGC      H5     C5     .      .
 BGC      C4     C5     C3     .
 BGC      H4     C4     .      .
 BGC      O4     C4     HD     .
 BGC      HD     O4     .      .
 BGC      C3     C4     O3     .
 BGC      H3     C3     .      .
 BGC      O3     C3     HC     .
 BGC      HC     O3     .      .
 BGC      C6     C5     O6     .
 BGC      H6C1   C6     .      .
 BGC      H6C2   C6     .      .
 BGC      O6     C6     .      .
 BGC      H6     O6     .      .
 BGC      C2     C3     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BGC      C2     C3        single      1.524    0.020
 BGC      C2     C1        single      1.524    0.020
 BGC      O2     C2        single      1.432    0.020
 BGC      H2     C2        single      1.099    0.020
 BGC      C3     C4        single      1.524    0.020
 BGC      O3     C3        single      1.432    0.020
 BGC      H3     C3        single      1.099    0.020
 BGC      C4     C5        single      1.524    0.020
 BGC      O4     C4        single      1.432    0.020
 BGC      H4     C4        single      1.099    0.020
 BGC      C6     C5        single      1.524    0.020
 BGC      C5     O5        single      1.426    0.020
 BGC      H5     C5        single      1.099    0.020
 BGC      O6     C6        single      1.432    0.020
 BGC      H6C1   C6        single      1.092    0.020
 BGC      H6C2   C6        single      1.092    0.020
 BGC      O1     C1        single      1.432    0.020
 BGC      O5     C1        single      1.426    0.020
 BGC      H1     C1        single      1.099    0.020
 BGC      HA     O1        single      0.967    0.020
 BGC      HB     O2        single      0.967    0.020
 BGC      HC     O3        single      0.967    0.020
 BGC      HD     O4        single      0.967    0.020
 BGC      H6     O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BGC      H1     C1     O1      109.470    3.000
 BGC      H1     C1     C2      108.340    3.000
 BGC      O1     C1     C2      109.470    3.000
 BGC      H1     C1     O5      109.470    3.000
 BGC      O1     C1     O5      109.470    3.000
 BGC      C2     C1     O5      109.470    3.000
 BGC      C1     O1     HA      109.470    3.000
 BGC      C1     C2     H2      108.340    3.000
 BGC      C1     C2     O2      109.470    3.000
 BGC      C1     C2     C3      111.000    3.000
 BGC      H2     C2     O2      109.470    3.000
 BGC      H2     C2     C3      108.340    3.000
 BGC      O2     C2     C3      109.470    3.000
 BGC      C2     O2     HB      109.470    3.000
 BGC      C1     O5     C5      111.800    3.000
 BGC      O5     C5     H5      109.470    3.000
 BGC      O5     C5     C4      109.470    3.000
 BGC      O5     C5     C6      109.470    3.000
 BGC      H5     C5     C4      108.340    3.000
 BGC      H5     C5     C6      108.340    3.000
 BGC      C4     C5     C6      111.000    3.000
 BGC      C5     C4     H4      108.340    3.000
 BGC      C5     C4     O4      109.470    3.000
 BGC      C5     C4     C3      111.000    3.000
 BGC      H4     C4     O4      109.470    3.000
 BGC      H4     C4     C3      108.340    3.000
 BGC      O4     C4     C3      109.470    3.000
 BGC      C4     O4     HD      109.470    3.000
 BGC      C4     C3     H3      108.340    3.000
 BGC      C4     C3     O3      109.470    3.000
 BGC      C4     C3     C2      111.000    3.000
 BGC      H3     C3     O3      109.470    3.000
 BGC      H3     C3     C2      108.340    3.000
 BGC      O3     C3     C2      109.470    3.000
 BGC      C3     O3     HC      109.470    3.000
 BGC      C5     C6     H6C1    109.470    3.000
 BGC      C5     C6     H6C2    109.470    3.000
 BGC      C5     C6     O6      109.470    3.000
 BGC      H6C1   C6     H6C2    107.900    3.000
 BGC      H6C1   C6     O6      109.470    3.000
 BGC      H6C2   C6     O6      109.470    3.000
 BGC      C6     O6     H6      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BGC      var_1    O5     C1     O1     HA       -59.974   20.000   1
 BGC      var_2    O5     C1     C2     O2       180.000   20.000   3
 BGC      var_3    C1     C2     C3     C4       -60.000   20.000   3
 BGC      var_4    C1     C2     O2     HB        59.919   20.000   1
 BGC      var_5    C1     O5     C5     C6       180.000   20.000   1
 BGC      var_6    O5     C5     C4     C3       -60.000   20.000   3
 BGC      var_7    C5     C4     O4     HD       179.530   20.000   1
 BGC      var_8    C5     C4     C3     O3       180.000   20.000   3
 BGC      var_9    C4     C3     O3     HC      -179.213   20.000   1
 BGC      var_10   O5     C5     C6     O6        59.820   20.000   3
 BGC      var_1    C5     O5     C1     C2         0.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BGC      chir_01  C2     C3     C1     O2        positiv
 BGC      chir_02  C3     C2     C4     O3        positiv
 BGC      chir_03  C4     C3     C5     O4        negativ
 BGC      chir_04  C5     C4     C6     O5        negativ
 BGC      chir_05  C1     C2     O1     O5        positiv
# ------------------------------------------------------
`.trim();

monomers["LAT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
LAT      LAT 'BETA-LACTOSE                        ' saccharide         45  23 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_LAT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 LAT           "O6'"  O    OH1       0.000      0.000    0.000    0.000
 LAT           "HO6'" H    H         0.000      0.347   -0.418    0.800
 LAT           "C6'"  C    CH2       0.000     -1.414   -0.195   -0.063
 LAT           "H6'1" H    H         0.000     -1.882    0.253    0.816
 LAT           "H6'2" H    H         0.000     -1.632   -1.265   -0.085
 LAT           "C5'"  C    CH1       0.000     -1.964    0.465   -1.329
 LAT           "H5'"  H    H         0.000     -1.740    1.541   -1.305
 LAT           "O5'"  O    O2        0.000     -1.351   -0.121   -2.475
 LAT           "C1'"  C    CH1       0.000     -1.750    0.635   -3.615
 LAT           "H1'"  H    H         0.000     -1.540    1.699   -3.439
 LAT           "O1'"  O    OH1       0.000     -1.019    0.190   -4.759
 LAT           "HO1'" H    H         0.000     -0.073    0.310   -4.602
 LAT           "C4'"  C    CH1       0.000     -3.479    0.264   -1.391
 LAT           "H4'"  H    H         0.000     -3.706   -0.811   -1.435
 LAT           "C3'"  C    CH1       0.000     -4.026    0.955   -2.645
 LAT           "H3'"  H    H         0.000     -3.895    2.042   -2.552
 LAT           "O3'"  O    OH1       0.000     -5.413    0.651   -2.795
 LAT           "HO3'" H    H         0.000     -5.755    1.089   -3.586
 LAT           "C2'"  C    CH1       0.000     -3.248    0.446   -3.864
 LAT           "H2'"  H    H         0.000     -3.463   -0.621   -4.017
 LAT           "O2'"  O    OH1       0.000     -3.639    1.183   -5.023
 LAT           "HO2'" H    H         0.000     -3.148    0.860   -5.791
 LAT           O1     O    O2        0.000     -4.086    0.832   -0.229
 LAT           C1     C    CH1       0.000     -4.701   -0.242    0.484
 LAT           H1     H    H         0.000     -3.983   -1.068    0.590
 LAT           O5     O    O2        0.000     -5.843   -0.696   -0.237
 LAT           C5     C    CH1       0.000     -6.320   -1.874    0.409
 LAT           H5     H    H         0.000     -5.493   -2.589    0.522
 LAT           C6     C    CH2       0.000     -7.427   -2.506   -0.437
 LAT           H61    H    H         0.000     -8.249   -1.797   -0.548
 LAT           H62    H    H         0.000     -7.791   -3.410    0.057
 LAT           O6     O    OH1       0.000     -6.908   -2.842   -1.725
 LAT           HO6    H    H         0.000     -7.608   -3.241   -2.259
 LAT           C4     C    CH1       0.000     -6.875   -1.518    1.790
 LAT           H4     H    H         0.000     -7.260   -2.426    2.276
 LAT           O4     O    OH1       0.000     -7.932   -0.565    1.654
 LAT           HO4    H    H         0.000     -8.276   -0.339    2.528
 LAT           C3     C    CH1       0.000     -5.751   -0.920    2.642
 LAT           H3     H    H         0.000     -4.989   -1.686    2.837
 LAT           O3     O    OH1       0.000     -6.284   -0.446    3.880
 LAT           HO3    H    H         0.000     -5.573   -0.058    4.408
 LAT           C2     C    CH1       0.000     -5.123    0.246    1.871
 LAT           H2     H    H         0.000     -5.858    1.057    1.768
 LAT           O2     O    OH1       0.000     -3.978    0.728    2.579
 LAT           HO2    H    H         0.000     -3.580    1.459    2.087
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 LAT      "O6'"  n/a    "C6'"  START
 LAT      "HO6'" "O6'"  .      .
 LAT      "C6'"  "O6'"  "C5'"  .
 LAT      "H6'1" "C6'"  .      .
 LAT      "H6'2" "C6'"  .      .
 LAT      "C5'"  "C6'"  "C4'"  .
 LAT      "H5'"  "C5'"  .      .
 LAT      "O5'"  "C5'"  "C1'"  .
 LAT      "C1'"  "O5'"  "O1'"  .
 LAT      "H1'"  "C1'"  .      .
 LAT      "O1'"  "C1'"  "HO1'" .
 LAT      "HO1'" "O1'"  .      .
 LAT      "C4'"  "C5'"  O1     .
 LAT      "H4'"  "C4'"  .      .
 LAT      "C3'"  "C4'"  "C2'"  .
 LAT      "H3'"  "C3'"  .      .
 LAT      "O3'"  "C3'"  "HO3'" .
 LAT      "HO3'" "O3'"  .      .
 LAT      "C2'"  "C3'"  "O2'"  .
 LAT      "H2'"  "C2'"  .      .
 LAT      "O2'"  "C2'"  "HO2'" .
 LAT      "HO2'" "O2'"  .      .
 LAT      O1     "C4'"  C1     .
 LAT      C1     O1     O5     .
 LAT      H1     C1     .      .
 LAT      O5     C1     C5     .
 LAT      C5     O5     C4     .
 LAT      H5     C5     .      .
 LAT      C6     C5     O6     .
 LAT      H61    C6     .      .
 LAT      H62    C6     .      .
 LAT      O6     C6     HO6    .
 LAT      HO6    O6     .      .
 LAT      C4     C5     C3     .
 LAT      H4     C4     .      .
 LAT      O4     C4     HO4    .
 LAT      HO4    O4     .      .
 LAT      C3     C4     C2     .
 LAT      H3     C3     .      .
 LAT      O3     C3     HO3    .
 LAT      HO3    O3     .      .
 LAT      C2     C3     O2     .
 LAT      H2     C2     .      .
 LAT      O2     C2     HO2    .
 LAT      HO2    O2     .      END
 LAT      C1     C2     .    ADD
 LAT      "C1'"  "C2'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 LAT      C1     C2        single      1.524    0.020
 LAT      C1     O1        single      1.426    0.020
 LAT      O5     C1        single      1.426    0.020
 LAT      H1     C1        single      1.099    0.020
 LAT      C2     C3        single      1.524    0.020
 LAT      O2     C2        single      1.432    0.020
 LAT      H2     C2        single      1.099    0.020
 LAT      C3     C4        single      1.524    0.020
 LAT      O3     C3        single      1.432    0.020
 LAT      H3     C3        single      1.099    0.020
 LAT      C4     C5        single      1.524    0.020
 LAT      O4     C4        single      1.432    0.020
 LAT      H4     C4        single      1.099    0.020
 LAT      C6     C5        single      1.524    0.020
 LAT      C5     O5        single      1.426    0.020
 LAT      H5     C5        single      1.099    0.020
 LAT      O6     C6        single      1.432    0.020
 LAT      H61    C6        single      1.092    0.020
 LAT      H62    C6        single      1.092    0.020
 LAT      O1     "C4'"     single      1.426    0.020
 LAT      HO2    O2        single      0.967    0.020
 LAT      HO3    O3        single      0.967    0.020
 LAT      HO4    O4        single      0.967    0.020
 LAT      HO6    O6        single      0.967    0.020
 LAT      "C1'"  "C2'"     single      1.524    0.020
 LAT      "O1'"  "C1'"     single      1.432    0.020
 LAT      "C1'"  "O5'"     single      1.426    0.020
 LAT      "H1'"  "C1'"     single      1.099    0.020
 LAT      "C2'"  "C3'"     single      1.524    0.020
 LAT      "O2'"  "C2'"     single      1.432    0.020
 LAT      "H2'"  "C2'"     single      1.099    0.020
 LAT      "C3'"  "C4'"     single      1.524    0.020
 LAT      "O3'"  "C3'"     single      1.432    0.020
 LAT      "H3'"  "C3'"     single      1.099    0.020
 LAT      "C4'"  "C5'"     single      1.524    0.020
 LAT      "H4'"  "C4'"     single      1.099    0.020
 LAT      "C5'"  "C6'"     single      1.524    0.020
 LAT      "O5'"  "C5'"     single      1.426    0.020
 LAT      "H5'"  "C5'"     single      1.099    0.020
 LAT      "C6'"  "O6'"     single      1.432    0.020
 LAT      "H6'1" "C6'"     single      1.092    0.020
 LAT      "H6'2" "C6'"     single      1.092    0.020
 LAT      "HO1'" "O1'"     single      0.967    0.020
 LAT      "HO2'" "O2'"     single      0.967    0.020
 LAT      "HO3'" "O3'"     single      0.967    0.020
 LAT      "HO6'" "O6'"     single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 LAT      "HO6'" "O6'"  "C6'"   109.470    3.000
 LAT      "O6'"  "C6'"  "H6'1"  109.470    3.000
 LAT      "O6'"  "C6'"  "H6'2"  109.470    3.000
 LAT      "O6'"  "C6'"  "C5'"   109.470    3.000
 LAT      "H6'1" "C6'"  "H6'2"  107.900    3.000
 LAT      "H6'1" "C6'"  "C5'"   109.470    3.000
 LAT      "H6'2" "C6'"  "C5'"   109.470    3.000
 LAT      "C6'"  "C5'"  "H5'"   108.340    3.000
 LAT      "C6'"  "C5'"  "O5'"   109.470    3.000
 LAT      "C6'"  "C5'"  "C4'"   111.000    3.000
 LAT      "H5'"  "C5'"  "O5'"   109.470    3.000
 LAT      "H5'"  "C5'"  "C4'"   108.340    3.000
 LAT      "O5'"  "C5'"  "C4'"   109.470    3.000
 LAT      "C5'"  "O5'"  "C1'"   111.800    3.000
 LAT      "O5'"  "C1'"  "H1'"   109.470    3.000
 LAT      "O5'"  "C1'"  "O1'"   109.470    3.000
 LAT      "O5'"  "C1'"  "C2'"   109.470    3.000
 LAT      "H1'"  "C1'"  "O1'"   109.470    3.000
 LAT      "H1'"  "C1'"  "C2'"   108.340    3.000
 LAT      "O1'"  "C1'"  "C2'"   109.470    3.000
 LAT      "C1'"  "O1'"  "HO1'"  109.470    3.000
 LAT      "C5'"  "C4'"  "H4'"   108.340    3.000
 LAT      "C5'"  "C4'"  "C3'"   111.000    3.000
 LAT      "C5'"  "C4'"  O1      109.470    3.000
 LAT      "H4'"  "C4'"  "C3'"   108.340    3.000
 LAT      "H4'"  "C4'"  O1      109.470    3.000
 LAT      "C3'"  "C4'"  O1      109.470    3.000
 LAT      "C4'"  "C3'"  "H3'"   108.340    3.000
 LAT      "C4'"  "C3'"  "O3'"   109.470    3.000
 LAT      "C4'"  "C3'"  "C2'"   111.000    3.000
 LAT      "H3'"  "C3'"  "O3'"   109.470    3.000
 LAT      "H3'"  "C3'"  "C2'"   108.340    3.000
 LAT      "O3'"  "C3'"  "C2'"   109.470    3.000
 LAT      "C3'"  "O3'"  "HO3'"  109.470    3.000
 LAT      "C3'"  "C2'"  "H2'"   108.340    3.000
 LAT      "C3'"  "C2'"  "O2'"   109.470    3.000
 LAT      "C3'"  "C2'"  "C1'"   111.000    3.000
 LAT      "H2'"  "C2'"  "O2'"   109.470    3.000
 LAT      "H2'"  "C2'"  "C1'"   108.340    3.000
 LAT      "O2'"  "C2'"  "C1'"   109.470    3.000
 LAT      "C2'"  "O2'"  "HO2'"  109.470    3.000
 LAT      "C4'"  O1     C1      111.800    3.000
 LAT      O1     C1     H1      109.470    3.000
 LAT      O1     C1     O5      109.470    3.000
 LAT      O1     C1     C2      109.470    3.000
 LAT      H1     C1     O5      109.470    3.000
 LAT      H1     C1     C2      108.340    3.000
 LAT      O5     C1     C2      109.470    3.000
 LAT      C1     O5     C5      111.800    3.000
 LAT      O5     C5     H5      109.470    3.000
 LAT      O5     C5     C6      109.470    3.000
 LAT      O5     C5     C4      109.470    3.000
 LAT      H5     C5     C6      108.340    3.000
 LAT      H5     C5     C4      108.340    3.000
 LAT      C6     C5     C4      111.000    3.000
 LAT      C5     C6     H61     109.470    3.000
 LAT      C5     C6     H62     109.470    3.000
 LAT      C5     C6     O6      109.470    3.000
 LAT      H61    C6     H62     107.900    3.000
 LAT      H61    C6     O6      109.470    3.000
 LAT      H62    C6     O6      109.470    3.000
 LAT      C6     O6     HO6     109.470    3.000
 LAT      C5     C4     H4      108.340    3.000
 LAT      C5     C4     O4      109.470    3.000
 LAT      C5     C4     C3      111.000    3.000
 LAT      H4     C4     O4      109.470    3.000
 LAT      H4     C4     C3      108.340    3.000
 LAT      O4     C4     C3      109.470    3.000
 LAT      C4     O4     HO4     109.470    3.000
 LAT      C4     C3     H3      108.340    3.000
 LAT      C4     C3     O3      109.470    3.000
 LAT      C4     C3     C2      111.000    3.000
 LAT      H3     C3     O3      109.470    3.000
 LAT      H3     C3     C2      108.340    3.000
 LAT      O3     C3     C2      109.470    3.000
 LAT      C3     O3     HO3     109.470    3.000
 LAT      C3     C2     H2      108.340    3.000
 LAT      C3     C2     O2      109.470    3.000
 LAT      C3     C2     C1      111.000    3.000
 LAT      H2     C2     O2      109.470    3.000
 LAT      H2     C2     C1      108.340    3.000
 LAT      O2     C2     C1      109.470    3.000
 LAT      C2     O2     HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 LAT      var_1    "HO6'" "O6'"  "C6'"  "C5'"    179.995   20.000   1
 LAT      var_2    "O6'"  "C6'"  "C5'"  "C4'"   -179.639   20.000   3
 LAT      var_3    "C6'"  "C5'"  "O5'"  "C1'"    180.000   20.000   1
 LAT      var_4    "C5'"  "O5'"  "C1'"  "O1'"    180.000   20.000   1
 LAT      var_5    "O5'"  "C1'"  "C2'"  "C3'"     60.000   20.000   3
 LAT      var_6    "O5'"  "C1'"  "O1'"  "HO1'"   -59.725   20.000   1
 LAT      var_7    "C6'"  "C5'"  "C4'"  O1        60.000   20.000   3
 LAT      var_8    "C5'"  "C4'"  "C3'"  "C2'"     60.000   20.000   3
 LAT      var_9    "C4'"  "C3'"  "O3'"  "HO3'"   179.970   20.000   1
 LAT      var_10   "C4'"  "C3'"  "C2'"  "O2'"    180.000   20.000   3
 LAT      var_11   "C3'"  "C2'"  "O2'"  "HO2'"  -179.973   20.000   1
 LAT      var_12   "C5'"  "C4'"  O1     C1      -116.888   20.000   1
 LAT      var_13   "C4'"  O1     C1     O5       -71.008   20.000   1
 LAT      var_14   O1     C1     C2     C3       180.000   20.000   3
 LAT      var_15   O1     C1     O5     C5       180.000   20.000   1
 LAT      var_16   C1     O5     C5     C4        60.000   20.000   1
 LAT      var_17   O5     C5     C6     O6        59.842   20.000   3
 LAT      var_18   C5     C6     O6     HO6      180.000   20.000   1
 LAT      var_19   O5     C5     C4     C3       -60.000   20.000   3
 LAT      var_20   C5     C4     O4     HO4     -179.645   20.000   1
 LAT      var_21   C5     C4     C3     C2        60.000   20.000   3
 LAT      var_22   C4     C3     O3     HO3     -179.201   20.000   1
 LAT      var_23   C4     C3     C2     O2       180.000   20.000   3
 LAT      var_24   C3     C2     O2     HO2      179.584   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 LAT      chir_01  C1     C2     O1     O5        positiv
 LAT      chir_02  C2     C1     C3     O2        negativ
 LAT      chir_03  C3     C2     C4     O3        positiv
 LAT      chir_04  C4     C3     C5     O4        positiv
 LAT      chir_05  C5     C4     C6     O5        negativ
 LAT      chir_06  "C1'"  "C2'"  "O1'"  "O5'"     positiv
 LAT      chir_07  "C2'"  "C1'"  "C3'"  "O2'"     negativ
 LAT      chir_08  "C3'"  "C2'"  "C4'"  "O3'"     positiv
 LAT      chir_09  "C4'"  O1     "C3'"  "C5'"     negativ
 LAT      chir_10  "C5'"  "C4'"  "C6'"  "O5'"     negativ
# ------------------------------------------------------
`.trim();

monomers["LBT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
LBT      LBT 'ALPHA-LACTOSE                       ' saccharide         45  23 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_LBT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 LBT           "O6'"  O    OH1       0.000      0.000    0.000    0.000
 LBT           "H6'"  H    H         0.000      0.335   -0.386    0.821
 LBT           "C6'"  C    CH2       0.000     -1.407   -0.230   -0.094
 LBT           "H6'1" H    H         0.000     -1.909    0.232    0.759
 LBT           "H6'2" H    H         0.000     -1.601   -1.305   -0.089
 LBT           "C5'"  C    CH1       0.000     -1.938    0.381   -1.392
 LBT           "H5'"  H    H         0.000     -1.738    1.462   -1.396
 LBT           "O5'"  O    O2        0.000     -1.281   -0.225   -2.504
 LBT           "C1'"  C    CH1       0.000     -1.667    0.489   -3.677
 LBT           "H1'"  H    H         0.000     -1.074    0.135   -4.532
 LBT           "O1'"  O    OH1       0.000     -1.432    1.884   -3.482
 LBT           HD     H    H         0.000     -0.493    2.030   -3.304
 LBT           "C4'"  C    CH1       0.000     -3.446    0.143   -1.490
 LBT           "H4'"  H    H         0.000     -3.648   -0.937   -1.508
 LBT           "C3'"  C    CH1       0.000     -3.973    0.784   -2.777
 LBT           "H3'"  H    H         0.000     -3.869    1.877   -2.714
 LBT           "O3'"  O    OH1       0.000     -5.349    0.444   -2.953
 LBT           HF     H    H         0.000     -5.679    0.850   -3.766
 LBT           "C2'"  C    CH1       0.000     -3.153    0.258   -3.959
 LBT           "H2'"  H    H         0.000     -3.340   -0.818   -4.085
 LBT           "O2'"  O    OH1       0.000     -3.529    0.952   -5.149
 LBT           HE     H    H         0.000     -3.010    0.618   -5.894
 LBT           O1     O    O2        0.000     -4.096    0.731   -0.361
 LBT           C1     C    CH1       0.000     -4.706   -0.336    0.367
 LBT           H1     H    H         0.000     -3.973   -1.142    0.517
 LBT           O5     O    O2        0.000     -5.818   -0.838   -0.369
 LBT           C5     C    CH1       0.000     -6.286   -2.007    0.299
 LBT           H5     H    H         0.000     -5.447   -2.699    0.455
 LBT           C6     C    CH2       0.000     -7.356   -2.688   -0.557
 LBT           H6C1   H    H         0.000     -8.190   -2.001   -0.711
 LBT           H6C2   H    H         0.000     -7.713   -3.584   -0.047
 LBT           O6     O    OH1       0.000     -6.795   -3.049   -1.821
 LBT           H6     H    H         0.000     -7.471   -3.479   -2.361
 LBT           C4     C    CH1       0.000     -6.887   -1.623    1.654
 LBT           H4     H    H         0.000     -7.265   -2.524    2.157
 LBT           O4     O    OH1       0.000     -7.959   -0.700    1.461
 LBT           HC     H    H         0.000     -8.331   -0.456    2.319
 LBT           C3     C    CH1       0.000     -5.799   -0.974    2.516
 LBT           H3     H    H         0.000     -5.025   -1.717    2.754
 LBT           O3     O    OH1       0.000     -6.375   -0.477    3.725
 LBT           HB     H    H         0.000     -5.688   -0.058    4.260
 LBT           C2     C    CH1       0.000     -5.177    0.183    1.729
 LBT           H2     H    H         0.000     -5.926    0.973    1.581
 LBT           O2     O    OH1       0.000     -4.062    0.710    2.450
 LBT           HA     H    H         0.000     -3.667    1.436    1.948
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 LBT      "O6'"  n/a    "C6'"  START
 LBT      "H6'"  "O6'"  .      .
 LBT      "C6'"  "O6'"  "C5'"  .
 LBT      "H6'1" "C6'"  .      .
 LBT      "H6'2" "C6'"  .      .
 LBT      "C5'"  "C6'"  "C4'"  .
 LBT      "H5'"  "C5'"  .      .
 LBT      "O5'"  "C5'"  "C1'"  .
 LBT      "C1'"  "O5'"  "O1'"  .
 LBT      "H1'"  "C1'"  .      .
 LBT      "O1'"  "C1'"  HD     .
 LBT      HD     "O1'"  .      .
 LBT      "C4'"  "C5'"  O1     .
 LBT      "H4'"  "C4'"  .      .
 LBT      "C3'"  "C4'"  "C2'"  .
 LBT      "H3'"  "C3'"  .      .
 LBT      "O3'"  "C3'"  HF     .
 LBT      HF     "O3'"  .      .
 LBT      "C2'"  "C3'"  "O2'"  .
 LBT      "H2'"  "C2'"  .      .
 LBT      "O2'"  "C2'"  HE     .
 LBT      HE     "O2'"  .      .
 LBT      O1     "C4'"  C1     .
 LBT      C1     O1     O5     .
 LBT      H1     C1     .      .
 LBT      O5     C1     C5     .
 LBT      C5     O5     C4     .
 LBT      H5     C5     .      .
 LBT      C6     C5     O6     .
 LBT      H6C1   C6     .      .
 LBT      H6C2   C6     .      .
 LBT      O6     C6     H6     .
 LBT      H6     O6     .      .
 LBT      C4     C5     C3     .
 LBT      H4     C4     .      .
 LBT      O4     C4     HC     .
 LBT      HC     O4     .      .
 LBT      C3     C4     C2     .
 LBT      H3     C3     .      .
 LBT      O3     C3     HB     .
 LBT      HB     O3     .      .
 LBT      C2     C3     O2     .
 LBT      H2     C2     .      .
 LBT      O2     C2     HA     .
 LBT      HA     O2     .      END
 LBT      C1     C2     .    ADD
 LBT      "C1'"  "C2'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 LBT      C1     C2        single      1.524    0.020
 LBT      C1     O1        single      1.426    0.020
 LBT      O5     C1        single      1.426    0.020
 LBT      H1     C1        single      1.099    0.020
 LBT      C2     C3        single      1.524    0.020
 LBT      O2     C2        single      1.432    0.020
 LBT      H2     C2        single      1.099    0.020
 LBT      C3     C4        single      1.524    0.020
 LBT      O3     C3        single      1.432    0.020
 LBT      H3     C3        single      1.099    0.020
 LBT      C4     C5        single      1.524    0.020
 LBT      O4     C4        single      1.432    0.020
 LBT      H4     C4        single      1.099    0.020
 LBT      C6     C5        single      1.524    0.020
 LBT      C5     O5        single      1.426    0.020
 LBT      H5     C5        single      1.099    0.020
 LBT      O6     C6        single      1.432    0.020
 LBT      H6C1   C6        single      1.092    0.020
 LBT      H6C2   C6        single      1.092    0.020
 LBT      O1     "C4'"     single      1.426    0.020
 LBT      HA     O2        single      0.967    0.020
 LBT      HB     O3        single      0.967    0.020
 LBT      HC     O4        single      0.967    0.020
 LBT      H6     O6        single      0.967    0.020
 LBT      "C1'"  "C2'"     single      1.524    0.020
 LBT      "O1'"  "C1'"     single      1.432    0.020
 LBT      "C1'"  "O5'"     single      1.426    0.020
 LBT      "H1'"  "C1'"     single      1.099    0.020
 LBT      "C2'"  "C3'"     single      1.524    0.020
 LBT      "O2'"  "C2'"     single      1.432    0.020
 LBT      "H2'"  "C2'"     single      1.099    0.020
 LBT      "C3'"  "C4'"     single      1.524    0.020
 LBT      "O3'"  "C3'"     single      1.432    0.020
 LBT      "H3'"  "C3'"     single      1.099    0.020
 LBT      "C4'"  "C5'"     single      1.524    0.020
 LBT      "H4'"  "C4'"     single      1.099    0.020
 LBT      "C5'"  "C6'"     single      1.524    0.020
 LBT      "O5'"  "C5'"     single      1.426    0.020
 LBT      "H5'"  "C5'"     single      1.099    0.020
 LBT      "C6'"  "O6'"     single      1.432    0.020
 LBT      "H6'1" "C6'"     single      1.092    0.020
 LBT      "H6'2" "C6'"     single      1.092    0.020
 LBT      HD     "O1'"     single      0.967    0.020
 LBT      HE     "O2'"     single      0.967    0.020
 LBT      HF     "O3'"     single      0.967    0.020
 LBT      "H6'"  "O6'"     single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 LBT      "H6'"  "O6'"  "C6'"   109.470    3.000
 LBT      "O6'"  "C6'"  "H6'1"  109.470    3.000
 LBT      "O6'"  "C6'"  "H6'2"  109.470    3.000
 LBT      "O6'"  "C6'"  "C5'"   109.470    3.000
 LBT      "H6'1" "C6'"  "H6'2"  107.900    3.000
 LBT      "H6'1" "C6'"  "C5'"   109.470    3.000
 LBT      "H6'2" "C6'"  "C5'"   109.470    3.000
 LBT      "C6'"  "C5'"  "H5'"   108.340    3.000
 LBT      "C6'"  "C5'"  "O5'"   109.470    3.000
 LBT      "C6'"  "C5'"  "C4'"   111.000    3.000
 LBT      "H5'"  "C5'"  "O5'"   109.470    3.000
 LBT      "H5'"  "C5'"  "C4'"   108.340    3.000
 LBT      "O5'"  "C5'"  "C4'"   109.470    3.000
 LBT      "C5'"  "O5'"  "C1'"   111.800    3.000
 LBT      "O5'"  "C1'"  "H1'"   109.470    3.000
 LBT      "O5'"  "C1'"  "O1'"   109.470    3.000
 LBT      "O5'"  "C1'"  "C2'"   109.470    3.000
 LBT      "H1'"  "C1'"  "O1'"   109.470    3.000
 LBT      "H1'"  "C1'"  "C2'"   108.340    3.000
 LBT      "O1'"  "C1'"  "C2'"   109.470    3.000
 LBT      "C1'"  "O1'"  HD      109.470    3.000
 LBT      "C5'"  "C4'"  "H4'"   108.340    3.000
 LBT      "C5'"  "C4'"  "C3'"   111.000    3.000
 LBT      "C5'"  "C4'"  O1      109.470    3.000
 LBT      "H4'"  "C4'"  "C3'"   108.340    3.000
 LBT      "H4'"  "C4'"  O1      109.470    3.000
 LBT      "C3'"  "C4'"  O1      109.470    3.000
 LBT      "C4'"  "C3'"  "H3'"   108.340    3.000
 LBT      "C4'"  "C3'"  "O3'"   109.470    3.000
 LBT      "C4'"  "C3'"  "C2'"   111.000    3.000
 LBT      "H3'"  "C3'"  "O3'"   109.470    3.000
 LBT      "H3'"  "C3'"  "C2'"   108.340    3.000
 LBT      "O3'"  "C3'"  "C2'"   109.470    3.000
 LBT      "C3'"  "O3'"  HF      109.470    3.000
 LBT      "C3'"  "C2'"  "H2'"   108.340    3.000
 LBT      "C3'"  "C2'"  "O2'"   109.470    3.000
 LBT      "C3'"  "C2'"  "C1'"   111.000    3.000
 LBT      "H2'"  "C2'"  "O2'"   109.470    3.000
 LBT      "H2'"  "C2'"  "C1'"   108.340    3.000
 LBT      "O2'"  "C2'"  "C1'"   109.470    3.000
 LBT      "C2'"  "O2'"  HE      109.470    3.000
 LBT      "C4'"  O1     C1      111.800    3.000
 LBT      O1     C1     H1      109.470    3.000
 LBT      O1     C1     O5      109.470    3.000
 LBT      O1     C1     C2      109.470    3.000
 LBT      H1     C1     O5      109.470    3.000
 LBT      H1     C1     C2      108.340    3.000
 LBT      O5     C1     C2      109.470    3.000
 LBT      C1     O5     C5      111.800    3.000
 LBT      O5     C5     H5      109.470    3.000
 LBT      O5     C5     C6      109.470    3.000
 LBT      O5     C5     C4      109.470    3.000
 LBT      H5     C5     C6      108.340    3.000
 LBT      H5     C5     C4      108.340    3.000
 LBT      C6     C5     C4      111.000    3.000
 LBT      C5     C6     H6C1    109.470    3.000
 LBT      C5     C6     H6C2    109.470    3.000
 LBT      C5     C6     O6      109.470    3.000
 LBT      H6C1   C6     H6C2    107.900    3.000
 LBT      H6C1   C6     O6      109.470    3.000
 LBT      H6C2   C6     O6      109.470    3.000
 LBT      C6     O6     H6      109.470    3.000
 LBT      C5     C4     H4      108.340    3.000
 LBT      C5     C4     O4      109.470    3.000
 LBT      C5     C4     C3      111.000    3.000
 LBT      H4     C4     O4      109.470    3.000
 LBT      H4     C4     C3      108.340    3.000
 LBT      O4     C4     C3      109.470    3.000
 LBT      C4     O4     HC      109.470    3.000
 LBT      C4     C3     H3      108.340    3.000
 LBT      C4     C3     O3      109.470    3.000
 LBT      C4     C3     C2      111.000    3.000
 LBT      H3     C3     O3      109.470    3.000
 LBT      H3     C3     C2      108.340    3.000
 LBT      O3     C3     C2      109.470    3.000
 LBT      C3     O3     HB      109.470    3.000
 LBT      C3     C2     H2      108.340    3.000
 LBT      C3     C2     O2      109.470    3.000
 LBT      C3     C2     C1      111.000    3.000
 LBT      H2     C2     O2      109.470    3.000
 LBT      H2     C2     C1      108.340    3.000
 LBT      O2     C2     C1      109.470    3.000
 LBT      C2     O2     HA      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 LBT      var_1    "H6'"  "O6'"  "C6'"  "C5'"    179.990   20.000   1
 LBT      var_2    "O6'"  "C6'"  "C5'"  "C4'"   -179.647   20.000   3
 LBT      var_3    "C6'"  "C5'"  "O5'"  "C1'"    180.000   20.000   1
 LBT      var_4    "C5'"  "O5'"  "C1'"  "O1'"     60.000   20.000   1
 LBT      var_5    "O5'"  "C1'"  "C2'"  "C3'"     60.000   20.000   3
 LBT      var_6    "O5'"  "C1'"  "O1'"  HD        59.726   20.000   1
 LBT      var_7    "C6'"  "C5'"  "C4'"  O1        60.000   20.000   3
 LBT      var_8    "C5'"  "C4'"  "C3'"  "C2'"     60.000   20.000   3
 LBT      var_9    "C4'"  "C3'"  "O3'"  HF       179.994   20.000   1
 LBT      var_10   "C4'"  "C3'"  "C2'"  "O2'"    180.000   20.000   3
 LBT      var_11   "C3'"  "C2'"  "O2'"  HE       179.978   20.000   1
 LBT      var_12   "C5'"  "C4'"  O1     C1      -116.878   20.000   1
 LBT      var_13   "C4'"  O1     C1     O5       -71.002   20.000   1
 LBT      var_14   O1     C1     C2     C3       180.000   20.000   3
 LBT      var_15   O1     C1     O5     C5       180.000   20.000   1
 LBT      var_16   C1     O5     C5     C4        60.000   20.000   1
 LBT      var_17   O5     C5     C6     O6        59.840   20.000   3
 LBT      var_18   C5     C6     O6     H6       179.986   20.000   1
 LBT      var_19   O5     C5     C4     C3       -60.000   20.000   3
 LBT      var_20   C5     C4     O4     HC      -179.614   20.000   1
 LBT      var_21   C5     C4     C3     C2        60.000   20.000   3
 LBT      var_22   C4     C3     O3     HB      -179.196   20.000   1
 LBT      var_23   C4     C3     C2     O2       180.000   20.000   3
 LBT      var_24   C3     C2     O2     HA       179.583   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 LBT      chir_01  C1     C2     O1     O5        positiv
 LBT      chir_02  C2     C1     C3     O2        negativ
 LBT      chir_03  C3     C2     C4     O3        positiv
 LBT      chir_04  C4     C3     C5     O4        positiv
 LBT      chir_05  C5     C4     C6     O5        negativ
 LBT      chir_06  "C1'"  "C2'"  "O1'"  "O5'"     negativ
 LBT      chir_07  "C2'"  "C1'"  "C3'"  "O2'"     negativ
 LBT      chir_08  "C3'"  "C2'"  "C4'"  "O3'"     positiv
 LBT      chir_09  "C4'"  O1     "C3'"  "C5'"     negativ
 LBT      chir_10  "C5'"  "C4'"  "C6'"  "O5'"     negativ
# ------------------------------------------------------
`.trim();

monomers["BNG"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BNG      BNG 'B-NONYLGLUCOSIDE                    ' pyranose           51  21 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BNG
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BNG           C1     C    CH1       0.000      0.000    0.000    0.000
 BNG           H1     H    H         0.000      0.002    1.096   -0.082
 BNG           O1     O    O2        0.000     -0.641   -0.384    1.219
 BNG           "C1'"  C    CH2       0.000     -1.974    0.123    1.161
 BNG           "H1'1" H    H         0.000     -2.489   -0.306    0.299
 BNG           "H1'2" H    H         0.000     -1.946    1.210    1.063
 BNG           "C2'"  C    CH2       0.000     -2.719   -0.255    2.442
 BNG           "H2'1" H    H         0.000     -2.202    0.174    3.303
 BNG           "H2'2" H    H         0.000     -2.745   -1.343    2.539
 BNG           "C3'"  C    CH2       0.000     -4.148    0.287    2.381
 BNG           "H3'1" H    H         0.000     -4.663   -0.142    1.519
 BNG           "H3'2" H    H         0.000     -4.120    1.374    2.283
 BNG           "C4'"  C    CH2       0.000     -4.893   -0.092    3.662
 BNG           "H4'1" H    H         0.000     -4.376    0.336    4.523
 BNG           "H4'2" H    H         0.000     -4.919   -1.180    3.758
 BNG           "C5'"  C    CH2       0.000     -6.322    0.450    3.602
 BNG           "H5'1" H    H         0.000     -6.836    0.022    2.739
 BNG           "H5'2" H    H         0.000     -6.293    1.537    3.504
 BNG           "C6'"  C    CH2       0.000     -7.068    0.072    4.883
 BNG           "H6'1" H    H         0.000     -6.551    0.501    5.744
 BNG           "H6'2" H    H         0.000     -7.094   -1.015    4.979
 BNG           "C7'"  C    CH2       0.000     -8.496    0.614    4.822
 BNG           "H7'1" H    H         0.000     -9.010    0.186    3.959
 BNG           "H7'2" H    H         0.000     -8.467    1.702    4.724
 BNG           "C8'"  C    CH2       0.000     -9.242    0.236    6.103
 BNG           "H8'1" H    H         0.000     -8.724    0.665    6.964
 BNG           "H8'2" H    H         0.000     -9.268   -0.851    6.199
 BNG           "C9'"  C    CH3       0.000    -10.670    0.779    6.043
 BNG           "H9'3" H    H         0.000    -10.647    1.834    5.948
 BNG           "H9'2" H    H         0.000    -11.175    0.363    5.208
 BNG           "H9'1" H    H         0.000    -11.189    0.518    6.930
 BNG           O5     O    O2        0.000     -0.709   -0.555   -1.104
 BNG           C5     C    CH1       0.000     -0.151   -0.005   -2.296
 BNG           H5     H    H         0.000     -0.140    1.091   -2.222
 BNG           C4     C    CH1       0.000      1.279   -0.517   -2.484
 BNG           H4     H    H         0.000      1.273   -1.615   -2.536
 BNG           O4     O    OH1       0.000      1.821    0.015   -3.694
 BNG           HO4    H    H         0.000      2.725   -0.309   -3.810
 BNG           C3     C    CH1       0.000      2.131   -0.065   -1.294
 BNG           H3     H    H         0.000      2.224    1.030   -1.302
 BNG           O3     O    OH1       0.000      3.428   -0.657   -1.381
 BNG           HO3    H    H         0.000      3.963   -0.370   -0.629
 BNG           C2     C    CH1       0.000      1.442   -0.512    0.000
 BNG           H2     H    H         0.000      1.443   -1.610    0.056
 BNG           O2     O    OH1       0.000      2.141    0.025    1.124
 BNG           HO2    H    H         0.000      1.705   -0.259    1.939
 BNG           C6     C    CH2       0.000     -1.002   -0.424   -3.496
 BNG           H61    H    H         0.000     -1.014   -1.514   -3.570
 BNG           H62    H    H         0.000     -0.574   -0.003   -4.409
 BNG           O6     O    OH1       0.000     -2.337    0.058   -3.327
 BNG           HO6    H    H         0.000     -2.838   -0.226   -4.103
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BNG      C1     n/a    O5     START
 BNG      H1     C1     .      .
 BNG      O1     C1     "C1'"  .
 BNG      "C1'"  O1     "C2'"  .
 BNG      "H1'1" "C1'"  .      .
 BNG      "H1'2" "C1'"  .      .
 BNG      "C2'"  "C1'"  "C3'"  .
 BNG      "H2'1" "C2'"  .      .
 BNG      "H2'2" "C2'"  .      .
 BNG      "C3'"  "C2'"  "C4'"  .
 BNG      "H3'1" "C3'"  .      .
 BNG      "H3'2" "C3'"  .      .
 BNG      "C4'"  "C3'"  "C5'"  .
 BNG      "H4'1" "C4'"  .      .
 BNG      "H4'2" "C4'"  .      .
 BNG      "C5'"  "C4'"  "C6'"  .
 BNG      "H5'1" "C5'"  .      .
 BNG      "H5'2" "C5'"  .      .
 BNG      "C6'"  "C5'"  "C7'"  .
 BNG      "H6'1" "C6'"  .      .
 BNG      "H6'2" "C6'"  .      .
 BNG      "C7'"  "C6'"  "C8'"  .
 BNG      "H7'1" "C7'"  .      .
 BNG      "H7'2" "C7'"  .      .
 BNG      "C8'"  "C7'"  "C9'"  .
 BNG      "H8'1" "C8'"  .      .
 BNG      "H8'2" "C8'"  .      .
 BNG      "C9'"  "C8'"  "H9'1" .
 BNG      "H9'3" "C9'"  .      .
 BNG      "H9'2" "C9'"  .      .
 BNG      "H9'1" "C9'"  .      .
 BNG      O5     C1     .      END
 BNG      C5     O5     C6     .
 BNG      H5     C5     .      .
 BNG      C4     C5     C3     .
 BNG      H4     C4     .      .
 BNG      O4     C4     HO4    .
 BNG      HO4    O4     .      .
 BNG      C3     C4     C2     .
 BNG      H3     C3     .      .
 BNG      O3     C3     HO3    .
 BNG      HO3    O3     .      .
 BNG      C2     C3     O2     .
 BNG      H2     C2     .      .
 BNG      O2     C2     HO2    .
 BNG      HO2    O2     .      .
 BNG      C6     C5     O6     .
 BNG      H61    C6     .      .
 BNG      H62    C6     .      .
 BNG      O6     C6     .      .
 BNG      HO6    O6     .      .
 BNG      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BNG      C1     C2        single      1.524    0.020
 BNG      O1     C1        single      1.426    0.020
 BNG      O5     C1        single      1.426    0.020
 BNG      H1     C1        single      1.099    0.020
 BNG      C2     C3        single      1.524    0.020
 BNG      O2     C2        single      1.432    0.020
 BNG      H2     C2        single      1.099    0.020
 BNG      C3     C4        single      1.524    0.020
 BNG      O3     C3        single      1.432    0.020
 BNG      H3     C3        single      1.099    0.020
 BNG      C4     C5        single      1.524    0.020
 BNG      O4     C4        single      1.432    0.020
 BNG      H4     C4        single      1.099    0.020
 BNG      C6     C5        single      1.524    0.020
 BNG      C5     O5        single      1.426    0.020
 BNG      H5     C5        single      1.099    0.020
 BNG      O6     C6        single      1.432    0.020
 BNG      H61    C6        single      1.092    0.020
 BNG      H62    C6        single      1.092    0.020
 BNG      "C2'"  "C1'"     single      1.524    0.020
 BNG      "C1'"  O1        single      1.426    0.020
 BNG      "H1'1" "C1'"     single      1.092    0.020
 BNG      "H1'2" "C1'"     single      1.092    0.020
 BNG      "C3'"  "C2'"     single      1.524    0.020
 BNG      "H2'1" "C2'"     single      1.092    0.020
 BNG      "H2'2" "C2'"     single      1.092    0.020
 BNG      "C4'"  "C3'"     single      1.524    0.020
 BNG      "H3'1" "C3'"     single      1.092    0.020
 BNG      "H3'2" "C3'"     single      1.092    0.020
 BNG      "C5'"  "C4'"     single      1.524    0.020
 BNG      "H4'1" "C4'"     single      1.092    0.020
 BNG      "H4'2" "C4'"     single      1.092    0.020
 BNG      "C6'"  "C5'"     single      1.524    0.020
 BNG      "H5'1" "C5'"     single      1.092    0.020
 BNG      "H5'2" "C5'"     single      1.092    0.020
 BNG      "C7'"  "C6'"     single      1.524    0.020
 BNG      "H6'1" "C6'"     single      1.092    0.020
 BNG      "H6'2" "C6'"     single      1.092    0.020
 BNG      "C8'"  "C7'"     single      1.524    0.020
 BNG      "H7'1" "C7'"     single      1.092    0.020
 BNG      "H7'2" "C7'"     single      1.092    0.020
 BNG      "C9'"  "C8'"     single      1.513    0.020
 BNG      "H8'1" "C8'"     single      1.092    0.020
 BNG      "H8'2" "C8'"     single      1.092    0.020
 BNG      "H9'1" "C9'"     single      1.059    0.020
 BNG      "H9'2" "C9'"     single      1.059    0.020
 BNG      "H9'3" "C9'"     single      1.059    0.020
 BNG      HO2    O2        single      0.967    0.020
 BNG      HO3    O3        single      0.967    0.020
 BNG      HO4    O4        single      0.967    0.020
 BNG      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BNG      H1     C1     O1      109.470    3.000
 BNG      H1     C1     O5      109.470    3.000
 BNG      O1     C1     O5      109.470    3.000
 BNG      H1     C1     C2      108.340    3.000
 BNG      O1     C1     C2      109.470    3.000
 BNG      O5     C1     C2      109.470    3.000
 BNG      C1     O1     "C1'"   111.800    3.000
 BNG      O1     "C1'"  "H1'1"  109.470    3.000
 BNG      O1     "C1'"  "H1'2"  109.470    3.000
 BNG      O1     "C1'"  "C2'"   109.470    3.000
 BNG      "H1'1" "C1'"  "H1'2"  107.900    3.000
 BNG      "H1'1" "C1'"  "C2'"   109.470    3.000
 BNG      "H1'2" "C1'"  "C2'"   109.470    3.000
 BNG      "C1'"  "C2'"  "H2'1"  109.470    3.000
 BNG      "C1'"  "C2'"  "H2'2"  109.470    3.000
 BNG      "C1'"  "C2'"  "C3'"   111.000    3.000
 BNG      "H2'1" "C2'"  "H2'2"  107.900    3.000
 BNG      "H2'1" "C2'"  "C3'"   109.470    3.000
 BNG      "H2'2" "C2'"  "C3'"   109.470    3.000
 BNG      "C2'"  "C3'"  "H3'1"  109.470    3.000
 BNG      "C2'"  "C3'"  "H3'2"  109.470    3.000
 BNG      "C2'"  "C3'"  "C4'"   111.000    3.000
 BNG      "H3'1" "C3'"  "H3'2"  107.900    3.000
 BNG      "H3'1" "C3'"  "C4'"   109.470    3.000
 BNG      "H3'2" "C3'"  "C4'"   109.470    3.000
 BNG      "C3'"  "C4'"  "H4'1"  109.470    3.000
 BNG      "C3'"  "C4'"  "H4'2"  109.470    3.000
 BNG      "C3'"  "C4'"  "C5'"   111.000    3.000
 BNG      "H4'1" "C4'"  "H4'2"  107.900    3.000
 BNG      "H4'1" "C4'"  "C5'"   109.470    3.000
 BNG      "H4'2" "C4'"  "C5'"   109.470    3.000
 BNG      "C4'"  "C5'"  "H5'1"  109.470    3.000
 BNG      "C4'"  "C5'"  "H5'2"  109.470    3.000
 BNG      "C4'"  "C5'"  "C6'"   111.000    3.000
 BNG      "H5'1" "C5'"  "H5'2"  107.900    3.000
 BNG      "H5'1" "C5'"  "C6'"   109.470    3.000
 BNG      "H5'2" "C5'"  "C6'"   109.470    3.000
 BNG      "C5'"  "C6'"  "H6'1"  109.470    3.000
 BNG      "C5'"  "C6'"  "H6'2"  109.470    3.000
 BNG      "C5'"  "C6'"  "C7'"   111.000    3.000
 BNG      "H6'1" "C6'"  "H6'2"  107.900    3.000
 BNG      "H6'1" "C6'"  "C7'"   109.470    3.000
 BNG      "H6'2" "C6'"  "C7'"   109.470    3.000
 BNG      "C6'"  "C7'"  "H7'1"  109.470    3.000
 BNG      "C6'"  "C7'"  "H7'2"  109.470    3.000
 BNG      "C6'"  "C7'"  "C8'"   111.000    3.000
 BNG      "H7'1" "C7'"  "H7'2"  107.900    3.000
 BNG      "H7'1" "C7'"  "C8'"   109.470    3.000
 BNG      "H7'2" "C7'"  "C8'"   109.470    3.000
 BNG      "C7'"  "C8'"  "H8'1"  109.470    3.000
 BNG      "C7'"  "C8'"  "H8'2"  109.470    3.000
 BNG      "C7'"  "C8'"  "C9'"   111.000    3.000
 BNG      "H8'1" "C8'"  "H8'2"  107.900    3.000
 BNG      "H8'1" "C8'"  "C9'"   109.470    3.000
 BNG      "H8'2" "C8'"  "C9'"   109.470    3.000
 BNG      "C8'"  "C9'"  "H9'3"  109.470    3.000
 BNG      "C8'"  "C9'"  "H9'2"  109.470    3.000
 BNG      "C8'"  "C9'"  "H9'1"  109.470    3.000
 BNG      "H9'3" "C9'"  "H9'2"  109.470    3.000
 BNG      "H9'3" "C9'"  "H9'1"  109.470    3.000
 BNG      "H9'2" "C9'"  "H9'1"  109.470    3.000
 BNG      C1     O5     C5      111.800    3.000
 BNG      O5     C5     H5      109.470    3.000
 BNG      O5     C5     C4      109.470    3.000
 BNG      O5     C5     C6      109.470    3.000
 BNG      H5     C5     C4      108.340    3.000
 BNG      H5     C5     C6      108.340    3.000
 BNG      C4     C5     C6      111.000    3.000
 BNG      C5     C4     H4      108.340    3.000
 BNG      C5     C4     O4      109.470    3.000
 BNG      C5     C4     C3      111.000    3.000
 BNG      H4     C4     O4      109.470    3.000
 BNG      H4     C4     C3      108.340    3.000
 BNG      O4     C4     C3      109.470    3.000
 BNG      C4     O4     HO4     109.470    3.000
 BNG      C4     C3     H3      108.340    3.000
 BNG      C4     C3     O3      109.470    3.000
 BNG      C4     C3     C2      111.000    3.000
 BNG      H3     C3     O3      109.470    3.000
 BNG      H3     C3     C2      108.340    3.000
 BNG      O3     C3     C2      109.470    3.000
 BNG      C3     O3     HO3     109.470    3.000
 BNG      C3     C2     H2      108.340    3.000
 BNG      C3     C2     O2      109.470    3.000
 BNG      C3     C2     C1      111.000    3.000
 BNG      H2     C2     O2      109.470    3.000
 BNG      H2     C2     C1      108.340    3.000
 BNG      O2     C2     C1      109.470    3.000
 BNG      C2     O2     HO2     109.470    3.000
 BNG      C5     C6     H61     109.470    3.000
 BNG      C5     C6     H62     109.470    3.000
 BNG      C5     C6     O6      109.470    3.000
 BNG      H61    C6     H62     107.900    3.000
 BNG      H61    C6     O6      109.470    3.000
 BNG      H62    C6     O6      109.470    3.000
 BNG      C6     O6     HO6     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BNG      var_1    O5     C1     O1     "C1'"    -59.799   20.000   1
 BNG      var_2    C1     O1     "C1'"  "C2'"    179.977   20.000   1
 BNG      var_3    O1     "C1'"  "C2'"  "C3'"    179.999   20.000   3
 BNG      var_4    "C1'"  "C2'"  "C3'"  "C4'"    179.965   20.000   3
 BNG      var_5    "C2'"  "C3'"  "C4'"  "C5'"    179.981   20.000   3
 BNG      var_6    "C3'"  "C4'"  "C5'"  "C6'"   -179.983   20.000   3
 BNG      var_7    "C4'"  "C5'"  "C6'"  "C7'"   -179.998   20.000   3
 BNG      var_8    "C5'"  "C6'"  "C7'"  "C8'"    180.000   20.000   3
 BNG      var_9    "C6'"  "C7'"  "C8'"  "C9'"    179.998   20.000   3
 BNG      var_10   "C7'"  "C8'"  "C9'"  "H9'1"  -179.962   20.000   3
 BNG      var_11   C1     O5     C5     C6       180.000   20.000   1
 BNG      var_12   O5     C5     C4     C3       -60.000   20.000   3
 BNG      var_13   C5     C4     O4     HO4      179.973   20.000   1
 BNG      var_14   C5     C4     C3     C2        60.000   20.000   3
 BNG      var_15   C4     C3     O3     HO3      179.996   20.000   1
 BNG      var_16   C4     C3     C2     O2       180.000   20.000   3
 BNG      var_17   C3     C2     C1     O5        60.000   20.000   3
 BNG      var_18   C3     C2     O2     HO2     -179.980   20.000   1
 BNG      var_19   O5     C5     C6     O6        59.950   20.000   3
 BNG      var_1    C5     O5     C1     C2         0.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BNG      chir_01  C1     C2     O1     O5        positiv
 BNG      chir_02  C2     C1     C3     O2        negativ
 BNG      chir_03  C3     C2     C4     O3        positiv
 BNG      chir_04  C4     C3     C5     O4        negativ
 BNG      chir_05  C5     C4     C6     O5        negativ
# ------------------------------------------------------
`.trim();

monomers["BOG"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BOG      BOG 'B-OCTYLGLUCOSIDE                    ' pyranose           48  20 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BOG
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BOG           C1     C    CH1       0.000      0.000    0.000    0.000
 BOG           H1     H    H         0.000      0.135   -1.086    0.103
 BOG           O1     O    O2        0.000     -1.360    0.279   -0.341
 BOG           "C1'"  C    CH2       0.000     -2.165   -0.233    0.721
 BOG           "H1'1" H    H         0.000     -1.890    0.259    1.656
 BOG           "H1'2" H    H         0.000     -2.001   -1.309    0.815
 BOG           "C2'"  C    CH2       0.000     -3.640    0.035    0.417
 BOG           "H2'1" H    H         0.000     -3.913   -0.458   -0.519
 BOG           "H2'2" H    H         0.000     -3.801    1.110    0.321
 BOG           "C3'"  C    CH2       0.000     -4.504   -0.514    1.554
 BOG           "H3'1" H    H         0.000     -4.228   -0.021    2.489
 BOG           "H3'2" H    H         0.000     -4.340   -1.589    1.649
 BOG           "C4'"  C    CH2       0.000     -5.979   -0.246    1.250
 BOG           "H4'1" H    H         0.000     -6.252   -0.737    0.314
 BOG           "H4'2" H    H         0.000     -6.141    0.830    1.155
 BOG           "C5'"  C    CH2       0.000     -6.843   -0.795    2.386
 BOG           "H5'1" H    H         0.000     -6.567   -0.303    3.322
 BOG           "H5'2" H    H         0.000     -6.679   -1.870    2.480
 BOG           "C6'"  C    CH2       0.000     -8.318   -0.527    2.083
 BOG           "H6'1" H    H         0.000     -8.591   -1.019    1.147
 BOG           "H6'2" H    H         0.000     -8.479    0.549    1.988
 BOG           "C7'"  C    CH2       0.000     -9.181   -1.075    3.219
 BOG           "H7'1" H    H         0.000     -8.906   -0.583    4.154
 BOG           "H7'2" H    H         0.000     -9.017   -2.151    3.314
 BOG           "C8'"  C    CH3       0.000    -10.656   -0.807    2.915
 BOG           "H8'3" H    H         0.000    -10.818    0.237    2.823
 BOG           "H8'2" H    H         0.000    -10.926   -1.285    2.008
 BOG           "H8'1" H    H         0.000    -11.257   -1.186    3.702
 BOG           O5     O    O2        0.000      0.320    0.635    1.235
 BOG           C5     C    CH1       0.000      1.615    0.188    1.628
 BOG           H5     H    H         0.000      1.639   -0.911    1.621
 BOG           C4     C    CH1       0.000      2.668    0.725    0.656
 BOG           H4     H    H         0.000      2.630    1.824    0.644
 BOG           O4     O    OH1       0.000      3.965    0.296    1.072
 BOG           HO4    H    H         0.000      4.629    0.637    0.457
 BOG           C3     C    CH1       0.000      2.372    0.187   -0.747
 BOG           H3     H    H         0.000      2.512   -0.903   -0.761
 BOG           O3     O    OH1       0.000      3.255    0.796   -1.691
 BOG           HO3    H    H         0.000      3.066    0.455   -2.575
 BOG           C2     C    CH1       0.000      0.919    0.523   -1.105
 BOG           H2     H    H         0.000      0.805    1.612   -1.194
 BOG           O2     O    OH1       0.000      0.577   -0.095   -2.346
 BOG           HO2    H    H         0.000     -0.339    0.119   -2.570
 BOG           C6     C    CH2       0.000      1.922    0.693    3.039
 BOG           H61    H    H         0.000      1.898    1.785    3.047
 BOG           H62    H    H         0.000      2.914    0.349    3.340
 BOG           O6     O    OH1       0.000      0.944    0.187    3.950
 BOG           HO6    H    H         0.000      1.174    0.528    4.825
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BOG      C1     n/a    O5     START
 BOG      H1     C1     .      .
 BOG      O1     C1     "C1'"  .
 BOG      "C1'"  O1     "C2'"  .
 BOG      "H1'1" "C1'"  .      .
 BOG      "H1'2" "C1'"  .      .
 BOG      "C2'"  "C1'"  "C3'"  .
 BOG      "H2'1" "C2'"  .      .
 BOG      "H2'2" "C2'"  .      .
 BOG      "C3'"  "C2'"  "C4'"  .
 BOG      "H3'1" "C3'"  .      .
 BOG      "H3'2" "C3'"  .      .
 BOG      "C4'"  "C3'"  "C5'"  .
 BOG      "H4'1" "C4'"  .      .
 BOG      "H4'2" "C4'"  .      .
 BOG      "C5'"  "C4'"  "C6'"  .
 BOG      "H5'1" "C5'"  .      .
 BOG      "H5'2" "C5'"  .      .
 BOG      "C6'"  "C5'"  "C7'"  .
 BOG      "H6'1" "C6'"  .      .
 BOG      "H6'2" "C6'"  .      .
 BOG      "C7'"  "C6'"  "C8'"  .
 BOG      "H7'1" "C7'"  .      .
 BOG      "H7'2" "C7'"  .      .
 BOG      "C8'"  "C7'"  "H8'1" .
 BOG      "H8'3" "C8'"  .      .
 BOG      "H8'2" "C8'"  .      .
 BOG      "H8'1" "C8'"  .      .
 BOG      O5     C1     .      END
 BOG      C5     O5     C6     .
 BOG      H5     C5     .      .
 BOG      C4     C5     C3     .
 BOG      H4     C4     .      .
 BOG      O4     C4     HO4    .
 BOG      HO4    O4     .      .
 BOG      C3     C4     C2     .
 BOG      H3     C3     .      .
 BOG      O3     C3     HO3    .
 BOG      HO3    O3     .      .
 BOG      C2     C3     O2     .
 BOG      H2     C2     .      .
 BOG      O2     C2     HO2    .
 BOG      HO2    O2     .      .
 BOG      C6     C5     O6     .
 BOG      H61    C6     .      .
 BOG      H62    C6     .      .
 BOG      O6     C6     .      .
 BOG      HO6    O6     .      .
 BOG      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BOG      O1     C1        single      1.426    0.020
 BOG      C1     C2        single      1.524    0.020
 BOG      O5     C1        single      1.426    0.020
 BOG      H1     C1        single      1.099    0.020
 BOG      "C1'"  O1        single      1.426    0.020
 BOG      O2     C2        single      1.432    0.020
 BOG      C2     C3        single      1.524    0.020
 BOG      H2     C2        single      1.099    0.020
 BOG      HO2    O2        single      0.967    0.020
 BOG      O3     C3        single      1.432    0.020
 BOG      C3     C4        single      1.524    0.020
 BOG      H3     C3        single      1.099    0.020
 BOG      HO3    O3        single      0.967    0.020
 BOG      O4     C4        single      1.432    0.020
 BOG      C4     C5        single      1.524    0.020
 BOG      H4     C4        single      1.099    0.020
 BOG      HO4    O4        single      0.967    0.020
 BOG      C5     O5        single      1.426    0.020
 BOG      C6     C5        single      1.524    0.020
 BOG      H5     C5        single      1.099    0.020
 BOG      O6     C6        single      1.432    0.020
 BOG      H61    C6        single      1.092    0.020
 BOG      H62    C6        single      1.092    0.020
 BOG      HO6    O6        single      0.967    0.020
 BOG      "C2'"  "C1'"     single      1.524    0.020
 BOG      "H1'1" "C1'"     single      1.092    0.020
 BOG      "H1'2" "C1'"     single      1.092    0.020
 BOG      "C3'"  "C2'"     single      1.524    0.020
 BOG      "H2'1" "C2'"     single      1.092    0.020
 BOG      "H2'2" "C2'"     single      1.092    0.020
 BOG      "C4'"  "C3'"     single      1.524    0.020
 BOG      "H3'1" "C3'"     single      1.092    0.020
 BOG      "H3'2" "C3'"     single      1.092    0.020
 BOG      "C5'"  "C4'"     single      1.524    0.020
 BOG      "H4'1" "C4'"     single      1.092    0.020
 BOG      "H4'2" "C4'"     single      1.092    0.020
 BOG      "C6'"  "C5'"     single      1.524    0.020
 BOG      "H5'1" "C5'"     single      1.092    0.020
 BOG      "H5'2" "C5'"     single      1.092    0.020
 BOG      "C7'"  "C6'"     single      1.524    0.020
 BOG      "H6'1" "C6'"     single      1.092    0.020
 BOG      "H6'2" "C6'"     single      1.092    0.020
 BOG      "C8'"  "C7'"     single      1.513    0.020
 BOG      "H7'1" "C7'"     single      1.092    0.020
 BOG      "H7'2" "C7'"     single      1.092    0.020
 BOG      "H8'1" "C8'"     single      1.059    0.020
 BOG      "H8'2" "C8'"     single      1.059    0.020
 BOG      "H8'3" "C8'"     single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BOG      H1     C1     O1      109.470    3.000
 BOG      H1     C1     O5      109.470    3.000
 BOG      O1     C1     O5      109.470    3.000
 BOG      H1     C1     C2      108.340    3.000
 BOG      O1     C1     C2      109.470    3.000
 BOG      O5     C1     C2      109.470    3.000
 BOG      C1     O1     "C1'"   111.800    3.000
 BOG      O1     "C1'"  "H1'1"  109.470    3.000
 BOG      O1     "C1'"  "H1'2"  109.470    3.000
 BOG      O1     "C1'"  "C2'"   109.470    3.000
 BOG      "H1'1" "C1'"  "H1'2"  107.900    3.000
 BOG      "H1'1" "C1'"  "C2'"   109.470    3.000
 BOG      "H1'2" "C1'"  "C2'"   109.470    3.000
 BOG      "C1'"  "C2'"  "H2'1"  109.470    3.000
 BOG      "C1'"  "C2'"  "H2'2"  109.470    3.000
 BOG      "C1'"  "C2'"  "C3'"   111.000    3.000
 BOG      "H2'1" "C2'"  "H2'2"  107.900    3.000
 BOG      "H2'1" "C2'"  "C3'"   109.470    3.000
 BOG      "H2'2" "C2'"  "C3'"   109.470    3.000
 BOG      "C2'"  "C3'"  "H3'1"  109.470    3.000
 BOG      "C2'"  "C3'"  "H3'2"  109.470    3.000
 BOG      "C2'"  "C3'"  "C4'"   111.000    3.000
 BOG      "H3'1" "C3'"  "H3'2"  107.900    3.000
 BOG      "H3'1" "C3'"  "C4'"   109.470    3.000
 BOG      "H3'2" "C3'"  "C4'"   109.470    3.000
 BOG      "C3'"  "C4'"  "H4'1"  109.470    3.000
 BOG      "C3'"  "C4'"  "H4'2"  109.470    3.000
 BOG      "C3'"  "C4'"  "C5'"   111.000    3.000
 BOG      "H4'1" "C4'"  "H4'2"  107.900    3.000
 BOG      "H4'1" "C4'"  "C5'"   109.470    3.000
 BOG      "H4'2" "C4'"  "C5'"   109.470    3.000
 BOG      "C4'"  "C5'"  "H5'1"  109.470    3.000
 BOG      "C4'"  "C5'"  "H5'2"  109.470    3.000
 BOG      "C4'"  "C5'"  "C6'"   111.000    3.000
 BOG      "H5'1" "C5'"  "H5'2"  107.900    3.000
 BOG      "H5'1" "C5'"  "C6'"   109.470    3.000
 BOG      "H5'2" "C5'"  "C6'"   109.470    3.000
 BOG      "C5'"  "C6'"  "H6'1"  109.470    3.000
 BOG      "C5'"  "C6'"  "H6'2"  109.470    3.000
 BOG      "C5'"  "C6'"  "C7'"   111.000    3.000
 BOG      "H6'1" "C6'"  "H6'2"  107.900    3.000
 BOG      "H6'1" "C6'"  "C7'"   109.470    3.000
 BOG      "H6'2" "C6'"  "C7'"   109.470    3.000
 BOG      "C6'"  "C7'"  "H7'1"  109.470    3.000
 BOG      "C6'"  "C7'"  "H7'2"  109.470    3.000
 BOG      "C6'"  "C7'"  "C8'"   111.000    3.000
 BOG      "H7'1" "C7'"  "H7'2"  107.900    3.000
 BOG      "H7'1" "C7'"  "C8'"   109.470    3.000
 BOG      "H7'2" "C7'"  "C8'"   109.470    3.000
 BOG      "C7'"  "C8'"  "H8'3"  109.470    3.000
 BOG      "C7'"  "C8'"  "H8'2"  109.470    3.000
 BOG      "C7'"  "C8'"  "H8'1"  109.470    3.000
 BOG      "H8'3" "C8'"  "H8'2"  109.470    3.000
 BOG      "H8'3" "C8'"  "H8'1"  109.470    3.000
 BOG      "H8'2" "C8'"  "H8'1"  109.470    3.000
 BOG      C1     O5     C5      111.800    3.000
 BOG      O5     C5     H5      109.470    3.000
 BOG      O5     C5     C4      109.470    3.000
 BOG      O5     C5     C6      109.470    3.000
 BOG      H5     C5     C4      108.340    3.000
 BOG      H5     C5     C6      108.340    3.000
 BOG      C4     C5     C6      111.000    3.000
 BOG      C5     C4     H4      108.340    3.000
 BOG      C5     C4     O4      109.470    3.000
 BOG      C5     C4     C3      111.000    3.000
 BOG      H4     C4     O4      109.470    3.000
 BOG      H4     C4     C3      108.340    3.000
 BOG      O4     C4     C3      109.470    3.000
 BOG      C4     O4     HO4     109.470    3.000
 BOG      C4     C3     H3      108.340    3.000
 BOG      C4     C3     O3      109.470    3.000
 BOG      C4     C3     C2      111.000    3.000
 BOG      H3     C3     O3      109.470    3.000
 BOG      H3     C3     C2      108.340    3.000
 BOG      O3     C3     C2      109.470    3.000
 BOG      C3     O3     HO3     109.470    3.000
 BOG      C3     C2     H2      108.340    3.000
 BOG      C3     C2     O2      109.470    3.000
 BOG      C3     C2     C1      111.000    3.000
 BOG      H2     C2     O2      109.470    3.000
 BOG      H2     C2     C1      108.340    3.000
 BOG      O2     C2     C1      109.470    3.000
 BOG      C2     O2     HO2     109.470    3.000
 BOG      C5     C6     H61     109.470    3.000
 BOG      C5     C6     H62     109.470    3.000
 BOG      C5     C6     O6      109.470    3.000
 BOG      H61    C6     H62     107.900    3.000
 BOG      H61    C6     O6      109.470    3.000
 BOG      H62    C6     O6      109.470    3.000
 BOG      C6     O6     HO6     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BOG      var_1    O5     C1     O1     "C1'"    -59.799   20.000   1
 BOG      var_2    C1     O1     "C1'"  "C2'"    179.999   20.000   1
 BOG      var_3    O1     "C1'"  "C2'"  "C3'"   -179.965   20.000   3
 BOG      var_4    "C1'"  "C2'"  "C3'"  "C4'"    180.000   20.000   3
 BOG      var_5    "C2'"  "C3'"  "C4'"  "C5'"    179.946   20.000   3
 BOG      var_6    "C3'"  "C4'"  "C5'"  "C6'"    179.980   20.000   3
 BOG      var_7    "C4'"  "C5'"  "C6'"  "C7'"   -179.963   20.000   3
 BOG      var_8    "C5'"  "C6'"  "C7'"  "C8'"   -179.980   20.000   3
 BOG      var_9    "C6'"  "C7'"  "C8'"  "H8'1"  -179.975   20.000   3
 BOG      var_10   C1     O5     C5     C6       180.000   20.000   1
 BOG      var_11   O5     C5     C4     C3       -60.000   20.000   3
 BOG      var_12   C5     C4     O4     HO4     -179.949   20.000   1
 BOG      var_13   C5     C4     C3     C2        60.000   20.000   3
 BOG      var_14   C4     C3     O3     HO3     -179.973   20.000   1
 BOG      var_15   C4     C3     C2     O2       180.000   20.000   3
 BOG      var_16   C3     C2     C1     O5        60.000   20.000   3
 BOG      var_17   C3     C2     O2     HO2     -179.932   20.000   1
 BOG      var_18   O5     C5     C6     O6        59.890   20.000   3
 BOG      var_1    C5     O5     C1     C2         0.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BOG      chir_01  C1     O1     C2     O5        negativ
 BOG      chir_02  C2     C1     O2     C3        positiv
 BOG      chir_03  C3     C2     O3     C4        negativ
 BOG      chir_04  C4     C3     O4     C5        positiv
 BOG      chir_05  C5     C4     O5     C6        positiv
# ------------------------------------------------------
`.trim();

monomers["GCD"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GCD      GCD '4,5-DEHYDRO-D-GLUCURONIC ACID       ' pyranose           19  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GCD
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GCD           O6B    O    OC       -0.500      0.000    0.000    0.000
 GCD           C6     C    C         0.000     -1.035   -0.692    0.120
 GCD           O6A    O    OC       -0.500     -0.944   -1.927    0.296
 GCD           C5     C    C         0.000     -2.361   -0.052    0.055
 GCD           O5     O    O2        0.000     -2.423    1.288   -0.136
 GCD           C1     C    CH1       0.000     -3.659    1.943    0.160
 GCD           H1     H    H         0.000     -3.808    1.977    1.249
 GCD           O1     O    OH1       0.000     -3.639    3.271   -0.364
 GCD           HO1    H    H         0.000     -2.922    3.770    0.050
 GCD           C4     C    C1        0.000     -3.436   -0.814    0.186
 GCD           H4     H    H         0.000     -3.309   -1.873    0.330
 GCD           C3     C    CH1       0.000     -4.831   -0.249    0.141
 GCD           H3     H    H         0.000     -5.231   -0.178    1.162
 GCD           O3     O    OH1       0.000     -5.667   -1.106   -0.640
 GCD           HO3    H    H         0.000     -5.688   -1.986   -0.240
 GCD           C2     C    CH1       0.000     -4.797    1.145   -0.493
 GCD           H2     H    H         0.000     -4.615    1.057   -1.573
 GCD           O2     O    OH1       0.000     -6.042    1.809   -0.266
 GCD           HO2    H    H         0.000     -6.009    2.696   -0.651
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GCD      O6B    n/a    C6     START
 GCD      C6     O6B    C5     .
 GCD      O6A    C6     .      .
 GCD      C5     C6     C4     .
 GCD      O5     C5     C1     .
 GCD      C1     O5     O1     .
 GCD      H1     C1     .      .
 GCD      O1     C1     HO1    .
 GCD      HO1    O1     .      .
 GCD      C4     C5     C3     .
 GCD      H4     C4     .      .
 GCD      C3     C4     C2     .
 GCD      H3     C3     .      .
 GCD      O3     C3     HO3    .
 GCD      HO3    O3     .      .
 GCD      C2     C3     O2     .
 GCD      H2     C2     .      .
 GCD      O2     C2     HO2    .
 GCD      HO2    O2     .      END
 GCD      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GCD      C1     C2        single      1.524    0.020
 GCD      O1     C1        single      1.432    0.020
 GCD      C1     O5        single      1.426    0.020
 GCD      H1     C1        single      1.099    0.020
 GCD      C2     C3        single      1.524    0.020
 GCD      O2     C2        single      1.432    0.020
 GCD      H2     C2        single      1.099    0.020
 GCD      C3     C4        single      1.510    0.020
 GCD      O3     C3        single      1.432    0.020
 GCD      H3     C3        single      1.099    0.020
 GCD      C4     C5        double      1.340    0.020
 GCD      C5     C6        single      1.460    0.020
 GCD      O5     C5        single      1.454    0.020
 GCD      O6A    C6        deloc       1.250    0.020
 GCD      C6     O6B       deloc       1.250    0.020
 GCD      HO1    O1        single      0.967    0.020
 GCD      HO2    O2        single      0.967    0.020
 GCD      HO3    O3        single      0.967    0.020
 GCD      H4     C4        single      1.077    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GCD      O6B    C6     O6A     123.000    3.000
 GCD      O6B    C6     C5      120.000    3.000
 GCD      O6A    C6     C5      120.000    3.000
 GCD      C6     C5     O5      120.000    3.000
 GCD      C6     C5     C4      120.000    3.000
 GCD      O5     C5     C4      120.000    3.000
 GCD      C5     O5     C1      111.800    3.000
 GCD      O5     C1     H1      109.470    3.000
 GCD      O5     C1     O1      109.470    3.000
 GCD      O5     C1     C2      109.470    3.000
 GCD      H1     C1     O1      109.470    3.000
 GCD      H1     C1     C2      108.340    3.000
 GCD      O1     C1     C2      109.470    3.000
 GCD      C1     O1     HO1     109.470    3.000
 GCD      C5     C4     H4      120.000    3.000
 GCD      C5     C4     C3      120.500    3.000
 GCD      H4     C4     C3      120.000    3.000
 GCD      C4     C3     H3      108.810    3.000
 GCD      C4     C3     O3      109.470    3.000
 GCD      C4     C3     C2      109.470    3.000
 GCD      H3     C3     O3      109.470    3.000
 GCD      H3     C3     C2      108.340    3.000
 GCD      O3     C3     C2      109.470    3.000
 GCD      C3     O3     HO3     109.470    3.000
 GCD      C3     C2     H2      108.340    3.000
 GCD      C3     C2     O2      109.470    3.000
 GCD      C3     C2     C1      111.000    3.000
 GCD      H2     C2     O2      109.470    3.000
 GCD      H2     C2     C1      108.340    3.000
 GCD      O2     C2     C1      109.470    3.000
 GCD      C2     O2     HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GCD      var_1    O6B    C6     C5     C4      -179.984   20.000   1
 GCD      var_2    C6     C5     O5     C1      -150.000   20.000   1
 GCD      var_3    C5     O5     C1     O1       180.000   20.000   1
 GCD      var_4    O5     C1     C2     C3        60.000   20.000   3
 GCD      var_5    O5     C1     O1     HO1      -61.120   20.000   1
 GCD      var_6    C6     C5     C4     C3       180.000   20.000   1
 GCD      var_7    C5     C4     C3     C2        30.000   20.000   1
 GCD      var_8    C4     C3     O3     HO3       60.017   20.000   1
 GCD      var_9    C4     C3     C2     O2       180.000   20.000   3
 GCD      var_10   C3     C2     O2     HO2      178.805   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 GCD      chir_01  C1     C2     O1     O5        positiv
 GCD      chir_02  C2     C1     C3     O2        negativ
 GCD      chir_03  C3     C2     C4     O3        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 GCD      plan-1    C4        0.020
 GCD      plan-1    C3        0.020
 GCD      plan-1    C5        0.020
 GCD      plan-1    H4        0.020
 GCD      plan-2    C5        0.020
 GCD      plan-2    C4        0.020
 GCD      plan-2    C6        0.020
 GCD      plan-2    O5        0.020
 GCD      plan-2    H4        0.020
 GCD      plan-3    C6        0.020
 GCD      plan-3    C5        0.020
 GCD      plan-3    O6A       0.020
 GCD      plan-3    O6B       0.020
# ------------------------------------------------------
`.trim();

monomers["BMA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BMA      BMA 'BETA-D-MANNOSE                      ' pyranose           24  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BMA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BMA           C1     C    CH1       0.000      0.000    0.000    0.000
 BMA           H1     H    H         0.000      0.518   -0.967   -0.063
 BMA           O1     O    OH1       0.000      0.723    0.976   -0.752
 BMA           HO1    H    H         0.000      0.776    0.696   -1.676
 BMA           O5     O    O2        0.000     -1.315   -0.131   -0.534
 BMA           C5     C    CH1       0.000     -1.940   -1.231    0.123
 BMA           H5     H    H         0.000     -1.290   -2.115    0.052
 BMA           C6     C    CH2       0.000     -3.281   -1.531   -0.550
 BMA           H61    H    H         0.000     -3.927   -0.653   -0.479
 BMA           H62    H    H         0.000     -3.759   -2.374   -0.047
 BMA           O6     O    OH1       0.000     -3.063   -1.854   -1.924
 BMA           HO6    H    H         0.000     -3.930   -2.035   -2.310
 BMA           C4     C    CH1       0.000     -2.175   -0.890    1.596
 BMA           H4     H    H         0.000     -2.803    0.008    1.670
 BMA           O4     O    OH1       0.000     -2.827   -1.984    2.243
 BMA           HO4    H    H         0.000     -2.966   -1.770    3.175
 BMA           C3     C    CH1       0.000     -0.824   -0.627    2.269
 BMA           H3     H    H         0.000     -0.234   -1.554    2.288
 BMA           O3     O    OH1       0.000     -1.032   -0.162    3.604
 BMA           HO3    H    H         0.000     -0.178    0.014    4.020
 BMA           C2     C    CH1       0.000     -0.077    0.441    1.464
 BMA           H2     H    H         0.000      0.940    0.559    1.865
 BMA           O2     O    OH1       0.000     -0.772    1.684    1.553
 BMA           HO2    H    H         0.000     -0.302    2.353    1.038
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BMA      C1     n/a    O5     START
 BMA      H1     C1     .      .
 BMA      O1     C1     HO1    .
 BMA      HO1    O1     .      .
 BMA      O5     C1     .      END
 BMA      C5     O5     C4     .
 BMA      H5     C5     .      .
 BMA      C6     C5     O6     .
 BMA      H61    C6     .      .
 BMA      H62    C6     .      .
 BMA      O6     C6     .      .
 BMA      HO6    O6     .      .
 BMA      C4     C5     C3     .
 BMA      H4     C4     .      .
 BMA      O4     C4     HO4    .
 BMA      HO4    O4     .      .
 BMA      C3     C4     C2     .
 BMA      H3     C3     .      .
 BMA      O3     C3     HO3    .
 BMA      HO3    O3     .      .
 BMA      C2     C3     O2     .
 BMA      H2     C2     .      .
 BMA      O2     C2     HO2    .
 BMA      HO2    O2     .      .
 BMA      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BMA      C1     C2        single      1.524    0.020
 BMA      O1     C1        single      1.432    0.020
 BMA      O5     C1        single      1.426    0.020
 BMA      H1     C1        single      1.099    0.020
 BMA      C2     C3        single      1.524    0.020
 BMA      O2     C2        single      1.432    0.020
 BMA      H2     C2        single      1.099    0.020
 BMA      C3     C4        single      1.524    0.020
 BMA      O3     C3        single      1.432    0.020
 BMA      H3     C3        single      1.099    0.020
 BMA      C4     C5        single      1.524    0.020
 BMA      O4     C4        single      1.432    0.020
 BMA      H4     C4        single      1.099    0.020
 BMA      C6     C5        single      1.524    0.020
 BMA      C5     O5        single      1.426    0.020
 BMA      H5     C5        single      1.099    0.020
 BMA      O6     C6        single      1.432    0.020
 BMA      H61    C6        single      1.092    0.020
 BMA      H62    C6        single      1.092    0.020
 BMA      HO1    O1        single      0.967    0.020
 BMA      HO2    O2        single      0.967    0.020
 BMA      HO3    O3        single      0.967    0.020
 BMA      HO4    O4        single      0.967    0.020
 BMA      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BMA      H1     C1     O1      109.470    3.000
 BMA      H1     C1     O5      109.470    3.000
 BMA      O1     C1     O5      109.470    3.000
 BMA      H1     C1     C2      108.340    3.000
 BMA      O1     C1     C2      109.470    3.000
 BMA      O5     C1     C2      109.470    3.000
 BMA      C1     O1     HO1     109.470    3.000
 BMA      C1     O5     C5      111.800    3.000
 BMA      O5     C5     H5      109.470    3.000
 BMA      O5     C5     C6      109.470    3.000
 BMA      O5     C5     C4      109.470    3.000
 BMA      H5     C5     C6      108.340    3.000
 BMA      H5     C5     C4      108.340    3.000
 BMA      C6     C5     C4      111.000    3.000
 BMA      C5     C6     H61     109.470    3.000
 BMA      C5     C6     H62     109.470    3.000
 BMA      C5     C6     O6      109.470    3.000
 BMA      H61    C6     H62     107.900    3.000
 BMA      H61    C6     O6      109.470    3.000
 BMA      H62    C6     O6      109.470    3.000
 BMA      C6     O6     HO6     109.470    3.000
 BMA      C5     C4     H4      108.340    3.000
 BMA      C5     C4     O4      109.470    3.000
 BMA      C5     C4     C3      111.000    3.000
 BMA      H4     C4     O4      109.470    3.000
 BMA      H4     C4     C3      108.340    3.000
 BMA      O4     C4     C3      109.470    3.000
 BMA      C4     O4     HO4     109.470    3.000
 BMA      C4     C3     H3      108.340    3.000
 BMA      C4     C3     O3      109.470    3.000
 BMA      C4     C3     C2      111.000    3.000
 BMA      H3     C3     O3      109.470    3.000
 BMA      H3     C3     C2      108.340    3.000
 BMA      O3     C3     C2      109.470    3.000
 BMA      C3     O3     HO3     109.470    3.000
 BMA      C3     C2     H2      108.340    3.000
 BMA      C3     C2     O2      109.470    3.000
 BMA      C3     C2     C1      111.000    3.000
 BMA      H2     C2     O2      109.470    3.000
 BMA      H2     C2     C1      108.340    3.000
 BMA      O2     C2     C1      109.470    3.000
 BMA      C2     O2     HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BMA      var_1    O5     C1     O1     HO1      -59.979   20.000   1
 BMA      var_2    C1     O5     C5     C4        60.000   20.000   1
 BMA      var_3    O5     C5     C6     O6        59.860   20.000   3
 BMA      var_4    O5     C5     C4     C3       -60.000   20.000   3
 BMA      var_5    C5     C4     O4     HO4      179.446   20.000   1
 BMA      var_6    C5     C4     C3     C2        60.000   20.000   3
 BMA      var_7    C4     C3     O3     HO3     -179.192   20.000   1
 BMA      var_8    C4     C3     C2     O2        60.000   20.000   3
 BMA      var_9    C3     C2     C1     O5        60.000   20.000   3
 BMA      var_10   C3     C2     O2     HO2     -179.536   20.000   1
 BMA      var_1    C5     O5     C1     C2         0.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BMA      chir_01  C1     C2     O1     O5        positiv
 BMA      chir_02  C2     C1     C3     O2        positiv
 BMA      chir_03  C3     C2     C4     O3        positiv
 BMA      chir_04  C4     C3     C5     O4        negativ
 BMA      chir_05  C5     C4     C6     O5        negativ
# ------------------------------------------------------
`.trim();

monomers["GLO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GLO      GLO 'D-GLUCOSE IN LINEAR FORM            ' non-polymer        24  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GLO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GLO           O1     O    O         0.000      0.000    0.000    0.000
 GLO           C1     C    C1        0.000     -0.883   -0.605    0.558
 GLO           H1     H    H         0.000     -0.872   -1.682    0.571
 GLO           C2     C    CH1       0.000     -1.999    0.145    1.236
 GLO           H2     H    H         0.000     -1.840    1.225    1.117
 GLO           O2     O    OH1       0.000     -2.018   -0.184    2.626
 GLO           HO2    H    H         0.000     -2.158   -1.135    2.730
 GLO           C3     C    CH1       0.000     -3.336   -0.246    0.602
 GLO           H3     H    H         0.000     -3.322    0.006   -0.467
 GLO           O3     O    OH1       0.000     -3.544   -1.651    0.758
 GLO           HO3    H    H         0.000     -3.556   -1.873    1.699
 GLO           C4     C    CH1       0.000     -4.469    0.515    1.290
 GLO           H4     H    H         0.000     -4.310    1.595    1.171
 GLO           O4     O    OH1       0.000     -4.488    0.187    2.681
 GLO           HO4    H    H         0.000     -4.628   -0.764    2.785
 GLO           C5     C    CH1       0.000     -5.805    0.124    0.657
 GLO           H5     H    H         0.000     -5.965   -0.957    0.776
 GLO           O5     O    OH1       0.000     -5.787    0.452   -0.734
 GLO           HO5    H    H         0.000     -5.647    1.403   -0.838
 GLO           C6     C    CH2       0.000     -6.939    0.886    1.345
 GLO           H61    H    H         0.000     -6.779    1.959    1.228
 GLO           H62    H    H         0.000     -6.951    0.635    2.408
 GLO           O6     O    OH1       0.000     -8.187    0.521    0.754
 GLO           HO6    H    H         0.000     -8.903    1.003    1.189
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GLO      O1     n/a    C1     START
 GLO      C1     O1     C2     .
 GLO      H1     C1     .      .
 GLO      C2     C1     C3     .
 GLO      H2     C2     .      .
 GLO      O2     C2     HO2    .
 GLO      HO2    O2     .      .
 GLO      C3     C2     C4     .
 GLO      H3     C3     .      .
 GLO      O3     C3     HO3    .
 GLO      HO3    O3     .      .
 GLO      C4     C3     C5     .
 GLO      H4     C4     .      .
 GLO      O4     C4     HO4    .
 GLO      HO4    O4     .      .
 GLO      C5     C4     C6     .
 GLO      H5     C5     .      .
 GLO      O5     C5     HO5    .
 GLO      HO5    O5     .      .
 GLO      C6     C5     O6     .
 GLO      H61    C6     .      .
 GLO      H62    C6     .      .
 GLO      O6     C6     HO6    .
 GLO      HO6    O6     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GLO      C2     C1        single      1.510    0.020
 GLO      C1     O1        double      1.220    0.020
 GLO      H1     C1        single      1.077    0.020
 GLO      C3     C2        single      1.524    0.020
 GLO      O2     C2        single      1.432    0.020
 GLO      H2     C2        single      1.099    0.020
 GLO      C4     C3        single      1.524    0.020
 GLO      O3     C3        single      1.432    0.020
 GLO      H3     C3        single      1.099    0.020
 GLO      C5     C4        single      1.524    0.020
 GLO      O4     C4        single      1.432    0.020
 GLO      H4     C4        single      1.099    0.020
 GLO      C6     C5        single      1.524    0.020
 GLO      O5     C5        single      1.432    0.020
 GLO      H5     C5        single      1.099    0.020
 GLO      O6     C6        single      1.432    0.020
 GLO      H61    C6        single      1.092    0.020
 GLO      H62    C6        single      1.092    0.020
 GLO      HO2    O2        single      0.967    0.020
 GLO      HO3    O3        single      0.967    0.020
 GLO      HO4    O4        single      0.967    0.020
 GLO      HO5    O5        single      0.967    0.020
 GLO      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GLO      O1     C1     H1      123.000    3.000
 GLO      O1     C1     C2      120.500    3.000
 GLO      H1     C1     C2      120.000    3.000
 GLO      C1     C2     H2      108.810    3.000
 GLO      C1     C2     O2      109.470    3.000
 GLO      C1     C2     C3      109.470    3.000
 GLO      H2     C2     O2      109.470    3.000
 GLO      H2     C2     C3      108.340    3.000
 GLO      O2     C2     C3      109.470    3.000
 GLO      C2     O2     HO2     109.470    3.000
 GLO      C2     C3     H3      108.340    3.000
 GLO      C2     C3     O3      109.470    3.000
 GLO      C2     C3     C4      111.000    3.000
 GLO      H3     C3     O3      109.470    3.000
 GLO      H3     C3     C4      108.340    3.000
 GLO      O3     C3     C4      109.470    3.000
 GLO      C3     O3     HO3     109.470    3.000
 GLO      C3     C4     H4      108.340    3.000
 GLO      C3     C4     O4      109.470    3.000
 GLO      C3     C4     C5      111.000    3.000
 GLO      H4     C4     O4      109.470    3.000
 GLO      H4     C4     C5      108.340    3.000
 GLO      O4     C4     C5      109.470    3.000
 GLO      C4     O4     HO4     109.470    3.000
 GLO      C4     C5     H5      108.340    3.000
 GLO      C4     C5     O5      109.470    3.000
 GLO      C4     C5     C6      111.000    3.000
 GLO      H5     C5     O5      109.470    3.000
 GLO      H5     C5     C6      108.340    3.000
 GLO      O5     C5     C6      109.470    3.000
 GLO      C5     O5     HO5     109.470    3.000
 GLO      C5     C6     H61     109.470    3.000
 GLO      C5     C6     H62     109.470    3.000
 GLO      C5     C6     O6      109.470    3.000
 GLO      H61    C6     H62     107.900    3.000
 GLO      H61    C6     O6      109.470    3.000
 GLO      H62    C6     O6      109.470    3.000
 GLO      C6     O6     HO6     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GLO      var_1    O1     C1     C2     C3       120.026   20.000   1
 GLO      var_2    C1     C2     O2     HO2      -59.988   20.000   1
 GLO      var_3    C1     C2     C3     C4       179.993   20.000   3
 GLO      var_4    C2     C3     O3     HO3       60.013   20.000   1
 GLO      var_5    C2     C3     C4     C5       180.000   20.000   3
 GLO      var_6    C3     C4     O4     HO4      -60.025   20.000   1
 GLO      var_7    C3     C4     C5     C6      -179.997   20.000   3
 GLO      var_8    C4     C5     O5     HO5      -60.074   20.000   1
 GLO      var_9    C4     C5     C6     O6      -179.994   20.000   3
 GLO      var_10   C5     C6     O6     HO6     -179.940   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 GLO      chir_01  C2     C1     C3     O2        negativ
 GLO      chir_02  C3     C2     C4     O3        positiv
 GLO      chir_03  C4     C3     C5     O4        negativ
 GLO      chir_04  C5     C4     C6     O5        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 GLO      plan-1    C1        0.020
 GLO      plan-1    C2        0.000
 GLO      plan-1    O1        0.000
 GLO      plan-1    H1        0.000
# ------------------------------------------------------
`.trim();

monomers["DMU"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DMU      DMU 'DECYL-BETA-D-MALTOPYRANOSIDE        ' non-polymer        75  33 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DMU
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DMU           O6     O    OH1       0.000      0.000    0.000    0.000
 DMU           HO6    H    H         0.000      0.645   -0.557    0.457
 DMU           C11    C    CH2       0.000      0.387    0.153   -1.366
 DMU           H111   H    H         0.000      0.428   -0.828   -1.844
 DMU           H112   H    H         0.000      1.373    0.620   -1.414
 DMU           C9     C    CH1       0.000     -0.634    1.034   -2.091
 DMU           H9     H    H         0.000     -0.741    1.987   -1.554
 DMU           C8     C    CH1       0.000     -0.150    1.304   -3.516
 DMU           H8     H    H         0.000      0.830    1.800   -3.484
 DMU           O2     O    OH1       0.000     -0.037    0.069   -4.226
 DMU           HO2    H    H         0.000      0.269    0.242   -5.127
 DMU           C7     C    CH1       0.000     -1.162    2.213   -4.223
 DMU           H7     H    H         0.000     -0.886    2.319   -5.281
 DMU           O4     O    OH1       0.000     -1.170    3.498   -3.598
 DMU           HO4    H    H         0.000     -1.809    4.070   -4.046
 DMU           O1     O    O2        0.000     -1.894    0.365   -2.127
 DMU           C10    C    CH1       0.000     -2.855    1.284   -2.644
 DMU           H10    H    H         0.000     -2.811    2.220   -2.070
 DMU           C5     C    CH1       0.000     -2.551    1.575   -4.116
 DMU           H5     H    H         0.000     -2.570    0.637   -4.688
 DMU           O3     O    OH1       0.000     -3.532    2.474   -4.638
 DMU           HO3    H    H         0.000     -4.408    2.069   -4.570
 DMU           O7     O    O2        0.000     -4.162    0.719   -2.531
 DMU           C3     C    CH1       0.000     -4.481    0.693   -1.139
 DMU           H3     H    H         0.000     -3.559    0.583   -0.551
 DMU           C2     C    CH1       0.000     -5.185    1.997   -0.748
 DMU           H2     H    H         0.000     -6.050    2.161   -1.406
 DMU           O55    O    OH1       0.000     -4.274    3.091   -0.873
 DMU           H55    H    H         0.000     -4.720    3.912   -0.625
 DMU           C4     C    CH1       0.000     -5.416   -0.483   -0.849
 DMU           H4     H    H         0.000     -6.347   -0.359   -1.420
 DMU           C57    C    CH2       0.000     -4.734   -1.788   -1.268
 DMU           H571   H    H         0.000     -3.857   -1.958   -0.640
 DMU           H572   H    H         0.000     -4.423   -1.717   -2.313
 DMU           O61    O    OH1       0.000     -5.649   -2.874   -1.115
 DMU           H61    H    H         0.000     -5.217   -3.698   -1.379
 DMU           O5     O    O2        0.000     -5.716   -0.531    0.543
 DMU           C6     C    CH1       0.000     -6.505    0.616    0.855
 DMU           H6     H    H         0.000     -7.362    0.667    0.169
 DMU           C1     C    CH1       0.000     -5.659    1.881    0.706
 DMU           H1     H    H         0.000     -4.788    1.821    1.373
 DMU           O49    O    OH1       0.000     -6.444    3.025    1.046
 DMU           H49    H    H         0.000     -6.742    2.950    1.962
 DMU           O16    O    O2        0.000     -6.979    0.516    2.200
 DMU           C18    C    CH2       0.000     -7.856   -0.610    2.246
 DMU           H181   H    H         0.000     -7.308   -1.510    1.959
 DMU           H182   H    H         0.000     -8.685   -0.454    1.553
 DMU           C19    C    CH2       0.000     -8.400   -0.775    3.667
 DMU           H191   H    H         0.000     -8.947    0.126    3.953
 DMU           H192   H    H         0.000     -7.569   -0.929    4.358
 DMU           C22    C    CH2       0.000     -9.339   -1.981    3.717
 DMU           H221   H    H         0.000     -8.791   -2.881    3.431
 DMU           H222   H    H         0.000    -10.168   -1.825    3.023
 DMU           C25    C    CH2       0.000     -9.884   -2.145    5.137
 DMU           H251   H    H         0.000    -10.431   -1.243    5.422
 DMU           H252   H    H         0.000     -9.054   -2.299    5.829
 DMU           C28    C    CH2       0.000    -10.824   -3.351    5.188
 DMU           H281   H    H         0.000    -10.276   -4.251    4.901
 DMU           H282   H    H         0.000    -11.653   -3.196    4.495
 DMU           C31    C    CH2       0.000    -11.368   -3.515    6.608
 DMU           H311   H    H         0.000    -11.915   -2.613    6.893
 DMU           H312   H    H         0.000    -10.538   -3.669    7.300
 DMU           C34    C    CH2       0.000    -12.308   -4.721    6.658
 DMU           H341   H    H         0.000    -11.760   -5.621    6.372
 DMU           H342   H    H         0.000    -13.138   -4.566    5.965
 DMU           C37    C    CH2       0.000    -12.853   -4.884    8.078
 DMU           H371   H    H         0.000    -13.400   -3.984    8.363
 DMU           H372   H    H         0.000    -12.022   -5.038    8.770
 DMU           C40    C    CH2       0.000    -13.792   -6.092    8.129
 DMU           H401   H    H         0.000    -13.244   -6.992    7.842
 DMU           H402   H    H         0.000    -14.622   -5.937    7.436
 DMU           C43    C    CH3       0.000    -14.336   -6.255    9.549
 DMU           H433   H    H         0.000    -13.532   -6.407   10.224
 DMU           H432   H    H         0.000    -14.868   -5.382    9.830
 DMU           H431   H    H         0.000    -14.988   -7.090    9.588
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DMU      O6     n/a    C11    START
 DMU      HO6    O6     .      .
 DMU      C11    O6     C9     .
 DMU      H111   C11    .      .
 DMU      H112   C11    .      .
 DMU      C9     C11    O1     .
 DMU      H9     C9     .      .
 DMU      C8     C9     C7     .
 DMU      H8     C8     .      .
 DMU      O2     C8     HO2    .
 DMU      HO2    O2     .      .
 DMU      C7     C8     O4     .
 DMU      H7     C7     .      .
 DMU      O4     C7     HO4    .
 DMU      HO4    O4     .      .
 DMU      O1     C9     C10    .
 DMU      C10    O1     O7     .
 DMU      H10    C10    .      .
 DMU      C5     C10    O3     .
 DMU      H5     C5     .      .
 DMU      O3     C5     HO3    .
 DMU      HO3    O3     .      .
 DMU      O7     C10    C3     .
 DMU      C3     O7     C4     .
 DMU      H3     C3     .      .
 DMU      C2     C3     O55    .
 DMU      H2     C2     .      .
 DMU      O55    C2     H55    .
 DMU      H55    O55    .      .
 DMU      C4     C3     O5     .
 DMU      H4     C4     .      .
 DMU      C57    C4     O61    .
 DMU      H571   C57    .      .
 DMU      H572   C57    .      .
 DMU      O61    C57    H61    .
 DMU      H61    O61    .      .
 DMU      O5     C4     C6     .
 DMU      C6     O5     O16    .
 DMU      H6     C6     .      .
 DMU      C1     C6     O49    .
 DMU      H1     C1     .      .
 DMU      O49    C1     H49    .
 DMU      H49    O49    .      .
 DMU      O16    C6     C18    .
 DMU      C18    O16    C19    .
 DMU      H181   C18    .      .
 DMU      H182   C18    .      .
 DMU      C19    C18    C22    .
 DMU      H191   C19    .      .
 DMU      H192   C19    .      .
 DMU      C22    C19    C25    .
 DMU      H221   C22    .      .
 DMU      H222   C22    .      .
 DMU      C25    C22    C28    .
 DMU      H251   C25    .      .
 DMU      H252   C25    .      .
 DMU      C28    C25    C31    .
 DMU      H281   C28    .      .
 DMU      H282   C28    .      .
 DMU      C31    C28    C34    .
 DMU      H311   C31    .      .
 DMU      H312   C31    .      .
 DMU      C34    C31    C37    .
 DMU      H341   C34    .      .
 DMU      H342   C34    .      .
 DMU      C37    C34    C40    .
 DMU      H371   C37    .      .
 DMU      H372   C37    .      .
 DMU      C40    C37    C43    .
 DMU      H401   C40    .      .
 DMU      H402   C40    .      .
 DMU      C43    C40    H431   .
 DMU      H433   C43    .      .
 DMU      H432   C43    .      .
 DMU      H431   C43    .      END
 DMU      C1     C2     .    ADD
 DMU      C5     C7     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DMU      C1     C2        single      1.524    0.020
 DMU      C1     C6        single      1.524    0.020
 DMU      O49    C1        single      1.432    0.020
 DMU      H1     C1        single      1.099    0.020
 DMU      C2     C3        single      1.524    0.020
 DMU      O55    C2        single      1.432    0.020
 DMU      H2     C2        single      1.099    0.020
 DMU      C4     C3        single      1.524    0.020
 DMU      C3     O7        single      1.426    0.020
 DMU      H3     C3        single      1.099    0.020
 DMU      O5     C4        single      1.426    0.020
 DMU      C57    C4        single      1.524    0.020
 DMU      H4     C4        single      1.099    0.020
 DMU      C6     O5        single      1.426    0.020
 DMU      O16    C6        single      1.426    0.020
 DMU      H6     C6        single      1.099    0.020
 DMU      O7     C10       single      1.426    0.020
 DMU      C18    O16       single      1.426    0.020
 DMU      C19    C18       single      1.524    0.020
 DMU      H181   C18       single      1.092    0.020
 DMU      H182   C18       single      1.092    0.020
 DMU      C22    C19       single      1.524    0.020
 DMU      H191   C19       single      1.092    0.020
 DMU      H192   C19       single      1.092    0.020
 DMU      C25    C22       single      1.524    0.020
 DMU      H221   C22       single      1.092    0.020
 DMU      H222   C22       single      1.092    0.020
 DMU      C28    C25       single      1.524    0.020
 DMU      H251   C25       single      1.092    0.020
 DMU      H252   C25       single      1.092    0.020
 DMU      C31    C28       single      1.524    0.020
 DMU      H281   C28       single      1.092    0.020
 DMU      H282   C28       single      1.092    0.020
 DMU      C34    C31       single      1.524    0.020
 DMU      H311   C31       single      1.092    0.020
 DMU      H312   C31       single      1.092    0.020
 DMU      C37    C34       single      1.524    0.020
 DMU      H341   C34       single      1.092    0.020
 DMU      H342   C34       single      1.092    0.020
 DMU      C40    C37       single      1.524    0.020
 DMU      H371   C37       single      1.092    0.020
 DMU      H372   C37       single      1.092    0.020
 DMU      C43    C40       single      1.513    0.020
 DMU      H401   C40       single      1.092    0.020
 DMU      H402   C40       single      1.092    0.020
 DMU      H431   C43       single      1.059    0.020
 DMU      H432   C43       single      1.059    0.020
 DMU      H433   C43       single      1.059    0.020
 DMU      H49    O49       single      0.967    0.020
 DMU      H55    O55       single      0.967    0.020
 DMU      O61    C57       single      1.432    0.020
 DMU      H571   C57       single      1.092    0.020
 DMU      H572   C57       single      1.092    0.020
 DMU      H61    O61       single      0.967    0.020
 DMU      C5     C7        single      1.524    0.020
 DMU      C5     C10       single      1.524    0.020
 DMU      O3     C5        single      1.432    0.020
 DMU      H5     C5        single      1.099    0.020
 DMU      C7     C8        single      1.524    0.020
 DMU      O4     C7        single      1.432    0.020
 DMU      H7     C7        single      1.099    0.020
 DMU      C8     C9        single      1.524    0.020
 DMU      O2     C8        single      1.432    0.020
 DMU      H8     C8        single      1.099    0.020
 DMU      O1     C9        single      1.426    0.020
 DMU      C9     C11       single      1.524    0.020
 DMU      H9     C9        single      1.099    0.020
 DMU      C10    O1        single      1.426    0.020
 DMU      H10    C10       single      1.099    0.020
 DMU      HO2    O2        single      0.967    0.020
 DMU      HO3    O3        single      0.967    0.020
 DMU      HO4    O4        single      0.967    0.020
 DMU      C11    O6        single      1.432    0.020
 DMU      H111   C11       single      1.092    0.020
 DMU      H112   C11       single      1.092    0.020
 DMU      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DMU      HO6    O6     C11     109.470    3.000
 DMU      O6     C11    H111    109.470    3.000
 DMU      O6     C11    H112    109.470    3.000
 DMU      O6     C11    C9      109.470    3.000
 DMU      H111   C11    H112    107.900    3.000
 DMU      H111   C11    C9      109.470    3.000
 DMU      H112   C11    C9      109.470    3.000
 DMU      C11    C9     H9      108.340    3.000
 DMU      C11    C9     C8      111.000    3.000
 DMU      C11    C9     O1      109.470    3.000
 DMU      H9     C9     C8      108.340    3.000
 DMU      H9     C9     O1      109.470    3.000
 DMU      C8     C9     O1      109.470    3.000
 DMU      C9     C8     H8      108.340    3.000
 DMU      C9     C8     O2      109.470    3.000
 DMU      C9     C8     C7      111.000    3.000
 DMU      H8     C8     O2      109.470    3.000
 DMU      H8     C8     C7      108.340    3.000
 DMU      O2     C8     C7      109.470    3.000
 DMU      C8     O2     HO2     109.470    3.000
 DMU      C8     C7     H7      108.340    3.000
 DMU      C8     C7     O4      109.470    3.000
 DMU      C8     C7     C5      111.000    3.000
 DMU      H7     C7     O4      109.470    3.000
 DMU      H7     C7     C5      108.340    3.000
 DMU      O4     C7     C5      109.470    3.000
 DMU      C7     O4     HO4     109.470    3.000
 DMU      C9     O1     C10     111.800    3.000
 DMU      O1     C10    H10     109.470    3.000
 DMU      O1     C10    C5      109.470    3.000
 DMU      O1     C10    O7      109.470    3.000
 DMU      H10    C10    C5      108.340    3.000
 DMU      H10    C10    O7      109.470    3.000
 DMU      C5     C10    O7      109.470    3.000
 DMU      C10    C5     H5      108.340    3.000
 DMU      C10    C5     O3      109.470    3.000
 DMU      C10    C5     C7      111.000    3.000
 DMU      H5     C5     O3      109.470    3.000
 DMU      H5     C5     C7      108.340    3.000
 DMU      O3     C5     C7      109.470    3.000
 DMU      C5     O3     HO3     109.470    3.000
 DMU      C10    O7     C3      111.800    3.000
 DMU      O7     C3     H3      109.470    3.000
 DMU      O7     C3     C2      109.470    3.000
 DMU      O7     C3     C4      109.470    3.000
 DMU      H3     C3     C2      108.340    3.000
 DMU      H3     C3     C4      108.340    3.000
 DMU      C2     C3     C4      111.000    3.000
 DMU      C3     C2     H2      108.340    3.000
 DMU      C3     C2     O55     109.470    3.000
 DMU      C3     C2     C1      111.000    3.000
 DMU      H2     C2     O55     109.470    3.000
 DMU      H2     C2     C1      108.340    3.000
 DMU      O55    C2     C1      109.470    3.000
 DMU      C2     O55    H55     109.470    3.000
 DMU      C3     C4     H4      108.340    3.000
 DMU      C3     C4     C57     111.000    3.000
 DMU      C3     C4     O5      109.470    3.000
 DMU      H4     C4     C57     108.340    3.000
 DMU      H4     C4     O5      109.470    3.000
 DMU      C57    C4     O5      109.470    3.000
 DMU      C4     C57    H571    109.470    3.000
 DMU      C4     C57    H572    109.470    3.000
 DMU      C4     C57    O61     109.470    3.000
 DMU      H571   C57    H572    107.900    3.000
 DMU      H571   C57    O61     109.470    3.000
 DMU      H572   C57    O61     109.470    3.000
 DMU      C57    O61    H61     109.470    3.000
 DMU      C4     O5     C6      111.800    3.000
 DMU      O5     C6     H6      109.470    3.000
 DMU      O5     C6     C1      109.470    3.000
 DMU      O5     C6     O16     109.470    3.000
 DMU      H6     C6     C1      108.340    3.000
 DMU      H6     C6     O16     109.470    3.000
 DMU      C1     C6     O16     109.470    3.000
 DMU      C6     C1     H1      108.340    3.000
 DMU      C6     C1     O49     109.470    3.000
 DMU      C6     C1     C2      111.000    3.000
 DMU      H1     C1     O49     109.470    3.000
 DMU      H1     C1     C2      108.340    3.000
 DMU      O49    C1     C2      109.470    3.000
 DMU      C1     O49    H49     109.470    3.000
 DMU      C6     O16    C18     111.800    3.000
 DMU      O16    C18    H181    109.470    3.000
 DMU      O16    C18    H182    109.470    3.000
 DMU      O16    C18    C19     109.470    3.000
 DMU      H181   C18    H182    107.900    3.000
 DMU      H181   C18    C19     109.470    3.000
 DMU      H182   C18    C19     109.470    3.000
 DMU      C18    C19    H191    109.470    3.000
 DMU      C18    C19    H192    109.470    3.000
 DMU      C18    C19    C22     111.000    3.000
 DMU      H191   C19    H192    107.900    3.000
 DMU      H191   C19    C22     109.470    3.000
 DMU      H192   C19    C22     109.470    3.000
 DMU      C19    C22    H221    109.470    3.000
 DMU      C19    C22    H222    109.470    3.000
 DMU      C19    C22    C25     111.000    3.000
 DMU      H221   C22    H222    107.900    3.000
 DMU      H221   C22    C25     109.470    3.000
 DMU      H222   C22    C25     109.470    3.000
 DMU      C22    C25    H251    109.470    3.000
 DMU      C22    C25    H252    109.470    3.000
 DMU      C22    C25    C28     111.000    3.000
 DMU      H251   C25    H252    107.900    3.000
 DMU      H251   C25    C28     109.470    3.000
 DMU      H252   C25    C28     109.470    3.000
 DMU      C25    C28    H281    109.470    3.000
 DMU      C25    C28    H282    109.470    3.000
 DMU      C25    C28    C31     111.000    3.000
 DMU      H281   C28    H282    107.900    3.000
 DMU      H281   C28    C31     109.470    3.000
 DMU      H282   C28    C31     109.470    3.000
 DMU      C28    C31    H311    109.470    3.000
 DMU      C28    C31    H312    109.470    3.000
 DMU      C28    C31    C34     111.000    3.000
 DMU      H311   C31    H312    107.900    3.000
 DMU      H311   C31    C34     109.470    3.000
 DMU      H312   C31    C34     109.470    3.000
 DMU      C31    C34    H341    109.470    3.000
 DMU      C31    C34    H342    109.470    3.000
 DMU      C31    C34    C37     111.000    3.000
 DMU      H341   C34    H342    107.900    3.000
 DMU      H341   C34    C37     109.470    3.000
 DMU      H342   C34    C37     109.470    3.000
 DMU      C34    C37    H371    109.470    3.000
 DMU      C34    C37    H372    109.470    3.000
 DMU      C34    C37    C40     111.000    3.000
 DMU      H371   C37    H372    107.900    3.000
 DMU      H371   C37    C40     109.470    3.000
 DMU      H372   C37    C40     109.470    3.000
 DMU      C37    C40    H401    109.470    3.000
 DMU      C37    C40    H402    109.470    3.000
 DMU      C37    C40    C43     111.000    3.000
 DMU      H401   C40    H402    107.900    3.000
 DMU      H401   C40    C43     109.470    3.000
 DMU      H402   C40    C43     109.470    3.000
 DMU      C40    C43    H433    109.470    3.000
 DMU      C40    C43    H432    109.470    3.000
 DMU      C40    C43    H431    109.470    3.000
 DMU      H433   C43    H432    109.470    3.000
 DMU      H433   C43    H431    109.470    3.000
 DMU      H432   C43    H431    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DMU      var_1    HO6    O6     C11    C9       179.986   20.000   1
 DMU      var_2    O6     C11    C9     O1       -65.000   20.000   3
 DMU      var_3    C11    C9     C8     C7       180.000   20.000   3
 DMU      var_4    C9     C8     O2     HO2      179.999   20.000   1
 DMU      var_5    C9     C8     C7     O4        60.000   20.000   3
 DMU      var_6    C8     C7     O4     HO4      179.974   20.000   1
 DMU      var_7    C11    C9     O1     C10      180.000   20.000   1
 DMU      var_8    C9     O1     C10    O7       180.000   20.000   1
 DMU      var_9    O1     C10    C5     O3       180.000   20.000   3
 DMU      var_10   C10    C5     C7     C8        60.000   20.000   3
 DMU      var_11   C10    C5     O3     HO3      -60.472   20.000   1
 DMU      var_12   O1     C10    O7     C3        69.885   20.000   1
 DMU      var_13   C10    O7     C3     C4      -150.010   20.000   1
 DMU      var_14   O7     C3     C2     O55      -60.000   20.000   3
 DMU      var_15   C3     C2     O55    H55     -179.979   20.000   1
 DMU      var_16   O7     C3     C4     O5       180.000   20.000   3
 DMU      var_17   C3     C4     C57    O61     -174.695   20.000   3
 DMU      var_18   C4     C57    O61    H61     -179.955   20.000   1
 DMU      var_19   C3     C4     O5     C6        60.000   20.000   1
 DMU      var_20   C4     O5     C6     O16      180.000   20.000   1
 DMU      var_21   O5     C6     C1     O49      180.000   20.000   3
 DMU      var_22   C6     C1     C2     C3       -60.000   20.000   3
 DMU      var_23   C6     C1     O49    H49       60.424   20.000   1
 DMU      var_24   O5     C6     O16    C18      -64.866   20.000   1
 DMU      var_25   C6     O16    C18    C19      179.955   20.000   1
 DMU      var_26   O16    C18    C19    C22     -179.999   20.000   3
 DMU      var_27   C18    C19    C22    C25     -179.948   20.000   3
 DMU      var_28   C19    C22    C25    C28      179.994   20.000   3
 DMU      var_29   C22    C25    C28    C31      179.994   20.000   3
 DMU      var_30   C25    C28    C31    C34      180.000   20.000   3
 DMU      var_31   C28    C31    C34    C37      180.000   20.000   3
 DMU      var_32   C31    C34    C37    C40     -179.965   20.000   3
 DMU      var_33   C34    C37    C40    C43      179.983   20.000   3
 DMU      var_34   C37    C40    C43    H431     179.946   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DMU      chir_01  C1     C2     C6     O49       positiv
 DMU      chir_02  C2     C1     C3     O55       positiv
 DMU      chir_03  C3     C2     C4     O7        negativ
 DMU      chir_04  C4     C3     O5     C57       positiv
 DMU      chir_05  C6     C1     O5     O16       positiv
 DMU      chir_06  C5     C7     C10    O3        negativ
 DMU      chir_07  C7     C5     C8     O4        positiv
 DMU      chir_08  C8     C7     C9     O2        negativ
 DMU      chir_09  C9     C8     O1     C11       positiv
 DMU      chir_10  C10    O7     C5     O1        positiv
# ------------------------------------------------------
`.trim();

monomers["LMT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
LMT      LMT 'DODECYL-BETA-D-MALTOSIDE            ' non-polymer        81  35 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_LMT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 LMT           "O6'"  O    OH1       0.000      0.000    0.000    0.000
 LMT           "H6'"  H    H         0.000      0.884    0.323    0.222
 LMT           "C6'"  C    CH2       0.000     -0.394    0.526   -1.269
 LMT           H6D    H    H         0.000      0.316    0.202   -2.033
 LMT           H6E    H    H         0.000     -0.406    1.616   -1.224
 LMT           "C5'"  C    CH1       0.000     -1.792    0.013   -1.621
 LMT           "H5'"  H    H         0.000     -1.793   -1.086   -1.604
 LMT           "C4'"  C    CH1       0.000     -2.173    0.500   -3.020
 LMT           "H4'"  H    H         0.000     -2.194    1.599   -3.033
 LMT           "C3'"  C    CH1       0.000     -3.560   -0.044   -3.377
 LMT           "H3'"  H    H         0.000     -3.515   -1.138   -3.467
 LMT           "O3'"  O    OH1       0.000     -3.992    0.521   -4.617
 LMT           H3O2   H    H         0.000     -4.867    0.176   -4.840
 LMT           "C2'"  C    CH1       0.000     -4.539    0.341   -2.262
 LMT           "H2'"  H    H         0.000     -4.663    1.433   -2.242
 LMT           "O2'"  O    OH1       0.000     -5.803   -0.281   -2.502
 LMT           H2O2   H    H         0.000     -6.420   -0.037   -1.798
 LMT           O1B    O    O2        0.000     -1.213    0.030   -3.969
 LMT           C1B    C    CH1       0.000     -1.243    0.938   -5.072
 LMT           H1B    H    H         0.000     -2.287    1.156   -5.337
 LMT           O5B    O    O2        0.000     -0.584    2.148   -4.707
 LMT           C5B    C    CH1       0.000      0.705    1.803   -4.202
 LMT           H5B    H    H         0.000      0.597    1.046   -3.413
 LMT           C6B    C    CH2       0.000      1.375    3.050   -3.622
 LMT           "H6'2" H    H         0.000      1.482    3.803   -4.406
 LMT           "H6'1" H    H         0.000      2.362    2.786   -3.236
 LMT           O6B    O    OH1       0.000      0.571    3.574   -2.563
 LMT           H6B    H    H         0.000      0.995    4.362   -2.198
 LMT           C4B    C    CH1       0.000      1.570    1.240   -5.331
 LMT           H4B    H    H         0.000      1.660    1.987   -6.132
 LMT           "O4'"  O    OH1       0.000      2.868    0.922   -4.825
 LMT           H4O1   H    H         0.000      3.414    0.566   -5.539
 LMT           C3B    C    CH1       0.000      0.908   -0.027   -5.883
 LMT           H3B    H    H         0.000      0.912   -0.811   -5.113
 LMT           O3B    O    OH1       0.000      1.625   -0.481   -7.033
 LMT           H3O1   H    H         0.000      1.206   -1.281   -7.379
 LMT           C2B    C    CH1       0.000     -0.535    0.305   -6.271
 LMT           H2B    H    H         0.000     -0.536    1.011   -7.114
 LMT           O2B    O    OH1       0.000     -1.216   -0.893   -6.650
 LMT           H2O1   H    H         0.000     -2.127   -0.682   -6.895
 LMT           "O5'"  O    O2        0.000     -2.730    0.502   -0.666
 LMT           "C1'"  C    CH1       0.000     -3.979   -0.136   -0.921
 LMT           "H1'"  H    H         0.000     -3.833   -1.225   -0.952
 LMT           "O1'"  O    O2        0.000     -4.901    0.189    0.120
 LMT           C1     C    CH2       0.000     -4.327   -0.281    1.342
 LMT           H12    H    H         0.000     -3.366    0.212    1.505
 LMT           H11    H    H         0.000     -4.175   -1.361    1.280
 LMT           C2     C    CH2       0.000     -5.269    0.037    2.504
 LMT           H22    H    H         0.000     -6.230   -0.456    2.339
 LMT           H21    H    H         0.000     -5.422    1.117    2.564
 LMT           C3     C    CH2       0.000     -4.655   -0.466    3.812
 LMT           H32    H    H         0.000     -3.694    0.027    3.975
 LMT           H31    H    H         0.000     -4.502   -1.546    3.750
 LMT           C4     C    CH2       0.000     -5.597   -0.148    4.974
 LMT           H42    H    H         0.000     -6.557   -0.641    4.808
 LMT           H41    H    H         0.000     -5.749    0.931    5.033
 LMT           C5     C    CH2       0.000     -4.983   -0.652    6.281
 LMT           H52    H    H         0.000     -4.022   -0.159    6.444
 LMT           H51    H    H         0.000     -4.831   -1.731    6.219
 LMT           C6     C    CH2       0.000     -5.925   -0.334    7.443
 LMT           H62    H    H         0.000     -6.885   -0.825    7.277
 LMT           H61    H    H         0.000     -6.075    0.746    7.503
 LMT           C7     C    CH2       0.000     -5.312   -0.837    8.751
 LMT           H72    H    H         0.000     -4.351   -0.344    8.915
 LMT           H71    H    H         0.000     -5.160   -1.917    8.688
 LMT           C8     C    CH2       0.000     -6.254   -0.520    9.913
 LMT           H82    H    H         0.000     -7.214   -1.014    9.748
 LMT           H81    H    H         0.000     -6.407    0.559    9.973
 LMT           C9     C    CH2       0.000     -5.639   -1.023   11.221
 LMT           H92    H    H         0.000     -4.679   -0.530   11.384
 LMT           H91    H    H         0.000     -5.487   -2.103   11.159
 LMT           C10    C    CH2       0.000     -6.582   -0.705   12.383
 LMT           H102   H    H         0.000     -7.542   -1.198   12.217
 LMT           H101   H    H         0.000     -6.733    0.374   12.442
 LMT           C11    C    CH2       0.000     -5.968   -1.209   13.691
 LMT           H112   H    H         0.000     -5.007   -0.717   13.854
 LMT           H111   H    H         0.000     -5.817   -2.288   13.629
 LMT           C12    C    CH3       0.000     -6.910   -0.890   14.854
 LMT           H121   H    H         0.000     -7.058    0.158   14.916
 LMT           H122   H    H         0.000     -7.844   -1.366   14.697
 LMT           H123   H    H         0.000     -6.487   -1.238   15.761
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 LMT      "O6'"  n/a    "C6'"  START
 LMT      "H6'"  "O6'"  .      .
 LMT      "C6'"  "O6'"  "C5'"  .
 LMT      H6D    "C6'"  .      .
 LMT      H6E    "C6'"  .      .
 LMT      "C5'"  "C6'"  "O5'"  .
 LMT      "H5'"  "C5'"  .      .
 LMT      "C4'"  "C5'"  O1B    .
 LMT      "H4'"  "C4'"  .      .
 LMT      "C3'"  "C4'"  "C2'"  .
 LMT      "H3'"  "C3'"  .      .
 LMT      "O3'"  "C3'"  H3O2   .
 LMT      H3O2   "O3'"  .      .
 LMT      "C2'"  "C3'"  "O2'"  .
 LMT      "H2'"  "C2'"  .      .
 LMT      "O2'"  "C2'"  H2O2   .
 LMT      H2O2   "O2'"  .      .
 LMT      O1B    "C4'"  C1B    .
 LMT      C1B    O1B    O5B    .
 LMT      H1B    C1B    .      .
 LMT      O5B    C1B    C5B    .
 LMT      C5B    O5B    C4B    .
 LMT      H5B    C5B    .      .
 LMT      C6B    C5B    O6B    .
 LMT      "H6'2" C6B    .      .
 LMT      "H6'1" C6B    .      .
 LMT      O6B    C6B    H6B    .
 LMT      H6B    O6B    .      .
 LMT      C4B    C5B    C3B    .
 LMT      H4B    C4B    .      .
 LMT      "O4'"  C4B    H4O1   .
 LMT      H4O1   "O4'"  .      .
 LMT      C3B    C4B    C2B    .
 LMT      H3B    C3B    .      .
 LMT      O3B    C3B    H3O1   .
 LMT      H3O1   O3B    .      .
 LMT      C2B    C3B    O2B    .
 LMT      H2B    C2B    .      .
 LMT      O2B    C2B    H2O1   .
 LMT      H2O1   O2B    .      .
 LMT      "O5'"  "C5'"  "C1'"  .
 LMT      "C1'"  "O5'"  "O1'"  .
 LMT      "H1'"  "C1'"  .      .
 LMT      "O1'"  "C1'"  C1     .
 LMT      C1     "O1'"  C2     .
 LMT      H12    C1     .      .
 LMT      H11    C1     .      .
 LMT      C2     C1     C3     .
 LMT      H22    C2     .      .
 LMT      H21    C2     .      .
 LMT      C3     C2     C4     .
 LMT      H32    C3     .      .
 LMT      H31    C3     .      .
 LMT      C4     C3     C5     .
 LMT      H42    C4     .      .
 LMT      H41    C4     .      .
 LMT      C5     C4     C6     .
 LMT      H52    C5     .      .
 LMT      H51    C5     .      .
 LMT      C6     C5     C7     .
 LMT      H62    C6     .      .
 LMT      H61    C6     .      .
 LMT      C7     C6     C8     .
 LMT      H72    C7     .      .
 LMT      H71    C7     .      .
 LMT      C8     C7     C9     .
 LMT      H82    C8     .      .
 LMT      H81    C8     .      .
 LMT      C9     C8     C10    .
 LMT      H92    C9     .      .
 LMT      H91    C9     .      .
 LMT      C10    C9     C11    .
 LMT      H102   C10    .      .
 LMT      H101   C10    .      .
 LMT      C11    C10    C12    .
 LMT      H112   C11    .      .
 LMT      H111   C11    .      .
 LMT      C12    C11    H123   .
 LMT      H121   C12    .      .
 LMT      H122   C12    .      .
 LMT      H123   C12    .      END
 LMT      C1B    C2B    .    ADD
 LMT      "C1'"  "C2'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 LMT      C1B    C2B       single      1.524    0.020
 LMT      C1B    O1B       single      1.426    0.020
 LMT      O5B    C1B       single      1.426    0.020
 LMT      H1B    C1B       single      1.099    0.020
 LMT      C2B    C3B       single      1.524    0.020
 LMT      O2B    C2B       single      1.432    0.020
 LMT      H2B    C2B       single      1.099    0.020
 LMT      C3B    C4B       single      1.524    0.020
 LMT      O3B    C3B       single      1.432    0.020
 LMT      H3B    C3B       single      1.099    0.020
 LMT      C4B    C5B       single      1.524    0.020
 LMT      "O4'"  C4B       single      1.432    0.020
 LMT      H4B    C4B       single      1.099    0.020
 LMT      C6B    C5B       single      1.524    0.020
 LMT      C5B    O5B       single      1.426    0.020
 LMT      H5B    C5B       single      1.099    0.020
 LMT      O6B    C6B       single      1.432    0.020
 LMT      "H6'2" C6B       single      1.092    0.020
 LMT      "H6'1" C6B       single      1.092    0.020
 LMT      O1B    "C4'"     single      1.426    0.020
 LMT      H2O1   O2B       single      0.967    0.020
 LMT      H3O1   O3B       single      0.967    0.020
 LMT      H4O1   "O4'"     single      0.967    0.020
 LMT      H6B    O6B       single      0.967    0.020
 LMT      "C1'"  "C2'"     single      1.524    0.020
 LMT      "O1'"  "C1'"     single      1.426    0.020
 LMT      "C1'"  "O5'"     single      1.426    0.020
 LMT      "H1'"  "C1'"     single      1.099    0.020
 LMT      "C2'"  "C3'"     single      1.524    0.020
 LMT      "O2'"  "C2'"     single      1.432    0.020
 LMT      "H2'"  "C2'"     single      1.099    0.020
 LMT      "C3'"  "C4'"     single      1.524    0.020
 LMT      "O3'"  "C3'"     single      1.432    0.020
 LMT      "H3'"  "C3'"     single      1.099    0.020
 LMT      "C4'"  "C5'"     single      1.524    0.020
 LMT      "H4'"  "C4'"     single      1.099    0.020
 LMT      "C5'"  "C6'"     single      1.524    0.020
 LMT      "O5'"  "C5'"     single      1.426    0.020
 LMT      "H5'"  "C5'"     single      1.099    0.020
 LMT      "C6'"  "O6'"     single      1.432    0.020
 LMT      H6D    "C6'"     single      1.092    0.020
 LMT      H6E    "C6'"     single      1.092    0.020
 LMT      C1     "O1'"     single      1.426    0.020
 LMT      H2O2   "O2'"     single      0.967    0.020
 LMT      H3O2   "O3'"     single      0.967    0.020
 LMT      "H6'"  "O6'"     single      0.967    0.020
 LMT      C2     C1        single      1.524    0.020
 LMT      H12    C1        single      1.092    0.020
 LMT      H11    C1        single      1.092    0.020
 LMT      C3     C2        single      1.524    0.020
 LMT      H22    C2        single      1.092    0.020
 LMT      H21    C2        single      1.092    0.020
 LMT      C4     C3        single      1.524    0.020
 LMT      H32    C3        single      1.092    0.020
 LMT      H31    C3        single      1.092    0.020
 LMT      C5     C4        single      1.524    0.020
 LMT      H42    C4        single      1.092    0.020
 LMT      H41    C4        single      1.092    0.020
 LMT      C6     C5        single      1.524    0.020
 LMT      H52    C5        single      1.092    0.020
 LMT      H51    C5        single      1.092    0.020
 LMT      C7     C6        single      1.524    0.020
 LMT      H62    C6        single      1.092    0.020
 LMT      H61    C6        single      1.092    0.020
 LMT      C8     C7        single      1.524    0.020
 LMT      H72    C7        single      1.092    0.020
 LMT      H71    C7        single      1.092    0.020
 LMT      C9     C8        single      1.524    0.020
 LMT      H82    C8        single      1.092    0.020
 LMT      H81    C8        single      1.092    0.020
 LMT      C10    C9        single      1.524    0.020
 LMT      H92    C9        single      1.092    0.020
 LMT      H91    C9        single      1.092    0.020
 LMT      C11    C10       single      1.524    0.020
 LMT      H102   C10       single      1.092    0.020
 LMT      H101   C10       single      1.092    0.020
 LMT      C12    C11       single      1.513    0.020
 LMT      H112   C11       single      1.092    0.020
 LMT      H111   C11       single      1.092    0.020
 LMT      H123   C12       single      1.059    0.020
 LMT      H122   C12       single      1.059    0.020
 LMT      H121   C12       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 LMT      "H6'"  "O6'"  "C6'"   109.470    3.000
 LMT      "O6'"  "C6'"  H6D     109.470    3.000
 LMT      "O6'"  "C6'"  H6E     109.470    3.000
 LMT      "O6'"  "C6'"  "C5'"   109.470    3.000
 LMT      H6D    "C6'"  H6E     107.900    3.000
 LMT      H6D    "C6'"  "C5'"   109.470    3.000
 LMT      H6E    "C6'"  "C5'"   109.470    3.000
 LMT      "C6'"  "C5'"  "H5'"   108.340    3.000
 LMT      "C6'"  "C5'"  "C4'"   111.000    3.000
 LMT      "C6'"  "C5'"  "O5'"   109.470    3.000
 LMT      "H5'"  "C5'"  "C4'"   108.340    3.000
 LMT      "H5'"  "C5'"  "O5'"   109.470    3.000
 LMT      "C4'"  "C5'"  "O5'"   109.470    3.000
 LMT      "C5'"  "C4'"  "H4'"   108.340    3.000
 LMT      "C5'"  "C4'"  "C3'"   111.000    3.000
 LMT      "C5'"  "C4'"  O1B     109.470    3.000
 LMT      "H4'"  "C4'"  "C3'"   108.340    3.000
 LMT      "H4'"  "C4'"  O1B     109.470    3.000
 LMT      "C3'"  "C4'"  O1B     109.470    3.000
 LMT      "C4'"  "C3'"  "H3'"   108.340    3.000
 LMT      "C4'"  "C3'"  "O3'"   109.470    3.000
 LMT      "C4'"  "C3'"  "C2'"   111.000    3.000
 LMT      "H3'"  "C3'"  "O3'"   109.470    3.000
 LMT      "H3'"  "C3'"  "C2'"   108.340    3.000
 LMT      "O3'"  "C3'"  "C2'"   109.470    3.000
 LMT      "C3'"  "O3'"  H3O2    109.470    3.000
 LMT      "C3'"  "C2'"  "H2'"   108.340    3.000
 LMT      "C3'"  "C2'"  "O2'"   109.470    3.000
 LMT      "C3'"  "C2'"  "C1'"   111.000    3.000
 LMT      "H2'"  "C2'"  "O2'"   109.470    3.000
 LMT      "H2'"  "C2'"  "C1'"   108.340    3.000
 LMT      "O2'"  "C2'"  "C1'"   109.470    3.000
 LMT      "C2'"  "O2'"  H2O2    109.470    3.000
 LMT      "C4'"  O1B    C1B     111.800    3.000
 LMT      O1B    C1B    H1B     109.470    3.000
 LMT      O1B    C1B    O5B     109.470    3.000
 LMT      O1B    C1B    C2B     109.470    3.000
 LMT      H1B    C1B    O5B     109.470    3.000
 LMT      H1B    C1B    C2B     108.340    3.000
 LMT      O5B    C1B    C2B     109.470    3.000
 LMT      C1B    O5B    C5B     111.800    3.000
 LMT      O5B    C5B    H5B     109.470    3.000
 LMT      O5B    C5B    C6B     109.470    3.000
 LMT      O5B    C5B    C4B     109.470    3.000
 LMT      H5B    C5B    C6B     108.340    3.000
 LMT      H5B    C5B    C4B     108.340    3.000
 LMT      C6B    C5B    C4B     111.000    3.000
 LMT      C5B    C6B    "H6'2"  109.470    3.000
 LMT      C5B    C6B    "H6'1"  109.470    3.000
 LMT      C5B    C6B    O6B     109.470    3.000
 LMT      "H6'2" C6B    "H6'1"  107.900    3.000
 LMT      "H6'2" C6B    O6B     109.470    3.000
 LMT      "H6'1" C6B    O6B     109.470    3.000
 LMT      C6B    O6B    H6B     109.470    3.000
 LMT      C5B    C4B    H4B     108.340    3.000
 LMT      C5B    C4B    "O4'"   109.470    3.000
 LMT      C5B    C4B    C3B     111.000    3.000
 LMT      H4B    C4B    "O4'"   109.470    3.000
 LMT      H4B    C4B    C3B     108.340    3.000
 LMT      "O4'"  C4B    C3B     109.470    3.000
 LMT      C4B    "O4'"  H4O1    109.470    3.000
 LMT      C4B    C3B    H3B     108.340    3.000
 LMT      C4B    C3B    O3B     109.470    3.000
 LMT      C4B    C3B    C2B     111.000    3.000
 LMT      H3B    C3B    O3B     109.470    3.000
 LMT      H3B    C3B    C2B     108.340    3.000
 LMT      O3B    C3B    C2B     109.470    3.000
 LMT      C3B    O3B    H3O1    109.470    3.000
 LMT      C3B    C2B    H2B     108.340    3.000
 LMT      C3B    C2B    O2B     109.470    3.000
 LMT      C3B    C2B    C1B     111.000    3.000
 LMT      H2B    C2B    O2B     109.470    3.000
 LMT      H2B    C2B    C1B     108.340    3.000
 LMT      O2B    C2B    C1B     109.470    3.000
 LMT      C2B    O2B    H2O1    109.470    3.000
 LMT      "C5'"  "O5'"  "C1'"   111.800    3.000
 LMT      "O5'"  "C1'"  "H1'"   109.470    3.000
 LMT      "O5'"  "C1'"  "O1'"   109.470    3.000
 LMT      "O5'"  "C1'"  "C2'"   109.470    3.000
 LMT      "H1'"  "C1'"  "O1'"   109.470    3.000
 LMT      "H1'"  "C1'"  "C2'"   108.340    3.000
 LMT      "O1'"  "C1'"  "C2'"   109.470    3.000
 LMT      "C1'"  "O1'"  C1      111.800    3.000
 LMT      "O1'"  C1     H12     109.470    3.000
 LMT      "O1'"  C1     H11     109.470    3.000
 LMT      "O1'"  C1     C2      109.470    3.000
 LMT      H12    C1     H11     107.900    3.000
 LMT      H12    C1     C2      109.470    3.000
 LMT      H11    C1     C2      109.470    3.000
 LMT      C1     C2     H22     109.470    3.000
 LMT      C1     C2     H21     109.470    3.000
 LMT      C1     C2     C3      111.000    3.000
 LMT      H22    C2     H21     107.900    3.000
 LMT      H22    C2     C3      109.470    3.000
 LMT      H21    C2     C3      109.470    3.000
 LMT      C2     C3     H32     109.470    3.000
 LMT      C2     C3     H31     109.470    3.000
 LMT      C2     C3     C4      111.000    3.000
 LMT      H32    C3     H31     107.900    3.000
 LMT      H32    C3     C4      109.470    3.000
 LMT      H31    C3     C4      109.470    3.000
 LMT      C3     C4     H42     109.470    3.000
 LMT      C3     C4     H41     109.470    3.000
 LMT      C3     C4     C5      111.000    3.000
 LMT      H42    C4     H41     107.900    3.000
 LMT      H42    C4     C5      109.470    3.000
 LMT      H41    C4     C5      109.470    3.000
 LMT      C4     C5     H52     109.470    3.000
 LMT      C4     C5     H51     109.470    3.000
 LMT      C4     C5     C6      111.000    3.000
 LMT      H52    C5     H51     107.900    3.000
 LMT      H52    C5     C6      109.470    3.000
 LMT      H51    C5     C6      109.470    3.000
 LMT      C5     C6     H62     109.470    3.000
 LMT      C5     C6     H61     109.470    3.000
 LMT      C5     C6     C7      111.000    3.000
 LMT      H62    C6     H61     107.900    3.000
 LMT      H62    C6     C7      109.470    3.000
 LMT      H61    C6     C7      109.470    3.000
 LMT      C6     C7     H72     109.470    3.000
 LMT      C6     C7     H71     109.470    3.000
 LMT      C6     C7     C8      111.000    3.000
 LMT      H72    C7     H71     107.900    3.000
 LMT      H72    C7     C8      109.470    3.000
 LMT      H71    C7     C8      109.470    3.000
 LMT      C7     C8     H82     109.470    3.000
 LMT      C7     C8     H81     109.470    3.000
 LMT      C7     C8     C9      111.000    3.000
 LMT      H82    C8     H81     107.900    3.000
 LMT      H82    C8     C9      109.470    3.000
 LMT      H81    C8     C9      109.470    3.000
 LMT      C8     C9     H92     109.470    3.000
 LMT      C8     C9     H91     109.470    3.000
 LMT      C8     C9     C10     111.000    3.000
 LMT      H92    C9     H91     107.900    3.000
 LMT      H92    C9     C10     109.470    3.000
 LMT      H91    C9     C10     109.470    3.000
 LMT      C9     C10    H102    109.470    3.000
 LMT      C9     C10    H101    109.470    3.000
 LMT      C9     C10    C11     111.000    3.000
 LMT      H102   C10    H101    107.900    3.000
 LMT      H102   C10    C11     109.470    3.000
 LMT      H101   C10    C11     109.470    3.000
 LMT      C10    C11    H112    109.470    3.000
 LMT      C10    C11    H111    109.470    3.000
 LMT      C10    C11    C12     111.000    3.000
 LMT      H112   C11    H111    107.900    3.000
 LMT      H112   C11    C12     109.470    3.000
 LMT      H111   C11    C12     109.470    3.000
 LMT      C11    C12    H121    109.470    3.000
 LMT      C11    C12    H122    109.470    3.000
 LMT      C11    C12    H123    109.470    3.000
 LMT      H121   C12    H122    109.470    3.000
 LMT      H121   C12    H123    109.470    3.000
 LMT      H122   C12    H123    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 LMT      var_1    "H6'"  "O6'"  "C6'"  "C5'"    179.951   20.000   1
 LMT      var_2    "O6'"  "C6'"  "C5'"  "O5'"     63.409   20.000   3
 LMT      var_3    "C6'"  "C5'"  "C4'"  O1B       60.000   20.000   3
 LMT      var_4    "C5'"  "C4'"  "C3'"  "C2'"     60.000   20.000   3
 LMT      var_5    "C4'"  "C3'"  "O3'"  H3O2     179.988   20.000   1
 LMT      var_6    "C4'"  "C3'"  "C2'"  "O2'"    180.000   20.000   3
 LMT      var_7    "C3'"  "C2'"  "O2'"  H2O2    -179.981   20.000   1
 LMT      var_8    "C5'"  "C4'"  O1B    C1B     -154.880   20.000   1
 LMT      var_9    "C4'"  O1B    C1B    O5B       74.890   20.000   1
 LMT      var_10   O1B    C1B    C2B    C3B      -60.000   20.000   3
 LMT      var_11   O1B    C1B    O5B    C5B       60.000   20.000   1
 LMT      var_12   C1B    O5B    C5B    C4B       60.000   20.000   1
 LMT      var_13   O5B    C5B    C6B    O6B       59.962   20.000   3
 LMT      var_14   C5B    C6B    O6B    H6B     -179.969   20.000   1
 LMT      var_15   O5B    C5B    C4B    C3B      -60.000   20.000   3
 LMT      var_16   C5B    C4B    "O4'"  H4O1    -179.995   20.000   1
 LMT      var_17   C5B    C4B    C3B    C2B       60.000   20.000   3
 LMT      var_18   C4B    C3B    O3B    H3O1     179.954   20.000   1
 LMT      var_19   C4B    C3B    C2B    O2B      180.000   20.000   3
 LMT      var_20   C3B    C2B    O2B    H2O1     179.984   20.000   1
 LMT      var_21   "C6'"  "C5'"  "O5'"  "C1'"    180.000   20.000   1
 LMT      var_22   "C5'"  "O5'"  "C1'"  "O1'"    180.000   20.000   1
 LMT      var_23   "O5'"  "C1'"  "C2'"  "C3'"     60.000   20.000   3
 LMT      var_24   "O5'"  "C1'"  "O1'"  C1       -59.830   20.000   1
 LMT      var_25   "C1'"  "O1'"  C1     C2      -179.974   20.000   1
 LMT      var_26   "O1'"  C1     C2     C3      -179.974   20.000   3
 LMT      var_27   C1     C2     C3     C4       180.000   20.000   3
 LMT      var_28   C2     C3     C4     C5       179.974   20.000   3
 LMT      var_29   C3     C4     C5     C6       179.974   20.000   3
 LMT      var_30   C4     C5     C6     C7       179.969   20.000   3
 LMT      var_31   C5     C6     C7     C8      -179.944   20.000   3
 LMT      var_32   C6     C7     C8     C9      -179.943   20.000   3
 LMT      var_33   C7     C8     C9     C10      179.971   20.000   3
 LMT      var_34   C8     C9     C10    C11      179.969   20.000   3
 LMT      var_35   C9     C10    C11    C12      179.944   20.000   3
 LMT      var_36   C10    C11    C12    H123     179.975   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 LMT      chir_01  C1B    C2B    O1B    O5B       negativ
 LMT      chir_02  C2B    C1B    C3B    O2B       negativ
 LMT      chir_03  C3B    C2B    C4B    O3B       positiv
 LMT      chir_04  C4B    C3B    C5B    "O4'"     negativ
 LMT      chir_05  C5B    C4B    C6B    O5B       negativ
 LMT      chir_06  "C1'"  "C2'"  "O1'"  "O5'"     positiv
 LMT      chir_07  "C2'"  "C1'"  "C3'"  "O2'"     negativ
 LMT      chir_08  "C3'"  "C2'"  "C4'"  "O3'"     positiv
 LMT      chir_09  "C4'"  O1B    "C3'"  "C5'"     negativ
 LMT      chir_10  "C5'"  "C4'"  "C6'"  "O5'"     negativ
# ------------------------------------------------------
`.trim();

monomers["TRE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TRE      TRE 'TREHALOSE                           ' pyranose           45  23 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TRE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TRE           C1     C    CH1       0.000      0.000    0.000    0.000
 TRE           HC1    H    H         0.000     -0.208   -0.988    0.435
 TRE           O1     O    O2        0.000     -0.984    0.298   -0.991
 TRE           C1P    C    CH1       0.000     -0.894   -0.725   -1.984
 TRE           HC1P   H    H         0.000      0.114   -0.723   -2.420
 TRE           O5P    O    O2        0.000     -1.147   -1.992   -1.381
 TRE           C5P    C    CH1       0.000     -2.382   -1.896   -0.676
 TRE           HC5P   H    H         0.000     -2.352   -1.030   -0.001
 TRE           C4P    C    CH1       0.000     -3.534   -1.728   -1.668
 TRE           HC4P   H    H         0.000     -3.552   -2.582   -2.359
 TRE           O4P    O    OH1       0.000     -4.772   -1.660   -0.958
 TRE           HO4P   H    H         0.000     -5.498   -1.552   -1.587
 TRE           C3P    C    CH1       0.000     -3.324   -0.432   -2.460
 TRE           HC3P   H    H         0.000     -3.409    0.431   -1.785
 TRE           O3P    O    OH1       0.000     -4.309   -0.335   -3.490
 TRE           HO3P   H    H         0.000     -4.174    0.483   -3.988
 TRE           C2P    C    CH1       0.000     -1.925   -0.461   -3.083
 TRE           HC2P   H    H         0.000     -1.873   -1.260   -3.835
 TRE           O2P    O    OH1       0.000     -1.651    0.798   -3.701
 TRE           HO2P   H    H         0.000     -0.768    0.777   -4.095
 TRE           C6P    C    CH2       0.000     -2.601   -3.171    0.142
 TRE           H6P1   H    H         0.000     -2.631   -4.032   -0.529
 TRE           H6P2   H    H         0.000     -3.548   -3.098    0.681
 TRE           O6P    O    OH1       0.000     -1.531   -3.328    1.075
 TRE           HO6P   H    H         0.000     -1.707   -4.140    1.569
 TRE           O5     O    O2        0.000      1.293   -0.010   -0.602
 TRE           C5     C    CH1       0.000      1.449    1.220   -1.305
 TRE           HC5    H    H         0.000      0.593    1.367   -1.979
 TRE           C6     C    CH2       0.000      2.742    1.175   -2.125
 TRE           HC61   H    H         0.000      3.592    1.030   -1.456
 TRE           HC62   H    H         0.000      2.862    2.117   -2.666
 TRE           O6     O    OH1       0.000      2.677    0.094   -3.057
 TRE           HO6    H    H         0.000      3.493    0.066   -3.574
 TRE           C4     C    CH1       0.000      1.519    2.380   -0.311
 TRE           HC4    H    H         0.000      2.359    2.223    0.380
 TRE           O4     O    OH1       0.000      1.705    3.607   -1.020
 TRE           HO4    H    H         0.000      1.740    4.340   -0.390
 TRE           C3     C    CH1       0.000      0.206    2.438    0.480
 TRE           HC3    H    H         0.000     -0.621    2.699   -0.196
 TRE           O3     O    OH1       0.000      0.310    3.419    1.512
 TRE           HO3    H    H         0.000     -0.515    3.444    2.016
 TRE           C2     C    CH1       0.000     -0.051    1.061    1.102
 TRE           HC2    H    H         0.000      0.721    0.847    1.854
 TRE           O2     O    OH1       0.000     -1.339    1.047    1.720
 TRE           HO2    H    H         0.000     -1.501    0.176    2.106
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TRE      C1     n/a    O5     START
 TRE      HC1    C1     .      .
 TRE      O1     C1     C1P    .
 TRE      C1P    O1     O5P    .
 TRE      HC1P   C1P    .      .
 TRE      O5P    C1P    C5P    .
 TRE      C5P    O5P    C6P    .
 TRE      HC5P   C5P    .      .
 TRE      C4P    C5P    C3P    .
 TRE      HC4P   C4P    .      .
 TRE      O4P    C4P    HO4P   .
 TRE      HO4P   O4P    .      .
 TRE      C3P    C4P    C2P    .
 TRE      HC3P   C3P    .      .
 TRE      O3P    C3P    HO3P   .
 TRE      HO3P   O3P    .      .
 TRE      C2P    C3P    O2P    .
 TRE      HC2P   C2P    .      .
 TRE      O2P    C2P    HO2P   .
 TRE      HO2P   O2P    .      .
 TRE      C6P    C5P    O6P    .
 TRE      H6P1   C6P    .      .
 TRE      H6P2   C6P    .      .
 TRE      O6P    C6P    .      .
 TRE      HO6P   O6P    .      .
 TRE      O5     C1     .      END
 TRE      C5     O5     C4     .
 TRE      HC5    C5     .      .
 TRE      C6     C5     O6     .
 TRE      HC61   C6     .      .
 TRE      HC62   C6     .      .
 TRE      O6     C6     HO6    .
 TRE      HO6    O6     .      .
 TRE      C4     C5     C3     .
 TRE      HC4    C4     .      .
 TRE      O4     C4     HO4    .
 TRE      HO4    O4     .      .
 TRE      C3     C4     C2     .
 TRE      HC3    C3     .      .
 TRE      O3     C3     HO3    .
 TRE      HO3    O3     .      .
 TRE      C2     C3     O2     .
 TRE      HC2    C2     .      .
 TRE      O2     C2     HO2    .
 TRE      HO2    O2     .      .
 TRE      C1     C2     .    ADD
 TRE      C1P    C2P    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TRE      C1     C2        single      1.524    0.020
 TRE      O1     C1        single      1.426    0.020
 TRE      O5     C1        single      1.426    0.020
 TRE      HC1    C1        single      1.099    0.020
 TRE      C2     C3        single      1.524    0.020
 TRE      O2     C2        single      1.432    0.020
 TRE      HC2    C2        single      1.099    0.020
 TRE      C3     C4        single      1.524    0.020
 TRE      O3     C3        single      1.432    0.020
 TRE      HC3    C3        single      1.099    0.020
 TRE      C4     C5        single      1.524    0.020
 TRE      O4     C4        single      1.432    0.020
 TRE      HC4    C4        single      1.099    0.020
 TRE      C6     C5        single      1.524    0.020
 TRE      C5     O5        single      1.426    0.020
 TRE      HC5    C5        single      1.099    0.020
 TRE      O6     C6        single      1.432    0.020
 TRE      HC61   C6        single      1.092    0.020
 TRE      HC62   C6        single      1.092    0.020
 TRE      C1P    O1        single      1.426    0.020
 TRE      HO2    O2        single      0.967    0.020
 TRE      HO3    O3        single      0.967    0.020
 TRE      HO4    O4        single      0.967    0.020
 TRE      HO6    O6        single      0.967    0.020
 TRE      C1P    C2P       single      1.524    0.020
 TRE      O5P    C1P       single      1.426    0.020
 TRE      HC1P   C1P       single      1.099    0.020
 TRE      C2P    C3P       single      1.524    0.020
 TRE      O2P    C2P       single      1.432    0.020
 TRE      HC2P   C2P       single      1.099    0.020
 TRE      C3P    C4P       single      1.524    0.020
 TRE      O3P    C3P       single      1.432    0.020
 TRE      HC3P   C3P       single      1.099    0.020
 TRE      C4P    C5P       single      1.524    0.020
 TRE      O4P    C4P       single      1.432    0.020
 TRE      HC4P   C4P       single      1.099    0.020
 TRE      C6P    C5P       single      1.524    0.020
 TRE      C5P    O5P       single      1.426    0.020
 TRE      HC5P   C5P       single      1.099    0.020
 TRE      O6P    C6P       single      1.432    0.020
 TRE      H6P1   C6P       single      1.092    0.020
 TRE      H6P2   C6P       single      1.092    0.020
 TRE      HO2P   O2P       single      0.967    0.020
 TRE      HO3P   O3P       single      0.967    0.020
 TRE      HO4P   O4P       single      0.967    0.020
 TRE      HO6P   O6P       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TRE      HC1    C1     O1      109.470    3.000
 TRE      HC1    C1     O5      109.470    3.000
 TRE      O1     C1     O5      109.470    3.000
 TRE      HC1    C1     C2      108.340    3.000
 TRE      O1     C1     C2      109.470    3.000
 TRE      O5     C1     C2      109.470    3.000
 TRE      C1     O1     C1P     111.800    3.000
 TRE      O1     C1P    HC1P    109.470    3.000
 TRE      O1     C1P    O5P     109.470    3.000
 TRE      O1     C1P    C2P     109.470    3.000
 TRE      HC1P   C1P    O5P     109.470    3.000
 TRE      HC1P   C1P    C2P     108.340    3.000
 TRE      O5P    C1P    C2P     109.470    3.000
 TRE      C1P    O5P    C5P     111.800    3.000
 TRE      O5P    C5P    HC5P    109.470    3.000
 TRE      O5P    C5P    C4P     109.470    3.000
 TRE      O5P    C5P    C6P     109.470    3.000
 TRE      HC5P   C5P    C4P     108.340    3.000
 TRE      HC5P   C5P    C6P     108.340    3.000
 TRE      C4P    C5P    C6P     111.000    3.000
 TRE      C5P    C4P    HC4P    108.340    3.000
 TRE      C5P    C4P    O4P     109.470    3.000
 TRE      C5P    C4P    C3P     111.000    3.000
 TRE      HC4P   C4P    O4P     109.470    3.000
 TRE      HC4P   C4P    C3P     108.340    3.000
 TRE      O4P    C4P    C3P     109.470    3.000
 TRE      C4P    O4P    HO4P    109.470    3.000
 TRE      C4P    C3P    HC3P    108.340    3.000
 TRE      C4P    C3P    O3P     109.470    3.000
 TRE      C4P    C3P    C2P     111.000    3.000
 TRE      HC3P   C3P    O3P     109.470    3.000
 TRE      HC3P   C3P    C2P     108.340    3.000
 TRE      O3P    C3P    C2P     109.470    3.000
 TRE      C3P    O3P    HO3P    109.470    3.000
 TRE      C3P    C2P    HC2P    108.340    3.000
 TRE      C3P    C2P    O2P     109.470    3.000
 TRE      C3P    C2P    C1P     111.000    3.000
 TRE      HC2P   C2P    O2P     109.470    3.000
 TRE      HC2P   C2P    C1P     108.340    3.000
 TRE      O2P    C2P    C1P     109.470    3.000
 TRE      C2P    O2P    HO2P    109.470    3.000
 TRE      C5P    C6P    H6P1    109.470    3.000
 TRE      C5P    C6P    H6P2    109.470    3.000
 TRE      C5P    C6P    O6P     109.470    3.000
 TRE      H6P1   C6P    H6P2    107.900    3.000
 TRE      H6P1   C6P    O6P     109.470    3.000
 TRE      H6P2   C6P    O6P     109.470    3.000
 TRE      C6P    O6P    HO6P    109.470    3.000
 TRE      C1     O5     C5      111.800    3.000
 TRE      O5     C5     HC5     109.470    3.000
 TRE      O5     C5     C6      109.470    3.000
 TRE      O5     C5     C4      109.470    3.000
 TRE      HC5    C5     C6      108.340    3.000
 TRE      HC5    C5     C4      108.340    3.000
 TRE      C6     C5     C4      111.000    3.000
 TRE      C5     C6     HC61    109.470    3.000
 TRE      C5     C6     HC62    109.470    3.000
 TRE      C5     C6     O6      109.470    3.000
 TRE      HC61   C6     HC62    107.900    3.000
 TRE      HC61   C6     O6      109.470    3.000
 TRE      HC62   C6     O6      109.470    3.000
 TRE      C6     O6     HO6     109.470    3.000
 TRE      C5     C4     HC4     108.340    3.000
 TRE      C5     C4     O4      109.470    3.000
 TRE      C5     C4     C3      111.000    3.000
 TRE      HC4    C4     O4      109.470    3.000
 TRE      HC4    C4     C3      108.340    3.000
 TRE      O4     C4     C3      109.470    3.000
 TRE      C4     O4     HO4     109.470    3.000
 TRE      C4     C3     HC3     108.340    3.000
 TRE      C4     C3     O3      109.470    3.000
 TRE      C4     C3     C2      111.000    3.000
 TRE      HC3    C3     O3      109.470    3.000
 TRE      HC3    C3     C2      108.340    3.000
 TRE      O3     C3     C2      109.470    3.000
 TRE      C3     O3     HO3     109.470    3.000
 TRE      C3     C2     HC2     108.340    3.000
 TRE      C3     C2     O2      109.470    3.000
 TRE      C3     C2     C1      111.000    3.000
 TRE      HC2    C2     O2      109.470    3.000
 TRE      HC2    C2     C1      108.340    3.000
 TRE      O2     C2     C1      109.470    3.000
 TRE      C2     O2     HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TRE      var_1    O5     C1     O1     C1P       59.999   20.000   1
 TRE      var_2    C1     O1     C1P    O5P       59.874   20.000   1
 TRE      var_3    O1     C1P    C2P    C3P      -60.000   20.000   3
 TRE      var_4    O1     C1P    O5P    C5P       60.000   20.000   1
 TRE      var_5    C1P    O5P    C5P    C6P      180.000   20.000   1
 TRE      var_6    O5P    C5P    C4P    C3P      -60.000   20.000   3
 TRE      var_7    C5P    C4P    O4P    HO4P     179.898   20.000   1
 TRE      var_8    C5P    C4P    C3P    C2P       60.000   20.000   3
 TRE      var_9    C4P    C3P    O3P    HO3P    -179.969   20.000   1
 TRE      var_10   C4P    C3P    C2P    O2P      180.000   20.000   3
 TRE      var_11   C3P    C2P    O2P    HO2P    -179.934   20.000   1
 TRE      var_12   O5P    C5P    C6P    O6P       59.992   20.000   3
 TRE      var_13   C1     O5     C5     C4        60.000   20.000   1
 TRE      var_14   O5     C5     C6     O6        59.871   20.000   3
 TRE      var_15   C5     C6     O6     HO6     -179.980   20.000   1
 TRE      var_16   O5     C5     C4     C3       -60.000   20.000   3
 TRE      var_17   C5     C4     O4     HO4      179.458   20.000   1
 TRE      var_18   C5     C4     C3     C2        60.000   20.000   3
 TRE      var_19   C4     C3     O3     HO3     -179.213   20.000   1
 TRE      var_20   C4     C3     C2     O2       180.000   20.000   3
 TRE      var_21   C3     C2     C1     O5        60.000   20.000   3
 TRE      var_22   C3     C2     O2     HO2      179.626   20.000   1
 TRE      var_1    C5     O5     C1     C2       -60.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TRE      chir_01  C1     C2     O1     O5        negativ
 TRE      chir_02  C2     C1     C3     O2        negativ
 TRE      chir_03  C3     C2     C4     O3        positiv
 TRE      chir_04  C4     C3     C5     O4        negativ
 TRE      chir_05  C5     C4     C6     O5        negativ
 TRE      chir_06  C1P    O1     C2P    O5P       positiv
 TRE      chir_07  C2P    C1P    C3P    O2P       negativ
 TRE      chir_08  C3P    C2P    C4P    O3P       positiv
 TRE      chir_09  C4P    C3P    C5P    O4P       negativ
 TRE      chir_10  C5P    C4P    C6P    O5P       negativ
# ------------------------------------------------------
`.trim();

monomers["FFC"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
FFC      FFC '2-DEOXY-2-FLUORO-B-D-CELLOBIOSIDE   ' non-polymer        44  23 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_FFC
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 FFC           F2A    F    F         0.000      0.000    0.000    0.000
 FFC           C2A    C    CH1       0.000     -0.979    0.781    0.623
 FFC           H2A    H    H         0.000     -1.138    0.422    1.649
 FFC           C3A    C    CH1       0.000     -2.290    0.682   -0.164
 FFC           H3A    H    H         0.000     -2.119    0.993   -1.204
 FFC           O3A    O    OH1       0.000     -2.762   -0.666   -0.138
 FFC           HO3A   H    H         0.000     -2.102   -1.246   -0.540
 FFC           C4A    C    CH1       0.000     -3.331    1.602    0.483
 FFC           H4A    H    H         0.000     -3.539    1.259    1.506
 FFC           C5A    C    CH1       0.000     -2.783    3.031    0.523
 FFC           H5A    H    H         0.000     -2.615    3.388   -0.503
 FFC           C6A    C    CH2       0.000     -3.792    3.945    1.221
 FFC           H6A    H    H         0.000     -3.893    3.644    2.266
 FFC           H6AA   H    H         0.000     -4.762    3.863    0.725
 FFC           O6A    O    OH1       0.000     -3.335    5.297    1.155
 FFC           HO6A   H    H         0.000     -3.973    5.874    1.597
 FFC           O5A    O    O2        0.000     -1.549    3.047    1.242
 FFC           C1A    C    CH1       0.000     -0.523    2.242    0.657
 FFC           H1A    H    H         0.000      0.395    2.325    1.257
 FFC           O1A    O    OH1       0.000     -0.265    2.691   -0.674
 FFC           H1     H    H         0.000      0.023    3.614   -0.652
 FFC           O4A    O    O2        0.000     -4.536    1.573   -0.285
 FFC           C1B    C    CH1       0.000     -5.460    0.563    0.123
 FFC           H1B    H    H         0.000     -5.678    0.676    1.194
 FFC           O5B    O    O2        0.000     -4.893   -0.726   -0.115
 FFC           C5B    C    CH1       0.000     -5.730   -1.814    0.284
 FFC           H5B    H    H         0.000     -5.951   -1.732    1.357
 FFC           C6B    C    CH2       0.000     -5.012   -3.137    0.011
 FFC           H6B    H    H         0.000     -4.715   -3.179   -1.039
 FFC           H6BA   H    H         0.000     -5.686   -3.968    0.230
 FFC           O6B    O    OH1       0.000     -3.852   -3.231    0.840
 FFC           HO6B   H    H         0.000     -3.399   -4.067    0.667
 FFC           C4B    C    CH1       0.000     -7.037   -1.769   -0.512
 FFC           H4B    H    H         0.000     -6.821   -1.893   -1.583
 FFC           O4B    O    OH1       0.000     -7.899   -2.822   -0.075
 FFC           HO4B   H    H         0.000     -8.726   -2.789   -0.575
 FFC           C3B    C    CH1       0.000     -7.719   -0.418   -0.280
 FFC           H3B    H    H         0.000     -7.983   -0.316    0.782
 FFC           O3B    O    OH1       0.000     -8.904   -0.338   -1.077
 FFC           HO3B   H    H         0.000     -9.330    0.518   -0.935
 FFC           C2B    C    CH1       0.000     -6.757    0.704   -0.680
 FFC           H2B    H    H         0.000     -6.534    0.632   -1.754
 FFC           O2B    O    OH1       0.000     -7.357    1.971   -0.399
 FFC           HO2B   H    H         0.000     -6.746    2.678   -0.647
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 FFC      F2A    n/a    C2A    START
 FFC      C2A    F2A    C3A    .
 FFC      H2A    C2A    .      .
 FFC      C3A    C2A    C4A    .
 FFC      H3A    C3A    .      .
 FFC      O3A    C3A    HO3A   .
 FFC      HO3A   O3A    .      .
 FFC      C4A    C3A    O4A    .
 FFC      H4A    C4A    .      .
 FFC      C5A    C4A    O5A    .
 FFC      H5A    C5A    .      .
 FFC      C6A    C5A    O6A    .
 FFC      H6A    C6A    .      .
 FFC      H6AA   C6A    .      .
 FFC      O6A    C6A    HO6A   .
 FFC      HO6A   O6A    .      .
 FFC      O5A    C5A    C1A    .
 FFC      C1A    O5A    O1A    .
 FFC      H1A    C1A    .      .
 FFC      O1A    C1A    H1     .
 FFC      H1     O1A    .      .
 FFC      O4A    C4A    C1B    .
 FFC      C1B    O4A    O5B    .
 FFC      H1B    C1B    .      .
 FFC      O5B    C1B    C5B    .
 FFC      C5B    O5B    C4B    .
 FFC      H5B    C5B    .      .
 FFC      C6B    C5B    O6B    .
 FFC      H6B    C6B    .      .
 FFC      H6BA   C6B    .      .
 FFC      O6B    C6B    HO6B   .
 FFC      HO6B   O6B    .      .
 FFC      C4B    C5B    C3B    .
 FFC      H4B    C4B    .      .
 FFC      O4B    C4B    HO4B   .
 FFC      HO4B   O4B    .      .
 FFC      C3B    C4B    C2B    .
 FFC      H3B    C3B    .      .
 FFC      O3B    C3B    HO3B   .
 FFC      HO3B   O3B    .      .
 FFC      C2B    C3B    O2B    .
 FFC      H2B    C2B    .      .
 FFC      O2B    C2B    HO2B   .
 FFC      HO2B   O2B    .      END
 FFC      C1A    C2A    .    ADD
 FFC      C1B    C2B    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 FFC      O1A    C1A       single      1.432    0.020
 FFC      C1A    C2A       single      1.524    0.020
 FFC      C1A    O5A       single      1.426    0.020
 FFC      C3A    C2A       single      1.524    0.020
 FFC      C2A    F2A       single      1.370    0.020
 FFC      C4A    C3A       single      1.524    0.020
 FFC      O3A    C3A       single      1.432    0.020
 FFC      C5A    C4A       single      1.524    0.020
 FFC      O4A    C4A       single      1.426    0.020
 FFC      C6A    C5A       single      1.524    0.020
 FFC      O5A    C5A       single      1.426    0.020
 FFC      O6A    C6A       single      1.432    0.020
 FFC      C1B    O4A       single      1.426    0.020
 FFC      C1B    C2B       single      1.524    0.020
 FFC      O5B    C1B       single      1.426    0.020
 FFC      C2B    C3B       single      1.524    0.020
 FFC      O2B    C2B       single      1.432    0.020
 FFC      C3B    C4B       single      1.524    0.020
 FFC      O3B    C3B       single      1.432    0.020
 FFC      C4B    C5B       single      1.524    0.020
 FFC      O4B    C4B       single      1.432    0.020
 FFC      C6B    C5B       single      1.524    0.020
 FFC      C5B    O5B       single      1.426    0.020
 FFC      O6B    C6B       single      1.432    0.020
 FFC      H1A    C1A       single      1.099    0.020
 FFC      H2A    C2A       single      1.099    0.020
 FFC      H3A    C3A       single      1.099    0.020
 FFC      H4A    C4A       single      1.099    0.020
 FFC      H5A    C5A       single      1.099    0.020
 FFC      H6A    C6A       single      1.092    0.020
 FFC      H6AA   C6A       single      1.092    0.020
 FFC      HO3A   O3A       single      0.967    0.020
 FFC      HO6A   O6A       single      0.967    0.020
 FFC      H1B    C1B       single      1.099    0.020
 FFC      H2B    C2B       single      1.099    0.020
 FFC      H3B    C3B       single      1.099    0.020
 FFC      H4B    C4B       single      1.099    0.020
 FFC      H5B    C5B       single      1.099    0.020
 FFC      H6B    C6B       single      1.092    0.020
 FFC      H6BA   C6B       single      1.092    0.020
 FFC      HO2B   O2B       single      0.967    0.020
 FFC      HO3B   O3B       single      0.967    0.020
 FFC      HO4B   O4B       single      0.967    0.020
 FFC      HO6B   O6B       single      0.967    0.020
 FFC      H1     O1A       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 FFC      F2A    C2A    H2A     109.500    3.000
 FFC      F2A    C2A    C3A     109.500    3.000
 FFC      F2A    C2A    C1A     109.500    3.000
 FFC      H2A    C2A    C3A     108.340    3.000
 FFC      H2A    C2A    C1A     108.340    3.000
 FFC      C3A    C2A    C1A     111.000    3.000
 FFC      C2A    C3A    H3A     108.340    3.000
 FFC      C2A    C3A    O3A     109.470    3.000
 FFC      C2A    C3A    C4A     111.000    3.000
 FFC      H3A    C3A    O3A     109.470    3.000
 FFC      H3A    C3A    C4A     108.340    3.000
 FFC      O3A    C3A    C4A     109.470    3.000
 FFC      C3A    O3A    HO3A    109.470    3.000
 FFC      C3A    C4A    H4A     108.340    3.000
 FFC      C3A    C4A    C5A     111.000    3.000
 FFC      C3A    C4A    O4A     109.470    3.000
 FFC      H4A    C4A    C5A     108.340    3.000
 FFC      H4A    C4A    O4A     109.470    3.000
 FFC      C5A    C4A    O4A     109.470    3.000
 FFC      C4A    C5A    H5A     108.340    3.000
 FFC      C4A    C5A    C6A     111.000    3.000
 FFC      C4A    C5A    O5A     109.470    3.000
 FFC      H5A    C5A    C6A     108.340    3.000
 FFC      H5A    C5A    O5A     109.470    3.000
 FFC      C6A    C5A    O5A     109.470    3.000
 FFC      C5A    C6A    H6A     109.470    3.000
 FFC      C5A    C6A    H6AA    109.470    3.000
 FFC      C5A    C6A    O6A     109.470    3.000
 FFC      H6A    C6A    H6AA    107.900    3.000
 FFC      H6A    C6A    O6A     109.470    3.000
 FFC      H6AA   C6A    O6A     109.470    3.000
 FFC      C6A    O6A    HO6A    109.470    3.000
 FFC      C5A    O5A    C1A     111.800    3.000
 FFC      O5A    C1A    H1A     109.470    3.000
 FFC      O5A    C1A    O1A     109.470    3.000
 FFC      O5A    C1A    C2A     109.470    3.000
 FFC      H1A    C1A    O1A     109.470    3.000
 FFC      H1A    C1A    C2A     108.340    3.000
 FFC      O1A    C1A    C2A     109.470    3.000
 FFC      C1A    O1A    H1      109.470    3.000
 FFC      C4A    O4A    C1B     111.800    3.000
 FFC      O4A    C1B    H1B     109.470    3.000
 FFC      O4A    C1B    O5B     109.470    3.000
 FFC      O4A    C1B    C2B     109.470    3.000
 FFC      H1B    C1B    O5B     109.470    3.000
 FFC      H1B    C1B    C2B     108.340    3.000
 FFC      O5B    C1B    C2B     109.470    3.000
 FFC      C1B    O5B    C5B     111.800    3.000
 FFC      O5B    C5B    H5B     109.470    3.000
 FFC      O5B    C5B    C6B     109.470    3.000
 FFC      O5B    C5B    C4B     109.470    3.000
 FFC      H5B    C5B    C6B     108.340    3.000
 FFC      H5B    C5B    C4B     108.340    3.000
 FFC      C6B    C5B    C4B     111.000    3.000
 FFC      C5B    C6B    H6B     109.470    3.000
 FFC      C5B    C6B    H6BA    109.470    3.000
 FFC      C5B    C6B    O6B     109.470    3.000
 FFC      H6B    C6B    H6BA    107.900    3.000
 FFC      H6B    C6B    O6B     109.470    3.000
 FFC      H6BA   C6B    O6B     109.470    3.000
 FFC      C6B    O6B    HO6B    109.470    3.000
 FFC      C5B    C4B    H4B     108.340    3.000
 FFC      C5B    C4B    O4B     109.470    3.000
 FFC      C5B    C4B    C3B     111.000    3.000
 FFC      H4B    C4B    O4B     109.470    3.000
 FFC      H4B    C4B    C3B     108.340    3.000
 FFC      O4B    C4B    C3B     109.470    3.000
 FFC      C4B    O4B    HO4B    109.470    3.000
 FFC      C4B    C3B    H3B     108.340    3.000
 FFC      C4B    C3B    O3B     109.470    3.000
 FFC      C4B    C3B    C2B     111.000    3.000
 FFC      H3B    C3B    O3B     109.470    3.000
 FFC      H3B    C3B    C2B     108.340    3.000
 FFC      O3B    C3B    C2B     109.470    3.000
 FFC      C3B    O3B    HO3B    109.470    3.000
 FFC      C3B    C2B    H2B     108.340    3.000
 FFC      C3B    C2B    O2B     109.470    3.000
 FFC      C3B    C2B    C1B     111.000    3.000
 FFC      H2B    C2B    O2B     109.470    3.000
 FFC      H2B    C2B    C1B     108.340    3.000
 FFC      O2B    C2B    C1B     109.470    3.000
 FFC      C2B    O2B    HO2B    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 FFC      var_1    F2A    C2A    C3A    C4A      180.000   20.000   3
 FFC      var_2    C2A    C3A    O3A    HO3A     -60.048   20.000   1
 FFC      var_3    C2A    C3A    C4A    O4A      180.000   20.000   3
 FFC      var_4    C3A    C4A    C5A    O5A      -60.000   20.000   3
 FFC      var_5    C4A    C5A    C6A    O6A     -174.970   20.000   3
 FFC      var_6    C5A    C6A    O6A    HO6A    -179.973   20.000   1
 FFC      var_7    C4A    C5A    O5A    C1A       60.000   20.000   1
 FFC      var_8    C5A    O5A    C1A    O1A       60.000   20.000   1
 FFC      var_9    O5A    C1A    C2A    F2A      180.000   20.000   3
 FFC      var_10   O5A    C1A    O1A    H1        60.054   20.000   1
 FFC      var_11   C3A    C4A    O4A    C1B       90.020   20.000   1
 FFC      var_12   C4A    O4A    C1B    O5B      -65.114   20.000   1
 FFC      var_13   O4A    C1B    C2B    C3B      180.000   20.000   3
 FFC      var_14   O4A    C1B    O5B    C5B      180.000   20.000   1
 FFC      var_15   C1B    O5B    C5B    C4B       60.000   20.000   1
 FFC      var_16   O5B    C5B    C6B    O6B       65.045   20.000   3
 FFC      var_17   C5B    C6B    O6B    HO6B    -179.997   20.000   1
 FFC      var_18   O5B    C5B    C4B    C3B      -60.000   20.000   3
 FFC      var_19   C5B    C4B    O4B    HO4B     179.702   20.000   1
 FFC      var_20   C5B    C4B    C3B    C2B       60.000   20.000   3
 FFC      var_21   C4B    C3B    O3B    HO3B    -179.563   20.000   1
 FFC      var_22   C4B    C3B    C2B    O2B      180.000   20.000   3
 FFC      var_23   C3B    C2B    O2B    HO2B     179.672   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 FFC      chir_01  C1A    O1A    C2A    O5A       positiv
 FFC      chir_02  C2A    C1A    C3A    F2A       negativ
 FFC      chir_03  C3A    C2A    C4A    O3A       positiv
 FFC      chir_04  C4A    C3A    C5A    O4A       negativ
 FFC      chir_05  C5A    C4A    C6A    O5A       negativ
 FFC      chir_06  C1B    O4A    C2B    O5B       negativ
 FFC      chir_07  C2B    C1B    C3B    O2B       negativ
 FFC      chir_08  C3B    C2B    C4B    O3B       positiv
 FFC      chir_09  C4B    C3B    C5B    O4B       negativ
 FFC      chir_10  C5B    C4B    C6B    O5B       negativ
# ------------------------------------------------------
`.trim();

monomers["XYP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
XYP      XYP 'BETA-D-XYLOPYRANOSE                 ' non-polymer        20  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_XYP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 XYP           O4B    O    OH1       0.000      0.000    0.000    0.000
 XYP           HO4B   H    H         0.000      0.743   -0.364   -0.500
 XYP           C4B    C    CH1       0.000     -1.228   -0.431   -0.590
 XYP           H4B    H    H         0.000     -1.279   -1.528   -0.573
 XYP           C3B    C    CH1       0.000     -2.408    0.149    0.197
 XYP           H3B    H    H         0.000     -2.299    1.241    0.271
 XYP           O3B    O    OH1       0.000     -2.443   -0.417    1.508
 XYP           HO3B   H    H         0.000     -1.623   -0.202    1.972
 XYP           C2B    C    CH1       0.000     -3.705   -0.187   -0.544
 XYP           H2B    H    H         0.000     -3.867   -1.274   -0.525
 XYP           O2B    O    OH1       0.000     -4.805    0.470    0.088
 XYP           HO2B   H    H         0.000     -5.621    0.258   -0.385
 XYP           C5B    C    CH2       0.000     -1.301    0.061   -2.038
 XYP           H5B1   H    H         0.000     -0.449   -0.332   -2.595
 XYP           H5B2   H    H         0.000     -1.271    1.153   -2.049
 XYP           O5B    O    O2        0.000     -2.512   -0.388   -2.639
 XYP           C1B    C    CH1       0.000     -3.592    0.286   -1.995
 XYP           H1B    H    H         0.000     -3.407    1.370   -2.012
 XYP           O4A    O    OH1       0.000     -4.810    0.001   -2.684
 XYP           HO4A   H    H         0.000     -4.740    0.304   -3.599
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 XYP      O4B    n/a    C4B    START
 XYP      HO4B   O4B    .      .
 XYP      C4B    O4B    C5B    .
 XYP      H4B    C4B    .      .
 XYP      C3B    C4B    C2B    .
 XYP      H3B    C3B    .      .
 XYP      O3B    C3B    HO3B   .
 XYP      HO3B   O3B    .      .
 XYP      C2B    C3B    O2B    .
 XYP      H2B    C2B    .      .
 XYP      O2B    C2B    HO2B   .
 XYP      HO2B   O2B    .      .
 XYP      C5B    C4B    O5B    .
 XYP      H5B1   C5B    .      .
 XYP      H5B2   C5B    .      .
 XYP      O5B    C5B    C1B    .
 XYP      C1B    O5B    O4A    .
 XYP      H1B    C1B    .      .
 XYP      O4A    C1B    HO4A   .
 XYP      HO4A   O4A    .      END
 XYP      C1B    C2B    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 XYP      O4A    C1B       single      1.432    0.020
 XYP      HO4A   O4A       single      0.967    0.020
 XYP      C1B    C2B       single      1.524    0.020
 XYP      C1B    O5B       single      1.426    0.020
 XYP      H1B    C1B       single      1.099    0.020
 XYP      C2B    C3B       single      1.524    0.020
 XYP      O2B    C2B       single      1.432    0.020
 XYP      H2B    C2B       single      1.099    0.020
 XYP      C3B    C4B       single      1.524    0.020
 XYP      O3B    C3B       single      1.432    0.020
 XYP      H3B    C3B       single      1.099    0.020
 XYP      C5B    C4B       single      1.524    0.020
 XYP      C4B    O4B       single      1.432    0.020
 XYP      H4B    C4B       single      1.099    0.020
 XYP      O5B    C5B       single      1.426    0.020
 XYP      H5B1   C5B       single      1.092    0.020
 XYP      H5B2   C5B       single      1.092    0.020
 XYP      HO2B   O2B       single      0.967    0.020
 XYP      HO3B   O3B       single      0.967    0.020
 XYP      HO4B   O4B       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 XYP      HO4B   O4B    C4B     109.470    3.000
 XYP      O4B    C4B    H4B     109.470    3.000
 XYP      O4B    C4B    C3B     109.470    3.000
 XYP      O4B    C4B    C5B     109.470    3.000
 XYP      H4B    C4B    C3B     108.340    3.000
 XYP      H4B    C4B    C5B     108.340    3.000
 XYP      C3B    C4B    C5B     111.000    3.000
 XYP      C4B    C3B    H3B     108.340    3.000
 XYP      C4B    C3B    O3B     109.470    3.000
 XYP      C4B    C3B    C2B     111.000    3.000
 XYP      H3B    C3B    O3B     109.470    3.000
 XYP      H3B    C3B    C2B     108.340    3.000
 XYP      O3B    C3B    C2B     109.470    3.000
 XYP      C3B    O3B    HO3B    109.470    3.000
 XYP      C3B    C2B    H2B     108.340    3.000
 XYP      C3B    C2B    O2B     109.470    3.000
 XYP      C3B    C2B    C1B     111.000    3.000
 XYP      H2B    C2B    O2B     109.470    3.000
 XYP      H2B    C2B    C1B     108.340    3.000
 XYP      O2B    C2B    C1B     109.470    3.000
 XYP      C2B    O2B    HO2B    109.470    3.000
 XYP      C4B    C5B    H5B1    109.470    3.000
 XYP      C4B    C5B    H5B2    109.470    3.000
 XYP      C4B    C5B    O5B     109.470    3.000
 XYP      H5B1   C5B    H5B2    107.900    3.000
 XYP      H5B1   C5B    O5B     109.470    3.000
 XYP      H5B2   C5B    O5B     109.470    3.000
 XYP      C5B    O5B    C1B     111.800    3.000
 XYP      O5B    C1B    H1B     109.470    3.000
 XYP      O5B    C1B    O4A     109.470    3.000
 XYP      O5B    C1B    C2B     109.470    3.000
 XYP      H1B    C1B    O4A     109.470    3.000
 XYP      H1B    C1B    C2B     108.340    3.000
 XYP      O4A    C1B    C2B     109.470    3.000
 XYP      C1B    O4A    HO4A    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 XYP      var_1    HO4B   O4B    C4B    C5B      -60.078   20.000   1
 XYP      var_2    O4B    C4B    C3B    C2B      180.000   20.000   3
 XYP      var_3    C4B    C3B    O3B    HO3B      60.597   20.000   1
 XYP      var_4    C4B    C3B    C2B    O2B      180.000   20.000   3
 XYP      var_5    C3B    C2B    O2B    HO2B     179.738   20.000   1
 XYP      var_6    O4B    C4B    C5B    O5B      180.000   20.000   3
 XYP      var_7    C4B    C5B    O5B    C1B       60.000   20.000   1
 XYP      var_8    C5B    O5B    C1B    O4A      180.000   20.000   1
 XYP      var_9    O5B    C1B    C2B    C3B       60.000   20.000   3
 XYP      var_10   O5B    C1B    O4A    HO4A     -59.931   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 XYP      chir_01  C1B    O4A    C2B    O5B       negativ
 XYP      chir_02  C2B    C1B    C3B    O2B       negativ
 XYP      chir_03  C3B    C2B    C4B    O3B       positiv
 XYP      chir_04  C4B    C3B    C5B    O4B       negativ
# ------------------------------------------------------
`.trim();

monomers["SIA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SIA      SIA 'O-SIALIC ACID                       ' non-polymer        39  21 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SIA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SIA           O10    O    O         0.000      0.000    0.000    0.000
 SIA           C10    C    C         0.000     -0.497   -1.015   -0.439
 SIA           C11    C    CH3       0.000      0.383   -2.136   -0.926
 SIA           H113   H    H         0.000      0.187   -3.011   -0.361
 SIA           H112   H    H         0.000      0.184   -2.325   -1.949
 SIA           H111   H    H         0.000      1.401   -1.864   -0.810
 SIA           N5     N    NH1       0.000     -1.838   -1.140   -0.490
 SIA           HN5    H    H         0.000     -2.252   -1.986   -0.855
 SIA           C5     C    CH1       0.000     -2.695   -0.051   -0.017
 SIA           H5     H    H         0.000     -2.184    0.911   -0.167
 SIA           C4     C    CH1       0.000     -2.995   -0.246    1.473
 SIA           H4     H    H         0.000     -3.409   -1.250    1.638
 SIA           O4     O    OH1       0.000     -1.792   -0.092    2.230
 SIA           HO4    H    H         0.000     -1.985   -0.216    3.169
 SIA           C3     C    CH2       0.000     -4.017    0.810    1.909
 SIA           H32    H    H         0.000     -3.570    1.804    1.846
 SIA           H31    H    H         0.000     -4.329    0.617    2.938
 SIA           C6     C    CH1       0.000     -4.009   -0.058   -0.797
 SIA           H6     H    H         0.000     -4.528   -1.012   -0.629
 SIA           O6     O    O2        0.000     -4.838    1.016   -0.358
 SIA           C2     C    CT        0.000     -5.235    0.737    0.983
 SIA           O2     O    OH1       0.000     -6.207    1.696    1.402
 SIA           HO2    H    H         0.000     -6.976    1.651    0.818
 SIA           C1     C    C         0.000     -5.833   -0.644    1.051
 SIA           O1B    O    OC       -0.500     -5.853   -1.265    2.137
 SIA           O1A    O    OC       -0.500     -6.308   -1.170    0.020
 SIA           C7     C    CH1       0.000     -3.718    0.105   -2.290
 SIA           H7     H    H         0.000     -3.079   -0.722   -2.631
 SIA           O7     O    OH1       0.000     -3.047    1.347   -2.512
 SIA           HO7    H    H         0.000     -3.609    2.074   -2.212
 SIA           C8     C    CH1       0.000     -5.033    0.089   -3.072
 SIA           H8     H    H         0.000     -5.671    0.916   -2.732
 SIA           O8     O    OH1       0.000     -5.704   -1.153   -2.850
 SIA           HO8    H    H         0.000     -5.142   -1.880   -3.150
 SIA           C9     C    CH2       0.000     -4.741    0.251   -4.566
 SIA           H91    H    H         0.000     -4.105   -0.570   -4.903
 SIA           H92    H    H         0.000     -4.227    1.200   -4.734
 SIA           O9     O    OH1       0.000     -5.969    0.236   -5.295
 SIA           HO9    H    H         0.000     -5.783    0.339   -6.238
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SIA      O10    n/a    C10    START
 SIA      C10    O10    N5     .
 SIA      C11    C10    H111   .
 SIA      H113   C11    .      .
 SIA      H112   C11    .      .
 SIA      H111   C11    .      .
 SIA      N5     C10    C5     .
 SIA      HN5    N5     .      .
 SIA      C5     N5     C6     .
 SIA      H5     C5     .      .
 SIA      C4     C5     C3     .
 SIA      H4     C4     .      .
 SIA      O4     C4     HO4    .
 SIA      HO4    O4     .      .
 SIA      C3     C4     H31    .
 SIA      H32    C3     .      .
 SIA      H31    C3     .      .
 SIA      C6     C5     C7     .
 SIA      H6     C6     .      .
 SIA      O6     C6     C2     .
 SIA      C2     O6     C1     .
 SIA      O2     C2     HO2    .
 SIA      HO2    O2     .      .
 SIA      C1     C2     O1A    .
 SIA      O1B    C1     .      .
 SIA      O1A    C1     .      .
 SIA      C7     C6     C8     .
 SIA      H7     C7     .      .
 SIA      O7     C7     HO7    .
 SIA      HO7    O7     .      .
 SIA      C8     C7     C9     .
 SIA      H8     C8     .      .
 SIA      O8     C8     HO8    .
 SIA      HO8    O8     .      .
 SIA      C9     C8     O9     .
 SIA      H91    C9     .      .
 SIA      H92    C9     .      .
 SIA      O9     C9     HO9    .
 SIA      HO9    O9     .      END
 SIA      C2     C3     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SIA      C1     C2        single      1.507    0.020
 SIA      O1A    C1        deloc       1.250    0.020
 SIA      O1B    C1        deloc       1.250    0.020
 SIA      C2     C3        single      1.524    0.020
 SIA      O2     C2        single      1.432    0.020
 SIA      C2     O6        single      1.426    0.020
 SIA      C3     C4        single      1.524    0.020
 SIA      H31    C3        single      1.092    0.020
 SIA      H32    C3        single      1.092    0.020
 SIA      C4     C5        single      1.524    0.020
 SIA      O4     C4        single      1.432    0.020
 SIA      H4     C4        single      1.099    0.020
 SIA      C6     C5        single      1.524    0.020
 SIA      C5     N5        single      1.450    0.020
 SIA      H5     C5        single      1.099    0.020
 SIA      C7     C6        single      1.524    0.020
 SIA      O6     C6        single      1.426    0.020
 SIA      H6     C6        single      1.099    0.020
 SIA      C8     C7        single      1.524    0.020
 SIA      O7     C7        single      1.432    0.020
 SIA      H7     C7        single      1.099    0.020
 SIA      C9     C8        single      1.524    0.020
 SIA      O8     C8        single      1.432    0.020
 SIA      H8     C8        single      1.099    0.020
 SIA      O9     C9        single      1.432    0.020
 SIA      H91    C9        single      1.092    0.020
 SIA      H92    C9        single      1.092    0.020
 SIA      C11    C10       single      1.500    0.020
 SIA      N5     C10       single      1.330    0.020
 SIA      C10    O10       double      1.220    0.020
 SIA      H111   C11       single      1.059    0.020
 SIA      H112   C11       single      1.059    0.020
 SIA      H113   C11       single      1.059    0.020
 SIA      HN5    N5        single      1.010    0.020
 SIA      HO2    O2        single      0.967    0.020
 SIA      HO4    O4        single      0.967    0.020
 SIA      HO7    O7        single      0.967    0.020
 SIA      HO8    O8        single      0.967    0.020
 SIA      HO9    O9        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SIA      O10    C10    C11     123.000    3.000
 SIA      O10    C10    N5      123.000    3.000
 SIA      C11    C10    N5      116.500    3.000
 SIA      C10    C11    H113    109.470    3.000
 SIA      C10    C11    H112    109.470    3.000
 SIA      C10    C11    H111    109.470    3.000
 SIA      H113   C11    H112    109.470    3.000
 SIA      H113   C11    H111    109.470    3.000
 SIA      H112   C11    H111    109.470    3.000
 SIA      C10    N5     HN5     120.000    3.000
 SIA      C10    N5     C5      121.500    3.000
 SIA      HN5    N5     C5      118.500    3.000
 SIA      N5     C5     H5      108.550    3.000
 SIA      N5     C5     C4      110.000    3.000
 SIA      N5     C5     C6      110.000    3.000
 SIA      H5     C5     C4      108.340    3.000
 SIA      H5     C5     C6      108.340    3.000
 SIA      C4     C5     C6      111.000    3.000
 SIA      C5     C4     H4      108.340    3.000
 SIA      C5     C4     O4      109.470    3.000
 SIA      C5     C4     C3      111.000    3.000
 SIA      H4     C4     O4      109.470    3.000
 SIA      H4     C4     C3      108.340    3.000
 SIA      O4     C4     C3      109.470    3.000
 SIA      C4     O4     HO4     109.470    3.000
 SIA      C4     C3     H32     109.470    3.000
 SIA      C4     C3     H31     109.470    3.000
 SIA      C4     C3     C2      111.000    3.000
 SIA      H32    C3     H31     107.900    3.000
 SIA      H32    C3     C2      109.470    3.000
 SIA      H31    C3     C2      109.470    3.000
 SIA      C5     C6     H6      108.340    3.000
 SIA      C5     C6     O6      109.470    3.000
 SIA      C5     C6     C7      111.000    3.000
 SIA      H6     C6     O6      109.470    3.000
 SIA      H6     C6     C7      108.340    3.000
 SIA      O6     C6     C7      109.470    3.000
 SIA      C6     O6     C2      111.800    3.000
 SIA      O6     C2     O2      109.470    3.000
 SIA      O6     C2     C1      109.470    3.000
 SIA      O6     C2     C3      109.470    3.000
 SIA      O2     C2     C1      109.470    3.000
 SIA      O2     C2     C3      109.470    3.000
 SIA      C1     C2     C3      109.470    3.000
 SIA      C2     O2     HO2     109.470    3.000
 SIA      C2     C1     O1B     118.500    3.000
 SIA      C2     C1     O1A     118.500    3.000
 SIA      O1B    C1     O1A     123.000    3.000
 SIA      C6     C7     H7      108.340    3.000
 SIA      C6     C7     O7      109.470    3.000
 SIA      C6     C7     C8      111.000    3.000
 SIA      H7     C7     O7      109.470    3.000
 SIA      H7     C7     C8      108.340    3.000
 SIA      O7     C7     C8      109.470    3.000
 SIA      C7     O7     HO7     109.470    3.000
 SIA      C7     C8     H8      108.340    3.000
 SIA      C7     C8     O8      109.470    3.000
 SIA      C7     C8     C9      111.000    3.000
 SIA      H8     C8     O8      109.470    3.000
 SIA      H8     C8     C9      108.340    3.000
 SIA      O8     C8     C9      109.470    3.000
 SIA      C8     O8     HO8     109.470    3.000
 SIA      C8     C9     H91     109.470    3.000
 SIA      C8     C9     H92     109.470    3.000
 SIA      C8     C9     O9      109.470    3.000
 SIA      H91    C9     H92     107.900    3.000
 SIA      H91    C9     O9      109.470    3.000
 SIA      H92    C9     O9      109.470    3.000
 SIA      C9     O9     HO9     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 SIA      var_1    O10    C10    C11    H111      -0.047   20.000   1
 SIA      CONST_1  O10    C10    N5     C5         0.000    0.000   0
 SIA      var_2    C10    N5     C5     C6       150.193   20.000   3
 SIA      var_3    N5     C5     C4     C3       180.000   20.000   3
 SIA      var_4    C5     C4     O4     HO4     -179.988   20.000   1
 SIA      var_5    C5     C4     C3     C2        60.000   20.000   3
 SIA      var_6    N5     C5     C6     C7       -60.000   20.000   3
 SIA      var_7    C5     C6     O6     C2       -60.000   20.000   1
 SIA      var_8    C6     O6     C2     C1       -60.000   20.000   1
 SIA      var_9    O6     C2     C3     C4       -60.000   20.000   1
 SIA      var_10   O6     C2     O2     HO2       59.657   20.000   1
 SIA      var_11   O6     C2     C1     O1A      -22.910   20.000   1
 SIA      var_12   C5     C6     C7     C8       179.637   20.000   3
 SIA      var_13   C6     C7     O7     HO7      -60.036   20.000   1
 SIA      var_14   C6     C7     C8     C9      -179.990   20.000   3
 SIA      var_15   C7     C8     O8     HO8      -60.033   20.000   1
 SIA      var_16   C7     C8     C9     O9       179.995   20.000   3
 SIA      var_17   C8     C9     O9     HO9      179.983   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 SIA      chir_01  C2     C1     C3     O2        positiv
 SIA      chir_02  C4     C3     C5     O4        negativ
 SIA      chir_03  C5     C4     C6     N5        positiv
 SIA      chir_04  C6     C5     C7     O6        positiv
 SIA      chir_05  C7     C6     C8     O7        negativ
 SIA      chir_06  C8     C7     C9     O8        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 SIA      plan-1    C1        0.020
 SIA      plan-1    C2        0.020
 SIA      plan-1    O1A       0.020
 SIA      plan-1    O1B       0.020
 SIA      plan-2    C10       0.020
 SIA      plan-2    C11       0.020
 SIA      plan-2    N5        0.020
 SIA      plan-2    O10       0.020
 SIA      plan-2    HN5       0.020
 SIA      plan-3    N5        0.020
 SIA      plan-3    C5        0.020
 SIA      plan-3    C10       0.020
 SIA      plan-3    HN5       0.020
# ------------------------------------------------------
`.trim();

monomers["SO4"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SO4      SO4 'SULFATE ION                         ' non-polymer         5   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SO4
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SO4           O4     O    OS       -1.000      0.000    0.000    0.000
 SO4           S      S    ST        0.000     -1.427    0.000   -0.360
 SO4           O1     O    OS        0.000     -1.733   -1.201   -1.153
 SO4           O2     O    OS        0.000     -1.733    1.201   -1.153
 SO4           O3     O    OS       -1.000     -2.241    0.000    0.865
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SO4      S    n/a    O4      START
 SO4     O4     S       .     .
 SO4      O1     S      .      .
 SO4      O2     S      .      .
 SO4      O3     S      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SO4      O1     S         deloc       1.480    0.020
 SO4      O2     S         deloc       1.480    0.020
 SO4      O3     S         deloc       1.480    0.020
 SO4      S      O4        deloc       1.480    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SO4      O4     S      O1      109.500    3.000
 SO4      O4     S      O2      109.500    3.000
 SO4      O4     S      O3      109.500    3.000
 SO4      O1     S      O2      109.500    3.000
 SO4      O1     S      O3      109.500    3.000
 SO4      O2     S      O3      109.500    3.000
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 SO4      chir_01  S      O1     O2     O3        both
# ------------------------------------------------------
`.trim();

monomers["NO3"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
NO3      NO3 'NITRATE ION                         ' non-polymer         4   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_NO3
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 NO3           O3     O    O        -1.000      0.000    0.000    0.000
 NO3           N      N    N         1.000     -1.085    0.555   -0.001
 NO3           O1     O    O         0.000     -2.108   -0.107    0.000
 NO3           O2     O    O        -1.000     -1.146    1.770    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 NO3      O3     n/a    N      START
 NO3      N      O3     O2     .
 NO3      O1     N      .      .
 NO3      O2     N      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 NO3      O1     N         double      1.220    0.020
 NO3      O2     N         single      1.400    0.020
 NO3      N      O3        single      1.400    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 NO3      O3     N      O1      120.000    3.000
 NO3      O3     N      O2      120.000    3.000
 NO3      O1     N      O2      120.000    3.000
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 NO3      plan-1    N         0.020
 NO3      plan-1    O1        0.000
 NO3      plan-1    O2        0.000
 NO3      plan-1    O3        0.000
# ------------------------------------------------------
`.trim();

monomers["MOH"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MOH      MOH 'METHANOL                            ' non-polymer         6   2 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MOH
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MOH           O      O    OH1       0.000      0.000    0.000    0.000
 MOH           HO     H    H         0.000     -0.561   -0.789    0.000
 MOH           C      C    CH3       0.000      1.376   -0.387    0.000
 MOH           H3     H    H         0.000      1.585   -0.964   -0.865
 MOH           H2     H    H         0.000      1.990    0.478    0.000
 MOH           H1     H    H         0.000      1.585   -0.964    0.865
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MOH      O      n/a    C      START
 MOH      HO     O      .      .
 MOH      C      O      H1     .
 MOH      H3     C      .      .
 MOH      H2     C      .      .
 MOH      H1     C      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MOH      C      O         single      1.413    0.020
 MOH      H1     C         single      1.059    0.020
 MOH      H2     C         single      1.059    0.020
 MOH      H3     C         single      1.059    0.020
 MOH      HO     O         single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MOH      HO     O      C       109.470    3.000
 MOH      O      C      H3      109.470    3.000
 MOH      O      C      H2      109.470    3.000
 MOH      O      C      H1      109.470    3.000
 MOH      H3     C      H2      109.470    3.000
 MOH      H3     C      H1      109.470    3.000
 MOH      H2     C      H1      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MOH      var_1    HO     O      C      H1       -60.004   20.000   1
# ------------------------------------------------------
`.trim();

monomers["EOH"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
EOH      EOH 'ETHANOL                             ' non-polymer         9   3 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_EOH
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 EOH           O      O    OH1       0.000      0.000    0.000    0.000
 EOH           HO     H    H         0.000      0.732   -0.631    0.000
 EOH           C1     C    CH2       0.000     -1.240   -0.710    0.000
 EOH           H11    H    H         0.000     -1.300   -1.338    0.891
 EOH           H12    H    H         0.000     -1.300   -1.338   -0.891
 EOH           C2     C    CH3       0.000     -2.399    0.289    0.000
 EOH           H23    H    H         0.000     -2.342    0.900   -0.864
 EOH           H22    H    H         0.000     -3.321   -0.234    0.000
 EOH           H21    H    H         0.000     -2.343    0.900    0.865
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 EOH      O      n/a    C1     START
 EOH      HO     O      .      .
 EOH      C1     O      C2     .
 EOH      H11    C1     .      .
 EOH      H12    C1     .      .
 EOH      C2     C1     H21    .
 EOH      H23    C2     .      .
 EOH      H22    C2     .      .
 EOH      H21    C2     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 EOH      C2     C1        single      1.513    0.020
 EOH      C1     O         single      1.432    0.020
 EOH      H11    C1        single      1.092    0.020
 EOH      H12    C1        single      1.092    0.020
 EOH      H21    C2        single      1.059    0.020
 EOH      H22    C2        single      1.059    0.020
 EOH      H23    C2        single      1.059    0.020
 EOH      HO     O         single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 EOH      HO     O      C1      109.470    3.000
 EOH      O      C1     H11     109.470    3.000
 EOH      O      C1     H12     109.470    3.000
 EOH      O      C1     C2      109.470    3.000
 EOH      H11    C1     H12     107.900    3.000
 EOH      H11    C1     C2      109.470    3.000
 EOH      H12    C1     C2      109.470    3.000
 EOH      C1     C2     H23     109.470    3.000
 EOH      C1     C2     H22     109.470    3.000
 EOH      C1     C2     H21     109.470    3.000
 EOH      H23    C2     H22     109.470    3.000
 EOH      H23    C2     H21     109.470    3.000
 EOH      H22    C2     H21     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 EOH      var_1    HO     O      C1     C2       180.000   20.000   1
 EOH      var_2    O      C1     C2     H21      -60.027   20.000   3
# ------------------------------------------------------
`.trim();

monomers["GOL"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GOL      GOL 'GLYCEROL                            ' non-polymer        14   6 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GOL
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GOL           O3     O    OH1       0.000      0.000    0.000    0.000
 GOL           HO3    H    H         0.000      0.767   -0.423    0.409
 GOL           C3     C    CH2       0.000     -1.197   -0.609    0.491
 GOL           H31    H    H         0.000     -1.248   -0.487    1.575
 GOL           H32    H    H         0.000     -1.191   -1.672    0.244
 GOL           C2     C    CH1       0.000     -2.411    0.060   -0.156
 GOL           H2     H    H         0.000     -2.314    0.016   -1.250
 GOL           O2     O    OH1       0.000     -2.482    1.424    0.261
 GOL           HO2    H    H         0.000     -2.568    1.462    1.223
 GOL           C1     C    CH2       0.000     -3.684   -0.672    0.272
 GOL           H11    H    H         0.000     -3.827   -0.553    1.348
 GOL           H12    H    H         0.000     -3.591   -1.733    0.033
 GOL           O1     O    OH1       0.000     -4.806   -0.122   -0.423
 GOL           HO1    H    H         0.000     -5.610   -0.585   -0.152
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GOL      O3     n/a    C3     START
 GOL      HO3    O3     .      .
 GOL      C3     O3     C2     .
 GOL      H31    C3     .      .
 GOL      H32    C3     .      .
 GOL      C2     C3     C1     .
 GOL      H2     C2     .      .
 GOL      O2     C2     HO2    .
 GOL      HO2    O2     .      .
 GOL      C1     C2     O1     .
 GOL      H11    C1     .      .
 GOL      H12    C1     .      .
 GOL      O1     C1     HO1    .
 GOL      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GOL      O1     C1        single      1.432    0.020
 GOL      C1     C2        single      1.524    0.020
 GOL      H11    C1        single      1.092    0.020
 GOL      H12    C1        single      1.092    0.020
 GOL      HO1    O1        single      0.967    0.020
 GOL      O2     C2        single      1.432    0.020
 GOL      C2     C3        single      1.524    0.020
 GOL      H2     C2        single      1.099    0.020
 GOL      HO2    O2        single      0.967    0.020
 GOL      C3     O3        single      1.432    0.020
 GOL      H31    C3        single      1.092    0.020
 GOL      H32    C3        single      1.092    0.020
 GOL      HO3    O3        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GOL      HO3    O3     C3      109.470    3.000
 GOL      O3     C3     H31     109.470    3.000
 GOL      O3     C3     H32     109.470    3.000
 GOL      O3     C3     C2      109.470    3.000
 GOL      H31    C3     H32     107.900    3.000
 GOL      H31    C3     C2      109.470    3.000
 GOL      H32    C3     C2      109.470    3.000
 GOL      C3     C2     H2      108.340    3.000
 GOL      C3     C2     O2      109.470    3.000
 GOL      C3     C2     C1      109.470    3.000
 GOL      H2     C2     O2      109.470    3.000
 GOL      H2     C2     C1      108.340    3.000
 GOL      O2     C2     C1      109.470    3.000
 GOL      C2     O2     HO2     109.470    3.000
 GOL      C2     C1     H11     109.470    3.000
 GOL      C2     C1     H12     109.470    3.000
 GOL      C2     C1     O1      109.470    3.000
 GOL      H11    C1     H12     107.900    3.000
 GOL      H11    C1     O1      109.470    3.000
 GOL      H12    C1     O1      109.470    3.000
 GOL      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GOL      var_1    HO3    O3     C3     C2      -179.972   20.000   1
 GOL      var_2    O3     C3     C2     C1       174.998   20.000   3
 GOL      var_3    C3     C2     O2     HO2      -59.996   20.000   1
 GOL      var_4    C3     C2     C1     O1      -174.998   20.000   3
 GOL      var_5    C2     C1     O1     HO1      179.972   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 GOL      chir_01  C2     C1     O2     C3        both
# ------------------------------------------------------
`.trim();

monomers["ACT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ACT      ACT 'ACETATE ION                         ' non-polymer         7   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ACT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ACT           OXT    O    OC       -0.500      0.000    0.000    0.000
 ACT           C      C    C         0.000     -0.875    0.894    0.000
 ACT           O      O    OC       -0.500     -2.087    0.582    0.000
 ACT           CH3    C    CH3       0.000     -0.470    2.345    0.000
 ACT           H3     H    H         0.000      0.458    2.455   -0.499
 ACT           H2     H    H         0.000     -1.208    2.919   -0.499
 ACT           H1     H    H         0.000     -0.375    2.687    0.998
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ACT      OXT    n/a    C      START
 ACT      C      OXT    CH3    .
 ACT      O      C      .      .
 ACT      CH3    C      H1     .
 ACT      H3     CH3    .      .
 ACT      H2     CH3    .      .
 ACT      H1     CH3    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ACT      O      C         deloc       1.250    0.020
 ACT      C      OXT       deloc       1.250    0.020
 ACT      CH3    C         single      1.500    0.020
 ACT      H1     CH3       single      1.059    0.020
 ACT      H2     CH3       single      1.059    0.020
 ACT      H3     CH3       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ACT      OXT    C      O       123.000    3.000
 ACT      OXT    C      CH3     120.000    3.000
 ACT      O      C      CH3     120.000    3.000
 ACT      C      CH3    H3      109.470    3.000
 ACT      C      CH3    H2      109.470    3.000
 ACT      C      CH3    H1      109.470    3.000
 ACT      H3     CH3    H2      109.470    3.000
 ACT      H3     CH3    H1      109.470    3.000
 ACT      H2     CH3    H1      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ACT      var_1    OXT    C      CH3    H1       -90.000   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ACT      plan-1    C         0.020
 ACT      plan-1    O         0.000
 ACT      plan-1    OXT       0.000
 ACT      plan-1    CH3       0.000
# ------------------------------------------------------
`.trim();

monomers["CL"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CL       CL  'CHLORIDE ION                        ' non-polymer         1   1 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CL
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CL            CL     CL   CL       -1.000      0.000    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CL       CL     n/a    .      END
# ------------------------------------------------------
`.trim();

monomers["BR"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BR       BR  'BROMIDE ION                         ' non-polymer         1   1 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BR
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BR            BR     BR   BR       -1.000      0.000    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BR       BR     n/a    .      END
# ------------------------------------------------------
`.trim();

monomers["PG4"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PG4      PG4 'TETRAETHYLENE GLYCOL                ' non-polymer        31  13 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PG4
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PG4           O5     O    OH1       0.000      0.000    0.000    0.000
 PG4           HO5    H    H         0.000      0.729   -0.498    0.393
 PG4           C8     C    CH2       0.000     -0.506    0.936    0.954
 PG4           H81    H    H         0.000      0.290    1.623    1.247
 PG4           H82    H    H         0.000     -0.864    0.398    1.835
 PG4           C7     C    CH2       0.000     -1.659    1.724    0.334
 PG4           H71    H    H         0.000     -1.300    2.261   -0.547
 PG4           H72    H    H         0.000     -2.044    2.440    1.063
 PG4           O4     O    O2        0.000     -2.701    0.824   -0.048
 PG4           C6     C    CH2       0.000     -3.744    1.617   -0.619
 PG4           H61    H    H         0.000     -3.357    2.155   -1.487
 PG4           H62    H    H         0.000     -4.102    2.334    0.122
 PG4           C5     C    CH2       0.000     -4.896    0.709   -1.052
 PG4           H51    H    H         0.000     -4.536   -0.007   -1.793
 PG4           H52    H    H         0.000     -5.692    1.315   -1.489
 PG4           O3     O    O2        0.000     -5.401    0.006    0.085
 PG4           C4     C    CH2       0.000     -6.468   -0.820   -0.383
 PG4           H41    H    H         0.000     -6.088   -1.516   -1.133
 PG4           H42    H    H         0.000     -7.244   -0.194   -0.829
 PG4           C3     C    CH2       0.000     -7.057   -1.605    0.792
 PG4           H31    H    H         0.000     -6.280   -2.232    1.235
 PG4           H32    H    H         0.000     -7.872   -2.237    0.435
 PG4           O2     O    O2        0.000     -7.553   -0.694    1.774
 PG4           C2     C    CH2       0.000     -8.086   -1.484    2.837
 PG4           H21    H    H         0.000     -7.297   -2.112    3.255
 PG4           H22    H    H         0.000     -8.889   -2.117    2.453
 PG4           C1     C    CH2       0.000     -8.639   -0.564    3.928
 PG4           H11    H    H         0.000     -7.835    0.068    4.312
 PG4           H12    H    H         0.000     -9.045   -1.168    4.742
 PG4           O1     O    OH1       0.000     -9.672    0.256    3.381
 PG4           HO1    H    H         0.000    -10.020    0.838    4.070
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PG4      O5     n/a    C8     START
 PG4      HO5    O5     .      .
 PG4      C8     O5     C7     .
 PG4      H81    C8     .      .
 PG4      H82    C8     .      .
 PG4      C7     C8     O4     .
 PG4      H71    C7     .      .
 PG4      H72    C7     .      .
 PG4      O4     C7     C6     .
 PG4      C6     O4     C5     .
 PG4      H61    C6     .      .
 PG4      H62    C6     .      .
 PG4      C5     C6     O3     .
 PG4      H51    C5     .      .
 PG4      H52    C5     .      .
 PG4      O3     C5     C4     .
 PG4      C4     O3     C3     .
 PG4      H41    C4     .      .
 PG4      H42    C4     .      .
 PG4      C3     C4     O2     .
 PG4      H31    C3     .      .
 PG4      H32    C3     .      .
 PG4      O2     C3     C2     .
 PG4      C2     O2     C1     .
 PG4      H21    C2     .      .
 PG4      H22    C2     .      .
 PG4      C1     C2     O1     .
 PG4      H11    C1     .      .
 PG4      H12    C1     .      .
 PG4      O1     C1     HO1    .
 PG4      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PG4      O1     C1        single      1.432    0.020
 PG4      HO1    O1        single      0.967    0.020
 PG4      C1     C2        single      1.524    0.020
 PG4      H11    C1        single      1.092    0.020
 PG4      H12    C1        single      1.092    0.020
 PG4      C2     O2        single      1.426    0.020
 PG4      H21    C2        single      1.092    0.020
 PG4      H22    C2        single      1.092    0.020
 PG4      O2     C3        single      1.426    0.020
 PG4      C3     C4        single      1.524    0.020
 PG4      H31    C3        single      1.092    0.020
 PG4      H32    C3        single      1.092    0.020
 PG4      C4     O3        single      1.426    0.020
 PG4      H41    C4        single      1.092    0.020
 PG4      H42    C4        single      1.092    0.020
 PG4      O3     C5        single      1.426    0.020
 PG4      C5     C6        single      1.524    0.020
 PG4      H51    C5        single      1.092    0.020
 PG4      H52    C5        single      1.092    0.020
 PG4      C6     O4        single      1.426    0.020
 PG4      H61    C6        single      1.092    0.020
 PG4      H62    C6        single      1.092    0.020
 PG4      O4     C7        single      1.426    0.020
 PG4      C7     C8        single      1.524    0.020
 PG4      H71    C7        single      1.092    0.020
 PG4      H72    C7        single      1.092    0.020
 PG4      C8     O5        single      1.432    0.020
 PG4      H81    C8        single      1.092    0.020
 PG4      H82    C8        single      1.092    0.020
 PG4      HO5    O5        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PG4      HO5    O5     C8      109.470    3.000
 PG4      O5     C8     H81     109.470    3.000
 PG4      O5     C8     H82     109.470    3.000
 PG4      O5     C8     C7      109.470    3.000
 PG4      H81    C8     H82     107.900    3.000
 PG4      H81    C8     C7      109.470    3.000
 PG4      H82    C8     C7      109.470    3.000
 PG4      C8     C7     H71     109.470    3.000
 PG4      C8     C7     H72     109.470    3.000
 PG4      C8     C7     O4      109.470    3.000
 PG4      H71    C7     H72     107.900    3.000
 PG4      H71    C7     O4      109.470    3.000
 PG4      H72    C7     O4      109.470    3.000
 PG4      C7     O4     C6      111.800    3.000
 PG4      O4     C6     H61     109.470    3.000
 PG4      O4     C6     H62     109.470    3.000
 PG4      O4     C6     C5      109.470    3.000
 PG4      H61    C6     H62     107.900    3.000
 PG4      H61    C6     C5      109.470    3.000
 PG4      H62    C6     C5      109.470    3.000
 PG4      C6     C5     H51     109.470    3.000
 PG4      C6     C5     H52     109.470    3.000
 PG4      C6     C5     O3      109.470    3.000
 PG4      H51    C5     H52     107.900    3.000
 PG4      H51    C5     O3      109.470    3.000
 PG4      H52    C5     O3      109.470    3.000
 PG4      C5     O3     C4      111.800    3.000
 PG4      O3     C4     H41     109.470    3.000
 PG4      O3     C4     H42     109.470    3.000
 PG4      O3     C4     C3      109.470    3.000
 PG4      H41    C4     H42     107.900    3.000
 PG4      H41    C4     C3      109.470    3.000
 PG4      H42    C4     C3      109.470    3.000
 PG4      C4     C3     H31     109.470    3.000
 PG4      C4     C3     H32     109.470    3.000
 PG4      C4     C3     O2      109.470    3.000
 PG4      H31    C3     H32     107.900    3.000
 PG4      H31    C3     O2      109.470    3.000
 PG4      H32    C3     O2      109.470    3.000
 PG4      C3     O2     C2      111.800    3.000
 PG4      O2     C2     H21     109.470    3.000
 PG4      O2     C2     H22     109.470    3.000
 PG4      O2     C2     C1      109.470    3.000
 PG4      H21    C2     H22     107.900    3.000
 PG4      H21    C2     C1      109.470    3.000
 PG4      H22    C2     C1      109.470    3.000
 PG4      C2     C1     H11     109.470    3.000
 PG4      C2     C1     H12     109.470    3.000
 PG4      C2     C1     O1      109.470    3.000
 PG4      H11    C1     H12     107.900    3.000
 PG4      H11    C1     O1      109.470    3.000
 PG4      H12    C1     O1      109.470    3.000
 PG4      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PG4      var_1    HO5    O5     C8     C7      -179.974   20.000   1
 PG4      var_2    O5     C8     C7     O4        60.038   20.000   3
 PG4      var_3    C8     C7     O4     C6      -179.967   20.000   1
 PG4      var_4    C7     O4     C6     C5       179.975   20.000   1
 PG4      var_5    O4     C6     C5     O3        60.021   20.000   3
 PG4      var_6    C6     C5     O3     C4      -179.982   20.000   1
 PG4      var_7    C5     O3     C4     C3       179.984   20.000   1
 PG4      var_8    O3     C4     C3     O2        59.934   20.000   3
 PG4      var_9    C4     C3     O2     C2       179.948   20.000   1
 PG4      var_10   C3     O2     C2     C1      -179.965   20.000   1
 PG4      var_11   O2     C2     C1     O1        60.038   20.000   3
 PG4      var_12   C2     C1     O1     HO1     -179.951   20.000   1
# ------------------------------------------------------
`.trim();

monomers["PG5"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PG5      PG5 '1-METHOXY-2-[2-(2-METHOXY-ETHOXY]-ET' non-polymer        30  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PG5
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PG5           C8     C    CH3       0.000      0.000    0.000    0.000
 PG5           H81    H    H         0.000      0.455    0.948    0.125
 PG5           H82    H    H         0.000      0.593   -0.740    0.471
 PG5           H83    H    H         0.000     -0.081   -0.218   -1.033
 PG5           O4     O    O2        0.000     -1.303    0.014    0.588
 PG5           C7     C    CH2       0.000     -1.860   -1.286    0.387
 PG5           H71    H    H         0.000     -1.224   -2.033    0.868
 PG5           H72    H    H         0.000     -1.919   -1.495   -0.683
 PG5           C6     C    CH2       0.000     -3.262   -1.338    0.997
 PG5           H61    H    H         0.000     -3.200   -1.130    2.067
 PG5           H62    H    H         0.000     -3.687   -2.333    0.845
 PG5           O3     O    O2        0.000     -4.093   -0.362    0.367
 PG5           C5     C    CH2       0.000     -5.382   -0.460    0.977
 PG5           H51    H    H         0.000     -5.293   -0.263    2.047
 PG5           H52    H    H         0.000     -5.780   -1.465    0.824
 PG5           C4     C    CH2       0.000     -6.324    0.565    0.345
 PG5           H41    H    H         0.000     -5.925    1.569    0.500
 PG5           H42    H    H         0.000     -7.308    0.489    0.812
 PG5           O2     O    O2        0.000     -6.438    0.307   -1.056
 PG5           C3     C    CH2       0.000     -7.328    1.292   -1.586
 PG5           H31    H    H         0.000     -6.916    2.287   -1.407
 PG5           H32    H    H         0.000     -8.299    1.207   -1.094
 PG5           C2     C    CH2       0.000     -7.496    1.071   -3.090
 PG5           H21    H    H         0.000     -6.524    1.158   -3.580
 PG5           H22    H    H         0.000     -8.175    1.825   -3.494
 PG5           O1     O    O2        0.000     -8.034   -0.231   -3.323
 PG5           C1     C    CH3       0.000     -8.167   -0.376   -4.739
 PG5           H13    H    H         0.000     -8.566   -1.332   -4.960
 PG5           H12    H    H         0.000     -8.817    0.372   -5.112
 PG5           H11    H    H         0.000     -7.216   -0.277   -5.195
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PG5      C8     n/a    O4     START
 PG5      H81    C8     .      .
 PG5      H82    C8     .      .
 PG5      H83    C8     .      .
 PG5      O4     C8     C7     .
 PG5      C7     O4     C6     .
 PG5      H71    C7     .      .
 PG5      H72    C7     .      .
 PG5      C6     C7     O3     .
 PG5      H61    C6     .      .
 PG5      H62    C6     .      .
 PG5      O3     C6     C5     .
 PG5      C5     O3     C4     .
 PG5      H51    C5     .      .
 PG5      H52    C5     .      .
 PG5      C4     C5     O2     .
 PG5      H41    C4     .      .
 PG5      H42    C4     .      .
 PG5      O2     C4     C3     .
 PG5      C3     O2     C2     .
 PG5      H31    C3     .      .
 PG5      H32    C3     .      .
 PG5      C2     C3     O1     .
 PG5      H21    C2     .      .
 PG5      H22    C2     .      .
 PG5      O1     C2     C1     .
 PG5      C1     O1     H11    .
 PG5      H13    C1     .      .
 PG5      H12    C1     .      .
 PG5      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PG5      C1     O1        single      1.426    0.020
 PG5      H11    C1        single      1.059    0.020
 PG5      H12    C1        single      1.059    0.020
 PG5      H13    C1        single      1.059    0.020
 PG5      O1     C2        single      1.426    0.020
 PG5      C2     C3        single      1.524    0.020
 PG5      H21    C2        single      1.092    0.020
 PG5      H22    C2        single      1.092    0.020
 PG5      C3     O2        single      1.426    0.020
 PG5      H31    C3        single      1.092    0.020
 PG5      H32    C3        single      1.092    0.020
 PG5      O2     C4        single      1.426    0.020
 PG5      C4     C5        single      1.524    0.020
 PG5      H41    C4        single      1.092    0.020
 PG5      H42    C4        single      1.092    0.020
 PG5      C5     O3        single      1.426    0.020
 PG5      H51    C5        single      1.092    0.020
 PG5      H52    C5        single      1.092    0.020
 PG5      O3     C6        single      1.426    0.020
 PG5      C6     C7        single      1.524    0.020
 PG5      H61    C6        single      1.092    0.020
 PG5      H62    C6        single      1.092    0.020
 PG5      C7     O4        single      1.426    0.020
 PG5      H71    C7        single      1.092    0.020
 PG5      H72    C7        single      1.092    0.020
 PG5      O4     C8        single      1.426    0.020
 PG5      H81    C8        single      1.059    0.020
 PG5      H82    C8        single      1.059    0.020
 PG5      H83    C8        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PG5      H81    C8     H82     109.470    3.000
 PG5      H81    C8     H83     109.470    3.000
 PG5      H82    C8     H83     109.470    3.000
 PG5      H81    C8     O4      109.470    3.000
 PG5      H82    C8     O4      109.470    3.000
 PG5      H83    C8     O4      109.470    3.000
 PG5      C8     O4     C7      111.800    3.000
 PG5      O4     C7     H71     109.470    3.000
 PG5      O4     C7     H72     109.470    3.000
 PG5      O4     C7     C6      109.470    3.000
 PG5      H71    C7     H72     107.900    3.000
 PG5      H71    C7     C6      109.470    3.000
 PG5      H72    C7     C6      109.470    3.000
 PG5      C7     C6     H61     109.470    3.000
 PG5      C7     C6     H62     109.470    3.000
 PG5      C7     C6     O3      109.470    3.000
 PG5      H61    C6     H62     107.900    3.000
 PG5      H61    C6     O3      109.470    3.000
 PG5      H62    C6     O3      109.470    3.000
 PG5      C6     O3     C5      111.800    3.000
 PG5      O3     C5     H51     109.470    3.000
 PG5      O3     C5     H52     109.470    3.000
 PG5      O3     C5     C4      109.470    3.000
 PG5      H51    C5     H52     107.900    3.000
 PG5      H51    C5     C4      109.470    3.000
 PG5      H52    C5     C4      109.470    3.000
 PG5      C5     C4     H41     109.470    3.000
 PG5      C5     C4     H42     109.470    3.000
 PG5      C5     C4     O2      109.470    3.000
 PG5      H41    C4     H42     107.900    3.000
 PG5      H41    C4     O2      109.470    3.000
 PG5      H42    C4     O2      109.470    3.000
 PG5      C4     O2     C3      111.800    3.000
 PG5      O2     C3     H31     109.470    3.000
 PG5      O2     C3     H32     109.470    3.000
 PG5      O2     C3     C2      109.470    3.000
 PG5      H31    C3     H32     107.900    3.000
 PG5      H31    C3     C2      109.470    3.000
 PG5      H32    C3     C2      109.470    3.000
 PG5      C3     C2     H21     109.470    3.000
 PG5      C3     C2     H22     109.470    3.000
 PG5      C3     C2     O1      109.470    3.000
 PG5      H21    C2     H22     107.900    3.000
 PG5      H21    C2     O1      109.470    3.000
 PG5      H22    C2     O1      109.470    3.000
 PG5      C2     O1     C1      111.800    3.000
 PG5      O1     C1     H13     109.470    3.000
 PG5      O1     C1     H12     109.470    3.000
 PG5      O1     C1     H11     109.470    3.000
 PG5      H13    C1     H12     109.470    3.000
 PG5      H13    C1     H11     109.470    3.000
 PG5      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PG5      var_1    H83    C8     O4     C7        60.008   20.000   1
 PG5      var_2    C8     O4     C7     C6       179.994   20.000   1
 PG5      var_3    O4     C7     C6     O3        60.041   20.000   3
 PG5      var_4    C7     C6     O3     C5      -179.993   20.000   1
 PG5      var_5    C6     O3     C5     C4       179.970   20.000   1
 PG5      var_6    O3     C5     C4     O2        59.955   20.000   3
 PG5      var_7    C5     C4     O2     C3       179.970   20.000   1
 PG5      var_8    C4     O2     C3     C2      -179.974   20.000   1
 PG5      var_9    O2     C3     C2     O1        60.005   20.000   3
 PG5      var_10   C3     C2     O1     C1      -179.984   20.000   1
 PG5      var_11   C2     O1     C1     H11       60.030   20.000   1
# ------------------------------------------------------
`.trim();

monomers["PG6"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PG6      PG6 '1-(2-METHOXY-ETHOXY)-2-{2-[2-(2-METH' non-polymer        44  18 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PG6
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PG6           C12    C    CH3       0.000      0.000    0.000    0.000
 PG6           H121   H    H         0.000      0.585   -0.883    0.022
 PG6           H122   H    H         0.000      0.632    0.838   -0.143
 PG6           H123   H    H         0.000     -0.519    0.102    0.918
 PG6           O6     O    O2        0.000     -0.940   -0.077   -1.074
 PG6           C11    C    CH2       0.000     -1.695    1.136   -1.049
 PG6           H111   H    H         0.000     -1.022    1.986   -1.183
 PG6           H112   H    H         0.000     -2.207    1.227   -0.088
 PG6           C10    C    CH2       0.000     -2.727    1.119   -2.178
 PG6           H101   H    H         0.000     -2.213    1.030   -3.138
 PG6           H102   H    H         0.000     -3.302    2.047   -2.159
 PG6           O5     O    O2        0.000     -3.606    0.007   -2.003
 PG6           C9     C    CH2       0.000     -4.541    0.045   -3.083
 PG6           H91    H    H         0.000     -4.005   -0.029   -4.031
 PG6           H92    H    H         0.000     -5.094    0.987   -3.052
 PG6           C8     C    CH2       0.000     -5.518   -1.125   -2.954
 PG6           H81    H    H         0.000     -4.964   -2.065   -2.986
 PG6           H82    H    H         0.000     -6.231   -1.096   -3.781
 PG6           O4     O    O2        0.000     -6.220   -1.024   -1.714
 PG6           C7     C    CH2       0.000     -7.112   -2.139   -1.652
 PG6           H71    H    H         0.000     -6.537   -3.067   -1.700
 PG6           H72    H    H         0.000     -7.804   -2.098   -2.495
 PG6           C6     C    CH2       0.000     -7.898   -2.092   -0.342
 PG6           H61    H    H         0.000     -7.204   -2.135    0.500
 PG6           H62    H    H         0.000     -8.578   -2.945   -0.295
 PG6           O3     O    O2        0.000     -8.649   -0.878   -0.281
 PG6           C5     C    CH2       0.000     -9.358   -0.892    0.959
 PG6           H51    H    H         0.000     -8.645   -0.951    1.784
 PG6           H52    H    H         0.000    -10.019   -1.761    0.989
 PG6           C4     C    CH2       0.000    -10.186    0.386    1.089
 PG6           H41    H    H         0.000     -9.522    1.253    1.060
 PG6           H42    H    H         0.000    -10.726    0.374    2.038
 PG6           O2     O    O2        0.000    -11.119    0.462    0.009
 PG6           C3     C    CH2       0.000    -11.858    1.671    0.184
 PG6           H31    H    H         0.000    -11.173    2.522    0.166
 PG6           H32    H    H         0.000    -12.376    1.644    1.145
 PG6           C2     C    CH2       0.000    -12.880    1.813   -0.944
 PG6           H21    H    H         0.000    -12.359    1.843   -1.903
 PG6           H22    H    H         0.000    -13.443    2.739   -0.809
 PG6           O1     O    O2        0.000    -13.775    0.700   -0.921
 PG6           C1     C    CH3       0.000    -14.699    0.891   -1.993
 PG6           H13    H    H         0.000    -15.387    0.085   -2.014
 PG6           H12    H    H         0.000    -15.225    1.799   -1.850
 PG6           H11    H    H         0.000    -14.173    0.929   -2.911
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PG6      C12    n/a    O6     START
 PG6      H121   C12    .      .
 PG6      H122   C12    .      .
 PG6      H123   C12    .      .
 PG6      O6     C12    C11    .
 PG6      C11    O6     C10    .
 PG6      H111   C11    .      .
 PG6      H112   C11    .      .
 PG6      C10    C11    O5     .
 PG6      H101   C10    .      .
 PG6      H102   C10    .      .
 PG6      O5     C10    C9     .
 PG6      C9     O5     C8     .
 PG6      H91    C9     .      .
 PG6      H92    C9     .      .
 PG6      C8     C9     O4     .
 PG6      H81    C8     .      .
 PG6      H82    C8     .      .
 PG6      O4     C8     C7     .
 PG6      C7     O4     C6     .
 PG6      H71    C7     .      .
 PG6      H72    C7     .      .
 PG6      C6     C7     O3     .
 PG6      H61    C6     .      .
 PG6      H62    C6     .      .
 PG6      O3     C6     C5     .
 PG6      C5     O3     C4     .
 PG6      H51    C5     .      .
 PG6      H52    C5     .      .
 PG6      C4     C5     O2     .
 PG6      H41    C4     .      .
 PG6      H42    C4     .      .
 PG6      O2     C4     C3     .
 PG6      C3     O2     C2     .
 PG6      H31    C3     .      .
 PG6      H32    C3     .      .
 PG6      C2     C3     O1     .
 PG6      H21    C2     .      .
 PG6      H22    C2     .      .
 PG6      O1     C2     C1     .
 PG6      C1     O1     H11    .
 PG6      H13    C1     .      .
 PG6      H12    C1     .      .
 PG6      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PG6      C1     O1        single      1.426    0.020
 PG6      H11    C1        single      1.059    0.020
 PG6      H12    C1        single      1.059    0.020
 PG6      H13    C1        single      1.059    0.020
 PG6      O1     C2        single      1.426    0.020
 PG6      C2     C3        single      1.524    0.020
 PG6      H21    C2        single      1.092    0.020
 PG6      H22    C2        single      1.092    0.020
 PG6      C3     O2        single      1.426    0.020
 PG6      H31    C3        single      1.092    0.020
 PG6      H32    C3        single      1.092    0.020
 PG6      O2     C4        single      1.426    0.020
 PG6      C4     C5        single      1.524    0.020
 PG6      H41    C4        single      1.092    0.020
 PG6      H42    C4        single      1.092    0.020
 PG6      C5     O3        single      1.426    0.020
 PG6      H51    C5        single      1.092    0.020
 PG6      H52    C5        single      1.092    0.020
 PG6      O3     C6        single      1.426    0.020
 PG6      C6     C7        single      1.524    0.020
 PG6      H61    C6        single      1.092    0.020
 PG6      H62    C6        single      1.092    0.020
 PG6      C7     O4        single      1.426    0.020
 PG6      H71    C7        single      1.092    0.020
 PG6      H72    C7        single      1.092    0.020
 PG6      O4     C8        single      1.426    0.020
 PG6      C8     C9        single      1.524    0.020
 PG6      H81    C8        single      1.092    0.020
 PG6      H82    C8        single      1.092    0.020
 PG6      C9     O5        single      1.426    0.020
 PG6      H91    C9        single      1.092    0.020
 PG6      H92    C9        single      1.092    0.020
 PG6      O5     C10       single      1.426    0.020
 PG6      C10    C11       single      1.524    0.020
 PG6      H101   C10       single      1.092    0.020
 PG6      H102   C10       single      1.092    0.020
 PG6      C11    O6        single      1.426    0.020
 PG6      H111   C11       single      1.092    0.020
 PG6      H112   C11       single      1.092    0.020
 PG6      O6     C12       single      1.426    0.020
 PG6      H121   C12       single      1.059    0.020
 PG6      H122   C12       single      1.059    0.020
 PG6      H123   C12       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PG6      H121   C12    H122    109.470    3.000
 PG6      H121   C12    H123    109.470    3.000
 PG6      H122   C12    H123    109.470    3.000
 PG6      H121   C12    O6      109.470    3.000
 PG6      H122   C12    O6      109.470    3.000
 PG6      H123   C12    O6      109.470    3.000
 PG6      C12    O6     C11     111.800    3.000
 PG6      O6     C11    H111    109.470    3.000
 PG6      O6     C11    H112    109.470    3.000
 PG6      O6     C11    C10     109.470    3.000
 PG6      H111   C11    H112    107.900    3.000
 PG6      H111   C11    C10     109.470    3.000
 PG6      H112   C11    C10     109.470    3.000
 PG6      C11    C10    H101    109.470    3.000
 PG6      C11    C10    H102    109.470    3.000
 PG6      C11    C10    O5      109.470    3.000
 PG6      H101   C10    H102    107.900    3.000
 PG6      H101   C10    O5      109.470    3.000
 PG6      H102   C10    O5      109.470    3.000
 PG6      C10    O5     C9      111.800    3.000
 PG6      O5     C9     H91     109.470    3.000
 PG6      O5     C9     H92     109.470    3.000
 PG6      O5     C9     C8      109.470    3.000
 PG6      H91    C9     H92     107.900    3.000
 PG6      H91    C9     C8      109.470    3.000
 PG6      H92    C9     C8      109.470    3.000
 PG6      C9     C8     H81     109.470    3.000
 PG6      C9     C8     H82     109.470    3.000
 PG6      C9     C8     O4      109.470    3.000
 PG6      H81    C8     H82     107.900    3.000
 PG6      H81    C8     O4      109.470    3.000
 PG6      H82    C8     O4      109.470    3.000
 PG6      C8     O4     C7      111.800    3.000
 PG6      O4     C7     H71     109.470    3.000
 PG6      O4     C7     H72     109.470    3.000
 PG6      O4     C7     C6      109.470    3.000
 PG6      H71    C7     H72     107.900    3.000
 PG6      H71    C7     C6      109.470    3.000
 PG6      H72    C7     C6      109.470    3.000
 PG6      C7     C6     H61     109.470    3.000
 PG6      C7     C6     H62     109.470    3.000
 PG6      C7     C6     O3      109.470    3.000
 PG6      H61    C6     H62     107.900    3.000
 PG6      H61    C6     O3      109.470    3.000
 PG6      H62    C6     O3      109.470    3.000
 PG6      C6     O3     C5      111.800    3.000
 PG6      O3     C5     H51     109.470    3.000
 PG6      O3     C5     H52     109.470    3.000
 PG6      O3     C5     C4      109.470    3.000
 PG6      H51    C5     H52     107.900    3.000
 PG6      H51    C5     C4      109.470    3.000
 PG6      H52    C5     C4      109.470    3.000
 PG6      C5     C4     H41     109.470    3.000
 PG6      C5     C4     H42     109.470    3.000
 PG6      C5     C4     O2      109.470    3.000
 PG6      H41    C4     H42     107.900    3.000
 PG6      H41    C4     O2      109.470    3.000
 PG6      H42    C4     O2      109.470    3.000
 PG6      C4     O2     C3      111.800    3.000
 PG6      O2     C3     H31     109.470    3.000
 PG6      O2     C3     H32     109.470    3.000
 PG6      O2     C3     C2      109.470    3.000
 PG6      H31    C3     H32     107.900    3.000
 PG6      H31    C3     C2      109.470    3.000
 PG6      H32    C3     C2      109.470    3.000
 PG6      C3     C2     H21     109.470    3.000
 PG6      C3     C2     H22     109.470    3.000
 PG6      C3     C2     O1      109.470    3.000
 PG6      H21    C2     H22     107.900    3.000
 PG6      H21    C2     O1      109.470    3.000
 PG6      H22    C2     O1      109.470    3.000
 PG6      C2     O1     C1      111.800    3.000
 PG6      O1     C1     H13     109.470    3.000
 PG6      O1     C1     H12     109.470    3.000
 PG6      O1     C1     H11     109.470    3.000
 PG6      H13    C1     H12     109.470    3.000
 PG6      H13    C1     H11     109.470    3.000
 PG6      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PG6      var_1    H123   C12    O6     C11       60.012   20.000   1
 PG6      var_2    C12    O6     C11    C10     -179.963   20.000   1
 PG6      var_3    O6     C11    C10    O5        59.961   20.000   3
 PG6      var_4    C11    C10    O5     C9      -179.999   20.000   1
 PG6      var_5    C10    O5     C9     C8       179.999   20.000   1
 PG6      var_6    O5     C9     C8     O4        60.045   20.000   3
 PG6      var_7    C9     C8     O4     C7      -179.996   20.000   1
 PG6      var_8    C8     O4     C7     C6      -179.996   20.000   1
 PG6      var_9    O4     C7     C6     O3        60.002   20.000   3
 PG6      var_10   C7     C6     O3     C5      -179.997   20.000   1
 PG6      var_11   C6     O3     C5     C4       179.983   20.000   1
 PG6      var_12   O3     C5     C4     O2        60.009   20.000   3
 PG6      var_13   C5     C4     O2     C3      -179.959   20.000   1
 PG6      var_14   C4     O2     C3     C2      -179.957   20.000   1
 PG6      var_15   O2     C3     C2     O1        59.943   20.000   3
 PG6      var_16   C3     C2     O1     C1      -179.964   20.000   1
 PG6      var_17   C2     O1     C1     H11       60.030   20.000   1
# ------------------------------------------------------
`.trim();

monomers["1PE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
1PE      1PE 'PENTAETHYLENE GLYCOL                ' non-polymer        38  16 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_1PE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 1PE           OH7    O    OH1       0.000      0.000    0.000    0.000
 1PE           HO7    H    H         0.000      0.632    0.724   -0.105
 1PE           C16    C    CH2       0.000     -0.938    0.028   -1.078
 1PE           H161   H    H         0.000     -0.406   -0.086   -2.025
 1PE           H162   H    H         0.000     -1.469    0.982   -1.072
 1PE           C26    C    CH2       0.000     -1.939   -1.116   -0.912
 1PE           H261   H    H         0.000     -1.406   -2.069   -0.919
 1PE           H262   H    H         0.000     -2.654   -1.095   -1.737
 1PE           OH6    O    O2        0.000     -2.634   -0.967    0.328
 1PE           C15    C    CH2       0.000     -3.548   -2.060    0.423
 1PE           H151   H    H         0.000     -2.994   -3.000    0.399
 1PE           H152   H    H         0.000     -4.243   -2.027   -0.419
 1PE           C25    C    CH2       0.000     -4.329   -1.959    1.735
 1PE           H251   H    H         0.000     -3.633   -1.994    2.576
 1PE           H252   H    H         0.000     -5.028   -2.795    1.807
 1PE           OH5    O    O2        0.000     -5.053   -0.727    1.765
 1PE           C14    C    CH2       0.000     -5.757   -0.692    3.008
 1PE           H141   H    H         0.000     -5.042   -0.743    3.832
 1PE           H142   H    H         0.000     -6.437   -1.544    3.065
 1PE           C24    C    CH2       0.000     -6.557    0.608    3.104
 1PE           H241   H    H         0.000     -5.875    1.459    3.047
 1PE           H242   H    H         0.000     -7.093    0.635    4.054
 1PE           OH4    O    O2        0.000     -7.491    0.673    2.025
 1PE           C13    C    CH2       0.000     -8.204    1.903    2.169
 1PE           H131   H    H         0.000     -7.501    2.737    2.125
 1PE           H132   H    H         0.000     -8.719    1.914    3.132
 1PE           C23    C    CH2       0.000     -9.227    2.035    1.041
 1PE           H231   H    H         0.000     -8.711    2.027    0.079
 1PE           H232   H    H         0.000     -9.771    2.976    1.152
 1PE           OH3    O    O2        0.000    -10.146    0.942    1.099
 1PE           C22    C    CH2       0.000    -11.071    1.122    0.025
 1PE           H221   H    H         0.000    -10.530    1.124   -0.924
 1PE           H222   H    H         0.000    -11.590    2.074    0.148
 1PE           C12    C    CH2       0.000    -12.088   -0.020    0.031
 1PE           H121   H    H         0.000    -11.566   -0.971   -0.094
 1PE           H122   H    H         0.000    -12.793    0.118   -0.791
 1PE           OH2    O    OH1       0.000    -12.795   -0.022    1.272
 1PE           HO2    H    H         0.000    -13.437   -0.745    1.274
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 1PE      OH7    n/a    C16    START
 1PE      HO7    OH7    .      .
 1PE      C16    OH7    C26    .
 1PE      H161   C16    .      .
 1PE      H162   C16    .      .
 1PE      C26    C16    OH6    .
 1PE      H261   C26    .      .
 1PE      H262   C26    .      .
 1PE      OH6    C26    C15    .
 1PE      C15    OH6    C25    .
 1PE      H151   C15    .      .
 1PE      H152   C15    .      .
 1PE      C25    C15    OH5    .
 1PE      H251   C25    .      .
 1PE      H252   C25    .      .
 1PE      OH5    C25    C14    .
 1PE      C14    OH5    C24    .
 1PE      H141   C14    .      .
 1PE      H142   C14    .      .
 1PE      C24    C14    OH4    .
 1PE      H241   C24    .      .
 1PE      H242   C24    .      .
 1PE      OH4    C24    C13    .
 1PE      C13    OH4    C23    .
 1PE      H131   C13    .      .
 1PE      H132   C13    .      .
 1PE      C23    C13    OH3    .
 1PE      H231   C23    .      .
 1PE      H232   C23    .      .
 1PE      OH3    C23    C22    .
 1PE      C22    OH3    C12    .
 1PE      H221   C22    .      .
 1PE      H222   C22    .      .
 1PE      C12    C22    OH2    .
 1PE      H121   C12    .      .
 1PE      H122   C12    .      .
 1PE      OH2    C12    HO2    .
 1PE      HO2    OH2    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 1PE      OH2    C12       single      1.432    0.020
 1PE      HO2    OH2       single      0.967    0.020
 1PE      C12    C22       single      1.524    0.020
 1PE      H121   C12       single      1.092    0.020
 1PE      H122   C12       single      1.092    0.020
 1PE      C22    OH3       single      1.426    0.020
 1PE      H221   C22       single      1.092    0.020
 1PE      H222   C22       single      1.092    0.020
 1PE      OH3    C23       single      1.426    0.020
 1PE      C23    C13       single      1.524    0.020
 1PE      C13    OH4       single      1.426    0.020
 1PE      H131   C13       single      1.092    0.020
 1PE      H132   C13       single      1.092    0.020
 1PE      H231   C23       single      1.092    0.020
 1PE      H232   C23       single      1.092    0.020
 1PE      OH4    C24       single      1.426    0.020
 1PE      C24    C14       single      1.524    0.020
 1PE      C14    OH5       single      1.426    0.020
 1PE      H141   C14       single      1.092    0.020
 1PE      H142   C14       single      1.092    0.020
 1PE      H241   C24       single      1.092    0.020
 1PE      H242   C24       single      1.092    0.020
 1PE      OH5    C25       single      1.426    0.020
 1PE      C25    C15       single      1.524    0.020
 1PE      C15    OH6       single      1.426    0.020
 1PE      H151   C15       single      1.092    0.020
 1PE      H152   C15       single      1.092    0.020
 1PE      H251   C25       single      1.092    0.020
 1PE      H252   C25       single      1.092    0.020
 1PE      OH6    C26       single      1.426    0.020
 1PE      C26    C16       single      1.524    0.020
 1PE      C16    OH7       single      1.432    0.020
 1PE      H161   C16       single      1.092    0.020
 1PE      H162   C16       single      1.092    0.020
 1PE      H261   C26       single      1.092    0.020
 1PE      H262   C26       single      1.092    0.020
 1PE      HO7    OH7       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 1PE      HO7    OH7    C16     109.470    3.000
 1PE      OH7    C16    H161    109.470    3.000
 1PE      OH7    C16    H162    109.470    3.000
 1PE      OH7    C16    C26     109.470    3.000
 1PE      H161   C16    H162    107.900    3.000
 1PE      H161   C16    C26     109.470    3.000
 1PE      H162   C16    C26     109.470    3.000
 1PE      C16    C26    H261    109.470    3.000
 1PE      C16    C26    H262    109.470    3.000
 1PE      C16    C26    OH6     109.470    3.000
 1PE      H261   C26    H262    107.900    3.000
 1PE      H261   C26    OH6     109.470    3.000
 1PE      H262   C26    OH6     109.470    3.000
 1PE      C26    OH6    C15     111.800    3.000
 1PE      OH6    C15    H151    109.470    3.000
 1PE      OH6    C15    H152    109.470    3.000
 1PE      OH6    C15    C25     109.470    3.000
 1PE      H151   C15    H152    107.900    3.000
 1PE      H151   C15    C25     109.470    3.000
 1PE      H152   C15    C25     109.470    3.000
 1PE      C15    C25    H251    109.470    3.000
 1PE      C15    C25    H252    109.470    3.000
 1PE      C15    C25    OH5     109.470    3.000
 1PE      H251   C25    H252    107.900    3.000
 1PE      H251   C25    OH5     109.470    3.000
 1PE      H252   C25    OH5     109.470    3.000
 1PE      C25    OH5    C14     111.800    3.000
 1PE      OH5    C14    H141    109.470    3.000
 1PE      OH5    C14    H142    109.470    3.000
 1PE      OH5    C14    C24     109.470    3.000
 1PE      H141   C14    H142    107.900    3.000
 1PE      H141   C14    C24     109.470    3.000
 1PE      H142   C14    C24     109.470    3.000
 1PE      C14    C24    H241    109.470    3.000
 1PE      C14    C24    H242    109.470    3.000
 1PE      C14    C24    OH4     109.470    3.000
 1PE      H241   C24    H242    107.900    3.000
 1PE      H241   C24    OH4     109.470    3.000
 1PE      H242   C24    OH4     109.470    3.000
 1PE      C24    OH4    C13     111.800    3.000
 1PE      OH4    C13    H131    109.470    3.000
 1PE      OH4    C13    H132    109.470    3.000
 1PE      OH4    C13    C23     109.470    3.000
 1PE      H131   C13    H132    107.900    3.000
 1PE      H131   C13    C23     109.470    3.000
 1PE      H132   C13    C23     109.470    3.000
 1PE      C13    C23    H231    109.470    3.000
 1PE      C13    C23    H232    109.470    3.000
 1PE      C13    C23    OH3     109.470    3.000
 1PE      H231   C23    H232    107.900    3.000
 1PE      H231   C23    OH3     109.470    3.000
 1PE      H232   C23    OH3     109.470    3.000
 1PE      C23    OH3    C22     111.800    3.000
 1PE      OH3    C22    H221    109.470    3.000
 1PE      OH3    C22    H222    109.470    3.000
 1PE      OH3    C22    C12     109.470    3.000
 1PE      H221   C22    H222    107.900    3.000
 1PE      H221   C22    C12     109.470    3.000
 1PE      H222   C22    C12     109.470    3.000
 1PE      C22    C12    H121    109.470    3.000
 1PE      C22    C12    H122    109.470    3.000
 1PE      C22    C12    OH2     109.470    3.000
 1PE      H121   C12    H122    107.900    3.000
 1PE      H121   C12    OH2     109.470    3.000
 1PE      H122   C12    OH2     109.470    3.000
 1PE      C12    OH2    HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 1PE      var_1    HO7    OH7    C16    C26     -179.995   20.000   1
 1PE      var_2    OH7    C16    C26    OH6       59.981   20.000   3
 1PE      var_3    C16    C26    OH6    C15     -179.973   20.000   1
 1PE      var_4    C26    OH6    C15    C25     -179.982   20.000   1
 1PE      var_5    OH6    C15    C25    OH5       59.946   20.000   3
 1PE      var_6    C15    C25    OH5    C14     -179.962   20.000   1
 1PE      var_7    C25    OH5    C14    C24     -179.974   20.000   1
 1PE      var_8    OH5    C14    C24    OH4       60.023   20.000   3
 1PE      var_9    C14    C24    OH4    C13     -179.995   20.000   1
 1PE      var_10   C24    OH4    C13    C23     -179.964   20.000   1
 1PE      var_11   OH4    C13    C23    OH3       59.911   20.000   3
 1PE      var_12   C13    C23    OH3    C22     -179.961   20.000   1
 1PE      var_13   C23    OH3    C22    C12     -179.936   20.000   1
 1PE      var_14   OH3    C22    C12    OH2       59.993   20.000   3
 1PE      var_15   C22    C12    OH2    HO2     -179.946   20.000   1
# ------------------------------------------------------
`.trim();

monomers["2PE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
2PE      2PE 'NONAETHYLENE GLYCOL                 ' non-polymer        66  28 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_2PE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 2PE           O28    O    OH1       0.000      0.000    0.000    0.000
 2PE           HO2    H    H         0.000      0.605    0.743   -0.128
 2PE           C27    C    CH2       0.000     -0.877   -0.100   -1.125
 2PE           H271   H    H         0.000     -0.290   -0.260   -2.031
 2PE           H272   H    H         0.000     -1.450    0.825   -1.222
 2PE           C26    C    CH2       0.000     -1.834   -1.275   -0.921
 2PE           H261   H    H         0.000     -1.260   -2.198   -0.825
 2PE           H262   H    H         0.000     -2.503   -1.351   -1.782
 2PE           O25    O    O2        0.000     -2.603   -1.064    0.264
 2PE           C24    C    CH2       0.000     -3.473   -2.190    0.398
 2PE           H241   H    H         0.000     -2.877   -3.102    0.478
 2PE           H242   H    H         0.000     -4.120   -2.255   -0.479
 2PE           C23    C    CH2       0.000     -4.329   -2.026    1.655
 2PE           H231   H    H         0.000     -3.680   -1.962    2.531
 2PE           H232   H    H         0.000     -4.992   -2.888    1.758
 2PE           O22    O    O2        0.000     -5.108   -0.833    1.549
 2PE           C21    C    CH2       0.000     -5.881   -0.736    2.748
 2PE           H211   H    H         0.000     -5.211   -0.688    3.609
 2PE           H212   H    H         0.000     -6.524   -1.613    2.837
 2PE           C20    C    CH2       0.000     -6.742    0.527    2.698
 2PE           H201   H    H         0.000     -6.096    1.404    2.611
 2PE           H202   H    H         0.000     -7.332    0.601    3.614
 2PE           O19    O    O2        0.000     -7.616    0.463    1.571
 2PE           C18    C    CH2       0.000     -8.390    1.665    1.580
 2PE           H181   H    H         0.000     -7.723    2.527    1.506
 2PE           H182   H    H         0.000     -8.958    1.725    2.510
 2PE           C17    C    CH2       0.000     -9.353    1.661    0.391
 2PE           H171   H    H         0.000     -8.783    1.604   -0.538
 2PE           H172   H    H         0.000     -9.943    2.580    0.399
 2PE           O16    O    O2        0.000    -10.224    0.533    0.488
 2PE           C15    C    CH2       0.000    -11.094    0.586   -0.643
 2PE           H151   H    H         0.000    -10.502    0.542   -1.559
 2PE           H152   H    H         0.000    -11.662    1.518   -0.622
 2PE           C14    C    CH2       0.000    -12.059   -0.601   -0.601
 2PE           H141   H    H         0.000    -11.490   -1.533   -0.623
 2PE           H142   H    H         0.000    -12.723   -0.561   -1.467
 2PE           O13    O    O2        0.000    -12.834   -0.542    0.599
 2PE           C12    C    CH2       0.000    -13.710   -1.670    0.580
 2PE           H121   H    H         0.000    -13.119   -2.588    0.543
 2PE           H122   H    H         0.000    -14.352   -1.617   -0.302
 2PE           C11    C    CH2       0.000    -14.572   -1.667    1.843
 2PE           H111   H    H         0.000    -13.928   -1.722    2.723
 2PE           H112   H    H         0.000    -15.241   -2.530    1.828
 2PE           O10    O    O2        0.000    -15.345   -0.465    1.890
 2PE           C9     C    CH2       0.000    -16.124   -0.522    3.086
 2PE           H91    H    H         0.000    -15.460   -0.591    3.950
 2PE           H92    H    H         0.000    -16.773   -1.400    3.056
 2PE           C8     C    CH2       0.000    -16.978    0.742    3.197
 2PE           H81    H    H         0.000    -16.328    1.618    3.229
 2PE           H82    H    H         0.000    -17.573    0.698    4.112
 2PE           O7     O    O2        0.000    -17.847    0.831    2.066
 2PE           C6     C    CH2       0.000    -18.615    2.025    2.228
 2PE           H61    H    H         0.000    -17.943    2.886    2.271
 2PE           H62    H    H         0.000    -19.189    1.965    3.155
 2PE           C5     C    CH2       0.000    -19.571    2.182    1.044
 2PE           H51    H    H         0.000    -18.995    2.243    0.118
 2PE           H52    H    H         0.000    -20.156    3.096    1.168
 2PE           O4     O    O2        0.000    -20.448    1.056    0.988
 2PE           C3     C    CH2       0.000    -21.311    1.260   -0.133
 2PE           H31    H    H         0.000    -20.714    1.332   -1.044
 2PE           H32    H    H         0.000    -21.874    2.185    0.006
 2PE           C2     C    CH2       0.000    -22.281    0.084   -0.249
 2PE           H21    H    H         0.000    -21.716   -0.840   -0.389
 2PE           H22    H    H         0.000    -22.939    0.240   -1.106
 2PE           O1     O    OH1       0.000    -23.064   -0.010    0.943
 2PE           HO1    H    H         0.000    -23.677   -0.754    0.868
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 2PE      O28    n/a    C27    START
 2PE      HO2    O28    .      .
 2PE      C27    O28    C26    .
 2PE      H271   C27    .      .
 2PE      H272   C27    .      .
 2PE      C26    C27    O25    .
 2PE      H261   C26    .      .
 2PE      H262   C26    .      .
 2PE      O25    C26    C24    .
 2PE      C24    O25    C23    .
 2PE      H241   C24    .      .
 2PE      H242   C24    .      .
 2PE      C23    C24    O22    .
 2PE      H231   C23    .      .
 2PE      H232   C23    .      .
 2PE      O22    C23    C21    .
 2PE      C21    O22    C20    .
 2PE      H211   C21    .      .
 2PE      H212   C21    .      .
 2PE      C20    C21    O19    .
 2PE      H201   C20    .      .
 2PE      H202   C20    .      .
 2PE      O19    C20    C18    .
 2PE      C18    O19    C17    .
 2PE      H181   C18    .      .
 2PE      H182   C18    .      .
 2PE      C17    C18    O16    .
 2PE      H171   C17    .      .
 2PE      H172   C17    .      .
 2PE      O16    C17    C15    .
 2PE      C15    O16    C14    .
 2PE      H151   C15    .      .
 2PE      H152   C15    .      .
 2PE      C14    C15    O13    .
 2PE      H141   C14    .      .
 2PE      H142   C14    .      .
 2PE      O13    C14    C12    .
 2PE      C12    O13    C11    .
 2PE      H121   C12    .      .
 2PE      H122   C12    .      .
 2PE      C11    C12    O10    .
 2PE      H111   C11    .      .
 2PE      H112   C11    .      .
 2PE      O10    C11    C9     .
 2PE      C9     O10    C8     .
 2PE      H91    C9     .      .
 2PE      H92    C9     .      .
 2PE      C8     C9     O7     .
 2PE      H81    C8     .      .
 2PE      H82    C8     .      .
 2PE      O7     C8     C6     .
 2PE      C6     O7     C5     .
 2PE      H61    C6     .      .
 2PE      H62    C6     .      .
 2PE      C5     C6     O4     .
 2PE      H51    C5     .      .
 2PE      H52    C5     .      .
 2PE      O4     C5     C3     .
 2PE      C3     O4     C2     .
 2PE      H31    C3     .      .
 2PE      H32    C3     .      .
 2PE      C2     C3     O1     .
 2PE      H21    C2     .      .
 2PE      H22    C2     .      .
 2PE      O1     C2     HO1    .
 2PE      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 2PE      O1     C2        single      1.432    0.020
 2PE      HO1    O1        single      0.967    0.020
 2PE      C2     C3        single      1.524    0.020
 2PE      H21    C2        single      1.092    0.020
 2PE      H22    C2        single      1.092    0.020
 2PE      C3     O4        single      1.426    0.020
 2PE      H31    C3        single      1.092    0.020
 2PE      H32    C3        single      1.092    0.020
 2PE      O4     C5        single      1.426    0.020
 2PE      C5     C6        single      1.524    0.020
 2PE      H51    C5        single      1.092    0.020
 2PE      H52    C5        single      1.092    0.020
 2PE      C6     O7        single      1.426    0.020
 2PE      H61    C6        single      1.092    0.020
 2PE      H62    C6        single      1.092    0.020
 2PE      O7     C8        single      1.426    0.020
 2PE      C8     C9        single      1.524    0.020
 2PE      H81    C8        single      1.092    0.020
 2PE      H82    C8        single      1.092    0.020
 2PE      C9     O10       single      1.426    0.020
 2PE      H91    C9        single      1.092    0.020
 2PE      H92    C9        single      1.092    0.020
 2PE      O10    C11       single      1.426    0.020
 2PE      C11    C12       single      1.524    0.020
 2PE      H111   C11       single      1.092    0.020
 2PE      H112   C11       single      1.092    0.020
 2PE      C12    O13       single      1.426    0.020
 2PE      H121   C12       single      1.092    0.020
 2PE      H122   C12       single      1.092    0.020
 2PE      O13    C14       single      1.426    0.020
 2PE      C14    C15       single      1.524    0.020
 2PE      H141   C14       single      1.092    0.020
 2PE      H142   C14       single      1.092    0.020
 2PE      C15    O16       single      1.426    0.020
 2PE      H151   C15       single      1.092    0.020
 2PE      H152   C15       single      1.092    0.020
 2PE      O16    C17       single      1.426    0.020
 2PE      C17    C18       single      1.524    0.020
 2PE      H171   C17       single      1.092    0.020
 2PE      H172   C17       single      1.092    0.020
 2PE      C18    O19       single      1.426    0.020
 2PE      H181   C18       single      1.092    0.020
 2PE      H182   C18       single      1.092    0.020
 2PE      O19    C20       single      1.426    0.020
 2PE      C20    C21       single      1.524    0.020
 2PE      H201   C20       single      1.092    0.020
 2PE      H202   C20       single      1.092    0.020
 2PE      C21    O22       single      1.426    0.020
 2PE      H211   C21       single      1.092    0.020
 2PE      H212   C21       single      1.092    0.020
 2PE      O22    C23       single      1.426    0.020
 2PE      C23    C24       single      1.524    0.020
 2PE      H231   C23       single      1.092    0.020
 2PE      H232   C23       single      1.092    0.020
 2PE      C24    O25       single      1.426    0.020
 2PE      H241   C24       single      1.092    0.020
 2PE      H242   C24       single      1.092    0.020
 2PE      O25    C26       single      1.426    0.020
 2PE      C26    C27       single      1.524    0.020
 2PE      H261   C26       single      1.092    0.020
 2PE      H262   C26       single      1.092    0.020
 2PE      C27    O28       single      1.432    0.020
 2PE      H271   C27       single      1.092    0.020
 2PE      H272   C27       single      1.092    0.020
 2PE      HO2    O28       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 2PE      HO2    O28    C27     109.470    3.000
 2PE      O28    C27    H271    109.470    3.000
 2PE      O28    C27    H272    109.470    3.000
 2PE      O28    C27    C26     109.470    3.000
 2PE      H271   C27    H272    107.900    3.000
 2PE      H271   C27    C26     109.470    3.000
 2PE      H272   C27    C26     109.470    3.000
 2PE      C27    C26    H261    109.470    3.000
 2PE      C27    C26    H262    109.470    3.000
 2PE      C27    C26    O25     109.470    3.000
 2PE      H261   C26    H262    107.900    3.000
 2PE      H261   C26    O25     109.470    3.000
 2PE      H262   C26    O25     109.470    3.000
 2PE      C26    O25    C24     111.800    3.000
 2PE      O25    C24    H241    109.470    3.000
 2PE      O25    C24    H242    109.470    3.000
 2PE      O25    C24    C23     109.470    3.000
 2PE      H241   C24    H242    107.900    3.000
 2PE      H241   C24    C23     109.470    3.000
 2PE      H242   C24    C23     109.470    3.000
 2PE      C24    C23    H231    109.470    3.000
 2PE      C24    C23    H232    109.470    3.000
 2PE      C24    C23    O22     109.470    3.000
 2PE      H231   C23    H232    107.900    3.000
 2PE      H231   C23    O22     109.470    3.000
 2PE      H232   C23    O22     109.470    3.000
 2PE      C23    O22    C21     111.800    3.000
 2PE      O22    C21    H211    109.470    3.000
 2PE      O22    C21    H212    109.470    3.000
 2PE      O22    C21    C20     109.470    3.000
 2PE      H211   C21    H212    107.900    3.000
 2PE      H211   C21    C20     109.470    3.000
 2PE      H212   C21    C20     109.470    3.000
 2PE      C21    C20    H201    109.470    3.000
 2PE      C21    C20    H202    109.470    3.000
 2PE      C21    C20    O19     109.470    3.000
 2PE      H201   C20    H202    107.900    3.000
 2PE      H201   C20    O19     109.470    3.000
 2PE      H202   C20    O19     109.470    3.000
 2PE      C20    O19    C18     111.800    3.000
 2PE      O19    C18    H181    109.470    3.000
 2PE      O19    C18    H182    109.470    3.000
 2PE      O19    C18    C17     109.470    3.000
 2PE      H181   C18    H182    107.900    3.000
 2PE      H181   C18    C17     109.470    3.000
 2PE      H182   C18    C17     109.470    3.000
 2PE      C18    C17    H171    109.470    3.000
 2PE      C18    C17    H172    109.470    3.000
 2PE      C18    C17    O16     109.470    3.000
 2PE      H171   C17    H172    107.900    3.000
 2PE      H171   C17    O16     109.470    3.000
 2PE      H172   C17    O16     109.470    3.000
 2PE      C17    O16    C15     111.800    3.000
 2PE      O16    C15    H151    109.470    3.000
 2PE      O16    C15    H152    109.470    3.000
 2PE      O16    C15    C14     109.470    3.000
 2PE      H151   C15    H152    107.900    3.000
 2PE      H151   C15    C14     109.470    3.000
 2PE      H152   C15    C14     109.470    3.000
 2PE      C15    C14    H141    109.470    3.000
 2PE      C15    C14    H142    109.470    3.000
 2PE      C15    C14    O13     109.470    3.000
 2PE      H141   C14    H142    107.900    3.000
 2PE      H141   C14    O13     109.470    3.000
 2PE      H142   C14    O13     109.470    3.000
 2PE      C14    O13    C12     111.800    3.000
 2PE      O13    C12    H121    109.470    3.000
 2PE      O13    C12    H122    109.470    3.000
 2PE      O13    C12    C11     109.470    3.000
 2PE      H121   C12    H122    107.900    3.000
 2PE      H121   C12    C11     109.470    3.000
 2PE      H122   C12    C11     109.470    3.000
 2PE      C12    C11    H111    109.470    3.000
 2PE      C12    C11    H112    109.470    3.000
 2PE      C12    C11    O10     109.470    3.000
 2PE      H111   C11    H112    107.900    3.000
 2PE      H111   C11    O10     109.470    3.000
 2PE      H112   C11    O10     109.470    3.000
 2PE      C11    O10    C9      111.800    3.000
 2PE      O10    C9     H91     109.470    3.000
 2PE      O10    C9     H92     109.470    3.000
 2PE      O10    C9     C8      109.470    3.000
 2PE      H91    C9     H92     107.900    3.000
 2PE      H91    C9     C8      109.470    3.000
 2PE      H92    C9     C8      109.470    3.000
 2PE      C9     C8     H81     109.470    3.000
 2PE      C9     C8     H82     109.470    3.000
 2PE      C9     C8     O7      109.470    3.000
 2PE      H81    C8     H82     107.900    3.000
 2PE      H81    C8     O7      109.470    3.000
 2PE      H82    C8     O7      109.470    3.000
 2PE      C8     O7     C6      111.800    3.000
 2PE      O7     C6     H61     109.470    3.000
 2PE      O7     C6     H62     109.470    3.000
 2PE      O7     C6     C5      109.470    3.000
 2PE      H61    C6     H62     107.900    3.000
 2PE      H61    C6     C5      109.470    3.000
 2PE      H62    C6     C5      109.470    3.000
 2PE      C6     C5     H51     109.470    3.000
 2PE      C6     C5     H52     109.470    3.000
 2PE      C6     C5     O4      109.470    3.000
 2PE      H51    C5     H52     107.900    3.000
 2PE      H51    C5     O4      109.470    3.000
 2PE      H52    C5     O4      109.470    3.000
 2PE      C5     O4     C3      111.800    3.000
 2PE      O4     C3     H31     109.470    3.000
 2PE      O4     C3     H32     109.470    3.000
 2PE      O4     C3     C2      109.470    3.000
 2PE      H31    C3     H32     107.900    3.000
 2PE      H31    C3     C2      109.470    3.000
 2PE      H32    C3     C2      109.470    3.000
 2PE      C3     C2     H21     109.470    3.000
 2PE      C3     C2     H22     109.470    3.000
 2PE      C3     C2     O1      109.470    3.000
 2PE      H21    C2     H22     107.900    3.000
 2PE      H21    C2     O1      109.470    3.000
 2PE      H22    C2     O1      109.470    3.000
 2PE      C2     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 2PE      var_1    HO2    O28    C27    C26     -179.964   20.000   1
 2PE      var_2    O28    C27    C26    O25       60.014   20.000   3
 2PE      var_3    C27    C26    O25    C24      179.999   20.000   1
 2PE      var_4    C26    O25    C24    C23     -179.995   20.000   1
 2PE      var_5    O25    C24    C23    O22       60.025   20.000   3
 2PE      var_6    C24    C23    O22    C21     -179.950   20.000   1
 2PE      var_7    C23    O22    C21    C20      179.992   20.000   1
 2PE      var_8    O22    C21    C20    O19       59.962   20.000   3
 2PE      var_9    C21    C20    O19    C18     -179.991   20.000   1
 2PE      var_10   C20    O19    C18    C17     -179.986   20.000   1
 2PE      var_11   O19    C18    C17    O16       59.977   20.000   3
 2PE      var_12   C18    C17    O16    C15      179.997   20.000   1
 2PE      var_13   C17    O16    C15    C14      179.997   20.000   1
 2PE      var_14   O16    C15    C14    O13       60.006   20.000   3
 2PE      var_15   C15    C14    O13    C12     -179.981   20.000   1
 2PE      var_16   C14    O13    C12    C11     -179.982   20.000   1
 2PE      var_17   O13    C12    C11    O10       59.991   20.000   3
 2PE      var_18   C12    C11    O10    C9      -179.983   20.000   1
 2PE      var_19   C11    O10    C9     C8      -179.989   20.000   1
 2PE      var_20   O10    C9     C8     O7        59.981   20.000   3
 2PE      var_21   C9     C8     O7     C6       179.995   20.000   1
 2PE      var_22   C8     O7     C6     C5      -179.993   20.000   1
 2PE      var_23   O7     C6     C5     O4        59.986   20.000   3
 2PE      var_24   C6     C5     O4     C3      -179.990   20.000   1
 2PE      var_25   C5     O4     C3     C2      -179.957   20.000   1
 2PE      var_26   O4     C3     C2     O1        60.017   20.000   3
 2PE      var_27   C3     C2     O1     HO1     -179.995   20.000   1
# ------------------------------------------------------
`.trim();

monomers["7PE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
7PE      7PE '2-(2-(2-(2-(2-(2-ETHOXYETHOXY)ETHOXY' non-polymer        51  21 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_7PE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 7PE           O1     O    OH1       0.000      0.000    0.000    0.000
 7PE           HO1    H    H         0.000      0.664   -0.150    0.686
 7PE           C2     C    CH2       0.000     -0.791    1.138    0.346
 7PE           H21    H    H         0.000     -0.148    2.016    0.431
 7PE           H22    H    H         0.000     -1.288    0.959    1.302
 7PE           C3     C    CH2       0.000     -1.843    1.377   -0.740
 7PE           H31    H    H         0.000     -1.349    1.470   -1.710
 7PE           H32    H    H         0.000     -2.388    2.298   -0.522
 7PE           O4     O    O2        0.000     -2.754    0.279   -0.771
 7PE           C5     C    CH2       0.000     -3.706    0.560   -1.799
 7PE           H51    H    H         0.000     -3.189    0.663   -2.755
 7PE           H52    H    H         0.000     -4.228    1.491   -1.567
 7PE           C6     C    CH2       0.000     -4.718   -0.585   -1.885
 7PE           H61    H    H         0.000     -4.187   -1.529   -2.030
 7PE           H62    H    H         0.000     -5.390   -0.414   -2.729
 7PE           O7     O    O2        0.000     -5.475   -0.643   -0.675
 7PE           C8     C    CH2       0.000     -6.396   -1.727   -0.816
 7PE           H81    H    H         0.000     -5.844   -2.655   -0.975
 7PE           H82    H    H         0.000     -7.047   -1.541   -1.674
 7PE           C9     C    CH2       0.000     -7.243   -1.845    0.453
 7PE           H91    H    H         0.000     -6.586   -1.943    1.320
 7PE           H92    H    H         0.000     -7.884   -2.726    0.381
 7PE           O10    O    O2        0.000     -8.052   -0.676    0.596
 7PE           C11    C    CH2       0.000     -8.815   -0.847    1.793
 7PE           H111   H    H         0.000     -8.138   -0.958    2.642
 7PE           H112   H    H         0.000     -9.436   -1.741    1.703
 7PE           C12    C    CH2       0.000     -9.708    0.377    2.006
 7PE           H121   H    H         0.000     -9.094    1.280    2.006
 7PE           H122   H    H         0.000    -10.223    0.289    2.965
 7PE           O13    O    O2        0.000    -10.670    0.454    0.952
 7PE           C14    C    CH2       0.000    -11.470    1.611    1.207
 7PE           H141   H    H         0.000    -10.833    2.498    1.219
 7PE           H142   H    H         0.000    -11.962    1.506    2.176
 7PE           C15    C    CH2       0.000    -12.526    1.753    0.109
 7PE           H151   H    H         0.000    -12.035    1.769   -0.867
 7PE           H152   H    H         0.000    -13.077    2.685    0.253
 7PE           O16    O    O2        0.000    -13.429    0.649    0.172
 7PE           C17    C    CH2       0.000    -14.386    0.838   -0.873
 7PE           H171   H    H         0.000    -13.872    0.867   -1.836
 7PE           H172   H    H         0.000    -14.915    1.781   -0.715
 7PE           C18    C    CH2       0.000    -15.388   -0.318   -0.862
 7PE           H181   H    H         0.000    -14.851   -1.266   -0.931
 7PE           H182   H    H         0.000    -16.064   -0.221   -1.715
 7PE           O19    O    O2        0.000    -16.142   -0.283    0.352
 7PE           C20    C    CH2       0.000    -17.056   -1.381    0.303
 7PE           H201   H    H         0.000    -16.497   -2.315    0.219
 7PE           H202   H    H         0.000    -17.710   -1.271   -0.565
 7PE           C21    C    CH3       0.000    -17.898   -1.401    1.579
 7PE           H213   H    H         0.000    -17.265   -1.507    2.423
 7PE           H212   H    H         0.000    -18.442   -0.495    1.662
 7PE           H211   H    H         0.000    -18.577   -2.215    1.546
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 7PE      O1     n/a    C2     START
 7PE      HO1    O1     .      .
 7PE      C2     O1     C3     .
 7PE      H21    C2     .      .
 7PE      H22    C2     .      .
 7PE      C3     C2     O4     .
 7PE      H31    C3     .      .
 7PE      H32    C3     .      .
 7PE      O4     C3     C5     .
 7PE      C5     O4     C6     .
 7PE      H51    C5     .      .
 7PE      H52    C5     .      .
 7PE      C6     C5     O7     .
 7PE      H61    C6     .      .
 7PE      H62    C6     .      .
 7PE      O7     C6     C8     .
 7PE      C8     O7     C9     .
 7PE      H81    C8     .      .
 7PE      H82    C8     .      .
 7PE      C9     C8     O10    .
 7PE      H91    C9     .      .
 7PE      H92    C9     .      .
 7PE      O10    C9     C11    .
 7PE      C11    O10    C12    .
 7PE      H111   C11    .      .
 7PE      H112   C11    .      .
 7PE      C12    C11    O13    .
 7PE      H121   C12    .      .
 7PE      H122   C12    .      .
 7PE      O13    C12    C14    .
 7PE      C14    O13    C15    .
 7PE      H141   C14    .      .
 7PE      H142   C14    .      .
 7PE      C15    C14    O16    .
 7PE      H151   C15    .      .
 7PE      H152   C15    .      .
 7PE      O16    C15    C17    .
 7PE      C17    O16    C18    .
 7PE      H171   C17    .      .
 7PE      H172   C17    .      .
 7PE      C18    C17    O19    .
 7PE      H181   C18    .      .
 7PE      H182   C18    .      .
 7PE      O19    C18    C20    .
 7PE      C20    O19    C21    .
 7PE      H201   C20    .      .
 7PE      H202   C20    .      .
 7PE      C21    C20    H211   .
 7PE      H213   C21    .      .
 7PE      H212   C21    .      .
 7PE      H211   C21    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 7PE      C21    C20       single      1.513    0.020
 7PE      H211   C21       single      1.059    0.020
 7PE      H212   C21       single      1.059    0.020
 7PE      H213   C21       single      1.059    0.020
 7PE      C20    O19       single      1.426    0.020
 7PE      H201   C20       single      1.092    0.020
 7PE      H202   C20       single      1.092    0.020
 7PE      O19    C18       single      1.426    0.020
 7PE      C18    C17       single      1.524    0.020
 7PE      H181   C18       single      1.092    0.020
 7PE      H182   C18       single      1.092    0.020
 7PE      C17    O16       single      1.426    0.020
 7PE      H171   C17       single      1.092    0.020
 7PE      H172   C17       single      1.092    0.020
 7PE      O16    C15       single      1.426    0.020
 7PE      C15    C14       single      1.524    0.020
 7PE      H151   C15       single      1.092    0.020
 7PE      H152   C15       single      1.092    0.020
 7PE      C14    O13       single      1.426    0.020
 7PE      H141   C14       single      1.092    0.020
 7PE      H142   C14       single      1.092    0.020
 7PE      O13    C12       single      1.426    0.020
 7PE      C12    C11       single      1.524    0.020
 7PE      H121   C12       single      1.092    0.020
 7PE      H122   C12       single      1.092    0.020
 7PE      C11    O10       single      1.426    0.020
 7PE      H111   C11       single      1.092    0.020
 7PE      H112   C11       single      1.092    0.020
 7PE      O10    C9        single      1.426    0.020
 7PE      C9     C8        single      1.524    0.020
 7PE      H91    C9        single      1.092    0.020
 7PE      H92    C9        single      1.092    0.020
 7PE      C8     O7        single      1.426    0.020
 7PE      H81    C8        single      1.092    0.020
 7PE      H82    C8        single      1.092    0.020
 7PE      O7     C6        single      1.426    0.020
 7PE      C6     C5        single      1.524    0.020
 7PE      H61    C6        single      1.092    0.020
 7PE      H62    C6        single      1.092    0.020
 7PE      C5     O4        single      1.426    0.020
 7PE      H51    C5        single      1.092    0.020
 7PE      H52    C5        single      1.092    0.020
 7PE      O4     C3        single      1.426    0.020
 7PE      C3     C2        single      1.524    0.020
 7PE      H31    C3        single      1.092    0.020
 7PE      H32    C3        single      1.092    0.020
 7PE      C2     O1        single      1.432    0.020
 7PE      H21    C2        single      1.092    0.020
 7PE      H22    C2        single      1.092    0.020
 7PE      HO1    O1        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 7PE      HO1    O1     C2      109.470    3.000
 7PE      O1     C2     H21     109.470    3.000
 7PE      O1     C2     H22     109.470    3.000
 7PE      O1     C2     C3      109.470    3.000
 7PE      H21    C2     H22     107.900    3.000
 7PE      H21    C2     C3      109.470    3.000
 7PE      H22    C2     C3      109.470    3.000
 7PE      C2     C3     H31     109.470    3.000
 7PE      C2     C3     H32     109.470    3.000
 7PE      C2     C3     O4      109.470    3.000
 7PE      H31    C3     H32     107.900    3.000
 7PE      H31    C3     O4      109.470    3.000
 7PE      H32    C3     O4      109.470    3.000
 7PE      C3     O4     C5      111.800    3.000
 7PE      O4     C5     H51     109.470    3.000
 7PE      O4     C5     H52     109.470    3.000
 7PE      O4     C5     C6      109.470    3.000
 7PE      H51    C5     H52     107.900    3.000
 7PE      H51    C5     C6      109.470    3.000
 7PE      H52    C5     C6      109.470    3.000
 7PE      C5     C6     H61     109.470    3.000
 7PE      C5     C6     H62     109.470    3.000
 7PE      C5     C6     O7      109.470    3.000
 7PE      H61    C6     H62     107.900    3.000
 7PE      H61    C6     O7      109.470    3.000
 7PE      H62    C6     O7      109.470    3.000
 7PE      C6     O7     C8      111.800    3.000
 7PE      O7     C8     H81     109.470    3.000
 7PE      O7     C8     H82     109.470    3.000
 7PE      O7     C8     C9      109.470    3.000
 7PE      H81    C8     H82     107.900    3.000
 7PE      H81    C8     C9      109.470    3.000
 7PE      H82    C8     C9      109.470    3.000
 7PE      C8     C9     H91     109.470    3.000
 7PE      C8     C9     H92     109.470    3.000
 7PE      C8     C9     O10     109.470    3.000
 7PE      H91    C9     H92     107.900    3.000
 7PE      H91    C9     O10     109.470    3.000
 7PE      H92    C9     O10     109.470    3.000
 7PE      C9     O10    C11     111.800    3.000
 7PE      O10    C11    H111    109.470    3.000
 7PE      O10    C11    H112    109.470    3.000
 7PE      O10    C11    C12     109.470    3.000
 7PE      H111   C11    H112    107.900    3.000
 7PE      H111   C11    C12     109.470    3.000
 7PE      H112   C11    C12     109.470    3.000
 7PE      C11    C12    H121    109.470    3.000
 7PE      C11    C12    H122    109.470    3.000
 7PE      C11    C12    O13     109.470    3.000
 7PE      H121   C12    H122    107.900    3.000
 7PE      H121   C12    O13     109.470    3.000
 7PE      H122   C12    O13     109.470    3.000
 7PE      C12    O13    C14     111.800    3.000
 7PE      O13    C14    H141    109.470    3.000
 7PE      O13    C14    H142    109.470    3.000
 7PE      O13    C14    C15     109.470    3.000
 7PE      H141   C14    H142    107.900    3.000
 7PE      H141   C14    C15     109.470    3.000
 7PE      H142   C14    C15     109.470    3.000
 7PE      C14    C15    H151    109.470    3.000
 7PE      C14    C15    H152    109.470    3.000
 7PE      C14    C15    O16     109.470    3.000
 7PE      H151   C15    H152    107.900    3.000
 7PE      H151   C15    O16     109.470    3.000
 7PE      H152   C15    O16     109.470    3.000
 7PE      C15    O16    C17     111.800    3.000
 7PE      O16    C17    H171    109.470    3.000
 7PE      O16    C17    H172    109.470    3.000
 7PE      O16    C17    C18     109.470    3.000
 7PE      H171   C17    H172    107.900    3.000
 7PE      H171   C17    C18     109.470    3.000
 7PE      H172   C17    C18     109.470    3.000
 7PE      C17    C18    H181    109.470    3.000
 7PE      C17    C18    H182    109.470    3.000
 7PE      C17    C18    O19     109.470    3.000
 7PE      H181   C18    H182    107.900    3.000
 7PE      H181   C18    O19     109.470    3.000
 7PE      H182   C18    O19     109.470    3.000
 7PE      C18    O19    C20     111.800    3.000
 7PE      O19    C20    H201    109.470    3.000
 7PE      O19    C20    H202    109.470    3.000
 7PE      O19    C20    C21     109.470    3.000
 7PE      H201   C20    H202    107.900    3.000
 7PE      H201   C20    C21     109.470    3.000
 7PE      H202   C20    C21     109.470    3.000
 7PE      C20    C21    H213    109.470    3.000
 7PE      C20    C21    H212    109.470    3.000
 7PE      C20    C21    H211    109.470    3.000
 7PE      H213   C21    H212    109.470    3.000
 7PE      H213   C21    H211    109.470    3.000
 7PE      H212   C21    H211    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 7PE      var_1    HO1    O1     C2     C3       179.954   20.000   1
 7PE      var_2    O1     C2     C3     O4        64.983   20.000   3
 7PE      var_3    C2     C3     O4     C5       179.977   20.000   1
 7PE      var_4    C3     O4     C5     C6       179.999   20.000   1
 7PE      var_5    O4     C5     C6     O7        65.033   20.000   3
 7PE      var_6    C5     C6     O7     C8      -179.991   20.000   1
 7PE      var_7    C6     O7     C8     C9       179.984   20.000   1
 7PE      var_8    O7     C8     C9     O10       64.971   20.000   3
 7PE      var_9    C8     C9     O10    C11      179.981   20.000   1
 7PE      var_10   C9     O10    C11    C12     -179.999   20.000   1
 7PE      var_11   O10    C11    C12    O13       65.035   20.000   3
 7PE      var_12   C11    C12    O13    C14      179.986   20.000   1
 7PE      var_13   C12    O13    C14    C15      179.970   20.000   1
 7PE      var_14   O13    C14    C15    O16       65.039   20.000   3
 7PE      var_15   C14    C15    O16    C17      179.977   20.000   1
 7PE      var_16   C15    O16    C17    C18      179.938   20.000   1
 7PE      var_17   O16    C17    C18    O19       65.022   20.000   3
 7PE      var_18   C17    C18    O19    C20      179.992   20.000   1
 7PE      var_19   C18    O19    C20    C21     -179.969   20.000   1
 7PE      var_20   O19    C20    C21    H211    -179.952   20.000   3
# ------------------------------------------------------
`.trim();

monomers["PE3"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PE3      PE3 '3,6,9,12,15,18,21,24,27,30,33,36,39-' non-polymer       101  43 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PE3
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PE3           O1     O    OH1       0.000      0.000    0.000    0.000
 PE3           HO1    H    H         0.000      0.628   -0.315   -0.664
 PE3           C2     C    CH2       0.000     -0.831   -1.083    0.419
 PE3           H21    H    H         0.000     -0.211   -1.872    0.849
 PE3           H22    H    H         0.000     -1.375   -1.478   -0.441
 PE3           C3     C    CH2       0.000     -1.827   -0.585    1.470
 PE3           H31    H    H         0.000     -1.283   -0.111    2.290
 PE3           H32    H    H         0.000     -2.401   -1.430    1.855
 PE3           O4     O    O2        0.000     -2.713    0.363    0.874
 PE3           C5     C    CH2       0.000     -3.613    0.789    1.900
 PE3           H51    H    H         0.000     -3.046    1.245    2.714
 PE3           H52    H    H         0.000     -4.165   -0.073    2.280
 PE3           C6     C    CH2       0.000     -4.595    1.812    1.324
 PE3           H61    H    H         0.000     -4.039    2.632    0.866
 PE3           H62    H    H         0.000     -5.224    2.204    2.127
 PE3           O7     O    O2        0.000     -5.416    1.181    0.339
 PE3           C8     C    CH2       0.000     -6.307    2.183   -0.157
 PE3           H81    H    H         0.000     -5.729    2.999   -0.596
 PE3           H82    H    H         0.000     -6.913    2.569    0.665
 PE3           C9     C    CH2       0.000     -7.219    1.571   -1.222
 PE3           H91    H    H         0.000     -6.609    1.107   -2.000
 PE3           H92    H    H         0.000     -7.838    2.354   -1.665
 PE3           O10    O    O2        0.000     -8.058    0.583   -0.621
 PE3           C11    C    CH2       0.000     -8.881    0.051   -1.661
 PE3           H111   H    H         0.000     -8.250   -0.393   -2.433
 PE3           H112   H    H         0.000     -9.478    0.855   -2.097
 PE3           C12    C    CH2       0.000     -9.809   -1.018   -1.081
 PE3           H121   H    H         0.000     -9.214   -1.777   -0.568
 PE3           H122   H    H         0.000    -10.374   -1.487   -1.890
 PE3           O13    O    O2        0.000    -10.713   -0.413   -0.154
 PE3           C14    C    CH2       0.000    -11.549   -1.457    0.350
 PE3           H141   H    H         0.000    -10.931   -2.209    0.845
 PE3           H142   H    H         0.000    -12.091   -1.920   -0.477
 PE3           C15    C    CH2       0.000    -12.546   -0.873    1.352
 PE3           H151   H    H         0.000    -12.003   -0.334    2.132
 PE3           H152   H    H         0.000    -13.122   -1.682    1.804
 PE3           O16    O    O2        0.000    -13.429    0.025    0.679
 PE3           C17    C    CH2       0.000    -14.331    0.534    1.663
 PE3           H171   H    H         0.000    -13.765    1.055    2.438
 PE3           H172   H    H         0.000    -14.885   -0.293    2.111
 PE3           C18    C    CH2       0.000    -15.310    1.508    1.003
 PE3           H181   H    H         0.000    -14.751    2.288    0.481
 PE3           H182   H    H         0.000    -15.940    1.964    1.769
 PE3           O19    O    O2        0.000    -16.128    0.801    0.070
 PE3           C20    C    CH2       0.000    -17.016    1.759   -0.510
 PE3           H201   H    H         0.000    -16.436    2.535   -1.013
 PE3           H202   H    H         0.000    -17.625    2.213    0.275
 PE3           C21    C    CH2       0.000    -17.926    1.063   -1.524
 PE3           H211   H    H         0.000    -17.314    0.536   -2.260
 PE3           H212   H    H         0.000    -18.542    1.809   -2.032
 PE3           O22    O    O2        0.000    -18.769    0.129   -0.846
 PE3           C23    C    CH2       0.000    -19.590   -0.485   -1.842
 PE3           H231   H    H         0.000    -18.957   -0.992   -2.573
 PE3           H232   H    H         0.000    -20.184    0.280   -2.345
 PE3           C24    C    CH2       0.000    -20.521   -1.502   -1.178
 PE3           H241   H    H         0.000    -19.928   -2.216   -0.602
 PE3           H242   H    H         0.000    -21.084   -2.035   -1.947
 PE3           O25    O    O2        0.000    -21.427   -0.820   -0.307
 PE3           C26    C    CH2       0.000    -22.265   -1.818    0.279
 PE3           H261   H    H         0.000    -21.650   -2.528    0.836
 PE3           H262   H    H         0.000    -22.806   -2.348   -0.509
 PE3           C27    C    CH2       0.000    -23.265   -1.153    1.227
 PE3           H271   H    H         0.000    -22.724   -0.553    1.962
 PE3           H272   H    H         0.000    -23.844   -1.921    1.742
 PE3           O28    O    O2        0.000    -24.144   -0.312    0.479
 PE3           C29    C    CH2       0.000    -25.048    0.278    1.415
 PE3           H291   H    H         0.000    -24.484    0.859    2.147
 PE3           H292   H    H         0.000    -25.605   -0.510    1.927
 PE3           C30    C    CH2       0.000    -26.023    1.195    0.674
 PE3           H301   H    H         0.000    -25.461    1.928    0.091
 PE3           H302   H    H         0.000    -26.654    1.715    1.398
 PE3           O31    O    O2        0.000    -26.841    0.415   -0.200
 PE3           C32    C    CH2       0.000    -27.725    1.324   -0.860
 PE3           H321   H    H         0.000    -27.141    2.054   -1.424
 PE3           H322   H    H         0.000    -28.334    1.842   -0.117
 PE3           C33    C    CH2       0.000    -28.633    0.548   -1.816
 PE3           H331   H    H         0.000    -28.020   -0.039   -2.504
 PE3           H332   H    H         0.000    -29.245    1.250   -2.386
 PE3           O34    O    O2        0.000    -29.480   -0.326   -1.066
 PE3           C35    C    CH2       0.000    -30.298   -1.018   -2.010
 PE3           H351   H    H         0.000    -29.664   -1.584   -2.695
 PE3           H352   H    H         0.000    -30.890   -0.296   -2.576
 PE3           C36    C    CH2       0.000    -31.233   -1.976   -1.268
 PE3           H361   H    H         0.000    -30.644   -2.641   -0.634
 PE3           H362   H    H         0.000    -31.795   -2.569   -1.993
 PE3           O37    O    O2        0.000    -32.141   -1.224   -0.459
 PE3           C38    C    CH2       0.000    -32.983   -2.169    0.204
 PE3           H381   H    H         0.000    -32.371   -2.832    0.819
 PE3           H382   H    H         0.000    -33.522   -2.760   -0.539
 PE3           C39    C    CH2       0.000    -33.983   -1.426    1.091
 PE3           H391   H    H         0.000    -33.444   -0.769    1.776
 PE3           H392   H    H         0.000    -34.566   -2.149    1.666
 PE3           O40    O    O2        0.000    -34.860   -0.649    0.273
 PE3           C41    C    CH2       0.000    -35.765    0.018    1.155
 PE3           H411   H    H         0.000    -35.202    0.657    1.839
 PE3           H412   H    H         0.000    -36.325   -0.723    1.730
 PE3           C42    C    CH2       0.000    -36.737    0.873    0.338
 PE3           H421   H    H         0.000    -36.172    1.554   -0.301
 PE3           H422   H    H         0.000    -37.370    1.451    1.015
 PE3           O43    O    OH1       0.000    -37.553    0.024   -0.472
 PE3           H43    H    H         0.000    -38.166    0.565   -0.987
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PE3      O1     n/a    C2     START
 PE3      HO1    O1     .      .
 PE3      C2     O1     C3     .
 PE3      H21    C2     .      .
 PE3      H22    C2     .      .
 PE3      C3     C2     O4     .
 PE3      H31    C3     .      .
 PE3      H32    C3     .      .
 PE3      O4     C3     C5     .
 PE3      C5     O4     C6     .
 PE3      H51    C5     .      .
 PE3      H52    C5     .      .
 PE3      C6     C5     O7     .
 PE3      H61    C6     .      .
 PE3      H62    C6     .      .
 PE3      O7     C6     C8     .
 PE3      C8     O7     C9     .
 PE3      H81    C8     .      .
 PE3      H82    C8     .      .
 PE3      C9     C8     O10    .
 PE3      H91    C9     .      .
 PE3      H92    C9     .      .
 PE3      O10    C9     C11    .
 PE3      C11    O10    C12    .
 PE3      H111   C11    .      .
 PE3      H112   C11    .      .
 PE3      C12    C11    O13    .
 PE3      H121   C12    .      .
 PE3      H122   C12    .      .
 PE3      O13    C12    C14    .
 PE3      C14    O13    C15    .
 PE3      H141   C14    .      .
 PE3      H142   C14    .      .
 PE3      C15    C14    O16    .
 PE3      H151   C15    .      .
 PE3      H152   C15    .      .
 PE3      O16    C15    C17    .
 PE3      C17    O16    C18    .
 PE3      H171   C17    .      .
 PE3      H172   C17    .      .
 PE3      C18    C17    O19    .
 PE3      H181   C18    .      .
 PE3      H182   C18    .      .
 PE3      O19    C18    C20    .
 PE3      C20    O19    C21    .
 PE3      H201   C20    .      .
 PE3      H202   C20    .      .
 PE3      C21    C20    O22    .
 PE3      H211   C21    .      .
 PE3      H212   C21    .      .
 PE3      O22    C21    C23    .
 PE3      C23    O22    C24    .
 PE3      H231   C23    .      .
 PE3      H232   C23    .      .
 PE3      C24    C23    O25    .
 PE3      H241   C24    .      .
 PE3      H242   C24    .      .
 PE3      O25    C24    C26    .
 PE3      C26    O25    C27    .
 PE3      H261   C26    .      .
 PE3      H262   C26    .      .
 PE3      C27    C26    O28    .
 PE3      H271   C27    .      .
 PE3      H272   C27    .      .
 PE3      O28    C27    C29    .
 PE3      C29    O28    C30    .
 PE3      H291   C29    .      .
 PE3      H292   C29    .      .
 PE3      C30    C29    O31    .
 PE3      H301   C30    .      .
 PE3      H302   C30    .      .
 PE3      O31    C30    C32    .
 PE3      C32    O31    C33    .
 PE3      H321   C32    .      .
 PE3      H322   C32    .      .
 PE3      C33    C32    O34    .
 PE3      H331   C33    .      .
 PE3      H332   C33    .      .
 PE3      O34    C33    C35    .
 PE3      C35    O34    C36    .
 PE3      H351   C35    .      .
 PE3      H352   C35    .      .
 PE3      C36    C35    O37    .
 PE3      H361   C36    .      .
 PE3      H362   C36    .      .
 PE3      O37    C36    C38    .
 PE3      C38    O37    C39    .
 PE3      H381   C38    .      .
 PE3      H382   C38    .      .
 PE3      C39    C38    O40    .
 PE3      H391   C39    .      .
 PE3      H392   C39    .      .
 PE3      O40    C39    C41    .
 PE3      C41    O40    C42    .
 PE3      H411   C41    .      .
 PE3      H412   C41    .      .
 PE3      C42    C41    O43    .
 PE3      H421   C42    .      .
 PE3      H422   C42    .      .
 PE3      O43    C42    H43    .
 PE3      H43    O43    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PE3      O43    C42       single      1.432    0.020
 PE3      H43    O43       single      0.967    0.020
 PE3      C42    C41       single      1.524    0.020
 PE3      H421   C42       single      1.092    0.020
 PE3      H422   C42       single      1.092    0.020
 PE3      C41    O40       single      1.426    0.020
 PE3      H411   C41       single      1.092    0.020
 PE3      H412   C41       single      1.092    0.020
 PE3      O40    C39       single      1.426    0.020
 PE3      C39    C38       single      1.524    0.020
 PE3      H391   C39       single      1.092    0.020
 PE3      H392   C39       single      1.092    0.020
 PE3      C38    O37       single      1.426    0.020
 PE3      H381   C38       single      1.092    0.020
 PE3      H382   C38       single      1.092    0.020
 PE3      O37    C36       single      1.426    0.020
 PE3      C36    C35       single      1.524    0.020
 PE3      H361   C36       single      1.092    0.020
 PE3      H362   C36       single      1.092    0.020
 PE3      C35    O34       single      1.426    0.020
 PE3      H351   C35       single      1.092    0.020
 PE3      H352   C35       single      1.092    0.020
 PE3      O34    C33       single      1.426    0.020
 PE3      C33    C32       single      1.524    0.020
 PE3      H331   C33       single      1.092    0.020
 PE3      H332   C33       single      1.092    0.020
 PE3      C32    O31       single      1.426    0.020
 PE3      H321   C32       single      1.092    0.020
 PE3      H322   C32       single      1.092    0.020
 PE3      O31    C30       single      1.426    0.020
 PE3      C30    C29       single      1.524    0.020
 PE3      H301   C30       single      1.092    0.020
 PE3      H302   C30       single      1.092    0.020
 PE3      C29    O28       single      1.426    0.020
 PE3      H291   C29       single      1.092    0.020
 PE3      H292   C29       single      1.092    0.020
 PE3      O28    C27       single      1.426    0.020
 PE3      C27    C26       single      1.524    0.020
 PE3      H271   C27       single      1.092    0.020
 PE3      H272   C27       single      1.092    0.020
 PE3      C26    O25       single      1.426    0.020
 PE3      H261   C26       single      1.092    0.020
 PE3      H262   C26       single      1.092    0.020
 PE3      O25    C24       single      1.426    0.020
 PE3      C24    C23       single      1.524    0.020
 PE3      H241   C24       single      1.092    0.020
 PE3      H242   C24       single      1.092    0.020
 PE3      C23    O22       single      1.426    0.020
 PE3      H231   C23       single      1.092    0.020
 PE3      H232   C23       single      1.092    0.020
 PE3      O22    C21       single      1.426    0.020
 PE3      C21    C20       single      1.524    0.020
 PE3      H211   C21       single      1.092    0.020
 PE3      H212   C21       single      1.092    0.020
 PE3      C20    O19       single      1.426    0.020
 PE3      H201   C20       single      1.092    0.020
 PE3      H202   C20       single      1.092    0.020
 PE3      O19    C18       single      1.426    0.020
 PE3      C18    C17       single      1.524    0.020
 PE3      H181   C18       single      1.092    0.020
 PE3      H182   C18       single      1.092    0.020
 PE3      C17    O16       single      1.426    0.020
 PE3      H171   C17       single      1.092    0.020
 PE3      H172   C17       single      1.092    0.020
 PE3      O16    C15       single      1.426    0.020
 PE3      C15    C14       single      1.524    0.020
 PE3      H151   C15       single      1.092    0.020
 PE3      H152   C15       single      1.092    0.020
 PE3      C14    O13       single      1.426    0.020
 PE3      H141   C14       single      1.092    0.020
 PE3      H142   C14       single      1.092    0.020
 PE3      O13    C12       single      1.426    0.020
 PE3      C12    C11       single      1.524    0.020
 PE3      H121   C12       single      1.092    0.020
 PE3      H122   C12       single      1.092    0.020
 PE3      C11    O10       single      1.426    0.020
 PE3      H111   C11       single      1.092    0.020
 PE3      H112   C11       single      1.092    0.020
 PE3      O10    C9        single      1.426    0.020
 PE3      C9     C8        single      1.524    0.020
 PE3      H91    C9        single      1.092    0.020
 PE3      H92    C9        single      1.092    0.020
 PE3      C8     O7        single      1.426    0.020
 PE3      H81    C8        single      1.092    0.020
 PE3      H82    C8        single      1.092    0.020
 PE3      O7     C6        single      1.426    0.020
 PE3      C6     C5        single      1.524    0.020
 PE3      H61    C6        single      1.092    0.020
 PE3      H62    C6        single      1.092    0.020
 PE3      C5     O4        single      1.426    0.020
 PE3      H51    C5        single      1.092    0.020
 PE3      H52    C5        single      1.092    0.020
 PE3      O4     C3        single      1.426    0.020
 PE3      C3     C2        single      1.524    0.020
 PE3      H31    C3        single      1.092    0.020
 PE3      H32    C3        single      1.092    0.020
 PE3      C2     O1        single      1.432    0.020
 PE3      H21    C2        single      1.092    0.020
 PE3      H22    C2        single      1.092    0.020
 PE3      HO1    O1        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PE3      HO1    O1     C2      109.470    3.000
 PE3      O1     C2     H21     109.470    3.000
 PE3      O1     C2     H22     109.470    3.000
 PE3      O1     C2     C3      109.470    3.000
 PE3      H21    C2     H22     107.900    3.000
 PE3      H21    C2     C3      109.470    3.000
 PE3      H22    C2     C3      109.470    3.000
 PE3      C2     C3     H31     109.470    3.000
 PE3      C2     C3     H32     109.470    3.000
 PE3      C2     C3     O4      109.470    3.000
 PE3      H31    C3     H32     107.900    3.000
 PE3      H31    C3     O4      109.470    3.000
 PE3      H32    C3     O4      109.470    3.000
 PE3      C3     O4     C5      111.800    3.000
 PE3      O4     C5     H51     109.470    3.000
 PE3      O4     C5     H52     109.470    3.000
 PE3      O4     C5     C6      109.470    3.000
 PE3      H51    C5     H52     107.900    3.000
 PE3      H51    C5     C6      109.470    3.000
 PE3      H52    C5     C6      109.470    3.000
 PE3      C5     C6     H61     109.470    3.000
 PE3      C5     C6     H62     109.470    3.000
 PE3      C5     C6     O7      109.470    3.000
 PE3      H61    C6     H62     107.900    3.000
 PE3      H61    C6     O7      109.470    3.000
 PE3      H62    C6     O7      109.470    3.000
 PE3      C6     O7     C8      111.800    3.000
 PE3      O7     C8     H81     109.470    3.000
 PE3      O7     C8     H82     109.470    3.000
 PE3      O7     C8     C9      109.470    3.000
 PE3      H81    C8     H82     107.900    3.000
 PE3      H81    C8     C9      109.470    3.000
 PE3      H82    C8     C9      109.470    3.000
 PE3      C8     C9     H91     109.470    3.000
 PE3      C8     C9     H92     109.470    3.000
 PE3      C8     C9     O10     109.470    3.000
 PE3      H91    C9     H92     107.900    3.000
 PE3      H91    C9     O10     109.470    3.000
 PE3      H92    C9     O10     109.470    3.000
 PE3      C9     O10    C11     111.800    3.000
 PE3      O10    C11    H111    109.470    3.000
 PE3      O10    C11    H112    109.470    3.000
 PE3      O10    C11    C12     109.470    3.000
 PE3      H111   C11    H112    107.900    3.000
 PE3      H111   C11    C12     109.470    3.000
 PE3      H112   C11    C12     109.470    3.000
 PE3      C11    C12    H121    109.470    3.000
 PE3      C11    C12    H122    109.470    3.000
 PE3      C11    C12    O13     109.470    3.000
 PE3      H121   C12    H122    107.900    3.000
 PE3      H121   C12    O13     109.470    3.000
 PE3      H122   C12    O13     109.470    3.000
 PE3      C12    O13    C14     111.800    3.000
 PE3      O13    C14    H141    109.470    3.000
 PE3      O13    C14    H142    109.470    3.000
 PE3      O13    C14    C15     109.470    3.000
 PE3      H141   C14    H142    107.900    3.000
 PE3      H141   C14    C15     109.470    3.000
 PE3      H142   C14    C15     109.470    3.000
 PE3      C14    C15    H151    109.470    3.000
 PE3      C14    C15    H152    109.470    3.000
 PE3      C14    C15    O16     109.470    3.000
 PE3      H151   C15    H152    107.900    3.000
 PE3      H151   C15    O16     109.470    3.000
 PE3      H152   C15    O16     109.470    3.000
 PE3      C15    O16    C17     111.800    3.000
 PE3      O16    C17    H171    109.470    3.000
 PE3      O16    C17    H172    109.470    3.000
 PE3      O16    C17    C18     109.470    3.000
 PE3      H171   C17    H172    107.900    3.000
 PE3      H171   C17    C18     109.470    3.000
 PE3      H172   C17    C18     109.470    3.000
 PE3      C17    C18    H181    109.470    3.000
 PE3      C17    C18    H182    109.470    3.000
 PE3      C17    C18    O19     109.470    3.000
 PE3      H181   C18    H182    107.900    3.000
 PE3      H181   C18    O19     109.470    3.000
 PE3      H182   C18    O19     109.470    3.000
 PE3      C18    O19    C20     111.800    3.000
 PE3      O19    C20    H201    109.470    3.000
 PE3      O19    C20    H202    109.470    3.000
 PE3      O19    C20    C21     109.470    3.000
 PE3      H201   C20    H202    107.900    3.000
 PE3      H201   C20    C21     109.470    3.000
 PE3      H202   C20    C21     109.470    3.000
 PE3      C20    C21    H211    109.470    3.000
 PE3      C20    C21    H212    109.470    3.000
 PE3      C20    C21    O22     109.470    3.000
 PE3      H211   C21    H212    107.900    3.000
 PE3      H211   C21    O22     109.470    3.000
 PE3      H212   C21    O22     109.470    3.000
 PE3      C21    O22    C23     111.800    3.000
 PE3      O22    C23    H231    109.470    3.000
 PE3      O22    C23    H232    109.470    3.000
 PE3      O22    C23    C24     109.470    3.000
 PE3      H231   C23    H232    107.900    3.000
 PE3      H231   C23    C24     109.470    3.000
 PE3      H232   C23    C24     109.470    3.000
 PE3      C23    C24    H241    109.470    3.000
 PE3      C23    C24    H242    109.470    3.000
 PE3      C23    C24    O25     109.470    3.000
 PE3      H241   C24    H242    107.900    3.000
 PE3      H241   C24    O25     109.470    3.000
 PE3      H242   C24    O25     109.470    3.000
 PE3      C24    O25    C26     111.800    3.000
 PE3      O25    C26    H261    109.470    3.000
 PE3      O25    C26    H262    109.470    3.000
 PE3      O25    C26    C27     109.470    3.000
 PE3      H261   C26    H262    107.900    3.000
 PE3      H261   C26    C27     109.470    3.000
 PE3      H262   C26    C27     109.470    3.000
 PE3      C26    C27    H271    109.470    3.000
 PE3      C26    C27    H272    109.470    3.000
 PE3      C26    C27    O28     109.470    3.000
 PE3      H271   C27    H272    107.900    3.000
 PE3      H271   C27    O28     109.470    3.000
 PE3      H272   C27    O28     109.470    3.000
 PE3      C27    O28    C29     111.800    3.000
 PE3      O28    C29    H291    109.470    3.000
 PE3      O28    C29    H292    109.470    3.000
 PE3      O28    C29    C30     109.470    3.000
 PE3      H291   C29    H292    107.900    3.000
 PE3      H291   C29    C30     109.470    3.000
 PE3      H292   C29    C30     109.470    3.000
 PE3      C29    C30    H301    109.470    3.000
 PE3      C29    C30    H302    109.470    3.000
 PE3      C29    C30    O31     109.470    3.000
 PE3      H301   C30    H302    107.900    3.000
 PE3      H301   C30    O31     109.470    3.000
 PE3      H302   C30    O31     109.470    3.000
 PE3      C30    O31    C32     111.800    3.000
 PE3      O31    C32    H321    109.470    3.000
 PE3      O31    C32    H322    109.470    3.000
 PE3      O31    C32    C33     109.470    3.000
 PE3      H321   C32    H322    107.900    3.000
 PE3      H321   C32    C33     109.470    3.000
 PE3      H322   C32    C33     109.470    3.000
 PE3      C32    C33    H331    109.470    3.000
 PE3      C32    C33    H332    109.470    3.000
 PE3      C32    C33    O34     109.470    3.000
 PE3      H331   C33    H332    107.900    3.000
 PE3      H331   C33    O34     109.470    3.000
 PE3      H332   C33    O34     109.470    3.000
 PE3      C33    O34    C35     111.800    3.000
 PE3      O34    C35    H351    109.470    3.000
 PE3      O34    C35    H352    109.470    3.000
 PE3      O34    C35    C36     109.470    3.000
 PE3      H351   C35    H352    107.900    3.000
 PE3      H351   C35    C36     109.470    3.000
 PE3      H352   C35    C36     109.470    3.000
 PE3      C35    C36    H361    109.470    3.000
 PE3      C35    C36    H362    109.470    3.000
 PE3      C35    C36    O37     109.470    3.000
 PE3      H361   C36    H362    107.900    3.000
 PE3      H361   C36    O37     109.470    3.000
 PE3      H362   C36    O37     109.470    3.000
 PE3      C36    O37    C38     111.800    3.000
 PE3      O37    C38    H381    109.470    3.000
 PE3      O37    C38    H382    109.470    3.000
 PE3      O37    C38    C39     109.470    3.000
 PE3      H381   C38    H382    107.900    3.000
 PE3      H381   C38    C39     109.470    3.000
 PE3      H382   C38    C39     109.470    3.000
 PE3      C38    C39    H391    109.470    3.000
 PE3      C38    C39    H392    109.470    3.000
 PE3      C38    C39    O40     109.470    3.000
 PE3      H391   C39    H392    107.900    3.000
 PE3      H391   C39    O40     109.470    3.000
 PE3      H392   C39    O40     109.470    3.000
 PE3      C39    O40    C41     111.800    3.000
 PE3      O40    C41    H411    109.470    3.000
 PE3      O40    C41    H412    109.470    3.000
 PE3      O40    C41    C42     109.470    3.000
 PE3      H411   C41    H412    107.900    3.000
 PE3      H411   C41    C42     109.470    3.000
 PE3      H412   C41    C42     109.470    3.000
 PE3      C41    C42    H421    109.470    3.000
 PE3      C41    C42    H422    109.470    3.000
 PE3      C41    C42    O43     109.470    3.000
 PE3      H421   C42    H422    107.900    3.000
 PE3      H421   C42    O43     109.470    3.000
 PE3      H422   C42    O43     109.470    3.000
 PE3      C42    O43    H43     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PE3      var_1    HO1    O1     C2     C3      -179.979   20.000   1
 PE3      var_2    O1     C2     C3     O4        64.987   20.000   3
 PE3      var_3    C2     C3     O4     C5      -179.973   20.000   1
 PE3      var_4    C3     O4     C5     C6      -179.993   20.000   1
 PE3      var_5    O4     C5     C6     O7        65.000   20.000   3
 PE3      var_6    C5     C6     O7     C8       179.965   20.000   1
 PE3      var_7    C6     O7     C8     C9       179.991   20.000   1
 PE3      var_8    O7     C8     C9     O10       64.994   20.000   3
 PE3      var_9    C8     C9     O10    C11      179.982   20.000   1
 PE3      var_10   C9     O10    C11    C12     -179.988   20.000   1
 PE3      var_11   O10    C11    C12    O13       64.988   20.000   3
 PE3      var_12   C11    C12    O13    C14     -179.987   20.000   1
 PE3      var_13   C12    O13    C14    C15     -179.958   20.000   1
 PE3      var_14   O13    C14    C15    O16       65.016   20.000   3
 PE3      var_15   C14    C15    O16    C17     -179.979   20.000   1
 PE3      var_16   C15    O16    C17    C18      179.990   20.000   1
 PE3      var_17   O16    C17    C18    O19       64.948   20.000   3
 PE3      var_18   C17    C18    O19    C20     -179.984   20.000   1
 PE3      var_19   C18    O19    C20    C21     -179.987   20.000   1
 PE3      var_20   O19    C20    C21    O22       65.009   20.000   3
 PE3      var_21   C20    C21    O22    C23     -179.993   20.000   1
 PE3      var_22   C21    O22    C23    C24     -180.000   20.000   1
 PE3      var_23   O22    C23    C24    O25       64.992   20.000   3
 PE3      var_24   C23    C24    O25    C26     -179.998   20.000   1
 PE3      var_25   C24    O25    C26    C27     -179.984   20.000   1
 PE3      var_26   O25    C26    C27    O28       64.969   20.000   3
 PE3      var_27   C26    C27    O28    C29     -180.000   20.000   1
 PE3      var_28   C27    O28    C29    C30      179.988   20.000   1
 PE3      var_29   O28    C29    C30    O31       65.008   20.000   3
 PE3      var_30   C29    C30    O31    C32     -179.976   20.000   1
 PE3      var_31   C30    O31    C32    C33     -179.985   20.000   1
 PE3      var_32   O31    C32    C33    O34       65.011   20.000   3
 PE3      var_33   C32    C33    O34    C35     -179.996   20.000   1
 PE3      var_34   C33    O34    C35    C36      179.960   20.000   1
 PE3      var_35   O34    C35    C36    O37       64.984   20.000   3
 PE3      var_36   C35    C36    O37    C38      179.998   20.000   1
 PE3      var_37   C36    O37    C38    C39     -179.993   20.000   1
 PE3      var_38   O37    C38    C39    O40       65.016   20.000   3
 PE3      var_39   C38    C39    O40    C41     -179.971   20.000   1
 PE3      var_40   C39    O40    C41    C42     -179.991   20.000   1
 PE3      var_41   O40    C41    C42    O43       64.964   20.000   3
 PE3      var_42   C41    C42    O43    H43      179.965   20.000   1
# ------------------------------------------------------
`.trim();

monomers["PE4"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PE4      PE4 '2-{2-[2-(2-{2-[2-(2-ETHOXY-ETHOXY)-E' non-polymer        58  24 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PE4
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PE4           C16    C    CH3       0.000      0.000    0.000    0.000
 PE4           H161   H    H         0.000      0.804   -0.516   -0.459
 PE4           H162   H    H         0.000     -0.456    0.641   -0.711
 PE4           H163   H    H         0.000      0.371    0.580    0.806
 PE4           C15    C    CH2       0.000     -1.028   -1.006    0.520
 PE4           H151   H    H         0.000     -0.553   -1.666    1.250
 PE4           H152   H    H         0.000     -1.407   -1.601   -0.313
 PE4           O8     O    O2        0.000     -2.109   -0.307    1.140
 PE4           C14    C    CH2       0.000     -3.030   -1.297    1.601
 PE4           H141   H    H         0.000     -2.530   -1.953    2.316
 PE4           H142   H    H         0.000     -3.383   -1.888    0.753
 PE4           C13    C    CH2       0.000     -4.218   -0.612    2.279
 PE4           H131   H    H         0.000     -3.863   -0.021    3.126
 PE4           H132   H    H         0.000     -4.921   -1.369    2.633
 PE4           O7     O    O2        0.000     -4.871    0.244    1.340
 PE4           C12    C    CH2       0.000     -5.966    0.853    2.028
 PE4           H121   H    H         0.000     -5.588    1.424    2.879
 PE4           H122   H    H         0.000     -6.647    0.077    2.386
 PE4           C11    C    CH2       0.000     -6.712    1.788    1.074
 PE4           H111   H    H         0.000     -6.030    2.563    0.719
 PE4           H112   H    H         0.000     -7.548    2.253    1.601
 PE4           O6     O    O2        0.000     -7.206    1.039   -0.038
 PE4           C10    C    CH2       0.000     -7.890    1.963   -0.886
 PE4           H101   H    H         0.000     -7.194    2.737   -1.217
 PE4           H102   H    H         0.000     -8.711    2.425   -0.334
 PE4           C9     C    CH2       0.000     -8.446    1.221   -2.103
 PE4           H91    H    H         0.000     -7.624    0.759   -2.655
 PE4           H92    H    H         0.000     -8.967    1.927   -2.753
 PE4           O5     O    O2        0.000     -9.358    0.209   -1.669
 PE4           C8     C    CH2       0.000     -9.839   -0.443   -2.845
 PE4           H81    H    H         0.000     -8.998   -0.882   -3.387
 PE4           H82    H    H         0.000    -10.341    0.285   -3.485
 PE4           C7     C    CH2       0.000    -10.824   -1.544   -2.449
 PE4           H71    H    H         0.000    -10.320   -2.271   -1.811
 PE4           H72    H    H         0.000    -11.192   -2.043   -3.348
 PE4           O4     O    O2        0.000    -11.923   -0.966   -1.740
 PE4           C6     C    CH2       0.000    -12.804   -2.039   -1.400
 PE4           H61    H    H         0.000    -12.274   -2.760   -0.775
 PE4           H62    H    H         0.000    -13.146   -2.531   -2.312
 PE4           C5     C    CH2       0.000    -14.008   -1.486   -0.634
 PE4           H51    H    H         0.000    -13.664   -0.994    0.278
 PE4           H52    H    H         0.000    -14.681   -2.306   -0.373
 PE4           O3     O    O2        0.000    -14.701   -0.543   -1.454
 PE4           C4     C    CH2       0.000    -15.808   -0.065   -0.688
 PE4           H41    H    H         0.000    -15.441    0.409    0.225
 PE4           H42    H    H         0.000    -16.457   -0.903   -0.425
 PE4           C3     C    CH2       0.000    -16.597    0.954   -1.512
 PE4           H31    H    H         0.000    -15.948    1.793   -1.772
 PE4           H32    H    H         0.000    -17.443    1.319   -0.925
 PE4           O2     O    O2        0.000    -17.077    0.332   -2.707
 PE4           C2     C    CH2       0.000    -17.801    1.331   -3.428
 PE4           H21    H    H         0.000    -17.136    2.164   -3.664
 PE4           H22    H    H         0.000    -18.631    1.691   -2.817
 PE4           C1     C    CH2       0.000    -18.344    0.728   -4.725
 PE4           H11    H    H         0.000    -17.513    0.368   -5.335
 PE4           H12    H    H         0.000    -18.896    1.491   -5.278
 PE4           O1     O    OH1       0.000    -19.215   -0.361   -4.415
 PE4           HO1    H    H         0.000    -19.558   -0.742   -5.235
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PE4      C16    n/a    C15    START
 PE4      H161   C16    .      .
 PE4      H162   C16    .      .
 PE4      H163   C16    .      .
 PE4      C15    C16    O8     .
 PE4      H151   C15    .      .
 PE4      H152   C15    .      .
 PE4      O8     C15    C14    .
 PE4      C14    O8     C13    .
 PE4      H141   C14    .      .
 PE4      H142   C14    .      .
 PE4      C13    C14    O7     .
 PE4      H131   C13    .      .
 PE4      H132   C13    .      .
 PE4      O7     C13    C12    .
 PE4      C12    O7     C11    .
 PE4      H121   C12    .      .
 PE4      H122   C12    .      .
 PE4      C11    C12    O6     .
 PE4      H111   C11    .      .
 PE4      H112   C11    .      .
 PE4      O6     C11    C10    .
 PE4      C10    O6     C9     .
 PE4      H101   C10    .      .
 PE4      H102   C10    .      .
 PE4      C9     C10    O5     .
 PE4      H91    C9     .      .
 PE4      H92    C9     .      .
 PE4      O5     C9     C8     .
 PE4      C8     O5     C7     .
 PE4      H81    C8     .      .
 PE4      H82    C8     .      .
 PE4      C7     C8     O4     .
 PE4      H71    C7     .      .
 PE4      H72    C7     .      .
 PE4      O4     C7     C6     .
 PE4      C6     O4     C5     .
 PE4      H61    C6     .      .
 PE4      H62    C6     .      .
 PE4      C5     C6     O3     .
 PE4      H51    C5     .      .
 PE4      H52    C5     .      .
 PE4      O3     C5     C4     .
 PE4      C4     O3     C3     .
 PE4      H41    C4     .      .
 PE4      H42    C4     .      .
 PE4      C3     C4     O2     .
 PE4      H31    C3     .      .
 PE4      H32    C3     .      .
 PE4      O2     C3     C2     .
 PE4      C2     O2     C1     .
 PE4      H21    C2     .      .
 PE4      H22    C2     .      .
 PE4      C1     C2     O1     .
 PE4      H11    C1     .      .
 PE4      H12    C1     .      .
 PE4      O1     C1     HO1    .
 PE4      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PE4      O1     C1        single      1.432    0.020
 PE4      HO1    O1        single      0.967    0.020
 PE4      C1     C2        single      1.524    0.020
 PE4      H11    C1        single      1.092    0.020
 PE4      H12    C1        single      1.092    0.020
 PE4      C2     O2        single      1.426    0.020
 PE4      H21    C2        single      1.092    0.020
 PE4      H22    C2        single      1.092    0.020
 PE4      O2     C3        single      1.426    0.020
 PE4      C3     C4        single      1.524    0.020
 PE4      H31    C3        single      1.092    0.020
 PE4      H32    C3        single      1.092    0.020
 PE4      C4     O3        single      1.426    0.020
 PE4      H41    C4        single      1.092    0.020
 PE4      H42    C4        single      1.092    0.020
 PE4      O3     C5        single      1.426    0.020
 PE4      C5     C6        single      1.524    0.020
 PE4      H51    C5        single      1.092    0.020
 PE4      H52    C5        single      1.092    0.020
 PE4      C6     O4        single      1.426    0.020
 PE4      H61    C6        single      1.092    0.020
 PE4      H62    C6        single      1.092    0.020
 PE4      O4     C7        single      1.426    0.020
 PE4      C7     C8        single      1.524    0.020
 PE4      H71    C7        single      1.092    0.020
 PE4      H72    C7        single      1.092    0.020
 PE4      C8     O5        single      1.426    0.020
 PE4      H81    C8        single      1.092    0.020
 PE4      H82    C8        single      1.092    0.020
 PE4      O5     C9        single      1.426    0.020
 PE4      C9     C10       single      1.524    0.020
 PE4      H91    C9        single      1.092    0.020
 PE4      H92    C9        single      1.092    0.020
 PE4      C10    O6        single      1.426    0.020
 PE4      H101   C10       single      1.092    0.020
 PE4      H102   C10       single      1.092    0.020
 PE4      O6     C11       single      1.426    0.020
 PE4      C11    C12       single      1.524    0.020
 PE4      H111   C11       single      1.092    0.020
 PE4      H112   C11       single      1.092    0.020
 PE4      C12    O7        single      1.426    0.020
 PE4      H121   C12       single      1.092    0.020
 PE4      H122   C12       single      1.092    0.020
 PE4      O7     C13       single      1.426    0.020
 PE4      C13    C14       single      1.524    0.020
 PE4      H131   C13       single      1.092    0.020
 PE4      H132   C13       single      1.092    0.020
 PE4      C14    O8        single      1.426    0.020
 PE4      H141   C14       single      1.092    0.020
 PE4      H142   C14       single      1.092    0.020
 PE4      O8     C15       single      1.426    0.020
 PE4      C15    C16       single      1.513    0.020
 PE4      H151   C15       single      1.092    0.020
 PE4      H152   C15       single      1.092    0.020
 PE4      H161   C16       single      1.059    0.020
 PE4      H162   C16       single      1.059    0.020
 PE4      H163   C16       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PE4      H161   C16    H162    109.470    3.000
 PE4      H161   C16    H163    109.470    3.000
 PE4      H162   C16    H163    109.470    3.000
 PE4      H161   C16    C15     109.470    3.000
 PE4      H162   C16    C15     109.470    3.000
 PE4      H163   C16    C15     109.470    3.000
 PE4      C16    C15    H151    109.470    3.000
 PE4      C16    C15    H152    109.470    3.000
 PE4      C16    C15    O8      109.470    3.000
 PE4      H151   C15    H152    107.900    3.000
 PE4      H151   C15    O8      109.470    3.000
 PE4      H152   C15    O8      109.470    3.000
 PE4      C15    O8     C14     111.800    3.000
 PE4      O8     C14    H141    109.470    3.000
 PE4      O8     C14    H142    109.470    3.000
 PE4      O8     C14    C13     109.470    3.000
 PE4      H141   C14    H142    107.900    3.000
 PE4      H141   C14    C13     109.470    3.000
 PE4      H142   C14    C13     109.470    3.000
 PE4      C14    C13    H131    109.470    3.000
 PE4      C14    C13    H132    109.470    3.000
 PE4      C14    C13    O7      109.470    3.000
 PE4      H131   C13    H132    107.900    3.000
 PE4      H131   C13    O7      109.470    3.000
 PE4      H132   C13    O7      109.470    3.000
 PE4      C13    O7     C12     111.800    3.000
 PE4      O7     C12    H121    109.470    3.000
 PE4      O7     C12    H122    109.470    3.000
 PE4      O7     C12    C11     109.470    3.000
 PE4      H121   C12    H122    107.900    3.000
 PE4      H121   C12    C11     109.470    3.000
 PE4      H122   C12    C11     109.470    3.000
 PE4      C12    C11    H111    109.470    3.000
 PE4      C12    C11    H112    109.470    3.000
 PE4      C12    C11    O6      109.470    3.000
 PE4      H111   C11    H112    107.900    3.000
 PE4      H111   C11    O6      109.470    3.000
 PE4      H112   C11    O6      109.470    3.000
 PE4      C11    O6     C10     111.800    3.000
 PE4      O6     C10    H101    109.470    3.000
 PE4      O6     C10    H102    109.470    3.000
 PE4      O6     C10    C9      109.470    3.000
 PE4      H101   C10    H102    107.900    3.000
 PE4      H101   C10    C9      109.470    3.000
 PE4      H102   C10    C9      109.470    3.000
 PE4      C10    C9     H91     109.470    3.000
 PE4      C10    C9     H92     109.470    3.000
 PE4      C10    C9     O5      109.470    3.000
 PE4      H91    C9     H92     107.900    3.000
 PE4      H91    C9     O5      109.470    3.000
 PE4      H92    C9     O5      109.470    3.000
 PE4      C9     O5     C8      111.800    3.000
 PE4      O5     C8     H81     109.470    3.000
 PE4      O5     C8     H82     109.470    3.000
 PE4      O5     C8     C7      109.470    3.000
 PE4      H81    C8     H82     107.900    3.000
 PE4      H81    C8     C7      109.470    3.000
 PE4      H82    C8     C7      109.470    3.000
 PE4      C8     C7     H71     109.470    3.000
 PE4      C8     C7     H72     109.470    3.000
 PE4      C8     C7     O4      109.470    3.000
 PE4      H71    C7     H72     107.900    3.000
 PE4      H71    C7     O4      109.470    3.000
 PE4      H72    C7     O4      109.470    3.000
 PE4      C7     O4     C6      111.800    3.000
 PE4      O4     C6     H61     109.470    3.000
 PE4      O4     C6     H62     109.470    3.000
 PE4      O4     C6     C5      109.470    3.000
 PE4      H61    C6     H62     107.900    3.000
 PE4      H61    C6     C5      109.470    3.000
 PE4      H62    C6     C5      109.470    3.000
 PE4      C6     C5     H51     109.470    3.000
 PE4      C6     C5     H52     109.470    3.000
 PE4      C6     C5     O3      109.470    3.000
 PE4      H51    C5     H52     107.900    3.000
 PE4      H51    C5     O3      109.470    3.000
 PE4      H52    C5     O3      109.470    3.000
 PE4      C5     O3     C4      111.800    3.000
 PE4      O3     C4     H41     109.470    3.000
 PE4      O3     C4     H42     109.470    3.000
 PE4      O3     C4     C3      109.470    3.000
 PE4      H41    C4     H42     107.900    3.000
 PE4      H41    C4     C3      109.470    3.000
 PE4      H42    C4     C3      109.470    3.000
 PE4      C4     C3     H31     109.470    3.000
 PE4      C4     C3     H32     109.470    3.000
 PE4      C4     C3     O2      109.470    3.000
 PE4      H31    C3     H32     107.900    3.000
 PE4      H31    C3     O2      109.470    3.000
 PE4      H32    C3     O2      109.470    3.000
 PE4      C3     O2     C2      111.800    3.000
 PE4      O2     C2     H21     109.470    3.000
 PE4      O2     C2     H22     109.470    3.000
 PE4      O2     C2     C1      109.470    3.000
 PE4      H21    C2     H22     107.900    3.000
 PE4      H21    C2     C1      109.470    3.000
 PE4      H22    C2     C1      109.470    3.000
 PE4      C2     C1     H11     109.470    3.000
 PE4      C2     C1     H12     109.470    3.000
 PE4      C2     C1     O1      109.470    3.000
 PE4      H11    C1     H12     107.900    3.000
 PE4      H11    C1     O1      109.470    3.000
 PE4      H12    C1     O1      109.470    3.000
 PE4      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PE4      var_1    H163   C16    C15    O8        59.933   20.000   3
 PE4      var_2    C16    C15    O8     C14      179.964   20.000   1
 PE4      var_3    C15    O8     C14    C13      179.994   20.000   1
 PE4      var_4    O8     C14    C13    O7        60.086   20.000   3
 PE4      var_5    C14    C13    O7     C12     -179.983   20.000   1
 PE4      var_6    C13    O7     C12    C11      179.974   20.000   1
 PE4      var_7    O7     C12    C11    O6        59.998   20.000   3
 PE4      var_8    C12    C11    O6     C10      179.945   20.000   1
 PE4      var_9    C11    O6     C10    C9      -179.998   20.000   1
 PE4      var_10   O6     C10    C9     O5        60.050   20.000   3
 PE4      var_11   C10    C9     O5     C8      -179.995   20.000   1
 PE4      var_12   C9     O5     C8     C7       179.989   20.000   1
 PE4      var_13   O5     C8     C7     O4        59.977   20.000   3
 PE4      var_14   C8     C7     O4     C6       179.981   20.000   1
 PE4      var_15   C7     O4     C6     C5       179.996   20.000   1
 PE4      var_16   O4     C6     C5     O3        60.035   20.000   3
 PE4      var_17   C6     C5     O3     C4      -179.993   20.000   1
 PE4      var_18   C5     O3     C4     C3      -179.973   20.000   1
 PE4      var_19   O3     C4     C3     O2        59.958   20.000   3
 PE4      var_20   C4     C3     O2     C2      -179.982   20.000   1
 PE4      var_21   C3     O2     C2     C1      -179.987   20.000   1
 PE4      var_22   O2     C2     C1     O1        60.034   20.000   3
 PE4      var_23   C2     C1     O1     HO1      179.969   20.000   1
# ------------------------------------------------------
`.trim();

monomers["PE5"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PE5      PE5 '3,6,9,12,15,18,21,24-OCTAOXAHEXACOSA' non-polymer        65  27 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PE5
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PE5           O52    O    OH1       0.000      0.000    0.000    0.000
 PE5           H52    H    H         0.000      0.624   -0.733    0.091
 PE5           C16    C    CH2       0.000     -0.663    0.219    1.248
 PE5           H161   H    H         0.000      0.077    0.462    2.014
 PE5           H162   H    H         0.000     -1.201   -0.686    1.537
 PE5           C15    C    CH2       0.000     -1.650    1.378    1.104
 PE5           H151   H    H         0.000     -1.110    2.282    0.816
 PE5           H152   H    H         0.000     -2.155    1.545    2.057
 PE5           O8     O    O2        0.000     -2.617    1.058    0.101
 PE5           C14    C    CH2       0.000     -3.506    2.174    0.014
 PE5           H141   H    H         0.000     -2.942    3.068   -0.259
 PE5           H142   H    H         0.000     -3.988    2.331    0.982
 PE5           C13    C    CH2       0.000     -4.570    1.896   -1.048
 PE5           H131   H    H         0.000     -4.087    1.739   -2.015
 PE5           H132   H    H         0.000     -5.248    2.749   -1.115
 PE5           O7     O    O2        0.000     -5.309    0.726   -0.688
 PE5           C12    C    CH2       0.000     -6.282    0.521   -1.713
 PE5           H121   H    H         0.000     -5.778    0.382   -2.672
 PE5           H122   H    H         0.000     -6.939    1.391   -1.771
 PE5           C11    C    CH2       0.000     -7.111   -0.724   -1.387
 PE5           H111   H    H         0.000     -6.453   -1.594   -1.330
 PE5           H112   H    H         0.000     -7.854   -0.881   -2.171
 PE5           O6     O    O2        0.000     -7.771   -0.541   -0.133
 PE5           C10    C    CH2       0.000     -8.524   -1.730    0.114
 PE5           H101   H    H         0.000     -7.848   -2.587    0.152
 PE5           H102   H    H         0.000     -9.248   -1.875   -0.689
 PE5           C9     C    CH2       0.000     -9.259   -1.599    1.448
 PE5           H91    H    H         0.000     -8.533   -1.456    2.251
 PE5           H92    H    H         0.000     -9.833   -2.509    1.637
 PE5           O5     O    O2        0.000    -10.144   -0.477    1.398
 PE5           C8     C    CH2       0.000    -10.796   -0.409    2.667
 PE5           H81    H    H         0.000    -10.049   -0.281    3.453
 PE5           H82    H    H         0.000    -11.351   -1.334    2.840
 PE5           C7     C    CH2       0.000    -11.762    0.776    2.680
 PE5           H71    H    H         0.000    -11.205    1.700    2.507
 PE5           H72    H    H         0.000    -12.260    0.829    3.650
 PE5           O4     O    O2        0.000    -12.738    0.607    1.650
 PE5           C6     C    CH2       0.000    -13.606    1.740    1.713
 PE5           H61    H    H         0.000    -13.026    2.651    1.553
 PE5           H62    H    H         0.000    -14.081    1.780    2.695
 PE5           C5     C    CH2       0.000    -14.680    1.621    0.631
 PE5           H51    H    H         0.000    -14.204    1.582   -0.351
 PE5           H52A   H    H         0.000    -15.342    2.488    0.679
 PE5           O3     O    O2        0.000    -15.438    0.429    0.842
 PE5           C4     C    CH2       0.000    -16.419    0.375   -0.195
 PE5           H41    H    H         0.000    -15.921    0.353   -1.167
 PE5           H42    H    H         0.000    -17.059    1.258   -0.136
 PE5           C3     C    CH2       0.000    -17.270   -0.885   -0.028
 PE5           H31    H    H         0.000    -16.629   -1.767   -0.089
 PE5           H32    H    H         0.000    -18.019   -0.926   -0.822
 PE5           O2     O    O2        0.000    -17.922   -0.854    1.243
 PE5           C2     C    CH2       0.000    -18.696   -2.051    1.339
 PE5           H21    H    H         0.000    -18.037   -2.917    1.262
 PE5           H22    H    H         0.000    -19.427   -2.077    0.528
 PE5           C1     C    CH2       0.000    -19.424   -2.081    2.684
 PE5           H11    H    H         0.000    -18.693   -2.056    3.494
 PE5           H12    H    H         0.000    -20.015   -2.997    2.757
 PE5           O1     O    O2        0.000    -20.287   -0.946    2.784
 PE5           C50    C    CH2       0.000    -20.934   -1.030    4.055
 PE5           H501   H    H         0.000    -20.183   -1.018    4.847
 PE5           H502   H    H         0.000    -21.505   -1.960    4.112
 PE5           C48    C    CH3       0.000    -21.878    0.161    4.227
 PE5           H483   H    H         0.000    -21.326    1.064    4.173
 PE5           H482   H    H         0.000    -22.609    0.151    3.459
 PE5           H481   H    H         0.000    -22.360    0.102    5.170
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PE5      O52    n/a    C16    START
 PE5      H52    O52    .      .
 PE5      C16    O52    C15    .
 PE5      H161   C16    .      .
 PE5      H162   C16    .      .
 PE5      C15    C16    O8     .
 PE5      H151   C15    .      .
 PE5      H152   C15    .      .
 PE5      O8     C15    C14    .
 PE5      C14    O8     C13    .
 PE5      H141   C14    .      .
 PE5      H142   C14    .      .
 PE5      C13    C14    O7     .
 PE5      H131   C13    .      .
 PE5      H132   C13    .      .
 PE5      O7     C13    C12    .
 PE5      C12    O7     C11    .
 PE5      H121   C12    .      .
 PE5      H122   C12    .      .
 PE5      C11    C12    O6     .
 PE5      H111   C11    .      .
 PE5      H112   C11    .      .
 PE5      O6     C11    C10    .
 PE5      C10    O6     C9     .
 PE5      H101   C10    .      .
 PE5      H102   C10    .      .
 PE5      C9     C10    O5     .
 PE5      H91    C9     .      .
 PE5      H92    C9     .      .
 PE5      O5     C9     C8     .
 PE5      C8     O5     C7     .
 PE5      H81    C8     .      .
 PE5      H82    C8     .      .
 PE5      C7     C8     O4     .
 PE5      H71    C7     .      .
 PE5      H72    C7     .      .
 PE5      O4     C7     C6     .
 PE5      C6     O4     C5     .
 PE5      H61    C6     .      .
 PE5      H62    C6     .      .
 PE5      C5     C6     O3     .
 PE5      H51    C5     .      .
 PE5      H52A   C5     .      .
 PE5      O3     C5     C4     .
 PE5      C4     O3     C3     .
 PE5      H41    C4     .      .
 PE5      H42    C4     .      .
 PE5      C3     C4     O2     .
 PE5      H31    C3     .      .
 PE5      H32    C3     .      .
 PE5      O2     C3     C2     .
 PE5      C2     O2     C1     .
 PE5      H21    C2     .      .
 PE5      H22    C2     .      .
 PE5      C1     C2     O1     .
 PE5      H11    C1     .      .
 PE5      H12    C1     .      .
 PE5      O1     C1     C50    .
 PE5      C50    O1     C48    .
 PE5      H501   C50    .      .
 PE5      H502   C50    .      .
 PE5      C48    C50    H481   .
 PE5      H483   C48    .      .
 PE5      H482   C48    .      .
 PE5      H481   C48    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PE5      C48    C50       single      1.513    0.020
 PE5      H481   C48       single      1.059    0.020
 PE5      H482   C48       single      1.059    0.020
 PE5      H483   C48       single      1.059    0.020
 PE5      C50    O1        single      1.426    0.020
 PE5      H501   C50       single      1.092    0.020
 PE5      H502   C50       single      1.092    0.020
 PE5      O1     C1        single      1.426    0.020
 PE5      C1     C2        single      1.524    0.020
 PE5      H11    C1        single      1.092    0.020
 PE5      H12    C1        single      1.092    0.020
 PE5      C2     O2        single      1.426    0.020
 PE5      H21    C2        single      1.092    0.020
 PE5      H22    C2        single      1.092    0.020
 PE5      O2     C3        single      1.426    0.020
 PE5      C3     C4        single      1.524    0.020
 PE5      H31    C3        single      1.092    0.020
 PE5      H32    C3        single      1.092    0.020
 PE5      C4     O3        single      1.426    0.020
 PE5      H41    C4        single      1.092    0.020
 PE5      H42    C4        single      1.092    0.020
 PE5      O3     C5        single      1.426    0.020
 PE5      C5     C6        single      1.524    0.020
 PE5      H51    C5        single      1.092    0.020
 PE5      H52A   C5        single      1.092    0.020
 PE5      C6     O4        single      1.426    0.020
 PE5      H61    C6        single      1.092    0.020
 PE5      H62    C6        single      1.092    0.020
 PE5      O4     C7        single      1.426    0.020
 PE5      C7     C8        single      1.524    0.020
 PE5      H71    C7        single      1.092    0.020
 PE5      H72    C7        single      1.092    0.020
 PE5      C8     O5        single      1.426    0.020
 PE5      H81    C8        single      1.092    0.020
 PE5      H82    C8        single      1.092    0.020
 PE5      O5     C9        single      1.426    0.020
 PE5      C9     C10       single      1.524    0.020
 PE5      H91    C9        single      1.092    0.020
 PE5      H92    C9        single      1.092    0.020
 PE5      C10    O6        single      1.426    0.020
 PE5      H101   C10       single      1.092    0.020
 PE5      H102   C10       single      1.092    0.020
 PE5      O6     C11       single      1.426    0.020
 PE5      C11    C12       single      1.524    0.020
 PE5      H111   C11       single      1.092    0.020
 PE5      H112   C11       single      1.092    0.020
 PE5      C12    O7        single      1.426    0.020
 PE5      H121   C12       single      1.092    0.020
 PE5      H122   C12       single      1.092    0.020
 PE5      O7     C13       single      1.426    0.020
 PE5      C13    C14       single      1.524    0.020
 PE5      H131   C13       single      1.092    0.020
 PE5      H132   C13       single      1.092    0.020
 PE5      C14    O8        single      1.426    0.020
 PE5      H141   C14       single      1.092    0.020
 PE5      H142   C14       single      1.092    0.020
 PE5      O8     C15       single      1.426    0.020
 PE5      C15    C16       single      1.524    0.020
 PE5      H151   C15       single      1.092    0.020
 PE5      H152   C15       single      1.092    0.020
 PE5      C16    O52       single      1.432    0.020
 PE5      H161   C16       single      1.092    0.020
 PE5      H162   C16       single      1.092    0.020
 PE5      H52    O52       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PE5      H52    O52    C16     109.470    3.000
 PE5      O52    C16    H161    109.470    3.000
 PE5      O52    C16    H162    109.470    3.000
 PE5      O52    C16    C15     109.470    3.000
 PE5      H161   C16    H162    107.900    3.000
 PE5      H161   C16    C15     109.470    3.000
 PE5      H162   C16    C15     109.470    3.000
 PE5      C16    C15    H151    109.470    3.000
 PE5      C16    C15    H152    109.470    3.000
 PE5      C16    C15    O8      109.470    3.000
 PE5      H151   C15    H152    107.900    3.000
 PE5      H151   C15    O8      109.470    3.000
 PE5      H152   C15    O8      109.470    3.000
 PE5      C15    O8     C14     111.800    3.000
 PE5      O8     C14    H141    109.470    3.000
 PE5      O8     C14    H142    109.470    3.000
 PE5      O8     C14    C13     109.470    3.000
 PE5      H141   C14    H142    107.900    3.000
 PE5      H141   C14    C13     109.470    3.000
 PE5      H142   C14    C13     109.470    3.000
 PE5      C14    C13    H131    109.470    3.000
 PE5      C14    C13    H132    109.470    3.000
 PE5      C14    C13    O7      109.470    3.000
 PE5      H131   C13    H132    107.900    3.000
 PE5      H131   C13    O7      109.470    3.000
 PE5      H132   C13    O7      109.470    3.000
 PE5      C13    O7     C12     111.800    3.000
 PE5      O7     C12    H121    109.470    3.000
 PE5      O7     C12    H122    109.470    3.000
 PE5      O7     C12    C11     109.470    3.000
 PE5      H121   C12    H122    107.900    3.000
 PE5      H121   C12    C11     109.470    3.000
 PE5      H122   C12    C11     109.470    3.000
 PE5      C12    C11    H111    109.470    3.000
 PE5      C12    C11    H112    109.470    3.000
 PE5      C12    C11    O6      109.470    3.000
 PE5      H111   C11    H112    107.900    3.000
 PE5      H111   C11    O6      109.470    3.000
 PE5      H112   C11    O6      109.470    3.000
 PE5      C11    O6     C10     111.800    3.000
 PE5      O6     C10    H101    109.470    3.000
 PE5      O6     C10    H102    109.470    3.000
 PE5      O6     C10    C9      109.470    3.000
 PE5      H101   C10    H102    107.900    3.000
 PE5      H101   C10    C9      109.470    3.000
 PE5      H102   C10    C9      109.470    3.000
 PE5      C10    C9     H91     109.470    3.000
 PE5      C10    C9     H92     109.470    3.000
 PE5      C10    C9     O5      109.470    3.000
 PE5      H91    C9     H92     107.900    3.000
 PE5      H91    C9     O5      109.470    3.000
 PE5      H92    C9     O5      109.470    3.000
 PE5      C9     O5     C8      111.800    3.000
 PE5      O5     C8     H81     109.470    3.000
 PE5      O5     C8     H82     109.470    3.000
 PE5      O5     C8     C7      109.470    3.000
 PE5      H81    C8     H82     107.900    3.000
 PE5      H81    C8     C7      109.470    3.000
 PE5      H82    C8     C7      109.470    3.000
 PE5      C8     C7     H71     109.470    3.000
 PE5      C8     C7     H72     109.470    3.000
 PE5      C8     C7     O4      109.470    3.000
 PE5      H71    C7     H72     107.900    3.000
 PE5      H71    C7     O4      109.470    3.000
 PE5      H72    C7     O4      109.470    3.000
 PE5      C7     O4     C6      111.800    3.000
 PE5      O4     C6     H61     109.470    3.000
 PE5      O4     C6     H62     109.470    3.000
 PE5      O4     C6     C5      109.470    3.000
 PE5      H61    C6     H62     107.900    3.000
 PE5      H61    C6     C5      109.470    3.000
 PE5      H62    C6     C5      109.470    3.000
 PE5      C6     C5     H51     109.470    3.000
 PE5      C6     C5     H52A    109.470    3.000
 PE5      C6     C5     O3      109.470    3.000
 PE5      H51    C5     H52A    107.900    3.000
 PE5      H51    C5     O3      109.470    3.000
 PE5      H52A   C5     O3      109.470    3.000
 PE5      C5     O3     C4      111.800    3.000
 PE5      O3     C4     H41     109.470    3.000
 PE5      O3     C4     H42     109.470    3.000
 PE5      O3     C4     C3      109.470    3.000
 PE5      H41    C4     H42     107.900    3.000
 PE5      H41    C4     C3      109.470    3.000
 PE5      H42    C4     C3      109.470    3.000
 PE5      C4     C3     H31     109.470    3.000
 PE5      C4     C3     H32     109.470    3.000
 PE5      C4     C3     O2      109.470    3.000
 PE5      H31    C3     H32     107.900    3.000
 PE5      H31    C3     O2      109.470    3.000
 PE5      H32    C3     O2      109.470    3.000
 PE5      C3     O2     C2      111.800    3.000
 PE5      O2     C2     H21     109.470    3.000
 PE5      O2     C2     H22     109.470    3.000
 PE5      O2     C2     C1      109.470    3.000
 PE5      H21    C2     H22     107.900    3.000
 PE5      H21    C2     C1      109.470    3.000
 PE5      H22    C2     C1      109.470    3.000
 PE5      C2     C1     H11     109.470    3.000
 PE5      C2     C1     H12     109.470    3.000
 PE5      C2     C1     O1      109.470    3.000
 PE5      H11    C1     H12     107.900    3.000
 PE5      H11    C1     O1      109.470    3.000
 PE5      H12    C1     O1      109.470    3.000
 PE5      C1     O1     C50     111.800    3.000
 PE5      O1     C50    H501    109.470    3.000
 PE5      O1     C50    H502    109.470    3.000
 PE5      O1     C50    C48     109.470    3.000
 PE5      H501   C50    H502    107.900    3.000
 PE5      H501   C50    C48     109.470    3.000
 PE5      H502   C50    C48     109.470    3.000
 PE5      C50    C48    H483    109.470    3.000
 PE5      C50    C48    H482    109.470    3.000
 PE5      C50    C48    H481    109.470    3.000
 PE5      H483   C48    H482    109.470    3.000
 PE5      H483   C48    H481    109.470    3.000
 PE5      H482   C48    H481    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PE5      var_1    H52    O52    C16    C15     -179.922   20.000   1
 PE5      var_2    O52    C16    C15    O8        59.995   20.000   3
 PE5      var_3    C16    C15    O8     C14     -179.992   20.000   1
 PE5      var_4    C15    O8     C14    C13      179.960   20.000   1
 PE5      var_5    O8     C14    C13    O7        60.056   20.000   3
 PE5      var_6    C14    C13    O7     C12      179.974   20.000   1
 PE5      var_7    C13    O7     C12    C11      179.975   20.000   1
 PE5      var_8    O7     C12    C11    O6        60.007   20.000   3
 PE5      var_9    C12    C11    O6     C10     -179.999   20.000   1
 PE5      var_10   C11    O6     C10    C9      -179.967   20.000   1
 PE5      var_11   O6     C10    C9     O5        59.987   20.000   3
 PE5      var_12   C10    C9     O5     C8      -179.963   20.000   1
 PE5      var_13   C9     O5     C8     C7       179.995   20.000   1
 PE5      var_14   O5     C8     C7     O4        60.005   20.000   3
 PE5      var_15   C8     C7     O4     C6      -179.988   20.000   1
 PE5      var_16   C7     O4     C6     C5       179.982   20.000   1
 PE5      var_17   O4     C6     C5     O3        59.997   20.000   3
 PE5      var_18   C6     C5     O3     C4       179.990   20.000   1
 PE5      var_19   C5     O3     C4     C3       179.992   20.000   1
 PE5      var_20   O3     C4     C3     O2        60.007   20.000   3
 PE5      var_21   C4     C3     O2     C2      -179.965   20.000   1
 PE5      var_22   C3     O2     C2     C1      -179.990   20.000   1
 PE5      var_23   O2     C2     C1     O1        59.996   20.000   3
 PE5      var_24   C2     C1     O1     C50     -179.943   20.000   1
 PE5      var_25   C1     O1     C50    C48     -179.986   20.000   1
 PE5      var_26   O1     C50    C48    H481     179.987   20.000   3
# ------------------------------------------------------
`.trim();

monomers["PE6"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PE6      PE6 'PHOSPHORYL-HEXAETHYLENE GLYCOL      ' non-polymer        48  23 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PE6
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PE6           OP3    O    OP       -0.666      0.000    0.000    0.000
 PE6           P1     P    P         0.000     -1.047   -1.086    0.113
 PE6           OP1    O    OP       -0.666     -1.458   -1.241    1.561
 PE6           OP2    O    OP       -0.666     -0.473   -2.393   -0.390
 PE6           O2     O    O2        0.000     -2.332   -0.690   -0.769
 PE6           C3     C    CH2       0.000     -2.826    0.545   -0.247
 PE6           H31    H    H         0.000     -2.049    1.309   -0.325
 PE6           H32    H    H         0.000     -3.100    0.413    0.801
 PE6           C4     C    CH2       0.000     -4.054    0.982   -1.047
 PE6           H41    H    H         0.000     -3.778    1.115   -2.095
 PE6           H42    H    H         0.000     -4.430    1.927   -0.649
 PE6           O5     O    O2        0.000     -5.070   -0.018   -0.944
 PE6           C6     C    CH2       0.000     -6.186    0.446   -1.707
 PE6           H61    H    H         0.000     -5.882    0.586   -2.747
 PE6           H62    H    H         0.000     -6.534    1.398   -1.300
 PE6           C7     C    CH2       0.000     -7.315   -0.583   -1.638
 PE6           H71    H    H         0.000     -6.966   -1.534   -2.047
 PE6           H72    H    H         0.000     -8.167   -0.229   -2.222
 PE6           O8     O    O2        0.000     -7.711   -0.765   -0.277
 PE6           C9     C    CH2       0.000     -8.761   -1.734   -0.280
 PE6           H91    H    H         0.000     -8.392   -2.669   -0.705
 PE6           H92    H    H         0.000     -9.594   -1.365   -0.882
 PE6           C10    C    CH2       0.000     -9.234   -1.976    1.155
 PE6           H101   H    H         0.000     -8.401   -2.346    1.755
 PE6           H102   H    H         0.000    -10.037   -2.717    1.153
 PE6           O11    O    O2        0.000     -9.716   -0.751    1.710
 PE6           C12    C    CH2       0.000    -10.142   -1.041    3.043
 PE6           H121   H    H         0.000     -9.296   -1.422    3.619
 PE6           H122   H    H         0.000    -10.932   -1.793    3.017
 PE6           C13    C    CH2       0.000    -10.672    0.236    3.699
 PE6           H131   H    H         0.000     -9.880    0.988    3.724
 PE6           H132   H    H         0.000    -10.995    0.015    4.718
 PE6           O14    O    O2        0.000    -11.778    0.733    2.945
 PE6           C15    C    CH2       0.000    -12.226    1.920    3.603
 PE6           H151   H    H         0.000    -11.414    2.649    3.631
 PE6           H152   H    H         0.000    -12.529    1.676    4.624
 PE6           C16    C    CH2       0.000    -13.417    2.508    2.842
 PE6           H161   H    H         0.000    -13.111    2.752    1.823
 PE6           H162   H    H         0.000    -13.758    3.414    3.346
 PE6           O17    O    O2        0.000    -14.478    1.552    2.807
 PE6           C18    C    CH2       0.000    -15.554    2.157    2.087
 PE6           H181   H    H         0.000    -15.221    2.405    1.078
 PE6           H182   H    H         0.000    -15.867    3.068    2.601
 PE6           C19    C    CH2       0.000    -16.730    1.182    2.013
 PE6           H191   H    H         0.000    -16.415    0.272    1.498
 PE6           H192   H    H         0.000    -17.551    1.645    1.462
 PE6           O20    O    OH1       0.000    -17.164    0.857    3.334
 PE6           H20    H    H         0.000    -17.907    0.240    3.285
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PE6      OP3    n/a    P1     START
 PE6      P1     OP3    O2     .
 PE6      OP1    P1     .      .
 PE6      OP2    P1     .      .
 PE6      O2     P1     C3     .
 PE6      C3     O2     C4     .
 PE6      H31    C3     .      .
 PE6      H32    C3     .      .
 PE6      C4     C3     O5     .
 PE6      H41    C4     .      .
 PE6      H42    C4     .      .
 PE6      O5     C4     C6     .
 PE6      C6     O5     C7     .
 PE6      H61    C6     .      .
 PE6      H62    C6     .      .
 PE6      C7     C6     O8     .
 PE6      H71    C7     .      .
 PE6      H72    C7     .      .
 PE6      O8     C7     C9     .
 PE6      C9     O8     C10    .
 PE6      H91    C9     .      .
 PE6      H92    C9     .      .
 PE6      C10    C9     O11    .
 PE6      H101   C10    .      .
 PE6      H102   C10    .      .
 PE6      O11    C10    C12    .
 PE6      C12    O11    C13    .
 PE6      H121   C12    .      .
 PE6      H122   C12    .      .
 PE6      C13    C12    O14    .
 PE6      H131   C13    .      .
 PE6      H132   C13    .      .
 PE6      O14    C13    C15    .
 PE6      C15    O14    C16    .
 PE6      H151   C15    .      .
 PE6      H152   C15    .      .
 PE6      C16    C15    O17    .
 PE6      H161   C16    .      .
 PE6      H162   C16    .      .
 PE6      O17    C16    C18    .
 PE6      C18    O17    C19    .
 PE6      H181   C18    .      .
 PE6      H182   C18    .      .
 PE6      C19    C18    O20    .
 PE6      H191   C19    .      .
 PE6      H192   C19    .      .
 PE6      O20    C19    H20    .
 PE6      H20    O20    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PE6      C3     O2        single      1.426    0.020
 PE6      C4     C3        single      1.524    0.020
 PE6      H31    C3        single      1.092    0.020
 PE6      H32    C3        single      1.092    0.020
 PE6      O2     P1        single      1.610    0.020
 PE6      OP1    P1        deloc       1.510    0.020
 PE6      OP2    P1        deloc       1.510    0.020
 PE6      P1     OP3       deloc       1.510    0.020
 PE6      O5     C4        single      1.426    0.020
 PE6      H41    C4        single      1.092    0.020
 PE6      H42    C4        single      1.092    0.020
 PE6      C6     O5        single      1.426    0.020
 PE6      C7     C6        single      1.524    0.020
 PE6      H61    C6        single      1.092    0.020
 PE6      H62    C6        single      1.092    0.020
 PE6      O8     C7        single      1.426    0.020
 PE6      H71    C7        single      1.092    0.020
 PE6      H72    C7        single      1.092    0.020
 PE6      C9     O8        single      1.426    0.020
 PE6      C10    C9        single      1.524    0.020
 PE6      H91    C9        single      1.092    0.020
 PE6      H92    C9        single      1.092    0.020
 PE6      O11    C10       single      1.426    0.020
 PE6      H101   C10       single      1.092    0.020
 PE6      H102   C10       single      1.092    0.020
 PE6      C12    O11       single      1.426    0.020
 PE6      O20    C19       single      1.432    0.020
 PE6      H20    O20       single      0.967    0.020
 PE6      C19    C18       single      1.524    0.020
 PE6      H191   C19       single      1.092    0.020
 PE6      H192   C19       single      1.092    0.020
 PE6      C18    O17       single      1.426    0.020
 PE6      H181   C18       single      1.092    0.020
 PE6      H182   C18       single      1.092    0.020
 PE6      O17    C16       single      1.426    0.020
 PE6      C16    C15       single      1.524    0.020
 PE6      H161   C16       single      1.092    0.020
 PE6      H162   C16       single      1.092    0.020
 PE6      C15    O14       single      1.426    0.020
 PE6      H151   C15       single      1.092    0.020
 PE6      H152   C15       single      1.092    0.020
 PE6      O14    C13       single      1.426    0.020
 PE6      C13    C12       single      1.524    0.020
 PE6      H131   C13       single      1.092    0.020
 PE6      H132   C13       single      1.092    0.020
 PE6      H121   C12       single      1.092    0.020
 PE6      H122   C12       single      1.092    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PE6      OP3    P1     OP1     119.900    3.000
 PE6      OP3    P1     OP2     119.900    3.000
 PE6      OP3    P1     O2      108.200    3.000
 PE6      OP1    P1     OP2     119.900    3.000
 PE6      OP1    P1     O2      108.200    3.000
 PE6      OP2    P1     O2      108.200    3.000
 PE6      P1     O2     C3      120.500    3.000
 PE6      O2     C3     H31     109.470    3.000
 PE6      O2     C3     H32     109.470    3.000
 PE6      O2     C3     C4      109.470    3.000
 PE6      H31    C3     H32     107.900    3.000
 PE6      H31    C3     C4      109.470    3.000
 PE6      H32    C3     C4      109.470    3.000
 PE6      C3     C4     H41     109.470    3.000
 PE6      C3     C4     H42     109.470    3.000
 PE6      C3     C4     O5      109.470    3.000
 PE6      H41    C4     H42     107.900    3.000
 PE6      H41    C4     O5      109.470    3.000
 PE6      H42    C4     O5      109.470    3.000
 PE6      C4     O5     C6      111.800    3.000
 PE6      O5     C6     H61     109.470    3.000
 PE6      O5     C6     H62     109.470    3.000
 PE6      O5     C6     C7      109.470    3.000
 PE6      H61    C6     H62     107.900    3.000
 PE6      H61    C6     C7      109.470    3.000
 PE6      H62    C6     C7      109.470    3.000
 PE6      C6     C7     H71     109.470    3.000
 PE6      C6     C7     H72     109.470    3.000
 PE6      C6     C7     O8      109.470    3.000
 PE6      H71    C7     H72     107.900    3.000
 PE6      H71    C7     O8      109.470    3.000
 PE6      H72    C7     O8      109.470    3.000
 PE6      C7     O8     C9      111.800    3.000
 PE6      O8     C9     H91     109.470    3.000
 PE6      O8     C9     H92     109.470    3.000
 PE6      O8     C9     C10     109.470    3.000
 PE6      H91    C9     H92     107.900    3.000
 PE6      H91    C9     C10     109.470    3.000
 PE6      H92    C9     C10     109.470    3.000
 PE6      C9     C10    H101    109.470    3.000
 PE6      C9     C10    H102    109.470    3.000
 PE6      C9     C10    O11     109.470    3.000
 PE6      H101   C10    H102    107.900    3.000
 PE6      H101   C10    O11     109.470    3.000
 PE6      H102   C10    O11     109.470    3.000
 PE6      C10    O11    C12     111.800    3.000
 PE6      O11    C12    H121    109.470    3.000
 PE6      O11    C12    H122    109.470    3.000
 PE6      O11    C12    C13     109.470    3.000
 PE6      H121   C12    H122    107.900    3.000
 PE6      H121   C12    C13     109.470    3.000
 PE6      H122   C12    C13     109.470    3.000
 PE6      C12    C13    H131    109.470    3.000
 PE6      C12    C13    H132    109.470    3.000
 PE6      C12    C13    O14     109.470    3.000
 PE6      H131   C13    H132    107.900    3.000
 PE6      H131   C13    O14     109.470    3.000
 PE6      H132   C13    O14     109.470    3.000
 PE6      C13    O14    C15     111.800    3.000
 PE6      O14    C15    H151    109.470    3.000
 PE6      O14    C15    H152    109.470    3.000
 PE6      O14    C15    C16     109.470    3.000
 PE6      H151   C15    H152    107.900    3.000
 PE6      H151   C15    C16     109.470    3.000
 PE6      H152   C15    C16     109.470    3.000
 PE6      C15    C16    H161    109.470    3.000
 PE6      C15    C16    H162    109.470    3.000
 PE6      C15    C16    O17     109.470    3.000
 PE6      H161   C16    H162    107.900    3.000
 PE6      H161   C16    O17     109.470    3.000
 PE6      H162   C16    O17     109.470    3.000
 PE6      C16    O17    C18     111.800    3.000
 PE6      O17    C18    H181    109.470    3.000
 PE6      O17    C18    H182    109.470    3.000
 PE6      O17    C18    C19     109.470    3.000
 PE6      H181   C18    H182    107.900    3.000
 PE6      H181   C18    C19     109.470    3.000
 PE6      H182   C18    C19     109.470    3.000
 PE6      C18    C19    H191    109.470    3.000
 PE6      C18    C19    H192    109.470    3.000
 PE6      C18    C19    O20     109.470    3.000
 PE6      H191   C19    H192    107.900    3.000
 PE6      H191   C19    O20     109.470    3.000
 PE6      H192   C19    O20     109.470    3.000
 PE6      C19    O20    H20     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PE6      var_1    OP3    P1     O2     C3       -59.978   20.000   1
 PE6      var_2    P1     O2     C3     C4       179.940   20.000   1
 PE6      var_3    O2     C3     C4     O5        60.019   20.000   3
 PE6      var_4    C3     C4     O5     C6       179.974   20.000   1
 PE6      var_5    C4     O5     C6     C7       179.998   20.000   1
 PE6      var_6    O5     C6     C7     O8        59.980   20.000   3
 PE6      var_7    C6     C7     O8     C9      -179.941   20.000   1
 PE6      var_8    C7     O8     C9     C10     -179.967   20.000   1
 PE6      var_9    O8     C9     C10    O11       59.972   20.000   3
 PE6      var_10   C9     C10    O11    C12     -179.997   20.000   1
 PE6      var_11   C10    O11    C12    C13     -180.000   20.000   1
 PE6      var_12   O11    C12    C13    O14       60.049   20.000   3
 PE6      var_13   C12    C13    O14    C15     -179.986   20.000   1
 PE6      var_14   C13    O14    C15    C16      179.973   20.000   1
 PE6      var_15   O14    C15    C16    O17       59.948   20.000   3
 PE6      var_16   C15    C16    O17    C18      179.985   20.000   1
 PE6      var_17   C16    O17    C18    C19     -179.952   20.000   1
 PE6      var_18   O17    C18    C19    O20       59.990   20.000   3
 PE6      var_19   C18    C19    O20    H20     -179.904   20.000   1
# ------------------------------------------------------
`.trim();

monomers["PE7"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PE7      PE7 '1-DEOXY-1-THIO-HEPTAETHYLENE GLYCOL ' non-polymer        52  22 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PE7
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PE7           O22    O    OH1       0.000      0.000    0.000    0.000
 PE7           HO2    H    H         0.000      0.645   -0.717   -0.061
 PE7           C21    C    CH2       0.000     -0.832   -0.205    1.142
 PE7           H211   H    H         0.000     -0.216   -0.219    2.044
 PE7           H212   H    H         0.000     -1.354   -1.160    1.046
 PE7           C20    C    CH2       0.000     -1.855    0.928    1.238
 PE7           H201   H    H         0.000     -1.332    1.882    1.335
 PE7           H202   H    H         0.000     -2.490    0.772    2.113
 PE7           O19    O    O2        0.000     -2.661    0.944    0.060
 PE7           C18    C    CH2       0.000     -3.591    2.019    0.208
 PE7           H181   H    H         0.000     -3.044    2.958    0.319
 PE7           H182   H    H         0.000     -4.203    1.849    1.096
 PE7           C17    C    CH2       0.000     -4.490    2.093   -1.026
 PE7           H171   H    H         0.000     -3.876    2.266   -1.913
 PE7           H172   H    H         0.000     -5.199    2.915   -0.911
 PE7           O16    O    O2        0.000     -5.203    0.863   -1.171
 PE7           C15    C    CH2       0.000     -6.020    0.993   -2.335
 PE7           H151   H    H         0.000     -5.386    1.179   -3.205
 PE7           H152   H    H         0.000     -6.709    1.830   -2.204
 PE7           C14    C    CH2       0.000     -6.815   -0.296   -2.548
 PE7           H141   H    H         0.000     -6.124   -1.131   -2.680
 PE7           H142   H    H         0.000     -7.438   -0.196   -3.439
 PE7           O13    O    O2        0.000     -7.644   -0.537   -1.409
 PE7           C12    C    CH2       0.000     -8.356   -1.749   -1.667
 PE7           H121   H    H         0.000     -7.645   -2.565   -1.810
 PE7           H122   H    H         0.000     -8.959   -1.631   -2.570
 PE7           C11    C    CH2       0.000     -9.267   -2.067   -0.481
 PE7           H111   H    H         0.000     -8.662   -2.187    0.420
 PE7           H112   H    H         0.000     -9.811   -2.993   -0.679
 PE7           O10    O    O2        0.000    -10.196   -0.998   -0.295
 PE7           C9     C    CH2       0.000    -11.015   -1.352    0.822
 PE7           H91    H    H         0.000    -10.388   -1.480    1.707
 PE7           H92    H    H         0.000    -11.536   -2.287    0.608
 PE7           C8     C    CH2       0.000    -12.038   -0.243    1.077
 PE7           H81    H    H         0.000    -11.515    0.692    1.290
 PE7           H82    H    H         0.000    -12.662   -0.513    1.931
 PE7           O7     O    O2        0.000    -12.858   -0.078   -0.081
 PE7           C6     C    CH2       0.000    -13.788    0.966    0.218
 PE7           H61    H    H         0.000    -13.242    1.885    0.443
 PE7           H62    H    H         0.000    -14.390    0.680    1.083
 PE7           C5     C    CH2       0.000    -14.701    1.196   -0.988
 PE7           H51    H    H         0.000    -14.098    1.483   -1.852
 PE7           H52    H    H         0.000    -15.410    1.995   -0.760
 PE7           O4     O    O2        0.000    -15.414   -0.007   -1.281
 PE7           C3     C    CH2       0.000    -16.245    0.270   -2.410
 PE7           H31    H    H         0.000    -15.622    0.569   -3.256
 PE7           H32    H    H         0.000    -16.935    1.080   -2.163
 PE7           C2     C    CH2       0.000    -17.040   -0.983   -2.778
 PE7           H21    H    H         0.000    -17.662   -1.281   -1.931
 PE7           H22    H    H         0.000    -16.349   -1.792   -3.023
 PE7           S1     S    SH1       0.000    -18.095   -0.631   -4.212
 PE7           HS     H    H         0.000    -18.633   -1.845   -4.290
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PE7      O22    n/a    C21    START
 PE7      HO2    O22    .      .
 PE7      C21    O22    C20    .
 PE7      H211   C21    .      .
 PE7      H212   C21    .      .
 PE7      C20    C21    O19    .
 PE7      H201   C20    .      .
 PE7      H202   C20    .      .
 PE7      O19    C20    C18    .
 PE7      C18    O19    C17    .
 PE7      H181   C18    .      .
 PE7      H182   C18    .      .
 PE7      C17    C18    O16    .
 PE7      H171   C17    .      .
 PE7      H172   C17    .      .
 PE7      O16    C17    C15    .
 PE7      C15    O16    C14    .
 PE7      H151   C15    .      .
 PE7      H152   C15    .      .
 PE7      C14    C15    O13    .
 PE7      H141   C14    .      .
 PE7      H142   C14    .      .
 PE7      O13    C14    C12    .
 PE7      C12    O13    C11    .
 PE7      H121   C12    .      .
 PE7      H122   C12    .      .
 PE7      C11    C12    O10    .
 PE7      H111   C11    .      .
 PE7      H112   C11    .      .
 PE7      O10    C11    C9     .
 PE7      C9     O10    C8     .
 PE7      H91    C9     .      .
 PE7      H92    C9     .      .
 PE7      C8     C9     O7     .
 PE7      H81    C8     .      .
 PE7      H82    C8     .      .
 PE7      O7     C8     C6     .
 PE7      C6     O7     C5     .
 PE7      H61    C6     .      .
 PE7      H62    C6     .      .
 PE7      C5     C6     O4     .
 PE7      H51    C5     .      .
 PE7      H52    C5     .      .
 PE7      O4     C5     C3     .
 PE7      C3     O4     C2     .
 PE7      H31    C3     .      .
 PE7      H32    C3     .      .
 PE7      C2     C3     S1     .
 PE7      H21    C2     .      .
 PE7      H22    C2     .      .
 PE7      S1     C2     HS     .
 PE7      HS     S1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PE7      S1     C2        single      1.810    0.020
 PE7      HS     S1        single      1.330    0.020
 PE7      C2     C3        single      1.524    0.020
 PE7      H21    C2        single      1.092    0.020
 PE7      H22    C2        single      1.092    0.020
 PE7      C3     O4        single      1.426    0.020
 PE7      H31    C3        single      1.092    0.020
 PE7      H32    C3        single      1.092    0.020
 PE7      O4     C5        single      1.426    0.020
 PE7      C5     C6        single      1.524    0.020
 PE7      H51    C5        single      1.092    0.020
 PE7      H52    C5        single      1.092    0.020
 PE7      C6     O7        single      1.426    0.020
 PE7      H61    C6        single      1.092    0.020
 PE7      H62    C6        single      1.092    0.020
 PE7      O7     C8        single      1.426    0.020
 PE7      C8     C9        single      1.524    0.020
 PE7      H81    C8        single      1.092    0.020
 PE7      H82    C8        single      1.092    0.020
 PE7      C9     O10       single      1.426    0.020
 PE7      H91    C9        single      1.092    0.020
 PE7      H92    C9        single      1.092    0.020
 PE7      O10    C11       single      1.426    0.020
 PE7      C11    C12       single      1.524    0.020
 PE7      H111   C11       single      1.092    0.020
 PE7      H112   C11       single      1.092    0.020
 PE7      C12    O13       single      1.426    0.020
 PE7      H121   C12       single      1.092    0.020
 PE7      H122   C12       single      1.092    0.020
 PE7      O13    C14       single      1.426    0.020
 PE7      C14    C15       single      1.524    0.020
 PE7      H141   C14       single      1.092    0.020
 PE7      H142   C14       single      1.092    0.020
 PE7      C15    O16       single      1.426    0.020
 PE7      H151   C15       single      1.092    0.020
 PE7      H152   C15       single      1.092    0.020
 PE7      O16    C17       single      1.426    0.020
 PE7      C17    C18       single      1.524    0.020
 PE7      H171   C17       single      1.092    0.020
 PE7      H172   C17       single      1.092    0.020
 PE7      C18    O19       single      1.426    0.020
 PE7      H181   C18       single      1.092    0.020
 PE7      H182   C18       single      1.092    0.020
 PE7      O19    C20       single      1.426    0.020
 PE7      C20    C21       single      1.524    0.020
 PE7      H201   C20       single      1.092    0.020
 PE7      H202   C20       single      1.092    0.020
 PE7      C21    O22       single      1.432    0.020
 PE7      H211   C21       single      1.092    0.020
 PE7      H212   C21       single      1.092    0.020
 PE7      HO2    O22       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PE7      HO2    O22    C21     109.470    3.000
 PE7      O22    C21    H211    109.470    3.000
 PE7      O22    C21    H212    109.470    3.000
 PE7      O22    C21    C20     109.470    3.000
 PE7      H211   C21    H212    107.900    3.000
 PE7      H211   C21    C20     109.470    3.000
 PE7      H212   C21    C20     109.470    3.000
 PE7      C21    C20    H201    109.470    3.000
 PE7      C21    C20    H202    109.470    3.000
 PE7      C21    C20    O19     109.470    3.000
 PE7      H201   C20    H202    107.900    3.000
 PE7      H201   C20    O19     109.470    3.000
 PE7      H202   C20    O19     109.470    3.000
 PE7      C20    O19    C18     111.800    3.000
 PE7      O19    C18    H181    109.470    3.000
 PE7      O19    C18    H182    109.470    3.000
 PE7      O19    C18    C17     109.470    3.000
 PE7      H181   C18    H182    107.900    3.000
 PE7      H181   C18    C17     109.470    3.000
 PE7      H182   C18    C17     109.470    3.000
 PE7      C18    C17    H171    109.470    3.000
 PE7      C18    C17    H172    109.470    3.000
 PE7      C18    C17    O16     109.470    3.000
 PE7      H171   C17    H172    107.900    3.000
 PE7      H171   C17    O16     109.470    3.000
 PE7      H172   C17    O16     109.470    3.000
 PE7      C17    O16    C15     111.800    3.000
 PE7      O16    C15    H151    109.470    3.000
 PE7      O16    C15    H152    109.470    3.000
 PE7      O16    C15    C14     109.470    3.000
 PE7      H151   C15    H152    107.900    3.000
 PE7      H151   C15    C14     109.470    3.000
 PE7      H152   C15    C14     109.470    3.000
 PE7      C15    C14    H141    109.470    3.000
 PE7      C15    C14    H142    109.470    3.000
 PE7      C15    C14    O13     109.470    3.000
 PE7      H141   C14    H142    107.900    3.000
 PE7      H141   C14    O13     109.470    3.000
 PE7      H142   C14    O13     109.470    3.000
 PE7      C14    O13    C12     111.800    3.000
 PE7      O13    C12    H121    109.470    3.000
 PE7      O13    C12    H122    109.470    3.000
 PE7      O13    C12    C11     109.470    3.000
 PE7      H121   C12    H122    107.900    3.000
 PE7      H121   C12    C11     109.470    3.000
 PE7      H122   C12    C11     109.470    3.000
 PE7      C12    C11    H111    109.470    3.000
 PE7      C12    C11    H112    109.470    3.000
 PE7      C12    C11    O10     109.470    3.000
 PE7      H111   C11    H112    107.900    3.000
 PE7      H111   C11    O10     109.470    3.000
 PE7      H112   C11    O10     109.470    3.000
 PE7      C11    O10    C9      111.800    3.000
 PE7      O10    C9     H91     109.470    3.000
 PE7      O10    C9     H92     109.470    3.000
 PE7      O10    C9     C8      109.470    3.000
 PE7      H91    C9     H92     107.900    3.000
 PE7      H91    C9     C8      109.470    3.000
 PE7      H92    C9     C8      109.470    3.000
 PE7      C9     C8     H81     109.470    3.000
 PE7      C9     C8     H82     109.470    3.000
 PE7      C9     C8     O7      109.470    3.000
 PE7      H81    C8     H82     107.900    3.000
 PE7      H81    C8     O7      109.470    3.000
 PE7      H82    C8     O7      109.470    3.000
 PE7      C8     O7     C6      111.800    3.000
 PE7      O7     C6     H61     109.470    3.000
 PE7      O7     C6     H62     109.470    3.000
 PE7      O7     C6     C5      109.470    3.000
 PE7      H61    C6     H62     107.900    3.000
 PE7      H61    C6     C5      109.470    3.000
 PE7      H62    C6     C5      109.470    3.000
 PE7      C6     C5     H51     109.470    3.000
 PE7      C6     C5     H52     109.470    3.000
 PE7      C6     C5     O4      109.470    3.000
 PE7      H51    C5     H52     107.900    3.000
 PE7      H51    C5     O4      109.470    3.000
 PE7      H52    C5     O4      109.470    3.000
 PE7      C5     O4     C3      111.800    3.000
 PE7      O4     C3     H31     109.470    3.000
 PE7      O4     C3     H32     109.470    3.000
 PE7      O4     C3     C2      109.470    3.000
 PE7      H31    C3     H32     107.900    3.000
 PE7      H31    C3     C2      109.470    3.000
 PE7      H32    C3     C2      109.470    3.000
 PE7      C3     C2     H21     109.470    3.000
 PE7      C3     C2     H22     109.470    3.000
 PE7      C3     C2     S1      109.470    3.000
 PE7      H21    C2     H22     107.900    3.000
 PE7      H21    C2     S1      109.470    3.000
 PE7      H22    C2     S1      109.470    3.000
 PE7      C2     S1     HS       96.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PE7      var_1    HO2    O22    C21    C20     -179.929   20.000   1
 PE7      var_2    O22    C21    C20    O19       60.044   20.000   3
 PE7      var_3    C21    C20    O19    C18     -179.968   20.000   1
 PE7      var_4    C20    O19    C18    C17      179.993   20.000   1
 PE7      var_5    O19    C18    C17    O16       59.933   20.000   3
 PE7      var_6    C18    C17    O16    C15     -179.957   20.000   1
 PE7      var_7    C17    O16    C15    C14     -179.977   20.000   1
 PE7      var_8    O16    C15    C14    O13       60.023   20.000   3
 PE7      var_9    C15    C14    O13    C12     -179.962   20.000   1
 PE7      var_10   C14    O13    C12    C11     -179.994   20.000   1
 PE7      var_11   O13    C12    C11    O10       59.930   20.000   3
 PE7      var_12   C12    C11    O10    C9      -179.985   20.000   1
 PE7      var_13   C11    O10    C9     C8      -179.969   20.000   1
 PE7      var_14   O10    C9     C8     O7        60.060   20.000   3
 PE7      var_15   C9     C8     O7     C6      -179.985   20.000   1
 PE7      var_16   C8     O7     C6     C5       179.941   20.000   1
 PE7      var_17   O7     C6     C5     O4        59.999   20.000   3
 PE7      var_18   C6     C5     O4     C3       179.975   20.000   1
 PE7      var_19   C5     O4     C3     C2      -179.994   20.000   1
 PE7      var_20   O4     C3     C2     S1      -179.970   20.000   3
 PE7      var_21   C3     C2     S1     HS       179.994   20.000   1
# ------------------------------------------------------
`.trim();

monomers["PGE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PGE      PGE 'TRIETHYLENE GLYCOL                  ' non-polymer        24  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PGE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PGE           O4     O    OH1       0.000      0.000    0.000    0.000
 PGE           HO4    H    H         0.000      0.858   -0.019    0.445
 PGE           C6     C    CH2       0.000     -0.567    1.305    0.118
 PGE           H6     H    H         0.000      0.101    2.035   -0.345
 PGE           H62    H    H         0.000     -0.697    1.551    1.174
 PGE           C5     C    CH2       0.000     -1.924    1.337   -0.586
 PGE           H5     H    H         0.000     -1.792    1.093   -1.642
 PGE           H52    H    H         0.000     -2.357    2.336   -0.496
 PGE           O3     O    O2        0.000     -2.798    0.382    0.021
 PGE           C4     C    CH2       0.000     -4.042    0.460   -0.678
 PGE           H4     H    H         0.000     -3.882    0.226   -1.732
 PGE           H42    H    H         0.000     -4.447    1.470   -0.588
 PGE           C3     C    CH2       0.000     -5.028   -0.543   -0.076
 PGE           H3     H    H         0.000     -4.622   -1.552   -0.169
 PGE           H32    H    H         0.000     -5.979   -0.483   -0.610
 PGE           O2     O    O2        0.000     -5.235   -0.236    1.304
 PGE           C2     C    CH2       0.000     -6.160   -1.203    1.807
 PGE           H2     H    H         0.000     -5.740   -2.204    1.691
 PGE           H22    H    H         0.000     -7.096   -1.135    1.249
 PGE           C1     C    CH2       0.000     -6.428   -0.929    3.289
 PGE           H1     H    H         0.000     -5.491   -0.997    3.846
 PGE           H12    H    H         0.000     -7.133   -1.669    3.673
 PGE           O1     O    OH1       0.000     -6.979    0.380    3.439
 PGE           HO1    H    H         0.000     -7.148    0.552    4.375
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PGE      O4     n/a    C6     START
 PGE      HO4    O4     .      .
 PGE      C6     O4     C5     .
 PGE      H6     C6     .      .
 PGE      H62    C6     .      .
 PGE      C5     C6     O3     .
 PGE      H5     C5     .      .
 PGE      H52    C5     .      .
 PGE      O3     C5     C4     .
 PGE      C4     O3     C3     .
 PGE      H4     C4     .      .
 PGE      H42    C4     .      .
 PGE      C3     C4     O2     .
 PGE      H3     C3     .      .
 PGE      H32    C3     .      .
 PGE      O2     C3     C2     .
 PGE      C2     O2     C1     .
 PGE      H2     C2     .      .
 PGE      H22    C2     .      .
 PGE      C1     C2     O1     .
 PGE      H1     C1     .      .
 PGE      H12    C1     .      .
 PGE      O1     C1     HO1    .
 PGE      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PGE      O1     C1        single      1.432    0.020
 PGE      C1     C2        single      1.524    0.020
 PGE      H1     C1        single      1.092    0.020
 PGE      H12    C1        single      1.092    0.020
 PGE      HO1    O1        single      0.967    0.020
 PGE      C2     O2        single      1.426    0.020
 PGE      H2     C2        single      1.092    0.020
 PGE      H22    C2        single      1.092    0.020
 PGE      O2     C3        single      1.426    0.020
 PGE      C3     C4        single      1.524    0.020
 PGE      H3     C3        single      1.092    0.020
 PGE      H32    C3        single      1.092    0.020
 PGE      C4     O3        single      1.426    0.020
 PGE      H4     C4        single      1.092    0.020
 PGE      H42    C4        single      1.092    0.020
 PGE      C6     O4        single      1.432    0.020
 PGE      HO4    O4        single      0.967    0.020
 PGE      C5     C6        single      1.524    0.020
 PGE      H6     C6        single      1.092    0.020
 PGE      H62    C6        single      1.092    0.020
 PGE      O3     C5        single      1.426    0.020
 PGE      H5     C5        single      1.092    0.020
 PGE      H52    C5        single      1.092    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PGE      HO4    O4     C6      109.470    3.000
 PGE      O4     C6     H6      109.470    3.000
 PGE      O4     C6     H62     109.470    3.000
 PGE      O4     C6     C5      109.470    3.000
 PGE      H6     C6     H62     107.900    3.000
 PGE      H6     C6     C5      109.470    3.000
 PGE      H62    C6     C5      109.470    3.000
 PGE      C6     C5     H5      109.470    3.000
 PGE      C6     C5     H52     109.470    3.000
 PGE      C6     C5     O3      109.470    3.000
 PGE      H5     C5     H52     107.900    3.000
 PGE      H5     C5     O3      109.470    3.000
 PGE      H52    C5     O3      109.470    3.000
 PGE      C5     O3     C4      111.800    3.000
 PGE      O3     C4     H4      109.470    3.000
 PGE      O3     C4     H42     109.470    3.000
 PGE      O3     C4     C3      109.470    3.000
 PGE      H4     C4     H42     107.900    3.000
 PGE      H4     C4     C3      109.470    3.000
 PGE      H42    C4     C3      109.470    3.000
 PGE      C4     C3     H3      109.470    3.000
 PGE      C4     C3     H32     109.470    3.000
 PGE      C4     C3     O2      109.470    3.000
 PGE      H3     C3     H32     107.900    3.000
 PGE      H3     C3     O2      109.470    3.000
 PGE      H32    C3     O2      109.470    3.000
 PGE      C3     O2     C2      111.800    3.000
 PGE      O2     C2     H2      109.470    3.000
 PGE      O2     C2     H22     109.470    3.000
 PGE      O2     C2     C1      109.470    3.000
 PGE      H2     C2     H22     107.900    3.000
 PGE      H2     C2     C1      109.470    3.000
 PGE      H22    C2     C1      109.470    3.000
 PGE      C2     C1     H1      109.470    3.000
 PGE      C2     C1     H12     109.470    3.000
 PGE      C2     C1     O1      109.470    3.000
 PGE      H1     C1     H12     107.900    3.000
 PGE      H1     C1     O1      109.470    3.000
 PGE      H12    C1     O1      109.470    3.000
 PGE      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PGE      var_1    HO4    O4     C6     C5      -179.966   20.000   1
 PGE      var_2    O4     C6     C5     O3        60.004   20.000   3
 PGE      var_3    C6     C5     O3     C4      -179.957   20.000   1
 PGE      var_4    C5     O3     C4     C3      -179.996   20.000   1
 PGE      var_5    O3     C4     C3     O2        59.932   20.000   3
 PGE      var_6    C4     C3     O2     C2      -179.996   20.000   1
 PGE      var_7    C3     O2     C2     C1      -179.947   20.000   1
 PGE      var_8    O2     C2     C1     O1        60.033   20.000   3
 PGE      var_9    C2     C1     O1     HO1     -179.995   20.000   1
# ------------------------------------------------------
`.trim();

monomers["XPE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
XPE      XPE '3,6,9,12,15,18,21,24,27-NONAOXANONAC' non-polymer        73  31 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_XPE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 XPE           O31    O    OH1       0.000      0.000    0.000    0.000
 XPE           H31    H    H         0.000      0.600    0.712   -0.260
 XPE           C30    C    CH2       0.000     -0.868   -0.314   -1.091
 XPE           H301   H    H         0.000     -0.272   -0.633   -1.949
 XPE           H302   H    H         0.000     -1.447    0.572   -1.361
 XPE           C29    C    CH2       0.000     -1.817   -1.440   -0.681
 XPE           H291   H    H         0.000     -1.236   -2.325   -0.413
 XPE           H292   H    H         0.000     -2.479   -1.679   -1.516
 XPE           O28    O    O2        0.000     -2.595   -1.021    0.442
 XPE           C27    C    CH2       0.000     -3.458   -2.112    0.775
 XPE           H271   H    H         0.000     -2.856   -2.988    1.024
 XPE           H272   H    H         0.000     -4.099   -2.342   -0.078
 XPE           C26    C    CH2       0.000     -4.323   -1.728    1.977
 XPE           H261   H    H         0.000     -3.680   -1.498    2.830
 XPE           H262   H    H         0.000     -4.981   -2.561    2.233
 XPE           O25    O    O2        0.000     -5.110   -0.580    1.649
 XPE           C24    C    CH2       0.000     -5.893   -0.273    2.805
 XPE           H241   H    H         0.000     -5.230   -0.062    3.647
 XPE           H242   H    H         0.000     -6.530   -1.125    3.050
 XPE           C23    C    CH2       0.000     -6.764    0.952    2.521
 XPE           H231   H    H         0.000     -6.125    1.803    2.277
 XPE           H232   H    H         0.000     -7.361    1.187    3.404
 XPE           O22    O    O2        0.000     -7.631    0.674    1.418
 XPE           C21    C    CH2       0.000     -8.413    1.850    1.203
 XPE           H211   H    H         0.000     -7.753    2.690    0.976
 XPE           H212   H    H         0.000     -8.989    2.074    2.103
 XPE           C20    C    CH2       0.000     -9.368    1.619    0.030
 XPE           H201   H    H         0.000     -8.790    1.396   -0.870
 XPE           H202   H    H         0.000     -9.965    2.518   -0.135
 XPE           O19    O    O2        0.000    -10.231    0.520    0.329
 XPE           C18    C    CH2       0.000    -11.094    0.355   -0.799
 XPE           H181   H    H         0.000    -10.494    0.149   -1.688
 XPE           H182   H    H         0.000    -11.669    1.270   -0.953
 XPE           C17    C    CH2       0.000    -12.049   -0.812   -0.543
 XPE           H171   H    H         0.000    -11.472   -1.727   -0.390
 XPE           H172   H    H         0.000    -12.707   -0.938   -1.405
 XPE           O16    O    O2        0.000    -12.832   -0.540    0.621
 XPE           C15    C    CH2       0.000    -13.699   -1.662    0.805
 XPE           H151   H    H         0.000    -13.101   -2.565    0.941
 XPE           H152   H    H         0.000    -14.336   -1.777   -0.074
 XPE           C14    C    CH2       0.000    -14.570   -1.434    2.041
 XPE           H141   H    H         0.000    -13.932   -1.320    2.920
 XPE           H142   H    H         0.000    -15.232   -2.291    2.182
 XPE           O13    O    O2        0.000    -15.352   -0.251    1.861
 XPE           C12    C    CH2       0.000    -16.140   -0.094    3.043
 XPE           H121   H    H         0.000    -15.481    0.003    3.909
 XPE           H122   H    H         0.000    -16.781   -0.968    3.171
 XPE           C11    C    CH2       0.000    -17.005    1.161    2.916
 XPE           H111   H    H         0.000    -16.362    2.034    2.790
 XPE           H112   H    H         0.000    -17.606    1.280    3.820
 XPE           O10    O    O2        0.000    -17.866    1.033    1.783
 XPE           C9     C    CH2       0.000    -18.644    2.230    1.718
 XPE           H91    H    H         0.000    -17.980    3.089    1.606
 XPE           H92    H    H         0.000    -19.223    2.337    2.638
 XPE           C8     C    CH2       0.000    -19.593    2.158    0.521
 XPE           H81    H    H         0.000    -19.012    2.052   -0.398
 XPE           H82    H    H         0.000    -20.186    3.073    0.472
 XPE           O7     O    O2        0.000    -20.462    1.032    0.668
 XPE           C6     C    CH2       0.000    -21.319    1.019   -0.475
 XPE           H61    H    H         0.000    -20.715    0.927   -1.380
 XPE           H62    H    H         0.000    -21.890    1.949   -0.512
 XPE           C5     C    CH2       0.000    -22.278   -0.167   -0.379
 XPE           H51    H    H         0.000    -21.705   -1.096   -0.343
 XPE           H52    H    H         0.000    -22.932   -0.177   -1.253
 XPE           O4     O    O2        0.000    -23.068   -0.048    0.806
 XPE           C3     C    CH2       0.000    -23.940   -1.180    0.839
 XPE           H31A   H    H         0.000    -23.345   -2.095    0.859
 XPE           H32    H    H         0.000    -24.572   -1.177   -0.051
 XPE           C2     C    CH2       0.000    -24.817   -1.112    2.090
 XPE           H21    H    H         0.000    -24.183   -1.116    2.979
 XPE           H22    H    H         0.000    -25.482   -1.977    2.114
 XPE           O1     O    OH1       0.000    -25.594    0.087    2.062
 XPE           HO1    H    H         0.000    -26.148    0.130    2.853
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 XPE      O31    n/a    C30    START
 XPE      H31    O31    .      .
 XPE      C30    O31    C29    .
 XPE      H301   C30    .      .
 XPE      H302   C30    .      .
 XPE      C29    C30    O28    .
 XPE      H291   C29    .      .
 XPE      H292   C29    .      .
 XPE      O28    C29    C27    .
 XPE      C27    O28    C26    .
 XPE      H271   C27    .      .
 XPE      H272   C27    .      .
 XPE      C26    C27    O25    .
 XPE      H261   C26    .      .
 XPE      H262   C26    .      .
 XPE      O25    C26    C24    .
 XPE      C24    O25    C23    .
 XPE      H241   C24    .      .
 XPE      H242   C24    .      .
 XPE      C23    C24    O22    .
 XPE      H231   C23    .      .
 XPE      H232   C23    .      .
 XPE      O22    C23    C21    .
 XPE      C21    O22    C20    .
 XPE      H211   C21    .      .
 XPE      H212   C21    .      .
 XPE      C20    C21    O19    .
 XPE      H201   C20    .      .
 XPE      H202   C20    .      .
 XPE      O19    C20    C18    .
 XPE      C18    O19    C17    .
 XPE      H181   C18    .      .
 XPE      H182   C18    .      .
 XPE      C17    C18    O16    .
 XPE      H171   C17    .      .
 XPE      H172   C17    .      .
 XPE      O16    C17    C15    .
 XPE      C15    O16    C14    .
 XPE      H151   C15    .      .
 XPE      H152   C15    .      .
 XPE      C14    C15    O13    .
 XPE      H141   C14    .      .
 XPE      H142   C14    .      .
 XPE      O13    C14    C12    .
 XPE      C12    O13    C11    .
 XPE      H121   C12    .      .
 XPE      H122   C12    .      .
 XPE      C11    C12    O10    .
 XPE      H111   C11    .      .
 XPE      H112   C11    .      .
 XPE      O10    C11    C9     .
 XPE      C9     O10    C8     .
 XPE      H91    C9     .      .
 XPE      H92    C9     .      .
 XPE      C8     C9     O7     .
 XPE      H81    C8     .      .
 XPE      H82    C8     .      .
 XPE      O7     C8     C6     .
 XPE      C6     O7     C5     .
 XPE      H61    C6     .      .
 XPE      H62    C6     .      .
 XPE      C5     C6     O4     .
 XPE      H51    C5     .      .
 XPE      H52    C5     .      .
 XPE      O4     C5     C3     .
 XPE      C3     O4     C2     .
 XPE      H31A   C3     .      .
 XPE      H32    C3     .      .
 XPE      C2     C3     O1     .
 XPE      H21    C2     .      .
 XPE      H22    C2     .      .
 XPE      O1     C2     HO1    .
 XPE      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 XPE      O1     C2        single      1.432    0.020
 XPE      HO1    O1        single      0.967    0.020
 XPE      C2     C3        single      1.524    0.020
 XPE      H21    C2        single      1.092    0.020
 XPE      H22    C2        single      1.092    0.020
 XPE      C3     O4        single      1.426    0.020
 XPE      H31A   C3        single      1.092    0.020
 XPE      H32    C3        single      1.092    0.020
 XPE      O4     C5        single      1.426    0.020
 XPE      C5     C6        single      1.524    0.020
 XPE      H51    C5        single      1.092    0.020
 XPE      H52    C5        single      1.092    0.020
 XPE      C6     O7        single      1.426    0.020
 XPE      H61    C6        single      1.092    0.020
 XPE      H62    C6        single      1.092    0.020
 XPE      O7     C8        single      1.426    0.020
 XPE      C8     C9        single      1.524    0.020
 XPE      H81    C8        single      1.092    0.020
 XPE      H82    C8        single      1.092    0.020
 XPE      C9     O10       single      1.426    0.020
 XPE      H91    C9        single      1.092    0.020
 XPE      H92    C9        single      1.092    0.020
 XPE      O10    C11       single      1.426    0.020
 XPE      C11    C12       single      1.524    0.020
 XPE      H111   C11       single      1.092    0.020
 XPE      H112   C11       single      1.092    0.020
 XPE      C12    O13       single      1.426    0.020
 XPE      H121   C12       single      1.092    0.020
 XPE      H122   C12       single      1.092    0.020
 XPE      O13    C14       single      1.426    0.020
 XPE      C14    C15       single      1.524    0.020
 XPE      H141   C14       single      1.092    0.020
 XPE      H142   C14       single      1.092    0.020
 XPE      C15    O16       single      1.426    0.020
 XPE      H151   C15       single      1.092    0.020
 XPE      H152   C15       single      1.092    0.020
 XPE      O16    C17       single      1.426    0.020
 XPE      C17    C18       single      1.524    0.020
 XPE      H171   C17       single      1.092    0.020
 XPE      H172   C17       single      1.092    0.020
 XPE      C18    O19       single      1.426    0.020
 XPE      H181   C18       single      1.092    0.020
 XPE      H182   C18       single      1.092    0.020
 XPE      O19    C20       single      1.426    0.020
 XPE      C20    C21       single      1.524    0.020
 XPE      H201   C20       single      1.092    0.020
 XPE      H202   C20       single      1.092    0.020
 XPE      C21    O22       single      1.426    0.020
 XPE      H211   C21       single      1.092    0.020
 XPE      H212   C21       single      1.092    0.020
 XPE      O22    C23       single      1.426    0.020
 XPE      C23    C24       single      1.524    0.020
 XPE      H231   C23       single      1.092    0.020
 XPE      H232   C23       single      1.092    0.020
 XPE      C24    O25       single      1.426    0.020
 XPE      H241   C24       single      1.092    0.020
 XPE      H242   C24       single      1.092    0.020
 XPE      O25    C26       single      1.426    0.020
 XPE      C26    C27       single      1.524    0.020
 XPE      H261   C26       single      1.092    0.020
 XPE      H262   C26       single      1.092    0.020
 XPE      C27    O28       single      1.426    0.020
 XPE      H271   C27       single      1.092    0.020
 XPE      H272   C27       single      1.092    0.020
 XPE      O28    C29       single      1.426    0.020
 XPE      C29    C30       single      1.524    0.020
 XPE      H291   C29       single      1.092    0.020
 XPE      H292   C29       single      1.092    0.020
 XPE      C30    O31       single      1.432    0.020
 XPE      H301   C30       single      1.092    0.020
 XPE      H302   C30       single      1.092    0.020
 XPE      H31    O31       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 XPE      H31    O31    C30     109.470    3.000
 XPE      O31    C30    H301    109.470    3.000
 XPE      O31    C30    H302    109.470    3.000
 XPE      O31    C30    C29     109.470    3.000
 XPE      H301   C30    H302    107.900    3.000
 XPE      H301   C30    C29     109.470    3.000
 XPE      H302   C30    C29     109.470    3.000
 XPE      C30    C29    H291    109.470    3.000
 XPE      C30    C29    H292    109.470    3.000
 XPE      C30    C29    O28     109.470    3.000
 XPE      H291   C29    H292    107.900    3.000
 XPE      H291   C29    O28     109.470    3.000
 XPE      H292   C29    O28     109.470    3.000
 XPE      C29    O28    C27     111.800    3.000
 XPE      O28    C27    H271    109.470    3.000
 XPE      O28    C27    H272    109.470    3.000
 XPE      O28    C27    C26     109.470    3.000
 XPE      H271   C27    H272    107.900    3.000
 XPE      H271   C27    C26     109.470    3.000
 XPE      H272   C27    C26     109.470    3.000
 XPE      C27    C26    H261    109.470    3.000
 XPE      C27    C26    H262    109.470    3.000
 XPE      C27    C26    O25     109.470    3.000
 XPE      H261   C26    H262    107.900    3.000
 XPE      H261   C26    O25     109.470    3.000
 XPE      H262   C26    O25     109.470    3.000
 XPE      C26    O25    C24     111.800    3.000
 XPE      O25    C24    H241    109.470    3.000
 XPE      O25    C24    H242    109.470    3.000
 XPE      O25    C24    C23     109.470    3.000
 XPE      H241   C24    H242    107.900    3.000
 XPE      H241   C24    C23     109.470    3.000
 XPE      H242   C24    C23     109.470    3.000
 XPE      C24    C23    H231    109.470    3.000
 XPE      C24    C23    H232    109.470    3.000
 XPE      C24    C23    O22     109.470    3.000
 XPE      H231   C23    H232    107.900    3.000
 XPE      H231   C23    O22     109.470    3.000
 XPE      H232   C23    O22     109.470    3.000
 XPE      C23    O22    C21     111.800    3.000
 XPE      O22    C21    H211    109.470    3.000
 XPE      O22    C21    H212    109.470    3.000
 XPE      O22    C21    C20     109.470    3.000
 XPE      H211   C21    H212    107.900    3.000
 XPE      H211   C21    C20     109.470    3.000
 XPE      H212   C21    C20     109.470    3.000
 XPE      C21    C20    H201    109.470    3.000
 XPE      C21    C20    H202    109.470    3.000
 XPE      C21    C20    O19     109.470    3.000
 XPE      H201   C20    H202    107.900    3.000
 XPE      H201   C20    O19     109.470    3.000
 XPE      H202   C20    O19     109.470    3.000
 XPE      C20    O19    C18     111.800    3.000
 XPE      O19    C18    H181    109.470    3.000
 XPE      O19    C18    H182    109.470    3.000
 XPE      O19    C18    C17     109.470    3.000
 XPE      H181   C18    H182    107.900    3.000
 XPE      H181   C18    C17     109.470    3.000
 XPE      H182   C18    C17     109.470    3.000
 XPE      C18    C17    H171    109.470    3.000
 XPE      C18    C17    H172    109.470    3.000
 XPE      C18    C17    O16     109.470    3.000
 XPE      H171   C17    H172    107.900    3.000
 XPE      H171   C17    O16     109.470    3.000
 XPE      H172   C17    O16     109.470    3.000
 XPE      C17    O16    C15     111.800    3.000
 XPE      O16    C15    H151    109.470    3.000
 XPE      O16    C15    H152    109.470    3.000
 XPE      O16    C15    C14     109.470    3.000
 XPE      H151   C15    H152    107.900    3.000
 XPE      H151   C15    C14     109.470    3.000
 XPE      H152   C15    C14     109.470    3.000
 XPE      C15    C14    H141    109.470    3.000
 XPE      C15    C14    H142    109.470    3.000
 XPE      C15    C14    O13     109.470    3.000
 XPE      H141   C14    H142    107.900    3.000
 XPE      H141   C14    O13     109.470    3.000
 XPE      H142   C14    O13     109.470    3.000
 XPE      C14    O13    C12     111.800    3.000
 XPE      O13    C12    H121    109.470    3.000
 XPE      O13    C12    H122    109.470    3.000
 XPE      O13    C12    C11     109.470    3.000
 XPE      H121   C12    H122    107.900    3.000
 XPE      H121   C12    C11     109.470    3.000
 XPE      H122   C12    C11     109.470    3.000
 XPE      C12    C11    H111    109.470    3.000
 XPE      C12    C11    H112    109.470    3.000
 XPE      C12    C11    O10     109.470    3.000
 XPE      H111   C11    H112    107.900    3.000
 XPE      H111   C11    O10     109.470    3.000
 XPE      H112   C11    O10     109.470    3.000
 XPE      C11    O10    C9      111.800    3.000
 XPE      O10    C9     H91     109.470    3.000
 XPE      O10    C9     H92     109.470    3.000
 XPE      O10    C9     C8      109.470    3.000
 XPE      H91    C9     H92     107.900    3.000
 XPE      H91    C9     C8      109.470    3.000
 XPE      H92    C9     C8      109.470    3.000
 XPE      C9     C8     H81     109.470    3.000
 XPE      C9     C8     H82     109.470    3.000
 XPE      C9     C8     O7      109.470    3.000
 XPE      H81    C8     H82     107.900    3.000
 XPE      H81    C8     O7      109.470    3.000
 XPE      H82    C8     O7      109.470    3.000
 XPE      C8     O7     C6      111.800    3.000
 XPE      O7     C6     H61     109.470    3.000
 XPE      O7     C6     H62     109.470    3.000
 XPE      O7     C6     C5      109.470    3.000
 XPE      H61    C6     H62     107.900    3.000
 XPE      H61    C6     C5      109.470    3.000
 XPE      H62    C6     C5      109.470    3.000
 XPE      C6     C5     H51     109.470    3.000
 XPE      C6     C5     H52     109.470    3.000
 XPE      C6     C5     O4      109.470    3.000
 XPE      H51    C5     H52     107.900    3.000
 XPE      H51    C5     O4      109.470    3.000
 XPE      H52    C5     O4      109.470    3.000
 XPE      C5     O4     C3      111.800    3.000
 XPE      O4     C3     H31A    109.470    3.000
 XPE      O4     C3     H32     109.470    3.000
 XPE      O4     C3     C2      109.470    3.000
 XPE      H31A   C3     H32     107.900    3.000
 XPE      H31A   C3     C2      109.470    3.000
 XPE      H32    C3     C2      109.470    3.000
 XPE      C3     C2     H21     109.470    3.000
 XPE      C3     C2     H22     109.470    3.000
 XPE      C3     C2     O1      109.470    3.000
 XPE      H21    C2     H22     107.900    3.000
 XPE      H21    C2     O1      109.470    3.000
 XPE      H22    C2     O1      109.470    3.000
 XPE      C2     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 XPE      var_1    H31    O31    C30    C29      179.990   20.000   1
 XPE      var_2    O31    C30    C29    O28       59.962   20.000   3
 XPE      var_3    C30    C29    O28    C27     -179.991   20.000   1
 XPE      var_4    C29    O28    C27    C26      179.971   20.000   1
 XPE      var_5    O28    C27    C26    O25       60.025   20.000   3
 XPE      var_6    C27    C26    O25    C24      179.986   20.000   1
 XPE      var_7    C26    O25    C24    C23     -179.969   20.000   1
 XPE      var_8    O25    C24    C23    O22       59.980   20.000   3
 XPE      var_9    C24    C23    O22    C21     -179.963   20.000   1
 XPE      var_10   C23    O22    C21    C20     -179.985   20.000   1
 XPE      var_11   O22    C21    C20    O19       60.003   20.000   3
 XPE      var_12   C21    C20    O19    C18     -179.995   20.000   1
 XPE      var_13   C20    O19    C18    C17      179.984   20.000   1
 XPE      var_14   O19    C18    C17    O16       59.993   20.000   3
 XPE      var_15   C18    C17    O16    C15     -179.995   20.000   1
 XPE      var_16   C17    O16    C15    C14     -179.986   20.000   1
 XPE      var_17   O16    C15    C14    O13       59.973   20.000   3
 XPE      var_18   C15    C14    O13    C12      179.973   20.000   1
 XPE      var_19   C14    O13    C12    C11     -179.982   20.000   1
 XPE      var_20   O13    C12    C11    O10       60.003   20.000   3
 XPE      var_21   C12    C11    O10    C9      -179.979   20.000   1
 XPE      var_22   C11    O10    C9     C8      -179.959   20.000   1
 XPE      var_23   O10    C9     C8     O7        59.984   20.000   3
 XPE      var_24   C9     C8     O7     C6      -179.971   20.000   1
 XPE      var_25   C8     O7     C6     C5      -179.987   20.000   1
 XPE      var_26   O7     C6     C5     O4        59.995   20.000   3
 XPE      var_27   C6     C5     O4     C3      -179.985   20.000   1
 XPE      var_28   C5     O4     C3     C2      -179.989   20.000   1
 XPE      var_29   O4     C3     C2     O1        59.980   20.000   3
 XPE      var_30   C3     C2     O1     HO1     -179.977   20.000   1
# ------------------------------------------------------
`.trim();

monomers["C10"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
C10      C10 'HEXAETHYLENE GLYCOL MONODECYL ETHER ' non-polymer        75  29 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_C10
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 C10           O29    O    OH1       0.000      0.000    0.000    0.000
 C10           H29    H    H         0.000      0.541   -0.610   -0.519
 C10           C28    C    CH2       0.000     -0.525   -0.682    1.141
 C10           H281   H    H         0.000      0.300   -1.052    1.754
 C10           H282   H    H         0.000     -1.138   -1.523    0.811
 C10           C27    C    CH2       0.000     -1.381    0.284    1.963
 C10           H271   H    H         0.000     -0.767    1.125    2.292
 C10           H272   H    H         0.000     -1.780   -0.237    2.836
 C10           O26    O    O2        0.000     -2.459    0.765    1.159
 C10           C25    C    CH2       0.000     -3.218    1.657    1.978
 C10           H251   H    H         0.000     -2.580    2.479    2.307
 C10           H252   H    H         0.000     -3.594    1.118    2.850
 C10           C24    C    CH2       0.000     -4.395    2.212    1.174
 C10           H241   H    H         0.000     -4.018    2.752    0.303
 C10           H242   H    H         0.000     -4.974    2.894    1.801
 C10           O23    O    O2        0.000     -5.229    1.134    0.744
 C10           C22    C    CH2       0.000     -6.304    1.715    0.002
 C10           H221   H    H         0.000     -5.902    2.261   -0.854
 C10           H222   H    H         0.000     -6.858    2.402    0.644
 C10           C21    C    CH2       0.000     -7.239    0.608   -0.491
 C10           H211   H    H         0.000     -6.683   -0.079   -1.132
 C10           H212   H    H         0.000     -8.059    1.052   -1.059
 C10           O20    O    O2        0.000     -7.765   -0.105    0.631
 C10           C19    C    CH2       0.000     -8.626   -1.119    0.108
 C10           H191   H    H         0.000     -8.052   -1.783   -0.541
 C10           H192   H    H         0.000     -9.429   -0.653   -0.467
 C10           C18    C    CH2       0.000     -9.225   -1.924    1.264
 C10           H181   H    H         0.000     -8.421   -2.389    1.838
 C10           H182   H    H         0.000     -9.881   -2.700    0.864
 C10           O17    O    O2        0.000     -9.975   -1.053    2.112
 C10           C16    C    CH2       0.000    -10.505   -1.859    3.165
 C10           H161   H    H         0.000     -9.685   -2.326    3.714
 C10           H162   H    H         0.000    -11.146   -2.636    2.741
 C10           C15    C    CH2       0.000    -11.324   -0.983    4.115
 C10           H151   H    H         0.000    -10.682   -0.208    4.539
 C10           H152   H    H         0.000    -11.729   -1.600    4.920
 C10           O14    O    O2        0.000    -12.396   -0.374    3.395
 C10           C13    C    CH2       0.000    -13.119    0.427    4.332
 C10           H131   H    H         0.000    -12.454    1.184    4.753
 C10           H132   H    H         0.000    -13.500   -0.208    5.135
 C10           C12    C    CH2       0.000    -14.289    1.111    3.621
 C10           H121   H    H         0.000    -13.906    1.747    2.820
 C10           H122   H    H         0.000    -14.841    1.724    4.337
 C10           O11    O    O2        0.000    -15.158    0.120    3.071
 C10           C10    C    CH2       0.000    -16.224    0.819    2.425
 C10           H101   H    H         0.000    -15.816    1.458    1.640
 C10           H102   H    H         0.000    -16.750    1.435    3.157
 C10           C9     C    CH2       0.000    -17.197   -0.190    1.810
 C10           H9C1   H    H         0.000    -17.603   -0.829    2.597
 C10           H9C2   H    H         0.000    -16.668   -0.805    1.079
 C10           C8     C    CH2       0.000    -18.338    0.558    1.118
 C10           H8C1   H    H         0.000    -17.930    1.198    0.333
 C10           H8C2   H    H         0.000    -18.865    1.174    1.850
 C10           C7     C    CH2       0.000    -19.310   -0.450    0.503
 C10           H7C1   H    H         0.000    -19.716   -1.090    1.290
 C10           H7C2   H    H         0.000    -18.781   -1.066   -0.228
 C10           C6     C    CH2       0.000    -20.452    0.297   -0.187
 C10           H6C1   H    H         0.000    -20.044    0.937   -0.973
 C10           H6C2   H    H         0.000    -20.979    0.913    0.545
 C10           C5     C    CH2       0.000    -21.424   -0.711   -0.802
 C10           H5C1   H    H         0.000    -21.830   -1.350   -0.015
 C10           H5C2   H    H         0.000    -20.894   -1.327   -1.533
 C10           C4     C    CH2       0.000    -22.565    0.036   -1.494
 C10           H4C1   H    H         0.000    -22.157    0.675   -2.280
 C10           H4C2   H    H         0.000    -23.092    0.652   -0.762
 C10           C3     C    CH2       0.000    -23.537   -0.972   -2.108
 C10           H3C1   H    H         0.000    -23.943   -1.610   -1.320
 C10           H3C2   H    H         0.000    -23.008   -1.588   -2.838
 C10           C2     C    CH2       0.000    -24.679   -0.225   -2.801
 C10           H2C1   H    H         0.000    -24.270    0.414   -3.586
 C10           H2C2   H    H         0.000    -25.205    0.392   -2.069
 C10           C1     C    CH3       0.000    -25.652   -1.233   -3.415
 C10           H1C3   H    H         0.000    -25.143   -1.833   -4.125
 C10           H1C2   H    H         0.000    -26.050   -1.853   -2.653
 C10           H1C1   H    H         0.000    -26.443   -0.717   -3.895
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 C10      O29    n/a    C28    START
 C10      H29    O29    .      .
 C10      C28    O29    C27    .
 C10      H281   C28    .      .
 C10      H282   C28    .      .
 C10      C27    C28    O26    .
 C10      H271   C27    .      .
 C10      H272   C27    .      .
 C10      O26    C27    C25    .
 C10      C25    O26    C24    .
 C10      H251   C25    .      .
 C10      H252   C25    .      .
 C10      C24    C25    O23    .
 C10      H241   C24    .      .
 C10      H242   C24    .      .
 C10      O23    C24    C22    .
 C10      C22    O23    C21    .
 C10      H221   C22    .      .
 C10      H222   C22    .      .
 C10      C21    C22    O20    .
 C10      H211   C21    .      .
 C10      H212   C21    .      .
 C10      O20    C21    C19    .
 C10      C19    O20    C18    .
 C10      H191   C19    .      .
 C10      H192   C19    .      .
 C10      C18    C19    O17    .
 C10      H181   C18    .      .
 C10      H182   C18    .      .
 C10      O17    C18    C16    .
 C10      C16    O17    C15    .
 C10      H161   C16    .      .
 C10      H162   C16    .      .
 C10      C15    C16    O14    .
 C10      H151   C15    .      .
 C10      H152   C15    .      .
 C10      O14    C15    C13    .
 C10      C13    O14    C12    .
 C10      H131   C13    .      .
 C10      H132   C13    .      .
 C10      C12    C13    O11    .
 C10      H121   C12    .      .
 C10      H122   C12    .      .
 C10      O11    C12    C10    .
 C10      C10    O11    C9     .
 C10      H101   C10    .      .
 C10      H102   C10    .      .
 C10      C9     C10    C8     .
 C10      H9C1   C9     .      .
 C10      H9C2   C9     .      .
 C10      C8     C9     C7     .
 C10      H8C1   C8     .      .
 C10      H8C2   C8     .      .
 C10      C7     C8     C6     .
 C10      H7C1   C7     .      .
 C10      H7C2   C7     .      .
 C10      C6     C7     C5     .
 C10      H6C1   C6     .      .
 C10      H6C2   C6     .      .
 C10      C5     C6     C4     .
 C10      H5C1   C5     .      .
 C10      H5C2   C5     .      .
 C10      C4     C5     C3     .
 C10      H4C1   C4     .      .
 C10      H4C2   C4     .      .
 C10      C3     C4     C2     .
 C10      H3C1   C3     .      .
 C10      H3C2   C3     .      .
 C10      C2     C3     C1     .
 C10      H2C1   C2     .      .
 C10      H2C2   C2     .      .
 C10      C1     C2     H1C1   .
 C10      H1C3   C1     .      .
 C10      H1C2   C1     .      .
 C10      H1C1   C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 C10      C1     C2        single      1.513    0.020
 C10      H1C1   C1        single      1.059    0.020
 C10      H1C2   C1        single      1.059    0.020
 C10      H1C3   C1        single      1.059    0.020
 C10      C2     C3        single      1.524    0.020
 C10      H2C1   C2        single      1.092    0.020
 C10      H2C2   C2        single      1.092    0.020
 C10      C3     C4        single      1.524    0.020
 C10      H3C1   C3        single      1.092    0.020
 C10      H3C2   C3        single      1.092    0.020
 C10      C4     C5        single      1.524    0.020
 C10      H4C1   C4        single      1.092    0.020
 C10      H4C2   C4        single      1.092    0.020
 C10      C5     C6        single      1.524    0.020
 C10      H5C1   C5        single      1.092    0.020
 C10      H5C2   C5        single      1.092    0.020
 C10      C6     C7        single      1.524    0.020
 C10      H6C1   C6        single      1.092    0.020
 C10      H6C2   C6        single      1.092    0.020
 C10      C7     C8        single      1.524    0.020
 C10      H7C1   C7        single      1.092    0.020
 C10      H7C2   C7        single      1.092    0.020
 C10      C8     C9        single      1.524    0.020
 C10      H8C1   C8        single      1.092    0.020
 C10      H8C2   C8        single      1.092    0.020
 C10      C9     C10       single      1.524    0.020
 C10      H9C1   C9        single      1.092    0.020
 C10      H9C2   C9        single      1.092    0.020
 C10      C10    O11       single      1.426    0.020
 C10      H101   C10       single      1.092    0.020
 C10      H102   C10       single      1.092    0.020
 C10      O11    C12       single      1.426    0.020
 C10      C12    C13       single      1.524    0.020
 C10      H121   C12       single      1.092    0.020
 C10      H122   C12       single      1.092    0.020
 C10      C13    O14       single      1.426    0.020
 C10      H131   C13       single      1.092    0.020
 C10      H132   C13       single      1.092    0.020
 C10      O14    C15       single      1.426    0.020
 C10      C15    C16       single      1.524    0.020
 C10      H151   C15       single      1.092    0.020
 C10      H152   C15       single      1.092    0.020
 C10      C16    O17       single      1.426    0.020
 C10      H161   C16       single      1.092    0.020
 C10      H162   C16       single      1.092    0.020
 C10      O17    C18       single      1.426    0.020
 C10      C18    C19       single      1.524    0.020
 C10      H181   C18       single      1.092    0.020
 C10      H182   C18       single      1.092    0.020
 C10      C19    O20       single      1.426    0.020
 C10      H191   C19       single      1.092    0.020
 C10      H192   C19       single      1.092    0.020
 C10      O20    C21       single      1.426    0.020
 C10      C21    C22       single      1.524    0.020
 C10      H211   C21       single      1.092    0.020
 C10      H212   C21       single      1.092    0.020
 C10      C22    O23       single      1.426    0.020
 C10      H221   C22       single      1.092    0.020
 C10      H222   C22       single      1.092    0.020
 C10      O23    C24       single      1.426    0.020
 C10      C24    C25       single      1.524    0.020
 C10      H241   C24       single      1.092    0.020
 C10      H242   C24       single      1.092    0.020
 C10      C25    O26       single      1.426    0.020
 C10      H251   C25       single      1.092    0.020
 C10      H252   C25       single      1.092    0.020
 C10      O26    C27       single      1.426    0.020
 C10      C27    C28       single      1.524    0.020
 C10      H271   C27       single      1.092    0.020
 C10      H272   C27       single      1.092    0.020
 C10      C28    O29       single      1.432    0.020
 C10      H281   C28       single      1.092    0.020
 C10      H282   C28       single      1.092    0.020
 C10      H29    O29       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 C10      H29    O29    C28     109.470    3.000
 C10      O29    C28    H281    109.470    3.000
 C10      O29    C28    H282    109.470    3.000
 C10      O29    C28    C27     109.470    3.000
 C10      H281   C28    H282    107.900    3.000
 C10      H281   C28    C27     109.470    3.000
 C10      H282   C28    C27     109.470    3.000
 C10      C28    C27    H271    109.470    3.000
 C10      C28    C27    H272    109.470    3.000
 C10      C28    C27    O26     109.470    3.000
 C10      H271   C27    H272    107.900    3.000
 C10      H271   C27    O26     109.470    3.000
 C10      H272   C27    O26     109.470    3.000
 C10      C27    O26    C25     111.800    3.000
 C10      O26    C25    H251    109.470    3.000
 C10      O26    C25    H252    109.470    3.000
 C10      O26    C25    C24     109.470    3.000
 C10      H251   C25    H252    107.900    3.000
 C10      H251   C25    C24     109.470    3.000
 C10      H252   C25    C24     109.470    3.000
 C10      C25    C24    H241    109.470    3.000
 C10      C25    C24    H242    109.470    3.000
 C10      C25    C24    O23     109.470    3.000
 C10      H241   C24    H242    107.900    3.000
 C10      H241   C24    O23     109.470    3.000
 C10      H242   C24    O23     109.470    3.000
 C10      C24    O23    C22     111.800    3.000
 C10      O23    C22    H221    109.470    3.000
 C10      O23    C22    H222    109.470    3.000
 C10      O23    C22    C21     109.470    3.000
 C10      H221   C22    H222    107.900    3.000
 C10      H221   C22    C21     109.470    3.000
 C10      H222   C22    C21     109.470    3.000
 C10      C22    C21    H211    109.470    3.000
 C10      C22    C21    H212    109.470    3.000
 C10      C22    C21    O20     109.470    3.000
 C10      H211   C21    H212    107.900    3.000
 C10      H211   C21    O20     109.470    3.000
 C10      H212   C21    O20     109.470    3.000
 C10      C21    O20    C19     111.800    3.000
 C10      O20    C19    H191    109.470    3.000
 C10      O20    C19    H192    109.470    3.000
 C10      O20    C19    C18     109.470    3.000
 C10      H191   C19    H192    107.900    3.000
 C10      H191   C19    C18     109.470    3.000
 C10      H192   C19    C18     109.470    3.000
 C10      C19    C18    H181    109.470    3.000
 C10      C19    C18    H182    109.470    3.000
 C10      C19    C18    O17     109.470    3.000
 C10      H181   C18    H182    107.900    3.000
 C10      H181   C18    O17     109.470    3.000
 C10      H182   C18    O17     109.470    3.000
 C10      C18    O17    C16     111.800    3.000
 C10      O17    C16    H161    109.470    3.000
 C10      O17    C16    H162    109.470    3.000
 C10      O17    C16    C15     109.470    3.000
 C10      H161   C16    H162    107.900    3.000
 C10      H161   C16    C15     109.470    3.000
 C10      H162   C16    C15     109.470    3.000
 C10      C16    C15    H151    109.470    3.000
 C10      C16    C15    H152    109.470    3.000
 C10      C16    C15    O14     109.470    3.000
 C10      H151   C15    H152    107.900    3.000
 C10      H151   C15    O14     109.470    3.000
 C10      H152   C15    O14     109.470    3.000
 C10      C15    O14    C13     111.800    3.000
 C10      O14    C13    H131    109.470    3.000
 C10      O14    C13    H132    109.470    3.000
 C10      O14    C13    C12     109.470    3.000
 C10      H131   C13    H132    107.900    3.000
 C10      H131   C13    C12     109.470    3.000
 C10      H132   C13    C12     109.470    3.000
 C10      C13    C12    H121    109.470    3.000
 C10      C13    C12    H122    109.470    3.000
 C10      C13    C12    O11     109.470    3.000
 C10      H121   C12    H122    107.900    3.000
 C10      H121   C12    O11     109.470    3.000
 C10      H122   C12    O11     109.470    3.000
 C10      C12    O11    C10     111.800    3.000
 C10      O11    C10    H101    109.470    3.000
 C10      O11    C10    H102    109.470    3.000
 C10      O11    C10    C9      109.470    3.000
 C10      H101   C10    H102    107.900    3.000
 C10      H101   C10    C9      109.470    3.000
 C10      H102   C10    C9      109.470    3.000
 C10      C10    C9     H9C1    109.470    3.000
 C10      C10    C9     H9C2    109.470    3.000
 C10      C10    C9     C8      111.000    3.000
 C10      H9C1   C9     H9C2    107.900    3.000
 C10      H9C1   C9     C8      109.470    3.000
 C10      H9C2   C9     C8      109.470    3.000
 C10      C9     C8     H8C1    109.470    3.000
 C10      C9     C8     H8C2    109.470    3.000
 C10      C9     C8     C7      111.000    3.000
 C10      H8C1   C8     H8C2    107.900    3.000
 C10      H8C1   C8     C7      109.470    3.000
 C10      H8C2   C8     C7      109.470    3.000
 C10      C8     C7     H7C1    109.470    3.000
 C10      C8     C7     H7C2    109.470    3.000
 C10      C8     C7     C6      111.000    3.000
 C10      H7C1   C7     H7C2    107.900    3.000
 C10      H7C1   C7     C6      109.470    3.000
 C10      H7C2   C7     C6      109.470    3.000
 C10      C7     C6     H6C1    109.470    3.000
 C10      C7     C6     H6C2    109.470    3.000
 C10      C7     C6     C5      111.000    3.000
 C10      H6C1   C6     H6C2    107.900    3.000
 C10      H6C1   C6     C5      109.470    3.000
 C10      H6C2   C6     C5      109.470    3.000
 C10      C6     C5     H5C1    109.470    3.000
 C10      C6     C5     H5C2    109.470    3.000
 C10      C6     C5     C4      111.000    3.000
 C10      H5C1   C5     H5C2    107.900    3.000
 C10      H5C1   C5     C4      109.470    3.000
 C10      H5C2   C5     C4      109.470    3.000
 C10      C5     C4     H4C1    109.470    3.000
 C10      C5     C4     H4C2    109.470    3.000
 C10      C5     C4     C3      111.000    3.000
 C10      H4C1   C4     H4C2    107.900    3.000
 C10      H4C1   C4     C3      109.470    3.000
 C10      H4C2   C4     C3      109.470    3.000
 C10      C4     C3     H3C1    109.470    3.000
 C10      C4     C3     H3C2    109.470    3.000
 C10      C4     C3     C2      111.000    3.000
 C10      H3C1   C3     H3C2    107.900    3.000
 C10      H3C1   C3     C2      109.470    3.000
 C10      H3C2   C3     C2      109.470    3.000
 C10      C3     C2     H2C1    109.470    3.000
 C10      C3     C2     H2C2    109.470    3.000
 C10      C3     C2     C1      111.000    3.000
 C10      H2C1   C2     H2C2    107.900    3.000
 C10      H2C1   C2     C1      109.470    3.000
 C10      H2C2   C2     C1      109.470    3.000
 C10      C2     C1     H1C3    109.470    3.000
 C10      C2     C1     H1C2    109.470    3.000
 C10      C2     C1     H1C1    109.470    3.000
 C10      H1C3   C1     H1C2    109.470    3.000
 C10      H1C3   C1     H1C1    109.470    3.000
 C10      H1C2   C1     H1C1    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 C10      var_1    H29    O29    C28    C27      179.998   20.000   1
 C10      var_2    O29    C28    C27    O26       60.068   20.000   3
 C10      var_3    C28    C27    O26    C25      179.978   20.000   1
 C10      var_4    C27    O26    C25    C24      179.979   20.000   1
 C10      var_5    O26    C25    C24    O23       59.971   20.000   3
 C10      var_6    C25    C24    O23    C22     -179.983   20.000   1
 C10      var_7    C24    O23    C22    C21      179.987   20.000   1
 C10      var_8    O23    C22    C21    O20       60.060   20.000   3
 C10      var_9    C22    C21    O20    C19      179.995   20.000   1
 C10      var_10   C21    O20    C19    C18      179.955   20.000   1
 C10      var_11   O20    C19    C18    O17       60.032   20.000   3
 C10      var_12   C19    C18    O17    C16      179.997   20.000   1
 C10      var_13   C18    O17    C16    C15      179.974   20.000   1
 C10      var_14   O17    C16    C15    O14       59.971   20.000   3
 C10      var_15   C16    C15    O14    C13      179.994   20.000   1
 C10      var_16   C15    O14    C13    C12     -179.973   20.000   1
 C10      var_17   O14    C13    C12    O11       59.993   20.000   3
 C10      var_18   C13    C12    O11    C10      179.963   20.000   1
 C10      var_19   C12    O11    C10    C9       179.997   20.000   1
 C10      var_20   O11    C10    C9     C8      -179.991   20.000   3
 C10      var_21   C10    C9     C8     C7       179.983   20.000   3
 C10      var_22   C9     C8     C7     C6       179.964   20.000   3
 C10      var_23   C8     C7     C6     C5       180.000   20.000   3
 C10      var_24   C7     C6     C5     C4      -179.964   20.000   3
 C10      var_25   C6     C5     C4     C3      -179.964   20.000   3
 C10      var_26   C5     C4     C3     C2      -179.964   20.000   3
 C10      var_27   C4     C3     C2     C1      -179.983   20.000   3
 C10      var_28   C3     C2     C1     H1C1    -179.978   20.000   3
# ------------------------------------------------------
`.trim();

monomers["CE1"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CE1      CE1 'O-DODECANYL OCTAETHYLENE GLYCOL     ' non-polymer        95  37 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CE1
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CE1           O37    O    OH1       0.000      0.000    0.000    0.000
 CE1           H37    H    H         0.000      0.647    0.680    0.232
 CE1           C36    C    CH2       0.000     -0.965    0.549   -0.900
 CE1           H361   H    H         0.000     -0.462    0.899   -1.804
 CE1           H362   H    H         0.000     -1.474    1.387   -0.420
 CE1           C35    C    CH2       0.000     -1.988   -0.528   -1.268
 CE1           H351   H    H         0.000     -1.478   -1.365   -1.749
 CE1           H352   H    H         0.000     -2.725   -0.108   -1.957
 CE1           O34    O    O2        0.000     -2.646   -0.984   -0.085
 CE1           C33    C    CH2       0.000     -3.584   -1.982   -0.494
 CE1           H331   H    H         0.000     -3.053   -2.800   -0.985
 CE1           H332   H    H         0.000     -4.300   -1.543   -1.193
 CE1           C32    C    CH2       0.000     -4.326   -2.516    0.732
 CE1           H321   H    H         0.000     -3.609   -2.955    1.429
 CE1           H322   H    H         0.000     -5.042   -3.279    0.420
 CE1           O31    O    O2        0.000     -5.021   -1.444    1.373
 CE1           C30    C    CH2       0.000     -5.689   -2.005    2.504
 CE1           H301   H    H         0.000     -4.954   -2.450    3.178
 CE1           H302   H    H         0.000     -6.387   -2.775    2.169
 CE1           C29    C    CH2       0.000     -6.457   -0.903    3.239
 CE1           H291   H    H         0.000     -5.758   -0.135    3.575
 CE1           H292   H    H         0.000     -6.968   -1.332    4.104
 CE1           O28    O    O2        0.000     -7.418   -0.322    2.356
 CE1           C27    C    CH2       0.000     -8.098    0.694    3.098
 CE1           H271   H    H         0.000     -7.378    1.442    3.435
 CE1           H272   H    H         0.000     -8.588    0.245    3.964
 CE1           C26    C    CH2       0.000     -9.146    1.360    2.205
 CE1           H261   H    H         0.000     -8.654    1.808    1.339
 CE1           H262   H    H         0.000     -9.664    2.137    2.770
 CE1           O25    O    O2        0.000    -10.089    0.380    1.765
 CE1           C24    C    CH2       0.000    -11.037    1.061    0.941
 CE1           H241   H    H         0.000    -10.522    1.514    0.092
 CE1           H242   H    H         0.000    -11.531    1.841    1.524
 CE1           C23    C    CH2       0.000    -12.081    0.063    0.434
 CE1           H231   H    H         0.000    -11.585   -0.716   -0.149
 CE1           H232   H    H         0.000    -12.804    0.584   -0.198
 CE1           O22    O    O2        0.000    -12.755   -0.527    1.546
 CE1           C21    C    CH2       0.000    -13.710   -1.445    1.010
 CE1           H211   H    H         0.000    -13.193   -2.204    0.420
 CE1           H212   H    H         0.000    -14.413   -0.905    0.371
 CE1           C20    C    CH2       0.000    -14.471   -2.116    2.154
 CE1           H201   H    H         0.000    -13.767   -2.656    2.791
 CE1           H202   H    H         0.000    -15.200   -2.817    1.744
 CE1           O19    O    O2        0.000    -15.147   -1.120    2.926
 CE1           C18    C    CH2       0.000    -15.834   -1.807    3.974
 CE1           H181   H    H         0.000    -15.112   -2.351    4.586
 CE1           H182   H    H         0.000    -16.546   -2.512    3.540
 CE1           C17    C    CH2       0.000    -16.581   -0.794    4.842
 CE1           H171   H    H         0.000    -15.867   -0.090    5.276
 CE1           H172   H    H         0.000    -17.106   -1.318    5.643
 CE1           O16    O    O2        0.000    -17.525   -0.082    4.038
 CE1           C15    C    CH2       0.000    -18.188    0.844    4.902
 CE1           H151   H    H         0.000    -17.454    1.526    5.336
 CE1           H152   H    H         0.000    -18.692    0.297    5.702
 CE1           C14    C    CH2       0.000    -19.218    1.641    4.100
 CE1           H141   H    H         0.000    -18.712    2.187    3.301
 CE1           H142   H    H         0.000    -19.723    2.350    4.760
 CE1           O13    O    O2        0.000    -20.178    0.747    3.534
 CE1           C12    C    CH2       0.000    -21.107    1.548    2.801
 CE1           H121   H    H         0.000    -20.577    2.095    2.018
 CE1           H122   H    H         0.000    -21.588    2.258    3.477
 CE1           C11    C    CH2       0.000    -22.168    0.647    2.166
 CE1           H111   H    H         0.000    -22.696    0.100    2.950
 CE1           H112   H    H         0.000    -21.685   -0.063    1.491
 CE1           C10    C    CH2       0.000    -23.162    1.504    1.382
 CE1           H101   H    H         0.000    -22.632    2.052    0.600
 CE1           H102   H    H         0.000    -23.644    2.214    2.059
 CE1           C9     C    CH2       0.000    -24.223    0.603    0.747
 CE1           H91    H    H         0.000    -24.751    0.055    1.530
 CE1           H92    H    H         0.000    -23.740   -0.105    0.071
 CE1           C8     C    CH2       0.000    -25.218    1.461   -0.037
 CE1           H81    H    H         0.000    -24.688    2.009   -0.819
 CE1           H82    H    H         0.000    -25.699    2.170    0.641
 CE1           C7     C    CH2       0.000    -26.279    0.560   -0.672
 CE1           H71    H    H         0.000    -26.807    0.012    0.112
 CE1           H72    H    H         0.000    -25.795   -0.149   -1.347
 CE1           C6     C    CH2       0.000    -27.274    1.416   -1.456
 CE1           H61    H    H         0.000    -26.744    1.963   -2.239
 CE1           H62    H    H         0.000    -27.754    2.126   -0.780
 CE1           C5     C    CH2       0.000    -28.334    0.516   -2.091
 CE1           H51    H    H         0.000    -28.862   -0.030   -1.307
 CE1           H52    H    H         0.000    -27.851   -0.194   -2.765
 CE1           C4     C    CH2       0.000    -29.329    1.373   -2.876
 CE1           H41    H    H         0.000    -28.799    1.919   -3.659
 CE1           H42    H    H         0.000    -29.810    2.083   -2.200
 CE1           C3     C    CH2       0.000    -30.390    0.472   -3.511
 CE1           H31    H    H         0.000    -30.918   -0.075   -2.726
 CE1           H32    H    H         0.000    -29.907   -0.237   -4.186
 CE1           C2     C    CH2       0.000    -31.385    1.329   -4.295
 CE1           H21    H    H         0.000    -30.855    1.876   -5.077
 CE1           H22    H    H         0.000    -31.866    2.038   -3.618
 CE1           C1     C    CH3       0.000    -32.445    0.429   -4.930
 CE1           H13    H    H         0.000    -33.136    1.021   -5.475
 CE1           H12    H    H         0.000    -31.981   -0.261   -5.588
 CE1           H11    H    H         0.000    -32.962   -0.103   -4.173
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CE1      O37    n/a    C36    START
 CE1      H37    O37    .      .
 CE1      C36    O37    C35    .
 CE1      H361   C36    .      .
 CE1      H362   C36    .      .
 CE1      C35    C36    O34    .
 CE1      H351   C35    .      .
 CE1      H352   C35    .      .
 CE1      O34    C35    C33    .
 CE1      C33    O34    C32    .
 CE1      H331   C33    .      .
 CE1      H332   C33    .      .
 CE1      C32    C33    O31    .
 CE1      H321   C32    .      .
 CE1      H322   C32    .      .
 CE1      O31    C32    C30    .
 CE1      C30    O31    C29    .
 CE1      H301   C30    .      .
 CE1      H302   C30    .      .
 CE1      C29    C30    O28    .
 CE1      H291   C29    .      .
 CE1      H292   C29    .      .
 CE1      O28    C29    C27    .
 CE1      C27    O28    C26    .
 CE1      H271   C27    .      .
 CE1      H272   C27    .      .
 CE1      C26    C27    O25    .
 CE1      H261   C26    .      .
 CE1      H262   C26    .      .
 CE1      O25    C26    C24    .
 CE1      C24    O25    C23    .
 CE1      H241   C24    .      .
 CE1      H242   C24    .      .
 CE1      C23    C24    O22    .
 CE1      H231   C23    .      .
 CE1      H232   C23    .      .
 CE1      O22    C23    C21    .
 CE1      C21    O22    C20    .
 CE1      H211   C21    .      .
 CE1      H212   C21    .      .
 CE1      C20    C21    O19    .
 CE1      H201   C20    .      .
 CE1      H202   C20    .      .
 CE1      O19    C20    C18    .
 CE1      C18    O19    C17    .
 CE1      H181   C18    .      .
 CE1      H182   C18    .      .
 CE1      C17    C18    O16    .
 CE1      H171   C17    .      .
 CE1      H172   C17    .      .
 CE1      O16    C17    C15    .
 CE1      C15    O16    C14    .
 CE1      H151   C15    .      .
 CE1      H152   C15    .      .
 CE1      C14    C15    O13    .
 CE1      H141   C14    .      .
 CE1      H142   C14    .      .
 CE1      O13    C14    C12    .
 CE1      C12    O13    C11    .
 CE1      H121   C12    .      .
 CE1      H122   C12    .      .
 CE1      C11    C12    C10    .
 CE1      H111   C11    .      .
 CE1      H112   C11    .      .
 CE1      C10    C11    C9     .
 CE1      H101   C10    .      .
 CE1      H102   C10    .      .
 CE1      C9     C10    C8     .
 CE1      H91    C9     .      .
 CE1      H92    C9     .      .
 CE1      C8     C9     C7     .
 CE1      H81    C8     .      .
 CE1      H82    C8     .      .
 CE1      C7     C8     C6     .
 CE1      H71    C7     .      .
 CE1      H72    C7     .      .
 CE1      C6     C7     C5     .
 CE1      H61    C6     .      .
 CE1      H62    C6     .      .
 CE1      C5     C6     C4     .
 CE1      H51    C5     .      .
 CE1      H52    C5     .      .
 CE1      C4     C5     C3     .
 CE1      H41    C4     .      .
 CE1      H42    C4     .      .
 CE1      C3     C4     C2     .
 CE1      H31    C3     .      .
 CE1      H32    C3     .      .
 CE1      C2     C3     C1     .
 CE1      H21    C2     .      .
 CE1      H22    C2     .      .
 CE1      C1     C2     H11    .
 CE1      H13    C1     .      .
 CE1      H12    C1     .      .
 CE1      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CE1      C1     C2        single      1.513    0.020
 CE1      H11    C1        single      1.059    0.020
 CE1      H12    C1        single      1.059    0.020
 CE1      H13    C1        single      1.059    0.020
 CE1      C2     C3        single      1.524    0.020
 CE1      H21    C2        single      1.092    0.020
 CE1      H22    C2        single      1.092    0.020
 CE1      C3     C4        single      1.524    0.020
 CE1      H31    C3        single      1.092    0.020
 CE1      H32    C3        single      1.092    0.020
 CE1      C4     C5        single      1.524    0.020
 CE1      H41    C4        single      1.092    0.020
 CE1      H42    C4        single      1.092    0.020
 CE1      C5     C6        single      1.524    0.020
 CE1      H51    C5        single      1.092    0.020
 CE1      H52    C5        single      1.092    0.020
 CE1      C6     C7        single      1.524    0.020
 CE1      H61    C6        single      1.092    0.020
 CE1      H62    C6        single      1.092    0.020
 CE1      C7     C8        single      1.524    0.020
 CE1      H71    C7        single      1.092    0.020
 CE1      H72    C7        single      1.092    0.020
 CE1      C8     C9        single      1.524    0.020
 CE1      H81    C8        single      1.092    0.020
 CE1      H82    C8        single      1.092    0.020
 CE1      C9     C10       single      1.524    0.020
 CE1      H91    C9        single      1.092    0.020
 CE1      H92    C9        single      1.092    0.020
 CE1      C10    C11       single      1.524    0.020
 CE1      H101   C10       single      1.092    0.020
 CE1      H102   C10       single      1.092    0.020
 CE1      C11    C12       single      1.524    0.020
 CE1      H111   C11       single      1.092    0.020
 CE1      H112   C11       single      1.092    0.020
 CE1      C12    O13       single      1.426    0.020
 CE1      H121   C12       single      1.092    0.020
 CE1      H122   C12       single      1.092    0.020
 CE1      O13    C14       single      1.426    0.020
 CE1      C14    C15       single      1.524    0.020
 CE1      H141   C14       single      1.092    0.020
 CE1      H142   C14       single      1.092    0.020
 CE1      C15    O16       single      1.426    0.020
 CE1      H151   C15       single      1.092    0.020
 CE1      H152   C15       single      1.092    0.020
 CE1      O16    C17       single      1.426    0.020
 CE1      C17    C18       single      1.524    0.020
 CE1      H171   C17       single      1.092    0.020
 CE1      H172   C17       single      1.092    0.020
 CE1      C18    O19       single      1.426    0.020
 CE1      H181   C18       single      1.092    0.020
 CE1      H182   C18       single      1.092    0.020
 CE1      O19    C20       single      1.426    0.020
 CE1      C20    C21       single      1.524    0.020
 CE1      H201   C20       single      1.092    0.020
 CE1      H202   C20       single      1.092    0.020
 CE1      C21    O22       single      1.426    0.020
 CE1      H211   C21       single      1.092    0.020
 CE1      H212   C21       single      1.092    0.020
 CE1      O22    C23       single      1.426    0.020
 CE1      C23    C24       single      1.524    0.020
 CE1      H231   C23       single      1.092    0.020
 CE1      H232   C23       single      1.092    0.020
 CE1      C24    O25       single      1.426    0.020
 CE1      H241   C24       single      1.092    0.020
 CE1      H242   C24       single      1.092    0.020
 CE1      O25    C26       single      1.426    0.020
 CE1      C26    C27       single      1.524    0.020
 CE1      H261   C26       single      1.092    0.020
 CE1      H262   C26       single      1.092    0.020
 CE1      C27    O28       single      1.426    0.020
 CE1      H271   C27       single      1.092    0.020
 CE1      H272   C27       single      1.092    0.020
 CE1      O28    C29       single      1.426    0.020
 CE1      C29    C30       single      1.524    0.020
 CE1      H291   C29       single      1.092    0.020
 CE1      H292   C29       single      1.092    0.020
 CE1      C30    O31       single      1.426    0.020
 CE1      H301   C30       single      1.092    0.020
 CE1      H302   C30       single      1.092    0.020
 CE1      O31    C32       single      1.426    0.020
 CE1      C32    C33       single      1.524    0.020
 CE1      H321   C32       single      1.092    0.020
 CE1      H322   C32       single      1.092    0.020
 CE1      C33    O34       single      1.426    0.020
 CE1      H331   C33       single      1.092    0.020
 CE1      H332   C33       single      1.092    0.020
 CE1      O34    C35       single      1.426    0.020
 CE1      C35    C36       single      1.524    0.020
 CE1      H351   C35       single      1.092    0.020
 CE1      H352   C35       single      1.092    0.020
 CE1      C36    O37       single      1.432    0.020
 CE1      H361   C36       single      1.092    0.020
 CE1      H362   C36       single      1.092    0.020
 CE1      H37    O37       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CE1      H37    O37    C36     109.470    3.000
 CE1      O37    C36    H361    109.470    3.000
 CE1      O37    C36    H362    109.470    3.000
 CE1      O37    C36    C35     109.470    3.000
 CE1      H361   C36    H362    107.900    3.000
 CE1      H361   C36    C35     109.470    3.000
 CE1      H362   C36    C35     109.470    3.000
 CE1      C36    C35    H351    109.470    3.000
 CE1      C36    C35    H352    109.470    3.000
 CE1      C36    C35    O34     109.470    3.000
 CE1      H351   C35    H352    107.900    3.000
 CE1      H351   C35    O34     109.470    3.000
 CE1      H352   C35    O34     109.470    3.000
 CE1      C35    O34    C33     111.800    3.000
 CE1      O34    C33    H331    109.470    3.000
 CE1      O34    C33    H332    109.470    3.000
 CE1      O34    C33    C32     109.470    3.000
 CE1      H331   C33    H332    107.900    3.000
 CE1      H331   C33    C32     109.470    3.000
 CE1      H332   C33    C32     109.470    3.000
 CE1      C33    C32    H321    109.470    3.000
 CE1      C33    C32    H322    109.470    3.000
 CE1      C33    C32    O31     109.470    3.000
 CE1      H321   C32    H322    107.900    3.000
 CE1      H321   C32    O31     109.470    3.000
 CE1      H322   C32    O31     109.470    3.000
 CE1      C32    O31    C30     111.800    3.000
 CE1      O31    C30    H301    109.470    3.000
 CE1      O31    C30    H302    109.470    3.000
 CE1      O31    C30    C29     109.470    3.000
 CE1      H301   C30    H302    107.900    3.000
 CE1      H301   C30    C29     109.470    3.000
 CE1      H302   C30    C29     109.470    3.000
 CE1      C30    C29    H291    109.470    3.000
 CE1      C30    C29    H292    109.470    3.000
 CE1      C30    C29    O28     109.470    3.000
 CE1      H291   C29    H292    107.900    3.000
 CE1      H291   C29    O28     109.470    3.000
 CE1      H292   C29    O28     109.470    3.000
 CE1      C29    O28    C27     111.800    3.000
 CE1      O28    C27    H271    109.470    3.000
 CE1      O28    C27    H272    109.470    3.000
 CE1      O28    C27    C26     109.470    3.000
 CE1      H271   C27    H272    107.900    3.000
 CE1      H271   C27    C26     109.470    3.000
 CE1      H272   C27    C26     109.470    3.000
 CE1      C27    C26    H261    109.470    3.000
 CE1      C27    C26    H262    109.470    3.000
 CE1      C27    C26    O25     109.470    3.000
 CE1      H261   C26    H262    107.900    3.000
 CE1      H261   C26    O25     109.470    3.000
 CE1      H262   C26    O25     109.470    3.000
 CE1      C26    O25    C24     111.800    3.000
 CE1      O25    C24    H241    109.470    3.000
 CE1      O25    C24    H242    109.470    3.000
 CE1      O25    C24    C23     109.470    3.000
 CE1      H241   C24    H242    107.900    3.000
 CE1      H241   C24    C23     109.470    3.000
 CE1      H242   C24    C23     109.470    3.000
 CE1      C24    C23    H231    109.470    3.000
 CE1      C24    C23    H232    109.470    3.000
 CE1      C24    C23    O22     109.470    3.000
 CE1      H231   C23    H232    107.900    3.000
 CE1      H231   C23    O22     109.470    3.000
 CE1      H232   C23    O22     109.470    3.000
 CE1      C23    O22    C21     111.800    3.000
 CE1      O22    C21    H211    109.470    3.000
 CE1      O22    C21    H212    109.470    3.000
 CE1      O22    C21    C20     109.470    3.000
 CE1      H211   C21    H212    107.900    3.000
 CE1      H211   C21    C20     109.470    3.000
 CE1      H212   C21    C20     109.470    3.000
 CE1      C21    C20    H201    109.470    3.000
 CE1      C21    C20    H202    109.470    3.000
 CE1      C21    C20    O19     109.470    3.000
 CE1      H201   C20    H202    107.900    3.000
 CE1      H201   C20    O19     109.470    3.000
 CE1      H202   C20    O19     109.470    3.000
 CE1      C20    O19    C18     111.800    3.000
 CE1      O19    C18    H181    109.470    3.000
 CE1      O19    C18    H182    109.470    3.000
 CE1      O19    C18    C17     109.470    3.000
 CE1      H181   C18    H182    107.900    3.000
 CE1      H181   C18    C17     109.470    3.000
 CE1      H182   C18    C17     109.470    3.000
 CE1      C18    C17    H171    109.470    3.000
 CE1      C18    C17    H172    109.470    3.000
 CE1      C18    C17    O16     109.470    3.000
 CE1      H171   C17    H172    107.900    3.000
 CE1      H171   C17    O16     109.470    3.000
 CE1      H172   C17    O16     109.470    3.000
 CE1      C17    O16    C15     111.800    3.000
 CE1      O16    C15    H151    109.470    3.000
 CE1      O16    C15    H152    109.470    3.000
 CE1      O16    C15    C14     109.470    3.000
 CE1      H151   C15    H152    107.900    3.000
 CE1      H151   C15    C14     109.470    3.000
 CE1      H152   C15    C14     109.470    3.000
 CE1      C15    C14    H141    109.470    3.000
 CE1      C15    C14    H142    109.470    3.000
 CE1      C15    C14    O13     109.470    3.000
 CE1      H141   C14    H142    107.900    3.000
 CE1      H141   C14    O13     109.470    3.000
 CE1      H142   C14    O13     109.470    3.000
 CE1      C14    O13    C12     111.800    3.000
 CE1      O13    C12    H121    109.470    3.000
 CE1      O13    C12    H122    109.470    3.000
 CE1      O13    C12    C11     109.470    3.000
 CE1      H121   C12    H122    107.900    3.000
 CE1      H121   C12    C11     109.470    3.000
 CE1      H122   C12    C11     109.470    3.000
 CE1      C12    C11    H111    109.470    3.000
 CE1      C12    C11    H112    109.470    3.000
 CE1      C12    C11    C10     111.000    3.000
 CE1      H111   C11    H112    107.900    3.000
 CE1      H111   C11    C10     109.470    3.000
 CE1      H112   C11    C10     109.470    3.000
 CE1      C11    C10    H101    109.470    3.000
 CE1      C11    C10    H102    109.470    3.000
 CE1      C11    C10    C9      111.000    3.000
 CE1      H101   C10    H102    107.900    3.000
 CE1      H101   C10    C9      109.470    3.000
 CE1      H102   C10    C9      109.470    3.000
 CE1      C10    C9     H91     109.470    3.000
 CE1      C10    C9     H92     109.470    3.000
 CE1      C10    C9     C8      111.000    3.000
 CE1      H91    C9     H92     107.900    3.000
 CE1      H91    C9     C8      109.470    3.000
 CE1      H92    C9     C8      109.470    3.000
 CE1      C9     C8     H81     109.470    3.000
 CE1      C9     C8     H82     109.470    3.000
 CE1      C9     C8     C7      111.000    3.000
 CE1      H81    C8     H82     107.900    3.000
 CE1      H81    C8     C7      109.470    3.000
 CE1      H82    C8     C7      109.470    3.000
 CE1      C8     C7     H71     109.470    3.000
 CE1      C8     C7     H72     109.470    3.000
 CE1      C8     C7     C6      111.000    3.000
 CE1      H71    C7     H72     107.900    3.000
 CE1      H71    C7     C6      109.470    3.000
 CE1      H72    C7     C6      109.470    3.000
 CE1      C7     C6     H61     109.470    3.000
 CE1      C7     C6     H62     109.470    3.000
 CE1      C7     C6     C5      111.000    3.000
 CE1      H61    C6     H62     107.900    3.000
 CE1      H61    C6     C5      109.470    3.000
 CE1      H62    C6     C5      109.470    3.000
 CE1      C6     C5     H51     109.470    3.000
 CE1      C6     C5     H52     109.470    3.000
 CE1      C6     C5     C4      111.000    3.000
 CE1      H51    C5     H52     107.900    3.000
 CE1      H51    C5     C4      109.470    3.000
 CE1      H52    C5     C4      109.470    3.000
 CE1      C5     C4     H41     109.470    3.000
 CE1      C5     C4     H42     109.470    3.000
 CE1      C5     C4     C3      111.000    3.000
 CE1      H41    C4     H42     107.900    3.000
 CE1      H41    C4     C3      109.470    3.000
 CE1      H42    C4     C3      109.470    3.000
 CE1      C4     C3     H31     109.470    3.000
 CE1      C4     C3     H32     109.470    3.000
 CE1      C4     C3     C2      111.000    3.000
 CE1      H31    C3     H32     107.900    3.000
 CE1      H31    C3     C2      109.470    3.000
 CE1      H32    C3     C2      109.470    3.000
 CE1      C3     C2     H21     109.470    3.000
 CE1      C3     C2     H22     109.470    3.000
 CE1      C3     C2     C1      111.000    3.000
 CE1      H21    C2     H22     107.900    3.000
 CE1      H21    C2     C1      109.470    3.000
 CE1      H22    C2     C1      109.470    3.000
 CE1      C2     C1     H13     109.470    3.000
 CE1      C2     C1     H12     109.470    3.000
 CE1      C2     C1     H11     109.470    3.000
 CE1      H13    C1     H12     109.470    3.000
 CE1      H13    C1     H11     109.470    3.000
 CE1      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CE1      var_1    H37    O37    C36    C35      179.962   20.000   1
 CE1      var_2    O37    C36    C35    O34       60.016   20.000   3
 CE1      var_3    C36    C35    O34    C33      179.977   20.000   1
 CE1      var_4    C35    O34    C33    C32      179.972   20.000   1
 CE1      var_5    O34    C33    C32    O31       60.013   20.000   3
 CE1      var_6    C33    C32    O31    C30     -179.996   20.000   1
 CE1      var_7    C32    O31    C30    C29     -179.986   20.000   1
 CE1      var_8    O31    C30    C29    O28       59.970   20.000   3
 CE1      var_9    C30    C29    O28    C27     -179.993   20.000   1
 CE1      var_10   C29    O28    C27    C26     -179.997   20.000   1
 CE1      var_11   O28    C27    C26    O25       60.065   20.000   3
 CE1      var_12   C27    C26    O25    C24      179.951   20.000   1
 CE1      var_13   C26    O25    C24    C23      179.968   20.000   1
 CE1      var_14   O25    C24    C23    O22       60.058   20.000   3
 CE1      var_15   C24    C23    O22    C21     -179.961   20.000   1
 CE1      var_16   C23    O22    C21    C20      179.960   20.000   1
 CE1      var_17   O22    C21    C20    O19       59.966   20.000   3
 CE1      var_18   C21    C20    O19    C18     -179.971   20.000   1
 CE1      var_19   C20    O19    C18    C17      179.965   20.000   1
 CE1      var_20   O19    C18    C17    O16       59.978   20.000   3
 CE1      var_21   C18    C17    O16    C15      179.939   20.000   1
 CE1      var_22   C17    O16    C15    C14     -179.984   20.000   1
 CE1      var_23   O16    C15    C14    O13       60.057   20.000   3
 CE1      var_24   C15    C14    O13    C12     -179.986   20.000   1
 CE1      var_25   C14    O13    C12    C11     -179.994   20.000   1
 CE1      var_26   O13    C12    C11    C10      179.966   20.000   3
 CE1      var_27   C12    C11    C10    C9       179.965   20.000   3
 CE1      var_28   C11    C10    C9     C8       179.965   20.000   3
 CE1      var_29   C10    C9     C8     C7      -180.000   20.000   3
 CE1      var_30   C9     C8     C7     C6      -179.963   20.000   3
 CE1      var_31   C8     C7     C6     C5      -179.963   20.000   3
 CE1      var_32   C7     C6     C5     C4      -179.965   20.000   3
 CE1      var_33   C6     C5     C4     C3       180.000   20.000   3
 CE1      var_34   C5     C4     C3     C2       179.965   20.000   3
 CE1      var_35   C4     C3     C2     C1       179.965   20.000   3
 CE1      var_36   C3     C2     C1     H11       60.030   20.000   3
# ------------------------------------------------------
`.trim();

monomers["CE9"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CE9      CE9 'DODECYL NONA ETHYLENE GLYCOL ETHER  ' non-polymer       102  40 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CE9
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CE9           OXT    O    OH1       0.000      0.000    0.000    0.000
 CE9           HXT    H    H         0.000     -0.588   -0.766    0.041
 CE9           C39    C    CH2       0.000      1.348   -0.445   -0.103
 CE9           H391   H    H         0.000      1.971    0.104    0.606
 CE9           H392   H    H         0.000      1.715   -0.272   -1.117
 CE9           C38    C    CH2       0.000      1.405   -1.927    0.212
 CE9           H381   H    H         0.000      1.052   -2.099    1.231
 CE9           H382   H    H         0.000      2.433   -2.282    0.119
 CE9           O37    O    O2        0.000      0.575   -2.628   -0.704
 CE9           C36    C    CH2       0.000      0.591   -4.029   -0.454
 CE9           H361   H    H         0.000      0.245   -4.225    0.563
 CE9           H362   H    H         0.000      1.607   -4.411   -0.571
 CE9           C35    C    CH2       0.000     -0.329   -4.718   -1.444
 CE9           H351   H    H         0.000     -0.314   -5.796   -1.271
 CE9           H352   H    H         0.000      0.006   -4.510   -2.463
 CE9           O34    O    O2        0.000     -1.651   -4.227   -1.269
 CE9           C33    C    CH2       0.000     -2.559   -4.841   -2.174
 CE9           H331   H    H         0.000     -2.556   -5.922   -2.021
 CE9           H332   H    H         0.000     -2.259   -4.619   -3.201
 CE9           C32    C    CH2       0.000     -3.953   -4.296   -1.924
 CE9           H321   H    H         0.000     -4.656   -4.751   -2.624
 CE9           H322   H    H         0.000     -3.954   -3.213   -2.060
 CE9           O31    O    O2        0.000     -4.339   -4.608   -0.593
 CE9           C30    C    CH2       0.000     -5.642   -4.118   -0.301
 CE9           H301   H    H         0.000     -6.363   -4.557   -0.994
 CE9           H302   H    H         0.000     -5.658   -3.031   -0.403
 CE9           C29    C    CH2       0.000     -6.008   -4.500    1.121
 CE9           H291   H    H         0.000     -6.007   -5.588    1.221
 CE9           H292   H    H         0.000     -7.001   -4.115    1.361
 CE9           O28    O    O2        0.000     -5.053   -3.940    2.011
 CE9           C27    C    CH2       0.000     -5.347   -4.268    3.364
 CE9           H271   H    H         0.000     -5.355   -5.353    3.486
 CE9           H272   H    H         0.000     -6.325   -3.865    3.636
 CE9           C26    C    CH2       0.000     -4.283   -3.665    4.261
 CE9           H261   H    H         0.000     -4.507   -3.898    5.304
 CE9           H262   H    H         0.000     -4.262   -2.581    4.128
 CE9           O25    O    O2        0.000     -3.018   -4.211    3.913
 CE9           C24    C    CH2       0.000     -1.976   -3.662    4.710
 CE9           H241   H    H         0.000     -2.165   -3.879    5.763
 CE9           H242   H    H         0.000     -1.933   -2.580    4.565
 CE9           C23    C    CH2       0.000     -0.656   -4.281    4.294
 CE9           H231   H    H         0.000      0.154   -3.856    4.890
 CE9           H232   H    H         0.000     -0.473   -4.078    3.236
 CE9           O22    O    O2        0.000     -0.715   -5.684    4.505
 CE9           C21    C    CH2       0.000      0.493   -6.323    4.110
 CE9           H211   H    H         0.000      1.326   -5.923    4.692
 CE9           H212   H    H         0.000      0.673   -6.143    3.048
 CE9           C20    C    CH2       0.000      0.371   -7.813    4.358
 CE9           H201   H    H         0.000      1.289   -8.314    4.045
 CE9           H202   H    H         0.000     -0.472   -8.212    3.790
 CE9           O19    O    O2        0.000      0.157   -8.036    5.744
 CE9           C18    C    CH2       0.000      0.012   -9.421    6.033
 CE9           H181   H    H         0.000      0.916   -9.955    5.735
 CE9           H182   H    H         0.000     -0.844   -9.822    5.486
 CE9           C17    C    CH2       0.000     -0.212   -9.596    7.523
 CE9           H171   H    H         0.000     -0.339  -10.656    7.753
 CE9           H172   H    H         0.000     -1.108   -9.050    7.826
 CE9           O16    O    O2        0.000      0.915   -9.089    8.223
 CE9           C15    C    CH2       0.000      0.750   -9.207    9.631
 CE9           H151   H    H         0.000      0.624  -10.258    9.899
 CE9           H152   H    H         0.000     -0.131   -8.644    9.946
 CE9           C14    C    CH2       0.000      1.980   -8.651   10.322
 CE9           H141   H    H         0.000      2.860   -9.223   10.020
 CE9           H142   H    H         0.000      1.857   -8.721   11.405
 CE9           O13    O    O2        0.000      2.147   -7.290    9.950
 CE9           C12    C    CH2       0.000      3.276   -6.708   10.587
 CE9           H121   H    H         0.000      4.173   -7.261   10.302
 CE9           H122   H    H         0.000      3.145   -6.762   11.669
 CE9           C11    C    CH2       0.000      3.419   -5.252   10.162
 CE9           H111   H    H         0.000      4.275   -4.828   10.691
 CE9           H112   H    H         0.000      2.510   -4.723   10.459
 CE9           C10    C    CH2       0.000      3.626   -5.106    8.651
 CE9           H101   H    H         0.000      2.758   -5.525    8.138
 CE9           H102   H    H         0.000      4.521   -5.664    8.367
 CE9           C9     C    CH2       0.000      3.793   -3.636    8.256
 CE9           H91    H    H         0.000      4.667   -3.251    8.786
 CE9           H92    H    H         0.000      2.901   -3.103    8.591
 CE9           C8     C    CH2       0.000      3.977   -3.431    6.748
 CE9           H81    H    H         0.000      3.106   -3.861    6.250
 CE9           H82    H    H         0.000      4.873   -3.978    6.449
 CE9           C7     C    CH2       0.000      4.119   -1.960    6.351
 CE9           H71    H    H         0.000      4.989   -1.561    6.876
 CE9           H72    H    H         0.000      3.220   -1.440    6.691
 CE9           C6     C    CH2       0.000      4.290   -1.752    4.843
 CE9           H61    H    H         0.000      3.379   -2.137    4.378
 CE9           H62    H    H         0.000      5.138   -2.373    4.546
 CE9           C5     C    CH2       0.000      4.527   -0.308    4.387
 CE9           H51    H    H         0.000      5.455    0.033    4.852
 CE9           H52    H    H         0.000      3.694    0.292    4.757
 CE9           C4     C    CH2       0.000      4.631   -0.159    2.867
 CE9           H41    H    H         0.000      3.726   -0.588    2.433
 CE9           H42    H    H         0.000      5.499   -0.735    2.540
 CE9           C3     C    CH2       0.000      4.779    1.296    2.408
 CE9           H31    H    H         0.000      5.690    1.690    2.862
 CE9           H32    H    H         0.000      3.916    1.847    2.788
 CE9           C2     C    CH2       0.000      4.856    1.452    0.889
 CE9           H21    H    H         0.000      3.920    1.094    0.456
 CE9           H22    H    H         0.000      5.683    0.841    0.520
 CE9           C1     C    CH3       0.000      5.079    2.904    0.491
 CE9           H13    H    H         0.000      5.120    2.980   -0.565
 CE9           H12    H    H         0.000      4.281    3.498    0.856
 CE9           H11    H    H         0.000      5.991    3.249    0.905
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CE9      OXT    n/a    C39    START
 CE9      HXT    OXT    .      .
 CE9      C39    OXT    C38    .
 CE9      H391   C39    .      .
 CE9      H392   C39    .      .
 CE9      C38    C39    O37    .
 CE9      H381   C38    .      .
 CE9      H382   C38    .      .
 CE9      O37    C38    C36    .
 CE9      C36    O37    C35    .
 CE9      H361   C36    .      .
 CE9      H362   C36    .      .
 CE9      C35    C36    O34    .
 CE9      H351   C35    .      .
 CE9      H352   C35    .      .
 CE9      O34    C35    C33    .
 CE9      C33    O34    C32    .
 CE9      H331   C33    .      .
 CE9      H332   C33    .      .
 CE9      C32    C33    O31    .
 CE9      H321   C32    .      .
 CE9      H322   C32    .      .
 CE9      O31    C32    C30    .
 CE9      C30    O31    C29    .
 CE9      H301   C30    .      .
 CE9      H302   C30    .      .
 CE9      C29    C30    O28    .
 CE9      H291   C29    .      .
 CE9      H292   C29    .      .
 CE9      O28    C29    C27    .
 CE9      C27    O28    C26    .
 CE9      H271   C27    .      .
 CE9      H272   C27    .      .
 CE9      C26    C27    O25    .
 CE9      H261   C26    .      .
 CE9      H262   C26    .      .
 CE9      O25    C26    C24    .
 CE9      C24    O25    C23    .
 CE9      H241   C24    .      .
 CE9      H242   C24    .      .
 CE9      C23    C24    O22    .
 CE9      H231   C23    .      .
 CE9      H232   C23    .      .
 CE9      O22    C23    C21    .
 CE9      C21    O22    C20    .
 CE9      H211   C21    .      .
 CE9      H212   C21    .      .
 CE9      C20    C21    O19    .
 CE9      H201   C20    .      .
 CE9      H202   C20    .      .
 CE9      O19    C20    C18    .
 CE9      C18    O19    C17    .
 CE9      H181   C18    .      .
 CE9      H182   C18    .      .
 CE9      C17    C18    O16    .
 CE9      H171   C17    .      .
 CE9      H172   C17    .      .
 CE9      O16    C17    C15    .
 CE9      C15    O16    C14    .
 CE9      H151   C15    .      .
 CE9      H152   C15    .      .
 CE9      C14    C15    O13    .
 CE9      H141   C14    .      .
 CE9      H142   C14    .      .
 CE9      O13    C14    C12    .
 CE9      C12    O13    C11    .
 CE9      H121   C12    .      .
 CE9      H122   C12    .      .
 CE9      C11    C12    C10    .
 CE9      H111   C11    .      .
 CE9      H112   C11    .      .
 CE9      C10    C11    C9     .
 CE9      H101   C10    .      .
 CE9      H102   C10    .      .
 CE9      C9     C10    C8     .
 CE9      H91    C9     .      .
 CE9      H92    C9     .      .
 CE9      C8     C9     C7     .
 CE9      H81    C8     .      .
 CE9      H82    C8     .      .
 CE9      C7     C8     C6     .
 CE9      H71    C7     .      .
 CE9      H72    C7     .      .
 CE9      C6     C7     C5     .
 CE9      H61    C6     .      .
 CE9      H62    C6     .      .
 CE9      C5     C6     C4     .
 CE9      H51    C5     .      .
 CE9      H52    C5     .      .
 CE9      C4     C5     C3     .
 CE9      H41    C4     .      .
 CE9      H42    C4     .      .
 CE9      C3     C4     C2     .
 CE9      H31    C3     .      .
 CE9      H32    C3     .      .
 CE9      C2     C3     C1     .
 CE9      H21    C2     .      .
 CE9      H22    C2     .      .
 CE9      C1     C2     H11    .
 CE9      H13    C1     .      .
 CE9      H12    C1     .      .
 CE9      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CE9      C1     C2        single      1.513    0.020
 CE9      H11    C1        single      1.059    0.020
 CE9      H12    C1        single      1.059    0.020
 CE9      H13    C1        single      1.059    0.020
 CE9      C2     C3        single      1.524    0.020
 CE9      H21    C2        single      1.092    0.020
 CE9      H22    C2        single      1.092    0.020
 CE9      C3     C4        single      1.524    0.020
 CE9      H31    C3        single      1.092    0.020
 CE9      H32    C3        single      1.092    0.020
 CE9      C4     C5        single      1.524    0.020
 CE9      H41    C4        single      1.092    0.020
 CE9      H42    C4        single      1.092    0.020
 CE9      C5     C6        single      1.524    0.020
 CE9      H51    C5        single      1.092    0.020
 CE9      H52    C5        single      1.092    0.020
 CE9      C6     C7        single      1.524    0.020
 CE9      H61    C6        single      1.092    0.020
 CE9      H62    C6        single      1.092    0.020
 CE9      C7     C8        single      1.524    0.020
 CE9      H71    C7        single      1.092    0.020
 CE9      H72    C7        single      1.092    0.020
 CE9      C8     C9        single      1.524    0.020
 CE9      H81    C8        single      1.092    0.020
 CE9      H82    C8        single      1.092    0.020
 CE9      C9     C10       single      1.524    0.020
 CE9      H91    C9        single      1.092    0.020
 CE9      H92    C9        single      1.092    0.020
 CE9      C10    C11       single      1.524    0.020
 CE9      H101   C10       single      1.092    0.020
 CE9      H102   C10       single      1.092    0.020
 CE9      C11    C12       single      1.524    0.020
 CE9      H111   C11       single      1.092    0.020
 CE9      H112   C11       single      1.092    0.020
 CE9      C12    O13       single      1.426    0.020
 CE9      H121   C12       single      1.092    0.020
 CE9      H122   C12       single      1.092    0.020
 CE9      O13    C14       single      1.426    0.020
 CE9      C14    C15       single      1.524    0.020
 CE9      H141   C14       single      1.092    0.020
 CE9      H142   C14       single      1.092    0.020
 CE9      C15    O16       single      1.426    0.020
 CE9      H151   C15       single      1.092    0.020
 CE9      H152   C15       single      1.092    0.020
 CE9      O16    C17       single      1.426    0.020
 CE9      C17    C18       single      1.524    0.020
 CE9      H171   C17       single      1.092    0.020
 CE9      H172   C17       single      1.092    0.020
 CE9      C18    O19       single      1.426    0.020
 CE9      H181   C18       single      1.092    0.020
 CE9      H182   C18       single      1.092    0.020
 CE9      O19    C20       single      1.426    0.020
 CE9      C20    C21       single      1.524    0.020
 CE9      H201   C20       single      1.092    0.020
 CE9      H202   C20       single      1.092    0.020
 CE9      C21    O22       single      1.426    0.020
 CE9      H211   C21       single      1.092    0.020
 CE9      H212   C21       single      1.092    0.020
 CE9      O22    C23       single      1.426    0.020
 CE9      C23    C24       single      1.524    0.020
 CE9      H231   C23       single      1.092    0.020
 CE9      H232   C23       single      1.092    0.020
 CE9      C24    O25       single      1.426    0.020
 CE9      H241   C24       single      1.092    0.020
 CE9      H242   C24       single      1.092    0.020
 CE9      O25    C26       single      1.426    0.020
 CE9      C26    C27       single      1.524    0.020
 CE9      H261   C26       single      1.092    0.020
 CE9      H262   C26       single      1.092    0.020
 CE9      C27    O28       single      1.426    0.020
 CE9      H271   C27       single      1.092    0.020
 CE9      H272   C27       single      1.092    0.020
 CE9      O28    C29       single      1.426    0.020
 CE9      C29    C30       single      1.524    0.020
 CE9      H291   C29       single      1.092    0.020
 CE9      H292   C29       single      1.092    0.020
 CE9      C30    O31       single      1.426    0.020
 CE9      H301   C30       single      1.092    0.020
 CE9      H302   C30       single      1.092    0.020
 CE9      O31    C32       single      1.426    0.020
 CE9      C32    C33       single      1.524    0.020
 CE9      H321   C32       single      1.092    0.020
 CE9      H322   C32       single      1.092    0.020
 CE9      C33    O34       single      1.426    0.020
 CE9      H331   C33       single      1.092    0.020
 CE9      H332   C33       single      1.092    0.020
 CE9      O34    C35       single      1.426    0.020
 CE9      C35    C36       single      1.524    0.020
 CE9      H351   C35       single      1.092    0.020
 CE9      H352   C35       single      1.092    0.020
 CE9      C36    O37       single      1.426    0.020
 CE9      H361   C36       single      1.092    0.020
 CE9      H362   C36       single      1.092    0.020
 CE9      O37    C38       single      1.426    0.020
 CE9      C38    C39       single      1.524    0.020
 CE9      H381   C38       single      1.092    0.020
 CE9      H382   C38       single      1.092    0.020
 CE9      C39    OXT       single      1.432    0.020
 CE9      H391   C39       single      1.092    0.020
 CE9      H392   C39       single      1.092    0.020
 CE9      HXT    OXT       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CE9      HXT    OXT    C39     109.470    3.000
 CE9      OXT    C39    H391    109.470    3.000
 CE9      OXT    C39    H392    109.470    3.000
 CE9      OXT    C39    C38     109.470    3.000
 CE9      H391   C39    H392    107.900    3.000
 CE9      H391   C39    C38     109.470    3.000
 CE9      H392   C39    C38     109.470    3.000
 CE9      C39    C38    H381    109.470    3.000
 CE9      C39    C38    H382    109.470    3.000
 CE9      C39    C38    O37     109.470    3.000
 CE9      H381   C38    H382    107.900    3.000
 CE9      H381   C38    O37     109.470    3.000
 CE9      H382   C38    O37     109.470    3.000
 CE9      C38    O37    C36     111.800    3.000
 CE9      O37    C36    H361    109.470    3.000
 CE9      O37    C36    H362    109.470    3.000
 CE9      O37    C36    C35     109.470    3.000
 CE9      H361   C36    H362    107.900    3.000
 CE9      H361   C36    C35     109.470    3.000
 CE9      H362   C36    C35     109.470    3.000
 CE9      C36    C35    H351    109.470    3.000
 CE9      C36    C35    H352    109.470    3.000
 CE9      C36    C35    O34     109.470    3.000
 CE9      H351   C35    H352    107.900    3.000
 CE9      H351   C35    O34     109.470    3.000
 CE9      H352   C35    O34     109.470    3.000
 CE9      C35    O34    C33     111.800    3.000
 CE9      O34    C33    H331    109.470    3.000
 CE9      O34    C33    H332    109.470    3.000
 CE9      O34    C33    C32     109.470    3.000
 CE9      H331   C33    H332    107.900    3.000
 CE9      H331   C33    C32     109.470    3.000
 CE9      H332   C33    C32     109.470    3.000
 CE9      C33    C32    H321    109.470    3.000
 CE9      C33    C32    H322    109.470    3.000
 CE9      C33    C32    O31     109.470    3.000
 CE9      H321   C32    H322    107.900    3.000
 CE9      H321   C32    O31     109.470    3.000
 CE9      H322   C32    O31     109.470    3.000
 CE9      C32    O31    C30     111.800    3.000
 CE9      O31    C30    H301    109.470    3.000
 CE9      O31    C30    H302    109.470    3.000
 CE9      O31    C30    C29     109.470    3.000
 CE9      H301   C30    H302    107.900    3.000
 CE9      H301   C30    C29     109.470    3.000
 CE9      H302   C30    C29     109.470    3.000
 CE9      C30    C29    H291    109.470    3.000
 CE9      C30    C29    H292    109.470    3.000
 CE9      C30    C29    O28     109.470    3.000
 CE9      H291   C29    H292    107.900    3.000
 CE9      H291   C29    O28     109.470    3.000
 CE9      H292   C29    O28     109.470    3.000
 CE9      C29    O28    C27     111.800    3.000
 CE9      O28    C27    H271    109.470    3.000
 CE9      O28    C27    H272    109.470    3.000
 CE9      O28    C27    C26     109.470    3.000
 CE9      H271   C27    H272    107.900    3.000
 CE9      H271   C27    C26     109.470    3.000
 CE9      H272   C27    C26     109.470    3.000
 CE9      C27    C26    H261    109.470    3.000
 CE9      C27    C26    H262    109.470    3.000
 CE9      C27    C26    O25     109.470    3.000
 CE9      H261   C26    H262    107.900    3.000
 CE9      H261   C26    O25     109.470    3.000
 CE9      H262   C26    O25     109.470    3.000
 CE9      C26    O25    C24     111.800    3.000
 CE9      O25    C24    H241    109.470    3.000
 CE9      O25    C24    H242    109.470    3.000
 CE9      O25    C24    C23     109.470    3.000
 CE9      H241   C24    H242    107.900    3.000
 CE9      H241   C24    C23     109.470    3.000
 CE9      H242   C24    C23     109.470    3.000
 CE9      C24    C23    H231    109.470    3.000
 CE9      C24    C23    H232    109.470    3.000
 CE9      C24    C23    O22     109.470    3.000
 CE9      H231   C23    H232    107.900    3.000
 CE9      H231   C23    O22     109.470    3.000
 CE9      H232   C23    O22     109.470    3.000
 CE9      C23    O22    C21     111.800    3.000
 CE9      O22    C21    H211    109.470    3.000
 CE9      O22    C21    H212    109.470    3.000
 CE9      O22    C21    C20     109.470    3.000
 CE9      H211   C21    H212    107.900    3.000
 CE9      H211   C21    C20     109.470    3.000
 CE9      H212   C21    C20     109.470    3.000
 CE9      C21    C20    H201    109.470    3.000
 CE9      C21    C20    H202    109.470    3.000
 CE9      C21    C20    O19     109.470    3.000
 CE9      H201   C20    H202    107.900    3.000
 CE9      H201   C20    O19     109.470    3.000
 CE9      H202   C20    O19     109.470    3.000
 CE9      C20    O19    C18     111.800    3.000
 CE9      O19    C18    H181    109.470    3.000
 CE9      O19    C18    H182    109.470    3.000
 CE9      O19    C18    C17     109.470    3.000
 CE9      H181   C18    H182    107.900    3.000
 CE9      H181   C18    C17     109.470    3.000
 CE9      H182   C18    C17     109.470    3.000
 CE9      C18    C17    H171    109.470    3.000
 CE9      C18    C17    H172    109.470    3.000
 CE9      C18    C17    O16     109.470    3.000
 CE9      H171   C17    H172    107.900    3.000
 CE9      H171   C17    O16     109.470    3.000
 CE9      H172   C17    O16     109.470    3.000
 CE9      C17    O16    C15     111.800    3.000
 CE9      O16    C15    H151    109.470    3.000
 CE9      O16    C15    H152    109.470    3.000
 CE9      O16    C15    C14     109.470    3.000
 CE9      H151   C15    H152    107.900    3.000
 CE9      H151   C15    C14     109.470    3.000
 CE9      H152   C15    C14     109.470    3.000
 CE9      C15    C14    H141    109.470    3.000
 CE9      C15    C14    H142    109.470    3.000
 CE9      C15    C14    O13     109.470    3.000
 CE9      H141   C14    H142    107.900    3.000
 CE9      H141   C14    O13     109.470    3.000
 CE9      H142   C14    O13     109.470    3.000
 CE9      C14    O13    C12     111.800    3.000
 CE9      O13    C12    H121    109.470    3.000
 CE9      O13    C12    H122    109.470    3.000
 CE9      O13    C12    C11     109.470    3.000
 CE9      H121   C12    H122    107.900    3.000
 CE9      H121   C12    C11     109.470    3.000
 CE9      H122   C12    C11     109.470    3.000
 CE9      C12    C11    H111    109.470    3.000
 CE9      C12    C11    H112    109.470    3.000
 CE9      C12    C11    C10     111.000    3.000
 CE9      H111   C11    H112    107.900    3.000
 CE9      H111   C11    C10     109.470    3.000
 CE9      H112   C11    C10     109.470    3.000
 CE9      C11    C10    H101    109.470    3.000
 CE9      C11    C10    H102    109.470    3.000
 CE9      C11    C10    C9      111.000    3.000
 CE9      H101   C10    H102    107.900    3.000
 CE9      H101   C10    C9      109.470    3.000
 CE9      H102   C10    C9      109.470    3.000
 CE9      C10    C9     H91     109.470    3.000
 CE9      C10    C9     H92     109.470    3.000
 CE9      C10    C9     C8      111.000    3.000
 CE9      H91    C9     H92     107.900    3.000
 CE9      H91    C9     C8      109.470    3.000
 CE9      H92    C9     C8      109.470    3.000
 CE9      C9     C8     H81     109.470    3.000
 CE9      C9     C8     H82     109.470    3.000
 CE9      C9     C8     C7      111.000    3.000
 CE9      H81    C8     H82     107.900    3.000
 CE9      H81    C8     C7      109.470    3.000
 CE9      H82    C8     C7      109.470    3.000
 CE9      C8     C7     H71     109.470    3.000
 CE9      C8     C7     H72     109.470    3.000
 CE9      C8     C7     C6      111.000    3.000
 CE9      H71    C7     H72     107.900    3.000
 CE9      H71    C7     C6      109.470    3.000
 CE9      H72    C7     C6      109.470    3.000
 CE9      C7     C6     H61     109.470    3.000
 CE9      C7     C6     H62     109.470    3.000
 CE9      C7     C6     C5      111.000    3.000
 CE9      H61    C6     H62     107.900    3.000
 CE9      H61    C6     C5      109.470    3.000
 CE9      H62    C6     C5      109.470    3.000
 CE9      C6     C5     H51     109.470    3.000
 CE9      C6     C5     H52     109.470    3.000
 CE9      C6     C5     C4      111.000    3.000
 CE9      H51    C5     H52     107.900    3.000
 CE9      H51    C5     C4      109.470    3.000
 CE9      H52    C5     C4      109.470    3.000
 CE9      C5     C4     H41     109.470    3.000
 CE9      C5     C4     H42     109.470    3.000
 CE9      C5     C4     C3      111.000    3.000
 CE9      H41    C4     H42     107.900    3.000
 CE9      H41    C4     C3      109.470    3.000
 CE9      H42    C4     C3      109.470    3.000
 CE9      C4     C3     H31     109.470    3.000
 CE9      C4     C3     H32     109.470    3.000
 CE9      C4     C3     C2      111.000    3.000
 CE9      H31    C3     H32     107.900    3.000
 CE9      H31    C3     C2      109.470    3.000
 CE9      H32    C3     C2      109.470    3.000
 CE9      C3     C2     H21     109.470    3.000
 CE9      C3     C2     H22     109.470    3.000
 CE9      C3     C2     C1      111.000    3.000
 CE9      H21    C2     H22     107.900    3.000
 CE9      H21    C2     C1      109.470    3.000
 CE9      H22    C2     C1      109.470    3.000
 CE9      C2     C1     H13     109.470    3.000
 CE9      C2     C1     H12     109.470    3.000
 CE9      C2     C1     H11     109.470    3.000
 CE9      H13    C1     H12     109.470    3.000
 CE9      H13    C1     H11     109.470    3.000
 CE9      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CE9      var_1    HXT    OXT    C39    C38      -13.087   20.000   1
 CE9      var_2    OXT    C39    C38    O37       59.105   20.000   3
 CE9      var_3    C39    C38    O37    C36      179.983   20.000   1
 CE9      var_4    C38    O37    C36    C35      179.043   20.000   1
 CE9      var_5    O37    C36    C35    O34      -60.866   20.000   3
 CE9      var_6    C36    C35    O34    C33     -179.991   20.000   1
 CE9      var_7    C35    O34    C33    C32      179.020   20.000   1
 CE9      var_8    O34    C33    C32    O31      -60.869   20.000   3
 CE9      var_9    C33    C32    O31    C30      179.949   20.000   1
 CE9      var_10   C32    O31    C30    C29      179.044   20.000   1
 CE9      var_11   O31    C30    C29    O28       59.152   20.000   3
 CE9      var_12   C30    C29    O28    C27     -179.991   20.000   1
 CE9      var_13   C29    O28    C27    C26      179.023   20.000   1
 CE9      var_14   O28    C27    C26    O25      -60.884   20.000   3
 CE9      var_15   C27    C26    O25    C24      178.997   20.000   1
 CE9      var_16   C26    O25    C24    C23      179.988   20.000   1
 CE9      var_17   O25    C24    C23    O22      -60.853   20.000   3
 CE9      var_18   C24    C23    O22    C21      179.061   20.000   1
 CE9      var_19   C23    O22    C21    C20      180.000   20.000   1
 CE9      var_20   O22    C21    C20    O19      -60.860   20.000   3
 CE9      var_21   C21    C20    O19    C18      179.002   20.000   1
 CE9      var_22   C20    O19    C18    C17      179.987   20.000   1
 CE9      var_23   O19    C18    C17    O16      -60.832   20.000   3
 CE9      var_24   C18    C17    O16    C15      179.035   20.000   1
 CE9      var_25   C17    O16    C15    C14      179.984   20.000   1
 CE9      var_26   O16    C15    C14    O13       59.077   20.000   3
 CE9      var_27   C15    C14    O13    C12      179.017   20.000   1
 CE9      var_28   C14    O13    C12    C11     -179.997   20.000   1
 CE9      var_29   O13    C12    C11    C10      -60.810   20.000   3
 CE9      var_30   C12    C11    C10    C9      -178.916   20.000   3
 CE9      var_31   C11    C10    C9     C8      -178.860   20.000   3
 CE9      var_32   C10    C9     C8     C7       178.972   20.000   3
 CE9      var_33   C9     C8     C7     C6      -179.497   20.000   3
 CE9      var_34   C8     C7     C6     C5      -176.242   20.000   3
 CE9      var_35   C7     C6     C5     C4      -177.545   20.000   3
 CE9      var_36   C6     C5     C4     C3       176.341   20.000   3
 CE9      var_37   C5     C4     C3     C2      -178.900   20.000   3
 CE9      var_38   C4     C3     C2     C1      -176.882   20.000   3
 CE9      var_39   C3     C2     C1     H11       60.449   20.000   3
# ------------------------------------------------------
`.trim();

monomers["CXE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CXE      CXE 'PENTAETHYLENE GLYCOL MONODECYL ETHER' non-polymer        68  26 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CXE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CXE           O26    O    OH1       0.000      0.000    0.000    0.000
 CXE           H26    H    H         0.000      0.063   -0.918   -0.295
 CXE           C25    C    CH2       0.000      0.561    0.117    1.303
 CXE           H251   H    H         0.000      0.375    1.119    1.694
 CXE           H252   H    H         0.000      1.638   -0.059    1.256
 CXE           C24    C    CH2       0.000     -0.083   -0.912    2.213
 CXE           H241   H    H         0.000     -1.158   -0.728    2.272
 CXE           H242   H    H         0.000      0.352   -0.842    3.212
 CXE           O23    O    O2        0.000      0.150   -2.210    1.683
 CXE           C22    C    CH2       0.000     -0.435   -3.218    2.498
 CXE           H221   H    H         0.000     -1.511   -3.051    2.574
 CXE           H222   H    H         0.000      0.008   -3.186    3.496
 CXE           C21    C    CH2       0.000     -0.175   -4.574    1.872
 CXE           H211   H    H         0.000     -0.607   -5.357    2.498
 CXE           H212   H    H         0.000      0.901   -4.736    1.779
 CXE           O20    O    O2        0.000     -0.773   -4.611    0.584
 CXE           C19    C    CH2       0.000     -0.560   -5.865   -0.053
 CXE           H191   H    H         0.000     -0.981   -6.665    0.559
 CXE           H192   H    H         0.000      0.511   -6.034   -0.183
 CXE           C18    C    CH2       0.000     -1.240   -5.853   -1.409
 CXE           H181   H    H         0.000     -1.070   -6.807   -1.914
 CXE           H182   H    H         0.000     -0.832   -5.044   -2.018
 CXE           O17    O    O2        0.000     -2.635   -5.654   -1.227
 CXE           C16    C    CH2       0.000     -3.322   -5.611   -2.471
 CXE           H161   H    H         0.000     -3.177   -6.554   -3.002
 CXE           H162   H    H         0.000     -2.934   -4.790   -3.076
 CXE           C15    C    CH2       0.000     -4.801   -5.397   -2.212
 CXE           H151   H    H         0.000     -5.194   -6.225   -1.619
 CXE           H152   H    H         0.000     -5.336   -5.346   -3.163
 CXE           O14    O    O2        0.000     -4.976   -4.178   -1.502
 CXE           C13    C    CH2       0.000     -6.350   -3.914   -1.251
 CXE           H131   H    H         0.000     -6.776   -4.723   -0.654
 CXE           H132   H    H         0.000     -6.889   -3.839   -2.198
 CXE           C12    C    CH2       0.000     -6.472   -2.606   -0.493
 CXE           H121   H    H         0.000     -7.525   -2.386   -0.308
 CXE           H122   H    H         0.000     -6.031   -1.799   -1.082
 CXE           O11    O    O2        0.000     -5.785   -2.721    0.746
 CXE           C10    C    CH2       0.000     -5.846   -1.514    1.491
 CXE           H101   H    H         0.000     -6.891   -1.269    1.692
 CXE           H102   H    H         0.000     -5.389   -0.710    0.910
 CXE           C9     C    CH2       0.000     -5.098   -1.678    2.809
 CXE           H091   H    H         0.000     -4.066   -1.951    2.581
 CXE           H092   H    H         0.000     -5.573   -2.487    3.368
 CXE           C8     C    CH2       0.000     -5.116   -0.397    3.648
 CXE           H081   H    H         0.000     -6.155   -0.120    3.837
 CXE           H082   H    H         0.000     -4.626    0.397    3.079
 CXE           C7     C    CH2       0.000     -4.389   -0.595    4.980
 CXE           H071   H    H         0.000     -3.350   -0.862    4.773
 CXE           H072   H    H         0.000     -4.872   -1.412    5.521
 CXE           C6     C    CH2       0.000     -4.431    0.676    5.830
 CXE           H061   H    H         0.000     -5.481    0.910    6.016
 CXE           H062   H    H         0.000     -3.980    1.478    5.241
 CXE           C5     C    CH2       0.000     -3.692    0.543    7.164
 CXE           H051   H    H         0.000     -2.642    0.344    6.938
 CXE           H052   H    H         0.000     -4.118   -0.314    7.690
 CXE           C4     C    CH2       0.000     -3.798    1.789    8.046
 CXE           H041   H    H         0.000     -4.854    2.010    8.211
 CXE           H042   H    H         0.000     -3.330    2.626    7.523
 CXE           C3     C    CH2       0.000     -3.103    1.575    9.392
 CXE           H031   H    H         0.000     -2.046    1.373    9.209
 CXE           H032   H    H         0.000     -3.558    0.711    9.883
 CXE           C2     C    CH2       0.000     -3.241    2.804   10.291
 CXE           H021   H    H         0.000     -4.303    3.012   10.432
 CXE           H022   H    H         0.000     -2.769    3.652    9.789
 CXE           C1     C    CH3       0.000     -2.581    2.582   11.643
 CXE           H013   H    H         0.000     -2.699    3.448   12.242
 CXE           H012   H    H         0.000     -3.035    1.756   12.127
 CXE           H011   H    H         0.000     -1.549    2.386   11.507
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CXE      O26    n/a    C25    START
 CXE      H26    O26    .      .
 CXE      C25    O26    C24    .
 CXE      H251   C25    .      .
 CXE      H252   C25    .      .
 CXE      C24    C25    O23    .
 CXE      H241   C24    .      .
 CXE      H242   C24    .      .
 CXE      O23    C24    C22    .
 CXE      C22    O23    C21    .
 CXE      H221   C22    .      .
 CXE      H222   C22    .      .
 CXE      C21    C22    O20    .
 CXE      H211   C21    .      .
 CXE      H212   C21    .      .
 CXE      O20    C21    C19    .
 CXE      C19    O20    C18    .
 CXE      H191   C19    .      .
 CXE      H192   C19    .      .
 CXE      C18    C19    O17    .
 CXE      H181   C18    .      .
 CXE      H182   C18    .      .
 CXE      O17    C18    C16    .
 CXE      C16    O17    C15    .
 CXE      H161   C16    .      .
 CXE      H162   C16    .      .
 CXE      C15    C16    O14    .
 CXE      H151   C15    .      .
 CXE      H152   C15    .      .
 CXE      O14    C15    C13    .
 CXE      C13    O14    C12    .
 CXE      H131   C13    .      .
 CXE      H132   C13    .      .
 CXE      C12    C13    O11    .
 CXE      H121   C12    .      .
 CXE      H122   C12    .      .
 CXE      O11    C12    C10    .
 CXE      C10    O11    C9     .
 CXE      H101   C10    .      .
 CXE      H102   C10    .      .
 CXE      C9     C10    C8     .
 CXE      H091   C9     .      .
 CXE      H092   C9     .      .
 CXE      C8     C9     C7     .
 CXE      H081   C8     .      .
 CXE      H082   C8     .      .
 CXE      C7     C8     C6     .
 CXE      H071   C7     .      .
 CXE      H072   C7     .      .
 CXE      C6     C7     C5     .
 CXE      H061   C6     .      .
 CXE      H062   C6     .      .
 CXE      C5     C6     C4     .
 CXE      H051   C5     .      .
 CXE      H052   C5     .      .
 CXE      C4     C5     C3     .
 CXE      H041   C4     .      .
 CXE      H042   C4     .      .
 CXE      C3     C4     C2     .
 CXE      H031   C3     .      .
 CXE      H032   C3     .      .
 CXE      C2     C3     C1     .
 CXE      H021   C2     .      .
 CXE      H022   C2     .      .
 CXE      C1     C2     H011   .
 CXE      H013   C1     .      .
 CXE      H012   C1     .      .
 CXE      H011   C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CXE      C1     C2        single      1.513    0.020
 CXE      H011   C1        single      1.059    0.020
 CXE      H012   C1        single      1.059    0.020
 CXE      H013   C1        single      1.059    0.020
 CXE      C2     C3        single      1.524    0.020
 CXE      H021   C2        single      1.092    0.020
 CXE      H022   C2        single      1.092    0.020
 CXE      C3     C4        single      1.524    0.020
 CXE      H031   C3        single      1.092    0.020
 CXE      H032   C3        single      1.092    0.020
 CXE      C4     C5        single      1.524    0.020
 CXE      H041   C4        single      1.092    0.020
 CXE      H042   C4        single      1.092    0.020
 CXE      C5     C6        single      1.524    0.020
 CXE      H051   C5        single      1.092    0.020
 CXE      H052   C5        single      1.092    0.020
 CXE      C6     C7        single      1.524    0.020
 CXE      H061   C6        single      1.092    0.020
 CXE      H062   C6        single      1.092    0.020
 CXE      C7     C8        single      1.524    0.020
 CXE      H071   C7        single      1.092    0.020
 CXE      H072   C7        single      1.092    0.020
 CXE      C8     C9        single      1.524    0.020
 CXE      H081   C8        single      1.092    0.020
 CXE      H082   C8        single      1.092    0.020
 CXE      C9     C10       single      1.524    0.020
 CXE      H091   C9        single      1.092    0.020
 CXE      H092   C9        single      1.092    0.020
 CXE      C10    O11       single      1.426    0.020
 CXE      H101   C10       single      1.092    0.020
 CXE      H102   C10       single      1.092    0.020
 CXE      O11    C12       single      1.426    0.020
 CXE      C12    C13       single      1.524    0.020
 CXE      H121   C12       single      1.092    0.020
 CXE      H122   C12       single      1.092    0.020
 CXE      C13    O14       single      1.426    0.020
 CXE      H131   C13       single      1.092    0.020
 CXE      H132   C13       single      1.092    0.020
 CXE      O14    C15       single      1.426    0.020
 CXE      C15    C16       single      1.524    0.020
 CXE      H151   C15       single      1.092    0.020
 CXE      H152   C15       single      1.092    0.020
 CXE      C16    O17       single      1.426    0.020
 CXE      H161   C16       single      1.092    0.020
 CXE      H162   C16       single      1.092    0.020
 CXE      O17    C18       single      1.426    0.020
 CXE      C18    C19       single      1.524    0.020
 CXE      H181   C18       single      1.092    0.020
 CXE      H182   C18       single      1.092    0.020
 CXE      C19    O20       single      1.426    0.020
 CXE      H191   C19       single      1.092    0.020
 CXE      H192   C19       single      1.092    0.020
 CXE      O20    C21       single      1.426    0.020
 CXE      C21    C22       single      1.524    0.020
 CXE      H211   C21       single      1.092    0.020
 CXE      H212   C21       single      1.092    0.020
 CXE      C22    O23       single      1.426    0.020
 CXE      H221   C22       single      1.092    0.020
 CXE      H222   C22       single      1.092    0.020
 CXE      O23    C24       single      1.426    0.020
 CXE      C24    C25       single      1.524    0.020
 CXE      H241   C24       single      1.092    0.020
 CXE      H242   C24       single      1.092    0.020
 CXE      C25    O26       single      1.432    0.020
 CXE      H251   C25       single      1.092    0.020
 CXE      H252   C25       single      1.092    0.020
 CXE      H26    O26       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CXE      H26    O26    C25     109.470    3.000
 CXE      O26    C25    H251    109.470    3.000
 CXE      O26    C25    H252    109.470    3.000
 CXE      O26    C25    C24     109.470    3.000
 CXE      H251   C25    H252    107.900    3.000
 CXE      H251   C25    C24     109.470    3.000
 CXE      H252   C25    C24     109.470    3.000
 CXE      C25    C24    H241    109.470    3.000
 CXE      C25    C24    H242    109.470    3.000
 CXE      C25    C24    O23     109.470    3.000
 CXE      H241   C24    H242    107.900    3.000
 CXE      H241   C24    O23     109.470    3.000
 CXE      H242   C24    O23     109.470    3.000
 CXE      C24    O23    C22     111.800    3.000
 CXE      O23    C22    H221    109.470    3.000
 CXE      O23    C22    H222    109.470    3.000
 CXE      O23    C22    C21     109.470    3.000
 CXE      H221   C22    H222    107.900    3.000
 CXE      H221   C22    C21     109.470    3.000
 CXE      H222   C22    C21     109.470    3.000
 CXE      C22    C21    H211    109.470    3.000
 CXE      C22    C21    H212    109.470    3.000
 CXE      C22    C21    O20     109.470    3.000
 CXE      H211   C21    H212    107.900    3.000
 CXE      H211   C21    O20     109.470    3.000
 CXE      H212   C21    O20     109.470    3.000
 CXE      C21    O20    C19     111.800    3.000
 CXE      O20    C19    H191    109.470    3.000
 CXE      O20    C19    H192    109.470    3.000
 CXE      O20    C19    C18     109.470    3.000
 CXE      H191   C19    H192    107.900    3.000
 CXE      H191   C19    C18     109.470    3.000
 CXE      H192   C19    C18     109.470    3.000
 CXE      C19    C18    H181    109.470    3.000
 CXE      C19    C18    H182    109.470    3.000
 CXE      C19    C18    O17     109.470    3.000
 CXE      H181   C18    H182    107.900    3.000
 CXE      H181   C18    O17     109.470    3.000
 CXE      H182   C18    O17     109.470    3.000
 CXE      C18    O17    C16     111.800    3.000
 CXE      O17    C16    H161    109.470    3.000
 CXE      O17    C16    H162    109.470    3.000
 CXE      O17    C16    C15     109.470    3.000
 CXE      H161   C16    H162    107.900    3.000
 CXE      H161   C16    C15     109.470    3.000
 CXE      H162   C16    C15     109.470    3.000
 CXE      C16    C15    H151    109.470    3.000
 CXE      C16    C15    H152    109.470    3.000
 CXE      C16    C15    O14     109.470    3.000
 CXE      H151   C15    H152    107.900    3.000
 CXE      H151   C15    O14     109.470    3.000
 CXE      H152   C15    O14     109.470    3.000
 CXE      C15    O14    C13     111.800    3.000
 CXE      O14    C13    H131    109.470    3.000
 CXE      O14    C13    H132    109.470    3.000
 CXE      O14    C13    C12     109.470    3.000
 CXE      H131   C13    H132    107.900    3.000
 CXE      H131   C13    C12     109.470    3.000
 CXE      H132   C13    C12     109.470    3.000
 CXE      C13    C12    H121    109.470    3.000
 CXE      C13    C12    H122    109.470    3.000
 CXE      C13    C12    O11     109.470    3.000
 CXE      H121   C12    H122    107.900    3.000
 CXE      H121   C12    O11     109.470    3.000
 CXE      H122   C12    O11     109.470    3.000
 CXE      C12    O11    C10     111.800    3.000
 CXE      O11    C10    H101    109.470    3.000
 CXE      O11    C10    H102    109.470    3.000
 CXE      O11    C10    C9      109.470    3.000
 CXE      H101   C10    H102    107.900    3.000
 CXE      H101   C10    C9      109.470    3.000
 CXE      H102   C10    C9      109.470    3.000
 CXE      C10    C9     H091    109.470    3.000
 CXE      C10    C9     H092    109.470    3.000
 CXE      C10    C9     C8      111.000    3.000
 CXE      H091   C9     H092    107.900    3.000
 CXE      H091   C9     C8      109.470    3.000
 CXE      H092   C9     C8      109.470    3.000
 CXE      C9     C8     H081    109.470    3.000
 CXE      C9     C8     H082    109.470    3.000
 CXE      C9     C8     C7      111.000    3.000
 CXE      H081   C8     H082    107.900    3.000
 CXE      H081   C8     C7      109.470    3.000
 CXE      H082   C8     C7      109.470    3.000
 CXE      C8     C7     H071    109.470    3.000
 CXE      C8     C7     H072    109.470    3.000
 CXE      C8     C7     C6      111.000    3.000
 CXE      H071   C7     H072    107.900    3.000
 CXE      H071   C7     C6      109.470    3.000
 CXE      H072   C7     C6      109.470    3.000
 CXE      C7     C6     H061    109.470    3.000
 CXE      C7     C6     H062    109.470    3.000
 CXE      C7     C6     C5      111.000    3.000
 CXE      H061   C6     H062    107.900    3.000
 CXE      H061   C6     C5      109.470    3.000
 CXE      H062   C6     C5      109.470    3.000
 CXE      C6     C5     H051    109.470    3.000
 CXE      C6     C5     H052    109.470    3.000
 CXE      C6     C5     C4      111.000    3.000
 CXE      H051   C5     H052    107.900    3.000
 CXE      H051   C5     C4      109.470    3.000
 CXE      H052   C5     C4      109.470    3.000
 CXE      C5     C4     H041    109.470    3.000
 CXE      C5     C4     H042    109.470    3.000
 CXE      C5     C4     C3      111.000    3.000
 CXE      H041   C4     H042    107.900    3.000
 CXE      H041   C4     C3      109.470    3.000
 CXE      H042   C4     C3      109.470    3.000
 CXE      C4     C3     H031    109.470    3.000
 CXE      C4     C3     H032    109.470    3.000
 CXE      C4     C3     C2      111.000    3.000
 CXE      H031   C3     H032    107.900    3.000
 CXE      H031   C3     C2      109.470    3.000
 CXE      H032   C3     C2      109.470    3.000
 CXE      C3     C2     H021    109.470    3.000
 CXE      C3     C2     H022    109.470    3.000
 CXE      C3     C2     C1      111.000    3.000
 CXE      H021   C2     H022    107.900    3.000
 CXE      H021   C2     C1      109.470    3.000
 CXE      H022   C2     C1      109.470    3.000
 CXE      C2     C1     H013    109.470    3.000
 CXE      C2     C1     H012    109.470    3.000
 CXE      C2     C1     H011    109.470    3.000
 CXE      H013   C1     H012    109.470    3.000
 CXE      H013   C1     H011    109.470    3.000
 CXE      H012   C1     H011    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CXE      var_1    H26    O26    C25    C24      -52.635   20.000   1
 CXE      var_2    O26    C25    C24    O23       59.155   20.000   3
 CXE      var_3    C25    C24    O23    C22     -179.975   20.000   1
 CXE      var_4    C24    O23    C22    C21      179.040   20.000   1
 CXE      var_5    O23    C22    C21    O20      -60.921   20.000   3
 CXE      var_6    C22    C21    O20    C19      179.983   20.000   1
 CXE      var_7    C21    O20    C19    C18      179.041   20.000   1
 CXE      var_8    O20    C19    C18    O17      -60.851   20.000   3
 CXE      var_9    C19    C18    O17    C16      179.024   20.000   1
 CXE      var_10   C18    O17    C16    C15      180.000   20.000   1
 CXE      var_11   O17    C16    C15    O14       59.116   20.000   3
 CXE      var_12   C16    C15    O14    C13      179.056   20.000   1
 CXE      var_13   C15    O14    C13    C12      179.981   20.000   1
 CXE      var_14   O14    C13    C12    O11      -60.882   20.000   3
 CXE      var_15   C13    C12    O11    C10      179.021   20.000   1
 CXE      var_16   C12    O11    C10    C9      -179.982   20.000   1
 CXE      var_17   O11    C10    C9     C8       179.218   20.000   3
 CXE      var_18   C10    C9     C8     C7       178.633   20.000   3
 CXE      var_19   C9     C8     C7     C6      -178.845   20.000   3
 CXE      var_20   C8     C7     C6     C5      -178.775   20.000   3
 CXE      var_21   C7     C6     C5     C4      -176.904   20.000   3
 CXE      var_22   C6     C5     C4     C3       177.086   20.000   3
 CXE      var_23   C5     C4     C3     C2      -178.442   20.000   3
 CXE      var_24   C4     C3     C2     C1       178.590   20.000   3
 CXE      var_25   C3     C2     C1     H011      60.328   20.000   3
# ------------------------------------------------------
`.trim();

monomers["EDO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
EDO      EDO '1,2-ETHANEDIOL                      ' non-polymer        10   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_EDO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 EDO           O2     O    OH1       0.000      0.000    0.000    0.000
 EDO           HO2    H    H         0.000      0.570    0.404   -0.669
 EDO           C2     C    CH2       0.000     -1.361    0.342   -0.266
 EDO           H21    H    H         0.000     -1.641   -0.025   -1.256
 EDO           H22    H    H         0.000     -1.475    1.428   -0.236
 EDO           C1     C    CH2       0.000     -2.263   -0.296    0.789
 EDO           H11    H    H         0.000     -2.149   -1.381    0.756
 EDO           H12    H    H         0.000     -3.303   -0.034    0.584
 EDO           O1     O    OH1       0.000     -1.897    0.184    2.084
 EDO           HO1    H    H         0.000     -2.469   -0.220    2.750
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 EDO      O2     n/a    C2     START
 EDO      HO2    O2     .      .
 EDO      C2     O2     C1     .
 EDO      H21    C2     .      .
 EDO      H22    C2     .      .
 EDO      C1     C2     O1     .
 EDO      H11    C1     .      .
 EDO      H12    C1     .      .
 EDO      O1     C1     HO1    .
 EDO      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 EDO      O1     C1        single      1.432    0.020
 EDO      C1     C2        single      1.524    0.020
 EDO      H11    C1        single      1.092    0.020
 EDO      H12    C1        single      1.092    0.020
 EDO      HO1    O1        single      0.967    0.020
 EDO      C2     O2        single      1.432    0.020
 EDO      H21    C2        single      1.092    0.020
 EDO      H22    C2        single      1.092    0.020
 EDO      HO2    O2        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 EDO      HO2    O2     C2      109.470    3.000
 EDO      O2     C2     H21     109.470    3.000
 EDO      O2     C2     H22     109.470    3.000
 EDO      O2     C2     C1      109.470    3.000
 EDO      H21    C2     H22     107.900    3.000
 EDO      H21    C2     C1      109.470    3.000
 EDO      H22    C2     C1      109.470    3.000
 EDO      C2     C1     H11     109.470    3.000
 EDO      C2     C1     H12     109.470    3.000
 EDO      C2     C1     O1      109.470    3.000
 EDO      H11    C1     H12     107.900    3.000
 EDO      H11    C1     O1      109.470    3.000
 EDO      H12    C1     O1      109.470    3.000
 EDO      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 EDO      var_1    HO2    O2     C2     C1       179.985   20.000   1
 EDO      var_2    O2     C2     C1     O1        59.966   20.000   3
 EDO      var_3    C2     C1     O1     HO1      179.985   20.000   1
# ------------------------------------------------------
`.trim();

monomers["N8E"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
N8E      N8E '3,6,9,12,15-PENTAOXATRICOSAN-1-OL   ' non-polymer        62  24 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_N8E
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 N8E           O24    O    OH1       0.000      0.000    0.000    0.000
 N8E           H24    H    H         0.000      0.761   -0.345    0.486
 N8E           C23    C    CH2       0.000     -0.635    1.020    0.773
 N8E           H231   H    H         0.000      0.075    1.828    0.962
 N8E           H232   H    H         0.000     -0.968    0.600    1.724
 N8E           C22    C    CH2       0.000     -1.839    1.566    0.004
 N8E           H221   H    H         0.000     -1.503    1.985   -0.947
 N8E           H222   H    H         0.000     -2.322    2.347    0.594
 N8E           O21    O    O2        0.000     -2.768    0.509   -0.241
 N8E           C20    C    CH2       0.000     -3.864    1.079   -0.958
 N8E           H201   H    H         0.000     -3.503    1.505   -1.896
 N8E           H202   H    H         0.000     -4.322    1.866   -0.354
 N8E           C19    C    CH2       0.000     -4.900   -0.006   -1.254
 N8E           H191   H    H         0.000     -4.441   -0.792   -1.858
 N8E           H192   H    H         0.000     -5.738    0.430   -1.803
 N8E           O18    O    O2        0.000     -5.372   -0.563   -0.025
 N8E           C17    C    CH2       0.000     -6.331   -1.565   -0.367
 N8E           H171   H    H         0.000     -5.853   -2.331   -0.982
 N8E           H172   H    H         0.000     -7.150   -1.109   -0.928
 N8E           C16    C    CH2       0.000     -6.879   -2.203    0.911
 N8E           H161   H    H         0.000     -6.060   -2.661    1.469
 N8E           H162   H    H         0.000     -7.612   -2.970    0.649
 N8E           O15    O    O2        0.000     -7.504   -1.201    1.714
 N8E           C14    C    CH2       0.000     -7.992   -1.856    2.886
 N8E           H141   H    H         0.000     -7.157   -2.316    3.419
 N8E           H142   H    H         0.000     -8.709   -2.628    2.599
 N8E           C13    C    CH2       0.000     -8.677   -0.833    3.795
 N8E           H131   H    H         0.000     -7.957   -0.064    4.082
 N8E           H132   H    H         0.000     -9.048   -1.335    4.691
 N8E           O12    O    O2        0.000     -9.767   -0.231    3.097
 N8E           C11    C    CH2       0.000    -10.361    0.709    3.993
 N8E           H111   H    H         0.000     -9.620    1.458    4.278
 N8E           H112   H    H         0.000    -10.712    0.188    4.887
 N8E           C10    C    CH2       0.000    -11.543    1.394    3.304
 N8E           H101   H    H         0.000    -11.191    1.916    2.412
 N8E           H102   H    H         0.000    -11.996    2.113    3.990
 N8E           O09    O    O2        0.000    -12.513    0.412    2.932
 N8E           C08    C    CH2       0.000    -13.585    1.109    2.297
 N8E           H081   H    H         0.000    -13.207    1.634    1.417
 N8E           H082   H    H         0.000    -14.012    1.832    2.994
 N8E           C07    C    CH2       0.000    -14.663    0.110    1.872
 N8E           H071   H    H         0.000    -15.040   -0.415    2.753
 N8E           H072   H    H         0.000    -14.234   -0.614    1.175
 N8E           C06    C    CH2       0.000    -15.812    0.857    1.191
 N8E           H061   H    H         0.000    -15.433    1.381    0.311
 N8E           H062   H    H         0.000    -16.238    1.581    1.888
 N8E           C05    C    CH2       0.000    -16.889   -0.142    0.767
 N8E           H051   H    H         0.000    -17.265   -0.666    1.648
 N8E           H052   H    H         0.000    -16.460   -0.865    0.071
 N8E           C04    C    CH2       0.000    -18.038    0.605    0.087
 N8E           H041   H    H         0.000    -17.659    1.130   -0.792
 N8E           H042   H    H         0.000    -18.465    1.328    0.785
 N8E           C03    C    CH2       0.000    -19.116   -0.394   -0.339
 N8E           H031   H    H         0.000    -19.492   -0.919    0.542
 N8E           H032   H    H         0.000    -18.686   -1.116   -1.036
 N8E           C02    C    CH2       0.000    -20.265    0.353   -1.019
 N8E           H021   H    H         0.000    -19.886    0.878   -1.898
 N8E           H022   H    H         0.000    -20.691    1.076   -0.321
 N8E           C01    C    CH3       0.000    -21.342   -0.646   -1.443
 N8E           H013   H    H         0.000    -20.930   -1.349   -2.121
 N8E           H012   H    H         0.000    -21.712   -1.156   -0.591
 N8E           H011   H    H         0.000    -22.140   -0.131   -1.916
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 N8E      O24    n/a    C23    START
 N8E      H24    O24    .      .
 N8E      C23    O24    C22    .
 N8E      H231   C23    .      .
 N8E      H232   C23    .      .
 N8E      C22    C23    O21    .
 N8E      H221   C22    .      .
 N8E      H222   C22    .      .
 N8E      O21    C22    C20    .
 N8E      C20    O21    C19    .
 N8E      H201   C20    .      .
 N8E      H202   C20    .      .
 N8E      C19    C20    O18    .
 N8E      H191   C19    .      .
 N8E      H192   C19    .      .
 N8E      O18    C19    C17    .
 N8E      C17    O18    C16    .
 N8E      H171   C17    .      .
 N8E      H172   C17    .      .
 N8E      C16    C17    O15    .
 N8E      H161   C16    .      .
 N8E      H162   C16    .      .
 N8E      O15    C16    C14    .
 N8E      C14    O15    C13    .
 N8E      H141   C14    .      .
 N8E      H142   C14    .      .
 N8E      C13    C14    O12    .
 N8E      H131   C13    .      .
 N8E      H132   C13    .      .
 N8E      O12    C13    C11    .
 N8E      C11    O12    C10    .
 N8E      H111   C11    .      .
 N8E      H112   C11    .      .
 N8E      C10    C11    O09    .
 N8E      H101   C10    .      .
 N8E      H102   C10    .      .
 N8E      O09    C10    C08    .
 N8E      C08    O09    C07    .
 N8E      H081   C08    .      .
 N8E      H082   C08    .      .
 N8E      C07    C08    C06    .
 N8E      H071   C07    .      .
 N8E      H072   C07    .      .
 N8E      C06    C07    C05    .
 N8E      H061   C06    .      .
 N8E      H062   C06    .      .
 N8E      C05    C06    C04    .
 N8E      H051   C05    .      .
 N8E      H052   C05    .      .
 N8E      C04    C05    C03    .
 N8E      H041   C04    .      .
 N8E      H042   C04    .      .
 N8E      C03    C04    C02    .
 N8E      H031   C03    .      .
 N8E      H032   C03    .      .
 N8E      C02    C03    C01    .
 N8E      H021   C02    .      .
 N8E      H022   C02    .      .
 N8E      C01    C02    H011   .
 N8E      H013   C01    .      .
 N8E      H012   C01    .      .
 N8E      H011   C01    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 N8E      C01    C02       single      1.513    0.020
 N8E      H011   C01       single      1.059    0.020
 N8E      H012   C01       single      1.059    0.020
 N8E      H013   C01       single      1.059    0.020
 N8E      C02    C03       single      1.524    0.020
 N8E      H021   C02       single      1.092    0.020
 N8E      H022   C02       single      1.092    0.020
 N8E      C03    C04       single      1.524    0.020
 N8E      H031   C03       single      1.092    0.020
 N8E      H032   C03       single      1.092    0.020
 N8E      C04    C05       single      1.524    0.020
 N8E      H041   C04       single      1.092    0.020
 N8E      H042   C04       single      1.092    0.020
 N8E      C05    C06       single      1.524    0.020
 N8E      H051   C05       single      1.092    0.020
 N8E      H052   C05       single      1.092    0.020
 N8E      C06    C07       single      1.524    0.020
 N8E      H061   C06       single      1.092    0.020
 N8E      H062   C06       single      1.092    0.020
 N8E      C07    C08       single      1.524    0.020
 N8E      H071   C07       single      1.092    0.020
 N8E      H072   C07       single      1.092    0.020
 N8E      C08    O09       single      1.426    0.020
 N8E      H081   C08       single      1.092    0.020
 N8E      H082   C08       single      1.092    0.020
 N8E      O09    C10       single      1.426    0.020
 N8E      C10    C11       single      1.524    0.020
 N8E      H101   C10       single      1.092    0.020
 N8E      H102   C10       single      1.092    0.020
 N8E      C11    O12       single      1.426    0.020
 N8E      H111   C11       single      1.092    0.020
 N8E      H112   C11       single      1.092    0.020
 N8E      O12    C13       single      1.426    0.020
 N8E      C13    C14       single      1.524    0.020
 N8E      H131   C13       single      1.092    0.020
 N8E      H132   C13       single      1.092    0.020
 N8E      C14    O15       single      1.426    0.020
 N8E      H141   C14       single      1.092    0.020
 N8E      H142   C14       single      1.092    0.020
 N8E      O15    C16       single      1.426    0.020
 N8E      C16    C17       single      1.524    0.020
 N8E      H161   C16       single      1.092    0.020
 N8E      H162   C16       single      1.092    0.020
 N8E      C17    O18       single      1.426    0.020
 N8E      H171   C17       single      1.092    0.020
 N8E      H172   C17       single      1.092    0.020
 N8E      O18    C19       single      1.426    0.020
 N8E      C19    C20       single      1.524    0.020
 N8E      H191   C19       single      1.092    0.020
 N8E      H192   C19       single      1.092    0.020
 N8E      C20    O21       single      1.426    0.020
 N8E      H201   C20       single      1.092    0.020
 N8E      H202   C20       single      1.092    0.020
 N8E      O21    C22       single      1.426    0.020
 N8E      C22    C23       single      1.524    0.020
 N8E      H221   C22       single      1.092    0.020
 N8E      H222   C22       single      1.092    0.020
 N8E      C23    O24       single      1.432    0.020
 N8E      H231   C23       single      1.092    0.020
 N8E      H232   C23       single      1.092    0.020
 N8E      H24    O24       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 N8E      H24    O24    C23     109.470    3.000
 N8E      O24    C23    H231    109.470    3.000
 N8E      O24    C23    H232    109.470    3.000
 N8E      O24    C23    C22     109.470    3.000
 N8E      H231   C23    H232    107.900    3.000
 N8E      H231   C23    C22     109.470    3.000
 N8E      H232   C23    C22     109.470    3.000
 N8E      C23    C22    H221    109.470    3.000
 N8E      C23    C22    H222    109.470    3.000
 N8E      C23    C22    O21     109.470    3.000
 N8E      H221   C22    H222    107.900    3.000
 N8E      H221   C22    O21     109.470    3.000
 N8E      H222   C22    O21     109.470    3.000
 N8E      C22    O21    C20     111.800    3.000
 N8E      O21    C20    H201    109.470    3.000
 N8E      O21    C20    H202    109.470    3.000
 N8E      O21    C20    C19     109.470    3.000
 N8E      H201   C20    H202    107.900    3.000
 N8E      H201   C20    C19     109.470    3.000
 N8E      H202   C20    C19     109.470    3.000
 N8E      C20    C19    H191    109.470    3.000
 N8E      C20    C19    H192    109.470    3.000
 N8E      C20    C19    O18     109.470    3.000
 N8E      H191   C19    H192    107.900    3.000
 N8E      H191   C19    O18     109.470    3.000
 N8E      H192   C19    O18     109.470    3.000
 N8E      C19    O18    C17     111.800    3.000
 N8E      O18    C17    H171    109.470    3.000
 N8E      O18    C17    H172    109.470    3.000
 N8E      O18    C17    C16     109.470    3.000
 N8E      H171   C17    H172    107.900    3.000
 N8E      H171   C17    C16     109.470    3.000
 N8E      H172   C17    C16     109.470    3.000
 N8E      C17    C16    H161    109.470    3.000
 N8E      C17    C16    H162    109.470    3.000
 N8E      C17    C16    O15     109.470    3.000
 N8E      H161   C16    H162    107.900    3.000
 N8E      H161   C16    O15     109.470    3.000
 N8E      H162   C16    O15     109.470    3.000
 N8E      C16    O15    C14     111.800    3.000
 N8E      O15    C14    H141    109.470    3.000
 N8E      O15    C14    H142    109.470    3.000
 N8E      O15    C14    C13     109.470    3.000
 N8E      H141   C14    H142    107.900    3.000
 N8E      H141   C14    C13     109.470    3.000
 N8E      H142   C14    C13     109.470    3.000
 N8E      C14    C13    H131    109.470    3.000
 N8E      C14    C13    H132    109.470    3.000
 N8E      C14    C13    O12     109.470    3.000
 N8E      H131   C13    H132    107.900    3.000
 N8E      H131   C13    O12     109.470    3.000
 N8E      H132   C13    O12     109.470    3.000
 N8E      C13    O12    C11     111.800    3.000
 N8E      O12    C11    H111    109.470    3.000
 N8E      O12    C11    H112    109.470    3.000
 N8E      O12    C11    C10     109.470    3.000
 N8E      H111   C11    H112    107.900    3.000
 N8E      H111   C11    C10     109.470    3.000
 N8E      H112   C11    C10     109.470    3.000
 N8E      C11    C10    H101    109.470    3.000
 N8E      C11    C10    H102    109.470    3.000
 N8E      C11    C10    O09     109.470    3.000
 N8E      H101   C10    H102    107.900    3.000
 N8E      H101   C10    O09     109.470    3.000
 N8E      H102   C10    O09     109.470    3.000
 N8E      C10    O09    C08     111.800    3.000
 N8E      O09    C08    H081    109.470    3.000
 N8E      O09    C08    H082    109.470    3.000
 N8E      O09    C08    C07     109.470    3.000
 N8E      H081   C08    H082    107.900    3.000
 N8E      H081   C08    C07     109.470    3.000
 N8E      H082   C08    C07     109.470    3.000
 N8E      C08    C07    H071    109.470    3.000
 N8E      C08    C07    H072    109.470    3.000
 N8E      C08    C07    C06     111.000    3.000
 N8E      H071   C07    H072    107.900    3.000
 N8E      H071   C07    C06     109.470    3.000
 N8E      H072   C07    C06     109.470    3.000
 N8E      C07    C06    H061    109.470    3.000
 N8E      C07    C06    H062    109.470    3.000
 N8E      C07    C06    C05     111.000    3.000
 N8E      H061   C06    H062    107.900    3.000
 N8E      H061   C06    C05     109.470    3.000
 N8E      H062   C06    C05     109.470    3.000
 N8E      C06    C05    H051    109.470    3.000
 N8E      C06    C05    H052    109.470    3.000
 N8E      C06    C05    C04     111.000    3.000
 N8E      H051   C05    H052    107.900    3.000
 N8E      H051   C05    C04     109.470    3.000
 N8E      H052   C05    C04     109.470    3.000
 N8E      C05    C04    H041    109.470    3.000
 N8E      C05    C04    H042    109.470    3.000
 N8E      C05    C04    C03     111.000    3.000
 N8E      H041   C04    H042    107.900    3.000
 N8E      H041   C04    C03     109.470    3.000
 N8E      H042   C04    C03     109.470    3.000
 N8E      C04    C03    H031    109.470    3.000
 N8E      C04    C03    H032    109.470    3.000
 N8E      C04    C03    C02     111.000    3.000
 N8E      H031   C03    H032    107.900    3.000
 N8E      H031   C03    C02     109.470    3.000
 N8E      H032   C03    C02     109.470    3.000
 N8E      C03    C02    H021    109.470    3.000
 N8E      C03    C02    H022    109.470    3.000
 N8E      C03    C02    C01     111.000    3.000
 N8E      H021   C02    H022    107.900    3.000
 N8E      H021   C02    C01     109.470    3.000
 N8E      H022   C02    C01     109.470    3.000
 N8E      C02    C01    H013    109.470    3.000
 N8E      C02    C01    H012    109.470    3.000
 N8E      C02    C01    H011    109.470    3.000
 N8E      H013   C01    H012    109.470    3.000
 N8E      H013   C01    H011    109.470    3.000
 N8E      H012   C01    H011    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 N8E      var_1    H24    O24    C23    C22      179.992   20.000   1
 N8E      var_2    O24    C23    C22    O21       60.073   20.000   3
 N8E      var_3    C23    C22    O21    C20      179.961   20.000   1
 N8E      var_4    C22    O21    C20    C19      179.963   20.000   1
 N8E      var_5    O21    C20    C19    O18       60.001   20.000   3
 N8E      var_6    C20    C19    O18    C17     -179.988   20.000   1
 N8E      var_7    C19    O18    C17    C16     -179.957   20.000   1
 N8E      var_8    O18    C17    C16    O15       59.981   20.000   3
 N8E      var_9    C17    C16    O15    C14     -179.948   20.000   1
 N8E      var_10   C16    O15    C14    C13     -179.969   20.000   1
 N8E      var_11   O15    C14    C13    O12       59.959   20.000   3
 N8E      var_12   C14    C13    O12    C11     -179.967   20.000   1
 N8E      var_13   C13    O12    C11    C10      179.979   20.000   1
 N8E      var_14   O12    C11    C10    O09       59.982   20.000   3
 N8E      var_15   C11    C10    O09    C08     -179.969   20.000   1
 N8E      var_16   C10    O09    C08    C07     -179.974   20.000   1
 N8E      var_17   O09    C08    C07    C06     -179.987   20.000   3
 N8E      var_18   C08    C07    C06    C05     -179.960   20.000   3
 N8E      var_19   C07    C06    C05    C04      179.969   20.000   3
 N8E      var_20   C06    C05    C04    C03      179.930   20.000   3
 N8E      var_21   C05    C04    C03    C02     -180.000   20.000   3
 N8E      var_22   C04    C03    C02    C01     -179.965   20.000   3
 N8E      var_23   C03    C02    C01    H011    -179.967   20.000   3
# ------------------------------------------------------
`.trim();

monomers["P33"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
P33      P33 '3,6,9,12,15,18-HEXAOXAICOSANE-1,20-D' non-polymer        52  22 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_P33
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 P33           O1     O    OH1       0.000      0.000    0.000    0.000
 P33           HO1    H    H         0.000      0.639   -0.725   -0.029
 P33           C2     C    CH2       0.000     -0.603    0.051    1.295
 P33           H21    H    H         0.000      0.170    0.215    2.049
 P33           H22A   H    H         0.000     -1.111   -0.894    1.496
 P33           C3     C    CH2       0.000     -1.614    1.197    1.342
 P33           H31    H    H         0.000     -1.104    2.141    1.141
 P33           H32    H    H         0.000     -2.074    1.235    2.332
 P33           O4     O    O2        0.000     -2.625    0.980    0.354
 P33           C5     C    CH2       0.000     -3.535    2.078    0.448
 P33           H51    H    H         0.000     -3.001    3.011    0.258
 P33           H52    H    H         0.000     -3.969    2.106    1.450
 P33           C6     C    CH2       0.000     -4.649    1.907   -0.587
 P33           H61    H    H         0.000     -4.213    1.880   -1.587
 P33           H62    H    H         0.000     -5.343    2.747   -0.515
 P33           O7     O    O2        0.000     -5.348    0.686   -0.338
 P33           C8     C    CH2       0.000     -6.368    0.584   -1.332
 P33           H81    H    H         0.000     -5.910    0.574   -2.323
 P33           H82    H    H         0.000     -7.041    1.441   -1.252
 P33           C9     C    CH2       0.000     -7.159   -0.708   -1.121
 P33           H91    H    H         0.000     -6.486   -1.563   -1.204
 P33           H92    H    H         0.000     -7.939   -0.785   -1.882
 P33           O10    O    O2        0.000     -7.758   -0.693    0.176
 P33           C11    C    CH2       0.000     -8.478   -1.920    0.312
 P33           H111   H    H         0.000     -7.787   -2.760    0.213
 P33           H112   H    H         0.000     -9.240   -1.983   -0.467
 P33           C12    C    CH2       0.000     -9.147   -1.969    1.687
 P33           H121   H    H         0.000     -8.383   -1.907    2.465
 P33           H122   H    H         0.000     -9.696   -2.907    1.790
 P33           O13    O    O2        0.000    -10.050   -0.869    1.816
 P33           C14    C    CH2       0.000    -10.639   -0.970    3.114
 P33           H141   H    H         0.000     -9.856   -0.921    3.874
 P33           H142   H    H         0.000    -11.169   -1.921    3.200
 P33           C15    C    CH2       0.000    -11.623    0.183    3.318
 P33           H151   H    H         0.000    -11.090    1.133    3.234
 P33           H152   H    H         0.000    -12.072    0.106    4.311
 P33           O16    O    O2        0.000    -12.646    0.119    2.324
 P33           C17    C    CH2       0.000    -13.528    1.217    2.567
 P33           H171   H    H         0.000    -12.971    2.153    2.491
 P33           H172   H    H         0.000    -13.952    1.127    3.569
 P33           C18    C    CH2       0.000    -14.654    1.206    1.532
 P33           H181   H    H         0.000    -14.227    1.298    0.531
 P33           H182   H    H         0.000    -15.326    2.046    1.718
 P33           O19    O    O2        0.000    -15.381   -0.020    1.631
 P33           C20    C    CH2       0.000    -16.413    0.031    0.643
 P33           H201   H    H         0.000    -15.964    0.137   -0.346
 P33           H202   H    H         0.000    -17.063    0.886    0.841
 P33           C21    C    CH2       0.000    -17.233   -1.259    0.697
 P33           H211   H    H         0.000    -16.581   -2.113    0.499
 P33           H212   H    H         0.000    -18.020   -1.221   -0.060
 P33           O22    O    OH1       0.000    -17.821   -1.397    1.991
 P33           H22    H    H         0.000    -18.338   -2.213    2.024
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 P33      O1     n/a    C2     START
 P33      HO1    O1     .      .
 P33      C2     O1     C3     .
 P33      H21    C2     .      .
 P33      H22A   C2     .      .
 P33      C3     C2     O4     .
 P33      H31    C3     .      .
 P33      H32    C3     .      .
 P33      O4     C3     C5     .
 P33      C5     O4     C6     .
 P33      H51    C5     .      .
 P33      H52    C5     .      .
 P33      C6     C5     O7     .
 P33      H61    C6     .      .
 P33      H62    C6     .      .
 P33      O7     C6     C8     .
 P33      C8     O7     C9     .
 P33      H81    C8     .      .
 P33      H82    C8     .      .
 P33      C9     C8     O10    .
 P33      H91    C9     .      .
 P33      H92    C9     .      .
 P33      O10    C9     C11    .
 P33      C11    O10    C12    .
 P33      H111   C11    .      .
 P33      H112   C11    .      .
 P33      C12    C11    O13    .
 P33      H121   C12    .      .
 P33      H122   C12    .      .
 P33      O13    C12    C14    .
 P33      C14    O13    C15    .
 P33      H141   C14    .      .
 P33      H142   C14    .      .
 P33      C15    C14    O16    .
 P33      H151   C15    .      .
 P33      H152   C15    .      .
 P33      O16    C15    C17    .
 P33      C17    O16    C18    .
 P33      H171   C17    .      .
 P33      H172   C17    .      .
 P33      C18    C17    O19    .
 P33      H181   C18    .      .
 P33      H182   C18    .      .
 P33      O19    C18    C20    .
 P33      C20    O19    C21    .
 P33      H201   C20    .      .
 P33      H202   C20    .      .
 P33      C21    C20    O22    .
 P33      H211   C21    .      .
 P33      H212   C21    .      .
 P33      O22    C21    H22    .
 P33      H22    O22    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 P33      O22    C21       single      1.432    0.020
 P33      H22    O22       single      0.967    0.020
 P33      C21    C20       single      1.524    0.020
 P33      H211   C21       single      1.092    0.020
 P33      H212   C21       single      1.092    0.020
 P33      C20    O19       single      1.426    0.020
 P33      H201   C20       single      1.092    0.020
 P33      H202   C20       single      1.092    0.020
 P33      O19    C18       single      1.426    0.020
 P33      C18    C17       single      1.524    0.020
 P33      H181   C18       single      1.092    0.020
 P33      H182   C18       single      1.092    0.020
 P33      C17    O16       single      1.426    0.020
 P33      H171   C17       single      1.092    0.020
 P33      H172   C17       single      1.092    0.020
 P33      O16    C15       single      1.426    0.020
 P33      C15    C14       single      1.524    0.020
 P33      H151   C15       single      1.092    0.020
 P33      H152   C15       single      1.092    0.020
 P33      C14    O13       single      1.426    0.020
 P33      H141   C14       single      1.092    0.020
 P33      H142   C14       single      1.092    0.020
 P33      O13    C12       single      1.426    0.020
 P33      C12    C11       single      1.524    0.020
 P33      H121   C12       single      1.092    0.020
 P33      H122   C12       single      1.092    0.020
 P33      C11    O10       single      1.426    0.020
 P33      H111   C11       single      1.092    0.020
 P33      H112   C11       single      1.092    0.020
 P33      O10    C9        single      1.426    0.020
 P33      C9     C8        single      1.524    0.020
 P33      H91    C9        single      1.092    0.020
 P33      H92    C9        single      1.092    0.020
 P33      C8     O7        single      1.426    0.020
 P33      H81    C8        single      1.092    0.020
 P33      H82    C8        single      1.092    0.020
 P33      O7     C6        single      1.426    0.020
 P33      C6     C5        single      1.524    0.020
 P33      H61    C6        single      1.092    0.020
 P33      H62    C6        single      1.092    0.020
 P33      C5     O4        single      1.426    0.020
 P33      H51    C5        single      1.092    0.020
 P33      H52    C5        single      1.092    0.020
 P33      O4     C3        single      1.426    0.020
 P33      C3     C2        single      1.524    0.020
 P33      H31    C3        single      1.092    0.020
 P33      H32    C3        single      1.092    0.020
 P33      C2     O1        single      1.432    0.020
 P33      H21    C2        single      1.092    0.020
 P33      H22A   C2        single      1.092    0.020
 P33      HO1    O1        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 P33      HO1    O1     C2      109.470    3.000
 P33      O1     C2     H21     109.470    3.000
 P33      O1     C2     H22A    109.470    3.000
 P33      O1     C2     C3      109.470    3.000
 P33      H21    C2     H22A    107.900    3.000
 P33      H21    C2     C3      109.470    3.000
 P33      H22A   C2     C3      109.470    3.000
 P33      C2     C3     H31     109.470    3.000
 P33      C2     C3     H32     109.470    3.000
 P33      C2     C3     O4      109.470    3.000
 P33      H31    C3     H32     107.900    3.000
 P33      H31    C3     O4      109.470    3.000
 P33      H32    C3     O4      109.470    3.000
 P33      C3     O4     C5      111.800    3.000
 P33      O4     C5     H51     109.470    3.000
 P33      O4     C5     H52     109.470    3.000
 P33      O4     C5     C6      109.470    3.000
 P33      H51    C5     H52     107.900    3.000
 P33      H51    C5     C6      109.470    3.000
 P33      H52    C5     C6      109.470    3.000
 P33      C5     C6     H61     109.470    3.000
 P33      C5     C6     H62     109.470    3.000
 P33      C5     C6     O7      109.470    3.000
 P33      H61    C6     H62     107.900    3.000
 P33      H61    C6     O7      109.470    3.000
 P33      H62    C6     O7      109.470    3.000
 P33      C6     O7     C8      111.800    3.000
 P33      O7     C8     H81     109.470    3.000
 P33      O7     C8     H82     109.470    3.000
 P33      O7     C8     C9      109.470    3.000
 P33      H81    C8     H82     107.900    3.000
 P33      H81    C8     C9      109.470    3.000
 P33      H82    C8     C9      109.470    3.000
 P33      C8     C9     H91     109.470    3.000
 P33      C8     C9     H92     109.470    3.000
 P33      C8     C9     O10     109.470    3.000
 P33      H91    C9     H92     107.900    3.000
 P33      H91    C9     O10     109.470    3.000
 P33      H92    C9     O10     109.470    3.000
 P33      C9     O10    C11     111.800    3.000
 P33      O10    C11    H111    109.470    3.000
 P33      O10    C11    H112    109.470    3.000
 P33      O10    C11    C12     109.470    3.000
 P33      H111   C11    H112    107.900    3.000
 P33      H111   C11    C12     109.470    3.000
 P33      H112   C11    C12     109.470    3.000
 P33      C11    C12    H121    109.470    3.000
 P33      C11    C12    H122    109.470    3.000
 P33      C11    C12    O13     109.470    3.000
 P33      H121   C12    H122    107.900    3.000
 P33      H121   C12    O13     109.470    3.000
 P33      H122   C12    O13     109.470    3.000
 P33      C12    O13    C14     111.800    3.000
 P33      O13    C14    H141    109.470    3.000
 P33      O13    C14    H142    109.470    3.000
 P33      O13    C14    C15     109.470    3.000
 P33      H141   C14    H142    107.900    3.000
 P33      H141   C14    C15     109.470    3.000
 P33      H142   C14    C15     109.470    3.000
 P33      C14    C15    H151    109.470    3.000
 P33      C14    C15    H152    109.470    3.000
 P33      C14    C15    O16     109.470    3.000
 P33      H151   C15    H152    107.900    3.000
 P33      H151   C15    O16     109.470    3.000
 P33      H152   C15    O16     109.470    3.000
 P33      C15    O16    C17     111.800    3.000
 P33      O16    C17    H171    109.470    3.000
 P33      O16    C17    H172    109.470    3.000
 P33      O16    C17    C18     109.470    3.000
 P33      H171   C17    H172    107.900    3.000
 P33      H171   C17    C18     109.470    3.000
 P33      H172   C17    C18     109.470    3.000
 P33      C17    C18    H181    109.470    3.000
 P33      C17    C18    H182    109.470    3.000
 P33      C17    C18    O19     109.470    3.000
 P33      H181   C18    H182    107.900    3.000
 P33      H181   C18    O19     109.470    3.000
 P33      H182   C18    O19     109.470    3.000
 P33      C18    O19    C20     111.800    3.000
 P33      O19    C20    H201    109.470    3.000
 P33      O19    C20    H202    109.470    3.000
 P33      O19    C20    C21     109.470    3.000
 P33      H201   C20    H202    107.900    3.000
 P33      H201   C20    C21     109.470    3.000
 P33      H202   C20    C21     109.470    3.000
 P33      C20    C21    H211    109.470    3.000
 P33      C20    C21    H212    109.470    3.000
 P33      C20    C21    O22     109.470    3.000
 P33      H211   C21    H212    107.900    3.000
 P33      H211   C21    O22     109.470    3.000
 P33      H212   C21    O22     109.470    3.000
 P33      C21    O22    H22     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 P33      var_1    HO1    O1     C2     C3      -179.968   20.000   1
 P33      var_2    O1     C2     C3     O4        60.009   20.000   3
 P33      var_3    C2     C3     O4     C5      -179.994   20.000   1
 P33      var_4    C3     O4     C5     C6      -179.956   20.000   1
 P33      var_5    O4     C5     C6     O7        59.996   20.000   3
 P33      var_6    C5     C6     O7     C8      -179.970   20.000   1
 P33      var_7    C6     O7     C8     C9      -179.975   20.000   1
 P33      var_8    O7     C8     C9     O10       59.957   20.000   3
 P33      var_9    C8     C9     O10    C11     -179.968   20.000   1
 P33      var_10   C9     O10    C11    C12     -179.965   20.000   1
 P33      var_11   O10    C11    C12    O13       59.989   20.000   3
 P33      var_12   C11    C12    O13    C14     -179.986   20.000   1
 P33      var_13   C12    O13    C14    C15     -179.987   20.000   1
 P33      var_14   O13    C14    C15    O16       59.966   20.000   3
 P33      var_15   C14    C15    O16    C17     -179.995   20.000   1
 P33      var_16   C15    O16    C17    C18     -179.948   20.000   1
 P33      var_17   O16    C17    C18    O19       59.978   20.000   3
 P33      var_18   C17    C18    O19    C20     -179.975   20.000   1
 P33      var_19   C18    O19    C20    C21      179.991   20.000   1
 P33      var_20   O19    C20    C21    O22       60.055   20.000   3
 P33      var_21   C20    C21    O22    H22     -179.936   20.000   1
# ------------------------------------------------------
`.trim();

monomers["P4C"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
P4C      P4C 'O-ACETALDEHYDYL-HEXAETHYLENE GLYCOL ' non-polymer        50  22 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_P4C
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 P4C           O22    O    O         0.000      0.000    0.000    0.000
 P4C           C21    C    C1        0.000     -1.134   -0.160    0.381
 P4C           H21    H    H         0.000     -1.452   -1.126    0.733
 P4C           C20    C    CH2       0.000     -2.105    0.992    0.363
 P4C           H201   H    H         0.000     -1.604    1.883   -0.022
 P4C           H202   H    H         0.000     -2.458    1.185    1.379
 P4C           O19    O    O2        0.000     -3.214    0.668   -0.475
 P4C           C18    C    CH2       0.000     -4.094    1.794   -0.450
 P4C           H181   H    H         0.000     -3.567    2.675   -0.823
 P4C           H182   H    H         0.000     -4.422    1.976    0.576
 P4C           C17    C    CH2       0.000     -5.310    1.512   -1.334
 P4C           H171   H    H         0.000     -4.980    1.331   -2.360
 P4C           H172   H    H         0.000     -5.981    2.373   -1.316
 P4C           O16    O    O2        0.000     -5.998    0.359   -0.843
 P4C           C15    C    CH2       0.000     -7.117    0.147   -1.706
 P4C           H151   H    H         0.000     -6.764   -0.017   -2.726
 P4C           H152   H    H         0.000     -7.764    1.026   -1.683
 P4C           C14    C    CH2       0.000     -7.901   -1.077   -1.233
 P4C           H141   H    H         0.000     -7.252   -1.955   -1.258
 P4C           H142   H    H         0.000     -8.755   -1.238   -1.894
 P4C           O13    O    O2        0.000     -8.363   -0.862    0.102
 P4C           C12    C    CH2       0.000     -9.083   -2.035    0.485
 P4C           H121   H    H         0.000     -8.418   -2.901    0.438
 P4C           H122   H    H         0.000     -9.922   -2.185   -0.198
 P4C           C11    C    CH2       0.000     -9.607   -1.870    1.911
 P4C           H111   H    H         0.000     -8.766   -1.723    2.592
 P4C           H112   H    H         0.000    -10.157   -2.767    2.202
 P4C           O10    O    O2        0.000    -10.475   -0.737    1.971
 P4C           C9     C    CH2       0.000    -10.929   -0.635    3.323
 P4C           H91    H    H         0.000    -10.071   -0.503    3.985
 P4C           H92    H    H         0.000    -11.461   -1.548    3.597
 P4C           C8     C    CH2       0.000    -11.869    0.564    3.456
 P4C           H81    H    H         0.000    -11.334    1.476    3.182
 P4C           H82    H    H         0.000    -12.214    0.642    4.488
 P4C           O7     O    O2        0.000    -12.990    0.389    2.588
 P4C           C6     C    CH2       0.000    -13.826    1.535    2.758
 P4C           H61    H    H         0.000    -13.267    2.435    2.494
 P4C           H62    H    H         0.000    -14.146    1.600    3.800
 P4C           C5     C    CH2       0.000    -15.053    1.412    1.853
 P4C           H51    H    H         0.000    -14.731    1.348    0.811
 P4C           H52    H    H         0.000    -15.691    2.289    1.983
 P4C           O4     O    O2        0.000    -15.784    0.234    2.200
 P4C           C3     C    CH2       0.000    -16.911    0.174    1.323
 P4C           H31    H    H         0.000    -16.564    0.126    0.289
 P4C           H32    H    H         0.000    -17.524    1.067    1.459
 P4C           C2     C    CH2       0.000    -17.741   -1.070    1.643
 P4C           H21A   H    H         0.000    -17.126   -1.962    1.505
 P4C           H22    H    H         0.000    -18.601   -1.115    0.972
 P4C           O1     O    OH1       0.000    -18.193   -1.006    2.996
 P4C           HO1    H    H         0.000    -18.717   -1.793    3.197
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 P4C      O22    n/a    C21    START
 P4C      C21    O22    C20    .
 P4C      H21    C21    .      .
 P4C      C20    C21    O19    .
 P4C      H201   C20    .      .
 P4C      H202   C20    .      .
 P4C      O19    C20    C18    .
 P4C      C18    O19    C17    .
 P4C      H181   C18    .      .
 P4C      H182   C18    .      .
 P4C      C17    C18    O16    .
 P4C      H171   C17    .      .
 P4C      H172   C17    .      .
 P4C      O16    C17    C15    .
 P4C      C15    O16    C14    .
 P4C      H151   C15    .      .
 P4C      H152   C15    .      .
 P4C      C14    C15    O13    .
 P4C      H141   C14    .      .
 P4C      H142   C14    .      .
 P4C      O13    C14    C12    .
 P4C      C12    O13    C11    .
 P4C      H121   C12    .      .
 P4C      H122   C12    .      .
 P4C      C11    C12    O10    .
 P4C      H111   C11    .      .
 P4C      H112   C11    .      .
 P4C      O10    C11    C9     .
 P4C      C9     O10    C8     .
 P4C      H91    C9     .      .
 P4C      H92    C9     .      .
 P4C      C8     C9     O7     .
 P4C      H81    C8     .      .
 P4C      H82    C8     .      .
 P4C      O7     C8     C6     .
 P4C      C6     O7     C5     .
 P4C      H61    C6     .      .
 P4C      H62    C6     .      .
 P4C      C5     C6     O4     .
 P4C      H51    C5     .      .
 P4C      H52    C5     .      .
 P4C      O4     C5     C3     .
 P4C      C3     O4     C2     .
 P4C      H31    C3     .      .
 P4C      H32    C3     .      .
 P4C      C2     C3     O1     .
 P4C      H21A   C2     .      .
 P4C      H22    C2     .      .
 P4C      O1     C2     HO1    .
 P4C      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 P4C      O1     C2        single      1.432    0.020
 P4C      HO1    O1        single      0.967    0.020
 P4C      C2     C3        single      1.524    0.020
 P4C      H21A   C2        single      1.092    0.020
 P4C      H22    C2        single      1.092    0.020
 P4C      C3     O4        single      1.426    0.020
 P4C      H31    C3        single      1.092    0.020
 P4C      H32    C3        single      1.092    0.020
 P4C      O4     C5        single      1.426    0.020
 P4C      C5     C6        single      1.524    0.020
 P4C      H51    C5        single      1.092    0.020
 P4C      H52    C5        single      1.092    0.020
 P4C      C6     O7        single      1.426    0.020
 P4C      H61    C6        single      1.092    0.020
 P4C      H62    C6        single      1.092    0.020
 P4C      O7     C8        single      1.426    0.020
 P4C      C8     C9        single      1.524    0.020
 P4C      H81    C8        single      1.092    0.020
 P4C      H82    C8        single      1.092    0.020
 P4C      C9     O10       single      1.426    0.020
 P4C      H91    C9        single      1.092    0.020
 P4C      H92    C9        single      1.092    0.020
 P4C      O10    C11       single      1.426    0.020
 P4C      C11    C12       single      1.524    0.020
 P4C      H111   C11       single      1.092    0.020
 P4C      H112   C11       single      1.092    0.020
 P4C      C12    O13       single      1.426    0.020
 P4C      H121   C12       single      1.092    0.020
 P4C      H122   C12       single      1.092    0.020
 P4C      O13    C14       single      1.426    0.020
 P4C      C14    C15       single      1.524    0.020
 P4C      H141   C14       single      1.092    0.020
 P4C      H142   C14       single      1.092    0.020
 P4C      C15    O16       single      1.426    0.020
 P4C      H151   C15       single      1.092    0.020
 P4C      H152   C15       single      1.092    0.020
 P4C      O16    C17       single      1.426    0.020
 P4C      C17    C18       single      1.524    0.020
 P4C      H171   C17       single      1.092    0.020
 P4C      H172   C17       single      1.092    0.020
 P4C      C18    O19       single      1.426    0.020
 P4C      H181   C18       single      1.092    0.020
 P4C      H182   C18       single      1.092    0.020
 P4C      O19    C20       single      1.426    0.020
 P4C      C20    C21       single      1.510    0.020
 P4C      H201   C20       single      1.092    0.020
 P4C      H202   C20       single      1.092    0.020
 P4C      C21    O22       double      1.220    0.020
 P4C      H21    C21       single      1.077    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 P4C      O22    C21    H21     123.000    3.000
 P4C      O22    C21    C20     120.500    3.000
 P4C      H21    C21    C20     120.000    3.000
 P4C      C21    C20    H201    109.470    3.000
 P4C      C21    C20    H202    109.470    3.000
 P4C      C21    C20    O19     109.500    3.000
 P4C      H201   C20    H202    107.900    3.000
 P4C      H201   C20    O19     109.470    3.000
 P4C      H202   C20    O19     109.470    3.000
 P4C      C20    O19    C18     111.800    3.000
 P4C      O19    C18    H181    109.470    3.000
 P4C      O19    C18    H182    109.470    3.000
 P4C      O19    C18    C17     109.470    3.000
 P4C      H181   C18    H182    107.900    3.000
 P4C      H181   C18    C17     109.470    3.000
 P4C      H182   C18    C17     109.470    3.000
 P4C      C18    C17    H171    109.470    3.000
 P4C      C18    C17    H172    109.470    3.000
 P4C      C18    C17    O16     109.470    3.000
 P4C      H171   C17    H172    107.900    3.000
 P4C      H171   C17    O16     109.470    3.000
 P4C      H172   C17    O16     109.470    3.000
 P4C      C17    O16    C15     111.800    3.000
 P4C      O16    C15    H151    109.470    3.000
 P4C      O16    C15    H152    109.470    3.000
 P4C      O16    C15    C14     109.470    3.000
 P4C      H151   C15    H152    107.900    3.000
 P4C      H151   C15    C14     109.470    3.000
 P4C      H152   C15    C14     109.470    3.000
 P4C      C15    C14    H141    109.470    3.000
 P4C      C15    C14    H142    109.470    3.000
 P4C      C15    C14    O13     109.470    3.000
 P4C      H141   C14    H142    107.900    3.000
 P4C      H141   C14    O13     109.470    3.000
 P4C      H142   C14    O13     109.470    3.000
 P4C      C14    O13    C12     111.800    3.000
 P4C      O13    C12    H121    109.470    3.000
 P4C      O13    C12    H122    109.470    3.000
 P4C      O13    C12    C11     109.470    3.000
 P4C      H121   C12    H122    107.900    3.000
 P4C      H121   C12    C11     109.470    3.000
 P4C      H122   C12    C11     109.470    3.000
 P4C      C12    C11    H111    109.470    3.000
 P4C      C12    C11    H112    109.470    3.000
 P4C      C12    C11    O10     109.470    3.000
 P4C      H111   C11    H112    107.900    3.000
 P4C      H111   C11    O10     109.470    3.000
 P4C      H112   C11    O10     109.470    3.000
 P4C      C11    O10    C9      111.800    3.000
 P4C      O10    C9     H91     109.470    3.000
 P4C      O10    C9     H92     109.470    3.000
 P4C      O10    C9     C8      109.470    3.000
 P4C      H91    C9     H92     107.900    3.000
 P4C      H91    C9     C8      109.470    3.000
 P4C      H92    C9     C8      109.470    3.000
 P4C      C9     C8     H81     109.470    3.000
 P4C      C9     C8     H82     109.470    3.000
 P4C      C9     C8     O7      109.470    3.000
 P4C      H81    C8     H82     107.900    3.000
 P4C      H81    C8     O7      109.470    3.000
 P4C      H82    C8     O7      109.470    3.000
 P4C      C8     O7     C6      111.800    3.000
 P4C      O7     C6     H61     109.470    3.000
 P4C      O7     C6     H62     109.470    3.000
 P4C      O7     C6     C5      109.470    3.000
 P4C      H61    C6     H62     107.900    3.000
 P4C      H61    C6     C5      109.470    3.000
 P4C      H62    C6     C5      109.470    3.000
 P4C      C6     C5     H51     109.470    3.000
 P4C      C6     C5     H52     109.470    3.000
 P4C      C6     C5     O4      109.470    3.000
 P4C      H51    C5     H52     107.900    3.000
 P4C      H51    C5     O4      109.470    3.000
 P4C      H52    C5     O4      109.470    3.000
 P4C      C5     O4     C3      111.800    3.000
 P4C      O4     C3     H31     109.470    3.000
 P4C      O4     C3     H32     109.470    3.000
 P4C      O4     C3     C2      109.470    3.000
 P4C      H31    C3     H32     107.900    3.000
 P4C      H31    C3     C2      109.470    3.000
 P4C      H32    C3     C2      109.470    3.000
 P4C      C3     C2     H21A    109.470    3.000
 P4C      C3     C2     H22     109.470    3.000
 P4C      C3     C2     O1      109.470    3.000
 P4C      H21A   C2     H22     107.900    3.000
 P4C      H21A   C2     O1      109.470    3.000
 P4C      H22    C2     O1      109.470    3.000
 P4C      C2     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 P4C      var_1    O22    C21    C20    O19      119.990   20.000   1
 P4C      var_2    C21    C20    O19    C18     -179.992   20.000   1
 P4C      var_3    C20    O19    C18    C17      179.918   20.000   1
 P4C      var_4    O19    C18    C17    O16       60.009   20.000   3
 P4C      var_5    C18    C17    O16    C15      179.991   20.000   1
 P4C      var_6    C17    O16    C15    C14     -179.936   20.000   1
 P4C      var_7    O16    C15    C14    O13       59.994   20.000   3
 P4C      var_8    C15    C14    O13    C12     -179.939   20.000   1
 P4C      var_9    C14    O13    C12    C11      179.999   20.000   1
 P4C      var_10   O13    C12    C11    O10       59.926   20.000   3
 P4C      var_11   C12    C11    O10    C9      -179.980   20.000   1
 P4C      var_12   C11    O10    C9     C8      -179.950   20.000   1
 P4C      var_13   O10    C9     C8     O7        60.020   20.000   3
 P4C      var_14   C9     C8     O7     C6       179.972   20.000   1
 P4C      var_15   C8     O7     C6     C5       179.992   20.000   1
 P4C      var_16   O7     C6     C5     O4        59.992   20.000   3
 P4C      var_17   C6     C5     O4     C3      -179.946   20.000   1
 P4C      var_18   C5     O4     C3     C2      -179.972   20.000   1
 P4C      var_19   O4     C3     C2     O1        59.961   20.000   3
 P4C      var_20   C3     C2     O1     HO1     -179.997   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 P4C      plan-1    C21       0.020
 P4C      plan-1    C20       0.000
 P4C      plan-1    O22       0.000
 P4C      plan-1    H21       0.000
# ------------------------------------------------------
`.trim();

monomers["12P"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
12P      12P 'DODECAETHYLENE GLYCOL               ' non-polymer        87  37 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_12P
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 12P           O1     O    OH1       0.000      0.000    0.000    0.000
 12P           HO1    H    H         0.000      0.641   -0.482    0.539
 12P           C2     C    CH2       0.000     -0.724    0.913    0.826
 12P           H21    H    H         0.000     -0.028    1.618    1.285
 12P           H22    H    H         0.000     -1.247    0.358    1.609
 12P           C3     C    CH2       0.000     -1.740    1.676   -0.025
 12P           H31    H    H         0.000     -1.215    2.231   -0.806
 12P           H32    H    H         0.000     -2.292    2.375    0.607
 12P           O4     O    O2        0.000     -2.650    0.752   -0.624
 12P           C5     C    CH2       0.000     -3.568    1.522   -1.402
 12P           H51    H    H         0.000     -3.020    2.079   -2.165
 12P           H52    H    H         0.000     -4.097    2.222   -0.751
 12P           C6     C    CH2       0.000     -4.575    0.588   -2.074
 12P           H61    H    H         0.000     -4.045   -0.111   -2.724
 12P           H62    H    H         0.000     -5.276    1.177   -2.670
 12P           O7     O    O2        0.000     -5.291   -0.139   -1.074
 12P           C8     C    CH2       0.000     -6.212   -0.989   -1.762
 12P           H81    H    H         0.000     -5.661   -1.667   -2.417
 12P           H82    H    H         0.000     -6.892   -0.380   -2.360
 12P           C9     C    CH2       0.000     -7.015   -1.801   -0.743
 12P           H91    H    H         0.000     -6.333   -2.409   -0.145
 12P           H92    H    H         0.000     -7.717   -2.452   -1.268
 12P           O10    O    O2        0.000     -7.736   -0.911    0.111
 12P           C11    C    CH2       0.000     -8.462   -1.724    1.035
 12P           H111   H    H         0.000     -7.762   -2.334    1.610
 12P           H112   H    H         0.000     -9.145   -2.376    0.486
 12P           C12    C    CH2       0.000     -9.260   -0.829    1.985
 12P           H121   H    H         0.000     -8.576   -0.179    2.534
 12P           H122   H    H         0.000     -9.814   -1.452    2.691
 12P           O13    O    O2        0.000    -10.176   -0.031    1.231
 12P           C14    C    CH2       0.000    -10.887    0.778    2.169
 12P           H141   H    H         0.000    -10.181    1.407    2.715
 12P           H142   H    H         0.000    -11.420    0.135    2.873
 12P           C15    C    CH2       0.000    -11.889    1.661    1.423
 12P           H151   H    H         0.000    -11.354    2.304    0.721
 12P           H152   H    H         0.000    -12.432    2.280    2.141
 12P           O16    O    O2        0.000    -12.812    0.837    0.709
 12P           C17    C    CH2       0.000    -13.716    1.715    0.038
 12P           H171   H    H         0.000    -13.159    2.357   -0.647
 12P           H172   H    H         0.000    -14.235    2.334    0.774
 12P           C18    C    CH2       0.000    -14.737    0.891   -0.749
 12P           H181   H    H         0.000    -14.217    0.275   -1.485
 12P           H182   H    H         0.000    -15.428    1.564   -1.263
 12P           O19    O    O2        0.000    -15.466    0.052    0.148
 12P           C20    C    CH2       0.000    -16.397   -0.687   -0.644
 12P           H201   H    H         0.000    -15.854   -1.284   -1.380
 12P           H202   H    H         0.000    -17.066    0.005   -1.160
 12P           C21    C    CH2       0.000    -17.215   -1.610    0.261
 12P           H211   H    H         0.000    -16.545   -2.303    0.774
 12P           H212   H    H         0.000    -17.927   -2.175   -0.345
 12P           O22    O    O2        0.000    -17.924   -0.828    1.225
 12P           C23    C    CH2       0.000    -18.664   -1.743    2.034
 12P           H231   H    H         0.000    -17.976   -2.434    2.524
 12P           H232   H    H         0.000    -19.357   -2.306    1.405
 12P           C24    C    CH2       0.000    -19.450   -0.965    3.092
 12P           H241   H    H         0.000    -18.757   -0.403    3.720
 12P           H242   H    H         0.000    -20.015   -1.665    3.712
 12P           O25    O    O2        0.000    -20.351   -0.063    2.448
 12P           C26    C    CH2       0.000    -21.052    0.629    3.483
 12P           H261   H    H         0.000    -20.338    1.171    4.106
 12P           H262   H    H         0.000    -21.597   -0.091    4.097
 12P           C27    C    CH2       0.000    -22.040    1.618    2.858
 12P           H271   H    H         0.000    -21.494    2.338    2.245
 12P           H272   H    H         0.000    -22.574    2.147    3.649
 12P           O28    O    O2        0.000    -22.974    0.907    2.043
 12P           C29    C    CH2       0.000    -23.863    1.879    1.491
 12P           H291   H    H         0.000    -23.294    2.596    0.895
 12P           H292   H    H         0.000    -24.375    2.404    2.300
 12P           C30    C    CH2       0.000    -24.894    1.180    0.603
 12P           H301   H    H         0.000    -24.381    0.655   -0.206
 12P           H302   H    H         0.000    -25.573    1.923    0.179
 12P           O31    O    O2        0.000    -25.639    0.243    1.384
 12P           C32    C    CH2       0.000    -26.581   -0.372    0.503
 12P           H321   H    H         0.000    -26.047   -0.877   -0.305
 12P           H322   H    H         0.000    -27.238    0.391    0.083
 12P           C33    C    CH2       0.000    -27.414   -1.393    1.281
 12P           H331   H    H         0.000    -26.755   -2.156    1.701
 12P           H332   H    H         0.000    -28.132   -1.865    0.608
 12P           O34    O    O2        0.000    -28.113   -0.731    2.338
 12P           C35    C    CH2       0.000    -28.869   -1.730    3.022
 12P           H351   H    H         0.000    -28.192   -2.489    3.420
 12P           H352   H    H         0.000    -29.569   -2.197    2.326
 12P           C36    C    CH2       0.000    -29.645   -1.085    4.172
 12P           H361   H    H         0.000    -28.944   -0.619    4.868
 12P           H362   H    H         0.000    -30.222   -1.850    4.696
 12P           O37    O    OH1       0.000    -30.530   -0.093    3.651
 12P           H37    H    H         0.000    -31.020    0.314    4.377
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 12P      O1     n/a    C2     START
 12P      HO1    O1     .      .
 12P      C2     O1     C3     .
 12P      H21    C2     .      .
 12P      H22    C2     .      .
 12P      C3     C2     O4     .
 12P      H31    C3     .      .
 12P      H32    C3     .      .
 12P      O4     C3     C5     .
 12P      C5     O4     C6     .
 12P      H51    C5     .      .
 12P      H52    C5     .      .
 12P      C6     C5     O7     .
 12P      H61    C6     .      .
 12P      H62    C6     .      .
 12P      O7     C6     C8     .
 12P      C8     O7     C9     .
 12P      H81    C8     .      .
 12P      H82    C8     .      .
 12P      C9     C8     O10    .
 12P      H91    C9     .      .
 12P      H92    C9     .      .
 12P      O10    C9     C11    .
 12P      C11    O10    C12    .
 12P      H111   C11    .      .
 12P      H112   C11    .      .
 12P      C12    C11    O13    .
 12P      H121   C12    .      .
 12P      H122   C12    .      .
 12P      O13    C12    C14    .
 12P      C14    O13    C15    .
 12P      H141   C14    .      .
 12P      H142   C14    .      .
 12P      C15    C14    O16    .
 12P      H151   C15    .      .
 12P      H152   C15    .      .
 12P      O16    C15    C17    .
 12P      C17    O16    C18    .
 12P      H171   C17    .      .
 12P      H172   C17    .      .
 12P      C18    C17    O19    .
 12P      H181   C18    .      .
 12P      H182   C18    .      .
 12P      O19    C18    C20    .
 12P      C20    O19    C21    .
 12P      H201   C20    .      .
 12P      H202   C20    .      .
 12P      C21    C20    O22    .
 12P      H211   C21    .      .
 12P      H212   C21    .      .
 12P      O22    C21    C23    .
 12P      C23    O22    C24    .
 12P      H231   C23    .      .
 12P      H232   C23    .      .
 12P      C24    C23    O25    .
 12P      H241   C24    .      .
 12P      H242   C24    .      .
 12P      O25    C24    C26    .
 12P      C26    O25    C27    .
 12P      H261   C26    .      .
 12P      H262   C26    .      .
 12P      C27    C26    O28    .
 12P      H271   C27    .      .
 12P      H272   C27    .      .
 12P      O28    C27    C29    .
 12P      C29    O28    C30    .
 12P      H291   C29    .      .
 12P      H292   C29    .      .
 12P      C30    C29    O31    .
 12P      H301   C30    .      .
 12P      H302   C30    .      .
 12P      O31    C30    C32    .
 12P      C32    O31    C33    .
 12P      H321   C32    .      .
 12P      H322   C32    .      .
 12P      C33    C32    O34    .
 12P      H331   C33    .      .
 12P      H332   C33    .      .
 12P      O34    C33    C35    .
 12P      C35    O34    C36    .
 12P      H351   C35    .      .
 12P      H352   C35    .      .
 12P      C36    C35    O37    .
 12P      H361   C36    .      .
 12P      H362   C36    .      .
 12P      O37    C36    H37    .
 12P      H37    O37    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 12P      O37    C36       single      1.432    0.020
 12P      H37    O37       single      0.967    0.020
 12P      C36    C35       single      1.524    0.020
 12P      H361   C36       single      1.092    0.020
 12P      H362   C36       single      1.092    0.020
 12P      C35    O34       single      1.426    0.020
 12P      H351   C35       single      1.092    0.020
 12P      H352   C35       single      1.092    0.020
 12P      O34    C33       single      1.426    0.020
 12P      C33    C32       single      1.524    0.020
 12P      H331   C33       single      1.092    0.020
 12P      H332   C33       single      1.092    0.020
 12P      C32    O31       single      1.426    0.020
 12P      H321   C32       single      1.092    0.020
 12P      H322   C32       single      1.092    0.020
 12P      O31    C30       single      1.426    0.020
 12P      C30    C29       single      1.524    0.020
 12P      H301   C30       single      1.092    0.020
 12P      H302   C30       single      1.092    0.020
 12P      C29    O28       single      1.426    0.020
 12P      H291   C29       single      1.092    0.020
 12P      H292   C29       single      1.092    0.020
 12P      O28    C27       single      1.426    0.020
 12P      C27    C26       single      1.524    0.020
 12P      H271   C27       single      1.092    0.020
 12P      H272   C27       single      1.092    0.020
 12P      C26    O25       single      1.426    0.020
 12P      H261   C26       single      1.092    0.020
 12P      H262   C26       single      1.092    0.020
 12P      O25    C24       single      1.426    0.020
 12P      C24    C23       single      1.524    0.020
 12P      H241   C24       single      1.092    0.020
 12P      H242   C24       single      1.092    0.020
 12P      C23    O22       single      1.426    0.020
 12P      H231   C23       single      1.092    0.020
 12P      H232   C23       single      1.092    0.020
 12P      O22    C21       single      1.426    0.020
 12P      C21    C20       single      1.524    0.020
 12P      H211   C21       single      1.092    0.020
 12P      H212   C21       single      1.092    0.020
 12P      C20    O19       single      1.426    0.020
 12P      H201   C20       single      1.092    0.020
 12P      H202   C20       single      1.092    0.020
 12P      O19    C18       single      1.426    0.020
 12P      C18    C17       single      1.524    0.020
 12P      H181   C18       single      1.092    0.020
 12P      H182   C18       single      1.092    0.020
 12P      C17    O16       single      1.426    0.020
 12P      H171   C17       single      1.092    0.020
 12P      H172   C17       single      1.092    0.020
 12P      O16    C15       single      1.426    0.020
 12P      C15    C14       single      1.524    0.020
 12P      H151   C15       single      1.092    0.020
 12P      H152   C15       single      1.092    0.020
 12P      C14    O13       single      1.426    0.020
 12P      H141   C14       single      1.092    0.020
 12P      H142   C14       single      1.092    0.020
 12P      O13    C12       single      1.426    0.020
 12P      C12    C11       single      1.524    0.020
 12P      H121   C12       single      1.092    0.020
 12P      H122   C12       single      1.092    0.020
 12P      C11    O10       single      1.426    0.020
 12P      H111   C11       single      1.092    0.020
 12P      H112   C11       single      1.092    0.020
 12P      O10    C9        single      1.426    0.020
 12P      C9     C8        single      1.524    0.020
 12P      H91    C9        single      1.092    0.020
 12P      H92    C9        single      1.092    0.020
 12P      C8     O7        single      1.426    0.020
 12P      H81    C8        single      1.092    0.020
 12P      H82    C8        single      1.092    0.020
 12P      O7     C6        single      1.426    0.020
 12P      C6     C5        single      1.524    0.020
 12P      H61    C6        single      1.092    0.020
 12P      H62    C6        single      1.092    0.020
 12P      C5     O4        single      1.426    0.020
 12P      H51    C5        single      1.092    0.020
 12P      H52    C5        single      1.092    0.020
 12P      O4     C3        single      1.426    0.020
 12P      C3     C2        single      1.524    0.020
 12P      H31    C3        single      1.092    0.020
 12P      H32    C3        single      1.092    0.020
 12P      C2     O1        single      1.432    0.020
 12P      H21    C2        single      1.092    0.020
 12P      H22    C2        single      1.092    0.020
 12P      HO1    O1        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 12P      HO1    O1     C2      109.470    3.000
 12P      O1     C2     H21     109.470    3.000
 12P      O1     C2     H22     109.470    3.000
 12P      O1     C2     C3      109.470    3.000
 12P      H21    C2     H22     107.900    3.000
 12P      H21    C2     C3      109.470    3.000
 12P      H22    C2     C3      109.470    3.000
 12P      C2     C3     H31     109.470    3.000
 12P      C2     C3     H32     109.470    3.000
 12P      C2     C3     O4      109.470    3.000
 12P      H31    C3     H32     107.900    3.000
 12P      H31    C3     O4      109.470    3.000
 12P      H32    C3     O4      109.470    3.000
 12P      C3     O4     C5      111.800    3.000
 12P      O4     C5     H51     109.470    3.000
 12P      O4     C5     H52     109.470    3.000
 12P      O4     C5     C6      109.470    3.000
 12P      H51    C5     H52     107.900    3.000
 12P      H51    C5     C6      109.470    3.000
 12P      H52    C5     C6      109.470    3.000
 12P      C5     C6     H61     109.470    3.000
 12P      C5     C6     H62     109.470    3.000
 12P      C5     C6     O7      109.470    3.000
 12P      H61    C6     H62     107.900    3.000
 12P      H61    C6     O7      109.470    3.000
 12P      H62    C6     O7      109.470    3.000
 12P      C6     O7     C8      111.800    3.000
 12P      O7     C8     H81     109.470    3.000
 12P      O7     C8     H82     109.470    3.000
 12P      O7     C8     C9      109.470    3.000
 12P      H81    C8     H82     107.900    3.000
 12P      H81    C8     C9      109.470    3.000
 12P      H82    C8     C9      109.470    3.000
 12P      C8     C9     H91     109.470    3.000
 12P      C8     C9     H92     109.470    3.000
 12P      C8     C9     O10     109.470    3.000
 12P      H91    C9     H92     107.900    3.000
 12P      H91    C9     O10     109.470    3.000
 12P      H92    C9     O10     109.470    3.000
 12P      C9     O10    C11     111.800    3.000
 12P      O10    C11    H111    109.470    3.000
 12P      O10    C11    H112    109.470    3.000
 12P      O10    C11    C12     109.470    3.000
 12P      H111   C11    H112    107.900    3.000
 12P      H111   C11    C12     109.470    3.000
 12P      H112   C11    C12     109.470    3.000
 12P      C11    C12    H121    109.470    3.000
 12P      C11    C12    H122    109.470    3.000
 12P      C11    C12    O13     109.470    3.000
 12P      H121   C12    H122    107.900    3.000
 12P      H121   C12    O13     109.470    3.000
 12P      H122   C12    O13     109.470    3.000
 12P      C12    O13    C14     111.800    3.000
 12P      O13    C14    H141    109.470    3.000
 12P      O13    C14    H142    109.470    3.000
 12P      O13    C14    C15     109.470    3.000
 12P      H141   C14    H142    107.900    3.000
 12P      H141   C14    C15     109.470    3.000
 12P      H142   C14    C15     109.470    3.000
 12P      C14    C15    H151    109.470    3.000
 12P      C14    C15    H152    109.470    3.000
 12P      C14    C15    O16     109.470    3.000
 12P      H151   C15    H152    107.900    3.000
 12P      H151   C15    O16     109.470    3.000
 12P      H152   C15    O16     109.470    3.000
 12P      C15    O16    C17     111.800    3.000
 12P      O16    C17    H171    109.470    3.000
 12P      O16    C17    H172    109.470    3.000
 12P      O16    C17    C18     109.470    3.000
 12P      H171   C17    H172    107.900    3.000
 12P      H171   C17    C18     109.470    3.000
 12P      H172   C17    C18     109.470    3.000
 12P      C17    C18    H181    109.470    3.000
 12P      C17    C18    H182    109.470    3.000
 12P      C17    C18    O19     109.470    3.000
 12P      H181   C18    H182    107.900    3.000
 12P      H181   C18    O19     109.470    3.000
 12P      H182   C18    O19     109.470    3.000
 12P      C18    O19    C20     111.800    3.000
 12P      O19    C20    H201    109.470    3.000
 12P      O19    C20    H202    109.470    3.000
 12P      O19    C20    C21     109.470    3.000
 12P      H201   C20    H202    107.900    3.000
 12P      H201   C20    C21     109.470    3.000
 12P      H202   C20    C21     109.470    3.000
 12P      C20    C21    H211    109.470    3.000
 12P      C20    C21    H212    109.470    3.000
 12P      C20    C21    O22     109.470    3.000
 12P      H211   C21    H212    107.900    3.000
 12P      H211   C21    O22     109.470    3.000
 12P      H212   C21    O22     109.470    3.000
 12P      C21    O22    C23     111.800    3.000
 12P      O22    C23    H231    109.470    3.000
 12P      O22    C23    H232    109.470    3.000
 12P      O22    C23    C24     109.470    3.000
 12P      H231   C23    H232    107.900    3.000
 12P      H231   C23    C24     109.470    3.000
 12P      H232   C23    C24     109.470    3.000
 12P      C23    C24    H241    109.470    3.000
 12P      C23    C24    H242    109.470    3.000
 12P      C23    C24    O25     109.470    3.000
 12P      H241   C24    H242    107.900    3.000
 12P      H241   C24    O25     109.470    3.000
 12P      H242   C24    O25     109.470    3.000
 12P      C24    O25    C26     111.800    3.000
 12P      O25    C26    H261    109.470    3.000
 12P      O25    C26    H262    109.470    3.000
 12P      O25    C26    C27     109.470    3.000
 12P      H261   C26    H262    107.900    3.000
 12P      H261   C26    C27     109.470    3.000
 12P      H262   C26    C27     109.470    3.000
 12P      C26    C27    H271    109.470    3.000
 12P      C26    C27    H272    109.470    3.000
 12P      C26    C27    O28     109.470    3.000
 12P      H271   C27    H272    107.900    3.000
 12P      H271   C27    O28     109.470    3.000
 12P      H272   C27    O28     109.470    3.000
 12P      C27    O28    C29     111.800    3.000
 12P      O28    C29    H291    109.470    3.000
 12P      O28    C29    H292    109.470    3.000
 12P      O28    C29    C30     109.470    3.000
 12P      H291   C29    H292    107.900    3.000
 12P      H291   C29    C30     109.470    3.000
 12P      H292   C29    C30     109.470    3.000
 12P      C29    C30    H301    109.470    3.000
 12P      C29    C30    H302    109.470    3.000
 12P      C29    C30    O31     109.470    3.000
 12P      H301   C30    H302    107.900    3.000
 12P      H301   C30    O31     109.470    3.000
 12P      H302   C30    O31     109.470    3.000
 12P      C30    O31    C32     111.800    3.000
 12P      O31    C32    H321    109.470    3.000
 12P      O31    C32    H322    109.470    3.000
 12P      O31    C32    C33     109.470    3.000
 12P      H321   C32    H322    107.900    3.000
 12P      H321   C32    C33     109.470    3.000
 12P      H322   C32    C33     109.470    3.000
 12P      C32    C33    H331    109.470    3.000
 12P      C32    C33    H332    109.470    3.000
 12P      C32    C33    O34     109.470    3.000
 12P      H331   C33    H332    107.900    3.000
 12P      H331   C33    O34     109.470    3.000
 12P      H332   C33    O34     109.470    3.000
 12P      C33    O34    C35     111.800    3.000
 12P      O34    C35    H351    109.470    3.000
 12P      O34    C35    H352    109.470    3.000
 12P      O34    C35    C36     109.470    3.000
 12P      H351   C35    H352    107.900    3.000
 12P      H351   C35    C36     109.470    3.000
 12P      H352   C35    C36     109.470    3.000
 12P      C35    C36    H361    109.470    3.000
 12P      C35    C36    H362    109.470    3.000
 12P      C35    C36    O37     109.470    3.000
 12P      H361   C36    H362    107.900    3.000
 12P      H361   C36    O37     109.470    3.000
 12P      H362   C36    O37     109.470    3.000
 12P      C36    O37    H37     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 12P      var_1    HO1    O1     C2     C3      -179.988   20.000   1
 12P      var_2    O1     C2     C3     O4        60.015   20.000   3
 12P      var_3    C2     C3     O4     C5       179.979   20.000   1
 12P      var_4    C3     O4     C5     C6       179.964   20.000   1
 12P      var_5    O4     C5     C6     O7        60.054   20.000   3
 12P      var_6    C5     C6     O7     C8       179.965   20.000   1
 12P      var_7    C6     O7     C8     C9       179.954   20.000   1
 12P      var_8    O7     C8     C9     O10       60.073   20.000   3
 12P      var_9    C8     C9     O10    C11      179.985   20.000   1
 12P      var_10   C9     O10    C11    C12      179.984   20.000   1
 12P      var_11   O10    C11    C12    O13       59.982   20.000   3
 12P      var_12   C11    C12    O13    C14     -179.990   20.000   1
 12P      var_13   C12    O13    C14    C15     -179.991   20.000   1
 12P      var_14   O13    C14    C15    O16       59.994   20.000   3
 12P      var_15   C14    C15    O16    C17      179.966   20.000   1
 12P      var_16   C15    O16    C17    C18     -179.950   20.000   1
 12P      var_17   O16    C17    C18    O19       60.003   20.000   3
 12P      var_18   C17    C18    O19    C20     -179.956   20.000   1
 12P      var_19   C18    O19    C20    C21     -179.951   20.000   1
 12P      var_20   O19    C20    C21    O22       59.933   20.000   3
 12P      var_21   C20    C21    O22    C23      179.987   20.000   1
 12P      var_22   C21    O22    C23    C24     -179.998   20.000   1
 12P      var_23   O22    C23    C24    O25       60.050   20.000   3
 12P      var_24   C23    C24    O25    C26      179.979   20.000   1
 12P      var_25   C24    O25    C26    C27      179.998   20.000   1
 12P      var_26   O25    C26    C27    O28       60.010   20.000   3
 12P      var_27   C26    C27    O28    C29      179.992   20.000   1
 12P      var_28   C27    O28    C29    C30      179.983   20.000   1
 12P      var_29   O28    C29    C30    O31       60.051   20.000   3
 12P      var_30   C29    C30    O31    C32      179.937   20.000   1
 12P      var_31   C30    O31    C32    C33      179.961   20.000   1
 12P      var_32   O31    C32    C33    O34       60.061   20.000   3
 12P      var_33   C32    C33    O34    C35      179.943   20.000   1
 12P      var_34   C33    O34    C35    C36      180.000   20.000   1
 12P      var_35   O34    C35    C36    O37       60.033   20.000   3
 12P      var_36   C35    C36    O37    H37     -179.985   20.000   1
# ------------------------------------------------------
`.trim();

monomers["15P"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
15P      15P 'POLYETHYLENE GLYCOL (N=34)          ' non-polymer       244 104 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_15P
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 15P           CM     C    CH3       0.000      0.000    0.000    0.000
 15P           HCM1   H    H         0.000      0.313   -0.480    0.890
 15P           HCM2   H    H         0.000     -0.143    1.032    0.186
 15P           HCM3   H    H         0.000     -0.909   -0.429   -0.332
 15P           O34    O    O2        0.000      0.995   -0.166   -1.001
 15P           C68    C    CH2       0.000      0.890   -1.435   -1.635
 15P           H681   H    H         0.000     -0.096   -1.537   -2.091
 15P           H682   H    H         0.000      1.032   -2.227   -0.896
 15P           C67    C    CH2       0.000      1.959   -1.543   -2.705
 15P           H671   H    H         0.000      1.896   -2.521   -3.188
 15P           H672   H    H         0.000      2.945   -1.425   -2.252
 15P           O33    O    O2        0.000      1.754   -0.522   -3.671
 15P           C66    C    CH2       0.000      2.731   -0.576   -4.703
 15P           H661   H    H         0.000      2.689   -1.548   -5.198
 15P           H662   H    H         0.000      3.725   -0.429   -4.275
 15P           C65    C    CH2       0.000      2.447    0.520   -5.712
 15P           H651   H    H         0.000      3.200    0.496   -6.502
 15P           H652   H    H         0.000      2.472    1.492   -5.216
 15P           O32    O    O2        0.000      1.160    0.307   -6.276
 15P           C64    C    CH2       0.000      0.839    1.309   -7.233
 15P           H641   H    H         0.000      1.584    1.306   -8.032
 15P           H642   H    H         0.000      0.829    2.289   -6.751
 15P           C63    C    CH2       0.000     -0.531    1.016   -7.816
 15P           H631   H    H         0.000     -0.518    0.043   -8.311
 15P           H632   H    H         0.000     -0.794    1.789   -8.540
 15P           O31    O    O2        0.000     -1.487    1.003   -6.766
 15P           C62    C    CH2       0.000     -2.796    0.732   -7.256
 15P           H621   H    H         0.000     -2.806   -0.236   -7.760
 15P           H622   H    H         0.000     -3.093    1.511   -7.961
 15P           C61    C    CH2       0.000     -3.765    0.706   -6.090
 15P           H611   H    H         0.000     -4.775    0.514   -6.457
 15P           H612   H    H         0.000     -3.743    1.669   -5.574
 15P           O30    O    O2        0.000     -3.382   -0.324   -5.190
 15P           C60    C    CH2       0.000     -4.260   -0.394   -4.074
 15P           H601   H    H         0.000     -5.278   -0.583   -4.419
 15P           H602   H    H         0.000     -4.232    0.550   -3.525
 15P           C59    C    CH2       0.000     -3.814   -1.523   -3.164
 15P           H591   H    H         0.000     -4.473   -1.576   -2.295
 15P           H592   H    H         0.000     -2.789   -1.345   -2.832
 15P           O29    O    O2        0.000     -3.875   -2.748   -3.882
 15P           C58    C    CH2       0.000     -3.466   -3.845   -3.075
 15P           H581   H    H         0.000     -4.111   -3.915   -2.196
 15P           H582   H    H         0.000     -2.432   -3.701   -2.755
 15P           C57    C    CH2       0.000     -3.574   -5.122   -3.886
 15P           H571   H    H         0.000     -4.610   -5.275   -4.195
 15P           H572   H    H         0.000     -3.246   -5.970   -3.281
 15P           O28    O    O2        0.000     -2.747   -5.012   -5.036
 15P           C56    C    CH2       0.000     -2.809   -6.186   -5.836
 15P           H561   H    H         0.000     -3.839   -6.361   -6.153
 15P           H562   H    H         0.000     -2.457   -7.043   -5.259
 15P           C55    C    CH2       0.000     -1.928   -6.000   -7.056
 15P           H551   H    H         0.000     -1.957   -6.902   -7.671
 15P           H552   H    H         0.000     -0.900   -5.808   -6.741
 15P           O27    O    O2        0.000     -2.407   -4.895   -7.810
 15P           C54    C    CH2       0.000     -1.615   -4.674   -8.971
 15P           H541   H    H         0.000     -1.627   -5.567   -9.600
 15P           H542   H    H         0.000     -0.587   -4.451   -8.677
 15P           C53    C    CH2       0.000     -2.188   -3.501   -9.744
 15P           H531   H    H         0.000     -1.579   -3.312  -10.631
 15P           H532   H    H         0.000     -2.193   -2.611   -9.111
 15P           O26    O    O2        0.000     -3.518   -3.812  -10.138
 15P           C52    C    CH2       0.000     -4.107   -2.743  -10.871
 15P           H521   H    H         0.000     -3.510   -2.535  -11.761
 15P           H522   H    H         0.000     -4.149   -1.849  -10.245
 15P           C51    C    CH2       0.000     -5.511   -3.141  -11.283
 15P           H511   H    H         0.000     -5.469   -4.027  -11.920
 15P           H512   H    H         0.000     -5.978   -2.321  -11.831
 15P           O25    O    O2        0.000     -6.272   -3.429  -10.118
 15P           C50    C    CH2       0.000     -7.602   -3.810  -10.446
 15P           H501   H    H         0.000     -7.584   -4.693  -11.088
 15P           H502   H    H         0.000     -8.100   -2.991  -10.970
 15P           C49    C    CH2       0.000     -8.355   -4.127   -9.169
 15P           H491   H    H         0.000     -9.383   -4.406   -9.408
 15P           H492   H    H         0.000     -8.360   -3.250   -8.518
 15P           O24    O    O2        0.000     -7.712   -5.206   -8.507
 15P           C48    C    CH2       0.000     -8.378   -5.547   -7.297
 15P           H481   H    H         0.000     -9.411   -5.827   -7.513
 15P           H482   H    H         0.000     -8.368   -4.692   -6.618
 15P           C47    C    CH2       0.000     -7.661   -6.716   -6.650
 15P           H471   H    H         0.000     -8.156   -6.977   -5.712
 15P           H472   H    H         0.000     -6.623   -6.444   -6.448
 15P           O23    O    O2        0.000     -7.698   -7.829   -7.533
 15P           C46    C    CH2       0.000     -7.037   -8.959   -6.975
 15P           H461   H    H         0.000     -7.515   -9.235   -6.032
 15P           H462   H    H         0.000     -5.988   -8.718   -6.793
 15P           C45    C    CH2       0.000     -7.131  -10.117   -7.950
 15P           H451   H    H         0.000     -6.614  -10.987   -7.538
 15P           H452   H    H         0.000     -6.669   -9.837   -8.899
 15P           O22    O    O2        0.000     -8.499  -10.434   -8.163
 15P           C44    C    CH2       0.000     -8.647  -11.518   -9.072
 15P           H441   H    H         0.000     -8.134  -12.399   -8.680
 15P           H442   H    H         0.000     -8.217  -11.249  -10.039
 15P           C43    C    CH2       0.000    -10.123  -11.825   -9.242
 15P           H431   H    H         0.000    -10.249  -12.646   -9.949
 15P           H432   H    H         0.000    -10.641  -10.940   -9.617
 15P           O21    O    O2        0.000    -10.666  -12.195   -7.982
 15P           C42    C    CH2       0.000    -12.053  -12.495   -8.080
 15P           H421   H    H         0.000    -12.202  -13.313   -8.788
 15P           H422   H    H         0.000    -12.595  -11.613   -8.425
 15P           C41    C    CH2       0.000    -12.569  -12.905   -6.714
 15P           H411   H    H         0.000    -13.637  -13.125   -6.776
 15P           H412   H    H         0.000    -12.405  -12.095   -6.001
 15P           O20    O    O2        0.000    -11.870  -14.065   -6.284
 15P           C40    C    CH2       0.000    -12.314  -14.496   -5.004
 15P           H401   H    H         0.000    -13.383  -14.717   -5.041
 15P           H402   H    H         0.000    -12.132  -13.710   -4.268
 15P           C39    C    CH2       0.000    -11.551  -15.747   -4.610
 15P           H391   H    H         0.000    -11.874  -16.078   -3.621
 15P           H392   H    H         0.000    -10.480  -15.532   -4.588
 15P           O19    O    O2        0.000    -11.812  -16.768   -5.562
 15P           C38    C    CH2       0.000    -11.120  -17.969   -5.242
 15P           H381   H    H         0.000    -11.426  -18.317   -4.253
 15P           H382   H    H         0.000    -10.043  -17.784   -5.244
 15P           C37    C    CH2       0.000    -11.455  -19.024   -6.278
 15P           H371   H    H         0.000    -10.917  -19.947   -6.049
 15P           H372   H    H         0.000    -11.165  -18.671   -7.269
 15P           O18    O    O2        0.000    -12.854  -19.271   -6.251
 15P           C36    C    CH2       0.000    -13.227  -20.257   -7.206
 15P           H361   H    H         0.000    -12.696  -21.189   -6.999
 15P           H362   H    H         0.000    -12.973  -19.911   -8.210
 15P           C35    C    CH2       0.000    -14.722  -20.494   -7.115
 15P           H351   H    H         0.000    -15.022  -21.240   -7.855
 15P           H352   H    H         0.000    -15.254  -19.560   -7.305
 15P           O17    O    O2        0.000    -15.038  -20.964   -5.812
 15P           C34    C    CH2       0.000    -16.433  -21.204   -5.668
 15P           H341   H    H         0.000    -16.753  -21.958   -6.390
 15P           H342   H    H         0.000    -16.985  -20.278   -5.842
 15P           C33    C    CH2       0.000    -16.707  -21.701   -4.262
 15P           H331   H    H         0.000    -17.778  -21.874   -4.136
 15P           H332   H    H         0.000    -16.373  -20.955   -3.538
 15P           O16    O    O2        0.000    -16.001  -22.916   -4.054
 15P           C32    C    CH2       0.000    -16.206  -23.418   -2.739
 15P           H321   H    H         0.000    -17.269  -23.608   -2.580
 15P           H322   H    H         0.000    -15.854  -22.687   -2.007
 15P           C31    C    CH2       0.000    -15.429  -24.712   -2.577
 15P           H311   H    H         0.000    -15.567  -25.099   -1.566
 15P           H312   H    H         0.000    -14.367  -24.527   -2.754
 15P           O15    O    O2        0.000    -15.909  -25.661   -3.519
 15P           C30    C    CH2       0.000    -15.200  -26.890   -3.427
 15P           H301   H    H         0.000    -15.319  -27.310   -2.426
 15P           H302   H    H         0.000    -14.139  -26.718   -3.624
 15P           C29    C    CH2       0.000    -15.755  -27.859   -4.453
 15P           H291   H    H         0.000    -15.207  -28.802   -4.402
 15P           H292   H    H         0.000    -15.651  -27.434   -5.454
 15P           O14    O    O2        0.000    -17.128  -28.091   -4.176
 15P           C28    C    CH2       0.000    -17.709  -28.980   -5.124
 15P           H281   H    H         0.000    -17.187  -29.938   -5.097
 15P           H282   H    H         0.000    -17.629  -28.552   -6.125
 15P           C27    C    CH2       0.000    -19.170  -29.189   -4.776
 15P           H271   H    H         0.000    -19.629  -29.858   -5.507
 15P           H272   H    H         0.000    -19.691  -28.229   -4.787
 15P           O13    O    O2        0.000    -19.262  -29.764   -3.481
 15P           C26    C    CH2       0.000    -20.616  -29.962   -3.092
 15P           H261   H    H         0.000    -21.107  -30.632   -3.800
 15P           H262   H    H         0.000    -21.138  -29.003   -3.078
 15P           C25    C    CH2       0.000    -20.647  -30.577   -1.707
 15P           H251   H    H         0.000    -21.683  -30.719   -1.392
 15P           H252   H    H         0.000    -20.141  -29.915   -1.000
 15P           O12    O    O2        0.000    -19.984  -31.833   -1.740
 15P           C24    C    CH2       0.000    -19.964  -32.446   -0.457
 15P           H241   H    H         0.000    -20.987  -32.608   -0.112
 15P           H242   H    H         0.000    -19.440  -31.800    0.251
 15P           C23    C    CH2       0.000    -19.245  -33.777   -0.557
 15P           H231   H    H         0.000    -19.212  -34.251    0.426
 15P           H232   H    H         0.000    -18.227  -33.618   -0.918
 15P           O11    O    O2        0.000    -19.946  -34.616   -1.465
 15P           C22    C    CH2       0.000    -19.301  -35.875   -1.615
 15P           H221   H    H         0.000    -19.254  -36.380   -0.648
 15P           H222   H    H         0.000    -18.289  -35.726   -1.997
 15P           C21    C    CH2       0.000    -20.092  -36.723   -2.592
 15P           H211   H    H         0.000    -19.597  -37.687   -2.725
 15P           H212   H    H         0.000    -20.154  -36.211   -3.555
 15P           O10    O    O2        0.000    -21.400  -36.927   -2.077
 15P           C20    C    CH2       0.000    -22.196  -37.700   -2.966
 15P           H201   H    H         0.000    -21.733  -38.677   -3.120
 15P           H202   H    H         0.000    -22.283  -37.185   -3.925
 15P           C19    C    CH2       0.000    -23.575  -37.883   -2.362
 15P           H191   H    H         0.000    -24.201  -38.464   -3.044
 15P           H192   H    H         0.000    -24.034  -36.907   -2.192
 15P           O9     O    O2        0.000    -23.453  -38.573   -1.126
 15P           C18    C    CH2       0.000    -24.719  -38.754   -0.503
 15P           H181   H    H         0.000    -25.371  -39.336   -1.157
 15P           H182   H    H         0.000    -25.176  -37.781   -0.309
 15P           C17    C    CH2       0.000    -24.524  -39.492    0.807
 15P           H171   H    H         0.000    -25.488  -39.624    1.301
 15P           H172   H    H         0.000    -23.858  -38.919    1.456
 15P           O8     O    O2        0.000    -23.949  -40.764    0.541
 15P           C16    C    CH2       0.000    -23.723  -41.495    1.740
 15P           H161   H    H         0.000    -24.671  -41.649    2.260
 15P           H162   H    H         0.000    -23.041  -40.938    2.386
 15P           C15    C    CH2       0.000    -23.110  -42.838    1.393
 15P           H151   H    H         0.000    -22.919  -43.402    2.308
 15P           H152   H    H         0.000    -22.171  -42.686    0.858
 15P           O7     O    O2        0.000    -24.015  -43.561    0.570
 15P           C14    C    CH2       0.000    -23.481  -44.825    0.193
 15P           H141   H    H         0.000    -23.280  -45.420    1.087
 15P           H142   H    H         0.000    -22.552  -44.680   -0.362
 15P           C13    C    CH2       0.000    -24.487  -45.547   -0.681
 15P           H131   H    H         0.000    -24.081  -46.513   -0.987
 15P           H132   H    H         0.000    -24.701  -44.946   -1.567
 15P           O6     O    O2        0.000    -25.684  -45.747    0.058
 15P           C12    C    CH2       0.000    -26.676  -46.403   -0.724
 15P           H121   H    H         0.000    -26.304  -47.378   -1.045
 15P           H122   H    H         0.000    -26.912  -45.798   -1.601
 15P           C11    C    CH2       0.000    -27.925  -46.588    0.117
 15P           H111   H    H         0.000    -28.698  -47.079   -0.478
 15P           H112   H    H         0.000    -28.289  -45.615    0.453
 15P           O5     O    O2        0.000    -27.611  -47.393    1.244
 15P           C10    C    CH2       0.000    -28.744  -47.583    2.082
 15P           H101   H    H         0.000    -29.539  -48.076    1.519
 15P           H102   H    H         0.000    -29.101  -46.615    2.441
 15P           C9     C    CH2       0.000    -28.348  -48.447    3.263
 15P           H19    H    H         0.000    -29.209  -48.587    3.921
 15P           H29    H    H         0.000    -27.542  -47.963    3.818
 15P           O4     O    O2        0.000    -27.905  -49.710    2.786
 15P           C8     C    CH2       0.000    -27.498  -50.557    3.854
 15P           H18    H    H         0.000    -28.338  -50.722    4.532
 15P           H28    H    H         0.000    -26.677  -50.090    4.401
 15P           C7     C    CH2       0.000    -27.038  -51.885    3.283
 15P           H17    H    H         0.000    -26.709  -52.539    4.094
 15P           H27    H    H         0.000    -26.209  -51.720    2.592
 15P           O3     O    O2        0.000    -28.119  -52.492    2.592
 15P           C6     C    CH2       0.000    -27.737  -53.736    2.017
 15P           H16    H    H         0.000    -27.407  -54.418    2.803
 15P           H26    H    H         0.000    -26.922  -53.577    1.308
 15P           C5     C    CH2       0.000    -28.929  -54.334    1.294
 15P           H15    H    H         0.000    -28.643  -55.282    0.835
 15P           H25    H    H         0.000    -29.273  -53.645    0.519
 15P           O2     O    O2        0.000    -29.974  -54.556    2.230
 15P           C4     C    CH2       0.000    -31.129  -55.098    1.601
 15P           H14    H    H         0.000    -30.880  -56.053    1.134
 15P           H24    H    H         0.000    -31.492  -54.405    0.839
 15P           C3     C    CH2       0.000    -32.207  -55.311    2.648
 15P           H13    H    H         0.000    -33.105  -55.714    2.173
 15P           H23    H    H         0.000    -32.446  -54.360    3.128
 15P           O1     O    O2        0.000    -31.732  -56.230    3.622
 15P           C2     C    CH2       0.000    -32.697  -56.452    4.643
 15P           H12    H    H         0.000    -33.609  -56.861    4.203
 15P           H22    H    H         0.000    -32.927  -55.509    5.143
 15P           C1     C    CH2       0.000    -32.135  -57.436    5.650
 15P           H11    H    H         0.000    -32.863  -57.603    6.446
 15P           H21    H    H         0.000    -31.213  -57.037    6.078
 15P           OXT    O    OH1       0.000    -31.859  -58.667    4.991
 15P           HXT    H    H         0.000    -32.417  -59.362    5.366
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 15P      CM     n/a    O34    START
 15P      HCM1   CM     .      .
 15P      HCM2   CM     .      .
 15P      HCM3   CM     .      .
 15P      O34    CM     C68    .
 15P      C68    O34    C67    .
 15P      H681   C68    .      .
 15P      H682   C68    .      .
 15P      C67    C68    O33    .
 15P      H671   C67    .      .
 15P      H672   C67    .      .
 15P      O33    C67    C66    .
 15P      C66    O33    C65    .
 15P      H661   C66    .      .
 15P      H662   C66    .      .
 15P      C65    C66    O32    .
 15P      H651   C65    .      .
 15P      H652   C65    .      .
 15P      O32    C65    C64    .
 15P      C64    O32    C63    .
 15P      H641   C64    .      .
 15P      H642   C64    .      .
 15P      C63    C64    O31    .
 15P      H631   C63    .      .
 15P      H632   C63    .      .
 15P      O31    C63    C62    .
 15P      C62    O31    C61    .
 15P      H621   C62    .      .
 15P      H622   C62    .      .
 15P      C61    C62    O30    .
 15P      H611   C61    .      .
 15P      H612   C61    .      .
 15P      O30    C61    C60    .
 15P      C60    O30    C59    .
 15P      H601   C60    .      .
 15P      H602   C60    .      .
 15P      C59    C60    O29    .
 15P      H591   C59    .      .
 15P      H592   C59    .      .
 15P      O29    C59    C58    .
 15P      C58    O29    C57    .
 15P      H581   C58    .      .
 15P      H582   C58    .      .
 15P      C57    C58    O28    .
 15P      H571   C57    .      .
 15P      H572   C57    .      .
 15P      O28    C57    C56    .
 15P      C56    O28    C55    .
 15P      H561   C56    .      .
 15P      H562   C56    .      .
 15P      C55    C56    O27    .
 15P      H551   C55    .      .
 15P      H552   C55    .      .
 15P      O27    C55    C54    .
 15P      C54    O27    C53    .
 15P      H541   C54    .      .
 15P      H542   C54    .      .
 15P      C53    C54    O26    .
 15P      H531   C53    .      .
 15P      H532   C53    .      .
 15P      O26    C53    C52    .
 15P      C52    O26    C51    .
 15P      H521   C52    .      .
 15P      H522   C52    .      .
 15P      C51    C52    O25    .
 15P      H511   C51    .      .
 15P      H512   C51    .      .
 15P      O25    C51    C50    .
 15P      C50    O25    C49    .
 15P      H501   C50    .      .
 15P      H502   C50    .      .
 15P      C49    C50    O24    .
 15P      H491   C49    .      .
 15P      H492   C49    .      .
 15P      O24    C49    C48    .
 15P      C48    O24    C47    .
 15P      H481   C48    .      .
 15P      H482   C48    .      .
 15P      C47    C48    O23    .
 15P      H471   C47    .      .
 15P      H472   C47    .      .
 15P      O23    C47    C46    .
 15P      C46    O23    C45    .
 15P      H461   C46    .      .
 15P      H462   C46    .      .
 15P      C45    C46    O22    .
 15P      H451   C45    .      .
 15P      H452   C45    .      .
 15P      O22    C45    C44    .
 15P      C44    O22    C43    .
 15P      H441   C44    .      .
 15P      H442   C44    .      .
 15P      C43    C44    O21    .
 15P      H431   C43    .      .
 15P      H432   C43    .      .
 15P      O21    C43    C42    .
 15P      C42    O21    C41    .
 15P      H421   C42    .      .
 15P      H422   C42    .      .
 15P      C41    C42    O20    .
 15P      H411   C41    .      .
 15P      H412   C41    .      .
 15P      O20    C41    C40    .
 15P      C40    O20    C39    .
 15P      H401   C40    .      .
 15P      H402   C40    .      .
 15P      C39    C40    O19    .
 15P      H391   C39    .      .
 15P      H392   C39    .      .
 15P      O19    C39    C38    .
 15P      C38    O19    C37    .
 15P      H381   C38    .      .
 15P      H382   C38    .      .
 15P      C37    C38    O18    .
 15P      H371   C37    .      .
 15P      H372   C37    .      .
 15P      O18    C37    C36    .
 15P      C36    O18    C35    .
 15P      H361   C36    .      .
 15P      H362   C36    .      .
 15P      C35    C36    O17    .
 15P      H351   C35    .      .
 15P      H352   C35    .      .
 15P      O17    C35    C34    .
 15P      C34    O17    C33    .
 15P      H341   C34    .      .
 15P      H342   C34    .      .
 15P      C33    C34    O16    .
 15P      H331   C33    .      .
 15P      H332   C33    .      .
 15P      O16    C33    C32    .
 15P      C32    O16    C31    .
 15P      H321   C32    .      .
 15P      H322   C32    .      .
 15P      C31    C32    O15    .
 15P      H311   C31    .      .
 15P      H312   C31    .      .
 15P      O15    C31    C30    .
 15P      C30    O15    C29    .
 15P      H301   C30    .      .
 15P      H302   C30    .      .
 15P      C29    C30    O14    .
 15P      H291   C29    .      .
 15P      H292   C29    .      .
 15P      O14    C29    C28    .
 15P      C28    O14    C27    .
 15P      H281   C28    .      .
 15P      H282   C28    .      .
 15P      C27    C28    O13    .
 15P      H271   C27    .      .
 15P      H272   C27    .      .
 15P      O13    C27    C26    .
 15P      C26    O13    C25    .
 15P      H261   C26    .      .
 15P      H262   C26    .      .
 15P      C25    C26    O12    .
 15P      H251   C25    .      .
 15P      H252   C25    .      .
 15P      O12    C25    C24    .
 15P      C24    O12    C23    .
 15P      H241   C24    .      .
 15P      H242   C24    .      .
 15P      C23    C24    O11    .
 15P      H231   C23    .      .
 15P      H232   C23    .      .
 15P      O11    C23    C22    .
 15P      C22    O11    C21    .
 15P      H221   C22    .      .
 15P      H222   C22    .      .
 15P      C21    C22    O10    .
 15P      H211   C21    .      .
 15P      H212   C21    .      .
 15P      O10    C21    C20    .
 15P      C20    O10    C19    .
 15P      H201   C20    .      .
 15P      H202   C20    .      .
 15P      C19    C20    O9     .
 15P      H191   C19    .      .
 15P      H192   C19    .      .
 15P      O9     C19    C18    .
 15P      C18    O9     C17    .
 15P      H181   C18    .      .
 15P      H182   C18    .      .
 15P      C17    C18    O8     .
 15P      H171   C17    .      .
 15P      H172   C17    .      .
 15P      O8     C17    C16    .
 15P      C16    O8     C15    .
 15P      H161   C16    .      .
 15P      H162   C16    .      .
 15P      C15    C16    O7     .
 15P      H151   C15    .      .
 15P      H152   C15    .      .
 15P      O7     C15    C14    .
 15P      C14    O7     C13    .
 15P      H141   C14    .      .
 15P      H142   C14    .      .
 15P      C13    C14    O6     .
 15P      H131   C13    .      .
 15P      H132   C13    .      .
 15P      O6     C13    C12    .
 15P      C12    O6     C11    .
 15P      H121   C12    .      .
 15P      H122   C12    .      .
 15P      C11    C12    O5     .
 15P      H111   C11    .      .
 15P      H112   C11    .      .
 15P      O5     C11    C10    .
 15P      C10    O5     C9     .
 15P      H101   C10    .      .
 15P      H102   C10    .      .
 15P      C9     C10    O4     .
 15P      H19    C9     .      .
 15P      H29    C9     .      .
 15P      O4     C9     C8     .
 15P      C8     O4     C7     .
 15P      H18    C8     .      .
 15P      H28    C8     .      .
 15P      C7     C8     O3     .
 15P      H17    C7     .      .
 15P      H27    C7     .      .
 15P      O3     C7     C6     .
 15P      C6     O3     C5     .
 15P      H16    C6     .      .
 15P      H26    C6     .      .
 15P      C5     C6     O2     .
 15P      H15    C5     .      .
 15P      H25    C5     .      .
 15P      O2     C5     C4     .
 15P      C4     O2     C3     .
 15P      H14    C4     .      .
 15P      H24    C4     .      .
 15P      C3     C4     O1     .
 15P      H13    C3     .      .
 15P      H23    C3     .      .
 15P      O1     C3     C2     .
 15P      C2     O1     C1     .
 15P      H12    C2     .      .
 15P      H22    C2     .      .
 15P      C1     C2     OXT    .
 15P      H11    C1     .      .
 15P      H21    C1     .      .
 15P      OXT    C1     HXT    .
 15P      HXT    OXT    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 15P      OXT    C1        single      1.432    0.020
 15P      HXT    OXT       single      0.967    0.020
 15P      C1     C2        single      1.524    0.020
 15P      H11    C1        single      1.092    0.020
 15P      H21    C1        single      1.092    0.020
 15P      C2     O1        single      1.426    0.020
 15P      H12    C2        single      1.092    0.020
 15P      H22    C2        single      1.092    0.020
 15P      O1     C3        single      1.426    0.020
 15P      C3     C4        single      1.524    0.020
 15P      H13    C3        single      1.092    0.020
 15P      H23    C3        single      1.092    0.020
 15P      C4     O2        single      1.426    0.020
 15P      H14    C4        single      1.092    0.020
 15P      H24    C4        single      1.092    0.020
 15P      O2     C5        single      1.426    0.020
 15P      C5     C6        single      1.524    0.020
 15P      H15    C5        single      1.092    0.020
 15P      H25    C5        single      1.092    0.020
 15P      C6     O3        single      1.426    0.020
 15P      H16    C6        single      1.092    0.020
 15P      H26    C6        single      1.092    0.020
 15P      O3     C7        single      1.426    0.020
 15P      C7     C8        single      1.524    0.020
 15P      H17    C7        single      1.092    0.020
 15P      H27    C7        single      1.092    0.020
 15P      C8     O4        single      1.426    0.020
 15P      H18    C8        single      1.092    0.020
 15P      H28    C8        single      1.092    0.020
 15P      O4     C9        single      1.426    0.020
 15P      C9     C10       single      1.524    0.020
 15P      H19    C9        single      1.092    0.020
 15P      H29    C9        single      1.092    0.020
 15P      C10    O5        single      1.426    0.020
 15P      H101   C10       single      1.092    0.020
 15P      H102   C10       single      1.092    0.020
 15P      O5     C11       single      1.426    0.020
 15P      C11    C12       single      1.524    0.020
 15P      H111   C11       single      1.092    0.020
 15P      H112   C11       single      1.092    0.020
 15P      C12    O6        single      1.426    0.020
 15P      H121   C12       single      1.092    0.020
 15P      H122   C12       single      1.092    0.020
 15P      O6     C13       single      1.426    0.020
 15P      C13    C14       single      1.524    0.020
 15P      H131   C13       single      1.092    0.020
 15P      H132   C13       single      1.092    0.020
 15P      C14    O7        single      1.426    0.020
 15P      H141   C14       single      1.092    0.020
 15P      H142   C14       single      1.092    0.020
 15P      O7     C15       single      1.426    0.020
 15P      C15    C16       single      1.524    0.020
 15P      H151   C15       single      1.092    0.020
 15P      H152   C15       single      1.092    0.020
 15P      C16    O8        single      1.426    0.020
 15P      H161   C16       single      1.092    0.020
 15P      H162   C16       single      1.092    0.020
 15P      O8     C17       single      1.426    0.020
 15P      C17    C18       single      1.524    0.020
 15P      H171   C17       single      1.092    0.020
 15P      H172   C17       single      1.092    0.020
 15P      C18    O9        single      1.426    0.020
 15P      H181   C18       single      1.092    0.020
 15P      H182   C18       single      1.092    0.020
 15P      O9     C19       single      1.426    0.020
 15P      C19    C20       single      1.524    0.020
 15P      H191   C19       single      1.092    0.020
 15P      H192   C19       single      1.092    0.020
 15P      C20    O10       single      1.426    0.020
 15P      H201   C20       single      1.092    0.020
 15P      H202   C20       single      1.092    0.020
 15P      O10    C21       single      1.426    0.020
 15P      C21    C22       single      1.524    0.020
 15P      H211   C21       single      1.092    0.020
 15P      H212   C21       single      1.092    0.020
 15P      C22    O11       single      1.426    0.020
 15P      H221   C22       single      1.092    0.020
 15P      H222   C22       single      1.092    0.020
 15P      O11    C23       single      1.426    0.020
 15P      C23    C24       single      1.524    0.020
 15P      H231   C23       single      1.092    0.020
 15P      H232   C23       single      1.092    0.020
 15P      C24    O12       single      1.426    0.020
 15P      H241   C24       single      1.092    0.020
 15P      H242   C24       single      1.092    0.020
 15P      O12    C25       single      1.426    0.020
 15P      C25    C26       single      1.524    0.020
 15P      H251   C25       single      1.092    0.020
 15P      H252   C25       single      1.092    0.020
 15P      C26    O13       single      1.426    0.020
 15P      H261   C26       single      1.092    0.020
 15P      H262   C26       single      1.092    0.020
 15P      O13    C27       single      1.426    0.020
 15P      C27    C28       single      1.524    0.020
 15P      H271   C27       single      1.092    0.020
 15P      H272   C27       single      1.092    0.020
 15P      C28    O14       single      1.426    0.020
 15P      H281   C28       single      1.092    0.020
 15P      H282   C28       single      1.092    0.020
 15P      O14    C29       single      1.426    0.020
 15P      C29    C30       single      1.524    0.020
 15P      H291   C29       single      1.092    0.020
 15P      H292   C29       single      1.092    0.020
 15P      C30    O15       single      1.426    0.020
 15P      H301   C30       single      1.092    0.020
 15P      H302   C30       single      1.092    0.020
 15P      O15    C31       single      1.426    0.020
 15P      C31    C32       single      1.524    0.020
 15P      H311   C31       single      1.092    0.020
 15P      H312   C31       single      1.092    0.020
 15P      C32    O16       single      1.426    0.020
 15P      H321   C32       single      1.092    0.020
 15P      H322   C32       single      1.092    0.020
 15P      O16    C33       single      1.426    0.020
 15P      C33    C34       single      1.524    0.020
 15P      H331   C33       single      1.092    0.020
 15P      H332   C33       single      1.092    0.020
 15P      C34    O17       single      1.426    0.020
 15P      H341   C34       single      1.092    0.020
 15P      H342   C34       single      1.092    0.020
 15P      O17    C35       single      1.426    0.020
 15P      C35    C36       single      1.524    0.020
 15P      H351   C35       single      1.092    0.020
 15P      H352   C35       single      1.092    0.020
 15P      C36    O18       single      1.426    0.020
 15P      H361   C36       single      1.092    0.020
 15P      H362   C36       single      1.092    0.020
 15P      O18    C37       single      1.426    0.020
 15P      C37    C38       single      1.524    0.020
 15P      H371   C37       single      1.092    0.020
 15P      H372   C37       single      1.092    0.020
 15P      C38    O19       single      1.426    0.020
 15P      H381   C38       single      1.092    0.020
 15P      H382   C38       single      1.092    0.020
 15P      O19    C39       single      1.426    0.020
 15P      C39    C40       single      1.524    0.020
 15P      H391   C39       single      1.092    0.020
 15P      H392   C39       single      1.092    0.020
 15P      C40    O20       single      1.426    0.020
 15P      H401   C40       single      1.092    0.020
 15P      H402   C40       single      1.092    0.020
 15P      O20    C41       single      1.426    0.020
 15P      C41    C42       single      1.524    0.020
 15P      H411   C41       single      1.092    0.020
 15P      H412   C41       single      1.092    0.020
 15P      C42    O21       single      1.426    0.020
 15P      H421   C42       single      1.092    0.020
 15P      H422   C42       single      1.092    0.020
 15P      O21    C43       single      1.426    0.020
 15P      C43    C44       single      1.524    0.020
 15P      H431   C43       single      1.092    0.020
 15P      H432   C43       single      1.092    0.020
 15P      C44    O22       single      1.426    0.020
 15P      H441   C44       single      1.092    0.020
 15P      H442   C44       single      1.092    0.020
 15P      O22    C45       single      1.426    0.020
 15P      C45    C46       single      1.524    0.020
 15P      H451   C45       single      1.092    0.020
 15P      H452   C45       single      1.092    0.020
 15P      C46    O23       single      1.426    0.020
 15P      H461   C46       single      1.092    0.020
 15P      H462   C46       single      1.092    0.020
 15P      O23    C47       single      1.426    0.020
 15P      C47    C48       single      1.524    0.020
 15P      H471   C47       single      1.092    0.020
 15P      H472   C47       single      1.092    0.020
 15P      C48    O24       single      1.426    0.020
 15P      H481   C48       single      1.092    0.020
 15P      H482   C48       single      1.092    0.020
 15P      O24    C49       single      1.426    0.020
 15P      C49    C50       single      1.524    0.020
 15P      H491   C49       single      1.092    0.020
 15P      H492   C49       single      1.092    0.020
 15P      C50    O25       single      1.426    0.020
 15P      H501   C50       single      1.092    0.020
 15P      H502   C50       single      1.092    0.020
 15P      O25    C51       single      1.426    0.020
 15P      C51    C52       single      1.524    0.020
 15P      H511   C51       single      1.092    0.020
 15P      H512   C51       single      1.092    0.020
 15P      C52    O26       single      1.426    0.020
 15P      H521   C52       single      1.092    0.020
 15P      H522   C52       single      1.092    0.020
 15P      O26    C53       single      1.426    0.020
 15P      C53    C54       single      1.524    0.020
 15P      H531   C53       single      1.092    0.020
 15P      H532   C53       single      1.092    0.020
 15P      C54    O27       single      1.426    0.020
 15P      H541   C54       single      1.092    0.020
 15P      H542   C54       single      1.092    0.020
 15P      O27    C55       single      1.426    0.020
 15P      C55    C56       single      1.524    0.020
 15P      H551   C55       single      1.092    0.020
 15P      H552   C55       single      1.092    0.020
 15P      C56    O28       single      1.426    0.020
 15P      H561   C56       single      1.092    0.020
 15P      H562   C56       single      1.092    0.020
 15P      O28    C57       single      1.426    0.020
 15P      C57    C58       single      1.524    0.020
 15P      H571   C57       single      1.092    0.020
 15P      H572   C57       single      1.092    0.020
 15P      C58    O29       single      1.426    0.020
 15P      H581   C58       single      1.092    0.020
 15P      H582   C58       single      1.092    0.020
 15P      O29    C59       single      1.426    0.020
 15P      C59    C60       single      1.524    0.020
 15P      H591   C59       single      1.092    0.020
 15P      H592   C59       single      1.092    0.020
 15P      C60    O30       single      1.426    0.020
 15P      H601   C60       single      1.092    0.020
 15P      H602   C60       single      1.092    0.020
 15P      O30    C61       single      1.426    0.020
 15P      C61    C62       single      1.524    0.020
 15P      H611   C61       single      1.092    0.020
 15P      H612   C61       single      1.092    0.020
 15P      C62    O31       single      1.426    0.020
 15P      H621   C62       single      1.092    0.020
 15P      H622   C62       single      1.092    0.020
 15P      O31    C63       single      1.426    0.020
 15P      C63    C64       single      1.524    0.020
 15P      H631   C63       single      1.092    0.020
 15P      H632   C63       single      1.092    0.020
 15P      C64    O32       single      1.426    0.020
 15P      H641   C64       single      1.092    0.020
 15P      H642   C64       single      1.092    0.020
 15P      O32    C65       single      1.426    0.020
 15P      C65    C66       single      1.524    0.020
 15P      H651   C65       single      1.092    0.020
 15P      H652   C65       single      1.092    0.020
 15P      C66    O33       single      1.426    0.020
 15P      H661   C66       single      1.092    0.020
 15P      H662   C66       single      1.092    0.020
 15P      O33    C67       single      1.426    0.020
 15P      C67    C68       single      1.524    0.020
 15P      H671   C67       single      1.092    0.020
 15P      H672   C67       single      1.092    0.020
 15P      C68    O34       single      1.426    0.020
 15P      H681   C68       single      1.092    0.020
 15P      H682   C68       single      1.092    0.020
 15P      O34    CM        single      1.426    0.020
 15P      HCM1   CM        single      1.059    0.020
 15P      HCM2   CM        single      1.059    0.020
 15P      HCM3   CM        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 15P      HCM1   CM     HCM2    109.470    3.000
 15P      HCM1   CM     HCM3    109.470    3.000
 15P      HCM2   CM     HCM3    109.470    3.000
 15P      HCM1   CM     O34     109.470    3.000
 15P      HCM2   CM     O34     109.470    3.000
 15P      HCM3   CM     O34     109.470    3.000
 15P      CM     O34    C68     111.800    3.000
 15P      O34    C68    H681    109.470    3.000
 15P      O34    C68    H682    109.470    3.000
 15P      O34    C68    C67     109.470    3.000
 15P      H681   C68    H682    107.900    3.000
 15P      H681   C68    C67     109.470    3.000
 15P      H682   C68    C67     109.470    3.000
 15P      C68    C67    H671    109.470    3.000
 15P      C68    C67    H672    109.470    3.000
 15P      C68    C67    O33     109.470    3.000
 15P      H671   C67    H672    107.900    3.000
 15P      H671   C67    O33     109.470    3.000
 15P      H672   C67    O33     109.470    3.000
 15P      C67    O33    C66     111.800    3.000
 15P      O33    C66    H661    109.470    3.000
 15P      O33    C66    H662    109.470    3.000
 15P      O33    C66    C65     109.470    3.000
 15P      H661   C66    H662    107.900    3.000
 15P      H661   C66    C65     109.470    3.000
 15P      H662   C66    C65     109.470    3.000
 15P      C66    C65    H651    109.470    3.000
 15P      C66    C65    H652    109.470    3.000
 15P      C66    C65    O32     109.470    3.000
 15P      H651   C65    H652    107.900    3.000
 15P      H651   C65    O32     109.470    3.000
 15P      H652   C65    O32     109.470    3.000
 15P      C65    O32    C64     111.800    3.000
 15P      O32    C64    H641    109.470    3.000
 15P      O32    C64    H642    109.470    3.000
 15P      O32    C64    C63     109.470    3.000
 15P      H641   C64    H642    107.900    3.000
 15P      H641   C64    C63     109.470    3.000
 15P      H642   C64    C63     109.470    3.000
 15P      C64    C63    H631    109.470    3.000
 15P      C64    C63    H632    109.470    3.000
 15P      C64    C63    O31     109.470    3.000
 15P      H631   C63    H632    107.900    3.000
 15P      H631   C63    O31     109.470    3.000
 15P      H632   C63    O31     109.470    3.000
 15P      C63    O31    C62     111.800    3.000
 15P      O31    C62    H621    109.470    3.000
 15P      O31    C62    H622    109.470    3.000
 15P      O31    C62    C61     109.470    3.000
 15P      H621   C62    H622    107.900    3.000
 15P      H621   C62    C61     109.470    3.000
 15P      H622   C62    C61     109.470    3.000
 15P      C62    C61    H611    109.470    3.000
 15P      C62    C61    H612    109.470    3.000
 15P      C62    C61    O30     109.470    3.000
 15P      H611   C61    H612    107.900    3.000
 15P      H611   C61    O30     109.470    3.000
 15P      H612   C61    O30     109.470    3.000
 15P      C61    O30    C60     111.800    3.000
 15P      O30    C60    H601    109.470    3.000
 15P      O30    C60    H602    109.470    3.000
 15P      O30    C60    C59     109.470    3.000
 15P      H601   C60    H602    107.900    3.000
 15P      H601   C60    C59     109.470    3.000
 15P      H602   C60    C59     109.470    3.000
 15P      C60    C59    H591    109.470    3.000
 15P      C60    C59    H592    109.470    3.000
 15P      C60    C59    O29     109.470    3.000
 15P      H591   C59    H592    107.900    3.000
 15P      H591   C59    O29     109.470    3.000
 15P      H592   C59    O29     109.470    3.000
 15P      C59    O29    C58     111.800    3.000
 15P      O29    C58    H581    109.470    3.000
 15P      O29    C58    H582    109.470    3.000
 15P      O29    C58    C57     109.470    3.000
 15P      H581   C58    H582    107.900    3.000
 15P      H581   C58    C57     109.470    3.000
 15P      H582   C58    C57     109.470    3.000
 15P      C58    C57    H571    109.470    3.000
 15P      C58    C57    H572    109.470    3.000
 15P      C58    C57    O28     109.470    3.000
 15P      H571   C57    H572    107.900    3.000
 15P      H571   C57    O28     109.470    3.000
 15P      H572   C57    O28     109.470    3.000
 15P      C57    O28    C56     111.800    3.000
 15P      O28    C56    H561    109.470    3.000
 15P      O28    C56    H562    109.470    3.000
 15P      O28    C56    C55     109.470    3.000
 15P      H561   C56    H562    107.900    3.000
 15P      H561   C56    C55     109.470    3.000
 15P      H562   C56    C55     109.470    3.000
 15P      C56    C55    H551    109.470    3.000
 15P      C56    C55    H552    109.470    3.000
 15P      C56    C55    O27     109.470    3.000
 15P      H551   C55    H552    107.900    3.000
 15P      H551   C55    O27     109.470    3.000
 15P      H552   C55    O27     109.470    3.000
 15P      C55    O27    C54     111.800    3.000
 15P      O27    C54    H541    109.470    3.000
 15P      O27    C54    H542    109.470    3.000
 15P      O27    C54    C53     109.470    3.000
 15P      H541   C54    H542    107.900    3.000
 15P      H541   C54    C53     109.470    3.000
 15P      H542   C54    C53     109.470    3.000
 15P      C54    C53    H531    109.470    3.000
 15P      C54    C53    H532    109.470    3.000
 15P      C54    C53    O26     109.470    3.000
 15P      H531   C53    H532    107.900    3.000
 15P      H531   C53    O26     109.470    3.000
 15P      H532   C53    O26     109.470    3.000
 15P      C53    O26    C52     111.800    3.000
 15P      O26    C52    H521    109.470    3.000
 15P      O26    C52    H522    109.470    3.000
 15P      O26    C52    C51     109.470    3.000
 15P      H521   C52    H522    107.900    3.000
 15P      H521   C52    C51     109.470    3.000
 15P      H522   C52    C51     109.470    3.000
 15P      C52    C51    H511    109.470    3.000
 15P      C52    C51    H512    109.470    3.000
 15P      C52    C51    O25     109.470    3.000
 15P      H511   C51    H512    107.900    3.000
 15P      H511   C51    O25     109.470    3.000
 15P      H512   C51    O25     109.470    3.000
 15P      C51    O25    C50     111.800    3.000
 15P      O25    C50    H501    109.470    3.000
 15P      O25    C50    H502    109.470    3.000
 15P      O25    C50    C49     109.470    3.000
 15P      H501   C50    H502    107.900    3.000
 15P      H501   C50    C49     109.470    3.000
 15P      H502   C50    C49     109.470    3.000
 15P      C50    C49    H491    109.470    3.000
 15P      C50    C49    H492    109.470    3.000
 15P      C50    C49    O24     109.470    3.000
 15P      H491   C49    H492    107.900    3.000
 15P      H491   C49    O24     109.470    3.000
 15P      H492   C49    O24     109.470    3.000
 15P      C49    O24    C48     111.800    3.000
 15P      O24    C48    H481    109.470    3.000
 15P      O24    C48    H482    109.470    3.000
 15P      O24    C48    C47     109.470    3.000
 15P      H481   C48    H482    107.900    3.000
 15P      H481   C48    C47     109.470    3.000
 15P      H482   C48    C47     109.470    3.000
 15P      C48    C47    H471    109.470    3.000
 15P      C48    C47    H472    109.470    3.000
 15P      C48    C47    O23     109.470    3.000
 15P      H471   C47    H472    107.900    3.000
 15P      H471   C47    O23     109.470    3.000
 15P      H472   C47    O23     109.470    3.000
 15P      C47    O23    C46     111.800    3.000
 15P      O23    C46    H461    109.470    3.000
 15P      O23    C46    H462    109.470    3.000
 15P      O23    C46    C45     109.470    3.000
 15P      H461   C46    H462    107.900    3.000
 15P      H461   C46    C45     109.470    3.000
 15P      H462   C46    C45     109.470    3.000
 15P      C46    C45    H451    109.470    3.000
 15P      C46    C45    H452    109.470    3.000
 15P      C46    C45    O22     109.470    3.000
 15P      H451   C45    H452    107.900    3.000
 15P      H451   C45    O22     109.470    3.000
 15P      H452   C45    O22     109.470    3.000
 15P      C45    O22    C44     111.800    3.000
 15P      O22    C44    H441    109.470    3.000
 15P      O22    C44    H442    109.470    3.000
 15P      O22    C44    C43     109.470    3.000
 15P      H441   C44    H442    107.900    3.000
 15P      H441   C44    C43     109.470    3.000
 15P      H442   C44    C43     109.470    3.000
 15P      C44    C43    H431    109.470    3.000
 15P      C44    C43    H432    109.470    3.000
 15P      C44    C43    O21     109.470    3.000
 15P      H431   C43    H432    107.900    3.000
 15P      H431   C43    O21     109.470    3.000
 15P      H432   C43    O21     109.470    3.000
 15P      C43    O21    C42     111.800    3.000
 15P      O21    C42    H421    109.470    3.000
 15P      O21    C42    H422    109.470    3.000
 15P      O21    C42    C41     109.470    3.000
 15P      H421   C42    H422    107.900    3.000
 15P      H421   C42    C41     109.470    3.000
 15P      H422   C42    C41     109.470    3.000
 15P      C42    C41    H411    109.470    3.000
 15P      C42    C41    H412    109.470    3.000
 15P      C42    C41    O20     109.470    3.000
 15P      H411   C41    H412    107.900    3.000
 15P      H411   C41    O20     109.470    3.000
 15P      H412   C41    O20     109.470    3.000
 15P      C41    O20    C40     111.800    3.000
 15P      O20    C40    H401    109.470    3.000
 15P      O20    C40    H402    109.470    3.000
 15P      O20    C40    C39     109.470    3.000
 15P      H401   C40    H402    107.900    3.000
 15P      H401   C40    C39     109.470    3.000
 15P      H402   C40    C39     109.470    3.000
 15P      C40    C39    H391    109.470    3.000
 15P      C40    C39    H392    109.470    3.000
 15P      C40    C39    O19     109.470    3.000
 15P      H391   C39    H392    107.900    3.000
 15P      H391   C39    O19     109.470    3.000
 15P      H392   C39    O19     109.470    3.000
 15P      C39    O19    C38     111.800    3.000
 15P      O19    C38    H381    109.470    3.000
 15P      O19    C38    H382    109.470    3.000
 15P      O19    C38    C37     109.470    3.000
 15P      H381   C38    H382    107.900    3.000
 15P      H381   C38    C37     109.470    3.000
 15P      H382   C38    C37     109.470    3.000
 15P      C38    C37    H371    109.470    3.000
 15P      C38    C37    H372    109.470    3.000
 15P      C38    C37    O18     109.470    3.000
 15P      H371   C37    H372    107.900    3.000
 15P      H371   C37    O18     109.470    3.000
 15P      H372   C37    O18     109.470    3.000
 15P      C37    O18    C36     111.800    3.000
 15P      O18    C36    H361    109.470    3.000
 15P      O18    C36    H362    109.470    3.000
 15P      O18    C36    C35     109.470    3.000
 15P      H361   C36    H362    107.900    3.000
 15P      H361   C36    C35     109.470    3.000
 15P      H362   C36    C35     109.470    3.000
 15P      C36    C35    H351    109.470    3.000
 15P      C36    C35    H352    109.470    3.000
 15P      C36    C35    O17     109.470    3.000
 15P      H351   C35    H352    107.900    3.000
 15P      H351   C35    O17     109.470    3.000
 15P      H352   C35    O17     109.470    3.000
 15P      C35    O17    C34     111.800    3.000
 15P      O17    C34    H341    109.470    3.000
 15P      O17    C34    H342    109.470    3.000
 15P      O17    C34    C33     109.470    3.000
 15P      H341   C34    H342    107.900    3.000
 15P      H341   C34    C33     109.470    3.000
 15P      H342   C34    C33     109.470    3.000
 15P      C34    C33    H331    109.470    3.000
 15P      C34    C33    H332    109.470    3.000
 15P      C34    C33    O16     109.470    3.000
 15P      H331   C33    H332    107.900    3.000
 15P      H331   C33    O16     109.470    3.000
 15P      H332   C33    O16     109.470    3.000
 15P      C33    O16    C32     111.800    3.000
 15P      O16    C32    H321    109.470    3.000
 15P      O16    C32    H322    109.470    3.000
 15P      O16    C32    C31     109.470    3.000
 15P      H321   C32    H322    107.900    3.000
 15P      H321   C32    C31     109.470    3.000
 15P      H322   C32    C31     109.470    3.000
 15P      C32    C31    H311    109.470    3.000
 15P      C32    C31    H312    109.470    3.000
 15P      C32    C31    O15     109.470    3.000
 15P      H311   C31    H312    107.900    3.000
 15P      H311   C31    O15     109.470    3.000
 15P      H312   C31    O15     109.470    3.000
 15P      C31    O15    C30     111.800    3.000
 15P      O15    C30    H301    109.470    3.000
 15P      O15    C30    H302    109.470    3.000
 15P      O15    C30    C29     109.470    3.000
 15P      H301   C30    H302    107.900    3.000
 15P      H301   C30    C29     109.470    3.000
 15P      H302   C30    C29     109.470    3.000
 15P      C30    C29    H291    109.470    3.000
 15P      C30    C29    H292    109.470    3.000
 15P      C30    C29    O14     109.470    3.000
 15P      H291   C29    H292    107.900    3.000
 15P      H291   C29    O14     109.470    3.000
 15P      H292   C29    O14     109.470    3.000
 15P      C29    O14    C28     111.800    3.000
 15P      O14    C28    H281    109.470    3.000
 15P      O14    C28    H282    109.470    3.000
 15P      O14    C28    C27     109.470    3.000
 15P      H281   C28    H282    107.900    3.000
 15P      H281   C28    C27     109.470    3.000
 15P      H282   C28    C27     109.470    3.000
 15P      C28    C27    H271    109.470    3.000
 15P      C28    C27    H272    109.470    3.000
 15P      C28    C27    O13     109.470    3.000
 15P      H271   C27    H272    107.900    3.000
 15P      H271   C27    O13     109.470    3.000
 15P      H272   C27    O13     109.470    3.000
 15P      C27    O13    C26     111.800    3.000
 15P      O13    C26    H261    109.470    3.000
 15P      O13    C26    H262    109.470    3.000
 15P      O13    C26    C25     109.470    3.000
 15P      H261   C26    H262    107.900    3.000
 15P      H261   C26    C25     109.470    3.000
 15P      H262   C26    C25     109.470    3.000
 15P      C26    C25    H251    109.470    3.000
 15P      C26    C25    H252    109.470    3.000
 15P      C26    C25    O12     109.470    3.000
 15P      H251   C25    H252    107.900    3.000
 15P      H251   C25    O12     109.470    3.000
 15P      H252   C25    O12     109.470    3.000
 15P      C25    O12    C24     111.800    3.000
 15P      O12    C24    H241    109.470    3.000
 15P      O12    C24    H242    109.470    3.000
 15P      O12    C24    C23     109.470    3.000
 15P      H241   C24    H242    107.900    3.000
 15P      H241   C24    C23     109.470    3.000
 15P      H242   C24    C23     109.470    3.000
 15P      C24    C23    H231    109.470    3.000
 15P      C24    C23    H232    109.470    3.000
 15P      C24    C23    O11     109.470    3.000
 15P      H231   C23    H232    107.900    3.000
 15P      H231   C23    O11     109.470    3.000
 15P      H232   C23    O11     109.470    3.000
 15P      C23    O11    C22     111.800    3.000
 15P      O11    C22    H221    109.470    3.000
 15P      O11    C22    H222    109.470    3.000
 15P      O11    C22    C21     109.470    3.000
 15P      H221   C22    H222    107.900    3.000
 15P      H221   C22    C21     109.470    3.000
 15P      H222   C22    C21     109.470    3.000
 15P      C22    C21    H211    109.470    3.000
 15P      C22    C21    H212    109.470    3.000
 15P      C22    C21    O10     109.470    3.000
 15P      H211   C21    H212    107.900    3.000
 15P      H211   C21    O10     109.470    3.000
 15P      H212   C21    O10     109.470    3.000
 15P      C21    O10    C20     111.800    3.000
 15P      O10    C20    H201    109.470    3.000
 15P      O10    C20    H202    109.470    3.000
 15P      O10    C20    C19     109.470    3.000
 15P      H201   C20    H202    107.900    3.000
 15P      H201   C20    C19     109.470    3.000
 15P      H202   C20    C19     109.470    3.000
 15P      C20    C19    H191    109.470    3.000
 15P      C20    C19    H192    109.470    3.000
 15P      C20    C19    O9      109.470    3.000
 15P      H191   C19    H192    107.900    3.000
 15P      H191   C19    O9      109.470    3.000
 15P      H192   C19    O9      109.470    3.000
 15P      C19    O9     C18     111.800    3.000
 15P      O9     C18    H181    109.470    3.000
 15P      O9     C18    H182    109.470    3.000
 15P      O9     C18    C17     109.470    3.000
 15P      H181   C18    H182    107.900    3.000
 15P      H181   C18    C17     109.470    3.000
 15P      H182   C18    C17     109.470    3.000
 15P      C18    C17    H171    109.470    3.000
 15P      C18    C17    H172    109.470    3.000
 15P      C18    C17    O8      109.470    3.000
 15P      H171   C17    H172    107.900    3.000
 15P      H171   C17    O8      109.470    3.000
 15P      H172   C17    O8      109.470    3.000
 15P      C17    O8     C16     111.800    3.000
 15P      O8     C16    H161    109.470    3.000
 15P      O8     C16    H162    109.470    3.000
 15P      O8     C16    C15     109.470    3.000
 15P      H161   C16    H162    107.900    3.000
 15P      H161   C16    C15     109.470    3.000
 15P      H162   C16    C15     109.470    3.000
 15P      C16    C15    H151    109.470    3.000
 15P      C16    C15    H152    109.470    3.000
 15P      C16    C15    O7      109.470    3.000
 15P      H151   C15    H152    107.900    3.000
 15P      H151   C15    O7      109.470    3.000
 15P      H152   C15    O7      109.470    3.000
 15P      C15    O7     C14     111.800    3.000
 15P      O7     C14    H141    109.470    3.000
 15P      O7     C14    H142    109.470    3.000
 15P      O7     C14    C13     109.470    3.000
 15P      H141   C14    H142    107.900    3.000
 15P      H141   C14    C13     109.470    3.000
 15P      H142   C14    C13     109.470    3.000
 15P      C14    C13    H131    109.470    3.000
 15P      C14    C13    H132    109.470    3.000
 15P      C14    C13    O6      109.470    3.000
 15P      H131   C13    H132    107.900    3.000
 15P      H131   C13    O6      109.470    3.000
 15P      H132   C13    O6      109.470    3.000
 15P      C13    O6     C12     111.800    3.000
 15P      O6     C12    H121    109.470    3.000
 15P      O6     C12    H122    109.470    3.000
 15P      O6     C12    C11     109.470    3.000
 15P      H121   C12    H122    107.900    3.000
 15P      H121   C12    C11     109.470    3.000
 15P      H122   C12    C11     109.470    3.000
 15P      C12    C11    H111    109.470    3.000
 15P      C12    C11    H112    109.470    3.000
 15P      C12    C11    O5      109.470    3.000
 15P      H111   C11    H112    107.900    3.000
 15P      H111   C11    O5      109.470    3.000
 15P      H112   C11    O5      109.470    3.000
 15P      C11    O5     C10     111.800    3.000
 15P      O5     C10    H101    109.470    3.000
 15P      O5     C10    H102    109.470    3.000
 15P      O5     C10    C9      109.470    3.000
 15P      H101   C10    H102    107.900    3.000
 15P      H101   C10    C9      109.470    3.000
 15P      H102   C10    C9      109.470    3.000
 15P      C10    C9     H19     109.470    3.000
 15P      C10    C9     H29     109.470    3.000
 15P      C10    C9     O4      109.470    3.000
 15P      H19    C9     H29     107.900    3.000
 15P      H19    C9     O4      109.470    3.000
 15P      H29    C9     O4      109.470    3.000
 15P      C9     O4     C8      111.800    3.000
 15P      O4     C8     H18     109.470    3.000
 15P      O4     C8     H28     109.470    3.000
 15P      O4     C8     C7      109.470    3.000
 15P      H18    C8     H28     107.900    3.000
 15P      H18    C8     C7      109.470    3.000
 15P      H28    C8     C7      109.470    3.000
 15P      C8     C7     H17     109.470    3.000
 15P      C8     C7     H27     109.470    3.000
 15P      C8     C7     O3      109.470    3.000
 15P      H17    C7     H27     107.900    3.000
 15P      H17    C7     O3      109.470    3.000
 15P      H27    C7     O3      109.470    3.000
 15P      C7     O3     C6      111.800    3.000
 15P      O3     C6     H16     109.470    3.000
 15P      O3     C6     H26     109.470    3.000
 15P      O3     C6     C5      109.470    3.000
 15P      H16    C6     H26     107.900    3.000
 15P      H16    C6     C5      109.470    3.000
 15P      H26    C6     C5      109.470    3.000
 15P      C6     C5     H15     109.470    3.000
 15P      C6     C5     H25     109.470    3.000
 15P      C6     C5     O2      109.470    3.000
 15P      H15    C5     H25     107.900    3.000
 15P      H15    C5     O2      109.470    3.000
 15P      H25    C5     O2      109.470    3.000
 15P      C5     O2     C4      111.800    3.000
 15P      O2     C4     H14     109.470    3.000
 15P      O2     C4     H24     109.470    3.000
 15P      O2     C4     C3      109.470    3.000
 15P      H14    C4     H24     107.900    3.000
 15P      H14    C4     C3      109.470    3.000
 15P      H24    C4     C3      109.470    3.000
 15P      C4     C3     H13     109.470    3.000
 15P      C4     C3     H23     109.470    3.000
 15P      C4     C3     O1      109.470    3.000
 15P      H13    C3     H23     107.900    3.000
 15P      H13    C3     O1      109.470    3.000
 15P      H23    C3     O1      109.470    3.000
 15P      C3     O1     C2      111.800    3.000
 15P      O1     C2     H12     109.470    3.000
 15P      O1     C2     H22     109.470    3.000
 15P      O1     C2     C1      109.470    3.000
 15P      H12    C2     H22     107.900    3.000
 15P      H12    C2     C1      109.470    3.000
 15P      H22    C2     C1      109.470    3.000
 15P      C2     C1     H11     109.470    3.000
 15P      C2     C1     H21     109.470    3.000
 15P      C2     C1     OXT     109.470    3.000
 15P      H11    C1     H21     107.900    3.000
 15P      H11    C1     OXT     109.470    3.000
 15P      H21    C1     OXT     109.470    3.000
 15P      C1     OXT    HXT     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 15P      var_1    HCM3   CM     O34    C68      -38.510   20.000   1
 15P      var_2    CM     O34    C68    C67      179.029   20.000   1
 15P      var_3    O34    C68    C67    O33      -60.852   20.000   3
 15P      var_4    C68    C67    O33    C66      179.993   20.000   1
 15P      var_5    C67    O33    C66    C65      179.029   20.000   1
 15P      var_6    O33    C66    C65    O32      -60.852   20.000   3
 15P      var_7    C66    C65    O32    C64     -179.988   20.000   1
 15P      var_8    C65    O32    C64    C63      179.016   20.000   1
 15P      var_9    O32    C64    C63    O31       59.134   20.000   3
 15P      var_10   C64    C63    O31    C62      179.988   20.000   1
 15P      var_11   C63    O31    C62    C61      178.991   20.000   1
 15P      var_12   O31    C62    C61    O30      -60.902   20.000   3
 15P      var_13   C62    C61    O30    C60     -179.988   20.000   1
 15P      var_14   C61    O30    C60    C59      179.087   20.000   1
 15P      var_15   O30    C60    C59    O29      -60.910   20.000   3
 15P      var_16   C60    C59    O29    C58      179.994   20.000   1
 15P      var_17   C59    O29    C58    C57      179.087   20.000   1
 15P      var_18   O29    C58    C57    O28       59.123   20.000   3
 15P      var_19   C58    C57    O28    C56      179.985   20.000   1
 15P      var_20   C57    O28    C56    C55      179.045   20.000   1
 15P      var_21   O28    C56    C55    O27      -60.870   20.000   3
 15P      var_22   C56    C55    O27    C54     -179.987   20.000   1
 15P      var_23   C55    O27    C54    C53      179.052   20.000   1
 15P      var_24   O27    C54    C53    O26      -60.902   20.000   3
 15P      var_25   C54    C53    O26    C52     -179.974   20.000   1
 15P      var_26   C53    O26    C52    C51      179.042   20.000   1
 15P      var_27   O26    C52    C51    O25       59.124   20.000   3
 15P      var_28   C52    C51    O25    C50     -179.997   20.000   1
 15P      var_29   C51    O25    C50    C49      179.014   20.000   1
 15P      var_30   O25    C50    C49    O24      -60.882   20.000   3
 15P      var_31   C50    C49    O24    C48      179.985   20.000   1
 15P      var_32   C49    O24    C48    C47      179.050   20.000   1
 15P      var_33   O24    C48    C47    O23      -60.887   20.000   3
 15P      var_34   C48    C47    O23    C46      179.993   20.000   1
 15P      var_35   C47    O23    C46    C45      179.053   20.000   1
 15P      var_36   O23    C46    C45    O22      -60.867   20.000   3
 15P      var_37   C46    C45    O22    C44     -179.948   20.000   1
 15P      var_38   C45    O22    C44    C43      179.065   20.000   1
 15P      var_39   O22    C44    C43    O21      -60.920   20.000   3
 15P      var_40   C44    C43    O21    C42     -179.978   20.000   1
 15P      var_41   C43    O21    C42    C41      179.003   20.000   1
 15P      var_42   O21    C42    C41    O20      -60.849   20.000   3
 15P      var_43   C42    C41    O20    C40      179.985   20.000   1
 15P      var_44   C41    O20    C40    C39      179.042   20.000   1
 15P      var_45   O20    C40    C39    O19      -60.911   20.000   3
 15P      var_46   C40    C39    O19    C38     -179.989   20.000   1
 15P      var_47   C39    O19    C38    C37      179.065   20.000   1
 15P      var_48   O19    C38    C37    O18      -60.893   20.000   3
 15P      var_49   C38    C37    O18    C36      180.000   20.000   1
 15P      var_50   C37    O18    C36    C35      179.044   20.000   1
 15P      var_51   O18    C36    C35    O17      -60.889   20.000   3
 15P      var_52   C36    C35    O17    C34      179.972   20.000   1
 15P      var_53   C35    O17    C34    C33     -179.976   20.000   1
 15P      var_54   O17    C34    C33    O16      -60.865   20.000   3
 15P      var_55   C34    C33    O16    C32      179.092   20.000   1
 15P      var_56   C33    O16    C32    C31     -179.983   20.000   1
 15P      var_57   O16    C32    C31    O15      -60.938   20.000   3
 15P      var_58   C32    C31    O15    C30      179.052   20.000   1
 15P      var_59   C31    O15    C30    C29     -179.978   20.000   1
 15P      var_60   O15    C30    C29    O14      -60.886   20.000   3
 15P      var_61   C30    C29    O14    C28      179.040   20.000   1
 15P      var_62   C29    O14    C28    C27      179.996   20.000   1
 15P      var_63   O14    C28    C27    O13      -60.843   20.000   3
 15P      var_64   C28    C27    O13    C26      179.021   20.000   1
 15P      var_65   C27    O13    C26    C25      179.953   20.000   1
 15P      var_66   O13    C26    C25    O12      -60.895   20.000   3
 15P      var_67   C26    C25    O12    C24      179.020   20.000   1
 15P      var_68   C25    O12    C24    C23     -179.972   20.000   1
 15P      var_69   O12    C24    C23    O11      -60.847   20.000   3
 15P      var_70   C24    C23    O11    C22      179.043   20.000   1
 15P      var_71   C23    O11    C22    C21     -179.997   20.000   1
 15P      var_72   O11    C22    C21    O10      -60.861   20.000   3
 15P      var_73   C22    C21    O10    C20      179.015   20.000   1
 15P      var_74   C21    O10    C20    C19      179.979   20.000   1
 15P      var_75   O10    C20    C19    O9       -60.890   20.000   3
 15P      var_76   C20    C19    O9     C18      179.071   20.000   1
 15P      var_77   C19    O9     C18    C17     -179.997   20.000   1
 15P      var_78   O9     C18    C17    O8       -60.899   20.000   3
 15P      var_79   C18    C17    O8     C16      179.068   20.000   1
 15P      var_80   C17    O8     C16    C15     -179.989   20.000   1
 15P      var_81   O8     C16    C15    O7       -60.889   20.000   3
 15P      var_82   C16    C15    O7     C14      179.013   20.000   1
 15P      var_83   C15    O7     C14    C13     -179.996   20.000   1
 15P      var_84   O7     C14    C13    O6       -60.853   20.000   3
 15P      var_85   C14    C13    O6     C12      179.011   20.000   1
 15P      var_86   C13    O6     C12    C11      179.990   20.000   1
 15P      var_87   O6     C12    C11    O5       -60.852   20.000   3
 15P      var_88   C12    C11    O5     C10      179.042   20.000   1
 15P      var_89   C11    O5     C10    C9       179.984   20.000   1
 15P      var_90   O5     C10    C9     O4       -60.867   20.000   3
 15P      var_91   C10    C9     O4     C8       179.042   20.000   1
 15P      var_92   C9     O4     C8     C7       179.980   20.000   1
 15P      var_93   O4     C8     C7     O3       -60.895   20.000   3
 15P      var_94   C8     C7     O3     C6       179.074   20.000   1
 15P      var_95   C7     O3     C6     C5      -179.957   20.000   1
 15P      var_96   O3     C6     C5     O2       -60.940   20.000   3
 15P      var_97   C6     C5     O2     C4       179.050   20.000   1
 15P      var_98   C5     O2     C4     C3      -179.955   20.000   1
 15P      var_99   O2     C4     C3     O1       -60.900   20.000   3
 15P      var_100  C4     C3     O1     C2       179.087   20.000   1
 15P      var_101  C3     O1     C2     C1      -179.974   20.000   1
 15P      var_102  O1     C2     C1     OXT      -60.901   20.000   3
 15P      var_103  C2     C1     OXT    HXT     -116.804   20.000   1
# ------------------------------------------------------
`.trim();

monomers["DMS"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DMS      DMS 'DIMETHYL SULFOXIDE                  ' non-polymer        10   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DMS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DMS           O      O    O         0.000      0.000    0.000    0.000
 DMS           S      S    S3        0.000     -1.321   -0.526    0.000
 DMS           C2     C    CH3       0.000     -2.250    0.175   -1.390
 DMS           H23    H    H         0.000     -3.268   -0.140   -1.358
 DMS           H22    H    H         0.000     -2.228    1.241   -1.356
 DMS           H21    H    H         0.000     -1.830   -0.139   -2.319
 DMS           C1     C    CH3       0.000     -2.251    0.175    1.389
 DMS           H13    H    H         0.000     -2.228    1.241    1.356
 DMS           H12    H    H         0.000     -3.269   -0.140    1.356
 DMS           H11    H    H         0.000     -1.832   -0.140    2.318
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DMS      O      n/a    S      START
 DMS      S      O      C1     .
 DMS      C2     S      H21    .
 DMS      H23    C2     .      .
 DMS      H22    C2     .      .
 DMS      H21    C2     .      .
 DMS      C1     S      H11    .
 DMS      H13    C1     .      .
 DMS      H12    C1     .      .
 DMS      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DMS      S      O         double      1.480    0.020
 DMS      C1     S         single      1.707    0.020
 DMS      C2     S         single      1.707    0.020
 DMS      H11    C1        single      1.059    0.020
 DMS      H12    C1        single      1.059    0.020
 DMS      H13    C1        single      1.059    0.020
 DMS      H21    C2        single      1.059    0.020
 DMS      H22    C2        single      1.059    0.020
 DMS      H23    C2        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DMS      O      S      C2      109.477    3.000
 DMS      O      S      C1      109.466    3.000
 DMS      C2     S      C1      100.075    3.000
 DMS      S      C2     H23     109.500    3.000
 DMS      S      C2     H22     109.500    3.000
 DMS      S      C2     H21     109.500    3.000
 DMS      H23    C2     H22     109.470    3.000
 DMS      H23    C2     H21     109.470    3.000
 DMS      H22    C2     H21     109.470    3.000
 DMS      S      C1     H13     109.500    3.000
 DMS      S      C1     H12     109.500    3.000
 DMS      S      C1     H11     109.500    3.000
 DMS      H13    C1     H12     109.470    3.000
 DMS      H13    C1     H11     109.470    3.000
 DMS      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DMS      var_1    O      S      C2     H21       64.977   20.000   1
 DMS      var_2    O      S      C1     H11      -65.008   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DMS      chir_01  S      O      C1     C2        negativ
# ------------------------------------------------------
`.trim();

monomers["IOD"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
IOD      IOD 'IODIDE ION                          ' non-polymer         1   1 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_IOD
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 IOD           I      I    I        -1.000      0.000    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 IOD      I      n/a    .      END
# ------------------------------------------------------
`.trim();

monomers["MRD"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MRD      MRD '(4R)-2-METHYLPENTANE-2,4-DIOL       ' non-polymer        22   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MRD
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MRD           O4     O    OH1       0.000      0.000    0.000    0.000
 MRD           HA     H    H         0.000      0.177   -0.950    0.019
 MRD           C4     C    CH1       0.000     -1.217    0.271    0.697
 MRD           H4     H    H         0.000     -1.419    1.351    0.675
 MRD           C5     C    CH3       0.000     -1.087   -0.194    2.150
 MRD           H5C3   H    H         0.000     -1.988    0.008    2.669
 MRD           H5C2   H    H         0.000     -0.893   -1.235    2.172
 MRD           H5C1   H    H         0.000     -0.288    0.323    2.617
 MRD           C3     C    CH2       0.000     -2.369   -0.476    0.024
 MRD           H3C1   H    H         0.000     -3.298   -0.270    0.558
 MRD           H3C2   H    H         0.000     -2.168   -1.550    0.046
 MRD           C2     C    CT        0.000     -2.499   -0.010   -1.428
 MRD           CM     C    CH3       0.000     -2.779    1.492   -1.457
 MRD           HMC3   H    H         0.000     -1.982    2.010   -0.991
 MRD           HMC2   H    H         0.000     -2.869    1.815   -2.462
 MRD           HMC1   H    H         0.000     -3.681    1.694   -0.940
 MRD           O2     O    OH1       0.000     -1.282   -0.282   -2.126
 MRD           H2     H    H         0.000     -1.105   -1.232   -2.106
 MRD           C1     C    CH3       0.000     -3.651   -0.758   -2.102
 MRD           H1C3   H    H         0.000     -3.457   -1.800   -2.081
 MRD           H1C2   H    H         0.000     -4.554   -0.558   -1.585
 MRD           H1C1   H    H         0.000     -3.742   -0.437   -3.107
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MRD      O4     n/a    C4     START
 MRD      HA     O4     .      .
 MRD      C4     O4     C3     .
 MRD      H4     C4     .      .
 MRD      C5     C4     H5C1   .
 MRD      H5C3   C5     .      .
 MRD      H5C2   C5     .      .
 MRD      H5C1   C5     .      .
 MRD      C3     C4     C2     .
 MRD      H3C1   C3     .      .
 MRD      H3C2   C3     .      .
 MRD      C2     C3     C1     .
 MRD      CM     C2     HMC1   .
 MRD      HMC3   CM     .      .
 MRD      HMC2   CM     .      .
 MRD      HMC1   CM     .      .
 MRD      O2     C2     H2     .
 MRD      H2     O2     .      .
 MRD      C1     C2     H1C1   .
 MRD      H1C3   C1     .      .
 MRD      H1C2   C1     .      .
 MRD      H1C1   C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MRD      C1     C2        single      1.524    0.020
 MRD      H1C1   C1        single      1.059    0.020
 MRD      H1C2   C1        single      1.059    0.020
 MRD      H1C3   C1        single      1.059    0.020
 MRD      O2     C2        single      1.432    0.020
 MRD      CM     C2        single      1.524    0.020
 MRD      C2     C3        single      1.524    0.020
 MRD      H2     O2        single      0.967    0.020
 MRD      HMC1   CM        single      1.059    0.020
 MRD      HMC2   CM        single      1.059    0.020
 MRD      HMC3   CM        single      1.059    0.020
 MRD      C3     C4        single      1.524    0.020
 MRD      H3C1   C3        single      1.092    0.020
 MRD      H3C2   C3        single      1.092    0.020
 MRD      C4     O4        single      1.432    0.020
 MRD      C5     C4        single      1.524    0.020
 MRD      H4     C4        single      1.099    0.020
 MRD      HA     O4        single      0.967    0.020
 MRD      H5C1   C5        single      1.059    0.020
 MRD      H5C2   C5        single      1.059    0.020
 MRD      H5C3   C5        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MRD      HA     O4     C4      109.470    3.000
 MRD      O4     C4     H4      109.470    3.000
 MRD      O4     C4     C5      109.470    3.000
 MRD      O4     C4     C3      109.470    3.000
 MRD      H4     C4     C5      108.340    3.000
 MRD      H4     C4     C3      108.340    3.000
 MRD      C5     C4     C3      111.000    3.000
 MRD      C4     C5     H5C3    109.470    3.000
 MRD      C4     C5     H5C2    109.470    3.000
 MRD      C4     C5     H5C1    109.470    3.000
 MRD      H5C3   C5     H5C2    109.470    3.000
 MRD      H5C3   C5     H5C1    109.470    3.000
 MRD      H5C2   C5     H5C1    109.470    3.000
 MRD      C4     C3     H3C1    109.470    3.000
 MRD      C4     C3     H3C2    109.470    3.000
 MRD      C4     C3     C2      111.000    3.000
 MRD      H3C1   C3     H3C2    107.900    3.000
 MRD      H3C1   C3     C2      109.470    3.000
 MRD      H3C2   C3     C2      109.470    3.000
 MRD      C3     C2     CM      111.000    3.000
 MRD      C3     C2     O2      109.470    3.000
 MRD      C3     C2     C1      111.000    3.000
 MRD      CM     C2     O2      109.470    3.000
 MRD      CM     C2     C1      111.000    3.000
 MRD      O2     C2     C1      109.470    3.000
 MRD      C2     CM     HMC3    109.470    3.000
 MRD      C2     CM     HMC2    109.470    3.000
 MRD      C2     CM     HMC1    109.470    3.000
 MRD      HMC3   CM     HMC2    109.470    3.000
 MRD      HMC3   CM     HMC1    109.470    3.000
 MRD      HMC2   CM     HMC1    109.470    3.000
 MRD      C2     O2     H2      109.470    3.000
 MRD      C2     C1     H1C3    109.470    3.000
 MRD      C2     C1     H1C2    109.470    3.000
 MRD      C2     C1     H1C1    109.470    3.000
 MRD      H1C3   C1     H1C2    109.470    3.000
 MRD      H1C3   C1     H1C1    109.470    3.000
 MRD      H1C2   C1     H1C1    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MRD      var_1    HA     O4     C4     C3       -59.952   20.000   1
 MRD      var_2    O4     C4     C5     H5C1      59.935   20.000   3
 MRD      var_3    O4     C4     C3     C2       -60.045   20.000   3
 MRD      var_4    C4     C3     C2     C1      -179.996   20.000   1
 MRD      var_5    C3     C2     CM     HMC1     -60.003   20.000   1
 MRD      var_6    C3     C2     O2     H2        59.926   20.000   1
 MRD      var_7    C3     C2     C1     H1C1    -179.987   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MRD      chir_01  C2     C1     O2     CM        both
 MRD      chir_02  C4     C3     O4     C5        both
# ------------------------------------------------------
`.trim();

monomers["BE7"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BE7      BE7 '(4-CARBOXYPHENYL)(CHLORO)MERCURY    ' non-polymer        15  11 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BE7
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BE7           CL1    CL   CL        0.000      0.000    0.000    0.000
 BE7           HG     HG   HG        0.000     -2.310   -0.001    0.000
 BE7           C5     C    CR6       0.000     -4.410   -0.002    0.000
 BE7           C4     C    CR16      0.000     -5.098   -1.201    0.000
 BE7           H4     H    H         0.000     -4.552   -2.137   -0.001
 BE7           C3     C    CR16      0.000     -6.478   -1.209    0.001
 BE7           H3     H    H         0.000     -7.016   -2.149    0.002
 BE7           C6     C    CR16      0.000     -5.098    1.199    0.001
 BE7           H6     H    H         0.000     -4.553    2.134    0.007
 BE7           C7     C    CR16      0.000     -6.478    1.206   -0.005
 BE7           H7     H    H         0.000     -7.016    2.146   -0.014
 BE7           C2     C    CR6       0.000     -7.179   -0.002    0.001
 BE7           C1     C    C         0.000     -8.656   -0.002    0.002
 BE7           O9     O    OC       -0.500     -9.283    1.081    0.002
 BE7           O8     O    OC       -0.500     -9.282   -1.085   -0.003
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BE7      CL1    n/a    HG     START
 BE7      HG     CL1    C5     .
 BE7      C5     HG     C6     .
 BE7      C4     C5     C3     .
 BE7      H4     C4     .      .
 BE7      C3     C4     H3     .
 BE7      H3     C3     .      .
 BE7      C6     C5     C7     .
 BE7      H6     C6     .      .
 BE7      C7     C6     C2     .
 BE7      H7     C7     .      .
 BE7      C2     C7     C1     .
 BE7      C1     C2     O8     .
 BE7      O9     C1     .      .
 BE7      O8     C1     .      END
 BE7      C2     C3     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BE7      C1     C2        single      1.500    0.020
 BE7      O9     C1        deloc       1.250    0.020
 BE7      O8     C1        deloc       1.250    0.020
 BE7      C2     C3        single      1.390    0.020
 BE7      C2     C7        double      1.390    0.020
 BE7      C3     C4        double      1.390    0.020
 BE7      H3     C3        single      1.083    0.020
 BE7      C4     C5        single      1.390    0.020
 BE7      H4     C4        single      1.083    0.020
 BE7      C6     C5        double      1.390    0.020
 BE7      C5     HG        single      2.295    0.020
 BE7      C7     C6        single      1.390    0.020
 BE7      H6     C6        single      1.083    0.020
 BE7      H7     C7        single      1.083    0.020
 BE7      HG     CL1       single      2.700    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BE7      CL1    HG     C5      180.000    3.000
 BE7      HG     C5     C4      120.000    3.000
 BE7      HG     C5     C6      120.000    3.000
 BE7      C4     C5     C6      120.000    3.000
 BE7      C5     C4     H4      120.000    3.000
 BE7      C5     C4     C3      120.000    3.000
 BE7      H4     C4     C3      120.000    3.000
 BE7      C4     C3     H3      120.000    3.000
 BE7      C4     C3     C2      120.000    3.000
 BE7      H3     C3     C2      120.000    3.000
 BE7      C5     C6     H6      120.000    3.000
 BE7      C5     C6     C7      120.000    3.000
 BE7      H6     C6     C7      120.000    3.000
 BE7      C6     C7     H7      120.000    3.000
 BE7      C6     C7     C2      120.000    3.000
 BE7      H7     C7     C2      120.000    3.000
 BE7      C7     C2     C1      120.000    3.000
 BE7      C7     C2     C3      120.000    3.000
 BE7      C1     C2     C3      120.000    3.000
 BE7      C2     C1     O9      120.000    3.000
 BE7      C2     C1     O8      120.000    3.000
 BE7      O9     C1     O8      123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BE7      var_1    C4     C5     HG     CL1      180.000   20.000   1
 BE7      CONST_1  HG     C5     C4     C3       180.000    0.000   0
 BE7      CONST_2  C5     C4     C3     C2         0.000    0.000   0
 BE7      CONST_3  HG     C5     C6     C7       180.000    0.000   0
 BE7      CONST_4  C5     C6     C7     C2         0.000    0.000   0
 BE7      CONST_5  C6     C7     C2     C1       180.000    0.000   0
 BE7      CONST_6  C7     C2     C3     C4         0.000    0.000   0
 BE7      var_2    C7     C2     C1     O8       179.440   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BE7      chir_01  HG     CL1    C5     .         cross0
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 BE7      plan-1    C1        0.020
 BE7      plan-1    C2        0.020
 BE7      plan-1    O9        0.020
 BE7      plan-1    O8        0.020
 BE7      plan-2    C2        0.020
 BE7      plan-2    C1        0.020
 BE7      plan-2    C3        0.020
 BE7      plan-2    C7        0.020
 BE7      plan-2    C4        0.020
 BE7      plan-2    C5        0.020
 BE7      plan-2    C6        0.020
 BE7      plan-2    H3        0.020
 BE7      plan-2    H4        0.020
 BE7      plan-2    HG        0.020
 BE7      plan-2    H6        0.020
 BE7      plan-2    H7        0.020
# ------------------------------------------------------
`.trim();

monomers["MHA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MHA      MHA '(CARBAMOYLMETHYL-CARBOXYMETHYL-AMINO' non-polymer        21  13 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MHA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MHA           O5     O    O         0.000      0.000    0.000    0.000
 MHA           C6     C    C         0.000     -0.156   -0.705   -0.975
 MHA           N2     N    NH2       0.000      0.913   -1.250   -1.589
 MHA           HN22   H    H         0.000      0.789   -1.839   -2.404
 MHA           HN21   H    H         0.000      1.848   -1.073   -1.242
 MHA           C5     C    CH2       0.000     -1.542   -0.970   -1.498
 MHA           HC51   H    H         0.000     -1.741   -2.043   -1.473
 MHA           HC52   H    H         0.000     -1.616   -0.611   -2.527
 MHA           N1     N    NT        0.000     -2.524   -0.268   -0.661
 MHA           C1     C    CH2       0.000     -3.848   -0.567   -1.224
 MHA           HC11   H    H         0.000     -4.619   -0.313   -0.494
 MHA           HC12   H    H         0.000     -3.910   -1.632   -1.460
 MHA           C2     C    C         0.000     -4.055    0.240   -2.478
 MHA           O2     O    OC       -0.500     -3.141    0.979   -2.906
 MHA           O1     O    OC       -0.500     -5.143    0.174   -3.093
 MHA           C3     C    CH2       0.000     -2.477   -0.898    0.663
 MHA           HC31   H    H         0.000     -1.437   -1.085    0.939
 MHA           HC32   H    H         0.000     -3.021   -1.845    0.635
 MHA           C4     C    C         0.000     -3.111    0.017    1.679
 MHA           O3     O    OC       -0.500     -3.303   -0.382    2.848
 MHA           O4     O    OC       -0.500     -3.445    1.177    1.351
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MHA      O5     n/a    C6     START
 MHA      C6     O5     C5     .
 MHA      N2     C6     HN21   .
 MHA      HN22   N2     .      .
 MHA      HN21   N2     .      .
 MHA      C5     C6     N1     .
 MHA      HC51   C5     .      .
 MHA      HC52   C5     .      .
 MHA      N1     C5     C3     .
 MHA      C1     N1     C2     .
 MHA      HC11   C1     .      .
 MHA      HC12   C1     .      .
 MHA      C2     C1     O1     .
 MHA      O2     C2     .      .
 MHA      O1     C2     .      .
 MHA      C3     N1     C4     .
 MHA      HC31   C3     .      .
 MHA      HC32   C3     .      .
 MHA      C4     C3     O4     .
 MHA      O3     C4     .      .
 MHA      O4     C4     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MHA      C1     N1        single      1.469    0.020
 MHA      C3     N1        single      1.469    0.020
 MHA      N1     C5        single      1.469    0.020
 MHA      C2     C1        single      1.510    0.020
 MHA      HC11   C1        single      1.092    0.020
 MHA      HC12   C1        single      1.092    0.020
 MHA      O1     C2        deloc       1.250    0.020
 MHA      O2     C2        deloc       1.250    0.020
 MHA      C4     C3        single      1.510    0.020
 MHA      HC31   C3        single      1.092    0.020
 MHA      HC32   C3        single      1.092    0.020
 MHA      O3     C4        deloc       1.250    0.020
 MHA      O4     C4        deloc       1.250    0.020
 MHA      C5     C6        single      1.510    0.020
 MHA      HC51   C5        single      1.092    0.020
 MHA      HC52   C5        single      1.092    0.020
 MHA      C6     O5        double      1.220    0.020
 MHA      N2     C6        single      1.332    0.020
 MHA      HN21   N2        single      1.010    0.020
 MHA      HN22   N2        single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MHA      O5     C6     N2      123.000    3.000
 MHA      O5     C6     C5      120.500    3.000
 MHA      N2     C6     C5      116.500    3.000
 MHA      C6     N2     HN22    120.000    3.000
 MHA      C6     N2     HN21    120.000    3.000
 MHA      HN22   N2     HN21    120.000    3.000
 MHA      C6     C5     HC51    109.470    3.000
 MHA      C6     C5     HC52    109.470    3.000
 MHA      C6     C5     N1      109.500    3.000
 MHA      HC51   C5     HC52    107.900    3.000
 MHA      HC51   C5     N1      109.470    3.000
 MHA      HC52   C5     N1      109.470    3.000
 MHA      C5     N1     C1      109.470    3.000
 MHA      C5     N1     C3      109.470    3.000
 MHA      C1     N1     C3      109.470    3.000
 MHA      N1     C1     HC11    109.470    3.000
 MHA      N1     C1     HC12    109.470    3.000
 MHA      N1     C1     C2      109.500    3.000
 MHA      HC11   C1     HC12    107.900    3.000
 MHA      HC11   C1     C2      109.470    3.000
 MHA      HC12   C1     C2      109.470    3.000
 MHA      C1     C2     O2      118.500    3.000
 MHA      C1     C2     O1      118.500    3.000
 MHA      O2     C2     O1      123.000    3.000
 MHA      N1     C3     HC31    109.470    3.000
 MHA      N1     C3     HC32    109.470    3.000
 MHA      N1     C3     C4      109.500    3.000
 MHA      HC31   C3     HC32    107.900    3.000
 MHA      HC31   C3     C4      109.470    3.000
 MHA      HC32   C3     C4      109.470    3.000
 MHA      C3     C4     O3      118.500    3.000
 MHA      C3     C4     O4      118.500    3.000
 MHA      O3     C4     O4      123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MHA      CONST_1  O5     C6     N2     HN21       0.000    0.000   0
 MHA      var_1    O5     C6     C5     N1        -0.066   20.000   3
 MHA      var_2    C6     C5     N1     C3       -66.205   20.000   1
 MHA      var_3    C5     N1     C1     C2       -75.755   20.000   1
 MHA      var_4    N1     C1     C2     O1      -177.334   20.000   3
 MHA      var_5    C5     N1     C3     C4       162.164   20.000   1
 MHA      var_6    N1     C3     C4     O4        -7.510   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MHA      chir_01  N1     C1     C3     C5        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 MHA      plan-1    C2        0.020
 MHA      plan-1    C1        0.020
 MHA      plan-1    O1        0.020
 MHA      plan-1    O2        0.020
 MHA      plan-2    C4        0.020
 MHA      plan-2    C3        0.020
 MHA      plan-2    O3        0.020
 MHA      plan-2    O4        0.020
 MHA      plan-3    C6        0.020
 MHA      plan-3    C5        0.020
 MHA      plan-3    O5        0.020
 MHA      plan-3    N2        0.020
 MHA      plan-3    HN22      0.020
 MHA      plan-3    HN21      0.020
 MHA      plan-4    N2        0.020
 MHA      plan-4    C6        0.020
 MHA      plan-4    HN21      0.020
 MHA      plan-4    HN22      0.020
# ------------------------------------------------------
`.trim();

monomers["BU3"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BU3      BU3 '(R,R)-2,3-BUTANEDIOL                ' non-polymer        16   6 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BU3
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BU3           O5     O    OH1       0.000      0.000    0.000    0.000
 BU3           HO5    H    H         0.000      0.397   -0.709    0.523
 BU3           C2     C    CH1       0.000     -1.009    0.652    0.773
 BU3           H2     H    H         0.000     -1.461    1.458    0.179
 BU3           C1     C    CH3       0.000     -0.380    1.243    2.036
 BU3           H13    H    H         0.000     -1.126    1.728    2.610
 BU3           H12    H    H         0.000      0.057    0.467    2.610
 BU3           H11    H    H         0.000      0.367    1.943    1.765
 BU3           C3     C    CH1       0.000     -2.086   -0.358    1.163
 BU3           H3     H    H         0.000     -2.862    0.144    1.757
 BU3           C4     C    CH3       0.000     -2.715   -0.949   -0.100
 BU3           H43    H    H         0.000     -3.152   -0.173   -0.674
 BU3           H42    H    H         0.000     -1.968   -1.434   -0.674
 BU3           H41    H    H         0.000     -3.462   -1.650    0.170
 BU3           O6     O    OH1       0.000     -1.499   -1.407    1.936
 BU3           HO6    H    H         0.000     -0.816   -1.848    1.413
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BU3      O5     n/a    C2     START
 BU3      HO5    O5     .      .
 BU3      C2     O5     C3     .
 BU3      H2     C2     .      .
 BU3      C1     C2     H11    .
 BU3      H13    C1     .      .
 BU3      H12    C1     .      .
 BU3      H11    C1     .      .
 BU3      C3     C2     O6     .
 BU3      H3     C3     .      .
 BU3      C4     C3     H41    .
 BU3      H43    C4     .      .
 BU3      H42    C4     .      .
 BU3      H41    C4     .      .
 BU3      O6     C3     HO6    .
 BU3      HO6    O6     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BU3      O6     C3        single      1.432    0.020
 BU3      HO6    O6        single      0.967    0.020
 BU3      C4     C3        single      1.524    0.020
 BU3      C3     C2        single      1.524    0.020
 BU3      H3     C3        single      1.099    0.020
 BU3      H41    C4        single      1.059    0.020
 BU3      H42    C4        single      1.059    0.020
 BU3      H43    C4        single      1.059    0.020
 BU3      C2     O5        single      1.432    0.020
 BU3      C1     C2        single      1.524    0.020
 BU3      H2     C2        single      1.099    0.020
 BU3      HO5    O5        single      0.967    0.020
 BU3      H11    C1        single      1.059    0.020
 BU3      H12    C1        single      1.059    0.020
 BU3      H13    C1        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BU3      HO5    O5     C2      109.470    3.000
 BU3      O5     C2     H2      109.470    3.000
 BU3      O5     C2     C1      109.470    3.000
 BU3      O5     C2     C3      109.470    3.000
 BU3      H2     C2     C1      108.340    3.000
 BU3      H2     C2     C3      108.340    3.000
 BU3      C1     C2     C3      111.000    3.000
 BU3      C2     C1     H13     109.470    3.000
 BU3      C2     C1     H12     109.470    3.000
 BU3      C2     C1     H11     109.470    3.000
 BU3      H13    C1     H12     109.470    3.000
 BU3      H13    C1     H11     109.470    3.000
 BU3      H12    C1     H11     109.470    3.000
 BU3      C2     C3     H3      108.340    3.000
 BU3      C2     C3     C4      111.000    3.000
 BU3      C2     C3     O6      109.470    3.000
 BU3      H3     C3     C4      108.340    3.000
 BU3      H3     C3     O6      109.470    3.000
 BU3      C4     C3     O6      109.470    3.000
 BU3      C3     C4     H43     109.470    3.000
 BU3      C3     C4     H42     109.470    3.000
 BU3      C3     C4     H41     109.470    3.000
 BU3      H43    C4     H42     109.470    3.000
 BU3      H43    C4     H41     109.470    3.000
 BU3      H42    C4     H41     109.470    3.000
 BU3      C3     O6     HO6     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BU3      var_1    HO5    O5     C2     C3       -59.975   20.000   1
 BU3      var_2    O5     C2     C1     H11       59.935   20.000   3
 BU3      var_3    O5     C2     C3     O6        60.041   20.000   3
 BU3      var_4    C2     C3     C4     H41      180.000   20.000   3
 BU3      var_5    C2     C3     O6     HO6      -59.975   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BU3      chir_01  C3     O6     C4     C2        positiv
 BU3      chir_02  C2     C3     O5     C1        positiv
# ------------------------------------------------------
`.trim();

monomers["PGO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PGO      PGO 'S-1,2-PROPANEDIOL                   ' non-polymer        13   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PGO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PGO           O2     O    OH1       0.000      0.000    0.000    0.000
 PGO           HO2    H    H         0.000      0.011    0.333    0.908
 PGO           C2     C    CH1       0.000     -1.289   -0.543   -0.292
 PGO           H2     H    H         0.000     -1.506   -1.366    0.403
 PGO           C3     C    CH3       0.000     -2.350    0.548   -0.137
 PGO           H33    H    H         0.000     -2.338    0.915    0.857
 PGO           H32    H    H         0.000     -2.142    1.342   -0.807
 PGO           H31    H    H         0.000     -3.306    0.147   -0.353
 PGO           C1     C    CH2       0.000     -1.307   -1.070   -1.728
 PGO           H11    H    H         0.000     -2.261   -1.565   -1.921
 PGO           H12    H    H         0.000     -0.493   -1.786   -1.862
 PGO           O1     O    OH1       0.000     -1.141    0.019   -2.638
 PGO           HO1    H    H         0.000     -1.152   -0.315   -3.546
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PGO      O2     n/a    C2     START
 PGO      HO2    O2     .      .
 PGO      C2     O2     C1     .
 PGO      H2     C2     .      .
 PGO      C3     C2     H31    .
 PGO      H33    C3     .      .
 PGO      H32    C3     .      .
 PGO      H31    C3     .      .
 PGO      C1     C2     O1     .
 PGO      H11    C1     .      .
 PGO      H12    C1     .      .
 PGO      O1     C1     HO1    .
 PGO      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PGO      C1     C2        single      1.524    0.020
 PGO      O1     C1        single      1.432    0.020
 PGO      H11    C1        single      1.092    0.020
 PGO      H12    C1        single      1.092    0.020
 PGO      C3     C2        single      1.524    0.020
 PGO      C2     O2        single      1.432    0.020
 PGO      H2     C2        single      1.099    0.020
 PGO      H31    C3        single      1.059    0.020
 PGO      H32    C3        single      1.059    0.020
 PGO      H33    C3        single      1.059    0.020
 PGO      HO1    O1        single      0.967    0.020
 PGO      HO2    O2        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PGO      HO2    O2     C2      109.470    3.000
 PGO      O2     C2     H2      109.470    3.000
 PGO      O2     C2     C3      109.470    3.000
 PGO      O2     C2     C1      109.470    3.000
 PGO      H2     C2     C3      108.340    3.000
 PGO      H2     C2     C1      108.340    3.000
 PGO      C3     C2     C1      111.000    3.000
 PGO      C2     C3     H33     109.470    3.000
 PGO      C2     C3     H32     109.470    3.000
 PGO      C2     C3     H31     109.470    3.000
 PGO      H33    C3     H32     109.470    3.000
 PGO      H33    C3     H31     109.470    3.000
 PGO      H32    C3     H31     109.470    3.000
 PGO      C2     C1     H11     109.470    3.000
 PGO      C2     C1     H12     109.470    3.000
 PGO      C2     C1     O1      109.470    3.000
 PGO      H11    C1     H12     107.900    3.000
 PGO      H11    C1     O1      109.470    3.000
 PGO      H12    C1     O1      109.470    3.000
 PGO      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PGO      var_1    HO2    O2     C2     C1       179.979   20.000   1
 PGO      var_2    O2     C2     C3     H31     -179.969   20.000   3
 PGO      var_3    O2     C2     C1     O1       -64.992   20.000   3
 PGO      var_4    C2     C1     O1     HO1      179.996   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 PGO      chir_01  C2     C1     C3     O2        positiv
# ------------------------------------------------------
`.trim();

monomers["BU2"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BU2      BU2 '1,3-BUTANEDIOL                      ' non-polymer        16   6 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BU2
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BU2           O3     O    OH1       0.000      0.000    0.000    0.000
 BU2           HO3    H    H         0.000      0.032    0.965    0.041
 BU2           C3     C    CH1       0.000     -1.272   -0.453    0.464
 BU2           HC3    H    H         0.000     -1.309   -1.551    0.417
 BU2           C4     C    CH3       0.000     -1.479    0.002    1.910
 BU2           HC43   H    H         0.000     -1.444    1.060    1.957
 BU2           HC42   H    H         0.000     -2.422   -0.334    2.256
 BU2           HC41   H    H         0.000     -0.714   -0.402    2.522
 BU2           C2     C    CH2       0.000     -2.376    0.132   -0.417
 BU2           HC21   H    H         0.000     -2.339    1.223   -0.369
 BU2           HC22   H    H         0.000     -3.348   -0.214   -0.060
 BU2           C1     C    CH2       0.000     -2.169   -0.323   -1.863
 BU2           HC11   H    H         0.000     -2.205   -1.414   -1.908
 BU2           HC12   H    H         0.000     -1.196    0.023   -2.217
 BU2           O1     O    OH1       0.000     -3.200    0.223   -2.687
 BU2           HO1    H    H         0.000     -3.068   -0.066   -3.600
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BU2      O3     n/a    C3     START
 BU2      HO3    O3     .      .
 BU2      C3     O3     C2     .
 BU2      HC3    C3     .      .
 BU2      C4     C3     HC41   .
 BU2      HC43   C4     .      .
 BU2      HC42   C4     .      .
 BU2      HC41   C4     .      .
 BU2      C2     C3     C1     .
 BU2      HC21   C2     .      .
 BU2      HC22   C2     .      .
 BU2      C1     C2     O1     .
 BU2      HC11   C1     .      .
 BU2      HC12   C1     .      .
 BU2      O1     C1     HO1    .
 BU2      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BU2      O1     C1        single      1.432    0.020
 BU2      C1     C2        single      1.524    0.020
 BU2      HC11   C1        single      1.092    0.020
 BU2      HC12   C1        single      1.092    0.020
 BU2      HO1    O1        single      0.967    0.020
 BU2      C2     C3        single      1.524    0.020
 BU2      HC21   C2        single      1.092    0.020
 BU2      HC22   C2        single      1.092    0.020
 BU2      C3     O3        single      1.432    0.020
 BU2      C4     C3        single      1.524    0.020
 BU2      HC3    C3        single      1.099    0.020
 BU2      HO3    O3        single      0.967    0.020
 BU2      HC41   C4        single      1.059    0.020
 BU2      HC42   C4        single      1.059    0.020
 BU2      HC43   C4        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BU2      HO3    O3     C3      109.470    3.000
 BU2      O3     C3     HC3     109.470    3.000
 BU2      O3     C3     C4      109.470    3.000
 BU2      O3     C3     C2      109.470    3.000
 BU2      HC3    C3     C4      108.340    3.000
 BU2      HC3    C3     C2      108.340    3.000
 BU2      C4     C3     C2      111.000    3.000
 BU2      C3     C4     HC43    109.470    3.000
 BU2      C3     C4     HC42    109.470    3.000
 BU2      C3     C4     HC41    109.470    3.000
 BU2      HC43   C4     HC42    109.470    3.000
 BU2      HC43   C4     HC41    109.470    3.000
 BU2      HC42   C4     HC41    109.470    3.000
 BU2      C3     C2     HC21    109.470    3.000
 BU2      C3     C2     HC22    109.470    3.000
 BU2      C3     C2     C1      111.000    3.000
 BU2      HC21   C2     HC22    107.900    3.000
 BU2      HC21   C2     C1      109.470    3.000
 BU2      HC22   C2     C1      109.470    3.000
 BU2      C2     C1     HC11    109.470    3.000
 BU2      C2     C1     HC12    109.470    3.000
 BU2      C2     C1     O1      109.470    3.000
 BU2      HC11   C1     HC12    107.900    3.000
 BU2      HC11   C1     O1      109.470    3.000
 BU2      HC12   C1     O1      109.470    3.000
 BU2      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BU2      var_1    HO3    O3     C3     C2        59.963   20.000   1
 BU2      var_2    O3     C3     C4     HC41     -59.943   20.000   3
 BU2      var_3    O3     C3     C2     C1        60.003   20.000   3
 BU2      var_4    C3     C2     C1     O1       180.000   20.000   3
 BU2      var_5    C2     C1     O1     HO1      179.980   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BU2      chir_01  C3     C2     O3     C4        negativ
# ------------------------------------------------------
`.trim();

monomers["PDO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PDO      PDO '1,3-PROPANDIOL                      ' non-polymer        13   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PDO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PDO           O3     O    OH1       0.000      0.000    0.000    0.000
 PDO           HO3    H    H         0.000      0.733   -0.631    0.000
 PDO           C3     C    CH2       0.000     -1.239   -0.711    0.000
 PDO           H31    H    H         0.000     -1.298   -1.340    0.891
 PDO           H32    H    H         0.000     -1.298   -1.340   -0.891
 PDO           C2     C    CH2       0.000     -2.400    0.286    0.000
 PDO           H21    H    H         0.000     -2.339    0.914   -0.891
 PDO           H22    H    H         0.000     -2.339    0.914    0.891
 PDO           C1     C    CH2       0.000     -3.726   -0.476    0.000
 PDO           H11    H    H         0.000     -3.785   -1.105    0.891
 PDO           H12    H    H         0.000     -3.785   -1.105   -0.891
 PDO           O1     O    OH1       0.000     -4.811    0.455    0.000
 PDO           HO1    H    H         0.000     -5.649   -0.027    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PDO      O3     n/a    C3     START
 PDO      HO3    O3     .      .
 PDO      C3     O3     C2     .
 PDO      H31    C3     .      .
 PDO      H32    C3     .      .
 PDO      C2     C3     C1     .
 PDO      H21    C2     .      .
 PDO      H22    C2     .      .
 PDO      C1     C2     O1     .
 PDO      H11    C1     .      .
 PDO      H12    C1     .      .
 PDO      O1     C1     HO1    .
 PDO      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PDO      O1     C1        single      1.432    0.020
 PDO      C1     C2        single      1.524    0.020
 PDO      H11    C1        single      1.092    0.020
 PDO      H12    C1        single      1.092    0.020
 PDO      HO1    O1        single      0.967    0.020
 PDO      C2     C3        single      1.524    0.020
 PDO      H21    C2        single      1.092    0.020
 PDO      H22    C2        single      1.092    0.020
 PDO      C3     O3        single      1.432    0.020
 PDO      H31    C3        single      1.092    0.020
 PDO      H32    C3        single      1.092    0.020
 PDO      HO3    O3        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PDO      HO3    O3     C3      109.470    3.000
 PDO      O3     C3     H31     109.470    3.000
 PDO      O3     C3     H32     109.470    3.000
 PDO      O3     C3     C2      109.470    3.000
 PDO      H31    C3     H32     107.900    3.000
 PDO      H31    C3     C2      109.470    3.000
 PDO      H32    C3     C2      109.470    3.000
 PDO      C3     C2     H21     109.470    3.000
 PDO      C3     C2     H22     109.470    3.000
 PDO      C3     C2     C1      111.000    3.000
 PDO      H21    C2     H22     107.900    3.000
 PDO      H21    C2     C1      109.470    3.000
 PDO      H22    C2     C1      109.470    3.000
 PDO      C2     C1     H11     109.470    3.000
 PDO      C2     C1     H12     109.470    3.000
 PDO      C2     C1     O1      109.470    3.000
 PDO      H11    C1     H12     107.900    3.000
 PDO      H11    C1     O1      109.470    3.000
 PDO      H12    C1     O1      109.470    3.000
 PDO      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PDO      var_1    HO3    O3     C3     C2       180.000   20.000   1
 PDO      var_2    O3     C3     C2     C1       180.000   20.000   3
 PDO      var_3    C3     C2     C1     O1       180.000   20.000   3
 PDO      var_4    C2     C1     O1     HO1      180.000   20.000   1
# ------------------------------------------------------
`.trim();

monomers["BU1"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BU1      BU1 '1,4-BUTANEDIOL                      ' non-polymer        16   6 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BU1
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BU1           O6     O    OH1       0.000      0.000    0.000    0.000
 BU1           HO6    H    H         0.000      0.482    0.000   -0.838
 BU1           C4     C    CH2       0.000     -1.404    0.000   -0.260
 BU1           H41    H    H         0.000     -1.666   -0.891   -0.834
 BU1           H42    H    H         0.000     -1.666    0.891   -0.834
 BU1           C3     C    CH2       0.000     -2.169    0.000    1.064
 BU1           H31    H    H         0.000     -1.904    0.891    1.637
 BU1           H32    H    H         0.000     -1.904   -0.891    1.637
 BU1           C2     C    CH2       0.000     -3.673    0.000    0.785
 BU1           H21    H    H         0.000     -3.935   -0.891    0.212
 BU1           H22    H    H         0.000     -3.935    0.891    0.212
 BU1           C1     C    CH2       0.000     -4.438    0.000    2.110
 BU1           H11    H    H         0.000     -4.173    0.891    2.682
 BU1           H12    H    H         0.000     -4.173   -0.891    2.682
 BU1           O5     O    OH1       0.000     -5.842    0.000    1.849
 BU1           HO5    H    H         0.000     -6.324    0.000    2.687
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BU1      O6     n/a    C4     START
 BU1      HO6    O6     .      .
 BU1      C4     O6     C3     .
 BU1      H41    C4     .      .
 BU1      H42    C4     .      .
 BU1      C3     C4     C2     .
 BU1      H31    C3     .      .
 BU1      H32    C3     .      .
 BU1      C2     C3     C1     .
 BU1      H21    C2     .      .
 BU1      H22    C2     .      .
 BU1      C1     C2     O5     .
 BU1      H11    C1     .      .
 BU1      H12    C1     .      .
 BU1      O5     C1     HO5    .
 BU1      HO5    O5     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BU1      C1     C2        single      1.524    0.020
 BU1      O5     C1        single      1.432    0.020
 BU1      H11    C1        single      1.092    0.020
 BU1      H12    C1        single      1.092    0.020
 BU1      C2     C3        single      1.524    0.020
 BU1      H21    C2        single      1.092    0.020
 BU1      H22    C2        single      1.092    0.020
 BU1      C3     C4        single      1.524    0.020
 BU1      H31    C3        single      1.092    0.020
 BU1      H32    C3        single      1.092    0.020
 BU1      C4     O6        single      1.432    0.020
 BU1      H41    C4        single      1.092    0.020
 BU1      H42    C4        single      1.092    0.020
 BU1      HO5    O5        single      0.967    0.020
 BU1      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BU1      HO6    O6     C4      109.470    3.000
 BU1      O6     C4     H41     109.470    3.000
 BU1      O6     C4     H42     109.470    3.000
 BU1      O6     C4     C3      109.470    3.000
 BU1      H41    C4     H42     107.900    3.000
 BU1      H41    C4     C3      109.470    3.000
 BU1      H42    C4     C3      109.470    3.000
 BU1      C4     C3     H31     109.470    3.000
 BU1      C4     C3     H32     109.470    3.000
 BU1      C4     C3     C2      111.000    3.000
 BU1      H31    C3     H32     107.900    3.000
 BU1      H31    C3     C2      109.470    3.000
 BU1      H32    C3     C2      109.470    3.000
 BU1      C3     C2     H21     109.470    3.000
 BU1      C3     C2     H22     109.470    3.000
 BU1      C3     C2     C1      111.000    3.000
 BU1      H21    C2     H22     107.900    3.000
 BU1      H21    C2     C1      109.470    3.000
 BU1      H22    C2     C1      109.470    3.000
 BU1      C2     C1     H11     109.470    3.000
 BU1      C2     C1     H12     109.470    3.000
 BU1      C2     C1     O5      109.470    3.000
 BU1      H11    C1     H12     107.900    3.000
 BU1      H11    C1     O5      109.470    3.000
 BU1      H12    C1     O5      109.470    3.000
 BU1      C1     O5     HO5     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BU1      var_1    HO6    O6     C4     C3       180.000   20.000   1
 BU1      var_2    O6     C4     C3     C2       180.000   20.000   3
 BU1      var_3    C4     C3     C2     C1       180.000   20.000   3
 BU1      var_4    C3     C2     C1     O5       180.000   20.000   3
 BU1      var_5    C2     C1     O5     HO5      180.000   20.000   1
# ------------------------------------------------------
`.trim();

monomers["1BO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
1BO      1BO '1-BUTANOL                           ' non-polymer        15   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_1BO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 1BO           OH     O    OH1       0.000      0.000    0.000    0.000
 1BO           HO     H    H         0.000      0.915    0.000    0.313
 1BO           C4     C    CH2       0.000     -0.886    0.000    1.121
 1BO           H41    H    H         0.000     -0.706    0.891    1.725
 1BO           H42    H    H         0.000     -0.706   -0.891    1.725
 1BO           C3     C    CH2       0.000     -2.333    0.000    0.628
 1BO           H31    H    H         0.000     -2.510   -0.891    0.022
 1BO           H32    H    H         0.000     -2.510    0.891    0.022
 1BO           C2     C    CH2       0.000     -3.281    0.000    1.828
 1BO           H21    H    H         0.000     -3.101    0.891    2.433
 1BO           H22    H    H         0.000     -3.101   -0.891    2.433
 1BO           C1     C    CH3       0.000     -4.729    0.000    1.336
 1BO           H13    H    H         0.000     -4.906    0.865    0.748
 1BO           H12    H    H         0.000     -4.906   -0.865    0.748
 1BO           H11    H    H         0.000     -5.388    0.000    2.166
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 1BO      OH     n/a    C4     START
 1BO      HO     OH     .      .
 1BO      C4     OH     C3     .
 1BO      H41    C4     .      .
 1BO      H42    C4     .      .
 1BO      C3     C4     C2     .
 1BO      H31    C3     .      .
 1BO      H32    C3     .      .
 1BO      C2     C3     C1     .
 1BO      H21    C2     .      .
 1BO      H22    C2     .      .
 1BO      C1     C2     H11    .
 1BO      H13    C1     .      .
 1BO      H12    C1     .      .
 1BO      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 1BO      C1     C2        single      1.513    0.020
 1BO      H11    C1        single      1.059    0.020
 1BO      H12    C1        single      1.059    0.020
 1BO      H13    C1        single      1.059    0.020
 1BO      C2     C3        single      1.524    0.020
 1BO      H21    C2        single      1.092    0.020
 1BO      H22    C2        single      1.092    0.020
 1BO      C3     C4        single      1.524    0.020
 1BO      H31    C3        single      1.092    0.020
 1BO      H32    C3        single      1.092    0.020
 1BO      C4     OH        single      1.432    0.020
 1BO      H41    C4        single      1.092    0.020
 1BO      H42    C4        single      1.092    0.020
 1BO      HO     OH        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 1BO      HO     OH     C4      109.470    3.000
 1BO      OH     C4     H41     109.470    3.000
 1BO      OH     C4     H42     109.470    3.000
 1BO      OH     C4     C3      109.470    3.000
 1BO      H41    C4     H42     107.900    3.000
 1BO      H41    C4     C3      109.470    3.000
 1BO      H42    C4     C3      109.470    3.000
 1BO      C4     C3     H31     109.470    3.000
 1BO      C4     C3     H32     109.470    3.000
 1BO      C4     C3     C2      111.000    3.000
 1BO      H31    C3     H32     107.900    3.000
 1BO      H31    C3     C2      109.470    3.000
 1BO      H32    C3     C2      109.470    3.000
 1BO      C3     C2     H21     109.470    3.000
 1BO      C3     C2     H22     109.470    3.000
 1BO      C3     C2     C1      111.000    3.000
 1BO      H21    C2     H22     107.900    3.000
 1BO      H21    C2     C1      109.470    3.000
 1BO      H22    C2     C1      109.470    3.000
 1BO      C2     C1     H13     109.470    3.000
 1BO      C2     C1     H12     109.470    3.000
 1BO      C2     C1     H11     109.470    3.000
 1BO      H13    C1     H12     109.470    3.000
 1BO      H13    C1     H11     109.470    3.000
 1BO      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 1BO      var_1    HO     OH     C4     C3       180.000   20.000   1
 1BO      var_2    OH     C4     C3     C2       180.000   20.000   3
 1BO      var_3    C4     C3     C2     C1       180.000   20.000   3
 1BO      var_4    C3     C2     C1     H11      180.000   20.000   3
# ------------------------------------------------------
`.trim();

monomers["TFP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TFP      TFP '10-[3-(4-METHYL-PIPERAZIN-1-YL)-PROP' non-polymer        52  28 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TFP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TFP           F3     F    F         0.000      0.000    0.000    0.000
 TFP           C21    C    CT        0.000     -0.487   -1.150    0.628
 TFP           F1     F    F         0.000      0.569   -1.825    1.250
 TFP           F2     F    F         0.000     -1.079   -1.987   -0.324
 TFP           C1     C    CR6       0.000     -1.513   -0.761    1.662
 TFP           C6     C    CR16      0.000     -2.653   -0.080    1.283
 TFP           H6     H    H         0.000     -2.806    0.176    0.241
 TFP           C5     C    CR66      0.000     -3.605    0.278    2.228
 TFP           N1     N    NR6       0.000     -4.740    0.969    1.807
 TFP           C12    C    CR66      0.000     -5.956    0.920    2.488
 TFP           C11    C    CR16      0.000     -7.129    1.132    1.772
 TFP           H11    H    H         0.000     -7.082    1.329    0.708
 TFP           C10    C    CR16      0.000     -8.354    1.092    2.410
 TFP           H10    H    H         0.000     -9.263    1.260    1.847
 TFP           C9     C    CR16      0.000     -8.417    0.839    3.768
 TFP           H9     H    H         0.000     -9.377    0.807    4.268
 TFP           C8     C    CR16      0.000     -7.257    0.626    4.486
 TFP           H8     H    H         0.000     -7.311    0.428    5.549
 TFP           C7     C    CR66      0.000     -6.018    0.665    3.852
 TFP           S      S    S2        0.000     -4.569    0.389    4.807
 TFP           C4     C    CR66      0.000     -3.402   -0.043    3.566
 TFP           C3     C    CR16      0.000     -2.251   -0.731    3.939
 TFP           H3     H    H         0.000     -2.091   -0.988    4.979
 TFP           C2     C    CR16      0.000     -1.312   -1.086    2.990
 TFP           H2     H    H         0.000     -0.418   -1.620    3.288
 TFP           C13    C    CH2       0.000     -4.653    1.781    0.592
 TFP           H131   H    H         0.000     -3.635    2.159    0.480
 TFP           H132   H    H         0.000     -5.346    2.622    0.666
 TFP           C14    C    CH2       0.000     -5.018    0.923   -0.621
 TFP           H141   H    H         0.000     -6.035    0.545   -0.506
 TFP           H142   H    H         0.000     -4.324    0.083   -0.694
 TFP           C15    C    CH2       0.000     -4.928    1.772   -1.891
 TFP           H151   H    H         0.000     -3.910    2.151   -2.004
 TFP           H152   H    H         0.000     -5.622    2.612   -1.816
 TFP           N2     N    NT        0.000     -5.278    0.948   -3.056
 TFP           C19    C    CH2       0.000     -6.695    0.596   -2.913
 TFP           H191   H    H         0.000     -7.284    1.508   -2.798
 TFP           H192   H    H         0.000     -6.824   -0.034   -2.031
 TFP           C18    C    CH2       0.000     -7.165   -0.162   -4.155
 TFP           H181   H    H         0.000     -8.204   -0.468   -4.020
 TFP           H182   H    H         0.000     -6.541   -1.047   -4.296
 TFP           N3     N    NT        0.000     -7.058    0.707   -5.333
 TFP           C20    C    CH3       0.000     -7.409   -0.117   -6.498
 TFP           H203   H    H         0.000     -7.247    0.438   -7.385
 TFP           H202   H    H         0.000     -6.805   -0.987   -6.510
 TFP           H201   H    H         0.000     -8.429   -0.396   -6.438
 TFP           C17    C    CH2       0.000     -5.641    1.059   -5.477
 TFP           H171   H    H         0.000     -5.512    1.689   -6.359
 TFP           H172   H    H         0.000     -5.052    0.147   -5.592
 TFP           C16    C    CH2       0.000     -5.172    1.817   -4.235
 TFP           H162   H    H         0.000     -5.797    2.701   -4.094
 TFP           H161   H    H         0.000     -4.133    2.124   -4.370
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TFP      F3     n/a    C21    START
 TFP      C21    F3     C1     .
 TFP      F1     C21    .      .
 TFP      F2     C21    .      .
 TFP      C1     C21    C6     .
 TFP      C6     C1     C5     .
 TFP      H6     C6     .      .
 TFP      C5     C6     N1     .
 TFP      N1     C5     C13    .
 TFP      C12    N1     C7     .
 TFP      C11    C12    C10    .
 TFP      H11    C11    .      .
 TFP      C10    C11    C9     .
 TFP      H10    C10    .      .
 TFP      C9     C10    C8     .
 TFP      H9     C9     .      .
 TFP      C8     C9     H8     .
 TFP      H8     C8     .      .
 TFP      C7     C12    S      .
 TFP      S      C7     C4     .
 TFP      C4     S      C3     .
 TFP      C3     C4     C2     .
 TFP      H3     C3     .      .
 TFP      C2     C3     H2     .
 TFP      H2     C2     .      .
 TFP      C13    N1     C14    .
 TFP      H131   C13    .      .
 TFP      H132   C13    .      .
 TFP      C14    C13    C15    .
 TFP      H141   C14    .      .
 TFP      H142   C14    .      .
 TFP      C15    C14    N2     .
 TFP      H151   C15    .      .
 TFP      H152   C15    .      .
 TFP      N2     C15    C19    .
 TFP      C19    N2     C18    .
 TFP      H191   C19    .      .
 TFP      H192   C19    .      .
 TFP      C18    C19    N3     .
 TFP      H181   C18    .      .
 TFP      H182   C18    .      .
 TFP      N3     C18    C17    .
 TFP      C20    N3     H201   .
 TFP      H203   C20    .      .
 TFP      H202   C20    .      .
 TFP      H201   C20    .      .
 TFP      C17    N3     C16    .
 TFP      H171   C17    .      .
 TFP      H172   C17    .      .
 TFP      C16    C17    H161   .
 TFP      H162   C16    .      .
 TFP      H161   C16    .      END
 TFP      C1     C2     .    ADD
 TFP      C4     C5     .    ADD
 TFP      C7     C8     .    ADD
 TFP      N2     C16    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TFP      C1     C2        double      1.390    0.020
 TFP      C6     C1        single      1.390    0.020
 TFP      C1     C21       single      1.500    0.020
 TFP      C2     C3        single      1.390    0.020
 TFP      H2     C2        single      1.083    0.020
 TFP      C3     C4        double      1.390    0.020
 TFP      H3     C3        single      1.083    0.020
 TFP      C4     C5        single      1.490    0.020
 TFP      C4     S         single      1.695    0.020
 TFP      C5     C6        double      1.390    0.020
 TFP      N1     C5        single      1.410    0.020
 TFP      H6     C6        single      1.083    0.020
 TFP      S      C7        single      1.695    0.020
 TFP      C7     C8        double      1.390    0.020
 TFP      C7     C12       single      1.490    0.020
 TFP      C8     C9        single      1.390    0.020
 TFP      H8     C8        single      1.083    0.020
 TFP      C9     C10       double      1.390    0.020
 TFP      H9     C9        single      1.083    0.020
 TFP      C10    C11       single      1.390    0.020
 TFP      H10    C10       single      1.083    0.020
 TFP      C11    C12       double      1.390    0.020
 TFP      H11    C11       single      1.083    0.020
 TFP      C12    N1        single      1.410    0.020
 TFP      C13    N1        single      1.465    0.020
 TFP      C14    C13       single      1.524    0.020
 TFP      H131   C13       single      1.092    0.020
 TFP      H132   C13       single      1.092    0.020
 TFP      C15    C14       single      1.524    0.020
 TFP      H141   C14       single      1.092    0.020
 TFP      H142   C14       single      1.092    0.020
 TFP      N2     C15       single      1.469    0.020
 TFP      H151   C15       single      1.092    0.020
 TFP      H152   C15       single      1.092    0.020
 TFP      N2     C16       single      1.469    0.020
 TFP      C19    N2        single      1.469    0.020
 TFP      C16    C17       single      1.524    0.020
 TFP      H161   C16       single      1.092    0.020
 TFP      H162   C16       single      1.092    0.020
 TFP      C17    N3        single      1.469    0.020
 TFP      H171   C17       single      1.092    0.020
 TFP      H172   C17       single      1.092    0.020
 TFP      N3     C18       single      1.469    0.020
 TFP      C20    N3        single      1.469    0.020
 TFP      C18    C19       single      1.524    0.020
 TFP      H181   C18       single      1.092    0.020
 TFP      H182   C18       single      1.092    0.020
 TFP      H191   C19       single      1.092    0.020
 TFP      H192   C19       single      1.092    0.020
 TFP      H201   C20       single      1.059    0.020
 TFP      H202   C20       single      1.059    0.020
 TFP      H203   C20       single      1.059    0.020
 TFP      F1     C21       single      1.320    0.020
 TFP      F2     C21       single      1.320    0.020
 TFP      C21    F3        single      1.320    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TFP      F3     C21    F1      109.470    3.000
 TFP      F3     C21    F2      109.470    3.000
 TFP      F3     C21    C1      109.470    3.000
 TFP      F1     C21    F2      109.470    3.000
 TFP      F1     C21    C1      109.470    3.000
 TFP      F2     C21    C1      109.470    3.000
 TFP      C21    C1     C6      120.000    3.000
 TFP      C21    C1     C2      120.000    3.000
 TFP      C6     C1     C2      120.000    3.000
 TFP      C1     C6     H6      120.000    3.000
 TFP      C1     C6     C5      120.000    3.000
 TFP      H6     C6     C5      120.000    3.000
 TFP      C6     C5     N1      120.000    3.000
 TFP      C6     C5     C4      120.000    3.000
 TFP      N1     C5     C4      120.000    3.000
 TFP      C5     N1     C12     120.000    3.000
 TFP      C5     N1     C13     120.000    3.000
 TFP      C12    N1     C13     120.000    3.000
 TFP      N1     C12    C11     120.000    3.000
 TFP      N1     C12    C7      120.000    3.000
 TFP      C11    C12    C7      120.000    3.000
 TFP      C12    C11    H11     120.000    3.000
 TFP      C12    C11    C10     120.000    3.000
 TFP      H11    C11    C10     120.000    3.000
 TFP      C11    C10    H10     120.000    3.000
 TFP      C11    C10    C9      120.000    3.000
 TFP      H10    C10    C9      120.000    3.000
 TFP      C10    C9     H9      120.000    3.000
 TFP      C10    C9     C8      120.000    3.000
 TFP      H9     C9     C8      120.000    3.000
 TFP      C9     C8     H8      120.000    3.000
 TFP      C9     C8     C7      120.000    3.000
 TFP      H8     C8     C7      120.000    3.000
 TFP      C12    C7     S       120.000    3.000
 TFP      C12    C7     C8      120.000    3.000
 TFP      S      C7     C8      120.000    3.000
 TFP      C7     S      C4      101.669    3.000
 TFP      S      C4     C3      120.000    3.000
 TFP      S      C4     C5      120.000    3.000
 TFP      C3     C4     C5      120.000    3.000
 TFP      C4     C3     H3      120.000    3.000
 TFP      C4     C3     C2      120.000    3.000
 TFP      H3     C3     C2      120.000    3.000
 TFP      C3     C2     H2      120.000    3.000
 TFP      C3     C2     C1      120.000    3.000
 TFP      H2     C2     C1      120.000    3.000
 TFP      N1     C13    H131    109.470    3.000
 TFP      N1     C13    H132    109.470    3.000
 TFP      N1     C13    C14     109.470    3.000
 TFP      H131   C13    H132    107.900    3.000
 TFP      H131   C13    C14     109.470    3.000
 TFP      H132   C13    C14     109.470    3.000
 TFP      C13    C14    H141    109.470    3.000
 TFP      C13    C14    H142    109.470    3.000
 TFP      C13    C14    C15     111.000    3.000
 TFP      H141   C14    H142    107.900    3.000
 TFP      H141   C14    C15     109.470    3.000
 TFP      H142   C14    C15     109.470    3.000
 TFP      C14    C15    H151    109.470    3.000
 TFP      C14    C15    H152    109.470    3.000
 TFP      C14    C15    N2      109.470    3.000
 TFP      H151   C15    H152    107.900    3.000
 TFP      H151   C15    N2      109.470    3.000
 TFP      H152   C15    N2      109.470    3.000
 TFP      C15    N2     C19     109.470    3.000
 TFP      C15    N2     C16     109.470    3.000
 TFP      C19    N2     C16     109.470    3.000
 TFP      N2     C19    H191    109.470    3.000
 TFP      N2     C19    H192    109.470    3.000
 TFP      N2     C19    C18     109.470    3.000
 TFP      H191   C19    H192    107.900    3.000
 TFP      H191   C19    C18     109.470    3.000
 TFP      H192   C19    C18     109.470    3.000
 TFP      C19    C18    H181    109.470    3.000
 TFP      C19    C18    H182    109.470    3.000
 TFP      C19    C18    N3      109.470    3.000
 TFP      H181   C18    H182    107.900    3.000
 TFP      H181   C18    N3      109.470    3.000
 TFP      H182   C18    N3      109.470    3.000
 TFP      C18    N3     C20     109.470    3.000
 TFP      C18    N3     C17     109.470    3.000
 TFP      C20    N3     C17     109.470    3.000
 TFP      N3     C20    H203    109.470    3.000
 TFP      N3     C20    H202    109.470    3.000
 TFP      N3     C20    H201    109.470    3.000
 TFP      H203   C20    H202    109.470    3.000
 TFP      H203   C20    H201    109.470    3.000
 TFP      H202   C20    H201    109.470    3.000
 TFP      N3     C17    H171    109.470    3.000
 TFP      N3     C17    H172    109.470    3.000
 TFP      N3     C17    C16     109.470    3.000
 TFP      H171   C17    H172    107.900    3.000
 TFP      H171   C17    C16     109.470    3.000
 TFP      H172   C17    C16     109.470    3.000
 TFP      C17    C16    H162    109.470    3.000
 TFP      C17    C16    H161    109.470    3.000
 TFP      C17    C16    N2      109.470    3.000
 TFP      H162   C16    H161    107.900    3.000
 TFP      H162   C16    N2      109.470    3.000
 TFP      H161   C16    N2      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TFP      var_1    F3     C21    C1     C6        60.002   20.000   1
 TFP      CONST_1  C21    C1     C2     C3       180.000    0.000   0
 TFP      CONST_2  C21    C1     C6     C5       180.000    0.000   0
 TFP      CONST_3  C1     C6     C5     N1       180.000    0.000   0
 TFP      CONST_4  C6     C5     N1     C13      -30.000    0.000   0
 TFP      CONST_5  C5     N1     C12    C7        30.000    0.000   0
 TFP      CONST_6  N1     C12    C11    C10      180.000    0.000   0
 TFP      CONST_7  C12    C11    C10    C9         0.000    0.000   0
 TFP      CONST_8  C11    C10    C9     C8         0.000    0.000   0
 TFP      CONST_9  C10    C9     C8     C7         0.000    0.000   0
 TFP      CONST_10 N1     C12    C7     S          0.000    0.000   0
 TFP      CONST_11 C12    C7     C8     C9         0.000    0.000   0
 TFP      CONST_12 C12    C7     S      C4       -30.000    0.000   0
 TFP      CONST_13 C7     S      C4     C3      -150.000    0.000   0
 TFP      CONST_14 S      C4     C5     C6       180.000    0.000   0
 TFP      CONST_15 S      C4     C3     C2       180.000    0.000   0
 TFP      CONST_16 C4     C3     C2     C1         0.000    0.000   0
 TFP      var_2    C5     N1     C13    C14       89.735   20.000   1
 TFP      var_3    N1     C13    C14    C15      179.942   20.000   3
 TFP      var_4    C13    C14    C15    N2       179.991   20.000   3
 TFP      var_5    C14    C15    N2     C19       66.110   20.000   1
 TFP      var_6    C15    N2     C16    C17      180.000   20.000   1
 TFP      var_7    C15    N2     C19    C18      180.000   20.000   1
 TFP      var_8    N2     C19    C18    N3       -60.000   20.000   3
 TFP      var_9    C19    C18    N3     C17       60.000   20.000   1
 TFP      var_10   C18    N3     C20    H201      66.000   20.000   1
 TFP      var_11   C18    N3     C17    C16      -60.000   20.000   1
 TFP      var_12   N3     C17    C16    N2        60.000   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TFP      chir_01  N2     C15    C16    C19       positiv
 TFP      chir_02  N3     C17    C18    C20       positiv
 TFP      chir_03  C21    C1     F1     F2        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TFP      plan-1    C1        0.020
 TFP      plan-1    C2        0.020
 TFP      plan-1    C6        0.020
 TFP      plan-1    C21       0.020
 TFP      plan-1    C3        0.020
 TFP      plan-1    H2        0.020
 TFP      plan-1    C4        0.020
 TFP      plan-1    H3        0.020
 TFP      plan-1    C5        0.020
 TFP      plan-1    S         0.020
 TFP      plan-1    N1        0.020
 TFP      plan-1    H6        0.020
 TFP      plan-1    C12       0.020
 TFP      plan-1    C13       0.020
 TFP      plan-1    C7        0.020
 TFP      plan-1    C8        0.020
 TFP      plan-1    C9        0.020
 TFP      plan-1    C10       0.020
 TFP      plan-1    C11       0.020
 TFP      plan-1    H8        0.020
 TFP      plan-1    H9        0.020
 TFP      plan-1    H10       0.020
 TFP      plan-1    H11       0.020
# ------------------------------------------------------
`.trim();

monomers["DHD"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DHD      DHD '2,4-DIOXO-PENTANEDIOIC ACID         ' non-polymer        13  11 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DHD
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DHD           O2     O    O         0.000      0.000    0.000    0.000
 DHD           C2     C    C         0.000     -0.370    0.000   -1.150
 DHD           C1     C    C         0.000      0.630    0.000   -2.254
 DHD           O12    O    OC       -0.500      1.854    0.000   -1.992
 DHD           O11    O    OC       -0.500      0.246    0.000   -3.444
 DHD           C3     C    CH2       0.000     -1.843    0.000   -1.466
 DHD           H31    H    H         0.000     -2.090   -0.891   -2.047
 DHD           H32    H    H         0.000     -2.090    0.891   -2.047
 DHD           C4     C    C         0.000     -2.633    0.000   -0.184
 DHD           O4     O    O         0.000     -2.058    0.000    0.879
 DHD           C5     C    C         0.000     -4.122    0.000   -0.224
 DHD           O51    O    OC       -0.500     -4.779    0.000    0.841
 DHD           O52    O    OC       -0.500     -4.717    0.000   -1.324
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DHD      O2     n/a    C2     START
 DHD      C2     O2     C3     .
 DHD      C1     C2     O11    .
 DHD      O12    C1     .      .
 DHD      O11    C1     .      .
 DHD      C3     C2     C4     .
 DHD      H31    C3     .      .
 DHD      H32    C3     .      .
 DHD      C4     C3     C5     .
 DHD      O4     C4     .      .
 DHD      C5     C4     O52    .
 DHD      O51    C5     .      .
 DHD      O52    C5     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DHD      C1     C2        single      1.460    0.020
 DHD      O11    C1        deloc       1.250    0.020
 DHD      O12    C1        deloc       1.250    0.020
 DHD      C3     C2        single      1.510    0.020
 DHD      C2     O2        double      1.220    0.020
 DHD      C4     C3        single      1.510    0.020
 DHD      H31    C3        single      1.092    0.020
 DHD      H32    C3        single      1.092    0.020
 DHD      C5     C4        single      1.460    0.020
 DHD      O4     C4        double      1.220    0.020
 DHD      O51    C5        deloc       1.250    0.020
 DHD      O52    C5        deloc       1.250    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DHD      O2     C2     C1      120.500    3.000
 DHD      O2     C2     C3      120.500    3.000
 DHD      C1     C2     C3      120.000    3.000
 DHD      C2     C1     O12     120.000    3.000
 DHD      C2     C1     O11     120.000    3.000
 DHD      O12    C1     O11     123.000    3.000
 DHD      C2     C3     H31     109.470    3.000
 DHD      C2     C3     H32     109.470    3.000
 DHD      C2     C3     C4      109.470    3.000
 DHD      H31    C3     H32     107.900    3.000
 DHD      H31    C3     C4      109.470    3.000
 DHD      H32    C3     C4      109.470    3.000
 DHD      C3     C4     O4      120.500    3.000
 DHD      C3     C4     C5      120.000    3.000
 DHD      O4     C4     C5      120.500    3.000
 DHD      C4     C5     O51     120.000    3.000
 DHD      C4     C5     O52     120.000    3.000
 DHD      O51    C5     O52     123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DHD      var_1    O2     C2     C1     O11      180.000   20.000   1
 DHD      var_2    O2     C2     C3     C4         0.000   20.000   3
 DHD      var_3    C2     C3     C4     C5       180.000   20.000   3
 DHD      var_4    C3     C4     C5     O52        0.000   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DHD      plan-1    C1        0.020
 DHD      plan-1    C2        0.020
 DHD      plan-1    O11       0.020
 DHD      plan-1    O12       0.020
 DHD      plan-2    C2        0.020
 DHD      plan-2    C1        0.020
 DHD      plan-2    C3        0.020
 DHD      plan-2    O2        0.020
 DHD      plan-3    C4        0.020
 DHD      plan-3    C3        0.020
 DHD      plan-3    C5        0.020
 DHD      plan-3    O4        0.020
 DHD      plan-4    C5        0.020
 DHD      plan-4    C4        0.020
 DHD      plan-4    O51       0.020
 DHD      plan-4    O52       0.020
# ------------------------------------------------------
`.trim();

monomers["PEU"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PEU      PEU '2,5,8,11,14,17,20,23,26,29,32,35,38,' non-polymer       195  83 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PEU
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PEU           ODE    O    OH1       0.000      0.000    0.000    0.000
 PEU           HDE    H    H         0.000      0.613    0.629    0.404
 PEU           CDD    C    CH2       0.000     -0.846    0.687   -0.924
 PEU           HDD1   H    H         0.000     -0.235    1.151   -1.701
 PEU           HDD2   H    H         0.000     -1.409    1.460   -0.396
 PEU           CDC    C    CH2       0.000     -1.818   -0.309   -1.563
 PEU           HDC1   H    H         0.000     -1.254   -1.127   -2.015
 PEU           HDC2   H    H         0.000     -2.403    0.198   -2.334
 PEU           ODB    O    O2        0.000     -2.695   -0.828   -0.561
 PEU           CDA    C    CH2       0.000     -3.572   -1.745   -1.217
 PEU           HDA1   H    H         0.000     -2.986   -2.546   -1.673
 PEU           HDA2   H    H         0.000     -4.134   -1.220   -1.991
 PEU           CCZ    C    CH2       0.000     -4.543   -2.341   -0.195
 PEU           HCZ1   H    H         0.000     -3.977   -2.789    0.625
 PEU           HCZ2   H    H         0.000     -5.152   -3.108   -0.677
 PEU           OCY    O    O2        0.000     -5.389   -1.309    0.316
 PEU           CCX    C    CH2       0.000     -6.267   -1.924    1.260
 PEU           HCX1   H    H         0.000     -5.680   -2.378    2.061
 PEU           HCX2   H    H         0.000     -6.855   -2.696    0.759
 PEU           CCW    C    CH2       0.000     -7.205   -0.868    1.848
 PEU           HCW1   H    H         0.000     -6.614   -0.053    2.272
 PEU           HCW2   H    H         0.000     -7.815   -1.320    2.633
 PEU           OCV    O    O2        0.000     -8.053   -0.358    0.818
 PEU           CCU    C    CH2       0.000     -8.901    0.618    1.427
 PEU           HCU1   H    H         0.000     -8.289    1.415    1.856
 PEU           HCU2   H    H         0.000     -9.489    0.147    2.217
 PEU           CCT    C    CH2       0.000     -9.840    1.206    0.373
 PEU           HCT1   H    H         0.000     -9.252    1.599   -0.459
 PEU           HCT2   H    H         0.000    -10.425    2.015    0.817
 PEU           OCS    O    O2        0.000    -10.720    0.187   -0.103
 PEU           CCR    C    CH2       0.000    -11.568    0.795   -1.081
 PEU           HCR1   H    H         0.000    -10.957    1.192   -1.894
 PEU           HCR2   H    H         0.000    -12.130    1.609   -0.618
 PEU           CCQ    C    CH2       0.000    -12.541   -0.249   -1.634
 PEU           HCQ1   H    H         0.000    -11.978   -1.102   -2.018
 PEU           HCQ2   H    H         0.000    -13.127    0.193   -2.442
 PEU           OCP    O    O2        0.000    -13.416   -0.683   -0.591
 PEU           CCO    C    CH2       0.000    -14.295   -1.652   -1.168
 PEU           HCO1   H    H         0.000    -13.710   -2.487   -1.558
 PEU           HCO2   H    H         0.000    -14.859   -1.192   -1.982
 PEU           CCN    C    CH2       0.000    -15.264   -2.160   -0.099
 PEU           HCN1   H    H         0.000    -14.697   -2.540    0.754
 PEU           HCN2   H    H         0.000    -15.875   -2.964   -0.515
 PEU           OCM    O    O2        0.000    -16.108   -1.089    0.327
 PEU           CCL    C    CH2       0.000    -16.987   -1.625    1.320
 PEU           HCL1   H    H         0.000    -16.399   -2.013    2.154
 PEU           HCL2   H    H         0.000    -17.576   -2.435    0.885
 PEU           CCK    C    CH2       0.000    -17.922   -0.523    1.821
 PEU           HCK1   H    H         0.000    -17.330    0.324    2.173
 PEU           HCK2   H    H         0.000    -18.530   -0.908    2.642
 PEU           OCJ    O    O2        0.000    -18.774   -0.100    0.753
 PEU           CCI    C    CH2       0.000    -19.619    0.924    1.281
 PEU           HCI1   H    H         0.000    -19.005    1.752    1.641
 PEU           HCI2   H    H         0.000    -20.205    0.521    2.110
 PEU           CCH    C    CH2       0.000    -20.560    1.424    0.183
 PEU           HCH1   H    H         0.000    -19.974    1.747   -0.679
 PEU           HCH2   H    H         0.000    -21.144    2.266    0.561
 PEU           OBD    O    O2        0.000    -21.441    0.369   -0.206
 PEU           CBE    C    CH2       0.000    -22.290    0.896   -1.228
 PEU           HBE1   H    H         0.000    -21.681    1.226   -2.072
 PEU           HBE2   H    H         0.000    -22.852    1.745   -0.832
 PEU           CBF    C    CH2       0.000    -23.263   -0.190   -1.692
 PEU           HBF1   H    H         0.000    -22.701   -1.072   -2.005
 PEU           HBF2   H    H         0.000    -23.850    0.184   -2.534
 PEU           OBG    O    O2        0.000    -24.138   -0.537   -0.616
 PEU           CBH    C    CH2       0.000    -25.018   -1.550   -1.109
 PEU           HBH1   H    H         0.000    -24.434   -2.415   -1.430
 PEU           HBH2   H    H         0.000    -25.583   -1.159   -1.958
 PEU           CBI    C    CH2       0.000    -25.985   -1.969    0.000
 PEU           HBI1   H    H         0.000    -25.417   -2.276    0.880
 PEU           HBI2   H    H         0.000    -26.597   -2.804   -0.348
 PEU           OBJ    O    O2        0.000    -26.829   -0.865    0.336
 PEU           CBK    C    CH2       0.000    -27.705   -1.318    1.371
 PEU           HBK1   H    H         0.000    -27.115   -1.634    2.234
 PEU           HBK2   H    H         0.000    -28.294   -2.161    1.006
 PEU           CBL    C    CH2       0.000    -28.641   -0.178    1.781
 PEU           HBL1   H    H         0.000    -28.049    0.695    2.063
 PEU           HBL2   H    H         0.000    -29.248   -0.494    2.632
 PEU           OBM    O    O2        0.000    -29.493    0.157    0.684
 PEU           CBN    C    CH2       0.000    -30.337    1.221    1.127
 PEU           HBN1   H    H         0.000    -29.722    2.075    1.417
 PEU           HBN2   H    H         0.000    -30.922    0.886    1.986
 PEU           CBO    C    CH2       0.000    -31.280    1.630   -0.006
 PEU           HBO1   H    H         0.000    -30.694    1.881   -0.893
 PEU           HBO2   H    H         0.000    -31.862    2.500    0.302
 PEU           OBP    O    O2        0.000    -32.162    0.546   -0.306
 PEU           CBQ    C    CH2       0.000    -33.013    0.988   -1.368
 PEU           HBQ1   H    H         0.000    -32.405    1.246   -2.237
 PEU           HBQ2   H    H         0.000    -33.573    1.866   -1.042
 PEU           CBR    C    CH2       0.000    -33.986   -0.132   -1.739
 PEU           HBR1   H    H         0.000    -33.425   -1.037   -1.979
 PEU           HBR2   H    H         0.000    -34.574    0.171   -2.607
 PEU           OBS    O    O2        0.000    -34.859   -0.390   -0.637
 PEU           CBT    C    CH2       0.000    -35.741   -1.438   -1.044
 PEU           HBT1   H    H         0.000    -35.157   -2.326   -1.294
 PEU           HBT2   H    H         0.000    -36.307   -1.117   -1.921
 PEU           CBU    C    CH2       0.000    -36.706   -1.765    0.097
 PEU           HBU1   H    H         0.000    -36.137   -2.000    0.999
 PEU           HBU2   H    H         0.000    -37.318   -2.625   -0.180
 PEU           OBV    O    O2        0.000    -37.550   -0.637    0.344
 PEU           CBW    C    CH2       0.000    -38.424   -1.002    1.414
 PEU           HBW1   H    H         0.000    -37.833   -1.246    2.299
 PEU           HBW2   H    H         0.000    -39.014   -1.872    1.120
 PEU           CBX    C    CH2       0.000    -39.358    0.168    1.730
 PEU           HBX1   H    H         0.000    -38.765    1.061    1.938
 PEU           HBX2   H    H         0.000    -39.964   -0.077    2.605
 PEU           OBY    O    O2        0.000    -40.212    0.411    0.611
 PEU           CBZ    C    CH2       0.000    -41.056    1.509    0.965
 PEU           HBZ1   H    H         0.000    -40.441    2.384    1.184
 PEU           HBZ2   H    H         0.000    -41.640    1.246    1.850
 PEU           CCA    C    CH2       0.000    -42.000    1.824   -0.197
 PEU           HCA1   H    H         0.000    -41.416    2.000   -1.102
 PEU           HCA2   H    H         0.000    -42.582    2.717    0.040
 PEU           OCB    O    O2        0.000    -42.883    0.719   -0.405
 PEU           CCC    C    CH2       0.000    -43.735    1.072   -1.497
 PEU           HCC1   H    H         0.000    -43.129    1.259   -2.386
 PEU           HCC2   H    H         0.000    -44.295    1.975   -1.244
 PEU           CCD    C    CH2       0.000    -44.710   -0.074   -1.774
 PEU           HCD1   H    H         0.000    -44.150   -0.997   -1.939
 PEU           HCD2   H    H         0.000    -45.300    0.156   -2.664
 PEU           OCE    O    O2        0.000    -45.581   -0.239   -0.653
 PEU           CCF    C    CH2       0.000    -46.463   -1.317   -0.971
 PEU           HCF1   H    H         0.000    -45.880   -2.224   -1.148
 PEU           HCF2   H    H         0.000    -47.031   -1.070   -1.871
 PEU           CCG    C    CH2       0.000    -47.428   -1.548    0.195
 PEU           HCG1   H    H         0.000    -46.857   -1.709    1.112
 PEU           HCG2   H    H         0.000    -48.041   -2.428   -0.010
 PEU           OBC    O    O2        0.000    -48.269   -0.405    0.349
 PEU           CBB    C    CH2       0.000    -49.142   -0.679    1.446
 PEU           HBB1   H    H         0.000    -48.550   -0.851    2.347
 PEU           HBB2   H    H         0.000    -49.734   -1.570    1.225
 PEU           CBA    C    CH2       0.000    -50.076    0.513    1.667
 PEU           HBA1   H    H         0.000    -49.482    1.420    1.801
 PEU           HBA2   H    H         0.000    -50.681    0.340    2.560
 PEU           OAZ    O    O2        0.000    -50.931    0.664    0.532
 PEU           CAY    C    CH2       0.000    -51.775    1.787    0.798
 PEU           HAY1   H    H         0.000    -51.160    2.678    0.943
 PEU           HAY2   H    H         0.000    -52.358    1.598    1.702
 PEU           CAX    C    CH2       0.000    -52.720    2.005   -0.385
 PEU           HAX1   H    H         0.000    -52.136    2.106   -1.303
 PEU           HAX2   H    H         0.000    -53.301    2.915   -0.223
 PEU           OAW    O    O2        0.000    -53.603    0.888   -0.501
 PEU           CAV    C    CH2       0.000    -54.458    1.150   -1.616
 PEU           HAV1   H    H         0.000    -53.853    1.263   -2.519
 PEU           HAV2   H    H         0.000    -55.017    2.071   -1.437
 PEU           CAU    C    CH2       0.000    -55.433   -0.015   -1.796
 PEU           HAU1   H    H         0.000    -54.873   -0.948   -1.886
 PEU           HAU2   H    H         0.000    -56.024    0.142   -2.701
 PEU           OAT    O    O2        0.000    -56.302   -0.086   -0.665
 PEU           CAS    C    CH2       0.000    -57.186   -1.187   -0.892
 PEU           HAS1   H    H         0.000    -56.603   -2.105   -0.994
 PEU           HAS2   H    H         0.000    -57.754   -1.014   -1.808
 PEU           CAR    C    CH2       0.000    -58.148   -1.321    0.290
 PEU           HAR1   H    H         0.000    -57.577   -1.406    1.217
 PEU           HAR2   H    H         0.000    -58.763   -2.214    0.160
 PEU           OAQ    O    O2        0.000    -58.990   -0.167    0.351
 PEU           CAP    C    CH2       0.000    -59.861   -0.351    1.469
 PEU           HAP1   H    H         0.000    -59.268   -0.449    2.380
 PEU           HAP2   H    H         0.000    -60.453   -1.257    1.323
 PEU           CAO    C    CH2       0.000    -60.794    0.856    1.592
 PEU           HAO1   H    H         0.000    -60.200    1.770    1.649
 PEU           HAO2   H    H         0.000    -61.398    0.758    2.497
 PEU           OAN    O    O2        0.000    -61.650    0.913    0.451
 PEU           CAM    C    CH2       0.000    -62.493    2.055    0.623
 PEU           HAM1   H    H         0.000    -61.876    2.954    0.693
 PEU           HAM2   H    H         0.000    -63.074    1.942    1.541
 PEU           CAL    C    CH2       0.000    -63.441    2.175   -0.572
 PEU           HAL1   H    H         0.000    -62.859    2.200   -1.495
 PEU           HAL2   H    H         0.000    -64.021    3.096   -0.483
 PEU           OAK    O    O2        0.000    -64.325    1.053   -0.594
 PEU           CAJ    C    CH2       0.000    -65.180    1.223   -1.726
 PEU           HAJ1   H    H         0.000    -64.577    1.261   -2.635
 PEU           HAJ2   H    H         0.000    -65.739    2.155   -1.623
 PEU           CAI    C    CH2       0.000    -66.157    0.047   -1.808
 PEU           HAI1   H    H         0.000    -65.597   -0.890   -1.822
 PEU           HAI2   H    H         0.000    -66.749    0.130   -2.722
 PEU           OAH    O    O2        0.000    -67.025    0.069   -0.673
 PEU           CAG    C    CH2       0.000    -67.908   -1.046   -0.807
 PEU           HAG1   H    H         0.000    -67.326   -1.969   -0.835
 PEU           HAG2   H    H         0.000    -68.478   -0.948   -1.734
 PEU           CAF    C    CH2       0.000    -68.869   -1.081    0.383
 PEU           HAF1   H    H         0.000    -68.296   -1.090    1.312
 PEU           HAF2   H    H         0.000    -69.483   -1.982    0.327
 PEU           OAE    O    O2        0.000    -69.710    0.074    0.351
 PEU           CAD    C    CH2       0.000    -70.579   -0.018    1.481
 PEU           HAD1   H    H         0.000    -69.983   -0.039    2.397
 PEU           HAD2   H    H         0.000    -71.171   -0.933    1.412
 PEU           CAC    C    CH2       0.000    -71.512    1.195    1.506
 PEU           HAC1   H    H         0.000    -70.917    2.111    1.488
 PEU           HAC2   H    H         0.000    -72.114    1.172    2.417
 PEU           OAB    O    O2        0.000    -72.371    1.160    0.364
 PEU           CAA    C    CH3       0.000    -73.212    2.312    0.444
 PEU           HAA3   H    H         0.000    -73.776    2.277    1.340
 PEU           HAA2   H    H         0.000    -72.615    3.187    0.437
 PEU           HAA1   H    H         0.000    -73.870    2.328   -0.386
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PEU      ODE    n/a    CDD    START
 PEU      HDE    ODE    .      .
 PEU      CDD    ODE    CDC    .
 PEU      HDD1   CDD    .      .
 PEU      HDD2   CDD    .      .
 PEU      CDC    CDD    ODB    .
 PEU      HDC1   CDC    .      .
 PEU      HDC2   CDC    .      .
 PEU      ODB    CDC    CDA    .
 PEU      CDA    ODB    CCZ    .
 PEU      HDA1   CDA    .      .
 PEU      HDA2   CDA    .      .
 PEU      CCZ    CDA    OCY    .
 PEU      HCZ1   CCZ    .      .
 PEU      HCZ2   CCZ    .      .
 PEU      OCY    CCZ    CCX    .
 PEU      CCX    OCY    CCW    .
 PEU      HCX1   CCX    .      .
 PEU      HCX2   CCX    .      .
 PEU      CCW    CCX    OCV    .
 PEU      HCW1   CCW    .      .
 PEU      HCW2   CCW    .      .
 PEU      OCV    CCW    CCU    .
 PEU      CCU    OCV    CCT    .
 PEU      HCU1   CCU    .      .
 PEU      HCU2   CCU    .      .
 PEU      CCT    CCU    OCS    .
 PEU      HCT1   CCT    .      .
 PEU      HCT2   CCT    .      .
 PEU      OCS    CCT    CCR    .
 PEU      CCR    OCS    CCQ    .
 PEU      HCR1   CCR    .      .
 PEU      HCR2   CCR    .      .
 PEU      CCQ    CCR    OCP    .
 PEU      HCQ1   CCQ    .      .
 PEU      HCQ2   CCQ    .      .
 PEU      OCP    CCQ    CCO    .
 PEU      CCO    OCP    CCN    .
 PEU      HCO1   CCO    .      .
 PEU      HCO2   CCO    .      .
 PEU      CCN    CCO    OCM    .
 PEU      HCN1   CCN    .      .
 PEU      HCN2   CCN    .      .
 PEU      OCM    CCN    CCL    .
 PEU      CCL    OCM    CCK    .
 PEU      HCL1   CCL    .      .
 PEU      HCL2   CCL    .      .
 PEU      CCK    CCL    OCJ    .
 PEU      HCK1   CCK    .      .
 PEU      HCK2   CCK    .      .
 PEU      OCJ    CCK    CCI    .
 PEU      CCI    OCJ    CCH    .
 PEU      HCI1   CCI    .      .
 PEU      HCI2   CCI    .      .
 PEU      CCH    CCI    OBD    .
 PEU      HCH1   CCH    .      .
 PEU      HCH2   CCH    .      .
 PEU      OBD    CCH    CBE    .
 PEU      CBE    OBD    CBF    .
 PEU      HBE1   CBE    .      .
 PEU      HBE2   CBE    .      .
 PEU      CBF    CBE    OBG    .
 PEU      HBF1   CBF    .      .
 PEU      HBF2   CBF    .      .
 PEU      OBG    CBF    CBH    .
 PEU      CBH    OBG    CBI    .
 PEU      HBH1   CBH    .      .
 PEU      HBH2   CBH    .      .
 PEU      CBI    CBH    OBJ    .
 PEU      HBI1   CBI    .      .
 PEU      HBI2   CBI    .      .
 PEU      OBJ    CBI    CBK    .
 PEU      CBK    OBJ    CBL    .
 PEU      HBK1   CBK    .      .
 PEU      HBK2   CBK    .      .
 PEU      CBL    CBK    OBM    .
 PEU      HBL1   CBL    .      .
 PEU      HBL2   CBL    .      .
 PEU      OBM    CBL    CBN    .
 PEU      CBN    OBM    CBO    .
 PEU      HBN1   CBN    .      .
 PEU      HBN2   CBN    .      .
 PEU      CBO    CBN    OBP    .
 PEU      HBO1   CBO    .      .
 PEU      HBO2   CBO    .      .
 PEU      OBP    CBO    CBQ    .
 PEU      CBQ    OBP    CBR    .
 PEU      HBQ1   CBQ    .      .
 PEU      HBQ2   CBQ    .      .
 PEU      CBR    CBQ    OBS    .
 PEU      HBR1   CBR    .      .
 PEU      HBR2   CBR    .      .
 PEU      OBS    CBR    CBT    .
 PEU      CBT    OBS    CBU    .
 PEU      HBT1   CBT    .      .
 PEU      HBT2   CBT    .      .
 PEU      CBU    CBT    OBV    .
 PEU      HBU1   CBU    .      .
 PEU      HBU2   CBU    .      .
 PEU      OBV    CBU    CBW    .
 PEU      CBW    OBV    CBX    .
 PEU      HBW1   CBW    .      .
 PEU      HBW2   CBW    .      .
 PEU      CBX    CBW    OBY    .
 PEU      HBX1   CBX    .      .
 PEU      HBX2   CBX    .      .
 PEU      OBY    CBX    CBZ    .
 PEU      CBZ    OBY    CCA    .
 PEU      HBZ1   CBZ    .      .
 PEU      HBZ2   CBZ    .      .
 PEU      CCA    CBZ    OCB    .
 PEU      HCA1   CCA    .      .
 PEU      HCA2   CCA    .      .
 PEU      OCB    CCA    CCC    .
 PEU      CCC    OCB    CCD    .
 PEU      HCC1   CCC    .      .
 PEU      HCC2   CCC    .      .
 PEU      CCD    CCC    OCE    .
 PEU      HCD1   CCD    .      .
 PEU      HCD2   CCD    .      .
 PEU      OCE    CCD    CCF    .
 PEU      CCF    OCE    CCG    .
 PEU      HCF1   CCF    .      .
 PEU      HCF2   CCF    .      .
 PEU      CCG    CCF    OBC    .
 PEU      HCG1   CCG    .      .
 PEU      HCG2   CCG    .      .
 PEU      OBC    CCG    CBB    .
 PEU      CBB    OBC    CBA    .
 PEU      HBB1   CBB    .      .
 PEU      HBB2   CBB    .      .
 PEU      CBA    CBB    OAZ    .
 PEU      HBA1   CBA    .      .
 PEU      HBA2   CBA    .      .
 PEU      OAZ    CBA    CAY    .
 PEU      CAY    OAZ    CAX    .
 PEU      HAY1   CAY    .      .
 PEU      HAY2   CAY    .      .
 PEU      CAX    CAY    OAW    .
 PEU      HAX1   CAX    .      .
 PEU      HAX2   CAX    .      .
 PEU      OAW    CAX    CAV    .
 PEU      CAV    OAW    CAU    .
 PEU      HAV1   CAV    .      .
 PEU      HAV2   CAV    .      .
 PEU      CAU    CAV    OAT    .
 PEU      HAU1   CAU    .      .
 PEU      HAU2   CAU    .      .
 PEU      OAT    CAU    CAS    .
 PEU      CAS    OAT    CAR    .
 PEU      HAS1   CAS    .      .
 PEU      HAS2   CAS    .      .
 PEU      CAR    CAS    OAQ    .
 PEU      HAR1   CAR    .      .
 PEU      HAR2   CAR    .      .
 PEU      OAQ    CAR    CAP    .
 PEU      CAP    OAQ    CAO    .
 PEU      HAP1   CAP    .      .
 PEU      HAP2   CAP    .      .
 PEU      CAO    CAP    OAN    .
 PEU      HAO1   CAO    .      .
 PEU      HAO2   CAO    .      .
 PEU      OAN    CAO    CAM    .
 PEU      CAM    OAN    CAL    .
 PEU      HAM1   CAM    .      .
 PEU      HAM2   CAM    .      .
 PEU      CAL    CAM    OAK    .
 PEU      HAL1   CAL    .      .
 PEU      HAL2   CAL    .      .
 PEU      OAK    CAL    CAJ    .
 PEU      CAJ    OAK    CAI    .
 PEU      HAJ1   CAJ    .      .
 PEU      HAJ2   CAJ    .      .
 PEU      CAI    CAJ    OAH    .
 PEU      HAI1   CAI    .      .
 PEU      HAI2   CAI    .      .
 PEU      OAH    CAI    CAG    .
 PEU      CAG    OAH    CAF    .
 PEU      HAG1   CAG    .      .
 PEU      HAG2   CAG    .      .
 PEU      CAF    CAG    OAE    .
 PEU      HAF1   CAF    .      .
 PEU      HAF2   CAF    .      .
 PEU      OAE    CAF    CAD    .
 PEU      CAD    OAE    CAC    .
 PEU      HAD1   CAD    .      .
 PEU      HAD2   CAD    .      .
 PEU      CAC    CAD    OAB    .
 PEU      HAC1   CAC    .      .
 PEU      HAC2   CAC    .      .
 PEU      OAB    CAC    CAA    .
 PEU      CAA    OAB    HAA1   .
 PEU      HAA3   CAA    .      .
 PEU      HAA2   CAA    .      .
 PEU      HAA1   CAA    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PEU      CAA    OAB       single      1.426    0.020
 PEU      HAA1   CAA       single      1.059    0.020
 PEU      HAA2   CAA       single      1.059    0.020
 PEU      HAA3   CAA       single      1.059    0.020
 PEU      OAB    CAC       single      1.426    0.020
 PEU      CAC    CAD       single      1.524    0.020
 PEU      HAC1   CAC       single      1.092    0.020
 PEU      HAC2   CAC       single      1.092    0.020
 PEU      CAD    OAE       single      1.426    0.020
 PEU      HAD1   CAD       single      1.092    0.020
 PEU      HAD2   CAD       single      1.092    0.020
 PEU      OAE    CAF       single      1.426    0.020
 PEU      CAF    CAG       single      1.524    0.020
 PEU      HAF1   CAF       single      1.092    0.020
 PEU      HAF2   CAF       single      1.092    0.020
 PEU      CAG    OAH       single      1.426    0.020
 PEU      HAG1   CAG       single      1.092    0.020
 PEU      HAG2   CAG       single      1.092    0.020
 PEU      OAH    CAI       single      1.426    0.020
 PEU      CAI    CAJ       single      1.524    0.020
 PEU      HAI1   CAI       single      1.092    0.020
 PEU      HAI2   CAI       single      1.092    0.020
 PEU      CAJ    OAK       single      1.426    0.020
 PEU      HAJ1   CAJ       single      1.092    0.020
 PEU      HAJ2   CAJ       single      1.092    0.020
 PEU      OAK    CAL       single      1.426    0.020
 PEU      CAL    CAM       single      1.524    0.020
 PEU      HAL1   CAL       single      1.092    0.020
 PEU      HAL2   CAL       single      1.092    0.020
 PEU      CAM    OAN       single      1.426    0.020
 PEU      HAM1   CAM       single      1.092    0.020
 PEU      HAM2   CAM       single      1.092    0.020
 PEU      OAN    CAO       single      1.426    0.020
 PEU      CAO    CAP       single      1.524    0.020
 PEU      HAO1   CAO       single      1.092    0.020
 PEU      HAO2   CAO       single      1.092    0.020
 PEU      CAP    OAQ       single      1.426    0.020
 PEU      HAP1   CAP       single      1.092    0.020
 PEU      HAP2   CAP       single      1.092    0.020
 PEU      OAQ    CAR       single      1.426    0.020
 PEU      CAR    CAS       single      1.524    0.020
 PEU      HAR1   CAR       single      1.092    0.020
 PEU      HAR2   CAR       single      1.092    0.020
 PEU      CAS    OAT       single      1.426    0.020
 PEU      HAS1   CAS       single      1.092    0.020
 PEU      HAS2   CAS       single      1.092    0.020
 PEU      OAT    CAU       single      1.426    0.020
 PEU      CAU    CAV       single      1.524    0.020
 PEU      HAU1   CAU       single      1.092    0.020
 PEU      HAU2   CAU       single      1.092    0.020
 PEU      CAV    OAW       single      1.426    0.020
 PEU      HAV1   CAV       single      1.092    0.020
 PEU      HAV2   CAV       single      1.092    0.020
 PEU      OAW    CAX       single      1.426    0.020
 PEU      CAX    CAY       single      1.524    0.020
 PEU      HAX1   CAX       single      1.092    0.020
 PEU      HAX2   CAX       single      1.092    0.020
 PEU      CAY    OAZ       single      1.426    0.020
 PEU      HAY1   CAY       single      1.092    0.020
 PEU      HAY2   CAY       single      1.092    0.020
 PEU      OAZ    CBA       single      1.426    0.020
 PEU      CBA    CBB       single      1.524    0.020
 PEU      HBA1   CBA       single      1.092    0.020
 PEU      HBA2   CBA       single      1.092    0.020
 PEU      CBB    OBC       single      1.426    0.020
 PEU      HBB1   CBB       single      1.092    0.020
 PEU      HBB2   CBB       single      1.092    0.020
 PEU      OBC    CCG       single      1.426    0.020
 PEU      CCG    CCF       single      1.524    0.020
 PEU      HCG1   CCG       single      1.092    0.020
 PEU      HCG2   CCG       single      1.092    0.020
 PEU      CCF    OCE       single      1.426    0.020
 PEU      HCF1   CCF       single      1.092    0.020
 PEU      HCF2   CCF       single      1.092    0.020
 PEU      OCE    CCD       single      1.426    0.020
 PEU      CCD    CCC       single      1.524    0.020
 PEU      HCD1   CCD       single      1.092    0.020
 PEU      HCD2   CCD       single      1.092    0.020
 PEU      CCC    OCB       single      1.426    0.020
 PEU      HCC1   CCC       single      1.092    0.020
 PEU      HCC2   CCC       single      1.092    0.020
 PEU      OCB    CCA       single      1.426    0.020
 PEU      CCA    CBZ       single      1.524    0.020
 PEU      HCA1   CCA       single      1.092    0.020
 PEU      HCA2   CCA       single      1.092    0.020
 PEU      CBZ    OBY       single      1.426    0.020
 PEU      HBZ1   CBZ       single      1.092    0.020
 PEU      HBZ2   CBZ       single      1.092    0.020
 PEU      OBY    CBX       single      1.426    0.020
 PEU      CBX    CBW       single      1.524    0.020
 PEU      HBX1   CBX       single      1.092    0.020
 PEU      HBX2   CBX       single      1.092    0.020
 PEU      CBW    OBV       single      1.426    0.020
 PEU      HBW1   CBW       single      1.092    0.020
 PEU      HBW2   CBW       single      1.092    0.020
 PEU      OBV    CBU       single      1.426    0.020
 PEU      CBU    CBT       single      1.524    0.020
 PEU      HBU1   CBU       single      1.092    0.020
 PEU      HBU2   CBU       single      1.092    0.020
 PEU      CBT    OBS       single      1.426    0.020
 PEU      HBT1   CBT       single      1.092    0.020
 PEU      HBT2   CBT       single      1.092    0.020
 PEU      OBS    CBR       single      1.426    0.020
 PEU      CBR    CBQ       single      1.524    0.020
 PEU      HBR1   CBR       single      1.092    0.020
 PEU      HBR2   CBR       single      1.092    0.020
 PEU      CBQ    OBP       single      1.426    0.020
 PEU      HBQ1   CBQ       single      1.092    0.020
 PEU      HBQ2   CBQ       single      1.092    0.020
 PEU      OBP    CBO       single      1.426    0.020
 PEU      CBO    CBN       single      1.524    0.020
 PEU      HBO1   CBO       single      1.092    0.020
 PEU      HBO2   CBO       single      1.092    0.020
 PEU      CBN    OBM       single      1.426    0.020
 PEU      HBN1   CBN       single      1.092    0.020
 PEU      HBN2   CBN       single      1.092    0.020
 PEU      OBM    CBL       single      1.426    0.020
 PEU      CBL    CBK       single      1.524    0.020
 PEU      HBL1   CBL       single      1.092    0.020
 PEU      HBL2   CBL       single      1.092    0.020
 PEU      CBK    OBJ       single      1.426    0.020
 PEU      HBK1   CBK       single      1.092    0.020
 PEU      HBK2   CBK       single      1.092    0.020
 PEU      OBJ    CBI       single      1.426    0.020
 PEU      CBI    CBH       single      1.524    0.020
 PEU      HBI1   CBI       single      1.092    0.020
 PEU      HBI2   CBI       single      1.092    0.020
 PEU      CBH    OBG       single      1.426    0.020
 PEU      HBH1   CBH       single      1.092    0.020
 PEU      HBH2   CBH       single      1.092    0.020
 PEU      OBG    CBF       single      1.426    0.020
 PEU      CBF    CBE       single      1.524    0.020
 PEU      HBF1   CBF       single      1.092    0.020
 PEU      HBF2   CBF       single      1.092    0.020
 PEU      CBE    OBD       single      1.426    0.020
 PEU      HBE1   CBE       single      1.092    0.020
 PEU      HBE2   CBE       single      1.092    0.020
 PEU      OBD    CCH       single      1.426    0.020
 PEU      CCH    CCI       single      1.524    0.020
 PEU      HCH1   CCH       single      1.092    0.020
 PEU      HCH2   CCH       single      1.092    0.020
 PEU      CCI    OCJ       single      1.426    0.020
 PEU      HCI1   CCI       single      1.092    0.020
 PEU      HCI2   CCI       single      1.092    0.020
 PEU      OCJ    CCK       single      1.426    0.020
 PEU      CCK    CCL       single      1.524    0.020
 PEU      HCK1   CCK       single      1.092    0.020
 PEU      HCK2   CCK       single      1.092    0.020
 PEU      CCL    OCM       single      1.426    0.020
 PEU      HCL1   CCL       single      1.092    0.020
 PEU      HCL2   CCL       single      1.092    0.020
 PEU      OCM    CCN       single      1.426    0.020
 PEU      CCN    CCO       single      1.524    0.020
 PEU      HCN1   CCN       single      1.092    0.020
 PEU      HCN2   CCN       single      1.092    0.020
 PEU      CCO    OCP       single      1.426    0.020
 PEU      HCO1   CCO       single      1.092    0.020
 PEU      HCO2   CCO       single      1.092    0.020
 PEU      OCP    CCQ       single      1.426    0.020
 PEU      CCQ    CCR       single      1.524    0.020
 PEU      HCQ1   CCQ       single      1.092    0.020
 PEU      HCQ2   CCQ       single      1.092    0.020
 PEU      CCR    OCS       single      1.426    0.020
 PEU      HCR1   CCR       single      1.092    0.020
 PEU      HCR2   CCR       single      1.092    0.020
 PEU      OCS    CCT       single      1.426    0.020
 PEU      CCT    CCU       single      1.524    0.020
 PEU      HCT1   CCT       single      1.092    0.020
 PEU      HCT2   CCT       single      1.092    0.020
 PEU      CCU    OCV       single      1.426    0.020
 PEU      HCU1   CCU       single      1.092    0.020
 PEU      HCU2   CCU       single      1.092    0.020
 PEU      OCV    CCW       single      1.426    0.020
 PEU      CCW    CCX       single      1.524    0.020
 PEU      HCW1   CCW       single      1.092    0.020
 PEU      HCW2   CCW       single      1.092    0.020
 PEU      CCX    OCY       single      1.426    0.020
 PEU      HCX1   CCX       single      1.092    0.020
 PEU      HCX2   CCX       single      1.092    0.020
 PEU      OCY    CCZ       single      1.426    0.020
 PEU      CCZ    CDA       single      1.524    0.020
 PEU      HCZ1   CCZ       single      1.092    0.020
 PEU      HCZ2   CCZ       single      1.092    0.020
 PEU      CDA    ODB       single      1.426    0.020
 PEU      HDA1   CDA       single      1.092    0.020
 PEU      HDA2   CDA       single      1.092    0.020
 PEU      ODB    CDC       single      1.426    0.020
 PEU      CDC    CDD       single      1.524    0.020
 PEU      HDC1   CDC       single      1.092    0.020
 PEU      HDC2   CDC       single      1.092    0.020
 PEU      CDD    ODE       single      1.432    0.020
 PEU      HDD1   CDD       single      1.092    0.020
 PEU      HDD2   CDD       single      1.092    0.020
 PEU      HDE    ODE       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PEU      HDE    ODE    CDD     109.470    3.000
 PEU      ODE    CDD    HDD1    109.470    3.000
 PEU      ODE    CDD    HDD2    109.470    3.000
 PEU      ODE    CDD    CDC     109.470    3.000
 PEU      HDD1   CDD    HDD2    107.900    3.000
 PEU      HDD1   CDD    CDC     109.470    3.000
 PEU      HDD2   CDD    CDC     109.470    3.000
 PEU      CDD    CDC    HDC1    109.470    3.000
 PEU      CDD    CDC    HDC2    109.470    3.000
 PEU      CDD    CDC    ODB     109.470    3.000
 PEU      HDC1   CDC    HDC2    107.900    3.000
 PEU      HDC1   CDC    ODB     109.470    3.000
 PEU      HDC2   CDC    ODB     109.470    3.000
 PEU      CDC    ODB    CDA     111.800    3.000
 PEU      ODB    CDA    HDA1    109.470    3.000
 PEU      ODB    CDA    HDA2    109.470    3.000
 PEU      ODB    CDA    CCZ     109.470    3.000
 PEU      HDA1   CDA    HDA2    107.900    3.000
 PEU      HDA1   CDA    CCZ     109.470    3.000
 PEU      HDA2   CDA    CCZ     109.470    3.000
 PEU      CDA    CCZ    HCZ1    109.470    3.000
 PEU      CDA    CCZ    HCZ2    109.470    3.000
 PEU      CDA    CCZ    OCY     109.470    3.000
 PEU      HCZ1   CCZ    HCZ2    107.900    3.000
 PEU      HCZ1   CCZ    OCY     109.470    3.000
 PEU      HCZ2   CCZ    OCY     109.470    3.000
 PEU      CCZ    OCY    CCX     111.800    3.000
 PEU      OCY    CCX    HCX1    109.470    3.000
 PEU      OCY    CCX    HCX2    109.470    3.000
 PEU      OCY    CCX    CCW     109.470    3.000
 PEU      HCX1   CCX    HCX2    107.900    3.000
 PEU      HCX1   CCX    CCW     109.470    3.000
 PEU      HCX2   CCX    CCW     109.470    3.000
 PEU      CCX    CCW    HCW1    109.470    3.000
 PEU      CCX    CCW    HCW2    109.470    3.000
 PEU      CCX    CCW    OCV     109.470    3.000
 PEU      HCW1   CCW    HCW2    107.900    3.000
 PEU      HCW1   CCW    OCV     109.470    3.000
 PEU      HCW2   CCW    OCV     109.470    3.000
 PEU      CCW    OCV    CCU     111.800    3.000
 PEU      OCV    CCU    HCU1    109.470    3.000
 PEU      OCV    CCU    HCU2    109.470    3.000
 PEU      OCV    CCU    CCT     109.470    3.000
 PEU      HCU1   CCU    HCU2    107.900    3.000
 PEU      HCU1   CCU    CCT     109.470    3.000
 PEU      HCU2   CCU    CCT     109.470    3.000
 PEU      CCU    CCT    HCT1    109.470    3.000
 PEU      CCU    CCT    HCT2    109.470    3.000
 PEU      CCU    CCT    OCS     109.470    3.000
 PEU      HCT1   CCT    HCT2    107.900    3.000
 PEU      HCT1   CCT    OCS     109.470    3.000
 PEU      HCT2   CCT    OCS     109.470    3.000
 PEU      CCT    OCS    CCR     111.800    3.000
 PEU      OCS    CCR    HCR1    109.470    3.000
 PEU      OCS    CCR    HCR2    109.470    3.000
 PEU      OCS    CCR    CCQ     109.470    3.000
 PEU      HCR1   CCR    HCR2    107.900    3.000
 PEU      HCR1   CCR    CCQ     109.470    3.000
 PEU      HCR2   CCR    CCQ     109.470    3.000
 PEU      CCR    CCQ    HCQ1    109.470    3.000
 PEU      CCR    CCQ    HCQ2    109.470    3.000
 PEU      CCR    CCQ    OCP     109.470    3.000
 PEU      HCQ1   CCQ    HCQ2    107.900    3.000
 PEU      HCQ1   CCQ    OCP     109.470    3.000
 PEU      HCQ2   CCQ    OCP     109.470    3.000
 PEU      CCQ    OCP    CCO     111.800    3.000
 PEU      OCP    CCO    HCO1    109.470    3.000
 PEU      OCP    CCO    HCO2    109.470    3.000
 PEU      OCP    CCO    CCN     109.470    3.000
 PEU      HCO1   CCO    HCO2    107.900    3.000
 PEU      HCO1   CCO    CCN     109.470    3.000
 PEU      HCO2   CCO    CCN     109.470    3.000
 PEU      CCO    CCN    HCN1    109.470    3.000
 PEU      CCO    CCN    HCN2    109.470    3.000
 PEU      CCO    CCN    OCM     109.470    3.000
 PEU      HCN1   CCN    HCN2    107.900    3.000
 PEU      HCN1   CCN    OCM     109.470    3.000
 PEU      HCN2   CCN    OCM     109.470    3.000
 PEU      CCN    OCM    CCL     111.800    3.000
 PEU      OCM    CCL    HCL1    109.470    3.000
 PEU      OCM    CCL    HCL2    109.470    3.000
 PEU      OCM    CCL    CCK     109.470    3.000
 PEU      HCL1   CCL    HCL2    107.900    3.000
 PEU      HCL1   CCL    CCK     109.470    3.000
 PEU      HCL2   CCL    CCK     109.470    3.000
 PEU      CCL    CCK    HCK1    109.470    3.000
 PEU      CCL    CCK    HCK2    109.470    3.000
 PEU      CCL    CCK    OCJ     109.470    3.000
 PEU      HCK1   CCK    HCK2    107.900    3.000
 PEU      HCK1   CCK    OCJ     109.470    3.000
 PEU      HCK2   CCK    OCJ     109.470    3.000
 PEU      CCK    OCJ    CCI     111.800    3.000
 PEU      OCJ    CCI    HCI1    109.470    3.000
 PEU      OCJ    CCI    HCI2    109.470    3.000
 PEU      OCJ    CCI    CCH     109.470    3.000
 PEU      HCI1   CCI    HCI2    107.900    3.000
 PEU      HCI1   CCI    CCH     109.470    3.000
 PEU      HCI2   CCI    CCH     109.470    3.000
 PEU      CCI    CCH    HCH1    109.470    3.000
 PEU      CCI    CCH    HCH2    109.470    3.000
 PEU      CCI    CCH    OBD     109.470    3.000
 PEU      HCH1   CCH    HCH2    107.900    3.000
 PEU      HCH1   CCH    OBD     109.470    3.000
 PEU      HCH2   CCH    OBD     109.470    3.000
 PEU      CCH    OBD    CBE     111.800    3.000
 PEU      OBD    CBE    HBE1    109.470    3.000
 PEU      OBD    CBE    HBE2    109.470    3.000
 PEU      OBD    CBE    CBF     109.470    3.000
 PEU      HBE1   CBE    HBE2    107.900    3.000
 PEU      HBE1   CBE    CBF     109.470    3.000
 PEU      HBE2   CBE    CBF     109.470    3.000
 PEU      CBE    CBF    HBF1    109.470    3.000
 PEU      CBE    CBF    HBF2    109.470    3.000
 PEU      CBE    CBF    OBG     109.470    3.000
 PEU      HBF1   CBF    HBF2    107.900    3.000
 PEU      HBF1   CBF    OBG     109.470    3.000
 PEU      HBF2   CBF    OBG     109.470    3.000
 PEU      CBF    OBG    CBH     111.800    3.000
 PEU      OBG    CBH    HBH1    109.470    3.000
 PEU      OBG    CBH    HBH2    109.470    3.000
 PEU      OBG    CBH    CBI     109.470    3.000
 PEU      HBH1   CBH    HBH2    107.900    3.000
 PEU      HBH1   CBH    CBI     109.470    3.000
 PEU      HBH2   CBH    CBI     109.470    3.000
 PEU      CBH    CBI    HBI1    109.470    3.000
 PEU      CBH    CBI    HBI2    109.470    3.000
 PEU      CBH    CBI    OBJ     109.470    3.000
 PEU      HBI1   CBI    HBI2    107.900    3.000
 PEU      HBI1   CBI    OBJ     109.470    3.000
 PEU      HBI2   CBI    OBJ     109.470    3.000
 PEU      CBI    OBJ    CBK     111.800    3.000
 PEU      OBJ    CBK    HBK1    109.470    3.000
 PEU      OBJ    CBK    HBK2    109.470    3.000
 PEU      OBJ    CBK    CBL     109.470    3.000
 PEU      HBK1   CBK    HBK2    107.900    3.000
 PEU      HBK1   CBK    CBL     109.470    3.000
 PEU      HBK2   CBK    CBL     109.470    3.000
 PEU      CBK    CBL    HBL1    109.470    3.000
 PEU      CBK    CBL    HBL2    109.470    3.000
 PEU      CBK    CBL    OBM     109.470    3.000
 PEU      HBL1   CBL    HBL2    107.900    3.000
 PEU      HBL1   CBL    OBM     109.470    3.000
 PEU      HBL2   CBL    OBM     109.470    3.000
 PEU      CBL    OBM    CBN     111.800    3.000
 PEU      OBM    CBN    HBN1    109.470    3.000
 PEU      OBM    CBN    HBN2    109.470    3.000
 PEU      OBM    CBN    CBO     109.470    3.000
 PEU      HBN1   CBN    HBN2    107.900    3.000
 PEU      HBN1   CBN    CBO     109.470    3.000
 PEU      HBN2   CBN    CBO     109.470    3.000
 PEU      CBN    CBO    HBO1    109.470    3.000
 PEU      CBN    CBO    HBO2    109.470    3.000
 PEU      CBN    CBO    OBP     109.470    3.000
 PEU      HBO1   CBO    HBO2    107.900    3.000
 PEU      HBO1   CBO    OBP     109.470    3.000
 PEU      HBO2   CBO    OBP     109.470    3.000
 PEU      CBO    OBP    CBQ     111.800    3.000
 PEU      OBP    CBQ    HBQ1    109.470    3.000
 PEU      OBP    CBQ    HBQ2    109.470    3.000
 PEU      OBP    CBQ    CBR     109.470    3.000
 PEU      HBQ1   CBQ    HBQ2    107.900    3.000
 PEU      HBQ1   CBQ    CBR     109.470    3.000
 PEU      HBQ2   CBQ    CBR     109.470    3.000
 PEU      CBQ    CBR    HBR1    109.470    3.000
 PEU      CBQ    CBR    HBR2    109.470    3.000
 PEU      CBQ    CBR    OBS     109.470    3.000
 PEU      HBR1   CBR    HBR2    107.900    3.000
 PEU      HBR1   CBR    OBS     109.470    3.000
 PEU      HBR2   CBR    OBS     109.470    3.000
 PEU      CBR    OBS    CBT     111.800    3.000
 PEU      OBS    CBT    HBT1    109.470    3.000
 PEU      OBS    CBT    HBT2    109.470    3.000
 PEU      OBS    CBT    CBU     109.470    3.000
 PEU      HBT1   CBT    HBT2    107.900    3.000
 PEU      HBT1   CBT    CBU     109.470    3.000
 PEU      HBT2   CBT    CBU     109.470    3.000
 PEU      CBT    CBU    HBU1    109.470    3.000
 PEU      CBT    CBU    HBU2    109.470    3.000
 PEU      CBT    CBU    OBV     109.470    3.000
 PEU      HBU1   CBU    HBU2    107.900    3.000
 PEU      HBU1   CBU    OBV     109.470    3.000
 PEU      HBU2   CBU    OBV     109.470    3.000
 PEU      CBU    OBV    CBW     111.800    3.000
 PEU      OBV    CBW    HBW1    109.470    3.000
 PEU      OBV    CBW    HBW2    109.470    3.000
 PEU      OBV    CBW    CBX     109.470    3.000
 PEU      HBW1   CBW    HBW2    107.900    3.000
 PEU      HBW1   CBW    CBX     109.470    3.000
 PEU      HBW2   CBW    CBX     109.470    3.000
 PEU      CBW    CBX    HBX1    109.470    3.000
 PEU      CBW    CBX    HBX2    109.470    3.000
 PEU      CBW    CBX    OBY     109.470    3.000
 PEU      HBX1   CBX    HBX2    107.900    3.000
 PEU      HBX1   CBX    OBY     109.470    3.000
 PEU      HBX2   CBX    OBY     109.470    3.000
 PEU      CBX    OBY    CBZ     111.800    3.000
 PEU      OBY    CBZ    HBZ1    109.470    3.000
 PEU      OBY    CBZ    HBZ2    109.470    3.000
 PEU      OBY    CBZ    CCA     109.470    3.000
 PEU      HBZ1   CBZ    HBZ2    107.900    3.000
 PEU      HBZ1   CBZ    CCA     109.470    3.000
 PEU      HBZ2   CBZ    CCA     109.470    3.000
 PEU      CBZ    CCA    HCA1    109.470    3.000
 PEU      CBZ    CCA    HCA2    109.470    3.000
 PEU      CBZ    CCA    OCB     109.470    3.000
 PEU      HCA1   CCA    HCA2    107.900    3.000
 PEU      HCA1   CCA    OCB     109.470    3.000
 PEU      HCA2   CCA    OCB     109.470    3.000
 PEU      CCA    OCB    CCC     111.800    3.000
 PEU      OCB    CCC    HCC1    109.470    3.000
 PEU      OCB    CCC    HCC2    109.470    3.000
 PEU      OCB    CCC    CCD     109.470    3.000
 PEU      HCC1   CCC    HCC2    107.900    3.000
 PEU      HCC1   CCC    CCD     109.470    3.000
 PEU      HCC2   CCC    CCD     109.470    3.000
 PEU      CCC    CCD    HCD1    109.470    3.000
 PEU      CCC    CCD    HCD2    109.470    3.000
 PEU      CCC    CCD    OCE     109.470    3.000
 PEU      HCD1   CCD    HCD2    107.900    3.000
 PEU      HCD1   CCD    OCE     109.470    3.000
 PEU      HCD2   CCD    OCE     109.470    3.000
 PEU      CCD    OCE    CCF     111.800    3.000
 PEU      OCE    CCF    HCF1    109.470    3.000
 PEU      OCE    CCF    HCF2    109.470    3.000
 PEU      OCE    CCF    CCG     109.470    3.000
 PEU      HCF1   CCF    HCF2    107.900    3.000
 PEU      HCF1   CCF    CCG     109.470    3.000
 PEU      HCF2   CCF    CCG     109.470    3.000
 PEU      CCF    CCG    HCG1    109.470    3.000
 PEU      CCF    CCG    HCG2    109.470    3.000
 PEU      CCF    CCG    OBC     109.470    3.000
 PEU      HCG1   CCG    HCG2    107.900    3.000
 PEU      HCG1   CCG    OBC     109.470    3.000
 PEU      HCG2   CCG    OBC     109.470    3.000
 PEU      CCG    OBC    CBB     111.800    3.000
 PEU      OBC    CBB    HBB1    109.470    3.000
 PEU      OBC    CBB    HBB2    109.470    3.000
 PEU      OBC    CBB    CBA     109.470    3.000
 PEU      HBB1   CBB    HBB2    107.900    3.000
 PEU      HBB1   CBB    CBA     109.470    3.000
 PEU      HBB2   CBB    CBA     109.470    3.000
 PEU      CBB    CBA    HBA1    109.470    3.000
 PEU      CBB    CBA    HBA2    109.470    3.000
 PEU      CBB    CBA    OAZ     109.470    3.000
 PEU      HBA1   CBA    HBA2    107.900    3.000
 PEU      HBA1   CBA    OAZ     109.470    3.000
 PEU      HBA2   CBA    OAZ     109.470    3.000
 PEU      CBA    OAZ    CAY     111.800    3.000
 PEU      OAZ    CAY    HAY1    109.470    3.000
 PEU      OAZ    CAY    HAY2    109.470    3.000
 PEU      OAZ    CAY    CAX     109.470    3.000
 PEU      HAY1   CAY    HAY2    107.900    3.000
 PEU      HAY1   CAY    CAX     109.470    3.000
 PEU      HAY2   CAY    CAX     109.470    3.000
 PEU      CAY    CAX    HAX1    109.470    3.000
 PEU      CAY    CAX    HAX2    109.470    3.000
 PEU      CAY    CAX    OAW     109.470    3.000
 PEU      HAX1   CAX    HAX2    107.900    3.000
 PEU      HAX1   CAX    OAW     109.470    3.000
 PEU      HAX2   CAX    OAW     109.470    3.000
 PEU      CAX    OAW    CAV     111.800    3.000
 PEU      OAW    CAV    HAV1    109.470    3.000
 PEU      OAW    CAV    HAV2    109.470    3.000
 PEU      OAW    CAV    CAU     109.470    3.000
 PEU      HAV1   CAV    HAV2    107.900    3.000
 PEU      HAV1   CAV    CAU     109.470    3.000
 PEU      HAV2   CAV    CAU     109.470    3.000
 PEU      CAV    CAU    HAU1    109.470    3.000
 PEU      CAV    CAU    HAU2    109.470    3.000
 PEU      CAV    CAU    OAT     109.470    3.000
 PEU      HAU1   CAU    HAU2    107.900    3.000
 PEU      HAU1   CAU    OAT     109.470    3.000
 PEU      HAU2   CAU    OAT     109.470    3.000
 PEU      CAU    OAT    CAS     111.800    3.000
 PEU      OAT    CAS    HAS1    109.470    3.000
 PEU      OAT    CAS    HAS2    109.470    3.000
 PEU      OAT    CAS    CAR     109.470    3.000
 PEU      HAS1   CAS    HAS2    107.900    3.000
 PEU      HAS1   CAS    CAR     109.470    3.000
 PEU      HAS2   CAS    CAR     109.470    3.000
 PEU      CAS    CAR    HAR1    109.470    3.000
 PEU      CAS    CAR    HAR2    109.470    3.000
 PEU      CAS    CAR    OAQ     109.470    3.000
 PEU      HAR1   CAR    HAR2    107.900    3.000
 PEU      HAR1   CAR    OAQ     109.470    3.000
 PEU      HAR2   CAR    OAQ     109.470    3.000
 PEU      CAR    OAQ    CAP     111.800    3.000
 PEU      OAQ    CAP    HAP1    109.470    3.000
 PEU      OAQ    CAP    HAP2    109.470    3.000
 PEU      OAQ    CAP    CAO     109.470    3.000
 PEU      HAP1   CAP    HAP2    107.900    3.000
 PEU      HAP1   CAP    CAO     109.470    3.000
 PEU      HAP2   CAP    CAO     109.470    3.000
 PEU      CAP    CAO    HAO1    109.470    3.000
 PEU      CAP    CAO    HAO2    109.470    3.000
 PEU      CAP    CAO    OAN     109.470    3.000
 PEU      HAO1   CAO    HAO2    107.900    3.000
 PEU      HAO1   CAO    OAN     109.470    3.000
 PEU      HAO2   CAO    OAN     109.470    3.000
 PEU      CAO    OAN    CAM     111.800    3.000
 PEU      OAN    CAM    HAM1    109.470    3.000
 PEU      OAN    CAM    HAM2    109.470    3.000
 PEU      OAN    CAM    CAL     109.470    3.000
 PEU      HAM1   CAM    HAM2    107.900    3.000
 PEU      HAM1   CAM    CAL     109.470    3.000
 PEU      HAM2   CAM    CAL     109.470    3.000
 PEU      CAM    CAL    HAL1    109.470    3.000
 PEU      CAM    CAL    HAL2    109.470    3.000
 PEU      CAM    CAL    OAK     109.470    3.000
 PEU      HAL1   CAL    HAL2    107.900    3.000
 PEU      HAL1   CAL    OAK     109.470    3.000
 PEU      HAL2   CAL    OAK     109.470    3.000
 PEU      CAL    OAK    CAJ     111.800    3.000
 PEU      OAK    CAJ    HAJ1    109.470    3.000
 PEU      OAK    CAJ    HAJ2    109.470    3.000
 PEU      OAK    CAJ    CAI     109.470    3.000
 PEU      HAJ1   CAJ    HAJ2    107.900    3.000
 PEU      HAJ1   CAJ    CAI     109.470    3.000
 PEU      HAJ2   CAJ    CAI     109.470    3.000
 PEU      CAJ    CAI    HAI1    109.470    3.000
 PEU      CAJ    CAI    HAI2    109.470    3.000
 PEU      CAJ    CAI    OAH     109.470    3.000
 PEU      HAI1   CAI    HAI2    107.900    3.000
 PEU      HAI1   CAI    OAH     109.470    3.000
 PEU      HAI2   CAI    OAH     109.470    3.000
 PEU      CAI    OAH    CAG     111.800    3.000
 PEU      OAH    CAG    HAG1    109.470    3.000
 PEU      OAH    CAG    HAG2    109.470    3.000
 PEU      OAH    CAG    CAF     109.470    3.000
 PEU      HAG1   CAG    HAG2    107.900    3.000
 PEU      HAG1   CAG    CAF     109.470    3.000
 PEU      HAG2   CAG    CAF     109.470    3.000
 PEU      CAG    CAF    HAF1    109.470    3.000
 PEU      CAG    CAF    HAF2    109.470    3.000
 PEU      CAG    CAF    OAE     109.470    3.000
 PEU      HAF1   CAF    HAF2    107.900    3.000
 PEU      HAF1   CAF    OAE     109.470    3.000
 PEU      HAF2   CAF    OAE     109.470    3.000
 PEU      CAF    OAE    CAD     111.800    3.000
 PEU      OAE    CAD    HAD1    109.470    3.000
 PEU      OAE    CAD    HAD2    109.470    3.000
 PEU      OAE    CAD    CAC     109.470    3.000
 PEU      HAD1   CAD    HAD2    107.900    3.000
 PEU      HAD1   CAD    CAC     109.470    3.000
 PEU      HAD2   CAD    CAC     109.470    3.000
 PEU      CAD    CAC    HAC1    109.470    3.000
 PEU      CAD    CAC    HAC2    109.470    3.000
 PEU      CAD    CAC    OAB     109.470    3.000
 PEU      HAC1   CAC    HAC2    107.900    3.000
 PEU      HAC1   CAC    OAB     109.470    3.000
 PEU      HAC2   CAC    OAB     109.470    3.000
 PEU      CAC    OAB    CAA     111.800    3.000
 PEU      OAB    CAA    HAA3    109.470    3.000
 PEU      OAB    CAA    HAA2    109.470    3.000
 PEU      OAB    CAA    HAA1    109.470    3.000
 PEU      HAA3   CAA    HAA2    109.470    3.000
 PEU      HAA3   CAA    HAA1    109.470    3.000
 PEU      HAA2   CAA    HAA1    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PEU      var_1    HDE    ODE    CDD    CDC     -179.982   20.000   1
 PEU      var_2    ODE    CDD    CDC    ODB       64.998   20.000   3
 PEU      var_3    CDD    CDC    ODB    CDA      179.994   20.000   1
 PEU      var_4    CDC    ODB    CDA    CCZ      179.997   20.000   1
 PEU      var_5    ODB    CDA    CCZ    OCY       65.028   20.000   3
 PEU      var_6    CDA    CCZ    OCY    CCX      179.992   20.000   1
 PEU      var_7    CCZ    OCY    CCX    CCW      179.990   20.000   1
 PEU      var_8    OCY    CCX    CCW    OCV       64.978   20.000   3
 PEU      var_9    CCX    CCW    OCV    CCU      179.975   20.000   1
 PEU      var_10   CCW    OCV    CCU    CCT     -179.966   20.000   1
 PEU      var_11   OCV    CCU    CCT    OCS       65.030   20.000   3
 PEU      var_12   CCU    CCT    OCS    CCR     -179.985   20.000   1
 PEU      var_13   CCT    OCS    CCR    CCQ     -179.993   20.000   1
 PEU      var_14   OCS    CCR    CCQ    OCP       64.969   20.000   3
 PEU      var_15   CCR    CCQ    OCP    CCO      179.991   20.000   1
 PEU      var_16   CCQ    OCP    CCO    CCN     -179.999   20.000   1
 PEU      var_17   OCP    CCO    CCN    OCM       65.012   20.000   3
 PEU      var_18   CCO    CCN    OCM    CCL      179.957   20.000   1
 PEU      var_19   CCN    OCM    CCL    CCK      179.982   20.000   1
 PEU      var_20   OCM    CCL    CCK    OCJ       65.087   20.000   3
 PEU      var_21   CCL    CCK    OCJ    CCI     -179.993   20.000   1
 PEU      var_22   CCK    OCJ    CCI    CCH      179.994   20.000   1
 PEU      var_23   OCJ    CCI    CCH    OBD       64.934   20.000   3
 PEU      var_24   CCI    CCH    OBD    CBE     -179.998   20.000   1
 PEU      var_25   CCH    OBD    CBE    CBF      179.997   20.000   1
 PEU      var_26   OBD    CBE    CBF    OBG       65.027   20.000   3
 PEU      var_27   CBE    CBF    OBG    CBH      179.998   20.000   1
 PEU      var_28   CBF    OBG    CBH    CBI      179.980   20.000   1
 PEU      var_29   OBG    CBH    CBI    OBJ       65.022   20.000   3
 PEU      var_30   CBH    CBI    OBJ    CBK      179.975   20.000   1
 PEU      var_31   CBI    OBJ    CBK    CBL      179.992   20.000   1
 PEU      var_32   OBJ    CBK    CBL    OBM       65.008   20.000   3
 PEU      var_33   CBK    CBL    OBM    CBN     -179.975   20.000   1
 PEU      var_34   CBL    OBM    CBN    CBO      179.987   20.000   1
 PEU      var_35   OBM    CBN    CBO    OBP       64.959   20.000   3
 PEU      var_36   CBN    CBO    OBP    CBQ     -179.973   20.000   1
 PEU      var_37   CBO    OBP    CBQ    CBR     -180.000   20.000   1
 PEU      var_38   OBP    CBQ    CBR    OBS       65.017   20.000   3
 PEU      var_39   CBQ    CBR    OBS    CBT      179.938   20.000   1
 PEU      var_40   CBR    OBS    CBT    CBU      179.949   20.000   1
 PEU      var_41   OBS    CBT    CBU    OBV       65.071   20.000   3
 PEU      var_42   CBT    CBU    OBV    CBW     -179.992   20.000   1
 PEU      var_43   CBU    OBV    CBW    CBX      179.989   20.000   1
 PEU      var_44   OBV    CBW    CBX    OBY       65.004   20.000   3
 PEU      var_45   CBW    CBX    OBY    CBZ      180.000   20.000   1
 PEU      var_46   CBX    OBY    CBZ    CCA      179.966   20.000   1
 PEU      var_47   OBY    CBZ    CCA    OCB       64.974   20.000   3
 PEU      var_48   CBZ    CCA    OCB    CCC      179.996   20.000   1
 PEU      var_49   CCA    OCB    CCC    CCD      179.986   20.000   1
 PEU      var_50   OCB    CCC    CCD    OCE       65.066   20.000   3
 PEU      var_51   CCC    CCD    OCE    CCF      179.972   20.000   1
 PEU      var_52   CCD    OCE    CCF    CCG      179.958   20.000   1
 PEU      var_53   OCE    CCF    CCG    OBC       65.002   20.000   3
 PEU      var_54   CCF    CCG    OBC    CBB      179.975   20.000   1
 PEU      var_55   CCG    OBC    CBB    CBA      179.993   20.000   1
 PEU      var_56   OBC    CBB    CBA    OAZ       65.013   20.000   3
 PEU      var_57   CBB    CBA    OAZ    CAY      179.984   20.000   1
 PEU      var_58   CBA    OAZ    CAY    CAX      179.982   20.000   1
 PEU      var_59   OAZ    CAY    CAX    OAW       65.015   20.000   3
 PEU      var_60   CAY    CAX    OAW    CAV      179.924   20.000   1
 PEU      var_61   CAX    OAW    CAV    CAU      179.994   20.000   1
 PEU      var_62   OAW    CAV    CAU    OAT       65.089   20.000   3
 PEU      var_63   CAV    CAU    OAT    CAS      179.970   20.000   1
 PEU      var_64   CAU    OAT    CAS    CAR      179.966   20.000   1
 PEU      var_65   OAT    CAS    CAR    OAQ       64.990   20.000   3
 PEU      var_66   CAS    CAR    OAQ    CAP      179.979   20.000   1
 PEU      var_67   CAR    OAQ    CAP    CAO     -179.984   20.000   1
 PEU      var_68   OAQ    CAP    CAO    OAN       65.027   20.000   3
 PEU      var_69   CAP    CAO    OAN    CAM     -179.978   20.000   1
 PEU      var_70   CAO    OAN    CAM    CAL     -179.981   20.000   1
 PEU      var_71   OAN    CAM    CAL    OAK       64.971   20.000   3
 PEU      var_72   CAM    CAL    OAK    CAJ      179.987   20.000   1
 PEU      var_73   CAL    OAK    CAJ    CAI      179.970   20.000   1
 PEU      var_74   OAK    CAJ    CAI    OAH       65.046   20.000   3
 PEU      var_75   CAJ    CAI    OAH    CAG      179.952   20.000   1
 PEU      var_76   CAI    OAH    CAG    CAF      179.981   20.000   1
 PEU      var_77   OAH    CAG    CAF    OAE       65.006   20.000   3
 PEU      var_78   CAG    CAF    OAE    CAD     -179.973   20.000   1
 PEU      var_79   CAF    OAE    CAD    CAC     -179.970   20.000   1
 PEU      var_80   OAE    CAD    CAC    OAB       64.953   20.000   3
 PEU      var_81   CAD    CAC    OAB    CAA     -179.956   20.000   1
 PEU      var_82   CAC    OAB    CAA    HAA1    -179.970   20.000   1
# ------------------------------------------------------
`.trim();

monomers["TRS"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TRS      TRS '2-AMINO-2-HYDROXYMETHYL-PROPANE-1,3-' non-polymer        20   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TRS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TRS           O3     O    OH1       0.000      0.000    0.000    0.000
 TRS           HO3    H    H         0.000      0.789    0.169    0.533
 TRS           C3     C    CH2       0.000     -1.101   -0.297    0.861
 TRS           H31    H    H         0.000     -1.284    0.551    1.524
 TRS           H32    H    H         0.000     -0.868   -1.181    1.459
 TRS           C      C    CT        0.000     -2.349   -0.565    0.018
 TRS           N      N    NT3       1.000     -2.103   -1.705   -0.874
 TRS           HN3    H    H         0.000     -1.884   -2.539   -0.307
 TRS           HN2    H    H         0.000     -2.947   -1.882   -1.440
 TRS           HN1    H    H         0.000     -1.308   -1.487   -1.494
 TRS           C2     C    CH2       0.000     -3.529   -0.883    0.940
 TRS           H21    H    H         0.000     -3.768   -0.004    1.541
 TRS           H22    H    H         0.000     -3.261   -1.712    1.599
 TRS           O2     O    OH1       0.000     -4.664   -1.246    0.152
 TRS           HO2    H    H         0.000     -5.409   -1.447    0.734
 TRS           C1     C    CH2       0.000     -2.676    0.675   -0.817
 TRS           H11    H    H         0.000     -3.567    0.484   -1.420
 TRS           H12    H    H         0.000     -1.835    0.902   -1.476
 TRS           O1     O    OH1       0.000     -2.916    1.784    0.051
 TRS           HO1    H    H         0.000     -3.122    2.567   -0.478
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TRS      O3     n/a    C3     START
 TRS      HO3    O3     .      .
 TRS      C3     O3     C      .
 TRS      H31    C3     .      .
 TRS      H32    C3     .      .
 TRS      C      C3     C1     .
 TRS      N      C      HN1    .
 TRS      HN3    N      .      .
 TRS      HN2    N      .      .
 TRS      HN1    N      .      .
 TRS      C2     C      O2     .
 TRS      H21    C2     .      .
 TRS      H22    C2     .      .
 TRS      O2     C2     HO2    .
 TRS      HO2    O2     .      .
 TRS      C1     C      O1     .
 TRS      H11    C1     .      .
 TRS      H12    C1     .      .
 TRS      O1     C1     HO1    .
 TRS      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TRS      C1     C         single      1.524    0.020
 TRS      C2     C         single      1.524    0.020
 TRS      C      C3        single      1.524    0.020
 TRS      N      C         single      1.488    0.020
 TRS      O1     C1        single      1.432    0.020
 TRS      H11    C1        single      1.092    0.020
 TRS      H12    C1        single      1.092    0.020
 TRS      O2     C2        single      1.432    0.020
 TRS      H21    C2        single      1.092    0.020
 TRS      H22    C2        single      1.092    0.020
 TRS      C3     O3        single      1.432    0.020
 TRS      H31    C3        single      1.092    0.020
 TRS      H32    C3        single      1.092    0.020
 TRS      HN1    N         single      1.033    0.020
 TRS      HN2    N         single      1.033    0.020
 TRS      HN3    N         single      1.033    0.020
 TRS      HO1    O1        single      0.967    0.020
 TRS      HO2    O2        single      0.967    0.020
 TRS      HO3    O3        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TRS      HO3    O3     C3      109.470    3.000
 TRS      O3     C3     H31     109.470    3.000
 TRS      O3     C3     H32     109.470    3.000
 TRS      O3     C3     C       109.470    3.000
 TRS      H31    C3     H32     107.900    3.000
 TRS      H31    C3     C       109.470    3.000
 TRS      H32    C3     C       109.470    3.000
 TRS      C3     C      N       110.000    3.000
 TRS      C3     C      C2      111.000    3.000
 TRS      C3     C      C1      111.000    3.000
 TRS      N      C      C2      110.000    3.000
 TRS      N      C      C1      110.000    3.000
 TRS      C2     C      C1      111.000    3.000
 TRS      C      N      HN3     109.470    3.000
 TRS      C      N      HN2     109.470    3.000
 TRS      C      N      HN1     109.470    3.000
 TRS      HN3    N      HN2     109.470    3.000
 TRS      HN3    N      HN1     109.470    3.000
 TRS      HN2    N      HN1     109.470    3.000
 TRS      C      C2     H21     109.470    3.000
 TRS      C      C2     H22     109.470    3.000
 TRS      C      C2     O2      109.470    3.000
 TRS      H21    C2     H22     107.900    3.000
 TRS      H21    C2     O2      109.470    3.000
 TRS      H22    C2     O2      109.470    3.000
 TRS      C2     O2     HO2     109.470    3.000
 TRS      C      C1     H11     109.470    3.000
 TRS      C      C1     H12     109.470    3.000
 TRS      C      C1     O1      109.470    3.000
 TRS      H11    C1     H12     107.900    3.000
 TRS      H11    C1     O1      109.470    3.000
 TRS      H12    C1     O1      109.470    3.000
 TRS      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TRS      var_1    HO3    O3     C3     C       -179.991   20.000   1
 TRS      var_2    O3     C3     C      C1       -60.062   20.000   1
 TRS      var_3    C3     C      N      HN1      -60.007   20.000   1
 TRS      var_4    C3     C      C2     O2      -175.013   20.000   1
 TRS      var_5    C      C2     O2     HO2     -180.000   20.000   1
 TRS      var_6    C3     C      C1     O1       -59.959   20.000   1
 TRS      var_7    C      C1     O1     HO1      179.979   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TRS      chir_01  C      C1     C2     C3        positiv
# ------------------------------------------------------
`.trim();

monomers["TAU"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TAU      TAU '2-AMINOETHANESULFONIC ACID          ' non-polymer        14   7 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TAU
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TAU           O3     O    OS        0.000      0.000    0.000    0.000
 TAU           S      S    ST        0.000     -1.386   -0.094   -0.301
 TAU           O1     O    OS        0.000     -2.081    0.937   -0.988
 TAU           O2     O    OH1       0.000     -1.438   -1.251   -1.287
 TAU           H2     H    H         0.000     -0.995   -1.151   -2.122
 TAU           C2     C    CH2       0.000     -2.335   -0.713    1.114
 TAU           H2C1   H    H         0.000     -1.861   -1.617    1.501
 TAU           H2C2   H    H         0.000     -3.353   -0.947    0.793
 TAU           C1     C    CH2       0.000     -2.375    0.353    2.209
 TAU           H1C1   H    H         0.000     -2.849    1.257    1.818
 TAU           H1C2   H    H         0.000     -1.357    0.586    2.526
 TAU           N1     N    NH2       0.000     -3.145   -0.148    3.355
 TAU           H1N2   H    H         0.000     -3.551   -1.076    3.332
 TAU           H1N1   H    H         0.000     -3.274    0.432    4.176
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TAU      O3     n/a    S      START
 TAU      S      O3     C2     .
 TAU      O1     S      .      .
 TAU      O2     S      H2     .
 TAU      H2     O2     .      .
 TAU      C2     S      C1     .
 TAU      H2C1   C2     .      .
 TAU      H2C2   C2     .      .
 TAU      C1     C2     N1     .
 TAU      H1C1   C1     .      .
 TAU      H1C2   C1     .      .
 TAU      N1     C1     H1N1   .
 TAU      H1N2   N1     .      .
 TAU      H1N1   N1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TAU      C1     C2        single      1.524    0.020
 TAU      N1     C1        single      1.450    0.020
 TAU      H1C1   C1        single      1.092    0.020
 TAU      H1C2   C1        single      1.092    0.020
 TAU      C2     S         single      1.662    0.020
 TAU      H2C1   C2        single      1.092    0.020
 TAU      H2C2   C2        single      1.092    0.020
 TAU      H1N1   N1        single      1.010    0.020
 TAU      H1N2   N1        single      1.010    0.020
 TAU      O1     S         double      1.436    0.020
 TAU      O2     S         single      1.635    0.020
 TAU      S      O3        double      1.436    0.020
 TAU      H2     O2        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TAU      O3     S      O1      109.500    3.000
 TAU      O3     S      O2      109.500    3.000
 TAU      O3     S      C2      109.500    3.000
 TAU      O1     S      O2      109.500    3.000
 TAU      O1     S      C2      109.500    3.000
 TAU      O2     S      C2      109.500    3.000
 TAU      S      O2     H2      120.000    3.000
 TAU      S      C2     H2C1    109.500    3.000
 TAU      S      C2     H2C2    109.500    3.000
 TAU      S      C2     C1      109.500    3.000
 TAU      H2C1   C2     H2C2    107.900    3.000
 TAU      H2C1   C2     C1      109.470    3.000
 TAU      H2C2   C2     C1      109.470    3.000
 TAU      C2     C1     H1C1    109.470    3.000
 TAU      C2     C1     H1C2    109.470    3.000
 TAU      C2     C1     N1      109.470    3.000
 TAU      H1C1   C1     H1C2    107.900    3.000
 TAU      H1C1   C1     N1      109.470    3.000
 TAU      H1C2   C1     N1      109.470    3.000
 TAU      C1     N1     H1N2    120.000    3.000
 TAU      C1     N1     H1N1    120.000    3.000
 TAU      H1N2   N1     H1N1    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TAU      var_1    O3     S      O2     H2       -63.816   20.000   1
 TAU      var_2    O3     S      C2     C1        70.311   20.000   1
 TAU      var_3    S      C2     C1     N1       179.987   20.000   3
 TAU      var_4    C2     C1     N1     H1N1    -179.981   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TAU      chir_01  S      C2     O1     O2        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TAU      plan-1    N1        0.020
 TAU      plan-1    C1        0.000
 TAU      plan-1    H1N1      0.000
 TAU      plan-1    H1N2      0.000
# ------------------------------------------------------
`.trim();

monomers["SBT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SBT      SBT '2-BUTANOL                           ' non-polymer        15   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SBT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SBT           OH     O    OH1       0.000      0.000    0.000    0.000
 SBT           HO     H    H         0.000      0.234    0.937    0.048
 SBT           C2     C    CH1       0.000     -0.862   -0.331    1.089
 SBT           H2     H    H         0.000     -1.129   -1.395    1.034
 SBT           C1     C    CH3       0.000     -0.144   -0.053    2.411
 SBT           H13    H    H         0.000      0.735   -0.641    2.467
 SBT           H12    H    H         0.000      0.115    0.973    2.465
 SBT           H11    H    H         0.000     -0.783   -0.297    3.220
 SBT           C3     C    CH2       0.000     -2.132    0.517    1.010
 SBT           H31    H    H         0.000     -1.867    1.575    1.067
 SBT           H32    H    H         0.000     -2.790    0.263    1.844
 SBT           C4     C    CH3       0.000     -2.850    0.239   -0.312
 SBT           H43    H    H         0.000     -2.213    0.485   -1.123
 SBT           H42    H    H         0.000     -3.108   -0.788   -0.369
 SBT           H41    H    H         0.000     -3.732    0.825   -0.369
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SBT      OH     n/a    C2     START
 SBT      HO     OH     .      .
 SBT      C2     OH     C3     .
 SBT      H2     C2     .      .
 SBT      C1     C2     H11    .
 SBT      H13    C1     .      .
 SBT      H12    C1     .      .
 SBT      H11    C1     .      .
 SBT      C3     C2     C4     .
 SBT      H31    C3     .      .
 SBT      H32    C3     .      .
 SBT      C4     C3     H41    .
 SBT      H43    C4     .      .
 SBT      H42    C4     .      .
 SBT      H41    C4     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SBT      C1     C2        single      1.524    0.020
 SBT      H11    C1        single      1.059    0.020
 SBT      H12    C1        single      1.059    0.020
 SBT      H13    C1        single      1.059    0.020
 SBT      C3     C2        single      1.524    0.020
 SBT      C2     OH        single      1.432    0.020
 SBT      H2     C2        single      1.099    0.020
 SBT      C4     C3        single      1.513    0.020
 SBT      H31    C3        single      1.092    0.020
 SBT      H32    C3        single      1.092    0.020
 SBT      H41    C4        single      1.059    0.020
 SBT      H42    C4        single      1.059    0.020
 SBT      H43    C4        single      1.059    0.020
 SBT      HO     OH        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SBT      HO     OH     C2      109.470    3.000
 SBT      OH     C2     H2      109.470    3.000
 SBT      OH     C2     C1      109.470    3.000
 SBT      OH     C2     C3      109.470    3.000
 SBT      H2     C2     C1      108.340    3.000
 SBT      H2     C2     C3      108.340    3.000
 SBT      C1     C2     C3      111.000    3.000
 SBT      C2     C1     H13     109.470    3.000
 SBT      C2     C1     H12     109.470    3.000
 SBT      C2     C1     H11     109.470    3.000
 SBT      H13    C1     H12     109.470    3.000
 SBT      H13    C1     H11     109.470    3.000
 SBT      H12    C1     H11     109.470    3.000
 SBT      C2     C3     H31     109.470    3.000
 SBT      C2     C3     H32     109.470    3.000
 SBT      C2     C3     C4      111.000    3.000
 SBT      H31    C3     H32     107.900    3.000
 SBT      H31    C3     C4      109.470    3.000
 SBT      H32    C3     C4      109.470    3.000
 SBT      C3     C4     H43     109.470    3.000
 SBT      C3     C4     H42     109.470    3.000
 SBT      C3     C4     H41     109.470    3.000
 SBT      H43    C4     H42     109.470    3.000
 SBT      H43    C4     H41     109.470    3.000
 SBT      H42    C4     H41     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 SBT      var_1    HO     OH     C2     C3        60.023   20.000   1
 SBT      var_2    OH     C2     C1     H11      179.975   20.000   3
 SBT      var_3    OH     C2     C3     C4        59.933   20.000   3
 SBT      var_4    C2     C3     C4     H41      179.981   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 SBT      chir_01  C2     C1     C3     OH        negativ
# ------------------------------------------------------
`.trim();

monomers["SAL"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SAL      SAL '2-HYDROXYBENZOIC ACID               ' non-polymer        15  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SAL
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SAL           "O2'"  O    OC       -0.500      0.000    0.000    0.000
 SAL           "C1'"  C    C         0.000     -1.216    0.010    0.296
 SAL           "O1'"  O    OC       -0.500     -1.566    0.022    1.496
 SAL           C1     C    CR6       0.000     -2.234    0.007   -0.770
 SAL           C6     C    CR16      0.000     -1.845   -0.006   -2.113
 SAL           H6     H    H         0.000     -0.794   -0.014   -2.373
 SAL           C5     C    CR16      0.000     -2.802   -0.009   -3.104
 SAL           H5     H    H         0.000     -2.500   -0.020   -4.144
 SAL           C4     C    CR16      0.000     -4.148    0.001   -2.776
 SAL           H4     H    H         0.000     -4.893   -0.002   -3.562
 SAL           C3     C    CR16      0.000     -4.545    0.016   -1.454
 SAL           H3     H    H         0.000     -5.599    0.030   -1.206
 SAL           C2     C    CR6       0.000     -3.596    0.011   -0.444
 SAL           O2     O    OH1       0.000     -3.985    0.026    0.855
 SAL           HO2    H    H         0.000     -4.088   -0.883    1.170
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SAL      "O2'"  n/a    "C1'"  START
 SAL      "C1'"  "O2'"  C1     .
 SAL      "O1'"  "C1'"  .      .
 SAL      C1     "C1'"  C6     .
 SAL      C6     C1     C5     .
 SAL      H6     C6     .      .
 SAL      C5     C6     C4     .
 SAL      H5     C5     .      .
 SAL      C4     C5     C3     .
 SAL      H4     C4     .      .
 SAL      C3     C4     C2     .
 SAL      H3     C3     .      .
 SAL      C2     C3     O2     .
 SAL      O2     C2     HO2    .
 SAL      HO2    O2     .      END
 SAL      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SAL      "O1'"  "C1'"     deloc       1.250    0.020
 SAL      "C1'"  "O2'"     deloc       1.250    0.020
 SAL      C1     "C1'"     single      1.500    0.020
 SAL      C1     C2        single      1.487    0.020
 SAL      C6     C1        double      1.390    0.020
 SAL      C2     C3        double      1.390    0.020
 SAL      O2     C2        single      1.362    0.020
 SAL      C3     C4        single      1.390    0.020
 SAL      H3     C3        single      1.083    0.020
 SAL      C4     C5        double      1.390    0.020
 SAL      H4     C4        single      1.083    0.020
 SAL      C5     C6        single      1.390    0.020
 SAL      H5     C5        single      1.083    0.020
 SAL      H6     C6        single      1.083    0.020
 SAL      HO2    O2        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SAL      "O2'"  "C1'"  "O1'"   123.000    3.000
 SAL      "O2'"  "C1'"  C1      120.000    3.000
 SAL      "O1'"  "C1'"  C1      120.000    3.000
 SAL      "C1'"  C1     C6      120.000    3.000
 SAL      "C1'"  C1     C2      120.000    3.000
 SAL      C6     C1     C2      120.000    3.000
 SAL      C1     C6     H6      120.000    3.000
 SAL      C1     C6     C5      120.000    3.000
 SAL      H6     C6     C5      120.000    3.000
 SAL      C6     C5     H5      120.000    3.000
 SAL      C6     C5     C4      120.000    3.000
 SAL      H5     C5     C4      120.000    3.000
 SAL      C5     C4     H4      120.000    3.000
 SAL      C5     C4     C3      120.000    3.000
 SAL      H4     C4     C3      120.000    3.000
 SAL      C4     C3     H3      120.000    3.000
 SAL      C4     C3     C2      120.000    3.000
 SAL      H3     C3     C2      120.000    3.000
 SAL      C3     C2     O2      120.000    3.000
 SAL      C3     C2     C1      120.000    3.000
 SAL      O2     C2     C1      120.000    3.000
 SAL      C2     O2     HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 SAL      var_1    "O2'"  "C1'"  C1     C6        -0.021   20.000   1
 SAL      CONST_1  "C1'"  C1     C2     C3       180.000    0.000   0
 SAL      CONST_2  "C1'"  C1     C6     C5       180.000    0.000   0
 SAL      CONST_3  C1     C6     C5     C4         0.000    0.000   0
 SAL      CONST_4  C6     C5     C4     C3         0.000    0.000   0
 SAL      CONST_5  C5     C4     C3     C2         0.000    0.000   0
 SAL      CONST_6  C4     C3     C2     O2       180.000    0.000   0
 SAL      var_2    C3     C2     O2     HO2       90.024   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 SAL      plan-1    "C1'"     0.020
 SAL      plan-1    "O1'"     0.020
 SAL      plan-1    "O2'"     0.020
 SAL      plan-1    C1        0.020
 SAL      plan-2    C1        0.020
 SAL      plan-2    "C1'"     0.020
 SAL      plan-2    C2        0.020
 SAL      plan-2    C6        0.020
 SAL      plan-2    C3        0.020
 SAL      plan-2    C4        0.020
 SAL      plan-2    C5        0.020
 SAL      plan-2    O2        0.020
 SAL      plan-2    H3        0.020
 SAL      plan-2    H4        0.020
 SAL      plan-2    H5        0.020
 SAL      plan-2    H6        0.020
# ------------------------------------------------------
`.trim();

monomers["MPD"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MPD      MPD '(4S)-2-METHYL-2,4-PENTANEDIOL       ' non-polymer        22   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MPD
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MPD           O4     O    OH1       0.000      0.000    0.000    0.000
 MPD           HO4    H    H         0.000      0.192    0.092    0.943
 MPD           C4     C    CH1       0.000     -0.739   -1.204   -0.220
 MPD           H4     H    H         0.000     -0.957   -1.309   -1.292
 MPD           C5     C    CH3       0.000      0.086   -2.402    0.253
 MPD           H53    H    H         0.000      0.996   -2.442   -0.289
 MPD           H52    H    H         0.000      0.297   -2.301    1.287
 MPD           H51    H    H         0.000     -0.460   -3.295    0.091
 MPD           C3     C    CH2       0.000     -2.052   -1.147    0.565
 MPD           H31    H    H         0.000     -1.838   -0.954    1.618
 MPD           H32    H    H         0.000     -2.574   -2.101    0.470
 MPD           C2     C    CT        0.000     -2.930   -0.025    0.007
 MPD           CM     C    CH3       0.000     -4.242    0.033    0.791
 MPD           HM3    H    H         0.000     -4.036    0.220    1.813
 MPD           HM2    H    H         0.000     -4.851    0.809    0.406
 MPD           HM1    H    H         0.000     -4.751   -0.892    0.699
 MPD           O2     O    OH1       0.000     -2.245    1.224    0.133
 MPD           HO2    H    H         0.000     -2.056    1.395    1.065
 MPD           C1     C    CH3       0.000     -3.229   -0.296   -1.468
 MPD           H13    H    H         0.000     -3.737   -1.221   -1.563
 MPD           H12    H    H         0.000     -3.837    0.481   -1.855
 MPD           H11    H    H         0.000     -2.321   -0.336   -2.012
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MPD      O4     n/a    C4     START
 MPD      HO4    O4     .      .
 MPD      C4     O4     C3     .
 MPD      H4     C4     .      .
 MPD      C5     C4     H51    .
 MPD      H53    C5     .      .
 MPD      H52    C5     .      .
 MPD      H51    C5     .      .
 MPD      C3     C4     C2     .
 MPD      H31    C3     .      .
 MPD      H32    C3     .      .
 MPD      C2     C3     C1     .
 MPD      CM     C2     HM1    .
 MPD      HM3    CM     .      .
 MPD      HM2    CM     .      .
 MPD      HM1    CM     .      .
 MPD      O2     C2     HO2    .
 MPD      HO2    O2     .      .
 MPD      C1     C2     H11    .
 MPD      H13    C1     .      .
 MPD      H12    C1     .      .
 MPD      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MPD      C1     C2        single      1.524    0.020
 MPD      H11    C1        single      1.059    0.020
 MPD      H12    C1        single      1.059    0.020
 MPD      H13    C1        single      1.059    0.020
 MPD      O2     C2        single      1.432    0.020
 MPD      CM     C2        single      1.524    0.020
 MPD      C2     C3        single      1.524    0.020
 MPD      HO2    O2        single      0.967    0.020
 MPD      HM1    CM        single      1.059    0.020
 MPD      HM2    CM        single      1.059    0.020
 MPD      HM3    CM        single      1.059    0.020
 MPD      C3     C4        single      1.524    0.020
 MPD      H31    C3        single      1.092    0.020
 MPD      H32    C3        single      1.092    0.020
 MPD      C4     O4        single      1.432    0.020
 MPD      C5     C4        single      1.524    0.020
 MPD      H4     C4        single      1.099    0.020
 MPD      HO4    O4        single      0.967    0.020
 MPD      H51    C5        single      1.059    0.020
 MPD      H52    C5        single      1.059    0.020
 MPD      H53    C5        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MPD      HO4    O4     C4      109.470    3.000
 MPD      O4     C4     H4      109.470    3.000
 MPD      O4     C4     C5      109.470    3.000
 MPD      O4     C4     C3      109.470    3.000
 MPD      H4     C4     C5      108.340    3.000
 MPD      H4     C4     C3      108.340    3.000
 MPD      C5     C4     C3      111.000    3.000
 MPD      C4     C5     H53     109.470    3.000
 MPD      C4     C5     H52     109.470    3.000
 MPD      C4     C5     H51     109.470    3.000
 MPD      H53    C5     H52     109.470    3.000
 MPD      H53    C5     H51     109.470    3.000
 MPD      H52    C5     H51     109.470    3.000
 MPD      C4     C3     H31     109.470    3.000
 MPD      C4     C3     H32     109.470    3.000
 MPD      C4     C3     C2      111.000    3.000
 MPD      H31    C3     H32     107.900    3.000
 MPD      H31    C3     C2      109.470    3.000
 MPD      H32    C3     C2      109.470    3.000
 MPD      C3     C2     CM      111.000    3.000
 MPD      C3     C2     O2      109.470    3.000
 MPD      C3     C2     C1      111.000    3.000
 MPD      CM     C2     O2      109.470    3.000
 MPD      CM     C2     C1      111.000    3.000
 MPD      O2     C2     C1      109.470    3.000
 MPD      C2     CM     HM3     109.470    3.000
 MPD      C2     CM     HM2     109.470    3.000
 MPD      C2     CM     HM1     109.470    3.000
 MPD      HM3    CM     HM2     109.470    3.000
 MPD      HM3    CM     HM1     109.470    3.000
 MPD      HM2    CM     HM1     109.470    3.000
 MPD      C2     O2     HO2     109.470    3.000
 MPD      C2     C1     H13     109.470    3.000
 MPD      C2     C1     H12     109.470    3.000
 MPD      C2     C1     H11     109.470    3.000
 MPD      H13    C1     H12     109.470    3.000
 MPD      H13    C1     H11     109.470    3.000
 MPD      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MPD      var_1    HO4    O4     C4     C3        60.015   20.000   1
 MPD      var_2    O4     C4     C5     H51     -179.988   20.000   3
 MPD      var_3    O4     C4     C3     C2        65.015   20.000   3
 MPD      var_4    C4     C3     C2     C1        59.994   20.000   1
 MPD      var_5    C3     C2     CM     HM1      -60.020   20.000   1
 MPD      var_6    C3     C2     O2     HO2      -59.958   20.000   1
 MPD      var_7    C3     C2     C1     H11      -59.987   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MPD      chir_01  C2     C1     O2     CM        both
 MPD      chir_02  C4     C3     O4     C5        both
# ------------------------------------------------------
`.trim();

monomers["IPA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
IPA      IPA 'ISOPROPYL ALCOHOL                   ' non-polymer        12   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_IPA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 IPA           O2     O    OH1       0.000      0.000    0.000    0.000
 IPA           HO2    H    H         0.000     -0.302   -0.908    0.138
 IPA           C2     C    CH1       0.000     -0.957    0.704   -0.793
 IPA           H2     H    H         0.000     -1.067    0.202   -1.764
 IPA           C3     C    CH3       0.000     -0.481    2.141   -1.012
 IPA           H33    H    H         0.000      0.453    2.132   -1.512
 IPA           H32    H    H         0.000     -1.190    2.663   -1.601
 IPA           H31    H    H         0.000     -0.375    2.626   -0.076
 IPA           C1     C    CH3       0.000     -2.306    0.718   -0.071
 IPA           H13    H    H         0.000     -2.637   -0.277    0.081
 IPA           H12    H    H         0.000     -2.202    1.201    0.866
 IPA           H11    H    H         0.000     -3.017    1.239   -0.658
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 IPA      O2     n/a    C2     START
 IPA      HO2    O2     .      .
 IPA      C2     O2     C1     .
 IPA      H2     C2     .      .
 IPA      C3     C2     H31    .
 IPA      H33    C3     .      .
 IPA      H32    C3     .      .
 IPA      H31    C3     .      .
 IPA      C1     C2     H11    .
 IPA      H13    C1     .      .
 IPA      H12    C1     .      .
 IPA      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 IPA      C1     C2        single      1.524    0.020
 IPA      H11    C1        single      1.059    0.020
 IPA      H12    C1        single      1.059    0.020
 IPA      H13    C1        single      1.059    0.020
 IPA      C3     C2        single      1.524    0.020
 IPA      C2     O2        single      1.432    0.020
 IPA      H2     C2        single      1.099    0.020
 IPA      H31    C3        single      1.059    0.020
 IPA      H32    C3        single      1.059    0.020
 IPA      H33    C3        single      1.059    0.020
 IPA      HO2    O2        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 IPA      HO2    O2     C2      109.470    3.000
 IPA      O2     C2     H2      109.470    3.000
 IPA      O2     C2     C3      109.470    3.000
 IPA      O2     C2     C1      109.470    3.000
 IPA      H2     C2     C3      108.340    3.000
 IPA      H2     C2     C1      108.340    3.000
 IPA      C3     C2     C1      111.000    3.000
 IPA      C2     C3     H33     109.470    3.000
 IPA      C2     C3     H32     109.470    3.000
 IPA      C2     C3     H31     109.470    3.000
 IPA      H33    C3     H32     109.470    3.000
 IPA      H33    C3     H31     109.470    3.000
 IPA      H32    C3     H31     109.470    3.000
 IPA      C2     C1     H13     109.470    3.000
 IPA      C2     C1     H12     109.470    3.000
 IPA      C2     C1     H11     109.470    3.000
 IPA      H13    C1     H12     109.470    3.000
 IPA      H13    C1     H11     109.470    3.000
 IPA      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 IPA      var_1    HO2    O2     C2     C1        59.960   20.000   1
 IPA      var_2    O2     C2     C3     H31      -60.020   20.000   3
 IPA      var_3    O2     C2     C1     H11     -179.990   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 IPA      chir_01  C2     C1     C3     O2        negativ
# ------------------------------------------------------
`.trim();

monomers["BU2"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BU2      BU2 '1,3-BUTANEDIOL                      ' non-polymer        16   6 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BU2
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BU2           O3     O    OH1       0.000      0.000    0.000    0.000
 BU2           HO3    H    H         0.000      0.032    0.965    0.041
 BU2           C3     C    CH1       0.000     -1.272   -0.453    0.464
 BU2           HC3    H    H         0.000     -1.309   -1.551    0.417
 BU2           C4     C    CH3       0.000     -1.479    0.002    1.910
 BU2           HC43   H    H         0.000     -1.444    1.060    1.957
 BU2           HC42   H    H         0.000     -2.422   -0.334    2.256
 BU2           HC41   H    H         0.000     -0.714   -0.402    2.522
 BU2           C2     C    CH2       0.000     -2.376    0.132   -0.417
 BU2           HC21   H    H         0.000     -2.339    1.223   -0.369
 BU2           HC22   H    H         0.000     -3.348   -0.214   -0.060
 BU2           C1     C    CH2       0.000     -2.169   -0.323   -1.863
 BU2           HC11   H    H         0.000     -2.205   -1.414   -1.908
 BU2           HC12   H    H         0.000     -1.196    0.023   -2.217
 BU2           O1     O    OH1       0.000     -3.200    0.223   -2.687
 BU2           HO1    H    H         0.000     -3.068   -0.066   -3.600
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BU2      O3     n/a    C3     START
 BU2      HO3    O3     .      .
 BU2      C3     O3     C2     .
 BU2      HC3    C3     .      .
 BU2      C4     C3     HC41   .
 BU2      HC43   C4     .      .
 BU2      HC42   C4     .      .
 BU2      HC41   C4     .      .
 BU2      C2     C3     C1     .
 BU2      HC21   C2     .      .
 BU2      HC22   C2     .      .
 BU2      C1     C2     O1     .
 BU2      HC11   C1     .      .
 BU2      HC12   C1     .      .
 BU2      O1     C1     HO1    .
 BU2      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BU2      O1     C1        single      1.432    0.020
 BU2      C1     C2        single      1.524    0.020
 BU2      HC11   C1        single      1.092    0.020
 BU2      HC12   C1        single      1.092    0.020
 BU2      HO1    O1        single      0.967    0.020
 BU2      C2     C3        single      1.524    0.020
 BU2      HC21   C2        single      1.092    0.020
 BU2      HC22   C2        single      1.092    0.020
 BU2      C3     O3        single      1.432    0.020
 BU2      C4     C3        single      1.524    0.020
 BU2      HC3    C3        single      1.099    0.020
 BU2      HO3    O3        single      0.967    0.020
 BU2      HC41   C4        single      1.059    0.020
 BU2      HC42   C4        single      1.059    0.020
 BU2      HC43   C4        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BU2      HO3    O3     C3      109.470    3.000
 BU2      O3     C3     HC3     109.470    3.000
 BU2      O3     C3     C4      109.470    3.000
 BU2      O3     C3     C2      109.470    3.000
 BU2      HC3    C3     C4      108.340    3.000
 BU2      HC3    C3     C2      108.340    3.000
 BU2      C4     C3     C2      111.000    3.000
 BU2      C3     C4     HC43    109.470    3.000
 BU2      C3     C4     HC42    109.470    3.000
 BU2      C3     C4     HC41    109.470    3.000
 BU2      HC43   C4     HC42    109.470    3.000
 BU2      HC43   C4     HC41    109.470    3.000
 BU2      HC42   C4     HC41    109.470    3.000
 BU2      C3     C2     HC21    109.470    3.000
 BU2      C3     C2     HC22    109.470    3.000
 BU2      C3     C2     C1      111.000    3.000
 BU2      HC21   C2     HC22    107.900    3.000
 BU2      HC21   C2     C1      109.470    3.000
 BU2      HC22   C2     C1      109.470    3.000
 BU2      C2     C1     HC11    109.470    3.000
 BU2      C2     C1     HC12    109.470    3.000
 BU2      C2     C1     O1      109.470    3.000
 BU2      HC11   C1     HC12    107.900    3.000
 BU2      HC11   C1     O1      109.470    3.000
 BU2      HC12   C1     O1      109.470    3.000
 BU2      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BU2      var_1    HO3    O3     C3     C2        59.963   20.000   1
 BU2      var_2    O3     C3     C4     HC41     -59.943   20.000   3
 BU2      var_3    O3     C3     C2     C1        60.003   20.000   3
 BU2      var_4    C3     C2     C1     O1       180.000   20.000   3
 BU2      var_5    C2     C1     O1     HO1      179.980   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BU2      chir_01  C3     C2     O3     C4        negativ
# ------------------------------------------------------
`.trim();

monomers["B3P"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
B3P      B3P '2-[3-(2-HYDROXY-1,1-DIHYDROXYMETHYL-' non-polymer        45  19 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_B3P
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 B3P           O6     O    OH1       0.000      0.000    0.000    0.000
 B3P           HO6    H    H         0.000      0.306   -0.443   -0.803
 B3P           C7     C    CH2       0.000     -0.471   -0.975    0.930
 B3P           H71    H    H         0.000      0.340   -1.663    1.178
 B3P           H72    H    H         0.000     -1.297   -1.534    0.484
 B3P           C4     C    CT        0.000     -0.955   -0.276    2.202
 B3P           C5     C    CH2       0.000      0.203    0.505    2.826
 B3P           H51    H    H         0.000      0.565    1.250    2.115
 B3P           H52    H    H         0.000      1.014   -0.184    3.074
 B3P           O4     O    OH1       0.000     -0.248    1.157    4.014
 B3P           HO4    H    H         0.000      0.484    1.651    4.407
 B3P           C6     C    CH2       0.000     -1.460   -1.321    3.198
 B3P           H61    H    H         0.000     -0.649   -2.009    3.446
 B3P           H62    H    H         0.000     -2.286   -1.880    2.752
 B3P           O5     O    OH1       0.000     -1.913   -0.667    4.386
 B3P           HO5    H    H         0.000     -2.231   -1.328    5.015
 B3P           N1     N    NH1       0.000     -2.046    0.649    1.867
 B3P           HN1    H    H         0.000     -2.055    1.648    2.015
 B3P           C3     C    CH2       0.000     -3.120   -0.159    1.276
 B3P           H31    H    H         0.000     -3.452   -0.907    2.000
 B3P           H32    H    H         0.000     -2.746   -0.662    0.382
 B3P           C1     C    CH2       0.000     -4.293    0.747    0.902
 B3P           H11    H    H         0.000     -3.959    1.494    0.179
 B3P           H12    H    H         0.000     -4.665    1.249    1.797
 B3P           C2     C    CH2       0.000     -5.412   -0.096    0.286
 B3P           H21    H    H         0.000     -5.744   -0.843    1.010
 B3P           H22    H    H         0.000     -5.038   -0.598   -0.608
 B3P           N2     N    NH1       0.000     -6.539    0.774   -0.073
 B3P           HN2    H    H         0.000     -6.593    1.774    0.055
 B3P           C8     C    CT        0.000     -7.572   -0.092   -0.656
 B3P           C11    C    CH2       0.000     -7.011   -0.794   -1.894
 B3P           H111   H    H         0.000     -7.780   -1.438   -2.326
 B3P           H112   H    H         0.000     -6.149   -1.399   -1.609
 B3P           O3     O    OH1       0.000     -6.611    0.184   -2.855
 B3P           HO3    H    H         0.000     -6.257   -0.261   -3.637
 B3P           C10    C    CH2       0.000     -8.000   -1.139    0.374
 B3P           H101   H    H         0.000     -7.137   -1.745    0.657
 B3P           H102   H    H         0.000     -8.768   -1.783   -0.061
 B3P           O2     O    OH1       0.000     -8.524   -0.483    1.530
 B3P           HO2    H    H         0.000     -8.795   -1.146    2.181
 B3P           C9     C    CH2       0.000     -8.783    0.754   -1.055
 B3P           H91    H    H         0.000     -9.550    0.109   -1.488
 B3P           H92    H    H         0.000     -8.478    1.501   -1.791
 B3P           O1     O    OH1       0.000     -9.308    1.409    0.101
 B3P           HO1    H    H         0.000    -10.072    1.945   -0.152
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 B3P      O6     n/a    C7     START
 B3P      HO6    O6     .      .
 B3P      C7     O6     C4     .
 B3P      H71    C7     .      .
 B3P      H72    C7     .      .
 B3P      C4     C7     N1     .
 B3P      C5     C4     O4     .
 B3P      H51    C5     .      .
 B3P      H52    C5     .      .
 B3P      O4     C5     HO4    .
 B3P      HO4    O4     .      .
 B3P      C6     C4     O5     .
 B3P      H61    C6     .      .
 B3P      H62    C6     .      .
 B3P      O5     C6     HO5    .
 B3P      HO5    O5     .      .
 B3P      N1     C4     C3     .
 B3P      HN1    N1     .      .
 B3P      C3     N1     C1     .
 B3P      H31    C3     .      .
 B3P      H32    C3     .      .
 B3P      C1     C3     C2     .
 B3P      H11    C1     .      .
 B3P      H12    C1     .      .
 B3P      C2     C1     N2     .
 B3P      H21    C2     .      .
 B3P      H22    C2     .      .
 B3P      N2     C2     C8     .
 B3P      HN2    N2     .      .
 B3P      C8     N2     C9     .
 B3P      C11    C8     O3     .
 B3P      H111   C11    .      .
 B3P      H112   C11    .      .
 B3P      O3     C11    HO3    .
 B3P      HO3    O3     .      .
 B3P      C10    C8     O2     .
 B3P      H101   C10    .      .
 B3P      H102   C10    .      .
 B3P      O2     C10    HO2    .
 B3P      HO2    O2     .      .
 B3P      C9     C8     O1     .
 B3P      H91    C9     .      .
 B3P      H92    C9     .      .
 B3P      O1     C9     HO1    .
 B3P      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 B3P      C2     C1        single      1.524    0.020
 B3P      C1     C3        single      1.524    0.020
 B3P      H11    C1        single      1.092    0.020
 B3P      H12    C1        single      1.092    0.020
 B3P      N2     C2        single      1.450    0.020
 B3P      H21    C2        single      1.092    0.020
 B3P      H22    C2        single      1.092    0.020
 B3P      C3     N1        single      1.450    0.020
 B3P      H31    C3        single      1.092    0.020
 B3P      H32    C3        single      1.092    0.020
 B3P      N1     C4        single      1.450    0.020
 B3P      HN1    N1        single      1.010    0.020
 B3P      C5     C4        single      1.524    0.020
 B3P      C6     C4        single      1.524    0.020
 B3P      C4     C7        single      1.524    0.020
 B3P      O4     C5        single      1.432    0.020
 B3P      H51    C5        single      1.092    0.020
 B3P      H52    C5        single      1.092    0.020
 B3P      O5     C6        single      1.432    0.020
 B3P      H61    C6        single      1.092    0.020
 B3P      H62    C6        single      1.092    0.020
 B3P      C7     O6        single      1.432    0.020
 B3P      H71    C7        single      1.092    0.020
 B3P      H72    C7        single      1.092    0.020
 B3P      C8     N2        single      1.450    0.020
 B3P      HN2    N2        single      1.010    0.020
 B3P      C9     C8        single      1.524    0.020
 B3P      C10    C8        single      1.524    0.020
 B3P      C11    C8        single      1.524    0.020
 B3P      O1     C9        single      1.432    0.020
 B3P      H91    C9        single      1.092    0.020
 B3P      H92    C9        single      1.092    0.020
 B3P      O2     C10       single      1.432    0.020
 B3P      H101   C10       single      1.092    0.020
 B3P      H102   C10       single      1.092    0.020
 B3P      O3     C11       single      1.432    0.020
 B3P      H111   C11       single      1.092    0.020
 B3P      H112   C11       single      1.092    0.020
 B3P      HO1    O1        single      0.967    0.020
 B3P      HO2    O2        single      0.967    0.020
 B3P      HO3    O3        single      0.967    0.020
 B3P      HO4    O4        single      0.967    0.020
 B3P      HO5    O5        single      0.967    0.020
 B3P      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 B3P      HO6    O6     C7      109.470    3.000
 B3P      O6     C7     H71     109.470    3.000
 B3P      O6     C7     H72     109.470    3.000
 B3P      O6     C7     C4      109.470    3.000
 B3P      H71    C7     H72     107.900    3.000
 B3P      H71    C7     C4      109.470    3.000
 B3P      H72    C7     C4      109.470    3.000
 B3P      C7     C4     C5      111.000    3.000
 B3P      C7     C4     C6      111.000    3.000
 B3P      C7     C4     N1      110.000    3.000
 B3P      C5     C4     C6      111.000    3.000
 B3P      C5     C4     N1      110.000    3.000
 B3P      C6     C4     N1      110.000    3.000
 B3P      C4     C5     H51     109.470    3.000
 B3P      C4     C5     H52     109.470    3.000
 B3P      C4     C5     O4      109.470    3.000
 B3P      H51    C5     H52     107.900    3.000
 B3P      H51    C5     O4      109.470    3.000
 B3P      H52    C5     O4      109.470    3.000
 B3P      C5     O4     HO4     109.470    3.000
 B3P      C4     C6     H61     109.470    3.000
 B3P      C4     C6     H62     109.470    3.000
 B3P      C4     C6     O5      109.470    3.000
 B3P      H61    C6     H62     107.900    3.000
 B3P      H61    C6     O5      109.470    3.000
 B3P      H62    C6     O5      109.470    3.000
 B3P      C6     O5     HO5     109.470    3.000
 B3P      C4     N1     HN1     118.500    3.000
 B3P      C4     N1     C3      120.000    3.000
 B3P      HN1    N1     C3      118.500    3.000
 B3P      N1     C3     H31     109.470    3.000
 B3P      N1     C3     H32     109.470    3.000
 B3P      N1     C3     C1      112.000    3.000
 B3P      H31    C3     H32     107.900    3.000
 B3P      H31    C3     C1      109.470    3.000
 B3P      H32    C3     C1      109.470    3.000
 B3P      C3     C1     H11     109.470    3.000
 B3P      C3     C1     H12     109.470    3.000
 B3P      C3     C1     C2      111.000    3.000
 B3P      H11    C1     H12     107.900    3.000
 B3P      H11    C1     C2      109.470    3.000
 B3P      H12    C1     C2      109.470    3.000
 B3P      C1     C2     H21     109.470    3.000
 B3P      C1     C2     H22     109.470    3.000
 B3P      C1     C2     N2      112.000    3.000
 B3P      H21    C2     H22     107.900    3.000
 B3P      H21    C2     N2      109.470    3.000
 B3P      H22    C2     N2      109.470    3.000
 B3P      C2     N2     HN2     118.500    3.000
 B3P      C2     N2     C8      120.000    3.000
 B3P      HN2    N2     C8      118.500    3.000
 B3P      N2     C8     C11     110.000    3.000
 B3P      N2     C8     C10     110.000    3.000
 B3P      N2     C8     C9      110.000    3.000
 B3P      C11    C8     C10     111.000    3.000
 B3P      C11    C8     C9      111.000    3.000
 B3P      C10    C8     C9      111.000    3.000
 B3P      C8     C11    H111    109.470    3.000
 B3P      C8     C11    H112    109.470    3.000
 B3P      C8     C11    O3      109.470    3.000
 B3P      H111   C11    H112    107.900    3.000
 B3P      H111   C11    O3      109.470    3.000
 B3P      H112   C11    O3      109.470    3.000
 B3P      C11    O3     HO3     109.470    3.000
 B3P      C8     C10    H101    109.470    3.000
 B3P      C8     C10    H102    109.470    3.000
 B3P      C8     C10    O2      109.470    3.000
 B3P      H101   C10    H102    107.900    3.000
 B3P      H101   C10    O2      109.470    3.000
 B3P      H102   C10    O2      109.470    3.000
 B3P      C10    O2     HO2     109.470    3.000
 B3P      C8     C9     H91     109.470    3.000
 B3P      C8     C9     H92     109.470    3.000
 B3P      C8     C9     O1      109.470    3.000
 B3P      H91    C9     H92     107.900    3.000
 B3P      H91    C9     O1      109.470    3.000
 B3P      H92    C9     O1      109.470    3.000
 B3P      C9     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 B3P      var_1    HO6    O6     C7     C4       179.985   20.000   1
 B3P      var_2    O6     C7     C4     N1        59.978   20.000   1
 B3P      var_3    C7     C4     C5     O4      -179.973   20.000   1
 B3P      var_4    C4     C5     O4     HO4     -179.896   20.000   1
 B3P      var_5    C7     C4     C6     O5      -179.990   20.000   1
 B3P      var_6    C4     C6     O5     HO5     -179.984   20.000   1
 B3P      var_7    C7     C4     N1     C3        60.025   20.000   1
 B3P      var_8    C4     N1     C3     C1      -179.966   20.000   3
 B3P      var_9    N1     C3     C1     C2      -179.990   20.000   3
 B3P      var_10   C3     C1     C2     N2       179.990   20.000   3
 B3P      var_11   C1     C2     N2     C8       179.966   20.000   3
 B3P      var_12   C2     N2     C8     C9       179.963   20.000   1
 B3P      var_13   N2     C8     C11    O3       -59.978   20.000   1
 B3P      var_14   C8     C11    O3     HO3     -179.985   20.000   1
 B3P      var_15   N2     C8     C10    O2        59.979   20.000   1
 B3P      var_16   C8     C10    O2     HO2      179.984   20.000   1
 B3P      var_17   N2     C8     C9     O1       -59.994   20.000   1
 B3P      var_18   C8     C9     O1     HO1      179.896   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 B3P      chir_01  C4     N1     C5     C6        negativ
 B3P      chir_02  C8     N2     C9     C10       positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 B3P      plan-1    N1        0.020
 B3P      plan-1    C3        0.020
 B3P      plan-1    C4        0.020
 B3P      plan-1    HN1       0.020
 B3P      plan-2    N2        0.020
 B3P      plan-2    C2        0.020
 B3P      plan-2    C8        0.020
 B3P      plan-2    HN2       0.020
# ------------------------------------------------------
`.trim();

monomers["BTB"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BTB      BTB '2-[BIS-(2-HYDROXY-ETHYL)-AMINO]-2-HY' non-polymer        33  14 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BTB
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BTB           O8     O    OH1       0.000      0.000    0.000    0.000
 BTB           HO8    H    H         0.000      0.625   -0.679   -0.288
 BTB           C8     C    CH2       0.000     -0.739   -0.480    1.126
 BTB           H81    H    H         0.000     -0.051   -0.712    1.941
 BTB           H82    H    H         0.000     -1.286   -1.382    0.844
 BTB           C7     C    CH2       0.000     -1.728    0.595    1.581
 BTB           H71    H    H         0.000     -1.227    1.566    1.598
 BTB           H72    H    H         0.000     -2.088    0.356    2.584
 BTB           N      N    NT        0.000     -2.863    0.644    0.650
 BTB           C5     C    CH2       0.000     -3.543    1.924    0.880
 BTB           H51    H    H         0.000     -2.819    2.738    0.804
 BTB           H52    H    H         0.000     -3.986    1.925    1.878
 BTB           C6     C    CH2       0.000     -4.641    2.115   -0.168
 BTB           H61    H    H         0.000     -4.323    1.668   -1.112
 BTB           H62    H    H         0.000     -4.821    3.182   -0.315
 BTB           O6     O    OH1       0.000     -5.842    1.485    0.280
 BTB           HO6    H    H         0.000     -6.556    1.673   -0.344
 BTB           C2     C    CT        0.000     -3.795   -0.411    1.065
 BTB           C4     C    CH2       0.000     -3.009   -1.664    1.453
 BTB           H41    H    H         0.000     -2.473   -2.042    0.579
 BTB           H42    H    H         0.000     -3.700   -2.429    1.813
 BTB           O4     O    OH1       0.000     -2.074   -1.341    2.484
 BTB           HO4    H    H         0.000     -1.525   -2.114    2.675
 BTB           C3     C    CH2       0.000     -4.741   -0.739   -0.091
 BTB           H31    H    H         0.000     -5.210    0.179   -0.449
 BTB           H32    H    H         0.000     -5.513   -1.429    0.257
 BTB           O3     O    OH1       0.000     -4.002   -1.345   -1.153
 BTB           HO3    H    H         0.000     -4.601   -1.553   -1.883
 BTB           C1     C    CH2       0.000     -4.608    0.072    2.268
 BTB           H11    H    H         0.000     -5.290   -0.719    2.586
 BTB           H12    H    H         0.000     -5.184    0.956    1.986
 BTB           O1     O    OH1       0.000     -3.723    0.400    3.341
 BTB           HO1    H    H         0.000     -4.237    0.706    4.100
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BTB      O8     n/a    C8     START
 BTB      HO8    O8     .      .
 BTB      C8     O8     C7     .
 BTB      H81    C8     .      .
 BTB      H82    C8     .      .
 BTB      C7     C8     N      .
 BTB      H71    C7     .      .
 BTB      H72    C7     .      .
 BTB      N      C7     C2     .
 BTB      C5     N      C6     .
 BTB      H51    C5     .      .
 BTB      H52    C5     .      .
 BTB      C6     C5     O6     .
 BTB      H61    C6     .      .
 BTB      H62    C6     .      .
 BTB      O6     C6     HO6    .
 BTB      HO6    O6     .      .
 BTB      C2     N      C1     .
 BTB      C4     C2     O4     .
 BTB      H41    C4     .      .
 BTB      H42    C4     .      .
 BTB      O4     C4     HO4    .
 BTB      HO4    O4     .      .
 BTB      C3     C2     O3     .
 BTB      H31    C3     .      .
 BTB      H32    C3     .      .
 BTB      O3     C3     HO3    .
 BTB      HO3    O3     .      .
 BTB      C1     C2     O1     .
 BTB      H11    C1     .      .
 BTB      H12    C1     .      .
 BTB      O1     C1     HO1    .
 BTB      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BTB      O1     C1        single      1.432    0.020
 BTB      C1     C2        single      1.524    0.020
 BTB      H11    C1        single      1.092    0.020
 BTB      H12    C1        single      1.092    0.020
 BTB      HO1    O1        single      0.967    0.020
 BTB      C3     C2        single      1.524    0.020
 BTB      C4     C2        single      1.524    0.020
 BTB      C2     N         single      1.472    0.020
 BTB      O3     C3        single      1.432    0.020
 BTB      H31    C3        single      1.092    0.020
 BTB      H32    C3        single      1.092    0.020
 BTB      HO3    O3        single      0.967    0.020
 BTB      O4     C4        single      1.432    0.020
 BTB      H41    C4        single      1.092    0.020
 BTB      H42    C4        single      1.092    0.020
 BTB      HO4    O4        single      0.967    0.020
 BTB      C5     N         single      1.469    0.020
 BTB      N      C7        single      1.469    0.020
 BTB      C6     C5        single      1.524    0.020
 BTB      H51    C5        single      1.092    0.020
 BTB      H52    C5        single      1.092    0.020
 BTB      O6     C6        single      1.432    0.020
 BTB      H61    C6        single      1.092    0.020
 BTB      H62    C6        single      1.092    0.020
 BTB      HO6    O6        single      0.967    0.020
 BTB      C7     C8        single      1.524    0.020
 BTB      H71    C7        single      1.092    0.020
 BTB      H72    C7        single      1.092    0.020
 BTB      C8     O8        single      1.432    0.020
 BTB      H81    C8        single      1.092    0.020
 BTB      H82    C8        single      1.092    0.020
 BTB      HO8    O8        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BTB      HO8    O8     C8      109.470    3.000
 BTB      O8     C8     H81     109.470    3.000
 BTB      O8     C8     H82     109.470    3.000
 BTB      O8     C8     C7      109.470    3.000
 BTB      H81    C8     H82     107.900    3.000
 BTB      H81    C8     C7      109.470    3.000
 BTB      H82    C8     C7      109.470    3.000
 BTB      C8     C7     H71     109.470    3.000
 BTB      C8     C7     H72     109.470    3.000
 BTB      C8     C7     N       109.470    3.000
 BTB      H71    C7     H72     107.900    3.000
 BTB      H71    C7     N       109.470    3.000
 BTB      H72    C7     N       109.470    3.000
 BTB      C7     N      C5      109.470    3.000
 BTB      C7     N      C2      109.500    3.000
 BTB      C5     N      C2      109.500    3.000
 BTB      N      C5     H51     109.470    3.000
 BTB      N      C5     H52     109.470    3.000
 BTB      N      C5     C6      109.470    3.000
 BTB      H51    C5     H52     107.900    3.000
 BTB      H51    C5     C6      109.470    3.000
 BTB      H52    C5     C6      109.470    3.000
 BTB      C5     C6     H61     109.470    3.000
 BTB      C5     C6     H62     109.470    3.000
 BTB      C5     C6     O6      109.470    3.000
 BTB      H61    C6     H62     107.900    3.000
 BTB      H61    C6     O6      109.470    3.000
 BTB      H62    C6     O6      109.470    3.000
 BTB      C6     O6     HO6     109.470    3.000
 BTB      N      C2     C4      109.500    3.000
 BTB      N      C2     C3      109.500    3.000
 BTB      N      C2     C1      109.500    3.000
 BTB      C4     C2     C3      111.000    3.000
 BTB      C4     C2     C1      111.000    3.000
 BTB      C3     C2     C1      111.000    3.000
 BTB      C2     C4     H41     109.470    3.000
 BTB      C2     C4     H42     109.470    3.000
 BTB      C2     C4     O4      109.470    3.000
 BTB      H41    C4     H42     107.900    3.000
 BTB      H41    C4     O4      109.470    3.000
 BTB      H42    C4     O4      109.470    3.000
 BTB      C4     O4     HO4     109.470    3.000
 BTB      C2     C3     H31     109.470    3.000
 BTB      C2     C3     H32     109.470    3.000
 BTB      C2     C3     O3      109.470    3.000
 BTB      H31    C3     H32     107.900    3.000
 BTB      H31    C3     O3      109.470    3.000
 BTB      H32    C3     O3      109.470    3.000
 BTB      C3     O3     HO3     109.470    3.000
 BTB      C2     C1     H11     109.470    3.000
 BTB      C2     C1     H12     109.470    3.000
 BTB      C2     C1     O1      109.470    3.000
 BTB      H11    C1     H12     107.900    3.000
 BTB      H11    C1     O1      109.470    3.000
 BTB      H12    C1     O1      109.470    3.000
 BTB      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BTB      var_1    HO8    O8     C8     C7      -179.999   20.000   1
 BTB      var_2    O8     C8     C7     N         75.555   20.000   3
 BTB      var_3    C8     C7     N      C2        83.200   20.000   1
 BTB      var_4    C7     N      C5     C6       173.461   20.000   1
 BTB      var_5    N      C5     C6     O6        86.295   20.000   3
 BTB      var_6    C5     C6     O6     HO6      174.948   20.000   1
 BTB      var_7    C7     N      C2     C1        78.970   20.000   1
 BTB      var_8    N      C2     C4     O4        56.837   20.000   1
 BTB      var_9    C2     C4     O4     HO4     -175.160   20.000   1
 BTB      var_10   N      C2     C3     O3        67.172   20.000   1
 BTB      var_11   C2     C3     O3     HO3     -179.976   20.000   1
 BTB      var_12   N      C2     C1     O1       -59.036   20.000   1
 BTB      var_13   C2     C1     O1     HO1      179.933   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BTB      chir_01  C2     C1     C3     C4        positiv
 BTB      chir_02  N      C2     C5     C7        negativ
# ------------------------------------------------------
`.trim();

monomers["B3P"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
B3P      B3P '2-[3-(2-HYDROXY-1,1-DIHYDROXYMETHYL-' non-polymer        45  19 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_B3P
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 B3P           O6     O    OH1       0.000      0.000    0.000    0.000
 B3P           HO6    H    H         0.000      0.306   -0.443   -0.803
 B3P           C7     C    CH2       0.000     -0.471   -0.975    0.930
 B3P           H71    H    H         0.000      0.340   -1.663    1.178
 B3P           H72    H    H         0.000     -1.297   -1.534    0.484
 B3P           C4     C    CT        0.000     -0.955   -0.276    2.202
 B3P           C5     C    CH2       0.000      0.203    0.505    2.826
 B3P           H51    H    H         0.000      0.565    1.250    2.115
 B3P           H52    H    H         0.000      1.014   -0.184    3.074
 B3P           O4     O    OH1       0.000     -0.248    1.157    4.014
 B3P           HO4    H    H         0.000      0.484    1.651    4.407
 B3P           C6     C    CH2       0.000     -1.460   -1.321    3.198
 B3P           H61    H    H         0.000     -0.649   -2.009    3.446
 B3P           H62    H    H         0.000     -2.286   -1.880    2.752
 B3P           O5     O    OH1       0.000     -1.913   -0.667    4.386
 B3P           HO5    H    H         0.000     -2.231   -1.328    5.015
 B3P           N1     N    NH1       0.000     -2.046    0.649    1.867
 B3P           HN1    H    H         0.000     -2.055    1.648    2.015
 B3P           C3     C    CH2       0.000     -3.120   -0.159    1.276
 B3P           H31    H    H         0.000     -3.452   -0.907    2.000
 B3P           H32    H    H         0.000     -2.746   -0.662    0.382
 B3P           C1     C    CH2       0.000     -4.293    0.747    0.902
 B3P           H11    H    H         0.000     -3.959    1.494    0.179
 B3P           H12    H    H         0.000     -4.665    1.249    1.797
 B3P           C2     C    CH2       0.000     -5.412   -0.096    0.286
 B3P           H21    H    H         0.000     -5.744   -0.843    1.010
 B3P           H22    H    H         0.000     -5.038   -0.598   -0.608
 B3P           N2     N    NH1       0.000     -6.539    0.774   -0.073
 B3P           HN2    H    H         0.000     -6.593    1.774    0.055
 B3P           C8     C    CT        0.000     -7.572   -0.092   -0.656
 B3P           C11    C    CH2       0.000     -7.011   -0.794   -1.894
 B3P           H111   H    H         0.000     -7.780   -1.438   -2.326
 B3P           H112   H    H         0.000     -6.149   -1.399   -1.609
 B3P           O3     O    OH1       0.000     -6.611    0.184   -2.855
 B3P           HO3    H    H         0.000     -6.257   -0.261   -3.637
 B3P           C10    C    CH2       0.000     -8.000   -1.139    0.374
 B3P           H101   H    H         0.000     -7.137   -1.745    0.657
 B3P           H102   H    H         0.000     -8.768   -1.783   -0.061
 B3P           O2     O    OH1       0.000     -8.524   -0.483    1.530
 B3P           HO2    H    H         0.000     -8.795   -1.146    2.181
 B3P           C9     C    CH2       0.000     -8.783    0.754   -1.055
 B3P           H91    H    H         0.000     -9.550    0.109   -1.488
 B3P           H92    H    H         0.000     -8.478    1.501   -1.791
 B3P           O1     O    OH1       0.000     -9.308    1.409    0.101
 B3P           HO1    H    H         0.000    -10.072    1.945   -0.152
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 B3P      O6     n/a    C7     START
 B3P      HO6    O6     .      .
 B3P      C7     O6     C4     .
 B3P      H71    C7     .      .
 B3P      H72    C7     .      .
 B3P      C4     C7     N1     .
 B3P      C5     C4     O4     .
 B3P      H51    C5     .      .
 B3P      H52    C5     .      .
 B3P      O4     C5     HO4    .
 B3P      HO4    O4     .      .
 B3P      C6     C4     O5     .
 B3P      H61    C6     .      .
 B3P      H62    C6     .      .
 B3P      O5     C6     HO5    .
 B3P      HO5    O5     .      .
 B3P      N1     C4     C3     .
 B3P      HN1    N1     .      .
 B3P      C3     N1     C1     .
 B3P      H31    C3     .      .
 B3P      H32    C3     .      .
 B3P      C1     C3     C2     .
 B3P      H11    C1     .      .
 B3P      H12    C1     .      .
 B3P      C2     C1     N2     .
 B3P      H21    C2     .      .
 B3P      H22    C2     .      .
 B3P      N2     C2     C8     .
 B3P      HN2    N2     .      .
 B3P      C8     N2     C9     .
 B3P      C11    C8     O3     .
 B3P      H111   C11    .      .
 B3P      H112   C11    .      .
 B3P      O3     C11    HO3    .
 B3P      HO3    O3     .      .
 B3P      C10    C8     O2     .
 B3P      H101   C10    .      .
 B3P      H102   C10    .      .
 B3P      O2     C10    HO2    .
 B3P      HO2    O2     .      .
 B3P      C9     C8     O1     .
 B3P      H91    C9     .      .
 B3P      H92    C9     .      .
 B3P      O1     C9     HO1    .
 B3P      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 B3P      C2     C1        single      1.524    0.020
 B3P      C1     C3        single      1.524    0.020
 B3P      H11    C1        single      1.092    0.020
 B3P      H12    C1        single      1.092    0.020
 B3P      N2     C2        single      1.450    0.020
 B3P      H21    C2        single      1.092    0.020
 B3P      H22    C2        single      1.092    0.020
 B3P      C3     N1        single      1.450    0.020
 B3P      H31    C3        single      1.092    0.020
 B3P      H32    C3        single      1.092    0.020
 B3P      N1     C4        single      1.450    0.020
 B3P      HN1    N1        single      1.010    0.020
 B3P      C5     C4        single      1.524    0.020
 B3P      C6     C4        single      1.524    0.020
 B3P      C4     C7        single      1.524    0.020
 B3P      O4     C5        single      1.432    0.020
 B3P      H51    C5        single      1.092    0.020
 B3P      H52    C5        single      1.092    0.020
 B3P      O5     C6        single      1.432    0.020
 B3P      H61    C6        single      1.092    0.020
 B3P      H62    C6        single      1.092    0.020
 B3P      C7     O6        single      1.432    0.020
 B3P      H71    C7        single      1.092    0.020
 B3P      H72    C7        single      1.092    0.020
 B3P      C8     N2        single      1.450    0.020
 B3P      HN2    N2        single      1.010    0.020
 B3P      C9     C8        single      1.524    0.020
 B3P      C10    C8        single      1.524    0.020
 B3P      C11    C8        single      1.524    0.020
 B3P      O1     C9        single      1.432    0.020
 B3P      H91    C9        single      1.092    0.020
 B3P      H92    C9        single      1.092    0.020
 B3P      O2     C10       single      1.432    0.020
 B3P      H101   C10       single      1.092    0.020
 B3P      H102   C10       single      1.092    0.020
 B3P      O3     C11       single      1.432    0.020
 B3P      H111   C11       single      1.092    0.020
 B3P      H112   C11       single      1.092    0.020
 B3P      HO1    O1        single      0.967    0.020
 B3P      HO2    O2        single      0.967    0.020
 B3P      HO3    O3        single      0.967    0.020
 B3P      HO4    O4        single      0.967    0.020
 B3P      HO5    O5        single      0.967    0.020
 B3P      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 B3P      HO6    O6     C7      109.470    3.000
 B3P      O6     C7     H71     109.470    3.000
 B3P      O6     C7     H72     109.470    3.000
 B3P      O6     C7     C4      109.470    3.000
 B3P      H71    C7     H72     107.900    3.000
 B3P      H71    C7     C4      109.470    3.000
 B3P      H72    C7     C4      109.470    3.000
 B3P      C7     C4     C5      111.000    3.000
 B3P      C7     C4     C6      111.000    3.000
 B3P      C7     C4     N1      110.000    3.000
 B3P      C5     C4     C6      111.000    3.000
 B3P      C5     C4     N1      110.000    3.000
 B3P      C6     C4     N1      110.000    3.000
 B3P      C4     C5     H51     109.470    3.000
 B3P      C4     C5     H52     109.470    3.000
 B3P      C4     C5     O4      109.470    3.000
 B3P      H51    C5     H52     107.900    3.000
 B3P      H51    C5     O4      109.470    3.000
 B3P      H52    C5     O4      109.470    3.000
 B3P      C5     O4     HO4     109.470    3.000
 B3P      C4     C6     H61     109.470    3.000
 B3P      C4     C6     H62     109.470    3.000
 B3P      C4     C6     O5      109.470    3.000
 B3P      H61    C6     H62     107.900    3.000
 B3P      H61    C6     O5      109.470    3.000
 B3P      H62    C6     O5      109.470    3.000
 B3P      C6     O5     HO5     109.470    3.000
 B3P      C4     N1     HN1     118.500    3.000
 B3P      C4     N1     C3      120.000    3.000
 B3P      HN1    N1     C3      118.500    3.000
 B3P      N1     C3     H31     109.470    3.000
 B3P      N1     C3     H32     109.470    3.000
 B3P      N1     C3     C1      112.000    3.000
 B3P      H31    C3     H32     107.900    3.000
 B3P      H31    C3     C1      109.470    3.000
 B3P      H32    C3     C1      109.470    3.000
 B3P      C3     C1     H11     109.470    3.000
 B3P      C3     C1     H12     109.470    3.000
 B3P      C3     C1     C2      111.000    3.000
 B3P      H11    C1     H12     107.900    3.000
 B3P      H11    C1     C2      109.470    3.000
 B3P      H12    C1     C2      109.470    3.000
 B3P      C1     C2     H21     109.470    3.000
 B3P      C1     C2     H22     109.470    3.000
 B3P      C1     C2     N2      112.000    3.000
 B3P      H21    C2     H22     107.900    3.000
 B3P      H21    C2     N2      109.470    3.000
 B3P      H22    C2     N2      109.470    3.000
 B3P      C2     N2     HN2     118.500    3.000
 B3P      C2     N2     C8      120.000    3.000
 B3P      HN2    N2     C8      118.500    3.000
 B3P      N2     C8     C11     110.000    3.000
 B3P      N2     C8     C10     110.000    3.000
 B3P      N2     C8     C9      110.000    3.000
 B3P      C11    C8     C10     111.000    3.000
 B3P      C11    C8     C9      111.000    3.000
 B3P      C10    C8     C9      111.000    3.000
 B3P      C8     C11    H111    109.470    3.000
 B3P      C8     C11    H112    109.470    3.000
 B3P      C8     C11    O3      109.470    3.000
 B3P      H111   C11    H112    107.900    3.000
 B3P      H111   C11    O3      109.470    3.000
 B3P      H112   C11    O3      109.470    3.000
 B3P      C11    O3     HO3     109.470    3.000
 B3P      C8     C10    H101    109.470    3.000
 B3P      C8     C10    H102    109.470    3.000
 B3P      C8     C10    O2      109.470    3.000
 B3P      H101   C10    H102    107.900    3.000
 B3P      H101   C10    O2      109.470    3.000
 B3P      H102   C10    O2      109.470    3.000
 B3P      C10    O2     HO2     109.470    3.000
 B3P      C8     C9     H91     109.470    3.000
 B3P      C8     C9     H92     109.470    3.000
 B3P      C8     C9     O1      109.470    3.000
 B3P      H91    C9     H92     107.900    3.000
 B3P      H91    C9     O1      109.470    3.000
 B3P      H92    C9     O1      109.470    3.000
 B3P      C9     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 B3P      var_1    HO6    O6     C7     C4       179.985   20.000   1
 B3P      var_2    O6     C7     C4     N1        59.978   20.000   1
 B3P      var_3    C7     C4     C5     O4      -179.973   20.000   1
 B3P      var_4    C4     C5     O4     HO4     -179.896   20.000   1
 B3P      var_5    C7     C4     C6     O5      -179.990   20.000   1
 B3P      var_6    C4     C6     O5     HO5     -179.984   20.000   1
 B3P      var_7    C7     C4     N1     C3        60.025   20.000   1
 B3P      var_8    C4     N1     C3     C1      -179.966   20.000   3
 B3P      var_9    N1     C3     C1     C2      -179.990   20.000   3
 B3P      var_10   C3     C1     C2     N2       179.990   20.000   3
 B3P      var_11   C1     C2     N2     C8       179.966   20.000   3
 B3P      var_12   C2     N2     C8     C9       179.963   20.000   1
 B3P      var_13   N2     C8     C11    O3       -59.978   20.000   1
 B3P      var_14   C8     C11    O3     HO3     -179.985   20.000   1
 B3P      var_15   N2     C8     C10    O2        59.979   20.000   1
 B3P      var_16   C8     C10    O2     HO2      179.984   20.000   1
 B3P      var_17   N2     C8     C9     O1       -59.994   20.000   1
 B3P      var_18   C8     C9     O1     HO1      179.896   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 B3P      chir_01  C4     N1     C5     C6        negativ
 B3P      chir_02  C8     N2     C9     C10       positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 B3P      plan-1    N1        0.020
 B3P      plan-1    C3        0.020
 B3P      plan-1    C4        0.020
 B3P      plan-1    HN1       0.020
 B3P      plan-2    N2        0.020
 B3P      plan-2    C2        0.020
 B3P      plan-2    C8        0.020
 B3P      plan-2    HN2       0.020
# ------------------------------------------------------
`.trim();

monomers["NHE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
NHE      NHE '2-[N-CYCLOHEXYLAMINO]ETHANE SULFONIC' non-polymer        30  13 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_NHE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 NHE           O2     O    OS        0.000      0.000    0.000    0.000
 NHE           S      S    ST        0.000     -0.882   -0.991    0.507
 NHE           O1     O    OS        0.000     -1.427   -0.917    1.817
 NHE           O3     O    OH1       0.000      0.005   -2.225    0.580
 NHE           HO3    H    H         0.000      0.749   -2.211    1.172
 NHE           C2     C    CH2       0.000     -2.140   -1.455   -0.714
 NHE           HC21   H    H         0.000     -2.679   -2.337   -0.363
 NHE           HC22   H    H         0.000     -1.655   -1.680   -1.667
 NHE           C1     C    CH2       0.000     -3.121   -0.296   -0.900
 NHE           HC11   H    H         0.000     -2.581    0.586   -1.251
 NHE           HC12   H    H         0.000     -3.604   -0.071    0.053
 NHE           N      N    NH1       0.000     -4.139   -0.674   -1.890
 NHE           HN     H    H         0.000     -4.203   -1.552   -2.384
 NHE           "C1'"  C    CH1       0.000     -5.045    0.475   -2.021
 NHE           "HC'1" H    H         0.000     -4.490    1.403   -1.825
 NHE           "C2'"  C    CH2       0.000     -5.618    0.514   -3.440
 NHE           "H2'2" H    H         0.000     -6.168   -0.410   -3.635
 NHE           "H2'1" H    H         0.000     -4.802    0.609   -4.159
 NHE           "C6'"  C    CH2       0.000     -6.187    0.343   -1.013
 NHE           "H6'1" H    H         0.000     -5.777    0.315   -0.001
 NHE           "H6'2" H    H         0.000     -6.737   -0.580   -1.206
 NHE           "C5'"  C    CH2       0.000     -7.130    1.539   -1.150
 NHE           "H5'1" H    H         0.000     -6.579    2.461   -0.955
 NHE           "H5'2" H    H         0.000     -7.945    1.444   -0.429
 NHE           "C4'"  C    CH2       0.000     -7.704    1.576   -2.568
 NHE           "H4'1" H    H         0.000     -8.379    2.430   -2.666
 NHE           "H4'2" H    H         0.000     -8.256    0.654   -2.762
 NHE           "C3'"  C    CH2       0.000     -6.562    1.709   -3.576
 NHE           "H3'2" H    H         0.000     -6.013    2.633   -3.381
 NHE           "H3'1" H    H         0.000     -6.973    1.737   -4.587
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 NHE      O2     n/a    S      START
 NHE      S      O2     C2     .
 NHE      O1     S      .      .
 NHE      O3     S      HO3    .
 NHE      HO3    O3     .      .
 NHE      C2     S      C1     .
 NHE      HC21   C2     .      .
 NHE      HC22   C2     .      .
 NHE      C1     C2     N      .
 NHE      HC11   C1     .      .
 NHE      HC12   C1     .      .
 NHE      N      C1     "C1'"  .
 NHE      HN     N      .      .
 NHE      "C1'"  N      "C6'"  .
 NHE      "HC'1" "C1'"  .      .
 NHE      "C2'"  "C1'"  "H2'1" .
 NHE      "H2'2" "C2'"  .      .
 NHE      "H2'1" "C2'"  .      .
 NHE      "C6'"  "C1'"  "C5'"  .
 NHE      "H6'1" "C6'"  .      .
 NHE      "H6'2" "C6'"  .      .
 NHE      "C5'"  "C6'"  "C4'"  .
 NHE      "H5'1" "C5'"  .      .
 NHE      "H5'2" "C5'"  .      .
 NHE      "C4'"  "C5'"  "C3'"  .
 NHE      "H4'1" "C4'"  .      .
 NHE      "H4'2" "C4'"  .      .
 NHE      "C3'"  "C4'"  "H3'1" .
 NHE      "H3'2" "C3'"  .      .
 NHE      "H3'1" "C3'"  .      END
 NHE      "C3'"  "C2'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 NHE      "C3'"  "C2'"     single      1.524    0.020
 NHE      "C3'"  "C4'"     single      1.524    0.020
 NHE      "H3'1" "C3'"     single      1.092    0.020
 NHE      "H3'2" "C3'"     single      1.092    0.020
 NHE      "C2'"  "C1'"     single      1.524    0.020
 NHE      "H2'1" "C2'"     single      1.092    0.020
 NHE      "H2'2" "C2'"     single      1.092    0.020
 NHE      "C6'"  "C1'"     single      1.524    0.020
 NHE      "C1'"  N         single      1.450    0.020
 NHE      "HC'1" "C1'"     single      1.099    0.020
 NHE      "C5'"  "C6'"     single      1.524    0.020
 NHE      "H6'1" "C6'"     single      1.092    0.020
 NHE      "H6'2" "C6'"     single      1.092    0.020
 NHE      N      C1        single      1.450    0.020
 NHE      HN     N         single      1.010    0.020
 NHE      C1     C2        single      1.524    0.020
 NHE      HC11   C1        single      1.092    0.020
 NHE      HC12   C1        single      1.092    0.020
 NHE      C2     S         single      1.662    0.020
 NHE      HC21   C2        single      1.092    0.020
 NHE      HC22   C2        single      1.092    0.020
 NHE      O1     S         double      1.436    0.020
 NHE      S      O2        double      1.436    0.020
 NHE      O3     S         single      1.635    0.020
 NHE      HO3    O3        single      0.967    0.020
 NHE      "C4'"  "C5'"     single      1.524    0.020
 NHE      "H5'1" "C5'"     single      1.092    0.020
 NHE      "H5'2" "C5'"     single      1.092    0.020
 NHE      "H4'1" "C4'"     single      1.092    0.020
 NHE      "H4'2" "C4'"     single      1.092    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 NHE      O2     S      O1      109.500    3.000
 NHE      O2     S      O3      109.500    3.000
 NHE      O2     S      C2      109.500    3.000
 NHE      O1     S      O3      109.500    3.000
 NHE      O1     S      C2      109.500    3.000
 NHE      O3     S      C2      109.500    3.000
 NHE      S      O3     HO3     120.000    3.000
 NHE      S      C2     HC21    109.500    3.000
 NHE      S      C2     HC22    109.500    3.000
 NHE      S      C2     C1      109.500    3.000
 NHE      HC21   C2     HC22    107.900    3.000
 NHE      HC21   C2     C1      109.470    3.000
 NHE      HC22   C2     C1      109.470    3.000
 NHE      C2     C1     HC11    109.470    3.000
 NHE      C2     C1     HC12    109.470    3.000
 NHE      C2     C1     N       112.000    3.000
 NHE      HC11   C1     HC12    107.900    3.000
 NHE      HC11   C1     N       109.470    3.000
 NHE      HC12   C1     N       109.470    3.000
 NHE      C1     N      HN      118.500    3.000
 NHE      C1     N      "C1'"   120.000    3.000
 NHE      HN     N      "C1'"   118.500    3.000
 NHE      N      "C1'"  "HC'1"  108.550    3.000
 NHE      N      "C1'"  "C2'"   110.000    3.000
 NHE      N      "C1'"  "C6'"   110.000    3.000
 NHE      "HC'1" "C1'"  "C2'"   108.340    3.000
 NHE      "HC'1" "C1'"  "C6'"   108.340    3.000
 NHE      "C2'"  "C1'"  "C6'"   109.470    3.000
 NHE      "C1'"  "C2'"  "H2'2"  109.470    3.000
 NHE      "C1'"  "C2'"  "H2'1"  109.470    3.000
 NHE      "C1'"  "C2'"  "C3'"   111.000    3.000
 NHE      "H2'2" "C2'"  "H2'1"  107.900    3.000
 NHE      "H2'2" "C2'"  "C3'"   109.470    3.000
 NHE      "H2'1" "C2'"  "C3'"   109.470    3.000
 NHE      "C1'"  "C6'"  "H6'1"  109.470    3.000
 NHE      "C1'"  "C6'"  "H6'2"  109.470    3.000
 NHE      "C1'"  "C6'"  "C5'"   111.000    3.000
 NHE      "H6'1" "C6'"  "H6'2"  107.900    3.000
 NHE      "H6'1" "C6'"  "C5'"   109.470    3.000
 NHE      "H6'2" "C6'"  "C5'"   109.470    3.000
 NHE      "C6'"  "C5'"  "H5'1"  109.470    3.000
 NHE      "C6'"  "C5'"  "H5'2"  109.470    3.000
 NHE      "C6'"  "C5'"  "C4'"   111.000    3.000
 NHE      "H5'1" "C5'"  "H5'2"  107.900    3.000
 NHE      "H5'1" "C5'"  "C4'"   109.470    3.000
 NHE      "H5'2" "C5'"  "C4'"   109.470    3.000
 NHE      "C5'"  "C4'"  "H4'1"  109.470    3.000
 NHE      "C5'"  "C4'"  "H4'2"  109.470    3.000
 NHE      "C5'"  "C4'"  "C3'"   111.000    3.000
 NHE      "H4'1" "C4'"  "H4'2"  107.900    3.000
 NHE      "H4'1" "C4'"  "C3'"   109.470    3.000
 NHE      "H4'2" "C4'"  "C3'"   109.470    3.000
 NHE      "C4'"  "C3'"  "H3'2"  109.470    3.000
 NHE      "C4'"  "C3'"  "H3'1"  109.470    3.000
 NHE      "C4'"  "C3'"  "C2'"   111.000    3.000
 NHE      "H3'2" "C3'"  "H3'1"  107.900    3.000
 NHE      "H3'2" "C3'"  "C2'"   109.470    3.000
 NHE      "H3'1" "C3'"  "C2'"   109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 NHE      var_1    O2     S      O3     HO3       63.809   20.000   1
 NHE      var_2    O2     S      C2     C1       -70.216   20.000   1
 NHE      var_3    S      C2     C1     N       -179.992   20.000   3
 NHE      var_4    C2     C1     N      "C1'"    179.974   20.000   3
 NHE      var_5    C1     N      "C1'"  "C6'"    -89.979   20.000   3
 NHE      var_6    N      "C1'"  "C2'"  "C3'"    180.000   20.000   3
 NHE      var_7    N      "C1'"  "C6'"  "C5'"    180.000   20.000   3
 NHE      var_8    "C1'"  "C6'"  "C5'"  "C4'"     60.000   20.000   3
 NHE      var_9    "C6'"  "C5'"  "C4'"  "C3'"    -60.000   20.000   3
 NHE      var_10   "C5'"  "C4'"  "C3'"  "C2'"     60.000   20.000   3
 NHE      var_11   "C4'"  "C3'"  "C2'"  "C1'"    -60.000   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 NHE      chir_01  "C1'"  "C2'"  "C6'"  N         negativ
 NHE      chir_02  S      C2     O1     O2        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 NHE      plan-1    N         0.020
 NHE      plan-1    "C1'"     0.000
 NHE      plan-1    C1        0.000
 NHE      plan-1    HN        0.000
# ------------------------------------------------------
`.trim();

monomers["C8E"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
C8E      C8E '(HYDROXYETHYLOXY)TRI(ETHYLOXY)OCTANE' non-polymer        55  21 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_C8E
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 C8E           O21    O    OH1       0.000      0.000    0.000    0.000
 C8E           HO2    H    H         0.000      0.700    0.618    0.252
 C8E           C20    C    CH2       0.000     -1.017    0.700   -0.720
 C8E           H201   H    H         0.000     -0.584    1.148   -1.617
 C8E           H202   H    H         0.000     -1.433    1.487   -0.087
 C8E           C19    C    CH2       0.000     -2.124   -0.276   -1.118
 C8E           H191   H    H         0.000     -1.706   -1.061   -1.751
 C8E           H192   H    H         0.000     -2.900    0.260   -1.670
 C8E           O18    O    O2        0.000     -2.690   -0.859    0.057
 C8E           C17    C    CH2       0.000     -3.713   -1.756   -0.380
 C8E           H171   H    H         0.000     -3.274   -2.522   -1.023
 C8E           H172   H    H         0.000     -4.468   -1.202   -0.940
 C8E           C16    C    CH2       0.000     -4.362   -2.420    0.837
 C8E           H161   H    H         0.000     -3.606   -2.975    1.396
 C8E           H162   H    H         0.000     -5.143   -3.107    0.503
 C8E           O15    O    O2        0.000     -4.935   -1.416    1.676
 C8E           C14    C    CH2       0.000     -5.523   -2.095    2.788
 C8E           H141   H    H         0.000     -4.752   -2.654    3.321
 C8E           H142   H    H         0.000     -6.290   -2.785    2.428
 C8E           C13    C    CH2       0.000     -6.158   -1.071    3.731
 C8E           H131   H    H         0.000     -5.391   -0.382    4.090
 C8E           H132   H    H         0.000     -6.606   -1.590    4.582
 C8E           O12    O    O2        0.000     -7.167   -0.340    3.032
 C8E           C11    C    CH2       0.000     -7.721    0.593    3.962
 C8E           H111   H    H         0.000     -6.933    1.261    4.318
 C8E           H112   H    H         0.000     -8.149    0.053    4.808
 C8E           C10    C    CH2       0.000     -8.812    1.413    3.273
 C8E           H101   H    H         0.000     -8.382    1.953    2.427
 C8E           H102   H    H         0.000     -9.233    2.127    3.984
 C8E           O9     O    O2        0.000     -9.843    0.538    2.808
 C8E           C8     C    CH2       0.000    -10.828    1.358    2.177
 C8E           H81    H    H         0.000    -10.372    1.899    1.345
 C8E           H82    H    H         0.000    -11.223    2.073    2.902
 C8E           C7     C    CH2       0.000    -11.965    0.479    1.654
 C8E           H71    H    H         0.000    -12.419   -0.061    2.487
 C8E           H72    H    H         0.000    -11.567   -0.236    0.931
 C8E           C6     C    CH2       0.000    -13.019    1.358    0.978
 C8E           H61    H    H         0.000    -12.563    1.898    0.146
 C8E           H62    H    H         0.000    -13.414    2.074    1.703
 C8E           C5     C    CH2       0.000    -14.157    0.479    0.456
 C8E           H51    H    H         0.000    -14.610   -0.061    1.290
 C8E           H52    H    H         0.000    -13.760   -0.236   -0.267
 C8E           C4     C    CH2       0.000    -15.212    1.357   -0.219
 C8E           H41    H    H         0.000    -14.756    1.898   -1.050
 C8E           H42    H    H         0.000    -15.607    2.071    0.506
 C8E           C3     C    CH2       0.000    -16.349    0.478   -0.742
 C8E           H31    H    H         0.000    -16.803   -0.063    0.091
 C8E           H32    H    H         0.000    -15.952   -0.237   -1.465
 C8E           C2     C    CH2       0.000    -17.405    1.356   -1.418
 C8E           H21    H    H         0.000    -16.949    1.897   -2.249
 C8E           H22    H    H         0.000    -17.800    2.071   -0.693
 C8E           C1     C    CH3       0.000    -18.542    0.477   -1.941
 C8E           H13    H    H         0.000    -19.275    1.084   -2.409
 C8E           H12    H    H         0.000    -18.160   -0.218   -2.645
 C8E           H11    H    H         0.000    -18.986   -0.049   -1.135
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 C8E      O21    n/a    C20    START
 C8E      HO2    O21    .      .
 C8E      C20    O21    C19    .
 C8E      H201   C20    .      .
 C8E      H202   C20    .      .
 C8E      C19    C20    O18    .
 C8E      H191   C19    .      .
 C8E      H192   C19    .      .
 C8E      O18    C19    C17    .
 C8E      C17    O18    C16    .
 C8E      H171   C17    .      .
 C8E      H172   C17    .      .
 C8E      C16    C17    O15    .
 C8E      H161   C16    .      .
 C8E      H162   C16    .      .
 C8E      O15    C16    C14    .
 C8E      C14    O15    C13    .
 C8E      H141   C14    .      .
 C8E      H142   C14    .      .
 C8E      C13    C14    O12    .
 C8E      H131   C13    .      .
 C8E      H132   C13    .      .
 C8E      O12    C13    C11    .
 C8E      C11    O12    C10    .
 C8E      H111   C11    .      .
 C8E      H112   C11    .      .
 C8E      C10    C11    O9     .
 C8E      H101   C10    .      .
 C8E      H102   C10    .      .
 C8E      O9     C10    C8     .
 C8E      C8     O9     C7     .
 C8E      H81    C8     .      .
 C8E      H82    C8     .      .
 C8E      C7     C8     C6     .
 C8E      H71    C7     .      .
 C8E      H72    C7     .      .
 C8E      C6     C7     C5     .
 C8E      H61    C6     .      .
 C8E      H62    C6     .      .
 C8E      C5     C6     C4     .
 C8E      H51    C5     .      .
 C8E      H52    C5     .      .
 C8E      C4     C5     C3     .
 C8E      H41    C4     .      .
 C8E      H42    C4     .      .
 C8E      C3     C4     C2     .
 C8E      H31    C3     .      .
 C8E      H32    C3     .      .
 C8E      C2     C3     C1     .
 C8E      H21    C2     .      .
 C8E      H22    C2     .      .
 C8E      C1     C2     H11    .
 C8E      H13    C1     .      .
 C8E      H12    C1     .      .
 C8E      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 C8E      C1     C2        single      1.513    0.020
 C8E      H11    C1        single      1.059    0.020
 C8E      H12    C1        single      1.059    0.020
 C8E      H13    C1        single      1.059    0.020
 C8E      C2     C3        single      1.524    0.020
 C8E      H21    C2        single      1.092    0.020
 C8E      H22    C2        single      1.092    0.020
 C8E      C3     C4        single      1.524    0.020
 C8E      H31    C3        single      1.092    0.020
 C8E      H32    C3        single      1.092    0.020
 C8E      C4     C5        single      1.524    0.020
 C8E      H41    C4        single      1.092    0.020
 C8E      H42    C4        single      1.092    0.020
 C8E      C5     C6        single      1.524    0.020
 C8E      H51    C5        single      1.092    0.020
 C8E      H52    C5        single      1.092    0.020
 C8E      C6     C7        single      1.524    0.020
 C8E      H61    C6        single      1.092    0.020
 C8E      H62    C6        single      1.092    0.020
 C8E      C7     C8        single      1.524    0.020
 C8E      H71    C7        single      1.092    0.020
 C8E      H72    C7        single      1.092    0.020
 C8E      C8     O9        single      1.426    0.020
 C8E      H81    C8        single      1.092    0.020
 C8E      H82    C8        single      1.092    0.020
 C8E      O9     C10       single      1.426    0.020
 C8E      C10    C11       single      1.524    0.020
 C8E      H101   C10       single      1.092    0.020
 C8E      H102   C10       single      1.092    0.020
 C8E      C11    O12       single      1.426    0.020
 C8E      H111   C11       single      1.092    0.020
 C8E      H112   C11       single      1.092    0.020
 C8E      O12    C13       single      1.426    0.020
 C8E      C13    C14       single      1.524    0.020
 C8E      H131   C13       single      1.092    0.020
 C8E      H132   C13       single      1.092    0.020
 C8E      C14    O15       single      1.426    0.020
 C8E      H141   C14       single      1.092    0.020
 C8E      H142   C14       single      1.092    0.020
 C8E      O15    C16       single      1.426    0.020
 C8E      C16    C17       single      1.524    0.020
 C8E      H161   C16       single      1.092    0.020
 C8E      H162   C16       single      1.092    0.020
 C8E      C17    O18       single      1.426    0.020
 C8E      H171   C17       single      1.092    0.020
 C8E      H172   C17       single      1.092    0.020
 C8E      O18    C19       single      1.426    0.020
 C8E      C19    C20       single      1.524    0.020
 C8E      H191   C19       single      1.092    0.020
 C8E      H192   C19       single      1.092    0.020
 C8E      C20    O21       single      1.432    0.020
 C8E      H201   C20       single      1.092    0.020
 C8E      H202   C20       single      1.092    0.020
 C8E      HO2    O21       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 C8E      HO2    O21    C20     109.470    3.000
 C8E      O21    C20    H201    109.470    3.000
 C8E      O21    C20    H202    109.470    3.000
 C8E      O21    C20    C19     109.470    3.000
 C8E      H201   C20    H202    107.900    3.000
 C8E      H201   C20    C19     109.470    3.000
 C8E      H202   C20    C19     109.470    3.000
 C8E      C20    C19    H191    109.470    3.000
 C8E      C20    C19    H192    109.470    3.000
 C8E      C20    C19    O18     109.470    3.000
 C8E      H191   C19    H192    107.900    3.000
 C8E      H191   C19    O18     109.470    3.000
 C8E      H192   C19    O18     109.470    3.000
 C8E      C19    O18    C17     111.800    3.000
 C8E      O18    C17    H171    109.470    3.000
 C8E      O18    C17    H172    109.470    3.000
 C8E      O18    C17    C16     109.470    3.000
 C8E      H171   C17    H172    107.900    3.000
 C8E      H171   C17    C16     109.470    3.000
 C8E      H172   C17    C16     109.470    3.000
 C8E      C17    C16    H161    109.470    3.000
 C8E      C17    C16    H162    109.470    3.000
 C8E      C17    C16    O15     109.470    3.000
 C8E      H161   C16    H162    107.900    3.000
 C8E      H161   C16    O15     109.470    3.000
 C8E      H162   C16    O15     109.470    3.000
 C8E      C16    O15    C14     111.800    3.000
 C8E      O15    C14    H141    109.470    3.000
 C8E      O15    C14    H142    109.470    3.000
 C8E      O15    C14    C13     109.470    3.000
 C8E      H141   C14    H142    107.900    3.000
 C8E      H141   C14    C13     109.470    3.000
 C8E      H142   C14    C13     109.470    3.000
 C8E      C14    C13    H131    109.470    3.000
 C8E      C14    C13    H132    109.470    3.000
 C8E      C14    C13    O12     109.470    3.000
 C8E      H131   C13    H132    107.900    3.000
 C8E      H131   C13    O12     109.470    3.000
 C8E      H132   C13    O12     109.470    3.000
 C8E      C13    O12    C11     111.800    3.000
 C8E      O12    C11    H111    109.470    3.000
 C8E      O12    C11    H112    109.470    3.000
 C8E      O12    C11    C10     109.470    3.000
 C8E      H111   C11    H112    107.900    3.000
 C8E      H111   C11    C10     109.470    3.000
 C8E      H112   C11    C10     109.470    3.000
 C8E      C11    C10    H101    109.470    3.000
 C8E      C11    C10    H102    109.470    3.000
 C8E      C11    C10    O9      109.470    3.000
 C8E      H101   C10    H102    107.900    3.000
 C8E      H101   C10    O9      109.470    3.000
 C8E      H102   C10    O9      109.470    3.000
 C8E      C10    O9     C8      111.800    3.000
 C8E      O9     C8     H81     109.470    3.000
 C8E      O9     C8     H82     109.470    3.000
 C8E      O9     C8     C7      109.470    3.000
 C8E      H81    C8     H82     107.900    3.000
 C8E      H81    C8     C7      109.470    3.000
 C8E      H82    C8     C7      109.470    3.000
 C8E      C8     C7     H71     109.470    3.000
 C8E      C8     C7     H72     109.470    3.000
 C8E      C8     C7     C6      111.000    3.000
 C8E      H71    C7     H72     107.900    3.000
 C8E      H71    C7     C6      109.470    3.000
 C8E      H72    C7     C6      109.470    3.000
 C8E      C7     C6     H61     109.470    3.000
 C8E      C7     C6     H62     109.470    3.000
 C8E      C7     C6     C5      111.000    3.000
 C8E      H61    C6     H62     107.900    3.000
 C8E      H61    C6     C5      109.470    3.000
 C8E      H62    C6     C5      109.470    3.000
 C8E      C6     C5     H51     109.470    3.000
 C8E      C6     C5     H52     109.470    3.000
 C8E      C6     C5     C4      111.000    3.000
 C8E      H51    C5     H52     107.900    3.000
 C8E      H51    C5     C4      109.470    3.000
 C8E      H52    C5     C4      109.470    3.000
 C8E      C5     C4     H41     109.470    3.000
 C8E      C5     C4     H42     109.470    3.000
 C8E      C5     C4     C3      111.000    3.000
 C8E      H41    C4     H42     107.900    3.000
 C8E      H41    C4     C3      109.470    3.000
 C8E      H42    C4     C3      109.470    3.000
 C8E      C4     C3     H31     109.470    3.000
 C8E      C4     C3     H32     109.470    3.000
 C8E      C4     C3     C2      111.000    3.000
 C8E      H31    C3     H32     107.900    3.000
 C8E      H31    C3     C2      109.470    3.000
 C8E      H32    C3     C2      109.470    3.000
 C8E      C3     C2     H21     109.470    3.000
 C8E      C3     C2     H22     109.470    3.000
 C8E      C3     C2     C1      111.000    3.000
 C8E      H21    C2     H22     107.900    3.000
 C8E      H21    C2     C1      109.470    3.000
 C8E      H22    C2     C1      109.470    3.000
 C8E      C2     C1     H13     109.470    3.000
 C8E      C2     C1     H12     109.470    3.000
 C8E      C2     C1     H11     109.470    3.000
 C8E      H13    C1     H12     109.470    3.000
 C8E      H13    C1     H11     109.470    3.000
 C8E      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 C8E      var_1    HO2    O21    C20    C19     -179.985   20.000   1
 C8E      var_2    O21    C20    C19    O18       60.052   20.000   3
 C8E      var_3    C20    C19    O18    C17     -179.995   20.000   1
 C8E      var_4    C19    O18    C17    C16      179.934   20.000   1
 C8E      var_5    O18    C17    C16    O15       60.020   20.000   3
 C8E      var_6    C17    C16    O15    C14      179.975   20.000   1
 C8E      var_7    C16    O15    C14    C13      179.975   20.000   1
 C8E      var_8    O15    C14    C13    O12       60.031   20.000   3
 C8E      var_9    C14    C13    O12    C11      179.945   20.000   1
 C8E      var_10   C13    O12    C11    C10      179.960   20.000   1
 C8E      var_11   O12    C11    C10    O9        60.043   20.000   3
 C8E      var_12   C11    C10    O9     C8      -179.997   20.000   1
 C8E      var_13   C10    O9     C8     C7       179.999   20.000   1
 C8E      var_14   O9     C8     C7     C6      -179.982   20.000   3
 C8E      var_15   C8     C7     C6     C5      -179.947   20.000   3
 C8E      var_16   C7     C6     C5     C4       179.966   20.000   3
 C8E      var_17   C6     C5     C4     C3       179.947   20.000   3
 C8E      var_18   C5     C4     C3     C2      -179.983   20.000   3
 C8E      var_19   C4     C3     C2     C1       180.000   20.000   3
 C8E      var_20   C3     C2     C1     H11       59.983   20.000   3
# ------------------------------------------------------
`.trim();

monomers["PE8"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PE8      PE8 '3,6,9,12,15,18,21-HEPTAOXATRICOSANE-' non-polymer        59  25 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PE8
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PE8           O25    O    OH1       0.000      0.000    0.000    0.000
 PE8           H25    H    H         0.000      0.670   -0.483    0.503
 PE8           C24    C    CH2       0.000     -0.671    0.919    0.863
 PE8           H241   H    H         0.000      0.053    1.623    1.278
 PE8           H242   H    H         0.000     -1.150    0.370    1.676
 PE8           C23    C    CH2       0.000     -1.731    1.683    0.067
 PE8           H231   H    H         0.000     -1.250    2.231   -0.746
 PE8           H232   H    H         0.000     -2.243    2.388    0.726
 PE8           O22    O    O2        0.000     -2.678    0.761   -0.474
 PE8           C21    C    CH2       0.000     -3.635    1.533   -1.202
 PE8           H211   H    H         0.000     -3.129    2.083   -1.998
 PE8           H212   H    H         0.000     -4.123    2.238   -0.527
 PE8           C20    C    CH2       0.000     -4.685    0.600   -1.812
 PE8           H201   H    H         0.000     -4.196   -0.105   -2.489
 PE8           H202   H    H         0.000     -5.416    1.189   -2.369
 PE8           O19    O    O2        0.000     -5.345   -0.120   -0.769
 PE8           C18    C    CH2       0.000     -6.307   -0.969   -1.399
 PE8           H181   H    H         0.000     -5.796   -1.653   -2.080
 PE8           H182   H    H         0.000     -7.017   -0.359   -1.961
 PE8           C17    C    CH2       0.000     -7.054   -1.772   -0.333
 PE8           H171   H    H         0.000     -6.343   -2.382    0.228
 PE8           H172   H    H         0.000     -7.788   -2.421   -0.815
 PE8           O16    O    O2        0.000     -7.721   -0.876    0.558
 PE8           C15    C    CH2       0.000     -8.396   -1.683    1.525
 PE8           H151   H    H         0.000     -7.667   -2.294    2.062
 PE8           H152   H    H         0.000     -9.113   -2.333    1.019
 PE8           C14    C    CH2       0.000     -9.135   -0.780    2.515
 PE8           H141   H    H         0.000     -8.417   -0.131    3.021
 PE8           H142   H    H         0.000     -9.650   -1.397    3.255
 PE8           O13    O    O2        0.000    -10.087    0.018    1.812
 PE8           C12    C    CH2       0.000    -10.740    0.834    2.785
 PE8           H121   H    H         0.000    -10.001    1.462    3.287
 PE8           H122   H    H         0.000    -11.234    0.197    3.522
 PE8           C11    C    CH2       0.000    -11.780    1.719    2.095
 PE8           H111   H    H         0.000    -11.283    2.357    1.361
 PE8           H112   H    H         0.000    -12.278    2.343    2.840
 PE8           O10    O    O2        0.000    -12.746    0.896    1.438
 PE8           C9     C    CH2       0.000    -13.684    1.776    0.816
 PE8           H91    H    H         0.000    -13.164    2.413    0.098
 PE8           H92    H    H         0.000    -14.158    2.399    1.577
 PE8           C8     C    CH2       0.000    -14.751    0.954    0.091
 PE8           H81    H    H         0.000    -14.275    0.332   -0.670
 PE8           H82    H    H         0.000    -15.467    1.627   -0.385
 PE8           O7     O    O2        0.000    -15.431    0.121    1.033
 PE8           C6     C    CH2       0.000    -16.410   -0.616    0.299
 PE8           H61    H    H         0.000    -15.913   -1.219   -0.465
 PE8           H62    H    H         0.000    -17.104    0.077   -0.180
 PE8           C5     C    CH2       0.000    -17.179   -1.533    1.254
 PE8           H51    H    H         0.000    -16.484   -2.227    1.731
 PE8           H52    H    H         0.000    -17.926   -2.097    0.692
 PE8           O4     O    O2        0.000    -17.827   -0.744    2.253
 PE8           C3     C    CH2       0.000    -18.524   -1.652    3.108
 PE8           H31    H    H         0.000    -17.812   -2.344    3.562
 PE8           H32    H    H         0.000    -19.254   -2.216    2.522
 PE8           C2     C    CH2       0.000    -19.246   -0.867    4.205
 PE8           H21    H    H         0.000    -18.515   -0.304    4.790
 PE8           H22    H    H         0.000    -19.777   -1.561    4.860
 PE8           O1     O    OH1       0.000    -20.178    0.037    3.609
 PE8           HO1    H    H         0.000    -20.633    0.532    4.303
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PE8      O25    n/a    C24    START
 PE8      H25    O25    .      .
 PE8      C24    O25    C23    .
 PE8      H241   C24    .      .
 PE8      H242   C24    .      .
 PE8      C23    C24    O22    .
 PE8      H231   C23    .      .
 PE8      H232   C23    .      .
 PE8      O22    C23    C21    .
 PE8      C21    O22    C20    .
 PE8      H211   C21    .      .
 PE8      H212   C21    .      .
 PE8      C20    C21    O19    .
 PE8      H201   C20    .      .
 PE8      H202   C20    .      .
 PE8      O19    C20    C18    .
 PE8      C18    O19    C17    .
 PE8      H181   C18    .      .
 PE8      H182   C18    .      .
 PE8      C17    C18    O16    .
 PE8      H171   C17    .      .
 PE8      H172   C17    .      .
 PE8      O16    C17    C15    .
 PE8      C15    O16    C14    .
 PE8      H151   C15    .      .
 PE8      H152   C15    .      .
 PE8      C14    C15    O13    .
 PE8      H141   C14    .      .
 PE8      H142   C14    .      .
 PE8      O13    C14    C12    .
 PE8      C12    O13    C11    .
 PE8      H121   C12    .      .
 PE8      H122   C12    .      .
 PE8      C11    C12    O10    .
 PE8      H111   C11    .      .
 PE8      H112   C11    .      .
 PE8      O10    C11    C9     .
 PE8      C9     O10    C8     .
 PE8      H91    C9     .      .
 PE8      H92    C9     .      .
 PE8      C8     C9     O7     .
 PE8      H81    C8     .      .
 PE8      H82    C8     .      .
 PE8      O7     C8     C6     .
 PE8      C6     O7     C5     .
 PE8      H61    C6     .      .
 PE8      H62    C6     .      .
 PE8      C5     C6     O4     .
 PE8      H51    C5     .      .
 PE8      H52    C5     .      .
 PE8      O4     C5     C3     .
 PE8      C3     O4     C2     .
 PE8      H31    C3     .      .
 PE8      H32    C3     .      .
 PE8      C2     C3     O1     .
 PE8      H21    C2     .      .
 PE8      H22    C2     .      .
 PE8      O1     C2     HO1    .
 PE8      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PE8      O1     C2        single      1.432    0.020
 PE8      HO1    O1        single      0.967    0.020
 PE8      C2     C3        single      1.524    0.020
 PE8      H21    C2        single      1.092    0.020
 PE8      H22    C2        single      1.092    0.020
 PE8      C3     O4        single      1.426    0.020
 PE8      H31    C3        single      1.092    0.020
 PE8      H32    C3        single      1.092    0.020
 PE8      O4     C5        single      1.426    0.020
 PE8      C5     C6        single      1.524    0.020
 PE8      H51    C5        single      1.092    0.020
 PE8      H52    C5        single      1.092    0.020
 PE8      C6     O7        single      1.426    0.020
 PE8      H61    C6        single      1.092    0.020
 PE8      H62    C6        single      1.092    0.020
 PE8      O7     C8        single      1.426    0.020
 PE8      C8     C9        single      1.524    0.020
 PE8      H81    C8        single      1.092    0.020
 PE8      H82    C8        single      1.092    0.020
 PE8      C9     O10       single      1.426    0.020
 PE8      H91    C9        single      1.092    0.020
 PE8      H92    C9        single      1.092    0.020
 PE8      O10    C11       single      1.426    0.020
 PE8      C11    C12       single      1.524    0.020
 PE8      H111   C11       single      1.092    0.020
 PE8      H112   C11       single      1.092    0.020
 PE8      C12    O13       single      1.426    0.020
 PE8      H121   C12       single      1.092    0.020
 PE8      H122   C12       single      1.092    0.020
 PE8      O13    C14       single      1.426    0.020
 PE8      C14    C15       single      1.524    0.020
 PE8      H141   C14       single      1.092    0.020
 PE8      H142   C14       single      1.092    0.020
 PE8      C15    O16       single      1.426    0.020
 PE8      H151   C15       single      1.092    0.020
 PE8      H152   C15       single      1.092    0.020
 PE8      O16    C17       single      1.426    0.020
 PE8      C17    C18       single      1.524    0.020
 PE8      H171   C17       single      1.092    0.020
 PE8      H172   C17       single      1.092    0.020
 PE8      C18    O19       single      1.426    0.020
 PE8      H181   C18       single      1.092    0.020
 PE8      H182   C18       single      1.092    0.020
 PE8      O19    C20       single      1.426    0.020
 PE8      C20    C21       single      1.524    0.020
 PE8      H201   C20       single      1.092    0.020
 PE8      H202   C20       single      1.092    0.020
 PE8      C21    O22       single      1.426    0.020
 PE8      H211   C21       single      1.092    0.020
 PE8      H212   C21       single      1.092    0.020
 PE8      O22    C23       single      1.426    0.020
 PE8      C23    C24       single      1.524    0.020
 PE8      H231   C23       single      1.092    0.020
 PE8      H232   C23       single      1.092    0.020
 PE8      C24    O25       single      1.432    0.020
 PE8      H241   C24       single      1.092    0.020
 PE8      H242   C24       single      1.092    0.020
 PE8      H25    O25       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PE8      H25    O25    C24     109.470    3.000
 PE8      O25    C24    H241    109.470    3.000
 PE8      O25    C24    H242    109.470    3.000
 PE8      O25    C24    C23     109.470    3.000
 PE8      H241   C24    H242    107.900    3.000
 PE8      H241   C24    C23     109.470    3.000
 PE8      H242   C24    C23     109.470    3.000
 PE8      C24    C23    H231    109.470    3.000
 PE8      C24    C23    H232    109.470    3.000
 PE8      C24    C23    O22     109.470    3.000
 PE8      H231   C23    H232    107.900    3.000
 PE8      H231   C23    O22     109.470    3.000
 PE8      H232   C23    O22     109.470    3.000
 PE8      C23    O22    C21     111.800    3.000
 PE8      O22    C21    H211    109.470    3.000
 PE8      O22    C21    H212    109.470    3.000
 PE8      O22    C21    C20     109.470    3.000
 PE8      H211   C21    H212    107.900    3.000
 PE8      H211   C21    C20     109.470    3.000
 PE8      H212   C21    C20     109.470    3.000
 PE8      C21    C20    H201    109.470    3.000
 PE8      C21    C20    H202    109.470    3.000
 PE8      C21    C20    O19     109.470    3.000
 PE8      H201   C20    H202    107.900    3.000
 PE8      H201   C20    O19     109.470    3.000
 PE8      H202   C20    O19     109.470    3.000
 PE8      C20    O19    C18     111.800    3.000
 PE8      O19    C18    H181    109.470    3.000
 PE8      O19    C18    H182    109.470    3.000
 PE8      O19    C18    C17     109.470    3.000
 PE8      H181   C18    H182    107.900    3.000
 PE8      H181   C18    C17     109.470    3.000
 PE8      H182   C18    C17     109.470    3.000
 PE8      C18    C17    H171    109.470    3.000
 PE8      C18    C17    H172    109.470    3.000
 PE8      C18    C17    O16     109.470    3.000
 PE8      H171   C17    H172    107.900    3.000
 PE8      H171   C17    O16     109.470    3.000
 PE8      H172   C17    O16     109.470    3.000
 PE8      C17    O16    C15     111.800    3.000
 PE8      O16    C15    H151    109.470    3.000
 PE8      O16    C15    H152    109.470    3.000
 PE8      O16    C15    C14     109.470    3.000
 PE8      H151   C15    H152    107.900    3.000
 PE8      H151   C15    C14     109.470    3.000
 PE8      H152   C15    C14     109.470    3.000
 PE8      C15    C14    H141    109.470    3.000
 PE8      C15    C14    H142    109.470    3.000
 PE8      C15    C14    O13     109.470    3.000
 PE8      H141   C14    H142    107.900    3.000
 PE8      H141   C14    O13     109.470    3.000
 PE8      H142   C14    O13     109.470    3.000
 PE8      C14    O13    C12     111.800    3.000
 PE8      O13    C12    H121    109.470    3.000
 PE8      O13    C12    H122    109.470    3.000
 PE8      O13    C12    C11     109.470    3.000
 PE8      H121   C12    H122    107.900    3.000
 PE8      H121   C12    C11     109.470    3.000
 PE8      H122   C12    C11     109.470    3.000
 PE8      C12    C11    H111    109.470    3.000
 PE8      C12    C11    H112    109.470    3.000
 PE8      C12    C11    O10     109.470    3.000
 PE8      H111   C11    H112    107.900    3.000
 PE8      H111   C11    O10     109.470    3.000
 PE8      H112   C11    O10     109.470    3.000
 PE8      C11    O10    C9      111.800    3.000
 PE8      O10    C9     H91     109.470    3.000
 PE8      O10    C9     H92     109.470    3.000
 PE8      O10    C9     C8      109.470    3.000
 PE8      H91    C9     H92     107.900    3.000
 PE8      H91    C9     C8      109.470    3.000
 PE8      H92    C9     C8      109.470    3.000
 PE8      C9     C8     H81     109.470    3.000
 PE8      C9     C8     H82     109.470    3.000
 PE8      C9     C8     O7      109.470    3.000
 PE8      H81    C8     H82     107.900    3.000
 PE8      H81    C8     O7      109.470    3.000
 PE8      H82    C8     O7      109.470    3.000
 PE8      C8     O7     C6      111.800    3.000
 PE8      O7     C6     H61     109.470    3.000
 PE8      O7     C6     H62     109.470    3.000
 PE8      O7     C6     C5      109.470    3.000
 PE8      H61    C6     H62     107.900    3.000
 PE8      H61    C6     C5      109.470    3.000
 PE8      H62    C6     C5      109.470    3.000
 PE8      C6     C5     H51     109.470    3.000
 PE8      C6     C5     H52     109.470    3.000
 PE8      C6     C5     O4      109.470    3.000
 PE8      H51    C5     H52     107.900    3.000
 PE8      H51    C5     O4      109.470    3.000
 PE8      H52    C5     O4      109.470    3.000
 PE8      C5     O4     C3      111.800    3.000
 PE8      O4     C3     H31     109.470    3.000
 PE8      O4     C3     H32     109.470    3.000
 PE8      O4     C3     C2      109.470    3.000
 PE8      H31    C3     H32     107.900    3.000
 PE8      H31    C3     C2      109.470    3.000
 PE8      H32    C3     C2      109.470    3.000
 PE8      C3     C2     H21     109.470    3.000
 PE8      C3     C2     H22     109.470    3.000
 PE8      C3     C2     O1      109.470    3.000
 PE8      H21    C2     H22     107.900    3.000
 PE8      H21    C2     O1      109.470    3.000
 PE8      H22    C2     O1      109.470    3.000
 PE8      C2     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PE8      var_1    H25    O25    C24    C23      179.985   20.000   1
 PE8      var_2    O25    C24    C23    O22       60.067   20.000   3
 PE8      var_3    C24    C23    O22    C21     -179.986   20.000   1
 PE8      var_4    C23    O22    C21    C20      179.966   20.000   1
 PE8      var_5    O22    C21    C20    O19       59.972   20.000   3
 PE8      var_6    C21    C20    O19    C18     -179.987   20.000   1
 PE8      var_7    C20    O19    C18    C17     -179.995   20.000   1
 PE8      var_8    O19    C18    C17    O16       59.994   20.000   3
 PE8      var_9    C18    C17    O16    C15     -179.991   20.000   1
 PE8      var_10   C17    O16    C15    C14     -179.987   20.000   1
 PE8      var_11   O16    C15    C14    O13       60.009   20.000   3
 PE8      var_12   C15    C14    O13    C12     -179.980   20.000   1
 PE8      var_13   C14    O13    C12    C11      179.993   20.000   1
 PE8      var_14   O13    C12    C11    O10       59.952   20.000   3
 PE8      var_15   C12    C11    O10    C9       179.985   20.000   1
 PE8      var_16   C11    O10    C9     C8      -179.990   20.000   1
 PE8      var_17   O10    C9     C8     O7        60.047   20.000   3
 PE8      var_18   C9     C8     O7     C6       179.979   20.000   1
 PE8      var_19   C8     O7     C6     C5      -179.990   20.000   1
 PE8      var_20   O7     C6     C5     O4        59.974   20.000   3
 PE8      var_21   C6     C5     O4     C3      -179.999   20.000   1
 PE8      var_22   C5     O4     C3     C2      -179.952   20.000   1
 PE8      var_23   O4     C3     C2     O1        60.035   20.000   3
 PE8      var_24   C3     C2     O1     HO1      179.979   20.000   1
# ------------------------------------------------------
`.trim();

monomers["2OS"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
2OS      2OS '3-N-OCTANOYLSUCROSE                 ' non-polymer        68  32 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_2OS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 2OS           O7     O    O        -0.500      0.000    0.000    0.000
 2OS           C4     C    C         0.000     -0.399    0.513    1.069
 2OS           C7     C    CH2       0.000      0.596    0.965    2.106
 2OS           H71    H    H         0.000      0.421    0.422    3.037
 2OS           H72    H    H         0.000      0.476    2.036    2.282
 2OS           C8     C    CH2       0.000      2.015    0.684    1.608
 2OS           H81    H    H         0.000      2.188    1.227    0.677
 2OS           H82    H    H         0.000      2.132   -0.387    1.431
 2OS           C9     C    CH2       0.000      3.026    1.142    2.662
 2OS           H91    H    H         0.000      2.850    0.599    3.593
 2OS           H92    H    H         0.000      2.906    2.213    2.838
 2OS           C10    C    CH2       0.000      4.444    0.860    2.165
 2OS           H101   H    H         0.000      4.617    1.402    1.233
 2OS           H102   H    H         0.000      4.561   -0.211    1.989
 2OS           C11    C    CH2       0.000      5.455    1.319    3.219
 2OS           H111   H    H         0.000      5.280    0.777    4.151
 2OS           H112   H    H         0.000      5.335    2.390    3.395
 2OS           C12    C    CH2       0.000      6.873    1.037    2.721
 2OS           H121   H    H         0.000      7.045    1.579    1.789
 2OS           H122   H    H         0.000      6.990   -0.034    2.545
 2OS           C31    C    CH3       0.000      7.884    1.495    3.774
 2OS           H313   H    H         0.000      7.772    2.535    3.947
 2OS           H312   H    H         0.000      7.718    0.970    4.680
 2OS           H311   H    H         0.000      8.868    1.300    3.432
 2OS           O11    O    O2       -0.500     -1.625    0.652    1.275
 2OS           C27    C    CH1       0.000     -2.673    0.227    0.290
 2OS           H27    H    H         0.000     -2.289   -0.623   -0.290
 2OS           C24    C    CH1       0.000     -2.973    1.383   -0.671
 2OS           H24    H    H         0.000     -3.282    2.267   -0.095
 2OS           O9     O    OH1       0.000     -1.807    1.695   -1.434
 2OS           HO9    H    H         0.000     -2.006    2.421   -2.042
 2OS           C16    C    CH1       0.000     -3.977   -0.194    0.978
 2OS           H16    H    H         0.000     -4.331    0.620    1.625
 2OS           O13    O    OH1       0.000     -3.745   -1.364    1.765
 2OS           H13    H    H         0.000     -4.568   -1.629    2.197
 2OS           C29    C    CH1       0.000     -5.029   -0.494   -0.091
 2OS           H29    H    H         0.000     -4.662   -1.293   -0.751
 2OS           C32    C    CH2       0.000     -6.325   -0.948    0.584
 2OS           H321   H    H         0.000     -6.752   -0.115    1.147
 2OS           H322   H    H         0.000     -6.110   -1.774    1.265
 2OS           O17    O    OH1       0.000     -7.255   -1.379   -0.411
 2OS           H17    H    H         0.000     -8.100   -1.592    0.008
 2OS           O15    O    O2        0.000     -5.283    0.678   -0.862
 2OS           C21    C    CH1       0.000     -4.105    0.965   -1.613
 2OS           H21    H    H         0.000     -4.312    1.781   -2.319
 2OS           O6     O    O2        0.000     -3.709   -0.200   -2.337
 2OS           C13    C    CT        0.000     -4.277   -0.090   -3.643
 2OS           C18    C    CH2       0.000     -3.468    0.904   -4.477
 2OS           H181   H    H         0.000     -3.933    1.018   -5.459
 2OS           H182   H    H         0.000     -2.449    0.531   -4.600
 2OS           O3     O    OH1       0.000     -3.437    2.169   -3.813
 2OS           HO3    H    H         0.000     -2.926    2.797   -4.342
 2OS           C3     C    CH1       0.000     -4.281   -1.471   -4.332
 2OS           H3     H    H         0.000     -4.081   -1.371   -5.408
 2OS           O5     O    OH1       0.000     -3.338   -2.353   -3.718
 2OS           HO5    H    H         0.000     -3.423   -3.234   -4.106
 2OS           C2     C    CH1       0.000     -5.738   -1.956   -4.083
 2OS           H2     H    H         0.000     -5.835   -2.420   -3.092
 2OS           O4     O    OH1       0.000     -6.166   -2.850   -5.113
 2OS           HO4    H    H         0.000     -7.105   -3.050   -4.995
 2OS           O2     O    O2        0.000     -5.637    0.351   -3.544
 2OS           C1     C    CH1       0.000     -6.511   -0.616   -4.148
 2OS           H1     H    H         0.000     -6.715   -0.344   -5.194
 2OS           C17    C    CH2       0.000     -7.818   -0.716   -3.362
 2OS           H171   H    H         0.000     -7.597   -0.943   -2.317
 2OS           H172   H    H         0.000     -8.436   -1.511   -3.783
 2OS           O1     O    OH1       0.000     -8.518    0.528   -3.443
 2OS           HO1    H    H         0.000     -9.305    0.492   -2.882
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 2OS      O7     n/a    C4     START
 2OS      C4     O7     O11    .
 2OS      C7     C4     C8     .
 2OS      H71    C7     .      .
 2OS      H72    C7     .      .
 2OS      C8     C7     C9     .
 2OS      H81    C8     .      .
 2OS      H82    C8     .      .
 2OS      C9     C8     C10    .
 2OS      H91    C9     .      .
 2OS      H92    C9     .      .
 2OS      C10    C9     C11    .
 2OS      H101   C10    .      .
 2OS      H102   C10    .      .
 2OS      C11    C10    C12    .
 2OS      H111   C11    .      .
 2OS      H112   C11    .      .
 2OS      C12    C11    C31    .
 2OS      H121   C12    .      .
 2OS      H122   C12    .      .
 2OS      C31    C12    H311   .
 2OS      H313   C31    .      .
 2OS      H312   C31    .      .
 2OS      H311   C31    .      .
 2OS      O11    C4     C27    .
 2OS      C27    O11    C16    .
 2OS      H27    C27    .      .
 2OS      C24    C27    O9     .
 2OS      H24    C24    .      .
 2OS      O9     C24    HO9    .
 2OS      HO9    O9     .      .
 2OS      C16    C27    C29    .
 2OS      H16    C16    .      .
 2OS      O13    C16    H13    .
 2OS      H13    O13    .      .
 2OS      C29    C16    O15    .
 2OS      H29    C29    .      .
 2OS      C32    C29    O17    .
 2OS      H321   C32    .      .
 2OS      H322   C32    .      .
 2OS      O17    C32    H17    .
 2OS      H17    O17    .      .
 2OS      O15    C29    C21    .
 2OS      C21    O15    O6     .
 2OS      H21    C21    .      .
 2OS      O6     C21    C13    .
 2OS      C13    O6     O2     .
 2OS      C18    C13    O3     .
 2OS      H181   C18    .      .
 2OS      H182   C18    .      .
 2OS      O3     C18    HO3    .
 2OS      HO3    O3     .      .
 2OS      C3     C13    C2     .
 2OS      H3     C3     .      .
 2OS      O5     C3     HO5    .
 2OS      HO5    O5     .      .
 2OS      C2     C3     O4     .
 2OS      H2     C2     .      .
 2OS      O4     C2     HO4    .
 2OS      HO4    O4     .      .
 2OS      O2     C13    C1     .
 2OS      C1     O2     C17    .
 2OS      H1     C1     .      .
 2OS      C17    C1     O1     .
 2OS      H171   C17    .      .
 2OS      H172   C17    .      .
 2OS      O1     C17    HO1    .
 2OS      HO1    O1     .      END
 2OS      C1     C2     .    ADD
 2OS      C21    C24    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 2OS      C7     C4        single      1.510    0.020
 2OS      O11    C4        deloc       1.454    0.020
 2OS      C4     O7        deloc       1.220    0.020
 2OS      C8     C7        single      1.524    0.020
 2OS      H71    C7        single      1.092    0.020
 2OS      H72    C7        single      1.092    0.020
 2OS      C9     C8        single      1.524    0.020
 2OS      H81    C8        single      1.092    0.020
 2OS      H82    C8        single      1.092    0.020
 2OS      C10    C9        single      1.524    0.020
 2OS      H91    C9        single      1.092    0.020
 2OS      H92    C9        single      1.092    0.020
 2OS      C11    C10       single      1.524    0.020
 2OS      H101   C10       single      1.092    0.020
 2OS      H102   C10       single      1.092    0.020
 2OS      C12    C11       single      1.524    0.020
 2OS      H111   C11       single      1.092    0.020
 2OS      H112   C11       single      1.092    0.020
 2OS      C31    C12       single      1.513    0.020
 2OS      H121   C12       single      1.092    0.020
 2OS      H122   C12       single      1.092    0.020
 2OS      C1     C2        single      1.524    0.020
 2OS      C1     O2        single      1.426    0.020
 2OS      C17    C1        single      1.524    0.020
 2OS      H1     C1        single      1.099    0.020
 2OS      C2     C3        single      1.524    0.020
 2OS      O4     C2        single      1.432    0.020
 2OS      H2     C2        single      1.099    0.020
 2OS      C3     C13       single      1.524    0.020
 2OS      O5     C3        single      1.432    0.020
 2OS      H3     C3        single      1.099    0.020
 2OS      O2     C13       single      1.426    0.020
 2OS      C18    C13       single      1.524    0.020
 2OS      C13    O6        single      1.426    0.020
 2OS      HO4    O4        single      0.967    0.020
 2OS      O1     C17       single      1.432    0.020
 2OS      H171   C17       single      1.092    0.020
 2OS      H172   C17       single      1.092    0.020
 2OS      HO1    O1        single      0.967    0.020
 2OS      O3     C18       single      1.432    0.020
 2OS      H181   C18       single      1.092    0.020
 2OS      H182   C18       single      1.092    0.020
 2OS      HO3    O3        single      0.967    0.020
 2OS      HO5    O5        single      0.967    0.020
 2OS      C21    C24       single      1.524    0.020
 2OS      C21    O15       single      1.426    0.020
 2OS      O6     C21       single      1.426    0.020
 2OS      H21    C21       single      1.099    0.020
 2OS      C24    C27       single      1.524    0.020
 2OS      O9     C24       single      1.432    0.020
 2OS      H24    C24       single      1.099    0.020
 2OS      C16    C27       single      1.524    0.020
 2OS      C27    O11       single      1.426    0.020
 2OS      H27    C27       single      1.099    0.020
 2OS      C29    C16       single      1.524    0.020
 2OS      O13    C16       single      1.432    0.020
 2OS      H16    C16       single      1.099    0.020
 2OS      O15    C29       single      1.426    0.020
 2OS      C32    C29       single      1.524    0.020
 2OS      H29    C29       single      1.099    0.020
 2OS      HO9    O9        single      0.967    0.020
 2OS      H13    O13       single      0.967    0.020
 2OS      O17    C32       single      1.432    0.020
 2OS      H321   C32       single      1.092    0.020
 2OS      H322   C32       single      1.092    0.020
 2OS      H17    O17       single      0.967    0.020
 2OS      H311   C31       single      1.059    0.020
 2OS      H312   C31       single      1.059    0.020
 2OS      H313   C31       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 2OS      O7     C4     C7      120.500    3.000
 2OS      O7     C4     O11     119.000    3.000
 2OS      C7     C4     O11     120.000    3.000
 2OS      C4     C7     H71     109.470    3.000
 2OS      C4     C7     H72     109.470    3.000
 2OS      C4     C7     C8      109.470    3.000
 2OS      H71    C7     H72     107.900    3.000
 2OS      H71    C7     C8      109.470    3.000
 2OS      H72    C7     C8      109.470    3.000
 2OS      C7     C8     H81     109.470    3.000
 2OS      C7     C8     H82     109.470    3.000
 2OS      C7     C8     C9      111.000    3.000
 2OS      H81    C8     H82     107.900    3.000
 2OS      H81    C8     C9      109.470    3.000
 2OS      H82    C8     C9      109.470    3.000
 2OS      C8     C9     H91     109.470    3.000
 2OS      C8     C9     H92     109.470    3.000
 2OS      C8     C9     C10     111.000    3.000
 2OS      H91    C9     H92     107.900    3.000
 2OS      H91    C9     C10     109.470    3.000
 2OS      H92    C9     C10     109.470    3.000
 2OS      C9     C10    H101    109.470    3.000
 2OS      C9     C10    H102    109.470    3.000
 2OS      C9     C10    C11     111.000    3.000
 2OS      H101   C10    H102    107.900    3.000
 2OS      H101   C10    C11     109.470    3.000
 2OS      H102   C10    C11     109.470    3.000
 2OS      C10    C11    H111    109.470    3.000
 2OS      C10    C11    H112    109.470    3.000
 2OS      C10    C11    C12     111.000    3.000
 2OS      H111   C11    H112    107.900    3.000
 2OS      H111   C11    C12     109.470    3.000
 2OS      H112   C11    C12     109.470    3.000
 2OS      C11    C12    H121    109.470    3.000
 2OS      C11    C12    H122    109.470    3.000
 2OS      C11    C12    C31     111.000    3.000
 2OS      H121   C12    H122    107.900    3.000
 2OS      H121   C12    C31     109.470    3.000
 2OS      H122   C12    C31     109.470    3.000
 2OS      C12    C31    H313    109.470    3.000
 2OS      C12    C31    H312    109.470    3.000
 2OS      C12    C31    H311    109.470    3.000
 2OS      H313   C31    H312    109.470    3.000
 2OS      H313   C31    H311    109.470    3.000
 2OS      H312   C31    H311    109.470    3.000
 2OS      C4     O11    C27     111.800    3.000
 2OS      O11    C27    H27     109.470    3.000
 2OS      O11    C27    C24     109.470    3.000
 2OS      O11    C27    C16     109.470    3.000
 2OS      H27    C27    C24     108.340    3.000
 2OS      H27    C27    C16     108.340    3.000
 2OS      C24    C27    C16     111.000    3.000
 2OS      C27    C24    H24     108.340    3.000
 2OS      C27    C24    O9      109.470    3.000
 2OS      C27    C24    C21     111.000    3.000
 2OS      H24    C24    O9      109.470    3.000
 2OS      H24    C24    C21     108.340    3.000
 2OS      O9     C24    C21     109.470    3.000
 2OS      C24    O9     HO9     109.470    3.000
 2OS      C27    C16    H16     108.340    3.000
 2OS      C27    C16    O13     109.470    3.000
 2OS      C27    C16    C29     111.000    3.000
 2OS      H16    C16    O13     109.470    3.000
 2OS      H16    C16    C29     108.340    3.000
 2OS      O13    C16    C29     109.470    3.000
 2OS      C16    O13    H13     109.470    3.000
 2OS      C16    C29    H29     108.340    3.000
 2OS      C16    C29    C32     111.000    3.000
 2OS      C16    C29    O15     109.470    3.000
 2OS      H29    C29    C32     108.340    3.000
 2OS      H29    C29    O15     109.470    3.000
 2OS      C32    C29    O15     109.470    3.000
 2OS      C29    C32    H321    109.470    3.000
 2OS      C29    C32    H322    109.470    3.000
 2OS      C29    C32    O17     109.470    3.000
 2OS      H321   C32    H322    107.900    3.000
 2OS      H321   C32    O17     109.470    3.000
 2OS      H322   C32    O17     109.470    3.000
 2OS      C32    O17    H17     109.470    3.000
 2OS      C29    O15    C21     111.800    3.000
 2OS      O15    C21    H21     109.470    3.000
 2OS      O15    C21    O6      109.470    3.000
 2OS      O15    C21    C24     109.470    3.000
 2OS      H21    C21    O6      109.470    3.000
 2OS      H21    C21    C24     108.340    3.000
 2OS      O6     C21    C24     109.470    3.000
 2OS      C21    O6     C13     111.800    3.000
 2OS      O6     C13    C3      109.470    3.000
 2OS      O6     C13    C18     109.470    3.000
 2OS      O6     C13    O2      109.500    3.000
 2OS      C3     C13    C18     111.000    3.000
 2OS      C3     C13    O2      109.470    3.000
 2OS      C18    C13    O2      109.470    3.000
 2OS      C13    C3     H3      108.340    3.000
 2OS      C13    C3     O5      109.470    3.000
 2OS      C13    C3     C2      111.000    3.000
 2OS      H3     C3     O5      109.470    3.000
 2OS      H3     C3     C2      108.340    3.000
 2OS      O5     C3     C2      109.470    3.000
 2OS      C3     O5     HO5     109.470    3.000
 2OS      C3     C2     H2      108.340    3.000
 2OS      C3     C2     O4      109.470    3.000
 2OS      C3     C2     C1      111.000    3.000
 2OS      H2     C2     O4      109.470    3.000
 2OS      H2     C2     C1      108.340    3.000
 2OS      O4     C2     C1      109.470    3.000
 2OS      C2     O4     HO4     109.470    3.000
 2OS      C13    C18    H181    109.470    3.000
 2OS      C13    C18    H182    109.470    3.000
 2OS      C13    C18    O3      109.470    3.000
 2OS      H181   C18    H182    107.900    3.000
 2OS      H181   C18    O3      109.470    3.000
 2OS      H182   C18    O3      109.470    3.000
 2OS      C18    O3     HO3     109.470    3.000
 2OS      C13    O2     C1      111.800    3.000
 2OS      O2     C1     H1      109.470    3.000
 2OS      O2     C1     C17     109.470    3.000
 2OS      O2     C1     C2      109.470    3.000
 2OS      H1     C1     C17     108.340    3.000
 2OS      H1     C1     C2      108.340    3.000
 2OS      C17    C1     C2      111.000    3.000
 2OS      C1     C17    H171    109.470    3.000
 2OS      C1     C17    H172    109.470    3.000
 2OS      C1     C17    O1      109.470    3.000
 2OS      H171   C17    H172    107.900    3.000
 2OS      H171   C17    O1      109.470    3.000
 2OS      H172   C17    O1      109.470    3.000
 2OS      C17    O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 2OS      var_1    O7     C4     C7     C8        -0.006   20.000   3
 2OS      var_2    C4     C7     C8     C9      -179.976   20.000   3
 2OS      var_3    C7     C8     C9     C10      179.947   20.000   3
 2OS      var_4    C8     C9     C10    C11      179.965   20.000   3
 2OS      var_5    C9     C10    C11    C12     -179.980   20.000   3
 2OS      var_6    C10    C11    C12    C31     -179.983   20.000   3
 2OS      var_7    C11    C12    C31    H311     179.982   20.000   3
 2OS      var_8    O7     C4     O11    C27        0.027   20.000   1
 2OS      var_9    C4     O11    C27    C16      149.814   20.000   1
 2OS      var_10   O11    C27    C24    O9        60.000   20.000   3
 2OS      var_11   C27    C24    O9     HO9      179.603   20.000   1
 2OS      var_12   O11    C27    C16    C29      180.000   20.000   3
 2OS      var_13   C27    C16    O13    H13     -179.927   20.000   1
 2OS      var_14   C27    C16    C29    O15      -60.000   20.000   3
 2OS      var_15   C16    C29    C32    O17     -173.174   20.000   3
 2OS      var_16   C29    C32    O17    H17     -175.034   20.000   1
 2OS      var_17   C16    C29    O15    C21       60.000   20.000   1
 2OS      var_18   C29    O15    C21    O6        60.000   20.000   1
 2OS      var_19   O15    C21    C24    C27       60.000   20.000   3
 2OS      var_20   O15    C21    O6     C13       94.589   20.000   1
 2OS      var_21   C21    O6     C13    O2       -44.044   20.000   1
 2OS      var_22   O6     C13    C3     C2        90.000   20.000   1
 2OS      var_23   C13    C3     O5     HO5      174.267   20.000   1
 2OS      var_24   C13    C3     C2     O4       150.000   20.000   3
 2OS      var_25   C3     C2     O4     HO4     -173.066   20.000   1
 2OS      var_26   O6     C13    C18    O3       -57.402   20.000   1
 2OS      var_27   C13    C18    O3     HO3     -179.958   20.000   1
 2OS      var_28   O6     C13    O2     C1      -120.000   20.000   1
 2OS      var_29   C13    O2     C1     C17      150.000   20.000   1
 2OS      var_30   O2     C1     C2     C3       -30.000   20.000   3
 2OS      var_31   O2     C1     C17    O1        64.588   20.000   3
 2OS      var_32   C1     C17    O1     HO1     -174.981   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 2OS      chir_01  C1     C2     O2     C17       positiv
 2OS      chir_02  C2     C1     C3     O4        positiv
 2OS      chir_03  C3     C2     C13    O5        negativ
 2OS      chir_04  C13    C3     O2     C18       positiv
 2OS      chir_05  C21    C24    O15    O6        positiv
 2OS      chir_06  C24    C21    C27    O9        negativ
 2OS      chir_07  C27    C24    C16    O11       positiv
 2OS      chir_08  C16    C27    C29    O13       negativ
 2OS      chir_09  C29    C16    O15    C32       positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 2OS      plan-1    C4        0.020
 2OS      plan-1    C7        0.000
 2OS      plan-1    O11       0.000
 2OS      plan-1    O7        0.000
# ------------------------------------------------------
`.trim();

monomers["1PS"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
1PS      1PS '3-PYRIDINIUM-1-YLPROPANE-1-SULFONATE' non-polymer        24  13 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_1PS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 1PS           O3     O    OS        0.000      0.000    0.000    0.000
 1PS           S1     S    ST        0.000     -0.863   -0.881   -0.771
 1PS           O1     O    OS       -1.000     -0.194   -1.263   -2.006
 1PS           O2     O    OS        0.000     -1.169   -2.071    0.008
 1PS           C8     C    CH2       0.000     -2.405   -0.013   -1.170
 1PS           H81    H    H         0.000     -3.055   -0.672   -1.750
 1PS           H82    H    H         0.000     -2.179    0.880   -1.756
 1PS           C7     C    CH2       0.000     -3.112    0.392    0.126
 1PS           H71    H    H         0.000     -2.461    1.050    0.705
 1PS           H72    H    H         0.000     -3.337   -0.502    0.711
 1PS           C6     C    CH2       0.000     -4.413    1.124   -0.210
 1PS           H61    H    H         0.000     -5.062    0.465   -0.789
 1PS           H62    H    H         0.000     -4.186    2.017   -0.796
 1PS           N1     N    NR6       1.000     -5.090    1.511    1.031
 1PS           C3     C    CR16      0.000     -5.957    0.680    1.575
 1PS           H3     H    H         0.000     -6.159   -0.272    1.099
 1PS           C4     C    CR16      0.000     -6.610    1.009    2.748
 1PS           H4     H    H         0.000     -7.315    0.319    3.195
 1PS           C5     C    CR16      0.000     -6.353    2.233    3.345
 1PS           H5     H    H         0.000     -6.854    2.519    4.261
 1PS           C2     C    CR16      0.000     -5.438    3.082    2.740
 1PS           H2     H    H         0.000     -5.212    4.046    3.180
 1PS           C1     C    CR16      0.000     -4.820    2.684    1.571
 1PS           H1     H    H         0.000     -4.106    3.342    1.092
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 1PS      O3     n/a    S1     START
 1PS      S1     O3     C8     .
 1PS      O1     S1     .      .
 1PS      O2     S1     .      .
 1PS      C8     S1     C7     .
 1PS      H81    C8     .      .
 1PS      H82    C8     .      .
 1PS      C7     C8     C6     .
 1PS      H71    C7     .      .
 1PS      H72    C7     .      .
 1PS      C6     C7     N1     .
 1PS      H61    C6     .      .
 1PS      H62    C6     .      .
 1PS      N1     C6     C3     .
 1PS      C3     N1     C4     .
 1PS      H3     C3     .      .
 1PS      C4     C3     C5     .
 1PS      H4     C4     .      .
 1PS      C5     C4     C2     .
 1PS      H5     C5     .      .
 1PS      C2     C5     C1     .
 1PS      H2     C2     .      .
 1PS      C1     C2     H1     .
 1PS      H1     C1     .      END
 1PS      N1     C1     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 1PS      N1     C1        single      1.337    0.020
 1PS      C3     N1        double      1.337    0.020
 1PS      N1     C6        single      1.465    0.020
 1PS      C1     C2        double      1.390    0.020
 1PS      H1     C1        single      1.083    0.020
 1PS      C2     C5        single      1.390    0.020
 1PS      H2     C2        single      1.083    0.020
 1PS      C4     C3        single      1.390    0.020
 1PS      H3     C3        single      1.083    0.020
 1PS      C5     C4        double      1.390    0.020
 1PS      H4     C4        single      1.083    0.020
 1PS      H5     C5        single      1.083    0.020
 1PS      C6     C7        single      1.524    0.020
 1PS      H61    C6        single      1.092    0.020
 1PS      H62    C6        single      1.092    0.020
 1PS      C7     C8        single      1.524    0.020
 1PS      H71    C7        single      1.092    0.020
 1PS      H72    C7        single      1.092    0.020
 1PS      C8     S1        single      1.662    0.020
 1PS      H81    C8        single      1.092    0.020
 1PS      H82    C8        single      1.092    0.020
 1PS      O1     S1        deloc       1.480    0.020
 1PS      O2     S1        deloc       1.480    0.020
 1PS      S1     O3        deloc       1.480    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 1PS      O3     S1     O1      109.500    3.000
 1PS      O3     S1     O2      109.500    3.000
 1PS      O3     S1     C8      109.500    3.000
 1PS      O1     S1     O2      109.500    3.000
 1PS      O1     S1     C8      109.500    3.000
 1PS      O2     S1     C8      109.500    3.000
 1PS      S1     C8     H81     109.500    3.000
 1PS      S1     C8     H82     109.500    3.000
 1PS      S1     C8     C7      109.500    3.000
 1PS      H81    C8     H82     107.900    3.000
 1PS      H81    C8     C7      109.470    3.000
 1PS      H82    C8     C7      109.470    3.000
 1PS      C8     C7     H71     109.470    3.000
 1PS      C8     C7     H72     109.470    3.000
 1PS      C8     C7     C6      111.000    3.000
 1PS      H71    C7     H72     107.900    3.000
 1PS      H71    C7     C6      109.470    3.000
 1PS      H72    C7     C6      109.470    3.000
 1PS      C7     C6     H61     109.470    3.000
 1PS      C7     C6     H62     109.470    3.000
 1PS      C7     C6     N1      109.470    3.000
 1PS      H61    C6     H62     107.900    3.000
 1PS      H61    C6     N1      109.470    3.000
 1PS      H62    C6     N1      109.470    3.000
 1PS      C6     N1     C3      120.000    3.000
 1PS      C6     N1     C1      120.000    3.000
 1PS      C3     N1     C1      120.000    3.000
 1PS      N1     C3     H3      120.000    3.000
 1PS      N1     C3     C4      120.000    3.000
 1PS      H3     C3     C4      120.000    3.000
 1PS      C3     C4     H4      120.000    3.000
 1PS      C3     C4     C5      120.000    3.000
 1PS      H4     C4     C5      120.000    3.000
 1PS      C4     C5     H5      120.000    3.000
 1PS      C4     C5     C2      120.000    3.000
 1PS      H5     C5     C2      120.000    3.000
 1PS      C5     C2     H2      120.000    3.000
 1PS      C5     C2     C1      120.000    3.000
 1PS      H2     C2     C1      120.000    3.000
 1PS      C2     C1     H1      120.000    3.000
 1PS      C2     C1     N1      120.000    3.000
 1PS      H1     C1     N1      120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 1PS      var_1    O3     S1     C8     C7       -59.981   20.000   1
 1PS      var_2    S1     C8     C7     C6       179.991   20.000   3
 1PS      var_3    C8     C7     C6     N1      -179.995   20.000   3
 1PS      var_4    C7     C6     N1     C3       -90.292   20.000   1
 1PS      CONST_1  C6     N1     C1     C2       180.000    0.000   0
 1PS      CONST_2  C6     N1     C3     C4       180.000    0.000   0
 1PS      CONST_3  N1     C3     C4     C5         0.000    0.000   0
 1PS      CONST_4  C3     C4     C5     C2         0.000    0.000   0
 1PS      CONST_5  C4     C5     C2     C1         0.000    0.000   0
 1PS      CONST_6  C5     C2     C1     N1         0.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 1PS      chir_01  S1     C8     O1     O2        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 1PS      plan-1    N1        0.020
 1PS      plan-1    C1        0.020
 1PS      plan-1    C3        0.020
 1PS      plan-1    C6        0.020
 1PS      plan-1    C2        0.020
 1PS      plan-1    C4        0.020
 1PS      plan-1    C5        0.020
 1PS      plan-1    H1        0.020
 1PS      plan-1    H2        0.020
 1PS      plan-1    H3        0.020
 1PS      plan-1    H4        0.020
 1PS      plan-1    H5        0.020
# ------------------------------------------------------
`.trim();

monomers["CPS"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CPS      CPS '3-[(3-CHOLAMIDOPROPYL)DIMETHYLAMMONI' non-polymer       100  42 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CPS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CPS           O1S    O    OS        0.000      0.000    0.000    0.000
 CPS           S      S    ST        0.000     -0.166   -1.446    0.030
 CPS           O2S    O    OS       -1.000     -0.256   -1.910    1.406
 CPS           O3S    O    OS        0.000      0.950   -2.091   -0.643
 CPS           C32    C    CH2       0.000     -1.699   -1.876   -0.835
 CPS           H32    H    H         0.000     -1.833   -2.960   -0.820
 CPS           H32A   H    H         0.000     -1.641   -1.532   -1.870
 CPS           C31    C    CH2       0.000     -2.885   -1.204   -0.140
 CPS           H31    H    H         0.000     -2.749   -0.121   -0.156
 CPS           H31A   H    H         0.000     -2.940   -1.548    0.896
 CPS           C30    C    CH2       0.000     -4.179   -1.569   -0.870
 CPS           H30    H    H         0.000     -4.313   -2.653   -0.854
 CPS           H30A   H    H         0.000     -4.121   -1.226   -1.905
 CPS           N2     N    NT        1.000     -5.317   -0.923   -0.201
 CPS           C28    C    CH3       0.000     -5.135    0.535   -0.223
 CPS           H28B   H    H         0.000     -4.239    0.786    0.283
 CPS           H28A   H    H         0.000     -5.079    0.869   -1.226
 CPS           H28    H    H         0.000     -5.955    1.000    0.259
 CPS           C29    C    CH3       0.000     -5.393   -1.386    1.192
 CPS           H29B   H    H         0.000     -4.497   -1.134    1.697
 CPS           H29A   H    H         0.000     -6.213   -0.920    1.674
 CPS           H29    H    H         0.000     -5.525   -2.437    1.208
 CPS           C27    C    CH2       0.000     -6.559   -1.272   -0.903
 CPS           H271   H    H         0.000     -6.693   -2.356   -0.888
 CPS           H272   H    H         0.000     -6.501   -0.928   -1.937
 CPS           C26    C    CH2       0.000     -7.744   -0.601   -0.206
 CPS           H261   H    H         0.000     -7.608    0.483   -0.221
 CPS           H262   H    H         0.000     -7.800   -0.945    0.829
 CPS           C25    C    CH2       0.000     -9.039   -0.964   -0.936
 CPS           H25    H    H         0.000     -9.172   -2.048   -0.921
 CPS           H25A   H    H         0.000     -8.981   -0.621   -1.971
 CPS           N1     N    NH1       0.000    -10.173   -0.321   -0.269
 CPS           HN1    H    H         0.000    -10.019    0.257    0.544
 CPS           C24    C    C         0.000    -11.422   -0.500   -0.741
 CPS           O1     O    O         0.000    -11.607   -1.195   -1.718
 CPS           C23    C    CH2       0.000    -12.590    0.161   -0.056
 CPS           H23    H    H         0.000    -12.454    1.245   -0.071
 CPS           H23A   H    H         0.000    -12.646   -0.182    0.979
 CPS           C22    C    CH2       0.000    -13.884   -0.202   -0.786
 CPS           H22    H    H         0.000    -14.018   -1.286   -0.771
 CPS           H22A   H    H         0.000    -13.826    0.142   -1.821
 CPS           C20    C    CH1       0.000    -15.069    0.470   -0.089
 CPS           H20    H    H         0.000    -15.074    0.193    0.974
 CPS           C21    C    CH3       0.000    -14.943    1.989   -0.222
 CPS           H21B   H    H         0.000    -14.010    2.302    0.170
 CPS           H21A   H    H         0.000    -15.006    2.262   -1.243
 CPS           H21    H    H         0.000    -15.726    2.458    0.317
 CPS           C9     C    CH1       0.000    -16.374    0.007   -0.742
 CPS           H9     H    H         0.000    -16.413    0.336   -1.790
 CPS           C5     C    CT        0.000    -17.572    0.552    0.028
 CPS           C10    C    CH3       0.000    -17.217    0.687    1.509
 CPS           H10B   H    H         0.000    -16.836   -0.234    1.868
 CPS           H10A   H    H         0.000    -16.484    1.442    1.631
 CPS           H10    H    H         0.000    -18.085    0.947    2.059
 CPS           C4     C    CH1       0.000    -18.168    1.852   -0.477
 CPS           H4     H    H         0.000    -17.415    2.651   -0.431
 CPS           O4     O    OH1       0.000    -18.622    1.688   -1.822
 CPS           HO4    H    H         0.000    -19.031    2.509   -2.126
 CPS           C8     C    CH2       0.000    -16.495   -1.531   -0.657
 CPS           H8     H    H         0.000    -15.659   -1.960   -0.101
 CPS           H8A    H    H         0.000    -16.535   -1.977   -1.653
 CPS           C7     C    CH2       0.000    -17.822   -1.821    0.096
 CPS           H7     H    H         0.000    -17.674   -1.957    1.169
 CPS           H7A    H    H         0.000    -18.354   -2.684   -0.309
 CPS           C6     C    CH1       0.000    -18.643   -0.551   -0.151
 CPS           H6     H    H         0.000    -19.039   -0.541   -1.177
 CPS           C18    C    CH1       0.000    -19.748   -0.269    0.848
 CPS           H18    H    H         0.000    -19.331   -0.207    1.863
 CPS           C19    C    CH1       0.000    -20.386    1.074    0.459
 CPS           H19    H    H         0.000    -20.824    0.979   -0.545
 CPS           C3     C    CH2       0.000    -19.354    2.197    0.438
 CPS           H3A    H    H         0.000    -18.995    2.355    1.457
 CPS           H3     H    H         0.000    -19.840    3.106    0.079
 CPS           C2     C    CT        0.000    -21.501    1.405    1.452
 CPS           C11    C    CH3       0.000    -20.917    1.485    2.864
 CPS           H11B   H    H         0.000    -20.479    0.554    3.120
 CPS           H11A   H    H         0.000    -20.178    2.243    2.900
 CPS           H11    H    H         0.000    -21.688    1.712    3.554
 CPS           C17    C    CH1       0.000    -20.814   -1.364    0.785
 CPS           H17    H    H         0.000    -20.363   -2.330    1.051
 CPS           O3     O    OH1       0.000    -21.347   -1.434   -0.538
 CPS           HO3    H    H         0.000    -22.021   -2.126   -0.577
 CPS           C16    C    CH2       0.000    -21.938   -1.036    1.770
 CPS           H16    H    H         0.000    -21.530   -0.984    2.782
 CPS           H16A   H    H         0.000    -22.699   -1.819    1.726
 CPS           C15    C    CH1       0.000    -22.567    0.309    1.402
 CPS           H15    H    H         0.000    -23.367    0.546    2.117
 CPS           C14    C    CH2       0.000    -23.153    0.230   -0.008
 CPS           H14    H    H         0.000    -23.912   -0.554   -0.043
 CPS           H14A   H    H         0.000    -22.358   -0.003   -0.720
 CPS           C13    C    CH1       0.000    -23.787    1.574   -0.372
 CPS           H13    H    H         0.000    -24.585    1.808    0.347
 CPS           O2     O    OH1       0.000    -24.338    1.501   -1.689
 CPS           HO2    H    H         0.000    -24.739    2.351   -1.917
 CPS           C12    C    CH2       0.000    -22.721    2.671   -0.324
 CPS           H12    H    H         0.000    -23.175    3.629   -0.584
 CPS           H12A   H    H         0.000    -21.929    2.439   -1.039
 CPS           C1     C    CH2       0.000    -22.132    2.750    1.085
 CPS           H1A    H    H         0.000    -22.924    2.988    1.798
 CPS           H1     H    H         0.000    -21.369    3.531    1.117
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CPS      O1S    n/a    S      START
 CPS      S      O1S    C32    .
 CPS      O2S    S      .      .
 CPS      O3S    S      .      .
 CPS      C32    S      C31    .
 CPS      H32    C32    .      .
 CPS      H32A   C32    .      .
 CPS      C31    C32    C30    .
 CPS      H31    C31    .      .
 CPS      H31A   C31    .      .
 CPS      C30    C31    N2     .
 CPS      H30    C30    .      .
 CPS      H30A   C30    .      .
 CPS      N2     C30    C27    .
 CPS      C28    N2     H28    .
 CPS      H28B   C28    .      .
 CPS      H28A   C28    .      .
 CPS      H28    C28    .      .
 CPS      C29    N2     H29    .
 CPS      H29B   C29    .      .
 CPS      H29A   C29    .      .
 CPS      H29    C29    .      .
 CPS      C27    N2     C26    .
 CPS      H271   C27    .      .
 CPS      H272   C27    .      .
 CPS      C26    C27    C25    .
 CPS      H261   C26    .      .
 CPS      H262   C26    .      .
 CPS      C25    C26    N1     .
 CPS      H25    C25    .      .
 CPS      H25A   C25    .      .
 CPS      N1     C25    C24    .
 CPS      HN1    N1     .      .
 CPS      C24    N1     C23    .
 CPS      O1     C24    .      .
 CPS      C23    C24    C22    .
 CPS      H23    C23    .      .
 CPS      H23A   C23    .      .
 CPS      C22    C23    C20    .
 CPS      H22    C22    .      .
 CPS      H22A   C22    .      .
 CPS      C20    C22    C9     .
 CPS      H20    C20    .      .
 CPS      C21    C20    H21    .
 CPS      H21B   C21    .      .
 CPS      H21A   C21    .      .
 CPS      H21    C21    .      .
 CPS      C9     C20    C8     .
 CPS      H9     C9     .      .
 CPS      C5     C9     C4     .
 CPS      C10    C5     H10    .
 CPS      H10B   C10    .      .
 CPS      H10A   C10    .      .
 CPS      H10    C10    .      .
 CPS      C4     C5     O4     .
 CPS      H4     C4     .      .
 CPS      O4     C4     HO4    .
 CPS      HO4    O4     .      .
 CPS      C8     C9     C7     .
 CPS      H8     C8     .      .
 CPS      H8A    C8     .      .
 CPS      C7     C8     C6     .
 CPS      H7     C7     .      .
 CPS      H7A    C7     .      .
 CPS      C6     C7     C18    .
 CPS      H6     C6     .      .
 CPS      C18    C6     C17    .
 CPS      H18    C18    .      .
 CPS      C19    C18    C2     .
 CPS      H19    C19    .      .
 CPS      C3     C19    H3     .
 CPS      H3A    C3     .      .
 CPS      H3     C3     .      .
 CPS      C2     C19    C11    .
 CPS      C11    C2     H11    .
 CPS      H11B   C11    .      .
 CPS      H11A   C11    .      .
 CPS      H11    C11    .      .
 CPS      C17    C18    C16    .
 CPS      H17    C17    .      .
 CPS      O3     C17    HO3    .
 CPS      HO3    O3     .      .
 CPS      C16    C17    C15    .
 CPS      H16    C16    .      .
 CPS      H16A   C16    .      .
 CPS      C15    C16    C14    .
 CPS      H15    C15    .      .
 CPS      C14    C15    C13    .
 CPS      H14    C14    .      .
 CPS      H14A   C14    .      .
 CPS      C13    C14    C12    .
 CPS      H13    C13    .      .
 CPS      O2     C13    HO2    .
 CPS      HO2    O2     .      .
 CPS      C12    C13    C1     .
 CPS      H12    C12    .      .
 CPS      H12A   C12    .      .
 CPS      C1     C12    H1     .
 CPS      H1A    C1     .      .
 CPS      H1     C1     .      END
 CPS      C1     C2     .    ADD
 CPS      C2     C15    .    ADD
 CPS      C3     C4     .    ADD
 CPS      C5     C6     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CPS      C1     C2        single      1.524    0.020
 CPS      C1     C12       single      1.524    0.020
 CPS      C11    C2        single      1.524    0.020
 CPS      C2     C15       single      1.524    0.020
 CPS      C2     C19       single      1.524    0.020
 CPS      C3     C4        single      1.524    0.020
 CPS      C3     C19       single      1.524    0.020
 CPS      C4     C5        single      1.524    0.020
 CPS      O4     C4        single      1.432    0.020
 CPS      C5     C6        single      1.524    0.020
 CPS      C5     C9        single      1.524    0.020
 CPS      C10    C5        single      1.524    0.020
 CPS      C6     C7        single      1.524    0.020
 CPS      C18    C6        single      1.524    0.020
 CPS      C7     C8        single      1.524    0.020
 CPS      C8     C9        single      1.524    0.020
 CPS      C9     C20       single      1.524    0.020
 CPS      C12    C13       single      1.524    0.020
 CPS      C13    C14       single      1.524    0.020
 CPS      O2     C13       single      1.432    0.020
 CPS      C14    C15       single      1.524    0.020
 CPS      C15    C16       single      1.524    0.020
 CPS      C16    C17       single      1.524    0.020
 CPS      C17    C18       single      1.524    0.020
 CPS      O3     C17       single      1.432    0.020
 CPS      C19    C18       single      1.524    0.020
 CPS      C21    C20       single      1.524    0.020
 CPS      C20    C22       single      1.524    0.020
 CPS      C22    C23       single      1.524    0.020
 CPS      C23    C24       single      1.510    0.020
 CPS      C24    N1        single      1.330    0.020
 CPS      O1     C24       double      1.220    0.020
 CPS      C25    C26       single      1.524    0.020
 CPS      N1     C25       single      1.450    0.020
 CPS      C26    C27       single      1.524    0.020
 CPS      C27    N2        single      1.469    0.020
 CPS      C28    N2        single      1.469    0.020
 CPS      C29    N2        single      1.469    0.020
 CPS      C30    C31       single      1.524    0.020
 CPS      N2     C30       single      1.469    0.020
 CPS      C31    C32       single      1.524    0.020
 CPS      C32    S         single      1.662    0.020
 CPS      O2S    S         deloc       1.480    0.020
 CPS      O3S    S         deloc       1.480    0.020
 CPS      S      O1S       deloc       1.480    0.020
 CPS      H1     C1        single      1.092    0.020
 CPS      H1A    C1        single      1.092    0.020
 CPS      H3     C3        single      1.092    0.020
 CPS      H3A    C3        single      1.092    0.020
 CPS      H4     C4        single      1.099    0.020
 CPS      H6     C6        single      1.099    0.020
 CPS      H7     C7        single      1.092    0.020
 CPS      H7A    C7        single      1.092    0.020
 CPS      H8     C8        single      1.092    0.020
 CPS      H8A    C8        single      1.092    0.020
 CPS      H9     C9        single      1.099    0.020
 CPS      H10    C10       single      1.059    0.020
 CPS      H10A   C10       single      1.059    0.020
 CPS      H10B   C10       single      1.059    0.020
 CPS      H11    C11       single      1.059    0.020
 CPS      H11A   C11       single      1.059    0.020
 CPS      H11B   C11       single      1.059    0.020
 CPS      H12    C12       single      1.092    0.020
 CPS      H12A   C12       single      1.092    0.020
 CPS      H13    C13       single      1.099    0.020
 CPS      H14    C14       single      1.092    0.020
 CPS      H14A   C14       single      1.092    0.020
 CPS      H15    C15       single      1.099    0.020
 CPS      H16    C16       single      1.092    0.020
 CPS      H16A   C16       single      1.092    0.020
 CPS      H17    C17       single      1.099    0.020
 CPS      H18    C18       single      1.099    0.020
 CPS      H19    C19       single      1.099    0.020
 CPS      H20    C20       single      1.099    0.020
 CPS      H21    C21       single      1.059    0.020
 CPS      H21A   C21       single      1.059    0.020
 CPS      H21B   C21       single      1.059    0.020
 CPS      H22    C22       single      1.092    0.020
 CPS      H22A   C22       single      1.092    0.020
 CPS      H23    C23       single      1.092    0.020
 CPS      H23A   C23       single      1.092    0.020
 CPS      H25    C25       single      1.092    0.020
 CPS      H25A   C25       single      1.092    0.020
 CPS      H261   C26       single      1.092    0.020
 CPS      H271   C27       single      1.092    0.020
 CPS      H28    C28       single      1.059    0.020
 CPS      H28A   C28       single      1.059    0.020
 CPS      H28B   C28       single      1.059    0.020
 CPS      H29    C29       single      1.059    0.020
 CPS      H29A   C29       single      1.059    0.020
 CPS      H29B   C29       single      1.059    0.020
 CPS      H30    C30       single      1.092    0.020
 CPS      H30A   C30       single      1.092    0.020
 CPS      H31    C31       single      1.092    0.020
 CPS      H31A   C31       single      1.092    0.020
 CPS      H32    C32       single      1.092    0.020
 CPS      H32A   C32       single      1.092    0.020
 CPS      HN1    N1        single      1.010    0.020
 CPS      HO2    O2        single      0.967    0.020
 CPS      HO3    O3        single      0.967    0.020
 CPS      HO4    O4        single      0.967    0.020
 CPS      H262   C26       single      1.092    0.020
 CPS      H272   C27       single      1.092    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CPS      O1S    S      O2S     109.500    3.000
 CPS      O1S    S      O3S     109.500    3.000
 CPS      O1S    S      C32     109.500    3.000
 CPS      O2S    S      O3S     109.500    3.000
 CPS      O2S    S      C32     109.500    3.000
 CPS      O3S    S      C32     109.500    3.000
 CPS      S      C32    H32     109.500    3.000
 CPS      S      C32    H32A    109.500    3.000
 CPS      S      C32    C31     109.500    3.000
 CPS      H32    C32    H32A    107.900    3.000
 CPS      H32    C32    C31     109.470    3.000
 CPS      H32A   C32    C31     109.470    3.000
 CPS      C32    C31    H31     109.470    3.000
 CPS      C32    C31    H31A    109.470    3.000
 CPS      C32    C31    C30     111.000    3.000
 CPS      H31    C31    H31A    107.900    3.000
 CPS      H31    C31    C30     109.470    3.000
 CPS      H31A   C31    C30     109.470    3.000
 CPS      C31    C30    H30     109.470    3.000
 CPS      C31    C30    H30A    109.470    3.000
 CPS      C31    C30    N2      109.470    3.000
 CPS      H30    C30    H30A    107.900    3.000
 CPS      H30    C30    N2      109.470    3.000
 CPS      H30A   C30    N2      109.470    3.000
 CPS      C30    N2     C28     109.470    3.000
 CPS      C30    N2     C29     109.470    3.000
 CPS      C30    N2     C27     109.470    3.000
 CPS      C28    N2     C29     109.470    3.000
 CPS      C28    N2     C27     109.470    3.000
 CPS      C29    N2     C27     109.470    3.000
 CPS      N2     C28    H28B    109.470    3.000
 CPS      N2     C28    H28A    109.470    3.000
 CPS      N2     C28    H28     109.470    3.000
 CPS      H28B   C28    H28A    109.470    3.000
 CPS      H28B   C28    H28     109.470    3.000
 CPS      H28A   C28    H28     109.470    3.000
 CPS      N2     C29    H29B    109.470    3.000
 CPS      N2     C29    H29A    109.470    3.000
 CPS      N2     C29    H29     109.470    3.000
 CPS      H29B   C29    H29A    109.470    3.000
 CPS      H29B   C29    H29     109.470    3.000
 CPS      H29A   C29    H29     109.470    3.000
 CPS      N2     C27    H271    109.470    3.000
 CPS      N2     C27    H272    109.470    3.000
 CPS      N2     C27    C26     109.470    3.000
 CPS      H271   C27    H272    107.900    3.000
 CPS      H271   C27    C26     109.470    3.000
 CPS      H272   C27    C26     109.470    3.000
 CPS      C27    C26    H261    109.470    3.000
 CPS      C27    C26    H262    109.470    3.000
 CPS      C27    C26    C25     111.000    3.000
 CPS      H261   C26    H262    107.900    3.000
 CPS      H261   C26    C25     109.470    3.000
 CPS      H262   C26    C25     109.470    3.000
 CPS      C26    C25    H25     109.470    3.000
 CPS      C26    C25    H25A    109.470    3.000
 CPS      C26    C25    N1      112.000    3.000
 CPS      H25    C25    H25A    107.900    3.000
 CPS      H25    C25    N1      109.470    3.000
 CPS      H25A   C25    N1      109.470    3.000
 CPS      C25    N1     HN1     118.500    3.000
 CPS      C25    N1     C24     121.500    3.000
 CPS      HN1    N1     C24     120.000    3.000
 CPS      N1     C24    O1      123.000    3.000
 CPS      N1     C24    C23     116.500    3.000
 CPS      O1     C24    C23     120.500    3.000
 CPS      C24    C23    H23     109.470    3.000
 CPS      C24    C23    H23A    109.470    3.000
 CPS      C24    C23    C22     109.470    3.000
 CPS      H23    C23    H23A    107.900    3.000
 CPS      H23    C23    C22     109.470    3.000
 CPS      H23A   C23    C22     109.470    3.000
 CPS      C23    C22    H22     109.470    3.000
 CPS      C23    C22    H22A    109.470    3.000
 CPS      C23    C22    C20     111.000    3.000
 CPS      H22    C22    H22A    107.900    3.000
 CPS      H22    C22    C20     109.470    3.000
 CPS      H22A   C22    C20     109.470    3.000
 CPS      C22    C20    H20     108.340    3.000
 CPS      C22    C20    C21     111.000    3.000
 CPS      C22    C20    C9      111.000    3.000
 CPS      H20    C20    C21     108.340    3.000
 CPS      H20    C20    C9      108.340    3.000
 CPS      C21    C20    C9      111.000    3.000
 CPS      C20    C21    H21B    109.470    3.000
 CPS      C20    C21    H21A    109.470    3.000
 CPS      C20    C21    H21     109.470    3.000
 CPS      H21B   C21    H21A    109.470    3.000
 CPS      H21B   C21    H21     109.470    3.000
 CPS      H21A   C21    H21     109.470    3.000
 CPS      C20    C9     H9      108.340    3.000
 CPS      C20    C9     C5      111.000    3.000
 CPS      C20    C9     C8      111.000    3.000
 CPS      H9     C9     C5      108.340    3.000
 CPS      H9     C9     C8      108.340    3.000
 CPS      C5     C9     C8      111.000    3.000
 CPS      C9     C5     C10     111.000    3.000
 CPS      C9     C5     C4      111.000    3.000
 CPS      C9     C5     C6      111.000    3.000
 CPS      C10    C5     C4      111.000    3.000
 CPS      C10    C5     C6      111.000    3.000
 CPS      C4     C5     C6      111.000    3.000
 CPS      C5     C10    H10B    109.470    3.000
 CPS      C5     C10    H10A    109.470    3.000
 CPS      C5     C10    H10     109.470    3.000
 CPS      H10B   C10    H10A    109.470    3.000
 CPS      H10B   C10    H10     109.470    3.000
 CPS      H10A   C10    H10     109.470    3.000
 CPS      C5     C4     H4      108.340    3.000
 CPS      C5     C4     O4      109.470    3.000
 CPS      C5     C4     C3      111.000    3.000
 CPS      H4     C4     O4      109.470    3.000
 CPS      H4     C4     C3      108.340    3.000
 CPS      O4     C4     C3      109.470    3.000
 CPS      C4     O4     HO4     109.470    3.000
 CPS      C9     C8     H8      109.470    3.000
 CPS      C9     C8     H8A     109.470    3.000
 CPS      C9     C8     C7      111.000    3.000
 CPS      H8     C8     H8A     107.900    3.000
 CPS      H8     C8     C7      109.470    3.000
 CPS      H8A    C8     C7      109.470    3.000
 CPS      C8     C7     H7      109.470    3.000
 CPS      C8     C7     H7A     109.470    3.000
 CPS      C8     C7     C6      111.000    3.000
 CPS      H7     C7     H7A     107.900    3.000
 CPS      H7     C7     C6      109.470    3.000
 CPS      H7A    C7     C6      109.470    3.000
 CPS      C7     C6     H6      108.340    3.000
 CPS      C7     C6     C18     111.000    3.000
 CPS      C7     C6     C5      111.000    3.000
 CPS      H6     C6     C18     108.340    3.000
 CPS      H6     C6     C5      108.340    3.000
 CPS      C18    C6     C5      111.000    3.000
 CPS      C6     C18    H18     108.340    3.000
 CPS      C6     C18    C19     111.000    3.000
 CPS      C6     C18    C17     111.000    3.000
 CPS      H18    C18    C19     108.340    3.000
 CPS      H18    C18    C17     108.340    3.000
 CPS      C19    C18    C17     111.000    3.000
 CPS      C18    C19    H19     108.340    3.000
 CPS      C18    C19    C3      111.000    3.000
 CPS      C18    C19    C2      111.000    3.000
 CPS      H19    C19    C3      108.340    3.000
 CPS      H19    C19    C2      108.340    3.000
 CPS      C3     C19    C2      111.000    3.000
 CPS      C19    C3     H3A     109.470    3.000
 CPS      C19    C3     H3      109.470    3.000
 CPS      C19    C3     C4      111.000    3.000
 CPS      H3A    C3     H3      107.900    3.000
 CPS      H3A    C3     C4      109.470    3.000
 CPS      H3     C3     C4      109.470    3.000
 CPS      C19    C2     C11     111.000    3.000
 CPS      C19    C2     C1      111.000    3.000
 CPS      C19    C2     C15     111.000    3.000
 CPS      C1     C2     C15     111.000    3.000
 CPS      C11    C2     C1      111.000    3.000
 CPS      C11    C2     C15     111.000    3.000
 CPS      C2     C11    H11B    109.470    3.000
 CPS      C2     C11    H11A    109.470    3.000
 CPS      C2     C11    H11     109.470    3.000
 CPS      H11B   C11    H11A    109.470    3.000
 CPS      H11B   C11    H11     109.470    3.000
 CPS      H11A   C11    H11     109.470    3.000
 CPS      C18    C17    H17     108.340    3.000
 CPS      C18    C17    O3      109.470    3.000
 CPS      C18    C17    C16     111.000    3.000
 CPS      H17    C17    O3      109.470    3.000
 CPS      H17    C17    C16     108.340    3.000
 CPS      O3     C17    C16     109.470    3.000
 CPS      C17    O3     HO3     109.470    3.000
 CPS      C17    C16    H16     109.470    3.000
 CPS      C17    C16    H16A    109.470    3.000
 CPS      C17    C16    C15     111.000    3.000
 CPS      H16    C16    H16A    107.900    3.000
 CPS      H16    C16    C15     109.470    3.000
 CPS      H16A   C16    C15     109.470    3.000
 CPS      C16    C15    H15     108.340    3.000
 CPS      C16    C15    C14     109.470    3.000
 CPS      C16    C15    C2      111.000    3.000
 CPS      H15    C15    C14     108.340    3.000
 CPS      H15    C15    C2      108.340    3.000
 CPS      C14    C15    C2      111.000    3.000
 CPS      C15    C14    H14     109.470    3.000
 CPS      C15    C14    H14A    109.470    3.000
 CPS      C15    C14    C13     111.000    3.000
 CPS      H14    C14    H14A    107.900    3.000
 CPS      H14    C14    C13     109.470    3.000
 CPS      H14A   C14    C13     109.470    3.000
 CPS      C14    C13    H13     108.340    3.000
 CPS      C14    C13    O2      109.470    3.000
 CPS      C14    C13    C12     109.470    3.000
 CPS      H13    C13    O2      109.470    3.000
 CPS      H13    C13    C12     108.340    3.000
 CPS      O2     C13    C12     109.470    3.000
 CPS      C13    O2     HO2     109.470    3.000
 CPS      C13    C12    H12     109.470    3.000
 CPS      C13    C12    H12A    109.470    3.000
 CPS      C13    C12    C1      111.000    3.000
 CPS      H12    C12    H12A    107.900    3.000
 CPS      H12    C12    C1      109.470    3.000
 CPS      H12A   C12    C1      109.470    3.000
 CPS      C12    C1     H1A     109.470    3.000
 CPS      C12    C1     H1      109.470    3.000
 CPS      C12    C1     C2      111.000    3.000
 CPS      H1A    C1     H1      107.900    3.000
 CPS      H1A    C1     C2      109.470    3.000
 CPS      H1     C1     C2      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CPS      var_1    O1S    S      C32    C31      -60.010   20.000   1
 CPS      var_2    S      C32    C31    C30     -179.957   20.000   3
 CPS      var_3    C32    C31    C30    N2      -179.998   20.000   3
 CPS      var_4    C31    C30    N2     C27      179.960   20.000   1
 CPS      var_5    C30    N2     C28    H28     -179.998   20.000   1
 CPS      var_6    C30    N2     C29    H29      -60.064   20.000   1
 CPS      var_7    C30    N2     C27    C26      179.974   20.000   1
 CPS      var_8    N2     C27    C26    C25     -179.992   20.000   3
 CPS      var_9    C27    C26    C25    N1      -179.987   20.000   3
 CPS      var_10   C26    C25    N1     C24      179.997   20.000   3
 CPS      CONST_1  C25    N1     C24    C23      180.000    0.000   0
 CPS      var_11   N1     C24    C23    C22      180.000   20.000   3
 CPS      var_12   C24    C23    C22    C20      179.974   20.000   3
 CPS      var_13   C23    C22    C20    C9      -174.991   20.000   3
 CPS      var_14   C22    C20    C21    H21     -176.121   20.000   3
 CPS      var_15   C22    C20    C9     C8        58.249   20.000   3
 CPS      var_16   C20    C9     C5     C4        90.000   20.000   1
 CPS      var_17   C9     C5     C6     C7        30.000   20.000   1
 CPS      var_18   C9     C5     C10    H10     -172.861   20.000   1
 CPS      var_19   C9     C5     C4     O4        60.000   20.000   1
 CPS      var_20   C5     C4     O4     HO4      177.805   20.000   1
 CPS      var_21   C20    C9     C8     C7       120.000   20.000   3
 CPS      var_22   C9     C8     C7     C6        30.000   20.000   3
 CPS      var_23   C8     C7     C6     C18     -150.000   20.000   3
 CPS      var_24   C7     C6     C18    C17      -60.000   20.000   3
 CPS      var_25   C6     C18    C19    C2       180.000   20.000   3
 CPS      var_26   C18    C19    C3     C4        60.000   20.000   3
 CPS      var_27   C19    C3     C4     C5       -60.000   20.000   3
 CPS      var_28   C18    C19    C2     C11       60.000   20.000   1
 CPS      var_29   C19    C2     C15    C16       60.000   20.000   1
 CPS      var_30   C19    C2     C11    H11     -179.864   20.000   1
 CPS      var_31   C6     C18    C17    C16      180.000   20.000   3
 CPS      var_32   C18    C17    O3     HO3     -179.938   20.000   1
 CPS      var_33   C18    C17    C16    C15       60.000   20.000   3
 CPS      var_34   C17    C16    C15    C14       60.000   20.000   3
 CPS      var_35   C16    C15    C14    C13      180.000   20.000   3
 CPS      var_36   C15    C14    C13    C12       60.000   20.000   3
 CPS      var_37   C14    C13    O2     HO2     -179.992   20.000   1
 CPS      var_38   C14    C13    C12    C1       -60.000   20.000   3
 CPS      var_39   C13    C12    C1     C2        60.000   20.000   3
 CPS      var_40   C12    C1     C2     C19       60.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 CPS      chir_01  C2     C1     C11    C15       negativ
 CPS      chir_02  C4     C3     C5     O4        negativ
 CPS      chir_03  C5     C4     C6     C9        negativ
 CPS      chir_04  C6     C5     C7     C18       negativ
 CPS      chir_05  C9     C5     C8     C20       positiv
 CPS      chir_06  C13    C12    C14    O2        positiv
 CPS      chir_07  C15    C2     C14    C16       negativ
 CPS      chir_08  C17    C16    C18    O3        positiv
 CPS      chir_09  C18    C6     C17    C19       positiv
 CPS      chir_10  C19    C2     C3     C18       negativ
 CPS      chir_11  C20    C9     C21    C22       positiv
 CPS      chir_12  N2     C27    C28    C29       negativ
 CPS      chir_13  S      C32    O2S    O3S       negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 CPS      plan-1    C24       0.020
 CPS      plan-1    C23       0.020
 CPS      plan-1    N1        0.020
 CPS      plan-1    O1        0.020
 CPS      plan-1    HN1       0.020
 CPS      plan-2    N1        0.020
 CPS      plan-2    C24       0.020
 CPS      plan-2    C25       0.020
 CPS      plan-2    HN1       0.020
# ------------------------------------------------------
`.trim();

monomers["DMX"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DMX      DMX '3-[BENZYL(DIMETHYL)AMMONIO]PROPANE-1' non-polymer        36  17 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DMX
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DMX           O16    O    OS        0.000      0.000    0.000    0.000
 DMX           S11    S    ST        0.000     -1.328   -0.001   -0.593
 DMX           O14    O    OS       -1.000     -1.498   -1.193   -1.410
 DMX           O15    O    OS        0.000     -1.498    1.185   -1.417
 DMX           C10    C    CH2       0.000     -2.573    0.002    0.727
 DMX           H101   H    H         0.000     -2.447    0.895    1.343
 DMX           H102   H    H         0.000     -2.447   -0.888    1.347
 DMX           C17    C    CH2       0.000     -3.972    0.001    0.107
 DMX           H171   H    H         0.000     -4.096   -0.892   -0.509
 DMX           H172   H    H         0.000     -4.096    0.891   -0.513
 DMX           C9     C    CH2       0.000     -5.022    0.003    1.220
 DMX           H91    H    H         0.000     -4.896    0.896    1.837
 DMX           H92    H    H         0.000     -4.896   -0.887    1.841
 DMX           N8     N    NT        1.000     -6.365    0.002    0.625
 DMX           C12    C    CH3       0.000     -6.533    1.199   -0.209
 DMX           H123   H    H         0.000     -6.412    2.065    0.388
 DMX           H122   H    H         0.000     -5.806    1.197   -0.980
 DMX           H121   H    H         0.000     -7.502    1.198   -0.637
 DMX           C13    C    CH3       0.000     -6.533   -1.200   -0.202
 DMX           H133   H    H         0.000     -6.413   -2.063    0.400
 DMX           H132   H    H         0.000     -7.502   -1.201   -0.631
 DMX           H131   H    H         0.000     -5.806   -1.203   -0.972
 DMX           C7     C    CH2       0.000     -7.374    0.005    1.694
 DMX           H71    H    H         0.000     -7.248    0.898    2.310
 DMX           H72    H    H         0.000     -7.249   -0.884    2.315
 DMX           C4     C    CR6       0.000     -8.752    0.004    1.084
 DMX           C3     C    CR16      0.000     -9.387    1.200    0.806
 DMX           H3     H    H         0.000     -8.895    2.139    1.030
 DMX           C2     C    CR16      0.000    -10.649    1.199    0.243
 DMX           H2     H    H         0.000    -11.143    2.136    0.018
 DMX           C5     C    CR16      0.000     -9.385   -1.195    0.808
 DMX           H5     H    H         0.000     -8.889   -2.132    1.030
 DMX           C6     C    CR16      0.000    -10.648   -1.196    0.248
 DMX           H6     H    H         0.000    -11.143   -2.135    0.031
 DMX           C1     C    CR16      0.000    -11.280    0.000   -0.034
 DMX           H1     H    H         0.000    -12.271   -0.001   -0.472
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DMX      O16    n/a    S11    START
 DMX      S11    O16    C10    .
 DMX      O14    S11    .      .
 DMX      O15    S11    .      .
 DMX      C10    S11    C17    .
 DMX      H101   C10    .      .
 DMX      H102   C10    .      .
 DMX      C17    C10    C9     .
 DMX      H171   C17    .      .
 DMX      H172   C17    .      .
 DMX      C9     C17    N8     .
 DMX      H91    C9     .      .
 DMX      H92    C9     .      .
 DMX      N8     C9     C7     .
 DMX      C12    N8     H121   .
 DMX      H123   C12    .      .
 DMX      H122   C12    .      .
 DMX      H121   C12    .      .
 DMX      C13    N8     H131   .
 DMX      H133   C13    .      .
 DMX      H132   C13    .      .
 DMX      H131   C13    .      .
 DMX      C7     N8     C4     .
 DMX      H71    C7     .      .
 DMX      H72    C7     .      .
 DMX      C4     C7     C5     .
 DMX      C3     C4     C2     .
 DMX      H3     C3     .      .
 DMX      C2     C3     H2     .
 DMX      H2     C2     .      .
 DMX      C5     C4     C6     .
 DMX      H5     C5     .      .
 DMX      C6     C5     C1     .
 DMX      H6     C6     .      .
 DMX      C1     C6     H1     .
 DMX      H1     C1     .      END
 DMX      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DMX      C1     C2        single      1.390    0.020
 DMX      C1     C6        double      1.390    0.020
 DMX      H1     C1        single      1.083    0.020
 DMX      C2     C3        double      1.390    0.020
 DMX      H2     C2        single      1.083    0.020
 DMX      C3     C4        single      1.390    0.020
 DMX      H3     C3        single      1.083    0.020
 DMX      C5     C4        double      1.390    0.020
 DMX      C4     C7        single      1.511    0.020
 DMX      C6     C5        single      1.390    0.020
 DMX      H5     C5        single      1.083    0.020
 DMX      H6     C6        single      1.083    0.020
 DMX      C7     N8        single      1.469    0.020
 DMX      H71    C7        single      1.092    0.020
 DMX      H72    C7        single      1.092    0.020
 DMX      N8     C9        single      1.469    0.020
 DMX      C12    N8        single      1.469    0.020
 DMX      C13    N8        single      1.469    0.020
 DMX      C9     C17       single      1.524    0.020
 DMX      H91    C9        single      1.092    0.020
 DMX      H92    C9        single      1.092    0.020
 DMX      C10    S11       single      1.662    0.020
 DMX      C17    C10       single      1.524    0.020
 DMX      H101   C10       single      1.092    0.020
 DMX      H102   C10       single      1.092    0.020
 DMX      O14    S11       deloc       1.480    0.020
 DMX      O15    S11       deloc       1.480    0.020
 DMX      S11    O16       deloc       1.480    0.020
 DMX      H121   C12       single      1.059    0.020
 DMX      H122   C12       single      1.059    0.020
 DMX      H123   C12       single      1.059    0.020
 DMX      H131   C13       single      1.059    0.020
 DMX      H132   C13       single      1.059    0.020
 DMX      H133   C13       single      1.059    0.020
 DMX      H171   C17       single      1.092    0.020
 DMX      H172   C17       single      1.092    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DMX      O16    S11    O14     109.500    3.000
 DMX      O16    S11    O15     109.500    3.000
 DMX      O16    S11    C10     109.500    3.000
 DMX      O14    S11    O15     109.500    3.000
 DMX      O14    S11    C10     109.500    3.000
 DMX      O15    S11    C10     109.500    3.000
 DMX      S11    C10    H101    109.500    3.000
 DMX      S11    C10    H102    109.500    3.000
 DMX      S11    C10    C17     109.500    3.000
 DMX      H101   C10    H102    107.900    3.000
 DMX      H101   C10    C17     109.470    3.000
 DMX      H102   C10    C17     109.470    3.000
 DMX      C10    C17    H171    109.470    3.000
 DMX      C10    C17    H172    109.470    3.000
 DMX      C10    C17    C9      111.000    3.000
 DMX      H171   C17    H172    107.900    3.000
 DMX      H171   C17    C9      109.470    3.000
 DMX      H172   C17    C9      109.470    3.000
 DMX      C17    C9     H91     109.470    3.000
 DMX      C17    C9     H92     109.470    3.000
 DMX      C17    C9     N8      109.470    3.000
 DMX      H91    C9     H92     107.900    3.000
 DMX      H91    C9     N8      109.470    3.000
 DMX      H92    C9     N8      109.470    3.000
 DMX      C9     N8     C12     109.470    3.000
 DMX      C9     N8     C13     109.470    3.000
 DMX      C9     N8     C7      109.470    3.000
 DMX      C12    N8     C13     109.470    3.000
 DMX      C12    N8     C7      109.470    3.000
 DMX      C13    N8     C7      109.470    3.000
 DMX      N8     C12    H123    109.470    3.000
 DMX      N8     C12    H122    109.470    3.000
 DMX      N8     C12    H121    109.470    3.000
 DMX      H123   C12    H122    109.470    3.000
 DMX      H123   C12    H121    109.470    3.000
 DMX      H122   C12    H121    109.470    3.000
 DMX      N8     C13    H133    109.470    3.000
 DMX      N8     C13    H132    109.470    3.000
 DMX      N8     C13    H131    109.470    3.000
 DMX      H133   C13    H132    109.470    3.000
 DMX      H133   C13    H131    109.470    3.000
 DMX      H132   C13    H131    109.470    3.000
 DMX      N8     C7     H71     109.470    3.000
 DMX      N8     C7     H72     109.470    3.000
 DMX      N8     C7     C4      109.500    3.000
 DMX      H71    C7     H72     107.900    3.000
 DMX      H71    C7     C4      109.470    3.000
 DMX      H72    C7     C4      109.470    3.000
 DMX      C7     C4     C3      120.000    3.000
 DMX      C7     C4     C5      120.000    3.000
 DMX      C3     C4     C5      120.000    3.000
 DMX      C4     C3     H3      120.000    3.000
 DMX      C4     C3     C2      120.000    3.000
 DMX      H3     C3     C2      120.000    3.000
 DMX      C3     C2     H2      120.000    3.000
 DMX      C3     C2     C1      120.000    3.000
 DMX      H2     C2     C1      120.000    3.000
 DMX      C4     C5     H5      120.000    3.000
 DMX      C4     C5     C6      120.000    3.000
 DMX      H5     C5     C6      120.000    3.000
 DMX      C5     C6     H6      120.000    3.000
 DMX      C5     C6     C1      120.000    3.000
 DMX      H6     C6     C1      120.000    3.000
 DMX      C6     C1     H1      120.000    3.000
 DMX      C6     C1     C2      120.000    3.000
 DMX      H1     C1     C2      120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DMX      var_1    O16    S11    C10    C17      179.996   20.000   1
 DMX      var_2    S11    C10    C17    C9       179.979   20.000   3
 DMX      var_3    C10    C17    C9     N8      -179.997   20.000   3
 DMX      var_4    C17    C9     N8     C7      -179.955   20.000   1
 DMX      var_5    C9     N8     C12    H121    -179.973   20.000   1
 DMX      var_6    C9     N8     C13    H131     -60.009   20.000   1
 DMX      var_7    C9     N8     C7     C4       179.998   20.000   1
 DMX      var_8    N8     C7     C4     C5        90.001   20.000   2
 DMX      CONST_1  C7     C4     C3     C2       180.000    0.000   0
 DMX      CONST_2  C4     C3     C2     C1         0.000    0.000   0
 DMX      CONST_3  C7     C4     C5     C6       180.000    0.000   0
 DMX      CONST_4  C4     C5     C6     C1         0.000    0.000   0
 DMX      CONST_5  C5     C6     C1     C2         0.000    0.000   0
 DMX      CONST_6  C6     C1     C2     C3         0.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DMX      chir_01  N8     C7     C9     C12       positiv
 DMX      chir_02  S11    C10    O14    O15       negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DMX      plan-1    C1        0.020
 DMX      plan-1    C2        0.020
 DMX      plan-1    C6        0.020
 DMX      plan-1    H1        0.020
 DMX      plan-1    C3        0.020
 DMX      plan-1    C4        0.020
 DMX      plan-1    C5        0.020
 DMX      plan-1    H2        0.020
 DMX      plan-1    H3        0.020
 DMX      plan-1    C7        0.020
 DMX      plan-1    H5        0.020
 DMX      plan-1    H6        0.020
# ------------------------------------------------------
`.trim();

monomers["MPO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MPO      MPO '3[N-MORPHOLINO]PROPANE SULFONIC ACID' non-polymer        28  13 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MPO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MPO           O2     O    OS        0.000      0.000    0.000    0.000
 MPO           S1     S    ST        0.000     -0.885    0.459    1.012
 MPO           O1     O    OS        0.000     -0.970    1.830    1.375
 MPO           O3     O    OH1       0.000     -0.323   -0.188    2.269
 MPO           HO3    H    H         0.000      0.549    0.062    2.552
 MPO           C1     C    CH2       0.000     -2.527   -0.294    0.856
 MPO           H11    H    H         0.000     -3.118   -0.064    1.745
 MPO           H12    H    H         0.000     -2.423   -1.377    0.760
 MPO           C2     C    CH2       0.000     -3.228    0.264   -0.384
 MPO           H21    H    H         0.000     -2.636    0.034   -1.271
 MPO           H22    H    H         0.000     -3.331    1.347   -0.287
 MPO           C3     C    CH2       0.000     -4.614   -0.371   -0.514
 MPO           H31    H    H         0.000     -5.205   -0.140    0.375
 MPO           H32    H    H         0.000     -4.510   -1.453   -0.609
 MPO           N1     N    NT        0.000     -5.287    0.165   -1.704
 MPO           C4     C    CH2       0.000     -6.605   -0.482   -1.771
 MPO           H41    H    H         0.000     -7.214   -0.151   -0.928
 MPO           H42    H    H         0.000     -6.479   -1.565   -1.725
 MPO           C5     C    CH2       0.000     -7.296   -0.102   -3.081
 MPO           H52    H    H         0.000     -7.377    0.985   -3.144
 MPO           H51    H    H         0.000     -8.295   -0.543   -3.103
 MPO           C7     C    CH2       0.000     -4.528   -0.305   -2.868
 MPO           H71    H    H         0.000     -4.417   -1.390   -2.814
 MPO           H72    H    H         0.000     -3.540    0.160   -2.868
 MPO           C6     C    CH2       0.000     -5.271    0.070   -4.150
 MPO           H62    H    H         0.000     -4.676   -0.234   -5.014
 MPO           H61    H    H         0.000     -5.422    1.152   -4.176
 MPO           O4     O    O2        0.000     -6.536   -0.589   -4.186
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MPO      O2     n/a    S1     START
 MPO      S1     O2     C1     .
 MPO      O1     S1     .      .
 MPO      O3     S1     HO3    .
 MPO      HO3    O3     .      .
 MPO      C1     S1     C2     .
 MPO      H11    C1     .      .
 MPO      H12    C1     .      .
 MPO      C2     C1     C3     .
 MPO      H21    C2     .      .
 MPO      H22    C2     .      .
 MPO      C3     C2     N1     .
 MPO      H31    C3     .      .
 MPO      H32    C3     .      .
 MPO      N1     C3     C7     .
 MPO      C4     N1     C5     .
 MPO      H41    C4     .      .
 MPO      H42    C4     .      .
 MPO      C5     C4     H51    .
 MPO      H52    C5     .      .
 MPO      H51    C5     .      .
 MPO      C7     N1     C6     .
 MPO      H71    C7     .      .
 MPO      H72    C7     .      .
 MPO      C6     C7     O4     .
 MPO      H62    C6     .      .
 MPO      H61    C6     .      .
 MPO      O4     C6     .      END
 MPO      O4     C5     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MPO      O1     S1        double      1.436    0.020
 MPO      S1     O2        double      1.436    0.020
 MPO      C1     S1        single      1.662    0.020
 MPO      O3     S1        single      1.635    0.020
 MPO      O4     C5        single      1.426    0.020
 MPO      O4     C6        single      1.426    0.020
 MPO      N1     C3        single      1.469    0.020
 MPO      C4     N1        single      1.469    0.020
 MPO      C7     N1        single      1.469    0.020
 MPO      C2     C1        single      1.524    0.020
 MPO      H11    C1        single      1.092    0.020
 MPO      H12    C1        single      1.092    0.020
 MPO      HO3    O3        single      0.967    0.020
 MPO      C3     C2        single      1.524    0.020
 MPO      H21    C2        single      1.092    0.020
 MPO      H22    C2        single      1.092    0.020
 MPO      H31    C3        single      1.092    0.020
 MPO      H32    C3        single      1.092    0.020
 MPO      C5     C4        single      1.524    0.020
 MPO      H41    C4        single      1.092    0.020
 MPO      H42    C4        single      1.092    0.020
 MPO      H51    C5        single      1.092    0.020
 MPO      H52    C5        single      1.092    0.020
 MPO      C6     C7        single      1.524    0.020
 MPO      H61    C6        single      1.092    0.020
 MPO      H62    C6        single      1.092    0.020
 MPO      H71    C7        single      1.092    0.020
 MPO      H72    C7        single      1.092    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MPO      O2     S1     O1      109.500    3.000
 MPO      O2     S1     O3      109.500    3.000
 MPO      O2     S1     C1      109.500    3.000
 MPO      O1     S1     O3      109.500    3.000
 MPO      O1     S1     C1      109.500    3.000
 MPO      O3     S1     C1      109.500    3.000
 MPO      S1     O3     HO3     120.000    3.000
 MPO      S1     C1     H11     109.500    3.000
 MPO      S1     C1     H12     109.500    3.000
 MPO      S1     C1     C2      109.500    3.000
 MPO      H11    C1     H12     107.900    3.000
 MPO      H11    C1     C2      109.470    3.000
 MPO      H12    C1     C2      109.470    3.000
 MPO      C1     C2     H21     109.470    3.000
 MPO      C1     C2     H22     109.470    3.000
 MPO      C1     C2     C3      111.000    3.000
 MPO      H21    C2     H22     107.900    3.000
 MPO      H21    C2     C3      109.470    3.000
 MPO      H22    C2     C3      109.470    3.000
 MPO      C2     C3     H31     109.470    3.000
 MPO      C2     C3     H32     109.470    3.000
 MPO      C2     C3     N1      109.470    3.000
 MPO      H31    C3     H32     107.900    3.000
 MPO      H31    C3     N1      109.470    3.000
 MPO      H32    C3     N1      109.470    3.000
 MPO      C3     N1     C4      109.470    3.000
 MPO      C3     N1     C7      109.470    3.000
 MPO      C4     N1     C7      109.470    3.000
 MPO      N1     C4     H41     109.470    3.000
 MPO      N1     C4     H42     109.470    3.000
 MPO      N1     C4     C5      109.470    3.000
 MPO      H41    C4     H42     107.900    3.000
 MPO      H41    C4     C5      109.470    3.000
 MPO      H42    C4     C5      109.470    3.000
 MPO      C4     C5     H52     109.470    3.000
 MPO      C4     C5     H51     109.470    3.000
 MPO      C4     C5     O4      109.470    3.000
 MPO      H52    C5     H51     107.900    3.000
 MPO      H52    C5     O4      109.470    3.000
 MPO      H51    C5     O4      109.470    3.000
 MPO      N1     C7     H71     109.470    3.000
 MPO      N1     C7     H72     109.470    3.000
 MPO      N1     C7     C6      109.470    3.000
 MPO      H71    C7     H72     107.900    3.000
 MPO      H71    C7     C6      109.470    3.000
 MPO      H72    C7     C6      109.470    3.000
 MPO      C7     C6     H62     109.470    3.000
 MPO      C7     C6     H61     109.470    3.000
 MPO      C7     C6     O4      109.470    3.000
 MPO      H62    C6     H61     107.900    3.000
 MPO      H62    C6     O4      109.470    3.000
 MPO      H61    C6     O4      109.470    3.000
 MPO      C6     O4     C5      111.800    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MPO      var_1    O2     S1     O3     HO3       63.759   20.000   1
 MPO      var_2    O2     S1     C1     C2       -70.208   20.000   1
 MPO      var_3    S1     C1     C2     C3      -179.964   20.000   3
 MPO      var_4    C1     C2     C3     N1      -179.979   20.000   3
 MPO      var_5    C2     C3     N1     C7        66.188   20.000   1
 MPO      var_6    C3     N1     C4     C5       180.000   20.000   1
 MPO      var_7    N1     C4     C5     O4        60.000   20.000   3
 MPO      var_8    C3     N1     C7     C6       180.000   20.000   1
 MPO      var_9    N1     C7     C6     O4       -60.000   20.000   3
 MPO      var_10   C7     C6     O4     C5        60.000   20.000   1
 MPO      var_11   C6     O4     C5     C4       -60.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MPO      chir_01  S1     O1     O2     C1        positiv
 MPO      chir_02  N1     C3     C4     C7        positiv
# ------------------------------------------------------
`.trim();

monomers["DXG"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DXG      DXG '4-DEOXYGLUCARATE                    ' non-polymer        21  13 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DXG
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DXG           O6B    O    OC       -0.500      0.000    0.000    0.000
 DXG           C6     C    C         0.000     -0.826   -0.892    0.295
 DXG           O6A    O    OC       -0.500     -0.487   -1.837    1.042
 DXG           C5     C    CH1       0.000     -2.230   -0.830   -0.249
 DXG           H51    H    H         0.000     -2.196   -0.760   -1.345
 DXG           O5     O    OH1       0.000     -2.941   -2.011    0.131
 DXG           HO51   H    H         0.000     -2.971   -2.072    1.095
 DXG           C4     C    CH2       0.000     -2.943    0.399    0.319
 DXG           H41    H    H         0.000     -2.352    1.293    0.106
 DXG           H42    H    H         0.000     -3.055    0.288    1.400
 DXG           C3     C    CH1       0.000     -4.323    0.532   -0.328
 DXG           H31    H    H         0.000     -4.884   -0.402   -0.190
 DXG           O3     O    OH1       0.000     -4.171    0.794   -1.724
 DXG           HO31   H    H         0.000     -3.678    1.617   -1.845
 DXG           C2     C    CH1       0.000     -5.084    1.686    0.328
 DXG           H21    H    H         0.000     -5.279    1.444    1.382
 DXG           O2     O    OH1       0.000     -4.301    2.879    0.250
 DXG           HO21   H    H         0.000     -4.130    3.091   -0.677
 DXG           C1     C    C         0.000     -6.392    1.897   -0.389
 DXG           O1B    O    OC       -0.500     -7.270    1.006   -0.362
 DXG           O1A    O    OC       -0.500     -6.601    2.962   -1.011
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DXG      O6B    n/a    C6     START
 DXG      C6     O6B    C5     .
 DXG      O6A    C6     .      .
 DXG      C5     C6     C4     .
 DXG      H51    C5     .      .
 DXG      O5     C5     HO51   .
 DXG      HO51   O5     .      .
 DXG      C4     C5     C3     .
 DXG      H41    C4     .      .
 DXG      H42    C4     .      .
 DXG      C3     C4     C2     .
 DXG      H31    C3     .      .
 DXG      O3     C3     HO31   .
 DXG      HO31   O3     .      .
 DXG      C2     C3     C1     .
 DXG      H21    C2     .      .
 DXG      O2     C2     HO21   .
 DXG      HO21   O2     .      .
 DXG      C1     C2     O1A    .
 DXG      O1B    C1     .      .
 DXG      O1A    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DXG      O1B    C1        deloc       1.250    0.020
 DXG      O1A    C1        deloc       1.250    0.020
 DXG      C1     C2        single      1.500    0.020
 DXG      O2     C2        single      1.432    0.020
 DXG      C2     C3        single      1.524    0.020
 DXG      H21    C2        single      1.099    0.020
 DXG      HO21   O2        single      0.967    0.020
 DXG      O3     C3        single      1.432    0.020
 DXG      C3     C4        single      1.524    0.020
 DXG      H31    C3        single      1.099    0.020
 DXG      HO31   O3        single      0.967    0.020
 DXG      C4     C5        single      1.524    0.020
 DXG      H41    C4        single      1.092    0.020
 DXG      H42    C4        single      1.092    0.020
 DXG      O5     C5        single      1.432    0.020
 DXG      HO51   O5        single      0.967    0.020
 DXG      C5     C6        single      1.500    0.020
 DXG      H51    C5        single      1.099    0.020
 DXG      O6A    C6        deloc       1.250    0.020
 DXG      C6     O6B       deloc       1.250    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DXG      O6B    C6     O6A     123.000    3.000
 DXG      O6B    C6     C5      118.500    3.000
 DXG      O6A    C6     C5      118.500    3.000
 DXG      C6     C5     H51     108.810    3.000
 DXG      C6     C5     O5      109.470    3.000
 DXG      C6     C5     C4      109.470    3.000
 DXG      H51    C5     O5      109.470    3.000
 DXG      H51    C5     C4      108.340    3.000
 DXG      O5     C5     C4      109.470    3.000
 DXG      C5     O5     HO51    109.470    3.000
 DXG      C5     C4     H41     109.470    3.000
 DXG      C5     C4     H42     109.470    3.000
 DXG      C5     C4     C3      111.000    3.000
 DXG      H41    C4     H42     107.900    3.000
 DXG      H41    C4     C3      109.470    3.000
 DXG      H42    C4     C3      109.470    3.000
 DXG      C4     C3     H31     108.340    3.000
 DXG      C4     C3     O3      109.470    3.000
 DXG      C4     C3     C2      111.000    3.000
 DXG      H31    C3     O3      109.470    3.000
 DXG      H31    C3     C2      108.340    3.000
 DXG      O3     C3     C2      109.470    3.000
 DXG      C3     O3     HO31    109.470    3.000
 DXG      C3     C2     H21     108.340    3.000
 DXG      C3     C2     O2      109.470    3.000
 DXG      C3     C2     C1      109.470    3.000
 DXG      H21    C2     O2      109.470    3.000
 DXG      H21    C2     C1      108.810    3.000
 DXG      O2     C2     C1      109.470    3.000
 DXG      C2     O2     HO21    109.470    3.000
 DXG      C2     C1     O1B     118.500    3.000
 DXG      C2     C1     O1A     118.500    3.000
 DXG      O1B    C1     O1A     123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DXG      var_1    O6B    C6     C5     C4       -65.015   20.000   3
 DXG      var_2    C6     C5     O5     HO51      60.019   20.000   1
 DXG      var_3    C6     C5     C4     C3       174.977   20.000   3
 DXG      var_4    C5     C4     C3     C2       175.009   20.000   3
 DXG      var_5    C4     C3     O3     HO31     -60.021   20.000   1
 DXG      var_6    C4     C3     C2     C1       175.007   20.000   3
 DXG      var_7    C3     C2     O2     HO21      59.986   20.000   1
 DXG      var_8    C3     C2     C1     O1A     -114.995   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DXG      chir_01  C2     C1     O2     C3        positiv
 DXG      chir_02  C3     C2     O3     C4        negativ
 DXG      chir_03  C5     C4     O5     C6        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DXG      plan-1    C1        0.020
 DXG      plan-1    O1B       0.020
 DXG      plan-1    O1A       0.020
 DXG      plan-1    C2        0.020
 DXG      plan-2    C6        0.020
 DXG      plan-2    C5        0.020
 DXG      plan-2    O6A       0.020
 DXG      plan-2    O6B       0.020
# ------------------------------------------------------
`.trim();

monomers["CM5"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CM5      CM5 '5-CYCLOHEXYL-1-PENTYL-BETA-D-MALTOSI' non-polymer        76  34 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CM5
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CM5           O34    O    OH1       0.000      0.000    0.000    0.000
 CM5           H34    H    H         0.000      0.017   -0.861   -0.440
 CM5           C29    C    CH1       0.000     -0.522    0.983   -0.897
 CM5           H29    H    H         0.000      0.118    1.043   -1.789
 CM5           C28    C    CH1       0.000     -0.561    2.347   -0.200
 CM5           H28    H    H         0.000     -1.113    2.263    0.746
 CM5           O33    O    OH1       0.000      0.773    2.791    0.060
 CM5           H33    H    H         0.000      1.219    2.151    0.631
 CM5           C27    C    CH1       0.000     -1.267    3.347   -1.122
 CM5           H27    H    H         0.000     -0.660    3.510   -2.024
 CM5           O32    O    OH1       0.000     -1.446    4.588   -0.435
 CM5           H32    H    H         0.000     -0.583    4.940   -0.178
 CM5           C26    C    CH1       0.000     -2.632    2.781   -1.519
 CM5           H26    H    H         0.000     -3.228    2.596   -0.614
 CM5           C30    C    CH2       0.000     -3.362    3.788   -2.411
 CM5           H301   H    H         0.000     -2.814    3.905   -3.349
 CM5           H302   H    H         0.000     -3.417    4.752   -1.900
 CM5           O31    O    OH1       0.000     -4.682    3.315   -2.684
 CM5           H31    H    H         0.000     -5.142    3.952   -3.247
 CM5           O25    O    O2        0.000     -2.458    1.557   -2.230
 CM5           C24    C    CH1       0.000     -1.943    0.594   -1.312
 CM5           H24    H    H         0.000     -1.926   -0.395   -1.790
 CM5           O23    O    O2        0.000     -2.778    0.548   -0.154
 CM5           C16    C    CH1       0.000     -3.966   -0.152   -0.529
 CM5           H16    H    H         0.000     -4.216    0.082   -1.573
 CM5           C17    C    CH1       0.000     -3.742   -1.661   -0.382
 CM5           H17    H    H         0.000     -3.388   -1.884    0.634
 CM5           O21    O    OH1       0.000     -2.770   -2.096   -1.335
 CM5           H21    H    H         0.000     -2.629   -3.047   -1.240
 CM5           C18    C    CH1       0.000     -5.072   -2.381   -0.634
 CM5           H18    H    H         0.000     -5.372   -2.244   -1.683
 CM5           O22    O    OH1       0.000     -4.919   -3.776   -0.358
 CM5           H22    H    H         0.000     -5.758   -4.229   -0.517
 CM5           C15    C    CH1       0.000     -5.120    0.274    0.381
 CM5           H15    H    H         0.000     -4.877    0.020    1.422
 CM5           C19    C    CH2       0.000     -5.332    1.784    0.265
 CM5           H191   H    H         0.000     -5.636    2.031   -0.755
 CM5           H192   H    H         0.000     -4.399    2.301    0.500
 CM5           O20    O    OH1       0.000     -6.350    2.195    1.180
 CM5           H20    H    H         0.000     -6.483    3.150    1.106
 CM5           O14    O    O2        0.000     -6.316   -0.404   -0.004
 CM5           C13    C    CH1       0.000     -6.141   -1.789    0.286
 CM5           H13    H    H         0.000     -5.828   -1.906    1.333
 CM5           O12    O    O2        0.000     -7.377   -2.476    0.080
 CM5           C1     C    CH2       0.000     -8.300   -1.963    1.044
 CM5           H11    H    H         0.000     -8.422   -0.888    0.894
 CM5           H12    H    H         0.000     -7.917   -2.148    2.049
 CM5           C2     C    CH2       0.000     -9.652   -2.659    0.876
 CM5           H21A   H    H         0.000     -9.528   -3.734    1.025
 CM5           H22A   H    H         0.000    -10.033   -2.474   -0.130
 CM5           C3     C    CH2       0.000    -10.640   -2.110    1.908
 CM5           H31A   H    H         0.000    -10.763   -1.035    1.757
 CM5           H32A   H    H         0.000    -10.256   -2.294    2.913
 CM5           C4     C    CH2       0.000    -11.991   -2.807    1.741
 CM5           H41    H    H         0.000    -11.866   -3.882    1.890
 CM5           H42    H    H         0.000    -12.373   -2.623    0.735
 CM5           C5     C    CH2       0.000    -12.979   -2.258    2.772
 CM5           H51    H    H         0.000    -13.101   -1.183    2.622
 CM5           H52    H    H         0.000    -12.595   -2.443    3.777
 CM5           C6     C    CH1       0.000    -14.331   -2.955    2.605
 CM5           H6     H    H         0.000    -14.193   -4.043    2.668
 CM5           C7     C    CH2       0.000    -15.281   -2.497    3.713
 CM5           H72    H    H         0.000    -15.417   -1.415    3.651
 CM5           H71    H    H         0.000    -14.855   -2.754    4.686
 CM5           C11    C    CH2       0.000    -14.926   -2.594    1.243
 CM5           H111   H    H         0.000    -14.247   -2.920    0.452
 CM5           H112   H    H         0.000    -15.062   -1.512    1.180
 CM5           C10    C    CH2       0.000    -16.278   -3.290    1.076
 CM5           H101   H    H         0.000    -16.140   -4.372    1.137
 CM5           H102   H    H         0.000    -16.702   -3.034    0.103
 CM5           C9     C    CH2       0.000    -17.228   -2.833    2.184
 CM5           H91    H    H         0.000    -18.193   -3.329    2.064
 CM5           H92    H    H         0.000    -17.366   -1.751    2.120
 CM5           C8     C    CH2       0.000    -16.633   -3.194    3.547
 CM5           H82    H    H         0.000    -16.497   -4.275    3.609
 CM5           H81    H    H         0.000    -17.312   -2.867    4.338
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CM5      O34    n/a    C29    START
 CM5      H34    O34    .      .
 CM5      C29    O34    C24    .
 CM5      H29    C29    .      .
 CM5      C28    C29    C27    .
 CM5      H28    C28    .      .
 CM5      O33    C28    H33    .
 CM5      H33    O33    .      .
 CM5      C27    C28    C26    .
 CM5      H27    C27    .      .
 CM5      O32    C27    H32    .
 CM5      H32    O32    .      .
 CM5      C26    C27    O25    .
 CM5      H26    C26    .      .
 CM5      C30    C26    O31    .
 CM5      H301   C30    .      .
 CM5      H302   C30    .      .
 CM5      O31    C30    H31    .
 CM5      H31    O31    .      .
 CM5      O25    C26    .      .
 CM5      C24    C29    O23    .
 CM5      H24    C24    .      .
 CM5      O23    C24    C16    .
 CM5      C16    O23    C15    .
 CM5      H16    C16    .      .
 CM5      C17    C16    C18    .
 CM5      H17    C17    .      .
 CM5      O21    C17    H21    .
 CM5      H21    O21    .      .
 CM5      C18    C17    O22    .
 CM5      H18    C18    .      .
 CM5      O22    C18    H22    .
 CM5      H22    O22    .      .
 CM5      C15    C16    O14    .
 CM5      H15    C15    .      .
 CM5      C19    C15    O20    .
 CM5      H191   C19    .      .
 CM5      H192   C19    .      .
 CM5      O20    C19    H20    .
 CM5      H20    O20    .      .
 CM5      O14    C15    C13    .
 CM5      C13    O14    O12    .
 CM5      H13    C13    .      .
 CM5      O12    C13    C1     .
 CM5      C1     O12    C2     .
 CM5      H11    C1     .      .
 CM5      H12    C1     .      .
 CM5      C2     C1     C3     .
 CM5      H21A   C2     .      .
 CM5      H22A   C2     .      .
 CM5      C3     C2     C4     .
 CM5      H31A   C3     .      .
 CM5      H32A   C3     .      .
 CM5      C4     C3     C5     .
 CM5      H41    C4     .      .
 CM5      H42    C4     .      .
 CM5      C5     C4     C6     .
 CM5      H51    C5     .      .
 CM5      H52    C5     .      .
 CM5      C6     C5     C11    .
 CM5      H6     C6     .      .
 CM5      C7     C6     H71    .
 CM5      H72    C7     .      .
 CM5      H71    C7     .      .
 CM5      C11    C6     C10    .
 CM5      H111   C11    .      .
 CM5      H112   C11    .      .
 CM5      C10    C11    C9     .
 CM5      H101   C10    .      .
 CM5      H102   C10    .      .
 CM5      C9     C10    C8     .
 CM5      H91    C9     .      .
 CM5      H92    C9     .      .
 CM5      C8     C9     H81    .
 CM5      H82    C8     .      .
 CM5      H81    C8     .      END
 CM5      C7     C8     .    ADD
 CM5      C13    C18    .    ADD
 CM5      C24    O25    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CM5      C7     C8        single      1.524    0.020
 CM5      C7     C6        single      1.524    0.020
 CM5      H71    C7        single      1.092    0.020
 CM5      H72    C7        single      1.092    0.020
 CM5      C8     C9        single      1.524    0.020
 CM5      H81    C8        single      1.092    0.020
 CM5      H82    C8        single      1.092    0.020
 CM5      C9     C10       single      1.524    0.020
 CM5      H91    C9        single      1.092    0.020
 CM5      H92    C9        single      1.092    0.020
 CM5      C10    C11       single      1.524    0.020
 CM5      H101   C10       single      1.092    0.020
 CM5      H102   C10       single      1.092    0.020
 CM5      C11    C6        single      1.524    0.020
 CM5      H111   C11       single      1.092    0.020
 CM5      H112   C11       single      1.092    0.020
 CM5      C6     C5        single      1.524    0.020
 CM5      H6     C6        single      1.099    0.020
 CM5      C5     C4        single      1.524    0.020
 CM5      H51    C5        single      1.092    0.020
 CM5      H52    C5        single      1.092    0.020
 CM5      C4     C3        single      1.524    0.020
 CM5      H41    C4        single      1.092    0.020
 CM5      H42    C4        single      1.092    0.020
 CM5      C3     C2        single      1.524    0.020
 CM5      H31A   C3        single      1.092    0.020
 CM5      H32A   C3        single      1.092    0.020
 CM5      C2     C1        single      1.524    0.020
 CM5      H21A   C2        single      1.092    0.020
 CM5      H22A   C2        single      1.092    0.020
 CM5      C1     O12       single      1.426    0.020
 CM5      H11    C1        single      1.092    0.020
 CM5      H12    C1        single      1.092    0.020
 CM5      O12    C13       single      1.426    0.020
 CM5      C13    C18       single      1.524    0.020
 CM5      C13    O14       single      1.426    0.020
 CM5      H13    C13       single      1.099    0.020
 CM5      O22    C18       single      1.432    0.020
 CM5      C18    C17       single      1.524    0.020
 CM5      H18    C18       single      1.099    0.020
 CM5      H22    O22       single      0.967    0.020
 CM5      O21    C17       single      1.432    0.020
 CM5      C17    C16       single      1.524    0.020
 CM5      H17    C17       single      1.099    0.020
 CM5      H21    O21       single      0.967    0.020
 CM5      O14    C15       single      1.426    0.020
 CM5      C19    C15       single      1.524    0.020
 CM5      C15    C16       single      1.524    0.020
 CM5      H15    C15       single      1.099    0.020
 CM5      O20    C19       single      1.432    0.020
 CM5      H191   C19       single      1.092    0.020
 CM5      H192   C19       single      1.092    0.020
 CM5      H20    O20       single      0.967    0.020
 CM5      C16    O23       single      1.426    0.020
 CM5      H16    C16       single      1.099    0.020
 CM5      O23    C24       single      1.426    0.020
 CM5      C24    O25       single      1.426    0.020
 CM5      C24    C29       single      1.524    0.020
 CM5      H24    C24       single      1.099    0.020
 CM5      O25    C26       single      1.426    0.020
 CM5      C30    C26       single      1.524    0.020
 CM5      C26    C27       single      1.524    0.020
 CM5      H26    C26       single      1.099    0.020
 CM5      O31    C30       single      1.432    0.020
 CM5      H301   C30       single      1.092    0.020
 CM5      H302   C30       single      1.092    0.020
 CM5      H31    O31       single      0.967    0.020
 CM5      O32    C27       single      1.432    0.020
 CM5      C27    C28       single      1.524    0.020
 CM5      H27    C27       single      1.099    0.020
 CM5      H32    O32       single      0.967    0.020
 CM5      O33    C28       single      1.432    0.020
 CM5      C28    C29       single      1.524    0.020
 CM5      H28    C28       single      1.099    0.020
 CM5      H33    O33       single      0.967    0.020
 CM5      C29    O34       single      1.432    0.020
 CM5      H29    C29       single      1.099    0.020
 CM5      H34    O34       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CM5      H34    O34    C29     109.470    3.000
 CM5      O34    C29    H29     109.470    3.000
 CM5      O34    C29    C28     109.470    3.000
 CM5      O34    C29    C24     109.470    3.000
 CM5      H29    C29    C28     108.340    3.000
 CM5      H29    C29    C24     108.340    3.000
 CM5      C28    C29    C24     111.000    3.000
 CM5      C29    C28    H28     108.340    3.000
 CM5      C29    C28    O33     109.470    3.000
 CM5      C29    C28    C27     111.000    3.000
 CM5      H28    C28    O33     109.470    3.000
 CM5      H28    C28    C27     108.340    3.000
 CM5      O33    C28    C27     109.470    3.000
 CM5      C28    O33    H33     109.470    3.000
 CM5      C28    C27    H27     108.340    3.000
 CM5      C28    C27    O32     109.470    3.000
 CM5      C28    C27    C26     111.000    3.000
 CM5      H27    C27    O32     109.470    3.000
 CM5      H27    C27    C26     108.340    3.000
 CM5      O32    C27    C26     109.470    3.000
 CM5      C27    O32    H32     109.470    3.000
 CM5      C27    C26    H26     108.340    3.000
 CM5      C27    C26    C30     111.000    3.000
 CM5      C27    C26    O25     109.470    3.000
 CM5      H26    C26    C30     108.340    3.000
 CM5      H26    C26    O25     109.470    3.000
 CM5      C30    C26    O25     109.470    3.000
 CM5      C26    C30    H301    109.470    3.000
 CM5      C26    C30    H302    109.470    3.000
 CM5      C26    C30    O31     109.470    3.000
 CM5      H301   C30    H302    107.900    3.000
 CM5      H301   C30    O31     109.470    3.000
 CM5      H302   C30    O31     109.470    3.000
 CM5      C30    O31    H31     109.470    3.000
 CM5      C26    O25    C24     111.800    3.000
 CM5      C29    C24    H24     108.340    3.000
 CM5      C29    C24    O23     109.470    3.000
 CM5      C29    C24    O25     109.470    3.000
 CM5      H24    C24    O23     109.470    3.000
 CM5      H24    C24    O25     109.470    3.000
 CM5      O23    C24    O25     109.470    3.000
 CM5      C24    O23    C16     111.800    3.000
 CM5      O23    C16    H16     109.470    3.000
 CM5      O23    C16    C17     109.470    3.000
 CM5      O23    C16    C15     109.470    3.000
 CM5      H16    C16    C17     108.340    3.000
 CM5      H16    C16    C15     108.340    3.000
 CM5      C17    C16    C15     111.000    3.000
 CM5      C16    C17    H17     108.340    3.000
 CM5      C16    C17    O21     109.470    3.000
 CM5      C16    C17    C18     111.000    3.000
 CM5      H17    C17    O21     109.470    3.000
 CM5      H17    C17    C18     108.340    3.000
 CM5      O21    C17    C18     109.470    3.000
 CM5      C17    O21    H21     109.470    3.000
 CM5      C17    C18    H18     108.340    3.000
 CM5      C17    C18    O22     109.470    3.000
 CM5      C17    C18    C13     111.000    3.000
 CM5      H18    C18    O22     109.470    3.000
 CM5      H18    C18    C13     108.340    3.000
 CM5      O22    C18    C13     109.470    3.000
 CM5      C18    O22    H22     109.470    3.000
 CM5      C16    C15    H15     108.340    3.000
 CM5      C16    C15    C19     111.000    3.000
 CM5      C16    C15    O14     109.470    3.000
 CM5      H15    C15    C19     108.340    3.000
 CM5      H15    C15    O14     109.470    3.000
 CM5      C19    C15    O14     109.470    3.000
 CM5      C15    C19    H191    109.470    3.000
 CM5      C15    C19    H192    109.470    3.000
 CM5      C15    C19    O20     109.470    3.000
 CM5      H191   C19    H192    107.900    3.000
 CM5      H191   C19    O20     109.470    3.000
 CM5      H192   C19    O20     109.470    3.000
 CM5      C19    O20    H20     109.470    3.000
 CM5      C15    O14    C13     111.800    3.000
 CM5      O14    C13    H13     109.470    3.000
 CM5      O14    C13    O12     109.470    3.000
 CM5      O14    C13    C18     109.470    3.000
 CM5      H13    C13    O12     109.470    3.000
 CM5      H13    C13    C18     108.340    3.000
 CM5      O12    C13    C18     109.470    3.000
 CM5      C13    O12    C1      111.800    3.000
 CM5      O12    C1     H11     109.470    3.000
 CM5      O12    C1     H12     109.470    3.000
 CM5      O12    C1     C2      109.470    3.000
 CM5      H11    C1     H12     107.900    3.000
 CM5      H11    C1     C2      109.470    3.000
 CM5      H12    C1     C2      109.470    3.000
 CM5      C1     C2     H21A    109.470    3.000
 CM5      C1     C2     H22A    109.470    3.000
 CM5      C1     C2     C3      111.000    3.000
 CM5      H21A   C2     H22A    107.900    3.000
 CM5      H21A   C2     C3      109.470    3.000
 CM5      H22A   C2     C3      109.470    3.000
 CM5      C2     C3     H31A    109.470    3.000
 CM5      C2     C3     H32A    109.470    3.000
 CM5      C2     C3     C4      111.000    3.000
 CM5      H31A   C3     H32A    107.900    3.000
 CM5      H31A   C3     C4      109.470    3.000
 CM5      H32A   C3     C4      109.470    3.000
 CM5      C3     C4     H41     109.470    3.000
 CM5      C3     C4     H42     109.470    3.000
 CM5      C3     C4     C5      111.000    3.000
 CM5      H41    C4     H42     107.900    3.000
 CM5      H41    C4     C5      109.470    3.000
 CM5      H42    C4     C5      109.470    3.000
 CM5      C4     C5     H51     109.470    3.000
 CM5      C4     C5     H52     109.470    3.000
 CM5      C4     C5     C6      111.000    3.000
 CM5      H51    C5     H52     107.900    3.000
 CM5      H51    C5     C6      109.470    3.000
 CM5      H52    C5     C6      109.470    3.000
 CM5      C5     C6     H6      108.340    3.000
 CM5      C5     C6     C7      109.470    3.000
 CM5      C5     C6     C11     109.470    3.000
 CM5      H6     C6     C7      108.340    3.000
 CM5      H6     C6     C11     108.340    3.000
 CM5      C7     C6     C11     109.470    3.000
 CM5      C6     C7     H72     109.470    3.000
 CM5      C6     C7     H71     109.470    3.000
 CM5      C6     C7     C8      111.000    3.000
 CM5      H72    C7     H71     107.900    3.000
 CM5      H72    C7     C8      109.470    3.000
 CM5      H71    C7     C8      109.470    3.000
 CM5      C6     C11    H111    109.470    3.000
 CM5      C6     C11    H112    109.470    3.000
 CM5      C6     C11    C10     111.000    3.000
 CM5      H111   C11    H112    107.900    3.000
 CM5      H111   C11    C10     109.470    3.000
 CM5      H112   C11    C10     109.470    3.000
 CM5      C11    C10    H101    109.470    3.000
 CM5      C11    C10    H102    109.470    3.000
 CM5      C11    C10    C9      111.000    3.000
 CM5      H101   C10    H102    107.900    3.000
 CM5      H101   C10    C9      109.470    3.000
 CM5      H102   C10    C9      109.470    3.000
 CM5      C10    C9     H91     109.470    3.000
 CM5      C10    C9     H92     109.470    3.000
 CM5      C10    C9     C8      111.000    3.000
 CM5      H91    C9     H92     107.900    3.000
 CM5      H91    C9     C8      109.470    3.000
 CM5      H92    C9     C8      109.470    3.000
 CM5      C9     C8     H82     109.470    3.000
 CM5      C9     C8     H81     109.470    3.000
 CM5      C9     C8     C7      111.000    3.000
 CM5      H82    C8     H81     107.900    3.000
 CM5      H82    C8     C7      109.470    3.000
 CM5      H81    C8     C7      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CM5      var_1    H34    O34    C29    C24       59.976   20.000   1
 CM5      var_2    O34    C29    C28    C27      180.000   20.000   3
 CM5      var_3    C29    C28    O33    H33      -60.006   20.000   1
 CM5      var_4    C29    C28    C27    C26       60.000   20.000   3
 CM5      var_5    C28    C27    O32    H32       59.945   20.000   1
 CM5      var_6    C28    C27    C26    O25      -60.000   20.000   3
 CM5      var_7    C27    C26    C30    O31     -174.853   20.000   3
 CM5      var_8    C26    C30    O31    H31      179.964   20.000   1
 CM5      var_9    C27    C26    O25    C24       60.000   20.000   1
 CM5      var_10   O34    C29    C24    O23       60.000   20.000   3
 CM5      var_11   C29    C24    O25    C26      -60.000   20.000   1
 CM5      var_12   C29    C24    O23    C16     -164.803   20.000   1
 CM5      var_13   C24    O23    C16    C15     -154.959   20.000   1
 CM5      var_14   O23    C16    C17    C18      180.000   20.000   3
 CM5      var_15   C16    C17    O21    H21      179.958   20.000   1
 CM5      var_16   C16    C17    C18    O22      180.000   20.000   3
 CM5      var_17   C17    C18    O22    H22      179.973   20.000   1
 CM5      var_18   O23    C16    C15    O14      180.000   20.000   3
 CM5      var_19   C16    C15    C19    O20     -176.200   20.000   3
 CM5      var_20   C15    C19    O20    H20      179.978   20.000   1
 CM5      var_21   C16    C15    O14    C13       60.000   20.000   1
 CM5      var_22   C15    O14    C13    O12      180.000   20.000   1
 CM5      var_23   O14    C13    C18    C17       60.000   20.000   3
 CM5      var_24   O14    C13    O12    C1       -64.669   20.000   1
 CM5      var_25   C13    O12    C1     C2       179.952   20.000   1
 CM5      var_26   O12    C1     C2     C3      -180.000   20.000   3
 CM5      var_27   C1     C2     C3     C4      -179.944   20.000   3
 CM5      var_28   C2     C3     C4     C5       180.000   20.000   3
 CM5      var_29   C3     C4     C5     C6       179.975   20.000   3
 CM5      var_30   C4     C5     C6     C11      -64.982   20.000   3
 CM5      var_31   C5     C6     C7     C8       180.000   20.000   3
 CM5      var_32   C6     C7     C8     C9       -60.000   20.000   3
 CM5      var_33   C5     C6     C11    C10      180.000   20.000   3
 CM5      var_34   C6     C11    C10    C9        60.000   20.000   3
 CM5      var_35   C11    C10    C9     C8       -60.000   20.000   3
 CM5      var_36   C10    C9     C8     C7        60.000   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 CM5      chir_01  C6     C7     C11    C5        negativ
 CM5      chir_02  C13    O12    C18    O14       negativ
 CM5      chir_03  C18    C13    O22    C17       positiv
 CM5      chir_04  C17    C18    O21    C16       negativ
 CM5      chir_05  C15    O14    C19    C16       positiv
 CM5      chir_06  C16    C17    C15    O23       negativ
 CM5      chir_07  C24    O23    O25    C29       negativ
 CM5      chir_08  C26    O25    C30    C27       positiv
 CM5      chir_09  C27    C26    O32    C28       negativ
 CM5      chir_10  C28    C27    O33    C29       positiv
 CM5      chir_11  C29    C24    C28    O34       negativ
# ------------------------------------------------------
`.trim();

monomers["ACA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ACA      ACA '6-AMINOHEXANOIC ACID                ' non-polymer        21   9 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ACA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ACA           O2     O    OC       -0.500      0.000    0.000    0.000
 ACA           C1     C    C         0.000     -1.243   -0.009   -0.137
 ACA           O1     O    OC       -0.500     -1.745   -0.025   -1.283
 ACA           C2     C    CH2       0.000     -2.137    0.002    1.076
 ACA           H21    H    H         0.000     -1.941    0.901    1.664
 ACA           H22    H    H         0.000     -1.933   -0.882    1.684
 ACA           C3     C    CH2       0.000     -3.600   -0.010    0.631
 ACA           H31    H    H         0.000     -3.794   -0.909    0.042
 ACA           H32    H    H         0.000     -3.802    0.873    0.022
 ACA           C4     C    CH2       0.000     -4.507    0.000    1.862
 ACA           H41    H    H         0.000     -4.311    0.900    2.449
 ACA           H42    H    H         0.000     -4.301   -0.882    2.471
 ACA           C5     C    CH2       0.000     -5.971   -0.013    1.419
 ACA           H51    H    H         0.000     -6.164   -0.913    0.832
 ACA           H52    H    H         0.000     -6.173    0.869    0.808
 ACA           C6     C    CH2       0.000     -6.879   -0.002    2.650
 ACA           H61    H    H         0.000     -6.683    0.898    3.237
 ACA           H62    H    H         0.000     -6.674   -0.884    3.260
 ACA           N6     N    NH2       0.000     -8.283   -0.015    2.225
 ACA           HN62   H    H         0.000     -8.519   -0.029    1.240
 ACA           HN61   H    H         0.000     -9.026   -0.010    2.914
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ACA      O2     n/a    C1     START
 ACA      C1     O2     C2     .
 ACA      O1     C1     .      .
 ACA      C2     C1     C3     .
 ACA      H21    C2     .      .
 ACA      H22    C2     .      .
 ACA      C3     C2     C4     .
 ACA      H31    C3     .      .
 ACA      H32    C3     .      .
 ACA      C4     C3     C5     .
 ACA      H41    C4     .      .
 ACA      H42    C4     .      .
 ACA      C5     C4     C6     .
 ACA      H51    C5     .      .
 ACA      H52    C5     .      .
 ACA      C6     C5     N6     .
 ACA      H61    C6     .      .
 ACA      H62    C6     .      .
 ACA      N6     C6     HN61   .
 ACA      HN62   N6     .      .
 ACA      HN61   N6     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ACA      O1     C1        deloc       1.250    0.020
 ACA      C1     O2        deloc       1.250    0.020
 ACA      C2     C1        single      1.510    0.020
 ACA      C3     C2        single      1.524    0.020
 ACA      H21    C2        single      1.092    0.020
 ACA      H22    C2        single      1.092    0.020
 ACA      C4     C3        single      1.524    0.020
 ACA      H31    C3        single      1.092    0.020
 ACA      H32    C3        single      1.092    0.020
 ACA      C5     C4        single      1.524    0.020
 ACA      H41    C4        single      1.092    0.020
 ACA      H42    C4        single      1.092    0.020
 ACA      C6     C5        single      1.524    0.020
 ACA      H51    C5        single      1.092    0.020
 ACA      H52    C5        single      1.092    0.020
 ACA      N6     C6        single      1.450    0.020
 ACA      H61    C6        single      1.092    0.020
 ACA      H62    C6        single      1.092    0.020
 ACA      HN61   N6        single      1.010    0.020
 ACA      HN62   N6        single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ACA      O2     C1     O1      123.000    3.000
 ACA      O2     C1     C2      118.500    3.000
 ACA      O1     C1     C2      118.500    3.000
 ACA      C1     C2     H21     109.470    3.000
 ACA      C1     C2     H22     109.470    3.000
 ACA      C1     C2     C3      109.470    3.000
 ACA      H21    C2     H22     107.900    3.000
 ACA      H21    C2     C3      109.470    3.000
 ACA      H22    C2     C3      109.470    3.000
 ACA      C2     C3     H31     109.470    3.000
 ACA      C2     C3     H32     109.470    3.000
 ACA      C2     C3     C4      111.000    3.000
 ACA      H31    C3     H32     107.900    3.000
 ACA      H31    C3     C4      109.470    3.000
 ACA      H32    C3     C4      109.470    3.000
 ACA      C3     C4     H41     109.470    3.000
 ACA      C3     C4     H42     109.470    3.000
 ACA      C3     C4     C5      111.000    3.000
 ACA      H41    C4     H42     107.900    3.000
 ACA      H41    C4     C5      109.470    3.000
 ACA      H42    C4     C5      109.470    3.000
 ACA      C4     C5     H51     109.470    3.000
 ACA      C4     C5     H52     109.470    3.000
 ACA      C4     C5     C6      111.000    3.000
 ACA      H51    C5     H52     107.900    3.000
 ACA      H51    C5     C6      109.470    3.000
 ACA      H52    C5     C6      109.470    3.000
 ACA      C5     C6     H61     109.470    3.000
 ACA      C5     C6     H62     109.470    3.000
 ACA      C5     C6     N6      109.470    3.000
 ACA      H61    C6     H62     107.900    3.000
 ACA      H61    C6     N6      109.470    3.000
 ACA      H62    C6     N6      109.470    3.000
 ACA      C6     N6     HN62    120.000    3.000
 ACA      C6     N6     HN61    120.000    3.000
 ACA      HN62   N6     HN61    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ACA      var_1    O2     C1     C2     C3       179.922   20.000   3
 ACA      var_2    C1     C2     C3     C4       179.996   20.000   3
 ACA      var_3    C2     C3     C4     C5      -179.920   20.000   3
 ACA      var_4    C3     C4     C5     C6      -179.960   20.000   3
 ACA      var_5    C4     C5     C6     N6       179.990   20.000   3
 ACA      var_6    C5     C6     N6     HN61    -179.999   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ACA      plan-1    C1        0.020
 ACA      plan-1    O1        0.020
 ACA      plan-1    O2        0.020
 ACA      plan-1    C2        0.020
 ACA      plan-2    N6        0.020
 ACA      plan-2    C6        0.020
 ACA      plan-2    HN61      0.020
 ACA      plan-2    HN62      0.020
# ------------------------------------------------------
`.trim();

monomers["ACN"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ACN      ACN 'ACETONE                             ' non-polymer        10   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ACN
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ACN           O      O    O         0.000      0.000    0.000    0.000
 ACN           C      C    C         0.000     -0.953    0.742    0.002
 ACN           C2     C    CH3       0.000     -2.349    0.175    0.000
 ACN           H23    H    H         0.000     -3.003    0.844   -0.498
 ACN           H22    H    H         0.000     -2.352   -0.758   -0.502
 ACN           H21    H    H         0.000     -2.678    0.039    0.998
 ACN           C1     C    CH3       0.000     -0.745    2.235    0.000
 ACN           H13    H    H         0.000     -1.551    2.705    0.501
 ACN           H12    H    H         0.000      0.161    2.467    0.497
 ACN           H11    H    H         0.000     -0.699    2.585   -0.999
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ACN      O      n/a    C      START
 ACN      C      O      C1     .
 ACN      C2     C      H21    .
 ACN      H23    C2     .      .
 ACN      H22    C2     .      .
 ACN      H21    C2     .      .
 ACN      C1     C      H11    .
 ACN      H13    C1     .      .
 ACN      H12    C1     .      .
 ACN      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ACN      C      O         double      1.220    0.020
 ACN      C1     C         single      1.500    0.020
 ACN      C2     C         single      1.500    0.020
 ACN      H11    C1        single      1.059    0.020
 ACN      H12    C1        single      1.059    0.020
 ACN      H13    C1        single      1.059    0.020
 ACN      H21    C2        single      1.059    0.020
 ACN      H22    C2        single      1.059    0.020
 ACN      H23    C2        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ACN      O      C      C2      123.000    3.000
 ACN      O      C      C1      123.000    3.000
 ACN      C2     C      C1      120.000    3.000
 ACN      C      C2     H23     109.470    3.000
 ACN      C      C2     H22     109.470    3.000
 ACN      C      C2     H21     109.470    3.000
 ACN      H23    C2     H22     109.470    3.000
 ACN      H23    C2     H21     109.470    3.000
 ACN      H22    C2     H21     109.470    3.000
 ACN      C      C1     H13     109.470    3.000
 ACN      C      C1     H12     109.470    3.000
 ACN      C      C1     H11     109.470    3.000
 ACN      H13    C1     H12     109.470    3.000
 ACN      H13    C1     H11     109.470    3.000
 ACN      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ACN      var_1    O      C      C2     H21       90.013   20.000   1
 ACN      var_2    O      C      C1     H11       89.990   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ACN      plan-1    C         0.020
 ACN      plan-1    O         0.000
 ACN      plan-1    C1        0.000
 ACN      plan-1    C2        0.000
# ------------------------------------------------------
`.trim();

monomers["CCN"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CCN      CCN 'ACETONITRILE                        ' non-polymer         6   3 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CCN
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CCN           C2     C    CH3       0.000      0.000    0.000    0.000
 CCN           H23    H    H         0.000      0.353    0.499   -0.865
 CCN           H21    H    H         0.000      0.353    0.499    0.865
 CCN           H22    H    H         0.000      0.353   -0.998    0.000
 CCN           C1     C    CSP       0.000     -1.472    0.000    0.000
 CCN           N      N    NS        0.000     -2.608    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CCN      C2     n/a    C1     START
 CCN      H23    C2     .      .
 CCN      H21    C2     .      .
 CCN      H22    C2     .      .
 CCN      C1     C2     N      .
 CCN      N      C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CCN      N      C1        triple      1.158    0.020
 CCN      C1     C2        single      1.470    0.020
 CCN      H21    C2        single      1.059    0.020
 CCN      H22    C2        single      1.059    0.020
 CCN      H23    C2        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CCN      H23    C2     H21     109.470    3.000
 CCN      H23    C2     H22     109.470    3.000
 CCN      H21    C2     H22     109.470    3.000
 CCN      H23    C2     C1      109.470    3.000
 CCN      H21    C2     C1      109.470    3.000
 CCN      H22    C2     C1      109.470    3.000
 CCN      C2     C1     N       180.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CCN      var_1    H22    C2     C1     N          0.000   20.000   1
# ------------------------------------------------------
`.trim();

monomers["DR6"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DR6      DR6 '"ALPHA-[4-(1,1,3,3 - TETRAMETHYLBUTY' non-polymer       247 105 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DR6
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DR6           ODR    O    OH1       0.000      0.000    0.000    0.000
 DR6           HDK1   H    H         0.000      0.087   -0.099    0.957
 DR6           CDQ    C    CH2       0.000     -1.016   -0.875   -0.474
 DR6           HDJ1   H    H         0.000     -1.628   -0.359   -1.217
 DR6           HDJ2   H    H         0.000     -1.647   -1.191    0.359
 DR6           CDP    C    CH2       0.000     -0.367   -2.090   -1.108
 DR6           HDI1   H    H         0.000     -1.139   -2.776   -1.463
 DR6           HDI2   H    H         0.000      0.258   -2.599   -0.370
 DR6           ODO    O    O2        0.000      0.436   -1.670   -2.202
 DR6           CDN    C    CH2       0.000      1.071   -2.773   -2.836
 DR6           HDH1   H    H         0.000      0.316   -3.475   -3.196
 DR6           HDH2   H    H         0.000      1.726   -3.279   -2.123
 DR6           CDM    C    CH2       0.000      1.892   -2.266   -4.007
 DR6           HDG1   H    H         0.000      2.396   -3.103   -4.493
 DR6           HDG2   H    H         0.000      2.636   -1.550   -3.652
 DR6           ODL    O    O2        0.000      1.027   -1.628   -4.937
 DR6           CDK    C    CH2       0.000      1.745   -1.131   -6.059
 DR6           HDF1   H    H         0.000      2.262   -1.953   -6.558
 DR6           HDF2   H    H         0.000      2.476   -0.390   -5.728
 DR6           CDJ    C    CH2       0.000      0.770   -0.485   -7.024
 DR6           HDE1   H    H         0.000      0.047   -1.227   -7.368
 DR6           HDE2   H    H         0.000      1.313   -0.084   -7.882
 DR6           ODI    O    O2        0.000      0.088    0.570   -6.358
 DR6           CDH    C    CH2       0.000     -0.843    1.215   -7.218
 DR6           HZH1   H    H         0.000     -1.575    0.488   -7.577
 DR6           HZH2   H    H         0.000     -0.315    1.650   -8.070
 DR6           CDG    C    CH2       0.000     -1.552    2.310   -6.447
 DR6           HDD1   H    H         0.000     -2.260    2.821   -7.103
 DR6           HDD2   H    H         0.000     -0.820    3.029   -6.073
 DR6           ODF    O    O2        0.000     -2.250    1.731   -5.354
 DR6           CDE    C    CH2       0.000     -2.937    2.718   -4.592
 DR6           HDC1   H    H         0.000     -3.649    3.244   -5.231
 DR6           HDC2   H    H         0.000     -2.219    3.432   -4.183
 DR6           CDD    C    CH2       0.000     -3.680    2.038   -3.458
 DR6           HDB1   H    H         0.000     -4.199    2.788   -2.857
 DR6           HDB2   H    H         0.000     -2.971    1.496   -2.828
 DR6           ODC    O    O2        0.000     -4.624    1.127   -4.002
 DR6           CDB    C    CH2       0.000     -5.353    0.459   -2.979
 DR6           HDA1   H    H         0.000     -5.879    1.193   -2.364
 DR6           HDA2   H    H         0.000     -4.666   -0.114   -2.353
 DR6           CDA    C    CH2       0.000     -6.359   -0.479   -3.620
 DR6           H6A    H    H         0.000     -6.914   -1.008   -2.843
 DR6           H6B    H    H         0.000     -5.837   -1.202   -4.249
 DR6           OCZ    O    O2        0.000     -7.259    0.280   -4.414
 DR6           CCY    C    CH2       0.000     -8.228   -0.550   -5.041
 DR6           HCY1   H    H         0.000     -8.794   -1.093   -4.281
 DR6           HCY2   H    H         0.000     -7.729   -1.264   -5.700
 DR6           CCX    C    CH2       0.000     -9.172    0.316   -5.854
 DR6           H3X    H    H         0.000     -9.912   -0.314   -6.352
 DR6           H3Y    H    H         0.000     -8.606    0.873   -6.604
 DR6           OCW    O    O2        0.000     -9.831    1.225   -4.983
 DR6           CCV    C    CH2       0.000    -10.731    2.066   -5.694
 DR6           H3V    H    H         0.000    -11.480    1.456   -6.204
 DR6           H4V    H    H         0.000    -10.181    2.655   -6.430
 DR6           CCU    C    CH2       0.000    -11.419    2.996   -4.712
 DR6           H3U    H    H         0.000    -12.103    3.656   -5.249
 DR6           H4U    H    H         0.000    -10.671    3.595   -4.189
 DR6           OCT    O    O2        0.000    -12.148    2.219   -3.771
 DR6           CCS    C    CH2       0.000    -12.816    3.042   -2.822
 DR6           H3S    H    H         0.000    -13.503    3.715   -3.339
 DR6           H4S    H    H         0.000    -12.082    3.629   -2.265
 DR6           CCR    C    CH2       0.000    -13.593    2.160   -1.863
 DR6           H3R    H    H         0.000    -14.099    2.782   -1.121
 DR6           H4R    H    H         0.000    -12.910    1.475   -1.357
 DR6           OCQ    O    O2        0.000    -14.556    1.416   -2.596
 DR6           CCP    C    CH2       0.000    -15.318    0.569   -1.744
 DR6           H3P    H    H         0.000    -15.830    1.170   -0.990
 DR6           H4P    H    H         0.000    -14.656   -0.146   -1.250
 DR6           CCO    C    CH2       0.000    -16.342   -0.179   -2.576
 DR6           H3O    H    H         0.000    -16.922   -0.844   -1.933
 DR6           H4O    H    H         0.000    -15.832   -0.768   -3.341
 DR6           OCN    O    O2        0.000    -17.209    0.759   -3.197
 DR6           CCM    C    CH2       0.000    -18.193    0.110   -3.993
 DR6           H3M    H    H         0.000    -18.784   -0.564   -3.370
 DR6           H4M    H    H         0.000    -17.706   -0.462   -4.786
 DR6           CCL    C    CH2       0.000    -19.101    1.158   -4.609
 DR6           H3L    H    H         0.000    -19.852    0.672   -5.234
 DR6           H4L    H    H         0.000    -18.509    1.844   -5.219
 DR6           OCK    O    O2        0.000    -19.744    1.882   -3.569
 DR6           CCJ    C    CH2       0.000    -20.611    2.883   -4.091
 DR6           H3J    H    H         0.000    -21.370    2.418   -4.724
 DR6           H4J    H    H         0.000    -20.034    3.597   -4.682
 DR6           CCI    C    CH2       0.000    -21.284    3.603   -2.938
 DR6           H3I    H    H         0.000    -21.941    4.384   -3.327
 DR6           H4I    H    H         0.000    -20.526    4.054   -2.294
 DR6           OCH    O    O2        0.000    -22.049    2.668   -2.190
 DR6           CCG    C    CH2       0.000    -22.705    3.291   -1.093
 DR6           H3G    H    H         0.000    -23.366    4.079   -1.459
 DR6           H4G    H    H         0.000    -21.963    3.724   -0.419
 DR6           CCF    C    CH2       0.000    -23.520    2.250   -0.348
 DR6           H3F    H    H         0.000    -24.017    2.714    0.506
 DR6           H4F    H    H         0.000    -22.863    1.452    0.005
 DR6           OCE    O    O2        0.000    -24.494    1.709   -1.228
 DR6           CCD    C    CH2       0.000    -25.292    0.723   -0.582
 DR6           H4D    H    H         0.000    -25.796    1.167    0.279
 DR6           H5D    H    H         0.000    -24.657   -0.100   -0.246
 DR6           CCC    C    CH2       0.000    -26.324    0.201   -1.561
 DR6           HC4    H    H         0.000    -26.932   -0.567   -1.078
 DR6           HC5    H    H         0.000    -25.822   -0.227   -2.431
 DR6           OCB    O    O2        0.000    -27.157    1.276   -1.974
 DR6           CCA    C    CH2       0.000    -28.149    0.843   -2.897
 DR6           H4A    H    H         0.000    -28.767    0.071   -2.435
 DR6           H5A    H    H         0.000    -27.668    0.437   -3.789
 DR6           CBZ    C    CH2       0.000    -29.016    2.025   -3.282
 DR6           H1Z    H    H         0.000    -29.773    1.706   -4.002
 DR6           H2Z    H    H         0.000    -28.397    2.806   -3.728
 DR6           OBY    O    O2        0.000    -29.653    2.532   -2.116
 DR6           CBX    C    CH2       0.000    -30.483    3.647   -2.419
 DR6           H1X    H    H         0.000    -31.257    3.347   -3.129
 DR6           H2X    H    H         0.000    -29.880    4.446   -2.856
 DR6           CBW    C    CH2       0.000    -31.132    4.141   -1.141
 DR6           H1W    H    H         0.000    -31.761    5.007   -1.359
 DR6           H2W    H    H         0.000    -30.360    4.425   -0.423
 DR6           OBV    O    O2        0.000    -31.930    3.100   -0.593
 DR6           CBU    C    CH2       0.000    -32.547    3.502    0.623
 DR6           H1U    H    H         0.000    -33.190    4.367    0.440
 DR6           H2U    H    H         0.000    -31.781    3.768    1.354
 DR6           CBT    C    CH2       0.000    -33.382    2.354    1.158
 DR6           H1T    H    H         0.000    -33.851    2.648    2.100
 DR6           H2T    H    H         0.000    -32.745    1.483    1.326
 DR6           OBS    O    O2        0.000    -34.387    2.031    0.208
 DR6           CBR    C    CH2       0.000    -35.190    0.942    0.649
 DR6           H1R    H    H         0.000    -35.679    1.203    1.590
 DR6           H2R    H    H         0.000    -34.563    0.060    0.798
 DR6           CBQ    C    CH2       0.000    -36.241    0.644   -0.402
 DR6           H1Q    H    H         0.000    -36.853   -0.201   -0.080
 DR6           H2Q    H    H         0.000    -35.755    0.399   -1.349
 DR6           OBP    O    O2        0.000    -37.064    1.789   -0.573
 DR6           CBO    C    CH2       0.000    -38.058    1.574   -1.567
 DR6           H1O    H    H         0.000    -38.694    0.736   -1.275
 DR6           H2O    H    H         0.000    -37.580    1.351   -2.523
 DR6           CBN    C    CH2       0.000    -38.901    2.827   -1.703
 DR6           H1N    H    H         0.000    -39.659    2.678   -2.475
 DR6           H2N    H    H         0.000    -38.264    3.670   -1.978
 DR6           OBM    O    O2        0.000    -39.535    3.097   -0.461
 DR6           CBL    C    CH2       0.000    -40.324    4.278   -0.524
 DR6           H1L    H    H         0.000    -41.099    4.162   -1.285
 DR6           H2L    H    H         0.000    -39.690    5.131   -0.778
 DR6           CBK    C    CH2       0.000    -40.972    4.513    0.827
 DR6           H1K    H    H         0.000    -41.570    5.427    0.794
 DR6           H2K    H    H         0.000    -40.200    4.612    1.592
 DR6           OBJ    O    O2        0.000    -41.810    3.408    1.138
 DR6           CBI    C    CH2       0.000    -42.429    3.565    2.409
 DR6           H1I    H    H         0.000    -43.040    4.470    2.411
 DR6           H2I    H    H         0.000    -41.663    3.643    3.183
 DR6           CBH    C    CH2       0.000    -43.308    2.359    2.683
 DR6           H1H    H    H         0.000    -43.778    2.463    3.664
 DR6           H2H    H    H         0.000    -42.701    1.451    2.666
 DR6           OBG    O    O2        0.000    -44.311    2.279    1.681
 DR6           CBF    C    CH2       0.000    -45.154    1.149    1.877
 DR6           H1F    H    H         0.000    -45.645    1.221    2.850
 DR6           H2F    H    H         0.000    -44.558    0.235    1.839
 DR6           CBE    C    CH2       0.000    -46.202    1.118    0.781
 DR6           H1E    H    H         0.000    -46.845    0.246    0.913
 DR6           H2E    H    H         0.000    -45.712    1.064   -0.193
 DR6           OBD    O    O2        0.000    -46.985    2.302    0.854
 DR6           CBC    C    CH2       0.000    -47.973    2.336   -0.169
 DR6           HAC    H    H         0.000    -48.640    1.478   -0.064
 DR6           HBC    H    H         0.000    -47.491    2.303   -1.148
 DR6           CBB    C    CH2       0.000    -48.772    3.619   -0.040
 DR6           HAB    H    H         0.000    -49.268    3.646    0.933
 DR6           HBB    H    H         0.000    -49.524    3.664   -0.831
 DR6           OBA    O    O2        0.000    -47.892    4.727   -0.157
 DR6           CA8    C    CH2       0.000    -48.594    5.962   -0.066
 DR6           H18    H    H         0.000    -49.101    6.026    0.900
 DR6           H28    H    H         0.000    -49.333    6.024   -0.867
 DR6           CA7    C    CH2       0.000    -47.606    7.104   -0.197
 DR6           H17    H    H         0.000    -48.136    8.057   -0.142
 DR6           H27    H    H         0.000    -47.087    7.032   -1.155
 DR6           OA6    O    O2        0.000    -46.662    7.024    0.861
 DR6           CA5    C    CH2       0.000    -45.693    8.063    0.776
 DR6           H15    H    H         0.000    -46.191    9.034    0.831
 DR6           H25    H    H         0.000    -45.154    7.985   -0.171
 DR6           CA4    C    CH2       0.000    -44.717    7.926    1.928
 DR6           H14    H    H         0.000    -43.961    8.711    1.863
 DR6           H24    H    H         0.000    -44.231    6.949    1.883
 DR6           OA3    O    O2        0.000    -45.426    8.049    3.152
 DR6           CA2    C    CH2       0.000    -44.560    7.907    4.272
 DR6           H21    H    H         0.000    -43.790    8.680    4.242
 DR6           H22    H    H         0.000    -44.086    6.923    4.248
 DR6           CA1    C    CH2       0.000    -45.371    8.048    5.546
 DR6           H11    H    H         0.000    -44.718    7.926    6.413
 DR6           H12    H    H         0.000    -46.152    7.285    5.571
 DR6           OAR    O    O2        0.000    -45.965    9.339    5.577
 DR6           CAQ    C    CH2       0.000    -46.758    9.518    6.743
 DR6           H1QA   H    H         0.000    -46.134    9.406    7.633
 DR6           H2QA   H    H         0.000    -47.556    8.773    6.764
 DR6           CAP    C    CH2       0.000    -47.364   10.910    6.720
 DR6           H1P    H    H         0.000    -47.987   11.054    7.605
 DR6           H2P    H    H         0.000    -47.975   11.029    5.823
 DR6           OAO    O    O2        0.000    -46.318   11.870    6.714
 DR6           CAN    C    CH2       0.000    -46.829   13.197    6.669
 DR6           H1NA   H    H         0.000    -47.456   13.378    7.545
 DR6           H2NA   H    H         0.000    -47.423   13.331    5.763
 DR6           CAM    C    CH2       0.000    -45.669   14.174    6.665
 DR6           H1M    H    H         0.000    -45.082   14.051    7.578
 DR6           H2M    H    H         0.000    -46.050   15.196    6.615
 DR6           OAL    O    O2        0.000    -44.849   13.916    5.534
 DR6           CAK    C    CH2       0.000    -43.753   14.820    5.466
 DR6           HK     H    H         0.000    -43.139   14.721    6.364
 DR6           H2KA   H    H         0.000    -44.126   15.844    5.393
 DR6           CAJ    C    CH2       0.000    -42.919   14.496    4.242
 DR6           H1J    H    H         0.000    -42.082   15.194    4.172
 DR6           H2J    H    H         0.000    -43.536   14.578    3.345
 DR6           OAI    O    O2        0.000    -42.423   13.169    4.359
 DR6           CAH    C    CH2       0.000    -41.647   12.802    3.224
 DR6           H1     H    H         0.000    -40.797   13.480    3.126
 DR6           H2     H    H         0.000    -42.263   12.861    2.324
 DR6           CAG    C    CH2       0.000    -41.147   11.382    3.405
 DR6           H1G    H    H         0.000    -40.561   11.086    2.532
 DR6           H2G    H    H         0.000    -41.996   10.705    3.520
 DR6           OAF    O    O2        0.000    -40.327   11.323    4.571
 DR6           CAE    C    CR6       0.000    -39.339   10.388    4.587
 DR6           CAY    C    CR16      0.000    -39.498    9.192    3.887
 DR6           H1Y    H    H         0.000    -40.410    9.007    3.332
 DR6           CAX    C    CR16      0.000    -38.484    8.234    3.901
 DR6           H1XA   H    H         0.000    -38.593    7.301    3.363
 DR6           CAD    C    CR16      0.000    -38.164   10.626    5.300
 DR6           H1D    H    H         0.000    -38.039   11.555    5.843
 DR6           CAC    C    CR16      0.000    -37.150    9.668    5.314
 DR6           H1C    H    H         0.000    -36.232    9.838    5.863
 DR6           CAW    C    CR6       0.000    -37.347    8.507    4.615
 DR6           CAV    C    CT        0.000    -36.226    7.448    4.629
 DR6           CAB    C    CH3       0.000    -36.843    6.159    5.245
 DR6           H3B    H    H         0.000    -36.094    5.414    5.345
 DR6           H2B    H    H         0.000    -37.248    6.375    6.202
 DR6           H1B    H    H         0.000    -37.615    5.793    4.615
 DR6           CBA    C    CH3       0.000    -35.037    7.815    5.543
 DR6           HB3    H    H         0.000    -34.275    7.082    5.449
 DR6           HB2    H    H         0.000    -34.648    8.761    5.262
 DR6           HB1    H    H         0.000    -35.360    7.856    6.552
 DR6           CAU    C    CH2       0.000    -35.719    7.070    3.190
 DR6           H1UA   H    H         0.000    -36.587    6.572    2.755
 DR6           H2UA   H    H         0.000    -34.943    6.330    3.399
 DR6           CAT    C    CT        0.000    -35.169    8.136    2.186
 DR6           CAZ    C    CH3       0.000    -36.157    9.266    1.874
 DR6           H3Z    H    H         0.000    -37.074    8.853    1.540
 DR6           H2ZA   H    H         0.000    -36.327    9.840    2.748
 DR6           H1ZA   H    H         0.000    -35.755    9.889    1.117
 DR6           CAS    C    CH3       0.000    -33.837    8.746    2.667
 DR6           H3SA   H    H         0.000    -33.407    9.323    1.889
 DR6           H2S    H    H         0.000    -34.013    9.368    3.508
 DR6           H1S    H    H         0.000    -33.167    7.971    2.940
 DR6           CAA    C    CH3       0.000    -34.866    7.397    0.858
 DR6           HA3    H    H         0.000    -34.453    8.076    0.155
 DR6           HA2    H    H         0.000    -34.173    6.613    1.034
 DR6           HA1    H    H         0.000    -35.762    6.988    0.463
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DR6      ODR    n/a    CDQ    START
 DR6      HDK1   ODR    .      .
 DR6      CDQ    ODR    CDP    .
 DR6      HDJ1   CDQ    .      .
 DR6      HDJ2   CDQ    .      .
 DR6      CDP    CDQ    ODO    .
 DR6      HDI1   CDP    .      .
 DR6      HDI2   CDP    .      .
 DR6      ODO    CDP    CDN    .
 DR6      CDN    ODO    CDM    .
 DR6      HDH1   CDN    .      .
 DR6      HDH2   CDN    .      .
 DR6      CDM    CDN    ODL    .
 DR6      HDG1   CDM    .      .
 DR6      HDG2   CDM    .      .
 DR6      ODL    CDM    CDK    .
 DR6      CDK    ODL    CDJ    .
 DR6      HDF1   CDK    .      .
 DR6      HDF2   CDK    .      .
 DR6      CDJ    CDK    ODI    .
 DR6      HDE1   CDJ    .      .
 DR6      HDE2   CDJ    .      .
 DR6      ODI    CDJ    CDH    .
 DR6      CDH    ODI    CDG    .
 DR6      HZH1   CDH    .      .
 DR6      HZH2   CDH    .      .
 DR6      CDG    CDH    ODF    .
 DR6      HDD1   CDG    .      .
 DR6      HDD2   CDG    .      .
 DR6      ODF    CDG    CDE    .
 DR6      CDE    ODF    CDD    .
 DR6      HDC1   CDE    .      .
 DR6      HDC2   CDE    .      .
 DR6      CDD    CDE    ODC    .
 DR6      HDB1   CDD    .      .
 DR6      HDB2   CDD    .      .
 DR6      ODC    CDD    CDB    .
 DR6      CDB    ODC    CDA    .
 DR6      HDA1   CDB    .      .
 DR6      HDA2   CDB    .      .
 DR6      CDA    CDB    OCZ    .
 DR6      H6A    CDA    .      .
 DR6      H6B    CDA    .      .
 DR6      OCZ    CDA    CCY    .
 DR6      CCY    OCZ    CCX    .
 DR6      HCY1   CCY    .      .
 DR6      HCY2   CCY    .      .
 DR6      CCX    CCY    OCW    .
 DR6      H3X    CCX    .      .
 DR6      H3Y    CCX    .      .
 DR6      OCW    CCX    CCV    .
 DR6      CCV    OCW    CCU    .
 DR6      H3V    CCV    .      .
 DR6      H4V    CCV    .      .
 DR6      CCU    CCV    OCT    .
 DR6      H3U    CCU    .      .
 DR6      H4U    CCU    .      .
 DR6      OCT    CCU    CCS    .
 DR6      CCS    OCT    CCR    .
 DR6      H3S    CCS    .      .
 DR6      H4S    CCS    .      .
 DR6      CCR    CCS    OCQ    .
 DR6      H3R    CCR    .      .
 DR6      H4R    CCR    .      .
 DR6      OCQ    CCR    CCP    .
 DR6      CCP    OCQ    CCO    .
 DR6      H3P    CCP    .      .
 DR6      H4P    CCP    .      .
 DR6      CCO    CCP    OCN    .
 DR6      H3O    CCO    .      .
 DR6      H4O    CCO    .      .
 DR6      OCN    CCO    CCM    .
 DR6      CCM    OCN    CCL    .
 DR6      H3M    CCM    .      .
 DR6      H4M    CCM    .      .
 DR6      CCL    CCM    OCK    .
 DR6      H3L    CCL    .      .
 DR6      H4L    CCL    .      .
 DR6      OCK    CCL    CCJ    .
 DR6      CCJ    OCK    CCI    .
 DR6      H3J    CCJ    .      .
 DR6      H4J    CCJ    .      .
 DR6      CCI    CCJ    OCH    .
 DR6      H3I    CCI    .      .
 DR6      H4I    CCI    .      .
 DR6      OCH    CCI    CCG    .
 DR6      CCG    OCH    CCF    .
 DR6      H3G    CCG    .      .
 DR6      H4G    CCG    .      .
 DR6      CCF    CCG    OCE    .
 DR6      H3F    CCF    .      .
 DR6      H4F    CCF    .      .
 DR6      OCE    CCF    CCD    .
 DR6      CCD    OCE    CCC    .
 DR6      H4D    CCD    .      .
 DR6      H5D    CCD    .      .
 DR6      CCC    CCD    OCB    .
 DR6      HC4    CCC    .      .
 DR6      HC5    CCC    .      .
 DR6      OCB    CCC    CCA    .
 DR6      CCA    OCB    CBZ    .
 DR6      H4A    CCA    .      .
 DR6      H5A    CCA    .      .
 DR6      CBZ    CCA    OBY    .
 DR6      H1Z    CBZ    .      .
 DR6      H2Z    CBZ    .      .
 DR6      OBY    CBZ    CBX    .
 DR6      CBX    OBY    CBW    .
 DR6      H1X    CBX    .      .
 DR6      H2X    CBX    .      .
 DR6      CBW    CBX    OBV    .
 DR6      H1W    CBW    .      .
 DR6      H2W    CBW    .      .
 DR6      OBV    CBW    CBU    .
 DR6      CBU    OBV    CBT    .
 DR6      H1U    CBU    .      .
 DR6      H2U    CBU    .      .
 DR6      CBT    CBU    OBS    .
 DR6      H1T    CBT    .      .
 DR6      H2T    CBT    .      .
 DR6      OBS    CBT    CBR    .
 DR6      CBR    OBS    CBQ    .
 DR6      H1R    CBR    .      .
 DR6      H2R    CBR    .      .
 DR6      CBQ    CBR    OBP    .
 DR6      H1Q    CBQ    .      .
 DR6      H2Q    CBQ    .      .
 DR6      OBP    CBQ    CBO    .
 DR6      CBO    OBP    CBN    .
 DR6      H1O    CBO    .      .
 DR6      H2O    CBO    .      .
 DR6      CBN    CBO    OBM    .
 DR6      H1N    CBN    .      .
 DR6      H2N    CBN    .      .
 DR6      OBM    CBN    CBL    .
 DR6      CBL    OBM    CBK    .
 DR6      H1L    CBL    .      .
 DR6      H2L    CBL    .      .
 DR6      CBK    CBL    OBJ    .
 DR6      H1K    CBK    .      .
 DR6      H2K    CBK    .      .
 DR6      OBJ    CBK    CBI    .
 DR6      CBI    OBJ    CBH    .
 DR6      H1I    CBI    .      .
 DR6      H2I    CBI    .      .
 DR6      CBH    CBI    OBG    .
 DR6      H1H    CBH    .      .
 DR6      H2H    CBH    .      .
 DR6      OBG    CBH    CBF    .
 DR6      CBF    OBG    CBE    .
 DR6      H1F    CBF    .      .
 DR6      H2F    CBF    .      .
 DR6      CBE    CBF    OBD    .
 DR6      H1E    CBE    .      .
 DR6      H2E    CBE    .      .
 DR6      OBD    CBE    CBC    .
 DR6      CBC    OBD    CBB    .
 DR6      HAC    CBC    .      .
 DR6      HBC    CBC    .      .
 DR6      CBB    CBC    OBA    .
 DR6      HAB    CBB    .      .
 DR6      HBB    CBB    .      .
 DR6      OBA    CBB    CA8    .
 DR6      CA8    OBA    CA7    .
 DR6      H18    CA8    .      .
 DR6      H28    CA8    .      .
 DR6      CA7    CA8    OA6    .
 DR6      H17    CA7    .      .
 DR6      H27    CA7    .      .
 DR6      OA6    CA7    CA5    .
 DR6      CA5    OA6    CA4    .
 DR6      H15    CA5    .      .
 DR6      H25    CA5    .      .
 DR6      CA4    CA5    OA3    .
 DR6      H14    CA4    .      .
 DR6      H24    CA4    .      .
 DR6      OA3    CA4    CA2    .
 DR6      CA2    OA3    CA1    .
 DR6      H21    CA2    .      .
 DR6      H22    CA2    .      .
 DR6      CA1    CA2    OAR    .
 DR6      H11    CA1    .      .
 DR6      H12    CA1    .      .
 DR6      OAR    CA1    CAQ    .
 DR6      CAQ    OAR    CAP    .
 DR6      H1QA   CAQ    .      .
 DR6      H2QA   CAQ    .      .
 DR6      CAP    CAQ    OAO    .
 DR6      H1P    CAP    .      .
 DR6      H2P    CAP    .      .
 DR6      OAO    CAP    CAN    .
 DR6      CAN    OAO    CAM    .
 DR6      H1NA   CAN    .      .
 DR6      H2NA   CAN    .      .
 DR6      CAM    CAN    OAL    .
 DR6      H1M    CAM    .      .
 DR6      H2M    CAM    .      .
 DR6      OAL    CAM    CAK    .
 DR6      CAK    OAL    CAJ    .
 DR6      HK     CAK    .      .
 DR6      H2KA   CAK    .      .
 DR6      CAJ    CAK    OAI    .
 DR6      H1J    CAJ    .      .
 DR6      H2J    CAJ    .      .
 DR6      OAI    CAJ    CAH    .
 DR6      CAH    OAI    CAG    .
 DR6      H1     CAH    .      .
 DR6      H2     CAH    .      .
 DR6      CAG    CAH    OAF    .
 DR6      H1G    CAG    .      .
 DR6      H2G    CAG    .      .
 DR6      OAF    CAG    CAE    .
 DR6      CAE    OAF    CAD    .
 DR6      CAY    CAE    CAX    .
 DR6      H1Y    CAY    .      .
 DR6      CAX    CAY    H1XA   .
 DR6      H1XA   CAX    .      .
 DR6      CAD    CAE    CAC    .
 DR6      H1D    CAD    .      .
 DR6      CAC    CAD    CAW    .
 DR6      H1C    CAC    .      .
 DR6      CAW    CAC    CAV    .
 DR6      CAV    CAW    CAU    .
 DR6      CAB    CAV    H1B    .
 DR6      H3B    CAB    .      .
 DR6      H2B    CAB    .      .
 DR6      H1B    CAB    .      .
 DR6      CBA    CAV    HB1    .
 DR6      HB3    CBA    .      .
 DR6      HB2    CBA    .      .
 DR6      HB1    CBA    .      .
 DR6      CAU    CAV    CAT    .
 DR6      H1UA   CAU    .      .
 DR6      H2UA   CAU    .      .
 DR6      CAT    CAU    CAA    .
 DR6      CAZ    CAT    H1ZA   .
 DR6      H3Z    CAZ    .      .
 DR6      H2ZA   CAZ    .      .
 DR6      H1ZA   CAZ    .      .
 DR6      CAS    CAT    H1S    .
 DR6      H3SA   CAS    .      .
 DR6      H2S    CAS    .      .
 DR6      H1S    CAS    .      .
 DR6      CAA    CAT    HA1    .
 DR6      HA3    CAA    .      .
 DR6      HA2    CAA    .      .
 DR6      HA1    CAA    .      END
 DR6      CAW    CAX    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DR6      CAA    CAT       single      1.524    0.020
 DR6      HA1    CAA       single      1.059    0.020
 DR6      HA2    CAA       single      1.059    0.020
 DR6      HA3    CAA       single      1.059    0.020
 DR6      CAS    CAT       single      1.524    0.020
 DR6      CAZ    CAT       single      1.524    0.020
 DR6      CAT    CAU       single      1.524    0.020
 DR6      H1S    CAS       single      1.059    0.020
 DR6      H2S    CAS       single      1.059    0.020
 DR6      H3SA   CAS       single      1.059    0.020
 DR6      H1ZA   CAZ       single      1.059    0.020
 DR6      H2ZA   CAZ       single      1.059    0.020
 DR6      H3Z    CAZ       single      1.059    0.020
 DR6      CAU    CAV       single      1.524    0.020
 DR6      H1UA   CAU       single      1.092    0.020
 DR6      H2UA   CAU       single      1.092    0.020
 DR6      CAB    CAV       single      1.524    0.020
 DR6      CBA    CAV       single      1.524    0.020
 DR6      CAV    CAW       single      1.500    0.020
 DR6      H1B    CAB       single      1.059    0.020
 DR6      H2B    CAB       single      1.059    0.020
 DR6      H3B    CAB       single      1.059    0.020
 DR6      HB1    CBA       single      1.059    0.020
 DR6      HB2    CBA       single      1.059    0.020
 DR6      HB3    CBA       single      1.059    0.020
 DR6      CAW    CAX       double      1.390    0.020
 DR6      CAW    CAC       single      1.390    0.020
 DR6      CAX    CAY       single      1.390    0.020
 DR6      H1XA   CAX       single      1.083    0.020
 DR6      CAY    CAE       double      1.390    0.020
 DR6      H1Y    CAY       single      1.083    0.020
 DR6      CAC    CAD       double      1.390    0.020
 DR6      H1C    CAC       single      1.083    0.020
 DR6      CAD    CAE       single      1.390    0.020
 DR6      H1D    CAD       single      1.083    0.020
 DR6      CAE    OAF       single      1.370    0.020
 DR6      OAF    CAG       single      1.426    0.020
 DR6      CAG    CAH       single      1.524    0.020
 DR6      H1G    CAG       single      1.092    0.020
 DR6      H2G    CAG       single      1.092    0.020
 DR6      CAH    OAI       single      1.426    0.020
 DR6      H1     CAH       single      1.092    0.020
 DR6      H2     CAH       single      1.092    0.020
 DR6      OAI    CAJ       single      1.426    0.020
 DR6      CAJ    CAK       single      1.524    0.020
 DR6      H1J    CAJ       single      1.092    0.020
 DR6      H2J    CAJ       single      1.092    0.020
 DR6      CAK    OAL       single      1.426    0.020
 DR6      HK     CAK       single      1.092    0.020
 DR6      H2KA   CAK       single      1.092    0.020
 DR6      OAL    CAM       single      1.426    0.020
 DR6      CAM    CAN       single      1.524    0.020
 DR6      H1M    CAM       single      1.092    0.020
 DR6      H2M    CAM       single      1.092    0.020
 DR6      CAN    OAO       single      1.426    0.020
 DR6      H1NA   CAN       single      1.092    0.020
 DR6      H2NA   CAN       single      1.092    0.020
 DR6      OAO    CAP       single      1.426    0.020
 DR6      CAP    CAQ       single      1.524    0.020
 DR6      H1P    CAP       single      1.092    0.020
 DR6      H2P    CAP       single      1.092    0.020
 DR6      CAQ    OAR       single      1.426    0.020
 DR6      H1QA   CAQ       single      1.092    0.020
 DR6      H2QA   CAQ       single      1.092    0.020
 DR6      OAR    CA1       single      1.426    0.020
 DR6      CA1    CA2       single      1.524    0.020
 DR6      H11    CA1       single      1.092    0.020
 DR6      H12    CA1       single      1.092    0.020
 DR6      CA2    OA3       single      1.426    0.020
 DR6      H21    CA2       single      1.092    0.020
 DR6      H22    CA2       single      1.092    0.020
 DR6      OA3    CA4       single      1.426    0.020
 DR6      CA4    CA5       single      1.524    0.020
 DR6      H14    CA4       single      1.092    0.020
 DR6      H24    CA4       single      1.092    0.020
 DR6      CA5    OA6       single      1.426    0.020
 DR6      H15    CA5       single      1.092    0.020
 DR6      H25    CA5       single      1.092    0.020
 DR6      OA6    CA7       single      1.426    0.020
 DR6      CA7    CA8       single      1.524    0.020
 DR6      H17    CA7       single      1.092    0.020
 DR6      H27    CA7       single      1.092    0.020
 DR6      CA8    OBA       single      1.426    0.020
 DR6      H18    CA8       single      1.092    0.020
 DR6      H28    CA8       single      1.092    0.020
 DR6      OBA    CBB       single      1.426    0.020
 DR6      CBB    CBC       single      1.524    0.020
 DR6      HAB    CBB       single      1.092    0.020
 DR6      HBB    CBB       single      1.092    0.020
 DR6      CBC    OBD       single      1.426    0.020
 DR6      HAC    CBC       single      1.092    0.020
 DR6      HBC    CBC       single      1.092    0.020
 DR6      OBD    CBE       single      1.426    0.020
 DR6      CBE    CBF       single      1.524    0.020
 DR6      H1E    CBE       single      1.092    0.020
 DR6      H2E    CBE       single      1.092    0.020
 DR6      CBF    OBG       single      1.426    0.020
 DR6      H1F    CBF       single      1.092    0.020
 DR6      H2F    CBF       single      1.092    0.020
 DR6      OBG    CBH       single      1.426    0.020
 DR6      CBH    CBI       single      1.524    0.020
 DR6      H1H    CBH       single      1.092    0.020
 DR6      H2H    CBH       single      1.092    0.020
 DR6      CBI    OBJ       single      1.426    0.020
 DR6      H1I    CBI       single      1.092    0.020
 DR6      H2I    CBI       single      1.092    0.020
 DR6      OBJ    CBK       single      1.426    0.020
 DR6      CBK    CBL       single      1.524    0.020
 DR6      H1K    CBK       single      1.092    0.020
 DR6      H2K    CBK       single      1.092    0.020
 DR6      CBL    OBM       single      1.426    0.020
 DR6      H1L    CBL       single      1.092    0.020
 DR6      H2L    CBL       single      1.092    0.020
 DR6      OBM    CBN       single      1.426    0.020
 DR6      CBN    CBO       single      1.524    0.020
 DR6      H1N    CBN       single      1.092    0.020
 DR6      H2N    CBN       single      1.092    0.020
 DR6      CBO    OBP       single      1.426    0.020
 DR6      H1O    CBO       single      1.092    0.020
 DR6      H2O    CBO       single      1.092    0.020
 DR6      OBP    CBQ       single      1.426    0.020
 DR6      CBQ    CBR       single      1.524    0.020
 DR6      H1Q    CBQ       single      1.092    0.020
 DR6      H2Q    CBQ       single      1.092    0.020
 DR6      CBR    OBS       single      1.426    0.020
 DR6      H1R    CBR       single      1.092    0.020
 DR6      H2R    CBR       single      1.092    0.020
 DR6      OBS    CBT       single      1.426    0.020
 DR6      CBT    CBU       single      1.524    0.020
 DR6      H1T    CBT       single      1.092    0.020
 DR6      H2T    CBT       single      1.092    0.020
 DR6      CBU    OBV       single      1.426    0.020
 DR6      H1U    CBU       single      1.092    0.020
 DR6      H2U    CBU       single      1.092    0.020
 DR6      OBV    CBW       single      1.426    0.020
 DR6      CBW    CBX       single      1.524    0.020
 DR6      H1W    CBW       single      1.092    0.020
 DR6      H2W    CBW       single      1.092    0.020
 DR6      CBX    OBY       single      1.426    0.020
 DR6      H1X    CBX       single      1.092    0.020
 DR6      H2X    CBX       single      1.092    0.020
 DR6      OBY    CBZ       single      1.426    0.020
 DR6      CBZ    CCA       single      1.524    0.020
 DR6      H1Z    CBZ       single      1.092    0.020
 DR6      H2Z    CBZ       single      1.092    0.020
 DR6      CCA    OCB       single      1.426    0.020
 DR6      H4A    CCA       single      1.092    0.020
 DR6      H5A    CCA       single      1.092    0.020
 DR6      OCB    CCC       single      1.426    0.020
 DR6      CCC    CCD       single      1.524    0.020
 DR6      HC4    CCC       single      1.092    0.020
 DR6      HC5    CCC       single      1.092    0.020
 DR6      CCD    OCE       single      1.426    0.020
 DR6      H4D    CCD       single      1.092    0.020
 DR6      H5D    CCD       single      1.092    0.020
 DR6      OCE    CCF       single      1.426    0.020
 DR6      CCF    CCG       single      1.524    0.020
 DR6      H3F    CCF       single      1.092    0.020
 DR6      H4F    CCF       single      1.092    0.020
 DR6      CCG    OCH       single      1.426    0.020
 DR6      H3G    CCG       single      1.092    0.020
 DR6      H4G    CCG       single      1.092    0.020
 DR6      OCH    CCI       single      1.426    0.020
 DR6      CCI    CCJ       single      1.524    0.020
 DR6      H3I    CCI       single      1.092    0.020
 DR6      H4I    CCI       single      1.092    0.020
 DR6      CCJ    OCK       single      1.426    0.020
 DR6      H3J    CCJ       single      1.092    0.020
 DR6      H4J    CCJ       single      1.092    0.020
 DR6      OCK    CCL       single      1.426    0.020
 DR6      CCL    CCM       single      1.524    0.020
 DR6      H3L    CCL       single      1.092    0.020
 DR6      H4L    CCL       single      1.092    0.020
 DR6      CCM    OCN       single      1.426    0.020
 DR6      H3M    CCM       single      1.092    0.020
 DR6      H4M    CCM       single      1.092    0.020
 DR6      OCN    CCO       single      1.426    0.020
 DR6      CCO    CCP       single      1.524    0.020
 DR6      H3O    CCO       single      1.092    0.020
 DR6      H4O    CCO       single      1.092    0.020
 DR6      CCP    OCQ       single      1.426    0.020
 DR6      H3P    CCP       single      1.092    0.020
 DR6      H4P    CCP       single      1.092    0.020
 DR6      OCQ    CCR       single      1.426    0.020
 DR6      CCR    CCS       single      1.524    0.020
 DR6      H3R    CCR       single      1.092    0.020
 DR6      H4R    CCR       single      1.092    0.020
 DR6      CCS    OCT       single      1.426    0.020
 DR6      H3S    CCS       single      1.092    0.020
 DR6      H4S    CCS       single      1.092    0.020
 DR6      OCT    CCU       single      1.426    0.020
 DR6      CCU    CCV       single      1.524    0.020
 DR6      H3U    CCU       single      1.092    0.020
 DR6      H4U    CCU       single      1.092    0.020
 DR6      CCV    OCW       single      1.426    0.020
 DR6      H3V    CCV       single      1.092    0.020
 DR6      H4V    CCV       single      1.092    0.020
 DR6      OCW    CCX       single      1.426    0.020
 DR6      CCX    CCY       single      1.524    0.020
 DR6      H3X    CCX       single      1.092    0.020
 DR6      H3Y    CCX       single      1.092    0.020
 DR6      CCY    OCZ       single      1.426    0.020
 DR6      HCY1   CCY       single      1.092    0.020
 DR6      HCY2   CCY       single      1.092    0.020
 DR6      OCZ    CDA       single      1.426    0.020
 DR6      CDA    CDB       single      1.524    0.020
 DR6      H6A    CDA       single      1.092    0.020
 DR6      H6B    CDA       single      1.092    0.020
 DR6      CDB    ODC       single      1.426    0.020
 DR6      HDA1   CDB       single      1.092    0.020
 DR6      HDA2   CDB       single      1.092    0.020
 DR6      ODC    CDD       single      1.426    0.020
 DR6      CDD    CDE       single      1.524    0.020
 DR6      HDB1   CDD       single      1.092    0.020
 DR6      HDB2   CDD       single      1.092    0.020
 DR6      CDE    ODF       single      1.426    0.020
 DR6      HDC1   CDE       single      1.092    0.020
 DR6      HDC2   CDE       single      1.092    0.020
 DR6      ODF    CDG       single      1.426    0.020
 DR6      CDG    CDH       single      1.524    0.020
 DR6      HDD1   CDG       single      1.092    0.020
 DR6      HDD2   CDG       single      1.092    0.020
 DR6      CDH    ODI       single      1.426    0.020
 DR6      HZH1   CDH       single      1.092    0.020
 DR6      HZH2   CDH       single      1.092    0.020
 DR6      ODI    CDJ       single      1.426    0.020
 DR6      CDJ    CDK       single      1.524    0.020
 DR6      HDE1   CDJ       single      1.092    0.020
 DR6      HDE2   CDJ       single      1.092    0.020
 DR6      CDK    ODL       single      1.426    0.020
 DR6      HDF1   CDK       single      1.092    0.020
 DR6      HDF2   CDK       single      1.092    0.020
 DR6      ODL    CDM       single      1.426    0.020
 DR6      CDM    CDN       single      1.524    0.020
 DR6      HDG1   CDM       single      1.092    0.020
 DR6      HDG2   CDM       single      1.092    0.020
 DR6      CDN    ODO       single      1.426    0.020
 DR6      HDH1   CDN       single      1.092    0.020
 DR6      HDH2   CDN       single      1.092    0.020
 DR6      ODO    CDP       single      1.426    0.020
 DR6      CDP    CDQ       single      1.524    0.020
 DR6      HDI1   CDP       single      1.092    0.020
 DR6      HDI2   CDP       single      1.092    0.020
 DR6      CDQ    ODR       single      1.432    0.020
 DR6      HDJ1   CDQ       single      1.092    0.020
 DR6      HDJ2   CDQ       single      1.092    0.020
 DR6      HDK1   ODR       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DR6      HDK1   ODR    CDQ     109.470    3.000
 DR6      ODR    CDQ    HDJ1    109.470    3.000
 DR6      ODR    CDQ    HDJ2    109.470    3.000
 DR6      ODR    CDQ    CDP     109.470    3.000
 DR6      HDJ1   CDQ    HDJ2    107.900    3.000
 DR6      HDJ1   CDQ    CDP     109.470    3.000
 DR6      HDJ2   CDQ    CDP     109.470    3.000
 DR6      CDQ    CDP    HDI1    109.470    3.000
 DR6      CDQ    CDP    HDI2    109.470    3.000
 DR6      CDQ    CDP    ODO     109.470    3.000
 DR6      HDI1   CDP    HDI2    107.900    3.000
 DR6      HDI1   CDP    ODO     109.470    3.000
 DR6      HDI2   CDP    ODO     109.470    3.000
 DR6      CDP    ODO    CDN     111.800    3.000
 DR6      ODO    CDN    HDH1    109.470    3.000
 DR6      ODO    CDN    HDH2    109.470    3.000
 DR6      ODO    CDN    CDM     109.470    3.000
 DR6      HDH1   CDN    HDH2    107.900    3.000
 DR6      HDH1   CDN    CDM     109.470    3.000
 DR6      HDH2   CDN    CDM     109.470    3.000
 DR6      CDN    CDM    HDG1    109.470    3.000
 DR6      CDN    CDM    HDG2    109.470    3.000
 DR6      CDN    CDM    ODL     109.470    3.000
 DR6      HDG1   CDM    HDG2    107.900    3.000
 DR6      HDG1   CDM    ODL     109.470    3.000
 DR6      HDG2   CDM    ODL     109.470    3.000
 DR6      CDM    ODL    CDK     111.800    3.000
 DR6      ODL    CDK    HDF1    109.470    3.000
 DR6      ODL    CDK    HDF2    109.470    3.000
 DR6      ODL    CDK    CDJ     109.470    3.000
 DR6      HDF1   CDK    HDF2    107.900    3.000
 DR6      HDF1   CDK    CDJ     109.470    3.000
 DR6      HDF2   CDK    CDJ     109.470    3.000
 DR6      CDK    CDJ    HDE1    109.470    3.000
 DR6      CDK    CDJ    HDE2    109.470    3.000
 DR6      CDK    CDJ    ODI     109.470    3.000
 DR6      HDE1   CDJ    HDE2    107.900    3.000
 DR6      HDE1   CDJ    ODI     109.470    3.000
 DR6      HDE2   CDJ    ODI     109.470    3.000
 DR6      CDJ    ODI    CDH     111.800    3.000
 DR6      ODI    CDH    HZH1    109.470    3.000
 DR6      ODI    CDH    HZH2    109.470    3.000
 DR6      ODI    CDH    CDG     109.470    3.000
 DR6      HZH1   CDH    HZH2    107.900    3.000
 DR6      HZH1   CDH    CDG     109.470    3.000
 DR6      HZH2   CDH    CDG     109.470    3.000
 DR6      CDH    CDG    HDD1    109.470    3.000
 DR6      CDH    CDG    HDD2    109.470    3.000
 DR6      CDH    CDG    ODF     109.470    3.000
 DR6      HDD1   CDG    HDD2    107.900    3.000
 DR6      HDD1   CDG    ODF     109.470    3.000
 DR6      HDD2   CDG    ODF     109.470    3.000
 DR6      CDG    ODF    CDE     111.800    3.000
 DR6      ODF    CDE    HDC1    109.470    3.000
 DR6      ODF    CDE    HDC2    109.470    3.000
 DR6      ODF    CDE    CDD     109.470    3.000
 DR6      HDC1   CDE    HDC2    107.900    3.000
 DR6      HDC1   CDE    CDD     109.470    3.000
 DR6      HDC2   CDE    CDD     109.470    3.000
 DR6      CDE    CDD    HDB1    109.470    3.000
 DR6      CDE    CDD    HDB2    109.470    3.000
 DR6      CDE    CDD    ODC     109.470    3.000
 DR6      HDB1   CDD    HDB2    107.900    3.000
 DR6      HDB1   CDD    ODC     109.470    3.000
 DR6      HDB2   CDD    ODC     109.470    3.000
 DR6      CDD    ODC    CDB     111.800    3.000
 DR6      ODC    CDB    HDA1    109.470    3.000
 DR6      ODC    CDB    HDA2    109.470    3.000
 DR6      ODC    CDB    CDA     109.470    3.000
 DR6      HDA1   CDB    HDA2    107.900    3.000
 DR6      HDA1   CDB    CDA     109.470    3.000
 DR6      HDA2   CDB    CDA     109.470    3.000
 DR6      CDB    CDA    H6A     109.470    3.000
 DR6      CDB    CDA    H6B     109.470    3.000
 DR6      CDB    CDA    OCZ     109.470    3.000
 DR6      H6A    CDA    H6B     107.900    3.000
 DR6      H6A    CDA    OCZ     109.470    3.000
 DR6      H6B    CDA    OCZ     109.470    3.000
 DR6      CDA    OCZ    CCY     111.800    3.000
 DR6      OCZ    CCY    HCY1    109.470    3.000
 DR6      OCZ    CCY    HCY2    109.470    3.000
 DR6      OCZ    CCY    CCX     109.470    3.000
 DR6      HCY1   CCY    HCY2    107.900    3.000
 DR6      HCY1   CCY    CCX     109.470    3.000
 DR6      HCY2   CCY    CCX     109.470    3.000
 DR6      CCY    CCX    H3X     109.470    3.000
 DR6      CCY    CCX    H3Y     109.470    3.000
 DR6      CCY    CCX    OCW     109.470    3.000
 DR6      H3X    CCX    H3Y     107.900    3.000
 DR6      H3X    CCX    OCW     109.470    3.000
 DR6      H3Y    CCX    OCW     109.470    3.000
 DR6      CCX    OCW    CCV     111.800    3.000
 DR6      OCW    CCV    H3V     109.470    3.000
 DR6      OCW    CCV    H4V     109.470    3.000
 DR6      OCW    CCV    CCU     109.470    3.000
 DR6      H3V    CCV    H4V     107.900    3.000
 DR6      H3V    CCV    CCU     109.470    3.000
 DR6      H4V    CCV    CCU     109.470    3.000
 DR6      CCV    CCU    H3U     109.470    3.000
 DR6      CCV    CCU    H4U     109.470    3.000
 DR6      CCV    CCU    OCT     109.470    3.000
 DR6      H3U    CCU    H4U     107.900    3.000
 DR6      H3U    CCU    OCT     109.470    3.000
 DR6      H4U    CCU    OCT     109.470    3.000
 DR6      CCU    OCT    CCS     111.800    3.000
 DR6      OCT    CCS    H3S     109.470    3.000
 DR6      OCT    CCS    H4S     109.470    3.000
 DR6      OCT    CCS    CCR     109.470    3.000
 DR6      H3S    CCS    H4S     107.900    3.000
 DR6      H3S    CCS    CCR     109.470    3.000
 DR6      H4S    CCS    CCR     109.470    3.000
 DR6      CCS    CCR    H3R     109.470    3.000
 DR6      CCS    CCR    H4R     109.470    3.000
 DR6      CCS    CCR    OCQ     109.470    3.000
 DR6      H3R    CCR    H4R     107.900    3.000
 DR6      H3R    CCR    OCQ     109.470    3.000
 DR6      H4R    CCR    OCQ     109.470    3.000
 DR6      CCR    OCQ    CCP     111.800    3.000
 DR6      OCQ    CCP    H3P     109.470    3.000
 DR6      OCQ    CCP    H4P     109.470    3.000
 DR6      OCQ    CCP    CCO     109.470    3.000
 DR6      H3P    CCP    H4P     107.900    3.000
 DR6      H3P    CCP    CCO     109.470    3.000
 DR6      H4P    CCP    CCO     109.470    3.000
 DR6      CCP    CCO    H3O     109.470    3.000
 DR6      CCP    CCO    H4O     109.470    3.000
 DR6      CCP    CCO    OCN     109.470    3.000
 DR6      H3O    CCO    H4O     107.900    3.000
 DR6      H3O    CCO    OCN     109.470    3.000
 DR6      H4O    CCO    OCN     109.470    3.000
 DR6      CCO    OCN    CCM     111.800    3.000
 DR6      OCN    CCM    H3M     109.470    3.000
 DR6      OCN    CCM    H4M     109.470    3.000
 DR6      OCN    CCM    CCL     109.470    3.000
 DR6      H3M    CCM    H4M     107.900    3.000
 DR6      H3M    CCM    CCL     109.470    3.000
 DR6      H4M    CCM    CCL     109.470    3.000
 DR6      CCM    CCL    H3L     109.470    3.000
 DR6      CCM    CCL    H4L     109.470    3.000
 DR6      CCM    CCL    OCK     109.470    3.000
 DR6      H3L    CCL    H4L     107.900    3.000
 DR6      H3L    CCL    OCK     109.470    3.000
 DR6      H4L    CCL    OCK     109.470    3.000
 DR6      CCL    OCK    CCJ     111.800    3.000
 DR6      OCK    CCJ    H3J     109.470    3.000
 DR6      OCK    CCJ    H4J     109.470    3.000
 DR6      OCK    CCJ    CCI     109.470    3.000
 DR6      H3J    CCJ    H4J     107.900    3.000
 DR6      H3J    CCJ    CCI     109.470    3.000
 DR6      H4J    CCJ    CCI     109.470    3.000
 DR6      CCJ    CCI    H3I     109.470    3.000
 DR6      CCJ    CCI    H4I     109.470    3.000
 DR6      CCJ    CCI    OCH     109.470    3.000
 DR6      H3I    CCI    H4I     107.900    3.000
 DR6      H3I    CCI    OCH     109.470    3.000
 DR6      H4I    CCI    OCH     109.470    3.000
 DR6      CCI    OCH    CCG     111.800    3.000
 DR6      OCH    CCG    H3G     109.470    3.000
 DR6      OCH    CCG    H4G     109.470    3.000
 DR6      OCH    CCG    CCF     109.470    3.000
 DR6      H3G    CCG    H4G     107.900    3.000
 DR6      H3G    CCG    CCF     109.470    3.000
 DR6      H4G    CCG    CCF     109.470    3.000
 DR6      CCG    CCF    H3F     109.470    3.000
 DR6      CCG    CCF    H4F     109.470    3.000
 DR6      CCG    CCF    OCE     109.470    3.000
 DR6      H3F    CCF    H4F     107.900    3.000
 DR6      H3F    CCF    OCE     109.470    3.000
 DR6      H4F    CCF    OCE     109.470    3.000
 DR6      CCF    OCE    CCD     111.800    3.000
 DR6      OCE    CCD    H4D     109.470    3.000
 DR6      OCE    CCD    H5D     109.470    3.000
 DR6      OCE    CCD    CCC     109.470    3.000
 DR6      H4D    CCD    H5D     107.900    3.000
 DR6      H4D    CCD    CCC     109.470    3.000
 DR6      H5D    CCD    CCC     109.470    3.000
 DR6      CCD    CCC    HC4     109.470    3.000
 DR6      CCD    CCC    HC5     109.470    3.000
 DR6      CCD    CCC    OCB     109.470    3.000
 DR6      HC4    CCC    HC5     107.900    3.000
 DR6      HC4    CCC    OCB     109.470    3.000
 DR6      HC5    CCC    OCB     109.470    3.000
 DR6      CCC    OCB    CCA     111.800    3.000
 DR6      OCB    CCA    H4A     109.470    3.000
 DR6      OCB    CCA    H5A     109.470    3.000
 DR6      OCB    CCA    CBZ     109.470    3.000
 DR6      H4A    CCA    H5A     107.900    3.000
 DR6      H4A    CCA    CBZ     109.470    3.000
 DR6      H5A    CCA    CBZ     109.470    3.000
 DR6      CCA    CBZ    H1Z     109.470    3.000
 DR6      CCA    CBZ    H2Z     109.470    3.000
 DR6      CCA    CBZ    OBY     109.470    3.000
 DR6      H1Z    CBZ    H2Z     107.900    3.000
 DR6      H1Z    CBZ    OBY     109.470    3.000
 DR6      H2Z    CBZ    OBY     109.470    3.000
 DR6      CBZ    OBY    CBX     111.800    3.000
 DR6      OBY    CBX    H1X     109.470    3.000
 DR6      OBY    CBX    H2X     109.470    3.000
 DR6      OBY    CBX    CBW     109.470    3.000
 DR6      H1X    CBX    H2X     107.900    3.000
 DR6      H1X    CBX    CBW     109.470    3.000
 DR6      H2X    CBX    CBW     109.470    3.000
 DR6      CBX    CBW    H1W     109.470    3.000
 DR6      CBX    CBW    H2W     109.470    3.000
 DR6      CBX    CBW    OBV     109.470    3.000
 DR6      H1W    CBW    H2W     107.900    3.000
 DR6      H1W    CBW    OBV     109.470    3.000
 DR6      H2W    CBW    OBV     109.470    3.000
 DR6      CBW    OBV    CBU     111.800    3.000
 DR6      OBV    CBU    H1U     109.470    3.000
 DR6      OBV    CBU    H2U     109.470    3.000
 DR6      OBV    CBU    CBT     109.470    3.000
 DR6      H1U    CBU    H2U     107.900    3.000
 DR6      H1U    CBU    CBT     109.470    3.000
 DR6      H2U    CBU    CBT     109.470    3.000
 DR6      CBU    CBT    H1T     109.470    3.000
 DR6      CBU    CBT    H2T     109.470    3.000
 DR6      CBU    CBT    OBS     109.470    3.000
 DR6      H1T    CBT    H2T     107.900    3.000
 DR6      H1T    CBT    OBS     109.470    3.000
 DR6      H2T    CBT    OBS     109.470    3.000
 DR6      CBT    OBS    CBR     111.800    3.000
 DR6      OBS    CBR    H1R     109.470    3.000
 DR6      OBS    CBR    H2R     109.470    3.000
 DR6      OBS    CBR    CBQ     109.470    3.000
 DR6      H1R    CBR    H2R     107.900    3.000
 DR6      H1R    CBR    CBQ     109.470    3.000
 DR6      H2R    CBR    CBQ     109.470    3.000
 DR6      CBR    CBQ    H1Q     109.470    3.000
 DR6      CBR    CBQ    H2Q     109.470    3.000
 DR6      CBR    CBQ    OBP     109.470    3.000
 DR6      H1Q    CBQ    H2Q     107.900    3.000
 DR6      H1Q    CBQ    OBP     109.470    3.000
 DR6      H2Q    CBQ    OBP     109.470    3.000
 DR6      CBQ    OBP    CBO     111.800    3.000
 DR6      OBP    CBO    H1O     109.470    3.000
 DR6      OBP    CBO    H2O     109.470    3.000
 DR6      OBP    CBO    CBN     109.470    3.000
 DR6      H1O    CBO    H2O     107.900    3.000
 DR6      H1O    CBO    CBN     109.470    3.000
 DR6      H2O    CBO    CBN     109.470    3.000
 DR6      CBO    CBN    H1N     109.470    3.000
 DR6      CBO    CBN    H2N     109.470    3.000
 DR6      CBO    CBN    OBM     109.470    3.000
 DR6      H1N    CBN    H2N     107.900    3.000
 DR6      H1N    CBN    OBM     109.470    3.000
 DR6      H2N    CBN    OBM     109.470    3.000
 DR6      CBN    OBM    CBL     111.800    3.000
 DR6      OBM    CBL    H1L     109.470    3.000
 DR6      OBM    CBL    H2L     109.470    3.000
 DR6      OBM    CBL    CBK     109.470    3.000
 DR6      H1L    CBL    H2L     107.900    3.000
 DR6      H1L    CBL    CBK     109.470    3.000
 DR6      H2L    CBL    CBK     109.470    3.000
 DR6      CBL    CBK    H1K     109.470    3.000
 DR6      CBL    CBK    H2K     109.470    3.000
 DR6      CBL    CBK    OBJ     109.470    3.000
 DR6      H1K    CBK    H2K     107.900    3.000
 DR6      H1K    CBK    OBJ     109.470    3.000
 DR6      H2K    CBK    OBJ     109.470    3.000
 DR6      CBK    OBJ    CBI     111.800    3.000
 DR6      OBJ    CBI    H1I     109.470    3.000
 DR6      OBJ    CBI    H2I     109.470    3.000
 DR6      OBJ    CBI    CBH     109.470    3.000
 DR6      H1I    CBI    H2I     107.900    3.000
 DR6      H1I    CBI    CBH     109.470    3.000
 DR6      H2I    CBI    CBH     109.470    3.000
 DR6      CBI    CBH    H1H     109.470    3.000
 DR6      CBI    CBH    H2H     109.470    3.000
 DR6      CBI    CBH    OBG     109.470    3.000
 DR6      H1H    CBH    H2H     107.900    3.000
 DR6      H1H    CBH    OBG     109.470    3.000
 DR6      H2H    CBH    OBG     109.470    3.000
 DR6      CBH    OBG    CBF     111.800    3.000
 DR6      OBG    CBF    H1F     109.470    3.000
 DR6      OBG    CBF    H2F     109.470    3.000
 DR6      OBG    CBF    CBE     109.470    3.000
 DR6      H1F    CBF    H2F     107.900    3.000
 DR6      H1F    CBF    CBE     109.470    3.000
 DR6      H2F    CBF    CBE     109.470    3.000
 DR6      CBF    CBE    H1E     109.470    3.000
 DR6      CBF    CBE    H2E     109.470    3.000
 DR6      CBF    CBE    OBD     109.470    3.000
 DR6      H1E    CBE    H2E     107.900    3.000
 DR6      H1E    CBE    OBD     109.470    3.000
 DR6      H2E    CBE    OBD     109.470    3.000
 DR6      CBE    OBD    CBC     111.800    3.000
 DR6      OBD    CBC    HAC     109.470    3.000
 DR6      OBD    CBC    HBC     109.470    3.000
 DR6      OBD    CBC    CBB     109.470    3.000
 DR6      HAC    CBC    HBC     107.900    3.000
 DR6      HAC    CBC    CBB     109.470    3.000
 DR6      HBC    CBC    CBB     109.470    3.000
 DR6      CBC    CBB    HAB     109.470    3.000
 DR6      CBC    CBB    HBB     109.470    3.000
 DR6      CBC    CBB    OBA     109.470    3.000
 DR6      HAB    CBB    HBB     107.900    3.000
 DR6      HAB    CBB    OBA     109.470    3.000
 DR6      HBB    CBB    OBA     109.470    3.000
 DR6      CBB    OBA    CA8     111.800    3.000
 DR6      OBA    CA8    H18     109.470    3.000
 DR6      OBA    CA8    H28     109.470    3.000
 DR6      OBA    CA8    CA7     109.470    3.000
 DR6      H18    CA8    H28     107.900    3.000
 DR6      H18    CA8    CA7     109.470    3.000
 DR6      H28    CA8    CA7     109.470    3.000
 DR6      CA8    CA7    H17     109.470    3.000
 DR6      CA8    CA7    H27     109.470    3.000
 DR6      CA8    CA7    OA6     109.470    3.000
 DR6      H17    CA7    H27     107.900    3.000
 DR6      H17    CA7    OA6     109.470    3.000
 DR6      H27    CA7    OA6     109.470    3.000
 DR6      CA7    OA6    CA5     111.800    3.000
 DR6      OA6    CA5    H15     109.470    3.000
 DR6      OA6    CA5    H25     109.470    3.000
 DR6      OA6    CA5    CA4     109.470    3.000
 DR6      H15    CA5    H25     107.900    3.000
 DR6      H15    CA5    CA4     109.470    3.000
 DR6      H25    CA5    CA4     109.470    3.000
 DR6      CA5    CA4    H14     109.470    3.000
 DR6      CA5    CA4    H24     109.470    3.000
 DR6      CA5    CA4    OA3     109.470    3.000
 DR6      H14    CA4    H24     107.900    3.000
 DR6      H14    CA4    OA3     109.470    3.000
 DR6      H24    CA4    OA3     109.470    3.000
 DR6      CA4    OA3    CA2     111.800    3.000
 DR6      OA3    CA2    H21     109.470    3.000
 DR6      OA3    CA2    H22     109.470    3.000
 DR6      OA3    CA2    CA1     109.470    3.000
 DR6      H21    CA2    H22     107.900    3.000
 DR6      H21    CA2    CA1     109.470    3.000
 DR6      H22    CA2    CA1     109.470    3.000
 DR6      CA2    CA1    H11     109.470    3.000
 DR6      CA2    CA1    H12     109.470    3.000
 DR6      CA2    CA1    OAR     109.470    3.000
 DR6      H11    CA1    H12     107.900    3.000
 DR6      H11    CA1    OAR     109.470    3.000
 DR6      H12    CA1    OAR     109.470    3.000
 DR6      CA1    OAR    CAQ     111.800    3.000
 DR6      OAR    CAQ    H1QA    109.470    3.000
 DR6      OAR    CAQ    H2QA    109.470    3.000
 DR6      OAR    CAQ    CAP     109.470    3.000
 DR6      H1QA   CAQ    H2QA    107.900    3.000
 DR6      H1QA   CAQ    CAP     109.470    3.000
 DR6      H2QA   CAQ    CAP     109.470    3.000
 DR6      CAQ    CAP    H1P     109.470    3.000
 DR6      CAQ    CAP    H2P     109.470    3.000
 DR6      CAQ    CAP    OAO     109.470    3.000
 DR6      H1P    CAP    H2P     107.900    3.000
 DR6      H1P    CAP    OAO     109.470    3.000
 DR6      H2P    CAP    OAO     109.470    3.000
 DR6      CAP    OAO    CAN     111.800    3.000
 DR6      OAO    CAN    H1NA    109.470    3.000
 DR6      OAO    CAN    H2NA    109.470    3.000
 DR6      OAO    CAN    CAM     109.470    3.000
 DR6      H1NA   CAN    H2NA    107.900    3.000
 DR6      H1NA   CAN    CAM     109.470    3.000
 DR6      H2NA   CAN    CAM     109.470    3.000
 DR6      CAN    CAM    H1M     109.470    3.000
 DR6      CAN    CAM    H2M     109.470    3.000
 DR6      CAN    CAM    OAL     109.470    3.000
 DR6      H1M    CAM    H2M     107.900    3.000
 DR6      H1M    CAM    OAL     109.470    3.000
 DR6      H2M    CAM    OAL     109.470    3.000
 DR6      CAM    OAL    CAK     111.800    3.000
 DR6      OAL    CAK    HK      109.470    3.000
 DR6      OAL    CAK    H2KA    109.470    3.000
 DR6      OAL    CAK    CAJ     109.470    3.000
 DR6      HK     CAK    H2KA    107.900    3.000
 DR6      HK     CAK    CAJ     109.470    3.000
 DR6      H2KA   CAK    CAJ     109.470    3.000
 DR6      CAK    CAJ    H1J     109.470    3.000
 DR6      CAK    CAJ    H2J     109.470    3.000
 DR6      CAK    CAJ    OAI     109.470    3.000
 DR6      H1J    CAJ    H2J     107.900    3.000
 DR6      H1J    CAJ    OAI     109.470    3.000
 DR6      H2J    CAJ    OAI     109.470    3.000
 DR6      CAJ    OAI    CAH     111.800    3.000
 DR6      OAI    CAH    H1      109.470    3.000
 DR6      OAI    CAH    H2      109.470    3.000
 DR6      OAI    CAH    CAG     109.470    3.000
 DR6      H1     CAH    H2      107.900    3.000
 DR6      H1     CAH    CAG     109.470    3.000
 DR6      H2     CAH    CAG     109.470    3.000
 DR6      CAH    CAG    H1G     109.470    3.000
 DR6      CAH    CAG    H2G     109.470    3.000
 DR6      CAH    CAG    OAF     109.470    3.000
 DR6      H1G    CAG    H2G     107.900    3.000
 DR6      H1G    CAG    OAF     109.470    3.000
 DR6      H2G    CAG    OAF     109.470    3.000
 DR6      CAG    OAF    CAE     120.000    3.000
 DR6      OAF    CAE    CAY     120.000    3.000
 DR6      OAF    CAE    CAD     120.000    3.000
 DR6      CAY    CAE    CAD     120.000    3.000
 DR6      CAE    CAY    H1Y     120.000    3.000
 DR6      CAE    CAY    CAX     120.000    3.000
 DR6      H1Y    CAY    CAX     120.000    3.000
 DR6      CAY    CAX    H1XA    120.000    3.000
 DR6      CAY    CAX    CAW     120.000    3.000
 DR6      H1XA   CAX    CAW     120.000    3.000
 DR6      CAE    CAD    H1D     120.000    3.000
 DR6      CAE    CAD    CAC     120.000    3.000
 DR6      H1D    CAD    CAC     120.000    3.000
 DR6      CAD    CAC    H1C     120.000    3.000
 DR6      CAD    CAC    CAW     120.000    3.000
 DR6      H1C    CAC    CAW     120.000    3.000
 DR6      CAC    CAW    CAV     120.000    3.000
 DR6      CAC    CAW    CAX     120.000    3.000
 DR6      CAV    CAW    CAX     120.000    3.000
 DR6      CAW    CAV    CAB     109.500    3.000
 DR6      CAW    CAV    CBA     109.500    3.000
 DR6      CAW    CAV    CAU     109.500    3.000
 DR6      CAB    CAV    CBA     111.000    3.000
 DR6      CAB    CAV    CAU     111.000    3.000
 DR6      CBA    CAV    CAU     111.000    3.000
 DR6      CAV    CAB    H3B     109.470    3.000
 DR6      CAV    CAB    H2B     109.470    3.000
 DR6      CAV    CAB    H1B     109.470    3.000
 DR6      H3B    CAB    H2B     109.470    3.000
 DR6      H3B    CAB    H1B     109.470    3.000
 DR6      H2B    CAB    H1B     109.470    3.000
 DR6      CAV    CBA    HB3     109.470    3.000
 DR6      CAV    CBA    HB2     109.470    3.000
 DR6      CAV    CBA    HB1     109.470    3.000
 DR6      HB3    CBA    HB2     109.470    3.000
 DR6      HB3    CBA    HB1     109.470    3.000
 DR6      HB2    CBA    HB1     109.470    3.000
 DR6      CAV    CAU    H1UA    109.470    3.000
 DR6      CAV    CAU    H2UA    109.470    3.000
 DR6      CAV    CAU    CAT     109.500    3.000
 DR6      H1UA   CAU    H2UA    107.900    3.000
 DR6      H1UA   CAU    CAT     109.470    3.000
 DR6      H2UA   CAU    CAT     109.470    3.000
 DR6      CAU    CAT    CAZ     111.000    3.000
 DR6      CAU    CAT    CAS     111.000    3.000
 DR6      CAU    CAT    CAA     111.000    3.000
 DR6      CAZ    CAT    CAS     111.000    3.000
 DR6      CAZ    CAT    CAA     111.000    3.000
 DR6      CAS    CAT    CAA     111.000    3.000
 DR6      CAT    CAZ    H3Z     109.470    3.000
 DR6      CAT    CAZ    H2ZA    109.470    3.000
 DR6      CAT    CAZ    H1ZA    109.470    3.000
 DR6      H3Z    CAZ    H2ZA    109.470    3.000
 DR6      H3Z    CAZ    H1ZA    109.470    3.000
 DR6      H2ZA   CAZ    H1ZA    109.470    3.000
 DR6      CAT    CAS    H3SA    109.470    3.000
 DR6      CAT    CAS    H2S     109.470    3.000
 DR6      CAT    CAS    H1S     109.470    3.000
 DR6      H3SA   CAS    H2S     109.470    3.000
 DR6      H3SA   CAS    H1S     109.470    3.000
 DR6      H2S    CAS    H1S     109.470    3.000
 DR6      CAT    CAA    HA3     109.470    3.000
 DR6      CAT    CAA    HA2     109.470    3.000
 DR6      CAT    CAA    HA1     109.470    3.000
 DR6      HA3    CAA    HA2     109.470    3.000
 DR6      HA3    CAA    HA1     109.470    3.000
 DR6      HA2    CAA    HA1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DR6      var_1    HDK1   ODR    CDQ    CDP     -102.004   20.000   1
 DR6      var_2    ODR    CDQ    CDP    ODO      -60.824   20.000   3
 DR6      var_3    CDQ    CDP    ODO    CDN     -179.982   20.000   1
 DR6      var_4    CDP    ODO    CDN    CDM      179.011   20.000   1
 DR6      var_5    ODO    CDN    CDM    ODL      -60.920   20.000   3
 DR6      var_6    CDN    CDM    ODL    CDK      179.975   20.000   1
 DR6      var_7    CDM    ODL    CDK    CDJ      179.050   20.000   1
 DR6      var_8    ODL    CDK    CDJ    ODI       59.103   20.000   3
 DR6      var_9    CDK    CDJ    ODI    CDH      179.994   20.000   1
 DR6      var_10   CDJ    ODI    CDH    CDG      179.045   20.000   1
 DR6      var_11   ODI    CDH    CDG    ODF      -60.840   20.000   3
 DR6      var_12   CDH    CDG    ODF    CDE     -179.994   20.000   1
 DR6      var_13   CDG    ODF    CDE    CDD      179.054   20.000   1
 DR6      var_14   ODF    CDE    CDD    ODC      -60.895   20.000   3
 DR6      var_15   CDE    CDD    ODC    CDB     -179.954   20.000   1
 DR6      var_16   CDD    ODC    CDB    CDA      179.056   20.000   1
 DR6      var_17   ODC    CDB    CDA    OCZ      -60.907   20.000   3
 DR6      var_18   CDB    CDA    OCZ    CCY     -179.987   20.000   1
 DR6      var_19   CDA    OCZ    CCY    CCX      179.052   20.000   1
 DR6      var_20   OCZ    CCY    CCX    OCW      -60.903   20.000   3
 DR6      var_21   CCY    CCX    OCW    CCV      179.955   20.000   1
 DR6      var_22   CCX    OCW    CCV    CCU      179.068   20.000   1
 DR6      var_23   OCW    CCV    CCU    OCT      -60.848   20.000   3
 DR6      var_24   CCV    CCU    OCT    CCS      179.997   20.000   1
 DR6      var_25   CCU    OCT    CCS    CCR      179.014   20.000   1
 DR6      var_26   OCT    CCS    CCR    OCQ      -60.835   20.000   3
 DR6      var_27   CCS    CCR    OCQ    CCP      179.990   20.000   1
 DR6      var_28   CCR    OCQ    CCP    CCO      179.009   20.000   1
 DR6      var_29   OCQ    CCP    CCO    OCN      -60.867   20.000   3
 DR6      var_30   CCP    CCO    OCN    CCM     -179.998   20.000   1
 DR6      var_31   CCO    OCN    CCM    CCL      179.020   20.000   1
 DR6      var_32   OCN    CCM    CCL    OCK      -60.868   20.000   3
 DR6      var_33   CCM    CCL    OCK    CCJ     -179.992   20.000   1
 DR6      var_34   CCL    OCK    CCJ    CCI      179.043   20.000   1
 DR6      var_35   OCK    CCJ    CCI    OCH      -60.929   20.000   3
 DR6      var_36   CCJ    CCI    OCH    CCG     -179.984   20.000   1
 DR6      var_37   CCI    OCH    CCG    CCF      179.090   20.000   1
 DR6      var_38   OCH    CCG    CCF    OCE      -60.899   20.000   3
 DR6      var_39   CCG    CCF    OCE    CCD     -180.000   20.000   1
 DR6      var_40   CCF    OCE    CCD    CCC      179.079   20.000   1
 DR6      var_41   OCE    CCD    CCC    OCB      -60.891   20.000   3
 DR6      var_42   CCD    CCC    OCB    CCA     -179.972   20.000   1
 DR6      var_43   CCC    OCB    CCA    CBZ      179.070   20.000   1
 DR6      var_44   OCB    CCA    CBZ    OBY      -60.908   20.000   3
 DR6      var_45   CCA    CBZ    OBY    CBX     -179.997   20.000   1
 DR6      var_46   CBZ    OBY    CBX    CBW     -179.995   20.000   1
 DR6      var_47   OBY    CBX    CBW    OBV      -60.897   20.000   3
 DR6      var_48   CBX    CBW    OBV    CBU      179.050   20.000   1
 DR6      var_49   CBW    OBV    CBU    CBT     -179.978   20.000   1
 DR6      var_50   OBV    CBU    CBT    OBS      -60.837   20.000   3
 DR6      var_51   CBU    CBT    OBS    CBR      179.054   20.000   1
 DR6      var_52   CBT    OBS    CBR    CBQ      179.991   20.000   1
 DR6      var_53   OBS    CBR    CBQ    OBP      -60.933   20.000   3
 DR6      var_54   CBR    CBQ    OBP    CBO      179.033   20.000   1
 DR6      var_55   CBQ    OBP    CBO    CBN     -179.992   20.000   1
 DR6      var_56   OBP    CBO    CBN    OBM      -60.892   20.000   3
 DR6      var_57   CBO    CBN    OBM    CBL      179.045   20.000   1
 DR6      var_58   CBN    OBM    CBL    CBK     -179.964   20.000   1
 DR6      var_59   OBM    CBL    CBK    OBJ      -60.886   20.000   3
 DR6      var_60   CBL    CBK    OBJ    CBI      179.051   20.000   1
 DR6      var_61   CBK    OBJ    CBI    CBH      179.975   20.000   1
 DR6      var_62   OBJ    CBI    CBH    OBG      -60.833   20.000   3
 DR6      var_63   CBI    CBH    OBG    CBF      179.016   20.000   1
 DR6      var_64   CBH    OBG    CBF    CBE      179.966   20.000   1
 DR6      var_65   OBG    CBF    CBE    OBD      -60.905   20.000   3
 DR6      var_66   CBF    CBE    OBD    CBC      179.049   20.000   1
 DR6      var_67   CBE    OBD    CBC    CBB     -179.944   20.000   1
 DR6      var_68   OBD    CBC    CBB    OBA       59.094   20.000   3
 DR6      var_69   CBC    CBB    OBA    CA8      179.005   20.000   1
 DR6      var_70   CBB    OBA    CA8    CA7     -179.984   20.000   1
 DR6      var_71   OBA    CA8    CA7    OA6      -60.825   20.000   3
 DR6      var_72   CA8    CA7    OA6    CA5      179.069   20.000   1
 DR6      var_73   CA7    OA6    CA5    CA4      179.968   20.000   1
 DR6      var_74   OA6    CA5    CA4    OA3      -60.867   20.000   3
 DR6      var_75   CA5    CA4    OA3    CA2      179.047   20.000   1
 DR6      var_76   CA4    OA3    CA2    CA1      179.966   20.000   1
 DR6      var_77   OA3    CA2    CA1    OAR      -60.888   20.000   3
 DR6      var_78   CA2    CA1    OAR    CAQ      179.034   20.000   1
 DR6      var_79   CA1    OAR    CAQ    CAP      179.989   20.000   1
 DR6      var_80   OAR    CAQ    CAP    OAO      -60.867   20.000   3
 DR6      var_81   CAQ    CAP    OAO    CAN      179.006   20.000   1
 DR6      var_82   CAP    OAO    CAN    CAM      179.995   20.000   1
 DR6      var_83   OAO    CAN    CAM    OAL       59.147   20.000   3
 DR6      var_84   CAN    CAM    OAL    CAK      179.043   20.000   1
 DR6      var_85   CAM    OAL    CAK    CAJ     -179.988   20.000   1
 DR6      var_86   OAL    CAK    CAJ    OAI      -60.900   20.000   3
 DR6      var_87   CAK    CAJ    OAI    CAH      179.081   20.000   1
 DR6      var_88   CAJ    OAI    CAH    CAG      179.992   20.000   1
 DR6      var_89   OAI    CAH    CAG    OAF      -60.868   20.000   3
 DR6      var_90   CAH    CAG    OAF    CAE     -151.005   20.000   1
 DR6      var_91   CAG    OAF    CAE    CAD      149.896   20.000   1
 DR6      CONST_1  OAF    CAE    CAY    CAX      180.000    0.000   0
 DR6      CONST_2  CAE    CAY    CAX    CAW        0.000    0.000   0
 DR6      CONST_3  OAF    CAE    CAD    CAC      180.000    0.000   0
 DR6      CONST_4  CAE    CAD    CAC    CAW        0.000    0.000   0
 DR6      CONST_5  CAD    CAC    CAW    CAV      180.000    0.000   0
 DR6      CONST_6  CAC    CAW    CAX    CAY        0.000    0.000   0
 DR6      var_92   CAC    CAW    CAV    CAU     -122.862   20.000   1
 DR6      var_93   CAW    CAV    CAB    H1B       64.073   20.000   1
 DR6      var_94   CAW    CAV    CBA    HB1       64.198   20.000   1
 DR6      var_95   CAW    CAV    CAU    CAT       56.487   20.000   1
 DR6      var_96   CAV    CAU    CAT    CAA     -176.119   20.000   1
 DR6      var_97   CAU    CAT    CAZ    H1ZA    -174.229   20.000   1
 DR6      var_98   CAU    CAT    CAS    H1S       49.602   20.000   1
 DR6      var_99   CAU    CAT    CAA    HA1       62.197   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DR6      chir_01  CAT    CAA    CAS    CAZ       negativ
 DR6      chir_02  CAV    CAU    CAB    CBA       negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DR6      plan-1    CAW       0.020
 DR6      plan-1    CAV       0.020
 DR6      plan-1    CAX       0.020
 DR6      plan-1    CAC       0.020
 DR6      plan-1    CAY       0.020
 DR6      plan-1    CAD       0.020
 DR6      plan-1    CAE       0.020
 DR6      plan-1    H1XA      0.020
 DR6      plan-1    H1Y       0.020
 DR6      plan-1    H1C       0.020
 DR6      plan-1    H1D       0.020
 DR6      plan-1    OAF       0.020
# ------------------------------------------------------
`.trim();

monomers["NH4"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
NH4      NH4 'AMMONIUM ION                        ' non-polymer         5   1 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_NH4
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 NH4           HN4    H    H         0.000      0.000    0.000    0.000
 NH4           N      N    NT        1.000     -0.581    0.302   -0.782
 NH4           HN3    H    H         0.000     -1.232    1.041   -0.516
 NH4           HN2    H    H         0.000     -0.024    0.609   -1.579
 NH4           HN1    H    H         0.000     -1.055   -0.583   -0.962
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 NH4      HN4    n/a    N      START
 NH4      N      HN4    HN1    .
 NH4      HN3    N      .      .
 NH4      HN2    N      .      .
 NH4      HN1    N      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 NH4      HN1    N         single      1.043    0.020
 NH4      HN2    N         single      1.043    0.020
 NH4      HN3    N         single      1.043    0.020
 NH4      N      HN4       single      1.043    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 NH4      HN4    N      HN3     109.500    3.000
 NH4      HN4    N      HN2     109.500    3.000
 NH4      HN4    N      HN1     109.500    3.000
 NH4      HN3    N      HN2     109.500    3.000
 NH4      HN3    N      HN1     109.500    3.000
 NH4      HN2    N      HN1     109.500    3.000
# ------------------------------------------------------
`.trim();

monomers["AZI"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
AZI      AZI 'AZIDE ION                           ' non-polymer         3   3 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_AZI
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 AZI           N3     N    NS       -1.000      0.000    0.000    0.000
 AZI           N2     N    N         1.000     -1.124    0.000    0.000
 AZI           N1     N    NS       -1.000     -2.248    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 AZI      N3     n/a    N2     START
 AZI      N2     N3     N1     .
 AZI      N1     N2     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 AZI      N1     N2        double      1.295    0.020
 AZI      N2     N3        double      1.295    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 AZI      N3     N2     N1      180.000    3.000
# ------------------------------------------------------
`.trim();

monomers["LAK"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
LAK      LAK 'BETA-D-GALACTOPYRANOSYL-1-6-BETA-D-G' saccharide         45  23 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_LAK
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 LAK           "O4'"  O    OH1       0.000      0.000    0.000    0.000
 LAK           "HO4'" H    H         0.000      0.891   -0.363    0.095
 LAK           "C4'"  C    CH1       0.000     -0.796   -0.396    1.118
 LAK           "H4'"  H    H         0.000     -0.855   -1.493    1.158
 LAK           "C3'"  C    CH1       0.000     -0.165    0.131    2.411
 LAK           "H3'"  H    H         0.000     -0.010    1.216    2.331
 LAK           "O3'"  O    OH1       0.000      1.089   -0.517    2.635
 LAK           "HO3'" H    H         0.000      1.477   -0.190    3.458
 LAK           "C2'"  C    CH1       0.000     -1.113   -0.168    3.577
 LAK           "H2'"  H    H         0.000     -0.731    0.304    4.493
 LAK           "O2'"  O    OH1       0.000     -1.207   -1.580    3.769
 LAK           "HO2'" H    H         0.000     -1.811   -1.765    4.501
 LAK           "C5'"  C    CH1       0.000     -2.204    0.187    0.977
 LAK           "H5'"  H    H         0.000     -2.145    1.284    0.962
 LAK           "O5'"  O    O2        0.000     -3.010   -0.230    2.076
 LAK           "C1'"  C    CH1       0.000     -2.497    0.397    3.249
 LAK           "H1'"  H    H         0.000     -2.419    1.480    3.081
 LAK           "O1'"  O    OH1       0.000     -3.381    0.150    4.346
 LAK           "HO1'" H    H         0.000     -4.255    0.510    4.142
 LAK           "C6'"  C    CH2       0.000     -2.830   -0.306   -0.329
 LAK           "H6'1" H    H         0.000     -2.887   -1.396   -0.316
 LAK           "H6'2" H    H         0.000     -2.213    0.015   -1.171
 LAK           O1     O    O2        0.000     -4.143    0.239   -0.464
 LAK           C1     C    CH1       0.000     -4.671   -0.254   -1.695
 LAK           H1     H    H         0.000     -4.704   -1.352   -1.664
 LAK           O5     O    O2        0.000     -3.835    0.164   -2.772
 LAK           C5     C    CH1       0.000     -4.291   -0.493   -3.953
 LAK           H5     H    H         0.000     -4.351   -1.574   -3.769
 LAK           C6     C    CH2       0.000     -3.309   -0.225   -5.096
 LAK           H61    H    H         0.000     -3.250    0.849   -5.280
 LAK           H62    H    H         0.000     -3.657   -0.730   -6.000
 LAK           O6     O    OH1       0.000     -2.018   -0.721   -4.739
 LAK           HO6    H    H         0.000     -1.398   -0.551   -5.461
 LAK           C4     C    CH1       0.000     -5.675    0.035   -4.337
 LAK           H4     H    H         0.000     -6.014   -0.459   -5.258
 LAK           O4     O    OH1       0.000     -5.611    1.446   -4.549
 LAK           HO4    H    H         0.000     -6.488    1.776   -4.786
 LAK           C3     C    CH1       0.000     -6.658   -0.270   -3.203
 LAK           H3     H    H         0.000     -6.790   -1.357   -3.111
 LAK           O3     O    OH1       0.000     -7.918    0.345   -3.478
 LAK           HO3    H    H         0.000     -8.531    0.161   -2.754
 LAK           C2     C    CH1       0.000     -6.086    0.291   -1.896
 LAK           H2     H    H         0.000     -6.052    1.388   -1.951
 LAK           O2     O    OH1       0.000     -6.912   -0.106   -0.800
 LAK           HO2    H    H         0.000     -6.545    0.244    0.023
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 LAK      "O4'"  n/a    "C4'"  START
 LAK      "HO4'" "O4'"  .      .
 LAK      "C4'"  "O4'"  "C5'"  .
 LAK      "H4'"  "C4'"  .      .
 LAK      "C3'"  "C4'"  "C2'"  .
 LAK      "H3'"  "C3'"  .      .
 LAK      "O3'"  "C3'"  "HO3'" .
 LAK      "HO3'" "O3'"  .      .
 LAK      "C2'"  "C3'"  "O2'"  .
 LAK      "H2'"  "C2'"  .      .
 LAK      "O2'"  "C2'"  "HO2'" .
 LAK      "HO2'" "O2'"  .      .
 LAK      "C5'"  "C4'"  "C6'"  .
 LAK      "H5'"  "C5'"  .      .
 LAK      "O5'"  "C5'"  "C1'"  .
 LAK      "C1'"  "O5'"  "O1'"  .
 LAK      "H1'"  "C1'"  .      .
 LAK      "O1'"  "C1'"  "HO1'" .
 LAK      "HO1'" "O1'"  .      .
 LAK      "C6'"  "C5'"  O1     .
 LAK      "H6'1" "C6'"  .      .
 LAK      "H6'2" "C6'"  .      .
 LAK      O1     "C6'"  C1     .
 LAK      C1     O1     O5     .
 LAK      H1     C1     .      .
 LAK      O5     C1     C5     .
 LAK      C5     O5     C4     .
 LAK      H5     C5     .      .
 LAK      C6     C5     O6     .
 LAK      H61    C6     .      .
 LAK      H62    C6     .      .
 LAK      O6     C6     HO6    .
 LAK      HO6    O6     .      .
 LAK      C4     C5     C3     .
 LAK      H4     C4     .      .
 LAK      O4     C4     HO4    .
 LAK      HO4    O4     .      .
 LAK      C3     C4     C2     .
 LAK      H3     C3     .      .
 LAK      O3     C3     HO3    .
 LAK      HO3    O3     .      .
 LAK      C2     C3     O2     .
 LAK      H2     C2     .      .
 LAK      O2     C2     HO2    .
 LAK      HO2    O2     .      END
 LAK      C1     C2     .    ADD
 LAK      "C1'"  "C2'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 LAK      C1     C2        single      1.524    0.020
 LAK      C1     O1        single      1.426    0.020
 LAK      O5     C1        single      1.426    0.020
 LAK      H1     C1        single      1.099    0.020
 LAK      C2     C3        single      1.524    0.020
 LAK      O2     C2        single      1.432    0.020
 LAK      H2     C2        single      1.099    0.020
 LAK      C3     C4        single      1.524    0.020
 LAK      O3     C3        single      1.432    0.020
 LAK      H3     C3        single      1.099    0.020
 LAK      C4     C5        single      1.524    0.020
 LAK      O4     C4        single      1.432    0.020
 LAK      H4     C4        single      1.099    0.020
 LAK      C6     C5        single      1.524    0.020
 LAK      C5     O5        single      1.426    0.020
 LAK      H5     C5        single      1.099    0.020
 LAK      O6     C6        single      1.432    0.020
 LAK      H61    C6        single      1.092    0.020
 LAK      H62    C6        single      1.092    0.020
 LAK      O1     "C6'"     single      1.426    0.020
 LAK      HO2    O2        single      0.967    0.020
 LAK      HO3    O3        single      0.967    0.020
 LAK      HO4    O4        single      0.967    0.020
 LAK      HO6    O6        single      0.967    0.020
 LAK      "C1'"  "C2'"     single      1.524    0.020
 LAK      "O1'"  "C1'"     single      1.432    0.020
 LAK      "C1'"  "O5'"     single      1.426    0.020
 LAK      "H1'"  "C1'"     single      1.099    0.020
 LAK      "C2'"  "C3'"     single      1.524    0.020
 LAK      "O2'"  "C2'"     single      1.432    0.020
 LAK      "H2'"  "C2'"     single      1.099    0.020
 LAK      "C3'"  "C4'"     single      1.524    0.020
 LAK      "O3'"  "C3'"     single      1.432    0.020
 LAK      "H3'"  "C3'"     single      1.099    0.020
 LAK      "C5'"  "C4'"     single      1.524    0.020
 LAK      "C4'"  "O4'"     single      1.432    0.020
 LAK      "H4'"  "C4'"     single      1.099    0.020
 LAK      "C6'"  "C5'"     single      1.524    0.020
 LAK      "O5'"  "C5'"     single      1.426    0.020
 LAK      "H5'"  "C5'"     single      1.099    0.020
 LAK      "H6'1" "C6'"     single      1.092    0.020
 LAK      "H6'2" "C6'"     single      1.092    0.020
 LAK      "HO1'" "O1'"     single      0.967    0.020
 LAK      "HO2'" "O2'"     single      0.967    0.020
 LAK      "HO3'" "O3'"     single      0.967    0.020
 LAK      "HO4'" "O4'"     single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 LAK      "HO4'" "O4'"  "C4'"   109.470    3.000
 LAK      "O4'"  "C4'"  "H4'"   109.470    3.000
 LAK      "O4'"  "C4'"  "C3'"   109.470    3.000
 LAK      "O4'"  "C4'"  "C5'"   109.470    3.000
 LAK      "H4'"  "C4'"  "C3'"   108.340    3.000
 LAK      "H4'"  "C4'"  "C5'"   108.340    3.000
 LAK      "C3'"  "C4'"  "C5'"   111.000    3.000
 LAK      "C4'"  "C3'"  "H3'"   108.340    3.000
 LAK      "C4'"  "C3'"  "O3'"   109.470    3.000
 LAK      "C4'"  "C3'"  "C2'"   111.000    3.000
 LAK      "H3'"  "C3'"  "O3'"   109.470    3.000
 LAK      "H3'"  "C3'"  "C2'"   108.340    3.000
 LAK      "O3'"  "C3'"  "C2'"   109.470    3.000
 LAK      "C3'"  "O3'"  "HO3'"  109.470    3.000
 LAK      "C3'"  "C2'"  "H2'"   108.340    3.000
 LAK      "C3'"  "C2'"  "O2'"   109.470    3.000
 LAK      "C3'"  "C2'"  "C1'"   111.000    3.000
 LAK      "H2'"  "C2'"  "O2'"   109.470    3.000
 LAK      "H2'"  "C2'"  "C1'"   108.340    3.000
 LAK      "O2'"  "C2'"  "C1'"   109.470    3.000
 LAK      "C2'"  "O2'"  "HO2'"  109.470    3.000
 LAK      "C4'"  "C5'"  "H5'"   108.340    3.000
 LAK      "C4'"  "C5'"  "O5'"   109.470    3.000
 LAK      "C4'"  "C5'"  "C6'"   111.000    3.000
 LAK      "H5'"  "C5'"  "O5'"   109.470    3.000
 LAK      "H5'"  "C5'"  "C6'"   108.340    3.000
 LAK      "O5'"  "C5'"  "C6'"   109.470    3.000
 LAK      "C5'"  "O5'"  "C1'"   111.800    3.000
 LAK      "O5'"  "C1'"  "H1'"   109.470    3.000
 LAK      "O5'"  "C1'"  "O1'"   109.470    3.000
 LAK      "O5'"  "C1'"  "C2'"   109.470    3.000
 LAK      "H1'"  "C1'"  "O1'"   109.470    3.000
 LAK      "H1'"  "C1'"  "C2'"   108.340    3.000
 LAK      "O1'"  "C1'"  "C2'"   109.470    3.000
 LAK      "C1'"  "O1'"  "HO1'"  109.470    3.000
 LAK      "C5'"  "C6'"  "H6'1"  109.470    3.000
 LAK      "C5'"  "C6'"  "H6'2"  109.470    3.000
 LAK      "C5'"  "C6'"  O1      109.470    3.000
 LAK      "H6'1" "C6'"  "H6'2"  107.900    3.000
 LAK      "H6'1" "C6'"  O1      109.470    3.000
 LAK      "H6'2" "C6'"  O1      109.470    3.000
 LAK      "C6'"  O1     C1      111.800    3.000
 LAK      O1     C1     H1      109.470    3.000
 LAK      O1     C1     O5      109.470    3.000
 LAK      O1     C1     C2      109.470    3.000
 LAK      H1     C1     O5      109.470    3.000
 LAK      H1     C1     C2      108.340    3.000
 LAK      O5     C1     C2      109.470    3.000
 LAK      C1     O5     C5      111.800    3.000
 LAK      O5     C5     H5      109.470    3.000
 LAK      O5     C5     C6      109.470    3.000
 LAK      O5     C5     C4      109.470    3.000
 LAK      H5     C5     C6      108.340    3.000
 LAK      H5     C5     C4      108.340    3.000
 LAK      C6     C5     C4      111.000    3.000
 LAK      C5     C6     H61     109.470    3.000
 LAK      C5     C6     H62     109.470    3.000
 LAK      C5     C6     O6      109.470    3.000
 LAK      H61    C6     H62     107.900    3.000
 LAK      H61    C6     O6      109.470    3.000
 LAK      H62    C6     O6      109.470    3.000
 LAK      C6     O6     HO6     109.470    3.000
 LAK      C5     C4     H4      108.340    3.000
 LAK      C5     C4     O4      109.470    3.000
 LAK      C5     C4     C3      111.000    3.000
 LAK      H4     C4     O4      109.470    3.000
 LAK      H4     C4     C3      108.340    3.000
 LAK      O4     C4     C3      109.470    3.000
 LAK      C4     O4     HO4     109.470    3.000
 LAK      C4     C3     H3      108.340    3.000
 LAK      C4     C3     O3      109.470    3.000
 LAK      C4     C3     C2      111.000    3.000
 LAK      H3     C3     O3      109.470    3.000
 LAK      H3     C3     C2      108.340    3.000
 LAK      O3     C3     C2      109.470    3.000
 LAK      C3     O3     HO3     109.470    3.000
 LAK      C3     C2     H2      108.340    3.000
 LAK      C3     C2     O2      109.470    3.000
 LAK      C3     C2     C1      111.000    3.000
 LAK      H2     C2     O2      109.470    3.000
 LAK      H2     C2     C1      108.340    3.000
 LAK      O2     C2     C1      109.470    3.000
 LAK      C2     O2     HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 LAK      var_1    "HO4'" "O4'"  "C4'"  "C5'"    179.545   20.000   1
 LAK      var_2    "O4'"  "C4'"  "C3'"  "C2'"    180.000   20.000   3
 LAK      var_3    "C4'"  "C3'"  "O3'"  "HO3'"  -179.226   20.000   1
 LAK      var_4    "C4'"  "C3'"  "C2'"  "O2'"     60.000   20.000   3
 LAK      var_5    "C3'"  "C2'"  "O2'"  "HO2'"  -179.586   20.000   1
 LAK      var_6    "O4'"  "C4'"  "C5'"  "C6'"     60.000   20.000   3
 LAK      var_7    "C4'"  "C5'"  "O5'"  "C1'"     60.000   20.000   1
 LAK      var_8    "C5'"  "O5'"  "C1'"  "O1'"    180.000   20.000   1
 LAK      var_9    "O5'"  "C1'"  "C2'"  "C3'"     60.000   20.000   3
 LAK      var_10   "O5'"  "C1'"  "O1'"  "HO1'"   -60.000   20.000   1
 LAK      var_11   "C4'"  "C5'"  "C6'"  O1      -179.869   20.000   3
 LAK      var_12   "C5'"  "C6'"  O1     C1      -179.998   20.000   1
 LAK      var_13   "C6'"  O1     C1     O5       -59.940   20.000   1
 LAK      var_14   O1     C1     C2     C3       180.000   20.000   3
 LAK      var_15   O1     C1     O5     C5       180.000   20.000   1
 LAK      var_16   C1     O5     C5     C4        60.000   20.000   1
 LAK      var_17   O5     C5     C6     O6        59.832   20.000   3
 LAK      var_18   C5     C6     O6     HO6     -179.961   20.000   1
 LAK      var_19   O5     C5     C4     C3       -60.000   20.000   3
 LAK      var_20   C5     C4     O4     HO4     -179.699   20.000   1
 LAK      var_21   C5     C4     C3     C2        60.000   20.000   3
 LAK      var_22   C4     C3     O3     HO3     -179.154   20.000   1
 LAK      var_23   C4     C3     C2     O2       180.000   20.000   3
 LAK      var_24   C3     C2     O2     HO2      179.572   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 LAK      chir_01  C1     C2     O1     O5        positiv
 LAK      chir_02  C2     C1     C3     O2        negativ
 LAK      chir_03  C3     C2     C4     O3        positiv
 LAK      chir_04  C4     C3     C5     O4        positiv
 LAK      chir_05  C5     C4     C6     O5        negativ
 LAK      chir_06  "C1'"  "C2'"  "O1'"  "O5'"     positiv
 LAK      chir_07  "C2'"  "C1'"  "C3'"  "O2'"     positiv
 LAK      chir_08  "C3'"  "C2'"  "C4'"  "O3'"     positiv
 LAK      chir_09  "C4'"  "C3'"  "C5'"  "O4'"     negativ
 LAK      chir_10  "C5'"  "C4'"  "C6'"  "O5'"     negativ
# ------------------------------------------------------
`.trim();

monomers["BCN"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BCN      BCN 'BICINE                              ' non-polymer        23  11 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BCN
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BCN           O22    O    OC       -0.500      0.000    0.000    0.000
 BCN           C2     C    C         0.000     -1.174   -0.323   -0.289
 BCN           O21    O    OC       -0.500     -1.518   -1.526   -0.252
 BCN           C1     C    CH2       0.000     -2.172    0.734   -0.681
 BCN           H11    H    H         0.000     -1.880    1.173   -1.637
 BCN           H12    H    H         0.000     -2.196    1.513    0.084
 BCN           N1     N    NT        0.000     -3.504    0.128   -0.805
 BCN           C5     C    CH2       0.000     -4.233    0.913   -1.809
 BCN           H51    H    H         0.000     -3.953    1.965   -1.721
 BCN           H52    H    H         0.000     -5.307    0.808   -1.642
 BCN           C6     C    CH2       0.000     -3.881    0.406   -3.208
 BCN           H61    H    H         0.000     -2.797    0.426   -3.339
 BCN           H62    H    H         0.000     -4.349    1.049   -3.956
 BCN           O6     O    OH1       0.000     -4.356   -0.931   -3.364
 BCN           HO6    H    H         0.000     -4.132   -1.251   -4.248
 BCN           C3     C    CH2       0.000     -4.188    0.345    0.477
 BCN           H31    H    H         0.000     -5.257    0.161    0.355
 BCN           H32    H    H         0.000     -4.032    1.375    0.804
 BCN           C4     C    CH2       0.000     -3.621   -0.615    1.525
 BCN           H41    H    H         0.000     -3.492   -1.603    1.080
 BCN           H42    H    H         0.000     -4.313   -0.683    2.367
 BCN           O4     O    OH1       0.000     -2.358   -0.129    1.983
 BCN           HO4    H    H         0.000     -2.002   -0.736    2.646
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BCN      O22    n/a    C2     START
 BCN      C2     O22    C1     .
 BCN      O21    C2     .      .
 BCN      C1     C2     N1     .
 BCN      H11    C1     .      .
 BCN      H12    C1     .      .
 BCN      N1     C1     C3     .
 BCN      C5     N1     C6     .
 BCN      H51    C5     .      .
 BCN      H52    C5     .      .
 BCN      C6     C5     O6     .
 BCN      H61    C6     .      .
 BCN      H62    C6     .      .
 BCN      O6     C6     HO6    .
 BCN      HO6    O6     .      .
 BCN      C3     N1     C4     .
 BCN      H31    C3     .      .
 BCN      H32    C3     .      .
 BCN      C4     C3     O4     .
 BCN      H41    C4     .      .
 BCN      H42    C4     .      .
 BCN      O4     C4     HO4    .
 BCN      HO4    O4     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BCN      N1     C1        single      1.469    0.020
 BCN      C3     N1        single      1.469    0.020
 BCN      C5     N1        single      1.469    0.020
 BCN      C1     C2        single      1.510    0.020
 BCN      H11    C1        single      1.092    0.020
 BCN      H12    C1        single      1.092    0.020
 BCN      O21    C2        deloc       1.250    0.020
 BCN      C2     O22       deloc       1.250    0.020
 BCN      C4     C3        single      1.524    0.020
 BCN      H31    C3        single      1.092    0.020
 BCN      H32    C3        single      1.092    0.020
 BCN      O4     C4        single      1.432    0.020
 BCN      H41    C4        single      1.092    0.020
 BCN      H42    C4        single      1.092    0.020
 BCN      HO4    O4        single      0.967    0.020
 BCN      C6     C5        single      1.524    0.020
 BCN      H51    C5        single      1.092    0.020
 BCN      H52    C5        single      1.092    0.020
 BCN      O6     C6        single      1.432    0.020
 BCN      H61    C6        single      1.092    0.020
 BCN      H62    C6        single      1.092    0.020
 BCN      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BCN      O22    C2     O21     123.000    3.000
 BCN      O22    C2     C1      118.500    3.000
 BCN      O21    C2     C1      118.500    3.000
 BCN      C2     C1     H11     109.470    3.000
 BCN      C2     C1     H12     109.470    3.000
 BCN      C2     C1     N1      109.500    3.000
 BCN      H11    C1     H12     107.900    3.000
 BCN      H11    C1     N1      109.470    3.000
 BCN      H12    C1     N1      109.470    3.000
 BCN      C1     N1     C5      109.470    3.000
 BCN      C1     N1     C3      109.470    3.000
 BCN      C5     N1     C3      109.470    3.000
 BCN      N1     C5     H51     109.470    3.000
 BCN      N1     C5     H52     109.470    3.000
 BCN      N1     C5     C6      109.470    3.000
 BCN      H51    C5     H52     107.900    3.000
 BCN      H51    C5     C6      109.470    3.000
 BCN      H52    C5     C6      109.470    3.000
 BCN      C5     C6     H61     109.470    3.000
 BCN      C5     C6     H62     109.470    3.000
 BCN      C5     C6     O6      109.470    3.000
 BCN      H61    C6     H62     107.900    3.000
 BCN      H61    C6     O6      109.470    3.000
 BCN      H62    C6     O6      109.470    3.000
 BCN      C6     O6     HO6     109.470    3.000
 BCN      N1     C3     H31     109.470    3.000
 BCN      N1     C3     H32     109.470    3.000
 BCN      N1     C3     C4      109.470    3.000
 BCN      H31    C3     H32     107.900    3.000
 BCN      H31    C3     C4      109.470    3.000
 BCN      H32    C3     C4      109.470    3.000
 BCN      C3     C4     H41     109.470    3.000
 BCN      C3     C4     H42     109.470    3.000
 BCN      C3     C4     O4      109.470    3.000
 BCN      H41    C4     H42     107.900    3.000
 BCN      H41    C4     O4      109.470    3.000
 BCN      H42    C4     O4      109.470    3.000
 BCN      C4     O4     HO4     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BCN      var_1    O22    C2     C1     N1      -172.969   20.000   3
 BCN      var_2    C2     C1     N1     C3        95.647   20.000   1
 BCN      var_3    C1     N1     C5     C6        84.242   20.000   1
 BCN      var_4    N1     C5     C6     O6        65.226   20.000   3
 BCN      var_5    C5     C6     O6     HO6     -179.954   20.000   1
 BCN      var_6    C1     N1     C3     C4       -75.162   20.000   1
 BCN      var_7    N1     C3     C4     O4        77.468   20.000   3
 BCN      var_8    C3     C4     O4     HO4      179.971   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BCN      chir_01  N1     C1     C3     C5        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 BCN      plan-1    C2        0.020
 BCN      plan-1    C1        0.000
 BCN      plan-1    O21       0.000
 BCN      plan-1    O22       0.000
# ------------------------------------------------------
`.trim();

monomers["CAC"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CAC      CAC 'CACODYLATE ION                      ' non-polymer        11   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CAC
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CAC           O2     O    O        -1.000     -8.103    9.162   23.790
 CAC           AS     AS   AS        0.000     -7.875    8.127   25.219
 CAC           O1     O    O         0.000     -7.834    8.918   26.861
 CAC           C2     C    CH3       0.000     -9.167    6.642   25.290
 CAC           H23    H    H         0.000     -8.863    5.942   26.025
 CAC           H22    H    H         0.000    -10.126    7.018   25.538
 CAC           H21    H    H         0.000     -9.210    6.164   24.346
 CAC           C1     C    CH3       0.000     -6.147    7.137   25.215
 CAC           H13    H    H         0.000     -5.343    7.819   25.331
 CAC           H12    H    H         0.000     -6.131    6.440   26.015
 CAC           H11    H    H         0.000     -6.033    6.617   24.297
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CAC      O2     n/a    AS     START
 CAC      AS     O2     C1     .
 CAC      O1     AS     .      .
 CAC      C2     AS     H21    .
 CAC      H23    C2     .      .
 CAC      H22    C2     .      .
 CAC      H21    C2     .      .
 CAC      C1     AS     H11    .
 CAC      H13    C1     .      .
 CAC      H12    C1     .      .
 CAC      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CAC      O1     AS        double      1.740    0.020
 CAC      AS     O2        single      1.740    0.020
 CAC      C1     AS        single      1.962    0.020
 CAC      C2     AS        single      1.962    0.020
 CAC      H11    C1        single      1.059    0.020
 CAC      H12    C1        single      1.059    0.020
 CAC      H13    C1        single      1.059    0.020
 CAC      H21    C2        single      1.059    0.020
 CAC      H22    C2        single      1.059    0.020
 CAC      H23    C2        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CAC      O2     AS     O1      109.470    3.000
 CAC      O2     AS     C2      109.470    3.000
 CAC      O2     AS     C1      109.470    3.000
 CAC      O1     AS     C2      109.470    3.000
 CAC      O1     AS     C1      109.470    3.000
 CAC      C2     AS     C1      109.470    3.000
 CAC      AS     C2     H23     109.500    3.000
 CAC      AS     C2     H22     109.500    3.000
 CAC      AS     C2     H21     109.500    3.000
 CAC      H23    C2     H22     109.470    3.000
 CAC      H23    C2     H21     109.470    3.000
 CAC      H22    C2     H21     109.470    3.000
 CAC      AS     C1     H13     109.500    3.000
 CAC      AS     C1     H12     109.500    3.000
 CAC      AS     C1     H11     109.500    3.000
 CAC      H13    C1     H12     109.470    3.000
 CAC      H13    C1     H11     109.470    3.000
 CAC      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CAC      var_1    O2     AS     C2     H21       47.566   20.000   1
 CAC      var_2    O2     AS     C1     H11      -52.037   20.000   1
# ------------------------------------------------------
`.trim();

monomers["FMT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
FMT      FMT 'FORMIC ACID                         ' non-polymer         5   3 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_FMT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 FMT           O1     O    O         0.000      0.000    0.000    0.000
 FMT           C      C    C1        0.000     -1.065    0.571    0.001
 FMT           H      H    H         0.000     -1.980    0.003    0.003
 FMT           O2     O    OH1       0.000     -1.107    1.912    0.000
 FMT           HO2    H    H         0.000     -1.959    2.373    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 FMT      O1     n/a    C      START
 FMT      C      O1     O2     .
 FMT      H      C      .      .
 FMT      O2     C      HO2    .
 FMT      HO2    O2     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 FMT      C      O1        double      1.220    0.020
 FMT      O2     C         single      1.330    0.020
 FMT      H      C         single      1.077    0.020
 FMT      HO2    O2        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 FMT      O1     C      H       123.000    3.000
 FMT      O1     C      O2      120.000    3.000
 FMT      H      C      O2      120.000    3.000
 FMT      C      O2     HO2     120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 FMT      var_1    O1     C      O2     HO2      179.942   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 FMT      plan-1    C         0.020
 FMT      plan-1    O1        0.000
 FMT      plan-1    O2        0.000
 FMT      plan-1    H         0.000
# ------------------------------------------------------
`.trim();

monomers["ACY"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ACY      ACY 'ACETIC ACID                         ' non-polymer         7   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ACY
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ACY           OXT    O    OC       -0.500      0.000    0.000    0.000
 ACY           C      C    C         0.000     -1.175   -0.429    0.002
 ACY           O      O    OC       -0.500     -1.392   -1.661    0.000
 ACY           CH3    C    CH3       0.000     -2.331    0.539    0.000
 ACY           H3     H    H         0.000     -2.047    1.430   -0.498
 ACY           H2     H    H         0.000     -3.157    0.104   -0.501
 ACY           H1     H    H         0.000     -2.605    0.766    0.998
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ACY      OXT    n/a    C      START
 ACY      C      OXT    CH3    .
 ACY      O      C      .      .
 ACY      CH3    C      H1     .
 ACY      H3     CH3    .      .
 ACY      H2     CH3    .      .
 ACY      H1     CH3    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ACY      O      C         deloc       1.250    0.020
 ACY      C      OXT       deloc       1.250    0.020
 ACY      CH3    C         single      1.500    0.020
 ACY      H1     CH3       single      1.059    0.020
 ACY      H2     CH3       single      1.059    0.020
 ACY      H3     CH3       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ACY      OXT    C      O       123.000    3.000
 ACY      OXT    C      CH3     120.000    3.000
 ACY      O      C      CH3     120.000    3.000
 ACY      C      CH3    H3      109.470    3.000
 ACY      C      CH3    H2      109.470    3.000
 ACY      C      CH3    H1      109.470    3.000
 ACY      H3     CH3    H2      109.470    3.000
 ACY      H3     CH3    H1      109.470    3.000
 ACY      H2     CH3    H1      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ACY      var_1    OXT    C      CH3    H1       -90.268   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ACY      plan-1    C         0.020
 ACY      plan-1    O         0.000
 ACY      plan-1    OXT       0.000
 ACY      plan-1    CH3       0.000
# ------------------------------------------------------
`.trim();

monomers["FCL"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
FCL      FCL '3-CHLORO-L-PHENYLALANINE            ' peptide            22  13 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_FCL
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 FCL           N      N    NH2       0.000      0.000    0.000    0.000
 FCL           HN1    H    H         0.000      0.040   -0.983   -0.222
 FCL           HN2    H    H         0.000     -0.851    0.521   -0.148
 FCL           CA     C    CH1       0.000      1.164    0.663    0.531
 FCL           HA     H    H         0.000      1.513    1.392   -0.213
 FCL           CB     C    CH2       0.000      0.828    1.420    1.822
 FCL           HBC1   H    H         0.000      0.822    0.695    2.639
 FCL           HBC2   H    H         0.000     -0.171    1.845    1.706
 FCL           CG     C    CR6       0.000      1.813    2.522    2.132
 FCL           CD2    C    CR16      0.000      1.582    3.796    1.638
 FCL           HD2    H    H         0.000      0.705    3.999    1.037
 FCL           CE2    C    CR16      0.000      2.492    4.815    1.924
 FCL           HE2    H    H         0.000      2.322    5.815    1.543
 FCL           CZ     C    CR16      0.000      3.619    4.546    2.699
 FCL           HZ     H    H         0.000      4.325    5.337    2.921
 FCL           CE1    C    CR6       0.000      3.838    3.259    3.189
 FCL           CD1    C    CR16      0.000      2.928    2.240    2.903
 FCL           HD1    H    H         0.000      3.093    1.239    3.281
 FCL           CL1    CL   CL        0.000      5.229    2.927    4.146
 FCL           C      C    C         0.000      2.290   -0.328    0.789
 FCL           O      O    OC       -0.500      2.090   -1.502    1.170
 FCL           OXT    O    OC       -0.500      3.440    0.118    0.581
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 FCL      N      n/a    CA     START
 FCL      HN1    N      .      .
 FCL      HN2    N      .      .
 FCL      CA     N      C      .
 FCL      HA     CA     .      .
 FCL      CB     CA     CG     .
 FCL      HBC1   CB     .      .
 FCL      HBC2   CB     .      .
 FCL      CG     CB     CD2    .
 FCL      CD2    CG     CE2    .
 FCL      HD2    CD2    .      .
 FCL      CE2    CD2    CZ     .
 FCL      HE2    CE2    .      .
 FCL      CZ     CE2    CE1    .
 FCL      HZ     CZ     .      .
 FCL      CE1    CZ     CL1    .
 FCL      CD1    CE1    HD1    .
 FCL      HD1    CD1    .      .
 FCL      CL1    CE1    .      .
 FCL      C      CA     .      END
 FCL      O      C      .      .
 FCL      OXT    C      .      .
 FCL      CG     CD1    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 FCL      CA     N         single      1.450    0.020
 FCL      C      CA        single      1.500    0.020
 FCL      CB     CA        single      1.524    0.020
 FCL      HA     CA        single      1.099    0.020
 FCL      O      C         deloc       1.250    0.020
 FCL      OXT    C         deloc       1.250    0.020
 FCL      CG     CB        single      1.511    0.020
 FCL      HBC1   CB        single      1.092    0.020
 FCL      HBC2   CB        single      1.092    0.020
 FCL      CG     CD1       double      1.390    0.020
 FCL      CD2    CG        single      1.390    0.020
 FCL      CD1    CE1       single      1.390    0.020
 FCL      HD1    CD1       single      1.083    0.020
 FCL      CE2    CD2       double      1.390    0.020
 FCL      HD2    CD2       single      1.083    0.020
 FCL      CL1    CE1       single      1.795    0.020
 FCL      CE1    CZ        double      1.390    0.020
 FCL      CZ     CE2       single      1.390    0.020
 FCL      HE2    CE2       single      1.083    0.020
 FCL      HZ     CZ        single      1.083    0.020
 FCL      HN1    N         single      1.010    0.020
 FCL      HN2    N         single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 FCL      HN1    N      HN2     120.000    3.000
 FCL      HN1    N      CA      120.000    3.000
 FCL      HN2    N      CA      120.000    3.000
 FCL      N      CA     HA      109.470    3.000
 FCL      N      CA     CB      109.470    3.000
 FCL      N      CA     C       109.470    3.000
 FCL      HA     CA     CB      108.340    3.000
 FCL      HA     CA     C       108.810    3.000
 FCL      CB     CA     C       109.470    3.000
 FCL      CA     CB     HBC1    109.470    3.000
 FCL      CA     CB     HBC2    109.470    3.000
 FCL      CA     CB     CG      109.470    3.000
 FCL      HBC1   CB     HBC2    107.900    3.000
 FCL      HBC1   CB     CG      109.470    3.000
 FCL      HBC2   CB     CG      109.470    3.000
 FCL      CB     CG     CD2     120.000    3.000
 FCL      CB     CG     CD1     120.000    3.000
 FCL      CD2    CG     CD1     120.000    3.000
 FCL      CG     CD2    HD2     120.000    3.000
 FCL      CG     CD2    CE2     120.000    3.000
 FCL      HD2    CD2    CE2     120.000    3.000
 FCL      CD2    CE2    HE2     120.000    3.000
 FCL      CD2    CE2    CZ      120.000    3.000
 FCL      HE2    CE2    CZ      120.000    3.000
 FCL      CE2    CZ     HZ      120.000    3.000
 FCL      CE2    CZ     CE1     120.000    3.000
 FCL      HZ     CZ     CE1     120.000    3.000
 FCL      CZ     CE1    CD1     120.000    3.000
 FCL      CZ     CE1    CL1     120.000    3.000
 FCL      CD1    CE1    CL1     120.000    3.000
 FCL      CE1    CD1    HD1     120.000    3.000
 FCL      CE1    CD1    CG      120.000    3.000
 FCL      HD1    CD1    CG      120.000    3.000
 FCL      CA     C      O       118.500    3.000
 FCL      CA     C      OXT     118.500    3.000
 FCL      O      C      OXT     123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 FCL      var_1    HN2    N      CA     C        175.000   20.000   1
 FCL      var_2    N      CA     CB     CG      -158.204   20.000   3
 FCL      var_3    CA     CB     CG     CD2       89.945   20.000   2
 FCL      CONST_1  CB     CG     CD1    CE1      180.000    0.000   0
 FCL      CONST_2  CB     CG     CD2    CE2      180.000    0.000   0
 FCL      CONST_3  CG     CD2    CE2    CZ         0.000    0.000   0
 FCL      CONST_4  CD2    CE2    CZ     CE1        0.000    0.000   0
 FCL      CONST_5  CE2    CZ     CE1    CL1      180.000    0.000   0
 FCL      CONST_6  CZ     CE1    CD1    CG         0.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 FCL      chir_01  CA     N      C      CB        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 FCL      plan-1    N         0.020
 FCL      plan-1    CA        0.020
 FCL      plan-1    HN1       0.020
 FCL      plan-1    HN2       0.020
 FCL      plan-2    C         0.020
 FCL      plan-2    CA        0.020
 FCL      plan-2    O         0.020
 FCL      plan-2    OXT       0.020
 FCL      plan-3    CG        0.020
 FCL      plan-3    CB        0.020
 FCL      plan-3    CD1       0.020
 FCL      plan-3    CD2       0.020
 FCL      plan-3    CE1       0.020
 FCL      plan-3    CE2       0.020
 FCL      plan-3    CZ        0.020
 FCL      plan-3    HD1       0.020
 FCL      plan-3    HD2       0.020
 FCL      plan-3    CL1       0.020
 FCL      plan-3    HE2       0.020
 FCL      plan-3    HZ        0.020
# ------------------------------------------------------
`.trim();

monomers["CIT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CIT      CIT 'CITRIC ACID                         ' non-polymer        18  13 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CIT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CIT           O6     O    OC       -0.500      0.000    0.000    0.000
 CIT           C6     C    C         0.000     -1.251   -0.012    0.000
 CIT           O5     O    OC       -0.500     -1.887    1.066    0.000
 CIT           C3     C    CT        0.000     -1.990   -1.323    0.000
 CIT           O7     O    OH1       0.000     -3.397   -1.076    0.000
 CIT           HO7    H    H         0.000     -3.872   -1.919    0.000
 CIT           C2     C    CH2       0.000     -1.614   -2.122   -1.249
 CIT           H21    H    H         0.000     -2.150   -3.073   -1.247
 CIT           H22    H    H         0.000     -0.538   -2.311   -1.248
 CIT           C1     C    C         0.000     -1.986   -1.336   -2.479
 CIT           O2     O    OC       -0.500     -1.762   -1.808   -3.615
 CIT           O1     O    OC       -0.500     -2.518   -0.209   -2.364
 CIT           C4     C    CH2       0.000     -1.614   -2.122    1.249
 CIT           H41    H    H         0.000     -0.538   -2.311    1.248
 CIT           H42    H    H         0.000     -2.150   -3.073    1.247
 CIT           C5     C    C         0.000     -1.986   -1.336    2.479
 CIT           O3     O    OC       -0.500     -2.518   -0.209    2.364
 CIT           O4     O    OC       -0.500     -1.762   -1.808    3.615
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CIT      O6     n/a    C6     START
 CIT      C6     O6     C3     .
 CIT      O5     C6     .      .
 CIT      C3     C6     C4     .
 CIT      O7     C3     HO7    .
 CIT      HO7    O7     .      .
 CIT      C2     C3     C1     .
 CIT      H21    C2     .      .
 CIT      H22    C2     .      .
 CIT      C1     C2     O1     .
 CIT      O2     C1     .      .
 CIT      O1     C1     .      .
 CIT      C4     C3     C5     .
 CIT      H41    C4     .      .
 CIT      H42    C4     .      .
 CIT      C5     C4     O4     .
 CIT      O3     C5     .      .
 CIT      O4     C5     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CIT      O1     C1        deloc       1.250    0.020
 CIT      O2     C1        deloc       1.250    0.020
 CIT      C1     C2        single      1.510    0.020
 CIT      C2     C3        single      1.524    0.020
 CIT      H21    C2        single      1.092    0.020
 CIT      H22    C2        single      1.092    0.020
 CIT      O7     C3        single      1.432    0.020
 CIT      C4     C3        single      1.524    0.020
 CIT      C3     C6        single      1.507    0.020
 CIT      HO7    O7        single      0.967    0.020
 CIT      C5     C4        single      1.510    0.020
 CIT      H41    C4        single      1.092    0.020
 CIT      H42    C4        single      1.092    0.020
 CIT      O3     C5        deloc       1.250    0.020
 CIT      O4     C5        deloc       1.250    0.020
 CIT      O5     C6        deloc       1.250    0.020
 CIT      C6     O6        deloc       1.250    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 CIT      O6     C6     O5      123.000    3.000
 CIT      O6     C6     C3      118.500    3.000
 CIT      O5     C6     C3      118.500    3.000
 CIT      C6     C3     C2      109.470    3.000
 CIT      C6     C3     O7      109.470    3.000
 CIT      C6     C3     C4      109.470    3.000
 CIT      C2     C3     O7      109.470    3.000
 CIT      C2     C3     C4      111.000    3.000
 CIT      O7     C3     C4      109.470    3.000
 CIT      C3     C2     H21     109.470    3.000
 CIT      C3     C2     H22     109.470    3.000
 CIT      C3     C2     C1      109.470    3.000
 CIT      H21    C2     H22     107.900    3.000
 CIT      H21    C2     C1      109.470    3.000
 CIT      H22    C2     C1      109.470    3.000
 CIT      C2     C1     O2      118.500    3.000
 CIT      C2     C1     O1      118.500    3.000
 CIT      O2     C1     O1      123.000    3.000
 CIT      C3     O7     HO7     109.470    3.000
 CIT      C3     C4     H41     109.470    3.000
 CIT      C3     C4     H42     109.470    3.000
 CIT      C3     C4     C5      109.470    3.000
 CIT      H41    C4     H42     107.900    3.000
 CIT      H41    C4     C5      109.470    3.000
 CIT      H42    C4     C5      109.470    3.000
 CIT      C4     C5     O3      118.500    3.000
 CIT      C4     C5     O4      118.500    3.000
 CIT      O3     C5     O4      123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 CIT      var_1    O6     C6     C3     C4        60.041   20.000   1
 CIT      var_2    C6     C3     C2     C1       -59.978   20.000   1
 CIT      var_3    C3     C2     C1     O1         0.033   20.000   3
 CIT      var_4    C6     C3     O7     HO7      180.000   20.000   1
 CIT      var_5    C6     C3     C4     C5        59.978   20.000   1
 CIT      var_6    C3     C4     C5     O4      -179.932   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 CIT      chir_01  C3     C2     O7     C4        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 CIT      plan-1    C1        0.020
 CIT      plan-1    O1        0.020
 CIT      plan-1    O2        0.020
 CIT      plan-1    C2        0.020
 CIT      plan-2    C5        0.020
 CIT      plan-2    C4        0.020
 CIT      plan-2    O3        0.020
 CIT      plan-2    O4        0.020
 CIT      plan-3    C6        0.020
 CIT      plan-3    C3        0.020
 CIT      plan-3    O5        0.020
 CIT      plan-3    O6        0.020
# ------------------------------------------------------
`.trim();

monomers["3CO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
3CO      3CO 'COBALT (III) ION                    ' non-polymer         1   1 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_3CO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 3CO           CO     CO   CO        3.000      0.000    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 3CO      CO     n/a    .      END
# ------------------------------------------------------
`.trim();

monomers["NCO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
NCO      NCO 'COBALT HEXAMMINE(III)               ' non-polymer        25   7 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_NCO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 NCO           N6     N    NT3       0.000      0.000    0.000    0.000
 NCO           HN61   H    H         0.000      0.505   -0.041   -0.872
 NCO           HN62   H    H         0.000      0.060    0.933    0.380
 NCO           HN63   H    H         0.000      0.403   -0.655    0.654
 NCO           CO     CO   CO        3.000     -1.736   -0.425   -0.286
 NCO           N5     N    NT3       0.000     -2.190    1.320   -0.120
 NCO           HN53   H    H         0.000     -2.831    1.571   -0.858
 NCO           HN52   H    H         0.000     -1.361    1.891   -0.186
 NCO           HN51   H    H         0.000     -2.631    1.468    0.775
 NCO           N2     N    NT3       0.000     -1.973   -0.656    1.493
 NCO           HN23   H    H         0.000     -1.551   -1.526    1.779
 NCO           HN22   H    H         0.000     -2.960   -0.677    1.701
 NCO           HN21   H    H         0.000     -1.541    0.108    1.992
 NCO           N3     N    NT3       0.000     -1.281   -2.170   -0.452
 NCO           HN33   H    H         0.000     -0.463   -2.250   -1.037
 NCO           HN32   H    H         0.000     -2.046   -2.677   -0.870
 NCO           HN31   H    H         0.000     -1.081   -2.553    0.460
 NCO           N4     N    NT3       0.000     -3.471   -0.850   -0.573
 NCO           HN43   H    H         0.000     -3.735   -0.574   -1.507
 NCO           HN42   H    H         0.000     -4.052   -0.366    0.097
 NCO           HN41   H    H         0.000     -3.595   -1.846   -0.469
 NCO           N1     N    NT3       0.000     -1.498   -0.194   -2.065
 NCO           HN13   H    H         0.000     -1.460   -1.095   -2.519
 NCO           HN12   H    H         0.000     -0.635    0.302   -2.229
 NCO           HN11   H    H         0.000     -2.268    0.339   -2.441
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 NCO      N6     n/a    CO     START
 NCO      HN61   N6     .      .
 NCO      HN62   N6     .      .
 NCO      HN63   N6     .      .
 NCO      CO     N6     N1     .
 NCO      N5     CO     HN51   .
 NCO      HN53   N5     .      .
 NCO      HN52   N5     .      .
 NCO      HN51   N5     .      .
 NCO      N2     CO     HN21   .
 NCO      HN23   N2     .      .
 NCO      HN22   N2     .      .
 NCO      HN21   N2     .      .
 NCO      N3     CO     HN31   .
 NCO      HN33   N3     .      .
 NCO      HN32   N3     .      .
 NCO      HN31   N3     .      .
 NCO      N4     CO     HN41   .
 NCO      HN43   N4     .      .
 NCO      HN42   N4     .      .
 NCO      HN41   N4     .      .
 NCO      N1     CO     HN11   .
 NCO      HN13   N1     .      .
 NCO      HN12   N1     .      .
 NCO      HN11   N1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 NCO      N1     CO        single      1.980    0.020
 NCO      N2     CO        single      1.980    0.020
 NCO      N3     CO        single      1.980    0.020
 NCO      N4     CO        single      1.980    0.020
 NCO      N5     CO        single      1.980    0.020
 NCO      CO     N6        single      1.980    0.020
 NCO      HN11   N1        single      1.033    0.020
 NCO      HN12   N1        single      1.033    0.020
 NCO      HN13   N1        single      1.033    0.020
 NCO      HN21   N2        single      1.033    0.020
 NCO      HN22   N2        single      1.033    0.020
 NCO      HN23   N2        single      1.033    0.020
 NCO      HN31   N3        single      1.033    0.020
 NCO      HN32   N3        single      1.033    0.020
 NCO      HN33   N3        single      1.033    0.020
 NCO      HN41   N4        single      1.033    0.020
 NCO      HN42   N4        single      1.033    0.020
 NCO      HN43   N4        single      1.033    0.020
 NCO      HN51   N5        single      1.033    0.020
 NCO      HN52   N5        single      1.033    0.020
 NCO      HN53   N5        single      1.033    0.020
 NCO      HN61   N6        single      1.033    0.020
 NCO      HN62   N6        single      1.033    0.020
 NCO      HN63   N6        single      1.033    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 NCO      HN61   N6     HN62    109.470    3.000
 NCO      HN61   N6     HN63    109.470    3.000
 NCO      HN62   N6     HN63    109.470    3.000
 NCO      HN61   N6     CO      109.500    3.000
 NCO      HN62   N6     CO      109.500    3.000
 NCO      HN63   N6     CO      109.500    3.000
 NCO      N6     CO     N5       90.000    3.000
 NCO      N6     CO     N2       90.000    3.000
 NCO      N6     CO     N3       90.000    3.000
 NCO      N6     CO     N4      180.000    3.000
 NCO      N6     CO     N1       90.000    3.000
 NCO      N5     CO     N2       90.000    3.000
 NCO      N5     CO     N3      180.000    3.000
 NCO      N2     CO     N3       90.000    3.000
 NCO      N5     CO     N4       90.000    3.000
 NCO      N2     CO     N4       90.000    3.000
 NCO      N3     CO     N4       90.000    3.000
 NCO      N5     CO     N1       90.000    3.000
 NCO      N2     CO     N1      180.000    3.000
 NCO      N3     CO     N1       90.000    3.000
 NCO      N4     CO     N1       90.000    3.000
 NCO      CO     N5     HN53    109.500    3.000
 NCO      CO     N5     HN52    109.500    3.000
 NCO      CO     N5     HN51    109.500    3.000
 NCO      HN53   N5     HN52    109.470    3.000
 NCO      HN53   N5     HN51    109.470    3.000
 NCO      HN52   N5     HN51    109.470    3.000
 NCO      CO     N2     HN23    109.500    3.000
 NCO      CO     N2     HN22    109.500    3.000
 NCO      CO     N2     HN21    109.500    3.000
 NCO      HN23   N2     HN22    109.470    3.000
 NCO      HN23   N2     HN21    109.470    3.000
 NCO      HN22   N2     HN21    109.470    3.000
 NCO      CO     N3     HN33    109.500    3.000
 NCO      CO     N3     HN32    109.500    3.000
 NCO      CO     N3     HN31    109.500    3.000
 NCO      HN33   N3     HN32    109.470    3.000
 NCO      HN33   N3     HN31    109.470    3.000
 NCO      HN32   N3     HN31    109.470    3.000
 NCO      CO     N4     HN43    109.500    3.000
 NCO      CO     N4     HN42    109.500    3.000
 NCO      CO     N4     HN41    109.500    3.000
 NCO      HN43   N4     HN42    109.470    3.000
 NCO      HN43   N4     HN41    109.470    3.000
 NCO      HN42   N4     HN41    109.470    3.000
 NCO      CO     N1     HN13    109.500    3.000
 NCO      CO     N1     HN12    109.500    3.000
 NCO      CO     N1     HN11    109.500    3.000
 NCO      HN13   N1     HN12    109.470    3.000
 NCO      HN13   N1     HN11    109.470    3.000
 NCO      HN12   N1     HN11    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 NCO      var_1    HN61   N6     CO     N5         0.000   20.000   1
 NCO      var_2    HN53   N5     CO     N6         0.000   20.000   1
 NCO      var_3    HN23   N2     CO     N6         0.000   20.000   1
 NCO      var_4    HN33   N3     CO     N6         0.000   20.000   1
 NCO      var_5    HN43   N4     CO     N5         0.000   20.000   1
 NCO      var_6    HN13   N1     CO     N6         0.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
_chem_comp_chir.atom_id_4
_chem_comp_chir.atom_id_5
_chem_comp_chir.atom_id_6
_chem_comp_chir.atom_id_7
_chem_comp_chir.atom_id_8
 NCO      chir_01  CO     N6     N4     N5        cross4
                   N2     N3     N1     .      .
# ------------------------------------------------------
`.trim();

monomers["CU1"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CU1      CU1 'COPPER (I) ION                      ' non-polymer         1   1 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CU1
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CU1           CU     CU   CU        1.000      0.000    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CU1      CU     n/a    .      END
# ------------------------------------------------------
`.trim();

monomers["CYN"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CYN      CYN 'CYANIDE ION                         ' non-polymer         2   2 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CYN
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CYN           N      N    NS        0.000      0.000    0.000    0.000
 CYN           C      C    C        -1.000     -0.527    0.000   -1.005
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CYN      N      n/a    C      START
 CYN      C      N      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CYN      C      N         triple      1.340    0.020
# ------------------------------------------------------
`.trim();

monomers["CYN"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
CYN      CYN 'CYANIDE ION                         ' non-polymer         2   2 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_CYN
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 CYN           N      N    NS        0.000      0.000    0.000    0.000
 CYN           C      C    C        -1.000     -0.527    0.000   -1.005
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 CYN      N      n/a    C      START
 CYN      C      N      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 CYN      C      N         triple      1.340    0.020
# ------------------------------------------------------
`.trim();

monomers["MA4"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MA4      MA4 'CYCLOHEXYL-HEXYL-BETA-D-MALTOSIDE   ' non-polymer        79  35 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MA4
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MA4           O60    O    OH1       0.000      0.000    0.000    0.000
 MA4           HO60   H    H         0.000      0.911    0.310    0.090
 MA4           C60    C    CH2       0.000     -0.514    0.399   -1.271
 MA4           H601   H    H         0.000      0.099   -0.035   -2.064
 MA4           H602   H    H         0.000     -0.489    1.488   -1.348
 MA4           C50    C    CH1       0.000     -1.957   -0.091   -1.415
 MA4           H501   H    H         0.000     -1.984   -1.184   -1.297
 MA4           C40    C    CH1       0.000     -2.487    0.283   -2.800
 MA4           H401   H    H         0.000     -2.480    1.376   -2.912
 MA4           C30    C    CH1       0.000     -3.921   -0.238   -2.945
 MA4           H301   H    H         0.000     -3.915   -1.337   -2.940
 MA4           O30    O    OH1       0.000     -4.480    0.231   -4.174
 MA4           HO30   H    H         0.000     -5.384   -0.099   -4.263
 MA4           C20    C    CH1       0.000     -4.752    0.277   -1.766
 MA4           H201   H    H         0.000     -4.846    1.370   -1.832
 MA4           O20    O    OH1       0.000     -6.052   -0.317   -1.802
 MA4           HO20   H    H         0.000     -6.575    0.009   -1.058
 MA4           O1     O    O2        0.000     -1.659   -0.305   -3.805
 MA4           C1     C    CH1       0.000     -1.832    0.472   -4.992
 MA4           H11    H    H         0.000     -2.897    0.708   -5.121
 MA4           O5     O    O2        0.000     -1.089    1.683   -4.877
 MA4           C5     C    CH1       0.000      0.251    1.337   -4.530
 MA4           H51    H    H         0.000      0.242    0.679   -3.650
 MA4           C6     C    CH2       0.000      1.038    2.607   -4.209
 MA4           H61    H    H         0.000      1.048    3.260   -5.084
 MA4           H62    H    H         0.000      2.064    2.342   -3.943
 MA4           O6     O    OH1       0.000      0.422    3.286   -3.113
 MA4           HO6    H    H         0.000      0.920    4.090   -2.911
 MA4           C4     C    CH1       0.000      0.915    0.610   -5.702
 MA4           H41    H    H         0.000      0.903    1.256   -6.591
 MA4           O4     O    OH1       0.000      2.265    0.289   -5.361
 MA4           HO4    H    H         0.000      2.681   -0.177   -6.099
 MA4           C3     C    CH1       0.000      0.140   -0.679   -5.993
 MA4           H31    H    H         0.000      0.239   -1.370   -5.144
 MA4           O3     O    OH1       0.000      0.654   -1.296   -7.175
 MA4           HO3    H    H         0.000      0.154   -2.102   -7.361
 MA4           C2     C    CH1       0.000     -1.337   -0.327   -6.199
 MA4           H21    H    H         0.000     -1.447    0.278   -7.110
 MA4           O2     O    OH1       0.000     -2.104   -1.525   -6.326
 MA4           HO2    H    H         0.000     -3.036   -1.299   -6.449
 MA4           O50    O    O2        0.000     -2.764    0.512   -0.408
 MA4           C10    C    CH1       0.000     -4.051   -0.099   -0.460
 MA4           H101   H    H         0.000     -3.939   -1.191   -0.407
 MA4           O10    O    O2        0.000     -4.835    0.351    0.647
 MA4           C11    C    CH2       0.000     -4.132   -0.027    1.832
 MA4           H111   H    H         0.000     -3.147    0.444    1.836
 MA4           H112   H    H         0.000     -4.015   -1.113    1.854
 MA4           C21    C    CH2       0.000     -4.922    0.428    3.060
 MA4           H211   H    H         0.000     -5.907   -0.043    3.053
 MA4           H212   H    H         0.000     -5.038    1.513    3.036
 MA4           C31    C    CH2       0.000     -4.170    0.022    4.330
 MA4           H311   H    H         0.000     -3.185    0.492    4.334
 MA4           H312   H    H         0.000     -4.055   -1.064    4.352
 MA4           C41    C    CH2       0.000     -4.960    0.478    5.559
 MA4           H411   H    H         0.000     -5.946    0.009    5.552
 MA4           H412   H    H         0.000     -5.075    1.564    5.534
 MA4           C51    C    CH2       0.000     -4.209    0.073    6.827
 MA4           H511   H    H         0.000     -3.223    0.542    6.831
 MA4           H512   H    H         0.000     -4.093   -1.013    6.849
 MA4           C61    C    CH2       0.000     -4.998    0.529    8.056
 MA4           H611   H    H         0.000     -5.984    0.059    8.049
 MA4           H612   H    H         0.000     -5.113    1.614    8.031
 MA4           C12    C    CH1       0.000     -4.246    0.123    9.325
 MA4           H121   H    H         0.000     -3.255    0.597    9.331
 MA4           C62    C    CH2       0.000     -4.085   -1.398    9.358
 MA4           H621   H    H         0.000     -3.523   -1.723    8.480
 MA4           H622   H    H         0.000     -5.071   -1.868    9.352
 MA4           C52    C    CH2       0.000     -3.333   -1.803   10.628
 MA4           H521   H    H         0.000     -2.347   -1.333   10.632
 MA4           H522   H    H         0.000     -3.217   -2.889   10.650
 MA4           C42    C    CH2       0.000     -4.123   -1.347   11.855
 MA4           H421   H    H         0.000     -3.586   -1.638   12.761
 MA4           H422   H    H         0.000     -5.107   -1.819   11.849
 MA4           C32    C    CH2       0.000     -4.285    0.173   11.823
 MA4           H321   H    H         0.000     -3.299    0.643   11.830
 MA4           H322   H    H         0.000     -4.848    0.497   12.700
 MA4           C22    C    CH2       0.000     -5.036    0.578   10.554
 MA4           H222   H    H         0.000     -5.153    1.664   10.532
 MA4           H221   H    H         0.000     -6.022    0.108   10.549
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MA4      O60    n/a    C60    START
 MA4      HO60   O60    .      .
 MA4      C60    O60    C50    .
 MA4      H601   C60    .      .
 MA4      H602   C60    .      .
 MA4      C50    C60    O50    .
 MA4      H501   C50    .      .
 MA4      C40    C50    O1     .
 MA4      H401   C40    .      .
 MA4      C30    C40    C20    .
 MA4      H301   C30    .      .
 MA4      O30    C30    HO30   .
 MA4      HO30   O30    .      .
 MA4      C20    C30    O20    .
 MA4      H201   C20    .      .
 MA4      O20    C20    HO20   .
 MA4      HO20   O20    .      .
 MA4      O1     C40    C1     .
 MA4      C1     O1     O5     .
 MA4      H11    C1     .      .
 MA4      O5     C1     C5     .
 MA4      C5     O5     C4     .
 MA4      H51    C5     .      .
 MA4      C6     C5     O6     .
 MA4      H61    C6     .      .
 MA4      H62    C6     .      .
 MA4      O6     C6     HO6    .
 MA4      HO6    O6     .      .
 MA4      C4     C5     C3     .
 MA4      H41    C4     .      .
 MA4      O4     C4     HO4    .
 MA4      HO4    O4     .      .
 MA4      C3     C4     C2     .
 MA4      H31    C3     .      .
 MA4      O3     C3     HO3    .
 MA4      HO3    O3     .      .
 MA4      C2     C3     O2     .
 MA4      H21    C2     .      .
 MA4      O2     C2     HO2    .
 MA4      HO2    O2     .      .
 MA4      O50    C50    C10    .
 MA4      C10    O50    O10    .
 MA4      H101   C10    .      .
 MA4      O10    C10    C11    .
 MA4      C11    O10    C21    .
 MA4      H111   C11    .      .
 MA4      H112   C11    .      .
 MA4      C21    C11    C31    .
 MA4      H211   C21    .      .
 MA4      H212   C21    .      .
 MA4      C31    C21    C41    .
 MA4      H311   C31    .      .
 MA4      H312   C31    .      .
 MA4      C41    C31    C51    .
 MA4      H411   C41    .      .
 MA4      H412   C41    .      .
 MA4      C51    C41    C61    .
 MA4      H511   C51    .      .
 MA4      H512   C51    .      .
 MA4      C61    C51    C12    .
 MA4      H611   C61    .      .
 MA4      H612   C61    .      .
 MA4      C12    C61    C62    .
 MA4      H121   C12    .      .
 MA4      C62    C12    C52    .
 MA4      H621   C62    .      .
 MA4      H622   C62    .      .
 MA4      C52    C62    C42    .
 MA4      H521   C52    .      .
 MA4      H522   C52    .      .
 MA4      C42    C52    C32    .
 MA4      H421   C42    .      .
 MA4      H422   C42    .      .
 MA4      C32    C42    C22    .
 MA4      H321   C32    .      .
 MA4      H322   C32    .      .
 MA4      C22    C32    H221   .
 MA4      H222   C22    .      .
 MA4      H221   C22    .      END
 MA4      C1     C2     .    ADD
 MA4      C10    C20    .    ADD
 MA4      C12    C22    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MA4      C1     C2        single      1.524    0.020
 MA4      O5     C1        single      1.426    0.020
 MA4      C1     O1        single      1.426    0.020
 MA4      H11    C1        single      1.099    0.020
 MA4      C2     C3        single      1.524    0.020
 MA4      O2     C2        single      1.432    0.020
 MA4      H21    C2        single      1.099    0.020
 MA4      C3     C4        single      1.524    0.020
 MA4      O3     C3        single      1.432    0.020
 MA4      H31    C3        single      1.099    0.020
 MA4      C4     C5        single      1.524    0.020
 MA4      O4     C4        single      1.432    0.020
 MA4      H41    C4        single      1.099    0.020
 MA4      C6     C5        single      1.524    0.020
 MA4      C5     O5        single      1.426    0.020
 MA4      H51    C5        single      1.099    0.020
 MA4      O6     C6        single      1.432    0.020
 MA4      H61    C6        single      1.092    0.020
 MA4      H62    C6        single      1.092    0.020
 MA4      HO2    O2        single      0.967    0.020
 MA4      HO3    O3        single      0.967    0.020
 MA4      HO6    O6        single      0.967    0.020
 MA4      O1     C40       single      1.426    0.020
 MA4      HO4    O4        single      0.967    0.020
 MA4      C10    C20       single      1.524    0.020
 MA4      O10    C10       single      1.426    0.020
 MA4      C10    O50       single      1.426    0.020
 MA4      H101   C10       single      1.099    0.020
 MA4      C20    C30       single      1.524    0.020
 MA4      O20    C20       single      1.432    0.020
 MA4      H201   C20       single      1.099    0.020
 MA4      C30    C40       single      1.524    0.020
 MA4      O30    C30       single      1.432    0.020
 MA4      H301   C30       single      1.099    0.020
 MA4      C40    C50       single      1.524    0.020
 MA4      H401   C40       single      1.099    0.020
 MA4      C50    C60       single      1.524    0.020
 MA4      O50    C50       single      1.426    0.020
 MA4      H501   C50       single      1.099    0.020
 MA4      C60    O60       single      1.432    0.020
 MA4      H601   C60       single      1.092    0.020
 MA4      H602   C60       single      1.092    0.020
 MA4      C11    O10       single      1.426    0.020
 MA4      HO20   O20       single      0.967    0.020
 MA4      HO30   O30       single      0.967    0.020
 MA4      HO60   O60       single      0.967    0.020
 MA4      C21    C11       single      1.524    0.020
 MA4      H111   C11       single      1.092    0.020
 MA4      H112   C11       single      1.092    0.020
 MA4      C31    C21       single      1.524    0.020
 MA4      H211   C21       single      1.092    0.020
 MA4      H212   C21       single      1.092    0.020
 MA4      C41    C31       single      1.524    0.020
 MA4      H311   C31       single      1.092    0.020
 MA4      H312   C31       single      1.092    0.020
 MA4      C51    C41       single      1.524    0.020
 MA4      H411   C41       single      1.092    0.020
 MA4      H412   C41       single      1.092    0.020
 MA4      C61    C51       single      1.524    0.020
 MA4      H511   C51       single      1.092    0.020
 MA4      H512   C51       single      1.092    0.020
 MA4      C12    C61       single      1.524    0.020
 MA4      H611   C61       single      1.092    0.020
 MA4      H612   C61       single      1.092    0.020
 MA4      C12    C22       single      1.524    0.020
 MA4      C62    C12       single      1.524    0.020
 MA4      H121   C12       single      1.099    0.020
 MA4      C22    C32       single      1.524    0.020
 MA4      H221   C22       single      1.092    0.020
 MA4      H222   C22       single      1.092    0.020
 MA4      C32    C42       single      1.524    0.020
 MA4      H321   C32       single      1.092    0.020
 MA4      H322   C32       single      1.092    0.020
 MA4      C42    C52       single      1.524    0.020
 MA4      H421   C42       single      1.092    0.020
 MA4      H422   C42       single      1.092    0.020
 MA4      C52    C62       single      1.524    0.020
 MA4      H521   C52       single      1.092    0.020
 MA4      H522   C52       single      1.092    0.020
 MA4      H621   C62       single      1.092    0.020
 MA4      H622   C62       single      1.092    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MA4      HO60   O60    C60     109.470    3.000
 MA4      O60    C60    H601    109.470    3.000
 MA4      O60    C60    H602    109.470    3.000
 MA4      O60    C60    C50     109.470    3.000
 MA4      H601   C60    H602    107.900    3.000
 MA4      H601   C60    C50     109.470    3.000
 MA4      H602   C60    C50     109.470    3.000
 MA4      C60    C50    H501    108.340    3.000
 MA4      C60    C50    C40     111.000    3.000
 MA4      C60    C50    O50     109.470    3.000
 MA4      H501   C50    C40     108.340    3.000
 MA4      H501   C50    O50     109.470    3.000
 MA4      C40    C50    O50     109.470    3.000
 MA4      C50    C40    H401    108.340    3.000
 MA4      C50    C40    C30     111.000    3.000
 MA4      C50    C40    O1      109.470    3.000
 MA4      H401   C40    C30     108.340    3.000
 MA4      H401   C40    O1      109.470    3.000
 MA4      C30    C40    O1      109.470    3.000
 MA4      C40    C30    H301    108.340    3.000
 MA4      C40    C30    O30     109.470    3.000
 MA4      C40    C30    C20     111.000    3.000
 MA4      H301   C30    O30     109.470    3.000
 MA4      H301   C30    C20     108.340    3.000
 MA4      O30    C30    C20     109.470    3.000
 MA4      C30    O30    HO30    109.470    3.000
 MA4      C30    C20    H201    108.340    3.000
 MA4      C30    C20    O20     109.470    3.000
 MA4      C30    C20    C10     111.000    3.000
 MA4      H201   C20    O20     109.470    3.000
 MA4      H201   C20    C10     108.340    3.000
 MA4      O20    C20    C10     109.470    3.000
 MA4      C20    O20    HO20    109.470    3.000
 MA4      C40    O1     C1      111.800    3.000
 MA4      O1     C1     H11     109.470    3.000
 MA4      O1     C1     O5      109.470    3.000
 MA4      O1     C1     C2      109.470    3.000
 MA4      H11    C1     O5      109.470    3.000
 MA4      H11    C1     C2      108.340    3.000
 MA4      O5     C1     C2      109.470    3.000
 MA4      C1     O5     C5      111.800    3.000
 MA4      O5     C5     H51     109.470    3.000
 MA4      O5     C5     C6      109.470    3.000
 MA4      O5     C5     C4      109.470    3.000
 MA4      H51    C5     C6      108.340    3.000
 MA4      H51    C5     C4      108.340    3.000
 MA4      C6     C5     C4      111.000    3.000
 MA4      C5     C6     H61     109.470    3.000
 MA4      C5     C6     H62     109.470    3.000
 MA4      C5     C6     O6      109.470    3.000
 MA4      H61    C6     H62     107.900    3.000
 MA4      H61    C6     O6      109.470    3.000
 MA4      H62    C6     O6      109.470    3.000
 MA4      C6     O6     HO6     109.470    3.000
 MA4      C5     C4     H41     108.340    3.000
 MA4      C5     C4     O4      109.470    3.000
 MA4      C5     C4     C3      111.000    3.000
 MA4      H41    C4     O4      109.470    3.000
 MA4      H41    C4     C3      108.340    3.000
 MA4      O4     C4     C3      109.470    3.000
 MA4      C4     O4     HO4     109.470    3.000
 MA4      C4     C3     H31     108.340    3.000
 MA4      C4     C3     O3      109.470    3.000
 MA4      C4     C3     C2      111.000    3.000
 MA4      H31    C3     O3      109.470    3.000
 MA4      H31    C3     C2      108.340    3.000
 MA4      O3     C3     C2      109.470    3.000
 MA4      C3     O3     HO3     109.470    3.000
 MA4      C3     C2     H21     108.340    3.000
 MA4      C3     C2     O2      109.470    3.000
 MA4      C3     C2     C1      111.000    3.000
 MA4      H21    C2     O2      109.470    3.000
 MA4      H21    C2     C1      108.340    3.000
 MA4      O2     C2     C1      109.470    3.000
 MA4      C2     O2     HO2     109.470    3.000
 MA4      C50    O50    C10     111.800    3.000
 MA4      O50    C10    H101    109.470    3.000
 MA4      O50    C10    O10     109.470    3.000
 MA4      O50    C10    C20     109.470    3.000
 MA4      H101   C10    O10     109.470    3.000
 MA4      H101   C10    C20     108.340    3.000
 MA4      O10    C10    C20     109.470    3.000
 MA4      C10    O10    C11     111.800    3.000
 MA4      O10    C11    H111    109.470    3.000
 MA4      O10    C11    H112    109.470    3.000
 MA4      O10    C11    C21     109.470    3.000
 MA4      H111   C11    H112    107.900    3.000
 MA4      H111   C11    C21     109.470    3.000
 MA4      H112   C11    C21     109.470    3.000
 MA4      C11    C21    H211    109.470    3.000
 MA4      C11    C21    H212    109.470    3.000
 MA4      C11    C21    C31     111.000    3.000
 MA4      H211   C21    H212    107.900    3.000
 MA4      H211   C21    C31     109.470    3.000
 MA4      H212   C21    C31     109.470    3.000
 MA4      C21    C31    H311    109.470    3.000
 MA4      C21    C31    H312    109.470    3.000
 MA4      C21    C31    C41     111.000    3.000
 MA4      H311   C31    H312    107.900    3.000
 MA4      H311   C31    C41     109.470    3.000
 MA4      H312   C31    C41     109.470    3.000
 MA4      C31    C41    H411    109.470    3.000
 MA4      C31    C41    H412    109.470    3.000
 MA4      C31    C41    C51     111.000    3.000
 MA4      H411   C41    H412    107.900    3.000
 MA4      H411   C41    C51     109.470    3.000
 MA4      H412   C41    C51     109.470    3.000
 MA4      C41    C51    H511    109.470    3.000
 MA4      C41    C51    H512    109.470    3.000
 MA4      C41    C51    C61     111.000    3.000
 MA4      H511   C51    H512    107.900    3.000
 MA4      H511   C51    C61     109.470    3.000
 MA4      H512   C51    C61     109.470    3.000
 MA4      C51    C61    H611    109.470    3.000
 MA4      C51    C61    H612    109.470    3.000
 MA4      C51    C61    C12     111.000    3.000
 MA4      H611   C61    H612    107.900    3.000
 MA4      H611   C61    C12     109.470    3.000
 MA4      H612   C61    C12     109.470    3.000
 MA4      C61    C12    H121    108.340    3.000
 MA4      C61    C12    C62     109.470    3.000
 MA4      C61    C12    C22     109.470    3.000
 MA4      H121   C12    C62     108.340    3.000
 MA4      H121   C12    C22     108.340    3.000
 MA4      C62    C12    C22     109.470    3.000
 MA4      C12    C62    H621    109.470    3.000
 MA4      C12    C62    H622    109.470    3.000
 MA4      C12    C62    C52     111.000    3.000
 MA4      H621   C62    H622    107.900    3.000
 MA4      H621   C62    C52     109.470    3.000
 MA4      H622   C62    C52     109.470    3.000
 MA4      C62    C52    H521    109.470    3.000
 MA4      C62    C52    H522    109.470    3.000
 MA4      C62    C52    C42     111.000    3.000
 MA4      H521   C52    H522    107.900    3.000
 MA4      H521   C52    C42     109.470    3.000
 MA4      H522   C52    C42     109.470    3.000
 MA4      C52    C42    H421    109.470    3.000
 MA4      C52    C42    H422    109.470    3.000
 MA4      C52    C42    C32     111.000    3.000
 MA4      H421   C42    H422    107.900    3.000
 MA4      H421   C42    C32     109.470    3.000
 MA4      H422   C42    C32     109.470    3.000
 MA4      C42    C32    H321    109.470    3.000
 MA4      C42    C32    H322    109.470    3.000
 MA4      C42    C32    C22     111.000    3.000
 MA4      H321   C32    H322    107.900    3.000
 MA4      H321   C32    C22     109.470    3.000
 MA4      H322   C32    C22     109.470    3.000
 MA4      C32    C22    H222    109.470    3.000
 MA4      C32    C22    H221    109.470    3.000
 MA4      C32    C22    C12     111.000    3.000
 MA4      H222   C22    H221    107.900    3.000
 MA4      H222   C22    C12     109.470    3.000
 MA4      H221   C22    C12     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MA4      var_1    HO60   O60    C60    C50     -179.989   20.000   1
 MA4      var_2    O60    C60    C50    O50       61.964   20.000   3
 MA4      var_3    C60    C50    C40    O1        60.000   20.000   3
 MA4      var_4    C50    C40    C30    C20       60.000   20.000   3
 MA4      var_5    C40    C30    O30    HO30     179.976   20.000   1
 MA4      var_6    C40    C30    C20    O20      180.000   20.000   3
 MA4      var_7    C30    C20    O20    HO20    -179.986   20.000   1
 MA4      var_8    C50    C40    O1     C1      -156.954   20.000   1
 MA4      var_9    C40    O1     C1     O5        77.172   20.000   1
 MA4      var_10   O1     C1     C2     C3       -60.000   20.000   3
 MA4      var_11   O1     C1     O5     C5        60.000   20.000   1
 MA4      var_12   C1     O5     C5     C4        60.000   20.000   1
 MA4      var_13   O5     C5     C6     O6        59.914   20.000   3
 MA4      var_14   C5     C6     O6     HO6     -179.949   20.000   1
 MA4      var_15   O5     C5     C4     C3       -60.000   20.000   3
 MA4      var_16   C5     C4     O4     HO4      179.509   20.000   1
 MA4      var_17   C5     C4     C3     C2        60.000   20.000   3
 MA4      var_18   C4     C3     O3     HO3     -179.216   20.000   1
 MA4      var_19   C4     C3     C2     O2       180.000   20.000   3
 MA4      var_20   C3     C2     O2     HO2      179.624   20.000   1
 MA4      var_21   C60    C50    O50    C10      180.000   20.000   1
 MA4      var_22   C50    O50    C10    O10      180.000   20.000   1
 MA4      var_23   O50    C10    C20    C30       60.000   20.000   3
 MA4      var_24   O50    C10    O10    C11      -59.621   20.000   1
 MA4      var_25   C10    O10    C11    C21     -179.997   20.000   1
 MA4      var_26   O10    C11    C21    C31      179.959   20.000   3
 MA4      var_27   C11    C21    C31    C41      179.945   20.000   3
 MA4      var_28   C21    C31    C41    C51      179.983   20.000   3
 MA4      var_29   C31    C41    C51    C61      180.000   20.000   3
 MA4      var_30   C41    C51    C61    C12     -179.983   20.000   3
 MA4      var_31   C51    C61    C12    C62      -60.000   20.000   3
 MA4      var_32   C61    C12    C22    C32      180.000   20.000   3
 MA4      var_33   C61    C12    C62    C52      180.000   20.000   3
 MA4      var_34   C12    C62    C52    C42       60.000   20.000   3
 MA4      var_35   C62    C52    C42    C32      -60.000   20.000   3
 MA4      var_36   C52    C42    C32    C22       60.000   20.000   3
 MA4      var_37   C42    C32    C22    C12      -60.000   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MA4      chir_01  C1     C2     O5     O1        positiv
 MA4      chir_02  C2     C1     C3     O2        negativ
 MA4      chir_03  C3     C2     C4     O3        positiv
 MA4      chir_04  C4     C3     C5     O4        negativ
 MA4      chir_05  C5     C4     C6     O5        negativ
 MA4      chir_06  C10    C20    O10    O50       positiv
 MA4      chir_07  C20    C10    C30    O20       negativ
 MA4      chir_08  C30    C20    C40    O30       positiv
 MA4      chir_09  C40    O1     C30    C50       negativ
 MA4      chir_10  C50    C40    C60    O50       negativ
 MA4      chir_11  C12    C61    C22    C62       negativ
# ------------------------------------------------------
`.trim();

monomers["TAR"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TAR      TAR 'D(-)-TARTARIC ACID                  ' non-polymer        14  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TAR
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TAR           O41    O    OC       -0.500      0.000    0.000    0.000
 TAR           C4     C    C         0.000     -1.126   -0.325   -0.438
 TAR           O4     O    OC       -0.500     -1.300   -1.458   -0.939
 TAR           C3     C    CH1       0.000     -2.274    0.650   -0.361
 TAR           H3     H    H         0.000     -1.987    1.592   -0.848
 TAR           O3     O    OH1       0.000     -3.412    0.098   -1.023
 TAR           HO3    H    H         0.000     -3.664   -0.731   -0.594
 TAR           C2     C    CH1       0.000     -2.617    0.918    1.105
 TAR           H2     H    H         0.000     -1.772    1.425    1.592
 TAR           O2     O    OH1       0.000     -2.876   -0.321    1.769
 TAR           HO2    H    H         0.000     -3.619   -0.767    1.340
 TAR           C1     C    C         0.000     -3.841    1.795    1.183
 TAR           O1     O    OC       -0.500     -4.898    1.351    1.684
 TAR           O11    O    OC       -0.500     -3.799    2.966    0.745
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TAR      O41    n/a    C4     START
 TAR      C4     O41    C3     .
 TAR      O4     C4     .      .
 TAR      C3     C4     C2     .
 TAR      H3     C3     .      .
 TAR      O3     C3     HO3    .
 TAR      HO3    O3     .      .
 TAR      C2     C3     C1     .
 TAR      H2     C2     .      .
 TAR      O2     C2     HO2    .
 TAR      HO2    O2     .      .
 TAR      C1     C2     O11    .
 TAR      O1     C1     .      .
 TAR      O11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TAR      O1     C1        deloc       1.250    0.020
 TAR      O11    C1        deloc       1.250    0.020
 TAR      C1     C2        single      1.500    0.020
 TAR      O2     C2        single      1.432    0.020
 TAR      C2     C3        single      1.524    0.020
 TAR      H2     C2        single      1.099    0.020
 TAR      HO2    O2        single      0.967    0.020
 TAR      O3     C3        single      1.432    0.020
 TAR      C3     C4        single      1.500    0.020
 TAR      H3     C3        single      1.099    0.020
 TAR      HO3    O3        single      0.967    0.020
 TAR      O4     C4        deloc       1.250    0.020
 TAR      C4     O41       deloc       1.250    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TAR      O41    C4     O4      123.000    3.000
 TAR      O41    C4     C3      118.500    3.000
 TAR      O4     C4     C3      118.500    3.000
 TAR      C4     C3     H3      108.810    3.000
 TAR      C4     C3     O3      109.470    3.000
 TAR      C4     C3     C2      109.470    3.000
 TAR      H3     C3     O3      109.470    3.000
 TAR      H3     C3     C2      108.340    3.000
 TAR      O3     C3     C2      109.470    3.000
 TAR      C3     O3     HO3     109.470    3.000
 TAR      C3     C2     H2      108.340    3.000
 TAR      C3     C2     O2      109.470    3.000
 TAR      C3     C2     C1      109.470    3.000
 TAR      H2     C2     O2      109.470    3.000
 TAR      H2     C2     C1      108.810    3.000
 TAR      O2     C2     C1      109.470    3.000
 TAR      C2     O2     HO2     109.470    3.000
 TAR      C2     C1     O1      118.500    3.000
 TAR      C2     C1     O11     118.500    3.000
 TAR      O1     C1     O11     123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TAR      var_1    O41    C4     C3     C2       -64.967   20.000   3
 TAR      var_2    C4     C3     O3     HO3       60.028   20.000   1
 TAR      var_3    C4     C3     C2     C1      -174.999   20.000   3
 TAR      var_4    C3     C2     O2     HO2      -59.979   20.000   1
 TAR      var_5    C3     C2     C1     O11      -64.967   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TAR      chir_01  C2     C1     O2     C3        negativ
 TAR      chir_02  C3     C2     O3     C4        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TAR      plan-1    C1        0.020
 TAR      plan-1    O1        0.020
 TAR      plan-1    O11       0.020
 TAR      plan-1    C2        0.020
 TAR      plan-2    C4        0.020
 TAR      plan-2    C3        0.020
 TAR      plan-2    O4        0.020
 TAR      plan-2    O41       0.020
# ------------------------------------------------------
`.trim();

monomers["MTL"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MTL      MTL 'D-MANNITOL                          ' non-polymer        26  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MTL
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MTL           O6     O    OH1       0.000      0.000    0.000    0.000
 MTL           HO6    H    H         0.000      0.576    0.000   -0.777
 MTL           C6     C    CH2       0.000     -1.365    0.000   -0.420
 MTL           H61    H    H         0.000     -1.560   -0.891   -1.021
 MTL           H62    H    H         0.000     -1.560    0.891   -1.021
 MTL           C5     C    CH1       0.000     -2.278    0.000    0.806
 MTL           H5     H    H         0.000     -2.081   -0.897    1.410
 MTL           O5     O    OH1       0.000     -2.022    1.166    1.591
 MTL           HO5    H    H         0.000     -2.196    1.955    1.060
 MTL           C4     C    CH1       0.000     -3.741    0.000    0.357
 MTL           H4     H    H         0.000     -3.938    0.897   -0.246
 MTL           O4     O    OH1       0.000     -3.997   -1.166   -0.427
 MTL           HO4    H    H         0.000     -3.823   -1.955    0.103
 MTL           C3     C    CH1       0.000     -4.652    0.000    1.583
 MTL           H3     H    H         0.000     -4.454    0.897    2.186
 MTL           O3     O    OH1       0.000     -4.395   -1.166    2.367
 MTL           HO3    H    H         0.000     -4.569   -1.955    1.837
 MTL           C2     C    CH1       0.000     -6.114    0.000    1.133
 MTL           H2     H    H         0.000     -6.311   -0.897    0.530
 MTL           O2     O    OH1       0.000     -6.370    1.166    0.349
 MTL           HO2    H    H         0.000     -6.197    1.955    0.880
 MTL           C1     C    CH2       0.000     -7.027    0.000    2.360
 MTL           H11    H    H         0.000     -6.829    0.891    2.960
 MTL           H12    H    H         0.000     -6.829   -0.891    2.960
 MTL           O1     O    OH1       0.000     -8.392    0.000    1.940
 MTL           HO1    H    H         0.000     -8.968    0.000    2.717
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MTL      O6     n/a    C6     START
 MTL      HO6    O6     .      .
 MTL      C6     O6     C5     .
 MTL      H61    C6     .      .
 MTL      H62    C6     .      .
 MTL      C5     C6     C4     .
 MTL      H5     C5     .      .
 MTL      O5     C5     HO5    .
 MTL      HO5    O5     .      .
 MTL      C4     C5     C3     .
 MTL      H4     C4     .      .
 MTL      O4     C4     HO4    .
 MTL      HO4    O4     .      .
 MTL      C3     C4     C2     .
 MTL      H3     C3     .      .
 MTL      O3     C3     HO3    .
 MTL      HO3    O3     .      .
 MTL      C2     C3     C1     .
 MTL      H2     C2     .      .
 MTL      O2     C2     HO2    .
 MTL      HO2    O2     .      .
 MTL      C1     C2     O1     .
 MTL      H11    C1     .      .
 MTL      H12    C1     .      .
 MTL      O1     C1     HO1    .
 MTL      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MTL      O1     C1        single      1.432    0.020
 MTL      HO1    O1        single      0.967    0.020
 MTL      C1     C2        single      1.524    0.020
 MTL      H11    C1        single      1.092    0.020
 MTL      H12    C1        single      1.092    0.020
 MTL      O2     C2        single      1.432    0.020
 MTL      C2     C3        single      1.524    0.020
 MTL      H2     C2        single      1.099    0.020
 MTL      HO2    O2        single      0.967    0.020
 MTL      O3     C3        single      1.432    0.020
 MTL      C3     C4        single      1.524    0.020
 MTL      H3     C3        single      1.099    0.020
 MTL      HO3    O3        single      0.967    0.020
 MTL      O4     C4        single      1.432    0.020
 MTL      C4     C5        single      1.524    0.020
 MTL      H4     C4        single      1.099    0.020
 MTL      HO4    O4        single      0.967    0.020
 MTL      O5     C5        single      1.432    0.020
 MTL      C5     C6        single      1.524    0.020
 MTL      H5     C5        single      1.099    0.020
 MTL      HO5    O5        single      0.967    0.020
 MTL      C6     O6        single      1.432    0.020
 MTL      H61    C6        single      1.092    0.020
 MTL      H62    C6        single      1.092    0.020
 MTL      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MTL      HO6    O6     C6      109.470    3.000
 MTL      O6     C6     H61     109.470    3.000
 MTL      O6     C6     H62     109.470    3.000
 MTL      O6     C6     C5      109.470    3.000
 MTL      H61    C6     H62     107.900    3.000
 MTL      H61    C6     C5      109.470    3.000
 MTL      H62    C6     C5      109.470    3.000
 MTL      C6     C5     H5      108.340    3.000
 MTL      C6     C5     O5      109.470    3.000
 MTL      C6     C5     C4      111.000    3.000
 MTL      H5     C5     O5      109.470    3.000
 MTL      H5     C5     C4      108.340    3.000
 MTL      O5     C5     C4      109.470    3.000
 MTL      C5     O5     HO5     109.470    3.000
 MTL      C5     C4     H4      108.340    3.000
 MTL      C5     C4     O4      109.470    3.000
 MTL      C5     C4     C3      111.000    3.000
 MTL      H4     C4     O4      109.470    3.000
 MTL      H4     C4     C3      108.340    3.000
 MTL      O4     C4     C3      109.470    3.000
 MTL      C4     O4     HO4     109.470    3.000
 MTL      C4     C3     H3      108.340    3.000
 MTL      C4     C3     O3      109.470    3.000
 MTL      C4     C3     C2      111.000    3.000
 MTL      H3     C3     O3      109.470    3.000
 MTL      H3     C3     C2      108.340    3.000
 MTL      O3     C3     C2      109.470    3.000
 MTL      C3     O3     HO3     109.470    3.000
 MTL      C3     C2     H2      108.340    3.000
 MTL      C3     C2     O2      109.470    3.000
 MTL      C3     C2     C1      111.000    3.000
 MTL      H2     C2     O2      109.470    3.000
 MTL      H2     C2     C1      108.340    3.000
 MTL      O2     C2     C1      109.470    3.000
 MTL      C2     O2     HO2     109.470    3.000
 MTL      C2     C1     H11     109.470    3.000
 MTL      C2     C1     H12     109.470    3.000
 MTL      C2     C1     O1      109.470    3.000
 MTL      H11    C1     H12     107.900    3.000
 MTL      H11    C1     O1      109.470    3.000
 MTL      H12    C1     O1      109.470    3.000
 MTL      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MTL      var_1    HO6    O6     C6     C5       180.000   20.000   1
 MTL      var_2    O6     C6     C5     C4       180.000   20.000   3
 MTL      var_3    C6     C5     O5     HO5       60.043   20.000   1
 MTL      var_4    C6     C5     C4     C3       180.000   20.000   3
 MTL      var_5    C5     C4     O4     HO4       60.045   20.000   1
 MTL      var_6    C5     C4     C3     C2       180.000   20.000   3
 MTL      var_7    C4     C3     O3     HO3      -60.000   20.000   1
 MTL      var_8    C4     C3     C2     C1       180.000   20.000   3
 MTL      var_9    C3     C2     O2     HO2      -60.045   20.000   1
 MTL      var_10   C3     C2     C1     O1       180.000   20.000   3
 MTL      var_11   C2     C1     O1     HO1      180.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MTL      chir_01  C2     C1     O2     C3        negativ
 MTL      chir_02  C3     C2     O3     C4        negativ
 MTL      chir_03  C4     C3     O4     C5        positiv
 MTL      chir_04  C5     C4     O5     C6        positiv
# ------------------------------------------------------
`.trim();

monomers["DPR"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DPR      DPR 'D-PROLINE                           ' P-peptide          16   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DPR
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DPR           OXT    O    OC       -0.500      0.000    0.000    0.000
 DPR           C      C    C         0.000     -0.357    0.127   -1.192
 DPR           O      O    OC       -0.500     -0.992   -0.739   -1.834
 DPR           CA     C    CH1       0.000      0.077    1.448   -1.734
 DPR           HA     H    H         0.000     -0.372    2.267   -1.155
 DPR           CB     C    CH2       0.000      1.595    1.590   -1.770
 DPR           HB2    H    H         0.000      2.093    0.723   -1.332
 DPR           HB3    H    H         0.000      1.930    2.496   -1.261
 DPR           CG     C    CH2       0.000      1.937    1.680   -3.249
 DPR           HG2    H    H         0.000      2.177    0.707   -3.682
 DPR           HG3    H    H         0.000      2.755    2.377   -3.446
 DPR           CD     C    CH2       0.000      0.661    2.209   -3.869
 DPR           HD2    H    H         0.000      0.577    1.970   -4.931
 DPR           HD3    H    H         0.000      0.537    3.285   -3.729
 DPR           N      N    NH1       0.000     -0.373    1.498   -3.125
 DPR           H      H    H         0.000     -1.231    1.115   -3.498
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DPR      N      n/a    CA     START
 DPR      H      N      .      .
 DPR      CD     N      CG     .
 DPR      HD2    CD     .      .
 DPR      HD3    CD     .      .
 DPR      CG     CD     CB     .
 DPR      HG2    CG     .      .
 DPR      HG3    CG     .      .
 DPR      CB     CG     HB2    .
 DPR      HB3    CB     .      .
 DPR      HB2    CB     .      .
 DPR      CA     N      C      .
 DPR      HA     CA     .      .
 DPR      C      CA     OXT    .
 DPR      O      C      .      .
 DPR      OXT    C      .      END
 DPR      CA     CB     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DPR      N      CA        single      1.450    0.020
 DPR      N      CD        single      1.450    0.020
 DPR      H      N         single      1.010    0.020
 DPR      CB     CA        single      1.524    0.020
 DPR      CA     C         single      1.500    0.020
 DPR      HA     CA        single      1.099    0.020
 DPR      CG     CB        single      1.524    0.020
 DPR      HB2    CB        single      1.092    0.020
 DPR      HB3    CB        single      1.092    0.020
 DPR      CD     CG        single      1.524    0.020
 DPR      HG2    CG        single      1.092    0.020
 DPR      HG3    CG        single      1.092    0.020
 DPR      HD2    CD        single      1.092    0.020
 DPR      HD3    CD        single      1.092    0.020
 DPR      O      C         deloc       1.250    0.020
 DPR      C      OXT       deloc       1.250    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DPR      OXT    C      O       123.000    3.000
 DPR      OXT    C      CA      118.500    3.000
 DPR      O      C      CA      118.500    3.000
 DPR      C      CA     HA      108.810    3.000
 DPR      C      CA     CB      109.470    3.000
 DPR      C      CA     N       111.600    3.000
 DPR      HA     CA     CB      108.340    3.000
 DPR      HA     CA     N       108.550    3.000
 DPR      CB     CA     N       110.000    3.000
 DPR      CA     CB     HB2     109.470    3.000
 DPR      CA     CB     HB3     109.470    3.000
 DPR      CA     CB     CG      111.000    3.000
 DPR      HB2    CB     HB3     107.900    3.000
 DPR      HB2    CB     CG      109.470    3.000
 DPR      HB3    CB     CG      109.470    3.000
 DPR      CB     CG     HG2     109.470    3.000
 DPR      CB     CG     HG3     109.470    3.000
 DPR      CB     CG     CD      111.000    3.000
 DPR      HG2    CG     HG3     107.900    3.000
 DPR      HG2    CG     CD      109.470    3.000
 DPR      HG3    CG     CD      109.470    3.000
 DPR      CG     CD     HD2     109.470    3.000
 DPR      CG     CD     HD3     109.470    3.000
 DPR      CG     CD     N       112.000    3.000
 DPR      HD2    CD     HD3     107.900    3.000
 DPR      HD2    CD     N       109.470    3.000
 DPR      HD3    CD     N       109.470    3.000
 DPR      CD     N      H       118.500    3.000
 DPR      CD     N      CA      120.000    3.000
 DPR      H      N      CA      118.500    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DPR      var_1    OXT    C      CA     CB        63.508   20.000   3
 DPR      var_2    C      CA     CB     CG       120.000   20.000   3
 DPR      var_3    CA     CB     CG     CD        30.000   20.000   3
 DPR      var_4    CB     CG     CD     N        -30.000   20.000   3
 DPR      var_5    CG     CD     N      CA        30.000   20.000   3
 DPR      var_6    CD     N      CA     C       -150.000   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DPR      chir_01  CA     N      CB     C         positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DPR      plan-1    N         0.020
 DPR      plan-1    CA        0.020
 DPR      plan-1    CD        0.020
 DPR      plan-1    H         0.020
 DPR      plan-2    C         0.020
 DPR      plan-2    CA        0.020
 DPR      plan-2    O         0.020
 DPR      plan-2    OXT       0.020
# ------------------------------------------------------
`.trim();

monomers["SOR"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SOR      SOR 'D-SORBITOL                          ' non-polymer        26  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SOR
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SOR           O6     O    OH1       0.000      0.000    0.000    0.000
 SOR           HO6    H    H         0.000      0.594    0.319   -0.693
 SOR           C6     C    CH2       0.000     -1.328    0.454   -0.267
 SOR           H61    H    H         0.000     -1.655    0.069   -1.235
 SOR           H62    H    H         0.000     -1.341    1.545   -0.287
 SOR           C5     C    CH1       0.000     -2.269   -0.049    0.827
 SOR           H5     H    H         0.000     -2.255   -1.147    0.846
 SOR           O5     O    OH1       0.000     -1.840    0.454    2.094
 SOR           HO5    H    H         0.000     -1.852    1.421    2.078
 SOR           C4     C    CH1       0.000     -3.692    0.437    0.542
 SOR           H4     H    H         0.000     -3.706    1.535    0.524
 SOR           O4     O    OH1       0.000     -4.121   -0.066   -0.724
 SOR           HO4    H    H         0.000     -4.108   -1.032   -0.708
 SOR           C3     C    CH1       0.000     -4.633   -0.067    1.636
 SOR           H3     H    H         0.000     -4.302    0.320    2.611
 SOR           O3     O    OH1       0.000     -4.614   -1.495    1.660
 SOR           HO3    H    H         0.000     -4.905   -1.834    0.803
 SOR           C2     C    CH1       0.000     -6.054    0.420    1.351
 SOR           H2     H    H         0.000     -6.068    1.518    1.333
 SOR           O2     O    OH1       0.000     -6.484   -0.083    0.085
 SOR           HO2    H    H         0.000     -6.471   -1.049    0.101
 SOR           C1     C    CH2       0.000     -6.997   -0.084    2.446
 SOR           H11    H    H         0.000     -6.667    0.301    3.413
 SOR           H12    H    H         0.000     -6.980   -1.175    2.464
 SOR           O1     O    OH1       0.000     -8.325    0.370    2.178
 SOR           HO1    H    H         0.000     -8.919    0.052    2.871
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SOR      O6     n/a    C6     START
 SOR      HO6    O6     .      .
 SOR      C6     O6     C5     .
 SOR      H61    C6     .      .
 SOR      H62    C6     .      .
 SOR      C5     C6     C4     .
 SOR      H5     C5     .      .
 SOR      O5     C5     HO5    .
 SOR      HO5    O5     .      .
 SOR      C4     C5     C3     .
 SOR      H4     C4     .      .
 SOR      O4     C4     HO4    .
 SOR      HO4    O4     .      .
 SOR      C3     C4     C2     .
 SOR      H3     C3     .      .
 SOR      O3     C3     HO3    .
 SOR      HO3    O3     .      .
 SOR      C2     C3     C1     .
 SOR      H2     C2     .      .
 SOR      O2     C2     HO2    .
 SOR      HO2    O2     .      .
 SOR      C1     C2     O1     .
 SOR      H11    C1     .      .
 SOR      H12    C1     .      .
 SOR      O1     C1     HO1    .
 SOR      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SOR      C1     C2        single      1.524    0.020
 SOR      O1     C1        single      1.432    0.020
 SOR      H11    C1        single      1.092    0.020
 SOR      H12    C1        single      1.092    0.020
 SOR      C2     C3        single      1.524    0.020
 SOR      O2     C2        single      1.432    0.020
 SOR      H2     C2        single      1.099    0.020
 SOR      C3     C4        single      1.524    0.020
 SOR      O3     C3        single      1.432    0.020
 SOR      H3     C3        single      1.099    0.020
 SOR      C4     C5        single      1.524    0.020
 SOR      O4     C4        single      1.432    0.020
 SOR      H4     C4        single      1.099    0.020
 SOR      C5     C6        single      1.524    0.020
 SOR      O5     C5        single      1.432    0.020
 SOR      H5     C5        single      1.099    0.020
 SOR      C6     O6        single      1.432    0.020
 SOR      H61    C6        single      1.092    0.020
 SOR      H62    C6        single      1.092    0.020
 SOR      HO1    O1        single      0.967    0.020
 SOR      HO2    O2        single      0.967    0.020
 SOR      HO3    O3        single      0.967    0.020
 SOR      HO4    O4        single      0.967    0.020
 SOR      HO5    O5        single      0.967    0.020
 SOR      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SOR      HO6    O6     C6      109.470    3.000
 SOR      O6     C6     H61     109.470    3.000
 SOR      O6     C6     H62     109.470    3.000
 SOR      O6     C6     C5      109.470    3.000
 SOR      H61    C6     H62     107.900    3.000
 SOR      H61    C6     C5      109.470    3.000
 SOR      H62    C6     C5      109.470    3.000
 SOR      C6     C5     H5      108.340    3.000
 SOR      C6     C5     O5      109.470    3.000
 SOR      C6     C5     C4      111.000    3.000
 SOR      H5     C5     O5      109.470    3.000
 SOR      H5     C5     C4      108.340    3.000
 SOR      O5     C5     C4      109.470    3.000
 SOR      C5     O5     HO5     109.470    3.000
 SOR      C5     C4     H4      108.340    3.000
 SOR      C5     C4     O4      109.470    3.000
 SOR      C5     C4     C3      111.000    3.000
 SOR      H4     C4     O4      109.470    3.000
 SOR      H4     C4     C3      108.340    3.000
 SOR      O4     C4     C3      109.470    3.000
 SOR      C4     O4     HO4     109.470    3.000
 SOR      C4     C3     H3      108.340    3.000
 SOR      C4     C3     O3      109.470    3.000
 SOR      C4     C3     C2      111.000    3.000
 SOR      H3     C3     O3      109.470    3.000
 SOR      H3     C3     C2      108.340    3.000
 SOR      O3     C3     C2      109.470    3.000
 SOR      C3     O3     HO3     109.470    3.000
 SOR      C3     C2     H2      108.340    3.000
 SOR      C3     C2     O2      109.470    3.000
 SOR      C3     C2     C1      111.000    3.000
 SOR      H2     C2     O2      109.470    3.000
 SOR      H2     C2     C1      108.340    3.000
 SOR      O2     C2     C1      109.470    3.000
 SOR      C2     O2     HO2     109.470    3.000
 SOR      C2     C1     H11     109.470    3.000
 SOR      C2     C1     H12     109.470    3.000
 SOR      C2     C1     O1      109.470    3.000
 SOR      H11    C1     H12     107.900    3.000
 SOR      H11    C1     O1      109.470    3.000
 SOR      H12    C1     O1      109.470    3.000
 SOR      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 SOR      var_1    HO6    O6     C6     C5      -179.967   20.000   1
 SOR      var_2    O6     C6     C5     C4      -179.988   20.000   3
 SOR      var_3    C6     C5     O5     HO5       60.044   20.000   1
 SOR      var_4    C6     C5     C4     C3       179.967   20.000   3
 SOR      var_5    C5     C4     O4     HO4       60.102   20.000   1
 SOR      var_6    C5     C4     C3     C2       179.964   20.000   3
 SOR      var_7    C4     C3     O3     HO3      -60.030   20.000   1
 SOR      var_8    C4     C3     C2     C1       179.997   20.000   3
 SOR      var_9    C3     C2     O2     HO2       60.050   20.000   1
 SOR      var_10   C3     C2     C1     O1      -179.953   20.000   3
 SOR      var_11   C2     C1     O1     HO1     -179.964   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 SOR      chir_01  C2     C1     C3     O2        negativ
 SOR      chir_02  C3     C2     C4     O3        positiv
 SOR      chir_03  C4     C3     C5     O4        negativ
 SOR      chir_04  C5     C4     C6     O5        negativ
# ------------------------------------------------------
`.trim();

monomers["DDQ"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DDQ      DDQ 'DECYLAMINE-N,N-DIMETHYL-N-OXIDE     ' non-polymer        41  14 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DDQ
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DDQ           O1     O    O        -1.000      0.000    0.000    0.000
 DDQ           N1     N    NT        1.000     -0.568    0.736   -1.130
 DDQ           CM1    C    CH3       0.000     -0.705   -0.165   -2.282
 DDQ           HM13   H    H         0.000      0.247   -0.542   -2.550
 DDQ           HM12   H    H         0.000     -1.345   -0.969   -2.027
 DDQ           HM11   H    H         0.000     -1.117    0.368   -3.099
 DDQ           CM2    C    CH3       0.000      0.320    1.851   -1.484
 DDQ           HM23   H    H         0.000      1.272    1.473   -1.752
 DDQ           HM22   H    H         0.000     -0.091    2.384   -2.302
 DDQ           HM21   H    H         0.000      0.419    2.501   -0.654
 DDQ           C1     C    CH2       0.000     -1.889    1.261   -0.758
 DDQ           H11    H    H         0.000     -2.312    1.811   -1.601
 DDQ           H12    H    H         0.000     -1.786    1.931    0.098
 DDQ           C2     C    CH2       0.000     -2.813    0.099   -0.390
 DDQ           H21    H    H         0.000     -2.388   -0.451    0.452
 DDQ           H22    H    H         0.000     -2.914   -0.571   -1.247
 DDQ           C3     C    CH2       0.000     -4.189    0.645   -0.003
 DDQ           H31    H    H         0.000     -4.612    1.195   -0.846
 DDQ           H32    H    H         0.000     -4.086    1.316    0.853
 DDQ           C4     C    CH2       0.000     -5.115   -0.516    0.367
 DDQ           H41    H    H         0.000     -4.690   -1.065    1.209
 DDQ           H42    H    H         0.000     -5.216   -1.186   -0.490
 DDQ           C5     C    CH2       0.000     -6.490    0.030    0.754
 DDQ           H51    H    H         0.000     -6.912    0.581   -0.090
 DDQ           H52    H    H         0.000     -6.387    0.701    1.609
 DDQ           C6     C    CH2       0.000     -7.415   -1.132    1.122
 DDQ           H61    H    H         0.000     -6.990   -1.682    1.964
 DDQ           H62    H    H         0.000     -7.516   -1.801    0.265
 DDQ           C7     C    CH2       0.000     -8.791   -0.584    1.509
 DDQ           H71    H    H         0.000     -9.214   -0.035    0.666
 DDQ           H72    H    H         0.000     -8.688    0.086    2.365
 DDQ           C8     C    CH2       0.000     -9.715   -1.746    1.878
 DDQ           H81    H    H         0.000     -9.290   -2.296    2.721
 DDQ           H82    H    H         0.000     -9.816   -2.417    1.022
 DDQ           C9     C    CH2       0.000    -11.091   -1.200    2.265
 DDQ           H91    H    H         0.000    -11.514   -0.650    1.422
 DDQ           H92    H    H         0.000    -10.989   -0.530    3.121
 DDQ           C10    C    CH3       0.000    -12.016   -2.362    2.633
 DDQ           H103   H    H         0.000    -11.607   -2.898    3.452
 DDQ           H102   H    H         0.000    -12.971   -1.987    2.902
 DDQ           H101   H    H         0.000    -12.117   -3.014    1.804
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DDQ      O1     n/a    N1     START
 DDQ      N1     O1     C1     .
 DDQ      CM1    N1     HM11   .
 DDQ      HM13   CM1    .      .
 DDQ      HM12   CM1    .      .
 DDQ      HM11   CM1    .      .
 DDQ      CM2    N1     HM21   .
 DDQ      HM23   CM2    .      .
 DDQ      HM22   CM2    .      .
 DDQ      HM21   CM2    .      .
 DDQ      C1     N1     C2     .
 DDQ      H11    C1     .      .
 DDQ      H12    C1     .      .
 DDQ      C2     C1     C3     .
 DDQ      H21    C2     .      .
 DDQ      H22    C2     .      .
 DDQ      C3     C2     C4     .
 DDQ      H31    C3     .      .
 DDQ      H32    C3     .      .
 DDQ      C4     C3     C5     .
 DDQ      H41    C4     .      .
 DDQ      H42    C4     .      .
 DDQ      C5     C4     C6     .
 DDQ      H51    C5     .      .
 DDQ      H52    C5     .      .
 DDQ      C6     C5     C7     .
 DDQ      H61    C6     .      .
 DDQ      H62    C6     .      .
 DDQ      C7     C6     C8     .
 DDQ      H71    C7     .      .
 DDQ      H72    C7     .      .
 DDQ      C8     C7     C9     .
 DDQ      H81    C8     .      .
 DDQ      H82    C8     .      .
 DDQ      C9     C8     C10    .
 DDQ      H91    C9     .      .
 DDQ      H92    C9     .      .
 DDQ      C10    C9     H101   .
 DDQ      H103   C10    .      .
 DDQ      H102   C10    .      .
 DDQ      H101   C10    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DDQ      N1     O1        single      1.250    0.020
 DDQ      CM1    N1        single      1.469    0.020
 DDQ      CM2    N1        single      1.469    0.020
 DDQ      C1     N1        single      1.469    0.020
 DDQ      HM11   CM1       single      1.059    0.020
 DDQ      HM12   CM1       single      1.059    0.020
 DDQ      HM13   CM1       single      1.059    0.020
 DDQ      HM21   CM2       single      1.059    0.020
 DDQ      HM22   CM2       single      1.059    0.020
 DDQ      HM23   CM2       single      1.059    0.020
 DDQ      C2     C1        single      1.524    0.020
 DDQ      H11    C1        single      1.092    0.020
 DDQ      H12    C1        single      1.092    0.020
 DDQ      C3     C2        single      1.524    0.020
 DDQ      H21    C2        single      1.092    0.020
 DDQ      H22    C2        single      1.092    0.020
 DDQ      C4     C3        single      1.524    0.020
 DDQ      H31    C3        single      1.092    0.020
 DDQ      H32    C3        single      1.092    0.020
 DDQ      C5     C4        single      1.524    0.020
 DDQ      H41    C4        single      1.092    0.020
 DDQ      H42    C4        single      1.092    0.020
 DDQ      C6     C5        single      1.524    0.020
 DDQ      H51    C5        single      1.092    0.020
 DDQ      H52    C5        single      1.092    0.020
 DDQ      C7     C6        single      1.524    0.020
 DDQ      H61    C6        single      1.092    0.020
 DDQ      H62    C6        single      1.092    0.020
 DDQ      C8     C7        single      1.524    0.020
 DDQ      H71    C7        single      1.092    0.020
 DDQ      H72    C7        single      1.092    0.020
 DDQ      C9     C8        single      1.524    0.020
 DDQ      H81    C8        single      1.092    0.020
 DDQ      H82    C8        single      1.092    0.020
 DDQ      C10    C9        single      1.513    0.020
 DDQ      H91    C9        single      1.092    0.020
 DDQ      H92    C9        single      1.092    0.020
 DDQ      H101   C10       single      1.059    0.020
 DDQ      H102   C10       single      1.059    0.020
 DDQ      H103   C10       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DDQ      O1     N1     CM1     109.500    3.000
 DDQ      O1     N1     CM2     109.500    3.000
 DDQ      O1     N1     C1      109.500    3.000
 DDQ      CM1    N1     CM2     109.470    3.000
 DDQ      CM1    N1     C1      109.470    3.000
 DDQ      CM2    N1     C1      109.470    3.000
 DDQ      N1     CM1    HM13    109.470    3.000
 DDQ      N1     CM1    HM12    109.470    3.000
 DDQ      N1     CM1    HM11    109.470    3.000
 DDQ      HM13   CM1    HM12    109.470    3.000
 DDQ      HM13   CM1    HM11    109.470    3.000
 DDQ      HM12   CM1    HM11    109.470    3.000
 DDQ      N1     CM2    HM23    109.470    3.000
 DDQ      N1     CM2    HM22    109.470    3.000
 DDQ      N1     CM2    HM21    109.470    3.000
 DDQ      HM23   CM2    HM22    109.470    3.000
 DDQ      HM23   CM2    HM21    109.470    3.000
 DDQ      HM22   CM2    HM21    109.470    3.000
 DDQ      N1     C1     H11     109.470    3.000
 DDQ      N1     C1     H12     109.470    3.000
 DDQ      N1     C1     C2      109.470    3.000
 DDQ      H11    C1     H12     107.900    3.000
 DDQ      H11    C1     C2      109.470    3.000
 DDQ      H12    C1     C2      109.470    3.000
 DDQ      C1     C2     H21     109.470    3.000
 DDQ      C1     C2     H22     109.470    3.000
 DDQ      C1     C2     C3      111.000    3.000
 DDQ      H21    C2     H22     107.900    3.000
 DDQ      H21    C2     C3      109.470    3.000
 DDQ      H22    C2     C3      109.470    3.000
 DDQ      C2     C3     H31     109.470    3.000
 DDQ      C2     C3     H32     109.470    3.000
 DDQ      C2     C3     C4      111.000    3.000
 DDQ      H31    C3     H32     107.900    3.000
 DDQ      H31    C3     C4      109.470    3.000
 DDQ      H32    C3     C4      109.470    3.000
 DDQ      C3     C4     H41     109.470    3.000
 DDQ      C3     C4     H42     109.470    3.000
 DDQ      C3     C4     C5      111.000    3.000
 DDQ      H41    C4     H42     107.900    3.000
 DDQ      H41    C4     C5      109.470    3.000
 DDQ      H42    C4     C5      109.470    3.000
 DDQ      C4     C5     H51     109.470    3.000
 DDQ      C4     C5     H52     109.470    3.000
 DDQ      C4     C5     C6      111.000    3.000
 DDQ      H51    C5     H52     107.900    3.000
 DDQ      H51    C5     C6      109.470    3.000
 DDQ      H52    C5     C6      109.470    3.000
 DDQ      C5     C6     H61     109.470    3.000
 DDQ      C5     C6     H62     109.470    3.000
 DDQ      C5     C6     C7      111.000    3.000
 DDQ      H61    C6     H62     107.900    3.000
 DDQ      H61    C6     C7      109.470    3.000
 DDQ      H62    C6     C7      109.470    3.000
 DDQ      C6     C7     H71     109.470    3.000
 DDQ      C6     C7     H72     109.470    3.000
 DDQ      C6     C7     C8      111.000    3.000
 DDQ      H71    C7     H72     107.900    3.000
 DDQ      H71    C7     C8      109.470    3.000
 DDQ      H72    C7     C8      109.470    3.000
 DDQ      C7     C8     H81     109.470    3.000
 DDQ      C7     C8     H82     109.470    3.000
 DDQ      C7     C8     C9      111.000    3.000
 DDQ      H81    C8     H82     107.900    3.000
 DDQ      H81    C8     C9      109.470    3.000
 DDQ      H82    C8     C9      109.470    3.000
 DDQ      C8     C9     H91     109.470    3.000
 DDQ      C8     C9     H92     109.470    3.000
 DDQ      C8     C9     C10     111.000    3.000
 DDQ      H91    C9     H92     107.900    3.000
 DDQ      H91    C9     C10     109.470    3.000
 DDQ      H92    C9     C10     109.470    3.000
 DDQ      C9     C10    H103    109.470    3.000
 DDQ      C9     C10    H102    109.470    3.000
 DDQ      C9     C10    H101    109.470    3.000
 DDQ      H103   C10    H102    109.470    3.000
 DDQ      H103   C10    H101    109.470    3.000
 DDQ      H102   C10    H101    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DDQ      var_1    O1     N1     CM1    HM11     179.950   20.000   1
 DDQ      var_2    O1     N1     CM2    HM21     -60.007   20.000   1
 DDQ      var_3    O1     N1     C1     C2       -60.032   20.000   1
 DDQ      var_4    N1     C1     C2     C3      -179.998   20.000   3
 DDQ      var_5    C1     C2     C3     C4      -179.960   20.000   3
 DDQ      var_6    C2     C3     C4     C5       180.000   20.000   3
 DDQ      var_7    C3     C4     C5     C6       179.960   20.000   3
 DDQ      var_8    C4     C5     C6     C7      -180.000   20.000   3
 DDQ      var_9    C5     C6     C7     C8      -179.960   20.000   3
 DDQ      var_10   C6     C7     C8     C9       180.000   20.000   3
 DDQ      var_11   C7     C8     C9     C10      179.960   20.000   3
 DDQ      var_12   C8     C9     C10    H101     -59.987   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 DDQ      chir_01  N1     O1     CM1    CM2       positiv
# ------------------------------------------------------
`.trim();

monomers["DMF"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DMF      DMF 'DIMETHYLFORMAMIDE                   ' non-polymer        12   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DMF
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DMF           O      O    O         0.000      0.000    0.000    0.000
 DMF           C      C    C1        0.000     -1.212    0.000   -0.056
 DMF           HC     H    H         0.000     -1.707    0.000   -1.012
 DMF           N      N    N         0.000     -1.938    0.000    1.079
 DMF           C2     C    CH3       0.000     -1.265    0.000    2.379
 DMF           H23    H    H         0.000     -1.546    0.865    2.924
 DMF           H22    H    H         0.000     -1.546   -0.865    2.924
 DMF           H21    H    H         0.000     -0.215    0.000    2.236
 DMF           C1     C    CH3       0.000     -3.401    0.000    1.011
 DMF           H13    H    H         0.000     -3.803    0.000    1.992
 DMF           H12    H    H         0.000     -3.733    0.865    0.496
 DMF           H11    H    H         0.000     -3.733   -0.865    0.496
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DMF      O      n/a    C      START
 DMF      C      O      N      .
 DMF      HC     C      .      .
 DMF      N      C      C1     .
 DMF      C2     N      H21    .
 DMF      H23    C2     .      .
 DMF      H22    C2     .      .
 DMF      H21    C2     .      .
 DMF      C1     N      H11    .
 DMF      H13    C1     .      .
 DMF      H12    C1     .      .
 DMF      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DMF      C1     N         single      1.455    0.020
 DMF      H11    C1        single      1.059    0.020
 DMF      H12    C1        single      1.059    0.020
 DMF      H13    C1        single      1.059    0.020
 DMF      C2     N         single      1.455    0.020
 DMF      H21    C2        single      1.059    0.020
 DMF      H22    C2        single      1.059    0.020
 DMF      H23    C2        single      1.059    0.020
 DMF      C      O         double      1.220    0.020
 DMF      N      C         single      1.260    0.020
 DMF      HC     C         single      1.077    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DMF      O      C      HC      123.000    3.000
 DMF      O      C      N       120.000    3.000
 DMF      HC     C      N       120.000    3.000
 DMF      C      N      C2      120.000    3.000
 DMF      C      N      C1      120.000    3.000
 DMF      C2     N      C1      120.000    3.000
 DMF      N      C2     H23     109.470    3.000
 DMF      N      C2     H22     109.470    3.000
 DMF      N      C2     H21     109.470    3.000
 DMF      H23    C2     H22     109.470    3.000
 DMF      H23    C2     H21     109.470    3.000
 DMF      H22    C2     H21     109.470    3.000
 DMF      N      C1     H13     109.470    3.000
 DMF      N      C1     H12     109.470    3.000
 DMF      N      C1     H11     109.470    3.000
 DMF      H13    C1     H12     109.470    3.000
 DMF      H13    C1     H11     109.470    3.000
 DMF      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DMF      var_1    O      C      N      C1       180.000   20.000   1
 DMF      var_2    C      N      C2     H21        0.000   20.000   1
 DMF      var_3    C      N      C1     H11       60.002   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DMF      plan-1    C         0.020
 DMF      plan-1    O         0.020
 DMF      plan-1    N         0.020
 DMF      plan-1    HC        0.020
 DMF      plan-2    N         0.020
 DMF      plan-2    C1        0.020
 DMF      plan-2    C2        0.020
 DMF      plan-2    C         0.020
 DMF      plan-2    HC        0.020
# ------------------------------------------------------
`.trim();

monomers["DIO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DIO      DIO '1,4-DIETHYLENE DIOXIDE              ' non-polymer        14   6 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DIO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DIO           "H2'2" H    H         0.000      0.001    0.002   -0.002
 DIO           "C2'"  C    CH2       0.000     -1.035   -0.315    0.128
 DIO           "H2'1" H    H         0.000     -1.086   -1.406    0.103
 DIO           "O1'"  O    O2        0.000     -1.830    0.220   -0.929
 DIO           "C1'"  C    CH2       0.000     -3.163   -0.248   -0.727
 DIO           "H1'2" H    H         0.000     -3.167   -1.340   -0.734
 DIO           "H1'1" H    H         0.000     -3.802    0.122   -1.531
 DIO           C2     C    CH2       0.000     -1.559    0.189    1.472
 DIO           H21    H    H         0.000     -1.551    1.281    1.476
 DIO           H22    H    H         0.000     -0.916   -0.181    2.273
 DIO           O1     O    O2        0.000     -2.892   -0.279    1.675
 DIO           C1     C    CH2       0.000     -3.687    0.257    0.617
 DIO           H12    H    H         0.000     -3.635    1.347    0.643
 DIO           H11    H    H         0.000     -4.723   -0.061    0.747
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DIO      "H2'2" n/a    "C2'"  START
 DIO      "C2'"  "H2'2" C2     .
 DIO      "H2'1" "C2'"  .      .
 DIO      "O1'"  "C2'"  "C1'"  .
 DIO      "C1'"  "O1'"  "H1'1" .
 DIO      "H1'2" "C1'"  .      .
 DIO      "H1'1" "C1'"  .      .
 DIO      C2     "C2'"  O1     .
 DIO      H21    C2     .      .
 DIO      H22    C2     .      .
 DIO      O1     C2     C1     .
 DIO      C1     O1     H11    .
 DIO      H12    C1     .      .
 DIO      H11    C1     .      END
 DIO      C1     "C1'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DIO      C1     "C1'"     single      1.524    0.020
 DIO      C1     O1        single      1.426    0.020
 DIO      H11    C1        single      1.092    0.020
 DIO      H12    C1        single      1.092    0.020
 DIO      C2     "C2'"     single      1.524    0.020
 DIO      O1     C2        single      1.426    0.020
 DIO      H21    C2        single      1.092    0.020
 DIO      H22    C2        single      1.092    0.020
 DIO      "C1'"  "O1'"     single      1.426    0.020
 DIO      "H1'1" "C1'"     single      1.092    0.020
 DIO      "H1'2" "C1'"     single      1.092    0.020
 DIO      "O1'"  "C2'"     single      1.426    0.020
 DIO      "H2'1" "C2'"     single      1.092    0.020
 DIO      "C2'"  "H2'2"    single      1.092    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DIO      "H2'2" "C2'"  "H2'1"  107.900    3.000
 DIO      "H2'2" "C2'"  "O1'"   109.470    3.000
 DIO      "H2'2" "C2'"  C2      109.470    3.000
 DIO      "H2'1" "C2'"  "O1'"   109.470    3.000
 DIO      "H2'1" "C2'"  C2      109.470    3.000
 DIO      "O1'"  "C2'"  C2      109.470    3.000
 DIO      "C2'"  "O1'"  "C1'"   111.800    3.000
 DIO      "O1'"  "C1'"  "H1'2"  109.470    3.000
 DIO      "O1'"  "C1'"  "H1'1"  109.470    3.000
 DIO      "O1'"  "C1'"  C1      109.470    3.000
 DIO      "H1'2" "C1'"  "H1'1"  107.900    3.000
 DIO      "H1'2" "C1'"  C1      109.470    3.000
 DIO      "H1'1" "C1'"  C1      109.470    3.000
 DIO      "C2'"  C2     H21     109.470    3.000
 DIO      "C2'"  C2     H22     109.470    3.000
 DIO      "C2'"  C2     O1      109.470    3.000
 DIO      H21    C2     H22     107.900    3.000
 DIO      H21    C2     O1      109.470    3.000
 DIO      H22    C2     O1      109.470    3.000
 DIO      C2     O1     C1      111.800    3.000
 DIO      O1     C1     H12     109.470    3.000
 DIO      O1     C1     H11     109.470    3.000
 DIO      O1     C1     "C1'"   109.470    3.000
 DIO      H12    C1     H11     107.900    3.000
 DIO      H12    C1     "C1'"   109.470    3.000
 DIO      H11    C1     "C1'"   109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DIO      var_1    "H2'2" "C2'"  "O1'"  "C1'"    180.000   20.000   1
 DIO      var_2    "C2'"  "O1'"  "C1'"  C1        60.000   20.000   1
 DIO      var_3    "H2'2" "C2'"  C2     O1       180.000   20.000   3
 DIO      var_4    "C2'"  C2     O1     C1       -60.000   20.000   1
 DIO      var_5    C2     O1     C1     "C1'"     60.000   20.000   1
 DIO      var_6    O1     C1     "C1'"  "O1'"    -60.000   20.000   3
# ------------------------------------------------------
`.trim();

monomers["SDS"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SDS      SDS 'DODECYL SULFATE                     ' non-polymer        43  17 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SDS
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SDS           O4     O    OS        0.000      0.000    0.000    0.000
 SDS           S      S    ST        0.000     -0.147   -0.629   -1.265
 SDS           O1S    O    OS        0.000      0.538   -0.256   -2.452
 SDS           O3S    O    OH1       0.000      0.185   -2.095   -1.040
 SDS           H3S    H    H         0.000      1.081   -2.324   -0.819
 SDS           O2S    O    O2        0.000     -1.630   -0.543   -1.599
 SDS           C1     C    CH2       0.000     -2.324   -0.382   -0.360
 SDS           H1C1   H    H         0.000     -1.983    0.531    0.131
 SDS           H1C2   H    H         0.000     -2.120   -1.239    0.285
 SDS           C12    C    CH2       0.000     -3.827   -0.289   -0.626
 SDS           H121   H    H         0.000     -4.166   -1.202   -1.119
 SDS           H122   H    H         0.000     -4.029    0.568   -1.272
 SDS           C11    C    CH2       0.000     -4.571   -0.117    0.699
 SDS           H111   H    H         0.000     -4.229    0.797    1.191
 SDS           H112   H    H         0.000     -4.366   -0.974    1.344
 SDS           C10    C    CH2       0.000     -6.073   -0.024    0.434
 SDS           H101   H    H         0.000     -6.411   -0.937   -0.059
 SDS           H102   H    H         0.000     -6.274    0.833   -0.212
 SDS           C9     C    CH2       0.000     -6.816    0.148    1.759
 SDS           H9C1   H    H         0.000     -6.475    1.062    2.250
 SDS           H9C2   H    H         0.000     -6.612   -0.709    2.403
 SDS           C8     C    CH2       0.000     -8.320    0.242    1.494
 SDS           H8C1   H    H         0.000     -8.659   -0.672    1.001
 SDS           H8C2   H    H         0.000     -8.523    1.099    0.848
 SDS           C7     C    CH2       0.000     -9.063    0.414    2.819
 SDS           H7C1   H    H         0.000     -8.721    1.327    3.311
 SDS           H7C2   H    H         0.000     -8.858   -0.444    3.464
 SDS           C6     C    CH2       0.000    -10.567    0.507    2.554
 SDS           H6C1   H    H         0.000    -10.905   -0.407    2.061
 SDS           H6C2   H    H         0.000    -10.768    1.364    1.908
 SDS           C5     C    CH2       0.000    -11.311    0.679    3.879
 SDS           H5C1   H    H         0.000    -10.969    1.593    4.371
 SDS           H5C2   H    H         0.000    -11.106   -0.178    4.524
 SDS           C4     C    CH2       0.000    -12.813    0.772    3.614
 SDS           H4C1   H    H         0.000    -13.152   -0.141    3.121
 SDS           H4C2   H    H         0.000    -13.015    1.629    2.968
 SDS           C3     C    CH2       0.000    -13.557    0.945    4.940
 SDS           H3C1   H    H         0.000    -13.216    1.858    5.432
 SDS           H3C2   H    H         0.000    -13.353    0.087    5.585
 SDS           C2     C    CH3       0.000    -15.060    1.038    4.674
 SDS           H2C3   H    H         0.000    -15.261    1.870    4.048
 SDS           H2C2   H    H         0.000    -15.394    0.152    4.196
 SDS           H2C1   H    H         0.000    -15.578    1.157    5.591
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SDS      O4     n/a    S      START
 SDS      S      O4     O2S    .
 SDS      O1S    S      .      .
 SDS      O3S    S      H3S    .
 SDS      H3S    O3S    .      .
 SDS      O2S    S      C1     .
 SDS      C1     O2S    C12    .
 SDS      H1C1   C1     .      .
 SDS      H1C2   C1     .      .
 SDS      C12    C1     C11    .
 SDS      H121   C12    .      .
 SDS      H122   C12    .      .
 SDS      C11    C12    C10    .
 SDS      H111   C11    .      .
 SDS      H112   C11    .      .
 SDS      C10    C11    C9     .
 SDS      H101   C10    .      .
 SDS      H102   C10    .      .
 SDS      C9     C10    C8     .
 SDS      H9C1   C9     .      .
 SDS      H9C2   C9     .      .
 SDS      C8     C9     C7     .
 SDS      H8C1   C8     .      .
 SDS      H8C2   C8     .      .
 SDS      C7     C8     C6     .
 SDS      H7C1   C7     .      .
 SDS      H7C2   C7     .      .
 SDS      C6     C7     C5     .
 SDS      H6C1   C6     .      .
 SDS      H6C2   C6     .      .
 SDS      C5     C6     C4     .
 SDS      H5C1   C5     .      .
 SDS      H5C2   C5     .      .
 SDS      C4     C5     C3     .
 SDS      H4C1   C4     .      .
 SDS      H4C2   C4     .      .
 SDS      C3     C4     C2     .
 SDS      H3C1   C3     .      .
 SDS      H3C2   C3     .      .
 SDS      C2     C3     H2C1   .
 SDS      H2C3   C2     .      .
 SDS      H2C2   C2     .      .
 SDS      H2C1   C2     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SDS      O1S    S         double      1.436    0.020
 SDS      O2S    S         single      1.535    0.020
 SDS      O3S    S         single      1.635    0.020
 SDS      S      O4        double      1.436    0.020
 SDS      C1     O2S       single      1.426    0.020
 SDS      H3S    O3S       single      0.967    0.020
 SDS      C12    C1        single      1.524    0.020
 SDS      H1C1   C1        single      1.092    0.020
 SDS      H1C2   C1        single      1.092    0.020
 SDS      C2     C3        single      1.513    0.020
 SDS      H2C1   C2        single      1.059    0.020
 SDS      H2C2   C2        single      1.059    0.020
 SDS      H2C3   C2        single      1.059    0.020
 SDS      C3     C4        single      1.524    0.020
 SDS      H3C1   C3        single      1.092    0.020
 SDS      H3C2   C3        single      1.092    0.020
 SDS      C4     C5        single      1.524    0.020
 SDS      H4C1   C4        single      1.092    0.020
 SDS      H4C2   C4        single      1.092    0.020
 SDS      C5     C6        single      1.524    0.020
 SDS      H5C1   C5        single      1.092    0.020
 SDS      H5C2   C5        single      1.092    0.020
 SDS      C6     C7        single      1.524    0.020
 SDS      H6C1   C6        single      1.092    0.020
 SDS      H6C2   C6        single      1.092    0.020
 SDS      C7     C8        single      1.524    0.020
 SDS      H7C1   C7        single      1.092    0.020
 SDS      H7C2   C7        single      1.092    0.020
 SDS      C8     C9        single      1.524    0.020
 SDS      H8C1   C8        single      1.092    0.020
 SDS      H8C2   C8        single      1.092    0.020
 SDS      C9     C10       single      1.524    0.020
 SDS      H9C1   C9        single      1.092    0.020
 SDS      H9C2   C9        single      1.092    0.020
 SDS      C10    C11       single      1.524    0.020
 SDS      H101   C10       single      1.092    0.020
 SDS      H102   C10       single      1.092    0.020
 SDS      C11    C12       single      1.524    0.020
 SDS      H111   C11       single      1.092    0.020
 SDS      H112   C11       single      1.092    0.020
 SDS      H121   C12       single      1.092    0.020
 SDS      H122   C12       single      1.092    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SDS      O4     S      O1S     109.500    3.000
 SDS      O4     S      O3S     109.500    3.000
 SDS      O4     S      O2S     109.500    3.000
 SDS      O1S    S      O3S     109.500    3.000
 SDS      O1S    S      O2S     109.500    3.000
 SDS      O3S    S      O2S     109.500    3.000
 SDS      S      O3S    H3S     120.000    3.000
 SDS      S      O2S    C1      120.000    3.000
 SDS      O2S    C1     H1C1    109.470    3.000
 SDS      O2S    C1     H1C2    109.470    3.000
 SDS      O2S    C1     C12     109.470    3.000
 SDS      H1C1   C1     H1C2    107.900    3.000
 SDS      H1C1   C1     C12     109.470    3.000
 SDS      H1C2   C1     C12     109.470    3.000
 SDS      C1     C12    H121    109.470    3.000
 SDS      C1     C12    H122    109.470    3.000
 SDS      C1     C12    C11     111.000    3.000
 SDS      H121   C12    H122    107.900    3.000
 SDS      H121   C12    C11     109.470    3.000
 SDS      H122   C12    C11     109.470    3.000
 SDS      C12    C11    H111    109.470    3.000
 SDS      C12    C11    H112    109.470    3.000
 SDS      C12    C11    C10     111.000    3.000
 SDS      H111   C11    H112    107.900    3.000
 SDS      H111   C11    C10     109.470    3.000
 SDS      H112   C11    C10     109.470    3.000
 SDS      C11    C10    H101    109.470    3.000
 SDS      C11    C10    H102    109.470    3.000
 SDS      C11    C10    C9      111.000    3.000
 SDS      H101   C10    H102    107.900    3.000
 SDS      H101   C10    C9      109.470    3.000
 SDS      H102   C10    C9      109.470    3.000
 SDS      C10    C9     H9C1    109.470    3.000
 SDS      C10    C9     H9C2    109.470    3.000
 SDS      C10    C9     C8      111.000    3.000
 SDS      H9C1   C9     H9C2    107.900    3.000
 SDS      H9C1   C9     C8      109.470    3.000
 SDS      H9C2   C9     C8      109.470    3.000
 SDS      C9     C8     H8C1    109.470    3.000
 SDS      C9     C8     H8C2    109.470    3.000
 SDS      C9     C8     C7      111.000    3.000
 SDS      H8C1   C8     H8C2    107.900    3.000
 SDS      H8C1   C8     C7      109.470    3.000
 SDS      H8C2   C8     C7      109.470    3.000
 SDS      C8     C7     H7C1    109.470    3.000
 SDS      C8     C7     H7C2    109.470    3.000
 SDS      C8     C7     C6      111.000    3.000
 SDS      H7C1   C7     H7C2    107.900    3.000
 SDS      H7C1   C7     C6      109.470    3.000
 SDS      H7C2   C7     C6      109.470    3.000
 SDS      C7     C6     H6C1    109.470    3.000
 SDS      C7     C6     H6C2    109.470    3.000
 SDS      C7     C6     C5      111.000    3.000
 SDS      H6C1   C6     H6C2    107.900    3.000
 SDS      H6C1   C6     C5      109.470    3.000
 SDS      H6C2   C6     C5      109.470    3.000
 SDS      C6     C5     H5C1    109.470    3.000
 SDS      C6     C5     H5C2    109.470    3.000
 SDS      C6     C5     C4      111.000    3.000
 SDS      H5C1   C5     H5C2    107.900    3.000
 SDS      H5C1   C5     C4      109.470    3.000
 SDS      H5C2   C5     C4      109.470    3.000
 SDS      C5     C4     H4C1    109.470    3.000
 SDS      C5     C4     H4C2    109.470    3.000
 SDS      C5     C4     C3      111.000    3.000
 SDS      H4C1   C4     H4C2    107.900    3.000
 SDS      H4C1   C4     C3      109.470    3.000
 SDS      H4C2   C4     C3      109.470    3.000
 SDS      C4     C3     H3C1    109.470    3.000
 SDS      C4     C3     H3C2    109.470    3.000
 SDS      C4     C3     C2      111.000    3.000
 SDS      H3C1   C3     H3C2    107.900    3.000
 SDS      H3C1   C3     C2      109.470    3.000
 SDS      H3C2   C3     C2      109.470    3.000
 SDS      C3     C2     H2C3    109.470    3.000
 SDS      C3     C2     H2C2    109.470    3.000
 SDS      C3     C2     H2C1    109.470    3.000
 SDS      H2C3   C2     H2C2    109.470    3.000
 SDS      H2C3   C2     H2C1    109.470    3.000
 SDS      H2C2   C2     H2C1    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 SDS      var_1    O4     S      O3S    H3S      -67.365   20.000   1
 SDS      var_2    O4     S      O2S    C1       -22.671   20.000   1
 SDS      var_3    S      O2S    C1     C12      179.997   20.000   1
 SDS      var_4    O2S    C1     C12    C11      179.984   20.000   3
 SDS      var_5    C1     C12    C11    C10     -179.996   20.000   3
 SDS      var_6    C12    C11    C10    C9      -179.996   20.000   3
 SDS      var_7    C11    C10    C9     C8       180.000   20.000   3
 SDS      var_8    C10    C9     C8     C7       179.996   20.000   3
 SDS      var_9    C9     C8     C7     C6       180.000   20.000   3
 SDS      var_10   C8     C7     C6     C5      -179.996   20.000   3
 SDS      var_11   C7     C6     C5     C4      -180.000   20.000   3
 SDS      var_12   C6     C5     C4     C3       179.996   20.000   3
 SDS      var_13   C5     C4     C3     C2       179.996   20.000   3
 SDS      var_14   C4     C3     C2     H2C1     179.978   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 SDS      chir_01  S      O1S    O2S    O3S       negativ
# ------------------------------------------------------
`.trim();

monomers["EEE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
EEE      EEE 'ETHYL ACETATE                       ' non-polymer        14   6 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_EEE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 EEE           O1     O    O        -0.500      0.000    0.000    0.000
 EEE           C1     C    C         0.000     -1.251    0.013    0.001
 EEE           C2     C    CH3       0.000     -2.017   -1.285    0.010
 EEE           H23    H    H         0.000     -2.625   -1.332    0.876
 EEE           H22    H    H         0.000     -2.629   -1.342   -0.854
 EEE           H21    H    H         0.000     -1.337   -2.098    0.013
 EEE           O2     O    O2       -0.500     -1.866    1.102   -0.009
 EEE           C3     C    CH2       0.000     -1.108    2.392   -0.018
 EEE           H31    H    H         0.000     -0.475    2.402   -0.908
 EEE           H32    H    H         0.000     -0.479    2.417    0.875
 EEE           C4     C    CH3       0.000     -2.029    3.614   -0.030
 EEE           H43    H    H         0.000     -2.640    3.591   -0.897
 EEE           H42    H    H         0.000     -2.644    3.605    0.833
 EEE           H41    H    H         0.000     -1.446    4.500   -0.036
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 EEE      O1     n/a    C1     START
 EEE      C1     O1     O2     .
 EEE      C2     C1     H21    .
 EEE      H23    C2     .      .
 EEE      H22    C2     .      .
 EEE      H21    C2     .      .
 EEE      O2     C1     C3     .
 EEE      C3     O2     C4     .
 EEE      H31    C3     .      .
 EEE      H32    C3     .      .
 EEE      C4     C3     H41    .
 EEE      H43    C4     .      .
 EEE      H42    C4     .      .
 EEE      H41    C4     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 EEE      C2     C1        single      1.500    0.020
 EEE      C1     O1        deloc       1.220    0.020
 EEE      O2     C1        deloc       1.454    0.020
 EEE      H21    C2        single      1.059    0.020
 EEE      H22    C2        single      1.059    0.020
 EEE      H23    C2        single      1.059    0.020
 EEE      C3     O2        single      1.426    0.020
 EEE      C4     C3        single      1.513    0.020
 EEE      H31    C3        single      1.092    0.020
 EEE      H32    C3        single      1.092    0.020
 EEE      H41    C4        single      1.059    0.020
 EEE      H42    C4        single      1.059    0.020
 EEE      H43    C4        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 EEE      O1     C1     C2      123.000    3.000
 EEE      O1     C1     O2      119.000    3.000
 EEE      C2     C1     O2      120.000    3.000
 EEE      C1     C2     H23     109.470    3.000
 EEE      C1     C2     H22     109.470    3.000
 EEE      C1     C2     H21     109.470    3.000
 EEE      H23    C2     H22     109.470    3.000
 EEE      H23    C2     H21     109.470    3.000
 EEE      H22    C2     H21     109.470    3.000
 EEE      C1     O2     C3      120.000    3.000
 EEE      O2     C3     H31     109.470    3.000
 EEE      O2     C3     H32     109.470    3.000
 EEE      O2     C3     C4      109.470    3.000
 EEE      H31    C3     H32     107.900    3.000
 EEE      H31    C3     C4      109.470    3.000
 EEE      H32    C3     C4      109.470    3.000
 EEE      C3     C4     H43     109.470    3.000
 EEE      C3     C4     H42     109.470    3.000
 EEE      C3     C4     H41     109.470    3.000
 EEE      H43    C4     H42     109.470    3.000
 EEE      H43    C4     H41     109.470    3.000
 EEE      H42    C4     H41     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 EEE      var_1    O1     C1     C2     H21       -0.077   20.000   1
 EEE      var_2    O1     C1     O2     C3        -0.199   20.000   1
 EEE      var_3    C1     O2     C3     C4       179.972   20.000   1
 EEE      var_4    O2     C3     C4     H41      179.986   20.000   3
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 EEE      plan-1    C1        0.020
 EEE      plan-1    C2        0.000
 EEE      plan-1    O1        0.000
 EEE      plan-1    O2        0.000
# ------------------------------------------------------
`.trim();

monomers["TRT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TRT      TRT 'FRAGMENT OF TRITON X-100            ' non-polymer        61  25 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TRT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TRT           C3     C    CH3       0.000      0.000    0.000    0.000
 TRT           H3C1   H    H         0.000     -0.125    1.044    0.129
 TRT           H3C2   H    H         0.000      1.022   -0.212   -0.180
 TRT           H3C3   H    H         0.000     -0.578   -0.324   -0.827
 TRT           C1     C    CT        0.000     -0.459   -0.731    1.263
 TRT           C2     C    CH3       0.000     -0.063    0.084    2.497
 TRT           H2C3   H    H         0.000     -0.303    1.104    2.341
 TRT           H2C2   H    H         0.000     -0.589   -0.276    3.343
 TRT           H2C1   H    H         0.000      0.979   -0.011    2.664
 TRT           C4     C    CH3       0.000      0.207   -2.106    1.327
 TRT           H4C3   H    H         0.000      0.002   -2.640    0.435
 TRT           H4C2   H    H         0.000      1.255   -1.987    1.433
 TRT           H4C1   H    H         0.000     -0.172   -2.645    2.156
 TRT           C5     C    CH2       0.000     -1.979   -0.901    1.231
 TRT           H5C1   H    H         0.000     -2.276   -1.654    1.963
 TRT           H5C2   H    H         0.000     -2.288   -1.222    0.234
 TRT           C6     C    CT        0.000     -2.648    0.432    1.569
 TRT           C7     C    CH3       0.000     -2.463    0.732    3.057
 TRT           H7C3   H    H         0.000     -1.704    1.460    3.180
 TRT           H7C2   H    H         0.000     -3.371    1.099    3.461
 TRT           H7C1   H    H         0.000     -2.186   -0.155    3.566
 TRT           C8     C    CH3       0.000     -2.010    1.548    0.741
 TRT           H8C3   H    H         0.000     -2.623    2.412    0.778
 TRT           H8C2   H    H         0.000     -1.053    1.778    1.134
 TRT           H8C1   H    H         0.000     -1.911    1.230   -0.265
 TRT           C9     C    CR6       0.000     -4.119    0.350    1.253
 TRT           C14    C    CR16      0.000     -4.936    1.442    1.478
 TRT           H14    H    H         0.000     -4.518    2.356    1.881
 TRT           C13    C    CR16      0.000     -6.284    1.370    1.188
 TRT           H13    H    H         0.000     -6.923    2.227    1.365
 TRT           C10    C    CR16      0.000     -4.650   -0.817    0.737
 TRT           H10    H    H         0.000     -4.008   -1.670    0.557
 TRT           C11    C    CR16      0.000     -5.999   -0.897    0.452
 TRT           H11    H    H         0.000     -6.416   -1.815    0.056
 TRT           C12    C    CR6       0.000     -6.820    0.199    0.672
 TRT           O15    O    O2        0.000     -8.146    0.125    0.387
 TRT           C16    C    CH2       0.000     -8.386   -1.188   -0.123
 TRT           H161   H    H         0.000     -8.109   -1.927    0.632
 TRT           H162   H    H         0.000     -7.785   -1.344   -1.021
 TRT           C17    C    CH2       0.000     -9.870   -1.337   -0.466
 TRT           H171   H    H         0.000    -10.468   -1.181    0.434
 TRT           H172   H    H         0.000    -10.053   -2.341   -0.854
 TRT           O18    O    O2        0.000    -10.230   -0.370   -1.453
 TRT           C19    C    CH2       0.000    -11.619   -0.561   -1.730
 TRT           H191   H    H         0.000    -12.195   -0.416   -0.814
 TRT           H192   H    H         0.000    -11.779   -1.575   -2.102
 TRT           C20    C    CH2       0.000    -12.073    0.448   -2.785
 TRT           H201   H    H         0.000    -11.912    1.462   -2.412
 TRT           H202   H    H         0.000    -13.134    0.303   -2.995
 TRT           O21    O    O2        0.000    -11.318    0.255   -3.983
 TRT           C22    C    CH2       0.000    -11.785    1.224   -4.926
 TRT           H221   H    H         0.000    -11.629    2.227   -4.524
 TRT           H222   H    H         0.000    -12.851    1.068   -5.109
 TRT           C23    C    CH2       0.000    -11.014    1.071   -6.237
 TRT           H231   H    H         0.000     -9.949    1.227   -6.052
 TRT           H232   H    H         0.000    -11.369    1.812   -6.956
 TRT           O24    O    O2        0.000    -11.220   -0.241   -6.762
 TRT           C25    C    CH3       0.000    -10.478   -0.321   -7.981
 TRT           H253   H    H         0.000    -10.831    0.413   -8.658
 TRT           H252   H    H         0.000     -9.452   -0.152   -7.781
 TRT           H251   H    H         0.000    -10.601   -1.282   -8.407
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TRT      C3     n/a    C1     START
 TRT      H3C1   C3     .      .
 TRT      H3C2   C3     .      .
 TRT      H3C3   C3     .      .
 TRT      C1     C3     C5     .
 TRT      C2     C1     H2C1   .
 TRT      H2C3   C2     .      .
 TRT      H2C2   C2     .      .
 TRT      H2C1   C2     .      .
 TRT      C4     C1     H4C1   .
 TRT      H4C3   C4     .      .
 TRT      H4C2   C4     .      .
 TRT      H4C1   C4     .      .
 TRT      C5     C1     C6     .
 TRT      H5C1   C5     .      .
 TRT      H5C2   C5     .      .
 TRT      C6     C5     C9     .
 TRT      C7     C6     H7C1   .
 TRT      H7C3   C7     .      .
 TRT      H7C2   C7     .      .
 TRT      H7C1   C7     .      .
 TRT      C8     C6     H8C1   .
 TRT      H8C3   C8     .      .
 TRT      H8C2   C8     .      .
 TRT      H8C1   C8     .      .
 TRT      C9     C6     C10    .
 TRT      C14    C9     C13    .
 TRT      H14    C14    .      .
 TRT      C13    C14    H13    .
 TRT      H13    C13    .      .
 TRT      C10    C9     C11    .
 TRT      H10    C10    .      .
 TRT      C11    C10    C12    .
 TRT      H11    C11    .      .
 TRT      C12    C11    O15    .
 TRT      O15    C12    C16    .
 TRT      C16    O15    C17    .
 TRT      H161   C16    .      .
 TRT      H162   C16    .      .
 TRT      C17    C16    O18    .
 TRT      H171   C17    .      .
 TRT      H172   C17    .      .
 TRT      O18    C17    C19    .
 TRT      C19    O18    C20    .
 TRT      H191   C19    .      .
 TRT      H192   C19    .      .
 TRT      C20    C19    O21    .
 TRT      H201   C20    .      .
 TRT      H202   C20    .      .
 TRT      O21    C20    C22    .
 TRT      C22    O21    C23    .
 TRT      H221   C22    .      .
 TRT      H222   C22    .      .
 TRT      C23    C22    O24    .
 TRT      H231   C23    .      .
 TRT      H232   C23    .      .
 TRT      O24    C23    C25    .
 TRT      C25    O24    H251   .
 TRT      H253   C25    .      .
 TRT      H252   C25    .      .
 TRT      H251   C25    .      END
 TRT      C12    C13    .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TRT      C25    O24       single      1.426    0.020
 TRT      H251   C25       single      1.059    0.020
 TRT      H252   C25       single      1.059    0.020
 TRT      H253   C25       single      1.059    0.020
 TRT      O24    C23       single      1.426    0.020
 TRT      C23    C22       single      1.524    0.020
 TRT      H231   C23       single      1.092    0.020
 TRT      H232   C23       single      1.092    0.020
 TRT      C22    O21       single      1.426    0.020
 TRT      H221   C22       single      1.092    0.020
 TRT      H222   C22       single      1.092    0.020
 TRT      O21    C20       single      1.426    0.020
 TRT      C20    C19       single      1.524    0.020
 TRT      H201   C20       single      1.092    0.020
 TRT      H202   C20       single      1.092    0.020
 TRT      C19    O18       single      1.426    0.020
 TRT      H191   C19       single      1.092    0.020
 TRT      H192   C19       single      1.092    0.020
 TRT      O18    C17       single      1.426    0.020
 TRT      C17    C16       single      1.524    0.020
 TRT      H171   C17       single      1.092    0.020
 TRT      H172   C17       single      1.092    0.020
 TRT      C16    O15       single      1.426    0.020
 TRT      H161   C16       single      1.092    0.020
 TRT      H162   C16       single      1.092    0.020
 TRT      O15    C12       single      1.370    0.020
 TRT      C12    C13       double      1.390    0.020
 TRT      C12    C11       single      1.390    0.020
 TRT      C13    C14       single      1.390    0.020
 TRT      H13    C13       single      1.083    0.020
 TRT      C14    C9        double      1.390    0.020
 TRT      H14    C14       single      1.083    0.020
 TRT      C11    C10       double      1.390    0.020
 TRT      H11    C11       single      1.083    0.020
 TRT      C10    C9        single      1.390    0.020
 TRT      H10    C10       single      1.083    0.020
 TRT      C9     C6        single      1.500    0.020
 TRT      C8     C6        single      1.524    0.020
 TRT      C7     C6        single      1.524    0.020
 TRT      C6     C5        single      1.524    0.020
 TRT      H8C1   C8        single      1.059    0.020
 TRT      H8C2   C8        single      1.059    0.020
 TRT      H8C3   C8        single      1.059    0.020
 TRT      H7C1   C7        single      1.059    0.020
 TRT      H7C2   C7        single      1.059    0.020
 TRT      H7C3   C7        single      1.059    0.020
 TRT      C5     C1        single      1.524    0.020
 TRT      H5C1   C5        single      1.092    0.020
 TRT      H5C2   C5        single      1.092    0.020
 TRT      C2     C1        single      1.524    0.020
 TRT      C4     C1        single      1.524    0.020
 TRT      C1     C3        single      1.524    0.020
 TRT      H2C1   C2        single      1.059    0.020
 TRT      H2C2   C2        single      1.059    0.020
 TRT      H2C3   C2        single      1.059    0.020
 TRT      H4C1   C4        single      1.059    0.020
 TRT      H4C2   C4        single      1.059    0.020
 TRT      H4C3   C4        single      1.059    0.020
 TRT      H3C1   C3        single      1.059    0.020
 TRT      H3C2   C3        single      1.059    0.020
 TRT      H3C3   C3        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TRT      H3C1   C3     H3C2    109.470    3.000
 TRT      H3C1   C3     H3C3    109.470    3.000
 TRT      H3C2   C3     H3C3    109.470    3.000
 TRT      H3C1   C3     C1      109.470    3.000
 TRT      H3C2   C3     C1      109.470    3.000
 TRT      H3C3   C3     C1      109.470    3.000
 TRT      C3     C1     C2      111.000    3.000
 TRT      C3     C1     C4      111.000    3.000
 TRT      C3     C1     C5      111.000    3.000
 TRT      C2     C1     C4      111.000    3.000
 TRT      C2     C1     C5      111.000    3.000
 TRT      C4     C1     C5      111.000    3.000
 TRT      C1     C2     H2C3    109.470    3.000
 TRT      C1     C2     H2C2    109.470    3.000
 TRT      C1     C2     H2C1    109.470    3.000
 TRT      H2C3   C2     H2C2    109.470    3.000
 TRT      H2C3   C2     H2C1    109.470    3.000
 TRT      H2C2   C2     H2C1    109.470    3.000
 TRT      C1     C4     H4C3    109.470    3.000
 TRT      C1     C4     H4C2    109.470    3.000
 TRT      C1     C4     H4C1    109.470    3.000
 TRT      H4C3   C4     H4C2    109.470    3.000
 TRT      H4C3   C4     H4C1    109.470    3.000
 TRT      H4C2   C4     H4C1    109.470    3.000
 TRT      C1     C5     H5C1    109.470    3.000
 TRT      C1     C5     H5C2    109.470    3.000
 TRT      C1     C5     C6      109.500    3.000
 TRT      H5C1   C5     H5C2    107.900    3.000
 TRT      H5C1   C5     C6      109.470    3.000
 TRT      H5C2   C5     C6      109.470    3.000
 TRT      C5     C6     C7      111.000    3.000
 TRT      C5     C6     C8      111.000    3.000
 TRT      C5     C6     C9      109.500    3.000
 TRT      C7     C6     C8      111.000    3.000
 TRT      C7     C6     C9      109.500    3.000
 TRT      C8     C6     C9      109.500    3.000
 TRT      C6     C7     H7C3    109.470    3.000
 TRT      C6     C7     H7C2    109.470    3.000
 TRT      C6     C7     H7C1    109.470    3.000
 TRT      H7C3   C7     H7C2    109.470    3.000
 TRT      H7C3   C7     H7C1    109.470    3.000
 TRT      H7C2   C7     H7C1    109.470    3.000
 TRT      C6     C8     H8C3    109.470    3.000
 TRT      C6     C8     H8C2    109.470    3.000
 TRT      C6     C8     H8C1    109.470    3.000
 TRT      H8C3   C8     H8C2    109.470    3.000
 TRT      H8C3   C8     H8C1    109.470    3.000
 TRT      H8C2   C8     H8C1    109.470    3.000
 TRT      C6     C9     C14     120.000    3.000
 TRT      C6     C9     C10     120.000    3.000
 TRT      C14    C9     C10     120.000    3.000
 TRT      C9     C14    H14     120.000    3.000
 TRT      C9     C14    C13     120.000    3.000
 TRT      H14    C14    C13     120.000    3.000
 TRT      C14    C13    H13     120.000    3.000
 TRT      C14    C13    C12     120.000    3.000
 TRT      H13    C13    C12     120.000    3.000
 TRT      C9     C10    H10     120.000    3.000
 TRT      C9     C10    C11     120.000    3.000
 TRT      H10    C10    C11     120.000    3.000
 TRT      C10    C11    H11     120.000    3.000
 TRT      C10    C11    C12     120.000    3.000
 TRT      H11    C11    C12     120.000    3.000
 TRT      C11    C12    O15     120.000    3.000
 TRT      C11    C12    C13     120.000    3.000
 TRT      O15    C12    C13     120.000    3.000
 TRT      C12    O15    C16     120.000    3.000
 TRT      O15    C16    H161    109.470    3.000
 TRT      O15    C16    H162    109.470    3.000
 TRT      O15    C16    C17     109.470    3.000
 TRT      H161   C16    H162    107.900    3.000
 TRT      H161   C16    C17     109.470    3.000
 TRT      H162   C16    C17     109.470    3.000
 TRT      C16    C17    H171    109.470    3.000
 TRT      C16    C17    H172    109.470    3.000
 TRT      C16    C17    O18     109.470    3.000
 TRT      H171   C17    H172    107.900    3.000
 TRT      H171   C17    O18     109.470    3.000
 TRT      H172   C17    O18     109.470    3.000
 TRT      C17    O18    C19     111.800    3.000
 TRT      O18    C19    H191    109.470    3.000
 TRT      O18    C19    H192    109.470    3.000
 TRT      O18    C19    C20     109.470    3.000
 TRT      H191   C19    H192    107.900    3.000
 TRT      H191   C19    C20     109.470    3.000
 TRT      H192   C19    C20     109.470    3.000
 TRT      C19    C20    H201    109.470    3.000
 TRT      C19    C20    H202    109.470    3.000
 TRT      C19    C20    O21     109.470    3.000
 TRT      H201   C20    H202    107.900    3.000
 TRT      H201   C20    O21     109.470    3.000
 TRT      H202   C20    O21     109.470    3.000
 TRT      C20    O21    C22     111.800    3.000
 TRT      O21    C22    H221    109.470    3.000
 TRT      O21    C22    H222    109.470    3.000
 TRT      O21    C22    C23     109.470    3.000
 TRT      H221   C22    H222    107.900    3.000
 TRT      H221   C22    C23     109.470    3.000
 TRT      H222   C22    C23     109.470    3.000
 TRT      C22    C23    H231    109.470    3.000
 TRT      C22    C23    H232    109.470    3.000
 TRT      C22    C23    O24     109.470    3.000
 TRT      H231   C23    H232    107.900    3.000
 TRT      H231   C23    O24     109.470    3.000
 TRT      H232   C23    O24     109.470    3.000
 TRT      C23    O24    C25     111.800    3.000
 TRT      O24    C25    H253    109.470    3.000
 TRT      O24    C25    H252    109.470    3.000
 TRT      O24    C25    H251    109.470    3.000
 TRT      H253   C25    H252    109.470    3.000
 TRT      H253   C25    H251    109.470    3.000
 TRT      H252   C25    H251    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TRT      var_1    H3C3   C3     C1     C5       -37.591   20.000   1
 TRT      var_2    C3     C1     C2     H2C1     -74.731   20.000   1
 TRT      var_3    C3     C1     C4     H4C1    -175.216   20.000   1
 TRT      var_4    C3     C1     C5     C6       -76.080   20.000   1
 TRT      var_5    C1     C5     C6     C9       167.960   20.000   1
 TRT      var_6    C5     C6     C7     H7C1     -17.026   20.000   1
 TRT      var_7    C5     C6     C8     H8C1      45.406   20.000   1
 TRT      var_8    C5     C6     C9     C10       -0.078   20.000   1
 TRT      CONST_1  C6     C9     C14    C13      180.000    0.000   0
 TRT      CONST_2  C9     C14    C13    C12        0.000    0.000   0
 TRT      CONST_3  C6     C9     C10    C11      180.000    0.000   0
 TRT      CONST_4  C9     C10    C11    C12        0.000    0.000   0
 TRT      CONST_5  C10    C11    C12    O15      180.000    0.000   0
 TRT      CONST_6  C11    C12    C13    C14        0.000    0.000   0
 TRT      var_9    C11    C12    O15    C16       -0.294   20.000   1
 TRT      var_10   C12    O15    C16    C17     -179.957   20.000   1
 TRT      var_11   O15    C16    C17    O18       60.021   20.000   3
 TRT      var_12   C16    C17    O18    C19      179.964   20.000   1
 TRT      var_13   C17    O18    C19    C20      179.990   20.000   1
 TRT      var_14   O18    C19    C20    O21       60.048   20.000   3
 TRT      var_15   C19    C20    O21    C22     -179.970   20.000   1
 TRT      var_16   C20    O21    C22    C23      179.958   20.000   1
 TRT      var_17   O21    C22    C23    O24       60.038   20.000   3
 TRT      var_18   C22    C23    O24    C25      179.980   20.000   1
 TRT      var_19   C23    O24    C25    H251     179.943   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TRT      chir_01  C6     C9     C8     C7        negativ
 TRT      chir_02  C1     C5     C2     C4        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TRT      plan-1    C12       0.020
 TRT      plan-1    O15       0.020
 TRT      plan-1    C13       0.020
 TRT      plan-1    C11       0.020
 TRT      plan-1    C14       0.020
 TRT      plan-1    C10       0.020
 TRT      plan-1    C9        0.020
 TRT      plan-1    H13       0.020
 TRT      plan-1    H14       0.020
 TRT      plan-1    H11       0.020
 TRT      plan-1    H10       0.020
 TRT      plan-1    C6        0.020
# ------------------------------------------------------
`.trim();

monomers["FRU"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
FRU      FRU 'FRUCTOSE                            ' non-polymer        24  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_FRU
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 FRU           O6     O    OH1       0.000      0.000    0.000    0.000
 FRU           HO6    H    H         0.000      0.763   -0.357    0.473
 FRU           C6     C    CH2       0.000     -1.181   -0.201    0.780
 FRU           H61    H    H         0.000     -1.074    0.310    1.739
 FRU           H62    H    H         0.000     -1.324   -1.270    0.953
 FRU           C5     C    CH1       0.000     -2.389    0.362    0.032
 FRU           H5     H    H         0.000     -2.257    1.436   -0.162
 FRU           C4     C    CH1       0.000     -3.692    0.110    0.831
 FRU           H4     H    H         0.000     -3.664   -0.871    1.325
 FRU           O4     O    OH1       0.000     -3.924    1.151    1.781
 FRU           HO4    H    H         0.000     -3.244    1.117    2.468
 FRU           C3     C    CH1       0.000     -4.765    0.133   -0.287
 FRU           H3     H    H         0.000     -5.246    1.119   -0.336
 FRU           O3     O    OH1       0.000     -5.741   -0.887   -0.070
 FRU           HO3    H    H         0.000     -6.228   -0.698    0.744
 FRU           O5     O    O2        0.000     -2.603   -0.354   -1.203
 FRU           C2     C    CT        0.000     -3.973   -0.143   -1.579
 FRU           O2     O    OH1       0.000     -4.486   -1.311   -2.222
 FRU           HO2    H    H         0.000     -3.978   -1.484   -3.026
 FRU           C1     C    CH2       0.000     -4.075    1.057   -2.521
 FRU           H11    H    H         0.000     -3.676    1.944   -2.025
 FRU           H12    H    H         0.000     -5.122    1.227   -2.781
 FRU           O1     O    OH1       0.000     -3.325    0.795   -3.709
 FRU           HO1    H    H         0.000     -3.390    1.554   -4.305
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 FRU      O6     n/a    C6     START
 FRU      HO6    O6     .      .
 FRU      C6     O6     C5     .
 FRU      H61    C6     .      .
 FRU      H62    C6     .      .
 FRU      C5     C6     O5     .
 FRU      H5     C5     .      .
 FRU      C4     C5     C3     .
 FRU      H4     C4     .      .
 FRU      O4     C4     HO4    .
 FRU      HO4    O4     .      .
 FRU      C3     C4     O3     .
 FRU      H3     C3     .      .
 FRU      O3     C3     HO3    .
 FRU      HO3    O3     .      .
 FRU      O5     C5     C2     .
 FRU      C2     O5     C1     .
 FRU      O2     C2     HO2    .
 FRU      HO2    O2     .      .
 FRU      C1     C2     O1     .
 FRU      H11    C1     .      .
 FRU      H12    C1     .      .
 FRU      O1     C1     HO1    .
 FRU      HO1    O1     .      END
 FRU      C2     C3     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 FRU      C1     C2        single      1.524    0.020
 FRU      O1     C1        single      1.432    0.020
 FRU      H11    C1        single      1.092    0.020
 FRU      H12    C1        single      1.092    0.020
 FRU      C2     C3        single      1.524    0.020
 FRU      O2     C2        single      1.432    0.020
 FRU      C2     O5        single      1.426    0.020
 FRU      C3     C4        single      1.524    0.020
 FRU      O3     C3        single      1.432    0.020
 FRU      H3     C3        single      1.099    0.020
 FRU      C4     C5        single      1.524    0.020
 FRU      O4     C4        single      1.432    0.020
 FRU      H4     C4        single      1.099    0.020
 FRU      C5     C6        single      1.524    0.020
 FRU      O5     C5        single      1.426    0.020
 FRU      H5     C5        single      1.099    0.020
 FRU      C6     O6        single      1.432    0.020
 FRU      H61    C6        single      1.092    0.020
 FRU      H62    C6        single      1.092    0.020
 FRU      HO1    O1        single      0.967    0.020
 FRU      HO2    O2        single      0.967    0.020
 FRU      HO3    O3        single      0.967    0.020
 FRU      HO4    O4        single      0.967    0.020
 FRU      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 FRU      HO6    O6     C6      109.470    3.000
 FRU      O6     C6     H61     109.470    3.000
 FRU      O6     C6     H62     109.470    3.000
 FRU      O6     C6     C5      109.470    3.000
 FRU      H61    C6     H62     107.900    3.000
 FRU      H61    C6     C5      109.470    3.000
 FRU      H62    C6     C5      109.470    3.000
 FRU      C6     C5     H5      108.340    3.000
 FRU      C6     C5     C4      111.000    3.000
 FRU      C6     C5     O5      109.470    3.000
 FRU      H5     C5     C4      108.340    3.000
 FRU      H5     C5     O5      109.470    3.000
 FRU      C4     C5     O5      109.470    3.000
 FRU      C5     C4     H4      108.340    3.000
 FRU      C5     C4     O4      109.470    3.000
 FRU      C5     C4     C3      111.000    3.000
 FRU      H4     C4     O4      109.470    3.000
 FRU      H4     C4     C3      108.340    3.000
 FRU      O4     C4     C3      109.470    3.000
 FRU      C4     O4     HO4     109.470    3.000
 FRU      C4     C3     H3      108.340    3.000
 FRU      C4     C3     O3      109.470    3.000
 FRU      C4     C3     C2      111.000    3.000
 FRU      H3     C3     O3      109.470    3.000
 FRU      H3     C3     C2      108.340    3.000
 FRU      O3     C3     C2      109.470    3.000
 FRU      C3     O3     HO3     109.470    3.000
 FRU      C5     O5     C2      111.800    3.000
 FRU      O5     C2     O2      109.470    3.000
 FRU      O5     C2     C1      109.470    3.000
 FRU      O5     C2     C3      109.470    3.000
 FRU      O2     C2     C1      109.470    3.000
 FRU      O2     C2     C3      109.470    3.000
 FRU      C1     C2     C3      111.000    3.000
 FRU      C2     O2     HO2     109.470    3.000
 FRU      C2     C1     H11     109.470    3.000
 FRU      C2     C1     H12     109.470    3.000
 FRU      C2     C1     O1      109.470    3.000
 FRU      H11    C1     H12     107.900    3.000
 FRU      H11    C1     O1      109.470    3.000
 FRU      H12    C1     O1      109.470    3.000
 FRU      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 FRU      var_1    HO6    O6     C6     C5      -179.951   20.000   1
 FRU      var_2    O6     C6     C5     O5        63.577   20.000   3
 FRU      var_3    C6     C5     C4     C3      -150.000   20.000   3
 FRU      var_4    C5     C4     O4     HO4      -67.281   20.000   1
 FRU      var_5    C5     C4     C3     O3       150.000   20.000   3
 FRU      var_6    C4     C3     O3     HO3       65.011   20.000   1
 FRU      var_7    C6     C5     O5     C2       150.000   20.000   1
 FRU      var_8    C5     O5     C2     C1        90.000   20.000   1
 FRU      var_9    O5     C2     C3     C4         0.000   20.000   1
 FRU      var_10   O5     C2     O2     HO2      -61.496   20.000   1
 FRU      var_11   O5     C2     C1     O1        61.435   20.000   1
 FRU      var_12   C2     C1     O1     HO1     -179.989   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 FRU      chir_01  C2     C1     C3     O2        negativ
 FRU      chir_02  C3     C2     C4     O3        positiv
 FRU      chir_03  C4     C3     C5     O4        negativ
 FRU      chir_04  C5     C4     C6     O5        negativ
# ------------------------------------------------------
`.trim();

monomers["GBL"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GBL      GBL 'GAMMA-BUTYROLACTONE                 ' non-polymer        12   6 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GBL
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GBL           O      O    O        -0.500      0.000    0.000    0.000
 GBL           C      C    C         0.000     -1.251    0.027   -0.009
 GBL           OD     O    O2       -0.500     -1.991   -0.976   -0.115
 GBL           CG     C    CH2       0.000     -3.376   -0.736    0.391
 GBL           HGC1   H    H         0.000     -3.480   -0.916    1.463
 GBL           HGC2   H    H         0.000     -4.136   -1.304   -0.148
 GBL           CB     C    CH2       0.000     -3.554    0.772    0.101
 GBL           HBC1   H    H         0.000     -4.120    1.291    0.877
 GBL           HBC2   H    H         0.000     -4.009    0.968   -0.872
 GBL           CA     C    CH2       0.000     -2.095    1.278    0.101
 GBL           HAC2   H    H         0.000     -1.850    1.805    1.025
 GBL           HAC1   H    H         0.000     -1.894    1.930   -0.752
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GBL      O      n/a    C      START
 GBL      C      O      OD     .
 GBL      OD     C      CG     .
 GBL      CG     OD     CB     .
 GBL      HGC1   CG     .      .
 GBL      HGC2   CG     .      .
 GBL      CB     CG     CA     .
 GBL      HBC1   CB     .      .
 GBL      HBC2   CB     .      .
 GBL      CA     CB     HAC1   .
 GBL      HAC2   CA     .      .
 GBL      HAC1   CA     .      END
 GBL      CA     C      .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GBL      CA     C         single      1.510    0.020
 GBL      CA     CB        single      1.524    0.020
 GBL      HAC1   CA        single      1.092    0.020
 GBL      HAC2   CA        single      1.092    0.020
 GBL      C      O         deloc       1.220    0.020
 GBL      OD     C         deloc       1.454    0.020
 GBL      CB     CG        single      1.524    0.020
 GBL      HBC1   CB        single      1.092    0.020
 GBL      HBC2   CB        single      1.092    0.020
 GBL      CG     OD        single      1.426    0.020
 GBL      HGC1   CG        single      1.092    0.020
 GBL      HGC2   CG        single      1.092    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GBL      O      C      OD      119.000    3.000
 GBL      O      C      CA      120.500    3.000
 GBL      OD     C      CA      120.000    3.000
 GBL      C      OD     CG      120.000    3.000
 GBL      OD     CG     HGC1    109.470    3.000
 GBL      OD     CG     HGC2    109.470    3.000
 GBL      OD     CG     CB      109.470    3.000
 GBL      HGC1   CG     HGC2    107.900    3.000
 GBL      HGC1   CG     CB      109.470    3.000
 GBL      HGC2   CG     CB      109.470    3.000
 GBL      CG     CB     HBC1    109.470    3.000
 GBL      CG     CB     HBC2    109.470    3.000
 GBL      CG     CB     CA      111.000    3.000
 GBL      HBC1   CB     HBC2    107.900    3.000
 GBL      HBC1   CB     CA      109.470    3.000
 GBL      HBC2   CB     CA      109.470    3.000
 GBL      CB     CA     HAC2    109.470    3.000
 GBL      CB     CA     HAC1    109.470    3.000
 GBL      CB     CA     C       109.470    3.000
 GBL      HAC2   CA     HAC1    107.900    3.000
 GBL      HAC2   CA     C       109.470    3.000
 GBL      HAC1   CA     C       109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GBL      var_1    O      C      OD     CG       150.000   20.000   1
 GBL      var_2    C      OD     CG     CB        30.000   20.000   1
 GBL      var_3    OD     CG     CB     CA       -30.000   20.000   3
 GBL      var_4    CG     CB     CA     C         30.000   20.000   3
 GBL      var_5    CB     CA     C      O        180.000   20.000   3
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 GBL      plan-1    C         0.020
 GBL      plan-1    CA        0.000
 GBL      plan-1    O         0.000
 GBL      plan-1    OD        0.000
# ------------------------------------------------------
`.trim();

monomers["GPX"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
GPX      GPX '.                                   ' non-polymer        41  31 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_GPX
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 GPX           O3B    O    OP       -0.666      0.000    0.000    0.000
 GPX           PB     P    P         0.000     -0.831   -0.024    1.264
 GPX           O1B    O    OP       -0.666     -1.078    1.393    1.733
 GPX           O2B    O    OP       -0.666     -0.090   -0.789    2.339
 GPX           O3A    O    O2        0.000     -2.240   -0.744    0.968
 GPX           PA     P    P         0.000     -2.971    0.118   -0.179
 GPX           O1A    O    OP       -0.500     -3.180    1.505    0.302
 GPX           O2A    O    OP       -0.500     -2.124    0.140   -1.396
 GPX           "O5'"  O    O2        0.000     -4.395   -0.549   -0.527
 GPX           "C5'"  C    CH2       0.000     -4.991    0.256   -1.544
 GPX           "H5'1" H    H         0.000     -4.343    0.270   -2.423
 GPX           "H5'2" H    H         0.000     -5.120    1.274   -1.172
 GPX           "C4'"  C    CH1       0.000     -6.353   -0.326   -1.923
 GPX           "H4'"  H    H         0.000     -6.238   -1.347   -2.313
 GPX           "C3'"  C    CH1       0.000     -7.053    0.572   -2.967
 GPX           "H3'"  H    H         0.000     -6.668    1.600   -2.929
 GPX           "O3'"  O    O2        0.000     -6.870   -0.005   -4.273
 GPX           "C2'"  C    CH1       0.000     -8.545    0.518   -2.570
 GPX           "H2'"  H    H         0.000     -8.936    1.518   -2.337
 GPX           "O2'"  O    O2        0.000     -9.294   -0.110   -3.640
 GPX           P1     P    P         0.000     -8.349    0.122   -4.949
 GPX           O21    O    OP       -0.500     -8.566   -0.946   -5.955
 GPX           O11    O    OP       -0.500     -8.555    1.477   -5.515
 GPX           "C1'"  C    CH1       0.000     -8.570   -0.403   -1.330
 GPX           "H1'"  H    H         0.000     -8.798   -1.436   -1.626
 GPX           "O4'"  O    O2        0.000     -7.237   -0.320   -0.782
 GPX           N9     N    NR5       0.000     -9.553    0.076   -0.358
 GPX           C4     C    CR56      0.000    -10.865   -0.303   -0.280
 GPX           C5     C    CR56      0.000    -11.412    0.408    0.794
 GPX           N7     N    NRD5      0.000    -10.423    1.177    1.313
 GPX           C8     C    CR15      0.000     -9.328    0.983    0.637
 GPX           H8     H    H         0.000     -8.380    1.468    0.834
 GPX           N3     N    NRD6      0.000    -11.637   -1.146   -0.976
 GPX           C2     C    CR6       0.000    -12.903   -1.319   -0.670
 GPX           N2     N    NH2       0.000    -13.655   -2.194   -1.413
 GPX           HN22   H    H         0.000    -14.633   -2.342   -1.194
 GPX           HN21   H    H         0.000    -13.236   -2.699   -2.186
 GPX           N1     N    NR16      0.000    -13.494   -0.650    0.361
 GPX           HN1    H    H         0.000    -14.501   -0.805    0.569
 GPX           C6     C    CR6       0.000    -12.776    0.213    1.113
 GPX           O6     O    O         0.000    -13.294    0.812    2.040
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 GPX      O3B    n/a    PB     START
 GPX      PB     O3B    O3A    .
 GPX      O1B    PB     .      .
 GPX      O2B    PB     .      .
 GPX      O3A    PB     PA     .
 GPX      PA     O3A    "O5'"  .
 GPX      O1A    PA     .      .
 GPX      O2A    PA     .      .
 GPX      "O5'"  PA     "C5'"  .
 GPX      "C5'"  "O5'"  "C4'"  .
 GPX      "H5'1" "C5'"  .      .
 GPX      "H5'2" "C5'"  .      .
 GPX      "C4'"  "C5'"  "C3'"  .
 GPX      "H4'"  "C4'"  .      .
 GPX      "C3'"  "C4'"  "C2'"  .
 GPX      "H3'"  "C3'"  .      .
 GPX      "O3'"  "C3'"  .      .
 GPX      "C2'"  "C3'"  "C1'"  .
 GPX      "H2'"  "C2'"  .      .
 GPX      "O2'"  "C2'"  P1     .
 GPX      P1     "O2'"  O11    .
 GPX      O21    P1     .      .
 GPX      O11    P1     .      .
 GPX      "C1'"  "C2'"  N9     .
 GPX      "H1'"  "C1'"  .      .
 GPX      "O4'"  "C1'"  .      .
 GPX      N9     "C1'"  C4     .
 GPX      C4     N9     N3     .
 GPX      C5     C4     N7     .
 GPX      N7     C5     C8     .
 GPX      C8     N7     H8     .
 GPX      H8     C8     .      .
 GPX      N3     C4     C2     .
 GPX      C2     N3     N1     .
 GPX      N2     C2     HN21   .
 GPX      HN22   N2     .      .
 GPX      HN21   N2     .      .
 GPX      N1     C2     C6     .
 GPX      HN1    N1     .      .
 GPX      C6     N1     O6     .
 GPX      O6     C6     .      END
 GPX      P1     "O3'"  .    ADD
 GPX      N9     C8     .    ADD
 GPX      C5     C6     .    ADD
 GPX      "C4'"  "O4'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 GPX      O11    P1        deloc       1.510    0.020
 GPX      O21    P1        deloc       1.510    0.020
 GPX      P1     "O3'"     single      1.610    0.020
 GPX      P1     "O2'"     single      1.610    0.020
 GPX      N9     C8        single      1.337    0.020
 GPX      C4     N9        single      1.337    0.020
 GPX      N9     "C1'"     single      1.485    0.020
 GPX      C8     N7        double      1.350    0.020
 GPX      H8     C8        single      1.083    0.020
 GPX      N7     C5        single      1.350    0.020
 GPX      C5     C6        single      1.490    0.020
 GPX      C5     C4        double      1.490    0.020
 GPX      O6     C6        double      1.250    0.020
 GPX      C6     N1        single      1.337    0.020
 GPX      N1     C2        single      1.337    0.020
 GPX      HN1    N1        single      1.040    0.020
 GPX      N2     C2        single      1.355    0.020
 GPX      C2     N3        double      1.350    0.020
 GPX      HN21   N2        single      1.010    0.020
 GPX      HN22   N2        single      1.010    0.020
 GPX      N3     C4        single      1.355    0.020
 GPX      "O3'"  "C3'"     single      1.426    0.020
 GPX      O1A    PA        deloc       1.510    0.020
 GPX      O2A    PA        deloc       1.510    0.020
 GPX      PA     O3A       single      1.610    0.020
 GPX      "O5'"  PA        single      1.610    0.020
 GPX      O3A    PB        single      1.610    0.020
 GPX      "C5'"  "O5'"     single      1.426    0.020
 GPX      O1B    PB        deloc       1.510    0.020
 GPX      O2B    PB        deloc       1.510    0.020
 GPX      PB     O3B       deloc       1.510    0.020
 GPX      "C4'"  "C5'"     single      1.524    0.020
 GPX      "H5'1" "C5'"     single      1.092    0.020
 GPX      "H5'2" "C5'"     single      1.092    0.020
 GPX      "C4'"  "O4'"     single      1.426    0.020
 GPX      "C3'"  "C4'"     single      1.524    0.020
 GPX      "H4'"  "C4'"     single      1.099    0.020
 GPX      "O4'"  "C1'"     single      1.426    0.020
 GPX      "C1'"  "C2'"     single      1.524    0.020
 GPX      "H1'"  "C1'"     single      1.099    0.020
 GPX      "O2'"  "C2'"     single      1.426    0.020
 GPX      "C2'"  "C3'"     single      1.524    0.020
 GPX      "H2'"  "C2'"     single      1.099    0.020
 GPX      "H3'"  "C3'"     single      1.099    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 GPX      O3B    PB     O1B     119.900    3.000
 GPX      O3B    PB     O2B     119.900    3.000
 GPX      O3B    PB     O3A     108.200    3.000
 GPX      O1B    PB     O2B     119.900    3.000
 GPX      O1B    PB     O3A     108.200    3.000
 GPX      O2B    PB     O3A     108.200    3.000
 GPX      PB     O3A    PA      120.500    3.000
 GPX      O3A    PA     O1A     108.200    3.000
 GPX      O3A    PA     O2A     108.200    3.000
 GPX      O3A    PA     "O5'"   102.600    3.000
 GPX      O1A    PA     O2A     119.900    3.000
 GPX      O1A    PA     "O5'"   108.200    3.000
 GPX      O2A    PA     "O5'"   108.200    3.000
 GPX      PA     "O5'"  "C5'"   120.500    3.000
 GPX      "O5'"  "C5'"  "H5'1"  109.470    3.000
 GPX      "O5'"  "C5'"  "H5'2"  109.470    3.000
 GPX      "O5'"  "C5'"  "C4'"   109.470    3.000
 GPX      "H5'1" "C5'"  "H5'2"  107.900    3.000
 GPX      "H5'1" "C5'"  "C4'"   109.470    3.000
 GPX      "H5'2" "C5'"  "C4'"   109.470    3.000
 GPX      "C5'"  "C4'"  "H4'"   108.340    3.000
 GPX      "C5'"  "C4'"  "C3'"   111.000    3.000
 GPX      "C5'"  "C4'"  "O4'"   109.470    3.000
 GPX      "H4'"  "C4'"  "C3'"   108.340    3.000
 GPX      "H4'"  "C4'"  "O4'"   109.470    3.000
 GPX      "C3'"  "C4'"  "O4'"   109.470    3.000
 GPX      "C4'"  "C3'"  "H3'"   108.340    3.000
 GPX      "C4'"  "C3'"  "O3'"   109.470    3.000
 GPX      "C4'"  "C3'"  "C2'"   111.000    3.000
 GPX      "H3'"  "C3'"  "O3'"   109.470    3.000
 GPX      "H3'"  "C3'"  "C2'"   108.340    3.000
 GPX      "O3'"  "C3'"  "C2'"   109.470    3.000
 GPX      "C3'"  "O3'"  P1      120.500    3.000
 GPX      "C3'"  "C2'"  "H2'"   108.340    3.000
 GPX      "C3'"  "C2'"  "O2'"   109.470    3.000
 GPX      "C3'"  "C2'"  "C1'"   111.000    3.000
 GPX      "H2'"  "C2'"  "O2'"   109.470    3.000
 GPX      "H2'"  "C2'"  "C1'"   108.340    3.000
 GPX      "O2'"  "C2'"  "C1'"   109.470    3.000
 GPX      "C2'"  "O2'"  P1      120.500    3.000
 GPX      "O2'"  P1     O21     108.200    3.000
 GPX      "O2'"  P1     O11     108.200    3.000
 GPX      "O2'"  P1     "O3'"   102.600    3.000
 GPX      O21    P1     O11     119.900    3.000
 GPX      O21    P1     "O3'"   108.200    3.000
 GPX      O11    P1     "O3'"   108.200    3.000
 GPX      "C2'"  "C1'"  "H1'"   108.340    3.000
 GPX      "C2'"  "C1'"  "O4'"   109.470    3.000
 GPX      "C2'"  "C1'"  N9      109.470    3.000
 GPX      "H1'"  "C1'"  "O4'"   109.470    3.000
 GPX      "H1'"  "C1'"  N9      109.470    3.000
 GPX      "O4'"  "C1'"  N9      109.470    3.000
 GPX      "C1'"  "O4'"  "C4'"   111.800    3.000
 GPX      "C1'"  N9     C4      126.000    3.000
 GPX      "C1'"  N9     C8      126.000    3.000
 GPX      C4     N9     C8      108.000    3.000
 GPX      N9     C4     C5      108.000    3.000
 GPX      N9     C4     N3      132.000    3.000
 GPX      C5     C4     N3      120.000    3.000
 GPX      C4     C5     N7      108.000    3.000
 GPX      C4     C5     C6      120.000    3.000
 GPX      N7     C5     C6      132.000    3.000
 GPX      C5     N7     C8      108.000    3.000
 GPX      N7     C8     H8      126.000    3.000
 GPX      N7     C8     N9      108.000    3.000
 GPX      H8     C8     N9      126.000    3.000
 GPX      C4     N3     C2      120.000    3.000
 GPX      N3     C2     N2      120.000    3.000
 GPX      N3     C2     N1      120.000    3.000
 GPX      N2     C2     N1      120.000    3.000
 GPX      C2     N2     HN22    120.000    3.000
 GPX      C2     N2     HN21    120.000    3.000
 GPX      HN22   N2     HN21    120.000    3.000
 GPX      C2     N1     HN1     120.000    3.000
 GPX      C2     N1     C6      120.000    3.000
 GPX      HN1    N1     C6      120.000    3.000
 GPX      N1     C6     O6      120.000    3.000
 GPX      N1     C6     C5      120.000    3.000
 GPX      O6     C6     C5      120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 GPX      var_1    O3B    PB     O3A    PA       -60.014   20.000   1
 GPX      var_2    PB     O3A    PA     "O5'"    179.983   20.000   1
 GPX      var_3    O3A    PA     "O5'"  "C5'"    179.976   20.000   1
 GPX      var_4    PA     "O5'"  "C5'"  "C4'"    179.994   20.000   1
 GPX      var_5    "O5'"  "C5'"  "C4'"  "C3'"    176.906   20.000   3
 GPX      var_6    "C5'"  "C4'"  "O4'"  "C1'"    150.000   20.000   1
 GPX      var_7    "C5'"  "C4'"  "C3'"  "C2'"   -150.000   20.000   3
 GPX      var_8    "C4'"  "C3'"  "O3'"  P1       150.000   20.000   1
 GPX      var_9    "C4'"  "C3'"  "C2'"  "C1'"      0.000   20.000   3
 GPX      var_10   "C3'"  "C2'"  "O2'"  P1       -30.000   20.000   1
 GPX      var_11   "C2'"  "O2'"  P1     O11      -90.000   20.000   1
 GPX      var_12   "O2'"  P1     "O3'"  "C3'"    -30.000   20.000   1
 GPX      var_13   "C3'"  "C2'"  "C1'"  N9       150.000   20.000   3
 GPX      var_14   "C2'"  "C1'"  "O4'"  "C4'"    -30.000   20.000   1
 GPX      var_15   "C2'"  "C1'"  N9     C4        91.512   20.000   1
 GPX      CONST_1  "C1'"  N9     C8     N7       180.000    0.000   0
 GPX      CONST_2  "C1'"  N9     C4     N3         0.000    0.000   0
 GPX      CONST_3  N9     C4     C5     N7         0.000    0.000   0
 GPX      CONST_4  C4     C5     C6     N1         0.000    0.000   0
 GPX      CONST_5  C4     C5     N7     C8         0.000    0.000   0
 GPX      CONST_6  C5     N7     C8     N9         0.000    0.000   0
 GPX      CONST_7  N9     C4     N3     C2       180.000    0.000   0
 GPX      CONST_8  C4     N3     C2     N1         0.000    0.000   0
 GPX      CONST_9  N3     C2     N2     HN21       0.040    0.000   0
 GPX      CONST_10 N3     C2     N1     C6         0.000    0.000   0
 GPX      CONST_11 C2     N1     C6     O6       180.000    0.000   0
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 GPX      chir_01  "C4'"  "C5'"  "O4'"  "C3'"     negativ
 GPX      chir_02  "C1'"  N9     "O4'"  "C2'"     positiv
 GPX      chir_03  "C2'"  "C1'"  "O2'"  "C3'"     positiv
 GPX      chir_04  "C3'"  "O3'"  "C4'"  "C2'"     positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 GPX      plan-1    N9        0.020
 GPX      plan-1    C8        0.020
 GPX      plan-1    C4        0.020
 GPX      plan-1    "C1'"     0.020
 GPX      plan-1    N7        0.020
 GPX      plan-1    H8        0.020
 GPX      plan-1    C5        0.020
 GPX      plan-1    C6        0.020
 GPX      plan-1    N1        0.020
 GPX      plan-1    C2        0.020
 GPX      plan-1    N3        0.020
 GPX      plan-1    O6        0.020
 GPX      plan-1    HN1       0.020
 GPX      plan-1    N2        0.020
 GPX      plan-1    HN22      0.020
 GPX      plan-1    HN21      0.020
 GPX      plan-2    N2        0.020
 GPX      plan-2    C2        0.020
 GPX      plan-2    HN21      0.020
 GPX      plan-2    HN22      0.020
# ------------------------------------------------------
`.trim();

monomers["HTO"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
HTO      HTO 'HEPTANE-1,2,3-TRIOL                 ' non-polymer        26  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_HTO
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 HTO           O3     O    OH1       0.000      0.000    0.000    0.000
 HTO           HO3    H    H         0.000      0.569    0.683    0.381
 HTO           C3     C    CH1       0.000     -1.304    0.095    0.574
 HTO           H3     H    H         0.000     -1.951   -0.682    0.142
 HTO           C2     C    CH1       0.000     -1.212   -0.103    2.088
 HTO           H2     H    H         0.000     -2.216   -0.030    2.528
 HTO           O2     O    OH1       0.000     -0.372    0.906    2.649
 HTO           HO2    H    H         0.000      0.511    0.841    2.261
 HTO           C1     C    CH2       0.000     -0.623   -1.483    2.388
 HTO           H11    H    H         0.000      0.374   -1.555    1.948
 HTO           H12    H    H         0.000     -1.266   -2.253    1.958
 HTO           O1     O    OH1       0.000     -0.536   -1.667    3.801
 HTO           HO1    H    H         0.000     -0.163   -2.539    3.989
 HTO           C4     C    CH2       0.000     -1.894    1.473    0.275
 HTO           H41    H    H         0.000     -1.251    2.244    0.705
 HTO           H42    H    H         0.000     -2.891    1.545    0.714
 HTO           C5     C    CH2       0.000     -1.986    1.671   -1.240
 HTO           H51    H    H         0.000     -2.628    0.899   -1.668
 HTO           H52    H    H         0.000     -0.988    1.598   -1.677
 HTO           C6     C    CH2       0.000     -2.576    3.050   -1.539
 HTO           H61    H    H         0.000     -1.934    3.821   -1.109
 HTO           H62    H    H         0.000     -3.573    3.122   -1.100
 HTO           C7     C    CH3       0.000     -2.669    3.248   -3.054
 HTO           H73    H    H         0.000     -1.701    3.178   -3.483
 HTO           H72    H    H         0.000     -3.293    2.501   -3.474
 HTO           H71    H    H         0.000     -3.077    4.204   -3.265
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 HTO      O3     n/a    C3     START
 HTO      HO3    O3     .      .
 HTO      C3     O3     C4     .
 HTO      H3     C3     .      .
 HTO      C2     C3     C1     .
 HTO      H2     C2     .      .
 HTO      O2     C2     HO2    .
 HTO      HO2    O2     .      .
 HTO      C1     C2     O1     .
 HTO      H11    C1     .      .
 HTO      H12    C1     .      .
 HTO      O1     C1     HO1    .
 HTO      HO1    O1     .      .
 HTO      C4     C3     C5     .
 HTO      H41    C4     .      .
 HTO      H42    C4     .      .
 HTO      C5     C4     C6     .
 HTO      H51    C5     .      .
 HTO      H52    C5     .      .
 HTO      C6     C5     C7     .
 HTO      H61    C6     .      .
 HTO      H62    C6     .      .
 HTO      C7     C6     H71    .
 HTO      H73    C7     .      .
 HTO      H72    C7     .      .
 HTO      H71    C7     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 HTO      O1     C1        single      1.432    0.020
 HTO      C1     C2        single      1.524    0.020
 HTO      H11    C1        single      1.092    0.020
 HTO      H12    C1        single      1.092    0.020
 HTO      HO1    O1        single      0.967    0.020
 HTO      O2     C2        single      1.432    0.020
 HTO      C2     C3        single      1.524    0.020
 HTO      H2     C2        single      1.099    0.020
 HTO      HO2    O2        single      0.967    0.020
 HTO      C3     O3        single      1.432    0.020
 HTO      C4     C3        single      1.524    0.020
 HTO      H3     C3        single      1.099    0.020
 HTO      HO3    O3        single      0.967    0.020
 HTO      C5     C4        single      1.524    0.020
 HTO      H41    C4        single      1.092    0.020
 HTO      H42    C4        single      1.092    0.020
 HTO      C6     C5        single      1.524    0.020
 HTO      H51    C5        single      1.092    0.020
 HTO      H52    C5        single      1.092    0.020
 HTO      C7     C6        single      1.513    0.020
 HTO      H61    C6        single      1.092    0.020
 HTO      H62    C6        single      1.092    0.020
 HTO      H71    C7        single      1.059    0.020
 HTO      H72    C7        single      1.059    0.020
 HTO      H73    C7        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 HTO      HO3    O3     C3      109.470    3.000
 HTO      O3     C3     H3      109.470    3.000
 HTO      O3     C3     C2      109.470    3.000
 HTO      O3     C3     C4      109.470    3.000
 HTO      H3     C3     C2      108.340    3.000
 HTO      H3     C3     C4      108.340    3.000
 HTO      C2     C3     C4      111.000    3.000
 HTO      C3     C2     H2      108.340    3.000
 HTO      C3     C2     O2      109.470    3.000
 HTO      C3     C2     C1      111.000    3.000
 HTO      H2     C2     O2      109.470    3.000
 HTO      H2     C2     C1      108.340    3.000
 HTO      O2     C2     C1      109.470    3.000
 HTO      C2     O2     HO2     109.470    3.000
 HTO      C2     C1     H11     109.470    3.000
 HTO      C2     C1     H12     109.470    3.000
 HTO      C2     C1     O1      109.470    3.000
 HTO      H11    C1     H12     107.900    3.000
 HTO      H11    C1     O1      109.470    3.000
 HTO      H12    C1     O1      109.470    3.000
 HTO      C1     O1     HO1     109.470    3.000
 HTO      C3     C4     H41     109.470    3.000
 HTO      C3     C4     H42     109.470    3.000
 HTO      C3     C4     C5      111.000    3.000
 HTO      H41    C4     H42     107.900    3.000
 HTO      H41    C4     C5      109.470    3.000
 HTO      H42    C4     C5      109.470    3.000
 HTO      C4     C5     H51     109.470    3.000
 HTO      C4     C5     H52     109.470    3.000
 HTO      C4     C5     C6      111.000    3.000
 HTO      H51    C5     H52     107.900    3.000
 HTO      H51    C5     C6      109.470    3.000
 HTO      H52    C5     C6      109.470    3.000
 HTO      C5     C6     H61     109.470    3.000
 HTO      C5     C6     H62     109.470    3.000
 HTO      C5     C6     C7      111.000    3.000
 HTO      H61    C6     H62     107.900    3.000
 HTO      H61    C6     C7      109.470    3.000
 HTO      H62    C6     C7      109.470    3.000
 HTO      C6     C7     H73     109.470    3.000
 HTO      C6     C7     H72     109.470    3.000
 HTO      C6     C7     H71     109.470    3.000
 HTO      H73    C7     H72     109.470    3.000
 HTO      H73    C7     H71     109.470    3.000
 HTO      H72    C7     H71     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 HTO      var_1    HO3    O3     C3     C4        60.063   20.000   1
 HTO      var_2    O3     C3     C2     C1       -60.013   20.000   3
 HTO      var_3    C3     C2     O2     HO2      -59.977   20.000   1
 HTO      var_4    C3     C2     C1     O1       179.974   20.000   3
 HTO      var_5    C2     C1     O1     HO1     -179.970   20.000   1
 HTO      var_6    O3     C3     C4     C5        59.966   20.000   3
 HTO      var_7    C3     C4     C5     C6       179.999   20.000   3
 HTO      var_8    C4     C5     C6     C7       180.000   20.000   3
 HTO      var_9    C5     C6     C7     H71     -179.974   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 HTO      chir_01  C2     C1     O2     C3        negativ
 HTO      chir_02  C3     C2     O3     C4        positiv
# ------------------------------------------------------
`.trim();

monomers["HTG"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
HTG      HTG 'HEPTYL 1-THIOHEXOPYRANOSIDE         ' non-polymer        45  19 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_HTG
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 HTG           O6     O    OH1       0.000      0.000    0.000    0.000
 HTG           HO6    H    H         0.000      0.902   -0.104    0.333
 HTG           C6     C    CH2       0.000     -0.497    1.288    0.369
 HTG           H61    H    H         0.000      0.142    2.061   -0.061
 HTG           H62    H    H         0.000     -0.496    1.380    1.457
 HTG           C5     C    CH1       0.000     -1.924    1.453   -0.157
 HTG           H5     H    H         0.000     -1.938    1.270   -1.240
 HTG           C4     C    CH1       0.000     -2.407    2.878    0.123
 HTG           H4     H    H         0.000     -2.416    3.057    1.207
 HTG           O4     O    OH1       0.000     -1.529    3.813   -0.508
 HTG           HO4    H    H         0.000     -1.835    4.713   -0.331
 HTG           C3     C    CH1       0.000     -3.825    3.045   -0.437
 HTG           H3     H    H         0.000     -3.800    2.970   -1.533
 HTG           O3     O    OH1       0.000     -4.344    4.320   -0.054
 HTG           HO3    H    H         0.000     -5.238    4.423   -0.408
 HTG           C2     C    CH1       0.000     -4.710    1.932    0.136
 HTG           H2     H    H         0.000     -4.818    2.069    1.221
 HTG           O2     O    OH1       0.000     -5.996    1.978   -0.485
 HTG           HO2    H    H         0.000     -6.553    1.275   -0.123
 HTG           O5     O    O2        0.000     -2.781    0.516    0.493
 HTG           C1     C    CH1       0.000     -4.054    0.578   -0.147
 HTG           H1     H    H         0.000     -3.924    0.454   -1.231
 HTG           S1     S    S2        0.000     -5.114   -0.750    0.488
 HTG           "C1'"  C    CH2       0.000     -4.199   -2.197   -0.110
 HTG           "H1'1" H    H         0.000     -3.192   -2.190    0.314
 HTG           "H1'2" H    H         0.000     -4.134   -2.161   -1.199
 HTG           "C2'"  C    CH2       0.000     -4.925   -3.473    0.319
 HTG           "H2'1" H    H         0.000     -5.932   -3.477   -0.104
 HTG           "H2'2" H    H         0.000     -4.990   -3.507    1.408
 HTG           "C3'"  C    CH2       0.000     -4.154   -4.694   -0.186
 HTG           "H3'1" H    H         0.000     -3.147   -4.687    0.237
 HTG           "H3'2" H    H         0.000     -4.090   -4.658   -1.275
 HTG           "C4'"  C    CH2       0.000     -4.880   -5.970    0.243
 HTG           "H4'1" H    H         0.000     -5.887   -5.975   -0.180
 HTG           "H4'2" H    H         0.000     -4.944   -6.003    1.333
 HTG           "C5'"  C    CH2       0.000     -4.107   -7.191   -0.261
 HTG           "H5'1" H    H         0.000     -3.101   -7.184    0.162
 HTG           "H5'2" H    H         0.000     -4.042   -7.155   -1.351
 HTG           "C6'"  C    CH2       0.000     -4.835   -8.467    0.167
 HTG           "H6'1" H    H         0.000     -5.841   -8.471   -0.257
 HTG           "H6'2" H    H         0.000     -4.900   -8.501    1.256
 HTG           "C7'"  C    CH3       0.000     -4.062   -9.688   -0.338
 HTG           "H7'3" H    H         0.000     -3.084   -9.685    0.071
 HTG           "H7'2" H    H         0.000     -4.562  -10.574   -0.041
 HTG           "H7'1" H    H         0.000     -3.999   -9.658   -1.396
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 HTG      O6     n/a    C6     START
 HTG      HO6    O6     .      .
 HTG      C6     O6     C5     .
 HTG      H61    C6     .      .
 HTG      H62    C6     .      .
 HTG      C5     C6     O5     .
 HTG      H5     C5     .      .
 HTG      C4     C5     C3     .
 HTG      H4     C4     .      .
 HTG      O4     C4     HO4    .
 HTG      HO4    O4     .      .
 HTG      C3     C4     C2     .
 HTG      H3     C3     .      .
 HTG      O3     C3     HO3    .
 HTG      HO3    O3     .      .
 HTG      C2     C3     O2     .
 HTG      H2     C2     .      .
 HTG      O2     C2     HO2    .
 HTG      HO2    O2     .      .
 HTG      O5     C5     C1     .
 HTG      C1     O5     S1     .
 HTG      H1     C1     .      .
 HTG      S1     C1     "C1'"  .
 HTG      "C1'"  S1     "C2'"  .
 HTG      "H1'1" "C1'"  .      .
 HTG      "H1'2" "C1'"  .      .
 HTG      "C2'"  "C1'"  "C3'"  .
 HTG      "H2'1" "C2'"  .      .
 HTG      "H2'2" "C2'"  .      .
 HTG      "C3'"  "C2'"  "C4'"  .
 HTG      "H3'1" "C3'"  .      .
 HTG      "H3'2" "C3'"  .      .
 HTG      "C4'"  "C3'"  "C5'"  .
 HTG      "H4'1" "C4'"  .      .
 HTG      "H4'2" "C4'"  .      .
 HTG      "C5'"  "C4'"  "C6'"  .
 HTG      "H5'1" "C5'"  .      .
 HTG      "H5'2" "C5'"  .      .
 HTG      "C6'"  "C5'"  "C7'"  .
 HTG      "H6'1" "C6'"  .      .
 HTG      "H6'2" "C6'"  .      .
 HTG      "C7'"  "C6'"  "H7'1" .
 HTG      "H7'3" "C7'"  .      .
 HTG      "H7'2" "C7'"  .      .
 HTG      "H7'1" "C7'"  .      END
 HTG      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 HTG      S1     C1        single      1.765    0.020
 HTG      C1     C2        single      1.524    0.020
 HTG      C1     O5        single      1.426    0.020
 HTG      H1     C1        single      1.099    0.020
 HTG      "C1'"  S1        single      1.762    0.020
 HTG      O2     C2        single      1.432    0.020
 HTG      C2     C3        single      1.524    0.020
 HTG      H2     C2        single      1.099    0.020
 HTG      HO2    O2        single      0.967    0.020
 HTG      O3     C3        single      1.432    0.020
 HTG      C3     C4        single      1.524    0.020
 HTG      H3     C3        single      1.099    0.020
 HTG      HO3    O3        single      0.967    0.020
 HTG      O4     C4        single      1.432    0.020
 HTG      C4     C5        single      1.524    0.020
 HTG      H4     C4        single      1.099    0.020
 HTG      HO4    O4        single      0.967    0.020
 HTG      O5     C5        single      1.426    0.020
 HTG      C5     C6        single      1.524    0.020
 HTG      H5     C5        single      1.099    0.020
 HTG      C6     O6        single      1.432    0.020
 HTG      H61    C6        single      1.092    0.020
 HTG      H62    C6        single      1.092    0.020
 HTG      HO6    O6        single      0.967    0.020
 HTG      "C2'"  "C1'"     single      1.524    0.020
 HTG      "H1'1" "C1'"     single      1.092    0.020
 HTG      "H1'2" "C1'"     single      1.092    0.020
 HTG      "C3'"  "C2'"     single      1.524    0.020
 HTG      "H2'1" "C2'"     single      1.092    0.020
 HTG      "H2'2" "C2'"     single      1.092    0.020
 HTG      "C4'"  "C3'"     single      1.524    0.020
 HTG      "H3'1" "C3'"     single      1.092    0.020
 HTG      "H3'2" "C3'"     single      1.092    0.020
 HTG      "C5'"  "C4'"     single      1.524    0.020
 HTG      "H4'1" "C4'"     single      1.092    0.020
 HTG      "H4'2" "C4'"     single      1.092    0.020
 HTG      "C6'"  "C5'"     single      1.524    0.020
 HTG      "H5'1" "C5'"     single      1.092    0.020
 HTG      "H5'2" "C5'"     single      1.092    0.020
 HTG      "C7'"  "C6'"     single      1.513    0.020
 HTG      "H6'1" "C6'"     single      1.092    0.020
 HTG      "H6'2" "C6'"     single      1.092    0.020
 HTG      "H7'1" "C7'"     single      1.059    0.020
 HTG      "H7'2" "C7'"     single      1.059    0.020
 HTG      "H7'3" "C7'"     single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 HTG      HO6    O6     C6      109.470    3.000
 HTG      O6     C6     H61     109.470    3.000
 HTG      O6     C6     H62     109.470    3.000
 HTG      O6     C6     C5      109.470    3.000
 HTG      H61    C6     H62     107.900    3.000
 HTG      H61    C6     C5      109.470    3.000
 HTG      H62    C6     C5      109.470    3.000
 HTG      C6     C5     H5      108.340    3.000
 HTG      C6     C5     C4      111.000    3.000
 HTG      C6     C5     O5      109.470    3.000
 HTG      H5     C5     C4      108.340    3.000
 HTG      H5     C5     O5      109.470    3.000
 HTG      C4     C5     O5      109.470    3.000
 HTG      C5     C4     H4      108.340    3.000
 HTG      C5     C4     O4      109.470    3.000
 HTG      C5     C4     C3      111.000    3.000
 HTG      H4     C4     O4      109.470    3.000
 HTG      H4     C4     C3      108.340    3.000
 HTG      O4     C4     C3      109.470    3.000
 HTG      C4     O4     HO4     109.470    3.000
 HTG      C4     C3     H3      108.340    3.000
 HTG      C4     C3     O3      109.470    3.000
 HTG      C4     C3     C2      111.000    3.000
 HTG      H3     C3     O3      109.470    3.000
 HTG      H3     C3     C2      108.340    3.000
 HTG      O3     C3     C2      109.470    3.000
 HTG      C3     O3     HO3     109.470    3.000
 HTG      C3     C2     H2      108.340    3.000
 HTG      C3     C2     O2      109.470    3.000
 HTG      C3     C2     C1      111.000    3.000
 HTG      H2     C2     O2      109.470    3.000
 HTG      H2     C2     C1      108.340    3.000
 HTG      O2     C2     C1      109.470    3.000
 HTG      C2     O2     HO2     109.470    3.000
 HTG      C5     O5     C1      111.800    3.000
 HTG      O5     C1     H1      109.470    3.000
 HTG      O5     C1     S1      109.500    3.000
 HTG      O5     C1     C2      109.470    3.000
 HTG      H1     C1     S1      109.500    3.000
 HTG      H1     C1     C2      108.340    3.000
 HTG      S1     C1     C2      109.500    3.000
 HTG      C1     S1     "C1'"   100.035    3.000
 HTG      S1     "C1'"  "H1'1"  109.500    3.000
 HTG      S1     "C1'"  "H1'2"  109.500    3.000
 HTG      S1     "C1'"  "C2'"   109.500    3.000
 HTG      "H1'1" "C1'"  "H1'2"  107.900    3.000
 HTG      "H1'1" "C1'"  "C2'"   109.470    3.000
 HTG      "H1'2" "C1'"  "C2'"   109.470    3.000
 HTG      "C1'"  "C2'"  "H2'1"  109.470    3.000
 HTG      "C1'"  "C2'"  "H2'2"  109.470    3.000
 HTG      "C1'"  "C2'"  "C3'"   111.000    3.000
 HTG      "H2'1" "C2'"  "H2'2"  107.900    3.000
 HTG      "H2'1" "C2'"  "C3'"   109.470    3.000
 HTG      "H2'2" "C2'"  "C3'"   109.470    3.000
 HTG      "C2'"  "C3'"  "H3'1"  109.470    3.000
 HTG      "C2'"  "C3'"  "H3'2"  109.470    3.000
 HTG      "C2'"  "C3'"  "C4'"   111.000    3.000
 HTG      "H3'1" "C3'"  "H3'2"  107.900    3.000
 HTG      "H3'1" "C3'"  "C4'"   109.470    3.000
 HTG      "H3'2" "C3'"  "C4'"   109.470    3.000
 HTG      "C3'"  "C4'"  "H4'1"  109.470    3.000
 HTG      "C3'"  "C4'"  "H4'2"  109.470    3.000
 HTG      "C3'"  "C4'"  "C5'"   111.000    3.000
 HTG      "H4'1" "C4'"  "H4'2"  107.900    3.000
 HTG      "H4'1" "C4'"  "C5'"   109.470    3.000
 HTG      "H4'2" "C4'"  "C5'"   109.470    3.000
 HTG      "C4'"  "C5'"  "H5'1"  109.470    3.000
 HTG      "C4'"  "C5'"  "H5'2"  109.470    3.000
 HTG      "C4'"  "C5'"  "C6'"   111.000    3.000
 HTG      "H5'1" "C5'"  "H5'2"  107.900    3.000
 HTG      "H5'1" "C5'"  "C6'"   109.470    3.000
 HTG      "H5'2" "C5'"  "C6'"   109.470    3.000
 HTG      "C5'"  "C6'"  "H6'1"  109.470    3.000
 HTG      "C5'"  "C6'"  "H6'2"  109.470    3.000
 HTG      "C5'"  "C6'"  "C7'"   111.000    3.000
 HTG      "H6'1" "C6'"  "H6'2"  107.900    3.000
 HTG      "H6'1" "C6'"  "C7'"   109.470    3.000
 HTG      "H6'2" "C6'"  "C7'"   109.470    3.000
 HTG      "C6'"  "C7'"  "H7'3"  109.470    3.000
 HTG      "C6'"  "C7'"  "H7'2"  109.470    3.000
 HTG      "C6'"  "C7'"  "H7'1"  109.470    3.000
 HTG      "H7'3" "C7'"  "H7'2"  109.470    3.000
 HTG      "H7'3" "C7'"  "H7'1"  109.470    3.000
 HTG      "H7'2" "C7'"  "H7'1"  109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 HTG      var_1    HO6    O6     C6     C5      -179.968   20.000   1
 HTG      var_2    O6     C6     C5     O5        64.967   20.000   3
 HTG      var_3    C6     C5     C4     C3       180.000   20.000   3
 HTG      var_4    C5     C4     O4     HO4      179.982   20.000   1
 HTG      var_5    C5     C4     C3     C2        60.000   20.000   3
 HTG      var_6    C4     C3     O3     HO3     -179.995   20.000   1
 HTG      var_7    C4     C3     C2     O2       180.000   20.000   3
 HTG      var_8    C3     C2     O2     HO2      179.981   20.000   1
 HTG      var_9    C6     C5     O5     C1       180.000   20.000   1
 HTG      var_10   C5     O5     C1     S1       180.000   20.000   1
 HTG      var_11   O5     C1     C2     C3        60.000   20.000   3
 HTG      var_12   O5     C1     S1     "C1'"    -64.828   20.000   1
 HTG      var_13   C1     S1     "C1'"  "C2'"   -179.991   20.000   1
 HTG      var_14   S1     "C1'"  "C2'"  "C3'"    179.981   20.000   3
 HTG      var_15   "C1'"  "C2'"  "C3'"  "C4'"    179.966   20.000   3
 HTG      var_16   "C2'"  "C3'"  "C4'"  "C5'"   -179.979   20.000   3
 HTG      var_17   "C3'"  "C4'"  "C5'"  "C6'"   -179.945   20.000   3
 HTG      var_18   "C4'"  "C5'"  "C6'"  "C7'"    180.000   20.000   3
 HTG      var_19   "C5'"  "C6'"  "C7'"  "H7'1"   -60.093   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 HTG      chir_01  C1     S1     C2     O5        negativ
 HTG      chir_02  C2     C1     O2     C3        positiv
 HTG      chir_03  C3     C2     O3     C4        negativ
 HTG      chir_04  C4     C3     O4     C5        positiv
 HTG      chir_05  C5     C4     O5     C6        positiv
# ------------------------------------------------------
`.trim();

monomers["B7G"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
B7G      B7G 'HEPTYL-BETA-D-GLUCOPYRANOSIDE       ' non-polymer        45  19 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_B7G
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 B7G           O6     O    OH1       0.000      0.000    0.000    0.000
 B7G           HO6    H    H         0.000      0.801   -0.328   -0.430
 B7G           C6     C    CH2       0.000      0.004   -0.391    1.374
 B7G           H61    H    H         0.000      0.883    0.028    1.868
 B7G           H62    H    H         0.000      0.035   -1.481    1.441
 B7G           C5     C    CH1       0.000     -1.262    0.127    2.057
 B7G           H51    H    H         0.000     -1.291    1.223    1.987
 B7G           C4     C    CH1       0.000     -1.251   -0.287    3.530
 B7G           H41    H    H         0.000     -1.245   -1.383    3.603
 B7G           O4     O    OH1       0.000     -0.087    0.240    4.167
 B7G           HO4    H    H         0.000     -0.082   -0.024    5.097
 B7G           C3     C    CH1       0.000     -2.506    0.264    4.214
 B7G           H31    H    H         0.000     -2.463    1.362    4.234
 B7G           O3     O    OH1       0.000     -2.585   -0.237    5.549
 B7G           HO3    H    H         0.000     -3.378    0.113    5.977
 B7G           C2     C    CH1       0.000     -3.736   -0.187    3.417
 B7G           H21    H    H         0.000     -3.837   -1.279    3.485
 B7G           O2     O    OH1       0.000     -4.906    0.436    3.950
 B7G           HO2    H    H         0.000     -5.680    0.150    3.447
 B7G           C1     C    CH1       0.000     -3.559    0.222    1.954
 B7G           H11    H    H         0.000     -3.433    1.312    1.892
 B7G           O5     O    O2        0.000     -2.409   -0.419    1.410
 B7G           O1     O    O2        0.000     -4.716   -0.166    1.208
 B7G           C7     C    CH2       0.000     -4.494    0.243   -0.141
 B7G           H71    H    H         0.000     -3.600   -0.250   -0.528
 B7G           H72    H    H         0.000     -4.355    1.326   -0.175
 B7G           C8     C    CH2       0.000     -5.702   -0.143   -0.997
 B7G           H81    H    H         0.000     -6.595    0.351   -0.608
 B7G           H82    H    H         0.000     -5.841   -1.226   -0.961
 B7G           C9     C    CH2       0.000     -5.464    0.294   -2.443
 B7G           H91    H    H         0.000     -4.570   -0.200   -2.830
 B7G           H92    H    H         0.000     -5.324    1.377   -2.478
 B7G           C10    C    CH2       0.000     -6.673   -0.092   -3.298
 B7G           H101   H    H         0.000     -7.566    0.401   -2.909
 B7G           H102   H    H         0.000     -6.812   -1.175   -3.262
 B7G           C11    C    CH2       0.000     -6.435    0.345   -4.745
 B7G           H111   H    H         0.000     -5.541   -0.148   -5.131
 B7G           H112   H    H         0.000     -6.296    1.428   -4.778
 B7G           C12    C    CH2       0.000     -7.642   -0.043   -5.601
 B7G           H121   H    H         0.000     -8.536    0.450   -5.211
 B7G           H122   H    H         0.000     -7.780   -1.125   -5.564
 B7G           C13    C    CH3       0.000     -7.406    0.395   -7.046
 B7G           H133   H    H         0.000     -7.271    1.446   -7.083
 B7G           H132   H    H         0.000     -6.540   -0.084   -7.426
 B7G           H131   H    H         0.000     -8.243    0.128   -7.641
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 B7G      O6     n/a    C6     START
 B7G      HO6    O6     .      .
 B7G      C6     O6     C5     .
 B7G      H61    C6     .      .
 B7G      H62    C6     .      .
 B7G      C5     C6     C4     .
 B7G      H51    C5     .      .
 B7G      C4     C5     C3     .
 B7G      H41    C4     .      .
 B7G      O4     C4     HO4    .
 B7G      HO4    O4     .      .
 B7G      C3     C4     C2     .
 B7G      H31    C3     .      .
 B7G      O3     C3     HO3    .
 B7G      HO3    O3     .      .
 B7G      C2     C3     C1     .
 B7G      H21    C2     .      .
 B7G      O2     C2     HO2    .
 B7G      HO2    O2     .      .
 B7G      C1     C2     O1     .
 B7G      H11    C1     .      .
 B7G      O5     C1     .      .
 B7G      O1     C1     C7     .
 B7G      C7     O1     C8     .
 B7G      H71    C7     .      .
 B7G      H72    C7     .      .
 B7G      C8     C7     C9     .
 B7G      H81    C8     .      .
 B7G      H82    C8     .      .
 B7G      C9     C8     C10    .
 B7G      H91    C9     .      .
 B7G      H92    C9     .      .
 B7G      C10    C9     C11    .
 B7G      H101   C10    .      .
 B7G      H102   C10    .      .
 B7G      C11    C10    C12    .
 B7G      H111   C11    .      .
 B7G      H112   C11    .      .
 B7G      C12    C11    C13    .
 B7G      H121   C12    .      .
 B7G      H122   C12    .      .
 B7G      C13    C12    H131   .
 B7G      H133   C13    .      .
 B7G      H132   C13    .      .
 B7G      H131   C13    .      END
 B7G      C5     O5     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 B7G      C5     O5        single      1.426    0.020
 B7G      C4     C5        single      1.524    0.020
 B7G      C5     C6        single      1.524    0.020
 B7G      H51    C5        single      1.099    0.020
 B7G      O5     C1        single      1.426    0.020
 B7G      C1     C2        single      1.524    0.020
 B7G      O1     C1        single      1.426    0.020
 B7G      H11    C1        single      1.099    0.020
 B7G      C2     C3        single      1.524    0.020
 B7G      O2     C2        single      1.432    0.020
 B7G      H21    C2        single      1.099    0.020
 B7G      C3     C4        single      1.524    0.020
 B7G      O3     C3        single      1.432    0.020
 B7G      H31    C3        single      1.099    0.020
 B7G      O4     C4        single      1.432    0.020
 B7G      H41    C4        single      1.099    0.020
 B7G      C6     O6        single      1.432    0.020
 B7G      H61    C6        single      1.092    0.020
 B7G      H62    C6        single      1.092    0.020
 B7G      C7     O1        single      1.426    0.020
 B7G      C8     C7        single      1.524    0.020
 B7G      H71    C7        single      1.092    0.020
 B7G      H72    C7        single      1.092    0.020
 B7G      C9     C8        single      1.524    0.020
 B7G      H81    C8        single      1.092    0.020
 B7G      H82    C8        single      1.092    0.020
 B7G      C10    C9        single      1.524    0.020
 B7G      H91    C9        single      1.092    0.020
 B7G      H92    C9        single      1.092    0.020
 B7G      C11    C10       single      1.524    0.020
 B7G      H101   C10       single      1.092    0.020
 B7G      H102   C10       single      1.092    0.020
 B7G      C12    C11       single      1.524    0.020
 B7G      H111   C11       single      1.092    0.020
 B7G      H112   C11       single      1.092    0.020
 B7G      C13    C12       single      1.513    0.020
 B7G      H121   C12       single      1.092    0.020
 B7G      H122   C12       single      1.092    0.020
 B7G      HO2    O2        single      0.967    0.020
 B7G      HO3    O3        single      0.967    0.020
 B7G      HO4    O4        single      0.967    0.020
 B7G      HO6    O6        single      0.967    0.020
 B7G      H131   C13       single      1.059    0.020
 B7G      H132   C13       single      1.059    0.020
 B7G      H133   C13       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 B7G      HO6    O6     C6      109.470    3.000
 B7G      O6     C6     H61     109.470    3.000
 B7G      O6     C6     H62     109.470    3.000
 B7G      O6     C6     C5      109.470    3.000
 B7G      H61    C6     H62     107.900    3.000
 B7G      H61    C6     C5      109.470    3.000
 B7G      H62    C6     C5      109.470    3.000
 B7G      C6     C5     H51     108.340    3.000
 B7G      C6     C5     C4      111.000    3.000
 B7G      C6     C5     O5      109.470    3.000
 B7G      H51    C5     C4      108.340    3.000
 B7G      H51    C5     O5      109.470    3.000
 B7G      C4     C5     O5      109.470    3.000
 B7G      C5     C4     H41     108.340    3.000
 B7G      C5     C4     O4      109.470    3.000
 B7G      C5     C4     C3      111.000    3.000
 B7G      H41    C4     O4      109.470    3.000
 B7G      H41    C4     C3      108.340    3.000
 B7G      O4     C4     C3      109.470    3.000
 B7G      C4     O4     HO4     109.470    3.000
 B7G      C4     C3     H31     108.340    3.000
 B7G      C4     C3     O3      109.470    3.000
 B7G      C4     C3     C2      111.000    3.000
 B7G      H31    C3     O3      109.470    3.000
 B7G      H31    C3     C2      108.340    3.000
 B7G      O3     C3     C2      109.470    3.000
 B7G      C3     O3     HO3     109.470    3.000
 B7G      C3     C2     H21     108.340    3.000
 B7G      C3     C2     O2      109.470    3.000
 B7G      C3     C2     C1      111.000    3.000
 B7G      H21    C2     O2      109.470    3.000
 B7G      H21    C2     C1      108.340    3.000
 B7G      O2     C2     C1      109.470    3.000
 B7G      C2     O2     HO2     109.470    3.000
 B7G      C2     C1     H11     108.340    3.000
 B7G      C2     C1     O5      109.470    3.000
 B7G      C2     C1     O1      109.470    3.000
 B7G      H11    C1     O5      109.470    3.000
 B7G      H11    C1     O1      109.470    3.000
 B7G      O5     C1     O1      109.470    3.000
 B7G      C1     O5     C5      111.800    3.000
 B7G      C1     O1     C7      111.800    3.000
 B7G      O1     C7     H71     109.470    3.000
 B7G      O1     C7     H72     109.470    3.000
 B7G      O1     C7     C8      109.470    3.000
 B7G      H71    C7     H72     107.900    3.000
 B7G      H71    C7     C8      109.470    3.000
 B7G      H72    C7     C8      109.470    3.000
 B7G      C7     C8     H81     109.470    3.000
 B7G      C7     C8     H82     109.470    3.000
 B7G      C7     C8     C9      111.000    3.000
 B7G      H81    C8     H82     107.900    3.000
 B7G      H81    C8     C9      109.470    3.000
 B7G      H82    C8     C9      109.470    3.000
 B7G      C8     C9     H91     109.470    3.000
 B7G      C8     C9     H92     109.470    3.000
 B7G      C8     C9     C10     111.000    3.000
 B7G      H91    C9     H92     107.900    3.000
 B7G      H91    C9     C10     109.470    3.000
 B7G      H92    C9     C10     109.470    3.000
 B7G      C9     C10    H101    109.470    3.000
 B7G      C9     C10    H102    109.470    3.000
 B7G      C9     C10    C11     111.000    3.000
 B7G      H101   C10    H102    107.900    3.000
 B7G      H101   C10    C11     109.470    3.000
 B7G      H102   C10    C11     109.470    3.000
 B7G      C10    C11    H111    109.470    3.000
 B7G      C10    C11    H112    109.470    3.000
 B7G      C10    C11    C12     111.000    3.000
 B7G      H111   C11    H112    107.900    3.000
 B7G      H111   C11    C12     109.470    3.000
 B7G      H112   C11    C12     109.470    3.000
 B7G      C11    C12    H121    109.470    3.000
 B7G      C11    C12    H122    109.470    3.000
 B7G      C11    C12    C13     111.000    3.000
 B7G      H121   C12    H122    107.900    3.000
 B7G      H121   C12    C13     109.470    3.000
 B7G      H122   C12    C13     109.470    3.000
 B7G      C12    C13    H133    109.470    3.000
 B7G      C12    C13    H132    109.470    3.000
 B7G      C12    C13    H131    109.470    3.000
 B7G      H133   C13    H132    109.470    3.000
 B7G      H133   C13    H131    109.470    3.000
 B7G      H132   C13    H131    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 B7G      var_1    HO6    O6     C6     C5       179.961   20.000   1
 B7G      var_2    O6     C6     C5     C4      -179.685   20.000   3
 B7G      var_3    C6     C5     O5     C1       180.000   20.000   1
 B7G      var_4    C6     C5     C4     C3       180.000   20.000   3
 B7G      var_5    C5     C4     O4     HO4     -179.917   20.000   1
 B7G      var_6    C5     C4     C3     C2        60.000   20.000   3
 B7G      var_7    C4     C3     O3     HO3      179.960   20.000   1
 B7G      var_8    C4     C3     C2     C1       -60.000   20.000   3
 B7G      var_9    C3     C2     O2     HO2      179.998   20.000   1
 B7G      var_10   C3     C2     C1     O1       180.000   20.000   3
 B7G      var_11   C2     C1     O5     C5       -60.000   20.000   1
 B7G      var_12   C2     C1     O1     C7       179.856   20.000   1
 B7G      var_13   C1     O1     C7     C8      -179.972   20.000   1
 B7G      var_14   O1     C7     C8     C9      -179.960   20.000   3
 B7G      var_15   C7     C8     C9     C10     -179.980   20.000   3
 B7G      var_16   C8     C9     C10    C11      179.980   20.000   3
 B7G      var_17   C9     C10    C11    C12      179.926   20.000   3
 B7G      var_18   C10    C11    C12    C13      179.980   20.000   3
 B7G      var_19   C11    C12    C13    H131    -179.916   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 B7G      chir_01  C5     O5     C4     C6        negativ
 B7G      chir_02  C1     O5     C2     O1        positiv
 B7G      chir_03  C2     C1     C3     O2        negativ
 B7G      chir_04  C3     C2     C4     O3        positiv
 B7G      chir_05  C4     C5     C3     O4        positiv
# ------------------------------------------------------
`.trim();

monomers["16D"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
16D      16D 'HEXANE-1,6-DIAMINE                  ' non-polymer        24   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_16D
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 16D           N2     N    NH2       0.000      0.000    0.000    0.000
 16D           HN21   H    H         0.000      0.596   -0.798   -0.187
 16D           HN22   H    H         0.000      0.382    0.802    0.488
 16D           C6     C    CH2       0.000     -1.404   -0.005   -0.432
 16D           H61    H    H         0.000     -1.596   -0.897   -1.032
 16D           H62    H    H         0.000     -1.602    0.886   -1.032
 16D           C5     C    CH2       0.000     -2.316   -0.008    0.795
 16D           H51    H    H         0.000     -2.122    0.884    1.394
 16D           H52    H    H         0.000     -2.116   -0.898    1.394
 16D           C4     C    CH2       0.000     -3.778   -0.013    0.345
 16D           H41    H    H         0.000     -3.970   -0.904   -0.255
 16D           H42    H    H         0.000     -3.976    0.878   -0.255
 16D           C3     C    CH2       0.000     -4.691   -0.016    1.572
 16D           H31    H    H         0.000     -4.496    0.876    2.171
 16D           H32    H    H         0.000     -4.490   -0.906    2.171
 16D           C2     C    CH2       0.000     -6.152   -0.020    1.122
 16D           H21    H    H         0.000     -6.344   -0.912    0.522
 16D           H22    H    H         0.000     -6.350    0.870    0.522
 16D           C1     C    CH2       0.000     -7.064   -0.023    2.350
 16D           H11    H    H         0.000     -6.870    0.868    2.949
 16D           H12    H    H         0.000     -6.864   -0.914    2.949
 16D           N1     N    NH2       0.000     -8.468   -0.028    1.917
 16D           HN12   H    H         0.000     -8.700   -0.029    0.931
 16D           HN11   H    H         0.000     -9.215   -0.031    2.603
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 16D      N2     n/a    C6     START
 16D      HN21   N2     .      .
 16D      HN22   N2     .      .
 16D      C6     N2     C5     .
 16D      H61    C6     .      .
 16D      H62    C6     .      .
 16D      C5     C6     C4     .
 16D      H51    C5     .      .
 16D      H52    C5     .      .
 16D      C4     C5     C3     .
 16D      H41    C4     .      .
 16D      H42    C4     .      .
 16D      C3     C4     C2     .
 16D      H31    C3     .      .
 16D      H32    C3     .      .
 16D      C2     C3     C1     .
 16D      H21    C2     .      .
 16D      H22    C2     .      .
 16D      C1     C2     N1     .
 16D      H11    C1     .      .
 16D      H12    C1     .      .
 16D      N1     C1     HN11   .
 16D      HN12   N1     .      .
 16D      HN11   N1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 16D      N1     C1        single      1.450    0.020
 16D      HN11   N1        single      1.010    0.020
 16D      HN12   N1        single      1.010    0.020
 16D      C1     C2        single      1.524    0.020
 16D      H11    C1        single      1.092    0.020
 16D      H12    C1        single      1.092    0.020
 16D      C2     C3        single      1.524    0.020
 16D      H21    C2        single      1.092    0.020
 16D      H22    C2        single      1.092    0.020
 16D      C3     C4        single      1.524    0.020
 16D      H31    C3        single      1.092    0.020
 16D      H32    C3        single      1.092    0.020
 16D      C4     C5        single      1.524    0.020
 16D      H41    C4        single      1.092    0.020
 16D      H42    C4        single      1.092    0.020
 16D      C5     C6        single      1.524    0.020
 16D      H51    C5        single      1.092    0.020
 16D      H52    C5        single      1.092    0.020
 16D      C6     N2        single      1.450    0.020
 16D      H61    C6        single      1.092    0.020
 16D      H62    C6        single      1.092    0.020
 16D      HN21   N2        single      1.010    0.020
 16D      HN22   N2        single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 16D      HN21   N2     HN22    120.000    3.000
 16D      HN21   N2     C6      120.000    3.000
 16D      HN22   N2     C6      120.000    3.000
 16D      N2     C6     H61     109.470    3.000
 16D      N2     C6     H62     109.470    3.000
 16D      N2     C6     C5      109.470    3.000
 16D      H61    C6     H62     107.900    3.000
 16D      H61    C6     C5      109.470    3.000
 16D      H62    C6     C5      109.470    3.000
 16D      C6     C5     H51     109.470    3.000
 16D      C6     C5     H52     109.470    3.000
 16D      C6     C5     C4      111.000    3.000
 16D      H51    C5     H52     107.900    3.000
 16D      H51    C5     C4      109.470    3.000
 16D      H52    C5     C4      109.470    3.000
 16D      C5     C4     H41     109.470    3.000
 16D      C5     C4     H42     109.470    3.000
 16D      C5     C4     C3      111.000    3.000
 16D      H41    C4     H42     107.900    3.000
 16D      H41    C4     C3      109.470    3.000
 16D      H42    C4     C3      109.470    3.000
 16D      C4     C3     H31     109.470    3.000
 16D      C4     C3     H32     109.470    3.000
 16D      C4     C3     C2      111.000    3.000
 16D      H31    C3     H32     107.900    3.000
 16D      H31    C3     C2      109.470    3.000
 16D      H32    C3     C2      109.470    3.000
 16D      C3     C2     H21     109.470    3.000
 16D      C3     C2     H22     109.470    3.000
 16D      C3     C2     C1      111.000    3.000
 16D      H21    C2     H22     107.900    3.000
 16D      H21    C2     C1      109.470    3.000
 16D      H22    C2     C1      109.470    3.000
 16D      C2     C1     H11     109.470    3.000
 16D      C2     C1     H12     109.470    3.000
 16D      C2     C1     N1      109.470    3.000
 16D      H11    C1     H12     107.900    3.000
 16D      H11    C1     N1      109.470    3.000
 16D      H12    C1     N1      109.470    3.000
 16D      C1     N1     HN12    120.000    3.000
 16D      C1     N1     HN11    120.000    3.000
 16D      HN12   N1     HN11    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 16D      var_1    HN22   N2     C6     C5       -66.200   20.000   1
 16D      var_2    N2     C6     C5     C4       180.000   20.000   3
 16D      var_3    C6     C5     C4     C3       180.000   20.000   3
 16D      var_4    C5     C4     C3     C2       180.000   20.000   3
 16D      var_5    C4     C3     C2     C1       180.000   20.000   3
 16D      var_6    C3     C2     C1     N1       180.000   20.000   3
 16D      var_7    C2     C1     N1     HN11     180.000   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 16D      plan-1    N1        0.020
 16D      plan-1    C1        0.020
 16D      plan-1    HN11      0.020
 16D      plan-1    HN12      0.020
 16D      plan-2    N2        0.020
 16D      plan-2    C6        0.020
 16D      plan-2    HN21      0.020
 16D      plan-2    HN22      0.020
# ------------------------------------------------------
`.trim();

monomers["HEZ"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
HEZ      HEZ 'HEXANE-1,6-DIOL                     ' non-polymer        22   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_HEZ
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 HEZ           O6     O    OH1       0.000      0.000    0.000    0.000
 HEZ           HO6    H    H         0.000      0.578    0.000   -0.775
 HEZ           C6     C    CH2       0.000     -1.364    0.000   -0.424
 HEZ           H61    H    H         0.000     -1.557   -0.891   -1.025
 HEZ           H62    H    H         0.000     -1.557    0.891   -1.025
 HEZ           C5     C    CH2       0.000     -2.280    0.000    0.801
 HEZ           H51    H    H         0.000     -2.084    0.891    1.401
 HEZ           H52    H    H         0.000     -2.084   -0.891    1.401
 HEZ           C4     C    CH2       0.000     -3.741    0.000    0.346
 HEZ           H41    H    H         0.000     -3.934   -0.891   -0.254
 HEZ           H42    H    H         0.000     -3.934    0.891   -0.254
 HEZ           C3     C    CH2       0.000     -4.656    0.000    1.570
 HEZ           H31    H    H         0.000     -4.461    0.891    2.170
 HEZ           H32    H    H         0.000     -4.461   -0.891    2.170
 HEZ           C2     C    CH2       0.000     -6.117    0.000    1.115
 HEZ           H21    H    H         0.000     -6.310   -0.891    0.515
 HEZ           H22    H    H         0.000     -6.310    0.891    0.515
 HEZ           C1     C    CH2       0.000     -7.033    0.000    2.340
 HEZ           H11    H    H         0.000     -6.837    0.891    2.940
 HEZ           H12    H    H         0.000     -6.837   -0.891    2.940
 HEZ           O1     O    OH1       0.000     -8.397    0.000    1.916
 HEZ           HO1    H    H         0.000     -8.975    0.000    2.691
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 HEZ      O6     n/a    C6     START
 HEZ      HO6    O6     .      .
 HEZ      C6     O6     C5     .
 HEZ      H61    C6     .      .
 HEZ      H62    C6     .      .
 HEZ      C5     C6     C4     .
 HEZ      H51    C5     .      .
 HEZ      H52    C5     .      .
 HEZ      C4     C5     C3     .
 HEZ      H41    C4     .      .
 HEZ      H42    C4     .      .
 HEZ      C3     C4     C2     .
 HEZ      H31    C3     .      .
 HEZ      H32    C3     .      .
 HEZ      C2     C3     C1     .
 HEZ      H21    C2     .      .
 HEZ      H22    C2     .      .
 HEZ      C1     C2     O1     .
 HEZ      H11    C1     .      .
 HEZ      H12    C1     .      .
 HEZ      O1     C1     HO1    .
 HEZ      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 HEZ      O1     C1        single      1.432    0.020
 HEZ      HO1    O1        single      0.967    0.020
 HEZ      C1     C2        single      1.524    0.020
 HEZ      H11    C1        single      1.092    0.020
 HEZ      H12    C1        single      1.092    0.020
 HEZ      C2     C3        single      1.524    0.020
 HEZ      H21    C2        single      1.092    0.020
 HEZ      H22    C2        single      1.092    0.020
 HEZ      C3     C4        single      1.524    0.020
 HEZ      H31    C3        single      1.092    0.020
 HEZ      H32    C3        single      1.092    0.020
 HEZ      C4     C5        single      1.524    0.020
 HEZ      H41    C4        single      1.092    0.020
 HEZ      H42    C4        single      1.092    0.020
 HEZ      C5     C6        single      1.524    0.020
 HEZ      H51    C5        single      1.092    0.020
 HEZ      H52    C5        single      1.092    0.020
 HEZ      C6     O6        single      1.432    0.020
 HEZ      H61    C6        single      1.092    0.020
 HEZ      H62    C6        single      1.092    0.020
 HEZ      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 HEZ      HO6    O6     C6      109.470    3.000
 HEZ      O6     C6     H61     109.470    3.000
 HEZ      O6     C6     H62     109.470    3.000
 HEZ      O6     C6     C5      109.470    3.000
 HEZ      H61    C6     H62     107.900    3.000
 HEZ      H61    C6     C5      109.470    3.000
 HEZ      H62    C6     C5      109.470    3.000
 HEZ      C6     C5     H51     109.470    3.000
 HEZ      C6     C5     H52     109.470    3.000
 HEZ      C6     C5     C4      111.000    3.000
 HEZ      H51    C5     H52     107.900    3.000
 HEZ      H51    C5     C4      109.470    3.000
 HEZ      H52    C5     C4      109.470    3.000
 HEZ      C5     C4     H41     109.470    3.000
 HEZ      C5     C4     H42     109.470    3.000
 HEZ      C5     C4     C3      111.000    3.000
 HEZ      H41    C4     H42     107.900    3.000
 HEZ      H41    C4     C3      109.470    3.000
 HEZ      H42    C4     C3      109.470    3.000
 HEZ      C4     C3     H31     109.470    3.000
 HEZ      C4     C3     H32     109.470    3.000
 HEZ      C4     C3     C2      111.000    3.000
 HEZ      H31    C3     H32     107.900    3.000
 HEZ      H31    C3     C2      109.470    3.000
 HEZ      H32    C3     C2      109.470    3.000
 HEZ      C3     C2     H21     109.470    3.000
 HEZ      C3     C2     H22     109.470    3.000
 HEZ      C3     C2     C1      111.000    3.000
 HEZ      H21    C2     H22     107.900    3.000
 HEZ      H21    C2     C1      109.470    3.000
 HEZ      H22    C2     C1      109.470    3.000
 HEZ      C2     C1     H11     109.470    3.000
 HEZ      C2     C1     H12     109.470    3.000
 HEZ      C2     C1     O1      109.470    3.000
 HEZ      H11    C1     H12     107.900    3.000
 HEZ      H11    C1     O1      109.470    3.000
 HEZ      H12    C1     O1      109.470    3.000
 HEZ      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 HEZ      var_1    HO6    O6     C6     C5       180.000   20.000   1
 HEZ      var_2    O6     C6     C5     C4       180.000   20.000   3
 HEZ      var_3    C6     C5     C4     C3       180.000   20.000   3
 HEZ      var_4    C5     C4     C3     C2       180.000   20.000   3
 HEZ      var_5    C4     C3     C2     C1       180.000   20.000   3
 HEZ      var_6    C3     C2     C1     O1       180.000   20.000   3
 HEZ      var_7    C2     C1     O1     HO1      180.000   20.000   1
# ------------------------------------------------------
`.trim();

monomers["ICT"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ICT      ICT 'ISOCITRIC ACID                      ' non-polymer        18  13 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ICT
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ICT           O6     O    OC       -0.500      0.000    0.000    0.000
 ICT           C6     C    C         0.000     -1.141   -0.275    0.433
 ICT           O5     O    OC       -0.500     -1.268   -0.873    1.525
 ICT           C3     C    CH1       0.000     -2.362    0.116   -0.358
 ICT           H3     H    H         0.000     -2.425    1.212   -0.415
 ICT           C2     C    CH1       0.000     -3.613   -0.431    0.330
 ICT           H2     H    H         0.000     -4.503   -0.146   -0.248
 ICT           O7     O    OH1       0.000     -3.530   -1.855    0.407
 ICT           HO7    H    H         0.000     -2.747   -2.105    0.915
 ICT           C1     C    C         0.000     -3.712    0.141    1.721
 ICT           O2     O    OC       -0.500     -3.795    1.378    1.883
 ICT           O1     O    OC       -0.500     -3.711   -0.621    2.713
 ICT           C4     C    CH2       0.000     -2.262   -0.464   -1.770
 ICT           H41    H    H         0.000     -2.309   -1.554   -1.718
 ICT           H42    H    H         0.000     -1.313   -0.163   -2.219
 ICT           C5     C    C         0.000     -3.402    0.051   -2.609
 ICT           O3     O    OC       -0.500     -4.173    0.920   -2.146
 ICT           O4     O    OC       -0.500     -3.576   -0.389   -3.767
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ICT      O6     n/a    C6     START
 ICT      C6     O6     C3     .
 ICT      O5     C6     .      .
 ICT      C3     C6     C4     .
 ICT      H3     C3     .      .
 ICT      C2     C3     C1     .
 ICT      H2     C2     .      .
 ICT      O7     C2     HO7    .
 ICT      HO7    O7     .      .
 ICT      C1     C2     O1     .
 ICT      O2     C1     .      .
 ICT      O1     C1     .      .
 ICT      C4     C3     C5     .
 ICT      H41    C4     .      .
 ICT      H42    C4     .      .
 ICT      C5     C4     O4     .
 ICT      O3     C5     .      .
 ICT      O4     C5     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ICT      O1     C1        deloc       1.250    0.020
 ICT      O2     C1        deloc       1.250    0.020
 ICT      C1     C2        single      1.500    0.020
 ICT      O7     C2        single      1.432    0.020
 ICT      C2     C3        single      1.524    0.020
 ICT      H2     C2        single      1.099    0.020
 ICT      HO7    O7        single      0.967    0.020
 ICT      C4     C3        single      1.524    0.020
 ICT      C3     C6        single      1.500    0.020
 ICT      H3     C3        single      1.099    0.020
 ICT      C5     C4        single      1.510    0.020
 ICT      H41    C4        single      1.092    0.020
 ICT      H42    C4        single      1.092    0.020
 ICT      O3     C5        deloc       1.250    0.020
 ICT      O4     C5        deloc       1.250    0.020
 ICT      O5     C6        deloc       1.250    0.020
 ICT      C6     O6        deloc       1.250    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ICT      O6     C6     O5      123.000    3.000
 ICT      O6     C6     C3      118.500    3.000
 ICT      O5     C6     C3      118.500    3.000
 ICT      C6     C3     H3      108.810    3.000
 ICT      C6     C3     C2      109.470    3.000
 ICT      C6     C3     C4      109.470    3.000
 ICT      H3     C3     C2      108.340    3.000
 ICT      H3     C3     C4      108.340    3.000
 ICT      C2     C3     C4      111.000    3.000
 ICT      C3     C2     H2      108.340    3.000
 ICT      C3     C2     O7      109.470    3.000
 ICT      C3     C2     C1      109.470    3.000
 ICT      H2     C2     O7      109.470    3.000
 ICT      H2     C2     C1      108.810    3.000
 ICT      O7     C2     C1      109.470    3.000
 ICT      C2     O7     HO7     109.470    3.000
 ICT      C2     C1     O2      118.500    3.000
 ICT      C2     C1     O1      118.500    3.000
 ICT      O2     C1     O1      123.000    3.000
 ICT      C3     C4     H41     109.470    3.000
 ICT      C3     C4     H42     109.470    3.000
 ICT      C3     C4     C5      109.470    3.000
 ICT      H41    C4     H42     107.900    3.000
 ICT      H41    C4     C5      109.470    3.000
 ICT      H42    C4     C5      109.470    3.000
 ICT      C4     C5     O3      118.500    3.000
 ICT      C4     C5     O4      118.500    3.000
 ICT      O3     C5     O4      123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ICT      var_1    O6     C6     C3     C4        55.479   20.000   3
 ICT      var_2    C6     C3     C2     C1        60.025   20.000   3
 ICT      var_3    C3     C2     O7     HO7       59.972   20.000   1
 ICT      var_4    C3     C2     C1     O1      -119.944   20.000   3
 ICT      var_5    C6     C3     C4     C5      -173.720   20.000   3
 ICT      var_6    C3     C4     C5     O4      -173.898   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 ICT      chir_01  C2     C1     O7     C3        positiv
 ICT      chir_02  C3     C2     C4     C6        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ICT      plan-1    C1        0.020
 ICT      plan-1    O1        0.020
 ICT      plan-1    O2        0.020
 ICT      plan-1    C2        0.020
 ICT      plan-2    C5        0.020
 ICT      plan-2    C4        0.020
 ICT      plan-2    O3        0.020
 ICT      plan-2    O4        0.020
 ICT      plan-3    C6        0.020
 ICT      plan-3    C3        0.020
 ICT      plan-3    O5        0.020
 ICT      plan-3    O6        0.020
# ------------------------------------------------------
`.trim();

monomers["TLA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TLA      TLA 'L(+)-TARTARIC ACID                  ' non-polymer        14  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TLA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TLA           O41    O    OC       -0.500      0.000    0.000    0.000
 TLA           C4     C    C         0.000     -0.646   -0.570   -0.907
 TLA           O4     O    OC       -0.500     -0.048   -1.045   -1.897
 TLA           C3     C    CH1       0.000     -2.146   -0.685   -0.805
 TLA           H3     H    H         0.000     -2.409   -1.246    0.102
 TLA           O3     O    OH1       0.000     -2.649   -1.371   -1.952
 TLA           HB     H    H         0.000     -2.417   -0.877   -2.750
 TLA           C2     C    CH1       0.000     -2.760    0.714   -0.736
 TLA           H2     H    H         0.000     -2.373    1.241    0.147
 TLA           O2     O    OH1       0.000     -2.418    1.443   -1.915
 TLA           HA     H    H         0.000     -2.759    0.978   -2.691
 TLA           C1     C    C         0.000     -4.260    0.597   -0.635
 TLA           O1     O    OC       -0.500     -4.987    1.108   -1.516
 TLA           O11    O    OC       -0.500     -4.777   -0.007    0.330
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TLA      O41    n/a    C4     START
 TLA      C4     O41    C3     .
 TLA      O4     C4     .      .
 TLA      C3     C4     C2     .
 TLA      H3     C3     .      .
 TLA      O3     C3     HB     .
 TLA      HB     O3     .      .
 TLA      C2     C3     C1     .
 TLA      H2     C2     .      .
 TLA      O2     C2     HA     .
 TLA      HA     O2     .      .
 TLA      C1     C2     O11    .
 TLA      O1     C1     .      .
 TLA      O11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TLA      O1     C1        deloc       1.250    0.020
 TLA      O11    C1        deloc       1.250    0.020
 TLA      C1     C2        single      1.500    0.020
 TLA      O2     C2        single      1.432    0.020
 TLA      C2     C3        single      1.524    0.020
 TLA      H2     C2        single      1.099    0.020
 TLA      HA     O2        single      0.967    0.020
 TLA      O3     C3        single      1.432    0.020
 TLA      C3     C4        single      1.500    0.020
 TLA      H3     C3        single      1.099    0.020
 TLA      HB     O3        single      0.967    0.020
 TLA      O4     C4        deloc       1.250    0.020
 TLA      C4     O41       deloc       1.250    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TLA      O41    C4     O4      123.000    3.000
 TLA      O41    C4     C3      118.500    3.000
 TLA      O4     C4     C3      118.500    3.000
 TLA      C4     C3     H3      108.810    3.000
 TLA      C4     C3     O3      109.470    3.000
 TLA      C4     C3     C2      109.470    3.000
 TLA      H3     C3     O3      109.470    3.000
 TLA      H3     C3     C2      108.340    3.000
 TLA      O3     C3     C2      109.470    3.000
 TLA      C3     O3     HB      109.470    3.000
 TLA      C3     C2     H2      108.340    3.000
 TLA      C3     C2     O2      109.470    3.000
 TLA      C3     C2     C1      109.470    3.000
 TLA      H2     C2     O2      109.470    3.000
 TLA      H2     C2     C1      108.810    3.000
 TLA      O2     C2     C1      109.470    3.000
 TLA      C2     O2     HA      109.470    3.000
 TLA      C2     C1     O1      118.500    3.000
 TLA      C2     C1     O11     118.500    3.000
 TLA      O1     C1     O11     123.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TLA      var_1    O41    C4     C3     C2        59.996   20.000   3
 TLA      var_2    C4     C3     O3     HB       -60.021   20.000   1
 TLA      var_3    C4     C3     C2     C1       179.960   20.000   3
 TLA      var_4    C3     C2     O2     HA        59.960   20.000   1
 TLA      var_5    C3     C2     C1     O11       60.118   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TLA      chir_01  C2     C1     O2     C3        positiv
 TLA      chir_02  C3     C2     O3     C4        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TLA      plan-1    C1        0.020
 TLA      plan-1    O1        0.020
 TLA      plan-1    O11       0.020
 TLA      plan-1    C2        0.020
 TLA      plan-2    C4        0.020
 TLA      plan-2    C3        0.020
 TLA      plan-2    O4        0.020
 TLA      plan-2    O41       0.020
# ------------------------------------------------------
`.trim();

monomers["LDA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
LDA      LDA 'LAURYL DIMETHYLAMINE-N-OXIDE        ' non-polymer        47  16 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_LDA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 LDA           O1     O    O        -1.000      0.000    0.000    0.000
 LDA           N1     N    NT        1.000     -0.499    0.696    1.186
 LDA           CM1    C    CH3       0.000      0.454    1.744    1.576
 LDA           HM13   H    H         0.000      1.392    1.303    1.795
 LDA           HM12   H    H         0.000      0.565    2.434    0.781
 LDA           HM11   H    H         0.000      0.093    2.248    2.435
 LDA           CM2    C    CH3       0.000     -0.653   -0.262    2.288
 LDA           HM23   H    H         0.000      0.285   -0.703    2.505
 LDA           HM22   H    H         0.000     -1.013    0.242    3.146
 LDA           HM21   H    H         0.000     -1.341   -1.016    2.006
 LDA           C1     C    CH2       0.000     -1.800    1.307    0.883
 LDA           H11    H    H         0.000     -1.704    1.954    0.008
 LDA           H12    H    H         0.000     -2.131    1.901    1.738
 LDA           C2     C    CH2       0.000     -2.826    0.209    0.597
 LDA           H21    H    H         0.000     -2.920   -0.437    1.472
 LDA           H22    H    H         0.000     -2.493   -0.385   -0.258
 LDA           C3     C    CH2       0.000     -4.181    0.845    0.282
 LDA           H31    H    H         0.000     -4.085    1.491   -0.594
 LDA           H32    H    H         0.000     -4.511    1.439    1.136
 LDA           C4     C    CH2       0.000     -5.207   -0.254   -0.004
 LDA           H41    H    H         0.000     -5.301   -0.899    0.872
 LDA           H42    H    H         0.000     -4.874   -0.848   -0.858
 LDA           C5     C    CH2       0.000     -6.562    0.382   -0.320
 LDA           H51    H    H         0.000     -6.465    1.027   -1.195
 LDA           H52    H    H         0.000     -6.892    0.976    0.535
 LDA           C6     C    CH2       0.000     -7.587   -0.717   -0.605
 LDA           H61    H    H         0.000     -7.682   -1.363    0.270
 LDA           H62    H    H         0.000     -7.256   -1.311   -1.460
 LDA           C7     C    CH2       0.000     -8.942   -0.081   -0.920
 LDA           H71    H    H         0.000     -8.846    0.566   -1.795
 LDA           H72    H    H         0.000     -9.272    0.513   -0.065
 LDA           C8     C    CH2       0.000     -9.967   -1.179   -1.207
 LDA           H81    H    H         0.000    -10.062   -1.825   -0.331
 LDA           H82    H    H         0.000     -9.635   -1.773   -2.061
 LDA           C9     C    CH2       0.000    -11.323   -0.543   -1.522
 LDA           H91    H    H         0.000    -11.227    0.103   -2.397
 LDA           H92    H    H         0.000    -11.653    0.051   -0.667
 LDA           C10    C    CH2       0.000    -12.348   -1.643   -1.807
 LDA           H101   H    H         0.000    -12.443   -2.288   -0.931
 LDA           H102   H    H         0.000    -12.016   -2.237   -2.661
 LDA           C11    C    CH2       0.000    -13.704   -1.006   -2.123
 LDA           H111   H    H         0.000    -13.607   -0.361   -2.999
 LDA           H112   H    H         0.000    -14.034   -0.412   -1.269
 LDA           C12    C    CH3       0.000    -14.729   -2.105   -2.409
 LDA           H123   H    H         0.000    -14.411   -2.684   -3.238
 LDA           H122   H    H         0.000    -14.825   -2.733   -1.560
 LDA           H121   H    H         0.000    -15.670   -1.667   -2.628
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 LDA      O1     n/a    N1     START
 LDA      N1     O1     C1     .
 LDA      CM1    N1     HM11   .
 LDA      HM13   CM1    .      .
 LDA      HM12   CM1    .      .
 LDA      HM11   CM1    .      .
 LDA      CM2    N1     HM21   .
 LDA      HM23   CM2    .      .
 LDA      HM22   CM2    .      .
 LDA      HM21   CM2    .      .
 LDA      C1     N1     C2     .
 LDA      H11    C1     .      .
 LDA      H12    C1     .      .
 LDA      C2     C1     C3     .
 LDA      H21    C2     .      .
 LDA      H22    C2     .      .
 LDA      C3     C2     C4     .
 LDA      H31    C3     .      .
 LDA      H32    C3     .      .
 LDA      C4     C3     C5     .
 LDA      H41    C4     .      .
 LDA      H42    C4     .      .
 LDA      C5     C4     C6     .
 LDA      H51    C5     .      .
 LDA      H52    C5     .      .
 LDA      C6     C5     C7     .
 LDA      H61    C6     .      .
 LDA      H62    C6     .      .
 LDA      C7     C6     C8     .
 LDA      H71    C7     .      .
 LDA      H72    C7     .      .
 LDA      C8     C7     C9     .
 LDA      H81    C8     .      .
 LDA      H82    C8     .      .
 LDA      C9     C8     C10    .
 LDA      H91    C9     .      .
 LDA      H92    C9     .      .
 LDA      C10    C9     C11    .
 LDA      H101   C10    .      .
 LDA      H102   C10    .      .
 LDA      C11    C10    C12    .
 LDA      H111   C11    .      .
 LDA      H112   C11    .      .
 LDA      C12    C11    H121   .
 LDA      H123   C12    .      .
 LDA      H122   C12    .      .
 LDA      H121   C12    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 LDA      N1     O1        single      1.250    0.020
 LDA      CM1    N1        single      1.469    0.020
 LDA      CM2    N1        single      1.469    0.020
 LDA      C1     N1        single      1.469    0.020
 LDA      HM11   CM1       single      1.059    0.020
 LDA      HM12   CM1       single      1.059    0.020
 LDA      HM13   CM1       single      1.059    0.020
 LDA      HM21   CM2       single      1.059    0.020
 LDA      HM22   CM2       single      1.059    0.020
 LDA      HM23   CM2       single      1.059    0.020
 LDA      C2     C1        single      1.524    0.020
 LDA      H11    C1        single      1.092    0.020
 LDA      H12    C1        single      1.092    0.020
 LDA      C3     C2        single      1.524    0.020
 LDA      H21    C2        single      1.092    0.020
 LDA      H22    C2        single      1.092    0.020
 LDA      C4     C3        single      1.524    0.020
 LDA      H31    C3        single      1.092    0.020
 LDA      H32    C3        single      1.092    0.020
 LDA      C5     C4        single      1.524    0.020
 LDA      H41    C4        single      1.092    0.020
 LDA      H42    C4        single      1.092    0.020
 LDA      C6     C5        single      1.524    0.020
 LDA      H51    C5        single      1.092    0.020
 LDA      H52    C5        single      1.092    0.020
 LDA      C7     C6        single      1.524    0.020
 LDA      H61    C6        single      1.092    0.020
 LDA      H62    C6        single      1.092    0.020
 LDA      C8     C7        single      1.524    0.020
 LDA      H71    C7        single      1.092    0.020
 LDA      H72    C7        single      1.092    0.020
 LDA      C9     C8        single      1.524    0.020
 LDA      H81    C8        single      1.092    0.020
 LDA      H82    C8        single      1.092    0.020
 LDA      C10    C9        single      1.524    0.020
 LDA      H91    C9        single      1.092    0.020
 LDA      H92    C9        single      1.092    0.020
 LDA      C11    C10       single      1.524    0.020
 LDA      H101   C10       single      1.092    0.020
 LDA      H102   C10       single      1.092    0.020
 LDA      C12    C11       single      1.513    0.020
 LDA      H111   C11       single      1.092    0.020
 LDA      H112   C11       single      1.092    0.020
 LDA      H121   C12       single      1.059    0.020
 LDA      H122   C12       single      1.059    0.020
 LDA      H123   C12       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 LDA      O1     N1     CM1     109.500    3.000
 LDA      O1     N1     CM2     109.500    3.000
 LDA      O1     N1     C1      109.500    3.000
 LDA      CM1    N1     CM2     109.470    3.000
 LDA      CM1    N1     C1      109.470    3.000
 LDA      CM2    N1     C1      109.470    3.000
 LDA      N1     CM1    HM13    109.470    3.000
 LDA      N1     CM1    HM12    109.470    3.000
 LDA      N1     CM1    HM11    109.470    3.000
 LDA      HM13   CM1    HM12    109.470    3.000
 LDA      HM13   CM1    HM11    109.470    3.000
 LDA      HM12   CM1    HM11    109.470    3.000
 LDA      N1     CM2    HM23    109.470    3.000
 LDA      N1     CM2    HM22    109.470    3.000
 LDA      N1     CM2    HM21    109.470    3.000
 LDA      HM23   CM2    HM22    109.470    3.000
 LDA      HM23   CM2    HM21    109.470    3.000
 LDA      HM22   CM2    HM21    109.470    3.000
 LDA      N1     C1     H11     109.470    3.000
 LDA      N1     C1     H12     109.470    3.000
 LDA      N1     C1     C2      109.470    3.000
 LDA      H11    C1     H12     107.900    3.000
 LDA      H11    C1     C2      109.470    3.000
 LDA      H12    C1     C2      109.470    3.000
 LDA      C1     C2     H21     109.470    3.000
 LDA      C1     C2     H22     109.470    3.000
 LDA      C1     C2     C3      111.000    3.000
 LDA      H21    C2     H22     107.900    3.000
 LDA      H21    C2     C3      109.470    3.000
 LDA      H22    C2     C3      109.470    3.000
 LDA      C2     C3     H31     109.470    3.000
 LDA      C2     C3     H32     109.470    3.000
 LDA      C2     C3     C4      111.000    3.000
 LDA      H31    C3     H32     107.900    3.000
 LDA      H31    C3     C4      109.470    3.000
 LDA      H32    C3     C4      109.470    3.000
 LDA      C3     C4     H41     109.470    3.000
 LDA      C3     C4     H42     109.470    3.000
 LDA      C3     C4     C5      111.000    3.000
 LDA      H41    C4     H42     107.900    3.000
 LDA      H41    C4     C5      109.470    3.000
 LDA      H42    C4     C5      109.470    3.000
 LDA      C4     C5     H51     109.470    3.000
 LDA      C4     C5     H52     109.470    3.000
 LDA      C4     C5     C6      111.000    3.000
 LDA      H51    C5     H52     107.900    3.000
 LDA      H51    C5     C6      109.470    3.000
 LDA      H52    C5     C6      109.470    3.000
 LDA      C5     C6     H61     109.470    3.000
 LDA      C5     C6     H62     109.470    3.000
 LDA      C5     C6     C7      111.000    3.000
 LDA      H61    C6     H62     107.900    3.000
 LDA      H61    C6     C7      109.470    3.000
 LDA      H62    C6     C7      109.470    3.000
 LDA      C6     C7     H71     109.470    3.000
 LDA      C6     C7     H72     109.470    3.000
 LDA      C6     C7     C8      111.000    3.000
 LDA      H71    C7     H72     107.900    3.000
 LDA      H71    C7     C8      109.470    3.000
 LDA      H72    C7     C8      109.470    3.000
 LDA      C7     C8     H81     109.470    3.000
 LDA      C7     C8     H82     109.470    3.000
 LDA      C7     C8     C9      111.000    3.000
 LDA      H81    C8     H82     107.900    3.000
 LDA      H81    C8     C9      109.470    3.000
 LDA      H82    C8     C9      109.470    3.000
 LDA      C8     C9     H91     109.470    3.000
 LDA      C8     C9     H92     109.470    3.000
 LDA      C8     C9     C10     111.000    3.000
 LDA      H91    C9     H92     107.900    3.000
 LDA      H91    C9     C10     109.470    3.000
 LDA      H92    C9     C10     109.470    3.000
 LDA      C9     C10    H101    109.470    3.000
 LDA      C9     C10    H102    109.470    3.000
 LDA      C9     C10    C11     111.000    3.000
 LDA      H101   C10    H102    107.900    3.000
 LDA      H101   C10    C11     109.470    3.000
 LDA      H102   C10    C11     109.470    3.000
 LDA      C10    C11    H111    109.470    3.000
 LDA      C10    C11    H112    109.470    3.000
 LDA      C10    C11    C12     111.000    3.000
 LDA      H111   C11    H112    107.900    3.000
 LDA      H111   C11    C12     109.470    3.000
 LDA      H112   C11    C12     109.470    3.000
 LDA      C11    C12    H123    109.470    3.000
 LDA      C11    C12    H122    109.470    3.000
 LDA      C11    C12    H121    109.470    3.000
 LDA      H123   C12    H122    109.470    3.000
 LDA      H123   C12    H121    109.470    3.000
 LDA      H122   C12    H121    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 LDA      var_1    O1     N1     CM1    HM11     179.970   20.000   1
 LDA      var_2    O1     N1     CM2    HM21     -60.056   20.000   1
 LDA      var_3    O1     N1     C1     C2        64.973   20.000   1
 LDA      var_4    N1     C1     C2     C3       179.985   20.000   3
 LDA      var_5    C1     C2     C3     C4      -179.960   20.000   3
 LDA      var_6    C2     C3     C4     C5      -179.960   20.000   3
 LDA      var_7    C3     C4     C5     C6       180.000   20.000   3
 LDA      var_8    C4     C5     C6     C7       179.960   20.000   3
 LDA      var_9    C5     C6     C7     C8       179.960   20.000   3
 LDA      var_10   C6     C7     C8     C9       180.000   20.000   3
 LDA      var_11   C7     C8     C9     C10     -179.961   20.000   3
 LDA      var_12   C8     C9     C10    C11     -179.960   20.000   3
 LDA      var_13   C9     C10    C11    C12     -180.000   20.000   3
 LDA      var_14   C10    C11    C12    H121     179.993   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 LDA      chir_01  N1     O1     CM1    CM2       both
# ------------------------------------------------------
`.trim();

monomers["MRY"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MRY      MRY 'MESO-ERYTHRITOL                     ' non-polymer        18   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MRY
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MRY           OAH    O    OH1       0.000      0.000    0.000    0.000
 MRY           HAH    H    H         0.000      0.520   -0.408   -0.706
 MRY           CAG    C    CH2       0.000     -1.358   -0.431   -0.100
 MRY           HAG1   H    H         0.000     -1.402   -1.518   -0.004
 MRY           HAG2   H    H         0.000     -1.762   -0.136   -1.071
 MRY           CAE    C    CH1       0.000     -2.182    0.215    1.015
 MRY           HAE    H    H         0.000     -2.138    1.309    0.917
 MRY           OAF    O    OH1       0.000     -1.651   -0.171    2.284
 MRY           HAF    H    H         0.000     -1.691   -1.133    2.370
 MRY           CAC    C    CH1       0.000     -3.635   -0.247    0.909
 MRY           HAC    H    H         0.000     -3.680   -1.341    1.007
 MRY           OAD    O    OH1       0.000     -4.166    0.139   -0.360
 MRY           HAD    H    H         0.000     -4.127    1.101   -0.446
 MRY           CAA    C    CH2       0.000     -4.460    0.399    2.024
 MRY           HAA1   H    H         0.000     -4.413    1.485    1.927
 MRY           HAA2   H    H         0.000     -4.053    0.104    2.994
 MRY           OAB    O    OH1       0.000     -5.817   -0.032    1.924
 MRY           HAB    H    H         0.000     -6.337    0.376    2.630
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MRY      OAH    n/a    CAG    START
 MRY      HAH    OAH    .      .
 MRY      CAG    OAH    CAE    .
 MRY      HAG1   CAG    .      .
 MRY      HAG2   CAG    .      .
 MRY      CAE    CAG    CAC    .
 MRY      HAE    CAE    .      .
 MRY      OAF    CAE    HAF    .
 MRY      HAF    OAF    .      .
 MRY      CAC    CAE    CAA    .
 MRY      HAC    CAC    .      .
 MRY      OAD    CAC    HAD    .
 MRY      HAD    OAD    .      .
 MRY      CAA    CAC    OAB    .
 MRY      HAA1   CAA    .      .
 MRY      HAA2   CAA    .      .
 MRY      OAB    CAA    HAB    .
 MRY      HAB    OAB    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MRY      OAB    CAA       single      1.432    0.020
 MRY      HAB    OAB       single      0.967    0.020
 MRY      CAA    CAC       single      1.524    0.020
 MRY      HAA1   CAA       single      1.092    0.020
 MRY      HAA2   CAA       single      1.092    0.020
 MRY      OAD    CAC       single      1.432    0.020
 MRY      CAC    CAE       single      1.524    0.020
 MRY      HAC    CAC       single      1.099    0.020
 MRY      HAD    OAD       single      0.967    0.020
 MRY      OAF    CAE       single      1.432    0.020
 MRY      CAE    CAG       single      1.524    0.020
 MRY      HAE    CAE       single      1.099    0.020
 MRY      HAF    OAF       single      0.967    0.020
 MRY      CAG    OAH       single      1.432    0.020
 MRY      HAG1   CAG       single      1.092    0.020
 MRY      HAG2   CAG       single      1.092    0.020
 MRY      HAH    OAH       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MRY      HAH    OAH    CAG     109.470    3.000
 MRY      OAH    CAG    HAG1    109.470    3.000
 MRY      OAH    CAG    HAG2    109.470    3.000
 MRY      OAH    CAG    CAE     109.470    3.000
 MRY      HAG1   CAG    HAG2    107.900    3.000
 MRY      HAG1   CAG    CAE     109.470    3.000
 MRY      HAG2   CAG    CAE     109.470    3.000
 MRY      CAG    CAE    HAE     108.340    3.000
 MRY      CAG    CAE    OAF     109.470    3.000
 MRY      CAG    CAE    CAC     111.000    3.000
 MRY      HAE    CAE    OAF     109.470    3.000
 MRY      HAE    CAE    CAC     108.340    3.000
 MRY      OAF    CAE    CAC     109.470    3.000
 MRY      CAE    OAF    HAF     109.470    3.000
 MRY      CAE    CAC    HAC     108.340    3.000
 MRY      CAE    CAC    OAD     109.470    3.000
 MRY      CAE    CAC    CAA     111.000    3.000
 MRY      HAC    CAC    OAD     109.470    3.000
 MRY      HAC    CAC    CAA     108.340    3.000
 MRY      OAD    CAC    CAA     109.470    3.000
 MRY      CAC    OAD    HAD     109.470    3.000
 MRY      CAC    CAA    HAA1    109.470    3.000
 MRY      CAC    CAA    HAA2    109.470    3.000
 MRY      CAC    CAA    OAB     109.470    3.000
 MRY      HAA1   CAA    HAA2    107.900    3.000
 MRY      HAA1   CAA    OAB     109.470    3.000
 MRY      HAA2   CAA    OAB     109.470    3.000
 MRY      CAA    OAB    HAB     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MRY      var_1    HAH    OAH    CAG    CAE     -179.938   20.000   1
 MRY      var_2    OAH    CAG    CAE    CAC     -179.935   20.000   3
 MRY      var_3    CAG    CAE    OAF    HAF      -60.047   20.000   1
 MRY      var_4    CAG    CAE    CAC    CAA      180.000   20.000   3
 MRY      var_5    CAE    CAC    OAD    HAD      -59.976   20.000   1
 MRY      var_6    CAE    CAC    CAA    OAB      179.935   20.000   3
 MRY      var_7    CAC    CAA    OAB    HAB      179.938   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MRY      chir_01  CAC    CAA    OAD    CAE       negativ
 MRY      chir_02  CAE    CAC    OAF    CAG       negativ
# ------------------------------------------------------
`.trim();

monomers["BEQ"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BEQ      BEQ '"N-(CARBOXYMETHYL)-N,N-DIMETHYL-3-[(' non-polymer        62  24 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BEQ
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BEQ           O      O    O         0.000      0.000    0.000    0.000
 BEQ           C4     C    C         0.000     -0.582   -0.966    0.486
 BEQ           N2     N    NH1       0.000     -0.088   -1.772    1.502
 BEQ           HN2    H    H         0.000     -0.658   -2.542    1.825
 BEQ           C3     C    CH2       0.000      1.201   -1.565    2.122
 BEQ           H31    H    H         0.000      1.149   -1.904    3.159
 BEQ           H32    H    H         0.000      1.432   -0.498    2.100
 BEQ           C2     C    CH2       0.000      2.291   -2.340    1.386
 BEQ           H21    H    H         0.000      3.242   -2.138    1.883
 BEQ           H22    H    H         0.000      2.333   -1.970    0.359
 BEQ           C1     C    CH2       0.000      2.029   -3.840    1.377
 BEQ           H11    H    H         0.000      1.096   -4.047    0.849
 BEQ           H12    H    H         0.000      1.953   -4.206    2.403
 BEQ           N1     N    NT        1.000      3.151   -4.524    0.689
 BEQ           CG     C    CH3       0.000      2.909   -6.039    0.622
 BEQ           HG3    H    H         0.000      3.198   -6.499    1.538
 BEQ           HG2    H    H         0.000      1.878   -6.240    0.450
 BEQ           HG1    H    H         0.000      3.477   -6.468   -0.169
 BEQ           CD     C    CH2       0.000      3.309   -4.003   -0.747
 BEQ           HD1    H    H         0.000      4.150   -4.549   -1.178
 BEQ           HD2    H    H         0.000      3.569   -2.946   -0.660
 BEQ           CE     C    C         0.000      2.089   -4.155   -1.645
 BEQ           OE2    O    OC       -0.500      2.285   -4.856   -2.663
 BEQ           OE1    O    OC       -0.500      1.048   -3.572   -1.268
 BEQ           CB     C    CH3       0.000      4.473   -4.285    1.430
 BEQ           HB3    H    H         0.000      5.222   -4.952    1.074
 BEQ           HB2    H    H         0.000      4.807   -3.286    1.277
 BEQ           HB1    H    H         0.000      4.345   -4.444    2.475
 BEQ           C5     C    CH2       0.000     -1.959   -1.421    0.034
 BEQ           H51    H    H         0.000     -2.625   -1.385    0.898
 BEQ           H52    H    H         0.000     -1.873   -2.453   -0.315
 BEQ           C6     C    CH2       0.000     -2.524   -0.549   -1.085
 BEQ           H61    H    H         0.000     -1.853   -0.611   -1.945
 BEQ           H62    H    H         0.000     -2.565    0.484   -0.731
 BEQ           C7     C    CH2       0.000     -3.924   -1.006   -1.494
 BEQ           H71    H    H         0.000     -4.582   -0.925   -0.626
 BEQ           H72    H    H         0.000     -3.869   -2.049   -1.810
 BEQ           C8     C    CH2       0.000     -4.477   -0.153   -2.636
 BEQ           H81    H    H         0.000     -3.789   -0.219   -3.482
 BEQ           H82    H    H         0.000     -4.537    0.883   -2.297
 BEQ           C9     C    CH2       0.000     -5.866   -0.633   -3.067
 BEQ           H91    H    H         0.000     -6.531   -0.592   -2.202
 BEQ           H92    H    H         0.000     -5.784   -1.665   -3.414
 BEQ           C10    C    CH2       0.000     -6.431    0.241   -4.188
 BEQ           H101   H    H         0.000     -5.733    0.188   -5.026
 BEQ           H102   H    H         0.000     -6.470    1.266   -3.814
 BEQ           C11    C    CH2       0.000     -7.826   -0.190   -4.652
 BEQ           H111   H    H         0.000     -8.463   -0.164   -3.766
 BEQ           H112   H    H         0.000     -7.727   -1.221   -4.998
 BEQ           C12    C    CH2       0.000     -8.453    0.664   -5.760
 BEQ           H121   H    H         0.000     -7.802    0.598   -6.633
 BEQ           H122   H    H         0.000     -8.479    1.696   -5.403
 BEQ           C13    C    CH2       0.000     -9.867    0.219   -6.141
 BEQ           H131   H    H         0.000    -10.485    0.282   -5.243
 BEQ           H132   H    H         0.000     -9.808   -0.822   -6.467
 BEQ           C14    C    CH2       0.000    -10.488    1.069   -7.251
 BEQ           H141   H    H         0.000     -9.862    0.955   -8.139
 BEQ           H142   H    H         0.000    -10.461    2.110   -6.920
 BEQ           C15    C    CH3       0.000    -11.920    0.678   -7.584
 BEQ           H153   H    H         0.000    -12.503    0.682   -6.700
 BEQ           H152   H    H         0.000    -12.325    1.371   -8.276
 BEQ           H151   H    H         0.000    -11.933   -0.292   -8.009
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BEQ      O      n/a    C4     START
 BEQ      C4     O      C5     .
 BEQ      N2     C4     C3     .
 BEQ      HN2    N2     .      .
 BEQ      C3     N2     C2     .
 BEQ      H31    C3     .      .
 BEQ      H32    C3     .      .
 BEQ      C2     C3     C1     .
 BEQ      H21    C2     .      .
 BEQ      H22    C2     .      .
 BEQ      C1     C2     N1     .
 BEQ      H11    C1     .      .
 BEQ      H12    C1     .      .
 BEQ      N1     C1     CB     .
 BEQ      CG     N1     HG1    .
 BEQ      HG3    CG     .      .
 BEQ      HG2    CG     .      .
 BEQ      HG1    CG     .      .
 BEQ      CD     N1     CE     .
 BEQ      HD1    CD     .      .
 BEQ      HD2    CD     .      .
 BEQ      CE     CD     OE1    .
 BEQ      OE2    CE     .      .
 BEQ      OE1    CE     .      .
 BEQ      CB     N1     HB1    .
 BEQ      HB3    CB     .      .
 BEQ      HB2    CB     .      .
 BEQ      HB1    CB     .      .
 BEQ      C5     C4     C6     .
 BEQ      H51    C5     .      .
 BEQ      H52    C5     .      .
 BEQ      C6     C5     C7     .
 BEQ      H61    C6     .      .
 BEQ      H62    C6     .      .
 BEQ      C7     C6     C8     .
 BEQ      H71    C7     .      .
 BEQ      H72    C7     .      .
 BEQ      C8     C7     C9     .
 BEQ      H81    C8     .      .
 BEQ      H82    C8     .      .
 BEQ      C9     C8     C10    .
 BEQ      H91    C9     .      .
 BEQ      H92    C9     .      .
 BEQ      C10    C9     C11    .
 BEQ      H101   C10    .      .
 BEQ      H102   C10    .      .
 BEQ      C11    C10    C12    .
 BEQ      H111   C11    .      .
 BEQ      H112   C11    .      .
 BEQ      C12    C11    C13    .
 BEQ      H121   C12    .      .
 BEQ      H122   C12    .      .
 BEQ      C13    C12    C14    .
 BEQ      H131   C13    .      .
 BEQ      H132   C13    .      .
 BEQ      C14    C13    C15    .
 BEQ      H141   C14    .      .
 BEQ      H142   C14    .      .
 BEQ      C15    C14    H151   .
 BEQ      H153   C15    .      .
 BEQ      H152   C15    .      .
 BEQ      H151   C15    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BEQ      CB     N1        single      1.469    0.020
 BEQ      CG     N1        single      1.469    0.020
 BEQ      CD     N1        single      1.469    0.020
 BEQ      N1     C1        single      1.469    0.020
 BEQ      HB1    CB        single      1.059    0.020
 BEQ      HB2    CB        single      1.059    0.020
 BEQ      HB3    CB        single      1.059    0.020
 BEQ      HG1    CG        single      1.059    0.020
 BEQ      HG2    CG        single      1.059    0.020
 BEQ      HG3    CG        single      1.059    0.020
 BEQ      CE     CD        single      1.510    0.020
 BEQ      HD1    CD        single      1.092    0.020
 BEQ      HD2    CD        single      1.092    0.020
 BEQ      OE1    CE        deloc       1.250    0.020
 BEQ      OE2    CE        deloc       1.250    0.020
 BEQ      C1     C2        single      1.524    0.020
 BEQ      H11    C1        single      1.092    0.020
 BEQ      H12    C1        single      1.092    0.020
 BEQ      C2     C3        single      1.524    0.020
 BEQ      H21    C2        single      1.092    0.020
 BEQ      H22    C2        single      1.092    0.020
 BEQ      C3     N2        single      1.450    0.020
 BEQ      H31    C3        single      1.092    0.020
 BEQ      H32    C3        single      1.092    0.020
 BEQ      N2     C4        single      1.330    0.020
 BEQ      HN2    N2        single      1.010    0.020
 BEQ      C4     O         double      1.220    0.020
 BEQ      C5     C4        single      1.510    0.020
 BEQ      C6     C5        single      1.524    0.020
 BEQ      H51    C5        single      1.092    0.020
 BEQ      H52    C5        single      1.092    0.020
 BEQ      C7     C6        single      1.524    0.020
 BEQ      H61    C6        single      1.092    0.020
 BEQ      H62    C6        single      1.092    0.020
 BEQ      C8     C7        single      1.524    0.020
 BEQ      H71    C7        single      1.092    0.020
 BEQ      H72    C7        single      1.092    0.020
 BEQ      C9     C8        single      1.524    0.020
 BEQ      H81    C8        single      1.092    0.020
 BEQ      H82    C8        single      1.092    0.020
 BEQ      C10    C9        single      1.524    0.020
 BEQ      H91    C9        single      1.092    0.020
 BEQ      H92    C9        single      1.092    0.020
 BEQ      C11    C10       single      1.524    0.020
 BEQ      H101   C10       single      1.092    0.020
 BEQ      H102   C10       single      1.092    0.020
 BEQ      C12    C11       single      1.524    0.020
 BEQ      H111   C11       single      1.092    0.020
 BEQ      H112   C11       single      1.092    0.020
 BEQ      C13    C12       single      1.524    0.020
 BEQ      H121   C12       single      1.092    0.020
 BEQ      H122   C12       single      1.092    0.020
 BEQ      C14    C13       single      1.524    0.020
 BEQ      H131   C13       single      1.092    0.020
 BEQ      H132   C13       single      1.092    0.020
 BEQ      C15    C14       single      1.513    0.020
 BEQ      H141   C14       single      1.092    0.020
 BEQ      H142   C14       single      1.092    0.020
 BEQ      H151   C15       single      1.059    0.020
 BEQ      H152   C15       single      1.059    0.020
 BEQ      H153   C15       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BEQ      O      C4     N2      123.000    3.000
 BEQ      O      C4     C5      120.500    3.000
 BEQ      N2     C4     C5      116.500    3.000
 BEQ      C4     N2     HN2     120.000    3.000
 BEQ      C4     N2     C3      121.500    3.000
 BEQ      HN2    N2     C3      118.500    3.000
 BEQ      N2     C3     H31     109.470    3.000
 BEQ      N2     C3     H32     109.470    3.000
 BEQ      N2     C3     C2      112.000    3.000
 BEQ      H31    C3     H32     107.900    3.000
 BEQ      H31    C3     C2      109.470    3.000
 BEQ      H32    C3     C2      109.470    3.000
 BEQ      C3     C2     H21     109.470    3.000
 BEQ      C3     C2     H22     109.470    3.000
 BEQ      C3     C2     C1      111.000    3.000
 BEQ      H21    C2     H22     107.900    3.000
 BEQ      H21    C2     C1      109.470    3.000
 BEQ      H22    C2     C1      109.470    3.000
 BEQ      C2     C1     H11     109.470    3.000
 BEQ      C2     C1     H12     109.470    3.000
 BEQ      C2     C1     N1      109.470    3.000
 BEQ      H11    C1     H12     107.900    3.000
 BEQ      H11    C1     N1      109.470    3.000
 BEQ      H12    C1     N1      109.470    3.000
 BEQ      C1     N1     CD      109.470    3.000
 BEQ      C1     N1     CG      109.470    3.000
 BEQ      C1     N1     CB      109.470    3.000
 BEQ      CD     N1     CG      109.470    3.000
 BEQ      CD     N1     CB      109.470    3.000
 BEQ      CG     N1     CB      109.470    3.000
 BEQ      N1     CD     HD1     109.470    3.000
 BEQ      N1     CD     HD2     109.470    3.000
 BEQ      N1     CD     CE      109.500    3.000
 BEQ      HD1    CD     HD2     107.900    3.000
 BEQ      HD1    CD     CE      109.470    3.000
 BEQ      HD2    CD     CE      109.470    3.000
 BEQ      CD     CE     OE2     118.500    3.000
 BEQ      CD     CE     OE1     118.500    3.000
 BEQ      OE2    CE     OE1     123.000    3.000
 BEQ      N1     CG     HG3     109.470    3.000
 BEQ      N1     CG     HG2     109.470    3.000
 BEQ      N1     CG     HG1     109.470    3.000
 BEQ      HG3    CG     HG2     109.470    3.000
 BEQ      HG3    CG     HG1     109.470    3.000
 BEQ      HG2    CG     HG1     109.470    3.000
 BEQ      N1     CB     HB3     109.470    3.000
 BEQ      N1     CB     HB2     109.470    3.000
 BEQ      N1     CB     HB1     109.470    3.000
 BEQ      HB3    CB     HB2     109.470    3.000
 BEQ      HB3    CB     HB1     109.470    3.000
 BEQ      HB2    CB     HB1     109.470    3.000
 BEQ      C4     C5     H51     109.470    3.000
 BEQ      C4     C5     H52     109.470    3.000
 BEQ      C4     C5     C6      109.470    3.000
 BEQ      H51    C5     H52     107.900    3.000
 BEQ      H51    C5     C6      109.470    3.000
 BEQ      H52    C5     C6      109.470    3.000
 BEQ      C5     C6     H61     109.470    3.000
 BEQ      C5     C6     H62     109.470    3.000
 BEQ      C5     C6     C7      111.000    3.000
 BEQ      H61    C6     H62     107.900    3.000
 BEQ      H61    C6     C7      109.470    3.000
 BEQ      H62    C6     C7      109.470    3.000
 BEQ      C6     C7     H71     109.470    3.000
 BEQ      C6     C7     H72     109.470    3.000
 BEQ      C6     C7     C8      111.000    3.000
 BEQ      H71    C7     H72     107.900    3.000
 BEQ      H71    C7     C8      109.470    3.000
 BEQ      H72    C7     C8      109.470    3.000
 BEQ      C7     C8     H81     109.470    3.000
 BEQ      C7     C8     H82     109.470    3.000
 BEQ      C7     C8     C9      111.000    3.000
 BEQ      H81    C8     H82     107.900    3.000
 BEQ      H81    C8     C9      109.470    3.000
 BEQ      H82    C8     C9      109.470    3.000
 BEQ      C8     C9     H91     109.470    3.000
 BEQ      C8     C9     H92     109.470    3.000
 BEQ      C8     C9     C10     111.000    3.000
 BEQ      H91    C9     H92     107.900    3.000
 BEQ      H91    C9     C10     109.470    3.000
 BEQ      H92    C9     C10     109.470    3.000
 BEQ      C9     C10    H101    109.470    3.000
 BEQ      C9     C10    H102    109.470    3.000
 BEQ      C9     C10    C11     111.000    3.000
 BEQ      H101   C10    H102    107.900    3.000
 BEQ      H101   C10    C11     109.470    3.000
 BEQ      H102   C10    C11     109.470    3.000
 BEQ      C10    C11    H111    109.470    3.000
 BEQ      C10    C11    H112    109.470    3.000
 BEQ      C10    C11    C12     111.000    3.000
 BEQ      H111   C11    H112    107.900    3.000
 BEQ      H111   C11    C12     109.470    3.000
 BEQ      H112   C11    C12     109.470    3.000
 BEQ      C11    C12    H121    109.470    3.000
 BEQ      C11    C12    H122    109.470    3.000
 BEQ      C11    C12    C13     111.000    3.000
 BEQ      H121   C12    H122    107.900    3.000
 BEQ      H121   C12    C13     109.470    3.000
 BEQ      H122   C12    C13     109.470    3.000
 BEQ      C12    C13    H131    109.470    3.000
 BEQ      C12    C13    H132    109.470    3.000
 BEQ      C12    C13    C14     111.000    3.000
 BEQ      H131   C13    H132    107.900    3.000
 BEQ      H131   C13    C14     109.470    3.000
 BEQ      H132   C13    C14     109.470    3.000
 BEQ      C13    C14    H141    109.470    3.000
 BEQ      C13    C14    H142    109.470    3.000
 BEQ      C13    C14    C15     111.000    3.000
 BEQ      H141   C14    H142    107.900    3.000
 BEQ      H141   C14    C15     109.470    3.000
 BEQ      H142   C14    C15     109.470    3.000
 BEQ      C14    C15    H153    109.470    3.000
 BEQ      C14    C15    H152    109.470    3.000
 BEQ      C14    C15    H151    109.470    3.000
 BEQ      H153   C15    H152    109.470    3.000
 BEQ      H153   C15    H151    109.470    3.000
 BEQ      H152   C15    H151    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BEQ      CONST_1  O      C4     N2     C3         0.000    0.000   0
 BEQ      var_1    C4     N2     C3     C2       -89.968   20.000   3
 BEQ      var_2    N2     C3     C2     C1       -59.950   20.000   3
 BEQ      var_3    C3     C2     C1     N1      -178.007   20.000   3
 BEQ      var_4    C2     C1     N1     CB        61.548   20.000   1
 BEQ      var_5    C1     N1     CD     CE       -58.422   20.000   1
 BEQ      var_6    N1     CD     CE     OE1       60.157   20.000   3
 BEQ      var_7    C1     N1     CG     HG1      157.719   20.000   1
 BEQ      var_8    C1     N1     CB     HB1       46.726   20.000   1
 BEQ      var_9    O      C4     C5     C6         0.113   20.000   3
 BEQ      var_10   C4     C5     C6     C7      -178.438   20.000   3
 BEQ      var_11   C5     C6     C7     C8      -178.652   20.000   3
 BEQ      var_12   C6     C7     C8     C9       178.664   20.000   3
 BEQ      var_13   C7     C8     C9     C10      178.691   20.000   3
 BEQ      var_14   C8     C9     C10    C11     -179.641   20.000   3
 BEQ      var_15   C9     C10    C11    C12      179.056   20.000   3
 BEQ      var_16   C10    C11    C12    C13     -177.675   20.000   3
 BEQ      var_17   C11    C12    C13    C14     -179.737   20.000   3
 BEQ      var_18   C12    C13    C14    C15     -176.982   20.000   3
 BEQ      var_19   C13    C14    C15    H151     -66.417   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 BEQ      chir_01  N1     CB     CG     CD        positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 BEQ      plan-1    CE        0.020
 BEQ      plan-1    CD        0.020
 BEQ      plan-1    OE1       0.020
 BEQ      plan-1    OE2       0.020
 BEQ      plan-2    N2        0.020
 BEQ      plan-2    C3        0.020
 BEQ      plan-2    C4        0.020
 BEQ      plan-2    HN2       0.020
 BEQ      plan-3    C4        0.020
 BEQ      plan-3    N2        0.020
 BEQ      plan-3    O         0.020
 BEQ      plan-3    C5        0.020
 BEQ      plan-3    HN2       0.020
# ------------------------------------------------------
`.trim();

monomers["C15"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
C15      C15 'N-DODECYL-N,N-DIMETHYL-3-AMMONIO-1-P' non-polymer        60  22 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_C15
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 C15           O2S    O    OS        0.000      0.000    0.000    0.000
 C15           S1     S    ST        0.000      1.094    0.826   -0.478
 C15           O1S    O    OS        0.000      0.864    1.956   -1.358
 C15           O3S    O    OH1       0.000      2.225   -0.141   -1.149
 C15           H3S    H    H         0.000      3.002    0.248   -1.572
 C15           C1     C    CH2       0.000      2.047    1.364    0.908
 C15           H1C1   H    H         0.000      3.002    1.749    0.545
 C15           H1C2   H    H         0.000      2.226    0.507    1.561
 C15           C2     C    CH2       0.000      1.322    2.454    1.685
 C15           H2C1   H    H         0.000      0.358    2.047    1.999
 C15           H2C2   H    H         0.000      1.158    3.290    1.002
 C15           C3     C    CH2       0.000      2.091    2.938    2.906
 C15           H3C1   H    H         0.000      3.059    3.327    2.582
 C15           H3C2   H    H         0.000      2.247    2.094    3.582
 C15           N1     N    NT        1.000      1.312    4.042    3.636
 C15           C1N    C    CH3       0.000     -0.064    3.478    4.019
 C15           HCN3   H    H         0.000     -0.075    2.420    3.904
 C15           HCN2   H    H         0.000     -0.290    3.713    5.032
 C15           HCN1   H    H         0.000     -0.820    3.895    3.397
 C15           C2N    C    CH3       0.000      2.065    4.379    4.931
 C15           HCN6   H    H         0.000      1.461    4.990    5.560
 C15           HCN5   H    H         0.000      2.310    3.487    5.458
 C15           HCN4   H    H         0.000      2.965    4.902    4.710
 C15           C16    C    CH2       0.000      1.170    5.242    2.779
 C15           H161   H    H         0.000      0.634    4.965    1.869
 C15           H162   H    H         0.000      2.165    5.607    2.516
 C15           C15    C    CH2       0.000      0.402    6.337    3.510
 C15           H151   H    H         0.000      0.987    6.576    4.401
 C15           H152   H    H         0.000     -0.549    5.893    3.809
 C15           C14    C    CH2       0.000      0.142    7.618    2.709
 C15           H141   H    H         0.000      1.122    8.056    2.507
 C15           H142   H    H         0.000     -0.423    8.281    3.369
 C15           C13    C    CH2       0.000     -0.619    7.437    1.391
 C15           H131   H    H         0.000      0.010    6.838    0.730
 C15           H132   H    H         0.000     -0.762    8.429    0.957
 C15           C12    C    CH2       0.000     -1.978    6.754    1.563
 C15           H121   H    H         0.000     -2.567    7.324    2.285
 C15           H122   H    H         0.000     -1.814    5.744    1.944
 C15           C11    C    CH2       0.000     -2.731    6.682    0.231
 C15           H111   H    H         0.000     -2.114    6.108   -0.463
 C15           H112   H    H         0.000     -2.839    7.703   -0.139
 C15           C10    C    CH2       0.000     -4.112    6.030    0.348
 C15           H101   H    H         0.000     -4.698    6.628    1.050
 C15           H102   H    H         0.000     -3.968    5.028    0.757
 C15           C9     C    CH2       0.000     -4.855    5.935   -0.987
 C15           H9C1   H    H         0.000     -4.277    5.300   -1.662
 C15           H9C2   H    H         0.000     -4.935    6.938   -1.412
 C15           C8     C    CH2       0.000     -6.254    5.345   -0.802
 C15           H8C1   H    H         0.000     -6.803    5.970   -0.095
 C15           H8C2   H    H         0.000     -6.154    4.337   -0.393
 C15           C7     C    CH2       0.000     -7.012    5.286   -2.128
 C15           H7C1   H    H         0.000     -6.432    4.687   -2.833
 C15           H7C2   H    H         0.000     -7.114    6.302   -2.515
 C15           C6     C    CH2       0.000     -8.398    4.666   -1.950
 C15           H6C1   H    H         0.000     -8.949    5.258   -1.216
 C15           H6C2   H    H         0.000     -8.274    3.648   -1.575
 C15           C5     C    CH3       0.000     -9.168    4.635   -3.261
 C15           H5C3   H    H         0.000    -10.122    4.204   -3.102
 C15           H5C2   H    H         0.000     -9.285    5.623   -3.627
 C15           H5C1   H    H         0.000     -8.635    4.058   -3.972
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 C15      O2S    n/a    S1     START
 C15      S1     O2S    C1     .
 C15      O1S    S1     .      .
 C15      O3S    S1     H3S    .
 C15      H3S    O3S    .      .
 C15      C1     S1     C2     .
 C15      H1C1   C1     .      .
 C15      H1C2   C1     .      .
 C15      C2     C1     C3     .
 C15      H2C1   C2     .      .
 C15      H2C2   C2     .      .
 C15      C3     C2     N1     .
 C15      H3C1   C3     .      .
 C15      H3C2   C3     .      .
 C15      N1     C3     C16    .
 C15      C1N    N1     HCN1   .
 C15      HCN3   C1N    .      .
 C15      HCN2   C1N    .      .
 C15      HCN1   C1N    .      .
 C15      C2N    N1     HCN4   .
 C15      HCN6   C2N    .      .
 C15      HCN5   C2N    .      .
 C15      HCN4   C2N    .      .
 C15      C16    N1     C15    .
 C15      H161   C16    .      .
 C15      H162   C16    .      .
 C15      C15    C16    C14    .
 C15      H151   C15    .      .
 C15      H152   C15    .      .
 C15      C14    C15    C13    .
 C15      H141   C14    .      .
 C15      H142   C14    .      .
 C15      C13    C14    C12    .
 C15      H131   C13    .      .
 C15      H132   C13    .      .
 C15      C12    C13    C11    .
 C15      H121   C12    .      .
 C15      H122   C12    .      .
 C15      C11    C12    C10    .
 C15      H111   C11    .      .
 C15      H112   C11    .      .
 C15      C10    C11    C9     .
 C15      H101   C10    .      .
 C15      H102   C10    .      .
 C15      C9     C10    C8     .
 C15      H9C1   C9     .      .
 C15      H9C2   C9     .      .
 C15      C8     C9     C7     .
 C15      H8C1   C8     .      .
 C15      H8C2   C8     .      .
 C15      C7     C8     C6     .
 C15      H7C1   C7     .      .
 C15      H7C2   C7     .      .
 C15      C6     C7     C5     .
 C15      H6C1   C6     .      .
 C15      H6C2   C6     .      .
 C15      C5     C6     H5C1   .
 C15      H5C3   C5     .      .
 C15      H5C2   C5     .      .
 C15      H5C1   C5     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 C15      C2     C1        single      1.524    0.020
 C15      C1     S1        single      1.662    0.020
 C15      H1C1   C1        single      1.092    0.020
 C15      H1C2   C1        single      1.092    0.020
 C15      C3     C2        single      1.524    0.020
 C15      H2C1   C2        single      1.092    0.020
 C15      H2C2   C2        single      1.092    0.020
 C15      N1     C3        single      1.469    0.020
 C15      H3C1   C3        single      1.092    0.020
 C15      H3C2   C3        single      1.092    0.020
 C15      C5     C6        single      1.513    0.020
 C15      H5C1   C5        single      1.059    0.020
 C15      H5C2   C5        single      1.059    0.020
 C15      H5C3   C5        single      1.059    0.020
 C15      C6     C7        single      1.524    0.020
 C15      H6C1   C6        single      1.092    0.020
 C15      H6C2   C6        single      1.092    0.020
 C15      C7     C8        single      1.524    0.020
 C15      H7C1   C7        single      1.092    0.020
 C15      H7C2   C7        single      1.092    0.020
 C15      C8     C9        single      1.524    0.020
 C15      H8C1   C8        single      1.092    0.020
 C15      H8C2   C8        single      1.092    0.020
 C15      C1N    N1        single      1.469    0.020
 C15      C2N    N1        single      1.469    0.020
 C15      C16    N1        single      1.469    0.020
 C15      HCN1   C1N       single      1.059    0.020
 C15      HCN2   C1N       single      1.059    0.020
 C15      HCN3   C1N       single      1.059    0.020
 C15      HCN4   C2N       single      1.059    0.020
 C15      HCN5   C2N       single      1.059    0.020
 C15      HCN6   C2N       single      1.059    0.020
 C15      C9     C10       single      1.524    0.020
 C15      H9C1   C9        single      1.092    0.020
 C15      H9C2   C9        single      1.092    0.020
 C15      C10    C11       single      1.524    0.020
 C15      H101   C10       single      1.092    0.020
 C15      H102   C10       single      1.092    0.020
 C15      C11    C12       single      1.524    0.020
 C15      H111   C11       single      1.092    0.020
 C15      H112   C11       single      1.092    0.020
 C15      C12    C13       single      1.524    0.020
 C15      H121   C12       single      1.092    0.020
 C15      H122   C12       single      1.092    0.020
 C15      C13    C14       single      1.524    0.020
 C15      H131   C13       single      1.092    0.020
 C15      H132   C13       single      1.092    0.020
 C15      C14    C15       single      1.524    0.020
 C15      H141   C14       single      1.092    0.020
 C15      H142   C14       single      1.092    0.020
 C15      C15    C16       single      1.524    0.020
 C15      H151   C15       single      1.092    0.020
 C15      H152   C15       single      1.092    0.020
 C15      H161   C16       single      1.092    0.020
 C15      H162   C16       single      1.092    0.020
 C15      O1S    S1        double      1.436    0.020
 C15      S1     O2S       double      1.436    0.020
 C15      O3S    S1        single      1.635    0.020
 C15      H3S    O3S       single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 C15      O2S    S1     O1S     109.500    3.000
 C15      O2S    S1     O3S     109.500    3.000
 C15      O2S    S1     C1      109.500    3.000
 C15      O1S    S1     O3S     109.500    3.000
 C15      O1S    S1     C1      109.500    3.000
 C15      O3S    S1     C1      109.500    3.000
 C15      S1     O3S    H3S     120.000    3.000
 C15      S1     C1     H1C1    109.500    3.000
 C15      S1     C1     H1C2    109.500    3.000
 C15      S1     C1     C2      109.500    3.000
 C15      H1C1   C1     H1C2    107.900    3.000
 C15      H1C1   C1     C2      109.470    3.000
 C15      H1C2   C1     C2      109.470    3.000
 C15      C1     C2     H2C1    109.470    3.000
 C15      C1     C2     H2C2    109.470    3.000
 C15      C1     C2     C3      111.000    3.000
 C15      H2C1   C2     H2C2    107.900    3.000
 C15      H2C1   C2     C3      109.470    3.000
 C15      H2C2   C2     C3      109.470    3.000
 C15      C2     C3     H3C1    109.470    3.000
 C15      C2     C3     H3C2    109.470    3.000
 C15      C2     C3     N1      109.470    3.000
 C15      H3C1   C3     H3C2    107.900    3.000
 C15      H3C1   C3     N1      109.470    3.000
 C15      H3C2   C3     N1      109.470    3.000
 C15      C3     N1     C1N     109.470    3.000
 C15      C3     N1     C2N     109.470    3.000
 C15      C3     N1     C16     109.470    3.000
 C15      C1N    N1     C2N     109.470    3.000
 C15      C1N    N1     C16     109.470    3.000
 C15      C2N    N1     C16     109.470    3.000
 C15      N1     C1N    HCN3    109.470    3.000
 C15      N1     C1N    HCN2    109.470    3.000
 C15      N1     C1N    HCN1    109.470    3.000
 C15      HCN3   C1N    HCN2    109.470    3.000
 C15      HCN3   C1N    HCN1    109.470    3.000
 C15      HCN2   C1N    HCN1    109.470    3.000
 C15      N1     C2N    HCN6    109.470    3.000
 C15      N1     C2N    HCN5    109.470    3.000
 C15      N1     C2N    HCN4    109.470    3.000
 C15      HCN6   C2N    HCN5    109.470    3.000
 C15      HCN6   C2N    HCN4    109.470    3.000
 C15      HCN5   C2N    HCN4    109.470    3.000
 C15      N1     C16    H161    109.470    3.000
 C15      N1     C16    H162    109.470    3.000
 C15      N1     C16    C15     109.470    3.000
 C15      H161   C16    H162    107.900    3.000
 C15      H161   C16    C15     109.470    3.000
 C15      H162   C16    C15     109.470    3.000
 C15      C16    C15    H151    109.470    3.000
 C15      C16    C15    H152    109.470    3.000
 C15      C16    C15    C14     111.000    3.000
 C15      H151   C15    H152    107.900    3.000
 C15      H151   C15    C14     109.470    3.000
 C15      H152   C15    C14     109.470    3.000
 C15      C15    C14    H141    109.470    3.000
 C15      C15    C14    H142    109.470    3.000
 C15      C15    C14    C13     111.000    3.000
 C15      H141   C14    H142    107.900    3.000
 C15      H141   C14    C13     109.470    3.000
 C15      H142   C14    C13     109.470    3.000
 C15      C14    C13    H131    109.470    3.000
 C15      C14    C13    H132    109.470    3.000
 C15      C14    C13    C12     111.000    3.000
 C15      H131   C13    H132    107.900    3.000
 C15      H131   C13    C12     109.470    3.000
 C15      H132   C13    C12     109.470    3.000
 C15      C13    C12    H121    109.470    3.000
 C15      C13    C12    H122    109.470    3.000
 C15      C13    C12    C11     111.000    3.000
 C15      H121   C12    H122    107.900    3.000
 C15      H121   C12    C11     109.470    3.000
 C15      H122   C12    C11     109.470    3.000
 C15      C12    C11    H111    109.470    3.000
 C15      C12    C11    H112    109.470    3.000
 C15      C12    C11    C10     111.000    3.000
 C15      H111   C11    H112    107.900    3.000
 C15      H111   C11    C10     109.470    3.000
 C15      H112   C11    C10     109.470    3.000
 C15      C11    C10    H101    109.470    3.000
 C15      C11    C10    H102    109.470    3.000
 C15      C11    C10    C9      111.000    3.000
 C15      H101   C10    H102    107.900    3.000
 C15      H101   C10    C9      109.470    3.000
 C15      H102   C10    C9      109.470    3.000
 C15      C10    C9     H9C1    109.470    3.000
 C15      C10    C9     H9C2    109.470    3.000
 C15      C10    C9     C8      111.000    3.000
 C15      H9C1   C9     H9C2    107.900    3.000
 C15      H9C1   C9     C8      109.470    3.000
 C15      H9C2   C9     C8      109.470    3.000
 C15      C9     C8     H8C1    109.470    3.000
 C15      C9     C8     H8C2    109.470    3.000
 C15      C9     C8     C7      111.000    3.000
 C15      H8C1   C8     H8C2    107.900    3.000
 C15      H8C1   C8     C7      109.470    3.000
 C15      H8C2   C8     C7      109.470    3.000
 C15      C8     C7     H7C1    109.470    3.000
 C15      C8     C7     H7C2    109.470    3.000
 C15      C8     C7     C6      111.000    3.000
 C15      H7C1   C7     H7C2    107.900    3.000
 C15      H7C1   C7     C6      109.470    3.000
 C15      H7C2   C7     C6      109.470    3.000
 C15      C7     C6     H6C1    109.470    3.000
 C15      C7     C6     H6C2    109.470    3.000
 C15      C7     C6     C5      111.000    3.000
 C15      H6C1   C6     H6C2    107.900    3.000
 C15      H6C1   C6     C5      109.470    3.000
 C15      H6C2   C6     C5      109.470    3.000
 C15      C6     C5     H5C3    109.470    3.000
 C15      C6     C5     H5C2    109.470    3.000
 C15      C6     C5     H5C1    109.470    3.000
 C15      H5C3   C5     H5C2    109.470    3.000
 C15      H5C3   C5     H5C1    109.470    3.000
 C15      H5C2   C5     H5C1    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 C15      var_1    O2S    S1     O3S    H3S      176.114   20.000   1
 C15      var_2    O2S    S1     C1     C2       -74.468   20.000   1
 C15      var_3    S1     C1     C2     C3       179.020   20.000   3
 C15      var_4    C1     C2     C3     N1       179.497   20.000   3
 C15      var_5    C2     C3     N1     C16      -64.197   20.000   1
 C15      var_6    C3     N1     C1N    HCN1    -106.773   20.000   1
 C15      var_7    C3     N1     C2N    HCN4      71.581   20.000   1
 C15      var_8    C3     N1     C16    C15     -179.718   20.000   1
 C15      var_9    N1     C16    C15    C14     -177.809   20.000   3
 C15      var_10   C16    C15    C14    C13       57.439   20.000   3
 C15      var_11   C15    C14    C13    C12       56.698   20.000   3
 C15      var_12   C14    C13    C12    C11      176.299   20.000   3
 C15      var_13   C13    C12    C11    C10     -178.878   20.000   3
 C15      var_14   C12    C11    C10    C9      -178.960   20.000   3
 C15      var_15   C11    C10    C9     C8      -177.036   20.000   3
 C15      var_16   C10    C9     C8     C7       178.399   20.000   3
 C15      var_17   C9     C8     C7     C6       178.650   20.000   3
 C15      var_18   C8     C7     C6     C5       178.660   20.000   3
 C15      var_19   C7     C6     C5     H5C1      60.186   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 C15      chir_01  N1     C3     C1N    C2N       negativ
 C15      chir_02  S1     C1     O1S    O2S       positiv
# ------------------------------------------------------
`.trim();

monomers["MG8"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MG8      MG8 'N-OCTANOYL-N-METHYLGLUCAMINE        ' non-polymer        53  22 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MG8
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MG8           O8     O    O         0.000      0.000    0.000    0.000
 MG8           C8     C    C         0.000      1.222   -0.037   -0.171
 MG8           C7     C    CH2       0.000      2.015    1.251   -0.357
 MG8           H71    H    H         0.000      2.517    1.197   -1.325
 MG8           H72    H    H         0.000      2.763    1.301    0.437
 MG8           C6     C    CH2       0.000      1.131    2.498   -0.307
 MG8           H61    H    H         0.000      0.674    2.535    0.684
 MG8           H62    H    H         0.000      0.351    2.376   -1.062
 MG8           C5     C    CH2       0.000      1.896    3.798   -0.568
 MG8           H51    H    H         0.000      2.400    3.693   -1.531
 MG8           H52    H    H         0.000      2.643    3.901    0.222
 MG8           C4     C    CH2       0.000      1.000    5.038   -0.590
 MG8           H41    H    H         0.000      0.479    5.108    0.367
 MG8           H42    H    H         0.000      0.268    4.924   -1.393
 MG8           C3     C    CH2       0.000      1.819    6.310   -0.821
 MG8           H31    H    H         0.000      2.322    6.228   -1.787
 MG8           H32    H    H         0.000      2.567    6.389   -0.029
 MG8           C2     C    CH2       0.000      0.930    7.553   -0.812
 MG8           H21    H    H         0.000      0.410    7.598    0.147
 MG8           H22    H    H         0.000      0.199    7.461   -1.618
 MG8           C1     C    CH3       0.000      1.745    8.822   -1.008
 MG8           H13A   H    H         0.000      2.458    8.909   -0.230
 MG8           H12A   H    H         0.000      2.246    8.781   -1.941
 MG8           H11A   H    H         0.000      1.101    9.663   -0.991
 MG8           N      N    N         0.000      1.959   -1.226   -0.204
 MG8           C15    C    CH3       0.000      3.405   -1.246   -0.407
 MG8           H153   H    H         0.000      3.824   -2.066    0.116
 MG8           H152   H    H         0.000      3.616   -1.341   -1.441
 MG8           H151   H    H         0.000      3.826   -0.344   -0.044
 MG8           C9     C    CH2       0.000      1.338   -2.535   -0.036
 MG8           H91    H    H         0.000      0.263   -2.407    0.112
 MG8           H92    H    H         0.000      1.768   -3.028    0.838
 MG8           C10    C    CH1       0.000      1.586   -3.391   -1.284
 MG8           H10    H    H         0.000      2.669   -3.501   -1.433
 MG8           O10    O    OH1       0.000      1.027   -2.722   -2.412
 MG8           HO10   H    H         0.000      0.295   -2.160   -2.122
 MG8           C11    C    CH1       0.000      0.952   -4.793   -1.158
 MG8           H11    H    H         0.000     -0.133   -4.673   -1.029
 MG8           O11    O    OH1       0.000      1.473   -5.437    0.004
 MG8           HO11   H    H         0.000      1.690   -6.355   -0.208
 MG8           C12    C    CH1       0.000      1.199   -5.696   -2.391
 MG8           H12    H    H         0.000      2.283   -5.827   -2.513
 MG8           O12    O    OH1       0.000      0.685   -5.070   -3.566
 MG8           HO12   H    H         0.000     -0.077   -4.524   -3.331
 MG8           C13    C    CH1       0.000      0.550   -7.091   -2.261
 MG8           H13    H    H         0.000      0.998   -7.605   -1.399
 MG8           O13    O    OH1       0.000      0.828   -7.850   -3.435
 MG8           HO13   H    H         0.000      1.758   -7.738   -3.676
 MG8           C14    C    CH2       0.000     -0.965   -7.042   -2.062
 MG8           H141   H    H         0.000     -1.424   -6.563   -2.930
 MG8           H142   H    H         0.000     -1.189   -6.459   -1.166
 MG8           O14    O    OH1       0.000     -1.484   -8.354   -1.915
 MG8           HO14   H    H         0.000     -0.889   -8.872   -1.356
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MG8      O8     n/a    C8     START
 MG8      C8     O8     N      .
 MG8      C7     C8     C6     .
 MG8      H71    C7     .      .
 MG8      H72    C7     .      .
 MG8      C6     C7     C5     .
 MG8      H61    C6     .      .
 MG8      H62    C6     .      .
 MG8      C5     C6     C4     .
 MG8      H51    C5     .      .
 MG8      H52    C5     .      .
 MG8      C4     C5     C3     .
 MG8      H41    C4     .      .
 MG8      H42    C4     .      .
 MG8      C3     C4     C2     .
 MG8      H31    C3     .      .
 MG8      H32    C3     .      .
 MG8      C2     C3     C1     .
 MG8      H21    C2     .      .
 MG8      H22    C2     .      .
 MG8      C1     C2     H11A   .
 MG8      H13A   C1     .      .
 MG8      H12A   C1     .      .
 MG8      H11A   C1     .      .
 MG8      N      C8     C9     .
 MG8      C15    N      H151   .
 MG8      H153   C15    .      .
 MG8      H152   C15    .      .
 MG8      H151   C15    .      .
 MG8      C9     N      C10    .
 MG8      H91    C9     .      .
 MG8      H92    C9     .      .
 MG8      C10    C9     C11    .
 MG8      H10    C10    .      .
 MG8      O10    C10    HO10   .
 MG8      HO10   O10    .      .
 MG8      C11    C10    C12    .
 MG8      H11    C11    .      .
 MG8      O11    C11    HO11   .
 MG8      HO11   O11    .      .
 MG8      C12    C11    C13    .
 MG8      H12    C12    .      .
 MG8      O12    C12    HO12   .
 MG8      HO12   O12    .      .
 MG8      C13    C12    C14    .
 MG8      H13    C13    .      .
 MG8      O13    C13    HO13   .
 MG8      HO13   O13    .      .
 MG8      C14    C13    O14    .
 MG8      H141   C14    .      .
 MG8      H142   C14    .      .
 MG8      O14    C14    HO14   .
 MG8      HO14   O14    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MG8      C1     C2        single      1.513    0.020
 MG8      H11A   C1        single      1.059    0.020
 MG8      H12A   C1        single      1.059    0.020
 MG8      H13A   C1        single      1.059    0.020
 MG8      C2     C3        single      1.524    0.020
 MG8      H21    C2        single      1.092    0.020
 MG8      H22    C2        single      1.092    0.020
 MG8      C3     C4        single      1.524    0.020
 MG8      H31    C3        single      1.092    0.020
 MG8      H32    C3        single      1.092    0.020
 MG8      C4     C5        single      1.524    0.020
 MG8      H41    C4        single      1.092    0.020
 MG8      H42    C4        single      1.092    0.020
 MG8      C5     C6        single      1.524    0.020
 MG8      H51    C5        single      1.092    0.020
 MG8      H52    C5        single      1.092    0.020
 MG8      C6     C7        single      1.524    0.020
 MG8      H61    C6        single      1.092    0.020
 MG8      H62    C6        single      1.092    0.020
 MG8      C7     C8        single      1.510    0.020
 MG8      H71    C7        single      1.092    0.020
 MG8      H72    C7        single      1.092    0.020
 MG8      C8     O8        double      1.220    0.020
 MG8      N      C8        single      1.330    0.020
 MG8      C9     N         single      1.455    0.020
 MG8      C15    N         single      1.455    0.020
 MG8      C10    C9        single      1.524    0.020
 MG8      H91    C9        single      1.092    0.020
 MG8      H92    C9        single      1.092    0.020
 MG8      O10    C10       single      1.432    0.020
 MG8      C11    C10       single      1.524    0.020
 MG8      H10    C10       single      1.099    0.020
 MG8      HO10   O10       single      0.967    0.020
 MG8      O11    C11       single      1.432    0.020
 MG8      C12    C11       single      1.524    0.020
 MG8      H11    C11       single      1.099    0.020
 MG8      HO11   O11       single      0.967    0.020
 MG8      O12    C12       single      1.432    0.020
 MG8      C13    C12       single      1.524    0.020
 MG8      H12    C12       single      1.099    0.020
 MG8      HO12   O12       single      0.967    0.020
 MG8      O13    C13       single      1.432    0.020
 MG8      C14    C13       single      1.524    0.020
 MG8      H13    C13       single      1.099    0.020
 MG8      HO13   O13       single      0.967    0.020
 MG8      O14    C14       single      1.432    0.020
 MG8      H141   C14       single      1.092    0.020
 MG8      H142   C14       single      1.092    0.020
 MG8      HO14   O14       single      0.967    0.020
 MG8      H151   C15       single      1.059    0.020
 MG8      H152   C15       single      1.059    0.020
 MG8      H153   C15       single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MG8      O8     C8     C7      120.500    3.000
 MG8      O8     C8     N       123.000    3.000
 MG8      C7     C8     N       116.500    3.000
 MG8      C8     C7     H71     109.470    3.000
 MG8      C8     C7     H72     109.470    3.000
 MG8      C8     C7     C6      109.470    3.000
 MG8      H71    C7     H72     107.900    3.000
 MG8      H71    C7     C6      109.470    3.000
 MG8      H72    C7     C6      109.470    3.000
 MG8      C7     C6     H61     109.470    3.000
 MG8      C7     C6     H62     109.470    3.000
 MG8      C7     C6     C5      111.000    3.000
 MG8      H61    C6     H62     107.900    3.000
 MG8      H61    C6     C5      109.470    3.000
 MG8      H62    C6     C5      109.470    3.000
 MG8      C6     C5     H51     109.470    3.000
 MG8      C6     C5     H52     109.470    3.000
 MG8      C6     C5     C4      111.000    3.000
 MG8      H51    C5     H52     107.900    3.000
 MG8      H51    C5     C4      109.470    3.000
 MG8      H52    C5     C4      109.470    3.000
 MG8      C5     C4     H41     109.470    3.000
 MG8      C5     C4     H42     109.470    3.000
 MG8      C5     C4     C3      111.000    3.000
 MG8      H41    C4     H42     107.900    3.000
 MG8      H41    C4     C3      109.470    3.000
 MG8      H42    C4     C3      109.470    3.000
 MG8      C4     C3     H31     109.470    3.000
 MG8      C4     C3     H32     109.470    3.000
 MG8      C4     C3     C2      111.000    3.000
 MG8      H31    C3     H32     107.900    3.000
 MG8      H31    C3     C2      109.470    3.000
 MG8      H32    C3     C2      109.470    3.000
 MG8      C3     C2     H21     109.470    3.000
 MG8      C3     C2     H22     109.470    3.000
 MG8      C3     C2     C1      111.000    3.000
 MG8      H21    C2     H22     107.900    3.000
 MG8      H21    C2     C1      109.470    3.000
 MG8      H22    C2     C1      109.470    3.000
 MG8      C2     C1     H13A    109.470    3.000
 MG8      C2     C1     H12A    109.470    3.000
 MG8      C2     C1     H11A    109.470    3.000
 MG8      H13A   C1     H12A    109.470    3.000
 MG8      H13A   C1     H11A    109.470    3.000
 MG8      H12A   C1     H11A    109.470    3.000
 MG8      C8     N      C15     127.000    3.000
 MG8      C8     N      C9      127.000    3.000
 MG8      C15    N      C9      120.000    3.000
 MG8      N      C15    H153    109.470    3.000
 MG8      N      C15    H152    109.470    3.000
 MG8      N      C15    H151    109.470    3.000
 MG8      H153   C15    H152    109.470    3.000
 MG8      H153   C15    H151    109.470    3.000
 MG8      H152   C15    H151    109.470    3.000
 MG8      N      C9     H91     109.470    3.000
 MG8      N      C9     H92     109.470    3.000
 MG8      N      C9     C10     105.000    3.000
 MG8      H91    C9     H92     107.900    3.000
 MG8      H91    C9     C10     109.470    3.000
 MG8      H92    C9     C10     109.470    3.000
 MG8      C9     C10    H10     108.340    3.000
 MG8      C9     C10    O10     109.470    3.000
 MG8      C9     C10    C11     111.000    3.000
 MG8      H10    C10    O10     109.470    3.000
 MG8      H10    C10    C11     108.340    3.000
 MG8      O10    C10    C11     109.470    3.000
 MG8      C10    O10    HO10    109.470    3.000
 MG8      C10    C11    H11     108.340    3.000
 MG8      C10    C11    O11     109.470    3.000
 MG8      C10    C11    C12     111.000    3.000
 MG8      H11    C11    O11     109.470    3.000
 MG8      H11    C11    C12     108.340    3.000
 MG8      O11    C11    C12     109.470    3.000
 MG8      C11    O11    HO11    109.470    3.000
 MG8      C11    C12    H12     108.340    3.000
 MG8      C11    C12    O12     109.470    3.000
 MG8      C11    C12    C13     111.000    3.000
 MG8      H12    C12    O12     109.470    3.000
 MG8      H12    C12    C13     108.340    3.000
 MG8      O12    C12    C13     109.470    3.000
 MG8      C12    O12    HO12    109.470    3.000
 MG8      C12    C13    H13     108.340    3.000
 MG8      C12    C13    O13     109.470    3.000
 MG8      C12    C13    C14     111.000    3.000
 MG8      H13    C13    O13     109.470    3.000
 MG8      H13    C13    C14     108.340    3.000
 MG8      O13    C13    C14     109.470    3.000
 MG8      C13    O13    HO13    109.470    3.000
 MG8      C13    C14    H141    109.470    3.000
 MG8      C13    C14    H142    109.470    3.000
 MG8      C13    C14    O14     109.470    3.000
 MG8      H141   C14    H142    107.900    3.000
 MG8      H141   C14    O14     109.470    3.000
 MG8      H142   C14    O14     109.470    3.000
 MG8      C14    O14    HO14    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MG8      var_1    O8     C8     C7     C6        -0.141   20.000   3
 MG8      var_2    C8     C7     C6     C5      -176.897   20.000   3
 MG8      var_3    C7     C6     C5     C4       177.002   20.000   3
 MG8      var_4    C6     C5     C4     C3       178.684   20.000   3
 MG8      var_5    C5     C4     C3     C2      -178.694   20.000   3
 MG8      var_6    C4     C3     C2     C1       178.652   20.000   3
 MG8      var_7    C3     C2     C1     H11A    -179.691   20.000   3
 MG8      CONST_1  O8     C8     N      C9         0.000    0.000   0
 MG8      var_8    C8     N      C15    H151      28.177   20.000   1
 MG8      var_9    C8     N      C9     C10      120.027   20.000   1
 MG8      var_10   N      C9     C10    C11      179.806   20.000   3
 MG8      var_11   C9     C10    O10    HO10     -27.064   20.000   1
 MG8      var_12   C9     C10    C11    C12     -179.180   20.000   3
 MG8      var_13   C10    C11    O11    HO11    -136.259   20.000   1
 MG8      var_14   C10    C11    C12    C13     -179.472   20.000   3
 MG8      var_15   C11    C12    O12    HO12     -30.646   20.000   1
 MG8      var_16   C11    C12    C13    C14       58.819   20.000   3
 MG8      var_17   C12    C13    O13    HO13      44.212   20.000   1
 MG8      var_18   C12    C13    C14    O14     -178.438   20.000   3
 MG8      var_19   C13    C14    O14    HO14      41.191   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MG8      chir_01  C10    C9     O10    C11       positiv
 MG8      chir_02  C11    C10    O11    C12       positiv
 MG8      chir_03  C12    C11    O12    C13       positiv
 MG8      chir_04  C13    C12    O13    C14       positiv
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 MG8      plan-1    C8        0.020
 MG8      plan-1    C7        0.020
 MG8      plan-1    O8        0.020
 MG8      plan-1    N         0.020
 MG8      plan-2    N         0.020
 MG8      plan-2    C8        0.020
 MG8      plan-2    C9        0.020
 MG8      plan-2    C15       0.020
# ------------------------------------------------------
`.trim();

monomers["POL"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
POL      POL 'N-PROPANOL                          ' non-polymer        12   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_POL
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 POL           C3     C    CH3       0.000      0.000    0.000    0.000
 POL           H31    H    H         0.000      1.000    0.000   -0.352
 POL           H32    H    H         0.000     -0.162    0.865    0.592
 POL           H33    H    H         0.000     -0.163   -0.865    0.592
 POL           C2     C    CH2       0.000     -0.964    0.000   -1.187
 POL           H21    H    H         0.000     -0.793   -0.891   -1.795
 POL           H22    H    H         0.000     -0.793    0.891   -1.795
 POL           C1     C    CH2       0.000     -2.404    0.000   -0.675
 POL           H11    H    H         0.000     -2.574    0.891   -0.067
 POL           H12    H    H         0.000     -2.574   -0.891   -0.067
 POL           O      O    OH1       0.000     -3.306    0.000   -1.784
 POL           HO     H    H         0.000     -4.216    0.000   -1.459
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 POL      C3     n/a    C2     START
 POL      H31    C3     .      .
 POL      H32    C3     .      .
 POL      H33    C3     .      .
 POL      C2     C3     C1     .
 POL      H21    C2     .      .
 POL      H22    C2     .      .
 POL      C1     C2     O      .
 POL      H11    C1     .      .
 POL      H12    C1     .      .
 POL      O      C1     HO     .
 POL      HO     O      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 POL      O      C1        single      1.432    0.020
 POL      HO     O         single      0.967    0.020
 POL      C1     C2        single      1.524    0.020
 POL      H11    C1        single      1.092    0.020
 POL      H12    C1        single      1.092    0.020
 POL      C2     C3        single      1.513    0.020
 POL      H21    C2        single      1.092    0.020
 POL      H22    C2        single      1.092    0.020
 POL      H31    C3        single      1.059    0.020
 POL      H32    C3        single      1.059    0.020
 POL      H33    C3        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 POL      H31    C3     H32     109.470    3.000
 POL      H31    C3     H33     109.470    3.000
 POL      H32    C3     H33     109.470    3.000
 POL      H31    C3     C2      109.470    3.000
 POL      H32    C3     C2      109.470    3.000
 POL      H33    C3     C2      109.470    3.000
 POL      C3     C2     H21     109.470    3.000
 POL      C3     C2     H22     109.470    3.000
 POL      C3     C2     C1      111.000    3.000
 POL      H21    C2     H22     107.900    3.000
 POL      H21    C2     C1      109.470    3.000
 POL      H22    C2     C1      109.470    3.000
 POL      C2     C1     H11     109.470    3.000
 POL      C2     C1     H12     109.470    3.000
 POL      C2     C1     O       109.470    3.000
 POL      H11    C1     H12     107.900    3.000
 POL      H11    C1     O       109.470    3.000
 POL      H12    C1     O       109.470    3.000
 POL      C1     O      HO      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 POL      var_1    H33    C3     C2     C1        59.986   20.000   3
 POL      var_2    C3     C2     C1     O        180.000   20.000   3
 POL      var_3    C2     C1     O      HO       180.000   20.000   1
# ------------------------------------------------------
`.trim();

monomers["JEF"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
JEF      JEF '.                                   ' non-polymer       104  41 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_JEF
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 JEF           N1     N    NH2       0.000      0.000    0.000    0.000
 JEF           HN11   H    H         0.000      0.773   -0.445   -0.480
 JEF           HN12   H    H         0.000      0.139    0.364    0.936
 JEF           C30    C    CH1       0.000     -1.310    0.117   -0.653
 JEF           H30    H    H         0.000     -1.543    1.178   -0.821
 JEF           C31    C    CH3       0.000     -2.384   -0.506    0.243
 JEF           H313   H    H         0.000     -2.115   -1.503    0.477
 JEF           H312   H    H         0.000     -2.468    0.056    1.137
 JEF           H311   H    H         0.000     -3.314   -0.502   -0.264
 JEF           C16    C    CH2       0.000     -1.279   -0.617   -1.996
 JEF           H161   H    H         0.000     -0.457   -0.230   -2.603
 JEF           H162   H    H         0.000     -2.223   -0.457   -2.521
 JEF           O6     O    O2        0.000     -1.088   -2.015   -1.771
 JEF           C14    C    CH2       0.000     -0.930   -2.780   -2.967
 JEF           H141   H    H         0.000     -0.010   -2.479   -3.472
 JEF           H142   H    H         0.000     -1.781   -2.602   -3.628
 JEF           C13    C    CH1       0.000     -0.858   -4.267   -2.616
 JEF           H13    H    H         0.000     -0.662   -4.850   -3.526
 JEF           C15    C    CH3       0.000      0.270   -4.499   -1.608
 JEF           H153   H    H         0.000      0.123   -3.877   -0.762
 JEF           H152   H    H         0.000      0.270   -5.513   -1.303
 JEF           H151   H    H         0.000      1.201   -4.266   -2.058
 JEF           O5     O    O2        0.000     -2.100   -4.682   -2.043
 JEF           C10    C    CH2       0.000     -2.463   -6.028   -2.355
 JEF           H101   H    H         0.000     -1.739   -6.713   -1.908
 JEF           H102   H    H         0.000     -2.466   -6.162   -3.439
 JEF           C11    C    CH1       0.000     -3.857   -6.322   -1.800
 JEF           H11    H    H         0.000     -4.104   -7.380   -1.970
 JEF           C12    C    CH3       0.000     -3.881   -6.029   -0.298
 JEF           H123   H    H         0.000     -4.846   -6.233    0.088
 JEF           H122   H    H         0.000     -3.169   -6.640    0.194
 JEF           H121   H    H         0.000     -3.644   -5.009   -0.133
 JEF           O4     O    O2        0.000     -4.818   -5.498   -2.461
 JEF           C8     C    CH2       0.000     -6.090   -6.122   -2.649
 JEF           H81    H    H         0.000     -6.548   -6.312   -1.676
 JEF           H82    H    H         0.000     -5.955   -7.068   -3.178
 JEF           C7     C    CH1       0.000     -6.995   -5.201   -3.469
 JEF           H7     H    H         0.000     -7.946   -5.711   -3.676
 JEF           C9     C    CH3       0.000     -6.305   -4.854   -4.791
 JEF           H93    H    H         0.000     -6.118   -5.743   -5.336
 JEF           H92    H    H         0.000     -6.931   -4.217   -5.360
 JEF           H91    H    H         0.000     -5.388   -4.363   -4.593
 JEF           O3     O    O2        0.000     -7.246   -4.002   -2.735
 JEF           C4     C    CH2       0.000     -8.472   -3.355   -3.080
 JEF           H41    H    H         0.000     -9.311   -4.002   -2.816
 JEF           H42    H    H         0.000     -8.489   -3.159   -4.154
 JEF           C5     C    CH1       0.000     -8.584   -2.034   -2.317
 JEF           H5     H    H         0.000     -9.486   -1.497   -2.644
 JEF           C6     C    CH3       0.000     -7.349   -1.175   -2.598
 JEF           H63    H    H         0.000     -7.284   -0.978   -3.637
 JEF           H62    H    H         0.000     -7.426   -0.259   -2.071
 JEF           H61    H    H         0.000     -6.479   -1.691   -2.283
 JEF           O2     O    O2        0.000     -8.670   -2.299   -0.916
 JEF           C3     C    CH2       0.000     -9.996   -2.568   -0.455
 JEF           H31    H    H         0.000    -10.358   -3.494   -0.908
 JEF           H32    H    H         0.000    -10.654   -1.744   -0.741
 JEF           C2     C    CH1       0.000     -9.989   -2.713    1.068
 JEF           H2     H    H         0.000    -10.990   -3.006    1.413
 JEF           C1     C    CH3       0.000     -8.975   -3.785    1.473
 JEF           H13A   H    H         0.000     -8.969   -3.886    2.527
 JEF           H12    H    H         0.000     -9.242   -4.710    1.031
 JEF           H11A   H    H         0.000     -8.009   -3.502    1.141
 JEF           OH     O    O2        0.000     -9.626   -1.465    1.663
 JEF           C17    C    CH2       0.000    -10.263   -1.212    2.916
 JEF           H171   H    H         0.000    -10.060   -2.038    3.601
 JEF           H172   H    H         0.000    -11.341   -1.124    2.764
 JEF           C      C    CH1       0.000     -9.722    0.091    3.510
 JEF           H      H    H         0.000    -10.157    0.247    4.507
 JEF           C18    C    CH3       0.000     -8.199    0.004    3.626
 JEF           H183   H    H         0.000     -7.823    0.905    4.038
 JEF           H182   H    H         0.000     -7.937   -0.806    4.256
 JEF           H181   H    H         0.000     -7.778   -0.146    2.666
 JEF           O      O    O2        0.000    -10.074    1.183    2.659
 JEF           C20    C    CH2       0.000    -10.344    2.400    3.358
 JEF           H201   H    H         0.000     -9.432    2.747    3.849
 JEF           H202   H    H         0.000    -11.116    2.224    4.110
 JEF           C19    C    CH1       0.000    -10.827    3.462    2.368
 JEF           H19    H    H         0.000    -11.109    4.372    2.915
 JEF           C40    C    CH3       0.000    -12.041    2.929    1.603
 JEF           H403   H    H         0.000    -12.377    3.662    0.916
 JEF           H402   H    H         0.000    -11.771    2.051    1.076
 JEF           H401   H    H         0.000    -12.819    2.704    2.286
 JEF           O10    O    O2        0.000     -9.778    3.766    1.446
 JEF           C32    C    CH2       0.000     -9.764    5.126    1.010
 JEF           H321   H    H         0.000     -9.556    5.778    1.861
 JEF           H322   H    H         0.000    -10.738    5.382    0.587
 JEF           C33    C    CH1       0.000     -8.680    5.310   -0.053
 JEF           H33    H    H         0.000     -8.721    6.336   -0.445
 JEF           C34    C    CH3       0.000     -8.912    4.319   -1.195
 JEF           H343   H    H         0.000     -8.118    4.390   -1.893
 JEF           H342   H    H         0.000     -8.951    3.334   -0.807
 JEF           H341   H    H         0.000     -9.827    4.543   -1.679
 JEF           O11    O    O2        0.000     -7.396    5.073    0.529
 JEF           C36    C    CH2       0.000     -6.351    5.879   -0.018
 JEF           H361   H    H         0.000     -6.627    6.933    0.057
 JEF           H362   H    H         0.000     -6.202    5.617   -1.068
 JEF           C37    C    CH2       0.000     -5.057    5.633    0.759
 JEF           H371   H    H         0.000     -5.232    5.814    1.822
 JEF           H372   H    H         0.000     -4.282    6.312    0.398
 JEF           O12    O    O2        0.000     -4.636    4.281    0.568
 JEF           C38    C    CH3       0.000     -3.494    3.913    1.343
 JEF           H383   H    H         0.000     -3.682    4.111    2.366
 JEF           H382   H    H         0.000     -3.296    2.880    1.214
 JEF           H381   H    H         0.000     -2.654    4.475    1.024
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 JEF      N1     n/a    C30    START
 JEF      HN11   N1     .      .
 JEF      HN12   N1     .      .
 JEF      C30    N1     C16    .
 JEF      H30    C30    .      .
 JEF      C31    C30    H311   .
 JEF      H313   C31    .      .
 JEF      H312   C31    .      .
 JEF      H311   C31    .      .
 JEF      C16    C30    O6     .
 JEF      H161   C16    .      .
 JEF      H162   C16    .      .
 JEF      O6     C16    C14    .
 JEF      C14    O6     C13    .
 JEF      H141   C14    .      .
 JEF      H142   C14    .      .
 JEF      C13    C14    O5     .
 JEF      H13    C13    .      .
 JEF      C15    C13    H151   .
 JEF      H153   C15    .      .
 JEF      H152   C15    .      .
 JEF      H151   C15    .      .
 JEF      O5     C13    C10    .
 JEF      C10    O5     C11    .
 JEF      H101   C10    .      .
 JEF      H102   C10    .      .
 JEF      C11    C10    O4     .
 JEF      H11    C11    .      .
 JEF      C12    C11    H121   .
 JEF      H123   C12    .      .
 JEF      H122   C12    .      .
 JEF      H121   C12    .      .
 JEF      O4     C11    C8     .
 JEF      C8     O4     C7     .
 JEF      H81    C8     .      .
 JEF      H82    C8     .      .
 JEF      C7     C8     O3     .
 JEF      H7     C7     .      .
 JEF      C9     C7     H91    .
 JEF      H93    C9     .      .
 JEF      H92    C9     .      .
 JEF      H91    C9     .      .
 JEF      O3     C7     C4     .
 JEF      C4     O3     C5     .
 JEF      H41    C4     .      .
 JEF      H42    C4     .      .
 JEF      C5     C4     O2     .
 JEF      H5     C5     .      .
 JEF      C6     C5     H61    .
 JEF      H63    C6     .      .
 JEF      H62    C6     .      .
 JEF      H61    C6     .      .
 JEF      O2     C5     C3     .
 JEF      C3     O2     C2     .
 JEF      H31    C3     .      .
 JEF      H32    C3     .      .
 JEF      C2     C3     OH     .
 JEF      H2     C2     .      .
 JEF      C1     C2     H11A   .
 JEF      H13A   C1     .      .
 JEF      H12    C1     .      .
 JEF      H11A   C1     .      .
 JEF      OH     C2     C17    .
 JEF      C17    OH     C      .
 JEF      H171   C17    .      .
 JEF      H172   C17    .      .
 JEF      C      C17    O      .
 JEF      H      C      .      .
 JEF      C18    C      H181   .
 JEF      H183   C18    .      .
 JEF      H182   C18    .      .
 JEF      H181   C18    .      .
 JEF      O      C      C20    .
 JEF      C20    O      C19    .
 JEF      H201   C20    .      .
 JEF      H202   C20    .      .
 JEF      C19    C20    O10    .
 JEF      H19    C19    .      .
 JEF      C40    C19    H401   .
 JEF      H403   C40    .      .
 JEF      H402   C40    .      .
 JEF      H401   C40    .      .
 JEF      O10    C19    C32    .
 JEF      C32    O10    C33    .
 JEF      H321   C32    .      .
 JEF      H322   C32    .      .
 JEF      C33    C32    O11    .
 JEF      H33    C33    .      .
 JEF      C34    C33    H341   .
 JEF      H343   C34    .      .
 JEF      H342   C34    .      .
 JEF      H341   C34    .      .
 JEF      O11    C33    C36    .
 JEF      C36    O11    C37    .
 JEF      H361   C36    .      .
 JEF      H362   C36    .      .
 JEF      C37    C36    O12    .
 JEF      H371   C37    .      .
 JEF      H372   C37    .      .
 JEF      O12    C37    C38    .
 JEF      C38    O12    H381   .
 JEF      H383   C38    .      .
 JEF      H382   C38    .      .
 JEF      H381   C38    .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 JEF      C38    O12       single      1.426    0.020
 JEF      H381   C38       single      1.059    0.020
 JEF      H382   C38       single      1.059    0.020
 JEF      H383   C38       single      1.059    0.020
 JEF      O12    C37       single      1.426    0.020
 JEF      C37    C36       single      1.524    0.020
 JEF      H371   C37       single      1.092    0.020
 JEF      H372   C37       single      1.092    0.020
 JEF      C36    O11       single      1.426    0.020
 JEF      H361   C36       single      1.092    0.020
 JEF      H362   C36       single      1.092    0.020
 JEF      C34    C33       single      1.524    0.020
 JEF      C33    C32       single      1.524    0.020
 JEF      H33    C33       single      1.099    0.020
 JEF      H341   C34       single      1.059    0.020
 JEF      H342   C34       single      1.059    0.020
 JEF      H343   C34       single      1.059    0.020
 JEF      C32    O10       single      1.426    0.020
 JEF      H321   C32       single      1.092    0.020
 JEF      H322   C32       single      1.092    0.020
 JEF      O10    C19       single      1.426    0.020
 JEF      C40    C19       single      1.524    0.020
 JEF      C19    C20       single      1.524    0.020
 JEF      H19    C19       single      1.099    0.020
 JEF      H401   C40       single      1.059    0.020
 JEF      H402   C40       single      1.059    0.020
 JEF      H403   C40       single      1.059    0.020
 JEF      C20    O         single      1.426    0.020
 JEF      H201   C20       single      1.092    0.020
 JEF      H202   C20       single      1.092    0.020
 JEF      O      C         single      1.426    0.020
 JEF      C18    C         single      1.524    0.020
 JEF      C      C17       single      1.524    0.020
 JEF      H      C         single      1.099    0.020
 JEF      H181   C18       single      1.059    0.020
 JEF      H182   C18       single      1.059    0.020
 JEF      H183   C18       single      1.059    0.020
 JEF      C17    OH        single      1.426    0.020
 JEF      H171   C17       single      1.092    0.020
 JEF      H172   C17       single      1.092    0.020
 JEF      OH     C2        single      1.426    0.020
 JEF      C1     C2        single      1.524    0.020
 JEF      C2     C3        single      1.524    0.020
 JEF      H2     C2        single      1.099    0.020
 JEF      H11A   C1        single      1.059    0.020
 JEF      H12    C1        single      1.059    0.020
 JEF      H13A   C1        single      1.059    0.020
 JEF      C3     O2        single      1.426    0.020
 JEF      H31    C3        single      1.092    0.020
 JEF      H32    C3        single      1.092    0.020
 JEF      O2     C5        single      1.426    0.020
 JEF      C6     C5        single      1.524    0.020
 JEF      C5     C4        single      1.524    0.020
 JEF      H5     C5        single      1.099    0.020
 JEF      H61    C6        single      1.059    0.020
 JEF      H62    C6        single      1.059    0.020
 JEF      H63    C6        single      1.059    0.020
 JEF      C4     O3        single      1.426    0.020
 JEF      H41    C4        single      1.092    0.020
 JEF      H42    C4        single      1.092    0.020
 JEF      O3     C7        single      1.426    0.020
 JEF      C9     C7        single      1.524    0.020
 JEF      C7     C8        single      1.524    0.020
 JEF      H7     C7        single      1.099    0.020
 JEF      H91    C9        single      1.059    0.020
 JEF      H92    C9        single      1.059    0.020
 JEF      H93    C9        single      1.059    0.020
 JEF      C8     O4        single      1.426    0.020
 JEF      H81    C8        single      1.092    0.020
 JEF      H82    C8        single      1.092    0.020
 JEF      O4     C11       single      1.426    0.020
 JEF      C12    C11       single      1.524    0.020
 JEF      C11    C10       single      1.524    0.020
 JEF      H11    C11       single      1.099    0.020
 JEF      H121   C12       single      1.059    0.020
 JEF      H122   C12       single      1.059    0.020
 JEF      H123   C12       single      1.059    0.020
 JEF      C10    O5        single      1.426    0.020
 JEF      H101   C10       single      1.092    0.020
 JEF      H102   C10       single      1.092    0.020
 JEF      O5     C13       single      1.426    0.020
 JEF      C15    C13       single      1.524    0.020
 JEF      C13    C14       single      1.524    0.020
 JEF      H13    C13       single      1.099    0.020
 JEF      H151   C15       single      1.059    0.020
 JEF      H152   C15       single      1.059    0.020
 JEF      H153   C15       single      1.059    0.020
 JEF      C14    O6        single      1.426    0.020
 JEF      H141   C14       single      1.092    0.020
 JEF      H142   C14       single      1.092    0.020
 JEF      O6     C16       single      1.426    0.020
 JEF      C16    C30       single      1.524    0.020
 JEF      H161   C16       single      1.092    0.020
 JEF      H162   C16       single      1.092    0.020
 JEF      C31    C30       single      1.524    0.020
 JEF      C30    N1        single      1.450    0.020
 JEF      H30    C30       single      1.099    0.020
 JEF      H311   C31       single      1.059    0.020
 JEF      H312   C31       single      1.059    0.020
 JEF      H313   C31       single      1.059    0.020
 JEF      HN11   N1        single      1.010    0.020
 JEF      HN12   N1        single      1.010    0.020
 JEF      O11    C33       single      1.426    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 JEF      HN11   N1     HN12    120.000    3.000
 JEF      HN11   N1     C30     120.000    3.000
 JEF      HN12   N1     C30     120.000    3.000
 JEF      N1     C30    H30     109.470    3.000
 JEF      N1     C30    C31     109.470    3.000
 JEF      N1     C30    C16     109.470    3.000
 JEF      H30    C30    C31     108.340    3.000
 JEF      H30    C30    C16     108.340    3.000
 JEF      C31    C30    C16     111.000    3.000
 JEF      C30    C31    H313    109.470    3.000
 JEF      C30    C31    H312    109.470    3.000
 JEF      C30    C31    H311    109.470    3.000
 JEF      H313   C31    H312    109.470    3.000
 JEF      H313   C31    H311    109.470    3.000
 JEF      H312   C31    H311    109.470    3.000
 JEF      C30    C16    H161    109.470    3.000
 JEF      C30    C16    H162    109.470    3.000
 JEF      C30    C16    O6      109.470    3.000
 JEF      H161   C16    H162    107.900    3.000
 JEF      H161   C16    O6      109.470    3.000
 JEF      H162   C16    O6      109.470    3.000
 JEF      C16    O6     C14     111.800    3.000
 JEF      O6     C14    H141    109.470    3.000
 JEF      O6     C14    H142    109.470    3.000
 JEF      O6     C14    C13     109.470    3.000
 JEF      H141   C14    H142    107.900    3.000
 JEF      H141   C14    C13     109.470    3.000
 JEF      H142   C14    C13     109.470    3.000
 JEF      C14    C13    H13     108.340    3.000
 JEF      C14    C13    C15     111.000    3.000
 JEF      C14    C13    O5      109.470    3.000
 JEF      H13    C13    C15     108.340    3.000
 JEF      H13    C13    O5      109.470    3.000
 JEF      C15    C13    O5      109.470    3.000
 JEF      C13    C15    H153    109.470    3.000
 JEF      C13    C15    H152    109.470    3.000
 JEF      C13    C15    H151    109.470    3.000
 JEF      H153   C15    H152    109.470    3.000
 JEF      H153   C15    H151    109.470    3.000
 JEF      H152   C15    H151    109.470    3.000
 JEF      C13    O5     C10     111.800    3.000
 JEF      O5     C10    H101    109.470    3.000
 JEF      O5     C10    H102    109.470    3.000
 JEF      O5     C10    C11     109.470    3.000
 JEF      H101   C10    H102    107.900    3.000
 JEF      H101   C10    C11     109.470    3.000
 JEF      H102   C10    C11     109.470    3.000
 JEF      C10    C11    H11     108.340    3.000
 JEF      C10    C11    C12     111.000    3.000
 JEF      C10    C11    O4      109.470    3.000
 JEF      H11    C11    C12     108.340    3.000
 JEF      H11    C11    O4      109.470    3.000
 JEF      C12    C11    O4      109.470    3.000
 JEF      C11    C12    H123    109.470    3.000
 JEF      C11    C12    H122    109.470    3.000
 JEF      C11    C12    H121    109.470    3.000
 JEF      H123   C12    H122    109.470    3.000
 JEF      H123   C12    H121    109.470    3.000
 JEF      H122   C12    H121    109.470    3.000
 JEF      C11    O4     C8      111.800    3.000
 JEF      O4     C8     H81     109.470    3.000
 JEF      O4     C8     H82     109.470    3.000
 JEF      O4     C8     C7      109.470    3.000
 JEF      H81    C8     H82     107.900    3.000
 JEF      H81    C8     C7      109.470    3.000
 JEF      H82    C8     C7      109.470    3.000
 JEF      C8     C7     H7      108.340    3.000
 JEF      C8     C7     C9      111.000    3.000
 JEF      C8     C7     O3      109.470    3.000
 JEF      H7     C7     C9      108.340    3.000
 JEF      H7     C7     O3      109.470    3.000
 JEF      C9     C7     O3      109.470    3.000
 JEF      C7     C9     H93     109.470    3.000
 JEF      C7     C9     H92     109.470    3.000
 JEF      C7     C9     H91     109.470    3.000
 JEF      H93    C9     H92     109.470    3.000
 JEF      H93    C9     H91     109.470    3.000
 JEF      H92    C9     H91     109.470    3.000
 JEF      C7     O3     C4      111.800    3.000
 JEF      O3     C4     H41     109.470    3.000
 JEF      O3     C4     H42     109.470    3.000
 JEF      O3     C4     C5      109.470    3.000
 JEF      H41    C4     H42     107.900    3.000
 JEF      H41    C4     C5      109.470    3.000
 JEF      H42    C4     C5      109.470    3.000
 JEF      C4     C5     H5      108.340    3.000
 JEF      C4     C5     C6      111.000    3.000
 JEF      C4     C5     O2      109.470    3.000
 JEF      H5     C5     C6      108.340    3.000
 JEF      H5     C5     O2      109.470    3.000
 JEF      C6     C5     O2      109.470    3.000
 JEF      C5     C6     H63     109.470    3.000
 JEF      C5     C6     H62     109.470    3.000
 JEF      C5     C6     H61     109.470    3.000
 JEF      H63    C6     H62     109.470    3.000
 JEF      H63    C6     H61     109.470    3.000
 JEF      H62    C6     H61     109.470    3.000
 JEF      C5     O2     C3      111.800    3.000
 JEF      O2     C3     H31     109.470    3.000
 JEF      O2     C3     H32     109.470    3.000
 JEF      O2     C3     C2      109.470    3.000
 JEF      H31    C3     H32     107.900    3.000
 JEF      H31    C3     C2      109.470    3.000
 JEF      H32    C3     C2      109.470    3.000
 JEF      C3     C2     H2      108.340    3.000
 JEF      C3     C2     C1      111.000    3.000
 JEF      C3     C2     OH      109.470    3.000
 JEF      H2     C2     C1      108.340    3.000
 JEF      H2     C2     OH      109.470    3.000
 JEF      C1     C2     OH      109.470    3.000
 JEF      C2     C1     H13A    109.470    3.000
 JEF      C2     C1     H12     109.470    3.000
 JEF      C2     C1     H11A    109.470    3.000
 JEF      H13A   C1     H12     109.470    3.000
 JEF      H13A   C1     H11A    109.470    3.000
 JEF      H12    C1     H11A    109.470    3.000
 JEF      C2     OH     C17     111.800    3.000
 JEF      OH     C17    H171    109.470    3.000
 JEF      OH     C17    H172    109.470    3.000
 JEF      OH     C17    C       109.470    3.000
 JEF      H171   C17    H172    107.900    3.000
 JEF      H171   C17    C       109.470    3.000
 JEF      H172   C17    C       109.470    3.000
 JEF      C17    C      H       108.340    3.000
 JEF      C17    C      C18     111.000    3.000
 JEF      C17    C      O       109.470    3.000
 JEF      H      C      C18     108.340    3.000
 JEF      H      C      O       109.470    3.000
 JEF      C18    C      O       109.470    3.000
 JEF      C      C18    H183    109.470    3.000
 JEF      C      C18    H182    109.470    3.000
 JEF      C      C18    H181    109.470    3.000
 JEF      H183   C18    H182    109.470    3.000
 JEF      H183   C18    H181    109.470    3.000
 JEF      H182   C18    H181    109.470    3.000
 JEF      C      O      C20     111.800    3.000
 JEF      O      C20    H201    109.470    3.000
 JEF      O      C20    H202    109.470    3.000
 JEF      O      C20    C19     109.470    3.000
 JEF      H201   C20    H202    107.900    3.000
 JEF      H201   C20    C19     109.470    3.000
 JEF      H202   C20    C19     109.470    3.000
 JEF      C20    C19    H19     108.340    3.000
 JEF      C20    C19    C40     111.000    3.000
 JEF      C20    C19    O10     109.470    3.000
 JEF      H19    C19    C40     108.340    3.000
 JEF      H19    C19    O10     109.470    3.000
 JEF      C40    C19    O10     109.470    3.000
 JEF      C19    C40    H403    109.470    3.000
 JEF      C19    C40    H402    109.470    3.000
 JEF      C19    C40    H401    109.470    3.000
 JEF      H403   C40    H402    109.470    3.000
 JEF      H403   C40    H401    109.470    3.000
 JEF      H402   C40    H401    109.470    3.000
 JEF      C19    O10    C32     111.800    3.000
 JEF      O10    C32    H321    109.470    3.000
 JEF      O10    C32    H322    109.470    3.000
 JEF      O10    C32    C33     109.470    3.000
 JEF      H321   C32    H322    107.900    3.000
 JEF      H321   C32    C33     109.470    3.000
 JEF      H322   C32    C33     109.470    3.000
 JEF      C32    C33    H33     108.340    3.000
 JEF      C32    C33    C34     111.000    3.000
 JEF      C32    C33    O11     109.470    3.000
 JEF      H33    C33    C34     108.340    3.000
 JEF      H33    C33    O11     109.470    3.000
 JEF      C34    C33    O11     109.470    3.000
 JEF      C33    C34    H343    109.470    3.000
 JEF      C33    C34    H342    109.470    3.000
 JEF      C33    C34    H341    109.470    3.000
 JEF      H343   C34    H342    109.470    3.000
 JEF      H343   C34    H341    109.470    3.000
 JEF      H342   C34    H341    109.470    3.000
 JEF      C33    O11    C36     111.800    3.000
 JEF      O11    C36    H361    109.470    3.000
 JEF      O11    C36    H362    109.470    3.000
 JEF      O11    C36    C37     109.470    3.000
 JEF      H361   C36    H362    107.900    3.000
 JEF      H361   C36    C37     109.470    3.000
 JEF      H362   C36    C37     109.470    3.000
 JEF      C36    C37    H371    109.470    3.000
 JEF      C36    C37    H372    109.470    3.000
 JEF      C36    C37    O12     109.470    3.000
 JEF      H371   C37    H372    107.900    3.000
 JEF      H371   C37    O12     109.470    3.000
 JEF      H372   C37    O12     109.470    3.000
 JEF      C37    O12    C38     111.800    3.000
 JEF      O12    C38    H383    109.470    3.000
 JEF      O12    C38    H382    109.470    3.000
 JEF      O12    C38    H381    109.470    3.000
 JEF      H383   C38    H382    109.470    3.000
 JEF      H383   C38    H381    109.470    3.000
 JEF      H382   C38    H381    109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 JEF      var_1    HN12   N1     C30    C16     -175.048   20.000   1
 JEF      var_2    N1     C30    C31    H311    -174.890   20.000   3
 JEF      var_3    N1     C30    C16    O6        64.829   20.000   3
 JEF      var_4    C30    C16    O6     C14     -174.979   20.000   1
 JEF      var_5    C16    O6     C14    C13     -175.038   20.000   1
 JEF      var_6    O6     C14    C13    O5        64.156   20.000   3
 JEF      var_7    C14    C13    C15    H151     -64.611   20.000   3
 JEF      var_8    C14    C13    O5     C10      146.492   20.000   1
 JEF      var_9    C13    O5     C10    C11     -174.988   20.000   1
 JEF      var_10   O5     C10    C11    O4        64.472   20.000   3
 JEF      var_11   C10    C11    C12    H121      60.037   20.000   3
 JEF      var_12   C10    C11    O4     C8       145.740   20.000   1
 JEF      var_13   C11    O4     C8     C7      -175.106   20.000   1
 JEF      var_14   O4     C8     C7     O3       -64.045   20.000   3
 JEF      var_15   C8     C7     C9     H91      -60.020   20.000   3
 JEF      var_16   C8     C7     O3     C4      -154.036   20.000   1
 JEF      var_17   C7     O3     C4     C5      -175.591   20.000   1
 JEF      var_18   O3     C4     C5     O2       -64.630   20.000   3
 JEF      var_19   C4     C5     C6     H61      -60.035   20.000   3
 JEF      var_20   C4     C5     O2     C3       -85.400   20.000   1
 JEF      var_21   C5     O2     C3     C2      -174.948   20.000   1
 JEF      var_22   O2     C3     C2     OH        64.902   20.000   3
 JEF      var_23   C3     C2     C1     H11A      60.048   20.000   3
 JEF      var_24   C3     C2     OH     C17      146.537   20.000   1
 JEF      var_25   C2     OH     C17    C        175.640   20.000   1
 JEF      var_26   OH     C17    C      O         64.162   20.000   3
 JEF      var_27   C17    C      C18    H181      60.010   20.000   3
 JEF      var_28   C17    C      O      C20      145.802   20.000   1
 JEF      var_29   C      O      C20    C19     -175.057   20.000   1
 JEF      var_30   O      C20    C19    O10      -64.416   20.000   3
 JEF      var_31   C20    C19    C40    H401      60.033   20.000   3
 JEF      var_32   C20    C19    O10    C32     -146.649   20.000   1
 JEF      var_33   C19    O10    C32    C33     -175.398   20.000   1
 JEF      var_34   O10    C32    C33    O11      -64.365   20.000   3
 JEF      var_35   C32    C33    C34    H341      64.610   20.000   3
 JEF      var_36   C32    C33    O11    C36     -146.354   20.000   1
 JEF      var_37   C33    O11    C36    C37      175.016   20.000   1
 JEF      var_38   O11    C36    C37    O12       64.836   20.000   3
 JEF      var_39   C36    C37    O12    C38     -175.042   20.000   1
 JEF      var_40   C37    O12    C38    H381     -65.028   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 JEF      chir_01  C33    O11    C34    C32       negativ
 JEF      chir_02  C19    O10    C40    C20       negativ
 JEF      chir_03  C      O      C18    C17       positiv
 JEF      chir_04  C2     OH     C1     C3        positiv
 JEF      chir_05  C5     O2     C6     C4        negativ
 JEF      chir_06  C7     O3     C9     C8        negativ
 JEF      chir_07  C11    O4     C12    C10       positiv
 JEF      chir_08  C13    O5     C15    C14       positiv
 JEF      chir_09  C30    C16    C31    N1        negativ
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 JEF      plan-1    N1        0.020
 JEF      plan-1    C30       0.000
 JEF      plan-1    HN11      0.000
 JEF      plan-1    HN12      0.000
# ------------------------------------------------------
`.trim();

monomers["DIA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
DIA      DIA 'OCTANE 1,8-DIAMINE                  ' non-polymer        30  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_DIA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 DIA           N8     N    NH2       0.000      0.000    0.000    0.000
 DIA           HN81   H    H         0.000      0.606   -0.799   -0.147
 DIA           HN82   H    H         0.000      0.349    0.801    0.513
 DIA           C8     C    CH2       0.000     -1.371   -0.003   -0.526
 DIA           HC81   H    H         0.000     -1.523   -0.894   -1.138
 DIA           HC82   H    H         0.000     -1.526    0.888   -1.138
 DIA           C7     C    CH2       0.000     -2.365   -0.005    0.635
 DIA           HC71   H    H         0.000     -2.211    0.887    1.247
 DIA           HC72   H    H         0.000     -2.207   -0.896    1.247
 DIA           C6     C    CH2       0.000     -3.793   -0.008    0.087
 DIA           HC61   H    H         0.000     -3.945   -0.899   -0.525
 DIA           HC62   H    H         0.000     -3.948    0.883   -0.525
 DIA           C5     C    CH2       0.000     -4.788   -0.010    1.248
 DIA           HC51   H    H         0.000     -4.633    0.882    1.859
 DIA           HC52   H    H         0.000     -4.630   -0.901    1.859
 DIA           C4     C    CH2       0.000     -6.214   -0.013    0.699
 DIA           HC41   H    H         0.000     -6.366   -0.905    0.087
 DIA           HC42   H    H         0.000     -6.370    0.878    0.087
 DIA           C3     C    CH2       0.000     -7.209   -0.015    1.861
 DIA           HC31   H    H         0.000     -7.054    0.876    2.472
 DIA           HC32   H    H         0.000     -7.050   -0.906    2.472
 DIA           C2     C    CH2       0.000     -8.636   -0.018    1.312
 DIA           HC21   H    H         0.000     -8.788   -0.910    0.700
 DIA           HC22   H    H         0.000     -8.792    0.873    0.700
 DIA           C1     C    CH2       0.000     -9.631   -0.020    2.473
 DIA           HC11   H    H         0.000     -9.476    0.871    3.085
 DIA           HC12   H    H         0.000     -9.472   -0.911    3.085
 DIA           N1     N    NH2       0.000    -11.002   -0.023    1.947
 DIA           HN12   H    H         0.000    -11.166   -0.023    0.947
 DIA           HN11   H    H         0.000    -11.793   -0.025    2.581
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 DIA      N8     n/a    C8     START
 DIA      HN81   N8     .      .
 DIA      HN82   N8     .      .
 DIA      C8     N8     C7     .
 DIA      HC81   C8     .      .
 DIA      HC82   C8     .      .
 DIA      C7     C8     C6     .
 DIA      HC71   C7     .      .
 DIA      HC72   C7     .      .
 DIA      C6     C7     C5     .
 DIA      HC61   C6     .      .
 DIA      HC62   C6     .      .
 DIA      C5     C6     C4     .
 DIA      HC51   C5     .      .
 DIA      HC52   C5     .      .
 DIA      C4     C5     C3     .
 DIA      HC41   C4     .      .
 DIA      HC42   C4     .      .
 DIA      C3     C4     C2     .
 DIA      HC31   C3     .      .
 DIA      HC32   C3     .      .
 DIA      C2     C3     C1     .
 DIA      HC21   C2     .      .
 DIA      HC22   C2     .      .
 DIA      C1     C2     N1     .
 DIA      HC11   C1     .      .
 DIA      HC12   C1     .      .
 DIA      N1     C1     HN11   .
 DIA      HN12   N1     .      .
 DIA      HN11   N1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 DIA      N1     C1        single      1.450    0.020
 DIA      HN11   N1        single      1.010    0.020
 DIA      HN12   N1        single      1.010    0.020
 DIA      C1     C2        single      1.524    0.020
 DIA      HC11   C1        single      1.092    0.020
 DIA      HC12   C1        single      1.092    0.020
 DIA      C2     C3        single      1.524    0.020
 DIA      HC21   C2        single      1.092    0.020
 DIA      HC22   C2        single      1.092    0.020
 DIA      C3     C4        single      1.524    0.020
 DIA      HC31   C3        single      1.092    0.020
 DIA      HC32   C3        single      1.092    0.020
 DIA      C4     C5        single      1.524    0.020
 DIA      HC41   C4        single      1.092    0.020
 DIA      HC42   C4        single      1.092    0.020
 DIA      C5     C6        single      1.524    0.020
 DIA      HC51   C5        single      1.092    0.020
 DIA      HC52   C5        single      1.092    0.020
 DIA      C6     C7        single      1.524    0.020
 DIA      HC61   C6        single      1.092    0.020
 DIA      HC62   C6        single      1.092    0.020
 DIA      C7     C8        single      1.524    0.020
 DIA      HC71   C7        single      1.092    0.020
 DIA      HC72   C7        single      1.092    0.020
 DIA      C8     N8        single      1.450    0.020
 DIA      HC81   C8        single      1.092    0.020
 DIA      HC82   C8        single      1.092    0.020
 DIA      HN81   N8        single      1.010    0.020
 DIA      HN82   N8        single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 DIA      HN81   N8     HN82    120.000    3.000
 DIA      HN81   N8     C8      120.000    3.000
 DIA      HN82   N8     C8      120.000    3.000
 DIA      N8     C8     HC81    109.470    3.000
 DIA      N8     C8     HC82    109.470    3.000
 DIA      N8     C8     C7      109.470    3.000
 DIA      HC81   C8     HC82    107.900    3.000
 DIA      HC81   C8     C7      109.470    3.000
 DIA      HC82   C8     C7      109.470    3.000
 DIA      C8     C7     HC71    109.470    3.000
 DIA      C8     C7     HC72    109.470    3.000
 DIA      C8     C7     C6      111.000    3.000
 DIA      HC71   C7     HC72    107.900    3.000
 DIA      HC71   C7     C6      109.470    3.000
 DIA      HC72   C7     C6      109.470    3.000
 DIA      C7     C6     HC61    109.470    3.000
 DIA      C7     C6     HC62    109.470    3.000
 DIA      C7     C6     C5      111.000    3.000
 DIA      HC61   C6     HC62    107.900    3.000
 DIA      HC61   C6     C5      109.470    3.000
 DIA      HC62   C6     C5      109.470    3.000
 DIA      C6     C5     HC51    109.470    3.000
 DIA      C6     C5     HC52    109.470    3.000
 DIA      C6     C5     C4      111.000    3.000
 DIA      HC51   C5     HC52    107.900    3.000
 DIA      HC51   C5     C4      109.470    3.000
 DIA      HC52   C5     C4      109.470    3.000
 DIA      C5     C4     HC41    109.470    3.000
 DIA      C5     C4     HC42    109.470    3.000
 DIA      C5     C4     C3      111.000    3.000
 DIA      HC41   C4     HC42    107.900    3.000
 DIA      HC41   C4     C3      109.470    3.000
 DIA      HC42   C4     C3      109.470    3.000
 DIA      C4     C3     HC31    109.470    3.000
 DIA      C4     C3     HC32    109.470    3.000
 DIA      C4     C3     C2      111.000    3.000
 DIA      HC31   C3     HC32    107.900    3.000
 DIA      HC31   C3     C2      109.470    3.000
 DIA      HC32   C3     C2      109.470    3.000
 DIA      C3     C2     HC21    109.470    3.000
 DIA      C3     C2     HC22    109.470    3.000
 DIA      C3     C2     C1      111.000    3.000
 DIA      HC21   C2     HC22    107.900    3.000
 DIA      HC21   C2     C1      109.470    3.000
 DIA      HC22   C2     C1      109.470    3.000
 DIA      C2     C1     HC11    109.470    3.000
 DIA      C2     C1     HC12    109.470    3.000
 DIA      C2     C1     N1      109.470    3.000
 DIA      HC11   C1     HC12    107.900    3.000
 DIA      HC11   C1     N1      109.470    3.000
 DIA      HC12   C1     N1      109.470    3.000
 DIA      C1     N1     HN12    120.000    3.000
 DIA      C1     N1     HN11    120.000    3.000
 DIA      HN12   N1     HN11    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 DIA      var_1    HN82   N8     C8     C7       -66.149   20.000   1
 DIA      var_2    N8     C8     C7     C6       180.000   20.000   3
 DIA      var_3    C8     C7     C6     C5       180.000   20.000   3
 DIA      var_4    C7     C6     C5     C4       180.000   20.000   3
 DIA      var_5    C6     C5     C4     C3       180.000   20.000   3
 DIA      var_6    C5     C4     C3     C2       180.000   20.000   3
 DIA      var_7    C4     C3     C2     C1       180.000   20.000   3
 DIA      var_8    C3     C2     C1     N1       180.000   20.000   3
 DIA      var_9    C2     C1     N1     HN11     180.000   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 DIA      plan-1    N1        0.020
 DIA      plan-1    C1        0.020
 DIA      plan-1    HN11      0.020
 DIA      plan-1    HN12      0.020
 DIA      plan-2    N8        0.020
 DIA      plan-2    C8        0.020
 DIA      plan-2    HN81      0.020
 DIA      plan-2    HN82      0.020
# ------------------------------------------------------
`.trim();

monomers["IPH"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
IPH      IPH 'PHENOL                              ' non-polymer        13   7 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_IPH
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 IPH           O1     O    OH1       0.000      0.000    0.000    0.000
 IPH           HO1    H    H         0.000      0.291    0.912    0.134
 IPH           C1     C    CR6       0.000     -1.244   -0.002   -0.548
 IPH           C6     C    CR16      0.000     -2.363   -0.014    0.270
 IPH           H6     H    H         0.000     -2.247   -0.027    1.347
 IPH           C5     C    CR16      0.000     -3.626   -0.010   -0.287
 IPH           H5     H    H         0.000     -4.500   -0.010    0.352
 IPH           C4     C    CR16      0.000     -3.776   -0.006   -1.662
 IPH           H4     H    H         0.000     -4.767   -0.009   -2.099
 IPH           C3     C    CR16      0.000     -2.660    0.001   -2.480
 IPH           H3     H    H         0.000     -2.779    0.006   -3.557
 IPH           C2     C    CR16      0.000     -1.396    0.003   -1.926
 IPH           H2     H    H         0.000     -0.524    0.008   -2.567
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 IPH      O1     n/a    C1     START
 IPH      HO1    O1     .      .
 IPH      C1     O1     C6     .
 IPH      C6     C1     C5     .
 IPH      H6     C6     .      .
 IPH      C5     C6     C4     .
 IPH      H5     C5     .      .
 IPH      C4     C5     C3     .
 IPH      H4     C4     .      .
 IPH      C3     C4     C2     .
 IPH      H3     C3     .      .
 IPH      C2     C3     H2     .
 IPH      H2     C2     .      END
 IPH      C1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 IPH      C1     C2        double      1.390    0.020
 IPH      C6     C1        single      1.390    0.020
 IPH      C1     O1        single      1.362    0.020
 IPH      C2     C3        single      1.390    0.020
 IPH      H2     C2        single      1.083    0.020
 IPH      C3     C4        double      1.390    0.020
 IPH      H3     C3        single      1.083    0.020
 IPH      C4     C5        single      1.390    0.020
 IPH      H4     C4        single      1.083    0.020
 IPH      C5     C6        double      1.390    0.020
 IPH      H5     C5        single      1.083    0.020
 IPH      H6     C6        single      1.083    0.020
 IPH      HO1    O1        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 IPH      HO1    O1     C1      109.470    3.000
 IPH      O1     C1     C6      120.000    3.000
 IPH      O1     C1     C2      120.000    3.000
 IPH      C6     C1     C2      120.000    3.000
 IPH      C1     C6     H6      120.000    3.000
 IPH      C1     C6     C5      120.000    3.000
 IPH      H6     C6     C5      120.000    3.000
 IPH      C6     C5     H5      120.000    3.000
 IPH      C6     C5     C4      120.000    3.000
 IPH      H5     C5     C4      120.000    3.000
 IPH      C5     C4     H4      120.000    3.000
 IPH      C5     C4     C3      120.000    3.000
 IPH      H4     C4     C3      120.000    3.000
 IPH      C4     C3     H3      120.000    3.000
 IPH      C4     C3     C2      120.000    3.000
 IPH      H3     C3     C2      120.000    3.000
 IPH      C3     C2     H2      120.000    3.000
 IPH      C3     C2     C1      120.000    3.000
 IPH      H2     C2     C1      120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 IPH      var_1    HO1    O1     C1     C6       -90.224   20.000   1
 IPH      CONST_1  O1     C1     C2     C3       180.000    0.000   0
 IPH      CONST_2  O1     C1     C6     C5       180.000    0.000   0
 IPH      CONST_3  C1     C6     C5     C4         0.000    0.000   0
 IPH      CONST_4  C6     C5     C4     C3         0.000    0.000   0
 IPH      CONST_5  C5     C4     C3     C2         0.000    0.000   0
 IPH      CONST_6  C4     C3     C2     C1         0.000    0.000   0
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 IPH      plan-1    C1        0.020
 IPH      plan-1    C2        0.020
 IPH      plan-1    C6        0.020
 IPH      plan-1    O1        0.020
 IPH      plan-1    C3        0.020
 IPH      plan-1    C4        0.020
 IPH      plan-1    C5        0.020
 IPH      plan-1    H2        0.020
 IPH      plan-1    H3        0.020
 IPH      plan-1    H4        0.020
 IPH      plan-1    H5        0.020
 IPH      plan-1    H6        0.020
# ------------------------------------------------------
`.trim();

monomers["PIN"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PIN      PIN '.                                   ' non-polymer        36  18 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PIN
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PIN           "O2'"  O    OS        0.000      0.000    0.000    0.000
 PIN           "S1'"  S    ST        0.000     -0.512   -1.299   -0.264
 PIN           "O1'"  O    OS        0.000     -0.274   -1.968   -1.493
 PIN           "O3'"  O    OH1       0.000      0.231   -2.165    0.742
 PIN           "HO3'" H    H         0.000      1.175   -2.236    0.663
 PIN           "C1'"  C    CH2       0.000     -2.243   -1.451    0.256
 PIN           "H1'1" H    H         0.000     -2.347   -1.088    1.281
 PIN           "H1'2" H    H         0.000     -2.544   -2.500    0.211
 PIN           "C2'"  C    CH2       0.000     -3.132   -0.623   -0.673
 PIN           "H2'1" H    H         0.000     -3.025   -0.987   -1.697
 PIN           "H2'2" H    H         0.000     -2.828    0.425   -0.627
 PIN           "N1'"  N    NT        0.000     -4.532   -0.748   -0.251
 PIN           "C4'"  C    CH2       0.000     -5.326    0.066   -1.179
 PIN           "H4'1" H    H         0.000     -5.259   -0.360   -2.182
 PIN           "H4'2" H    H         0.000     -4.935    1.086   -1.192
 PIN           C3     C    CH2       0.000     -6.786    0.084   -0.728
 PIN           H32    H    H         0.000     -7.159   -0.940   -0.669
 PIN           H31    H    H         0.000     -7.381    0.646   -1.450
 PIN           "C3'"  C    CH2       0.000     -4.634   -0.113    1.068
 PIN           "H3'1" H    H         0.000     -4.259    0.911    1.006
 PIN           "H3'2" H    H         0.000     -4.037   -0.676    1.788
 PIN           C4     C    CH2       0.000     -6.095   -0.094    1.519
 PIN           H41    H    H         0.000     -6.158    0.330    2.523
 PIN           H42    H    H         0.000     -6.482   -1.115    1.531
 PIN           N1     N    NT        0.000     -6.888    0.719    0.592
 PIN           C2     C    CH2       0.000     -8.290    0.595    1.013
 PIN           H21    H    H         0.000     -8.561   -0.461    1.068
 PIN           H22    H    H         0.000     -8.934    1.097    0.288
 PIN           C1     C    CH2       0.000     -8.469    1.241    2.388
 PIN           H11    H    H         0.000     -8.197    2.297    2.330
 PIN           H12    H    H         0.000     -7.823    0.739    3.111
 PIN           S1     S    ST        0.000    -10.199    1.087    2.909
 PIN           O1     O    OS        0.000    -10.533   -0.258    3.223
 PIN           O2     O    OS        0.000    -11.054    1.916    2.135
 PIN           O3     O    OH1       0.000    -10.213    1.765    4.271
 PIN           HO3    H    H         0.000    -11.036    1.805    4.745
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PIN      "O2'"  n/a    "S1'"  START
 PIN      "S1'"  "O2'"  "C1'"  .
 PIN      "O1'"  "S1'"  .      .
 PIN      "O3'"  "S1'"  "HO3'" .
 PIN      "HO3'" "O3'"  .      .
 PIN      "C1'"  "S1'"  "C2'"  .
 PIN      "H1'1" "C1'"  .      .
 PIN      "H1'2" "C1'"  .      .
 PIN      "C2'"  "C1'"  "N1'"  .
 PIN      "H2'1" "C2'"  .      .
 PIN      "H2'2" "C2'"  .      .
 PIN      "N1'"  "C2'"  "C3'"  .
 PIN      "C4'"  "N1'"  C3     .
 PIN      "H4'1" "C4'"  .      .
 PIN      "H4'2" "C4'"  .      .
 PIN      C3     "C4'"  H31    .
 PIN      H32    C3     .      .
 PIN      H31    C3     .      .
 PIN      "C3'"  "N1'"  C4     .
 PIN      "H3'1" "C3'"  .      .
 PIN      "H3'2" "C3'"  .      .
 PIN      C4     "C3'"  N1     .
 PIN      H41    C4     .      .
 PIN      H42    C4     .      .
 PIN      N1     C4     C2     .
 PIN      C2     N1     C1     .
 PIN      H21    C2     .      .
 PIN      H22    C2     .      .
 PIN      C1     C2     S1     .
 PIN      H11    C1     .      .
 PIN      H12    C1     .      .
 PIN      S1     C1     O3     .
 PIN      O1     S1     .      .
 PIN      O2     S1     .      .
 PIN      O3     S1     HO3    .
 PIN      HO3    O3     .      END
 PIN      N1     C3     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PIN      C1     C2        single      1.524    0.020
 PIN      S1     C1        single      1.662    0.020
 PIN      H11    C1        single      1.092    0.020
 PIN      H12    C1        single      1.092    0.020
 PIN      C2     N1        single      1.469    0.020
 PIN      H21    C2        single      1.092    0.020
 PIN      H22    C2        single      1.092    0.020
 PIN      N1     C3        single      1.469    0.020
 PIN      N1     C4        single      1.469    0.020
 PIN      C3     "C4'"     single      1.524    0.020
 PIN      H31    C3        single      1.092    0.020
 PIN      H32    C3        single      1.092    0.020
 PIN      C4     "C3'"     single      1.524    0.020
 PIN      H41    C4        single      1.092    0.020
 PIN      H42    C4        single      1.092    0.020
 PIN      "C2'"  "C1'"     single      1.524    0.020
 PIN      "C1'"  "S1'"     single      1.662    0.020
 PIN      "H1'1" "C1'"     single      1.092    0.020
 PIN      "H1'2" "C1'"     single      1.092    0.020
 PIN      "N1'"  "C2'"     single      1.469    0.020
 PIN      "H2'1" "C2'"     single      1.092    0.020
 PIN      "H2'2" "C2'"     single      1.092    0.020
 PIN      "C3'"  "N1'"     single      1.469    0.020
 PIN      "C4'"  "N1'"     single      1.469    0.020
 PIN      "H3'1" "C3'"     single      1.092    0.020
 PIN      "H3'2" "C3'"     single      1.092    0.020
 PIN      "H4'1" "C4'"     single      1.092    0.020
 PIN      "H4'2" "C4'"     single      1.092    0.020
 PIN      O1     S1        double      1.436    0.020
 PIN      O2     S1        double      1.436    0.020
 PIN      O3     S1        single      1.635    0.020
 PIN      "O1'"  "S1'"     double      1.436    0.020
 PIN      "S1'"  "O2'"     double      1.436    0.020
 PIN      "O3'"  "S1'"     single      1.635    0.020
 PIN      HO3    O3        single      0.967    0.020
 PIN      "HO3'" "O3'"     single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PIN      "O2'"  "S1'"  "O1'"   109.500    3.000
 PIN      "O2'"  "S1'"  "O3'"   109.500    3.000
 PIN      "O2'"  "S1'"  "C1'"   109.500    3.000
 PIN      "O1'"  "S1'"  "O3'"   109.500    3.000
 PIN      "O1'"  "S1'"  "C1'"   109.500    3.000
 PIN      "O3'"  "S1'"  "C1'"   109.500    3.000
 PIN      "S1'"  "O3'"  "HO3'"  120.000    3.000
 PIN      "S1'"  "C1'"  "H1'1"  109.500    3.000
 PIN      "S1'"  "C1'"  "H1'2"  109.500    3.000
 PIN      "S1'"  "C1'"  "C2'"   109.500    3.000
 PIN      "H1'1" "C1'"  "H1'2"  107.900    3.000
 PIN      "H1'1" "C1'"  "C2'"   109.470    3.000
 PIN      "H1'2" "C1'"  "C2'"   109.470    3.000
 PIN      "C1'"  "C2'"  "H2'1"  109.470    3.000
 PIN      "C1'"  "C2'"  "H2'2"  109.470    3.000
 PIN      "C1'"  "C2'"  "N1'"   109.470    3.000
 PIN      "H2'1" "C2'"  "H2'2"  107.900    3.000
 PIN      "H2'1" "C2'"  "N1'"   109.470    3.000
 PIN      "H2'2" "C2'"  "N1'"   109.470    3.000
 PIN      "C2'"  "N1'"  "C4'"   109.470    3.000
 PIN      "C2'"  "N1'"  "C3'"   109.470    3.000
 PIN      "C4'"  "N1'"  "C3'"   109.470    3.000
 PIN      "N1'"  "C4'"  "H4'1"  109.470    3.000
 PIN      "N1'"  "C4'"  "H4'2"  109.470    3.000
 PIN      "N1'"  "C4'"  C3      109.470    3.000
 PIN      "H4'1" "C4'"  "H4'2"  107.900    3.000
 PIN      "H4'1" "C4'"  C3      109.470    3.000
 PIN      "H4'2" "C4'"  C3      109.470    3.000
 PIN      "C4'"  C3     H32     109.470    3.000
 PIN      "C4'"  C3     H31     109.470    3.000
 PIN      "C4'"  C3     N1      109.470    3.000
 PIN      H32    C3     H31     107.900    3.000
 PIN      H32    C3     N1      109.470    3.000
 PIN      H31    C3     N1      109.470    3.000
 PIN      "N1'"  "C3'"  "H3'1"  109.470    3.000
 PIN      "N1'"  "C3'"  "H3'2"  109.470    3.000
 PIN      "N1'"  "C3'"  C4      109.470    3.000
 PIN      "H3'1" "C3'"  "H3'2"  107.900    3.000
 PIN      "H3'1" "C3'"  C4      109.470    3.000
 PIN      "H3'2" "C3'"  C4      109.470    3.000
 PIN      "C3'"  C4     H41     109.470    3.000
 PIN      "C3'"  C4     H42     109.470    3.000
 PIN      "C3'"  C4     N1      109.470    3.000
 PIN      H41    C4     H42     107.900    3.000
 PIN      H41    C4     N1      109.470    3.000
 PIN      H42    C4     N1      109.470    3.000
 PIN      C4     N1     C2      109.470    3.000
 PIN      C4     N1     C3      109.470    3.000
 PIN      C2     N1     C3      109.470    3.000
 PIN      N1     C2     H21     109.470    3.000
 PIN      N1     C2     H22     109.470    3.000
 PIN      N1     C2     C1      109.470    3.000
 PIN      H21    C2     H22     107.900    3.000
 PIN      H21    C2     C1      109.470    3.000
 PIN      H22    C2     C1      109.470    3.000
 PIN      C2     C1     H11     109.470    3.000
 PIN      C2     C1     H12     109.470    3.000
 PIN      C2     C1     S1      109.500    3.000
 PIN      H11    C1     H12     107.900    3.000
 PIN      H11    C1     S1      109.500    3.000
 PIN      H12    C1     S1      109.500    3.000
 PIN      C1     S1     O1      109.500    3.000
 PIN      C1     S1     O2      109.500    3.000
 PIN      C1     S1     O3      109.500    3.000
 PIN      O1     S1     O2      109.500    3.000
 PIN      O1     S1     O3      109.500    3.000
 PIN      O2     S1     O3      109.500    3.000
 PIN      S1     O3     HO3     120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PIN      var_1    "O2'"  "S1'"  "O3'"  "HO3'"   -63.836   20.000   1
 PIN      var_2    "O2'"  "S1'"  "C1'"  "C2'"     70.283   20.000   1
 PIN      var_3    "S1'"  "C1'"  "C2'"  "N1'"    179.989   20.000   3
 PIN      var_4    "C1'"  "C2'"  "N1'"  "C3'"     66.005   20.000   1
 PIN      var_5    "C2'"  "N1'"  "C4'"  C3       180.000   20.000   1
 PIN      var_6    "N1'"  "C4'"  C3     N1        60.000   20.000   3
 PIN      var_7    "C2'"  "N1'"  "C3'"  C4       180.000   20.000   1
 PIN      var_8    "N1'"  "C3'"  C4     N1       -60.000   20.000   3
 PIN      var_9    "C3'"  C4     N1     C2       180.000   20.000   1
 PIN      var_10   C4     N1     C3     "C4'"    -60.000   20.000   1
 PIN      var_11   C4     N1     C2     C1        66.041   20.000   1
 PIN      var_12   N1     C2     C1     S1      -179.978   20.000   3
 PIN      var_13   C2     C1     S1     O3       179.945   20.000   1
 PIN      var_14   C1     S1     O3     HO3     -179.998   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 PIN      chir_01  N1     C2     C3     C4        positiv
 PIN      chir_02  "N1'"  "C2'"  "C3'"  "C4'"     negativ
 PIN      chir_03  S1     C1     O1     O2        positiv
 PIN      chir_04  "S1'"  "C1'"  "O1'"  "O2'"     negativ
# ------------------------------------------------------
`.trim();

monomers["PGR"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PGR      PGR 'R-1,2-PROPANEDIOL                   ' non-polymer        13   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PGR
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PGR           O2     O    OH1       0.000      0.000    0.000    0.000
 PGR           HO2    H    H         0.000      0.062   -0.961    0.082
 PGR           C2     C    CH1       0.000     -1.346    0.411    0.239
 PGR           H2     H    H         0.000     -1.416    1.504    0.146
 PGR           C3     C    CH3       0.000     -1.766   -0.007    1.649
 PGR           H33    H    H         0.000     -2.764    0.300    1.827
 PGR           H32    H    H         0.000     -1.701   -1.061    1.740
 PGR           H31    H    H         0.000     -1.126    0.448    2.360
 PGR           C1     C    CH2       0.000     -2.271   -0.247   -0.786
 PGR           H11    H    H         0.000     -3.300    0.069   -0.602
 PGR           H12    H    H         0.000     -2.202   -1.332   -0.692
 PGR           O1     O    OH1       0.000     -1.879    0.145   -2.102
 PGR           HO1    H    H         0.000     -2.465   -0.272   -2.748
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PGR      O2     n/a    C2     START
 PGR      HO2    O2     .      .
 PGR      C2     O2     C1     .
 PGR      H2     C2     .      .
 PGR      C3     C2     H31    .
 PGR      H33    C3     .      .
 PGR      H32    C3     .      .
 PGR      H31    C3     .      .
 PGR      C1     C2     O1     .
 PGR      H11    C1     .      .
 PGR      H12    C1     .      .
 PGR      O1     C1     HO1    .
 PGR      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PGR      C1     C2        single      1.524    0.020
 PGR      O1     C1        single      1.432    0.020
 PGR      H11    C1        single      1.092    0.020
 PGR      H12    C1        single      1.092    0.020
 PGR      C3     C2        single      1.524    0.020
 PGR      C2     O2        single      1.432    0.020
 PGR      H2     C2        single      1.099    0.020
 PGR      H31    C3        single      1.059    0.020
 PGR      H32    C3        single      1.059    0.020
 PGR      H33    C3        single      1.059    0.020
 PGR      HO1    O1        single      0.967    0.020
 PGR      HO2    O2        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PGR      HO2    O2     C2      109.470    3.000
 PGR      O2     C2     H2      109.470    3.000
 PGR      O2     C2     C3      109.470    3.000
 PGR      O2     C2     C1      109.470    3.000
 PGR      H2     C2     C3      108.340    3.000
 PGR      H2     C2     C1      108.340    3.000
 PGR      C3     C2     C1      111.000    3.000
 PGR      C2     C3     H33     109.470    3.000
 PGR      C2     C3     H32     109.470    3.000
 PGR      C2     C3     H31     109.470    3.000
 PGR      H33    C3     H32     109.470    3.000
 PGR      H33    C3     H31     109.470    3.000
 PGR      H32    C3     H31     109.470    3.000
 PGR      C2     C1     H11     109.470    3.000
 PGR      C2     C1     H12     109.470    3.000
 PGR      C2     C1     O1      109.470    3.000
 PGR      H11    C1     H12     107.900    3.000
 PGR      H11    C1     O1      109.470    3.000
 PGR      H12    C1     O1      109.470    3.000
 PGR      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PGR      var_1    HO2    O2     C2     C1       -60.081   20.000   1
 PGR      var_2    O2     C2     C3     H31       59.873   20.000   3
 PGR      var_3    O2     C2     C1     O1       -59.902   20.000   3
 PGR      var_4    C2     C1     O1     HO1     -179.967   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 PGR      chir_01  C2     C1     C3     O2        negativ
# ------------------------------------------------------
`.trim();

monomers["SPD"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SPD      SPD 'SPERMIDINE                          ' non-polymer        29  10 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SPD
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SPD           N10    N    NH2       0.000      0.000    0.000    0.000
 SPD           H101   H    H         0.000      0.600   -0.796   -0.180
 SPD           H102   H    H         0.000      0.362    0.786    0.527
 SPD           C9     C    CH2       0.000     -1.381    0.015   -0.498
 SPD           H91    H    H         0.000     -1.549   -0.859   -1.130
 SPD           H92    H    H         0.000     -1.546    0.923   -1.083
 SPD           C8     C    CH2       0.000     -2.352   -0.014    0.684
 SPD           H81    H    H         0.000     -2.182    0.860    1.315
 SPD           H82    H    H         0.000     -2.185   -0.922    1.268
 SPD           C7     C    CH2       0.000     -3.790    0.002    0.165
 SPD           H71    H    H         0.000     -3.958   -0.873   -0.467
 SPD           H72    H    H         0.000     -3.955    0.909   -0.420
 SPD           N6     N    NH1       0.000     -4.722   -0.027    1.300
 SPD           HN6    H    H         0.000     -4.479   -0.052    2.280
 SPD           C5     C    CH2       0.000     -6.077   -0.010    0.734
 SPD           H51    H    H         0.000     -6.215   -0.885    0.095
 SPD           H52    H    H         0.000     -6.212    0.897    0.141
 SPD           C4     C    CH2       0.000     -7.103   -0.038    1.868
 SPD           H41    H    H         0.000     -6.962    0.837    2.506
 SPD           H42    H    H         0.000     -6.965   -0.945    2.460
 SPD           C3     C    CH2       0.000     -8.515   -0.021    1.280
 SPD           H31    H    H         0.000     -8.652   -0.895    0.641
 SPD           H32    H    H         0.000     -8.649    0.886    0.688
 SPD           C2     C    CH2       0.000     -9.541   -0.049    2.413
 SPD           H21    H    H         0.000     -9.401    0.826    3.052
 SPD           H22    H    H         0.000     -9.403   -0.956    3.006
 SPD           N1     N    NH2       0.000    -10.897   -0.032    1.849
 SPD           HN12   H    H         0.000    -11.505   -0.835    1.957
 SPD           HN11   H    H         0.000    -11.232    0.782    1.348
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SPD      N10    n/a    C9     START
 SPD      H101   N10    .      .
 SPD      H102   N10    .      .
 SPD      C9     N10    C8     .
 SPD      H91    C9     .      .
 SPD      H92    C9     .      .
 SPD      C8     C9     C7     .
 SPD      H81    C8     .      .
 SPD      H82    C8     .      .
 SPD      C7     C8     N6     .
 SPD      H71    C7     .      .
 SPD      H72    C7     .      .
 SPD      N6     C7     C5     .
 SPD      HN6    N6     .      .
 SPD      C5     N6     C4     .
 SPD      H51    C5     .      .
 SPD      H52    C5     .      .
 SPD      C4     C5     C3     .
 SPD      H41    C4     .      .
 SPD      H42    C4     .      .
 SPD      C3     C4     C2     .
 SPD      H31    C3     .      .
 SPD      H32    C3     .      .
 SPD      C2     C3     N1     .
 SPD      H21    C2     .      .
 SPD      H22    C2     .      .
 SPD      N1     C2     HN11   .
 SPD      HN12   N1     .      .
 SPD      HN11   N1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SPD      N1     C2        single      1.450    0.020
 SPD      HN11   N1        single      1.010    0.020
 SPD      HN12   N1        single      1.010    0.020
 SPD      C2     C3        single      1.524    0.020
 SPD      H21    C2        single      1.092    0.020
 SPD      H22    C2        single      1.092    0.020
 SPD      C3     C4        single      1.524    0.020
 SPD      H31    C3        single      1.092    0.020
 SPD      H32    C3        single      1.092    0.020
 SPD      C4     C5        single      1.524    0.020
 SPD      H41    C4        single      1.092    0.020
 SPD      H42    C4        single      1.092    0.020
 SPD      C5     N6        single      1.450    0.020
 SPD      H51    C5        single      1.092    0.020
 SPD      H52    C5        single      1.092    0.020
 SPD      N6     C7        single      1.450    0.020
 SPD      HN6    N6        single      1.010    0.020
 SPD      C7     C8        single      1.524    0.020
 SPD      H71    C7        single      1.092    0.020
 SPD      H72    C7        single      1.092    0.020
 SPD      C8     C9        single      1.524    0.020
 SPD      H81    C8        single      1.092    0.020
 SPD      H82    C8        single      1.092    0.020
 SPD      C9     N10       single      1.450    0.020
 SPD      H91    C9        single      1.092    0.020
 SPD      H92    C9        single      1.092    0.020
 SPD      H101   N10       single      1.010    0.020
 SPD      H102   N10       single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SPD      H101   N10    H102    120.000    3.000
 SPD      H101   N10    C9      120.000    3.000
 SPD      H102   N10    C9      120.000    3.000
 SPD      N10    C9     H91     109.470    3.000
 SPD      N10    C9     H92     109.470    3.000
 SPD      N10    C9     C8      109.470    3.000
 SPD      H91    C9     H92     107.900    3.000
 SPD      H91    C9     C8      109.470    3.000
 SPD      H92    C9     C8      109.470    3.000
 SPD      C9     C8     H81     109.470    3.000
 SPD      C9     C8     H82     109.470    3.000
 SPD      C9     C8     C7      111.000    3.000
 SPD      H81    C8     H82     107.900    3.000
 SPD      H81    C8     C7      109.470    3.000
 SPD      H82    C8     C7      109.470    3.000
 SPD      C8     C7     H71     109.470    3.000
 SPD      C8     C7     H72     109.470    3.000
 SPD      C8     C7     N6      112.000    3.000
 SPD      H71    C7     H72     107.900    3.000
 SPD      H71    C7     N6      109.470    3.000
 SPD      H72    C7     N6      109.470    3.000
 SPD      C7     N6     HN6     118.500    3.000
 SPD      C7     N6     C5      120.000    3.000
 SPD      HN6    N6     C5      118.500    3.000
 SPD      N6     C5     H51     109.470    3.000
 SPD      N6     C5     H52     109.470    3.000
 SPD      N6     C5     C4      112.000    3.000
 SPD      H51    C5     H52     107.900    3.000
 SPD      H51    C5     C4      109.470    3.000
 SPD      H52    C5     C4      109.470    3.000
 SPD      C5     C4     H41     109.470    3.000
 SPD      C5     C4     H42     109.470    3.000
 SPD      C5     C4     C3      111.000    3.000
 SPD      H41    C4     H42     107.900    3.000
 SPD      H41    C4     C3      109.470    3.000
 SPD      H42    C4     C3      109.470    3.000
 SPD      C4     C3     H31     109.470    3.000
 SPD      C4     C3     H32     109.470    3.000
 SPD      C4     C3     C2      111.000    3.000
 SPD      H31    C3     H32     107.900    3.000
 SPD      H31    C3     C2      109.470    3.000
 SPD      H32    C3     C2      109.470    3.000
 SPD      C3     C2     H21     109.470    3.000
 SPD      C3     C2     H22     109.470    3.000
 SPD      C3     C2     N1      109.470    3.000
 SPD      H21    C2     H22     107.900    3.000
 SPD      H21    C2     N1      109.470    3.000
 SPD      H22    C2     N1      109.470    3.000
 SPD      C2     N1     HN12    120.000    3.000
 SPD      C2     N1     HN11    120.000    3.000
 SPD      HN12   N1     HN11    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 SPD      var_1    H102   N10    C9     C8       -66.151   20.000   1
 SPD      var_2    N10    C9     C8     C7       179.997   20.000   3
 SPD      var_3    C9     C8     C7     N6      -179.999   20.000   3
 SPD      var_4    C8     C7     N6     C5      -179.972   20.000   3
 SPD      var_5    C7     N6     C5     C4      -179.984   20.000   3
 SPD      var_6    N6     C5     C4     C3       179.997   20.000   3
 SPD      var_7    C5     C4     C3     C2       179.999   20.000   3
 SPD      var_8    C4     C3     C2     N1      -179.998   20.000   3
 SPD      var_9    C3     C2     N1     HN11     -66.247   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 SPD      plan-1    N1        0.020
 SPD      plan-1    C2        0.020
 SPD      plan-1    HN11      0.020
 SPD      plan-1    HN12      0.020
 SPD      plan-2    N6        0.020
 SPD      plan-2    C5        0.020
 SPD      plan-2    C7        0.020
 SPD      plan-2    HN6       0.020
 SPD      plan-3    N10       0.020
 SPD      plan-3    C9        0.020
 SPD      plan-3    H101      0.020
 SPD      plan-3    H102      0.020
# ------------------------------------------------------
`.trim();

monomers["SPK"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SPK      SPK 'SPERMINE (FULLY PROTONATED FORM)    ' non-polymer        44  14 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SPK
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SPK           N14    N    NT3       1.000      0.000    0.000    0.000
 SPK           H141   H    H         0.000      0.024   -0.593    0.843
 SPK           H142   H    H         0.000      0.024   -0.593   -0.843
 SPK           H143   H    H         0.000      0.811    0.637    0.000
 SPK           C13    C    CH2       0.000     -1.238    0.791    0.000
 SPK           H131   H    H         0.000     -1.266    1.422   -0.891
 SPK           H132   H    H         0.000     -1.266    1.422    0.891
 SPK           C12    C    CH2       0.000     -2.444   -0.149    0.000
 SPK           H121   H    H         0.000     -2.414   -0.780    0.891
 SPK           H122   H    H         0.000     -2.414   -0.780   -0.891
 SPK           C11    C    CH2       0.000     -3.733    0.675    0.000
 SPK           H111   H    H         0.000     -3.762    1.306   -0.891
 SPK           H112   H    H         0.000     -3.762    1.306    0.891
 SPK           N10    N    NT2       1.000     -4.892   -0.229    0.000
 SPK           H101   H    H         0.000     -4.863   -0.825    0.843
 SPK           H102   H    H         0.000     -4.863   -0.825   -0.843
 SPK           C9     C    CH2       0.000     -6.130    0.562    0.000
 SPK           H9A    H    H         0.000     -6.158    1.193   -0.891
 SPK           H9B    H    H         0.000     -6.158    1.193    0.891
 SPK           C8     C    CH2       0.000     -7.336   -0.378    0.000
 SPK           H8A    H    H         0.000     -7.306   -1.008    0.891
 SPK           H8B    H    H         0.000     -7.306   -1.008   -0.891
 SPK           C7     C    CH2       0.000     -8.625    0.446    0.000
 SPK           H7A    H    H         0.000     -8.654    1.077   -0.891
 SPK           H7B    H    H         0.000     -8.654    1.077    0.891
 SPK           C6     C    CH2       0.000     -9.832   -0.494    0.000
 SPK           H6A    H    H         0.000     -9.801   -1.125    0.891
 SPK           H6B    H    H         0.000     -9.801   -1.125   -0.891
 SPK           N5     N    NT2       1.000    -11.070    0.297    0.000
 SPK           H5A    H    H         0.000    -11.097    0.893   -0.843
 SPK           H5B    H    H         0.000    -11.097    0.893    0.843
 SPK           C4     C    CH2       0.000    -12.228   -0.607    0.000
 SPK           H4A    H    H         0.000    -12.198   -1.237    0.891
 SPK           H4B    H    H         0.000    -12.198   -1.237   -0.891
 SPK           C3     C    CH2       0.000    -13.517    0.218    0.000
 SPK           H3A    H    H         0.000    -13.546    0.848   -0.891
 SPK           H3B    H    H         0.000    -13.546    0.848    0.891
 SPK           C2     C    CH2       0.000    -14.724   -0.723    0.000
 SPK           H2A    H    H         0.000    -14.693   -1.353    0.891
 SPK           H2B    H    H         0.000    -14.693   -1.353   -0.891
 SPK           N1     N    NT3       1.000    -15.962    0.068    0.000
 SPK           H1C    H    H         0.000    -16.773   -0.569    0.000
 SPK           H1B    H    H         0.000    -15.986    0.662    0.843
 SPK           H1A    H    H         0.000    -15.986    0.661   -0.844
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SPK      N14    n/a    C13    START
 SPK      H141   N14    .      .
 SPK      H142   N14    .      .
 SPK      H143   N14    .      .
 SPK      C13    N14    C12    .
 SPK      H131   C13    .      .
 SPK      H132   C13    .      .
 SPK      C12    C13    C11    .
 SPK      H121   C12    .      .
 SPK      H122   C12    .      .
 SPK      C11    C12    N10    .
 SPK      H111   C11    .      .
 SPK      H112   C11    .      .
 SPK      N10    C11    C9     .
 SPK      H101   N10    .      .
 SPK      H102   N10    .      .
 SPK      C9     N10    C8     .
 SPK      H9A    C9     .      .
 SPK      H9B    C9     .      .
 SPK      C8     C9     C7     .
 SPK      H8A    C8     .      .
 SPK      H8B    C8     .      .
 SPK      C7     C8     C6     .
 SPK      H7A    C7     .      .
 SPK      H7B    C7     .      .
 SPK      C6     C7     N5     .
 SPK      H6A    C6     .      .
 SPK      H6B    C6     .      .
 SPK      N5     C6     C4     .
 SPK      H5A    N5     .      .
 SPK      H5B    N5     .      .
 SPK      C4     N5     C3     .
 SPK      H4A    C4     .      .
 SPK      H4B    C4     .      .
 SPK      C3     C4     C2     .
 SPK      H3A    C3     .      .
 SPK      H3B    C3     .      .
 SPK      C2     C3     N1     .
 SPK      H2A    C2     .      .
 SPK      H2B    C2     .      .
 SPK      N1     C2     H1A    .
 SPK      H1C    N1     .      .
 SPK      H1B    N1     .      .
 SPK      H1A    N1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SPK      N1     C2        single      1.488    0.020
 SPK      H1A    N1        single      1.033    0.020
 SPK      H1B    N1        single      1.033    0.020
 SPK      H1C    N1        single      1.033    0.020
 SPK      C2     C3        single      1.524    0.020
 SPK      H2A    C2        single      1.092    0.020
 SPK      H2B    C2        single      1.092    0.020
 SPK      C3     C4        single      1.524    0.020
 SPK      H3A    C3        single      1.092    0.020
 SPK      H3B    C3        single      1.092    0.020
 SPK      C4     N5        single      1.472    0.020
 SPK      H4A    C4        single      1.092    0.020
 SPK      H4B    C4        single      1.092    0.020
 SPK      N5     C6        single      1.472    0.020
 SPK      H5A    N5        single      1.033    0.020
 SPK      H5B    N5        single      1.033    0.020
 SPK      C6     C7        single      1.524    0.020
 SPK      H6A    C6        single      1.092    0.020
 SPK      H6B    C6        single      1.092    0.020
 SPK      C7     C8        single      1.524    0.020
 SPK      H7A    C7        single      1.092    0.020
 SPK      H7B    C7        single      1.092    0.020
 SPK      C8     C9        single      1.524    0.020
 SPK      H8A    C8        single      1.092    0.020
 SPK      H8B    C8        single      1.092    0.020
 SPK      C9     N10       single      1.472    0.020
 SPK      H9A    C9        single      1.092    0.020
 SPK      H9B    C9        single      1.092    0.020
 SPK      N10    C11       single      1.472    0.020
 SPK      H101   N10       single      1.033    0.020
 SPK      H102   N10       single      1.033    0.020
 SPK      C11    C12       single      1.524    0.020
 SPK      H111   C11       single      1.092    0.020
 SPK      H112   C11       single      1.092    0.020
 SPK      C12    C13       single      1.524    0.020
 SPK      H121   C12       single      1.092    0.020
 SPK      H122   C12       single      1.092    0.020
 SPK      C13    N14       single      1.488    0.020
 SPK      H131   C13       single      1.092    0.020
 SPK      H132   C13       single      1.092    0.020
 SPK      H141   N14       single      1.033    0.020
 SPK      H142   N14       single      1.033    0.020
 SPK      H143   N14       single      1.033    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SPK      H141   N14    H142    109.470    3.000
 SPK      H141   N14    H143    109.470    3.000
 SPK      H142   N14    H143    109.470    3.000
 SPK      H141   N14    C13     109.470    3.000
 SPK      H142   N14    C13     109.470    3.000
 SPK      H143   N14    C13     109.470    3.000
 SPK      N14    C13    H131    109.470    3.000
 SPK      N14    C13    H132    109.470    3.000
 SPK      N14    C13    C12     110.000    3.000
 SPK      H131   C13    H132    107.900    3.000
 SPK      H131   C13    C12     109.470    3.000
 SPK      H132   C13    C12     109.470    3.000
 SPK      C13    C12    H121    109.470    3.000
 SPK      C13    C12    H122    109.470    3.000
 SPK      C13    C12    C11     111.000    3.000
 SPK      H121   C12    H122    107.900    3.000
 SPK      H121   C12    C11     109.470    3.000
 SPK      H122   C12    C11     109.470    3.000
 SPK      C12    C11    H111    109.470    3.000
 SPK      C12    C11    H112    109.470    3.000
 SPK      C12    C11    N10     109.500    3.000
 SPK      H111   C11    H112    107.900    3.000
 SPK      H111   C11    N10     109.500    3.000
 SPK      H112   C11    N10     109.500    3.000
 SPK      C11    N10    H101    109.500    3.000
 SPK      C11    N10    H102    109.500    3.000
 SPK      C11    N10    C9      109.500    3.000
 SPK      H101   N10    H102    109.500    3.000
 SPK      H101   N10    C9      109.500    3.000
 SPK      H102   N10    C9      109.500    3.000
 SPK      N10    C9     H9A     109.500    3.000
 SPK      N10    C9     H9B     109.500    3.000
 SPK      N10    C9     C8      109.500    3.000
 SPK      H9A    C9     H9B     107.900    3.000
 SPK      H9A    C9     C8      109.470    3.000
 SPK      H9B    C9     C8      109.470    3.000
 SPK      C9     C8     H8A     109.470    3.000
 SPK      C9     C8     H8B     109.470    3.000
 SPK      C9     C8     C7      111.000    3.000
 SPK      H8A    C8     H8B     107.900    3.000
 SPK      H8A    C8     C7      109.470    3.000
 SPK      H8B    C8     C7      109.470    3.000
 SPK      C8     C7     H7A     109.470    3.000
 SPK      C8     C7     H7B     109.470    3.000
 SPK      C8     C7     C6      111.000    3.000
 SPK      H7A    C7     H7B     107.900    3.000
 SPK      H7A    C7     C6      109.470    3.000
 SPK      H7B    C7     C6      109.470    3.000
 SPK      C7     C6     H6A     109.470    3.000
 SPK      C7     C6     H6B     109.470    3.000
 SPK      C7     C6     N5      109.500    3.000
 SPK      H6A    C6     H6B     107.900    3.000
 SPK      H6A    C6     N5      109.500    3.000
 SPK      H6B    C6     N5      109.500    3.000
 SPK      C6     N5     H5A     109.500    3.000
 SPK      C6     N5     H5B     109.500    3.000
 SPK      C6     N5     C4      109.500    3.000
 SPK      H5A    N5     H5B     109.500    3.000
 SPK      H5A    N5     C4      109.500    3.000
 SPK      H5B    N5     C4      109.500    3.000
 SPK      N5     C4     H4A     109.500    3.000
 SPK      N5     C4     H4B     109.500    3.000
 SPK      N5     C4     C3      109.500    3.000
 SPK      H4A    C4     H4B     107.900    3.000
 SPK      H4A    C4     C3      109.470    3.000
 SPK      H4B    C4     C3      109.470    3.000
 SPK      C4     C3     H3A     109.470    3.000
 SPK      C4     C3     H3B     109.470    3.000
 SPK      C4     C3     C2      111.000    3.000
 SPK      H3A    C3     H3B     107.900    3.000
 SPK      H3A    C3     C2      109.470    3.000
 SPK      H3B    C3     C2      109.470    3.000
 SPK      C3     C2     H2A     109.470    3.000
 SPK      C3     C2     H2B     109.470    3.000
 SPK      C3     C2     N1      110.000    3.000
 SPK      H2A    C2     H2B     107.900    3.000
 SPK      H2A    C2     N1      109.470    3.000
 SPK      H2B    C2     N1      109.470    3.000
 SPK      C2     N1     H1C     109.470    3.000
 SPK      C2     N1     H1B     109.470    3.000
 SPK      C2     N1     H1A     109.470    3.000
 SPK      H1C    N1     H1B     109.470    3.000
 SPK      H1C    N1     H1A     109.470    3.000
 SPK      H1B    N1     H1A     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 SPK      var_1    H143   N14    C13    C12      180.000   20.000   1
 SPK      var_2    N14    C13    C12    C11      180.000   20.000   3
 SPK      var_3    C13    C12    C11    N10      180.000   20.000   3
 SPK      var_4    C12    C11    N10    C9       180.000   20.000   1
 SPK      var_5    C11    N10    C9     C8       180.000   20.000   1
 SPK      var_6    N10    C9     C8     C7       180.000   20.000   3
 SPK      var_7    C9     C8     C7     C6       180.000   20.000   3
 SPK      var_8    C8     C7     C6     N5       180.000   20.000   3
 SPK      var_9    C7     C6     N5     C4       180.000   20.000   1
 SPK      var_10   C6     N5     C4     C3       180.000   20.000   1
 SPK      var_11   N5     C4     C3     C2       180.000   20.000   3
 SPK      var_12   C4     C3     C2     N1       180.000   20.000   3
 SPK      var_13   C3     C2     N1     H1A       60.017   20.000   1
# ------------------------------------------------------
`.trim();

monomers["SPM"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SPM      SPM 'SPERMINE                            ' non-polymer        40  14 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SPM
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SPM           N14    N    NT2       0.000     -0.098    0.153    0.155
 SPM           HN41   H    H         0.000      0.380   -0.680   -0.155
 SPM           HN42   H    H         0.000     -0.068    0.965    0.751
 SPM           C13    C    CH2       0.000     -1.381    0.201   -0.567
 SPM           H131   H    H         0.000     -1.428   -0.600   -1.304
 SPM           H132   H    H         0.000     -1.493    1.162   -1.069
 SPM           C12    C    CH2       0.000     -2.505    0.024    0.453
 SPM           H121   H    H         0.000     -2.459    0.838    1.177
 SPM           H122   H    H         0.000     -2.369   -0.927    0.968
 SPM           C11    C    CH2       0.000     -3.862    0.038   -0.245
 SPM           H111   H    H         0.000     -3.991   -0.857   -0.853
 SPM           H112   H    H         0.000     -3.961    0.921   -0.876
 SPM           N10    N    NT1       0.000     -4.879    0.068    0.802
 SPM           HN0    H    H         0.000     -4.712    0.080    1.797
 SPM           C9     C    CH2       0.000     -6.187    0.078    0.144
 SPM           H91    H    H         0.000     -6.308   -0.779   -0.520
 SPM           H92    H    H         0.000     -6.346    0.998   -0.419
 SPM           C8     C    CH2       0.000     -7.205   -0.008    1.280
 SPM           H81    H    H         0.000     -7.086    0.848    1.945
 SPM           H82    H    H         0.000     -7.049   -0.928    1.843
 SPM           C7     C    CH2       0.000     -8.608   -0.004    0.692
 SPM           H71    H    H         0.000     -8.727   -0.855    0.021
 SPM           H72    H    H         0.000     -8.769    0.920    0.136
 SPM           C6     C    CH2       0.000     -9.626   -0.102    1.828
 SPM           H61    H    H         0.000     -9.565    0.760    2.493
 SPM           H62    H    H         0.000     -9.490   -1.016    2.406
 SPM           N5     N    NT1       0.000    -10.936   -0.125    1.175
 SPM           HN5    H    H         0.000    -11.104   -0.164    0.182
 SPM           C4     C    CH2       0.000    -11.958   -0.081    2.220
 SPM           H41    H    H         0.000    -11.792    0.767    2.884
 SPM           H42    H    H         0.000    -11.952   -1.003    2.802
 SPM           C3     C    CH2       0.000    -13.307    0.073    1.523
 SPM           H31    H    H         0.000    -13.485   -0.801    0.896
 SPM           H32    H    H         0.000    -13.285    0.967    0.899
 SPM           C2     C    CH2       0.000    -14.426    0.199    2.556
 SPM           H21    H    H         0.000    -14.321    1.131    3.110
 SPM           H22    H    H         0.000    -14.391   -0.641    3.250
 SPM           N1     N    NT2       0.000    -15.714    0.193    1.841
 SPM           HN12   H    H         0.000    -16.191   -0.655    2.108
 SPM           HN11   H    H         0.000    -15.744    1.039    1.291
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SPM      N14    n/a    C13    START
 SPM      HN41   N14    .      .
 SPM      HN42   N14    .      .
 SPM      C13    N14    C12    .
 SPM      H131   C13    .      .
 SPM      H132   C13    .      .
 SPM      C12    C13    C11    .
 SPM      H121   C12    .      .
 SPM      H122   C12    .      .
 SPM      C11    C12    N10    .
 SPM      H111   C11    .      .
 SPM      H112   C11    .      .
 SPM      N10    C11    C9     .
 SPM      HN0    N10    .      .
 SPM      C9     N10    C8     .
 SPM      H91    C9     .      .
 SPM      H92    C9     .      .
 SPM      C8     C9     C7     .
 SPM      H81    C8     .      .
 SPM      H82    C8     .      .
 SPM      C7     C8     C6     .
 SPM      H71    C7     .      .
 SPM      H72    C7     .      .
 SPM      C6     C7     N5     .
 SPM      H61    C6     .      .
 SPM      H62    C6     .      .
 SPM      N5     C6     C4     .
 SPM      HN5    N5     .      .
 SPM      C4     N5     C3     .
 SPM      H41    C4     .      .
 SPM      H42    C4     .      .
 SPM      C3     C4     C2     .
 SPM      H31    C3     .      .
 SPM      H32    C3     .      .
 SPM      C2     C3     N1     .
 SPM      H21    C2     .      .
 SPM      H22    C2     .      .
 SPM      N1     C2     HN11   .
 SPM      HN12   N1     .      .
 SPM      HN11   N1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SPM      N1     C2        single      1.468    0.020
 SPM      HN11   N1        single      1.009    0.020
 SPM      HN12   N1        single      1.008    0.020
 SPM      C2     C3        single      1.529    0.020
 SPM      H21    C2        single      1.089    0.020
 SPM      H22    C2        single      1.090    0.020
 SPM      C3     C4        single      1.530    0.020
 SPM      H31    C3        single      1.089    0.020
 SPM      H32    C3        single      1.090    0.020
 SPM      C4     N5        single      1.468    0.020
 SPM      H41    C4        single      1.089    0.020
 SPM      H42    C4        single      1.090    0.020
 SPM      N5     C6        single      1.468    0.020
 SPM      HN5    N5        single      1.008    0.020
 SPM      C6     C7        single      1.530    0.020
 SPM      H61    C6        single      1.090    0.020
 SPM      H62    C6        single      1.090    0.020
 SPM      C7     C8        single      1.528    0.020
 SPM      H71    C7        single      1.089    0.020
 SPM      H72    C7        single      1.090    0.020
 SPM      C8     C9        single      1.529    0.020
 SPM      H81    C8        single      1.089    0.020
 SPM      H82    C8        single      1.090    0.020
 SPM      C9     N10       single      1.468    0.020
 SPM      H91    C9        single      1.089    0.020
 SPM      H92    C9        single      1.090    0.020
 SPM      N10    C11       single      1.469    0.020
 SPM      HN0    N10       single      1.008    0.020
 SPM      C11    C12       single      1.530    0.020
 SPM      H111   C11       single      1.090    0.020
 SPM      H112   C11       single      1.090    0.020
 SPM      C12    C13       single      1.529    0.020
 SPM      H121   C12       single      1.090    0.020
 SPM      H122   C12       single      1.090    0.020
 SPM      C13    N14       single      1.469    0.020
 SPM      H131   C13       single      1.089    0.020
 SPM      H132   C13       single      1.090    0.020
 SPM      HN41   N14       single      1.008    0.020
 SPM      HN42   N14       single      1.008    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SPM      HN41   N14    HN42    106.711    3.000
 SPM      HN41   N14    C13     106.772    3.000
 SPM      HN42   N14    C13     106.779    3.000
 SPM      N14    C13    H131    109.503    3.000
 SPM      N14    C13    H132    109.403    3.000
 SPM      N14    C13    C12     109.519    3.000
 SPM      H131   C13    H132    109.463    3.000
 SPM      H131   C13    C12     109.535    3.000
 SPM      H132   C13    C12     109.403    3.000
 SPM      C13    C12    H121    109.542    3.000
 SPM      C13    C12    H122    109.471    3.000
 SPM      C13    C12    C11     109.534    3.000
 SPM      H121   C12    H122    109.411    3.000
 SPM      H121   C12    C11     109.447    3.000
 SPM      H122   C12    C11     109.422    3.000
 SPM      C12    C11    H111    109.474    3.000
 SPM      C12    C11    H112    109.448    3.000
 SPM      C12    C11    N10     109.524    3.000
 SPM      H111   C11    H112    109.494    3.000
 SPM      H111   C11    N10     109.465    3.000
 SPM      H112   C11    N10     109.423    3.000
 SPM      C11    N10    HN0     106.737    3.000
 SPM      C11    N10    C9      106.736    3.000
 SPM      HN0    N10    C9      106.740    3.000
 SPM      N10    C9     H91     109.521    3.000
 SPM      N10    C9     H92     109.413    3.000
 SPM      N10    C9     C8      109.536    3.000
 SPM      H91    C9     H92     109.399    3.000
 SPM      H91    C9     C8      109.535    3.000
 SPM      H92    C9     C8      109.423    3.000
 SPM      C9     C8     H81     109.535    3.000
 SPM      C9     C8     H82     109.377    3.000
 SPM      C9     C8     C7      109.505    3.000
 SPM      H81    C8     H82     109.400    3.000
 SPM      H81    C8     C7      109.522    3.000
 SPM      H82    C8     C7      109.488    3.000
 SPM      C8     C7     H71     109.484    3.000
 SPM      C8     C7     H72     109.488    3.000
 SPM      C8     C7     C6      109.504    3.000
 SPM      H71    C7     H72     109.473    3.000
 SPM      H71    C7     C6      109.467    3.000
 SPM      H72    C7     C6      109.410    3.000
 SPM      C7     C6     H61     109.487    3.000
 SPM      C7     C6     H62     109.456    3.000
 SPM      C7     C6     N5      109.566    3.000
 SPM      H61    C6     H62     109.431    3.000
 SPM      H61    C6     N5      109.488    3.000
 SPM      H62    C6     N5      109.399    3.000
 SPM      C6     N5     HN5     106.726    3.000
 SPM      C6     N5     C4      106.800    3.000
 SPM      HN5    N5     C4      106.758    3.000
 SPM      N5     C4     H41     109.497    3.000
 SPM      N5     C4     H42     109.398    3.000
 SPM      N5     C4     C3      109.558    3.000
 SPM      H41    C4     H42     109.417    3.000
 SPM      H41    C4     C3      109.522    3.000
 SPM      H42    C4     C3      109.435    3.000
 SPM      C4     C3     H31     109.476    3.000
 SPM      C4     C3     H32     109.389    3.000
 SPM      C4     C3     C2      109.535    3.000
 SPM      H31    C3     H32     109.420    3.000
 SPM      H31    C3     C2      109.536    3.000
 SPM      H32    C3     C2      109.471    3.000
 SPM      C3     C2     H21     109.558    3.000
 SPM      C3     C2     H22     109.471    3.000
 SPM      C3     C2     N1      109.550    3.000
 SPM      H21    C2     H22     109.379    3.000
 SPM      H21    C2     N1      109.472    3.000
 SPM      H22    C2     N1      109.397    3.000
 SPM      C2     N1     HN12    106.803    3.000
 SPM      C2     N1     HN11    106.673    3.000
 SPM      HN12   N1     HN11    106.641    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 SPM      var_1            HN42   N14    C13    C12              -66.136           20.000   3
 SPM      var_2            N14    C13    C12    C11              179.937           20.000   3
 SPM      var_3            C13    C12    C11    N10              180.000           20.000   3
 SPM      var_4            C12    C11    N10    C9              -179.956           20.000   3
 SPM      var_5            C11    N10    C9     C8              -179.960           20.000   3
 SPM      var_6            N10    C9     C8     C7               180.000           20.000   3
 SPM      var_7            C9     C8     C7     C6               179.966           20.000   3
 SPM      var_8            C8     C7     C6     N5              -179.972           20.000   3
 SPM      var_9            C7     C6     N5     C4              -179.956           20.000   3
 SPM      var_10           C6     N5     C4     C3              -179.972           20.000   3
 SPM      var_11           N5     C4     C3     C2               179.966           20.000   3
 SPM      var_12           C4     C3     C2     N1               180.000           20.000   3
 SPM      var_13           C3     C2     N1     HN11             -66.250           20.000   3
# ------------------------------------------------------
`.trim();

monomers["TBU"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TBU      TBU 'TERTIARY-BUTYL ALCOHOL              ' non-polymer        15   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TBU
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TBU           C3     C    CH3       0.000      0.000    0.000    0.000
 TBU           H31    H    H         0.000      0.779    0.610   -0.379
 TBU           H32    H    H         0.000      0.023    0.018    1.059
 TBU           H33    H    H         0.000      0.136   -0.995   -0.338
 TBU           C      C    CT        0.000     -1.349    0.528   -0.491
 TBU           C2     C    CH3       0.000     -2.472   -0.354    0.059
 TBU           H23    H    H         0.000     -2.450   -0.337    1.118
 TBU           H22    H    H         0.000     -3.408    0.011   -0.280
 TBU           H21    H    H         0.000     -2.340   -1.349   -0.280
 TBU           C1     C    CH3       0.000     -1.543    1.964    0.000
 TBU           H13    H    H         0.000     -1.520    1.983    1.059
 TBU           H12    H    H         0.000     -0.766    2.576   -0.379
 TBU           H11    H    H         0.000     -2.478    2.332   -0.338
 TBU           O      O    OH1       0.000     -1.380    0.504   -1.919
 TBU           HO     H    H         0.000     -0.670    1.062   -2.265
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TBU      C3     n/a    C      START
 TBU      H31    C3     .      .
 TBU      H32    C3     .      .
 TBU      H33    C3     .      .
 TBU      C      C3     O      .
 TBU      C2     C      H21    .
 TBU      H23    C2     .      .
 TBU      H22    C2     .      .
 TBU      H21    C2     .      .
 TBU      C1     C      H11    .
 TBU      H13    C1     .      .
 TBU      H12    C1     .      .
 TBU      H11    C1     .      .
 TBU      O      C      HO     .
 TBU      HO     O      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TBU      O      C         single      1.432    0.020
 TBU      HO     O         single      0.967    0.020
 TBU      C1     C         single      1.524    0.020
 TBU      C2     C         single      1.524    0.020
 TBU      C      C3        single      1.524    0.020
 TBU      H11    C1        single      1.059    0.020
 TBU      H12    C1        single      1.059    0.020
 TBU      H13    C1        single      1.059    0.020
 TBU      H21    C2        single      1.059    0.020
 TBU      H22    C2        single      1.059    0.020
 TBU      H23    C2        single      1.059    0.020
 TBU      H31    C3        single      1.059    0.020
 TBU      H32    C3        single      1.059    0.020
 TBU      H33    C3        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TBU      H31    C3     H32     109.470    3.000
 TBU      H31    C3     H33     109.470    3.000
 TBU      H32    C3     H33     109.470    3.000
 TBU      H31    C3     C       109.470    3.000
 TBU      H32    C3     C       109.470    3.000
 TBU      H33    C3     C       109.470    3.000
 TBU      C3     C      C2      111.000    3.000
 TBU      C3     C      C1      111.000    3.000
 TBU      C3     C      O       109.470    3.000
 TBU      C2     C      C1      111.000    3.000
 TBU      C2     C      O       109.470    3.000
 TBU      C1     C      O       109.470    3.000
 TBU      C      C2     H23     109.470    3.000
 TBU      C      C2     H22     109.470    3.000
 TBU      C      C2     H21     109.470    3.000
 TBU      H23    C2     H22     109.470    3.000
 TBU      H23    C2     H21     109.470    3.000
 TBU      H22    C2     H21     109.470    3.000
 TBU      C      C1     H13     109.470    3.000
 TBU      C      C1     H12     109.470    3.000
 TBU      C      C1     H11     109.470    3.000
 TBU      H13    C1     H12     109.470    3.000
 TBU      H13    C1     H11     109.470    3.000
 TBU      H12    C1     H11     109.470    3.000
 TBU      C      O      HO      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TBU      var_1    H33    C3     C      O        -60.024   20.000   1
 TBU      var_2    C3     C      C2     H21      -60.052   20.000   1
 TBU      var_3    C3     C      C1     H11     -179.958   20.000   1
 TBU      var_4    C3     C      O      HO       -59.993   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TBU      chir_01  C      O      C1     C2        negativ
# ------------------------------------------------------
`.trim();

monomers["TMA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TMA      TMA 'TETRAMETHYLAMMONIUM ION             ' non-polymer        17   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TMA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TMA           C4     C    CH3       0.000      0.000    0.000    0.000
 TMA           H41    H    H         0.000      0.588   -0.031    0.881
 TMA           H42    H    H         0.000      0.205   -0.855   -0.591
 TMA           H43    H    H         0.000      0.234    0.874   -0.550
 TMA           N1     N    NT        1.000     -1.424    0.016    0.362
 TMA           C3     C    CH3       0.000     -2.239    0.058   -0.860
 TMA           H33    H    H         0.000     -2.034   -0.797   -1.450
 TMA           H32    H    H         0.000     -3.265    0.069   -0.599
 TMA           H31    H    H         0.000     -2.005    0.932   -1.410
 TMA           C2     C    CH3       0.000     -1.748   -1.197    1.124
 TMA           H23    H    H         0.000     -1.545   -2.051    0.533
 TMA           H22    H    H         0.000     -1.160   -1.228    2.004
 TMA           H21    H    H         0.000     -2.775   -1.185    1.386
 TMA           C1     C    CH3       0.000     -1.707    1.201    1.182
 TMA           H13    H    H         0.000     -1.473    2.075    0.632
 TMA           H12    H    H         0.000     -2.734    1.212    1.443
 TMA           H11    H    H         0.000     -1.119    1.170    2.062
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TMA      C4     n/a    N1     START
 TMA      H41    C4     .      .
 TMA      H42    C4     .      .
 TMA      H43    C4     .      .
 TMA      N1     C4     C1     .
 TMA      C3     N1     H31    .
 TMA      H33    C3     .      .
 TMA      H32    C3     .      .
 TMA      H31    C3     .      .
 TMA      C2     N1     H21    .
 TMA      H23    C2     .      .
 TMA      H22    C2     .      .
 TMA      H21    C2     .      .
 TMA      C1     N1     H11    .
 TMA      H13    C1     .      .
 TMA      H12    C1     .      .
 TMA      H11    C1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TMA      C1     N1        single      1.469    0.020
 TMA      C2     N1        single      1.469    0.020
 TMA      C3     N1        single      1.469    0.020
 TMA      N1     C4        single      1.469    0.020
 TMA      H11    C1        single      1.059    0.020
 TMA      H12    C1        single      1.059    0.020
 TMA      H13    C1        single      1.059    0.020
 TMA      H21    C2        single      1.059    0.020
 TMA      H22    C2        single      1.059    0.020
 TMA      H23    C2        single      1.059    0.020
 TMA      H31    C3        single      1.059    0.020
 TMA      H32    C3        single      1.059    0.020
 TMA      H33    C3        single      1.059    0.020
 TMA      H41    C4        single      1.059    0.020
 TMA      H42    C4        single      1.059    0.020
 TMA      H43    C4        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TMA      H41    C4     H42     109.470    3.000
 TMA      H41    C4     H43     109.470    3.000
 TMA      H42    C4     H43     109.470    3.000
 TMA      H41    C4     N1      109.470    3.000
 TMA      H42    C4     N1      109.470    3.000
 TMA      H43    C4     N1      109.470    3.000
 TMA      C4     N1     C3      109.470    3.000
 TMA      C4     N1     C2      109.470    3.000
 TMA      C4     N1     C1      109.470    3.000
 TMA      C3     N1     C2      109.470    3.000
 TMA      C3     N1     C1      109.470    3.000
 TMA      C2     N1     C1      109.470    3.000
 TMA      N1     C3     H33     109.470    3.000
 TMA      N1     C3     H32     109.470    3.000
 TMA      N1     C3     H31     109.470    3.000
 TMA      H33    C3     H32     109.470    3.000
 TMA      H33    C3     H31     109.470    3.000
 TMA      H32    C3     H31     109.470    3.000
 TMA      N1     C2     H23     109.470    3.000
 TMA      N1     C2     H22     109.470    3.000
 TMA      N1     C2     H21     109.470    3.000
 TMA      H23    C2     H22     109.470    3.000
 TMA      H23    C2     H21     109.470    3.000
 TMA      H22    C2     H21     109.470    3.000
 TMA      N1     C1     H13     109.470    3.000
 TMA      N1     C1     H12     109.470    3.000
 TMA      N1     C1     H11     109.470    3.000
 TMA      H13    C1     H12     109.470    3.000
 TMA      H13    C1     H11     109.470    3.000
 TMA      H12    C1     H11     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TMA      var_1    H43    C4     N1     C1       -60.014   20.000   1
 TMA      var_2    C4     N1     C3     H31      -60.017   20.000   1
 TMA      var_3    C4     N1     C2     H21      179.947   20.000   1
 TMA      var_4    C4     N1     C1     H11      -59.980   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 TMA      chir_01  N1     C1     C2     C3        negativ
# ------------------------------------------------------
`.trim();

monomers["TEP"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
TEP      TEP 'THEOPHYLLINE                        ' non-polymer        21  13 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_TEP
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 TEP           O6     O    O         0.000      0.000    0.000    0.000
 TEP           C6     C    CR6       0.000     -1.217   -0.002    0.054
 TEP           N1     N    NR6       0.000     -1.847   -0.004    1.246
 TEP           C1     C    CH3       0.000     -1.058   -0.007    2.481
 TEP           H13    H    H         0.000     -0.026   -0.010    2.240
 TEP           H12    H    H         0.000     -1.285    0.859    3.047
 TEP           H11    H    H         0.000     -1.291   -0.870    3.047
 TEP           C5     C    CR56      0.000     -1.983   -0.004   -1.131
 TEP           N7     N    NR15      0.000     -1.684   -0.005   -2.478
 TEP           HN7    H    H         0.000     -0.734   -0.007   -2.901
 TEP           C8     C    CR15      0.000     -2.858   -0.001   -3.142
 TEP           H8     H    H         0.000     -2.965    0.000   -4.219
 TEP           N9     N    NRD5      0.000     -3.847    0.000   -2.287
 TEP           C4     C    CR56      0.000     -3.369    0.000   -1.040
 TEP           N3     N    NR6       0.000     -3.957    0.000    0.214
 TEP           C3     C    CH3       0.000     -5.417    0.004    0.337
 TEP           H33    H    H         0.000     -5.809    0.870   -0.131
 TEP           H32    H    H         0.000     -5.813   -0.859   -0.131
 TEP           H31    H    H         0.000     -5.686    0.005    1.361
 TEP           C2     C    CR6       0.000     -3.189   -0.001    1.319
 TEP           O2     O    O         0.000     -3.723    0.000    2.412
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 TEP      O6     n/a    C6     START
 TEP      C6     O6     C5     .
 TEP      N1     C6     C1     .
 TEP      C1     N1     H11    .
 TEP      H13    C1     .      .
 TEP      H12    C1     .      .
 TEP      H11    C1     .      .
 TEP      C5     C6     N7     .
 TEP      N7     C5     C8     .
 TEP      HN7    N7     .      .
 TEP      C8     N7     N9     .
 TEP      H8     C8     .      .
 TEP      N9     C8     C4     .
 TEP      C4     N9     N3     .
 TEP      N3     C4     C2     .
 TEP      C3     N3     H31    .
 TEP      H33    C3     .      .
 TEP      H32    C3     .      .
 TEP      H31    C3     .      .
 TEP      C2     N3     O2     .
 TEP      O2     C2     .      END
 TEP      N1     C2     .    ADD
 TEP      C4     C5     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 TEP      C1     N1        single      1.465    0.020
 TEP      H11    C1        single      1.059    0.020
 TEP      H12    C1        single      1.059    0.020
 TEP      H13    C1        single      1.059    0.020
 TEP      N1     C2        single      1.410    0.020
 TEP      N1     C6        single      1.410    0.020
 TEP      O2     C2        double      1.250    0.020
 TEP      C2     N3        single      1.410    0.020
 TEP      C3     N3        single      1.465    0.020
 TEP      N3     C4        single      1.337    0.020
 TEP      H31    C3        single      1.059    0.020
 TEP      H32    C3        single      1.059    0.020
 TEP      H33    C3        single      1.059    0.020
 TEP      C4     C5        double      1.490    0.020
 TEP      C4     N9        single      1.350    0.020
 TEP      C5     C6        single      1.490    0.020
 TEP      N7     C5        single      1.340    0.020
 TEP      C6     O6        double      1.250    0.020
 TEP      C8     N7        single      1.350    0.020
 TEP      HN7    N7        single      1.040    0.020
 TEP      N9     C8        double      1.350    0.020
 TEP      H8     C8        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 TEP      O6     C6     N1      120.000    3.000
 TEP      O6     C6     C5      120.000    3.000
 TEP      N1     C6     C5      120.000    3.000
 TEP      C6     N1     C1      120.000    3.000
 TEP      C6     N1     C2      120.000    3.000
 TEP      C1     N1     C2      120.000    3.000
 TEP      N1     C1     H13     109.470    3.000
 TEP      N1     C1     H12     109.470    3.000
 TEP      N1     C1     H11     109.470    3.000
 TEP      H13    C1     H12     109.470    3.000
 TEP      H13    C1     H11     109.470    3.000
 TEP      H12    C1     H11     109.470    3.000
 TEP      C6     C5     N7      132.000    3.000
 TEP      C6     C5     C4      120.000    3.000
 TEP      N7     C5     C4      108.000    3.000
 TEP      C5     N7     HN7     126.000    3.000
 TEP      C5     N7     C8      108.000    3.000
 TEP      HN7    N7     C8      126.000    3.000
 TEP      N7     C8     H8      126.000    3.000
 TEP      N7     C8     N9      108.000    3.000
 TEP      H8     C8     N9      126.000    3.000
 TEP      C8     N9     C4      108.000    3.000
 TEP      N9     C4     N3      120.000    3.000
 TEP      N9     C4     C5      108.000    3.000
 TEP      N3     C4     C5      120.000    3.000
 TEP      C4     N3     C3      120.000    3.000
 TEP      C4     N3     C2      120.000    3.000
 TEP      C3     N3     C2      120.000    3.000
 TEP      N3     C3     H33     109.470    3.000
 TEP      N3     C3     H32     109.470    3.000
 TEP      N3     C3     H31     109.470    3.000
 TEP      H33    C3     H32     109.470    3.000
 TEP      H33    C3     H31     109.470    3.000
 TEP      H32    C3     H31     109.470    3.000
 TEP      N3     C2     O2      120.000    3.000
 TEP      N3     C2     N1      120.000    3.000
 TEP      O2     C2     N1      120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 TEP      CONST_1  O6     C6     N1     C1         0.000    0.000   0
 TEP      CONST_2  C6     N1     C2     N3         0.000    0.000   0
 TEP      var_1    C6     N1     C1     H11     -120.224   20.000   1
 TEP      CONST_3  O6     C6     C5     N7         0.000    0.000   0
 TEP      CONST_4  C6     C5     N7     C8       180.000    0.000   0
 TEP      CONST_5  C5     N7     C8     N9         0.000    0.000   0
 TEP      CONST_6  N7     C8     N9     C4         0.000    0.000   0
 TEP      CONST_7  C8     N9     C4     N3       180.000    0.000   0
 TEP      CONST_8  N9     C4     C5     C6       180.000    0.000   0
 TEP      CONST_9  N9     C4     N3     C2       180.000    0.000   0
 TEP      var_2    C4     N3     C3     H31     -179.982   20.000   1
 TEP      CONST_10 C4     N3     C2     O2       180.000    0.000   0
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 TEP      plan-1    N1        0.020
 TEP      plan-1    C1        0.020
 TEP      plan-1    C2        0.020
 TEP      plan-1    C6        0.020
 TEP      plan-1    N3        0.020
 TEP      plan-1    O2        0.020
 TEP      plan-1    C3        0.020
 TEP      plan-1    C4        0.020
 TEP      plan-1    C5        0.020
 TEP      plan-1    N9        0.020
 TEP      plan-1    N7        0.020
 TEP      plan-1    C8        0.020
 TEP      plan-1    O6        0.020
 TEP      plan-1    HN7       0.020
 TEP      plan-1    H8        0.020
# ------------------------------------------------------
`.trim();

monomers["SCN"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
SCN      SCN 'THIOCYANATE ION                     ' non-polymer         3   3 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_SCN
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 SCN           N      N    NS        0.000      0.000    0.000    0.000
 SCN           C      C    CSP       0.000     -1.136    0.000    0.000
 SCN           S      S    S1       -1.000     -2.946    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 SCN      N      n/a    C      START
 SCN      C      N      S      .
 SCN      S      C      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 SCN      S      C         single      1.689    0.020
 SCN      C      N         triple      1.158    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 SCN      N      C      S       180.000    2.000
# ------------------------------------------------------
`.trim();

monomers["ETF"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ETF      ETF 'TRIFLUOROETHANOL                    ' non-polymer         9   6 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ETF
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ETF           F3     F    F         0.000      0.000    0.000    0.000
 ETF           C1     C    CT        0.000     -0.929   -0.725    0.752
 ETF           F1     F    F         0.000     -0.407   -1.989    1.046
 ETF           F2     F    F         0.000     -2.112   -0.867    0.022
 ETF           C2     C    CH2       0.000     -1.221    0.020    2.056
 ETF           H21    H    H         0.000     -0.296    0.129    2.627
 ETF           H22    H    H         0.000     -1.945   -0.547    2.644
 ETF           O      O    OH1       0.000     -1.754    1.312    1.758
 ETF           HO     H    H         0.000     -1.939    1.782    2.582
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ETF      F3     n/a    C1     START
 ETF      C1     F3     C2     .
 ETF      F1     C1     .      .
 ETF      F2     C1     .      .
 ETF      C2     C1     O      .
 ETF      H21    C2     .      .
 ETF      H22    C2     .      .
 ETF      O      C2     HO     .
 ETF      HO     O      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ETF      C2     C1        single      1.524    0.020
 ETF      F1     C1        single      1.320    0.020
 ETF      F2     C1        single      1.320    0.020
 ETF      C1     F3        single      1.320    0.020
 ETF      O      C2        single      1.432    0.020
 ETF      H21    C2        single      1.092    0.020
 ETF      H22    C2        single      1.092    0.020
 ETF      HO     O         single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ETF      F3     C1     F1      109.470    3.000
 ETF      F3     C1     F2      109.470    3.000
 ETF      F3     C1     C2      109.470    3.000
 ETF      F1     C1     F2      109.470    3.000
 ETF      F1     C1     C2      109.470    3.000
 ETF      F2     C1     C2      109.470    3.000
 ETF      C1     C2     H21     109.470    3.000
 ETF      C1     C2     H22     109.470    3.000
 ETF      C1     C2     O       109.470    3.000
 ETF      H21    C2     H22     107.900    3.000
 ETF      H21    C2     O       109.470    3.000
 ETF      H22    C2     O       109.470    3.000
 ETF      C2     O      HO      109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ETF      var_1    F3     C1     C2     O         60.008   20.000   1
 ETF      var_2    C1     C2     O      HO       179.934   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 ETF      chir_01  C1     C2     F1     F2        negativ
# ------------------------------------------------------
`.trim();

monomers["144"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
144      144 'TRIS-HYDROXYMETHYL-METHYL-AMMONIUM  ' non-polymer        20   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_144
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 144           O4     O    OH1       0.000      0.000    0.000    0.000
 144           HO4    H    H         0.000      0.788   -0.057   -0.557
 144           C4     C    CH2       0.000     -1.158    0.136   -0.826
 144           H41    H    H         0.000     -1.237   -0.731   -1.485
 144           H42    H    H         0.000     -1.069    1.042   -1.429
 144           N      N    NT        1.000     -2.356    0.222    0.018
 144           C1     C    CH3       0.000     -2.247    1.389    0.904
 144           H13    H    H         0.000     -2.162    2.269    0.321
 144           H12    H    H         0.000     -3.111    1.452    1.513
 144           H11    H    H         0.000     -1.389    1.288    1.517
 144           C3     C    CH2       0.000     -3.545    0.362   -0.831
 144           H31    H    H         0.000     -3.624   -0.505   -1.490
 144           H32    H    H         0.000     -3.456    1.269   -1.434
 144           O3     O    OH1       0.000     -4.711    0.446   -0.010
 144           HO3    H    H         0.000     -5.493    0.539   -0.570
 144           C2     C    CH2       0.000     -2.473   -0.998    0.828
 144           H21    H    H         0.000     -3.363   -0.933    1.457
 144           H22    H    H         0.000     -1.589   -1.101    1.461
 144           O2     O    OH1       0.000     -2.579   -2.133   -0.034
 144           HO2    H    H         0.000     -2.656   -2.936    0.499
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 144      O4     n/a    C4     START
 144      HO4    O4     .      .
 144      C4     O4     N      .
 144      H41    C4     .      .
 144      H42    C4     .      .
 144      N      C4     C2     .
 144      C1     N      H11    .
 144      H13    C1     .      .
 144      H12    C1     .      .
 144      H11    C1     .      .
 144      C3     N      O3     .
 144      H31    C3     .      .
 144      H32    C3     .      .
 144      O3     C3     HO3    .
 144      HO3    O3     .      .
 144      C2     N      O2     .
 144      H21    C2     .      .
 144      H22    C2     .      .
 144      O2     C2     HO2    .
 144      HO2    O2     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 144      C1     N         single      1.469    0.020
 144      H11    C1        single      1.059    0.020
 144      H12    C1        single      1.059    0.020
 144      H13    C1        single      1.059    0.020
 144      C2     N         single      1.469    0.020
 144      C3     N         single      1.469    0.020
 144      N      C4        single      1.469    0.020
 144      O2     C2        single      1.432    0.020
 144      H21    C2        single      1.092    0.020
 144      H22    C2        single      1.092    0.020
 144      HO2    O2        single      0.967    0.020
 144      O3     C3        single      1.432    0.020
 144      H31    C3        single      1.092    0.020
 144      H32    C3        single      1.092    0.020
 144      HO3    O3        single      0.967    0.020
 144      C4     O4        single      1.432    0.020
 144      H41    C4        single      1.092    0.020
 144      H42    C4        single      1.092    0.020
 144      HO4    O4        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 144      HO4    O4     C4      109.470    3.000
 144      O4     C4     H41     109.470    3.000
 144      O4     C4     H42     109.470    3.000
 144      O4     C4     N       109.500    3.000
 144      H41    C4     H42     107.900    3.000
 144      H41    C4     N       109.470    3.000
 144      H42    C4     N       109.470    3.000
 144      C4     N      C1      109.470    3.000
 144      C4     N      C3      109.470    3.000
 144      C4     N      C2      109.470    3.000
 144      C1     N      C3      109.470    3.000
 144      C1     N      C2      109.470    3.000
 144      C3     N      C2      109.470    3.000
 144      N      C1     H13     109.470    3.000
 144      N      C1     H12     109.470    3.000
 144      N      C1     H11     109.470    3.000
 144      H13    C1     H12     109.470    3.000
 144      H13    C1     H11     109.470    3.000
 144      H12    C1     H11     109.470    3.000
 144      N      C3     H31     109.470    3.000
 144      N      C3     H32     109.470    3.000
 144      N      C3     O3      109.500    3.000
 144      H31    C3     H32     107.900    3.000
 144      H31    C3     O3      109.470    3.000
 144      H32    C3     O3      109.470    3.000
 144      C3     O3     HO3     109.470    3.000
 144      N      C2     H21     109.470    3.000
 144      N      C2     H22     109.470    3.000
 144      N      C2     O2      109.500    3.000
 144      H21    C2     H22     107.900    3.000
 144      H21    C2     O2      109.470    3.000
 144      H22    C2     O2      109.470    3.000
 144      C2     O2     HO2     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 144      var_1    HO4    O4     C4     N       -179.995   20.000   1
 144      var_2    O4     C4     N      C2       -59.995   20.000   1
 144      var_3    C4     N      C1     H11      -59.988   20.000   1
 144      var_4    C4     N      C3     O3      -179.989   20.000   1
 144      var_5    N      C3     O3     HO3      179.995   20.000   1
 144      var_6    C4     N      C2     O2       -60.016   20.000   1
 144      var_7    N      C2     O2     HO2      180.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 144      chir_01  N      C1     C2     C3        negativ
# ------------------------------------------------------
`.trim();

monomers["UMQ"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
UMQ      UMQ 'UNDECYL-MALTOSIDE                   ' non-polymer        78  34 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_UMQ
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 UMQ           "O2'"  O    OH1       0.000      0.000    0.000    0.000
 UMQ           "HO2'" H    H         0.000      0.069   -0.386    0.883
 UMQ           "C2'"  C    CH1       0.000     -1.257   -0.357   -0.577
 UMQ           "H2'1" H    H         0.000     -1.334   -1.451   -0.645
 UMQ           "C3'"  C    CH1       0.000     -1.369    0.254   -1.978
 UMQ           "H3'1" H    H         0.000     -1.188    1.337   -1.924
 UMQ           "O3'"  O    OH1       0.000     -0.410   -0.350   -2.847
 UMQ           "HO3'" H    H         0.000      0.480   -0.185   -2.507
 UMQ           "C4'"  C    CH1       0.000     -2.783   -0.005   -2.514
 UMQ           "H4'1" H    H         0.000     -2.926   -1.084   -2.667
 UMQ           O1     O    O2        0.000     -2.959    0.680   -3.755
 UMQ           C1     C    CH1       0.000     -2.455   -0.180   -4.778
 UMQ           H11    H    H         0.000     -1.490   -0.599   -4.460
 UMQ           O5     O    O2        0.000     -3.380   -1.241   -5.004
 UMQ           C5     C    CH1       0.000     -4.659   -0.654   -5.239
 UMQ           H51    H    H         0.000     -4.898    0.040   -4.421
 UMQ           C6     C    CH2       0.000     -5.720   -1.756   -5.298
 UMQ           H61    H    H         0.000     -5.483   -2.446   -6.110
 UMQ           H62    H    H         0.000     -6.700   -1.307   -5.478
 UMQ           O6     O    OH1       0.000     -5.740   -2.465   -4.058
 UMQ           HO61   H    H         0.000     -6.411   -3.160   -4.096
 UMQ           C4     C    CH1       0.000     -4.644    0.108   -6.565
 UMQ           H41    H    H         0.000     -4.383   -0.580   -7.382
 UMQ           O4     O    OH1       0.000     -5.936    0.669   -6.808
 UMQ           HO41   H    H         0.000     -5.925    1.150   -7.647
 UMQ           C3     C    CH1       0.000     -3.602    1.229   -6.485
 UMQ           H31    H    H         0.000     -3.917    1.973   -5.741
 UMQ           O3     O    OH1       0.000     -3.471    1.855   -7.763
 UMQ           HO31   H    H         0.000     -2.814    2.561   -7.709
 UMQ           C2     C    CH1       0.000     -2.261    0.620   -6.067
 UMQ           H21    H    H         0.000     -1.895   -0.045   -6.861
 UMQ           O2     O    OH1       0.000     -1.311    1.664   -5.843
 UMQ           HO21   H    H         0.000     -0.465    1.278   -5.579
 UMQ           "C5'"  C    CH1       0.000     -3.803    0.507   -1.496
 UMQ           "H5'1" H    H         0.000     -3.643    1.581   -1.327
 UMQ           "C6'"  C    CH2       0.000     -5.216    0.281   -2.036
 UMQ           "H6'1" H    H         0.000     -5.397   -0.791   -2.144
 UMQ           "H6'2" H    H         0.000     -5.314    0.765   -3.010
 UMQ           "O6'"  O    OH1       0.000     -6.168    0.837   -1.128
 UMQ           "HO6'" H    H         0.000     -7.061    0.695   -1.470
 UMQ           "O5'"  O    O2        0.000     -3.650   -0.193   -0.263
 UMQ           "C1'"  C    CH1       0.000     -2.393    0.184    0.295
 UMQ           "H1'1" H    H         0.000     -2.328    1.280    0.341
 UMQ           "O1'"  O    O2        0.000     -2.277   -0.355    1.613
 UMQ           CA     C    CH2       0.000     -3.356    0.185    2.376
 UMQ           HA1    H    H         0.000     -4.305   -0.105    1.919
 UMQ           HA2    H    H         0.000     -3.280    1.275    2.393
 UMQ           CB     C    CH2       0.000     -3.291   -0.354    3.806
 UMQ           HB1    H    H         0.000     -2.341   -0.064    4.260
 UMQ           HB2    H    H         0.000     -3.366   -1.443    3.787
 UMQ           CC     C    CH2       0.000     -4.447    0.224    4.623
 UMQ           HC1    H    H         0.000     -5.396   -0.066    4.167
 UMQ           HC2    H    H         0.000     -4.371    1.314    4.640
 UMQ           CD     C    CH2       0.000     -4.381   -0.315    6.054
 UMQ           HD1    H    H         0.000     -3.431   -0.024    6.508
 UMQ           HD2    H    H         0.000     -4.456   -1.404    6.035
 UMQ           CF     C    CH2       0.000     -5.536    0.263    6.872
 UMQ           HF1    H    H         0.000     -6.485   -0.027    6.414
 UMQ           HF2    H    H         0.000     -5.459    1.353    6.888
 UMQ           CG     C    CH2       0.000     -5.472   -0.275    8.301
 UMQ           HG1    H    H         0.000     -4.522    0.015    8.755
 UMQ           HG2    H    H         0.000     -5.547   -1.364    8.282
 UMQ           CH     C    CH2       0.000     -6.627    0.303    9.120
 UMQ           HH1    H    H         0.000     -7.576    0.013    8.663
 UMQ           HH2    H    H         0.000     -6.551    1.393    9.136
 UMQ           CI     C    CH2       0.000     -6.561   -0.236   10.549
 UMQ           HI1    H    H         0.000     -5.611    0.055   11.004
 UMQ           HI2    H    H         0.000     -6.636   -1.325   10.531
 UMQ           CJ     C    CH2       0.000     -7.717    0.342   11.367
 UMQ           HJ1    H    H         0.000     -8.666    0.052   10.911
 UMQ           HJ2    H    H         0.000     -7.641    1.432   11.383
 UMQ           CK     C    CH2       0.000     -7.651   -0.197   12.797
 UMQ           HK1    H    H         0.000     -6.701    0.094   13.251
 UMQ           HK2    H    H         0.000     -7.726   -1.286   12.778
 UMQ           CL     C    CH3       0.000     -8.807    0.381   13.615
 UMQ           HL3    H    H         0.000     -8.736    1.439   13.636
 UMQ           HL2    H    H         0.000     -9.731    0.101   13.176
 UMQ           HL1    H    H         0.000     -8.764    0.008   14.607
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 UMQ      "O2'"  n/a    "C2'"  START
 UMQ      "HO2'" "O2'"  .      .
 UMQ      "C2'"  "O2'"  "C3'"  .
 UMQ      "H2'1" "C2'"  .      .
 UMQ      "C3'"  "C2'"  "C4'"  .
 UMQ      "H3'1" "C3'"  .      .
 UMQ      "O3'"  "C3'"  "HO3'" .
 UMQ      "HO3'" "O3'"  .      .
 UMQ      "C4'"  "C3'"  "C5'"  .
 UMQ      "H4'1" "C4'"  .      .
 UMQ      O1     "C4'"  C1     .
 UMQ      C1     O1     O5     .
 UMQ      H11    C1     .      .
 UMQ      O5     C1     C5     .
 UMQ      C5     O5     C4     .
 UMQ      H51    C5     .      .
 UMQ      C6     C5     O6     .
 UMQ      H61    C6     .      .
 UMQ      H62    C6     .      .
 UMQ      O6     C6     HO61   .
 UMQ      HO61   O6     .      .
 UMQ      C4     C5     C3     .
 UMQ      H41    C4     .      .
 UMQ      O4     C4     HO41   .
 UMQ      HO41   O4     .      .
 UMQ      C3     C4     C2     .
 UMQ      H31    C3     .      .
 UMQ      O3     C3     HO31   .
 UMQ      HO31   O3     .      .
 UMQ      C2     C3     O2     .
 UMQ      H21    C2     .      .
 UMQ      O2     C2     HO21   .
 UMQ      HO21   O2     .      .
 UMQ      "C5'"  "C4'"  "O5'"  .
 UMQ      "H5'1" "C5'"  .      .
 UMQ      "C6'"  "C5'"  "O6'"  .
 UMQ      "H6'1" "C6'"  .      .
 UMQ      "H6'2" "C6'"  .      .
 UMQ      "O6'"  "C6'"  "HO6'" .
 UMQ      "HO6'" "O6'"  .      .
 UMQ      "O5'"  "C5'"  "C1'"  .
 UMQ      "C1'"  "O5'"  "O1'"  .
 UMQ      "H1'1" "C1'"  .      .
 UMQ      "O1'"  "C1'"  CA     .
 UMQ      CA     "O1'"  CB     .
 UMQ      HA1    CA     .      .
 UMQ      HA2    CA     .      .
 UMQ      CB     CA     CC     .
 UMQ      HB1    CB     .      .
 UMQ      HB2    CB     .      .
 UMQ      CC     CB     CD     .
 UMQ      HC1    CC     .      .
 UMQ      HC2    CC     .      .
 UMQ      CD     CC     CF     .
 UMQ      HD1    CD     .      .
 UMQ      HD2    CD     .      .
 UMQ      CF     CD     CG     .
 UMQ      HF1    CF     .      .
 UMQ      HF2    CF     .      .
 UMQ      CG     CF     CH     .
 UMQ      HG1    CG     .      .
 UMQ      HG2    CG     .      .
 UMQ      CH     CG     CI     .
 UMQ      HH1    CH     .      .
 UMQ      HH2    CH     .      .
 UMQ      CI     CH     CJ     .
 UMQ      HI1    CI     .      .
 UMQ      HI2    CI     .      .
 UMQ      CJ     CI     CK     .
 UMQ      HJ1    CJ     .      .
 UMQ      HJ2    CJ     .      .
 UMQ      CK     CJ     CL     .
 UMQ      HK1    CK     .      .
 UMQ      HK2    CK     .      .
 UMQ      CL     CK     HL1    .
 UMQ      HL3    CL     .      .
 UMQ      HL2    CL     .      .
 UMQ      HL1    CL     .      END
 UMQ      C2     C1     .    ADD
 UMQ      "C1'"  "C2'"  .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 UMQ      O2     C2        single      1.432    0.020
 UMQ      C2     C1        single      1.524    0.020
 UMQ      C2     C3        single      1.524    0.020
 UMQ      H21    C2        single      1.099    0.020
 UMQ      C4     C5        single      1.524    0.020
 UMQ      O4     C4        single      1.432    0.020
 UMQ      C3     C4        single      1.524    0.020
 UMQ      H41    C4        single      1.099    0.020
 UMQ      C6     C5        single      1.524    0.020
 UMQ      C5     O5        single      1.426    0.020
 UMQ      H51    C5        single      1.099    0.020
 UMQ      O6     C6        single      1.432    0.020
 UMQ      H61    C6        single      1.092    0.020
 UMQ      H62    C6        single      1.092    0.020
 UMQ      HO21   O2        single      0.967    0.020
 UMQ      HO41   O4        single      0.967    0.020
 UMQ      C1     O1        single      1.426    0.020
 UMQ      O5     C1        single      1.426    0.020
 UMQ      H11    C1        single      1.099    0.020
 UMQ      O3     C3        single      1.432    0.020
 UMQ      H31    C3        single      1.099    0.020
 UMQ      O1     "C4'"     single      1.426    0.020
 UMQ      HO31   O3        single      0.967    0.020
 UMQ      HO61   O6        single      0.967    0.020
 UMQ      "C1'"  "C2'"     single      1.524    0.020
 UMQ      "O1'"  "C1'"     single      1.426    0.020
 UMQ      "C1'"  "O5'"     single      1.426    0.020
 UMQ      "H1'1" "C1'"     single      1.099    0.020
 UMQ      "C3'"  "C2'"     single      1.524    0.020
 UMQ      "C2'"  "O2'"     single      1.432    0.020
 UMQ      "H2'1" "C2'"     single      1.099    0.020
 UMQ      "C4'"  "C3'"     single      1.524    0.020
 UMQ      "O3'"  "C3'"     single      1.432    0.020
 UMQ      "H3'1" "C3'"     single      1.099    0.020
 UMQ      "C5'"  "C4'"     single      1.524    0.020
 UMQ      "H4'1" "C4'"     single      1.099    0.020
 UMQ      "C6'"  "C5'"     single      1.524    0.020
 UMQ      "O5'"  "C5'"     single      1.426    0.020
 UMQ      "H5'1" "C5'"     single      1.099    0.020
 UMQ      "O6'"  "C6'"     single      1.432    0.020
 UMQ      "H6'1" "C6'"     single      1.092    0.020
 UMQ      "H6'2" "C6'"     single      1.092    0.020
 UMQ      CA     "O1'"     single      1.426    0.020
 UMQ      "HO3'" "O3'"     single      0.967    0.020
 UMQ      "HO6'" "O6'"     single      0.967    0.020
 UMQ      "HO2'" "O2'"     single      0.967    0.020
 UMQ      CB     CA        single      1.524    0.020
 UMQ      HA1    CA        single      1.092    0.020
 UMQ      HA2    CA        single      1.092    0.020
 UMQ      CC     CB        single      1.524    0.020
 UMQ      HB1    CB        single      1.092    0.020
 UMQ      HB2    CB        single      1.092    0.020
 UMQ      CD     CC        single      1.524    0.020
 UMQ      HC1    CC        single      1.092    0.020
 UMQ      HC2    CC        single      1.092    0.020
 UMQ      CF     CD        single      1.524    0.020
 UMQ      HD1    CD        single      1.092    0.020
 UMQ      HD2    CD        single      1.092    0.020
 UMQ      CG     CF        single      1.524    0.020
 UMQ      HF1    CF        single      1.092    0.020
 UMQ      HF2    CF        single      1.092    0.020
 UMQ      CH     CG        single      1.524    0.020
 UMQ      HG1    CG        single      1.092    0.020
 UMQ      HG2    CG        single      1.092    0.020
 UMQ      CI     CH        single      1.524    0.020
 UMQ      HH1    CH        single      1.092    0.020
 UMQ      HH2    CH        single      1.092    0.020
 UMQ      CJ     CI        single      1.524    0.020
 UMQ      HI1    CI        single      1.092    0.020
 UMQ      HI2    CI        single      1.092    0.020
 UMQ      CK     CJ        single      1.524    0.020
 UMQ      HJ1    CJ        single      1.092    0.020
 UMQ      HJ2    CJ        single      1.092    0.020
 UMQ      CL     CK        single      1.513    0.020
 UMQ      HK1    CK        single      1.092    0.020
 UMQ      HK2    CK        single      1.092    0.020
 UMQ      HL1    CL        single      1.059    0.020
 UMQ      HL2    CL        single      1.059    0.020
 UMQ      HL3    CL        single      1.059    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 UMQ      "HO2'" "O2'"  "C2'"   109.470    3.000
 UMQ      "O2'"  "C2'"  "H2'1"  109.470    3.000
 UMQ      "O2'"  "C2'"  "C3'"   109.470    3.000
 UMQ      "O2'"  "C2'"  "C1'"   109.470    3.000
 UMQ      "H2'1" "C2'"  "C3'"   108.340    3.000
 UMQ      "H2'1" "C2'"  "C1'"   108.340    3.000
 UMQ      "C3'"  "C2'"  "C1'"   111.000    3.000
 UMQ      "C2'"  "C3'"  "H3'1"  108.340    3.000
 UMQ      "C2'"  "C3'"  "O3'"   109.470    3.000
 UMQ      "C2'"  "C3'"  "C4'"   111.000    3.000
 UMQ      "H3'1" "C3'"  "O3'"   109.470    3.000
 UMQ      "H3'1" "C3'"  "C4'"   108.340    3.000
 UMQ      "O3'"  "C3'"  "C4'"   109.470    3.000
 UMQ      "C3'"  "O3'"  "HO3'"  109.470    3.000
 UMQ      "C3'"  "C4'"  "H4'1"  108.340    3.000
 UMQ      "C3'"  "C4'"  O1      109.470    3.000
 UMQ      "C3'"  "C4'"  "C5'"   111.000    3.000
 UMQ      "H4'1" "C4'"  O1      109.470    3.000
 UMQ      "H4'1" "C4'"  "C5'"   108.340    3.000
 UMQ      O1     "C4'"  "C5'"   109.470    3.000
 UMQ      "C4'"  O1     C1      111.800    3.000
 UMQ      O1     C1     H11     109.470    3.000
 UMQ      O1     C1     O5      109.470    3.000
 UMQ      O1     C1     C2      109.470    3.000
 UMQ      H11    C1     O5      109.470    3.000
 UMQ      H11    C1     C2      108.340    3.000
 UMQ      O5     C1     C2      109.470    3.000
 UMQ      C1     O5     C5      111.800    3.000
 UMQ      O5     C5     H51     109.470    3.000
 UMQ      O5     C5     C6      109.470    3.000
 UMQ      O5     C5     C4      109.470    3.000
 UMQ      H51    C5     C6      108.340    3.000
 UMQ      H51    C5     C4      108.340    3.000
 UMQ      C6     C5     C4      111.000    3.000
 UMQ      C5     C6     H61     109.470    3.000
 UMQ      C5     C6     H62     109.470    3.000
 UMQ      C5     C6     O6      109.470    3.000
 UMQ      H61    C6     H62     107.900    3.000
 UMQ      H61    C6     O6      109.470    3.000
 UMQ      H62    C6     O6      109.470    3.000
 UMQ      C6     O6     HO61    109.470    3.000
 UMQ      C5     C4     H41     108.340    3.000
 UMQ      C5     C4     O4      109.470    3.000
 UMQ      C5     C4     C3      111.000    3.000
 UMQ      H41    C4     O4      109.470    3.000
 UMQ      H41    C4     C3      108.340    3.000
 UMQ      O4     C4     C3      109.470    3.000
 UMQ      C4     O4     HO41    109.470    3.000
 UMQ      C4     C3     H31     108.340    3.000
 UMQ      C4     C3     O3      109.470    3.000
 UMQ      C4     C3     C2      111.000    3.000
 UMQ      H31    C3     O3      109.470    3.000
 UMQ      H31    C3     C2      108.340    3.000
 UMQ      O3     C3     C2      109.470    3.000
 UMQ      C3     O3     HO31    109.470    3.000
 UMQ      C3     C2     H21     108.340    3.000
 UMQ      C3     C2     O2      109.470    3.000
 UMQ      C3     C2     C1      111.000    3.000
 UMQ      H21    C2     O2      109.470    3.000
 UMQ      H21    C2     C1      108.340    3.000
 UMQ      O2     C2     C1      109.470    3.000
 UMQ      C2     O2     HO21    109.470    3.000
 UMQ      "C4'"  "C5'"  "H5'1"  108.340    3.000
 UMQ      "C4'"  "C5'"  "C6'"   111.000    3.000
 UMQ      "C4'"  "C5'"  "O5'"   109.470    3.000
 UMQ      "H5'1" "C5'"  "C6'"   108.340    3.000
 UMQ      "H5'1" "C5'"  "O5'"   109.470    3.000
 UMQ      "C6'"  "C5'"  "O5'"   109.470    3.000
 UMQ      "C5'"  "C6'"  "H6'1"  109.470    3.000
 UMQ      "C5'"  "C6'"  "H6'2"  109.470    3.000
 UMQ      "C5'"  "C6'"  "O6'"   109.470    3.000
 UMQ      "H6'1" "C6'"  "H6'2"  107.900    3.000
 UMQ      "H6'1" "C6'"  "O6'"   109.470    3.000
 UMQ      "H6'2" "C6'"  "O6'"   109.470    3.000
 UMQ      "C6'"  "O6'"  "HO6'"  109.470    3.000
 UMQ      "C5'"  "O5'"  "C1'"   111.800    3.000
 UMQ      "O5'"  "C1'"  "H1'1"  109.470    3.000
 UMQ      "O5'"  "C1'"  "O1'"   109.470    3.000
 UMQ      "O5'"  "C1'"  "C2'"   109.470    3.000
 UMQ      "H1'1" "C1'"  "O1'"   109.470    3.000
 UMQ      "H1'1" "C1'"  "C2'"   108.340    3.000
 UMQ      "O1'"  "C1'"  "C2'"   109.470    3.000
 UMQ      "C1'"  "O1'"  CA      111.800    3.000
 UMQ      "O1'"  CA     HA1     109.470    3.000
 UMQ      "O1'"  CA     HA2     109.470    3.000
 UMQ      "O1'"  CA     CB      109.470    3.000
 UMQ      HA1    CA     HA2     107.900    3.000
 UMQ      HA1    CA     CB      109.470    3.000
 UMQ      HA2    CA     CB      109.470    3.000
 UMQ      CA     CB     HB1     109.470    3.000
 UMQ      CA     CB     HB2     109.470    3.000
 UMQ      CA     CB     CC      111.000    3.000
 UMQ      HB1    CB     HB2     107.900    3.000
 UMQ      HB1    CB     CC      109.470    3.000
 UMQ      HB2    CB     CC      109.470    3.000
 UMQ      CB     CC     HC1     109.470    3.000
 UMQ      CB     CC     HC2     109.470    3.000
 UMQ      CB     CC     CD      111.000    3.000
 UMQ      HC1    CC     HC2     107.900    3.000
 UMQ      HC1    CC     CD      109.470    3.000
 UMQ      HC2    CC     CD      109.470    3.000
 UMQ      CC     CD     HD1     109.470    3.000
 UMQ      CC     CD     HD2     109.470    3.000
 UMQ      CC     CD     CF      111.000    3.000
 UMQ      HD1    CD     HD2     107.900    3.000
 UMQ      HD1    CD     CF      109.470    3.000
 UMQ      HD2    CD     CF      109.470    3.000
 UMQ      CD     CF     HF1     109.470    3.000
 UMQ      CD     CF     HF2     109.470    3.000
 UMQ      CD     CF     CG      111.000    3.000
 UMQ      HF1    CF     HF2     107.900    3.000
 UMQ      HF1    CF     CG      109.470    3.000
 UMQ      HF2    CF     CG      109.470    3.000
 UMQ      CF     CG     HG1     109.470    3.000
 UMQ      CF     CG     HG2     109.470    3.000
 UMQ      CF     CG     CH      111.000    3.000
 UMQ      HG1    CG     HG2     107.900    3.000
 UMQ      HG1    CG     CH      109.470    3.000
 UMQ      HG2    CG     CH      109.470    3.000
 UMQ      CG     CH     HH1     109.470    3.000
 UMQ      CG     CH     HH2     109.470    3.000
 UMQ      CG     CH     CI      111.000    3.000
 UMQ      HH1    CH     HH2     107.900    3.000
 UMQ      HH1    CH     CI      109.470    3.000
 UMQ      HH2    CH     CI      109.470    3.000
 UMQ      CH     CI     HI1     109.470    3.000
 UMQ      CH     CI     HI2     109.470    3.000
 UMQ      CH     CI     CJ      111.000    3.000
 UMQ      HI1    CI     HI2     107.900    3.000
 UMQ      HI1    CI     CJ      109.470    3.000
 UMQ      HI2    CI     CJ      109.470    3.000
 UMQ      CI     CJ     HJ1     109.470    3.000
 UMQ      CI     CJ     HJ2     109.470    3.000
 UMQ      CI     CJ     CK      111.000    3.000
 UMQ      HJ1    CJ     HJ2     107.900    3.000
 UMQ      HJ1    CJ     CK      109.470    3.000
 UMQ      HJ2    CJ     CK      109.470    3.000
 UMQ      CJ     CK     HK1     109.470    3.000
 UMQ      CJ     CK     HK2     109.470    3.000
 UMQ      CJ     CK     CL      111.000    3.000
 UMQ      HK1    CK     HK2     107.900    3.000
 UMQ      HK1    CK     CL      109.470    3.000
 UMQ      HK2    CK     CL      109.470    3.000
 UMQ      CK     CL     HL3     109.470    3.000
 UMQ      CK     CL     HL2     109.470    3.000
 UMQ      CK     CL     HL1     109.470    3.000
 UMQ      HL3    CL     HL2     109.470    3.000
 UMQ      HL3    CL     HL1     109.470    3.000
 UMQ      HL2    CL     HL1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 UMQ      var_1    "HO2'" "O2'"  "C2'"  "C3'"   -179.973   20.000   1
 UMQ      var_2    "O2'"  "C2'"  "C3'"  "C4'"    180.000   20.000   3
 UMQ      var_3    "C2'"  "C3'"  "O3'"  "HO3'"   -60.805   20.000   1
 UMQ      var_4    "C2'"  "C3'"  "C4'"  "C5'"     60.000   20.000   3
 UMQ      var_5    "C3'"  "C4'"  O1     C1        85.475   20.000   1
 UMQ      var_6    "C4'"  O1     C1     O5        74.894   20.000   1
 UMQ      var_7    O1     C1     O5     C5        60.000   20.000   1
 UMQ      var_8    C1     O5     C5     C4        60.000   20.000   1
 UMQ      var_9    O5     C5     C6     O6        59.959   20.000   3
 UMQ      var_10   C5     C6     O6     HO61     179.978   20.000   1
 UMQ      var_11   O5     C5     C4     C3       -60.000   20.000   3
 UMQ      var_12   C5     C4     O4     HO41    -179.987   20.000   1
 UMQ      var_13   C5     C4     C3     C2        60.000   20.000   3
 UMQ      var_14   C4     C3     O3     HO31     179.966   20.000   1
 UMQ      var_15   C4     C3     C2     O2       180.000   20.000   3
 UMQ      var_16   C3     C2     C1     O1       -60.000   20.000   3
 UMQ      var_17   C3     C2     O2     HO21     179.979   20.000   1
 UMQ      var_18   "C3'"  "C4'"  "C5'"  "O5'"    -60.000   20.000   3
 UMQ      var_19   "C4'"  "C5'"  "C6'"  "O6'"   -176.202   20.000   3
 UMQ      var_20   "C5'"  "C6'"  "O6'"  "HO6'"   179.944   20.000   1
 UMQ      var_21   "C4'"  "C5'"  "O5'"  "C1'"     60.000   20.000   1
 UMQ      var_22   "C5'"  "O5'"  "C1'"  "O1'"    180.000   20.000   1
 UMQ      var_23   "O5'"  "C1'"  "C2'"  "O2'"    180.000   20.000   3
 UMQ      var_24   "O5'"  "C1'"  "O1'"  CA       -59.843   20.000   1
 UMQ      var_25   "C1'"  "O1'"  CA     CB       179.991   20.000   1
 UMQ      var_26   "O1'"  CA     CB     CC      -179.979   20.000   3
 UMQ      var_27   CA     CB     CC     CD      -179.969   20.000   3
 UMQ      var_28   CB     CC     CD     CF       179.974   20.000   3
 UMQ      var_29   CC     CD     CF     CG       179.972   20.000   3
 UMQ      var_30   CD     CF     CG     CH       179.995   20.000   3
 UMQ      var_31   CF     CG     CH     CI      -179.977   20.000   3
 UMQ      var_32   CG     CH     CI     CJ      -179.969   20.000   3
 UMQ      var_33   CH     CI     CJ     CK       180.000   20.000   3
 UMQ      var_34   CI     CJ     CK     CL       179.995   20.000   3
 UMQ      var_35   CJ     CK     CL     HL1      179.945   20.000   3
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 UMQ      chir_01  C2     O2     C1     C3        negativ
 UMQ      chir_02  C4     C5     O4     C3        negativ
 UMQ      chir_03  C5     C4     C6     O5        negativ
 UMQ      chir_04  C1     C2     O1     O5        negativ
 UMQ      chir_05  C3     C2     C4     O3        positiv
 UMQ      chir_06  "C1'"  "C2'"  "O1'"  "O5'"     positiv
 UMQ      chir_07  "C2'"  "C1'"  "C3'"  "O2'"     negativ
 UMQ      chir_08  "C3'"  "C2'"  "C4'"  "O3'"     positiv
 UMQ      chir_09  "C4'"  O1     "C3'"  "C5'"     negativ
 UMQ      chir_10  "C5'"  "C4'"  "C6'"  "O5'"     negativ
# ------------------------------------------------------
`.trim();

monomers["URE"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
URE      URE 'UREA                                ' non-polymer         8   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_URE
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 URE           O      O    O         0.000      0.733   -1.463    0.486
 URE           C      C    C         0.000      0.209   -0.417    0.138
 URE           N2     N    NH2       0.000     -1.117   -0.281    0.155
 URE           HN22   H    H         0.000     -1.546    0.587   -0.134
 URE           HN21   H    H         0.000     -1.698   -1.052    0.458
 URE           N1     N    NH2       0.000      0.951    0.615   -0.266
 URE           HN12   H    H         0.000      0.511    1.478   -0.552
 URE           HN11   H    H         0.000      1.957    0.533   -0.285
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 URE      O      n/a    C      START
 URE      C      O      N1     .
 URE      N2     C      HN21   .
 URE      HN22   N2     .      .
 URE      HN21   N2     .      .
 URE      N1     C      HN11   .
 URE      HN12   N1     .      .
 URE      HN11   N1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 URE      C      O         double      1.220    0.020
 URE      N1     C         single      1.332    0.020
 URE      N2     C         single      1.332    0.020
 URE      HN11   N1        single      1.010    0.020
 URE      HN12   N1        single      1.010    0.020
 URE      HN21   N2        single      1.010    0.020
 URE      HN22   N2        single      1.010    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 URE      O      C      N2      123.000    3.000
 URE      O      C      N1      123.000    3.000
 URE      N2     C      N1      120.000    3.000
 URE      C      N2     HN22    120.000    3.000
 URE      C      N2     HN21    120.000    3.000
 URE      HN22   N2     HN21    120.000    3.000
 URE      C      N1     HN12    120.000    3.000
 URE      C      N1     HN11    120.000    3.000
 URE      HN12   N1     HN11    120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 URE      CONST_1  O      C      N2     HN21       0.000    0.000   0
 URE      CONST_2  O      C      N1     HN11       0.000    0.000   0
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 URE      plan-1    C         0.020
 URE      plan-1    O         0.020
 URE      plan-1    N1        0.020
 URE      plan-1    N2        0.020
 URE      plan-1    HN12      0.020
 URE      plan-1    HN11      0.020
 URE      plan-1    HN22      0.020
 URE      plan-1    HN21      0.020
 URE      plan-2    N1        0.020
 URE      plan-2    C         0.020
 URE      plan-2    HN11      0.020
 URE      plan-2    HN12      0.020
 URE      plan-3    N2        0.020
 URE      plan-3    C         0.020
 URE      plan-3    HN21      0.020
 URE      plan-3    HN22      0.020
# ------------------------------------------------------
`.trim();

monomers["EPE"] = `
# Created using JLigand 1.0.37
# and
# dictionary  5.41    ( 11/02/2013 )
# libcheck    5.2.0   ( 12/12/2011 )
# refmac      5.8.46  ( 12/06/2013 )
#
# Authors: Andrey Lebedev, Paul Young, Alexei Vagin, Garib Murshudov
# E-mail: andrey.lebedev@stfc.ac.uk
#

global_
_lib_name         mon_lib
_lib_version      5.41
_lib_update       11/02/2013

data_comp_list

loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
EPE      EPE '4-(2-HYDROXYETHYL)-1-PIPERAZINE ETHA' .                  32  15 .

data_comp_EPE

loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 EPE           O2S    O    OS       -0.330      4.485   -2.530   -1.054
 EPE           S      S    ST        0.000      3.595   -2.996    0.033
 EPE           O1S    O    OS       -0.330      2.661   -4.016   -0.495
 EPE           O3S    O    OS       -0.330      4.411   -3.588    1.116
 EPE           C10    C    CH2       0.000      2.732   -1.708    0.633
 EPE           H101   H    H         0.000      3.413   -0.882    0.849
 EPE           H102   H    H         0.000      2.249   -1.998    1.569
 EPE           C9     C    CH2       0.000      1.671   -1.251   -0.368
 EPE           H91    H    H         0.000      0.736   -1.784   -0.184
 EPE           H92    H    H         0.000      2.000   -1.492   -1.382
 EPE           N1     N    NT        0.000      1.457    0.206   -0.244
 EPE           C6     C    CH2       0.000      0.759    0.541    1.019
 EPE           H61    H    H         0.000      0.513   -0.368    1.573
 EPE           H62    H    H         0.000      1.431    1.131    1.646
 EPE           C5     C    CH2       0.000     -0.525    1.333    0.793
 EPE           H51    H    H         0.000     -1.038    1.444    1.750
 EPE           H52    H    H         0.000     -0.294    2.336    0.428
 EPE           N4     N    NT        0.000     -1.403    0.626   -0.158
 EPE           C3     C    CH2       0.000     -0.722    0.357   -1.445
 EPE           H31    H    H         0.000     -0.813   -0.706   -1.678
 EPE           H32    H    H         0.000     -1.211    0.909   -2.251
 EPE           C2     C    CH2       0.000      0.758    0.738   -1.430
 EPE           H22    H    H         0.000      0.860    1.826   -1.461
 EPE           H21    H    H         0.000      1.231    0.351   -2.334
 EPE           C7     C    CH2       0.000     -2.644    1.394   -0.382
 EPE           H71    H    H         0.000     -3.170    1.004   -1.257
 EPE           H72    H    H         0.000     -2.402    2.441   -0.576
 EPE           C8     C    CH2       0.000     -3.567    1.295    0.828
 EPE           H81    H    H         0.000     -3.324    2.085    1.542
 EPE           H82    H    H         0.000     -3.424    0.333    1.324
 EPE           O8     O    OH1       0.000     -4.930    1.426    0.409
 EPE           HO8    H    H         0.000     -5.496    1.542    1.185

loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 EPE      O2S    S         deloc       1.480    0.020
 EPE      S      O1S       deloc       1.480    0.020
 EPE      S      O3S       deloc       1.480    0.020
 EPE      S      C10       single      1.662    0.020
 EPE      C10    H101      single      1.092    0.020
 EPE      C10    H102      single      1.092    0.020
 EPE      C10    C9        single      1.524    0.020
 EPE      C9     H91       single      1.092    0.020
 EPE      C9     H92       single      1.092    0.020
 EPE      C9     N1        single      1.469    0.020
 EPE      N1     C6        single      1.469    0.020
 EPE      N1     C2        single      1.469    0.020
 EPE      C6     H61       single      1.092    0.020
 EPE      C6     H62       single      1.092    0.020
 EPE      C6     C5        single      1.524    0.020
 EPE      C5     H51       single      1.092    0.020
 EPE      C5     H52       single      1.092    0.020
 EPE      C5     N4        single      1.469    0.020
 EPE      N4     C3        single      1.469    0.020
 EPE      N4     C7        single      1.469    0.020
 EPE      C3     H31       single      1.092    0.020
 EPE      C3     H32       single      1.092    0.020
 EPE      C3     C2        single      1.524    0.020
 EPE      C2     H22       single      1.092    0.020
 EPE      C2     H21       single      1.092    0.020
 EPE      C7     H71       single      1.092    0.020
 EPE      C7     H72       single      1.092    0.020
 EPE      C7     C8        single      1.524    0.020
 EPE      C8     H81       single      1.092    0.020
 EPE      C8     H82       single      1.092    0.020
 EPE      C8     O8        single      1.432    0.020
 EPE      O8     HO8       single      0.967    0.020

loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 EPE      O2S    S      O1S     109.500    3.000
 EPE      O2S    S      O3S     109.500    3.000
 EPE      O2S    S      C10     109.500    3.000
 EPE      S      C10    H101    109.500    3.000
 EPE      S      C10    H102    109.500    3.000
 EPE      S      C10    C9      109.500    3.000
 EPE      O1S    S      O3S     109.500    3.000
 EPE      O1S    S      C10     109.500    3.000
 EPE      O3S    S      C10     109.500    3.000
 EPE      C10    C9     H91     109.470    3.000
 EPE      C10    C9     H92     109.470    3.000
 EPE      C10    C9     N1      109.470    3.000
 EPE      H101   C10    H102    107.900    3.000
 EPE      H101   C10    C9      109.470    3.000
 EPE      H102   C10    C9      109.470    3.000
 EPE      C9     N1     C6      109.470    3.000
 EPE      C9     N1     C2      109.470    3.000
 EPE      H91    C9     H92     107.900    3.000
 EPE      H91    C9     N1      109.470    3.000
 EPE      H92    C9     N1      109.470    3.000
 EPE      N1     C6     H61     109.470    3.000
 EPE      N1     C6     H62     109.470    3.000
 EPE      N1     C6     C5      109.470    3.000
 EPE      N1     C2     C3      109.470    3.000
 EPE      N1     C2     H22     109.470    3.000
 EPE      N1     C2     H21     109.470    3.000
 EPE      C6     N1     C2      109.470    3.000
 EPE      C6     C5     H51     109.470    3.000
 EPE      C6     C5     H52     109.470    3.000
 EPE      C6     C5     N4      109.470    3.000
 EPE      H61    C6     H62     107.900    3.000
 EPE      H61    C6     C5      109.470    3.000
 EPE      H62    C6     C5      109.470    3.000
 EPE      C5     N4     C3      109.470    3.000
 EPE      C5     N4     C7      109.470    3.000
 EPE      H51    C5     H52     107.900    3.000
 EPE      H51    C5     N4      109.470    3.000
 EPE      H52    C5     N4      109.470    3.000
 EPE      N4     C3     H31     109.470    3.000
 EPE      N4     C3     H32     109.470    3.000
 EPE      N4     C3     C2      109.470    3.000
 EPE      N4     C7     H71     109.470    3.000
 EPE      N4     C7     H72     109.470    3.000
 EPE      N4     C7     C8      109.470    3.000
 EPE      C3     N4     C7      109.470    3.000
 EPE      C3     C2     H22     109.470    3.000
 EPE      C3     C2     H21     109.470    3.000
 EPE      H31    C3     H32     107.900    3.000
 EPE      H31    C3     C2      109.470    3.000
 EPE      H32    C3     C2      109.470    3.000
 EPE      H22    C2     H21     107.900    3.000
 EPE      C7     C8     H81     109.470    3.000
 EPE      C7     C8     H82     109.470    3.000
 EPE      C7     C8     O8      109.470    3.000
 EPE      H71    C7     H72     107.900    3.000
 EPE      H71    C7     C8      109.470    3.000
 EPE      H72    C7     C8      109.470    3.000
 EPE      C8     O8     HO8     109.470    3.000
 EPE      H81    C8     H82     107.900    3.000
 EPE      H81    C8     O8      109.470    3.000
 EPE      H82    C8     O8      109.470    3.000

loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 EPE      var_2    S      C10    C9     N1       180.000   20.000   3
 EPE      var_1    O3S    S      C10    C9       177.641   20.000   3
 EPE      var_3    C10    C9     N1     C2       165.600   20.000   3
 EPE      var_4    C9     N1     C6     C5      -177.876   20.000   3
 EPE      var_5    C9     N1     C2     C3       124.266   20.000   3
 EPE      var_9    N1     C6     C5     N4       180.000   20.000   3
 EPE      var_6    N1     C2     C3     N4       180.000   20.000   3
 EPE      var_8    C6     C5     N4     C3       -53.602   20.000   3
 EPE      var_11   N4     C7     C8     O8       180.000   20.000   3
 EPE      var_10   C3     N4     C7     C8       173.631   20.000   3
 EPE      var_7    C2     C3     N4     C7       179.466   20.000   3
 EPE      var_12   C7     C8     O8     HO8      175.173   20.000   3

loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 EPE      chir_01  S      O2S    O1S    O3S       negativ
 EPE      chir_02  N1     C9     C6     C2        positiv
 EPE      chir_03  N4     C5     C3     C7        positiv
`.trim();

monomers["MES"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
MES      MES '2-(N-MORPHOLINO)-ETHANESULFONIC ACID' non-polymer        25  12 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_MES
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 MES           O3S    O    OS       -1.000      0.000    0.000    0.000
 MES           S      S    ST        0.000     -1.306   -0.521    0.374
 MES           O1S    O    OS        0.000     -1.381   -1.935    0.041
 MES           O2S    O    OS        0.000     -1.512   -0.343    1.803
 MES           C8     C    CH2       0.000     -2.592    0.378   -0.535
 MES           H81    H    H         0.000     -2.439    0.246   -1.608
 MES           H82    H    H         0.000     -2.537    1.440   -0.288
 MES           C7     C    CH2       0.000     -3.968   -0.167   -0.144
 MES           H71    H    H         0.000     -4.119   -0.036    0.929
 MES           H72    H    H         0.000     -4.022   -1.229   -0.391
 MES           N4     N    NT1       1.000     -5.011    0.561   -0.880
 MES           HN4    H    H         0.000     -4.820    0.507   -1.893
 MES           C3     C    CH2       0.000     -6.322   -0.037   -0.594
 MES           H31    H    H         0.000     -6.498   -0.033    0.483
 MES           H32    H    H         0.000     -6.342   -1.065   -0.961
 MES           C2     C    CH2       0.000     -7.412    0.777   -1.294
 MES           H22    H    H         0.000     -8.384    0.317   -1.104
 MES           H21    H    H         0.000     -7.220    0.788   -2.369
 MES           C5     C    CH2       0.000     -5.020    1.969   -0.455
 MES           H51    H    H         0.000     -4.069    2.436   -0.720
 MES           H52    H    H         0.000     -5.162    2.024    0.626
 MES           C6     C    CH2       0.000     -6.163    2.702   -1.160
 MES           H62    H    H         0.000     -6.026    2.628   -2.240
 MES           H61    H    H         0.000     -6.153    3.753   -0.864
 MES           O1     O    O2        0.000     -7.411    2.114   -0.795
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 MES      O3S    n/a    S      START
 MES      S      O3S    C8     .
 MES      O1S    S      .      .
 MES      O2S    S      .      .
 MES      C8     S      C7     .
 MES      H81    C8     .      .
 MES      H82    C8     .      .
 MES      C7     C8     N4     .
 MES      H71    C7     .      .
 MES      H72    C7     .      .
 MES      N4     C7     C5     .
 MES      HN4    N4     .      .
 MES      C3     N4     C2     .
 MES      H31    C3     .      .
 MES      H32    C3     .      .
 MES      C2     C3     H21    .
 MES      H22    C2     .      .
 MES      H21    C2     .      .
 MES      C5     N4     C6     .
 MES      H51    C5     .      .
 MES      H52    C5     .      .
 MES      C6     C5     O1     .
 MES      H62    C6     .      .
 MES      H61    C6     .      .
 MES      O1     C6     .      END
 MES      O1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 MES      O1     C2        single      1.426    0.020
 MES      O1     C6        single      1.426    0.020
 MES      C2     C3        single      1.524    0.020
 MES      H21    C2        single      1.092    0.020
 MES      H22    C2        single      1.092    0.020
 MES      C3     N4        single      1.472    0.020
 MES      H31    C3        single      1.092    0.020
 MES      H32    C3        single      1.092    0.020
 MES      C5     N4        single      1.472    0.020
 MES      N4     C7        single      1.472    0.020
 MES      HN4    N4        single      1.033    0.020
 MES      C6     C5        single      1.524    0.020
 MES      H51    C5        single      1.092    0.020
 MES      H52    C5        single      1.092    0.020
 MES      H61    C6        single      1.092    0.020
 MES      H62    C6        single      1.092    0.020
 MES      C7     C8        single      1.524    0.020
 MES      H71    C7        single      1.092    0.020
 MES      H72    C7        single      1.092    0.020
 MES      C8     S         single      1.662    0.020
 MES      H81    C8        single      1.092    0.020
 MES      H82    C8        single      1.092    0.020
 MES      O1S    S         deloc       1.480    0.020
 MES      O2S    S         deloc       1.480    0.020
 MES      S      O3S       deloc       1.480    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 MES      O3S    S      O1S     109.500    3.000
 MES      O3S    S      O2S     109.500    3.000
 MES      O3S    S      C8      109.500    3.000
 MES      O1S    S      O2S     109.500    3.000
 MES      O1S    S      C8      109.500    3.000
 MES      O2S    S      C8      109.500    3.000
 MES      S      C8     H81     109.500    3.000
 MES      S      C8     H82     109.500    3.000
 MES      S      C8     C7      109.500    3.000
 MES      H81    C8     H82     107.900    3.000
 MES      H81    C8     C7      109.470    3.000
 MES      H82    C8     C7      109.470    3.000
 MES      C8     C7     H71     109.470    3.000
 MES      C8     C7     H72     109.470    3.000
 MES      C8     C7     N4      109.500    3.000
 MES      H71    C7     H72     107.900    3.000
 MES      H71    C7     N4      109.500    3.000
 MES      H72    C7     N4      109.500    3.000
 MES      C7     N4     HN4     109.500    3.000
 MES      C7     N4     C3      109.500    3.000
 MES      C7     N4     C5      109.500    3.000
 MES      HN4    N4     C3      109.500    3.000
 MES      HN4    N4     C5      109.500    3.000
 MES      C3     N4     C5      109.500    3.000
 MES      N4     C3     H31     109.500    3.000
 MES      N4     C3     H32     109.500    3.000
 MES      N4     C3     C2      109.500    3.000
 MES      H31    C3     H32     107.900    3.000
 MES      H31    C3     C2      109.470    3.000
 MES      H32    C3     C2      109.470    3.000
 MES      C3     C2     H22     109.470    3.000
 MES      C3     C2     H21     109.470    3.000
 MES      C3     C2     O1      109.470    3.000
 MES      H22    C2     H21     107.900    3.000
 MES      H22    C2     O1      109.470    3.000
 MES      H21    C2     O1      109.470    3.000
 MES      N4     C5     H51     109.500    3.000
 MES      N4     C5     H52     109.500    3.000
 MES      N4     C5     C6      109.500    3.000
 MES      H51    C5     H52     107.900    3.000
 MES      H51    C5     C6      109.470    3.000
 MES      H52    C5     C6      109.470    3.000
 MES      C5     C6     H62     109.470    3.000
 MES      C5     C6     H61     109.470    3.000
 MES      C5     C6     O1      109.470    3.000
 MES      H62    C6     H61     107.900    3.000
 MES      H62    C6     O1      109.470    3.000
 MES      H61    C6     O1      109.470    3.000
 MES      C6     O1     C2      111.800    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 MES      var_1    O3S    S      C8     C7      -179.985   20.000   1
 MES      var_2    S      C8     C7     N4       179.982   20.000   3
 MES      var_3    C8     C7     N4     C5       -65.146   20.000   1
 MES      var_4    C7     N4     C3     C2       180.000   20.000   1
 MES      var_5    N4     C3     C2     O1       -60.000   20.000   3
 MES      var_6    C7     N4     C5     C6       180.000   20.000   1
 MES      var_7    N4     C5     C6     O1        60.000   20.000   3
 MES      var_8    C5     C6     O1     C2       -60.000   20.000   1
 MES      var_9    C6     O1     C2     C3        60.000   20.000   1
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 MES      chir_01  N4     C3     C5     C7        negativ
 MES      chir_02  S      C8     O1S    O2S       positiv
# ------------------------------------------------------
`.trim();

monomers["PEG"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PEG      PEG 'DI(HYDROXYETHYL)ETHER               ' non-polymer        17   7 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PEG
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PEG           O4     O    OH1       0.000      0.000    0.000    0.000
 PEG           HO4    H    H         0.000      0.811   -0.431    0.303
 PEG           C4     C    CH2       0.000     -0.653    0.621    1.110
 PEG           H41    H    H         0.000      0.012    1.365    1.553
 PEG           H42    H    H         0.000     -0.898   -0.137    1.857
 PEG           C3     C    CH2       0.000     -1.936    1.302    0.631
 PEG           H31    H    H         0.000     -1.699    1.996   -0.178
 PEG           H32    H    H         0.000     -2.387    1.851    1.460
 PEG           O2     O    O2        0.000     -2.853    0.314    0.159
 PEG           C2     C    CH2       0.000     -4.091    0.847   -0.314
 PEG           H21    H    H         0.000     -3.898    1.533   -1.142
 PEG           H22    H    H         0.000     -4.586    1.387    0.496
 PEG           C1     C    CH2       0.000     -4.989   -0.295   -0.793
 PEG           H11    H    H         0.000     -4.457   -0.886   -1.541
 PEG           H12    H    H         0.000     -5.897    0.119   -1.237
 PEG           O1     O    OH1       0.000     -5.336   -1.126    0.316
 PEG           HO1    H    H         0.000     -5.903   -1.848    0.013
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PEG      O4     n/a    C4     START
 PEG      HO4    O4     .      .
 PEG      C4     O4     C3     .
 PEG      H41    C4     .      .
 PEG      H42    C4     .      .
 PEG      C3     C4     O2     .
 PEG      H31    C3     .      .
 PEG      H32    C3     .      .
 PEG      O2     C3     C2     .
 PEG      C2     O2     C1     .
 PEG      H21    C2     .      .
 PEG      H22    C2     .      .
 PEG      C1     C2     O1     .
 PEG      H11    C1     .      .
 PEG      H12    C1     .      .
 PEG      O1     C1     HO1    .
 PEG      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PEG      O1     C1        single      1.432    0.020
 PEG      C1     C2        single      1.524    0.020
 PEG      H11    C1        single      1.092    0.020
 PEG      H12    C1        single      1.092    0.020
 PEG      HO1    O1        single      0.967    0.020
 PEG      C2     O2        single      1.426    0.020
 PEG      H21    C2        single      1.092    0.020
 PEG      H22    C2        single      1.092    0.020
 PEG      O2     C3        single      1.426    0.020
 PEG      C3     C4        single      1.524    0.020
 PEG      H31    C3        single      1.092    0.020
 PEG      H32    C3        single      1.092    0.020
 PEG      C4     O4        single      1.432    0.020
 PEG      H41    C4        single      1.092    0.020
 PEG      H42    C4        single      1.092    0.020
 PEG      HO4    O4        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PEG      HO4    O4     C4      109.470    3.000
 PEG      O4     C4     H41     109.470    3.000
 PEG      O4     C4     H42     109.470    3.000
 PEG      O4     C4     C3      109.470    3.000
 PEG      H41    C4     H42     107.900    3.000
 PEG      H41    C4     C3      109.470    3.000
 PEG      H42    C4     C3      109.470    3.000
 PEG      C4     C3     H31     109.470    3.000
 PEG      C4     C3     H32     109.470    3.000
 PEG      C4     C3     O2      109.470    3.000
 PEG      H31    C3     H32     107.900    3.000
 PEG      H31    C3     O2      109.470    3.000
 PEG      H32    C3     O2      109.470    3.000
 PEG      C3     O2     C2      111.800    3.000
 PEG      O2     C2     H21     109.470    3.000
 PEG      O2     C2     H22     109.470    3.000
 PEG      O2     C2     C1      109.470    3.000
 PEG      H21    C2     H22     107.900    3.000
 PEG      H21    C2     C1      109.470    3.000
 PEG      H22    C2     C1      109.470    3.000
 PEG      C2     C1     H11     109.470    3.000
 PEG      C2     C1     H12     109.470    3.000
 PEG      C2     C1     O1      109.470    3.000
 PEG      H11    C1     H12     107.900    3.000
 PEG      H11    C1     O1      109.470    3.000
 PEG      H12    C1     O1      109.470    3.000
 PEG      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 PEG      var_1    HO4    O4     C4     C3      -179.967   20.000   1
 PEG      var_2    O4     C4     C3     O2        65.009   20.000   3
 PEG      var_3    C4     C3     O2     C2       179.991   20.000   1
 PEG      var_4    C3     O2     C2     C1       179.991   20.000   1
 PEG      var_5    O2     C2     C1     O1        64.997   20.000   3
 PEG      var_6    C2     C1     O1     HO1     -179.968   20.000   1
# ------------------------------------------------------
`.trim();

monomers["ETA"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
ETA      ETA 'ETHANOLAMINE                        ' non-polymer        11   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_ETA
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 ETA           O      O    OH1       0.000      0.000    0.000    0.000
 ETA           HO     H    H         0.000      0.830    0.164    0.467
 ETA           CB     C    CH2       0.000     -0.991    0.924    0.454
 ETA           HB1    H    H         0.000     -0.656    1.944    0.255
 ETA           HB2    H    H         0.000     -1.144    0.796    1.527
 ETA           CA     C    CH2       0.000     -2.306    0.665   -0.285
 ETA           HA1    H    H         0.000     -2.132    0.707   -1.362
 ETA           HA2    H    H         0.000     -3.037    1.427   -0.006
 ETA           N      N    NH2       0.000     -2.818   -0.663    0.078
 ETA           HN2    H    H         0.000     -3.013   -1.350   -0.641
 ETA           HN1    H    H         0.000     -2.979   -0.901    1.050
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 ETA      O      n/a    CB     START
 ETA      HO     O      .      .
 ETA      CB     O      CA     .
 ETA      HB1    CB     .      .
 ETA      HB2    CB     .      .
 ETA      CA     CB     N      .
 ETA      HA1    CA     .      .
 ETA      HA2    CA     .      .
 ETA      N      CA     HN1    .
 ETA      HN2    N      .      .
 ETA      HN1    N      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 ETA      N      CA        single      1.450    0.020
 ETA      CA     CB        single      1.524    0.020
 ETA      HA1    CA        single      1.092    0.020
 ETA      HA2    CA        single      1.092    0.020
 ETA      HN1    N         single      1.010    0.020
 ETA      HN2    N         single      1.010    0.020
 ETA      CB     O         single      1.432    0.020
 ETA      HB1    CB        single      1.092    0.020
 ETA      HB2    CB        single      1.092    0.020
 ETA      HO     O         single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 ETA      HO     O      CB      109.470    3.000
 ETA      O      CB     HB1     109.470    3.000
 ETA      O      CB     HB2     109.470    3.000
 ETA      O      CB     CA      109.470    3.000
 ETA      HB1    CB     HB2     107.900    3.000
 ETA      HB1    CB     CA      109.470    3.000
 ETA      HB2    CB     CA      109.470    3.000
 ETA      CB     CA     HA1     109.470    3.000
 ETA      CB     CA     HA2     109.470    3.000
 ETA      CB     CA     N       109.470    3.000
 ETA      HA1    CA     HA2     107.900    3.000
 ETA      HA1    CA     N       109.470    3.000
 ETA      HA2    CA     N       109.470    3.000
 ETA      CA     N      HN2     120.000    3.000
 ETA      CA     N      HN1     120.000    3.000
 ETA      HN2    N      HN1     120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 ETA      var_1    HO     O      CB     CA      -179.972   20.000   1
 ETA      var_2    O      CB     CA     N         65.017   20.000   3
 ETA      var_3    CB     CA     N      HN1       56.012   20.000   1
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 ETA      plan-1    N         0.020
 ETA      plan-1    CA        0.000
 ETA      plan-1    HN1       0.000
 ETA      plan-1    HN2       0.000
# ------------------------------------------------------
`.trim();

monomers["HED"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
HED      HED '2-HYDROXYETHYL DISULFIDE            ' non-polymer        18   8 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_HED
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 HED           O6     O    OH1       0.000      0.000    0.000    0.000
 HED           HO6    H    H         0.000      0.430    0.408   -0.764
 HED           C6     C    CH2       0.000     -1.214    0.697    0.291
 HED           H61    H    H         0.000     -1.878    0.647   -0.574
 HED           H62    H    H         0.000     -0.988    1.742    0.515
 HED           C5     C    CH2       0.000     -1.895    0.051    1.498
 HED           H51    H    H         0.000     -1.229    0.102    2.361
 HED           H52    H    H         0.000     -2.118   -0.994    1.272
 HED           S4     S    S2        0.000     -3.435    0.934    1.867
 HED           S3     S    S2        0.000     -4.437    0.659    0.100
 HED           C2     C    CH2       0.000     -5.303   -0.891    0.468
 HED           H21    H    H         0.000     -4.573   -1.672    0.690
 HED           H22    H    H         0.000     -5.899   -1.188   -0.398
 HED           C1     C    CH2       0.000     -6.219   -0.690    1.676
 HED           H11    H    H         0.000     -6.948    0.092    1.452
 HED           H12    H    H         0.000     -5.621   -0.392    2.539
 HED           O1     O    OH1       0.000     -6.902   -1.911    1.965
 HED           HO1    H    H         0.000     -7.480   -1.783    2.729
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 HED      O6     n/a    C6     START
 HED      HO6    O6     .      .
 HED      C6     O6     C5     .
 HED      H61    C6     .      .
 HED      H62    C6     .      .
 HED      C5     C6     S4     .
 HED      H51    C5     .      .
 HED      H52    C5     .      .
 HED      S4     C5     S3     .
 HED      S3     S4     C2     .
 HED      C2     S3     C1     .
 HED      H21    C2     .      .
 HED      H22    C2     .      .
 HED      C1     C2     O1     .
 HED      H11    C1     .      .
 HED      H12    C1     .      .
 HED      O1     C1     HO1    .
 HED      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 HED      O1     C1        single      1.432    0.020
 HED      C1     C2        single      1.524    0.020
 HED      H11    C1        single      1.092    0.020
 HED      H12    C1        single      1.092    0.020
 HED      HO1    O1        single      0.967    0.020
 HED      C2     S3        single      1.762    0.020
 HED      H21    C2        single      1.092    0.020
 HED      H22    C2        single      1.092    0.020
 HED      S3     S4        single      2.000    0.020
 HED      S4     C5        single      1.762    0.020
 HED      C5     C6        single      1.524    0.020
 HED      H51    C5        single      1.092    0.020
 HED      H52    C5        single      1.092    0.020
 HED      C6     O6        single      1.432    0.020
 HED      H61    C6        single      1.092    0.020
 HED      H62    C6        single      1.092    0.020
 HED      HO6    O6        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 HED      HO6    O6     C6      109.470    3.000
 HED      O6     C6     H61     109.470    3.000
 HED      O6     C6     H62     109.470    3.000
 HED      O6     C6     C5      109.470    3.000
 HED      H61    C6     H62     107.900    3.000
 HED      H61    C6     C5      109.470    3.000
 HED      H62    C6     C5      109.470    3.000
 HED      C6     C5     H51     109.470    3.000
 HED      C6     C5     H52     109.470    3.000
 HED      C6     C5     S4      109.500    3.000
 HED      H51    C5     H52     107.900    3.000
 HED      H51    C5     S4      109.500    3.000
 HED      H52    C5     S4      109.500    3.000
 HED      C5     S4     S3      100.015    3.000
 HED      S4     S3     C2       99.993    3.000
 HED      S3     C2     H21     109.500    3.000
 HED      S3     C2     H22     109.500    3.000
 HED      S3     C2     C1      109.500    3.000
 HED      H21    C2     H22     107.900    3.000
 HED      H21    C2     C1      109.470    3.000
 HED      H22    C2     C1      109.470    3.000
 HED      C2     C1     H11     109.470    3.000
 HED      C2     C1     H12     109.470    3.000
 HED      C2     C1     O1      109.470    3.000
 HED      H11    C1     H12     107.900    3.000
 HED      H11    C1     O1      109.470    3.000
 HED      H12    C1     O1      109.470    3.000
 HED      C1     O1     HO1     109.470    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 HED      var_1    HO6    O6     C6     C5       179.908   20.000   1
 HED      var_2    O6     C6     C5     S4      -179.971   20.000   3
 HED      var_3    C6     C5     S4     S3        60.023   20.000   1
 HED      var_4    C5     S4     S3     C2        90.033   20.000   1
 HED      var_5    S4     S3     C2     C1        60.034   20.000   1
 HED      var_6    S3     C2     C1     O1      -179.989   20.000   3
 HED      var_7    C2     C1     O1     HO1      179.947   20.000   1
# ------------------------------------------------------
`.trim();

monomers["IMD"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
IMD      IMD 'IMIDAZOLE                           ' non-polymer        10   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_IMD
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 IMD           H5     H    H         0.000      0.003    0.001    0.001
 IMD           C5     C    CR15      0.000     -1.041   -0.289    0.000
 IMD           N1     N    NR15      0.000     -1.520   -1.550   -0.004
 IMD           HN1    H    H         0.000     -0.949   -2.419   -0.010
 IMD           C4     C    CR15      0.000     -2.101    0.543    0.001
 IMD           H4     H    H         0.000     -2.067    1.626    0.003
 IMD           N3     N    NR15      1.000     -3.212   -0.221   -0.002
 IMD           HN3    H    H         0.000     -4.192    0.128   -0.006
 IMD           C2     C    CR15      0.000     -2.842   -1.491    0.002
 IMD           H2     H    H         0.000     -3.511   -2.343    0.009
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 IMD      H5     n/a    C5     START
 IMD      C5     H5     C4     .
 IMD      N1     C5     HN1    .
 IMD      HN1    N1     .      .
 IMD      C4     C5     N3     .
 IMD      H4     C4     .      .
 IMD      N3     C4     C2     .
 IMD      HN3    N3     .      .
 IMD      C2     N3     H2     .
 IMD      H2     C2     .      END
 IMD      N1     C2     .    ADD
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 IMD      N1     C2        single      1.350    0.020
 IMD      N1     C5        single      1.350    0.020
 IMD      HN1    N1        single      1.040    0.020
 IMD      C2     N3        double      1.350    0.020
 IMD      H2     C2        single      1.083    0.020
 IMD      N3     C4        single      1.350    0.020
 IMD      HN3    N3        single      1.040    0.020
 IMD      C4     C5        double      1.380    0.020
 IMD      H4     C4        single      1.083    0.020
 IMD      C5     H5        single      1.083    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 IMD      H5     C5     N1      126.000    3.000
 IMD      H5     C5     C4      126.000    3.000
 IMD      N1     C5     C4      108.000    3.000
 IMD      C5     N1     HN1     126.000    3.000
 IMD      C5     N1     C2      108.000    3.000
 IMD      HN1    N1     C2      126.000    3.000
 IMD      C5     C4     H4      126.000    3.000
 IMD      C5     C4     N3      108.000    3.000
 IMD      H4     C4     N3      126.000    3.000
 IMD      C4     N3     HN3     126.000    3.000
 IMD      C4     N3     C2      108.000    3.000
 IMD      HN3    N3     C2      126.000    3.000
 IMD      N3     C2     H2      126.000    3.000
 IMD      N3     C2     N1      108.000    3.000
 IMD      H2     C2     N1      126.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 IMD      CONST_1  H5     C5     N1     C2       180.000    0.000   0
 IMD      CONST_2  C5     N1     C2     N3         0.000    0.000   0
 IMD      CONST_3  H5     C5     C4     N3       180.000    0.000   0
 IMD      CONST_4  C5     C4     N3     C2         0.000    0.000   0
 IMD      CONST_5  C4     N3     C2     N1         0.000    0.000   0
loop_
_chem_comp_plane_atom.comp_id
_chem_comp_plane_atom.plane_id
_chem_comp_plane_atom.atom_id
_chem_comp_plane_atom.dist_esd
 IMD      plan-1    N1        0.020
 IMD      plan-1    C2        0.020
 IMD      plan-1    C5        0.020
 IMD      plan-1    HN1       0.020
 IMD      plan-1    N3        0.020
 IMD      plan-1    C4        0.020
 IMD      plan-1    H2        0.020
 IMD      plan-1    HN3       0.020
 IMD      plan-1    H4        0.020
 IMD      plan-1    H5        0.020
# ------------------------------------------------------
`.trim();

monomers["BO3"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
BO3      BO3 'BORIC ACID                          ' non-polymer         7   4 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_BO3
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 BO3           O3     O    OH1       0.000      0.000    0.000    0.000
 BO3           HO3    H    H         0.000      0.349    0.000    0.883
 BO3           B      B    B         0.000     -1.410    0.000   -0.161
 BO3           O2     O    OH1       0.000     -1.976    0.000   -1.463
 BO3           HO2    H    H         0.000     -1.386    0.000   -2.208
 BO3           O1     O    OH1       0.000     -2.255    0.000    0.980
 BO3           HO1    H    H         0.000     -1.849    0.000    1.838
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 BO3      O3     n/a    B      START
 BO3      HO3    O3     .      .
 BO3      B      O3     O1     .
 BO3      O2     B      HO2    .
 BO3      HO2    O2     .      .
 BO3      O1     B      HO1    .
 BO3      HO1    O1     .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 BO3      O1     B         single      1.535    0.020
 BO3      O2     B         single      1.535    0.020
 BO3      B      O3        single      1.535    0.020
 BO3      HO1    O1        single      0.967    0.020
 BO3      HO2    O2        single      0.967    0.020
 BO3      HO3    O3        single      0.967    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 BO3      HO3    O3     B       120.000    3.000
 BO3      O3     B      O2      120.000    3.000
 BO3      O3     B      O1      120.000    3.000
 BO3      O2     B      O1      120.000    3.000
 BO3      B      O2     HO2     120.000    3.000
 BO3      B      O1     HO1     120.000    3.000
loop_
_chem_comp_tor.comp_id
_chem_comp_tor.id
_chem_comp_tor.atom_id_1
_chem_comp_tor.atom_id_2
_chem_comp_tor.atom_id_3
_chem_comp_tor.atom_id_4
_chem_comp_tor.value_angle
_chem_comp_tor.value_angle_esd
_chem_comp_tor.period
 BO3      var_1    HO3    O3     B      O1         0.000   20.000   1
 BO3      var_2    O3     B      O2     HO2        0.000   20.000   1
 BO3      var_3    O3     B      O1     HO1        0.000   20.000   1
# ------------------------------------------------------
`.trim();

monomers["IUM"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
IUM      IUM 'URANYL (VI) ION                     ' non-polymer         3   3 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_IUM
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 IUM           O2     O    O        -1.000      0.000    0.000    0.000
 IUM           U      U    U         4.000     -2.220    0.000    0.000
 IUM           O1     O    O        -1.000     -4.440    0.000    0.000
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 IUM      O2     n/a    U      START
 IUM      U      O2     O1     .
 IUM      O1     U      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 IUM      O1     U         single      2.240    0.020
 IUM      U      O2        single      2.240    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 IUM      O2     U      O1      180.000    3.000
loop_
_chem_comp_chir.comp_id
_chem_comp_chir.id
_chem_comp_chir.atom_id_centre
_chem_comp_chir.atom_id_1
_chem_comp_chir.atom_id_2
_chem_comp_chir.atom_id_3
_chem_comp_chir.volume_sign
 IUM      chir_01  U      O2     O1     .         cross0
# ------------------------------------------------------
`.trim();

monomers["PO4"] = `
global_
_lib_name         ?
_lib_version      ?
_lib_update       ?
# ------------------------------------------------
#
# ---   LIST OF MONOMERS ---
#
data_comp_list
loop_
_chem_comp.id
_chem_comp.three_letter_code
_chem_comp.name
_chem_comp.group
_chem_comp.number_atoms_all
_chem_comp.number_atoms_nh
_chem_comp.desc_level
PO4      PO4 'PHOSPHATE ION                       ' non-polymer         5   5 .
# ------------------------------------------------------
# ------------------------------------------------------
#
# --- DESCRIPTION OF MONOMERS ---
#
data_comp_PO4
#
loop_
_chem_comp_atom.comp_id
_chem_comp_atom.atom_id
_chem_comp_atom.type_symbol
_chem_comp_atom.type_energy
_chem_comp_atom.partial_charge
_chem_comp_atom.x
_chem_comp_atom.y
_chem_comp_atom.z
 PO4           O4     O    OP       -0.750      0.000    0.000    0.000
 PO4           P      P    P         0.000     -1.469    0.000   -0.364
 PO4           O1     O    OP       -0.750     -1.787   -1.235   -1.178
 PO4           O2     O    OP       -0.750     -1.787    1.235   -1.178
 PO4           O3     O    OP       -0.750     -2.301    0.000    0.899
loop_
_chem_comp_tree.comp_id
_chem_comp_tree.atom_id
_chem_comp_tree.atom_back
_chem_comp_tree.atom_forward
_chem_comp_tree.connect_type
 PO4      O4     n/a    P      START
 PO4      P      O4     O3     .
 PO4      O1     P      .      .
 PO4      O2     P      .      .
 PO4      O3     P      .      END
loop_
_chem_comp_bond.comp_id
_chem_comp_bond.atom_id_1
_chem_comp_bond.atom_id_2
_chem_comp_bond.type
_chem_comp_bond.value_dist
_chem_comp_bond.value_dist_esd
 PO4      O1     P         deloc       1.510    0.020
 PO4      O2     P         deloc       1.510    0.020
 PO4      O3     P         deloc       1.510    0.020
 PO4      P      O4        deloc       1.510    0.020
loop_
_chem_comp_angle.comp_id
_chem_comp_angle.atom_id_1
_chem_comp_angle.atom_id_2
_chem_comp_angle.atom_id_3
_chem_comp_angle.value_angle
_chem_comp_angle.value_angle_esd
 PO4      O4     P      O1      109.500    3.000
 PO4      O4     P      O2      109.500    3.000
 PO4      O4     P      O3      109.500    3.000
 PO4      O1     P      O2      109.500    3.000
 PO4      O1     P      O3      109.500    3.000
 PO4      O2     P      O3      109.500    3.000
# ------------------------------------------------------
`.trim();

export {ener_lib_cif,monomers};
